(function (factory) {
  if (typeof define === 'function' && define.amd)
    define(['exports', './kotlin-kotlin-stdlib.js', './compose-multiplatform-core-compose-ui-ui-unit.js', './kotlinx-coroutines-core.js', './compose-multiplatform-core-compose-ui-ui-geometry.js', './androidx-collection-collection.js', './compose-multiplatform-core-compose-ui-ui-graphics.js', './androidx-compose-runtime-runtime.js', './androidx-compose-runtime-runtime-saveable.js', './androidx-compose-runtime-runtime-retain.js', './compose-multiplatform-core-compose-ui-ui-text.js', './kotlinx-atomicfu.js', './skiko-kjs.js', './androidx-navigationevent-navigationevent.js', './androidx-lifecycle-lifecycle-runtime-compose.js', './compose-multiplatform-core-compose-ui-ui-backhandler.js', './androidx-savedstate-savedstate-compose.js', './androidx-savedstate-savedstate.js', './androidx-lifecycle-lifecycle-viewmodel-savedstate.js', './androidx-lifecycle-lifecycle-common.js', './androidx-lifecycle-lifecycle-runtime.js', './androidx-lifecycle-lifecycle-viewmodel.js', './compose-multiplatform-core-compose-ui-ui-util.js', './kotlinx-browser.js'], factory);
  else if (typeof exports === 'object')
    factory(module.exports, require('./kotlin-kotlin-stdlib.js'), require('./compose-multiplatform-core-compose-ui-ui-unit.js'), require('./kotlinx-coroutines-core.js'), require('./compose-multiplatform-core-compose-ui-ui-geometry.js'), require('./androidx-collection-collection.js'), require('./compose-multiplatform-core-compose-ui-ui-graphics.js'), require('./androidx-compose-runtime-runtime.js'), require('./androidx-compose-runtime-runtime-saveable.js'), require('./androidx-compose-runtime-runtime-retain.js'), require('./compose-multiplatform-core-compose-ui-ui-text.js'), require('./kotlinx-atomicfu.js'), require('./skiko-kjs.js'), require('./androidx-navigationevent-navigationevent.js'), require('./androidx-lifecycle-lifecycle-runtime-compose.js'), require('./compose-multiplatform-core-compose-ui-ui-backhandler.js'), require('./androidx-savedstate-savedstate-compose.js'), require('./androidx-savedstate-savedstate.js'), require('./androidx-lifecycle-lifecycle-viewmodel-savedstate.js'), require('./androidx-lifecycle-lifecycle-common.js'), require('./androidx-lifecycle-lifecycle-runtime.js'), require('./androidx-lifecycle-lifecycle-viewmodel.js'), require('./compose-multiplatform-core-compose-ui-ui-util.js'), require('./kotlinx-browser.js'));
  else {
    if (typeof globalThis['kotlin-kotlin-stdlib'] === 'undefined') {
      throw new Error("Error loading module 'compose-multiplatform-core-compose-ui-ui'. Its dependency 'kotlin-kotlin-stdlib' was not found. Please, check whether 'kotlin-kotlin-stdlib' is loaded prior to 'compose-multiplatform-core-compose-ui-ui'.");
    }
    if (typeof globalThis['compose-multiplatform-core-compose-ui-ui-unit'] === 'undefined') {
      throw new Error("Error loading module 'compose-multiplatform-core-compose-ui-ui'. Its dependency 'compose-multiplatform-core-compose-ui-ui-unit' was not found. Please, check whether 'compose-multiplatform-core-compose-ui-ui-unit' is loaded prior to 'compose-multiplatform-core-compose-ui-ui'.");
    }
    if (typeof globalThis['kotlinx-coroutines-core'] === 'undefined') {
      throw new Error("Error loading module 'compose-multiplatform-core-compose-ui-ui'. Its dependency 'kotlinx-coroutines-core' was not found. Please, check whether 'kotlinx-coroutines-core' is loaded prior to 'compose-multiplatform-core-compose-ui-ui'.");
    }
    if (typeof globalThis['compose-multiplatform-core-compose-ui-ui-geometry'] === 'undefined') {
      throw new Error("Error loading module 'compose-multiplatform-core-compose-ui-ui'. Its dependency 'compose-multiplatform-core-compose-ui-ui-geometry' was not found. Please, check whether 'compose-multiplatform-core-compose-ui-ui-geometry' is loaded prior to 'compose-multiplatform-core-compose-ui-ui'.");
    }
    if (typeof globalThis['androidx-collection-collection'] === 'undefined') {
      throw new Error("Error loading module 'compose-multiplatform-core-compose-ui-ui'. Its dependency 'androidx-collection-collection' was not found. Please, check whether 'androidx-collection-collection' is loaded prior to 'compose-multiplatform-core-compose-ui-ui'.");
    }
    if (typeof globalThis['compose-multiplatform-core-compose-ui-ui-graphics'] === 'undefined') {
      throw new Error("Error loading module 'compose-multiplatform-core-compose-ui-ui'. Its dependency 'compose-multiplatform-core-compose-ui-ui-graphics' was not found. Please, check whether 'compose-multiplatform-core-compose-ui-ui-graphics' is loaded prior to 'compose-multiplatform-core-compose-ui-ui'.");
    }
    if (typeof globalThis['androidx-compose-runtime-runtime'] === 'undefined') {
      throw new Error("Error loading module 'compose-multiplatform-core-compose-ui-ui'. Its dependency 'androidx-compose-runtime-runtime' was not found. Please, check whether 'androidx-compose-runtime-runtime' is loaded prior to 'compose-multiplatform-core-compose-ui-ui'.");
    }
    if (typeof globalThis['androidx-compose-runtime-runtime-saveable'] === 'undefined') {
      throw new Error("Error loading module 'compose-multiplatform-core-compose-ui-ui'. Its dependency 'androidx-compose-runtime-runtime-saveable' was not found. Please, check whether 'androidx-compose-runtime-runtime-saveable' is loaded prior to 'compose-multiplatform-core-compose-ui-ui'.");
    }
    if (typeof globalThis['androidx-compose-runtime-runtime-retain'] === 'undefined') {
      throw new Error("Error loading module 'compose-multiplatform-core-compose-ui-ui'. Its dependency 'androidx-compose-runtime-runtime-retain' was not found. Please, check whether 'androidx-compose-runtime-runtime-retain' is loaded prior to 'compose-multiplatform-core-compose-ui-ui'.");
    }
    if (typeof globalThis['compose-multiplatform-core-compose-ui-ui-text'] === 'undefined') {
      throw new Error("Error loading module 'compose-multiplatform-core-compose-ui-ui'. Its dependency 'compose-multiplatform-core-compose-ui-ui-text' was not found. Please, check whether 'compose-multiplatform-core-compose-ui-ui-text' is loaded prior to 'compose-multiplatform-core-compose-ui-ui'.");
    }
    if (typeof globalThis['kotlinx-atomicfu'] === 'undefined') {
      throw new Error("Error loading module 'compose-multiplatform-core-compose-ui-ui'. Its dependency 'kotlinx-atomicfu' was not found. Please, check whether 'kotlinx-atomicfu' is loaded prior to 'compose-multiplatform-core-compose-ui-ui'.");
    }
    if (typeof globalThis['skiko-kjs'] === 'undefined') {
      throw new Error("Error loading module 'compose-multiplatform-core-compose-ui-ui'. Its dependency 'skiko-kjs' was not found. Please, check whether 'skiko-kjs' is loaded prior to 'compose-multiplatform-core-compose-ui-ui'.");
    }
    if (typeof globalThis['androidx-navigationevent-navigationevent'] === 'undefined') {
      throw new Error("Error loading module 'compose-multiplatform-core-compose-ui-ui'. Its dependency 'androidx-navigationevent-navigationevent' was not found. Please, check whether 'androidx-navigationevent-navigationevent' is loaded prior to 'compose-multiplatform-core-compose-ui-ui'.");
    }
    if (typeof globalThis['androidx-lifecycle-lifecycle-runtime-compose'] === 'undefined') {
      throw new Error("Error loading module 'compose-multiplatform-core-compose-ui-ui'. Its dependency 'androidx-lifecycle-lifecycle-runtime-compose' was not found. Please, check whether 'androidx-lifecycle-lifecycle-runtime-compose' is loaded prior to 'compose-multiplatform-core-compose-ui-ui'.");
    }
    if (typeof globalThis['compose-multiplatform-core-compose-ui-ui-backhandler'] === 'undefined') {
      throw new Error("Error loading module 'compose-multiplatform-core-compose-ui-ui'. Its dependency 'compose-multiplatform-core-compose-ui-ui-backhandler' was not found. Please, check whether 'compose-multiplatform-core-compose-ui-ui-backhandler' is loaded prior to 'compose-multiplatform-core-compose-ui-ui'.");
    }
    if (typeof globalThis['androidx-savedstate-savedstate-compose'] === 'undefined') {
      throw new Error("Error loading module 'compose-multiplatform-core-compose-ui-ui'. Its dependency 'androidx-savedstate-savedstate-compose' was not found. Please, check whether 'androidx-savedstate-savedstate-compose' is loaded prior to 'compose-multiplatform-core-compose-ui-ui'.");
    }
    if (typeof globalThis['androidx-savedstate-savedstate'] === 'undefined') {
      throw new Error("Error loading module 'compose-multiplatform-core-compose-ui-ui'. Its dependency 'androidx-savedstate-savedstate' was not found. Please, check whether 'androidx-savedstate-savedstate' is loaded prior to 'compose-multiplatform-core-compose-ui-ui'.");
    }
    if (typeof globalThis['androidx-lifecycle-lifecycle-viewmodel-savedstate'] === 'undefined') {
      throw new Error("Error loading module 'compose-multiplatform-core-compose-ui-ui'. Its dependency 'androidx-lifecycle-lifecycle-viewmodel-savedstate' was not found. Please, check whether 'androidx-lifecycle-lifecycle-viewmodel-savedstate' is loaded prior to 'compose-multiplatform-core-compose-ui-ui'.");
    }
    if (typeof globalThis['androidx-lifecycle-lifecycle-common'] === 'undefined') {
      throw new Error("Error loading module 'compose-multiplatform-core-compose-ui-ui'. Its dependency 'androidx-lifecycle-lifecycle-common' was not found. Please, check whether 'androidx-lifecycle-lifecycle-common' is loaded prior to 'compose-multiplatform-core-compose-ui-ui'.");
    }
    if (typeof globalThis['androidx-lifecycle-lifecycle-runtime'] === 'undefined') {
      throw new Error("Error loading module 'compose-multiplatform-core-compose-ui-ui'. Its dependency 'androidx-lifecycle-lifecycle-runtime' was not found. Please, check whether 'androidx-lifecycle-lifecycle-runtime' is loaded prior to 'compose-multiplatform-core-compose-ui-ui'.");
    }
    if (typeof globalThis['androidx-lifecycle-lifecycle-viewmodel'] === 'undefined') {
      throw new Error("Error loading module 'compose-multiplatform-core-compose-ui-ui'. Its dependency 'androidx-lifecycle-lifecycle-viewmodel' was not found. Please, check whether 'androidx-lifecycle-lifecycle-viewmodel' is loaded prior to 'compose-multiplatform-core-compose-ui-ui'.");
    }
    if (typeof globalThis['compose-multiplatform-core-compose-ui-ui-util'] === 'undefined') {
      throw new Error("Error loading module 'compose-multiplatform-core-compose-ui-ui'. Its dependency 'compose-multiplatform-core-compose-ui-ui-util' was not found. Please, check whether 'compose-multiplatform-core-compose-ui-ui-util' is loaded prior to 'compose-multiplatform-core-compose-ui-ui'.");
    }
    if (typeof globalThis['kotlinx-browser'] === 'undefined') {
      throw new Error("Error loading module 'compose-multiplatform-core-compose-ui-ui'. Its dependency 'kotlinx-browser' was not found. Please, check whether 'kotlinx-browser' is loaded prior to 'compose-multiplatform-core-compose-ui-ui'.");
    }
    globalThis['compose-multiplatform-core-compose-ui-ui'] = factory(typeof globalThis['compose-multiplatform-core-compose-ui-ui'] === 'undefined' ? {} : globalThis['compose-multiplatform-core-compose-ui-ui'], globalThis['kotlin-kotlin-stdlib'], globalThis['compose-multiplatform-core-compose-ui-ui-unit'], globalThis['kotlinx-coroutines-core'], globalThis['compose-multiplatform-core-compose-ui-ui-geometry'], globalThis['androidx-collection-collection'], globalThis['compose-multiplatform-core-compose-ui-ui-graphics'], globalThis['androidx-compose-runtime-runtime'], globalThis['androidx-compose-runtime-runtime-saveable'], globalThis['androidx-compose-runtime-runtime-retain'], globalThis['compose-multiplatform-core-compose-ui-ui-text'], globalThis['kotlinx-atomicfu'], globalThis['skiko-kjs'], globalThis['androidx-navigationevent-navigationevent'], globalThis['androidx-lifecycle-lifecycle-runtime-compose'], globalThis['compose-multiplatform-core-compose-ui-ui-backhandler'], globalThis['androidx-savedstate-savedstate-compose'], globalThis['androidx-savedstate-savedstate'], globalThis['androidx-lifecycle-lifecycle-viewmodel-savedstate'], globalThis['androidx-lifecycle-lifecycle-common'], globalThis['androidx-lifecycle-lifecycle-runtime'], globalThis['androidx-lifecycle-lifecycle-viewmodel'], globalThis['compose-multiplatform-core-compose-ui-ui-util'], globalThis['kotlinx-browser']);
  }
}(function (_, kotlin_kotlin, kotlin_org_jetbrains_compose_ui_ui_unit, kotlin_org_jetbrains_kotlinx_kotlinx_coroutines_core, kotlin_org_jetbrains_compose_ui_ui_geometry, kotlin_androidx_collection_collection, kotlin_org_jetbrains_compose_ui_ui_graphics, kotlin_androidx_compose_runtime_runtime, kotlin_androidx_compose_runtime_runtime_saveable, kotlin_androidx_compose_runtime_runtime_retain, kotlin_org_jetbrains_compose_ui_ui_text, kotlin_org_jetbrains_kotlinx_atomicfu, kotlin_org_jetbrains_skiko_skiko, kotlin_androidx_navigationevent_navigationevent, kotlin_androidx_lifecycle_lifecycle_runtime_compose, kotlin_org_jetbrains_compose_ui_ui_backhandler, kotlin_androidx_savedstate_savedstate_compose, kotlin_androidx_savedstate_savedstate, kotlin_androidx_lifecycle_lifecycle_viewmodel_savedstate, kotlin_androidx_lifecycle_lifecycle_common, kotlin_androidx_lifecycle_lifecycle_runtime, kotlin_androidx_lifecycle_lifecycle_viewmodel, kotlin_org_jetbrains_compose_ui_ui_util, kotlin_org_jetbrains_kotlinx_kotlinx_browser) {
  'use strict';
  //region block: imports
  var imul = Math.imul;
  var sign = Math.sign;
  var protoOf = kotlin_kotlin.$_$.eh;
  var initMetadataForCompanion = kotlin_kotlin.$_$.dg;
  var LayoutDirection_Ltr_getInstance = kotlin_org_jetbrains_compose_ui_ui_unit.$_$.k4;
  var roundToInt = kotlin_kotlin.$_$.kh;
  var isNaN_0 = kotlin_kotlin.$_$.qo;
  var getNumberHashCode = kotlin_kotlin.$_$.xf;
  var equals = kotlin_kotlin.$_$.sf;
  var initMetadataForClass = kotlin_kotlin.$_$.cg;
  var _IntSize___get_packedValue__impl__uho7jf = kotlin_org_jetbrains_compose_ui_ui_unit.$_$.f3;
  var shiftRight = kotlin_kotlin.$_$.ze;
  var convertToInt = kotlin_kotlin.$_$.le;
  var Long = kotlin_kotlin.$_$.kn;
  var bitwiseAnd = kotlin_kotlin.$_$.ge;
  var fromInt = kotlin_kotlin.$_$.pe;
  var shiftLeft = kotlin_kotlin.$_$.xe;
  var bitwiseOr = kotlin_kotlin.$_$.he;
  var _IntOffset___init__impl__rq8h7b = kotlin_org_jetbrains_compose_ui_ui_unit.$_$.v2;
  var _IntSize___init__impl__emcjft = kotlin_org_jetbrains_compose_ui_ui_unit.$_$.d3;
  var initMetadataForObject = kotlin_kotlin.$_$.ig;
  var VOID = kotlin_kotlin.$_$.d;
  var THROW_CCE = kotlin_kotlin.$_$.sn;
  var initMetadataForInterface = kotlin_kotlin.$_$.gg;
  var Key_instance = kotlin_org_jetbrains_kotlinx_kotlinx_coroutines_core.$_$.j;
  var Job = kotlin_org_jetbrains_kotlinx_kotlinx_coroutines_core.$_$.c3;
  var CoroutineScope = kotlin_org_jetbrains_kotlinx_kotlinx_coroutines_core.$_$.x2;
  var Unit_instance = kotlin_kotlin.$_$.o3;
  var cancel = kotlin_org_jetbrains_kotlinx_kotlinx_coroutines_core.$_$.i3;
  var charSequenceLength = kotlin_kotlin.$_$.lf;
  var toString = kotlin_kotlin.$_$.hh;
  var hashCode = kotlin_kotlin.$_$.bg;
  var captureStack = kotlin_kotlin.$_$.gf;
  var Element = kotlin_kotlin.$_$.vd;
  var coroutineScope = kotlin_org_jetbrains_kotlinx_kotlinx_coroutines_core.$_$.w;
  var CoroutineImpl = kotlin_kotlin.$_$.xd;
  var CoroutineScope_0 = kotlin_org_jetbrains_kotlinx_kotlinx_coroutines_core.$_$.y2;
  var isInterface = kotlin_kotlin.$_$.rg;
  var get_job = kotlin_org_jetbrains_kotlinx_kotlinx_coroutines_core.$_$.p3;
  var cancelAndJoin = kotlin_org_jetbrains_kotlinx_kotlinx_coroutines_core.$_$.v;
  var get_COROUTINE_SUSPENDED = kotlin_kotlin.$_$.gd;
  var initMetadataForLambda = kotlin_kotlin.$_$.hg;
  var constructCallableReference = kotlin_kotlin.$_$.of;
  var LinkedHashMap_init_$Create$ = kotlin_kotlin.$_$.j4;
  var Companion_getInstance = kotlin_org_jetbrains_compose_ui_ui_geometry.$_$.l1;
  var Offset = kotlin_org_jetbrains_compose_ui_ui_geometry.$_$.c;
  var toSize = kotlin_org_jetbrains_compose_ui_ui_unit.$_$.t1;
  var toRect = kotlin_org_jetbrains_compose_ui_ui_geometry.$_$.o;
  var Companion_getInstance_0 = kotlin_org_jetbrains_compose_ui_ui_unit.$_$.g4;
  var _Offset___get_packedValue__impl__xh2k8q = kotlin_org_jetbrains_compose_ui_ui_geometry.$_$.y;
  var FloatCompanionObject_instance = kotlin_kotlin.$_$.v2;
  var floatFromBits = kotlin_kotlin.$_$.uf;
  var toPx = kotlin_org_jetbrains_compose_ui_ui_unit.$_$.h;
  var toPx_0 = kotlin_org_jetbrains_compose_ui_ui_unit.$_$.i;
  var roundToPx = kotlin_org_jetbrains_compose_ui_ui_unit.$_$.c;
  var roundToPx_0 = kotlin_org_jetbrains_compose_ui_ui_unit.$_$.d;
  var toDp = kotlin_org_jetbrains_compose_ui_ui_unit.$_$.g;
  var toDp_0 = kotlin_org_jetbrains_compose_ui_ui_unit.$_$.f;
  var toDp_1 = kotlin_org_jetbrains_compose_ui_ui_unit.$_$.q;
  var toSize_0 = kotlin_org_jetbrains_compose_ui_ui_unit.$_$.j;
  var toDpSize = kotlin_org_jetbrains_compose_ui_ui_unit.$_$.e;
  var Density = kotlin_org_jetbrains_compose_ui_ui_unit.$_$.l;
  var Companion_getInstance_1 = kotlin_org_jetbrains_compose_ui_ui_geometry.$_$.n1;
  var Density_0 = kotlin_org_jetbrains_compose_ui_ui_unit.$_$.k;
  var ensureNotNull = kotlin_kotlin.$_$.lo;
  var mutableObjectListOf = kotlin_androidx_collection_collection.$_$.g1;
  var toString_0 = kotlin_kotlin.$_$.hp;
  var getBooleanHashCode = kotlin_kotlin.$_$.vf;
  var _Size___get_packedValue__impl__7rlt1o = kotlin_org_jetbrains_compose_ui_ui_geometry.$_$.g1;
  var equalsLong = kotlin_kotlin.$_$.oe;
  var toRawBits = kotlin_kotlin.$_$.fp;
  var _Size___init__impl__aywn0g = kotlin_org_jetbrains_compose_ui_ui_geometry.$_$.c1;
  var _Constraints___get_hasBoundedWidth__impl__7hd0wr = kotlin_org_jetbrains_compose_ui_ui_unit.$_$.x1;
  var _Constraints___get_hasBoundedHeight__impl__bsh4rw = kotlin_org_jetbrains_compose_ui_ui_unit.$_$.w1;
  var _Constraints___get_hasFixedWidth__impl__4p17wc = kotlin_org_jetbrains_compose_ui_ui_unit.$_$.z1;
  var _Constraints___get_hasFixedHeight__impl__y56fxx = kotlin_org_jetbrains_compose_ui_ui_unit.$_$.y1;
  var _Constraints___get_maxWidth__impl__uuyqc = kotlin_org_jetbrains_compose_ui_ui_unit.$_$.c2;
  var _Constraints___get_maxHeight__impl__dt3e8z = kotlin_org_jetbrains_compose_ui_ui_unit.$_$.b2;
  var Constraints__copy$default_impl_f452rp = kotlin_org_jetbrains_compose_ui_ui_unit.$_$.w3;
  var _Constraints___get_minWidth__impl__hi9lfi = kotlin_org_jetbrains_compose_ui_ui_unit.$_$.e2;
  var _Constraints___get_minHeight__impl__ev4bgx = kotlin_org_jetbrains_compose_ui_ui_unit.$_$.d2;
  var constrainWidth = kotlin_org_jetbrains_compose_ui_ui_unit.$_$.c1;
  var constrainHeight = kotlin_org_jetbrains_compose_ui_ui_unit.$_$.b1;
  var Constraints = kotlin_org_jetbrains_compose_ui_ui_unit.$_$.a;
  var _IntOffset___get_x__impl__qiqr5o = kotlin_org_jetbrains_compose_ui_ui_unit.$_$.b3;
  var _IntOffset___get_y__impl__2avpwj = kotlin_org_jetbrains_compose_ui_ui_unit.$_$.c3;
  var get_RectangleShape = kotlin_org_jetbrains_compose_ui_ui_graphics.$_$.l1;
  var _Dp___init__impl__ms3zkb = kotlin_org_jetbrains_compose_ui_ui_unit.$_$.h2;
  var Dp__compareTo_impl_tlg3dl = kotlin_org_jetbrains_compose_ui_ui_unit.$_$.i2;
  var Dp__toString_impl_kcddez = kotlin_org_jetbrains_compose_ui_ui_unit.$_$.k2;
  var Color__toString_impl_hpzmaq = kotlin_org_jetbrains_compose_ui_ui_graphics.$_$.c3;
  var Dp__hashCode_impl_sxkrra = kotlin_org_jetbrains_compose_ui_ui_unit.$_$.j2;
  var Color__hashCode_impl_vjyivj = kotlin_org_jetbrains_compose_ui_ui_graphics.$_$.a3;
  var MutableVector = kotlin_androidx_compose_runtime_runtime.$_$.a;
  var IllegalStateException_init_$Create$ = kotlin_kotlin.$_$.w5;
  var invert = kotlin_kotlin.$_$.qe;
  var compare = kotlin_kotlin.$_$.je;
  var mutableScatterSetOf = kotlin_androidx_collection_collection.$_$.l1;
  var objectCreate = kotlin_kotlin.$_$.dh;
  var MutableLongSet = kotlin_androidx_collection_collection.$_$.k;
  var MutableObjectList = kotlin_androidx_collection_collection.$_$.m;
  var noWhenBranchMatchedException = kotlin_kotlin.$_$.uo;
  var println = kotlin_kotlin.$_$.de;
  var isArray = kotlin_kotlin.$_$.jg;
  var ArrayList_init_$Create$ = kotlin_kotlin.$_$.a4;
  var Rect = kotlin_org_jetbrains_compose_ui_ui_geometry.$_$.f;
  var FunctionAdapter = kotlin_kotlin.$_$.cf;
  var get_LocalSaveableStateRegistry = kotlin_androidx_compose_runtime_runtime_saveable.$_$.a;
  var Enum = kotlin_kotlin.$_$.en;
  var Rect_0 = kotlin_org_jetbrains_compose_ui_ui_geometry.$_$.e;
  var throwUninitializedPropertyAccessException = kotlin_kotlin.$_$.ce;
  var IllegalArgumentException_init_$Create$ = kotlin_kotlin.$_$.p5;
  var Companion_getInstance_2 = kotlin_org_jetbrains_compose_ui_ui_geometry.$_$.m1;
  var until = kotlin_kotlin.$_$.mi;
  var compareTo = kotlin_kotlin.$_$.nf;
  var Comparator = kotlin_kotlin.$_$.bn;
  var numberToLong = kotlin_kotlin.$_$.we;
  var multiply = kotlin_kotlin.$_$.ue;
  var add = kotlin_kotlin.$_$.fe;
  var Companion_getInstance_3 = kotlin_org_jetbrains_compose_ui_ui_graphics.$_$.d4;
  var Companion_instance = kotlin_androidx_compose_runtime_runtime.$_$.u2;
  var BlendMode__toString_impl_uuibkd = kotlin_org_jetbrains_compose_ui_ui_graphics.$_$.t2;
  var BlendMode__hashCode_impl_93ceri = kotlin_org_jetbrains_compose_ui_ui_graphics.$_$.s2;
  var StringBuilder_init_$Create$ = kotlin_kotlin.$_$.w4;
  var Companion_getInstance_4 = kotlin_org_jetbrains_compose_ui_ui_graphics.$_$.g4;
  var Companion_getInstance_5 = kotlin_org_jetbrains_compose_ui_ui_graphics.$_$.j4;
  var CanvasDrawScope = kotlin_org_jetbrains_compose_ui_ui_graphics.$_$.a;
  var ImageBitmap = kotlin_org_jetbrains_compose_ui_ui_graphics.$_$.a1;
  var Canvas = kotlin_org_jetbrains_compose_ui_ui_graphics.$_$.s;
  var PathFillType = kotlin_org_jetbrains_compose_ui_ui_graphics.$_$.i1;
  var StrokeCap = kotlin_org_jetbrains_compose_ui_ui_graphics.$_$.r1;
  var StrokeJoin = kotlin_org_jetbrains_compose_ui_ui_graphics.$_$.s1;
  var getStringHashCode = kotlin_kotlin.$_$.ag;
  var emptyList = kotlin_kotlin.$_$.c9;
  var getKClassFromExpression = kotlin_kotlin.$_$.ri;
  var StrokeCap__hashCode_impl_posxk8 = kotlin_org_jetbrains_compose_ui_ui_graphics.$_$.v3;
  var StrokeJoin__hashCode_impl_3pyh8w = kotlin_org_jetbrains_compose_ui_ui_graphics.$_$.w3;
  var PathFillType__hashCode_impl_pdqo4w = kotlin_org_jetbrains_compose_ui_ui_graphics.$_$.t3;
  var PathParser = kotlin_org_jetbrains_compose_ui_ui_graphics.$_$.n;
  var SolidColor = kotlin_org_jetbrains_compose_ui_ui_graphics.$_$.q1;
  var _Color___get_value__impl__1pls5m = kotlin_org_jetbrains_compose_ui_ui_graphics.$_$.d3;
  var _ULong___init__impl__c78o9k = kotlin_kotlin.$_$.w1;
  var Path = kotlin_org_jetbrains_compose_ui_ui_graphics.$_$.k1;
  var toPath = kotlin_org_jetbrains_compose_ui_ui_graphics.$_$.o;
  var Matrix__reset_impl_4l49i7 = kotlin_org_jetbrains_compose_ui_ui_graphics.$_$.n3;
  var _Matrix___init__impl__q3kp4w = kotlin_org_jetbrains_compose_ui_ui_graphics.$_$.i3;
  var Matrix = kotlin_org_jetbrains_compose_ui_ui_graphics.$_$.d1;
  var Matrix__translate$default_impl_10t8ql = kotlin_org_jetbrains_compose_ui_ui_graphics.$_$.y3;
  var Matrix__rotateZ_impl_2g2pf5 = kotlin_org_jetbrains_compose_ui_ui_graphics.$_$.p3;
  var Matrix__scale_impl_6w89a4 = kotlin_org_jetbrains_compose_ui_ui_graphics.$_$.q3;
  var Size = kotlin_org_jetbrains_compose_ui_ui_geometry.$_$.j;
  var mutableStateOf = kotlin_androidx_compose_runtime_runtime.$_$.b2;
  var ImageBitmapConfig = kotlin_org_jetbrains_compose_ui_ui_graphics.$_$.z;
  var KMutableProperty1 = kotlin_kotlin.$_$.wi;
  var getPropertyCallableRef = kotlin_kotlin.$_$.zf;
  var Companion_instance_0 = kotlin_org_jetbrains_compose_ui_ui_graphics.$_$.h4;
  var numberToInt = kotlin_kotlin.$_$.ch;
  var KProperty1 = kotlin_kotlin.$_$.yi;
  var PathMeasure = kotlin_org_jetbrains_compose_ui_ui_graphics.$_$.j1;
  var LazyThreadSafetyMode_NONE_getInstance = kotlin_kotlin.$_$.u3;
  var lazy = kotlin_kotlin.$_$.so;
  var Stroke = kotlin_org_jetbrains_compose_ui_ui_graphics.$_$.c;
  var _Color___get_red__impl__cwrsk6 = kotlin_org_jetbrains_compose_ui_ui_graphics.$_$.b3;
  var _Color___get_green__impl__bta9rs = kotlin_org_jetbrains_compose_ui_ui_graphics.$_$.z2;
  var _Color___get_blue__impl__xwez13 = kotlin_org_jetbrains_compose_ui_ui_graphics.$_$.w2;
  var BlendModeColorFilter = kotlin_org_jetbrains_compose_ui_ui_graphics.$_$.p;
  var Color__copy$default_impl_ectz3s = kotlin_org_jetbrains_compose_ui_ui_graphics.$_$.x3;
  var _Color___get_alpha__impl__wcfyv1 = kotlin_org_jetbrains_compose_ui_ui_graphics.$_$.v2;
  var Companion_getInstance_6 = kotlin_org_jetbrains_compose_ui_ui_graphics.$_$.p4;
  var Companion_getInstance_7 = kotlin_org_jetbrains_compose_ui_ui_graphics.$_$.q4;
  var Companion_getInstance_8 = kotlin_org_jetbrains_compose_ui_ui_graphics.$_$.m4;
  var Painter = kotlin_org_jetbrains_compose_ui_ui_graphics.$_$.h;
  var neverEqualPolicy = kotlin_androidx_compose_runtime_runtime.$_$.c2;
  var LayoutDirection_Rtl_getInstance = kotlin_org_jetbrains_compose_ui_ui_unit.$_$.l4;
  var Companion_getInstance_9 = kotlin_androidx_compose_runtime_runtime.$_$.w2;
  var Companion_getInstance_10 = kotlin_org_jetbrains_compose_ui_ui_unit.$_$.j4;
  var Velocity = kotlin_org_jetbrains_compose_ui_ui_unit.$_$.y;
  var initMetadataForCoroutine = kotlin_kotlin.$_$.eg;
  var get_isActive = kotlin_org_jetbrains_kotlinx_kotlinx_coroutines_core.$_$.o3;
  var Velocity__minus_impl_w0cg92 = kotlin_org_jetbrains_compose_ui_ui_unit.$_$.q3;
  var Velocity__plus_impl_9g3s6u = kotlin_org_jetbrains_compose_ui_ui_unit.$_$.r3;
  var Offset__minus_impl_hoj2c0 = kotlin_org_jetbrains_compose_ui_ui_geometry.$_$.x;
  var Offset__plus_impl_c78cg0 = kotlin_org_jetbrains_compose_ui_ui_geometry.$_$.z;
  var MutableLongObjectMap = kotlin_androidx_collection_collection.$_$.j;
  var LongSparseArray = kotlin_androidx_collection_collection.$_$.b;
  var ArrayList_init_$Create$_0 = kotlin_kotlin.$_$.z3;
  var Offset__toString_impl_4ffbou = kotlin_org_jetbrains_compose_ui_ui_geometry.$_$.b1;
  var Offset__hashCode_impl_hbql41 = kotlin_org_jetbrains_compose_ui_ui_geometry.$_$.w;
  var contentEquals = kotlin_kotlin.$_$.f8;
  var contentHashCode = kotlin_kotlin.$_$.j8;
  var subtract = kotlin_kotlin.$_$.af;
  var delay = kotlin_org_jetbrains_kotlinx_kotlinx_coroutines_core.$_$.x;
  var Companion_instance_1 = kotlin_kotlin.$_$.j3;
  var createFailure = kotlin_kotlin.$_$.ko;
  var _Result___init__impl__xyqfz8 = kotlin_kotlin.$_$.z;
  var launch = kotlin_org_jetbrains_kotlinx_kotlinx_coroutines_core.$_$.q3;
  var EmptyCoroutineContext_getInstance = kotlin_kotlin.$_$.q2;
  var intercepted = kotlin_kotlin.$_$.jd;
  var CancellableContinuationImpl = kotlin_org_jetbrains_kotlinx_kotlinx_coroutines_core.$_$.q2;
  var Continuation = kotlin_kotlin.$_$.rd;
  var CoroutineStart_UNDISPATCHED_getInstance = kotlin_org_jetbrains_kotlinx_kotlinx_coroutines_core.$_$.o;
  var createCoroutine = kotlin_kotlin.$_$.yd;
  var copyOf = kotlin_kotlin.$_$.p8;
  var longArray = kotlin_kotlin.$_$.wg;
  var IllegalArgumentException = kotlin_kotlin.$_$.hn;
  var toNumber = kotlin_kotlin.$_$.bf;
  var abs = kotlin_kotlin.$_$.jh;
  var coerceAtLeast = kotlin_kotlin.$_$.xh;
  var coerceAtMost = kotlin_kotlin.$_$.zh;
  var coerceAtLeast_0 = kotlin_kotlin.$_$.wh;
  var arrayCopy = kotlin_kotlin.$_$.q7;
  var UnsupportedOperationException_init_$Create$ = kotlin_kotlin.$_$.o6;
  var IndexOutOfBoundsException_init_$Create$ = kotlin_kotlin.$_$.a6;
  var Constraints_0 = kotlin_org_jetbrains_compose_ui_ui_unit.$_$.b;
  var IntSize = kotlin_org_jetbrains_compose_ui_ui_unit.$_$.t;
  var composableLambdaInstance = kotlin_androidx_compose_runtime_runtime.$_$.b;
  var get_currentCompositeKeyHashCode = kotlin_androidx_compose_runtime_runtime.$_$.l1;
  var invalidApplier = kotlin_androidx_compose_runtime_runtime.$_$.r1;
  var Applier = kotlin_androidx_compose_runtime_runtime.$_$.h;
  var _Updater___init__impl__rbfxm8 = kotlin_androidx_compose_runtime_runtime.$_$.r2;
  var Updater__set_impl_v7kwss = kotlin_androidx_compose_runtime_runtime.$_$.t2;
  var _Offset___init__impl__c168vi = kotlin_org_jetbrains_compose_ui_ui_geometry.$_$.r;
  var round = kotlin_org_jetbrains_compose_ui_ui_unit.$_$.n1;
  var IntOffset__plus_impl_nqoa9b = kotlin_org_jetbrains_compose_ui_ui_unit.$_$.z2;
  var IntOffset__minus_impl_4m69hb = kotlin_org_jetbrains_compose_ui_ui_unit.$_$.x2;
  var emptyMap = kotlin_kotlin.$_$.d9;
  var compositionLocalOf = kotlin_androidx_compose_runtime_runtime.$_$.i1;
  var coerceIn = kotlin_kotlin.$_$.ei;
  var IntOffset = kotlin_org_jetbrains_compose_ui_ui_unit.$_$.r;
  var Companion_getInstance_11 = kotlin_org_jetbrains_compose_ui_ui_unit.$_$.e4;
  var anyToString = kotlin_kotlin.$_$.df;
  var joinToString = kotlin_kotlin.$_$.ba;
  var PausableComposition = kotlin_androidx_compose_runtime_runtime.$_$.x;
  var MutableIntList = kotlin_androidx_collection_collection.$_$.f;
  var ShouldPauseCallback = kotlin_androidx_compose_runtime_runtime.$_$.c1;
  var mutableIntSetOf = kotlin_androidx_collection_collection.$_$.c1;
  var mutableScatterMapOf = kotlin_androidx_collection_collection.$_$.j1;
  var getOrNull = kotlin_kotlin.$_$.t9;
  var ComposeNodeLifecycleCallback = kotlin_androidx_compose_runtime_runtime.$_$.j;
  var mutableOrderedScatterSetOf = kotlin_androidx_collection_collection.$_$.i1;
  var Collection = kotlin_kotlin.$_$.y6;
  var IllegalStateException = kotlin_kotlin.$_$.in;
  var IllegalStateException_init_$Init$ = kotlin_kotlin.$_$.s5;
  var joinToString_0 = kotlin_kotlin.$_$.aa;
  var trimMargin = kotlin_kotlin.$_$.lm;
  var defineProp = kotlin_kotlin.$_$.pf;
  var rememberCompositionContext = kotlin_androidx_compose_runtime_runtime.$_$.f2;
  var Updater__reconcile_impl_1mfi6g = kotlin_androidx_compose_runtime_runtime.$_$.s2;
  var SideEffect = kotlin_androidx_compose_runtime_runtime.$_$.d1;
  var updateChangedFlags = kotlin_androidx_compose_runtime_runtime.$_$.q2;
  var copyToArray = kotlin_kotlin.$_$.x8;
  var HashSet_init_$Create$ = kotlin_kotlin.$_$.g4;
  var mutableObjectIntMapOf = kotlin_androidx_collection_collection.$_$.f1;
  var get_lastIndex = kotlin_kotlin.$_$.fa;
  var KtList = kotlin_kotlin.$_$.e7;
  var MutableLongList = kotlin_androidx_collection_collection.$_$.i;
  var Paint = kotlin_org_jetbrains_compose_ui_ui_graphics.$_$.h1;
  var Companion_getInstance_12 = kotlin_org_jetbrains_compose_ui_ui_graphics.$_$.l4;
  var Companion_getInstance_13 = kotlin_org_jetbrains_compose_ui_ui_unit.$_$.d4;
  var _Char___init__impl__6a9atx = kotlin_kotlin.$_$.q;
  var substring = kotlin_kotlin.$_$.pl;
  var get_LocalCompositionErrorContext = kotlin_androidx_compose_runtime_runtime.$_$.f;
  var Companion_getInstance_14 = kotlin_androidx_compose_runtime_runtime.$_$.x2;
  var KtMap = kotlin_kotlin.$_$.g7;
  var getValue = kotlin_kotlin.$_$.u9;
  var HashMap_init_$Create$ = kotlin_kotlin.$_$.d4;
  var record$default = kotlin_org_jetbrains_compose_ui_ui_graphics.$_$.d5;
  var drawLine$default = kotlin_org_jetbrains_compose_ui_ui_graphics.$_$.v4;
  var drawLine$default_0 = kotlin_org_jetbrains_compose_ui_ui_graphics.$_$.w4;
  var drawRect$default = kotlin_org_jetbrains_compose_ui_ui_graphics.$_$.z4;
  var drawRect$default_0 = kotlin_org_jetbrains_compose_ui_ui_graphics.$_$.a5;
  var drawImage$default = kotlin_org_jetbrains_compose_ui_ui_graphics.$_$.u4;
  var drawRoundRect$default = kotlin_org_jetbrains_compose_ui_ui_graphics.$_$.b5;
  var drawRoundRect$default_0 = kotlin_org_jetbrains_compose_ui_ui_graphics.$_$.c5;
  var drawCircle$default = kotlin_org_jetbrains_compose_ui_ui_graphics.$_$.t4;
  var drawArc$default = kotlin_org_jetbrains_compose_ui_ui_graphics.$_$.s4;
  var drawPath$default = kotlin_org_jetbrains_compose_ui_ui_graphics.$_$.y4;
  var drawPath$default_0 = kotlin_org_jetbrains_compose_ui_ui_graphics.$_$.x4;
  var DrawScope = kotlin_org_jetbrains_compose_ui_ui_graphics.$_$.b;
  var MutableScatterMap = kotlin_androidx_collection_collection.$_$.n;
  var MutableScatterSet = kotlin_androidx_collection_collection.$_$.o;
  var indexOf = kotlin_kotlin.$_$.v9;
  var copyOf_0 = kotlin_kotlin.$_$.v8;
  var copyOf_1 = kotlin_kotlin.$_$.u8;
  var copyOf_2 = kotlin_kotlin.$_$.s8;
  var contains = kotlin_kotlin.$_$.e8;
  var ComposeToolingFlags_instance = kotlin_androidx_compose_runtime_runtime.$_$.v2;
  var copyOf_3 = kotlin_kotlin.$_$.w8;
  var abs_0 = kotlin_kotlin.$_$.ih;
  var Matrix__timesAssign_impl_oas521 = kotlin_org_jetbrains_compose_ui_ui_graphics.$_$.r3;
  var StringBuilder = kotlin_kotlin.$_$.jj;
  var MutableRect = kotlin_org_jetbrains_compose_ui_ui_geometry.$_$.b;
  var isIdentity = kotlin_org_jetbrains_compose_ui_ui_graphics.$_$.g2;
  var bitwiseXor = kotlin_kotlin.$_$.ie;
  var toRect_0 = kotlin_org_jetbrains_compose_ui_ui_geometry.$_$.n;
  var plus = kotlin_org_jetbrains_compose_ui_ui_unit.$_$.l1;
  var minus = kotlin_org_jetbrains_compose_ui_ui_unit.$_$.i1;
  var Offset__getDistanceSquared_impl_97mhi6 = kotlin_org_jetbrains_compose_ui_ui_geometry.$_$.u;
  var SnapshotStateObserver = kotlin_androidx_compose_runtime_runtime.$_$.e;
  var _Dp___get_value__impl__geb1vb = kotlin_org_jetbrains_compose_ui_ui_unit.$_$.l2;
  var get_LocalRetainedValuesStore = kotlin_androidx_compose_runtime_runtime_retain.$_$.a;
  var androidx_compose_runtime_ProvidedValue$stableprop_getter = kotlin_androidx_compose_runtime_runtime.$_$.f1;
  var CompositionLocalProvider = kotlin_androidx_compose_runtime_runtime.$_$.k;
  var first = kotlin_kotlin.$_$.p9;
  var staticCompositionLocalOf = kotlin_androidx_compose_runtime_runtime.$_$.l2;
  var compositionLocalWithComputedDefaultOf = kotlin_androidx_compose_runtime_runtime.$_$.j1;
  var _Matrix___get_values__impl__fblr7b = kotlin_org_jetbrains_compose_ui_ui_graphics.$_$.s3;
  var throwKotlinNothingValueException = kotlin_kotlin.$_$.bp;
  var Unit = kotlin_kotlin.$_$.co;
  var snapshotFlow = kotlin_androidx_compose_runtime_runtime.$_$.h2;
  var collectLatest = kotlin_org_jetbrains_kotlinx_kotlinx_coroutines_core.$_$.p;
  var Generic = kotlin_org_jetbrains_compose_ui_ui_graphics.$_$.e1;
  var Rounded = kotlin_org_jetbrains_compose_ui_ui_graphics.$_$.g1;
  var Rectangle = kotlin_org_jetbrains_compose_ui_ui_graphics.$_$.f1;
  var _CornerRadius___get_packedValue__impl__okv4jq = kotlin_org_jetbrains_compose_ui_ui_geometry.$_$.q;
  var Companion_getInstance_15 = kotlin_org_jetbrains_compose_ui_ui_graphics.$_$.n4;
  var PausableComposition_0 = kotlin_androidx_compose_runtime_runtime.$_$.w;
  var ReusableComposition = kotlin_androidx_compose_runtime_runtime.$_$.b1;
  var DpSize = kotlin_org_jetbrains_compose_ui_ui_unit.$_$.n;
  var DpSize_0 = kotlin_org_jetbrains_compose_ui_ui_unit.$_$.o;
  var firstOrNull = kotlin_kotlin.$_$.k9;
  var TextRange = kotlin_org_jetbrains_compose_ui_ui_text.$_$.w1;
  var listOf = kotlin_kotlin.$_$.sa;
  var ImeAction = kotlin_org_jetbrains_compose_ui_ui_text.$_$.l;
  var toMutableList = kotlin_kotlin.$_$.pc;
  var rangeTo = kotlin_kotlin.$_$.ji;
  var plus_0 = kotlin_kotlin.$_$.ib;
  var _ULong___get_data__impl__fggpzb = kotlin_kotlin.$_$.x1;
  var Matrix__map_impl_7meu7m = kotlin_org_jetbrains_compose_ui_ui_graphics.$_$.l3;
  var intObjectMapOf = kotlin_androidx_collection_collection.$_$.x;
  var IntOffset__hashCode_impl_w5rrxs = kotlin_org_jetbrains_compose_ui_ui_unit.$_$.w2;
  var Matrix__hashCode_impl_s9ntm9 = kotlin_org_jetbrains_compose_ui_ui_graphics.$_$.j3;
  var mutableIntObjectMapOf = kotlin_androidx_collection_collection.$_$.b1;
  var _IntOffset___get_packedValue__impl__982pbx = kotlin_org_jetbrains_compose_ui_ui_unit.$_$.y2;
  var TextMeasurer = kotlin_org_jetbrains_compose_ui_ui_text.$_$.t1;
  var KProperty0 = kotlin_kotlin.$_$.xi;
  var await_0 = kotlin_org_jetbrains_kotlinx_kotlinx_coroutines_core.$_$.u;
  var lazy_0 = kotlin_kotlin.$_$.to;
  var Dispatchers_getInstance = kotlin_org_jetbrains_kotlinx_kotlinx_coroutines_core.$_$.h;
  var atomic$ref$1 = kotlin_org_jetbrains_kotlinx_atomicfu.$_$.d;
  var CancellationException = kotlin_kotlin.$_$.fd;
  var CancellationException_init_$Init$ = kotlin_kotlin.$_$.p4;
  var removeLast = kotlin_kotlin.$_$.ob;
  var checkIndexOverflow = kotlin_kotlin.$_$.a8;
  var atomic$int$1 = kotlin_org_jetbrains_kotlinx_atomicfu.$_$.e;
  var GlobalScope_instance = kotlin_org_jetbrains_kotlinx_kotlinx_coroutines_core.$_$.i;
  var Job_0 = kotlin_org_jetbrains_kotlinx_kotlinx_coroutines_core.$_$.d3;
  var KMutableProperty0 = kotlin_kotlin.$_$.vi;
  var get_currentSystemTheme = kotlin_org_jetbrains_skiko_skiko.$_$.i6;
  var Companion_getInstance_16 = kotlin_kotlin.$_$.d3;
  var DurationUnit_NANOSECONDS_getInstance = kotlin_kotlin.$_$.s3;
  var toDuration = kotlin_kotlin.$_$.sm;
  var Duration = kotlin_kotlin.$_$.om;
  var Duration__div_impl_dknbf4 = kotlin_kotlin.$_$.f;
  var Duration__compareTo_impl_pchp0f = kotlin_kotlin.$_$.e;
  var withFrameNanos = kotlin_androidx_compose_runtime_runtime.$_$.z2;
  var collectionSizeOrDefault = kotlin_kotlin.$_$.b8;
  var mapCapacity = kotlin_kotlin.$_$.ua;
  var LinkedHashMap_init_$Create$_0 = kotlin_kotlin.$_$.i4;
  var to = kotlin_kotlin.$_$.ip;
  var toSet = kotlin_kotlin.$_$.tc;
  var minus_0 = kotlin_kotlin.$_$.ab;
  var toList = kotlin_kotlin.$_$.kc;
  var HashSet_init_$Create$_0 = kotlin_kotlin.$_$.f4;
  var fill = kotlin_kotlin.$_$.i9;
  var mutableStateListOf = kotlin_androidx_compose_runtime_runtime.$_$.z1;
  var NavigationEventInput = kotlin_androidx_navigationevent_navigationevent.$_$.c;
  var ArraySet = kotlin_androidx_collection_collection.$_$.a;
  var returnIfSuspended = kotlin_kotlin.$_$.w3;
  var TextInputService = kotlin_org_jetbrains_compose_ui_ui_text.$_$.w;
  var FontLoader = kotlin_org_jetbrains_compose_ui_ui_text.$_$.c1;
  var createFontFamilyResolver = kotlin_org_jetbrains_compose_ui_ui_text.$_$.e;
  var ForgetfulRetainedValuesStore_instance = kotlin_androidx_compose_runtime_runtime_retain.$_$.b;
  var FlowCollector = kotlin_org_jetbrains_kotlinx_kotlinx_coroutines_core.$_$.p1;
  var SkiaGraphicsContext = kotlin_org_jetbrains_compose_ui_ui_graphics.$_$.p1;
  var DisposableEffect = kotlin_androidx_compose_runtime_runtime.$_$.q;
  var get_LocalHostDefaultProvider = kotlin_androidx_compose_runtime_runtime.$_$.u;
  var arrayConcat = kotlin_kotlin.$_$.a;
  var get_LocalLifecycleOwner = kotlin_androidx_lifecycle_lifecycle_runtime_compose.$_$.a;
  var get_LocalCompatNavigationEventDispatcherOwner = kotlin_org_jetbrains_compose_ui_ui_backhandler.$_$.b;
  var get_LocalSavedStateRegistryOwner = kotlin_androidx_savedstate_savedstate_compose.$_$.a;
  var mutableListOf = kotlin_kotlin.$_$.cb;
  var AbstractApplier = kotlin_androidx_compose_runtime_runtime.$_$.g;
  var SaveableStateRegistry = kotlin_androidx_compose_runtime_runtime_saveable.$_$.c;
  var getKClass = kotlin_kotlin.$_$.si;
  var SaveableStateRegistry_0 = kotlin_androidx_compose_runtime_runtime_saveable.$_$.b;
  var _SavedStateReader___init__impl__k2stzo = kotlin_androidx_savedstate_savedstate.$_$.c;
  var SavedStateReader__toMap_impl_49zebr = kotlin_androidx_savedstate_savedstate.$_$.g;
  var toMutableMap = kotlin_kotlin.$_$.rc;
  var SavedState = kotlin_androidx_savedstate_savedstate.$_$.b;
  var _SavedStateWriter___init__impl__99cr38 = kotlin_androidx_savedstate_savedstate.$_$.h;
  var SavedStateProvider = kotlin_androidx_savedstate_savedstate.$_$.a;
  var Runnable = kotlin_org_jetbrains_kotlinx_kotlinx_coroutines_core.$_$.f3;
  var CoroutineDispatcher = kotlin_org_jetbrains_kotlinx_kotlinx_coroutines_core.$_$.v2;
  var ArrayDeque_init_$Create$ = kotlin_kotlin.$_$.x3;
  var invokeOnTimeout = kotlin_org_jetbrains_kotlinx_kotlinx_coroutines_core.$_$.z2;
  var Delay = kotlin_org_jetbrains_kotlinx_kotlinx_coroutines_core.$_$.a3;
  var cancelConsumed = kotlin_org_jetbrains_kotlinx_kotlinx_coroutines_core.$_$.n1;
  var Channel = kotlin_org_jetbrains_kotlinx_kotlinx_coroutines_core.$_$.h1;
  var setOutline = kotlin_org_jetbrains_compose_ui_ui_graphics.$_$.e;
  var prepareTransformationMatrix = kotlin_org_jetbrains_compose_ui_ui_graphics.$_$.l2;
  var Companion_getInstance_17 = kotlin_org_jetbrains_compose_ui_ui_graphics.$_$.c4;
  var drawLayer = kotlin_org_jetbrains_compose_ui_ui_graphics.$_$.d;
  var Matrix__map_impl_7meu7m_0 = kotlin_org_jetbrains_compose_ui_ui_graphics.$_$.k3;
  var get_skiaCanvas = kotlin_org_jetbrains_compose_ui_ui_graphics.$_$.m2;
  var ClipMode_INTERSECT_getInstance = kotlin_org_jetbrains_skiko_skiko.$_$.a3;
  var get_skiaPaint = kotlin_org_jetbrains_compose_ui_ui_graphics.$_$.o2;
  var get_skiaImageFilter = kotlin_org_jetbrains_compose_ui_ui_graphics.$_$.n2;
  var set_alphaMultiplier = kotlin_org_jetbrains_compose_ui_ui_graphics.$_$.v1;
  var SnapshotMutationPolicy = kotlin_androidx_compose_runtime_runtime.$_$.e1;
  var PictureRecorder_init_$Create$ = kotlin_org_jetbrains_skiko_skiko.$_$.f5;
  var RTreeFactory_init_$Create$ = kotlin_org_jetbrains_skiko_skiko.$_$.g5;
  var asComposeCanvas = kotlin_org_jetbrains_compose_ui_ui_graphics.$_$.w1;
  var Point3 = kotlin_org_jetbrains_skiko_skiko.$_$.b6;
  var ShadowUtils_getInstance = kotlin_org_jetbrains_skiko_skiko.$_$.t;
  var materializeSkiaPath = kotlin_org_jetbrains_compose_ui_ui_graphics.$_$.j2;
  var toArgb = kotlin_org_jetbrains_compose_ui_ui_graphics.$_$.p2;
  var awaitCancellation = kotlin_org_jetbrains_kotlinx_kotlinx_coroutines_core.$_$.t;
  var Companion_getInstance_18 = kotlin_org_jetbrains_compose_ui_ui_text.$_$.k3;
  var startInput = kotlin_org_jetbrains_compose_ui_ui_text.$_$.r;
  var notifyFocusedRect = kotlin_org_jetbrains_compose_ui_ui_text.$_$.q;
  var updateTextLayoutResult = kotlin_org_jetbrains_compose_ui_ui_text.$_$.s;
  var PlatformTextInputService = kotlin_org_jetbrains_compose_ui_ui_text.$_$.t;
  var enableSavedStateHandles = kotlin_androidx_lifecycle_lifecycle_viewmodel_savedstate.$_$.f;
  var State_RESUMED_getInstance = kotlin_androidx_lifecycle_lifecycle_common.$_$.n;
  var Companion_instance_2 = kotlin_androidx_lifecycle_lifecycle_runtime.$_$.a;
  var LifecycleRegistry_init_$Create$ = kotlin_androidx_lifecycle_lifecycle_runtime.$_$.b;
  var ViewModelStore = kotlin_androidx_lifecycle_lifecycle_viewmodel.$_$.d;
  var NavigationEventDispatcher_init_$Create$ = kotlin_androidx_navigationevent_navigationevent.$_$.g;
  var Companion_instance_3 = kotlin_androidx_savedstate_savedstate.$_$.l;
  var SavedStateViewModelFactory = kotlin_androidx_lifecycle_lifecycle_viewmodel_savedstate.$_$.c;
  var State_DESTROYED_getInstance = kotlin_androidx_lifecycle_lifecycle_common.$_$.l;
  var HasDefaultViewModelProviderFactory = kotlin_androidx_lifecycle_lifecycle_viewmodel.$_$.a;
  var MutableCreationExtras_init_$Create$ = kotlin_androidx_lifecycle_lifecycle_viewmodel.$_$.j;
  var get_SAVED_STATE_REGISTRY_OWNER_KEY = kotlin_androidx_lifecycle_lifecycle_viewmodel_savedstate.$_$.a;
  var get_VIEW_MODEL_STORE_OWNER_KEY = kotlin_androidx_lifecycle_lifecycle_viewmodel_savedstate.$_$.d;
  var shiftRightUnsigned = kotlin_kotlin.$_$.ye;
  var CompositionLocalProvider_0 = kotlin_androidx_compose_runtime_runtime.$_$.l;
  var maxOf = kotlin_kotlin.$_$.cd;
  var Composition = kotlin_androidx_compose_runtime_runtime.$_$.n;
  var CompositionLocalProvider_1 = kotlin_androidx_compose_runtime_runtime.$_$.m;
  var rememberComposableLambda = kotlin_androidx_compose_runtime_runtime.$_$.c;
  var singleOrNull = kotlin_kotlin.$_$.tb;
  var BroadcastFrameClock = kotlin_androidx_compose_runtime_runtime.$_$.i;
  var Color = kotlin_org_jetbrains_compose_ui_ui_graphics.$_$.y;
  var first_0 = kotlin_kotlin.$_$.o9;
  var Companion_getInstance_19 = kotlin_org_jetbrains_compose_ui_ui_unit.$_$.f4;
  var KtMutableList = kotlin_kotlin.$_$.i7;
  var AutoCloseable = kotlin_kotlin.$_$.wm;
  var IllegalStateException_init_$Create$_0 = kotlin_kotlin.$_$.u5;
  var mutableStateMapOf = kotlin_androidx_compose_runtime_runtime.$_$.a2;
  var firstOrNull_0 = kotlin_kotlin.$_$.m9;
  var get_currentCompositionLocalContext = kotlin_androidx_compose_runtime_runtime.$_$.m1;
  var DisposableEffect_0 = kotlin_androidx_compose_runtime_runtime.$_$.p;
  var Recomposer = kotlin_androidx_compose_runtime_runtime.$_$.z;
  var Companion_getInstance_20 = kotlin_org_jetbrains_compose_ui_ui_unit.$_$.c4;
  var _DpOffset___init__impl__yq36wy = kotlin_org_jetbrains_compose_ui_ui_unit.$_$.m2;
  var DpOffset = kotlin_org_jetbrains_compose_ui_ui_unit.$_$.m;
  var NotImplementedError = kotlin_kotlin.$_$.mn;
  var rememberUpdatedState = kotlin_androidx_compose_runtime_runtime.$_$.g2;
  var LaunchedEffect = kotlin_androidx_compose_runtime_runtime.$_$.s;
  var DurationUnit_SECONDS_getInstance = kotlin_kotlin.$_$.t3;
  var toDuration_0 = kotlin_kotlin.$_$.rm;
  var LaunchedEffect_0 = kotlin_androidx_compose_runtime_runtime.$_$.r;
  var mutableFloatStateOf = kotlin_androidx_compose_runtime_runtime.$_$.v1;
  var getLocalDelegateReference = kotlin_kotlin.$_$.wf;
  var createCompositionCoroutineScope = kotlin_androidx_compose_runtime_runtime.$_$.k1;
  var get_center = kotlin_org_jetbrains_compose_ui_ui_unit.$_$.z;
  var IntRect = kotlin_org_jetbrains_compose_ui_ui_unit.$_$.s;
  var NavigationEventHandler = kotlin_androidx_navigationevent_navigationevent.$_$.a;
  var NavigationEventHandler_init_$Init$ = kotlin_androidx_navigationevent_navigationevent.$_$.h;
  var NavigationEventInfo = kotlin_androidx_navigationevent_navigationevent.$_$.b;
  var offset = kotlin_org_jetbrains_compose_ui_ui_unit.$_$.j1;
  var constrain = kotlin_org_jetbrains_compose_ui_ui_unit.$_$.d1;
  var Offset__times_impl_jz1mli = kotlin_org_jetbrains_compose_ui_ui_geometry.$_$.a1;
  var firstOrNull_1 = kotlin_kotlin.$_$.yj;
  var toString_1 = kotlin_kotlin.$_$.y;
  var Char = kotlin_kotlin.$_$.ym;
  var charCodeAt = kotlin_kotlin.$_$.jf;
  var Companion_getInstance_21 = kotlin_kotlin.$_$.h3;
  var isLowSurrogate = kotlin_kotlin.$_$.hk;
  var isHighSurrogate = kotlin_kotlin.$_$.fk;
  var Char__toInt_impl_vasixd = kotlin_kotlin.$_$.x;
  var Char__minus_impl_a2frrh = kotlin_kotlin.$_$.t;
  var mapOf = kotlin_kotlin.$_$.wa;
  var _Velocity___get_x__impl__qqcikv = kotlin_org_jetbrains_compose_ui_ui_unit.$_$.u3;
  var _Velocity___get_y__impl__239yhc = kotlin_org_jetbrains_compose_ui_ui_unit.$_$.v3;
  var Velocity__toString_impl_n5zo2k = kotlin_org_jetbrains_compose_ui_ui_unit.$_$.t3;
  var Velocity_0 = kotlin_org_jetbrains_compose_ui_ui_unit.$_$.x;
  var SetSelectionCommand = kotlin_org_jetbrains_compose_ui_ui_text.$_$.u;
  var _TextRange___get_min__impl__uu95c4 = kotlin_org_jetbrains_compose_ui_ui_text.$_$.u2;
  var _TextRange___get_max__impl__owm8m = kotlin_org_jetbrains_compose_ui_ui_text.$_$.t2;
  var TextFieldValue_init_$Create$ = kotlin_org_jetbrains_compose_ui_ui_text.$_$.b4;
  var Companion_getInstance_22 = kotlin_org_jetbrains_compose_ui_ui_text.$_$.f3;
  var Companion_getInstance_23 = kotlin_org_jetbrains_compose_ui_ui_text.$_$.c3;
  var Companion_getInstance_24 = kotlin_org_jetbrains_compose_ui_ui_text.$_$.g3;
  var coerceAtMost_0 = kotlin_kotlin.$_$.bi;
  var _TextRange___get_start__impl__ww4t90 = kotlin_org_jetbrains_compose_ui_ui_text.$_$.w2;
  var BackspaceCommand = kotlin_org_jetbrains_compose_ui_ui_text.$_$.f;
  var _TextRange___get_collapsed__impl__cilesp = kotlin_org_jetbrains_compose_ui_ui_text.$_$.q2;
  var DeleteSurroundingTextCommand = kotlin_org_jetbrains_compose_ui_ui_text.$_$.i;
  var CommitTextCommand_init_$Create$ = kotlin_org_jetbrains_compose_ui_ui_text.$_$.z3;
  var SetComposingTextCommand_init_$Create$ = kotlin_org_jetbrains_compose_ui_ui_text.$_$.a4;
  var compareValues = kotlin_kotlin.$_$.ad;
  var sortWith = kotlin_kotlin.$_$.wb;
  var numberToDouble = kotlin_kotlin.$_$.bh;
  var ChannelResult = kotlin_org_jetbrains_kotlinx_kotlinx_coroutines_core.$_$.g1;
  var receiveAsFlow = kotlin_org_jetbrains_kotlinx_kotlinx_coroutines_core.$_$.i2;
  var DurationUnit_MILLISECONDS_getInstance = kotlin_kotlin.$_$.q3;
  var debounce = kotlin_org_jetbrains_kotlinx_kotlinx_coroutines_core.$_$.y1;
  var LinkedHashSet_init_$Create$ = kotlin_kotlin.$_$.m4;
  var asReversed = kotlin_kotlin.$_$.u7;
  var fastJoinToString = kotlin_org_jetbrains_compose_ui_ui_util.$_$.c;
  var Offset__div_impl_eaxtg1 = kotlin_org_jetbrains_compose_ui_ui_geometry.$_$.t;
  var BufferOverflow_DROP_LATEST_getInstance = kotlin_org_jetbrains_kotlinx_kotlinx_coroutines_core.$_$.k;
  var clear = kotlin_org_jetbrains_kotlinx_kotlinx_browser.$_$.a;
  var onWasmReady = kotlin_org_jetbrains_skiko_skiko.$_$.e6;
  var DpRect_init_$Create$ = kotlin_org_jetbrains_compose_ui_ui_unit.$_$.m4;
  var listOf_0 = kotlin_kotlin.$_$.ta;
  var toIntSize = kotlin_org_jetbrains_compose_ui_ui_unit.$_$.s1;
  var _DpSize___get_width__impl__o3d5gt = kotlin_org_jetbrains_compose_ui_ui_unit.$_$.u2;
  var _DpSize___get_height__impl__5xueo2 = kotlin_org_jetbrains_compose_ui_ui_unit.$_$.s2;
  var toList_0 = kotlin_kotlin.$_$.lc;
  var SkikoRenderDelegate = kotlin_org_jetbrains_skiko_skiko.$_$.g6;
  var MainScope = kotlin_org_jetbrains_kotlinx_kotlinx_coroutines_core.$_$.e3;
  var Event_ON_RESUME_getInstance = kotlin_androidx_lifecycle_lifecycle_common.$_$.h;
  var Event_ON_PAUSE_getInstance = kotlin_androidx_lifecycle_lifecycle_common.$_$.g;
  var Event_ON_STOP_getInstance = kotlin_androidx_lifecycle_lifecycle_common.$_$.j;
  var Event_ON_START_getInstance = kotlin_androidx_lifecycle_lifecycle_common.$_$.i;
  var SkiaLayer = kotlin_org_jetbrains_skiko_skiko.$_$.f6;
  var get_hostOs = kotlin_org_jetbrains_skiko_skiko.$_$.j6;
  var TextFieldValue = kotlin_org_jetbrains_compose_ui_ui_text.$_$.v;
  var filterNotNull = kotlin_org_jetbrains_kotlinx_kotlinx_coroutines_core.$_$.a2;
  //endregion
  //region block: pre-declaration
  initMetadataForCompanion(Companion);
  initMetadataForClass(Horizontal, 'Horizontal');
  initMetadataForClass(Vertical, 'Vertical');
  initMetadataForClass(BiasAlignment, 'BiasAlignment');
  initMetadataForClass(Horizontal_0, 'Horizontal');
  initMetadataForClass(BiasAbsoluteAlignment, 'BiasAbsoluteAlignment');
  initMetadataForObject(AbsoluteAlignment, 'AbsoluteAlignment');
  initMetadataForObject(ComposeUiFlags, 'ComposeUiFlags');
  function then(other) {
    return other === Companion_instance_6 ? this : new CombinedModifier(this, other);
  }
  initMetadataForInterface(Modifier, 'Modifier');
  function foldIn(initial, operation) {
    return operation(initial, this);
  }
  function all(predicate) {
    return predicate(this);
  }
  initMetadataForInterface(Element_0, 'Element', VOID, VOID, [Modifier]);
  initMetadataForClass(InspectorValueInfo, 'InspectorValueInfo');
  initMetadataForClass(ComposedModifier, 'ComposedModifier', VOID, InspectorValueInfo, [Element_0]);
  initMetadataForCompanion(Companion_0);
  function onDensityChange() {
  }
  function onLayoutDirectionChange() {
  }
  initMetadataForInterface(DelegatableNode, 'DelegatableNode');
  initMetadataForClass(Node, 'Node', VOID, VOID, [DelegatableNode]);
  initMetadataForCompanion(Companion_1, VOID, [Modifier]);
  initMetadataForClass(CombinedModifier, 'CombinedModifier', VOID, VOID, [Modifier]);
  initMetadataForClass(PlatformOptimizedCancellationException, 'PlatformOptimizedCancellationException', VOID, CancellationException);
  initMetadataForClass(ModifierNodeDetachedCancellationException, 'ModifierNodeDetachedCancellationException', ModifierNodeDetachedCancellationException, PlatformOptimizedCancellationException);
  initMetadataForObject(Key, 'Key');
  function get_key() {
    return Key_instance_0;
  }
  initMetadataForInterface(MotionDurationScale, 'MotionDurationScale', VOID, VOID, [Element]);
  initMetadataForClass(Session, 'Session');
  initMetadataForLambda(SessionMutex$withSessionCancellingPrevious$slambda, CoroutineImpl, VOID, [1]);
  initMetadataForClass(ModifierNodeElement, 'ModifierNodeElement', VOID, VOID, [Element_0]);
  initMetadataForClass(ZIndexElement, 'ZIndexElement', VOID, ModifierNodeElement);
  function minIntrinsicWidth(_this__u8e3s4, measurable, height) {
    var tmp = NodeMeasuringIntrinsics_instance;
    var tmp_0 = LayoutModifierNode$minIntrinsicWidth$lambda(this);
    return tmp.bb8(new sam$androidx_compose_ui_node_NodeMeasuringIntrinsics_MeasureBlock$0(tmp_0), _this__u8e3s4, measurable, height);
  }
  function minIntrinsicHeight(_this__u8e3s4, measurable, width) {
    var tmp = NodeMeasuringIntrinsics_instance;
    var tmp_0 = LayoutModifierNode$minIntrinsicHeight$lambda(this);
    return tmp.cb8(new sam$androidx_compose_ui_node_NodeMeasuringIntrinsics_MeasureBlock$0_0(tmp_0), _this__u8e3s4, measurable, width);
  }
  function maxIntrinsicWidth(_this__u8e3s4, measurable, height) {
    var tmp = NodeMeasuringIntrinsics_instance;
    var tmp_0 = LayoutModifierNode$maxIntrinsicWidth$lambda(this);
    return tmp.db8(new sam$androidx_compose_ui_node_NodeMeasuringIntrinsics_MeasureBlock$0_1(tmp_0), _this__u8e3s4, measurable, height);
  }
  function maxIntrinsicHeight(_this__u8e3s4, measurable, width) {
    var tmp = NodeMeasuringIntrinsics_instance;
    var tmp_0 = LayoutModifierNode$maxIntrinsicHeight$lambda(this);
    return tmp.eb8(new sam$androidx_compose_ui_node_NodeMeasuringIntrinsics_MeasureBlock$0_2(tmp_0), _this__u8e3s4, measurable, width);
  }
  initMetadataForInterface(LayoutModifierNode, 'LayoutModifierNode', VOID, VOID, [DelegatableNode]);
  initMetadataForClass(ZIndexNode, 'ZIndexNode', VOID, Node, [LayoutModifierNode]);
  initMetadataForClass(AutofillTree, 'AutofillTree', AutofillTree);
  initMetadataForCompanion(Companion_2);
  function get_textValue() {
    return null;
  }
  function get_booleanValue() {
    return null;
  }
  initMetadataForInterface(FillableData, 'FillableData');
  function onStarted(event) {
    return Unit_instance;
  }
  function onEntered(event) {
    return Unit_instance;
  }
  function onMoved(event) {
    return Unit_instance;
  }
  function onExited(event) {
    return Unit_instance;
  }
  function onEnded(event) {
    return Unit_instance;
  }
  initMetadataForInterface(DragAndDropTarget, 'DragAndDropTarget');
  initMetadataForObject(DragAndDropTraversableKey, 'DragAndDropTraversableKey');
  initMetadataForCompanion(Companion_3);
  initMetadataForInterface(TraversableNode, 'TraversableNode', VOID, VOID, [DelegatableNode]);
  initMetadataForInterface(MeasuredSizeAwareModifierNode, 'MeasuredSizeAwareModifierNode', VOID, VOID, [DelegatableNode]);
  function onPlaced(coordinates) {
  }
  function onRemeasured(size) {
  }
  initMetadataForInterface(LayoutAwareModifierNode, 'LayoutAwareModifierNode', VOID, VOID, [MeasuredSizeAwareModifierNode, DelegatableNode]);
  initMetadataForClass(DragAndDropNode, 'DragAndDropNode', DragAndDropNode, Node, [TraversableNode, DragAndDropTarget, DelegatableNode, LayoutAwareModifierNode]);
  initMetadataForClass(CacheDrawScope, 'CacheDrawScope', VOID, VOID, [Density]);
  initMetadataForClass(DrawResult, 'DrawResult');
  initMetadataForInterface(DrawModifier, 'DrawModifier', VOID, VOID, [Element_0]);
  initMetadataForClass(DrawBehindElement, 'DrawBehindElement', VOID, ModifierNodeElement);
  initMetadataForClass(DrawWithCacheElement, 'DrawWithCacheElement', VOID, ModifierNodeElement);
  initMetadataForObject(EmptyBuildDrawCacheParams, 'EmptyBuildDrawCacheParams');
  function onMeasureResultChanged() {
  }
  initMetadataForInterface(DrawModifierNode, 'DrawModifierNode', VOID, VOID, [DelegatableNode]);
  initMetadataForClass(CacheDrawModifierNodeImpl, 'CacheDrawModifierNodeImpl', VOID, Node, [DrawModifierNode, DelegatableNode]);
  initMetadataForClass(DrawWithContentElement, 'DrawWithContentElement', VOID, ModifierNodeElement);
  initMetadataForClass(DrawBackgroundModifier, 'DrawBackgroundModifier', VOID, Node, [DrawModifierNode]);
  initMetadataForClass(ScopedGraphicsContext, 'ScopedGraphicsContext', ScopedGraphicsContext);
  initMetadataForClass(DrawWithContentModifier, 'DrawWithContentModifier', VOID, Node, [DrawModifierNode]);
  initMetadataForInterface(DrawCacheModifier, 'DrawCacheModifier', VOID, VOID, [DrawModifier]);
  initMetadataForClass(PainterElement, 'PainterElement', VOID, ModifierNodeElement);
  initMetadataForClass(PainterNode, 'PainterNode', VOID, Node, [LayoutModifierNode, DrawModifierNode]);
  initMetadataForClass(ShadowGraphicsLayerElement, 'ShadowGraphicsLayerElement', VOID, ModifierNodeElement);
  initMetadataForClass(FocusChangedElement, 'FocusChangedElement', VOID, ModifierNodeElement);
  initMetadataForInterface(FocusEventModifierNode, 'FocusEventModifierNode', VOID, VOID, [DelegatableNode]);
  initMetadataForClass(FocusChangedNode, 'FocusChangedNode', VOID, Node, [FocusEventModifierNode]);
  initMetadataForCompanion(Companion_4);
  initMetadataForClass(FocusDirection, 'FocusDirection');
  initMetadataForInterface(FocusEventModifier, 'FocusEventModifier', VOID, VOID, [Element_0]);
  initMetadataForClass(FocusInvalidationManager, 'FocusInvalidationManager');
  function clearFocus$default(force, $super) {
    force = force === VOID ? false : force;
    var tmp;
    if ($super === VOID) {
      this.d9d(force);
      tmp = Unit_instance;
    } else {
      tmp = $super.d9d.call(this, force);
    }
    return tmp;
  }
  initMetadataForInterface(FocusManager, 'FocusManager');
  initMetadataForInterface(FocusPropertiesScope, 'FocusPropertiesScope');
  initMetadataForInterface(FocusOrderModifier, 'FocusOrderModifier', VOID, VOID, [Element_0]);
  initMetadataForClass(FocusOrder, 'FocusOrder', FocusOrder_init_$Create$);
  function dispatchKeyEvent$default(keyEvent, onFocusedItem, $super) {
    var tmp;
    if (onFocusedItem === VOID) {
      tmp = FocusOwner$dispatchKeyEvent$lambda;
    } else {
      tmp = onFocusedItem;
    }
    onFocusedItem = tmp;
    return $super === VOID ? this.m9d(keyEvent, onFocusedItem) : $super.m9d.call(this, new KeyEvent(keyEvent), onFocusedItem);
  }
  initMetadataForInterface(FocusOwner, 'FocusOwner', VOID, VOID, [FocusManager]);
  initMetadataForClass(FocusOwnerImpl$modifier$1, VOID, VOID, ModifierNodeElement);
  initMetadataForClass(FocusOwnerImpl, 'FocusOwnerImpl', VOID, VOID, [FocusOwner]);
  initMetadataForCompanion(Companion_5);
  function get_next() {
    return Companion_getInstance_32().r9e_1;
  }
  function get_previous() {
    return Companion_getInstance_32().r9e_1;
  }
  function get_up() {
    return Companion_getInstance_32().r9e_1;
  }
  function get_down() {
    return Companion_getInstance_32().r9e_1;
  }
  function get_left() {
    return Companion_getInstance_32().r9e_1;
  }
  function get_right() {
    return Companion_getInstance_32().r9e_1;
  }
  function get_start() {
    return Companion_getInstance_32().r9e_1;
  }
  function get_end() {
    return Companion_getInstance_32().r9e_1;
  }
  function get_onEnter() {
    return FocusProperties$_get_onEnter_$lambda_szd2j8;
  }
  function set_onExit(_) {
  }
  function get_onExit() {
    return FocusProperties$_get_onExit_$lambda_n14g70;
  }
  function get_focusRect() {
    return Companion_getInstance_31().z9e_1;
  }
  initMetadataForInterface(FocusProperties, 'FocusProperties');
  initMetadataForClass(FocusPropertiesElement, 'FocusPropertiesElement', VOID, ModifierNodeElement);
  initMetadataForInterface(FocusPropertiesModifierNode, 'FocusPropertiesModifierNode', VOID, VOID, [DelegatableNode]);
  initMetadataForClass(FocusPropertiesNode, 'FocusPropertiesNode', VOID, Node, [FocusPropertiesModifierNode]);
  initMetadataForClass(FocusPropertiesImpl, 'FocusPropertiesImpl', FocusPropertiesImpl, VOID, [FocusProperties]);
  initMetadataForClass(CancelIndicatingFocusBoundaryScope, 'CancelIndicatingFocusBoundaryScope');
  initMetadataForClass(sam$androidx_compose_ui_focus_FocusPropertiesScope$0, 'sam$androidx_compose_ui_focus_FocusPropertiesScope$0', VOID, VOID, [FocusPropertiesScope, FunctionAdapter]);
  initMetadataForCompanion(Companion_6);
  initMetadataForClass(FocusRequester, 'FocusRequester', FocusRequester);
  initMetadataForClass(FocusRequesterElement, 'FocusRequesterElement', VOID, ModifierNodeElement);
  initMetadataForClass(FocusRequesterNode, 'FocusRequesterNode', VOID, Node, [DelegatableNode]);
  initMetadataForInterface(FocusRequesterModifier, 'FocusRequesterModifier', VOID, VOID, [Element_0]);
  initMetadataForClass(FocusStateImpl, 'FocusStateImpl', VOID, Enum);
  function requestFocus$default(focusDirection, $super) {
    focusDirection = focusDirection === VOID ? Companion_getInstance_30().q9b_1 : focusDirection;
    return $super === VOID ? this.i9e(focusDirection) : $super.i9e.call(this, new FocusDirection(focusDirection));
  }
  initMetadataForInterface(FocusTargetModifierNode, 'FocusTargetModifierNode', VOID, VOID, [DelegatableNode]);
  initMetadataForInterface(CompositionLocalConsumerModifierNode, 'CompositionLocalConsumerModifierNode', VOID, VOID, [DelegatableNode]);
  function get_providedValues() {
    return EmptyMap_getInstance();
  }
  initMetadataForInterface(ModifierLocalModifierNode, 'ModifierLocalModifierNode', VOID, VOID, [DelegatableNode]);
  initMetadataForClass(FocusTargetNode, 'FocusTargetNode', FocusTargetNode, Node, [CompositionLocalConsumerModifierNode, LayoutAwareModifierNode, FocusTargetModifierNode, DelegatableNode, ModifierLocalModifierNode]);
  initMetadataForClass(CustomDestinationResult, 'CustomDestinationResult', VOID, Enum);
  initMetadataForCompanion(Companion_7);
  initMetadataForObject(FocusableChildrenComparator, 'FocusableChildrenComparator', VOID, VOID, [Comparator]);
  function focusTargetAvailable() {
  }
  initMetadataForInterface(PlatformFocusOwner, 'PlatformFocusOwner');
  function get_shouldClearDescendantSemantics() {
    return false;
  }
  function get_shouldMergeDescendantSemantics() {
    return false;
  }
  function get_isImportantForBounds() {
    return true;
  }
  initMetadataForInterface(SemanticsModifierNode, 'SemanticsModifierNode', VOID, VOID, [DelegatableNode]);
  initMetadataForClass(BlockGraphicsLayerModifier, 'BlockGraphicsLayerModifier', VOID, Node, [LayoutModifierNode, SemanticsModifierNode]);
  initMetadataForClass(BlockGraphicsLayerElement, 'BlockGraphicsLayerElement', VOID, ModifierNodeElement);
  initMetadataForCompanion(Companion_8);
  initMetadataForClass(GraphicsLayerElement, 'GraphicsLayerElement', VOID, ModifierNodeElement);
  initMetadataForClass(SimpleGraphicsLayerModifier, 'SimpleGraphicsLayerModifier', VOID, Node, [LayoutModifierNode, SemanticsModifierNode]);
  function set_ambientShadowColor(ambientShadowColor) {
  }
  function set_spotShadowColor(spotShadowColor) {
  }
  function set_renderEffect(_) {
  }
  function set_blendMode(_) {
  }
  function set_colorFilter(_) {
  }
  function set_compositingStrategy(compositingStrategy) {
  }
  function get_size() {
    return Companion_getInstance_1().k5e_1;
  }
  initMetadataForInterface(GraphicsLayerScope, 'GraphicsLayerScope', VOID, VOID, [Density]);
  initMetadataForClass(ReusableGraphicsLayerScope, 'ReusableGraphicsLayerScope', ReusableGraphicsLayerScope, VOID, [GraphicsLayerScope]);
  initMetadataForCompanion(Companion_9);
  initMetadataForClass(TransformOrigin, 'TransformOrigin');
  initMetadataForClass(DrawCache, 'DrawCache', DrawCache);
  initMetadataForClass(GroupParams, 'GroupParams', GroupParams);
  initMetadataForClass(Builder, 'Builder');
  initMetadataForCompanion(Companion_10);
  initMetadataForClass(ImageVector, 'ImageVector');
  initMetadataForClass(VectorGroup$iterator$1);
  initMetadataForClass(VectorNode, 'VectorNode');
  initMetadataForClass(VectorGroup, 'VectorGroup', VOID, VectorNode);
  initMetadataForClass(VectorPath, 'VectorPath', VOID, VectorNode);
  initMetadataForClass(VNode, 'VNode');
  initMetadataForClass(GroupComponent, 'GroupComponent', GroupComponent, VNode);
  initMetadataForClass(VectorComponent, 'VectorComponent', VOID, VNode);
  initMetadataForClass(PathComponent, 'PathComponent', PathComponent, VNode);
  initMetadataForClass(VectorPainter, 'VectorPainter', VOID, Painter);
  initMetadataForCompanion(Companion_11);
  initMetadataForClass(HapticFeedbackType, 'HapticFeedbackType');
  initMetadataForCompanion(Companion_12);
  initMetadataForClass(InputMode, 'InputMode');
  initMetadataForInterface(IndirectPointerInputModifierNode, 'IndirectPointerInputModifierNode', VOID, VOID, [DelegatableNode]);
  initMetadataForClass(KeyEvent, 'KeyEvent');
  initMetadataForCompanion(Companion_13);
  initMetadataForClass(KeyInputElement, 'KeyInputElement', VOID, ModifierNodeElement);
  initMetadataForInterface(KeyInputModifierNode, 'KeyInputModifierNode', VOID, VOID, [DelegatableNode]);
  initMetadataForClass(KeyInputNode, 'KeyInputNode', VOID, Node, [KeyInputModifierNode]);
  initMetadataForInterface(SoftKeyboardInterceptionModifierNode, 'SoftKeyboardInterceptionModifierNode', VOID, VOID, [DelegatableNode]);
  function onPreScroll(available, source) {
    return Companion_getInstance().g5d_1;
  }
  function onPostScroll(consumed, available, source) {
    return Companion_getInstance().g5d_1;
  }
  function onPreFling(available, $completion) {
    return new Velocity(Companion_getInstance_10().v5g_1);
  }
  function onPostFling(consumed, available, $completion) {
    return new Velocity(Companion_getInstance_10().v5g_1);
  }
  initMetadataForInterface(NestedScrollConnection, 'NestedScrollConnection', VOID, VOID, VOID, [1, 2]);
  initMetadataForCompanion(Companion_14);
  initMetadataForCoroutine($dispatchPreFlingCOROUTINE$, CoroutineImpl);
  initMetadataForCoroutine($dispatchPostFlingCOROUTINE$, CoroutineImpl);
  initMetadataForClass(NestedScrollDispatcher, 'NestedScrollDispatcher', NestedScrollDispatcher, VOID, VOID, [1, 2]);
  initMetadataForClass(NestedScrollElement, 'NestedScrollElement', VOID, ModifierNodeElement);
  initMetadataForCoroutine($onPreFlingCOROUTINE$, CoroutineImpl);
  initMetadataForCoroutine($onPostFlingCOROUTINE$, CoroutineImpl);
  initMetadataForClass(NestedScrollNode, 'NestedScrollNode', VOID, Node, [TraversableNode, NestedScrollConnection], [1, 2]);
  initMetadataForClass(HitPathTracker, 'HitPathTracker');
  initMetadataForClass(NodeParent, 'NodeParent', NodeParent);
  initMetadataForClass(Node_0, 'Node', VOID, NodeParent);
  initMetadataForClass(PointerInputEventData, 'PointerInputEventData');
  initMetadataForClass(PointerInputChange, 'PointerInputChange');
  initMetadataForClass(PointerEventPass, 'PointerEventPass', VOID, Enum);
  initMetadataForCompanion(Companion_15);
  initMetadataForClass(PointerEventType, 'PointerEventType');
  initMetadataForCompanion(Companion_16);
  initMetadataForClass(PointerType, 'PointerType');
  initMetadataForClass(PointerId, 'PointerId');
  initMetadataForClass(PointerButtons, 'PointerButtons');
  initMetadataForClass(HistoricalChange, 'HistoricalChange');
  initMetadataForClass(PointerKeyboardModifiers, 'PointerKeyboardModifiers');
  initMetadataForInterface(PointerInputModifier, 'PointerInputModifier', VOID, VOID, [Element_0]);
  initMetadataForCompanion(Companion_17);
  initMetadataForClass(PointerHoverIconModifierElement, 'PointerHoverIconModifierElement', VOID, ModifierNodeElement);
  initMetadataForClass(StylusHoverIconModifierElement, 'StylusHoverIconModifierElement', VOID, ModifierNodeElement);
  function interceptOutOfBoundsChildEvents() {
    return false;
  }
  function sharePointerInputWithSiblings() {
    return false;
  }
  function onDensityChange_0() {
    this.xa1();
  }
  function onViewConfigurationChange() {
    this.xa1();
  }
  function get_touchBoundsExpansion() {
    return Companion_getInstance_63().ia6_1;
  }
  initMetadataForInterface(PointerInputModifierNode, 'PointerInputModifierNode', VOID, VOID, [DelegatableNode]);
  initMetadataForClass(HoverIconModifierNode, 'HoverIconModifierNode', VOID, Node, [TraversableNode, PointerInputModifierNode, CompositionLocalConsumerModifierNode]);
  initMetadataForClass(PointerHoverIconModifierNode, 'PointerHoverIconModifierNode', VOID, HoverIconModifierNode);
  initMetadataForClass(StylusHoverIconModifierNode, 'StylusHoverIconModifierNode', VOID, HoverIconModifierNode);
  initMetadataForClass(PointerInputEventProcessor, 'PointerInputEventProcessor');
  initMetadataForClass(PointerInputData, 'PointerInputData');
  initMetadataForClass(PointerInputChangeEventProducer, 'PointerInputChangeEventProducer', PointerInputChangeEventProducer);
  initMetadataForInterface(PointerInputEventHandler, 'PointerInputEventHandler', VOID, VOID, VOID, [1]);
  initMetadataForInterface(PointerInputScope, 'PointerInputScope', VOID, VOID, [Density], [1]);
  function get_extendedTouchPadding() {
    return Companion_getInstance_1().j5e_1;
  }
  function awaitPointerEvent$default(pass, $completion, $super) {
    pass = pass === VOID ? PointerEventPass_Main_getInstance() : pass;
    return $super === VOID ? this.pa7(pass, $completion) : $super.pa7.call(this, pass, $completion);
  }
  function withTimeoutOrNull(timeMillis, block, $completion) {
    return block(this, $completion);
  }
  function withTimeout(timeMillis, block, $completion) {
    return block(this, $completion);
  }
  initMetadataForInterface(AwaitPointerEventScope, 'AwaitPointerEventScope', VOID, VOID, [Density], [1, 2]);
  initMetadataForClass(SuspendPointerInputElement, 'SuspendPointerInputElement', VOID, ModifierNodeElement);
  initMetadataForLambda(SuspendingPointerInputModifierNodeImpl$PointerEventHandlerCoroutine$withTimeout$slambda, CoroutineImpl, VOID, [1]);
  initMetadataForCoroutine($withTimeoutOrNullCOROUTINE$, CoroutineImpl);
  initMetadataForCoroutine($withTimeoutCOROUTINE$, CoroutineImpl);
  initMetadataForClass(PointerEventHandlerCoroutine, 'PointerEventHandlerCoroutine', VOID, VOID, [AwaitPointerEventScope, Density, Continuation], [1, 2]);
  initMetadataForLambda(SuspendingPointerInputModifierNodeImpl$onPointerEvent$slambda, CoroutineImpl, VOID, [1]);
  initMetadataForClass(SuspendingPointerInputModifierNodeImpl, 'SuspendingPointerInputModifierNodeImpl', VOID, Node, [PointerInputModifierNode, PointerInputScope, Density], [1]);
  initMetadataForClass(PointerInputResetException, 'PointerInputResetException', PointerInputResetException, PlatformOptimizedCancellationException);
  initMetadataForObject(CancelTimeoutCancellationException, 'CancelTimeoutCancellationException', VOID, PlatformOptimizedCancellationException);
  initMetadataForClass(PointerIdArray, 'PointerIdArray', PointerIdArray);
  initMetadataForClass(VelocityTracker, 'VelocityTracker', VelocityTracker);
  initMetadataForClass(Strategy, 'Strategy', VOID, Enum);
  initMetadataForClass(VelocityTracker1D, 'VelocityTracker1D');
  initMetadataForClass(DataPointAtTime, 'DataPointAtTime');
  initMetadataForInterface(RotaryInputModifierNode, 'RotaryInputModifierNode', VOID, VOID, [DelegatableNode]);
  initMetadataForClass(AlignmentLine, 'AlignmentLine');
  initMetadataForClass(HorizontalAlignmentLine, 'HorizontalAlignmentLine', VOID, AlignmentLine);
  initMetadataForClass(VerticalAlignmentLine, 'VerticalAlignmentLine', VOID, AlignmentLine);
  initMetadataForCompanion(Companion_18);
  initMetadataForInterface(ApproachMeasureBlock, 'ApproachMeasureBlock');
  initMetadataForClass(sam$androidx_compose_ui_node_NodeMeasuringIntrinsics_ApproachMeasureBlock$0, 'sam$androidx_compose_ui_node_NodeMeasuringIntrinsics_ApproachMeasureBlock$0', VOID, VOID, [ApproachMeasureBlock, FunctionAdapter]);
  initMetadataForClass(sam$androidx_compose_ui_node_NodeMeasuringIntrinsics_ApproachMeasureBlock$0_0, 'sam$androidx_compose_ui_node_NodeMeasuringIntrinsics_ApproachMeasureBlock$0', VOID, VOID, [ApproachMeasureBlock, FunctionAdapter]);
  initMetadataForClass(sam$androidx_compose_ui_node_NodeMeasuringIntrinsics_ApproachMeasureBlock$0_1, 'sam$androidx_compose_ui_node_NodeMeasuringIntrinsics_ApproachMeasureBlock$0', VOID, VOID, [ApproachMeasureBlock, FunctionAdapter]);
  initMetadataForClass(sam$androidx_compose_ui_node_NodeMeasuringIntrinsics_ApproachMeasureBlock$0_2, 'sam$androidx_compose_ui_node_NodeMeasuringIntrinsics_ApproachMeasureBlock$0', VOID, VOID, [ApproachMeasureBlock, FunctionAdapter]);
  function isPlacementApproachInProgress(_this__u8e3s4, lookaheadCoordinates) {
    return false;
  }
  function minApproachIntrinsicWidth(_this__u8e3s4, measurable, height) {
    var tmp;
    if (ensureNotNull(ensureNotNull(this.f4n().t8v_1).kac()).fad()) {
      var tmp_0 = NodeMeasuringIntrinsics_instance;
      var tmp_1 = ApproachLayoutModifierNode$minApproachIntrinsicWidth$lambda(this);
      tmp = tmp_0.jac(new sam$androidx_compose_ui_node_NodeMeasuringIntrinsics_ApproachMeasureBlock$0(tmp_1), _this__u8e3s4, measurable, height);
    } else {
      tmp = measurable.b98(height);
    }
    return tmp;
  }
  function minApproachIntrinsicHeight(_this__u8e3s4, measurable, width) {
    var tmp;
    if (ensureNotNull(ensureNotNull(this.f4n().t8v_1).kac()).fad()) {
      var tmp_0 = NodeMeasuringIntrinsics_instance;
      var tmp_1 = ApproachLayoutModifierNode$minApproachIntrinsicHeight$lambda(this);
      tmp = tmp_0.had(new sam$androidx_compose_ui_node_NodeMeasuringIntrinsics_ApproachMeasureBlock$0_0(tmp_1), _this__u8e3s4, measurable, width);
    } else {
      tmp = measurable.d98(width);
    }
    return tmp;
  }
  function maxApproachIntrinsicWidth(_this__u8e3s4, measurable, height) {
    var tmp;
    if (ensureNotNull(ensureNotNull(this.f4n().t8v_1).kac()).fad()) {
      var tmp_0 = NodeMeasuringIntrinsics_instance;
      var tmp_1 = ApproachLayoutModifierNode$maxApproachIntrinsicWidth$lambda(this);
      tmp = tmp_0.jad(new sam$androidx_compose_ui_node_NodeMeasuringIntrinsics_ApproachMeasureBlock$0_1(tmp_1), _this__u8e3s4, measurable, height);
    } else {
      tmp = measurable.c98(height);
    }
    return tmp;
  }
  function maxApproachIntrinsicHeight(_this__u8e3s4, measurable, width) {
    var tmp;
    if (ensureNotNull(ensureNotNull(this.f4n().t8v_1).kac()).fad()) {
      var tmp_0 = NodeMeasuringIntrinsics_instance;
      var tmp_1 = ApproachLayoutModifierNode$maxApproachIntrinsicHeight$lambda(this);
      tmp = tmp_0.lad(new sam$androidx_compose_ui_node_NodeMeasuringIntrinsics_ApproachMeasureBlock$0_2(tmp_1), _this__u8e3s4, measurable, width);
    } else {
      tmp = measurable.e98(width);
    }
    return tmp;
  }
  initMetadataForInterface(ApproachLayoutModifierNode, 'ApproachLayoutModifierNode', VOID, VOID, [LayoutModifierNode]);
  function get_rulers() {
    return null;
  }
  initMetadataForInterface(MeasureResult, 'MeasureResult');
  initMetadataForClass(ApproachMeasureScopeImpl$layout$1, VOID, VOID, VOID, [MeasureResult]);
  function get_isLookingAhead() {
    return false;
  }
  initMetadataForInterface(IntrinsicMeasureScope, 'IntrinsicMeasureScope', VOID, VOID, [Density]);
  function layout(width, height, alignmentLines, placementBlock) {
    return this.hag(width, height, alignmentLines, null, placementBlock);
  }
  function layout$default(width, height, alignmentLines, placementBlock, $super) {
    alignmentLines = alignmentLines === VOID ? emptyMap() : alignmentLines;
    return $super === VOID ? this.kag(width, height, alignmentLines, placementBlock) : layout(width, height, alignmentLines, placementBlock);
  }
  function layout_0(width, height, alignmentLines, rulers, placementBlock) {
    // Inline function 'androidx.compose.ui.node.checkMeasuredSize' call
    // Inline function 'androidx.compose.ui.internal.checkPrecondition' call
    if (!((width & -16777216) === 0 && (height & -16777216) === 0)) {
      var tmp$ret$2 = 'Size(' + width + ' x ' + height + ') is out of range. Each dimension must be between 0 and ' + '16777215.';
      throwIllegalStateException(tmp$ret$2);
    }
    return new MeasureScope$layout$1(width, height, alignmentLines, rulers, this, placementBlock);
  }
  function layout$default_0(width, height, alignmentLines, rulers, placementBlock, $super) {
    alignmentLines = alignmentLines === VOID ? emptyMap() : alignmentLines;
    rulers = rulers === VOID ? null : rulers;
    return $super === VOID ? this.hag(width, height, alignmentLines, rulers, placementBlock) : layout_0(width, height, alignmentLines, rulers, placementBlock);
  }
  initMetadataForInterface(MeasureScope, 'MeasureScope', VOID, VOID, [IntrinsicMeasureScope]);
  initMetadataForClass(ApproachMeasureScopeImpl, 'ApproachMeasureScopeImpl', VOID, VOID, [MeasureScope, IntrinsicMeasureScope]);
  initMetadataForCompanion(Companion_19);
  initMetadataForInterface(BeyondBoundsLayoutProviderModifierNode, 'BeyondBoundsLayoutProviderModifierNode', VOID, VOID, [DelegatableNode]);
  initMetadataForClass(ContentScale$Companion$Crop$1);
  initMetadataForClass(ContentScale$Companion$Fit$1);
  initMetadataForClass(ContentScale$Companion$FillHeight$1);
  initMetadataForClass(ContentScale$Companion$FillWidth$1);
  initMetadataForClass(ContentScale$Companion$Inside$1);
  initMetadataForClass(ContentScale$Companion$FillBounds$1);
  initMetadataForCompanion(Companion_20);
  initMetadataForClass(FixedScale, 'FixedScale');
  initMetadataForClass(IntrinsicsMeasureScope$layout$1, VOID, VOID, VOID, [MeasureResult]);
  initMetadataForClass(IntrinsicsMeasureScope, 'IntrinsicsMeasureScope', VOID, VOID, [MeasureScope, IntrinsicMeasureScope]);
  initMetadataForClass(DefaultIntrinsicMeasurable, 'DefaultIntrinsicMeasurable');
  initMetadataForClass(IntrinsicMinMax, 'IntrinsicMinMax', VOID, Enum);
  initMetadataForClass(IntrinsicWidthHeight, 'IntrinsicWidthHeight', VOID, Enum);
  initMetadataForClass(ApproachIntrinsicsMeasureScope$layout$1, VOID, VOID, VOID, [MeasureResult]);
  initMetadataForClass(ApproachIntrinsicsMeasureScope, 'ApproachIntrinsicsMeasureScope', VOID, VOID, [MeasureScope, IntrinsicMeasureScope]);
  function get_parentData() {
    return null;
  }
  initMetadataForInterface(Measured, 'Measured');
  initMetadataForClass(Placeable, 'Placeable', VOID, VOID, [Measured]);
  initMetadataForClass(FixedSizeIntrinsicsPlaceable, 'FixedSizeIntrinsicsPlaceable', VOID, Placeable);
  function localToScreen(relativeToLocal) {
    return Companion_getInstance().i5d_1;
  }
  function localPositionOf(sourceCoordinates, relativeToSource, includeMotionFrameOfReference) {
    throw UnsupportedOperationException_init_$Create$('localPositionOf is not implemented on this LayoutCoordinates');
  }
  function localPositionOf$default(sourceCoordinates, relativeToSource, includeMotionFrameOfReference, $super) {
    relativeToSource = relativeToSource === VOID ? Companion_getInstance().g5d_1 : relativeToSource;
    includeMotionFrameOfReference = includeMotionFrameOfReference === VOID ? true : includeMotionFrameOfReference;
    return $super === VOID ? this.eai(sourceCoordinates, relativeToSource, includeMotionFrameOfReference) : localPositionOf(sourceCoordinates, relativeToSource, includeMotionFrameOfReference);
  }
  function localBoundingBoxOf$default(sourceCoordinates, clipBounds, $super) {
    clipBounds = clipBounds === VOID ? true : clipBounds;
    return $super === VOID ? this.x9h(sourceCoordinates, clipBounds) : $super.x9h.call(this, sourceCoordinates, clipBounds);
  }
  function transformFrom(sourceCoordinates, matrix) {
    throwUnsupportedOperationException('transformFrom is not implemented on this LayoutCoordinates');
  }
  initMetadataForInterface(LayoutCoordinates, 'LayoutCoordinates');
  initMetadataForInterface(LayoutIdParentData, 'LayoutIdParentData');
  initMetadataForClass(LayoutIdElement, 'LayoutIdElement', VOID, ModifierNodeElement);
  initMetadataForInterface(ParentDataModifierNode, 'ParentDataModifierNode', VOID, VOID, [DelegatableNode]);
  initMetadataForClass(LayoutIdModifier, 'LayoutIdModifier', VOID, Node, [ParentDataModifierNode, LayoutIdParentData]);
  function minIntrinsicWidth_0(_this__u8e3s4, measurable, height) {
    return MeasuringIntrinsics_instance.baj(this, _this__u8e3s4, measurable, height);
  }
  function minIntrinsicHeight_0(_this__u8e3s4, measurable, width) {
    return MeasuringIntrinsics_instance.caj(this, _this__u8e3s4, measurable, width);
  }
  function maxIntrinsicWidth_0(_this__u8e3s4, measurable, height) {
    return MeasuringIntrinsics_instance.daj(this, _this__u8e3s4, measurable, height);
  }
  function maxIntrinsicHeight_0(_this__u8e3s4, measurable, width) {
    return MeasuringIntrinsics_instance.eaj(this, _this__u8e3s4, measurable, width);
  }
  initMetadataForInterface(LayoutModifier, 'LayoutModifier', VOID, VOID, [Element_0]);
  initMetadataForClass(LayoutElement, 'LayoutElement', VOID, ModifierNodeElement);
  initMetadataForClass(DefaultIntrinsicMeasurable_0, 'DefaultIntrinsicMeasurable');
  initMetadataForClass(EmptyPlaceable, 'EmptyPlaceable', VOID, Placeable);
  initMetadataForClass(IntrinsicMinMax_0, 'IntrinsicMinMax', VOID, Enum);
  initMetadataForClass(IntrinsicWidthHeight_0, 'IntrinsicWidthHeight', VOID, Enum);
  initMetadataForObject(MeasuringIntrinsics, 'MeasuringIntrinsics');
  initMetadataForClass(LayoutModifierImpl, 'LayoutModifierImpl', VOID, Node, [LayoutModifierNode]);
  initMetadataForClass(LookaheadLayoutCoordinates, 'LookaheadLayoutCoordinates', VOID, VOID, [LayoutCoordinates]);
  function minIntrinsicWidth_1(_this__u8e3s4, measurables, height) {
    // Inline function 'androidx.compose.ui.util.fastMap' call
    var target = ArrayList_init_$Create$_0(measurables.n1());
    // Inline function 'androidx.compose.ui.util.fastForEach' call
    var inductionVariable = 0;
    var last = measurables.n1() - 1 | 0;
    if (inductionVariable <= last)
      do {
        var index = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var item = measurables.l1(index);
        // Inline function 'kotlin.collections.plusAssign' call
        var element = new DefaultIntrinsicMeasurable(item, IntrinsicMinMax_Min_getInstance(), IntrinsicWidthHeight_Width_getInstance());
        target.j1(element);
      }
       while (inductionVariable <= last);
    var mapped = target;
    var constraints = Constraints(VOID, VOID, VOID, height);
    var layoutReceiver = new IntrinsicsMeasureScope(_this__u8e3s4, _this__u8e3s4.r6p());
    var layoutResult = this.mak(layoutReceiver, mapped, constraints);
    return layoutResult.h5e();
  }
  function minIntrinsicHeight_1(_this__u8e3s4, measurables, width) {
    // Inline function 'androidx.compose.ui.util.fastMap' call
    var target = ArrayList_init_$Create$_0(measurables.n1());
    // Inline function 'androidx.compose.ui.util.fastForEach' call
    var inductionVariable = 0;
    var last = measurables.n1() - 1 | 0;
    if (inductionVariable <= last)
      do {
        var index = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var item = measurables.l1(index);
        // Inline function 'kotlin.collections.plusAssign' call
        var element = new DefaultIntrinsicMeasurable(item, IntrinsicMinMax_Min_getInstance(), IntrinsicWidthHeight_Height_getInstance());
        target.j1(element);
      }
       while (inductionVariable <= last);
    var mapped = target;
    var constraints = Constraints(VOID, width);
    var layoutReceiver = new IntrinsicsMeasureScope(_this__u8e3s4, _this__u8e3s4.r6p());
    var layoutResult = this.mak(layoutReceiver, mapped, constraints);
    return layoutResult.i5e();
  }
  function maxIntrinsicWidth_1(_this__u8e3s4, measurables, height) {
    // Inline function 'androidx.compose.ui.util.fastMap' call
    var target = ArrayList_init_$Create$_0(measurables.n1());
    // Inline function 'androidx.compose.ui.util.fastForEach' call
    var inductionVariable = 0;
    var last = measurables.n1() - 1 | 0;
    if (inductionVariable <= last)
      do {
        var index = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var item = measurables.l1(index);
        // Inline function 'kotlin.collections.plusAssign' call
        var element = new DefaultIntrinsicMeasurable(item, IntrinsicMinMax_Max_getInstance(), IntrinsicWidthHeight_Width_getInstance());
        target.j1(element);
      }
       while (inductionVariable <= last);
    var mapped = target;
    var constraints = Constraints(VOID, VOID, VOID, height);
    var layoutReceiver = new IntrinsicsMeasureScope(_this__u8e3s4, _this__u8e3s4.r6p());
    var layoutResult = this.mak(layoutReceiver, mapped, constraints);
    return layoutResult.h5e();
  }
  function maxIntrinsicHeight_1(_this__u8e3s4, measurables, width) {
    // Inline function 'androidx.compose.ui.util.fastMap' call
    var target = ArrayList_init_$Create$_0(measurables.n1());
    // Inline function 'androidx.compose.ui.util.fastForEach' call
    var inductionVariable = 0;
    var last = measurables.n1() - 1 | 0;
    if (inductionVariable <= last)
      do {
        var index = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var item = measurables.l1(index);
        // Inline function 'kotlin.collections.plusAssign' call
        var element = new DefaultIntrinsicMeasurable(item, IntrinsicMinMax_Max_getInstance(), IntrinsicWidthHeight_Height_getInstance());
        target.j1(element);
      }
       while (inductionVariable <= last);
    var mapped = target;
    var constraints = Constraints(VOID, width);
    var layoutReceiver = new IntrinsicsMeasureScope(_this__u8e3s4, _this__u8e3s4.r6p());
    var layoutResult = this.mak(layoutReceiver, mapped, constraints);
    return layoutResult.i5e();
  }
  initMetadataForInterface(MeasurePolicy, 'MeasurePolicy');
  initMetadataForClass(MeasureScope$layout$1, VOID, VOID, VOID, [MeasureResult]);
  initMetadataForClass(PlacementScope, 'PlacementScope', VOID, VOID, [Density]);
  initMetadataForClass(SimplePlacementScope, 'SimplePlacementScope', VOID, PlacementScope);
  function minIntrinsicWidth_2(_this__u8e3s4, measurables, height) {
    // Inline function 'androidx.compose.ui.util.fastMap' call
    var target = ArrayList_init_$Create$_0(measurables.n1());
    // Inline function 'androidx.compose.ui.util.fastForEach' call
    var inductionVariable = 0;
    var last = measurables.n1() - 1 | 0;
    if (inductionVariable <= last)
      do {
        var index = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var item = measurables.l1(index);
        // Inline function 'androidx.compose.ui.util.fastMap' call
        var target_0 = ArrayList_init_$Create$_0(item.n1());
        // Inline function 'androidx.compose.ui.util.fastForEach' call
        var inductionVariable_0 = 0;
        var last_0 = item.n1() - 1 | 0;
        if (inductionVariable_0 <= last_0)
          do {
            var index_0 = inductionVariable_0;
            inductionVariable_0 = inductionVariable_0 + 1 | 0;
            var item_0 = item.l1(index_0);
            // Inline function 'kotlin.collections.plusAssign' call
            var element = new DefaultIntrinsicMeasurable(item_0, IntrinsicMinMax_Min_getInstance(), IntrinsicWidthHeight_Width_getInstance());
            target_0.j1(element);
          }
           while (inductionVariable_0 <= last_0);
        // Inline function 'kotlin.collections.plusAssign' call
        target.j1(target_0);
      }
       while (inductionVariable <= last);
    var mapped = target;
    var constraints = Constraints(VOID, VOID, VOID, height);
    var layoutReceiver = new IntrinsicsMeasureScope(_this__u8e3s4, _this__u8e3s4.r6p());
    var layoutResult = this.yal(layoutReceiver, mapped, constraints);
    return layoutResult.h5e();
  }
  function minIntrinsicHeight_2(_this__u8e3s4, measurables, width) {
    // Inline function 'androidx.compose.ui.util.fastMap' call
    var target = ArrayList_init_$Create$_0(measurables.n1());
    // Inline function 'androidx.compose.ui.util.fastForEach' call
    var inductionVariable = 0;
    var last = measurables.n1() - 1 | 0;
    if (inductionVariable <= last)
      do {
        var index = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var item = measurables.l1(index);
        // Inline function 'androidx.compose.ui.util.fastMap' call
        var target_0 = ArrayList_init_$Create$_0(item.n1());
        // Inline function 'androidx.compose.ui.util.fastForEach' call
        var inductionVariable_0 = 0;
        var last_0 = item.n1() - 1 | 0;
        if (inductionVariable_0 <= last_0)
          do {
            var index_0 = inductionVariable_0;
            inductionVariable_0 = inductionVariable_0 + 1 | 0;
            var item_0 = item.l1(index_0);
            // Inline function 'kotlin.collections.plusAssign' call
            var element = new DefaultIntrinsicMeasurable(item_0, IntrinsicMinMax_Min_getInstance(), IntrinsicWidthHeight_Height_getInstance());
            target_0.j1(element);
          }
           while (inductionVariable_0 <= last_0);
        // Inline function 'kotlin.collections.plusAssign' call
        target.j1(target_0);
      }
       while (inductionVariable <= last);
    var mapped = target;
    var constraints = Constraints(VOID, width);
    var layoutReceiver = new IntrinsicsMeasureScope(_this__u8e3s4, _this__u8e3s4.r6p());
    var layoutResult = this.yal(layoutReceiver, mapped, constraints);
    return layoutResult.i5e();
  }
  function maxIntrinsicWidth_2(_this__u8e3s4, measurables, height) {
    // Inline function 'androidx.compose.ui.util.fastMap' call
    var target = ArrayList_init_$Create$_0(measurables.n1());
    // Inline function 'androidx.compose.ui.util.fastForEach' call
    var inductionVariable = 0;
    var last = measurables.n1() - 1 | 0;
    if (inductionVariable <= last)
      do {
        var index = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var item = measurables.l1(index);
        // Inline function 'androidx.compose.ui.util.fastMap' call
        var target_0 = ArrayList_init_$Create$_0(item.n1());
        // Inline function 'androidx.compose.ui.util.fastForEach' call
        var inductionVariable_0 = 0;
        var last_0 = item.n1() - 1 | 0;
        if (inductionVariable_0 <= last_0)
          do {
            var index_0 = inductionVariable_0;
            inductionVariable_0 = inductionVariable_0 + 1 | 0;
            var item_0 = item.l1(index_0);
            // Inline function 'kotlin.collections.plusAssign' call
            var element = new DefaultIntrinsicMeasurable(item_0, IntrinsicMinMax_Max_getInstance(), IntrinsicWidthHeight_Width_getInstance());
            target_0.j1(element);
          }
           while (inductionVariable_0 <= last_0);
        // Inline function 'kotlin.collections.plusAssign' call
        target.j1(target_0);
      }
       while (inductionVariable <= last);
    var mapped = target;
    var constraints = Constraints(VOID, VOID, VOID, height);
    var layoutReceiver = new IntrinsicsMeasureScope(_this__u8e3s4, _this__u8e3s4.r6p());
    var layoutResult = this.yal(layoutReceiver, mapped, constraints);
    return layoutResult.h5e();
  }
  function maxIntrinsicHeight_2(_this__u8e3s4, measurables, width) {
    // Inline function 'androidx.compose.ui.util.fastMap' call
    var target = ArrayList_init_$Create$_0(measurables.n1());
    // Inline function 'androidx.compose.ui.util.fastForEach' call
    var inductionVariable = 0;
    var last = measurables.n1() - 1 | 0;
    if (inductionVariable <= last)
      do {
        var index = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var item = measurables.l1(index);
        // Inline function 'androidx.compose.ui.util.fastMap' call
        var target_0 = ArrayList_init_$Create$_0(item.n1());
        // Inline function 'androidx.compose.ui.util.fastForEach' call
        var inductionVariable_0 = 0;
        var last_0 = item.n1() - 1 | 0;
        if (inductionVariable_0 <= last_0)
          do {
            var index_0 = inductionVariable_0;
            inductionVariable_0 = inductionVariable_0 + 1 | 0;
            var item_0 = item.l1(index_0);
            // Inline function 'kotlin.collections.plusAssign' call
            var element = new DefaultIntrinsicMeasurable(item_0, IntrinsicMinMax_Max_getInstance(), IntrinsicWidthHeight_Height_getInstance());
            target_0.j1(element);
          }
           while (inductionVariable_0 <= last_0);
        // Inline function 'kotlin.collections.plusAssign' call
        target.j1(target_0);
      }
       while (inductionVariable <= last);
    var mapped = target;
    var constraints = Constraints(VOID, width);
    var layoutReceiver = new IntrinsicsMeasureScope(_this__u8e3s4, _this__u8e3s4.r6p());
    var layoutResult = this.yal(layoutReceiver, mapped, constraints);
    return layoutResult.i5e();
  }
  initMetadataForInterface(MultiContentMeasurePolicy, 'MultiContentMeasurePolicy');
  initMetadataForClass(MultiContentMeasurePolicyImpl, 'MultiContentMeasurePolicyImpl', VOID, VOID, [MeasurePolicy]);
  initMetadataForInterface(OnGloballyPositionedModifier, 'OnGloballyPositionedModifier', VOID, VOID, [Element_0]);
  initMetadataForClass(OnGloballyPositionedElement, 'OnGloballyPositionedElement', VOID, ModifierNodeElement);
  initMetadataForInterface(GlobalPositionAwareModifierNode, 'GlobalPositionAwareModifierNode', VOID, VOID, [DelegatableNode]);
  initMetadataForClass(OnGloballyPositionedNode, 'OnGloballyPositionedNode', VOID, Node, [GlobalPositionAwareModifierNode]);
  initMetadataForInterface(OnPlacedModifier, 'OnPlacedModifier', VOID, VOID, [Element_0]);
  initMetadataForClass(OnPlacedNode, 'OnPlacedNode', VOID, Node, [LayoutAwareModifierNode]);
  initMetadataForClass(OnPlacedElement, 'OnPlacedElement', VOID, ModifierNodeElement);
  initMetadataForClass(OnSizeChangedModifier, 'OnSizeChangedModifier', VOID, ModifierNodeElement);
  initMetadataForClass(OnSizeChangedNode, 'OnSizeChangedNode', VOID, Node, [MeasuredSizeAwareModifierNode]);
  initMetadataForInterface(OnRemeasuredModifier, 'OnRemeasuredModifier', VOID, VOID, [Element_0]);
  initMetadataForInterface(ParentDataModifier, 'ParentDataModifier', VOID, VOID, [Element_0]);
  initMetadataForClass(LookaheadCapablePlacementScope, 'LookaheadCapablePlacementScope', VOID, PlacementScope);
  initMetadataForClass(OuterPlacementScope, 'OuterPlacementScope', VOID, PlacementScope);
  initMetadataForCompanion(Companion_21);
  initMetadataForClass(RectRulersImpl, 'RectRulersImpl');
  initMetadataForClass(InnerRectRulers, 'InnerRectRulers');
  initMetadataForInterface(RemeasurementModifier, 'RemeasurementModifier', VOID, VOID, [Element_0]);
  initMetadataForClass(NoIntrinsicsMeasurePolicy, 'NoIntrinsicsMeasurePolicy', VOID, VOID, [MeasurePolicy]);
  initMetadataForObject(RootMeasurePolicy, 'RootMeasurePolicy', VOID, NoIntrinsicsMeasurePolicy);
  initMetadataForCompanion(Companion_22);
  initMetadataForClass(Ruler, 'Ruler');
  initMetadataForClass(HorizontalRuler, 'HorizontalRuler', HorizontalRuler_init_$Create$, Ruler);
  initMetadataForCompanion(Companion_23);
  initMetadataForClass(VerticalRuler, 'VerticalRuler', VerticalRuler_init_$Create$, Ruler);
  initMetadataForCompanion(Companion_24);
  initMetadataForClass(ScaleFactor, 'ScaleFactor');
  initMetadataForClass(LayoutNodeSubcompositionsState$Scope$layout$1, VOID, VOID, VOID, [MeasureResult]);
  initMetadataForClass(LayoutNodeSubcompositionsState$createMeasurePolicy$1$measure$$inlined$createMeasureResult$1, VOID, VOID, VOID, [MeasureResult]);
  initMetadataForClass(LayoutNodeSubcompositionsState$createMeasurePolicy$1$measure$$inlined$createMeasureResult$2, VOID, VOID, VOID, [MeasureResult]);
  initMetadataForClass(NodeState, 'NodeState');
  initMetadataForClass(Scope, 'Scope', VOID, VOID, [MeasureScope]);
  initMetadataForClass(ApproachMeasureScopeImpl_0, 'ApproachMeasureScopeImpl', VOID, VOID, [MeasureScope]);
  initMetadataForClass(sam$androidx_compose_runtime_ShouldPauseCallback$0, 'sam$androidx_compose_runtime_ShouldPauseCallback$0', VOID, VOID, [ShouldPauseCallback, FunctionAdapter]);
  initMetadataForClass(LayoutNodeSubcompositionsState$createMeasurePolicy$1, VOID, VOID, NoIntrinsicsMeasurePolicy);
  function get_placeablesCount() {
    return 0;
  }
  function getSize(index) {
    return Companion_getInstance_0().n5g_1;
  }
  initMetadataForInterface(PrecomposedSlotHandle, 'PrecomposedSlotHandle');
  initMetadataForClass(LayoutNodeSubcompositionsState$createPrecomposedSlotHandle$1, VOID, VOID, VOID, [PrecomposedSlotHandle]);
  initMetadataForClass(LayoutNodeSubcompositionsState$createPrecomposedSlotHandle$2, VOID, VOID, VOID, [PrecomposedSlotHandle]);
  initMetadataForClass(LayoutNodeSubcompositionsState, 'LayoutNodeSubcompositionsState', VOID, VOID, [ComposeNodeLifecycleCallback]);
  initMetadataForClass(SlotIdsSet, 'SlotIdsSet', VOID, VOID, [Collection]);
  initMetadataForClass(SubcomposeLayoutState, 'SubcomposeLayoutState', SubcomposeLayoutState_init_$Create$);
  initMetadataForCompanion(Companion_25);
  initMetadataForObject(ComposableSingletons$SubcomposeLayoutKt, 'ComposableSingletons$SubcomposeLayoutKt');
  initMetadataForClass(SubcomposeLayoutPausableCompositionException, 'SubcomposeLayoutPausableCompositionException', VOID, IllegalStateException);
  initMetadataForObject(NoOpSubcomposeSlotReusePolicy, 'NoOpSubcomposeSlotReusePolicy');
  initMetadataForClass(ReusedSlotId$1);
  initMetadataForCompanion(Companion_26);
  initMetadataForClass(WindowInsetsRulersImpl, 'WindowInsetsRulersImpl');
  initMetadataForClass(InnermostInsetsRulers, 'InnermostInsetsRulers');
  initMetadataForClass(ModifierLocal, 'ModifierLocal');
  initMetadataForClass(ProvidableModifierLocal, 'ProvidableModifierLocal', VOID, ModifierLocal);
  initMetadataForInterface(ModifierLocalConsumer, 'ModifierLocalConsumer', VOID, VOID, [Element_0]);
  initMetadataForClass(ModifierLocalManager, 'ModifierLocalManager');
  initMetadataForClass(ModifierLocalMap, 'ModifierLocalMap');
  initMetadataForObject(EmptyMap, 'EmptyMap', VOID, ModifierLocalMap);
  initMetadataForClass(BackwardsCompatLocalMap, 'BackwardsCompatLocalMap', VOID, ModifierLocalMap);
  initMetadataForInterface(ModifierLocalProvider, 'ModifierLocalProvider', VOID, VOID, [Element_0]);
  initMetadataForClass(BackwardsCompatNode$initializeModifier$2);
  initMetadataForInterface(OwnerScope, 'OwnerScope');
  initMetadataForClass(BackwardsCompatNode, 'BackwardsCompatNode', VOID, Node, [LayoutModifierNode, DrawModifierNode, SemanticsModifierNode, PointerInputModifierNode, ModifierLocalModifierNode, ParentDataModifierNode, LayoutAwareModifierNode, GlobalPositionAwareModifierNode, FocusEventModifierNode, FocusPropertiesModifierNode, DelegatableNode, OwnerScope]);
  initMetadataForClass(DetachedModifierLocalReadScope$1);
  initMetadataForCompanion(Companion_27);
  initMetadataForClass(DelegatingNode, 'DelegatingNode', VOID, Node);
  initMetadataForClass(DepthSortedSetsForDifferentPasses, 'DepthSortedSetsForDifferentPasses');
  initMetadataForClass(DepthSortedSet, 'DepthSortedSet');
  initMetadataForClass(DepthComparator$1, VOID, VOID, VOID, [Comparator]);
  initMetadataForClass(HitTestResultIterator, 'HitTestResultIterator');
  initMetadataForClass(SubList, 'SubList', VOID, VOID, [KtList]);
  initMetadataForClass(HitTestResult, 'HitTestResult', HitTestResult, VOID, [KtList]);
  initMetadataForClass(TailModifierNode, 'TailModifierNode', TailModifierNode, Node);
  initMetadataForInterface(MeasureScopeWithLayoutNode, 'MeasureScopeWithLayoutNode', VOID, VOID, [MeasureScope]);
  initMetadataForInterface(MotionReferencePlacementDelegate, 'MotionReferencePlacementDelegate');
  initMetadataForClass(LookaheadCapablePlaceable, 'LookaheadCapablePlaceable', VOID, Placeable, [MeasureScopeWithLayoutNode, MotionReferencePlacementDelegate]);
  initMetadataForClass(LookaheadDelegate, 'LookaheadDelegate', VOID, LookaheadCapablePlaceable);
  initMetadataForClass(LookaheadDelegateImpl, 'LookaheadDelegateImpl', VOID, LookaheadDelegate);
  initMetadataForCompanion(Companion_28);
  initMetadataForClass(NodeCoordinator, 'NodeCoordinator', VOID, LookaheadCapablePlaceable, [LayoutCoordinates, OwnerScope]);
  initMetadataForClass(InnerNodeCoordinator, 'InnerNodeCoordinator', VOID, NodeCoordinator);
  initMetadataForClass(IntrinsicsPolicy, 'IntrinsicsPolicy');
  initMetadataForInterface(MeasureBlock, 'MeasureBlock');
  initMetadataForClass(sam$androidx_compose_ui_node_NodeMeasuringIntrinsics_MeasureBlock$0, 'sam$androidx_compose_ui_node_NodeMeasuringIntrinsics_MeasureBlock$0', VOID, VOID, [MeasureBlock, FunctionAdapter]);
  initMetadataForClass(sam$androidx_compose_ui_node_NodeMeasuringIntrinsics_MeasureBlock$0_0, 'sam$androidx_compose_ui_node_NodeMeasuringIntrinsics_MeasureBlock$0', VOID, VOID, [MeasureBlock, FunctionAdapter]);
  initMetadataForClass(sam$androidx_compose_ui_node_NodeMeasuringIntrinsics_MeasureBlock$0_1, 'sam$androidx_compose_ui_node_NodeMeasuringIntrinsics_MeasureBlock$0', VOID, VOID, [MeasureBlock, FunctionAdapter]);
  initMetadataForClass(sam$androidx_compose_ui_node_NodeMeasuringIntrinsics_MeasureBlock$0_2, 'sam$androidx_compose_ui_node_NodeMeasuringIntrinsics_MeasureBlock$0', VOID, VOID, [MeasureBlock, FunctionAdapter]);
  initMetadataForClass(DefaultIntrinsicMeasurable_1, 'DefaultIntrinsicMeasurable');
  initMetadataForClass(EmptyPlaceable_0, 'EmptyPlaceable', VOID, Placeable);
  initMetadataForClass(IntrinsicMinMax_1, 'IntrinsicMinMax', VOID, Enum);
  initMetadataForClass(IntrinsicWidthHeight_1, 'IntrinsicWidthHeight', VOID, Enum);
  initMetadataForObject(NodeMeasuringIntrinsics, 'NodeMeasuringIntrinsics');
  initMetadataForClass(LookaheadDelegateForLayoutModifierNode, 'LookaheadDelegateForLayoutModifierNode', VOID, LookaheadDelegate);
  initMetadataForCompanion(Companion_29);
  initMetadataForClass(LayoutModifierNodeCoordinator$measure$1, VOID, VOID, VOID, [MeasureResult]);
  initMetadataForClass(LayoutModifierNodeCoordinator, 'LayoutModifierNodeCoordinator', VOID, NodeCoordinator);
  initMetadataForClass(sam$kotlin_Comparator$0, 'sam$kotlin_Comparator$0', VOID, VOID, [Comparator, FunctionAdapter]);
  initMetadataForClass(LayoutNode$Companion$ErrorMeasurePolicy$1, VOID, VOID, NoIntrinsicsMeasurePolicy);
  function get_handwritingSlop() {
    return 2.0;
  }
  function get_minimumTouchTargetSize() {
    // Inline function 'androidx.compose.ui.unit.dp' call
    var tmp = _Dp___init__impl__ms3zkb(48);
    // Inline function 'androidx.compose.ui.unit.dp' call
    var tmp$ret$1 = _Dp___init__impl__ms3zkb(48);
    return DpSize(tmp, tmp$ret$1);
  }
  function get_maximumFlingVelocity() {
    return 3.4028235E38;
  }
  initMetadataForInterface(ViewConfiguration, 'ViewConfiguration');
  initMetadataForClass(LayoutNode$Companion$DummyViewConfiguration$1, VOID, VOID, VOID, [ViewConfiguration]);
  initMetadataForCompanion(Companion_30);
  initMetadataForClass(LayoutState, 'LayoutState', VOID, Enum);
  initMetadataForClass(UsageByParent, 'UsageByParent', VOID, Enum);
  initMetadataForClass(LayoutNode, 'LayoutNode', LayoutNode, VOID, [ComposeNodeLifecycleCallback, OwnerScope]);
  initMetadataForClass(AlignmentLines, 'AlignmentLines');
  initMetadataForClass(LookaheadAlignmentLines, 'LookaheadAlignmentLines', VOID, AlignmentLines);
  initMetadataForClass(LayoutNodeAlignmentLines, 'LayoutNodeAlignmentLines', VOID, AlignmentLines);
  initMetadataForClass(LayoutNodeDrawScope, 'LayoutNodeDrawScope', LayoutNodeDrawScope, VOID, [DrawScope]);
  initMetadataForClass(LayoutNodeLayoutDelegate, 'LayoutNodeLayoutDelegate');
  initMetadataForClass(LayoutTreeConsistencyChecker, 'LayoutTreeConsistencyChecker');
  initMetadataForClass(ResettableRulerScope, 'ResettableRulerScope', VOID, VOID, [Density]);
  initMetadataForCompanion(Companion_31);
  initMetadataForClass(LookaheadCapablePlaceable$layout$1, VOID, VOID, VOID, [MeasureResult]);
  initMetadataForClass(PlaceableResult, 'PlaceableResult', VOID, VOID, [OwnerScope]);
  initMetadataForClass(RulerTrackingMap, 'RulerTrackingMap', RulerTrackingMap);
  initMetadataForClass(PlacedState, 'PlacedState', VOID, Enum);
  initMetadataForClass(LookaheadPassDelegate, 'LookaheadPassDelegate', VOID, Placeable, [MotionReferencePlacementDelegate]);
  initMetadataForClass(PostponedRequest, 'PostponedRequest');
  initMetadataForClass(MeasureAndLayoutDelegate, 'MeasureAndLayoutDelegate');
  initMetadataForClass(Invalidation, 'Invalidation', VOID, Enum);
  initMetadataForClass(MeasurePassDelegate, 'MeasurePassDelegate', VOID, Placeable, [MotionReferencePlacementDelegate]);
  initMetadataForClass(MutableVectorWithMutationTracking, 'MutableVectorWithMutationTracking');
  initMetadataForClass(IntStack, 'IntStack');
  initMetadataForClass(Differ, 'Differ');
  initMetadataForClass(NodeChain$sentinelHead$1, VOID, VOID, Node);
  initMetadataForClass(NodeChain, 'NodeChain');
  function shouldHitTest(node) {
    return true;
  }
  initMetadataForInterface(HitTestSource, 'HitTestSource');
  initMetadataForClass(NodeCoordinator$Companion$PointerInputSource$1, VOID, VOID, VOID, [HitTestSource]);
  initMetadataForClass(NodeCoordinator$Companion$SemanticsSource$1, VOID, VOID, VOID, [HitTestSource]);
  initMetadataForCompanion(Companion_32);
  initMetadataForClass(LayerPositionalProperties, 'LayerPositionalProperties', LayerPositionalProperties);
  initMetadataForObject(Nodes, 'Nodes');
  initMetadataForObject(CanFocusChecker, 'CanFocusChecker', VOID, VOID, [FocusProperties]);
  initMetadataForCompanion(Companion_33);
  initMetadataForClass(ObserverNodeOwnerScope, 'ObserverNodeOwnerScope', VOID, VOID, [OwnerScope]);
  initMetadataForObject(DepthComparator_0, 'DepthComparator', VOID, VOID, [Comparator]);
  initMetadataForCompanion(Companion_34);
  initMetadataForClass(OnPositionedDispatcher, 'OnPositionedDispatcher', OnPositionedDispatcher);
  initMetadataForCompanion(Companion_35);
  function onRequestMeasure$default(layoutNode, affectsLookahead, forceRequest, scheduleMeasureAndLayout, $super) {
    affectsLookahead = affectsLookahead === VOID ? false : affectsLookahead;
    forceRequest = forceRequest === VOID ? false : forceRequest;
    scheduleMeasureAndLayout = scheduleMeasureAndLayout === VOID ? true : scheduleMeasureAndLayout;
    var tmp;
    if ($super === VOID) {
      this.zbd(layoutNode, affectsLookahead, forceRequest, scheduleMeasureAndLayout);
      tmp = Unit_instance;
    } else {
      tmp = $super.zbd.call(this, layoutNode, affectsLookahead, forceRequest, scheduleMeasureAndLayout);
    }
    return tmp;
  }
  function onRequestRelayout$default(layoutNode, affectsLookahead, forceRequest, $super) {
    affectsLookahead = affectsLookahead === VOID ? false : affectsLookahead;
    forceRequest = forceRequest === VOID ? false : forceRequest;
    var tmp;
    if ($super === VOID) {
      this.gbe(layoutNode, affectsLookahead, forceRequest);
      tmp = Unit_instance;
    } else {
      tmp = $super.gbe.call(this, layoutNode, affectsLookahead, forceRequest);
    }
    return tmp;
  }
  function measureAndLayout$default(sendPointerUpdate, $super) {
    sendPointerUpdate = sendPointerUpdate === VOID ? true : sendPointerUpdate;
    var tmp;
    if ($super === VOID) {
      this.mbm(sendPointerUpdate);
      tmp = Unit_instance;
    } else {
      tmp = $super.mbm.call(this, sendPointerUpdate);
    }
    return tmp;
  }
  function forceMeasureTheSubtree$default(layoutNode, affectsLookahead, $super) {
    affectsLookahead = affectsLookahead === VOID ? false : affectsLookahead;
    var tmp;
    if ($super === VOID) {
      this.ibi(layoutNode, affectsLookahead);
      tmp = Unit_instance;
    } else {
      tmp = $super.ibi.call(this, layoutNode, affectsLookahead);
    }
    return tmp;
  }
  function createLayer$default(drawBlock, invalidateParentLayer, explicitLayer, $super) {
    explicitLayer = explicitLayer === VOID ? null : explicitLayer;
    return $super === VOID ? this.obk(drawBlock, invalidateParentLayer, explicitLayer) : $super.obk.call(this, drawBlock, invalidateParentLayer, explicitLayer);
  }
  function onPreLayoutNodeReused(layoutNode, oldSemanticsId) {
  }
  function onPostLayoutNodeReused(layoutNode, oldSemanticsId) {
  }
  function get_placementScope() {
    return PlacementScope_1(this);
  }
  function get_outOfFrameExecutor() {
    return null;
  }
  function voteFrameRate(frameRate) {
  }
  function dispatchOnScrollChanged(delta) {
  }
  function invalidateRootLayer() {
  }
  initMetadataForInterface(Owner, 'Owner', VOID, VOID, VOID, [1]);
  initMetadataForClass(OwnerSnapshotObserver, 'OwnerSnapshotObserver');
  initMetadataForCompanion(Companion_36);
  initMetadataForClass(DpTouchBoundsExpansion, 'DpTouchBoundsExpansion');
  initMetadataForCompanion(Companion_37);
  initMetadataForClass(TouchBoundsExpansion, 'TouchBoundsExpansion');
  initMetadataForClass(TraverseDescendantsAction, 'TraverseDescendantsAction', VOID, Enum);
  initMetadataForInterface(UnplacedAwareModifierNode, 'UnplacedAwareModifierNode', VOID, VOID, [DelegatableNode]);
  initMetadataForObject(Key_0, 'Key');
  initMetadataForClass(ValueElement, 'ValueElement');
  initMetadataForInterface(PlatformTextInputSession, 'PlatformTextInputSession', VOID, VOID, VOID, [1]);
  initMetadataForInterface(PlatformTextInputSessionScope, 'PlatformTextInputSessionScope', VOID, VOID, [PlatformTextInputSession, CoroutineScope_0], [1]);
  initMetadataForLambda(ChainedPlatformTextInputInterceptor$textInputSession$slambda$o$startInputMethod$slambda$slambda, CoroutineImpl, VOID, [1]);
  initMetadataForLambda(ChainedPlatformTextInputInterceptor$textInputSession$slambda$o$startInputMethod$slambda, CoroutineImpl, VOID, [1]);
  initMetadataForCoroutine($startInputMethodCOROUTINE$, CoroutineImpl);
  initMetadataForClass(ChainedPlatformTextInputInterceptor$textInputSession$2$scope$1, VOID, VOID, VOID, [PlatformTextInputSessionScope], [1]);
  initMetadataForLambda(ChainedPlatformTextInputInterceptor$textInputSession$slambda, CoroutineImpl, VOID, [1]);
  initMetadataForCoroutine($textInputSessionCOROUTINE$, CoroutineImpl);
  initMetadataForInterface(PlatformTextInputInterceptor, 'PlatformTextInputInterceptor', VOID, VOID, VOID, [2]);
  initMetadataForCoroutine($establishTextInputSessionCOROUTINE$, CoroutineImpl);
  initMetadataForCoroutine($interceptedTextInputSessionCOROUTINE$, CoroutineImpl);
  initMetadataForClass(DelegatingSoftwareKeyboardController, 'DelegatingSoftwareKeyboardController');
  function showMenu(rect, onCopyRequested, onPasteRequested, onCutRequested, onSelectAllRequested, onAutofillRequested) {
    this.ybq(rect, onCopyRequested, onPasteRequested, onCutRequested, onSelectAllRequested);
  }
  initMetadataForInterface(TextToolbar, 'TextToolbar');
  initMetadataForClass(TextToolbarStatus, 'TextToolbarStatus', VOID, Enum);
  function get_containerSize() {
    var tmp0 = -2147483648;
    // Inline function 'androidx.compose.ui.unit.IntSize' call
    // Inline function 'androidx.compose.ui.util.packInts' call
    var val2 = -2147483648;
    var tmp$ret$1 = bitwiseOr(shiftLeft(fromInt(tmp0), 32), bitwiseAnd(fromInt(val2), new Long(-1, 0)));
    return _IntSize___init__impl__emcjft(tmp$ret$1);
  }
  initMetadataForInterface(WindowInfo, 'WindowInfo');
  initMetadataForCompanion(Companion_38);
  initMetadataForClass(WindowInfoImpl, 'WindowInfoImpl', WindowInfoImpl, VOID, [WindowInfo]);
  initMetadataForInterface(BringIntoViewModifierNode, 'BringIntoViewModifierNode', VOID, VOID, [DelegatableNode], [2]);
  initMetadataForClass(SemanticsConfiguration, 'SemanticsConfiguration', SemanticsConfiguration);
  initMetadataForInterface(SemanticsModifier, 'SemanticsModifier', VOID, VOID, [Element_0]);
  initMetadataForClass(ClearAndSetSemanticsElement, 'ClearAndSetSemanticsElement', VOID, ModifierNodeElement, [SemanticsModifier]);
  initMetadataForClass(AppendedSemanticsElement, 'AppendedSemanticsElement', VOID, ModifierNodeElement, [SemanticsModifier]);
  initMetadataForClass(CoreSemanticsModifierNode, 'CoreSemanticsModifierNode', VOID, Node, [SemanticsModifierNode]);
  initMetadataForClass(EmptySemanticsModifier, 'EmptySemanticsModifier', EmptySemanticsModifier, Node, [SemanticsModifierNode]);
  initMetadataForClass(SemanticsNode$fakeSemanticsNode$fakeNode$1, VOID, VOID, Node, [SemanticsModifierNode]);
  initMetadataForClass(SemanticsNode, 'SemanticsNode');
  initMetadataForClass(SemanticsOwner, 'SemanticsOwner');
  initMetadataForClass(SemanticsPropertyKey, 'SemanticsPropertyKey');
  initMetadataForCompanion(Companion_39);
  initMetadataForClass(Role, 'Role');
  initMetadataForClass(ScrollAxisRange, 'ScrollAxisRange');
  initMetadataForClass(AccessibilityAction, 'AccessibilityAction');
  initMetadataForObject(SemanticsProperties, 'SemanticsProperties');
  initMetadataForCompanion(Companion_40);
  initMetadataForClass(ProgressBarRangeInfo, 'ProgressBarRangeInfo');
  initMetadataForCompanion(Companion_41);
  initMetadataForClass(LiveRegionMode, 'LiveRegionMode');
  initMetadataForClass(CollectionInfo, 'CollectionInfo');
  initMetadataForObject(SemanticsActions, 'SemanticsActions');
  initMetadataForClass(RectList, 'RectList', RectList);
  initMetadataForClass(RectManager, 'RectManager', RectManager);
  initMetadataForObject(ExecuteDelayUsingPostAndRemove, 'ExecuteDelayUsingPostAndRemove');
  initMetadataForClass(RelativeLayoutBounds, 'RelativeLayoutBounds');
  initMetadataForClass(Entry, 'Entry');
  initMetadataForClass(ThrottledCallbacks, 'ThrottledCallbacks', ThrottledCallbacks);
  initMetadataForClass(ToggleableState, 'ToggleableState', VOID, Enum);
  initMetadataForCompanion(Companion_42);
  initMetadataForClass(ClipEntry, 'ClipEntry');
  initMetadataForClass(JsPlatformClipboardManager, 'JsPlatformClipboardManager', JsPlatformClipboardManager);
  initMetadataForCoroutine($getClipEntryCOROUTINE$, CoroutineImpl);
  initMetadataForCoroutine($setClipEntryCOROUTINE$, CoroutineImpl);
  initMetadataForClass(JsPlatformClipboard, 'JsPlatformClipboard', JsPlatformClipboard, VOID, VOID, [0, 1]);
  initMetadataForClass(AtomicReference, 'AtomicReference');
  initMetadataForClass(PointerEventTimeoutCancellationException, 'PointerEventTimeoutCancellationException', VOID, CancellationException);
  initMetadataForClass(SortedSet, 'SortedSet');
  initMetadataForClass(AtomicInt, 'AtomicInt');
  initMetadataForLambda(postDelayed$slambda, CoroutineImpl, VOID, [1]);
  initMetadataForObject(SkikoComposeUiFlags, 'SkikoComposeUiFlags');
  initMetadataForClass(SystemTheme, 'SystemTheme', VOID, Enum);
  initMetadataForCoroutine($withAnimationProgressCOROUTINE$, CoroutineImpl);
  initMetadataForCompanion(Companion_43);
  initMetadataForClass(PlatformContentDataType, 'PlatformContentDataType');
  initMetadataForCompanion(Companion_44);
  initMetadataForClass(PlatformContentType, 'PlatformContentType');
  initMetadataForObject(PlatformHapticFeedbackType, 'PlatformHapticFeedbackType');
  initMetadataForClass(InternalKeyEvent, 'InternalKeyEvent');
  initMetadataForClass(InternalPointerEvent, 'InternalPointerEvent');
  initMetadataForCompanion(Companion_45);
  initMetadataForClass(PointerButton, 'PointerButton');
  initMetadataForCompanion(Companion_46);
  initMetadataForClass(PointerEvent, 'PointerEvent');
  initMetadataForClass(PointerInputEvent, 'PointerInputEvent');
  initMetadataForClass(OnPointerEventModifierElement, 'OnPointerEventModifierElement', VOID, ModifierNodeElement);
  initMetadataForLambda(OnPointerEventModifierNode$pointerInputNode$slambda$slambda, CoroutineImpl, VOID, [1]);
  initMetadataForClass(sam$androidx_compose_ui_input_pointer_PointerInputEventHandler$0, 'sam$androidx_compose_ui_input_pointer_PointerInputEventHandler$0', VOID, VOID, [PointerInputEventHandler, FunctionAdapter], [1]);
  initMetadataForLambda(OnPointerEventModifierNode$pointerInputNode$slambda, CoroutineImpl, VOID, [1]);
  initMetadataForClass(OnPointerEventModifierNode, 'OnPointerEventModifierNode', VOID, DelegatingNode);
  initMetadataForClass(SyntheticEventSender, 'SyntheticEventSender');
  initMetadataForClass(Strategy_0, 'Strategy', VOID, Enum);
  initMetadataForClass(PointerVelocityTracker1D, 'PointerVelocityTracker1D', PointerVelocityTracker1D);
  initMetadataForClass(sam$androidx_compose_ui_layout_MeasurePolicy$0, 'sam$androidx_compose_ui_layout_MeasurePolicy$0', VOID, VOID, [MeasurePolicy, FunctionAdapter]);
  initMetadataForClass(sam$androidx_compose_ui_layout_MeasurePolicy$0_0, 'sam$androidx_compose_ui_layout_MeasurePolicy$0', VOID, VOID, [MeasurePolicy, FunctionAdapter]);
  initMetadataForClass(RulerProviderModifierElement, 'RulerProviderModifierElement', VOID, ModifierNodeElement);
  initMetadataForClass(RulerProviderModifierNode, 'RulerProviderModifierNode', VOID, Node, [LayoutModifierNode, TraversableNode]);
  initMetadataForClass(BackNavigationEventInput, 'BackNavigationEventInput', BackNavigationEventInput, NavigationEventInput);
  initMetadataForClass(DragAndDropOwner, 'DragAndDropOwner');
  initMetadataForClass(RootDragAndDropElement, 'RootDragAndDropElement', VOID, ModifierNodeElement);
  initMetadataForClass(EmptySemanticsElement, 'EmptySemanticsElement', VOID, ModifierNodeElement);
  initMetadataForLambda(RootNodeOwner$OwnerImpl$TextInputSession$startInputMethod$slambda$slambda$slambda, CoroutineImpl, VOID, [1]);
  initMetadataForLambda(RootNodeOwner$OwnerImpl$TextInputSession$startInputMethod$slambda$slambda, CoroutineImpl, VOID, [1]);
  initMetadataForLambda(RootNodeOwner$OwnerImpl$TextInputSession$startInputMethod$slambda, CoroutineImpl, VOID, [1]);
  initMetadataForCoroutine($startInputMethodCOROUTINE$_0, CoroutineImpl);
  initMetadataForClass(TextInputSession, 'TextInputSession', VOID, VOID, [PlatformTextInputSessionScope, CoroutineScope_0], [1]);
  initMetadataForClass(RootNodeOwner$OwnerImpl$platformFocusOwner$1, VOID, VOID, VOID, [PlatformFocusOwner]);
  initMetadataForCoroutine($textInputSessionCOROUTINE$_0, CoroutineImpl);
  initMetadataForLambda(RootNodeOwner$slambda$slambda, CoroutineImpl, VOID, [1]);
  initMetadataForClass(OwnerImpl, 'OwnerImpl', VOID, VOID, [Owner], [1]);
  initMetadataForClass(PlatformRootForTestImpl, 'PlatformRootForTestImpl');
  initMetadataForClass(PointerIconServiceImpl, 'PointerIconServiceImpl');
  function recycle(layer) {
    return false;
  }
  function notifyLayerIsDirty(layer, isDirty) {
    return Unit_instance;
  }
  function invalidate() {
    return Unit_instance;
  }
  function voteFrameRate_0(frameRate) {
    return Unit_instance;
  }
  initMetadataForInterface(OwnedLayerManager, 'OwnedLayerManager');
  initMetadataForClass(OwnedLayerManagerImpl, 'OwnedLayerManagerImpl', VOID, VOID, [OwnedLayerManager]);
  initMetadataForClass(sam$kotlinx_coroutines_flow_FlowCollector$0, 'sam$kotlinx_coroutines_flow_FlowCollector$0', VOID, VOID, [FlowCollector, FunctionAdapter], [1]);
  initMetadataForLambda(RootNodeOwner$slambda, CoroutineImpl, VOID, [1]);
  initMetadataForClass(RootNodeOwner, 'RootNodeOwner');
  initMetadataForObject(IdentityPositionCalculator, 'IdentityPositionCalculator');
  initMetadataForClass(RootWindowInsetsProviderModifierElement, 'RootWindowInsetsProviderModifierElement', VOID, ModifierNodeElement);
  initMetadataForClass(PlatformWindowInsetsProviderNode, 'PlatformWindowInsetsProviderNode', VOID, DelegatingNode, [TraversableNode]);
  initMetadataForClass(RootPlatformWindowInsetsProviderNode, 'RootPlatformWindowInsetsProviderNode', VOID, PlatformWindowInsetsProviderNode);
  initMetadataForClass(SnapshotInvalidationTracker, 'SnapshotInvalidationTracker', SnapshotInvalidationTracker);
  initMetadataForClass(CommandList, 'CommandList');
  initMetadataForClass(ProvidePlatformCompositionLocals$$inlined$cache$1$1);
  initMetadataForClass(ProvidePlatformCompositionLocals$hostDefaultProvider$1);
  initMetadataForClass(DefaultAccessibilityManager, 'DefaultAccessibilityManager', DefaultAccessibilityManager);
  initMetadataForClass(DefaultHapticFeedback, 'DefaultHapticFeedback', DefaultHapticFeedback);
  initMetadataForClass(DefaultUiApplier, 'DefaultUiApplier', VOID, AbstractApplier);
  initMetadataForClass(DisposableSaveableStateRegistry, 'DisposableSaveableStateRegistry', VOID, VOID, [SaveableStateRegistry]);
  initMetadataForClass(sam$androidx_savedstate_SavedStateRegistry_SavedStateProvider$0, 'sam$androidx_savedstate_SavedStateRegistry_SavedStateProvider$0', VOID, VOID, [SavedStateProvider, FunctionAdapter]);
  initMetadataForLambda(FlushCoroutineDispatcher$dispatch$slambda, CoroutineImpl, VOID, [1]);
  initMetadataForClass(FlushCoroutineDispatcher$scheduleResumeAfterDelay$$inlined$Runnable$1, VOID, VOID, VOID, [Runnable]);
  initMetadataForLambda(FlushCoroutineDispatcher$scheduleResumeAfterDelay$slambda, CoroutineImpl, VOID, [1]);
  initMetadataForClass(FlushCoroutineDispatcher, 'FlushCoroutineDispatcher', VOID, CoroutineDispatcher, [Delay], [1]);
  initMetadataForLambda(GlobalSnapshotManager$ensureStarted$slambda, CoroutineImpl, VOID, [1]);
  initMetadataForObject(GlobalSnapshotManager, 'GlobalSnapshotManager');
  initMetadataForClass(GraphicsLayerOwnerLayer, 'GraphicsLayerOwnerLayer');
  initMetadataForClass(LegacyRenderNodeLayer$drawState$1, VOID, VOID, VOID, [SnapshotMutationPolicy]);
  initMetadataForClass(LegacyRenderNodeLayer, 'LegacyRenderNodeLayer');
  function get_screenReader() {
    return EmptyPlatformScreenReader_instance;
  }
  function get_architectureComponentsOwner() {
    return get_EmptyArchitectureComponentsOwner();
  }
  function get_isWindowTransparent() {
    return false;
  }
  function get_hasNonTranslationComponents() {
    return false;
  }
  function convertLocalToWindowPosition(localPosition) {
    return localPosition;
  }
  function convertWindowToLocalPosition(positionInWindow) {
    return positionInWindow;
  }
  function convertLocalToScreenPosition(localPosition) {
    return this.pcp(localPosition);
  }
  function convertScreenToLocalPosition(positionOnScreen) {
    return this.qcq(positionOnScreen);
  }
  function get_measureDrawLayerBounds() {
    return false;
  }
  function get_localeList() {
    return Companion_getInstance_18().e2y();
  }
  function get_viewConfiguration() {
    return DefaultViewConfiguration_getInstance();
  }
  function get_textInputService() {
    return EmptyPlatformTextInputService_instance;
  }
  function startInputMethod(request, $completion) {
    var tmp = new $startInputMethodCOROUTINE$_1(this, request, $completion);
    tmp.p9_1 = Unit_instance;
    tmp.q9_1 = null;
    return tmp.v9();
  }
  function get_textToolbar() {
    return EmptyTextToolbar_getInstance();
  }
  function setPointerIcon(pointerIcon) {
    return Unit_instance;
  }
  function get_parentFocusManager() {
    return EmptyFocusManager_instance;
  }
  function requestFocus() {
    return true;
  }
  function get_dragAndDropManager() {
    return EmptyDragAndDropManager_instance;
  }
  function get_windowInsets() {
    return EmptyPlatformWindowInsets_instance;
  }
  function voteFrameRate_1(frameRate, frameRateCategory) {
    return Unit_instance;
  }
  function get_rootForTestListener() {
    return null;
  }
  function get_semanticsOwnerListener() {
    return null;
  }
  function get_isClearFocusOnMouseDownEnabled() {
    return get_isClearFocusOnMouseDownEnabled_0(ComposeUiFlags_instance);
  }
  initMetadataForInterface(PlatformContext, 'PlatformContext', VOID, VOID, VOID, [1]);
  initMetadataForClass(Empty, 'Empty', Empty, VOID, [PlatformContext], [1]);
  initMetadataForObject(DefaultViewConfiguration, 'DefaultViewConfiguration', VOID, VOID, [ViewConfiguration]);
  initMetadataForObject(EmptyFocusManager, 'EmptyFocusManager', VOID, VOID, [FocusManager]);
  initMetadataForCoroutine($startInputMethodCOROUTINE$_1, CoroutineImpl);
  initMetadataForObject(EmptyPlatformScreenReader, 'EmptyPlatformScreenReader');
  initMetadataForObject(EmptyPlatformTextInputService, 'EmptyPlatformTextInputService', VOID, VOID, [PlatformTextInputService]);
  initMetadataForObject(EmptyTextToolbar, 'EmptyTextToolbar', VOID, VOID, [TextToolbar]);
  initMetadataForObject(EmptyDragAndDropManager, 'EmptyDragAndDropManager');
  initMetadataForClass(DefaultInputModeManager, 'DefaultInputModeManager', DefaultInputModeManager);
  initMetadataForClass(DefaultArchitectureComponentsOwner, 'DefaultArchitectureComponentsOwner', DefaultArchitectureComponentsOwner, VOID, [HasDefaultViewModelProviderFactory]);
  initMetadataForCompanion(Companion_47);
  function get_displayCutouts() {
    return emptyList();
  }
  function get_captionBar() {
    return Companion_getInstance_73().wcz_1;
  }
  function get_displayCutout() {
    return Companion_getInstance_73().wcz_1;
  }
  function get_ime() {
    return Companion_getInstance_73().wcz_1;
  }
  function get_mandatorySystemGestures() {
    return Companion_getInstance_73().wcz_1;
  }
  function get_navigationBars() {
    return Companion_getInstance_73().wcz_1;
  }
  function get_statusBars() {
    return Companion_getInstance_73().wcz_1;
  }
  function get_systemBars() {
    return Companion_getInstance_73().wcz_1;
  }
  function get_systemGestures() {
    return Companion_getInstance_73().wcz_1;
  }
  function get_tappableElement() {
    return Companion_getInstance_73().wcz_1;
  }
  function get_waterfall() {
    return Companion_getInstance_73().wcz_1;
  }
  function excluding(safeInsets, ime) {
    return this;
  }
  initMetadataForInterface(PlatformWindowInsets, 'PlatformWindowInsets');
  initMetadataForCompanion(Companion_48);
  initMetadataForClass(ValuePlatformInsets, 'ValuePlatformInsets');
  initMetadataForObject(EmptyPlatformWindowInsets, 'EmptyPlatformWindowInsets', VOID, VOID, [PlatformWindowInsets]);
  initMetadataForClass(DynamicPlatformInsets, 'DynamicPlatformInsets', DynamicPlatformInsets);
  initMetadataForClass(safeDrawing$1);
  initMetadataForClass(safeGestures$1);
  initMetadataForClass(safeContent$1);
  initMetadataForClass(ExcludedWindowInsetsProviderModifierElement, 'ExcludedWindowInsetsProviderModifierElement', VOID, ModifierNodeElement);
  initMetadataForClass(ExcludedWindowInsetsProviderNode, 'ExcludedWindowInsetsProviderNode', VOID, PlatformWindowInsetsProviderNode);
  initMetadataForClass(SynchronizedObject, 'SynchronizedObject', SynchronizedObject);
  function sendPointerEvent$default(eventType, position, scrollDelta, timeMillis, type, buttons, keyboardModifiers, nativeEvent, button, scaleGestureFactor, panGestureOffset, $super) {
    scrollDelta = scrollDelta === VOID ? Companion_getInstance().g5d_1 : scrollDelta;
    timeMillis = timeMillis === VOID ? currentTimeMillis() : timeMillis;
    type = type === VOID ? Companion_getInstance_42().na2_1 : type;
    buttons = buttons === VOID ? null : buttons;
    keyboardModifiers = keyboardModifiers === VOID ? null : keyboardModifiers;
    nativeEvent = nativeEvent === VOID ? null : nativeEvent;
    button = button === VOID ? null : button;
    scaleGestureFactor = scaleGestureFactor === VOID ? 1.0 : scaleGestureFactor;
    panGestureOffset = panGestureOffset === VOID ? Companion_getInstance().g5d_1 : panGestureOffset;
    var tmp;
    if ($super === VOID) {
      tmp = this.rd2(eventType, position, scrollDelta, timeMillis, type, buttons, keyboardModifiers, nativeEvent, button, scaleGestureFactor, panGestureOffset);
    } else {
      var tmp_0 = $super.rd2;
      var tmp_1 = buttons;
      var tmp_2 = tmp_1 == null ? null : new PointerButtons(tmp_1);
      var tmp_3 = keyboardModifiers;
      var tmp_4 = tmp_3 == null ? null : new PointerKeyboardModifiers(tmp_3);
      var tmp_5 = button;
      tmp = tmp_0.call(this, new PointerEventType(eventType), new Offset(position), new Offset(scrollDelta), timeMillis, new PointerType(type), tmp_2, tmp_4, nativeEvent, tmp_5 == null ? null : new PointerButton(tmp_5), scaleGestureFactor, new Offset(panGestureOffset)).dc7_1;
    }
    return tmp;
  }
  function sendPointerEvent$default_0(eventType, pointers, buttons, keyboardModifiers, scrollDelta, timeMillis, nativeEvent, button, scaleGestureFactor, panGestureOffset, $super) {
    buttons = buttons === VOID ? PointerButtons_0() : buttons;
    keyboardModifiers = keyboardModifiers === VOID ? PointerKeyboardModifiers_0() : keyboardModifiers;
    scrollDelta = scrollDelta === VOID ? Companion_getInstance().g5d_1 : scrollDelta;
    timeMillis = timeMillis === VOID ? currentTimeMillis() : timeMillis;
    nativeEvent = nativeEvent === VOID ? null : nativeEvent;
    button = button === VOID ? null : button;
    scaleGestureFactor = scaleGestureFactor === VOID ? 1.0 : scaleGestureFactor;
    panGestureOffset = panGestureOffset === VOID ? Companion_getInstance().g5d_1 : panGestureOffset;
    var tmp;
    if ($super === VOID) {
      tmp = this.ud2(eventType, pointers, buttons, keyboardModifiers, scrollDelta, timeMillis, nativeEvent, button, scaleGestureFactor, panGestureOffset);
    } else {
      var tmp_0 = $super.ud2;
      var tmp_1 = button;
      tmp = tmp_0.call(this, new PointerEventType(eventType), pointers, new PointerButtons(buttons), new PointerKeyboardModifiers(keyboardModifiers), new Offset(scrollDelta), timeMillis, nativeEvent, tmp_1 == null ? null : new PointerButton(tmp_1), scaleGestureFactor, new Offset(panGestureOffset)).dc7_1;
    }
    return tmp;
  }
  initMetadataForInterface(ComposeScene, 'ComposeScene', VOID, VOID, [AutoCloseable], [1]);
  initMetadataForClass(BaseComposeScene, 'BaseComposeScene', VOID, VOID, [ComposeScene], [1]);
  initMetadataForCoroutine($startInputMethodCOROUTINE$_2, CoroutineImpl);
  initMetadataForClass(CanvasLayersComposeSceneImpl$AttachedComposeSceneLayer$owner$1, VOID, VOID, VOID, [PlatformContext], [1]);
  initMetadataForClass(AttachedComposeSceneLayer, 'AttachedComposeSceneLayer');
  function createLayer(density, layoutDirection, focusable, compositionContext) {
    throw IllegalStateException_init_$Create$_0();
  }
  initMetadataForInterface(ComposeSceneContext, 'ComposeSceneContext');
  initMetadataForClass(CanvasLayersComposeSceneImpl, 'CanvasLayersComposeSceneImpl', VOID, BaseComposeScene, [ComposeSceneContext], [1]);
  initMetadataForClass(CopiedList, 'CopiedList', VOID, VOID, [KtMutableList]);
  initMetadataForClass(ComposeSceneDragAndDropNode, 'ComposeSceneDragAndDropNode', VOID, VOID, [DragAndDropTarget]);
  initMetadataForClass(asDragAndDropStartTransferScope$1);
  initMetadataForClass(ComposeSceneFocusManager, 'ComposeSceneFocusManager');
  initMetadataForClass(ComposeSceneInputHandler, 'ComposeSceneInputHandler');
  initMetadataForClass(DefaultPointerStateTracker, 'DefaultPointerStateTracker', DefaultPointerStateTracker);
  initMetadataForClass(Content$$inlined$cache$1$1);
  initMetadataForClass(PointerEventResult, 'PointerEventResult');
  initMetadataForClass(ComposeScenePointer, 'ComposeScenePointer');
  initMetadataForLambda(ComposeSceneRecomposer$slambda, CoroutineImpl, VOID, [1]);
  initMetadataForClass(ComposeSceneRecomposer$scheduleAsEffect$$inlined$Runnable$1, VOID, VOID, VOID, [Runnable]);
  initMetadataForClass(ComposeSceneRecomposer, 'ComposeSceneRecomposer');
  initMetadataForClass(TrackInteropPlacementModifierNode, 'TrackInteropPlacementModifierNode', VOID, Node, [TraversableNode, LayoutAwareModifierNode, UnplacedAwareModifierNode, GlobalPositionAwareModifierNode]);
  initMetadataForClass(RootTrackInteropPlacementModifierElement, 'RootTrackInteropPlacementModifierElement', VOID, ModifierNodeElement);
  initMetadataForClass(DialogProperties, 'DialogProperties');
  initMetadataForLambda(DialogAppearanceController$hideDialogWithAnimation$lambda$slambda, CoroutineImpl, VOID, [1]);
  initMetadataForCoroutine($onDialogShownCOROUTINE$, CoroutineImpl);
  initMetadataForClass(DialogAppearanceController, 'DialogAppearanceController', VOID, VOID, VOID, [0]);
  initMetadataForLambda(Dialog$slambda, CoroutineImpl, VOID, [1]);
  initMetadataForClass(Dialog$$inlined$cache$3$1);
  initMetadataForLambda(DialogLayout$lambda$slambda, CoroutineImpl, VOID, [1]);
  initMetadataForClass(DialogLayout$1$$inlined$onDispose$1);
  initMetadataForClass(OnBackClickEventHandler, 'OnBackClickEventHandler', VOID, NavigationEventHandler);
  initMetadataForClass(BackClickHandlerInfo, 'BackClickHandlerInfo', VOID, NavigationEventInfo);
  initMetadataForClass(PopupProperties, 'PopupProperties');
  initMetadataForLambda(Popup$slambda, CoroutineImpl, VOID, [1]);
  initMetadataForClass(Popup$$inlined$cache$3$1);
  initMetadataForClass(PopupLayout$$inlined$cache$2$1);
  initMetadataForClass(sam$androidx_compose_ui_layout_MeasurePolicy$0_1, 'sam$androidx_compose_ui_layout_MeasurePolicy$0', VOID, VOID, [MeasurePolicy, FunctionAdapter]);
  initMetadataForClass(DragAndDropEvent, 'DragAndDropEvent');
  initMetadataForClass(DragAndDropTransferData, 'DragAndDropTransferData', DragAndDropTransferData);
  initMetadataForClass(WebDragAndDropManager, 'WebDragAndDropManager');
  initMetadataForClass(InternalStartTransferScope, 'InternalStartTransferScope');
  initMetadataForClass(EventTargetListener, 'EventTargetListener');
  initMetadataForCompanion(Companion_49);
  initMetadataForClass(Key_1, 'Key');
  initMetadataForClass(BrowserCursor, 'BrowserCursor');
  initMetadataForClass(WebVelocityTracker, 'WebVelocityTracker', WebVelocityTracker);
  initMetadataForClass(WeakReference, 'WeakReference');
  initMetadataForClass(BackingDomInput, 'BackingDomInput');
  function sendEditCommand(command) {
    return this.xdc(listOf(command));
  }
  initMetadataForInterface(ComposeCommandCommunicator, 'ComposeCommandCommunicator');
  initMetadataForClass(NativeInputEventsProcessor, 'NativeInputEventsProcessor');
  initMetadataForClass(DomInputStrategy$nativeInputEventsProcessor$1, VOID, VOID, NativeInputEventsProcessor);
  initMetadataForClass(DomInputStrategy, 'DomInputStrategy');
  initMetadataForClass(sam$kotlin_Comparator$0_0, 'sam$kotlin_Comparator$0', VOID, VOID, [Comparator, FunctionAdapter]);
  initMetadataForClass(WebUriHandler, 'WebUriHandler', WebUriHandler);
  initMetadataForClass(WebTextInputService$startInput$1, VOID, VOID, VOID, [ComposeCommandCommunicator]);
  initMetadataForClass(WebTextInputService, 'WebTextInputService', VOID, VOID, [PlatformTextInputService]);
  initMetadataForClass(TextToolbarMenu, 'TextToolbarMenu');
  initMetadataForClass(WebTextToolbar, 'WebTextToolbar', WebTextToolbar, VOID, [TextToolbar]);
  initMetadataForLambda(ComposeWebSemanticsListener$slambda$slambda$slambda, CoroutineImpl, VOID, [1]);
  initMetadataForLambda(ComposeWebSemanticsListener$slambda$slambda$slambda_1, CoroutineImpl, VOID, [1]);
  initMetadataForLambda(ComposeWebSemanticsListener$slambda$slambda, CoroutineImpl, VOID, [1]);
  initMetadataForLambda(ComposeWebSemanticsListener$slambda$slambda_1, CoroutineImpl, VOID, [1]);
  initMetadataForCompanion(Companion_50);
  initMetadataForClass(sam$kotlinx_coroutines_flow_FlowCollector$0_0, 'sam$kotlinx_coroutines_flow_FlowCollector$0', VOID, VOID, [FlowCollector, FunctionAdapter], [1]);
  initMetadataForLambda(ComposeWebSemanticsListener$slambda, CoroutineImpl, VOID, [1]);
  initMetadataForClass(ComposeWebSemanticsListener, 'ComposeWebSemanticsListener');
  initMetadataForClass(InteropViewGroup, 'InteropViewGroup');
  initMetadataForClass(WebInteropContainer, 'WebInteropContainer', WebInteropContainer);
  initMetadataForClass(ComposeViewportConfiguration, 'ComposeViewportConfiguration');
  initMetadataForObject(ComposableSingletons$ComposeWindow_webKt, 'ComposableSingletons$ComposeWindow_webKt');
  initMetadataForClass(ComposeWindow$platformContext$1$dragAndDropManager$1, VOID, VOID, WebDragAndDropManager);
  initMetadataForClass(ComposeWindow$platformContext$1$textInputService$1, VOID, VOID, WebTextInputService);
  initMetadataForClass(ComposeWindow$platformContext$1$viewConfiguration$1, VOID, VOID, VOID, [ViewConfiguration]);
  initMetadataForLambda(ComposeWindow$platformContext$o$startInputMethod$slambda, CoroutineImpl, VOID, [1]);
  initMetadataForCoroutine($startInputMethodCOROUTINE$_3, CoroutineImpl);
  initMetadataForLambda(ComposeWindow$lambda$lambda$slambda$slambda, CoroutineImpl, VOID, [1]);
  initMetadataForClass(TouchEventWithContainerOffset, 'TouchEventWithContainerOffset');
  initMetadataForClass(sam$org_jetbrains_skiko_SkikoRenderDelegate$0, 'sam$org_jetbrains_skiko_SkikoRenderDelegate$0', VOID, VOID, [SkikoRenderDelegate, FunctionAdapter]);
  initMetadataForClass(sam$kotlinx_coroutines_flow_FlowCollector$0_1, 'sam$kotlinx_coroutines_flow_FlowCollector$0', VOID, VOID, [FlowCollector, FunctionAdapter], [1]);
  initMetadataForClass(ComposeWindow$platformContext$1, VOID, VOID, VOID, [PlatformContext], [1]);
  initMetadataForLambda(ComposeWindow$lambda$lambda$slambda, CoroutineImpl, VOID, [1]);
  initMetadataForClass(ComposeWindow, 'ComposeWindow');
  function init() {
  }
  initMetadataForInterface(ComposeWindowState, 'ComposeWindowState');
  initMetadataForClass(DefaultWindowState, 'DefaultWindowState', VOID, VOID, [ComposeWindowState]);
  initMetadataForObject(Virtual, 'Virtual');
  initMetadataForObject(Hardware, 'Hardware');
  initMetadataForClass(SystemThemeObserverImpl, 'SystemThemeObserverImpl');
  initMetadataForLambda(WebTextInputSession$startInputMethod$slambda$slambda$slambda, CoroutineImpl, VOID, [1]);
  initMetadataForLambda(WebTextInputSession$startInputMethod$slambda$slambda$slambda_1, CoroutineImpl, VOID, [1]);
  initMetadataForLambda(WebTextInputSession$startInputMethod$slambda$slambda, CoroutineImpl, VOID, [1]);
  initMetadataForLambda(WebTextInputSession$startInputMethod$slambda$slambda_1, CoroutineImpl, VOID, [1]);
  initMetadataForClass(sam$kotlinx_coroutines_flow_FlowCollector$0_2, 'sam$kotlinx_coroutines_flow_FlowCollector$0', VOID, VOID, [FlowCollector, FunctionAdapter], [1]);
  initMetadataForLambda(WebTextInputSession$startInputMethod$slambda, CoroutineImpl, VOID, [1]);
  initMetadataForCoroutine($startInputMethodCOROUTINE$_4, CoroutineImpl);
  initMetadataForClass(WebTextInputSession, 'WebTextInputSession', VOID, VOID, [PlatformTextInputSessionScope, CoroutineScope_0], [1]);
  //endregion
  var androidx_compose_ui_AbsoluteAlignment$stable;
  var androidx_compose_ui_BiasAlignment_Horizontal$stable;
  var androidx_compose_ui_BiasAlignment_Vertical$stable;
  var androidx_compose_ui_BiasAlignment$stable;
  var androidx_compose_ui_BiasAbsoluteAlignment_Horizontal$stable;
  var androidx_compose_ui_BiasAbsoluteAlignment$stable;
  function Companion() {
    Companion_instance_4 = this;
    this.k8t_1 = new BiasAlignment(-1.0, -1.0);
    this.l8t_1 = new BiasAlignment(0.0, -1.0);
    this.m8t_1 = new BiasAlignment(1.0, -1.0);
    this.n8t_1 = new BiasAlignment(-1.0, 0.0);
    this.o8t_1 = new BiasAlignment(0.0, 0.0);
    this.p8t_1 = new BiasAlignment(1.0, 0.0);
    this.q8t_1 = new BiasAlignment(-1.0, 1.0);
    this.r8t_1 = new BiasAlignment(0.0, 1.0);
    this.s8t_1 = new BiasAlignment(1.0, 1.0);
    this.t8t_1 = new Vertical(-1.0);
    this.u8t_1 = new Vertical(0.0);
    this.v8t_1 = new Vertical(1.0);
    this.w8t_1 = new Horizontal(-1.0);
    this.x8t_1 = new Horizontal(0.0);
    this.y8t_1 = new Horizontal(1.0);
  }
  var Companion_instance_4;
  function Companion_getInstance_25() {
    if (Companion_instance_4 == null)
      new Companion();
    return Companion_instance_4;
  }
  function Horizontal(bias) {
    this.z8t_1 = bias;
  }
  protoOf(Horizontal).a8u = function (size, space, layoutDirection) {
    var center = (space - size | 0) / 2.0;
    var resolvedBias = layoutDirection.equals(LayoutDirection_Ltr_getInstance()) ? this.z8t_1 : -1 * this.z8t_1;
    // Inline function 'androidx.compose.ui.util.fastRoundToInt' call
    var this_0 = center * (1 + resolvedBias);
    var tmp;
    if (isNaN_0(this_0)) {
      tmp = 0;
    } else {
      // Inline function 'kotlin.math.roundToInt' call
      tmp = roundToInt(this_0);
    }
    return tmp;
  };
  protoOf(Horizontal).toString = function () {
    return 'Horizontal(bias=' + this.z8t_1 + ')';
  };
  protoOf(Horizontal).hashCode = function () {
    return getNumberHashCode(this.z8t_1);
  };
  protoOf(Horizontal).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof Horizontal))
      return false;
    if (!equals(this.z8t_1, other.z8t_1))
      return false;
    return true;
  };
  function Vertical(bias) {
    this.b8u_1 = bias;
  }
  protoOf(Vertical).c8u = function (size, space) {
    var center = (space - size | 0) / 2.0;
    // Inline function 'androidx.compose.ui.util.fastRoundToInt' call
    var this_0 = center * (1 + this.b8u_1);
    var tmp;
    if (isNaN_0(this_0)) {
      tmp = 0;
    } else {
      // Inline function 'kotlin.math.roundToInt' call
      tmp = roundToInt(this_0);
    }
    return tmp;
  };
  protoOf(Vertical).toString = function () {
    return 'Vertical(bias=' + this.b8u_1 + ')';
  };
  protoOf(Vertical).hashCode = function () {
    return getNumberHashCode(this.b8u_1);
  };
  protoOf(Vertical).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof Vertical))
      return false;
    if (!equals(this.b8u_1, other.b8u_1))
      return false;
    return true;
  };
  function BiasAlignment(horizontalBias, verticalBias) {
    this.d8u_1 = horizontalBias;
    this.e8u_1 = verticalBias;
  }
  protoOf(BiasAlignment).f8u = function (size, space, layoutDirection) {
    // Inline function 'androidx.compose.ui.unit.IntSize.width' call
    // Inline function 'androidx.compose.ui.util.unpackInt1' call
    var value = _IntSize___get_packedValue__impl__uho7jf(space);
    var tmp = convertToInt(shiftRight(value, 32));
    // Inline function 'androidx.compose.ui.unit.IntSize.width' call
    // Inline function 'androidx.compose.ui.util.unpackInt1' call
    var value_0 = _IntSize___get_packedValue__impl__uho7jf(size);
    var centerX = (tmp - convertToInt(shiftRight(value_0, 32)) | 0) / 2.0;
    // Inline function 'androidx.compose.ui.unit.IntSize.height' call
    // Inline function 'androidx.compose.ui.util.unpackInt2' call
    var value_1 = _IntSize___get_packedValue__impl__uho7jf(space);
    var tmp_0 = convertToInt(bitwiseAnd(value_1, new Long(-1, 0)));
    // Inline function 'androidx.compose.ui.unit.IntSize.height' call
    // Inline function 'androidx.compose.ui.util.unpackInt2' call
    var value_2 = _IntSize___get_packedValue__impl__uho7jf(size);
    var centerY = (tmp_0 - convertToInt(bitwiseAnd(value_2, new Long(-1, 0))) | 0) / 2.0;
    var tmp_1;
    if (layoutDirection.equals(LayoutDirection_Ltr_getInstance())) {
      tmp_1 = this.d8u_1;
    } else {
      tmp_1 = -1 * this.d8u_1;
    }
    var resolvedHorizontalBias = tmp_1;
    var x = centerX * (1 + resolvedHorizontalBias);
    var y = centerY * (1 + this.e8u_1);
    // Inline function 'androidx.compose.ui.util.fastRoundToInt' call
    var tmp_2;
    if (isNaN_0(x)) {
      tmp_2 = 0;
    } else {
      // Inline function 'kotlin.math.roundToInt' call
      tmp_2 = roundToInt(x);
    }
    var tmp0 = tmp_2;
    // Inline function 'androidx.compose.ui.util.fastRoundToInt' call
    var tmp_3;
    if (isNaN_0(y)) {
      tmp_3 = 0;
    } else {
      // Inline function 'kotlin.math.roundToInt' call
      tmp_3 = roundToInt(y);
    }
    // Inline function 'androidx.compose.ui.unit.IntOffset' call
    // Inline function 'androidx.compose.ui.util.packInts' call
    var val2 = tmp_3;
    var tmp$ret$13 = bitwiseOr(shiftLeft(fromInt(tmp0), 32), bitwiseAnd(fromInt(val2), new Long(-1, 0)));
    return _IntOffset___init__impl__rq8h7b(tmp$ret$13);
  };
  protoOf(BiasAlignment).toString = function () {
    return 'BiasAlignment(horizontalBias=' + this.d8u_1 + ', verticalBias=' + this.e8u_1 + ')';
  };
  protoOf(BiasAlignment).hashCode = function () {
    var result = getNumberHashCode(this.d8u_1);
    result = imul(result, 31) + getNumberHashCode(this.e8u_1) | 0;
    return result;
  };
  protoOf(BiasAlignment).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof BiasAlignment))
      return false;
    if (!equals(this.d8u_1, other.d8u_1))
      return false;
    if (!equals(this.e8u_1, other.e8u_1))
      return false;
    return true;
  };
  function Horizontal_0(bias) {
    this.g8u_1 = bias;
  }
  protoOf(Horizontal_0).a8u = function (size, space, layoutDirection) {
    var center = (space - size | 0) / 2.0;
    // Inline function 'androidx.compose.ui.util.fastRoundToInt' call
    var this_0 = center * (1 + this.g8u_1);
    var tmp;
    if (isNaN_0(this_0)) {
      tmp = 0;
    } else {
      // Inline function 'kotlin.math.roundToInt' call
      tmp = roundToInt(this_0);
    }
    return tmp;
  };
  protoOf(Horizontal_0).toString = function () {
    return 'Horizontal(bias=' + this.g8u_1 + ')';
  };
  protoOf(Horizontal_0).hashCode = function () {
    return getNumberHashCode(this.g8u_1);
  };
  protoOf(Horizontal_0).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof Horizontal_0))
      return false;
    if (!equals(this.g8u_1, other.g8u_1))
      return false;
    return true;
  };
  function BiasAbsoluteAlignment(horizontalBias, verticalBias) {
    this.h8u_1 = horizontalBias;
    this.i8u_1 = verticalBias;
  }
  protoOf(BiasAbsoluteAlignment).f8u = function (size, space, layoutDirection) {
    // Inline function 'androidx.compose.ui.unit.IntSize.width' call
    // Inline function 'androidx.compose.ui.util.unpackInt1' call
    var value = _IntSize___get_packedValue__impl__uho7jf(space);
    var tmp = convertToInt(shiftRight(value, 32));
    // Inline function 'androidx.compose.ui.unit.IntSize.width' call
    // Inline function 'androidx.compose.ui.util.unpackInt1' call
    var value_0 = _IntSize___get_packedValue__impl__uho7jf(size);
    var tmp0 = tmp - convertToInt(shiftRight(value_0, 32)) | 0;
    // Inline function 'androidx.compose.ui.unit.IntSize.height' call
    // Inline function 'androidx.compose.ui.util.unpackInt2' call
    var value_1 = _IntSize___get_packedValue__impl__uho7jf(space);
    var tmp_0 = convertToInt(bitwiseAnd(value_1, new Long(-1, 0)));
    // Inline function 'androidx.compose.ui.unit.IntSize.height' call
    // Inline function 'androidx.compose.ui.util.unpackInt2' call
    var value_2 = _IntSize___get_packedValue__impl__uho7jf(size);
    // Inline function 'androidx.compose.ui.unit.IntSize' call
    // Inline function 'androidx.compose.ui.util.packInts' call
    var val2 = tmp_0 - convertToInt(bitwiseAnd(value_2, new Long(-1, 0))) | 0;
    var tmp$ret$9 = bitwiseOr(shiftLeft(fromInt(tmp0), 32), bitwiseAnd(fromInt(val2), new Long(-1, 0)));
    var remaining = _IntSize___init__impl__emcjft(tmp$ret$9);
    // Inline function 'androidx.compose.ui.unit.IntSize.width' call
    // Inline function 'androidx.compose.ui.util.unpackInt1' call
    var value_3 = _IntSize___get_packedValue__impl__uho7jf(remaining);
    var centerX = convertToInt(shiftRight(value_3, 32)) / 2.0;
    // Inline function 'androidx.compose.ui.unit.IntSize.height' call
    // Inline function 'androidx.compose.ui.util.unpackInt2' call
    var value_4 = _IntSize___get_packedValue__impl__uho7jf(remaining);
    var centerY = convertToInt(bitwiseAnd(value_4, new Long(-1, 0))) / 2.0;
    var x = centerX * (1 + this.h8u_1);
    var y = centerY * (1 + this.i8u_1);
    // Inline function 'androidx.compose.ui.util.fastRoundToInt' call
    var tmp_1;
    if (isNaN_0(x)) {
      tmp_1 = 0;
    } else {
      // Inline function 'kotlin.math.roundToInt' call
      tmp_1 = roundToInt(x);
    }
    var tmp0_0 = tmp_1;
    // Inline function 'androidx.compose.ui.util.fastRoundToInt' call
    var tmp_2;
    if (isNaN_0(y)) {
      tmp_2 = 0;
    } else {
      // Inline function 'kotlin.math.roundToInt' call
      tmp_2 = roundToInt(y);
    }
    // Inline function 'androidx.compose.ui.unit.IntOffset' call
    // Inline function 'androidx.compose.ui.util.packInts' call
    var val2_0 = tmp_2;
    var tmp$ret$19 = bitwiseOr(shiftLeft(fromInt(tmp0_0), 32), bitwiseAnd(fromInt(val2_0), new Long(-1, 0)));
    return _IntOffset___init__impl__rq8h7b(tmp$ret$19);
  };
  protoOf(BiasAbsoluteAlignment).toString = function () {
    return 'BiasAbsoluteAlignment(horizontalBias=' + this.h8u_1 + ', verticalBias=' + this.i8u_1 + ')';
  };
  protoOf(BiasAbsoluteAlignment).hashCode = function () {
    var result = getNumberHashCode(this.h8u_1);
    result = imul(result, 31) + getNumberHashCode(this.i8u_1) | 0;
    return result;
  };
  protoOf(BiasAbsoluteAlignment).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof BiasAbsoluteAlignment))
      return false;
    if (!equals(this.h8u_1, other.h8u_1))
      return false;
    if (!equals(this.i8u_1, other.i8u_1))
      return false;
    return true;
  };
  function AbsoluteAlignment() {
    AbsoluteAlignment_instance = this;
    this.j8u_1 = new BiasAbsoluteAlignment(-1.0, -1.0);
    this.k8u_1 = new BiasAbsoluteAlignment(1.0, -1.0);
    this.l8u_1 = new BiasAbsoluteAlignment(-1.0, 0.0);
    this.m8u_1 = new BiasAbsoluteAlignment(1.0, 0.0);
    this.n8u_1 = new BiasAbsoluteAlignment(-1.0, 1.0);
    this.o8u_1 = new BiasAbsoluteAlignment(1.0, 1.0);
    this.p8u_1 = new Horizontal_0(-1.0);
    this.q8u_1 = new Horizontal_0(1.0);
  }
  var AbsoluteAlignment_instance;
  function AbsoluteAlignment_getInstance() {
    if (AbsoluteAlignment_instance == null)
      new AbsoluteAlignment();
    return AbsoluteAlignment_instance;
  }
  var androidx_compose_ui_ComposeUiFlags$stable;
  function ComposeUiFlags() {
    this.r8u_1 = false;
    this.s8u_1 = true;
    this.t8u_1 = false;
    this.u8u_1 = false;
    this.v8u_1 = true;
    this.w8u_1 = true;
    this.x8u_1 = true;
    this.y8u_1 = true;
    this.z8u_1 = true;
    this.a8v_1 = true;
    this.b8v_1 = false;
    this.c8v_1 = true;
  }
  var ComposeUiFlags_instance;
  function ComposeUiFlags_getInstance() {
    return ComposeUiFlags_instance;
  }
  var androidx_compose_ui_CompositionLocalMapInjectionNode$stable;
  var androidx_compose_ui_CompositionLocalMapInjectionElement$stable;
  function composed(_this__u8e3s4, inspectorInfo, factory) {
    inspectorInfo = inspectorInfo === VOID ? get_NoInspectorInfo() : inspectorInfo;
    return _this__u8e3s4.d8v(new ComposedModifier(inspectorInfo, factory));
  }
  function ComposedModifier(inspectorInfo, factory) {
    InspectorValueInfo.call(this, inspectorInfo);
    this.g8v_1 = factory;
  }
  function materialize(_this__u8e3s4, modifier) {
    _this__u8e3s4.m30(439770924);
    var result = materializeImpl(_this__u8e3s4, modifier);
    _this__u8e3s4.n30();
    return result;
  }
  function materializeImpl(_this__u8e3s4, modifier) {
    if (modifier.i8v(materializeImpl$lambda)) {
      return modifier;
    }
    _this__u8e3s4.k30(1219399079);
    var tmp = Companion_instance_6;
    var result = modifier.h8v(tmp, materializeImpl$lambda_0(_this__u8e3s4));
    _this__u8e3s4.l30();
    return result;
  }
  function materializeImpl$lambda(it) {
    return !(it instanceof ComposedModifier);
  }
  function materializeImpl$lambda_0($this_materializeImpl) {
    return function (acc, element) {
      var tmp;
      if (element instanceof ComposedModifier) {
        var tmp_0 = element.g8v_1;
        var factory = typeof tmp_0 === 'function' ? tmp_0 : THROW_CCE();
        var composedMod = factory(Companion_instance_6, $this_materializeImpl, 0);
        tmp = materializeImpl($this_materializeImpl, composedMod);
      } else {
        tmp = element;
      }
      return acc.d8v(tmp);
    };
  }
  var androidx_compose_ui_FrameRateModifierNode$stable;
  function _FrameRateCategory___init__impl__99b7iq(value) {
    return value;
  }
  function _FrameRateCategory___get_value__impl__e037z6($this) {
    return $this;
  }
  function Companion_0() {
    Companion_instance_5 = this;
    this.j8v_1 = _FrameRateCategory___init__impl__99b7iq(NaN);
    this.k8v_1 = _FrameRateCategory___init__impl__99b7iq(-3.0);
    this.l8v_1 = _FrameRateCategory___init__impl__99b7iq(-4.0);
  }
  var Companion_instance_5;
  function Companion_getInstance_26() {
    if (Companion_instance_5 == null)
      new Companion_0();
    return Companion_instance_5;
  }
  var androidx_compose_ui_ModifierNodeDetachedCancellationException$stable;
  var androidx_compose_ui_Modifier_Node$stable;
  var androidx_compose_ui_CombinedModifier$stable;
  function Element_0() {
  }
  function Node() {
    this.m8v_1 = this;
    this.n8v_1 = null;
    this.o8v_1 = 0;
    this.p8v_1 = -1;
    this.q8v_1 = null;
    this.r8v_1 = null;
    this.s8v_1 = null;
    this.t8v_1 = null;
    this.u8v_1 = false;
    this.v8v_1 = false;
    this.w8v_1 = false;
    this.x8v_1 = false;
    this.y8v_1 = null;
    this.z8v_1 = false;
  }
  protoOf(Node).f4n = function () {
    return this.m8v_1;
  };
  protoOf(Node).a8w = function () {
    var tmp0_elvis_lhs = this.n8v_1;
    var tmp;
    if (tmp0_elvis_lhs == null) {
      // Inline function 'kotlin.also' call
      var this_0 = CoroutineScope(requireOwner(this).q19().xj(Job(requireOwner(this).q19().aa(Key_instance))));
      this.n8v_1 = this_0;
      tmp = this_0;
    } else {
      tmp = tmp0_elvis_lhs;
    }
    return tmp;
  };
  protoOf(Node).b8w = function () {
    return true;
  };
  protoOf(Node).c8w = function (coordinator) {
    this.t8v_1 = coordinator;
  };
  protoOf(Node).d8w = function () {
    // Inline function 'androidx.compose.ui.internal.checkPrecondition' call
    if (!!this.z8v_1) {
      var tmp$ret$1 = 'node attached multiple times';
      throwIllegalStateException(tmp$ret$1);
    }
    // Inline function 'androidx.compose.ui.internal.checkPrecondition' call
    if (!!(this.t8v_1 == null)) {
      var tmp$ret$3 = 'attach invoked on a node without a coordinator';
      throwIllegalStateException(tmp$ret$3);
    }
    this.z8v_1 = true;
    this.w8v_1 = true;
  };
  protoOf(Node).e8w = function () {
    // Inline function 'androidx.compose.ui.internal.checkPrecondition' call
    if (!this.z8v_1) {
      var tmp$ret$1 = 'Must run markAsAttached() prior to runAttachLifecycle';
      throwIllegalStateException(tmp$ret$1);
    }
    // Inline function 'androidx.compose.ui.internal.checkPrecondition' call
    if (!this.w8v_1) {
      var tmp$ret$3 = 'Must run runAttachLifecycle() only once after markAsAttached()';
      throwIllegalStateException(tmp$ret$3);
    }
    this.w8v_1 = false;
    this.f8w();
    this.x8v_1 = true;
  };
  protoOf(Node).g8w = function () {
    // Inline function 'androidx.compose.ui.internal.checkPrecondition' call
    if (!this.z8v_1) {
      var tmp$ret$1 = 'node detached multiple times';
      throwIllegalStateException(tmp$ret$1);
    }
    // Inline function 'androidx.compose.ui.internal.checkPrecondition' call
    if (!!(this.t8v_1 == null)) {
      var tmp$ret$3 = 'detach invoked on a node without a coordinator';
      throwIllegalStateException(tmp$ret$3);
    }
    // Inline function 'androidx.compose.ui.internal.checkPrecondition' call
    if (!this.x8v_1) {
      var tmp$ret$5 = 'Must run runDetachLifecycle() once after runAttachLifecycle() and before markAsDetached()';
      throwIllegalStateException(tmp$ret$5);
    }
    this.x8v_1 = false;
    var tmp0_safe_receiver = this.y8v_1;
    if (tmp0_safe_receiver == null)
      null;
    else
      tmp0_safe_receiver();
    this.h8w();
  };
  protoOf(Node).i8w = function () {
    // Inline function 'androidx.compose.ui.internal.checkPrecondition' call
    if (!this.z8v_1) {
      var tmp$ret$1 = 'Cannot detach a node that is not attached';
      throwIllegalStateException(tmp$ret$1);
    }
    // Inline function 'androidx.compose.ui.internal.checkPrecondition' call
    if (!!this.w8v_1) {
      var tmp$ret$3 = 'Must run runAttachLifecycle() before markAsDetached()';
      throwIllegalStateException(tmp$ret$3);
    }
    // Inline function 'androidx.compose.ui.internal.checkPrecondition' call
    if (!!this.x8v_1) {
      var tmp$ret$5 = 'Must run runDetachLifecycle() before markAsDetached()';
      throwIllegalStateException(tmp$ret$5);
    }
    this.z8v_1 = false;
    var tmp0_safe_receiver = this.n8v_1;
    if (tmp0_safe_receiver == null)
      null;
    else {
      // Inline function 'kotlin.let' call
      cancel(tmp0_safe_receiver, new ModifierNodeDetachedCancellationException());
      this.n8v_1 = null;
    }
  };
  protoOf(Node).j8w = function () {
    // Inline function 'androidx.compose.ui.internal.checkPrecondition' call
    if (!this.z8v_1) {
      var tmp$ret$1 = 'reset() called on an unattached node';
      throwIllegalStateException(tmp$ret$1);
    }
    this.k8w();
  };
  protoOf(Node).f8w = function () {
  };
  protoOf(Node).h8w = function () {
  };
  protoOf(Node).k8w = function () {
  };
  protoOf(Node).i3o = function (effect) {
    requireOwner(this).l8w(effect);
  };
  protoOf(Node).m8w = function (owner) {
    this.m8v_1 = owner;
  };
  function Companion_1() {
  }
  protoOf(Companion_1).h8v = function (initial, operation) {
    return initial;
  };
  protoOf(Companion_1).i8v = function (predicate) {
    return true;
  };
  protoOf(Companion_1).d8v = function (other) {
    return other;
  };
  protoOf(Companion_1).toString = function () {
    return 'Modifier';
  };
  var Companion_instance_6;
  function Companion_getInstance_27() {
    return Companion_instance_6;
  }
  function Modifier() {
  }
  function androidx_compose_ui_Modifier_Node$stableprop_getter() {
    return androidx_compose_ui_Modifier_Node$stable;
  }
  function CombinedModifier$toString$lambda(acc, element) {
    var tmp;
    // Inline function 'kotlin.text.isEmpty' call
    if (charSequenceLength(acc) === 0) {
      tmp = toString(element);
    } else {
      tmp = acc + ', ' + toString(element);
    }
    return tmp;
  }
  function CombinedModifier(outer, inner) {
    this.p8w_1 = outer;
    this.q8w_1 = inner;
  }
  protoOf(CombinedModifier).h8v = function (initial, operation) {
    return this.q8w_1.h8v(this.p8w_1.h8v(initial, operation), operation);
  };
  protoOf(CombinedModifier).i8v = function (predicate) {
    return this.p8w_1.i8v(predicate) && this.q8w_1.i8v(predicate);
  };
  protoOf(CombinedModifier).equals = function (other) {
    var tmp;
    var tmp_0;
    if (other instanceof CombinedModifier) {
      tmp_0 = equals(this.p8w_1, other.p8w_1);
    } else {
      tmp_0 = false;
    }
    if (tmp_0) {
      tmp = equals(this.q8w_1, other.q8w_1);
    } else {
      tmp = false;
    }
    return tmp;
  };
  protoOf(CombinedModifier).hashCode = function () {
    return hashCode(this.p8w_1) + imul(31, hashCode(this.q8w_1)) | 0;
  };
  protoOf(CombinedModifier).toString = function () {
    return '[' + this.h8v('', CombinedModifier$toString$lambda) + ']';
  };
  function ModifierNodeDetachedCancellationException() {
    PlatformOptimizedCancellationException.call(this, 'The Modifier.Node was detached');
    captureStack(this, ModifierNodeDetachedCancellationException);
  }
  function Key() {
  }
  var Key_instance_0;
  function Key_getInstance() {
    return Key_instance_0;
  }
  function MotionDurationScale() {
  }
  function _SessionMutex___init__impl__v390co(currentSessionHolder) {
    return currentSessionHolder;
  }
  function _get_currentSessionHolder__4g0ozm($this) {
    return $this;
  }
  function _SessionMutex___init__impl__v390co_0() {
    return _SessionMutex___init__impl__v390co(new AtomicReference(null));
  }
  function SessionMutex__withSessionCancellingPrevious_impl_9g140v($this, sessionInitializer, session, $completion) {
    return coroutineScope(SessionMutex$withSessionCancellingPrevious$slambda_0(sessionInitializer, $this, session, null), $completion);
  }
  function Session(job, value) {
    this.s8w_1 = job;
    this.t8w_1 = value;
  }
  function SessionMutex$withSessionCancellingPrevious$slambda($sessionInitializer, this$0, $session, resultContinuation) {
    this.c8x_1 = $sessionInitializer;
    this.d8x_1 = this$0;
    this.e8x_1 = $session;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(SessionMutex$withSessionCancellingPrevious$slambda).j8x = function ($this$coroutineScope, $completion) {
    var tmp = this.q24($this$coroutineScope, $completion);
    tmp.p9_1 = Unit_instance;
    tmp.q9_1 = null;
    return tmp.v9();
  };
  protoOf(SessionMutex$withSessionCancellingPrevious$slambda).ja = function (p1, $completion) {
    return this.j8x((!(p1 == null) ? isInterface(p1, CoroutineScope_0) : false) ? p1 : THROW_CCE(), $completion);
  };
  protoOf(SessionMutex$withSessionCancellingPrevious$slambda).v9 = function () {
    var suspendResult = this.p9_1;
    $sm: do
      try {
        var tmp = this.n9_1;
        switch (tmp) {
          case 0:
            this.o9_1 = 9;
            this.g8x_1 = new Session(get_job(this.f8x_1.q19()), this.c8x_1(this.f8x_1));
            var tmp0_safe_receiver = _get_currentSessionHolder__4g0ozm(this.d8x_1).x21(this.g8x_1);
            var tmp1_safe_receiver = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.s8w_1;
            if (tmp1_safe_receiver == null) {
              this.i8x_1 = null;
              this.n9_1 = 2;
              continue $sm;
            } else {
              this.n9_1 = 1;
              suspendResult = cancelAndJoin(tmp1_safe_receiver, this);
              if (suspendResult === get_COROUTINE_SUSPENDED()) {
                return suspendResult;
              }
              continue $sm;
            }

          case 1:
            var tmp_0 = this;
            tmp_0.i8x_1 = Unit_instance;
            this.n9_1 = 2;
            continue $sm;
          case 2:
            this.n9_1 = 3;
            continue $sm;
          case 3:
            this.n9_1 = 4;
            continue $sm;
          case 4:
            this.o9_1 = 8;
            this.n9_1 = 5;
            suspendResult = this.e8x_1(this.g8x_1.t8w_1, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 5:
            this.h8x_1 = suspendResult;
            this.o9_1 = 9;
            this.n9_1 = 6;
            var tmp_1 = this;
            continue $sm;
          case 6:
            var tmp_2 = this.h8x_1;
            this.o9_1 = 9;
            _get_currentSessionHolder__4g0ozm(this.d8x_1).w21(this.g8x_1, null);
            return tmp_2;
          case 7:
            this.o9_1 = 9;
            _get_currentSessionHolder__4g0ozm(this.d8x_1).w21(this.g8x_1, null);
            return Unit_instance;
          case 8:
            this.o9_1 = 9;
            var t = this.q9_1;
            _get_currentSessionHolder__4g0ozm(this.d8x_1).w21(this.g8x_1, null);
            throw t;
          case 9:
            throw this.q9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.o9_1 === 9) {
          throw e;
        } else {
          this.n9_1 = this.o9_1;
          this.q9_1 = e;
        }
      }
     while (true);
  };
  protoOf(SessionMutex$withSessionCancellingPrevious$slambda).q24 = function ($this$coroutineScope, completion) {
    var i = new SessionMutex$withSessionCancellingPrevious$slambda(this.c8x_1, this.d8x_1, this.e8x_1, completion);
    i.f8x_1 = $this$coroutineScope;
    return i;
  };
  function SessionMutex$withSessionCancellingPrevious$slambda_0($sessionInitializer, this$0, $session, resultContinuation) {
    var i = new SessionMutex$withSessionCancellingPrevious$slambda($sessionInitializer, this$0, $session, resultContinuation);
    return constructCallableReference(function ($this$coroutineScope, $completion) {
      return i.j8x($this$coroutineScope, $completion);
    }, 1);
  }
  var androidx_compose_ui_ZIndexElement$stable;
  var androidx_compose_ui_ZIndexNode$stable;
  function zIndex(_this__u8e3s4, zIndex) {
    return _this__u8e3s4.d8v(new ZIndexElement(zIndex));
  }
  function ZIndexElement(zIndex) {
    ModifierNodeElement.call(this);
    this.m8x_1 = zIndex;
  }
  protoOf(ZIndexElement).r3d = function () {
    return new ZIndexNode(this.m8x_1);
  };
  protoOf(ZIndexElement).n8x = function (node) {
    node.c8y_1 = this.m8x_1;
  };
  protoOf(ZIndexElement).d8y = function (node) {
    return this.n8x(node instanceof ZIndexNode ? node : THROW_CCE());
  };
  protoOf(ZIndexElement).toString = function () {
    return 'ZIndexElement(zIndex=' + this.m8x_1 + ')';
  };
  protoOf(ZIndexElement).hashCode = function () {
    return getNumberHashCode(this.m8x_1);
  };
  protoOf(ZIndexElement).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof ZIndexElement))
      return false;
    if (!equals(this.m8x_1, other.m8x_1))
      return false;
    return true;
  };
  function ZIndexNode$measure$lambda($placeable, this$0) {
    return function ($this$layout) {
      $this$layout.f8y($placeable, 0, 0, this$0.c8y_1);
      return Unit_instance;
    };
  }
  function ZIndexNode(zIndex) {
    Node.call(this);
    this.c8y_1 = zIndex;
  }
  protoOf(ZIndexNode).g8y = function (_this__u8e3s4, measurable, constraints) {
    var placeable = measurable.h8y(constraints);
    var tmp = placeable.i8y_1;
    var tmp_0 = placeable.j8y_1;
    return _this__u8e3s4.n8y(tmp, tmp_0, VOID, ZIndexNode$measure$lambda(placeable, this));
  };
  protoOf(ZIndexNode).toString = function () {
    return 'ZIndexModifier(zIndex=' + this.c8y_1 + ')';
  };
  var androidx_compose_ui_autofill_AutofillNode$stable;
  var androidx_compose_ui_autofill_AutofillManager$stable;
  var androidx_compose_ui_autofill_AutofillTree$stable;
  function AutofillTree() {
    var tmp = this;
    // Inline function 'kotlin.collections.mutableMapOf' call
    tmp.s8y_1 = LinkedHashMap_init_$Create$();
  }
  function Companion_2() {
  }
  var Companion_instance_7;
  function Companion_getInstance_28() {
    return Companion_instance_7;
  }
  function FillableData() {
  }
  function DragAndDropTarget() {
  }
  var androidx_compose_ui_draganddrop_DragAndDropNode$stable;
  function DragAndDropTraversableKey() {
  }
  var DragAndDropTraversableKey_instance;
  function DragAndDropTraversableKey_getInstance() {
    return DragAndDropTraversableKey_instance;
  }
  function Companion_3() {
  }
  var Companion_instance_8;
  function Companion_getInstance_29() {
    return Companion_instance_8;
  }
  function _get_dragAndDropManager__clc0k0($this) {
    return requireOwner($this).b8z();
  }
  function DragAndDropNode$startDragAndDropTransfer$lambda($offset, $nodeCoordinates, $this_startDragAndDropTransfer, $isTransferStarted) {
    return function (currentNode) {
      var tmp;
      if (!currentNode.z8v_1) {
        return TraverseDescendantsAction_SkipSubtreeAndContinueTraversal_getInstance();
      }
      var tmp0_elvis_lhs = currentNode.q8z_1;
      var tmp_0;
      if (tmp0_elvis_lhs == null) {
        return TraverseDescendantsAction_ContinueTraversal_getInstance();
      } else {
        tmp_0 = tmp0_elvis_lhs;
      }
      var onStartTransfer = tmp_0;
      var tmp_1;
      if (!equals($offset, Companion_getInstance().i5d_1)) {
        var currentCoordinates = requireLayoutNode(currentNode).p91();
        var localPosition = currentCoordinates.q91($nodeCoordinates, $offset);
        if (!toRect(toSize(currentNode.v8z_1)).u5d(localPosition)) {
          return TraverseDescendantsAction_ContinueTraversal_getInstance();
        }
        tmp_1 = onStartTransfer($this_startDragAndDropTransfer, new Offset(localPosition));
      } else {
        tmp_1 = onStartTransfer($this_startDragAndDropTransfer, new Offset(Companion_getInstance().i5d_1));
      }
      var tmp_2;
      if ($isTransferStarted()) {
        tmp_2 = TraverseDescendantsAction_CancelTraversal_getInstance();
      } else {
        tmp_2 = TraverseDescendantsAction_ContinueTraversal_getInstance();
      }
      return tmp_2;
    };
  }
  function DragAndDropNode$acceptDragAndDropTransfer$lambda($startEvent, this$0, $handled) {
    return function (currentNode) {
      var tmp;
      if (!currentNode.z8v_1) {
        return TraverseDescendantsAction_SkipSubtreeAndContinueTraversal_getInstance();
      }
      // Inline function 'androidx.compose.ui.internal.checkPrecondition' call
      if (!(currentNode.u8z_1 == null)) {
        var tmp$ret$1 = 'DragAndDropTarget self reference must be null at the start of a drag and drop session';
        throwIllegalStateException(tmp$ret$1);
      }
      var tmp_0 = currentNode;
      var tmp0_safe_receiver = currentNode.r8z_1;
      tmp_0.u8z_1 = tmp0_safe_receiver == null ? null : tmp0_safe_receiver($startEvent);
      var accepted = !(currentNode.u8z_1 == null);
      var tmp_1;
      if (accepted) {
        _get_dragAndDropManager__clc0k0(this$0).r91(currentNode);
        tmp_1 = Unit_instance;
      }
      $handled._v = $handled._v || accepted;
      return TraverseDescendantsAction_ContinueTraversal_getInstance();
    };
  }
  function DragAndDropNode$onMoved$lambda(this$0, $event, $match) {
    return function (child) {
      var tmp;
      if (_get_dragAndDropManager__clc0k0(this$0).s91(child) && contains_0(child, get_positionInRoot($event))) {
        $match._v = child;
        return TraverseDescendantsAction_CancelTraversal_getInstance();
      }
      return TraverseDescendantsAction_ContinueTraversal_getInstance();
    };
  }
  function DragAndDropNode$onEnded$lambda($event) {
    return function (currentNode) {
      var tmp;
      if (!currentNode.m8v_1.z8v_1) {
        return TraverseDescendantsAction_SkipSubtreeAndContinueTraversal_getInstance();
      }
      var tmp0_safe_receiver = currentNode.u8z_1;
      if (tmp0_safe_receiver == null)
        null;
      else {
        tmp0_safe_receiver.a8z($event);
      }
      currentNode.u8z_1 = null;
      currentNode.t8z_1 = null;
      return TraverseDescendantsAction_ContinueTraversal_getInstance();
    };
  }
  function DragAndDropNode(onStartTransfer, onDropTargetValidate) {
    onStartTransfer = onStartTransfer === VOID ? null : onStartTransfer;
    onDropTargetValidate = onDropTargetValidate === VOID ? null : onDropTargetValidate;
    Node.call(this);
    this.q8z_1 = onStartTransfer;
    this.r8z_1 = onDropTargetValidate;
    this.s8z_1 = DragAndDropTraversableKey_instance;
    this.t8z_1 = null;
    this.u8z_1 = null;
    this.v8z_1 = Companion_getInstance_0().n5g_1;
  }
  protoOf(DragAndDropNode).t91 = function () {
    return this.s8z_1;
  };
  protoOf(DragAndDropNode).h8w = function () {
    this.u8z_1 = null;
    this.t8z_1 = null;
  };
  protoOf(DragAndDropNode).u91 = function (size) {
    this.v8z_1 = size;
  };
  protoOf(DragAndDropNode).v91 = function (_this__u8e3s4, offset, isTransferStarted) {
    var nodeCoordinates = requireLayoutNode(this).p91();
    traverseSelfAndDescendants(this, DragAndDropNode$startDragAndDropTransfer$lambda(offset, nodeCoordinates, _this__u8e3s4, isTransferStarted));
  };
  protoOf(DragAndDropNode).w91 = function (startEvent) {
    var handled = {_v: false};
    traverseSelfAndDescendants(this, DragAndDropNode$acceptDragAndDropTransfer$lambda(startEvent, this, handled));
    return handled._v;
  };
  protoOf(DragAndDropNode).w8y = function (event) {
    var self_0 = this.u8z_1;
    if (self_0 == null) {
      var tmp0_safe_receiver = this.t8z_1;
      if (tmp0_safe_receiver == null)
        null;
      else {
        tmp0_safe_receiver.w8y(event);
      }
    } else {
      self_0.w8y(event);
    }
  };
  protoOf(DragAndDropNode).x8y = function (event) {
    var self_0 = this.u8z_1;
    if (self_0 == null) {
      var tmp0_safe_receiver = this.t8z_1;
      if (tmp0_safe_receiver == null)
        null;
      else {
        tmp0_safe_receiver.x8y(event);
      }
    } else {
      self_0.x8y(event);
    }
  };
  protoOf(DragAndDropNode).y8y = function (event) {
    var currentChildNode = this.t8z_1;
    var tmp;
    if ((currentChildNode == null ? null : contains_0(currentChildNode, get_positionInRoot(event))) === true) {
      tmp = currentChildNode;
    } else {
      var tmp$ret$0;
      $l$block: {
        // Inline function 'androidx.compose.ui.draganddrop.firstDescendantOrNull' call
        if (!this.f4n().z8v_1) {
          tmp$ret$0 = null;
          break $l$block;
        }
        var match = {_v: null};
        traverseDescendants_0(this, DragAndDropNode$onMoved$lambda(this, event, match));
        tmp$ret$0 = match._v;
      }
      tmp = tmp$ret$0;
    }
    var newChildNode = tmp;
    if (!(newChildNode == null) && currentChildNode == null) {
      dispatchEntered(newChildNode, event);
      var tmp1_safe_receiver = this.u8z_1;
      if (tmp1_safe_receiver == null)
        null;
      else {
        tmp1_safe_receiver.z8y(event);
      }
    } else if (newChildNode == null && !(currentChildNode == null)) {
      var tmp2_safe_receiver = this.u8z_1;
      if (tmp2_safe_receiver == null)
        null;
      else {
        dispatchEntered(tmp2_safe_receiver, event);
      }
      currentChildNode.z8y(event);
    } else if (!equals(newChildNode, currentChildNode)) {
      if (newChildNode == null)
        null;
      else {
        dispatchEntered(newChildNode, event);
      }
      if (currentChildNode == null)
        null;
      else {
        currentChildNode.z8y(event);
      }
    } else if (!(newChildNode == null)) {
      newChildNode.y8y(event);
    } else {
      var tmp5_safe_receiver = this.u8z_1;
      if (tmp5_safe_receiver == null)
        null;
      else {
        tmp5_safe_receiver.y8y(event);
      }
    }
    this.t8z_1 = newChildNode;
  };
  protoOf(DragAndDropNode).z8y = function (event) {
    var tmp0_safe_receiver = this.u8z_1;
    if (tmp0_safe_receiver == null)
      null;
    else {
      tmp0_safe_receiver.z8y(event);
    }
    var tmp1_safe_receiver = this.t8z_1;
    if (tmp1_safe_receiver == null)
      null;
    else {
      tmp1_safe_receiver.z8y(event);
    }
    this.t8z_1 = null;
  };
  protoOf(DragAndDropNode).v8y = function (event) {
    var currentChildDropTarget = this.t8z_1;
    var tmp;
    if (currentChildDropTarget == null) {
      var tmp0_safe_receiver = this.u8z_1;
      var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.v8y(event);
      tmp = tmp1_elvis_lhs == null ? false : tmp1_elvis_lhs;
    } else {
      tmp = currentChildDropTarget.v8y(event);
    }
    return tmp;
  };
  protoOf(DragAndDropNode).a8z = function (event) {
    return traverseSelfAndDescendants(this, DragAndDropNode$onEnded$lambda(event));
  };
  function traverseSelfAndDescendants(_this__u8e3s4, block) {
    if (!block(_this__u8e3s4).equals(TraverseDescendantsAction_ContinueTraversal_getInstance()))
      return Unit_instance;
    traverseDescendants_0(_this__u8e3s4, block);
  }
  function contains_0(_this__u8e3s4, positionInRoot_0) {
    if (!_this__u8e3s4.m8v_1.z8v_1)
      return false;
    var currentCoordinates = requireLayoutNode(_this__u8e3s4).p91();
    if (!currentCoordinates.y91())
      return false;
    var _destruct__k2r9zo = positionInRoot(currentCoordinates);
    // Inline function 'androidx.compose.ui.geometry.Offset.component1' call
    // Inline function 'androidx.compose.ui.geometry.Offset.x' call
    // Inline function 'androidx.compose.ui.util.unpackFloat1' call
    var value = _Offset___get_packedValue__impl__xh2k8q(_destruct__k2r9zo);
    // Inline function 'androidx.compose.ui.util.floatFromBits' call
    // Inline function 'kotlin.fromBits' call
    var bits = convertToInt(shiftRight(value, 32));
    var x1 = floatFromBits(bits);
    // Inline function 'androidx.compose.ui.geometry.Offset.component2' call
    // Inline function 'androidx.compose.ui.geometry.Offset.y' call
    // Inline function 'androidx.compose.ui.util.unpackFloat2' call
    var value_0 = _Offset___get_packedValue__impl__xh2k8q(_destruct__k2r9zo);
    // Inline function 'androidx.compose.ui.util.floatFromBits' call
    // Inline function 'kotlin.fromBits' call
    var bits_0 = convertToInt(bitwiseAnd(value_0, new Long(-1, 0)));
    var y1 = floatFromBits(bits_0);
    // Inline function 'androidx.compose.ui.unit.IntSize.width' call
    var this_0 = _this__u8e3s4.v8z_1;
    // Inline function 'androidx.compose.ui.util.unpackInt1' call
    var value_1 = _IntSize___get_packedValue__impl__uho7jf(this_0);
    var x2 = x1 + convertToInt(shiftRight(value_1, 32));
    // Inline function 'androidx.compose.ui.unit.IntSize.height' call
    var this_1 = _this__u8e3s4.v8z_1;
    // Inline function 'androidx.compose.ui.util.unpackInt2' call
    var value_2 = _IntSize___get_packedValue__impl__uho7jf(this_1);
    var y2 = y1 + convertToInt(bitwiseAnd(value_2, new Long(-1, 0)));
    var tmp;
    // Inline function 'androidx.compose.ui.geometry.Offset.x' call
    // Inline function 'androidx.compose.ui.util.unpackFloat1' call
    var value_3 = _Offset___get_packedValue__impl__xh2k8q(positionInRoot_0);
    // Inline function 'androidx.compose.ui.util.floatFromBits' call
    // Inline function 'kotlin.fromBits' call
    var bits_1 = convertToInt(shiftRight(value_3, 32));
    var containsArg = floatFromBits(bits_1);
    if (x1 <= containsArg ? containsArg <= x2 : false) {
      // Inline function 'androidx.compose.ui.geometry.Offset.y' call
      // Inline function 'androidx.compose.ui.util.unpackFloat2' call
      var value_4 = _Offset___get_packedValue__impl__xh2k8q(positionInRoot_0);
      // Inline function 'androidx.compose.ui.util.floatFromBits' call
      // Inline function 'kotlin.fromBits' call
      var bits_2 = convertToInt(bitwiseAnd(value_4, new Long(-1, 0)));
      var containsArg_0 = floatFromBits(bits_2);
      tmp = y1 <= containsArg_0 ? containsArg_0 <= y2 : false;
    } else {
      tmp = false;
    }
    return tmp;
  }
  function dispatchEntered(_this__u8e3s4, event) {
    // Inline function 'kotlin.run' call
    _this__u8e3s4.x8y(event);
    _this__u8e3s4.y8y(event);
    return Unit_instance;
  }
  function alpha(_this__u8e3s4, alpha) {
    return !(alpha === 1.0) ? graphicsLayer_0(_this__u8e3s4, VOID, VOID, alpha, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, true) : _this__u8e3s4;
  }
  function clipToBounds(_this__u8e3s4) {
    return graphicsLayer_0(_this__u8e3s4, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, true);
  }
  function clip(_this__u8e3s4, shape) {
    return graphicsLayer_0(_this__u8e3s4, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, shape, true);
  }
  var androidx_compose_ui_draw_DrawBackgroundModifier$stable;
  var androidx_compose_ui_draw_CacheDrawScope$stable;
  var androidx_compose_ui_draw_DrawResult$stable;
  function drawBehind(_this__u8e3s4, onDraw) {
    return _this__u8e3s4.d8v(new DrawBehindElement(onDraw));
  }
  function drawWithCache(_this__u8e3s4, onBuildDrawCache) {
    return _this__u8e3s4.d8v(new DrawWithCacheElement(onBuildDrawCache));
  }
  function CacheDrawScope$onDrawBehind$lambda($block) {
    return function ($this$onDrawWithContent) {
      $block($this$onDrawWithContent);
      $this$onDrawWithContent.z91();
      return Unit_instance;
    };
  }
  function CacheDrawScope() {
    this.a92_1 = EmptyBuildDrawCacheParams_getInstance();
    this.b92_1 = null;
    this.c92_1 = null;
    this.d92_1 = null;
  }
  protoOf(CacheDrawScope).o5d = function () {
    return this.a92_1.o5d();
  };
  protoOf(CacheDrawScope).r6p = function () {
    return this.a92_1.r6p();
  };
  protoOf(CacheDrawScope).e92 = function (block) {
    return this.f92(CacheDrawScope$onDrawBehind$lambda(block));
  };
  protoOf(CacheDrawScope).f92 = function (block) {
    // Inline function 'kotlin.also' call
    var this_0 = new DrawResult(block);
    this.b92_1 = this_0;
    return this_0;
  };
  protoOf(CacheDrawScope).u5e = function () {
    return this.a92_1.u5e().u5e();
  };
  protoOf(CacheDrawScope).j5f = function () {
    return this.a92_1.u5e().j5f();
  };
  function DrawResult(block) {
    this.g92_1 = block;
  }
  function CacheDrawModifierNode(onBuildDrawCache) {
    return new CacheDrawModifierNodeImpl(new CacheDrawScope(), onBuildDrawCache);
  }
  function drawWithContent(_this__u8e3s4, onDraw) {
    return _this__u8e3s4.d8v(new DrawWithContentElement(onDraw));
  }
  function DrawModifier() {
  }
  function DrawBehindElement(onDraw) {
    ModifierNodeElement.call(this);
    this.j92_1 = onDraw;
  }
  protoOf(DrawBehindElement).r3d = function () {
    return new DrawBackgroundModifier(this.j92_1);
  };
  protoOf(DrawBehindElement).k92 = function (node) {
    node.z92_1 = this.j92_1;
  };
  protoOf(DrawBehindElement).d8y = function (node) {
    return this.k92(node instanceof DrawBackgroundModifier ? node : THROW_CCE());
  };
  protoOf(DrawBehindElement).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof DrawBehindElement))
      return false;
    if (!(this.j92_1 === other.j92_1))
      return false;
    return true;
  };
  protoOf(DrawBehindElement).hashCode = function () {
    return hashCode(this.j92_1);
  };
  function DrawWithCacheElement(onBuildDrawCache) {
    ModifierNodeElement.call(this);
    this.b93_1 = onBuildDrawCache;
  }
  protoOf(DrawWithCacheElement).r3d = function () {
    return new CacheDrawModifierNodeImpl(new CacheDrawScope(), this.b93_1);
  };
  protoOf(DrawWithCacheElement).c93 = function (node) {
    node.v93(this.b93_1);
  };
  protoOf(DrawWithCacheElement).d8y = function (node) {
    return this.c93(node instanceof CacheDrawModifierNodeImpl ? node : THROW_CCE());
  };
  protoOf(DrawWithCacheElement).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof DrawWithCacheElement))
      return false;
    if (!(this.b93_1 === other.b93_1))
      return false;
    return true;
  };
  protoOf(DrawWithCacheElement).hashCode = function () {
    return hashCode(this.b93_1);
  };
  function EmptyBuildDrawCacheParams() {
    EmptyBuildDrawCacheParams_instance = this;
    this.w93_1 = Companion_getInstance_1().k5e_1;
    this.x93_1 = LayoutDirection_Ltr_getInstance();
    this.y93_1 = Density_0(1.0, 1.0);
  }
  protoOf(EmptyBuildDrawCacheParams).o5d = function () {
    return this.w93_1;
  };
  protoOf(EmptyBuildDrawCacheParams).r6p = function () {
    return this.x93_1;
  };
  protoOf(EmptyBuildDrawCacheParams).u5e = function () {
    return this.y93_1;
  };
  var EmptyBuildDrawCacheParams_instance;
  function EmptyBuildDrawCacheParams_getInstance() {
    if (EmptyBuildDrawCacheParams_instance == null)
      new EmptyBuildDrawCacheParams();
    return EmptyBuildDrawCacheParams_instance;
  }
  function getOrBuildCachedDrawBlock($this, contentDrawScope) {
    if (!$this.s93_1) {
      // Inline function 'kotlin.apply' call
      var this_0 = $this.r93_1;
      this_0.b92_1 = null;
      this_0.c92_1 = contentDrawScope;
      observeReads($this, CacheDrawModifierNodeImpl$getOrBuildCachedDrawBlock$lambda($this, this_0));
      // Inline function 'androidx.compose.ui.internal.checkPreconditionNotNull' call
      if (this_0.b92_1 == null) {
        var tmp$ret$3 = 'DrawResult not defined, did you forget to call onDraw?';
        throwIllegalStateExceptionForNullCheck(tmp$ret$3);
      }
      $this.s93_1 = true;
    }
    return ensureNotNull($this.r93_1.b92_1);
  }
  function CacheDrawModifierNodeImpl$lambda(this$0) {
    return function () {
      return this$0.z93();
    };
  }
  function CacheDrawModifierNodeImpl$getOrBuildCachedDrawBlock$lambda(this$0, $$this$apply) {
    return function () {
      this$0.u93_1($$this$apply);
      return Unit_instance;
    };
  }
  function CacheDrawModifierNodeImpl(cacheDrawScope, block) {
    Node.call(this);
    this.r93_1 = cacheDrawScope;
    this.s93_1 = false;
    this.t93_1 = null;
    this.u93_1 = block;
    this.r93_1.a92_1 = this;
    var tmp = this.r93_1;
    tmp.d92_1 = CacheDrawModifierNodeImpl$lambda(this);
  }
  protoOf(CacheDrawModifierNodeImpl).v93 = function (value) {
    this.u93_1 = value;
    this.a94();
  };
  protoOf(CacheDrawModifierNodeImpl).u5e = function () {
    return requireDensity(this);
  };
  protoOf(CacheDrawModifierNodeImpl).r6p = function () {
    return requireLayoutDirection(this);
  };
  protoOf(CacheDrawModifierNodeImpl).o5d = function () {
    // Inline function 'androidx.compose.ui.node.Nodes.Draw' call
    var tmp$ret$0 = _NodeKind___init__impl__ojsprp(4);
    return toSize(requireCoordinator(this, tmp$ret$0).q95());
  };
  protoOf(CacheDrawModifierNodeImpl).z93 = function () {
    var localGraphicsContext = this.t93_1;
    if (localGraphicsContext == null) {
      // Inline function 'kotlin.also' call
      var this_0 = new ScopedGraphicsContext();
      this.t93_1 = this_0;
      localGraphicsContext = this_0;
    }
    if (localGraphicsContext.s95_1 == null) {
      localGraphicsContext.t95(requireGraphicsContext(this));
    }
    return localGraphicsContext;
  };
  protoOf(CacheDrawModifierNodeImpl).h8w = function () {
    protoOf(Node).h8w.call(this);
    var tmp0_safe_receiver = this.t93_1;
    if (tmp0_safe_receiver == null)
      null;
    else {
      tmp0_safe_receiver.u95();
    }
  };
  protoOf(CacheDrawModifierNodeImpl).k8w = function () {
    protoOf(Node).k8w.call(this);
    this.a94();
  };
  protoOf(CacheDrawModifierNodeImpl).v95 = function () {
    this.a94();
  };
  protoOf(CacheDrawModifierNodeImpl).w95 = function () {
    this.a94();
  };
  protoOf(CacheDrawModifierNodeImpl).a94 = function () {
    var tmp0_safe_receiver = this.t93_1;
    if (tmp0_safe_receiver == null)
      null;
    else {
      tmp0_safe_receiver.u95();
    }
    this.s93_1 = false;
    this.r93_1.b92_1 = null;
    invalidateDraw(this);
  };
  protoOf(CacheDrawModifierNodeImpl).n8w = function () {
    this.a94();
  };
  protoOf(CacheDrawModifierNodeImpl).o8w = function () {
    this.a94();
  };
  protoOf(CacheDrawModifierNodeImpl).h92 = function (_this__u8e3s4) {
    getOrBuildCachedDrawBlock(this, _this__u8e3s4).g92_1(_this__u8e3s4);
  };
  function DrawWithContentElement(onDraw) {
    ModifierNodeElement.call(this);
    this.y95_1 = onDraw;
  }
  protoOf(DrawWithContentElement).r3d = function () {
    return new DrawWithContentModifier(this.y95_1);
  };
  protoOf(DrawWithContentElement).z95 = function (node) {
    node.o96_1 = this.y95_1;
  };
  protoOf(DrawWithContentElement).d8y = function (node) {
    return this.z95(node instanceof DrawWithContentModifier ? node : THROW_CCE());
  };
  protoOf(DrawWithContentElement).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof DrawWithContentElement))
      return false;
    if (!(this.y95_1 === other.y95_1))
      return false;
    return true;
  };
  protoOf(DrawWithContentElement).hashCode = function () {
    return hashCode(this.y95_1);
  };
  function DrawBackgroundModifier(onDraw) {
    Node.call(this);
    this.z92_1 = onDraw;
  }
  protoOf(DrawBackgroundModifier).h92 = function (_this__u8e3s4) {
    this.z92_1(_this__u8e3s4);
    _this__u8e3s4.z91();
  };
  function ScopedGraphicsContext() {
    this.r95_1 = null;
    this.s95_1 = null;
  }
  protoOf(ScopedGraphicsContext).t95 = function (value) {
    this.u95();
    this.s95_1 = value;
  };
  protoOf(ScopedGraphicsContext).m6z = function () {
    var gContext = this.s95_1;
    // Inline function 'androidx.compose.ui.internal.checkPrecondition' call
    if (!!(gContext == null)) {
      var tmp$ret$1 = 'GraphicsContext not provided';
      throwIllegalStateException(tmp$ret$1);
    }
    var layer = gContext.m6z();
    var layers = this.r95_1;
    if (layers == null) {
      // Inline function 'kotlin.also' call
      this.r95_1 = mutableObjectListOf(layer);
    } else {
      layers.j1(layer);
    }
    return layer;
  };
  protoOf(ScopedGraphicsContext).n6z = function (layer) {
    var tmp0_safe_receiver = this.s95_1;
    if (tmp0_safe_receiver == null)
      null;
    else {
      tmp0_safe_receiver.n6z(layer);
    }
  };
  protoOf(ScopedGraphicsContext).u95 = function () {
    var tmp0_safe_receiver = this.r95_1;
    if (tmp0_safe_receiver == null)
      null;
    else {
      // Inline function 'kotlin.let' call
      // Inline function 'androidx.collection.ObjectList.forEach' call
      // Inline function 'kotlin.contracts.contract' call
      var content = tmp0_safe_receiver.sz_1;
      var inductionVariable = 0;
      var last = tmp0_safe_receiver.tz_1;
      if (inductionVariable < last)
        do {
          var i = inductionVariable;
          inductionVariable = inductionVariable + 1 | 0;
          var layer = content[i];
          this.n6z(layer);
        }
         while (inductionVariable < last);
      tmp0_safe_receiver.c3();
    }
  };
  function DrawWithContentModifier(onDraw) {
    Node.call(this);
    this.o96_1 = onDraw;
  }
  protoOf(DrawWithContentModifier).h92 = function (_this__u8e3s4) {
    this.o96_1(_this__u8e3s4);
  };
  function DrawCacheModifier() {
  }
  function paint(_this__u8e3s4, painter, sizeToIntrinsics, alignment, contentScale, alpha, colorFilter) {
    sizeToIntrinsics = sizeToIntrinsics === VOID ? true : sizeToIntrinsics;
    alignment = alignment === VOID ? Companion_getInstance_25().o8t_1 : alignment;
    contentScale = contentScale === VOID ? Companion_getInstance_46().u96_1 : contentScale;
    alpha = alpha === VOID ? 1.0 : alpha;
    colorFilter = colorFilter === VOID ? null : colorFilter;
    return _this__u8e3s4.d8v(new PainterElement(painter, sizeToIntrinsics, alignment, contentScale, alpha, colorFilter));
  }
  function PainterElement(painter, sizeToIntrinsics, alignment, contentScale, alpha, colorFilter) {
    ModifierNodeElement.call(this);
    this.y96_1 = painter;
    this.z96_1 = sizeToIntrinsics;
    this.a97_1 = alignment;
    this.b97_1 = contentScale;
    this.c97_1 = alpha;
    this.d97_1 = colorFilter;
  }
  protoOf(PainterElement).r3d = function () {
    return new PainterNode(this.y96_1, this.z96_1, this.a97_1, this.b97_1, this.c97_1, this.d97_1);
  };
  protoOf(PainterElement).e97 = function (node) {
    var intrinsicsChanged = !(node.u97_1 === this.z96_1) || (this.z96_1 && !equals(node.t97_1.g6t(), this.y96_1.g6t()));
    node.t97_1 = this.y96_1;
    node.u97_1 = this.z96_1;
    node.v97_1 = this.a97_1;
    node.w97_1 = this.b97_1;
    node.x97_1 = this.c97_1;
    node.y97_1 = this.d97_1;
    if (intrinsicsChanged) {
      invalidateMeasurement(node);
    }
    invalidateDraw(node);
  };
  protoOf(PainterElement).d8y = function (node) {
    return this.e97(node instanceof PainterNode ? node : THROW_CCE());
  };
  protoOf(PainterElement).toString = function () {
    return 'PainterElement(painter=' + toString(this.y96_1) + ', sizeToIntrinsics=' + this.z96_1 + ', alignment=' + toString(this.a97_1) + ', contentScale=' + toString(this.b97_1) + ', alpha=' + this.c97_1 + ', colorFilter=' + toString_0(this.d97_1) + ')';
  };
  protoOf(PainterElement).hashCode = function () {
    var result = hashCode(this.y96_1);
    result = imul(result, 31) + getBooleanHashCode(this.z96_1) | 0;
    result = imul(result, 31) + hashCode(this.a97_1) | 0;
    result = imul(result, 31) + hashCode(this.b97_1) | 0;
    result = imul(result, 31) + getNumberHashCode(this.c97_1) | 0;
    result = imul(result, 31) + (this.d97_1 == null ? 0 : hashCode(this.d97_1)) | 0;
    return result;
  };
  protoOf(PainterElement).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof PainterElement))
      return false;
    if (!equals(this.y96_1, other.y96_1))
      return false;
    if (!(this.z96_1 === other.z96_1))
      return false;
    if (!equals(this.a97_1, other.a97_1))
      return false;
    if (!equals(this.b97_1, other.b97_1))
      return false;
    if (!equals(this.c97_1, other.c97_1))
      return false;
    if (!equals(this.d97_1, other.d97_1))
      return false;
    return true;
  };
  function _get_useIntrinsicSize__a0bws($this) {
    var tmp;
    if ($this.u97_1) {
      // Inline function 'androidx.compose.ui.geometry.isSpecified' call
      var this_0 = $this.t97_1.g6t();
      tmp = !equalsLong(_Size___get_packedValue__impl__7rlt1o(this_0), new Long(2143289344, 2143289344));
    } else {
      tmp = false;
    }
    return tmp;
  }
  function calculateScaledSize($this, dstSize) {
    var tmp;
    if (!_get_useIntrinsicSize__a0bws($this)) {
      tmp = dstSize;
    } else {
      var tmp_0;
      if (!hasSpecifiedAndFiniteWidth($this, $this.t97_1.g6t())) {
        // Inline function 'androidx.compose.ui.geometry.Size.width' call
        // Inline function 'androidx.compose.ui.util.unpackFloat1' call
        var value = _Size___get_packedValue__impl__7rlt1o(dstSize);
        // Inline function 'androidx.compose.ui.util.floatFromBits' call
        // Inline function 'kotlin.fromBits' call
        var bits = convertToInt(shiftRight(value, 32));
        tmp_0 = floatFromBits(bits);
      } else {
        // Inline function 'androidx.compose.ui.geometry.Size.width' call
        var this_0 = $this.t97_1.g6t();
        // Inline function 'androidx.compose.ui.util.unpackFloat1' call
        var value_0 = _Size___get_packedValue__impl__7rlt1o(this_0);
        // Inline function 'androidx.compose.ui.util.floatFromBits' call
        // Inline function 'kotlin.fromBits' call
        var bits_0 = convertToInt(shiftRight(value_0, 32));
        tmp_0 = floatFromBits(bits_0);
      }
      var srcWidth = tmp_0;
      var tmp_1;
      if (!hasSpecifiedAndFiniteHeight($this, $this.t97_1.g6t())) {
        // Inline function 'androidx.compose.ui.geometry.Size.height' call
        // Inline function 'androidx.compose.ui.util.unpackFloat2' call
        var value_1 = _Size___get_packedValue__impl__7rlt1o(dstSize);
        // Inline function 'androidx.compose.ui.util.floatFromBits' call
        // Inline function 'kotlin.fromBits' call
        var bits_1 = convertToInt(bitwiseAnd(value_1, new Long(-1, 0)));
        tmp_1 = floatFromBits(bits_1);
      } else {
        // Inline function 'androidx.compose.ui.geometry.Size.height' call
        var this_1 = $this.t97_1.g6t();
        // Inline function 'androidx.compose.ui.util.unpackFloat2' call
        var value_2 = _Size___get_packedValue__impl__7rlt1o(this_1);
        // Inline function 'androidx.compose.ui.util.floatFromBits' call
        // Inline function 'kotlin.fromBits' call
        var bits_2 = convertToInt(bitwiseAnd(value_2, new Long(-1, 0)));
        tmp_1 = floatFromBits(bits_2);
      }
      var srcHeight = tmp_1;
      // Inline function 'androidx.compose.ui.geometry.Size' call
      // Inline function 'androidx.compose.ui.util.packFloats' call
      var v1 = fromInt(toRawBits(srcWidth));
      var v2 = fromInt(toRawBits(srcHeight));
      var tmp$ret$17 = bitwiseOr(shiftLeft(v1, 32), bitwiseAnd(v2, new Long(-1, 0)));
      var srcSize = _Size___init__impl__aywn0g(tmp$ret$17);
      var tmp_2;
      var tmp_3;
      // Inline function 'androidx.compose.ui.geometry.Size.width' call
      // Inline function 'androidx.compose.ui.util.unpackFloat1' call
      var value_3 = _Size___get_packedValue__impl__7rlt1o(dstSize);
      // Inline function 'androidx.compose.ui.util.floatFromBits' call
      // Inline function 'kotlin.fromBits' call
      var bits_3 = convertToInt(shiftRight(value_3, 32));
      if (!(floatFromBits(bits_3) === 0.0)) {
        // Inline function 'androidx.compose.ui.geometry.Size.height' call
        // Inline function 'androidx.compose.ui.util.unpackFloat2' call
        var value_4 = _Size___get_packedValue__impl__7rlt1o(dstSize);
        // Inline function 'androidx.compose.ui.util.floatFromBits' call
        // Inline function 'kotlin.fromBits' call
        var bits_4 = convertToInt(bitwiseAnd(value_4, new Long(-1, 0)));
        tmp_3 = !(floatFromBits(bits_4) === 0.0);
      } else {
        tmp_3 = false;
      }
      if (tmp_3) {
        tmp_2 = times(srcSize, $this.w97_1.z97(srcSize, dstSize));
      } else {
        tmp_2 = Companion_getInstance_1().j5e_1;
      }
      tmp = tmp_2;
    }
    return tmp;
  }
  function modifyConstraints($this, constraints) {
    var hasBoundedDimens = _Constraints___get_hasBoundedWidth__impl__7hd0wr(constraints) && _Constraints___get_hasBoundedHeight__impl__bsh4rw(constraints);
    var hasFixedDimens = _Constraints___get_hasFixedWidth__impl__4p17wc(constraints) && _Constraints___get_hasFixedHeight__impl__y56fxx(constraints);
    if (!_get_useIntrinsicSize__a0bws($this) && hasBoundedDimens || hasFixedDimens) {
      return Constraints__copy$default_impl_f452rp(constraints, _Constraints___get_maxWidth__impl__uuyqc(constraints), VOID, _Constraints___get_maxHeight__impl__dt3e8z(constraints));
    }
    var intrinsicSize = $this.t97_1.g6t();
    var tmp;
    if (hasSpecifiedAndFiniteWidth($this, intrinsicSize)) {
      // Inline function 'androidx.compose.ui.geometry.Size.width' call
      // Inline function 'androidx.compose.ui.util.unpackFloat1' call
      var value = _Size___get_packedValue__impl__7rlt1o(intrinsicSize);
      // Inline function 'androidx.compose.ui.util.floatFromBits' call
      // Inline function 'kotlin.fromBits' call
      var bits = convertToInt(shiftRight(value, 32));
      // Inline function 'androidx.compose.ui.util.fastRoundToInt' call
      var this_0 = floatFromBits(bits);
      var tmp_0;
      if (isNaN_0(this_0)) {
        tmp_0 = 0;
      } else {
        // Inline function 'kotlin.math.roundToInt' call
        tmp_0 = roundToInt(this_0);
      }
      tmp = tmp_0;
    } else {
      tmp = _Constraints___get_minWidth__impl__hi9lfi(constraints);
    }
    var intrinsicWidth = tmp;
    var tmp_1;
    if (hasSpecifiedAndFiniteHeight($this, intrinsicSize)) {
      // Inline function 'androidx.compose.ui.geometry.Size.height' call
      // Inline function 'androidx.compose.ui.util.unpackFloat2' call
      var value_0 = _Size___get_packedValue__impl__7rlt1o(intrinsicSize);
      // Inline function 'androidx.compose.ui.util.floatFromBits' call
      // Inline function 'kotlin.fromBits' call
      var bits_0 = convertToInt(bitwiseAnd(value_0, new Long(-1, 0)));
      // Inline function 'androidx.compose.ui.util.fastRoundToInt' call
      var this_1 = floatFromBits(bits_0);
      var tmp_2;
      if (isNaN_0(this_1)) {
        tmp_2 = 0;
      } else {
        // Inline function 'kotlin.math.roundToInt' call
        tmp_2 = roundToInt(this_1);
      }
      tmp_1 = tmp_2;
    } else {
      tmp_1 = _Constraints___get_minHeight__impl__ev4bgx(constraints);
    }
    var intrinsicHeight = tmp_1;
    var constrainedWidth = constrainWidth(constraints, intrinsicWidth);
    var constrainedHeight = constrainHeight(constraints, intrinsicHeight);
    // Inline function 'androidx.compose.ui.geometry.Size' call
    // Inline function 'androidx.compose.ui.util.packFloats' call
    var v1 = fromInt(toRawBits(constrainedWidth));
    var v2 = fromInt(toRawBits(constrainedHeight));
    var tmp$ret$13 = bitwiseOr(shiftLeft(v1, 32), bitwiseAnd(v2, new Long(-1, 0)));
    var tmp$ret$12 = _Size___init__impl__aywn0g(tmp$ret$13);
    var scaledSize = calculateScaledSize($this, tmp$ret$12);
    // Inline function 'androidx.compose.ui.geometry.Size.width' call
    // Inline function 'androidx.compose.ui.util.unpackFloat1' call
    var value_1 = _Size___get_packedValue__impl__7rlt1o(scaledSize);
    // Inline function 'androidx.compose.ui.util.floatFromBits' call
    // Inline function 'kotlin.fromBits' call
    var bits_1 = convertToInt(shiftRight(value_1, 32));
    // Inline function 'androidx.compose.ui.util.fastRoundToInt' call
    var this_2 = floatFromBits(bits_1);
    var tmp_3;
    if (isNaN_0(this_2)) {
      tmp_3 = 0;
    } else {
      // Inline function 'kotlin.math.roundToInt' call
      tmp_3 = roundToInt(this_2);
    }
    var tmp$ret$18 = tmp_3;
    var minWidth = constrainWidth(constraints, tmp$ret$18);
    // Inline function 'androidx.compose.ui.geometry.Size.height' call
    // Inline function 'androidx.compose.ui.util.unpackFloat2' call
    var value_2 = _Size___get_packedValue__impl__7rlt1o(scaledSize);
    // Inline function 'androidx.compose.ui.util.floatFromBits' call
    // Inline function 'kotlin.fromBits' call
    var bits_2 = convertToInt(bitwiseAnd(value_2, new Long(-1, 0)));
    // Inline function 'androidx.compose.ui.util.fastRoundToInt' call
    var this_3 = floatFromBits(bits_2);
    var tmp_4;
    if (isNaN_0(this_3)) {
      tmp_4 = 0;
    } else {
      // Inline function 'kotlin.math.roundToInt' call
      tmp_4 = roundToInt(this_3);
    }
    var tmp$ret$24 = tmp_4;
    var minHeight = constrainHeight(constraints, tmp$ret$24);
    return Constraints__copy$default_impl_f452rp(constraints, minWidth, VOID, minHeight);
  }
  function hasSpecifiedAndFiniteWidth($this, $receiver) {
    var tmp;
    if (!equals($receiver, Companion_getInstance_1().k5e_1)) {
      // Inline function 'androidx.compose.ui.geometry.Size.width' call
      // Inline function 'androidx.compose.ui.util.unpackFloat1' call
      var value = _Size___get_packedValue__impl__7rlt1o($receiver);
      // Inline function 'androidx.compose.ui.util.floatFromBits' call
      // Inline function 'kotlin.fromBits' call
      var bits = convertToInt(shiftRight(value, 32));
      // Inline function 'androidx.compose.ui.util.fastIsFinite' call
      var this_0 = floatFromBits(bits);
      tmp = (toRawBits(this_0) & 2147483647) < 2139095040;
    } else {
      tmp = false;
    }
    return tmp;
  }
  function hasSpecifiedAndFiniteHeight($this, $receiver) {
    var tmp;
    if (!equals($receiver, Companion_getInstance_1().k5e_1)) {
      // Inline function 'androidx.compose.ui.geometry.Size.height' call
      // Inline function 'androidx.compose.ui.util.unpackFloat2' call
      var value = _Size___get_packedValue__impl__7rlt1o($receiver);
      // Inline function 'androidx.compose.ui.util.floatFromBits' call
      // Inline function 'kotlin.fromBits' call
      var bits = convertToInt(bitwiseAnd(value, new Long(-1, 0)));
      // Inline function 'androidx.compose.ui.util.fastIsFinite' call
      var this_0 = floatFromBits(bits);
      tmp = (toRawBits(this_0) & 2147483647) < 2139095040;
    } else {
      tmp = false;
    }
    return tmp;
  }
  function PainterNode$measure$lambda($placeable) {
    return function ($this$layout) {
      $this$layout.a98($placeable, 0, 0);
      return Unit_instance;
    };
  }
  function PainterNode(painter, sizeToIntrinsics, alignment, contentScale, alpha, colorFilter) {
    alignment = alignment === VOID ? Companion_getInstance_25().o8t_1 : alignment;
    contentScale = contentScale === VOID ? Companion_getInstance_46().u96_1 : contentScale;
    alpha = alpha === VOID ? 1.0 : alpha;
    colorFilter = colorFilter === VOID ? null : colorFilter;
    Node.call(this);
    this.t97_1 = painter;
    this.u97_1 = sizeToIntrinsics;
    this.v97_1 = alignment;
    this.w97_1 = contentScale;
    this.x97_1 = alpha;
    this.y97_1 = colorFilter;
  }
  protoOf(PainterNode).b8w = function () {
    return false;
  };
  protoOf(PainterNode).g8y = function (_this__u8e3s4, measurable, constraints) {
    var placeable = measurable.h8y(modifyConstraints(this, constraints));
    var tmp = placeable.i8y_1;
    var tmp_0 = placeable.j8y_1;
    return _this__u8e3s4.n8y(tmp, tmp_0, VOID, PainterNode$measure$lambda(placeable));
  };
  protoOf(PainterNode).o8y = function (_this__u8e3s4, measurable, height) {
    var tmp;
    if (_get_useIntrinsicSize__a0bws(this)) {
      var constraints = modifyConstraints(this, Constraints(VOID, VOID, VOID, height));
      var layoutWidth = measurable.b98(height);
      // Inline function 'kotlin.math.max' call
      var a = _Constraints___get_minWidth__impl__hi9lfi(constraints);
      tmp = Math.max(a, layoutWidth);
    } else {
      tmp = measurable.b98(height);
    }
    return tmp;
  };
  protoOf(PainterNode).q8y = function (_this__u8e3s4, measurable, height) {
    var tmp;
    if (_get_useIntrinsicSize__a0bws(this)) {
      var constraints = modifyConstraints(this, Constraints(VOID, VOID, VOID, height));
      var layoutWidth = measurable.c98(height);
      // Inline function 'kotlin.math.max' call
      var a = _Constraints___get_minWidth__impl__hi9lfi(constraints);
      tmp = Math.max(a, layoutWidth);
    } else {
      tmp = measurable.c98(height);
    }
    return tmp;
  };
  protoOf(PainterNode).p8y = function (_this__u8e3s4, measurable, width) {
    var tmp;
    if (_get_useIntrinsicSize__a0bws(this)) {
      var constraints = modifyConstraints(this, Constraints(VOID, width));
      var layoutHeight = measurable.d98(width);
      // Inline function 'kotlin.math.max' call
      var a = _Constraints___get_minHeight__impl__ev4bgx(constraints);
      tmp = Math.max(a, layoutHeight);
    } else {
      tmp = measurable.d98(width);
    }
    return tmp;
  };
  protoOf(PainterNode).r8y = function (_this__u8e3s4, measurable, width) {
    var tmp;
    if (_get_useIntrinsicSize__a0bws(this)) {
      var constraints = modifyConstraints(this, Constraints(VOID, width));
      var layoutHeight = measurable.e98(width);
      // Inline function 'kotlin.math.max' call
      var a = _Constraints___get_minHeight__impl__ev4bgx(constraints);
      tmp = Math.max(a, layoutHeight);
    } else {
      tmp = measurable.e98(width);
    }
    return tmp;
  };
  protoOf(PainterNode).h92 = function (_this__u8e3s4) {
    var intrinsicSize = this.t97_1.g6t();
    var tmp;
    if (hasSpecifiedAndFiniteWidth(this, intrinsicSize)) {
      // Inline function 'androidx.compose.ui.geometry.Size.width' call
      // Inline function 'androidx.compose.ui.util.unpackFloat1' call
      var value = _Size___get_packedValue__impl__7rlt1o(intrinsicSize);
      // Inline function 'androidx.compose.ui.util.floatFromBits' call
      // Inline function 'kotlin.fromBits' call
      var bits = convertToInt(shiftRight(value, 32));
      tmp = floatFromBits(bits);
    } else {
      // Inline function 'androidx.compose.ui.geometry.Size.width' call
      var this_0 = _this__u8e3s4.o5d();
      // Inline function 'androidx.compose.ui.util.unpackFloat1' call
      var value_0 = _Size___get_packedValue__impl__7rlt1o(this_0);
      // Inline function 'androidx.compose.ui.util.floatFromBits' call
      // Inline function 'kotlin.fromBits' call
      var bits_0 = convertToInt(shiftRight(value_0, 32));
      tmp = floatFromBits(bits_0);
    }
    var srcWidth = tmp;
    var tmp_0;
    if (hasSpecifiedAndFiniteHeight(this, intrinsicSize)) {
      // Inline function 'androidx.compose.ui.geometry.Size.height' call
      // Inline function 'androidx.compose.ui.util.unpackFloat2' call
      var value_1 = _Size___get_packedValue__impl__7rlt1o(intrinsicSize);
      // Inline function 'androidx.compose.ui.util.floatFromBits' call
      // Inline function 'kotlin.fromBits' call
      var bits_1 = convertToInt(bitwiseAnd(value_1, new Long(-1, 0)));
      tmp_0 = floatFromBits(bits_1);
    } else {
      // Inline function 'androidx.compose.ui.geometry.Size.height' call
      var this_1 = _this__u8e3s4.o5d();
      // Inline function 'androidx.compose.ui.util.unpackFloat2' call
      var value_2 = _Size___get_packedValue__impl__7rlt1o(this_1);
      // Inline function 'androidx.compose.ui.util.floatFromBits' call
      // Inline function 'kotlin.fromBits' call
      var bits_2 = convertToInt(bitwiseAnd(value_2, new Long(-1, 0)));
      tmp_0 = floatFromBits(bits_2);
    }
    var srcHeight = tmp_0;
    // Inline function 'androidx.compose.ui.geometry.Size' call
    // Inline function 'androidx.compose.ui.util.packFloats' call
    var v1 = fromInt(toRawBits(srcWidth));
    var v2 = fromInt(toRawBits(srcHeight));
    var tmp$ret$17 = bitwiseOr(shiftLeft(v1, 32), bitwiseAnd(v2, new Long(-1, 0)));
    var srcSize = _Size___init__impl__aywn0g(tmp$ret$17);
    var tmp_1;
    var tmp_2;
    // Inline function 'androidx.compose.ui.geometry.Size.width' call
    var this_2 = _this__u8e3s4.o5d();
    // Inline function 'androidx.compose.ui.util.unpackFloat1' call
    var value_3 = _Size___get_packedValue__impl__7rlt1o(this_2);
    // Inline function 'androidx.compose.ui.util.floatFromBits' call
    // Inline function 'kotlin.fromBits' call
    var bits_3 = convertToInt(shiftRight(value_3, 32));
    if (!(floatFromBits(bits_3) === 0.0)) {
      // Inline function 'androidx.compose.ui.geometry.Size.height' call
      var this_3 = _this__u8e3s4.o5d();
      // Inline function 'androidx.compose.ui.util.unpackFloat2' call
      var value_4 = _Size___get_packedValue__impl__7rlt1o(this_3);
      // Inline function 'androidx.compose.ui.util.floatFromBits' call
      // Inline function 'kotlin.fromBits' call
      var bits_4 = convertToInt(bitwiseAnd(value_4, new Long(-1, 0)));
      tmp_2 = !(floatFromBits(bits_4) === 0.0);
    } else {
      tmp_2 = false;
    }
    if (tmp_2) {
      tmp_1 = times(srcSize, this.w97_1.z97(srcSize, _this__u8e3s4.o5d()));
    } else {
      tmp_1 = Companion_getInstance_1().j5e_1;
    }
    var scaledSize = tmp_1;
    var tmp_3 = this.v97_1;
    // Inline function 'androidx.compose.ui.geometry.Size.width' call
    // Inline function 'androidx.compose.ui.util.unpackFloat1' call
    var value_5 = _Size___get_packedValue__impl__7rlt1o(scaledSize);
    // Inline function 'androidx.compose.ui.util.floatFromBits' call
    // Inline function 'kotlin.fromBits' call
    var bits_5 = convertToInt(shiftRight(value_5, 32));
    // Inline function 'androidx.compose.ui.util.fastRoundToInt' call
    var this_4 = floatFromBits(bits_5);
    var tmp_4;
    if (isNaN_0(this_4)) {
      tmp_4 = 0;
    } else {
      // Inline function 'kotlin.math.roundToInt' call
      tmp_4 = roundToInt(this_4);
    }
    var tmp0 = tmp_4;
    // Inline function 'androidx.compose.ui.geometry.Size.height' call
    // Inline function 'androidx.compose.ui.util.unpackFloat2' call
    var value_6 = _Size___get_packedValue__impl__7rlt1o(scaledSize);
    // Inline function 'androidx.compose.ui.util.floatFromBits' call
    // Inline function 'kotlin.fromBits' call
    var bits_6 = convertToInt(bitwiseAnd(value_6, new Long(-1, 0)));
    // Inline function 'androidx.compose.ui.util.fastRoundToInt' call
    var this_5 = floatFromBits(bits_6);
    var tmp_5;
    if (isNaN_0(this_5)) {
      tmp_5 = 0;
    } else {
      // Inline function 'kotlin.math.roundToInt' call
      tmp_5 = roundToInt(this_5);
    }
    // Inline function 'androidx.compose.ui.unit.IntSize' call
    // Inline function 'androidx.compose.ui.util.packInts' call
    var val2 = tmp_5;
    var tmp$ret$39 = bitwiseOr(shiftLeft(fromInt(tmp0), 32), bitwiseAnd(fromInt(val2), new Long(-1, 0)));
    var tmp_6 = _IntSize___init__impl__emcjft(tmp$ret$39);
    // Inline function 'androidx.compose.ui.geometry.Size.width' call
    var this_6 = _this__u8e3s4.o5d();
    // Inline function 'androidx.compose.ui.util.unpackFloat1' call
    var value_7 = _Size___get_packedValue__impl__7rlt1o(this_6);
    // Inline function 'androidx.compose.ui.util.floatFromBits' call
    // Inline function 'kotlin.fromBits' call
    var bits_7 = convertToInt(shiftRight(value_7, 32));
    // Inline function 'androidx.compose.ui.util.fastRoundToInt' call
    var this_7 = floatFromBits(bits_7);
    var tmp_7;
    if (isNaN_0(this_7)) {
      tmp_7 = 0;
    } else {
      // Inline function 'kotlin.math.roundToInt' call
      tmp_7 = roundToInt(this_7);
    }
    var tmp0_0 = tmp_7;
    // Inline function 'androidx.compose.ui.geometry.Size.height' call
    var this_8 = _this__u8e3s4.o5d();
    // Inline function 'androidx.compose.ui.util.unpackFloat2' call
    var value_8 = _Size___get_packedValue__impl__7rlt1o(this_8);
    // Inline function 'androidx.compose.ui.util.floatFromBits' call
    // Inline function 'kotlin.fromBits' call
    var bits_8 = convertToInt(bitwiseAnd(value_8, new Long(-1, 0)));
    // Inline function 'androidx.compose.ui.util.fastRoundToInt' call
    var this_9 = floatFromBits(bits_8);
    var tmp_8;
    if (isNaN_0(this_9)) {
      tmp_8 = 0;
    } else {
      // Inline function 'kotlin.math.roundToInt' call
      tmp_8 = roundToInt(this_9);
    }
    // Inline function 'androidx.compose.ui.unit.IntSize' call
    // Inline function 'androidx.compose.ui.util.packInts' call
    var val2_0 = tmp_8;
    var tmp$ret$53 = bitwiseOr(shiftLeft(fromInt(tmp0_0), 32), bitwiseAnd(fromInt(val2_0), new Long(-1, 0)));
    var tmp$ret$52 = _IntSize___init__impl__emcjft(tmp$ret$53);
    var alignedPosition = tmp_3.f8u(tmp_6, tmp$ret$52, _this__u8e3s4.r6p());
    var dx = _IntOffset___get_x__impl__qiqr5o(alignedPosition);
    var dy = _IntOffset___get_y__impl__2avpwj(alignedPosition);
    // Inline function 'androidx.compose.ui.graphics.drawscope.translate' call
    _this__u8e3s4.v6p().p6p().b5d(dx, dy);
    try {
      // Inline function 'kotlin.with' call
      this.t97_1.q6t(_this__u8e3s4, scaledSize, this.x97_1, this.y97_1);
    }finally {
      _this__u8e3s4.v6p().p6p().b5d(-dx, -dy);
    }
    _this__u8e3s4.z91();
  };
  protoOf(PainterNode).toString = function () {
    return 'PainterModifier(' + ('painter=' + toString(this.t97_1) + ', ') + ('sizeToIntrinsics=' + this.u97_1 + ', ') + ('alignment=' + toString(this.v97_1) + ', ') + ('alpha=' + this.x97_1 + ', ') + ('colorFilter=' + toString_0(this.y97_1) + ')');
  };
  function rotate(_this__u8e3s4, degrees) {
    return !(degrees === 0.0) ? graphicsLayer_0(_this__u8e3s4, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, degrees) : _this__u8e3s4;
  }
  function scale(_this__u8e3s4, scaleX, scaleY) {
    var tmp;
    if (!(scaleX === 1.0) || !(scaleY === 1.0)) {
      tmp = graphicsLayer_0(_this__u8e3s4, scaleX, scaleY);
    } else {
      tmp = _this__u8e3s4;
    }
    return tmp;
  }
  var androidx_compose_ui_draw_BlockDropShadowElement$stable;
  var androidx_compose_ui_draw_SimpleDropShadowElement$stable;
  var androidx_compose_ui_draw_SimpleDropShadowNode$stable;
  var androidx_compose_ui_draw_SimpleInnerShadowElement$stable;
  var androidx_compose_ui_draw_SimpleInnerShadowNode$stable;
  var androidx_compose_ui_draw_BlockInnerShadowElement$stable;
  var androidx_compose_ui_draw_BlockInnerShadowNode$stable;
  var androidx_compose_ui_draw_BlockDropShadowNode$stable;
  var androidx_compose_ui_draw_ShadowGraphicsLayerElement$stable;
  function shadow(_this__u8e3s4, elevation, shape, clip, ambientColor, spotColor) {
    shape = shape === VOID ? get_RectangleShape() : shape;
    var tmp;
    if (clip === VOID) {
      // Inline function 'androidx.compose.ui.unit.dp' call
      var tmp$ret$0 = _Dp___init__impl__ms3zkb(0);
      tmp = Dp__compareTo_impl_tlg3dl(elevation, tmp$ret$0) > 0;
    } else {
      tmp = clip;
    }
    clip = tmp;
    ambientColor = ambientColor === VOID ? get_DefaultShadowColor() : ambientColor;
    spotColor = spotColor === VOID ? get_DefaultShadowColor() : spotColor;
    var tmp_0;
    var tmp_1;
    // Inline function 'androidx.compose.ui.unit.dp' call
    var tmp$ret$1 = _Dp___init__impl__ms3zkb(0);
    if (Dp__compareTo_impl_tlg3dl(elevation, tmp$ret$1) > 0) {
      tmp_1 = true;
    } else {
      tmp_1 = clip;
    }
    if (tmp_1) {
      tmp_0 = _this__u8e3s4.d8v(new ShadowGraphicsLayerElement(elevation, shape, clip, ambientColor, spotColor));
    } else {
      tmp_0 = _this__u8e3s4;
    }
    return tmp_0;
  }
  function createBlock($this) {
    return ShadowGraphicsLayerElement$createBlock$lambda($this);
  }
  function ShadowGraphicsLayerElement$createBlock$lambda(this$0) {
    return function (_this__u8e3s4) {
      _this__u8e3s4.a67(_this__u8e3s4.v5e(this$0.g98_1));
      _this__u8e3s4.l98(this$0.h98_1);
      _this__u8e3s4.n67(this$0.i98_1);
      _this__u8e3s4.y6z(this$0.j98_1);
      _this__u8e3s4.z6z(this$0.k98_1);
      return Unit_instance;
    };
  }
  function ShadowGraphicsLayerElement(elevation, shape, clip, ambientColor, spotColor) {
    ModifierNodeElement.call(this);
    this.g98_1 = elevation;
    this.h98_1 = shape;
    this.i98_1 = clip;
    this.j98_1 = ambientColor;
    this.k98_1 = spotColor;
  }
  protoOf(ShadowGraphicsLayerElement).r3d = function () {
    return new BlockGraphicsLayerModifier(createBlock(this));
  };
  protoOf(ShadowGraphicsLayerElement).m98 = function (node) {
    node.b99_1 = createBlock(this);
    node.d99();
  };
  protoOf(ShadowGraphicsLayerElement).d8y = function (node) {
    return this.m98(node instanceof BlockGraphicsLayerModifier ? node : THROW_CCE());
  };
  protoOf(ShadowGraphicsLayerElement).toString = function () {
    return 'ShadowGraphicsLayerElement(elevation=' + Dp__toString_impl_kcddez(this.g98_1) + ', shape=' + toString(this.h98_1) + ', clip=' + this.i98_1 + ', ambientColor=' + Color__toString_impl_hpzmaq(this.j98_1) + ', spotColor=' + Color__toString_impl_hpzmaq(this.k98_1) + ')';
  };
  protoOf(ShadowGraphicsLayerElement).hashCode = function () {
    var result = Dp__hashCode_impl_sxkrra(this.g98_1);
    result = imul(result, 31) + hashCode(this.h98_1) | 0;
    result = imul(result, 31) + getBooleanHashCode(this.i98_1) | 0;
    result = imul(result, 31) + Color__hashCode_impl_vjyivj(this.j98_1) | 0;
    result = imul(result, 31) + Color__hashCode_impl_vjyivj(this.k98_1) | 0;
    return result;
  };
  protoOf(ShadowGraphicsLayerElement).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof ShadowGraphicsLayerElement))
      return false;
    if (!equals(this.g98_1, other.g98_1))
      return false;
    if (!equals(this.h98_1, other.h98_1))
      return false;
    if (!(this.i98_1 === other.i98_1))
      return false;
    if (!equals(this.j98_1, other.j98_1))
      return false;
    if (!equals(this.k98_1, other.k98_1))
      return false;
    return true;
  };
  function searchBeyondBounds(_this__u8e3s4, direction, block) {
    // Inline function 'androidx.compose.ui.node.Nodes.FocusTarget' call
    var tmp2 = _NodeKind___init__impl__ojsprp(1024);
    var tmp$ret$1;
    $l$block: {
      // Inline function 'androidx.compose.ui.node.nearestAncestor' call
      // Inline function 'androidx.compose.ui.node.visitAncestors' call
      // Inline function 'androidx.compose.ui.node.visitAncestors' call
      var mask = _NodeKind___get_mask__impl__1uopb6(tmp2);
      // Inline function 'androidx.compose.ui.internal.checkPrecondition' call
      if (!_this__u8e3s4.f4n().z8v_1) {
        var tmp$ret$5 = 'visitAncestors called on an unattached node';
        throwIllegalStateException(tmp$ret$5);
      }
      var node = false ? _this__u8e3s4.f4n() : _this__u8e3s4.f4n().q8v_1;
      var layout = requireLayoutNode(_this__u8e3s4);
      while (!(layout == null)) {
        var head = layout.d91_1.j99_1;
        if (!((head.p8v_1 & mask) === 0)) {
          while (!(node == null)) {
            if (!((node.o8v_1 & mask) === 0)) {
              // Inline function 'androidx.compose.ui.node.dispatchForKind' call
              var stack = null;
              var node_0 = node;
              $l$loop: while (!(node_0 == null)) {
                var tmp;
                if (node_0 instanceof FocusTargetNode) {
                  tmp$ret$1 = node_0;
                  break $l$block;
                } else {
                  tmp = true;
                }
                var dispatchAgain = tmp;
                var tmp_0;
                var tmp_1;
                if (dispatchAgain || false) {
                  // Inline function 'androidx.compose.ui.Node.isKind' call
                  tmp_1 = !((node_0.o8v_1 & _NodeKind___get_mask__impl__1uopb6(tmp2)) === 0);
                } else {
                  tmp_1 = false;
                }
                if (tmp_1) {
                  tmp_0 = node_0 instanceof DelegatingNode;
                } else {
                  tmp_0 = false;
                }
                if (tmp_0) {
                  var count = 0;
                  // Inline function 'androidx.compose.ui.node.DelegatingNode.forEachImmediateDelegate' call
                  var node_1 = node_0.e9a_1;
                  while (!(node_1 == null)) {
                    var next = node_1;
                    // Inline function 'androidx.compose.ui.Node.isKind' call
                    if (!((next.o8v_1 & _NodeKind___get_mask__impl__1uopb6(tmp2)) === 0)) {
                      count = count + 1 | 0;
                      if (count === 1) {
                        node_0 = next;
                      } else {
                        var tmp0_elvis_lhs = stack;
                        var tmp_2;
                        if (tmp0_elvis_lhs == null) {
                          // Inline function 'androidx.compose.runtime.collection.mutableVectorOf' call
                          // Inline function 'androidx.compose.runtime.collection.MutableVector' call
                          // Inline function 'kotlin.arrayOfNulls' call
                          var tmp$ret$15 = Array(16);
                          tmp_2 = new MutableVector(tmp$ret$15, 0);
                        } else {
                          tmp_2 = tmp0_elvis_lhs;
                        }
                        stack = tmp_2;
                        var theNode = node_0;
                        if (!(theNode == null)) {
                          var tmp1_safe_receiver = stack;
                          if (tmp1_safe_receiver == null)
                            null;
                          else
                            tmp1_safe_receiver.zz(theNode);
                          node_0 = null;
                        }
                        var tmp2_safe_receiver = stack;
                        if (tmp2_safe_receiver == null)
                          null;
                        else
                          tmp2_safe_receiver.zz(next);
                      }
                    }
                    node_1 = node_1.r8v_1;
                  }
                  if (count === 1) {
                    continue $l$loop;
                  }
                }
                node_0 = access$pop$tDelegatableNodeKt(stack);
              }
            }
            node = node.q8v_1;
          }
        }
        layout = layout.f9a();
        var tmp0_safe_receiver = layout;
        var tmp1_safe_receiver_0 = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.d91_1;
        node = tmp1_safe_receiver_0 == null ? null : tmp1_safe_receiver_0.i99_1;
      }
      tmp$ret$1 = null;
    }
    var tmp0_safe_receiver_0 = tmp$ret$1;
    if (tmp0_safe_receiver_0 == null)
      null;
    else {
      // Inline function 'kotlin.let' call
      if (equals(tmp0_safe_receiver_0.d9b(), _this__u8e3s4.d9b())) {
        return null;
      }
    }
    var tmp1_safe_receiver_1 = _this__u8e3s4.d9b();
    var tmp_3;
    if (tmp1_safe_receiver_1 == null) {
      tmp_3 = null;
    } else {
      var tmp_4;
      if (direction === Companion_getInstance_30().o9b_1) {
        tmp_4 = Companion_getInstance_45().i9b_1;
      } else if (direction === Companion_getInstance_30().p9b_1) {
        tmp_4 = Companion_getInstance_45().j9b_1;
      } else if (direction === Companion_getInstance_30().m9b_1) {
        tmp_4 = Companion_getInstance_45().g9b_1;
      } else if (direction === Companion_getInstance_30().n9b_1) {
        tmp_4 = Companion_getInstance_45().h9b_1;
      } else if (direction === Companion_getInstance_30().k9b_1) {
        tmp_4 = Companion_getInstance_45().f9b_1;
      } else if (direction === Companion_getInstance_30().l9b_1) {
        tmp_4 = Companion_getInstance_45().e9b_1;
      } else {
        // Inline function 'kotlin.error' call
        var message = 'Unsupported direction for beyond bounds layout';
        throw IllegalStateException_init_$Create$(toString(message));
      }
      tmp_3 = tmp1_safe_receiver_1.s9b(tmp_4, block);
    }
    return tmp_3;
  }
  function onFocusChanged(_this__u8e3s4, onFocusChanged) {
    return _this__u8e3s4.d8v(new FocusChangedElement(onFocusChanged));
  }
  function FocusChangedElement(onFocusChanged) {
    ModifierNodeElement.call(this);
    this.u9b_1 = onFocusChanged;
  }
  protoOf(FocusChangedElement).r3d = function () {
    return new FocusChangedNode(this.u9b_1);
  };
  protoOf(FocusChangedElement).v9b = function (node) {
    node.k9c_1 = this.u9b_1;
  };
  protoOf(FocusChangedElement).d8y = function (node) {
    return this.v9b(node instanceof FocusChangedNode ? node : THROW_CCE());
  };
  protoOf(FocusChangedElement).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof FocusChangedElement))
      return false;
    if (!(this.u9b_1 === other.u9b_1))
      return false;
    return true;
  };
  protoOf(FocusChangedElement).hashCode = function () {
    return hashCode(this.u9b_1);
  };
  function FocusChangedNode(onFocusChanged) {
    Node.call(this);
    this.k9c_1 = onFocusChanged;
    this.l9c_1 = null;
  }
  protoOf(FocusChangedNode).m9c = function (focusState) {
    if (!equals(this.l9c_1, focusState)) {
      this.l9c_1 = focusState;
      this.k9c_1(focusState);
    }
  };
  function _FocusDirection___init__impl__7vv8u2(value) {
    return value;
  }
  function FocusDirection__toString_impl_h9c1oa($this) {
    return $this === Companion_getInstance_30().k9b_1 ? 'Next' : $this === Companion_getInstance_30().l9b_1 ? 'Previous' : $this === Companion_getInstance_30().m9b_1 ? 'Left' : $this === Companion_getInstance_30().n9b_1 ? 'Right' : $this === Companion_getInstance_30().o9b_1 ? 'Up' : $this === Companion_getInstance_30().p9b_1 ? 'Down' : $this === Companion_getInstance_30().q9b_1 ? 'Enter' : $this === Companion_getInstance_30().r9b_1 ? 'Exit' : 'Invalid FocusDirection';
  }
  function Companion_4() {
    Companion_instance_9 = this;
    this.k9b_1 = _FocusDirection___init__impl__7vv8u2(1);
    this.l9b_1 = _FocusDirection___init__impl__7vv8u2(2);
    this.m9b_1 = _FocusDirection___init__impl__7vv8u2(3);
    this.n9b_1 = _FocusDirection___init__impl__7vv8u2(4);
    this.o9b_1 = _FocusDirection___init__impl__7vv8u2(5);
    this.p9b_1 = _FocusDirection___init__impl__7vv8u2(6);
    this.q9b_1 = _FocusDirection___init__impl__7vv8u2(7);
    this.r9b_1 = _FocusDirection___init__impl__7vv8u2(8);
  }
  var Companion_instance_9;
  function Companion_getInstance_30() {
    if (Companion_instance_9 == null)
      new Companion_4();
    return Companion_instance_9;
  }
  function FocusDirection__hashCode_impl_4htv4l($this) {
    return $this;
  }
  function FocusDirection__equals_impl_wfq8xl($this, other) {
    if (!(other instanceof FocusDirection))
      return false;
    if (!($this === other.n9c_1))
      return false;
    return true;
  }
  function FocusDirection(value) {
    Companion_getInstance_30();
    this.n9c_1 = value;
  }
  protoOf(FocusDirection).toString = function () {
    return FocusDirection__toString_impl_h9c1oa(this.n9c_1);
  };
  protoOf(FocusDirection).hashCode = function () {
    return FocusDirection__hashCode_impl_4htv4l(this.n9c_1);
  };
  protoOf(FocusDirection).equals = function (other) {
    return FocusDirection__equals_impl_wfq8xl(this.n9c_1, other);
  };
  function FocusEventModifier() {
  }
  function FocusEventModifierNode() {
  }
  function invalidateFocusEvent(_this__u8e3s4) {
    requireOwner(_this__u8e3s4).o9c().p9c(_this__u8e3s4);
  }
  var androidx_compose_ui_focus_FocusInvalidationManager$stable;
  function invalidateNodes($this) {
    var activeFocusTargetNode = $this.q9c_1.v9c();
    if (activeFocusTargetNode == null) {
      // Inline function 'androidx.collection.ScatterSet.forEach' call
      var this_0 = $this.t9c_1;
      // Inline function 'kotlin.contracts.contract' call
      var elements = this_0.k16_1;
      $l$block: {
        // Inline function 'androidx.collection.ScatterSet.forEachIndex' call
        // Inline function 'kotlin.contracts.contract' call
        var m = this_0.j16_1;
        var lastIndex = m.length - 2 | 0;
        var inductionVariable = 0;
        if (inductionVariable <= lastIndex)
          do {
            var i = inductionVariable;
            inductionVariable = inductionVariable + 1 | 0;
            var slot = m[i];
            // Inline function 'androidx.collection.maskEmptyOrDeleted' call
            var this_1 = slot;
            var tmp$ret$4 = bitwiseAnd(bitwiseAnd(this_1, shiftLeft(invert(this_1), 7)), new Long(-2139062144, -2139062144));
            if (!equalsLong(tmp$ret$4, new Long(-2139062144, -2139062144))) {
              var bitCount = 8 - (~(i - lastIndex | 0) >>> 31 | 0) | 0;
              var inductionVariable_0 = 0;
              if (inductionVariable_0 < bitCount)
                do {
                  var j = inductionVariable_0;
                  inductionVariable_0 = inductionVariable_0 + 1 | 0;
                  // Inline function 'androidx.collection.isFull' call
                  var value = bitwiseAnd(slot, new Long(255, 0));
                  if (compare(value, new Long(128, 0)) < 0) {
                    var index = (i << 3) + j | 0;
                    elements[index].m9c(FocusStateImpl_Inactive_getInstance());
                  }
                  slot = shiftRight(slot, 8);
                }
                 while (inductionVariable_0 < bitCount);
              if (!(bitCount === 8)) {
                break $l$block;
              }
            }
          }
           while (!(i === lastIndex));
      }
    } else if (activeFocusTargetNode.z8v_1) {
      if ($this.s9c_1.m1(activeFocusTargetNode)) {
        activeFocusTargetNode.w9c();
      }
      var activeFocusTargetNodeState = activeFocusTargetNode.x9c();
      var traversedFocusTargetCount = 0;
      // Inline function 'androidx.compose.ui.node.Nodes.FocusTarget' call
      var tmp0 = _NodeKind___init__impl__ojsprp(1024);
      // Inline function 'androidx.compose.ui.node.Nodes.FocusEvent' call
      // Inline function 'androidx.compose.ui.node.NodeKind.or' call
      var other = _NodeKind___init__impl__ojsprp(4096);
      // Inline function 'androidx.compose.ui.node.visitAncestors' call
      var mask = _NodeKind___get_mask__impl__1uopb6(tmp0) | _NodeKind___get_mask__impl__1uopb6(other);
      // Inline function 'androidx.compose.ui.internal.checkPrecondition' call
      if (!activeFocusTargetNode.f4n().z8v_1) {
        var tmp$ret$13 = 'visitAncestors called on an unattached node';
        throwIllegalStateException(tmp$ret$13);
      }
      var node = true ? activeFocusTargetNode.f4n() : activeFocusTargetNode.f4n().q8v_1;
      var layout = requireLayoutNode(activeFocusTargetNode);
      while (!(layout == null)) {
        var head = layout.d91_1.j99_1;
        if (!((head.p8v_1 & mask) === 0)) {
          while (!(node == null)) {
            if (!((node.o8v_1 & mask) === 0)) {
              var tmp0_0 = node;
              $l$block_0: {
                // Inline function 'androidx.compose.ui.node.Nodes.FocusTarget' call
                // Inline function 'androidx.compose.ui.Node.isKind' call
                var kind = _NodeKind___init__impl__ojsprp(1024);
                if (!((tmp0_0.o8v_1 & _NodeKind___get_mask__impl__1uopb6(kind)) === 0)) {
                  traversedFocusTargetCount = traversedFocusTargetCount + 1 | 0;
                }
                var tmp;
                if (!isInterface(tmp0_0, FocusEventModifierNode)) {
                  tmp = true;
                } else {
                  tmp = !$this.t9c_1.m1(tmp0_0);
                }
                if (tmp) {
                  break $l$block_0;
                }
                if (traversedFocusTargetCount <= 1) {
                  tmp0_0.m9c(activeFocusTargetNodeState);
                } else {
                  tmp0_0.m9c(FocusStateImpl_ActiveParent_getInstance());
                }
                $this.t9c_1.d3(tmp0_0);
              }
            }
            node = node.q8v_1;
          }
        }
        layout = layout.f9a();
        var tmp0_safe_receiver = layout;
        var tmp1_safe_receiver = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.d91_1;
        node = tmp1_safe_receiver == null ? null : tmp1_safe_receiver.i99_1;
      }
      // Inline function 'androidx.collection.ScatterSet.forEach' call
      var this_2 = $this.t9c_1;
      // Inline function 'kotlin.contracts.contract' call
      var elements_0 = this_2.k16_1;
      $l$block_1: {
        // Inline function 'androidx.collection.ScatterSet.forEachIndex' call
        // Inline function 'kotlin.contracts.contract' call
        var m_0 = this_2.j16_1;
        var lastIndex_0 = m_0.length - 2 | 0;
        var inductionVariable_1 = 0;
        if (inductionVariable_1 <= lastIndex_0)
          do {
            var i_0 = inductionVariable_1;
            inductionVariable_1 = inductionVariable_1 + 1 | 0;
            var slot_0 = m_0[i_0];
            // Inline function 'androidx.collection.maskEmptyOrDeleted' call
            var this_3 = slot_0;
            var tmp$ret$21 = bitwiseAnd(bitwiseAnd(this_3, shiftLeft(invert(this_3), 7)), new Long(-2139062144, -2139062144));
            if (!equalsLong(tmp$ret$21, new Long(-2139062144, -2139062144))) {
              var bitCount_0 = 8 - (~(i_0 - lastIndex_0 | 0) >>> 31 | 0) | 0;
              var inductionVariable_2 = 0;
              if (inductionVariable_2 < bitCount_0)
                do {
                  var j_0 = inductionVariable_2;
                  inductionVariable_2 = inductionVariable_2 + 1 | 0;
                  // Inline function 'androidx.collection.isFull' call
                  var value_0 = bitwiseAnd(slot_0, new Long(255, 0));
                  if (compare(value_0, new Long(128, 0)) < 0) {
                    var index_0 = (i_0 << 3) + j_0 | 0;
                    elements_0[index_0].m9c(FocusStateImpl_Inactive_getInstance());
                  }
                  slot_0 = shiftRight(slot_0, 8);
                }
                 while (inductionVariable_2 < bitCount_0);
              if (!(bitCount_0 === 8)) {
                break $l$block_1;
              }
            }
          }
           while (!(i_0 === lastIndex_0));
      }
    }
    invalidateOwnerFocusState($this);
    $this.s9c_1.c3();
    $this.t9c_1.c3();
    $this.u9c_1 = false;
  }
  function invalidateOwnerFocusState($this) {
    if ($this.q9c_1.v9c() == null || equals($this.q9c_1.z9c(), FocusStateImpl_Inactive_getInstance())) {
      $this.q9c_1.y9c();
    }
  }
  function FocusInvalidationManager$invalidateNodes$ref(p0) {
    return constructCallableReference(function () {
      var tmp0 = p0;
      invalidateNodes(tmp0);
      return Unit_instance;
    }, 0, 0, 46, 'invalidateNodes', [p0]);
  }
  function FocusInvalidationManager(focusOwner, owner) {
    this.q9c_1 = focusOwner;
    this.r9c_1 = owner;
    this.s9c_1 = mutableScatterSetOf();
    this.t9c_1 = mutableScatterSetOf();
    this.u9c_1 = false;
  }
  protoOf(FocusInvalidationManager).a9d = function (node) {
    if (this.s9c_1.j1(node)) {
      this.b9d();
    }
  };
  protoOf(FocusInvalidationManager).p9c = function (node) {
    if (this.t9c_1.j1(node)) {
      this.b9d();
    }
  };
  protoOf(FocusInvalidationManager).b9d = function () {
    if (!this.u9c_1) {
      this.r9c_1.l8w(FocusInvalidationManager$invalidateNodes$ref(this));
      this.u9c_1 = true;
    }
  };
  protoOf(FocusInvalidationManager).c9d = function () {
    return this.u9c_1;
  };
  function FocusManager() {
  }
  var androidx_compose_ui_focus_FocusOrder$stable;
  var androidx_compose_ui_focus_FocusOrderToProperties$stable;
  function FocusPropertiesScope() {
  }
  function FocusOrderModifier() {
  }
  function FocusOrder_init_$Init$($this) {
    FocusOrder.call($this, new FocusPropertiesImpl());
    return $this;
  }
  function FocusOrder_init_$Create$() {
    return FocusOrder_init_$Init$(objectCreate(protoOf(FocusOrder)));
  }
  function FocusOrder(focusProperties) {
    this.i9d_1 = focusProperties;
  }
  function FocusOwner$dispatchKeyEvent$lambda() {
    return false;
  }
  function FocusOwner() {
  }
  var androidx_compose_ui_focus_FocusOwnerImpl$stable;
  function clearFocus($this, forced, refreshFocusEvents) {
    forced = forced === VOID ? false : forced;
    if ($this.v9c() == null)
      return true;
    if ($this.a9e_1 && !forced) {
      return false;
    }
    var previousActiveFocusTargetNode = $this.v9c();
    $this.q9d(null);
    if (refreshFocusEvents && !(previousActiveFocusTargetNode == null)) {
      previousActiveFocusTargetNode.b9e($this.a9e_1 ? FocusStateImpl_Captured_getInstance() : FocusStateImpl_Active_getInstance(), FocusStateImpl_Inactive_getInstance());
      // Inline function 'androidx.compose.ui.node.Nodes.FocusTarget' call
      // Inline function 'androidx.compose.ui.node.visitAncestors' call
      var type = _NodeKind___init__impl__ojsprp(1024);
      // Inline function 'androidx.compose.ui.node.visitAncestors' call
      var mask = _NodeKind___get_mask__impl__1uopb6(type);
      // Inline function 'androidx.compose.ui.internal.checkPrecondition' call
      if (!previousActiveFocusTargetNode.f4n().z8v_1) {
        var tmp$ret$4 = 'visitAncestors called on an unattached node';
        throwIllegalStateException(tmp$ret$4);
      }
      var node = false ? previousActiveFocusTargetNode.f4n() : previousActiveFocusTargetNode.f4n().q8v_1;
      var layout = requireLayoutNode(previousActiveFocusTargetNode);
      while (!(layout == null)) {
        var head = layout.d91_1.j99_1;
        if (!((head.p8v_1 & mask) === 0)) {
          while (!(node == null)) {
            if (!((node.o8v_1 & mask) === 0)) {
              // Inline function 'androidx.compose.ui.node.dispatchForKind' call
              var stack = null;
              var node_0 = node;
              $l$loop: while (!(node_0 == null)) {
                var tmp;
                if (node_0 instanceof FocusTargetNode) {
                  node_0.b9e(FocusStateImpl_ActiveParent_getInstance(), FocusStateImpl_Inactive_getInstance());
                  tmp = false;
                } else {
                  tmp = true;
                }
                var dispatchAgain = tmp;
                var tmp_0;
                var tmp_1;
                if (dispatchAgain || false) {
                  // Inline function 'androidx.compose.ui.Node.isKind' call
                  tmp_1 = !((node_0.o8v_1 & _NodeKind___get_mask__impl__1uopb6(type)) === 0);
                } else {
                  tmp_1 = false;
                }
                if (tmp_1) {
                  tmp_0 = node_0 instanceof DelegatingNode;
                } else {
                  tmp_0 = false;
                }
                if (tmp_0) {
                  var count = 0;
                  // Inline function 'androidx.compose.ui.node.DelegatingNode.forEachImmediateDelegate' call
                  var node_1 = node_0.e9a_1;
                  while (!(node_1 == null)) {
                    var next = node_1;
                    // Inline function 'androidx.compose.ui.Node.isKind' call
                    if (!((next.o8v_1 & _NodeKind___get_mask__impl__1uopb6(type)) === 0)) {
                      count = count + 1 | 0;
                      if (count === 1) {
                        node_0 = next;
                      } else {
                        var tmp0_elvis_lhs = stack;
                        var tmp_2;
                        if (tmp0_elvis_lhs == null) {
                          // Inline function 'androidx.compose.runtime.collection.mutableVectorOf' call
                          // Inline function 'androidx.compose.runtime.collection.MutableVector' call
                          // Inline function 'kotlin.arrayOfNulls' call
                          var tmp$ret$14 = Array(16);
                          tmp_2 = new MutableVector(tmp$ret$14, 0);
                        } else {
                          tmp_2 = tmp0_elvis_lhs;
                        }
                        stack = tmp_2;
                        var theNode = node_0;
                        if (!(theNode == null)) {
                          var tmp1_safe_receiver = stack;
                          if (tmp1_safe_receiver == null)
                            null;
                          else
                            tmp1_safe_receiver.zz(theNode);
                          node_0 = null;
                        }
                        var tmp2_safe_receiver = stack;
                        if (tmp2_safe_receiver == null)
                          null;
                        else
                          tmp2_safe_receiver.zz(next);
                      }
                    }
                    node_1 = node_1.r8v_1;
                  }
                  if (count === 1) {
                    continue $l$loop;
                  }
                }
                node_0 = access$pop$tDelegatableNodeKt(stack);
              }
            }
            node = node.q8v_1;
          }
        }
        layout = layout.f9a();
        var tmp0_safe_receiver = layout;
        var tmp1_safe_receiver_0 = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.d91_1;
        node = tmp1_safe_receiver_0 == null ? null : tmp1_safe_receiver_0.i99_1;
      }
    }
    return true;
  }
  function findFocusTargetNode($this) {
    return findActiveFocusNode($this.u9d_1);
  }
  function lastLocalKeyInputNode($this, $receiver) {
    var focusedKeyInputNode = null;
    // Inline function 'androidx.compose.ui.node.Nodes.FocusTarget' call
    var tmp0 = _NodeKind___init__impl__ojsprp(1024);
    // Inline function 'androidx.compose.ui.node.Nodes.KeyInput' call
    // Inline function 'androidx.compose.ui.node.NodeKind.or' call
    var other = _NodeKind___init__impl__ojsprp(8192);
    // Inline function 'androidx.compose.ui.node.visitLocalDescendants' call
    var tmp2 = _NodeKind___get_mask__impl__1uopb6(tmp0) | _NodeKind___get_mask__impl__1uopb6(other);
    $l$block: {
      // Inline function 'androidx.compose.ui.node.visitLocalDescendants' call
      // Inline function 'androidx.compose.ui.internal.checkPrecondition' call
      if (!$receiver.f4n().z8v_1) {
        var tmp$ret$6 = 'visitLocalDescendants called on an unattached node';
        throwIllegalStateException(tmp$ret$6);
      }
      var self_0 = $receiver.f4n();
      if ((self_0.p8v_1 & tmp2) === 0) {
        break $l$block;
      }
      var next = false ? self_0 : self_0.r8v_1;
      while (!(next == null)) {
        if (!((next.o8v_1 & tmp2) === 0)) {
          var modifierNode = next;
          // Inline function 'androidx.compose.ui.node.Nodes.FocusTarget' call
          // Inline function 'androidx.compose.ui.Node.isKind' call
          var kind = _NodeKind___init__impl__ojsprp(1024);
          if (!((modifierNode.o8v_1 & _NodeKind___get_mask__impl__1uopb6(kind)) === 0))
            return focusedKeyInputNode;
          focusedKeyInputNode = modifierNode;
        }
        next = next.r8v_1;
      }
    }
    return focusedKeyInputNode;
  }
  function validateKeyEvent($this, keyEvent) {
    var keyCode = _Key___get_keyCode__impl__ymzu5v(get_key_0(keyEvent));
    var tmp0_subject = get_type(keyEvent);
    if (tmp0_subject === Companion_getInstance_39().e9e_1) {
      var tmp1_elvis_lhs = $this.x9d_1;
      var tmp;
      if (tmp1_elvis_lhs == null) {
        // Inline function 'kotlin.also' call
        var this_0 = new MutableLongSet(3);
        $this.x9d_1 = this_0;
        tmp = this_0;
      } else {
        tmp = tmp1_elvis_lhs;
      }
      var keysCurrentlyDown = tmp;
      keysCurrentlyDown.wx(keyCode);
    } else if (tmp0_subject === Companion_getInstance_39().d9e_1) {
      var tmp2_safe_receiver = $this.x9d_1;
      if (!((tmp2_safe_receiver == null ? null : tmp2_safe_receiver.lm(keyCode)) === true)) {
        return false;
      }
      var tmp3_safe_receiver = $this.x9d_1;
      if (tmp3_safe_receiver == null)
        null;
      else
        tmp3_safe_receiver.kx(keyCode);
    }
    return true;
  }
  function FocusOwnerImpl$modifier$1(this$0) {
    this.g9e_1 = this$0;
    ModifierNodeElement.call(this);
  }
  protoOf(FocusOwnerImpl$modifier$1).r3d = function () {
    return this.g9e_1.u9d_1;
  };
  protoOf(FocusOwnerImpl$modifier$1).h9e = function (node) {
  };
  protoOf(FocusOwnerImpl$modifier$1).d8y = function (node) {
    return this.h9e(node instanceof FocusTargetNode ? node : THROW_CCE());
  };
  protoOf(FocusOwnerImpl$modifier$1).hashCode = function () {
    return hashCode(this.g9e_1.u9d_1);
  };
  protoOf(FocusOwnerImpl$modifier$1).equals = function (other) {
    return other === this;
  };
  function FocusOwnerImpl$takeFocus$lambda($focusDirection) {
    return function (it) {
      return it.i9e($focusDirection);
    };
  }
  function FocusOwnerImpl$moveFocus$lambda($requestFocusSuccess, $focusDirection) {
    return function (it) {
      $requestFocusSuccess._v = it.i9e($focusDirection);
      return $requestFocusSuccess._v;
    };
  }
  function FocusOwnerImpl$focusSearch$lambda($source, this$0, $onFound) {
    return function (it) {
      var tmp;
      if (equals(it, $source)) {
        tmp = false;
      } else if (equals(it, this$0.u9d_1)) {
        // Inline function 'kotlin.error' call
        var message = 'Focus search landed at the root.';
        throw IllegalStateException_init_$Create$(toString(message));
      } else {
        tmp = $onFound(it);
      }
      return tmp;
    };
  }
  function FocusOwnerImpl(platformFocusOwner, owner) {
    this.s9d_1 = platformFocusOwner;
    this.t9d_1 = owner;
    this.u9d_1 = new FocusTargetNode(Companion_getInstance_33().l9e_1);
    this.v9d_1 = new FocusInvalidationManager(this, this.t9d_1);
    var tmp = this;
    tmp.w9d_1 = new FocusOwnerImpl$modifier$1(this);
    this.x9d_1 = null;
    this.y9d_1 = new MutableObjectList(1);
    this.z9d_1 = null;
    this.a9e_1 = false;
  }
  protoOf(FocusOwnerImpl).j9d = function () {
    return this.w9d_1;
  };
  protoOf(FocusOwnerImpl).k9d = function (focusDirection, previouslyFocusedRect) {
    return this.s9d_1.k9d(focusDirection, previouslyFocusedRect);
  };
  protoOf(FocusOwnerImpl).m9e = function (focusDirection, previouslyFocusedRect) {
    var tmp0_elvis_lhs = this.n9e(focusDirection, previouslyFocusedRect, FocusOwnerImpl$takeFocus$lambda(focusDirection));
    return tmp0_elvis_lhs == null ? false : tmp0_elvis_lhs;
  };
  protoOf(FocusOwnerImpl).y9c = function () {
    this.s9d_1.y9c();
  };
  protoOf(FocusOwnerImpl).d9d = function (force) {
    this.l9d(force, true, true, Companion_getInstance_30().r9b_1);
  };
  protoOf(FocusOwnerImpl).l9d = function (force, refreshFocusEvents, clearOwnerFocus, focusDirection) {
    var tmp;
    if (!force) {
      var tmp_0;
      switch (performCustomClearFocus(this.u9d_1, focusDirection).a1_1) {
        case 2:
        case 1:
        case 3:
          tmp_0 = false;
          break;
        case 0:
          tmp_0 = clearFocus(this, force, refreshFocusEvents);
          break;
        default:
          noWhenBranchMatchedException();
          break;
      }
      tmp = tmp_0;
    } else {
      tmp = clearFocus(this, force, refreshFocusEvents);
    }
    var clearedFocusSuccessfully = tmp;
    if (clearedFocusSuccessfully && clearOwnerFocus) {
      this.y9c();
    }
    return clearedFocusSuccessfully;
  };
  protoOf(FocusOwnerImpl).f9d = function (focusDirection) {
    return this.o9e(focusDirection, true);
  };
  protoOf(FocusOwnerImpl).o9e = function (focusDirection, wrapAroundForOneDimensionalFocus) {
    var tmp;
    if (ComposeUiFlags_instance.r8u_1) {
      tmp = true;
    } else {
      var tmp_0;
      if (ComposeUiFlags_instance.s8u_1) {
        var tmp0_safe_receiver = this.v9c();
        tmp_0 = (tmp0_safe_receiver == null ? null : tmp0_safe_receiver.u9a_1) === true;
      } else {
        tmp_0 = false;
      }
      tmp = tmp_0;
    }
    if (tmp) {
      if (this.s9d_1.p9e(focusDirection)) {
        return true;
      }
    }
    var requestFocusSuccess = {_v: false};
    var activeNodeBefore = this.v9c();
    var tmp_1 = this.s9d_1.q9e();
    var focusSearchSuccess = this.n9e(focusDirection, tmp_1, FocusOwnerImpl$moveFocus$lambda(requestFocusSuccess, focusDirection));
    if (focusSearchSuccess === true && !(activeNodeBefore === this.v9c())) {
      return true;
    }
    if (focusSearchSuccess == null || requestFocusSuccess._v == null)
      return false;
    if (focusSearchSuccess && requestFocusSuccess._v)
      return true;
    if (is1dFocusSearch(focusDirection) && wrapAroundForOneDimensionalFocus) {
      var clearFocus = this.l9d(false, true, false, focusDirection);
      return clearFocus && this.m9e(focusDirection, null);
    }
    var tmp_2;
    if (ComposeUiFlags_instance.r8u_1 || ComposeUiFlags_instance.s8u_1) {
      tmp_2 = false;
    } else {
      tmp_2 = this.s9d_1.p9e(focusDirection);
    }
    return tmp_2;
  };
  protoOf(FocusOwnerImpl).n9e = function (focusDirection, focusedRect, onFound) {
    var tmp0_safe_receiver = findFocusTargetNode(this);
    var tmp;
    if (tmp0_safe_receiver == null) {
      tmp = null;
    } else {
      // Inline function 'kotlin.also' call
      var customDest = customFocusSearch(tmp0_safe_receiver, focusDirection, this.t9d_1.r6p());
      if (equals(customDest, Companion_getInstance_32().s9e_1))
        return null;
      else if (equals(customDest, Companion_getInstance_32().t9e_1)) {
        var tmp0_safe_receiver_0 = findFocusTargetNode(this);
        var tmp_0;
        if (tmp0_safe_receiver_0 == null) {
          tmp_0 = null;
        } else {
          // Inline function 'kotlin.let' call
          tmp_0 = onFound(tmp0_safe_receiver_0);
        }
        return tmp_0;
      } else if (!equals(customDest, Companion_getInstance_32().r9e_1)) {
        var tmp$ret$3;
        $l$block: {
          // Inline function 'androidx.compose.ui.focus.FocusRequester.findFocusTarget' call
          // Inline function 'kotlin.check' call
          if (!!(customDest === Companion_getInstance_32().r9e_1)) {
            var message = '\n    Please check whether the focusRequester is FocusRequester.Cancel or FocusRequester.Default\n    before invoking any functions on the focusRequester.\n';
            throw IllegalStateException_init_$Create$(toString(message));
          }
          // Inline function 'kotlin.check' call
          if (!!(customDest === Companion_getInstance_32().s9e_1)) {
            var message_0 = '\n    Please check whether the focusRequester is FocusRequester.Cancel or FocusRequester.Default\n    before invoking any functions on the focusRequester.\n';
            throw IllegalStateException_init_$Create$(toString(message_0));
          }
          // Inline function 'androidx.compose.runtime.collection.MutableVector.isEmpty' call
          if (customDest.u9e_1.d3e_1 === 0) {
            println('FocusRelatedWarning: \n   FocusRequester is not initialized. Here are some possible fixes:\n\n   1. Remember the FocusRequester: val focusRequester = remember { FocusRequester() }\n   2. Did you forget to add a Modifier.focusRequester() ?\n   3. Are you attempting to request focus during composition? Focus requests should be made in\n   response to some event. Eg Modifier.clickable { focusRequester.requestFocus() }\n');
            tmp$ret$3 = false;
            break $l$block;
          }
          var success = false;
          // Inline function 'androidx.compose.runtime.collection.MutableVector.forEach' call
          var this_0 = customDest.u9e_1;
          var i = 0;
          var tmp_1 = this_0.b3e_1;
          var content = isArray(tmp_1) ? tmp_1 : THROW_CCE();
          var size = this_0.d3e_1;
          while (i < size) {
            var tmp0 = content[i];
            $l$block_0: {
              // Inline function 'androidx.compose.ui.node.Nodes.FocusTarget' call
              // Inline function 'androidx.compose.ui.node.visitChildren' call
              var type = _NodeKind___init__impl__ojsprp(1024);
              // Inline function 'androidx.compose.ui.node.visitChildren' call
              var mask = _NodeKind___get_mask__impl__1uopb6(type);
              // Inline function 'androidx.compose.ui.internal.checkPrecondition' call
              if (!tmp0.f4n().z8v_1) {
                var tmp$ret$15 = 'visitChildren called on an unattached node';
                throwIllegalStateException(tmp$ret$15);
              }
              // Inline function 'androidx.compose.runtime.collection.mutableVectorOf' call
              // Inline function 'androidx.compose.runtime.collection.MutableVector' call
              // Inline function 'kotlin.arrayOfNulls' call
              var tmp$ret$18 = Array(16);
              var branches = new MutableVector(tmp$ret$18, 0);
              var child = tmp0.f4n().r8v_1;
              if (child == null) {
                access$addLayoutNodeChildren$tDelegatableNodeKt(branches, tmp0.f4n(), false);
              } else
                branches.zz(child);
              $l$loop_0: while (true) {
                // Inline function 'androidx.compose.runtime.collection.MutableVector.isNotEmpty' call
                if (!!(branches.d3e_1 === 0)) {
                  break $l$loop_0;
                }
                // Inline function 'androidx.compose.runtime.collection.MutableVector.lastIndex' call
                var tmp$ret$20 = branches.d3e_1 - 1 | 0;
                var branch = branches.h3(tmp$ret$20);
                if ((branch.p8v_1 & mask) === 0) {
                  access$addLayoutNodeChildren$tDelegatableNodeKt(branches, branch, false);
                  continue $l$loop_0;
                }
                var node = branch;
                $l$loop_2: while (!(node == null)) {
                  if (!((node.o8v_1 & mask) === 0)) {
                    // Inline function 'androidx.compose.ui.node.dispatchForKind' call
                    // Inline function 'androidx.compose.ui.node.dispatchForKind' call
                    var stack = null;
                    var node_0 = node;
                    $l$loop_1: while (!(node_0 == null)) {
                      var tmp_2;
                      if (node_0 instanceof FocusTargetNode) {
                        if (onFound(node_0)) {
                          success = true;
                          break $l$block_0;
                        }
                        tmp_2 = false;
                      } else {
                        tmp_2 = true;
                      }
                      var dispatchAgain = tmp_2;
                      var tmp_3;
                      var tmp_4;
                      if (dispatchAgain || false) {
                        // Inline function 'androidx.compose.ui.Node.isKind' call
                        tmp_4 = !((node_0.o8v_1 & _NodeKind___get_mask__impl__1uopb6(type)) === 0);
                      } else {
                        tmp_4 = false;
                      }
                      if (tmp_4) {
                        tmp_3 = node_0 instanceof DelegatingNode;
                      } else {
                        tmp_3 = false;
                      }
                      if (tmp_3) {
                        var count = 0;
                        // Inline function 'androidx.compose.ui.node.DelegatingNode.forEachImmediateDelegate' call
                        var node_1 = node_0.e9a_1;
                        while (!(node_1 == null)) {
                          var next = node_1;
                          // Inline function 'androidx.compose.ui.Node.isKind' call
                          if (!((next.o8v_1 & _NodeKind___get_mask__impl__1uopb6(type)) === 0)) {
                            count = count + 1 | 0;
                            if (count === 1) {
                              node_0 = next;
                            } else {
                              var tmp0_elvis_lhs = stack;
                              var tmp_5;
                              if (tmp0_elvis_lhs == null) {
                                // Inline function 'androidx.compose.runtime.collection.mutableVectorOf' call
                                // Inline function 'androidx.compose.runtime.collection.MutableVector' call
                                // Inline function 'kotlin.arrayOfNulls' call
                                var tmp$ret$31 = Array(16);
                                tmp_5 = new MutableVector(tmp$ret$31, 0);
                              } else {
                                tmp_5 = tmp0_elvis_lhs;
                              }
                              stack = tmp_5;
                              var theNode = node_0;
                              if (!(theNode == null)) {
                                var tmp1_safe_receiver = stack;
                                if (tmp1_safe_receiver == null)
                                  null;
                                else
                                  tmp1_safe_receiver.zz(theNode);
                                node_0 = null;
                              }
                              var tmp2_safe_receiver = stack;
                              if (tmp2_safe_receiver == null)
                                null;
                              else
                                tmp2_safe_receiver.zz(next);
                            }
                          }
                          node_1 = node_1.r8v_1;
                        }
                        if (count === 1) {
                          continue $l$loop_1;
                        }
                      }
                      node_0 = access$pop$tDelegatableNodeKt(stack);
                    }
                    break $l$loop_2;
                  }
                  node = node.r8v_1;
                }
              }
            }
            i = i + 1 | 0;
          }
          tmp$ret$3 = success;
        }
        return tmp$ret$3;
      }
      tmp = tmp0_safe_receiver;
    }
    var source = tmp;
    var tmp_6 = this.u9d_1;
    var tmp_7 = this.t9d_1.r6p();
    return focusSearch(tmp_6, focusDirection, tmp_7, focusedRect, FocusOwnerImpl$focusSearch$lambda(source, this, onFound));
  };
  protoOf(FocusOwnerImpl).m9d = function (keyEvent, onFocusedItem) {
    // Inline function 'androidx.compose.ui.util.trace' call
    if (this.v9d_1.c9d()) {
      println('FocusRelatedWarning: Dispatching key event while focus system is invalidated.');
      return false;
    }
    if (!validateKeyEvent(this, keyEvent))
      return false;
    var activeFocusTarget = findFocusTargetNode(this);
    var tmp1_elvis_lhs = activeFocusTarget == null ? null : lastLocalKeyInputNode(this, activeFocusTarget);
    var tmp;
    if (tmp1_elvis_lhs == null) {
      var tmp_0;
      if (activeFocusTarget == null) {
        tmp_0 = null;
      } else {
        // Inline function 'androidx.compose.ui.node.Nodes.KeyInput' call
        var tmp4 = _NodeKind___init__impl__ojsprp(8192);
        var tmp$ret$3;
        $l$block: {
          // Inline function 'androidx.compose.ui.focus.FocusOwnerImpl.nearestAncestorIncludingSelf' call
          // Inline function 'androidx.compose.ui.node.visitAncestors' call
          // Inline function 'androidx.compose.ui.node.visitAncestors' call
          var mask = _NodeKind___get_mask__impl__1uopb6(tmp4);
          // Inline function 'androidx.compose.ui.internal.checkPrecondition' call
          if (!activeFocusTarget.f4n().z8v_1) {
            var tmp$ret$7 = 'visitAncestors called on an unattached node';
            throwIllegalStateException(tmp$ret$7);
          }
          var node = true ? activeFocusTarget.f4n() : activeFocusTarget.f4n().q8v_1;
          var layout = requireLayoutNode(activeFocusTarget);
          while (!(layout == null)) {
            var head = layout.d91_1.j99_1;
            if (!((head.p8v_1 & mask) === 0)) {
              while (!(node == null)) {
                if (!((node.o8v_1 & mask) === 0)) {
                  // Inline function 'androidx.compose.ui.node.dispatchForKind' call
                  var stack = null;
                  var node_0 = node;
                  $l$loop: while (!(node_0 == null)) {
                    var tmp_1;
                    if (isInterface(node_0, KeyInputModifierNode)) {
                      tmp$ret$3 = node_0;
                      break $l$block;
                    } else {
                      tmp_1 = true;
                    }
                    var dispatchAgain = tmp_1;
                    var tmp_2;
                    var tmp_3;
                    if (dispatchAgain || false) {
                      // Inline function 'androidx.compose.ui.Node.isKind' call
                      tmp_3 = !((node_0.o8v_1 & _NodeKind___get_mask__impl__1uopb6(tmp4)) === 0);
                    } else {
                      tmp_3 = false;
                    }
                    if (tmp_3) {
                      tmp_2 = node_0 instanceof DelegatingNode;
                    } else {
                      tmp_2 = false;
                    }
                    if (tmp_2) {
                      var count = 0;
                      // Inline function 'androidx.compose.ui.node.DelegatingNode.forEachImmediateDelegate' call
                      var node_1 = node_0.e9a_1;
                      while (!(node_1 == null)) {
                        var next = node_1;
                        // Inline function 'androidx.compose.ui.Node.isKind' call
                        if (!((next.o8v_1 & _NodeKind___get_mask__impl__1uopb6(tmp4)) === 0)) {
                          count = count + 1 | 0;
                          if (count === 1) {
                            node_0 = next;
                          } else {
                            var tmp0_elvis_lhs = stack;
                            var tmp_4;
                            if (tmp0_elvis_lhs == null) {
                              // Inline function 'androidx.compose.runtime.collection.mutableVectorOf' call
                              // Inline function 'androidx.compose.runtime.collection.MutableVector' call
                              // Inline function 'kotlin.arrayOfNulls' call
                              var tmp$ret$17 = Array(16);
                              tmp_4 = new MutableVector(tmp$ret$17, 0);
                            } else {
                              tmp_4 = tmp0_elvis_lhs;
                            }
                            stack = tmp_4;
                            var theNode = node_0;
                            if (!(theNode == null)) {
                              var tmp1_safe_receiver = stack;
                              if (tmp1_safe_receiver == null)
                                null;
                              else
                                tmp1_safe_receiver.zz(theNode);
                              node_0 = null;
                            }
                            var tmp2_safe_receiver = stack;
                            if (tmp2_safe_receiver == null)
                              null;
                            else
                              tmp2_safe_receiver.zz(next);
                          }
                        }
                        node_1 = node_1.r8v_1;
                      }
                      if (count === 1) {
                        continue $l$loop;
                      }
                    }
                    node_0 = access$pop$tDelegatableNodeKt(stack);
                  }
                }
                node = node.q8v_1;
              }
            }
            layout = layout.f9a();
            var tmp0_safe_receiver = layout;
            var tmp1_safe_receiver_0 = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.d91_1;
            node = tmp1_safe_receiver_0 == null ? null : tmp1_safe_receiver_0.i99_1;
          }
          tmp$ret$3 = null;
        }
        tmp_0 = tmp$ret$3;
      }
      var tmp3_safe_receiver = tmp_0;
      tmp = tmp3_safe_receiver == null ? null : tmp3_safe_receiver.f4n();
    } else {
      tmp = tmp1_elvis_lhs;
    }
    var tmp4_elvis_lhs = tmp;
    var tmp_5;
    if (tmp4_elvis_lhs == null) {
      var tmp0 = this.u9d_1;
      // Inline function 'androidx.compose.ui.node.Nodes.KeyInput' call
      var tmp2 = _NodeKind___init__impl__ojsprp(8192);
      var tmp$ret$19;
      $l$block_0: {
        // Inline function 'androidx.compose.ui.node.nearestAncestor' call
        // Inline function 'androidx.compose.ui.node.visitAncestors' call
        // Inline function 'androidx.compose.ui.node.visitAncestors' call
        var mask_0 = _NodeKind___get_mask__impl__1uopb6(tmp2);
        // Inline function 'androidx.compose.ui.internal.checkPrecondition' call
        if (!tmp0.f4n().z8v_1) {
          var tmp$ret$23 = 'visitAncestors called on an unattached node';
          throwIllegalStateException(tmp$ret$23);
        }
        var node_2 = false ? tmp0.f4n() : tmp0.f4n().q8v_1;
        var layout_0 = requireLayoutNode(tmp0);
        while (!(layout_0 == null)) {
          var head_0 = layout_0.d91_1.j99_1;
          if (!((head_0.p8v_1 & mask_0) === 0)) {
            while (!(node_2 == null)) {
              if (!((node_2.o8v_1 & mask_0) === 0)) {
                // Inline function 'androidx.compose.ui.node.dispatchForKind' call
                var stack_0 = null;
                var node_3 = node_2;
                $l$loop_0: while (!(node_3 == null)) {
                  var tmp_6;
                  if (isInterface(node_3, KeyInputModifierNode)) {
                    tmp$ret$19 = node_3;
                    break $l$block_0;
                  } else {
                    tmp_6 = true;
                  }
                  var dispatchAgain_0 = tmp_6;
                  var tmp_7;
                  var tmp_8;
                  if (dispatchAgain_0 || false) {
                    // Inline function 'androidx.compose.ui.Node.isKind' call
                    tmp_8 = !((node_3.o8v_1 & _NodeKind___get_mask__impl__1uopb6(tmp2)) === 0);
                  } else {
                    tmp_8 = false;
                  }
                  if (tmp_8) {
                    tmp_7 = node_3 instanceof DelegatingNode;
                  } else {
                    tmp_7 = false;
                  }
                  if (tmp_7) {
                    var count_0 = 0;
                    // Inline function 'androidx.compose.ui.node.DelegatingNode.forEachImmediateDelegate' call
                    var node_4 = node_3.e9a_1;
                    while (!(node_4 == null)) {
                      var next_0 = node_4;
                      // Inline function 'androidx.compose.ui.Node.isKind' call
                      if (!((next_0.o8v_1 & _NodeKind___get_mask__impl__1uopb6(tmp2)) === 0)) {
                        count_0 = count_0 + 1 | 0;
                        if (count_0 === 1) {
                          node_3 = next_0;
                        } else {
                          var tmp0_elvis_lhs_0 = stack_0;
                          var tmp_9;
                          if (tmp0_elvis_lhs_0 == null) {
                            // Inline function 'androidx.compose.runtime.collection.mutableVectorOf' call
                            // Inline function 'androidx.compose.runtime.collection.MutableVector' call
                            // Inline function 'kotlin.arrayOfNulls' call
                            var tmp$ret$33 = Array(16);
                            tmp_9 = new MutableVector(tmp$ret$33, 0);
                          } else {
                            tmp_9 = tmp0_elvis_lhs_0;
                          }
                          stack_0 = tmp_9;
                          var theNode_0 = node_3;
                          if (!(theNode_0 == null)) {
                            var tmp1_safe_receiver_1 = stack_0;
                            if (tmp1_safe_receiver_1 == null)
                              null;
                            else
                              tmp1_safe_receiver_1.zz(theNode_0);
                            node_3 = null;
                          }
                          var tmp2_safe_receiver_0 = stack_0;
                          if (tmp2_safe_receiver_0 == null)
                            null;
                          else
                            tmp2_safe_receiver_0.zz(next_0);
                        }
                      }
                      node_4 = node_4.r8v_1;
                    }
                    if (count_0 === 1) {
                      continue $l$loop_0;
                    }
                  }
                  node_3 = access$pop$tDelegatableNodeKt(stack_0);
                }
              }
              node_2 = node_2.q8v_1;
            }
          }
          layout_0 = layout_0.f9a();
          var tmp0_safe_receiver_0 = layout_0;
          var tmp1_safe_receiver_2 = tmp0_safe_receiver_0 == null ? null : tmp0_safe_receiver_0.d91_1;
          node_2 = tmp1_safe_receiver_2 == null ? null : tmp1_safe_receiver_2.i99_1;
        }
        tmp$ret$19 = null;
      }
      var tmp5_safe_receiver = tmp$ret$19;
      tmp_5 = tmp5_safe_receiver == null ? null : tmp5_safe_receiver.f4n();
    } else {
      tmp_5 = tmp4_elvis_lhs;
    }
    var focusedKeyInputNode = tmp_5;
    if (focusedKeyInputNode == null)
      null;
    else {
      // Inline function 'androidx.compose.ui.node.Nodes.KeyInput' call
      // Inline function 'androidx.compose.ui.focus.FocusOwnerImpl.traverseAncestorsIncludingSelf' call
      var type = _NodeKind___init__impl__ojsprp(8192);
      // Inline function 'androidx.compose.ui.node.ancestors' call
      var result = null;
      // Inline function 'androidx.compose.ui.node.visitAncestors' call
      // Inline function 'androidx.compose.ui.node.visitAncestors' call
      var mask_1 = _NodeKind___get_mask__impl__1uopb6(type);
      // Inline function 'androidx.compose.ui.internal.checkPrecondition' call
      if (!focusedKeyInputNode.f4n().z8v_1) {
        var tmp$ret$40 = 'visitAncestors called on an unattached node';
        throwIllegalStateException(tmp$ret$40);
      }
      var node_5 = false ? focusedKeyInputNode.f4n() : focusedKeyInputNode.f4n().q8v_1;
      var layout_1 = requireLayoutNode(focusedKeyInputNode);
      while (!(layout_1 == null)) {
        var head_1 = layout_1.d91_1.j99_1;
        if (!((head_1.p8v_1 & mask_1) === 0)) {
          while (!(node_5 == null)) {
            if (!((node_5.o8v_1 & mask_1) === 0)) {
              // Inline function 'androidx.compose.ui.node.dispatchForKind' call
              var stack_1 = null;
              var node_6 = node_5;
              $l$loop_1: while (!(node_6 == null)) {
                var tmp_10;
                if (isInterface(node_6, KeyInputModifierNode)) {
                  var it = node_6;
                  if (result == null) {
                    // Inline function 'kotlin.collections.mutableListOf' call
                    result = ArrayList_init_$Create$();
                  }
                  var tmp0_safe_receiver_1 = result;
                  if (tmp0_safe_receiver_1 == null)
                    null;
                  else
                    tmp0_safe_receiver_1.j1(it);
                  tmp_10 = false;
                } else {
                  tmp_10 = true;
                }
                var dispatchAgain_1 = tmp_10;
                var tmp_11;
                var tmp_12;
                if (dispatchAgain_1 || false) {
                  // Inline function 'androidx.compose.ui.Node.isKind' call
                  tmp_12 = !((node_6.o8v_1 & _NodeKind___get_mask__impl__1uopb6(type)) === 0);
                } else {
                  tmp_12 = false;
                }
                if (tmp_12) {
                  tmp_11 = node_6 instanceof DelegatingNode;
                } else {
                  tmp_11 = false;
                }
                if (tmp_11) {
                  var count_1 = 0;
                  // Inline function 'androidx.compose.ui.node.DelegatingNode.forEachImmediateDelegate' call
                  var node_7 = node_6.e9a_1;
                  while (!(node_7 == null)) {
                    var next_1 = node_7;
                    // Inline function 'androidx.compose.ui.Node.isKind' call
                    if (!((next_1.o8v_1 & _NodeKind___get_mask__impl__1uopb6(type)) === 0)) {
                      count_1 = count_1 + 1 | 0;
                      if (count_1 === 1) {
                        node_6 = next_1;
                      } else {
                        var tmp0_elvis_lhs_1 = stack_1;
                        var tmp_13;
                        if (tmp0_elvis_lhs_1 == null) {
                          // Inline function 'androidx.compose.runtime.collection.mutableVectorOf' call
                          // Inline function 'androidx.compose.runtime.collection.MutableVector' call
                          // Inline function 'kotlin.arrayOfNulls' call
                          var tmp$ret$51 = Array(16);
                          tmp_13 = new MutableVector(tmp$ret$51, 0);
                        } else {
                          tmp_13 = tmp0_elvis_lhs_1;
                        }
                        stack_1 = tmp_13;
                        var theNode_1 = node_6;
                        if (!(theNode_1 == null)) {
                          var tmp1_safe_receiver_3 = stack_1;
                          if (tmp1_safe_receiver_3 == null)
                            null;
                          else
                            tmp1_safe_receiver_3.zz(theNode_1);
                          node_6 = null;
                        }
                        var tmp2_safe_receiver_1 = stack_1;
                        if (tmp2_safe_receiver_1 == null)
                          null;
                        else
                          tmp2_safe_receiver_1.zz(next_1);
                      }
                    }
                    node_7 = node_7.r8v_1;
                  }
                  if (count_1 === 1) {
                    continue $l$loop_1;
                  }
                }
                node_6 = access$pop$tDelegatableNodeKt(stack_1);
              }
            }
            node_5 = node_5.q8v_1;
          }
        }
        layout_1 = layout_1.f9a();
        var tmp0_safe_receiver_2 = layout_1;
        var tmp1_safe_receiver_4 = tmp0_safe_receiver_2 == null ? null : tmp0_safe_receiver_2.d91_1;
        node_5 = tmp1_safe_receiver_4 == null ? null : tmp1_safe_receiver_4.i99_1;
      }
      var ancestors = result;
      if (ancestors == null)
        null;
      else {
        // Inline function 'androidx.compose.ui.util.fastForEachReversed' call
        var inductionVariable = ancestors.n1() - 1 | 0;
        if (0 <= inductionVariable)
          do {
            var index = inductionVariable;
            inductionVariable = inductionVariable + -1 | 0;
            var item = ancestors.l1(index);
            if (item.v9e(keyEvent))
              return true;
          }
           while (0 <= inductionVariable);
      }
      // Inline function 'androidx.compose.ui.node.dispatchForKind' call
      // Inline function 'androidx.compose.ui.node.dispatchForKind' call
      var stack_2 = null;
      var node_8 = focusedKeyInputNode.f4n();
      $l$loop_2: while (!(node_8 == null)) {
        var tmp_14;
        if (isInterface(node_8, KeyInputModifierNode)) {
          if (node_8.v9e(keyEvent))
            return true;
          tmp_14 = false;
        } else {
          tmp_14 = true;
        }
        var dispatchAgain_2 = tmp_14;
        var tmp_15;
        var tmp_16;
        if (dispatchAgain_2 || false) {
          // Inline function 'androidx.compose.ui.Node.isKind' call
          tmp_16 = !((node_8.o8v_1 & _NodeKind___get_mask__impl__1uopb6(type)) === 0);
        } else {
          tmp_16 = false;
        }
        if (tmp_16) {
          tmp_15 = node_8 instanceof DelegatingNode;
        } else {
          tmp_15 = false;
        }
        if (tmp_15) {
          var count_2 = 0;
          // Inline function 'androidx.compose.ui.node.DelegatingNode.forEachImmediateDelegate' call
          var node_9 = node_8.e9a_1;
          while (!(node_9 == null)) {
            var next_2 = node_9;
            // Inline function 'androidx.compose.ui.Node.isKind' call
            if (!((next_2.o8v_1 & _NodeKind___get_mask__impl__1uopb6(type)) === 0)) {
              count_2 = count_2 + 1 | 0;
              if (count_2 === 1) {
                node_8 = next_2;
              } else {
                var tmp0_elvis_lhs_2 = stack_2;
                var tmp_17;
                if (tmp0_elvis_lhs_2 == null) {
                  // Inline function 'androidx.compose.runtime.collection.mutableVectorOf' call
                  // Inline function 'androidx.compose.runtime.collection.MutableVector' call
                  // Inline function 'kotlin.arrayOfNulls' call
                  var tmp$ret$63 = Array(16);
                  tmp_17 = new MutableVector(tmp$ret$63, 0);
                } else {
                  tmp_17 = tmp0_elvis_lhs_2;
                }
                stack_2 = tmp_17;
                var theNode_2 = node_8;
                if (!(theNode_2 == null)) {
                  var tmp1_safe_receiver_5 = stack_2;
                  if (tmp1_safe_receiver_5 == null)
                    null;
                  else
                    tmp1_safe_receiver_5.zz(theNode_2);
                  node_8 = null;
                }
                var tmp2_safe_receiver_2 = stack_2;
                if (tmp2_safe_receiver_2 == null)
                  null;
                else
                  tmp2_safe_receiver_2.zz(next_2);
              }
            }
            node_9 = node_9.r8v_1;
          }
          if (count_2 === 1) {
            continue $l$loop_2;
          }
        }
        node_8 = access$pop$tDelegatableNodeKt(stack_2);
      }
      if (onFocusedItem())
        return true;
      // Inline function 'androidx.compose.ui.node.dispatchForKind' call
      // Inline function 'androidx.compose.ui.node.dispatchForKind' call
      var stack_3 = null;
      var node_10 = focusedKeyInputNode.f4n();
      $l$loop_3: while (!(node_10 == null)) {
        var tmp_18;
        if (isInterface(node_10, KeyInputModifierNode)) {
          if (node_10.w9e(keyEvent))
            return true;
          tmp_18 = false;
        } else {
          tmp_18 = true;
        }
        var dispatchAgain_3 = tmp_18;
        var tmp_19;
        var tmp_20;
        if (dispatchAgain_3 || false) {
          // Inline function 'androidx.compose.ui.Node.isKind' call
          tmp_20 = !((node_10.o8v_1 & _NodeKind___get_mask__impl__1uopb6(type)) === 0);
        } else {
          tmp_20 = false;
        }
        if (tmp_20) {
          tmp_19 = node_10 instanceof DelegatingNode;
        } else {
          tmp_19 = false;
        }
        if (tmp_19) {
          var count_3 = 0;
          // Inline function 'androidx.compose.ui.node.DelegatingNode.forEachImmediateDelegate' call
          var node_11 = node_10.e9a_1;
          while (!(node_11 == null)) {
            var next_3 = node_11;
            // Inline function 'androidx.compose.ui.Node.isKind' call
            if (!((next_3.o8v_1 & _NodeKind___get_mask__impl__1uopb6(type)) === 0)) {
              count_3 = count_3 + 1 | 0;
              if (count_3 === 1) {
                node_10 = next_3;
              } else {
                var tmp0_elvis_lhs_3 = stack_3;
                var tmp_21;
                if (tmp0_elvis_lhs_3 == null) {
                  // Inline function 'androidx.compose.runtime.collection.mutableVectorOf' call
                  // Inline function 'androidx.compose.runtime.collection.MutableVector' call
                  // Inline function 'kotlin.arrayOfNulls' call
                  var tmp$ret$74 = Array(16);
                  tmp_21 = new MutableVector(tmp$ret$74, 0);
                } else {
                  tmp_21 = tmp0_elvis_lhs_3;
                }
                stack_3 = tmp_21;
                var theNode_3 = node_10;
                if (!(theNode_3 == null)) {
                  var tmp1_safe_receiver_6 = stack_3;
                  if (tmp1_safe_receiver_6 == null)
                    null;
                  else
                    tmp1_safe_receiver_6.zz(theNode_3);
                  node_10 = null;
                }
                var tmp2_safe_receiver_3 = stack_3;
                if (tmp2_safe_receiver_3 == null)
                  null;
                else
                  tmp2_safe_receiver_3.zz(next_3);
              }
            }
            node_11 = node_11.r8v_1;
          }
          if (count_3 === 1) {
            continue $l$loop_3;
          }
        }
        node_10 = access$pop$tDelegatableNodeKt(stack_3);
      }
      if (ancestors == null)
        null;
      else {
        // Inline function 'androidx.compose.ui.util.fastForEach' call
        var inductionVariable_0 = 0;
        var last = ancestors.n1() - 1 | 0;
        if (inductionVariable_0 <= last)
          do {
            var index_0 = inductionVariable_0;
            inductionVariable_0 = inductionVariable_0 + 1 | 0;
            var item_0 = ancestors.l1(index_0);
            if (item_0.w9e(keyEvent))
              return true;
          }
           while (inductionVariable_0 <= last);
      }
    }
    return false;
  };
  protoOf(FocusOwnerImpl).o9d = function () {
    this.s9d_1.o9d();
  };
  protoOf(FocusOwnerImpl).a9d = function (node) {
    this.v9d_1.a9d(node);
  };
  protoOf(FocusOwnerImpl).p9c = function (node) {
    this.v9d_1.p9c(node);
  };
  protoOf(FocusOwnerImpl).p9d = function () {
    this.v9d_1.b9d();
  };
  protoOf(FocusOwnerImpl).z9c = function () {
    return this.u9d_1.x9c();
  };
  protoOf(FocusOwnerImpl).q9d = function (value) {
    var previousValue = this.z9d_1;
    this.z9d_1 = value;
    if (value == null || !(previousValue === value)) {
      this.x9e(false);
    }
    // Inline function 'androidx.collection.ObjectList.forEach' call
    var this_0 = this.y9d_1;
    // Inline function 'kotlin.contracts.contract' call
    var content = this_0.sz_1;
    var inductionVariable = 0;
    var last = this_0.tz_1;
    if (inductionVariable < last)
      do {
        var i = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        content[i].y9e(previousValue, value);
      }
       while (inductionVariable < last);
  };
  protoOf(FocusOwnerImpl).v9c = function () {
    var tmp;
    var tmp0_safe_receiver = this.z9d_1;
    if ((tmp0_safe_receiver == null ? null : tmp0_safe_receiver.z8v_1) === true) {
      tmp = this.z9d_1;
    } else {
      tmp = null;
    }
    return tmp;
  };
  protoOf(FocusOwnerImpl).x9e = function (value) {
    // Inline function 'androidx.compose.ui.internal.requirePrecondition' call
    if (!(!value || !(this.v9c() == null))) {
      var tmp$ret$1 = 'Cannot capture focus when the active focus target node is unset';
      throwIllegalArgumentException(tmp$ret$1);
    }
    this.a9e_1 = value;
  };
  protoOf(FocusOwnerImpl).r9d = function () {
    return this.a9e_1;
  };
  function is1dFocusSearch(_this__u8e3s4) {
    return _this__u8e3s4 === Companion_getInstance_30().k9b_1 || _this__u8e3s4 === Companion_getInstance_30().l9b_1 ? true : false;
  }
  var androidx_compose_ui_focus_CancelIndicatingFocusBoundaryScope$stable;
  var androidx_compose_ui_focus_FocusPropertiesImpl$stable;
  function focusProperties(_this__u8e3s4, scope) {
    return _this__u8e3s4.d8v(new FocusPropertiesElement(new sam$androidx_compose_ui_focus_FocusPropertiesScope$0(scope)));
  }
  function Companion_5() {
    Companion_instance_10 = this;
    this.z9e_1 = new Rect(NaN, NaN, NaN, NaN);
  }
  var Companion_instance_10;
  function Companion_getInstance_31() {
    if (Companion_instance_10 == null)
      new Companion_5();
    return Companion_instance_10;
  }
  function FocusProperties$_get_onEnter_$lambda_szd2j8(_this__u8e3s4) {
    return Unit_instance;
  }
  function FocusProperties$_get_onExit_$lambda_n14g70(_this__u8e3s4) {
    return Unit_instance;
  }
  function FocusProperties() {
  }
  function FocusPropertiesElement(scope) {
    ModifierNodeElement.call(this);
    this.l9f_1 = scope;
  }
  protoOf(FocusPropertiesElement).r3d = function () {
    return new FocusPropertiesNode(this.l9f_1);
  };
  protoOf(FocusPropertiesElement).m9f = function (node) {
    node.b9g_1 = this.l9f_1;
  };
  protoOf(FocusPropertiesElement).d8y = function (node) {
    return this.m9f(node instanceof FocusPropertiesNode ? node : THROW_CCE());
  };
  protoOf(FocusPropertiesElement).toString = function () {
    return 'FocusPropertiesElement(scope=' + toString(this.l9f_1) + ')';
  };
  protoOf(FocusPropertiesElement).hashCode = function () {
    return hashCode(this.l9f_1);
  };
  protoOf(FocusPropertiesElement).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof FocusPropertiesElement))
      return false;
    if (!equals(this.l9f_1, other.l9f_1))
      return false;
    return true;
  };
  function FocusPropertiesNode(focusPropertiesScope) {
    Node.call(this);
    this.b9g_1 = focusPropertiesScope;
  }
  protoOf(FocusPropertiesNode).c9g = function (focusProperties) {
    this.b9g_1.g9d(focusProperties);
  };
  function FocusPropertiesImpl$onEnter$lambda(_this__u8e3s4) {
    return Unit_instance;
  }
  function FocusPropertiesImpl$onExit$lambda(_this__u8e3s4) {
    return Unit_instance;
  }
  function FocusPropertiesImpl() {
    this.d9g_1 = true;
    this.e9g_1 = Companion_getInstance_32().r9e_1;
    this.f9g_1 = Companion_getInstance_32().r9e_1;
    this.g9g_1 = Companion_getInstance_32().r9e_1;
    this.h9g_1 = Companion_getInstance_32().r9e_1;
    this.i9g_1 = Companion_getInstance_32().r9e_1;
    this.j9g_1 = Companion_getInstance_32().r9e_1;
    this.k9g_1 = Companion_getInstance_32().r9e_1;
    this.l9g_1 = Companion_getInstance_32().r9e_1;
    var tmp = this;
    tmp.m9g_1 = FocusPropertiesImpl$onEnter$lambda;
    var tmp_0 = this;
    tmp_0.n9g_1 = FocusPropertiesImpl$onExit$lambda;
    this.o9g_1 = Companion_getInstance_31().z9e_1;
  }
  protoOf(FocusPropertiesImpl).a9f = function () {
    return this.d9g_1;
  };
  protoOf(FocusPropertiesImpl).c1o = function () {
    return this.e9g_1;
  };
  protoOf(FocusPropertiesImpl).b9f = function () {
    return this.f9g_1;
  };
  protoOf(FocusPropertiesImpl).c9f = function () {
    return this.g9g_1;
  };
  protoOf(FocusPropertiesImpl).d9f = function () {
    return this.h9g_1;
  };
  protoOf(FocusPropertiesImpl).e9f = function () {
    return this.i9g_1;
  };
  protoOf(FocusPropertiesImpl).x61 = function () {
    return this.j9g_1;
  };
  protoOf(FocusPropertiesImpl).e1 = function () {
    return this.k9g_1;
  };
  protoOf(FocusPropertiesImpl).f9f = function () {
    return this.l9g_1;
  };
  protoOf(FocusPropertiesImpl).g9f = function () {
    return this.m9g_1;
  };
  protoOf(FocusPropertiesImpl).h9f = function (_set____db54di) {
    this.n9g_1 = _set____db54di;
  };
  protoOf(FocusPropertiesImpl).i9f = function () {
    return this.n9g_1;
  };
  protoOf(FocusPropertiesImpl).j9f = function () {
    return this.o9g_1;
  };
  function CancelIndicatingFocusBoundaryScope(requestedFocusDirection) {
    this.p9g_1 = requestedFocusDirection;
    this.q9g_1 = false;
  }
  protoOf(CancelIndicatingFocusBoundaryScope).r9g = function () {
    return this.p9g_1;
  };
  protoOf(CancelIndicatingFocusBoundaryScope).s9g = function () {
    this.q9g_1 = true;
  };
  function sam$androidx_compose_ui_focus_FocusPropertiesScope$0(function_0) {
    this.t9g_1 = function_0;
  }
  protoOf(sam$androidx_compose_ui_focus_FocusPropertiesScope$0).g9d = function (focusProperties) {
    return this.t9g_1(focusProperties);
  };
  protoOf(sam$androidx_compose_ui_focus_FocusPropertiesScope$0).q3 = function () {
    return this.t9g_1;
  };
  protoOf(sam$androidx_compose_ui_focus_FocusPropertiesScope$0).equals = function (other) {
    var tmp;
    if (!(other == null) ? isInterface(other, FocusPropertiesScope) : false) {
      var tmp_0;
      if (!(other == null) ? isInterface(other, FunctionAdapter) : false) {
        tmp_0 = equals(this.q3(), other.q3());
      } else {
        tmp_0 = false;
      }
      tmp = tmp_0;
    } else {
      tmp = false;
    }
    return tmp;
  };
  protoOf(sam$androidx_compose_ui_focus_FocusPropertiesScope$0).hashCode = function () {
    return hashCode(this.q3());
  };
  function FocusPropertiesModifierNode() {
  }
  function invalidateFocusProperties(_this__u8e3s4) {
    // Inline function 'androidx.compose.ui.node.Nodes.FocusTarget' call
    // Inline function 'androidx.compose.ui.node.visitChildren' call
    var type = _NodeKind___init__impl__ojsprp(1024);
    // Inline function 'androidx.compose.ui.node.visitChildren' call
    var mask = _NodeKind___get_mask__impl__1uopb6(type);
    // Inline function 'androidx.compose.ui.internal.checkPrecondition' call
    if (!_this__u8e3s4.f4n().z8v_1) {
      var tmp$ret$4 = 'visitChildren called on an unattached node';
      throwIllegalStateException(tmp$ret$4);
    }
    // Inline function 'androidx.compose.runtime.collection.mutableVectorOf' call
    // Inline function 'androidx.compose.runtime.collection.MutableVector' call
    // Inline function 'kotlin.arrayOfNulls' call
    var tmp$ret$7 = Array(16);
    var branches = new MutableVector(tmp$ret$7, 0);
    var child = _this__u8e3s4.f4n().r8v_1;
    if (child == null) {
      access$addLayoutNodeChildren$tDelegatableNodeKt(branches, _this__u8e3s4.f4n(), false);
    } else
      branches.zz(child);
    $l$loop_0: while (true) {
      // Inline function 'androidx.compose.runtime.collection.MutableVector.isNotEmpty' call
      if (!!(branches.d3e_1 === 0)) {
        break $l$loop_0;
      }
      // Inline function 'androidx.compose.runtime.collection.MutableVector.lastIndex' call
      var tmp$ret$9 = branches.d3e_1 - 1 | 0;
      var branch = branches.h3(tmp$ret$9);
      if ((branch.p8v_1 & mask) === 0) {
        access$addLayoutNodeChildren$tDelegatableNodeKt(branches, branch, false);
        continue $l$loop_0;
      }
      var node = branch;
      $l$loop_2: while (!(node == null)) {
        if (!((node.o8v_1 & mask) === 0)) {
          // Inline function 'androidx.compose.ui.node.dispatchForKind' call
          // Inline function 'androidx.compose.ui.node.dispatchForKind' call
          var stack = null;
          var node_0 = node;
          $l$loop_1: while (!(node_0 == null)) {
            var tmp;
            if (node_0 instanceof FocusTargetNode) {
              var it = node_0;
              invalidateFocusTarget(it);
              tmp = false;
            } else {
              tmp = true;
            }
            var dispatchAgain = tmp;
            var tmp_0;
            var tmp_1;
            if (dispatchAgain || false) {
              // Inline function 'androidx.compose.ui.Node.isKind' call
              tmp_1 = !((node_0.o8v_1 & _NodeKind___get_mask__impl__1uopb6(type)) === 0);
            } else {
              tmp_1 = false;
            }
            if (tmp_1) {
              tmp_0 = node_0 instanceof DelegatingNode;
            } else {
              tmp_0 = false;
            }
            if (tmp_0) {
              var count = 0;
              // Inline function 'androidx.compose.ui.node.DelegatingNode.forEachImmediateDelegate' call
              var node_1 = node_0.e9a_1;
              while (!(node_1 == null)) {
                var next = node_1;
                // Inline function 'androidx.compose.ui.Node.isKind' call
                if (!((next.o8v_1 & _NodeKind___get_mask__impl__1uopb6(type)) === 0)) {
                  count = count + 1 | 0;
                  if (count === 1) {
                    node_0 = next;
                  } else {
                    var tmp0_elvis_lhs = stack;
                    var tmp_2;
                    if (tmp0_elvis_lhs == null) {
                      // Inline function 'androidx.compose.runtime.collection.mutableVectorOf' call
                      // Inline function 'androidx.compose.runtime.collection.MutableVector' call
                      // Inline function 'kotlin.arrayOfNulls' call
                      var tmp$ret$20 = Array(16);
                      tmp_2 = new MutableVector(tmp$ret$20, 0);
                    } else {
                      tmp_2 = tmp0_elvis_lhs;
                    }
                    stack = tmp_2;
                    var theNode = node_0;
                    if (!(theNode == null)) {
                      var tmp1_safe_receiver = stack;
                      if (tmp1_safe_receiver == null)
                        null;
                      else
                        tmp1_safe_receiver.zz(theNode);
                      node_0 = null;
                    }
                    var tmp2_safe_receiver = stack;
                    if (tmp2_safe_receiver == null)
                      null;
                    else
                      tmp2_safe_receiver.zz(next);
                  }
                }
                node_1 = node_1.r8v_1;
              }
              if (count === 1) {
                continue $l$loop_1;
              }
            }
            node_0 = access$pop$tDelegatableNodeKt(stack);
          }
          break $l$loop_2;
        }
        node = node.r8v_1;
      }
    }
  }
  var androidx_compose_ui_focus_FocusRequester_Companion_FocusRequesterFactory$stable;
  var androidx_compose_ui_focus_FocusRequester$stable;
  function Companion_6() {
    Companion_instance_11 = this;
    this.r9e_1 = new FocusRequester();
    this.s9e_1 = new FocusRequester();
    this.t9e_1 = new FocusRequester();
  }
  var Companion_instance_11;
  function Companion_getInstance_32() {
    if (Companion_instance_11 == null)
      new Companion_6();
    return Companion_instance_11;
  }
  function FocusRequester() {
    Companion_getInstance_32();
    var tmp = this;
    // Inline function 'androidx.compose.runtime.collection.mutableVectorOf' call
    // Inline function 'androidx.compose.runtime.collection.MutableVector' call
    // Inline function 'kotlin.arrayOfNulls' call
    var tmp$ret$2 = Array(16);
    tmp.u9e_1 = new MutableVector(tmp$ret$2, 0);
  }
  protoOf(FocusRequester).i9e = function (focusDirection) {
    var tmp$ret$0;
    $l$block: {
      // Inline function 'androidx.compose.ui.focus.FocusRequester.findFocusTarget' call
      // Inline function 'kotlin.check' call
      if (!!(this === Companion_getInstance_32().r9e_1)) {
        var message = '\n    Please check whether the focusRequester is FocusRequester.Cancel or FocusRequester.Default\n    before invoking any functions on the focusRequester.\n';
        throw IllegalStateException_init_$Create$(toString(message));
      }
      // Inline function 'kotlin.check' call
      if (!!(this === Companion_getInstance_32().s9e_1)) {
        var message_0 = '\n    Please check whether the focusRequester is FocusRequester.Cancel or FocusRequester.Default\n    before invoking any functions on the focusRequester.\n';
        throw IllegalStateException_init_$Create$(toString(message_0));
      }
      // Inline function 'androidx.compose.runtime.collection.MutableVector.isEmpty' call
      if (this.u9e_1.d3e_1 === 0) {
        println('FocusRelatedWarning: \n   FocusRequester is not initialized. Here are some possible fixes:\n\n   1. Remember the FocusRequester: val focusRequester = remember { FocusRequester() }\n   2. Did you forget to add a Modifier.focusRequester() ?\n   3. Are you attempting to request focus during composition? Focus requests should be made in\n   response to some event. Eg Modifier.clickable { focusRequester.requestFocus() }\n');
        tmp$ret$0 = false;
        break $l$block;
      }
      var success = false;
      // Inline function 'androidx.compose.runtime.collection.MutableVector.forEach' call
      var this_0 = this.u9e_1;
      var i = 0;
      var tmp = this_0.b3e_1;
      var content = isArray(tmp) ? tmp : THROW_CCE();
      var size = this_0.d3e_1;
      while (i < size) {
        var tmp0 = content[i];
        $l$block_0: {
          // Inline function 'androidx.compose.ui.node.Nodes.FocusTarget' call
          // Inline function 'androidx.compose.ui.node.visitChildren' call
          var type = _NodeKind___init__impl__ojsprp(1024);
          // Inline function 'androidx.compose.ui.node.visitChildren' call
          var mask = _NodeKind___get_mask__impl__1uopb6(type);
          // Inline function 'androidx.compose.ui.internal.checkPrecondition' call
          if (!tmp0.f4n().z8v_1) {
            var tmp$ret$12 = 'visitChildren called on an unattached node';
            throwIllegalStateException(tmp$ret$12);
          }
          // Inline function 'androidx.compose.runtime.collection.mutableVectorOf' call
          // Inline function 'androidx.compose.runtime.collection.MutableVector' call
          // Inline function 'kotlin.arrayOfNulls' call
          var tmp$ret$15 = Array(16);
          var branches = new MutableVector(tmp$ret$15, 0);
          var child = tmp0.f4n().r8v_1;
          if (child == null) {
            access$addLayoutNodeChildren$tDelegatableNodeKt(branches, tmp0.f4n(), false);
          } else
            branches.zz(child);
          $l$loop_0: while (true) {
            // Inline function 'androidx.compose.runtime.collection.MutableVector.isNotEmpty' call
            if (!!(branches.d3e_1 === 0)) {
              break $l$loop_0;
            }
            // Inline function 'androidx.compose.runtime.collection.MutableVector.lastIndex' call
            var tmp$ret$17 = branches.d3e_1 - 1 | 0;
            var branch = branches.h3(tmp$ret$17);
            if ((branch.p8v_1 & mask) === 0) {
              access$addLayoutNodeChildren$tDelegatableNodeKt(branches, branch, false);
              continue $l$loop_0;
            }
            var node = branch;
            $l$loop_2: while (!(node == null)) {
              if (!((node.o8v_1 & mask) === 0)) {
                // Inline function 'androidx.compose.ui.node.dispatchForKind' call
                // Inline function 'androidx.compose.ui.node.dispatchForKind' call
                var stack = null;
                var node_0 = node;
                $l$loop_1: while (!(node_0 == null)) {
                  var tmp_0;
                  if (node_0 instanceof FocusTargetNode) {
                    if (node_0.i9e(focusDirection)) {
                      success = true;
                      break $l$block_0;
                    }
                    tmp_0 = false;
                  } else {
                    tmp_0 = true;
                  }
                  var dispatchAgain = tmp_0;
                  var tmp_1;
                  var tmp_2;
                  if (dispatchAgain || false) {
                    // Inline function 'androidx.compose.ui.Node.isKind' call
                    tmp_2 = !((node_0.o8v_1 & _NodeKind___get_mask__impl__1uopb6(type)) === 0);
                  } else {
                    tmp_2 = false;
                  }
                  if (tmp_2) {
                    tmp_1 = node_0 instanceof DelegatingNode;
                  } else {
                    tmp_1 = false;
                  }
                  if (tmp_1) {
                    var count = 0;
                    // Inline function 'androidx.compose.ui.node.DelegatingNode.forEachImmediateDelegate' call
                    var node_1 = node_0.e9a_1;
                    while (!(node_1 == null)) {
                      var next = node_1;
                      // Inline function 'androidx.compose.ui.Node.isKind' call
                      if (!((next.o8v_1 & _NodeKind___get_mask__impl__1uopb6(type)) === 0)) {
                        count = count + 1 | 0;
                        if (count === 1) {
                          node_0 = next;
                        } else {
                          var tmp0_elvis_lhs = stack;
                          var tmp_3;
                          if (tmp0_elvis_lhs == null) {
                            // Inline function 'androidx.compose.runtime.collection.mutableVectorOf' call
                            // Inline function 'androidx.compose.runtime.collection.MutableVector' call
                            // Inline function 'kotlin.arrayOfNulls' call
                            var tmp$ret$29 = Array(16);
                            tmp_3 = new MutableVector(tmp$ret$29, 0);
                          } else {
                            tmp_3 = tmp0_elvis_lhs;
                          }
                          stack = tmp_3;
                          var theNode = node_0;
                          if (!(theNode == null)) {
                            var tmp1_safe_receiver = stack;
                            if (tmp1_safe_receiver == null)
                              null;
                            else
                              tmp1_safe_receiver.zz(theNode);
                            node_0 = null;
                          }
                          var tmp2_safe_receiver = stack;
                          if (tmp2_safe_receiver == null)
                            null;
                          else
                            tmp2_safe_receiver.zz(next);
                        }
                      }
                      node_1 = node_1.r8v_1;
                    }
                    if (count === 1) {
                      continue $l$loop_1;
                    }
                  }
                  node_0 = access$pop$tDelegatableNodeKt(stack);
                }
                break $l$loop_2;
              }
              node = node.r8v_1;
            }
          }
        }
        i = i + 1 | 0;
      }
      tmp$ret$0 = success;
    }
    return tmp$ret$0;
  };
  protoOf(FocusRequester).u9g = function (focusDirection, $super) {
    focusDirection = focusDirection === VOID ? Companion_getInstance_30().q9b_1 : focusDirection;
    return $super === VOID ? this.i9e(focusDirection) : $super.i9e.call(this, new FocusDirection(focusDirection));
  };
  function focusRequester(_this__u8e3s4, focusRequester) {
    return _this__u8e3s4.d8v(new FocusRequesterElement(focusRequester));
  }
  function FocusRequesterElement(focusRequester) {
    ModifierNodeElement.call(this);
    this.w9g_1 = focusRequester;
  }
  protoOf(FocusRequesterElement).r3d = function () {
    return new FocusRequesterNode(this.w9g_1);
  };
  protoOf(FocusRequesterElement).x9g = function (node) {
    // Inline function 'androidx.compose.runtime.collection.MutableVector.minusAssign' call
    node.m9h_1.u9e_1.g10(node);
    node.m9h_1 = this.w9g_1;
    // Inline function 'androidx.compose.runtime.collection.MutableVector.plusAssign' call
    node.m9h_1.u9e_1.zz(node);
  };
  protoOf(FocusRequesterElement).d8y = function (node) {
    return this.x9g(node instanceof FocusRequesterNode ? node : THROW_CCE());
  };
  protoOf(FocusRequesterElement).toString = function () {
    return 'FocusRequesterElement(focusRequester=' + toString(this.w9g_1) + ')';
  };
  protoOf(FocusRequesterElement).hashCode = function () {
    return hashCode(this.w9g_1);
  };
  protoOf(FocusRequesterElement).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof FocusRequesterElement))
      return false;
    if (!equals(this.w9g_1, other.w9g_1))
      return false;
    return true;
  };
  function FocusRequesterNode(focusRequester) {
    Node.call(this);
    this.m9h_1 = focusRequester;
  }
  protoOf(FocusRequesterNode).f8w = function () {
    protoOf(Node).f8w.call(this);
    // Inline function 'androidx.compose.runtime.collection.MutableVector.plusAssign' call
    this.m9h_1.u9e_1.zz(this);
  };
  protoOf(FocusRequesterNode).h8w = function () {
    // Inline function 'androidx.compose.runtime.collection.MutableVector.minusAssign' call
    this.m9h_1.u9e_1.g10(this);
    protoOf(Node).h8w.call(this);
  };
  function FocusRequesterModifier() {
  }
  function requestFocus_0(_this__u8e3s4) {
    // Inline function 'androidx.compose.ui.node.Nodes.FocusTarget' call
    // Inline function 'androidx.compose.ui.node.visitSelfAndChildren' call
    var type = _NodeKind___init__impl__ojsprp(1024);
    // Inline function 'androidx.compose.ui.node.dispatchForKind' call
    // Inline function 'androidx.compose.ui.node.dispatchForKind' call
    var stack = null;
    var node = _this__u8e3s4.f4n();
    $l$loop: while (!(node == null)) {
      var tmp;
      if (node instanceof FocusTargetNode) {
        return node.o9h();
      } else {
        tmp = true;
      }
      var dispatchAgain = tmp;
      var tmp_0;
      var tmp_1;
      if (dispatchAgain || false) {
        // Inline function 'androidx.compose.ui.Node.isKind' call
        tmp_1 = !((node.o8v_1 & _NodeKind___get_mask__impl__1uopb6(type)) === 0);
      } else {
        tmp_1 = false;
      }
      if (tmp_1) {
        tmp_0 = node instanceof DelegatingNode;
      } else {
        tmp_0 = false;
      }
      if (tmp_0) {
        var count = 0;
        // Inline function 'androidx.compose.ui.node.DelegatingNode.forEachImmediateDelegate' call
        var node_0 = node.e9a_1;
        while (!(node_0 == null)) {
          var next = node_0;
          // Inline function 'androidx.compose.ui.Node.isKind' call
          if (!((next.o8v_1 & _NodeKind___get_mask__impl__1uopb6(type)) === 0)) {
            count = count + 1 | 0;
            if (count === 1) {
              node = next;
            } else {
              var tmp0_elvis_lhs = stack;
              var tmp_2;
              if (tmp0_elvis_lhs == null) {
                // Inline function 'androidx.compose.runtime.collection.mutableVectorOf' call
                // Inline function 'androidx.compose.runtime.collection.MutableVector' call
                // Inline function 'kotlin.arrayOfNulls' call
                var tmp$ret$11 = Array(16);
                tmp_2 = new MutableVector(tmp$ret$11, 0);
              } else {
                tmp_2 = tmp0_elvis_lhs;
              }
              stack = tmp_2;
              var theNode = node;
              if (!(theNode == null)) {
                var tmp1_safe_receiver = stack;
                if (tmp1_safe_receiver == null)
                  null;
                else
                  tmp1_safe_receiver.zz(theNode);
                node = null;
              }
              var tmp2_safe_receiver = stack;
              if (tmp2_safe_receiver == null)
                null;
              else
                tmp2_safe_receiver.zz(next);
            }
          }
          node_0 = node_0.r8v_1;
        }
        if (count === 1) {
          continue $l$loop;
        }
      }
      node = access$pop$tDelegatableNodeKt(stack);
    }
    // Inline function 'androidx.compose.ui.node.visitChildren' call
    var mask = _NodeKind___get_mask__impl__1uopb6(type);
    // Inline function 'androidx.compose.ui.internal.checkPrecondition' call
    if (!_this__u8e3s4.f4n().z8v_1) {
      var tmp$ret$14 = 'visitChildren called on an unattached node';
      throwIllegalStateException(tmp$ret$14);
    }
    // Inline function 'androidx.compose.runtime.collection.mutableVectorOf' call
    // Inline function 'androidx.compose.runtime.collection.MutableVector' call
    // Inline function 'kotlin.arrayOfNulls' call
    var tmp$ret$17 = Array(16);
    var branches = new MutableVector(tmp$ret$17, 0);
    var child = _this__u8e3s4.f4n().r8v_1;
    if (child == null) {
      access$addLayoutNodeChildren$tDelegatableNodeKt(branches, _this__u8e3s4.f4n(), false);
    } else
      branches.zz(child);
    $l$loop_1: while (true) {
      // Inline function 'androidx.compose.runtime.collection.MutableVector.isNotEmpty' call
      if (!!(branches.d3e_1 === 0)) {
        break $l$loop_1;
      }
      // Inline function 'androidx.compose.runtime.collection.MutableVector.lastIndex' call
      var tmp$ret$19 = branches.d3e_1 - 1 | 0;
      var branch = branches.h3(tmp$ret$19);
      if ((branch.p8v_1 & mask) === 0) {
        access$addLayoutNodeChildren$tDelegatableNodeKt(branches, branch, false);
        continue $l$loop_1;
      }
      var node_1 = branch;
      $l$loop_3: while (!(node_1 == null)) {
        if (!((node_1.o8v_1 & mask) === 0)) {
          // Inline function 'androidx.compose.ui.node.dispatchForKind' call
          // Inline function 'androidx.compose.ui.node.dispatchForKind' call
          var stack_0 = null;
          var node_2 = node_1;
          $l$loop_2: while (!(node_2 == null)) {
            var tmp_3;
            if (node_2 instanceof FocusTargetNode) {
              return node_2.o9h();
            } else {
              tmp_3 = true;
            }
            var dispatchAgain_0 = tmp_3;
            var tmp_4;
            var tmp_5;
            if (dispatchAgain_0 || false) {
              // Inline function 'androidx.compose.ui.Node.isKind' call
              tmp_5 = !((node_2.o8v_1 & _NodeKind___get_mask__impl__1uopb6(type)) === 0);
            } else {
              tmp_5 = false;
            }
            if (tmp_5) {
              tmp_4 = node_2 instanceof DelegatingNode;
            } else {
              tmp_4 = false;
            }
            if (tmp_4) {
              var count_0 = 0;
              // Inline function 'androidx.compose.ui.node.DelegatingNode.forEachImmediateDelegate' call
              var node_3 = node_2.e9a_1;
              while (!(node_3 == null)) {
                var next_0 = node_3;
                // Inline function 'androidx.compose.ui.Node.isKind' call
                if (!((next_0.o8v_1 & _NodeKind___get_mask__impl__1uopb6(type)) === 0)) {
                  count_0 = count_0 + 1 | 0;
                  if (count_0 === 1) {
                    node_2 = next_0;
                  } else {
                    var tmp0_elvis_lhs_0 = stack_0;
                    var tmp_6;
                    if (tmp0_elvis_lhs_0 == null) {
                      // Inline function 'androidx.compose.runtime.collection.mutableVectorOf' call
                      // Inline function 'androidx.compose.runtime.collection.MutableVector' call
                      // Inline function 'kotlin.arrayOfNulls' call
                      var tmp$ret$30 = Array(16);
                      tmp_6 = new MutableVector(tmp$ret$30, 0);
                    } else {
                      tmp_6 = tmp0_elvis_lhs_0;
                    }
                    stack_0 = tmp_6;
                    var theNode_0 = node_2;
                    if (!(theNode_0 == null)) {
                      var tmp1_safe_receiver_0 = stack_0;
                      if (tmp1_safe_receiver_0 == null)
                        null;
                      else
                        tmp1_safe_receiver_0.zz(theNode_0);
                      node_2 = null;
                    }
                    var tmp2_safe_receiver_0 = stack_0;
                    if (tmp2_safe_receiver_0 == null)
                      null;
                    else
                      tmp2_safe_receiver_0.zz(next_0);
                  }
                }
                node_3 = node_3.r8v_1;
              }
              if (count_0 === 1) {
                continue $l$loop_2;
              }
            }
            node_2 = access$pop$tDelegatableNodeKt(stack_0);
          }
          break $l$loop_3;
        }
        node_1 = node_1.r8v_1;
      }
    }
    return false;
  }
  var androidx_compose_ui_focus_FocusRestorerNode$stable;
  function saveFocusedChild(_this__u8e3s4) {
    if (!_this__u8e3s4.x9c().r9h())
      return false;
    // Inline function 'androidx.compose.ui.node.Nodes.FocusTarget' call
    // Inline function 'androidx.compose.ui.node.visitChildren' call
    var type = _NodeKind___init__impl__ojsprp(1024);
    // Inline function 'androidx.compose.ui.node.visitChildren' call
    var mask = _NodeKind___get_mask__impl__1uopb6(type);
    // Inline function 'androidx.compose.ui.internal.checkPrecondition' call
    if (!_this__u8e3s4.f4n().z8v_1) {
      var tmp$ret$4 = 'visitChildren called on an unattached node';
      throwIllegalStateException(tmp$ret$4);
    }
    // Inline function 'androidx.compose.runtime.collection.mutableVectorOf' call
    // Inline function 'androidx.compose.runtime.collection.MutableVector' call
    // Inline function 'kotlin.arrayOfNulls' call
    var tmp$ret$7 = Array(16);
    var branches = new MutableVector(tmp$ret$7, 0);
    var child = _this__u8e3s4.f4n().r8v_1;
    if (child == null) {
      access$addLayoutNodeChildren$tDelegatableNodeKt(branches, _this__u8e3s4.f4n(), false);
    } else
      branches.zz(child);
    $l$loop_0: while (true) {
      // Inline function 'androidx.compose.runtime.collection.MutableVector.isNotEmpty' call
      if (!!(branches.d3e_1 === 0)) {
        break $l$loop_0;
      }
      // Inline function 'androidx.compose.runtime.collection.MutableVector.lastIndex' call
      var tmp$ret$9 = branches.d3e_1 - 1 | 0;
      var branch = branches.h3(tmp$ret$9);
      if ((branch.p8v_1 & mask) === 0) {
        access$addLayoutNodeChildren$tDelegatableNodeKt(branches, branch, false);
        continue $l$loop_0;
      }
      var node = branch;
      $l$loop_2: while (!(node == null)) {
        if (!((node.o8v_1 & mask) === 0)) {
          // Inline function 'androidx.compose.ui.node.dispatchForKind' call
          // Inline function 'androidx.compose.ui.node.dispatchForKind' call
          var stack = null;
          var node_0 = node;
          $l$loop_1: while (!(node_0 == null)) {
            var tmp;
            if (node_0 instanceof FocusTargetNode) {
              var child_0 = node_0;
              if (child_0.x9c().r9h()) {
                var previouslyFocusedChildHash = requireLayoutNode(child_0).d90_1;
                _this__u8e3s4.c9b_1 = previouslyFocusedChildHash;
                var saveableStateRegistry = currentValueOf(_this__u8e3s4, get_LocalSaveableStateRegistry());
                if (saveableStateRegistry == null)
                  null;
                else {
                  var tmp_0 = 'pfc' + requireLayoutNode(_this__u8e3s4).d90_1;
                  saveableStateRegistry.k7o(tmp_0, saveFocusedChild$lambda(previouslyFocusedChildHash));
                }
                return true;
              }
              tmp = false;
            } else {
              tmp = true;
            }
            var dispatchAgain = tmp;
            var tmp_1;
            var tmp_2;
            if (dispatchAgain || false) {
              // Inline function 'androidx.compose.ui.Node.isKind' call
              tmp_2 = !((node_0.o8v_1 & _NodeKind___get_mask__impl__1uopb6(type)) === 0);
            } else {
              tmp_2 = false;
            }
            if (tmp_2) {
              tmp_1 = node_0 instanceof DelegatingNode;
            } else {
              tmp_1 = false;
            }
            if (tmp_1) {
              var count = 0;
              // Inline function 'androidx.compose.ui.node.DelegatingNode.forEachImmediateDelegate' call
              var node_1 = node_0.e9a_1;
              while (!(node_1 == null)) {
                var next = node_1;
                // Inline function 'androidx.compose.ui.Node.isKind' call
                if (!((next.o8v_1 & _NodeKind___get_mask__impl__1uopb6(type)) === 0)) {
                  count = count + 1 | 0;
                  if (count === 1) {
                    node_0 = next;
                  } else {
                    var tmp0_elvis_lhs = stack;
                    var tmp_3;
                    if (tmp0_elvis_lhs == null) {
                      // Inline function 'androidx.compose.runtime.collection.mutableVectorOf' call
                      // Inline function 'androidx.compose.runtime.collection.MutableVector' call
                      // Inline function 'kotlin.arrayOfNulls' call
                      var tmp$ret$20 = Array(16);
                      tmp_3 = new MutableVector(tmp$ret$20, 0);
                    } else {
                      tmp_3 = tmp0_elvis_lhs;
                    }
                    stack = tmp_3;
                    var theNode = node_0;
                    if (!(theNode == null)) {
                      var tmp1_safe_receiver = stack;
                      if (tmp1_safe_receiver == null)
                        null;
                      else
                        tmp1_safe_receiver.zz(theNode);
                      node_0 = null;
                    }
                    var tmp2_safe_receiver = stack;
                    if (tmp2_safe_receiver == null)
                      null;
                    else
                      tmp2_safe_receiver.zz(next);
                  }
                }
                node_1 = node_1.r8v_1;
              }
              if (count === 1) {
                continue $l$loop_1;
              }
            }
            node_0 = access$pop$tDelegatableNodeKt(stack);
          }
          break $l$loop_2;
        }
        node = node.r8v_1;
      }
    }
    return false;
  }
  function saveFocusedChild$lambda($previouslyFocusedChildHash) {
    return function () {
      return $previouslyFocusedChildHash;
    };
  }
  var FocusStateImpl_Active_instance;
  var FocusStateImpl_ActiveParent_instance;
  var FocusStateImpl_Captured_instance;
  var FocusStateImpl_Inactive_instance;
  var FocusStateImpl_entriesInitialized;
  function FocusStateImpl_initEntries() {
    if (FocusStateImpl_entriesInitialized)
      return Unit_instance;
    FocusStateImpl_entriesInitialized = true;
    FocusStateImpl_Active_instance = new FocusStateImpl('Active', 0);
    FocusStateImpl_ActiveParent_instance = new FocusStateImpl('ActiveParent', 1);
    FocusStateImpl_Captured_instance = new FocusStateImpl('Captured', 2);
    FocusStateImpl_Inactive_instance = new FocusStateImpl('Inactive', 3);
  }
  function FocusStateImpl(name, ordinal) {
    Enum.call(this, name, ordinal);
  }
  protoOf(FocusStateImpl).s9h = function () {
    var tmp;
    switch (this.a1_1) {
      case 2:
      case 0:
        tmp = true;
        break;
      case 1:
      case 3:
        tmp = false;
        break;
      default:
        noWhenBranchMatchedException();
        break;
    }
    return tmp;
  };
  protoOf(FocusStateImpl).r9h = function () {
    var tmp;
    switch (this.a1_1) {
      case 0:
      case 1:
      case 2:
        tmp = true;
        break;
      case 3:
        tmp = false;
        break;
      default:
        noWhenBranchMatchedException();
        break;
    }
    return tmp;
  };
  function FocusStateImpl_Active_getInstance() {
    FocusStateImpl_initEntries();
    return FocusStateImpl_Active_instance;
  }
  function FocusStateImpl_ActiveParent_getInstance() {
    FocusStateImpl_initEntries();
    return FocusStateImpl_ActiveParent_instance;
  }
  function FocusStateImpl_Captured_getInstance() {
    FocusStateImpl_initEntries();
    return FocusStateImpl_Captured_instance;
  }
  function FocusStateImpl_Inactive_getInstance() {
    FocusStateImpl_initEntries();
    return FocusStateImpl_Inactive_instance;
  }
  function FocusTargetModifierNode() {
  }
  function funFocusTargetModifierNode2(focusability, onFocusChange) {
    focusability = focusability === VOID ? Companion_getInstance_33().j9e_1 : focusability;
    onFocusChange = onFocusChange === VOID ? null : onFocusChange;
    return new FocusTargetNode(focusability, VOID, onFocusChange);
  }
  function getFocusedRect(_this__u8e3s4) {
    if (!_this__u8e3s4.f4n().z8v_1)
      return null;
    var currentFocusState = _this__u8e3s4.x9c();
    if (!currentFocusState.r9h())
      return null;
    if (currentFocusState.s9h()) {
      return (_this__u8e3s4 instanceof FocusTargetNode ? _this__u8e3s4 : THROW_CCE()).t9h();
    }
    var tmp0_safe_receiver = requireOwner(_this__u8e3s4).o9c().v9c();
    return tmp0_safe_receiver == null ? null : tmp0_safe_receiver.u9h(requireLayoutCoordinates(_this__u8e3s4));
  }
  var androidx_compose_ui_focus_FocusTargetNode_FocusTargetElement$stable;
  var androidx_compose_ui_focus_FocusTargetNode$stable;
  function assignFocus($this, focusDirection) {
    var tmp;
    switch (performCustomRequestFocus($this, focusDirection).a1_1) {
      case 0:
        tmp = performRequestFocus($this);
        break;
      case 2:
        tmp = true;
        break;
      case 1:
      case 3:
        tmp = false;
        break;
      default:
        noWhenBranchMatchedException();
        break;
    }
    return tmp;
  }
  function access$_get_isProcessingCustomExit__f74o4h($this) {
    return $this.x9a_1;
  }
  function access$_set_isProcessingCustomExit__xkvxez($this, _set____db54di) {
    $this.x9a_1 = _set____db54di;
    return Unit_instance;
  }
  function access$_get_isProcessingCustomEnter__pxgf2f($this) {
    return $this.y9a_1;
  }
  function access$_set_isProcessingCustomEnter__omi8n9($this, _set____db54di) {
    $this.y9a_1 = _set____db54di;
    return Unit_instance;
  }
  function FocusTargetNode$requestFocus$lambda($focusDirection) {
    return function (it) {
      return assignFocus(it, $focusDirection);
    };
  }
  function FocusTargetNode$invalidateFocus$lambda($focusProperties, this$0) {
    return function () {
      $focusProperties._v = this$0.v9h();
      return Unit_instance;
    };
  }
  function FocusTargetNode(focusability, isInteropViewHost, onFocusChange, onDispatchEventsCompleted) {
    focusability = focusability === VOID ? Companion_getInstance_33().j9e_1 : focusability;
    isInteropViewHost = isInteropViewHost === VOID ? false : isInteropViewHost;
    onFocusChange = onFocusChange === VOID ? null : onFocusChange;
    onDispatchEventsCompleted = onDispatchEventsCompleted === VOID ? null : onDispatchEventsCompleted;
    Node.call(this);
    this.u9a_1 = isInteropViewHost;
    this.v9a_1 = onFocusChange;
    this.w9a_1 = onDispatchEventsCompleted;
    this.x9a_1 = false;
    this.y9a_1 = false;
    this.z9a_1 = null;
    this.a9b_1 = false;
    this.b9b_1 = focusability;
    this.c9b_1 = null;
  }
  protoOf(FocusTargetNode).b8w = function () {
    return this.a9b_1;
  };
  protoOf(FocusTargetNode).x9c = function () {
    if (!this.z8v_1)
      return FocusStateImpl_Inactive_getInstance();
    var focusOwner = requireOwner(this).o9c();
    var tmp0_elvis_lhs = focusOwner.v9c();
    var tmp;
    if (tmp0_elvis_lhs == null) {
      return FocusStateImpl_Inactive_getInstance();
    } else {
      tmp = tmp0_elvis_lhs;
    }
    var activeNode = tmp;
    var tmp_0;
    if (this === activeNode) {
      tmp_0 = focusOwner.r9d() ? FocusStateImpl_Captured_getInstance() : FocusStateImpl_Active_getInstance();
    } else {
      if (activeNode.z8v_1) {
        // Inline function 'androidx.compose.ui.node.Nodes.FocusTarget' call
        // Inline function 'androidx.compose.ui.node.visitAncestors' call
        var type = _NodeKind___init__impl__ojsprp(1024);
        // Inline function 'androidx.compose.ui.node.visitAncestors' call
        var mask = _NodeKind___get_mask__impl__1uopb6(type);
        // Inline function 'androidx.compose.ui.internal.checkPrecondition' call
        if (!activeNode.f4n().z8v_1) {
          var tmp$ret$4 = 'visitAncestors called on an unattached node';
          throwIllegalStateException(tmp$ret$4);
        }
        var node = false ? activeNode.f4n() : activeNode.f4n().q8v_1;
        var layout = requireLayoutNode(activeNode);
        while (!(layout == null)) {
          var head = layout.d91_1.j99_1;
          if (!((head.p8v_1 & mask) === 0)) {
            while (!(node == null)) {
              if (!((node.o8v_1 & mask) === 0)) {
                // Inline function 'androidx.compose.ui.node.dispatchForKind' call
                var stack = null;
                var node_0 = node;
                $l$loop: while (!(node_0 == null)) {
                  var tmp_1;
                  if (node_0 instanceof FocusTargetNode) {
                    if (this === node_0)
                      return FocusStateImpl_ActiveParent_getInstance();
                    tmp_1 = false;
                  } else {
                    tmp_1 = true;
                  }
                  var dispatchAgain = tmp_1;
                  var tmp_2;
                  var tmp_3;
                  if (dispatchAgain || false) {
                    // Inline function 'androidx.compose.ui.Node.isKind' call
                    tmp_3 = !((node_0.o8v_1 & _NodeKind___get_mask__impl__1uopb6(type)) === 0);
                  } else {
                    tmp_3 = false;
                  }
                  if (tmp_3) {
                    tmp_2 = node_0 instanceof DelegatingNode;
                  } else {
                    tmp_2 = false;
                  }
                  if (tmp_2) {
                    var count = 0;
                    // Inline function 'androidx.compose.ui.node.DelegatingNode.forEachImmediateDelegate' call
                    var node_1 = node_0.e9a_1;
                    while (!(node_1 == null)) {
                      var next = node_1;
                      // Inline function 'androidx.compose.ui.Node.isKind' call
                      if (!((next.o8v_1 & _NodeKind___get_mask__impl__1uopb6(type)) === 0)) {
                        count = count + 1 | 0;
                        if (count === 1) {
                          node_0 = next;
                        } else {
                          var tmp0_elvis_lhs_0 = stack;
                          var tmp_4;
                          if (tmp0_elvis_lhs_0 == null) {
                            // Inline function 'androidx.compose.runtime.collection.mutableVectorOf' call
                            // Inline function 'androidx.compose.runtime.collection.MutableVector' call
                            // Inline function 'kotlin.arrayOfNulls' call
                            var tmp$ret$14 = Array(16);
                            tmp_4 = new MutableVector(tmp$ret$14, 0);
                          } else {
                            tmp_4 = tmp0_elvis_lhs_0;
                          }
                          stack = tmp_4;
                          var theNode = node_0;
                          if (!(theNode == null)) {
                            var tmp1_safe_receiver = stack;
                            if (tmp1_safe_receiver == null)
                              null;
                            else
                              tmp1_safe_receiver.zz(theNode);
                            node_0 = null;
                          }
                          var tmp2_safe_receiver = stack;
                          if (tmp2_safe_receiver == null)
                            null;
                          else
                            tmp2_safe_receiver.zz(next);
                        }
                      }
                      node_1 = node_1.r8v_1;
                    }
                    if (count === 1) {
                      continue $l$loop;
                    }
                  }
                  node_0 = access$pop$tDelegatableNodeKt(stack);
                }
              }
              node = node.q8v_1;
            }
          }
          layout = layout.f9a();
          var tmp0_safe_receiver = layout;
          var tmp1_safe_receiver_0 = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.d91_1;
          node = tmp1_safe_receiver_0 == null ? null : tmp1_safe_receiver_0.i99_1;
        }
      }
      tmp_0 = FocusStateImpl_Inactive_getInstance();
    }
    return tmp_0;
  };
  protoOf(FocusTargetNode).i9e = function (focusDirection) {
    // Inline function 'androidx.compose.ui.util.trace' call
    if (this.v9h().a9f()) {
      return assignFocus(this, focusDirection);
    } else {
      return findChildCorrespondingToFocusEnter(this, focusDirection, FocusTargetNode$requestFocus$lambda(focusDirection));
    }
  };
  protoOf(FocusTargetNode).d9b = function () {
    return findNearestBeyondBoundsLayoutAncestor(this);
  };
  protoOf(FocusTargetNode).w95 = function () {
    this.w9c();
  };
  protoOf(FocusTargetNode).k8w = function () {
    if (this.x9c().s9h()) {
      requireOwner(this).o9c().l9d(true, true, true, Companion_getInstance_30().r9b_1);
    }
  };
  protoOf(FocusTargetNode).h8w = function () {
    switch (this.x9c().a1_1) {
      case 0:
      case 2:
        var focusOwner = requireOwner(this).o9c();
        focusOwner.l9d(true, true, false, Companion_getInstance_30().r9b_1);
        if (this.u9a_1) {
          focusOwner.k9d(null, null);
        }

        focusOwner.p9d();
        break;
      case 1:
        var focusOwner_0 = requireOwner(this).o9c();
        var tmp1_safe_receiver = findActiveFocusNode(this);
        if ((tmp1_safe_receiver == null ? null : tmp1_safe_receiver.u9a_1) === true) {
          focusOwner_0.k9d(null, null);
          focusOwner_0.p9d();
        }

        break;
      case 3:
        break;
      default:
        noWhenBranchMatchedException();
        break;
    }
    this.z9a_1 = null;
    this.c9b_1 = null;
  };
  protoOf(FocusTargetNode).x91 = function (coordinates) {
    if (ComposeUiFlags_instance.t8u_1) {
      requireOwner(this.m8v_1).o9c().o9d();
    }
  };
  protoOf(FocusTargetNode).v9h = function () {
    var properties = new FocusPropertiesImpl();
    properties.d9g_1 = Focusability__canFocus_impl_2zet2l(this.b9b_1, this);
    // Inline function 'androidx.compose.ui.node.Nodes.FocusProperties' call
    var tmp2 = _NodeKind___init__impl__ojsprp(2048);
    // Inline function 'androidx.compose.ui.node.Nodes.FocusTarget' call
    var tmp4 = _NodeKind___init__impl__ojsprp(1024);
    $l$block: {
      // Inline function 'androidx.compose.ui.node.visitSelfAndAncestors' call
      var self_0 = this.f4n();
      // Inline function 'androidx.compose.ui.node.visitAncestors' call
      var mask = _NodeKind___get_mask__impl__1uopb6(tmp2) | _NodeKind___get_mask__impl__1uopb6(tmp4);
      // Inline function 'androidx.compose.ui.internal.checkPrecondition' call
      if (!this.f4n().z8v_1) {
        var tmp$ret$5 = 'visitAncestors called on an unattached node';
        throwIllegalStateException(tmp$ret$5);
      }
      var node = true ? this.f4n() : this.f4n().q8v_1;
      var layout = requireLayoutNode(this);
      while (!(layout == null)) {
        var head = layout.d91_1.j99_1;
        if (!((head.p8v_1 & mask) === 0)) {
          while (!(node == null)) {
            if (!((node.o8v_1 & mask) === 0)) {
              var it = node;
              var tmp;
              if (!(it === self_0)) {
                // Inline function 'androidx.compose.ui.Node.isKind' call
                tmp = !((it.o8v_1 & _NodeKind___get_mask__impl__1uopb6(tmp4)) === 0);
              } else {
                tmp = false;
              }
              if (tmp) {
                break $l$block;
              }
              // Inline function 'androidx.compose.ui.Node.isKind' call
              if (!((it.o8v_1 & _NodeKind___get_mask__impl__1uopb6(tmp2)) === 0)) {
                // Inline function 'androidx.compose.ui.node.dispatchForKind' call
                // Inline function 'androidx.compose.ui.node.dispatchForKind' call
                var stack = null;
                var node_0 = it;
                $l$loop: while (!(node_0 == null)) {
                  var tmp_0;
                  if (isInterface(node_0, FocusPropertiesModifierNode)) {
                    node_0.c9g(properties);
                    tmp_0 = false;
                  } else {
                    tmp_0 = true;
                  }
                  var dispatchAgain = tmp_0;
                  var tmp_1;
                  var tmp_2;
                  if (dispatchAgain || false) {
                    // Inline function 'androidx.compose.ui.Node.isKind' call
                    tmp_2 = !((node_0.o8v_1 & _NodeKind___get_mask__impl__1uopb6(tmp2)) === 0);
                  } else {
                    tmp_2 = false;
                  }
                  if (tmp_2) {
                    tmp_1 = node_0 instanceof DelegatingNode;
                  } else {
                    tmp_1 = false;
                  }
                  if (tmp_1) {
                    var count = 0;
                    // Inline function 'androidx.compose.ui.node.DelegatingNode.forEachImmediateDelegate' call
                    var node_1 = node_0.e9a_1;
                    while (!(node_1 == null)) {
                      var next = node_1;
                      // Inline function 'androidx.compose.ui.Node.isKind' call
                      if (!((next.o8v_1 & _NodeKind___get_mask__impl__1uopb6(tmp2)) === 0)) {
                        count = count + 1 | 0;
                        if (count === 1) {
                          node_0 = next;
                        } else {
                          var tmp0_elvis_lhs = stack;
                          var tmp_3;
                          if (tmp0_elvis_lhs == null) {
                            // Inline function 'androidx.compose.runtime.collection.mutableVectorOf' call
                            // Inline function 'androidx.compose.runtime.collection.MutableVector' call
                            // Inline function 'kotlin.arrayOfNulls' call
                            var tmp$ret$18 = Array(16);
                            tmp_3 = new MutableVector(tmp$ret$18, 0);
                          } else {
                            tmp_3 = tmp0_elvis_lhs;
                          }
                          stack = tmp_3;
                          var theNode = node_0;
                          if (!(theNode == null)) {
                            var tmp1_safe_receiver = stack;
                            if (tmp1_safe_receiver == null)
                              null;
                            else
                              tmp1_safe_receiver.zz(theNode);
                            node_0 = null;
                          }
                          var tmp2_safe_receiver = stack;
                          if (tmp2_safe_receiver == null)
                            null;
                          else
                            tmp2_safe_receiver.zz(next);
                        }
                      }
                      node_1 = node_1.r8v_1;
                    }
                    if (count === 1) {
                      continue $l$loop;
                    }
                  }
                  node_0 = access$pop$tDelegatableNodeKt(stack);
                }
              }
            }
            node = node.q8v_1;
          }
        }
        layout = layout.f9a();
        var tmp0_safe_receiver = layout;
        var tmp1_safe_receiver_0 = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.d91_1;
        node = tmp1_safe_receiver_0 == null ? null : tmp1_safe_receiver_0.i99_1;
      }
    }
    return properties;
  };
  protoOf(FocusTargetNode).u9h = function (relativeCoordinates) {
    var customRect = this.v9h().j9f();
    if (!(customRect === Companion_getInstance_31().z9e_1)) {
      if (relativeCoordinates == null)
        return customRect;
      return customRect.p5d(relativeCoordinates.w9h(requireLayoutCoordinates(this)));
    }
    var tmp1_elvis_lhs = relativeCoordinates == null ? null : relativeCoordinates.x9h(requireLayoutCoordinates(this), false);
    return tmp1_elvis_lhs == null ? Rect_0(Companion_getInstance().g5d_1, toSize(requireLayoutCoordinates(this).q95())) : tmp1_elvis_lhs;
  };
  protoOf(FocusTargetNode).t9h = function (relativeCoordinates, $super) {
    relativeCoordinates = relativeCoordinates === VOID ? null : relativeCoordinates;
    return $super === VOID ? this.u9h(relativeCoordinates) : $super.u9h.call(this, relativeCoordinates);
  };
  protoOf(FocusTargetNode).w9c = function () {
    switch (this.x9c().a1_1) {
      case 0:
      case 2:
        var focusProperties = {_v: null};
        observeReads(this, FocusTargetNode$invalidateFocus$lambda(focusProperties, this));
        var tmp;
        if (focusProperties._v == null) {
          throwUninitializedPropertyAccessException('focusProperties');
        } else {
          tmp = focusProperties._v;
        }

        if (!tmp.a9f()) {
          requireOwner(this).o9c().d9d(true);
        }

        break;
      case 1:
      case 3:
        break;
      default:
        noWhenBranchMatchedException();
        break;
    }
  };
  protoOf(FocusTargetNode).b9e = function (previousState, newState) {
    var focusOwner = requireOwner(this).o9c();
    var activeNode = focusOwner.v9c();
    if (!equals(previousState, newState)) {
      var tmp0_safe_receiver = this.v9a_1;
      if (tmp0_safe_receiver == null)
        null;
      else
        tmp0_safe_receiver(previousState, newState);
    }
    // Inline function 'androidx.compose.ui.node.Nodes.FocusEvent' call
    var tmp2 = _NodeKind___init__impl__ojsprp(4096);
    // Inline function 'androidx.compose.ui.node.Nodes.FocusTarget' call
    var tmp4 = _NodeKind___init__impl__ojsprp(1024);
    $l$block: {
      // Inline function 'androidx.compose.ui.node.visitSelfAndAncestors' call
      var self_0 = this.f4n();
      // Inline function 'androidx.compose.ui.node.visitAncestors' call
      var mask = _NodeKind___get_mask__impl__1uopb6(tmp2) | _NodeKind___get_mask__impl__1uopb6(tmp4);
      // Inline function 'androidx.compose.ui.internal.checkPrecondition' call
      if (!this.f4n().z8v_1) {
        var tmp$ret$5 = 'visitAncestors called on an unattached node';
        throwIllegalStateException(tmp$ret$5);
      }
      var node = true ? this.f4n() : this.f4n().q8v_1;
      var layout = requireLayoutNode(this);
      while (!(layout == null)) {
        var head = layout.d91_1.j99_1;
        if (!((head.p8v_1 & mask) === 0)) {
          while (!(node == null)) {
            if (!((node.o8v_1 & mask) === 0)) {
              var it = node;
              var tmp;
              if (!(it === self_0)) {
                // Inline function 'androidx.compose.ui.Node.isKind' call
                tmp = !((it.o8v_1 & _NodeKind___get_mask__impl__1uopb6(tmp4)) === 0);
              } else {
                tmp = false;
              }
              if (tmp) {
                break $l$block;
              }
              // Inline function 'androidx.compose.ui.Node.isKind' call
              if (!((it.o8v_1 & _NodeKind___get_mask__impl__1uopb6(tmp2)) === 0)) {
                // Inline function 'androidx.compose.ui.node.dispatchForKind' call
                // Inline function 'androidx.compose.ui.node.dispatchForKind' call
                var stack = null;
                var node_0 = it;
                $l$loop: while (!(node_0 == null)) {
                  var tmp_0;
                  if (isInterface(node_0, FocusEventModifierNode)) {
                    var tmp0 = node_0;
                    $l$block_0: {
                      if (!(activeNode === focusOwner.v9c())) {
                        break $l$block_0;
                      }
                      tmp0.m9c(newState);
                    }
                    tmp_0 = false;
                  } else {
                    tmp_0 = true;
                  }
                  var dispatchAgain = tmp_0;
                  var tmp_1;
                  var tmp_2;
                  if (dispatchAgain || false) {
                    // Inline function 'androidx.compose.ui.Node.isKind' call
                    tmp_2 = !((node_0.o8v_1 & _NodeKind___get_mask__impl__1uopb6(tmp2)) === 0);
                  } else {
                    tmp_2 = false;
                  }
                  if (tmp_2) {
                    tmp_1 = node_0 instanceof DelegatingNode;
                  } else {
                    tmp_1 = false;
                  }
                  if (tmp_1) {
                    var count = 0;
                    // Inline function 'androidx.compose.ui.node.DelegatingNode.forEachImmediateDelegate' call
                    var node_1 = node_0.e9a_1;
                    while (!(node_1 == null)) {
                      var next = node_1;
                      // Inline function 'androidx.compose.ui.Node.isKind' call
                      if (!((next.o8v_1 & _NodeKind___get_mask__impl__1uopb6(tmp2)) === 0)) {
                        count = count + 1 | 0;
                        if (count === 1) {
                          node_0 = next;
                        } else {
                          var tmp0_elvis_lhs = stack;
                          var tmp_3;
                          if (tmp0_elvis_lhs == null) {
                            // Inline function 'androidx.compose.runtime.collection.mutableVectorOf' call
                            // Inline function 'androidx.compose.runtime.collection.MutableVector' call
                            // Inline function 'kotlin.arrayOfNulls' call
                            var tmp$ret$18 = Array(16);
                            tmp_3 = new MutableVector(tmp$ret$18, 0);
                          } else {
                            tmp_3 = tmp0_elvis_lhs;
                          }
                          stack = tmp_3;
                          var theNode = node_0;
                          if (!(theNode == null)) {
                            var tmp1_safe_receiver = stack;
                            if (tmp1_safe_receiver == null)
                              null;
                            else
                              tmp1_safe_receiver.zz(theNode);
                            node_0 = null;
                          }
                          var tmp2_safe_receiver = stack;
                          if (tmp2_safe_receiver == null)
                            null;
                          else
                            tmp2_safe_receiver.zz(next);
                        }
                      }
                      node_1 = node_1.r8v_1;
                    }
                    if (count === 1) {
                      continue $l$loop;
                    }
                  }
                  node_0 = access$pop$tDelegatableNodeKt(stack);
                }
              }
            }
            node = node.q8v_1;
          }
        }
        layout = layout.f9a();
        var tmp0_safe_receiver_0 = layout;
        var tmp1_safe_receiver_0 = tmp0_safe_receiver_0 == null ? null : tmp0_safe_receiver_0.d91_1;
        node = tmp1_safe_receiver_0 == null ? null : tmp1_safe_receiver_0.i99_1;
      }
    }
    var tmp1_safe_receiver_1 = this.w9a_1;
    if (tmp1_safe_receiver_1 == null)
      null;
    else
      tmp1_safe_receiver_1(this);
  };
  function invalidateFocusTarget(_this__u8e3s4) {
    requireOwner(_this__u8e3s4).o9c().a9d(_this__u8e3s4);
  }
  var CustomDestinationResult_None_instance;
  var CustomDestinationResult_Cancelled_instance;
  var CustomDestinationResult_Redirected_instance;
  var CustomDestinationResult_RedirectCancelled_instance;
  var CustomDestinationResult_entriesInitialized;
  function CustomDestinationResult_initEntries() {
    if (CustomDestinationResult_entriesInitialized)
      return Unit_instance;
    CustomDestinationResult_entriesInitialized = true;
    CustomDestinationResult_None_instance = new CustomDestinationResult('None', 0);
    CustomDestinationResult_Cancelled_instance = new CustomDestinationResult('Cancelled', 1);
    CustomDestinationResult_Redirected_instance = new CustomDestinationResult('Redirected', 2);
    CustomDestinationResult_RedirectCancelled_instance = new CustomDestinationResult('RedirectCancelled', 3);
  }
  function CustomDestinationResult(name, ordinal) {
    Enum.call(this, name, ordinal);
  }
  function performCustomRequestFocus(_this__u8e3s4, focusDirection) {
    switch (_this__u8e3s4.x9c().a1_1) {
      case 0:
      case 2:
        return CustomDestinationResult_None_getInstance();
      case 1:
        return performCustomClearFocus(requireActiveChild(_this__u8e3s4), focusDirection);
      case 3:
        // Inline function 'androidx.compose.ui.node.Nodes.FocusTarget' call

        var tmp2 = _NodeKind___init__impl__ojsprp(1024);
        var tmp$ret$1;
        $l$block: {
          // Inline function 'androidx.compose.ui.node.nearestAncestor' call
          // Inline function 'androidx.compose.ui.node.visitAncestors' call
          // Inline function 'androidx.compose.ui.node.visitAncestors' call
          var mask = _NodeKind___get_mask__impl__1uopb6(tmp2);
          // Inline function 'androidx.compose.ui.internal.checkPrecondition' call
          if (!_this__u8e3s4.f4n().z8v_1) {
            var tmp$ret$5 = 'visitAncestors called on an unattached node';
            throwIllegalStateException(tmp$ret$5);
          }
          var node = false ? _this__u8e3s4.f4n() : _this__u8e3s4.f4n().q8v_1;
          var layout = requireLayoutNode(_this__u8e3s4);
          while (!(layout == null)) {
            var head = layout.d91_1.j99_1;
            if (!((head.p8v_1 & mask) === 0)) {
              while (!(node == null)) {
                if (!((node.o8v_1 & mask) === 0)) {
                  // Inline function 'androidx.compose.ui.node.dispatchForKind' call
                  var stack = null;
                  var node_0 = node;
                  $l$loop: while (!(node_0 == null)) {
                    var tmp;
                    if (node_0 instanceof FocusTargetNode) {
                      tmp$ret$1 = node_0;
                      break $l$block;
                    } else {
                      tmp = true;
                    }
                    var dispatchAgain = tmp;
                    var tmp_0;
                    var tmp_1;
                    if (dispatchAgain || false) {
                      // Inline function 'androidx.compose.ui.Node.isKind' call
                      tmp_1 = !((node_0.o8v_1 & _NodeKind___get_mask__impl__1uopb6(tmp2)) === 0);
                    } else {
                      tmp_1 = false;
                    }
                    if (tmp_1) {
                      tmp_0 = node_0 instanceof DelegatingNode;
                    } else {
                      tmp_0 = false;
                    }
                    if (tmp_0) {
                      var count = 0;
                      // Inline function 'androidx.compose.ui.node.DelegatingNode.forEachImmediateDelegate' call
                      var node_1 = node_0.e9a_1;
                      while (!(node_1 == null)) {
                        var next = node_1;
                        // Inline function 'androidx.compose.ui.Node.isKind' call
                        if (!((next.o8v_1 & _NodeKind___get_mask__impl__1uopb6(tmp2)) === 0)) {
                          count = count + 1 | 0;
                          if (count === 1) {
                            node_0 = next;
                          } else {
                            var tmp0_elvis_lhs = stack;
                            var tmp_2;
                            if (tmp0_elvis_lhs == null) {
                              // Inline function 'androidx.compose.runtime.collection.mutableVectorOf' call
                              // Inline function 'androidx.compose.runtime.collection.MutableVector' call
                              // Inline function 'kotlin.arrayOfNulls' call
                              var tmp$ret$15 = Array(16);
                              tmp_2 = new MutableVector(tmp$ret$15, 0);
                            } else {
                              tmp_2 = tmp0_elvis_lhs;
                            }
                            stack = tmp_2;
                            var theNode = node_0;
                            if (!(theNode == null)) {
                              var tmp1_safe_receiver = stack;
                              if (tmp1_safe_receiver == null)
                                null;
                              else
                                tmp1_safe_receiver.zz(theNode);
                              node_0 = null;
                            }
                            var tmp2_safe_receiver = stack;
                            if (tmp2_safe_receiver == null)
                              null;
                            else
                              tmp2_safe_receiver.zz(next);
                          }
                        }
                        node_1 = node_1.r8v_1;
                      }
                      if (count === 1) {
                        continue $l$loop;
                      }
                    }
                    node_0 = access$pop$tDelegatableNodeKt(stack);
                  }
                }
                node = node.q8v_1;
              }
            }
            layout = layout.f9a();
            var tmp0_safe_receiver = layout;
            var tmp1_safe_receiver_0 = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.d91_1;
            node = tmp1_safe_receiver_0 == null ? null : tmp1_safe_receiver_0.i99_1;
          }
          tmp$ret$1 = null;
        }

        var tmp1_elvis_lhs = tmp$ret$1;
        var tmp_3;
        if (tmp1_elvis_lhs == null) {
          return CustomDestinationResult_None_getInstance();
        } else {
          tmp_3 = tmp1_elvis_lhs;
        }

        var focusParent = tmp_3;
        var tmp_4;
        switch (focusParent.x9c().a1_1) {
          case 2:
            tmp_4 = CustomDestinationResult_Cancelled_getInstance();
            break;
          case 1:
            tmp_4 = performCustomRequestFocus(focusParent, focusDirection);
            break;
          case 0:
            tmp_4 = performCustomEnter(focusParent, focusDirection);
            break;
          case 3:
            // Inline function 'kotlin.takeUnless' call

            var this_0 = performCustomRequestFocus(focusParent, focusDirection);
            var tmp_5;
            if (!this_0.equals(CustomDestinationResult_None_getInstance())) {
              tmp_5 = this_0;
            } else {
              tmp_5 = null;
            }

            var tmp3_elvis_lhs = tmp_5;
            tmp_4 = tmp3_elvis_lhs == null ? performCustomEnter(focusParent, focusDirection) : tmp3_elvis_lhs;
            break;
          default:
            noWhenBranchMatchedException();
            break;
        }

        return tmp_4;
      default:
        noWhenBranchMatchedException();
        break;
    }
  }
  function performRequestFocus(_this__u8e3s4) {
    var focusOwner = requireOwner(_this__u8e3s4).o9c();
    var previousActiveNode = focusOwner.v9c();
    var previousFocusState = _this__u8e3s4.x9c();
    if (previousActiveNode === _this__u8e3s4) {
      _this__u8e3s4.b9e(previousFocusState, previousFocusState);
      return true;
    }
    if (ComposeUiFlags_instance.s8u_1) {
      var tmp;
      if (!((previousActiveNode == null ? null : previousActiveNode.u9a_1) === false)) {
        tmp = !_this__u8e3s4.u9a_1;
      } else {
        tmp = false;
      }
      if (tmp) {
        if (!requestOwnerFocus(_this__u8e3s4))
          return false;
      }
    } else {
      if (previousActiveNode == null && !requestOwnerFocus(_this__u8e3s4)) {
        return false;
      }
    }
    var previousAncestorTargetNodes = null;
    if (!(previousActiveNode == null)) {
      // Inline function 'androidx.compose.runtime.collection.mutableVectorOf' call
      // Inline function 'androidx.compose.runtime.collection.MutableVector' call
      // Inline function 'kotlin.arrayOfNulls' call
      var tmp$ret$2 = Array(16);
      previousAncestorTargetNodes = new MutableVector(tmp$ret$2, 0);
      // Inline function 'androidx.compose.ui.node.Nodes.FocusTarget' call
      // Inline function 'androidx.compose.ui.node.visitAncestors' call
      var type = _NodeKind___init__impl__ojsprp(1024);
      // Inline function 'androidx.compose.ui.node.visitAncestors' call
      var mask = _NodeKind___get_mask__impl__1uopb6(type);
      // Inline function 'androidx.compose.ui.internal.checkPrecondition' call
      if (!previousActiveNode.f4n().z8v_1) {
        var tmp$ret$7 = 'visitAncestors called on an unattached node';
        throwIllegalStateException(tmp$ret$7);
      }
      var node = false ? previousActiveNode.f4n() : previousActiveNode.f4n().q8v_1;
      var layout = requireLayoutNode(previousActiveNode);
      while (!(layout == null)) {
        var head = layout.d91_1.j99_1;
        if (!((head.p8v_1 & mask) === 0)) {
          while (!(node == null)) {
            if (!((node.o8v_1 & mask) === 0)) {
              // Inline function 'androidx.compose.ui.node.dispatchForKind' call
              var stack = null;
              var node_0 = node;
              $l$loop: while (!(node_0 == null)) {
                var tmp_0;
                if (node_0 instanceof FocusTargetNode) {
                  var it = node_0;
                  previousAncestorTargetNodes.zz(it);
                  tmp_0 = false;
                } else {
                  tmp_0 = true;
                }
                var dispatchAgain = tmp_0;
                var tmp_1;
                var tmp_2;
                if (dispatchAgain || false) {
                  // Inline function 'androidx.compose.ui.Node.isKind' call
                  tmp_2 = !((node_0.o8v_1 & _NodeKind___get_mask__impl__1uopb6(type)) === 0);
                } else {
                  tmp_2 = false;
                }
                if (tmp_2) {
                  tmp_1 = node_0 instanceof DelegatingNode;
                } else {
                  tmp_1 = false;
                }
                if (tmp_1) {
                  var count = 0;
                  // Inline function 'androidx.compose.ui.node.DelegatingNode.forEachImmediateDelegate' call
                  var node_1 = node_0.e9a_1;
                  while (!(node_1 == null)) {
                    var next = node_1;
                    // Inline function 'androidx.compose.ui.Node.isKind' call
                    if (!((next.o8v_1 & _NodeKind___get_mask__impl__1uopb6(type)) === 0)) {
                      count = count + 1 | 0;
                      if (count === 1) {
                        node_0 = next;
                      } else {
                        var tmp0_elvis_lhs = stack;
                        var tmp_3;
                        if (tmp0_elvis_lhs == null) {
                          // Inline function 'androidx.compose.runtime.collection.mutableVectorOf' call
                          // Inline function 'androidx.compose.runtime.collection.MutableVector' call
                          // Inline function 'kotlin.arrayOfNulls' call
                          var tmp$ret$17 = Array(16);
                          tmp_3 = new MutableVector(tmp$ret$17, 0);
                        } else {
                          tmp_3 = tmp0_elvis_lhs;
                        }
                        stack = tmp_3;
                        var theNode = node_0;
                        if (!(theNode == null)) {
                          var tmp1_safe_receiver = stack;
                          if (tmp1_safe_receiver == null)
                            null;
                          else
                            tmp1_safe_receiver.zz(theNode);
                          node_0 = null;
                        }
                        var tmp2_safe_receiver = stack;
                        if (tmp2_safe_receiver == null)
                          null;
                        else
                          tmp2_safe_receiver.zz(next);
                      }
                    }
                    node_1 = node_1.r8v_1;
                  }
                  if (count === 1) {
                    continue $l$loop;
                  }
                }
                node_0 = access$pop$tDelegatableNodeKt(stack);
              }
            }
            node = node.q8v_1;
          }
        }
        layout = layout.f9a();
        var tmp0_safe_receiver = layout;
        var tmp1_safe_receiver_0 = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.d91_1;
        node = tmp1_safe_receiver_0 == null ? null : tmp1_safe_receiver_0.i99_1;
      }
    }
    var shouldClearFocusFromPreviousActiveNode = true;
    // Inline function 'androidx.compose.runtime.collection.mutableVectorOf' call
    // Inline function 'androidx.compose.runtime.collection.MutableVector' call
    // Inline function 'kotlin.arrayOfNulls' call
    var tmp$ret$20 = Array(16);
    var commonAncestorTargetNodes = new MutableVector(tmp$ret$20, 0);
    // Inline function 'androidx.compose.runtime.collection.mutableVectorOf' call
    // Inline function 'androidx.compose.runtime.collection.MutableVector' call
    // Inline function 'kotlin.arrayOfNulls' call
    var tmp$ret$23 = Array(16);
    var ancestorTargetNodes = new MutableVector(tmp$ret$23, 0);
    // Inline function 'androidx.compose.ui.node.Nodes.FocusTarget' call
    // Inline function 'androidx.compose.ui.node.visitAncestors' call
    var type_0 = _NodeKind___init__impl__ojsprp(1024);
    // Inline function 'androidx.compose.ui.node.visitAncestors' call
    var mask_0 = _NodeKind___get_mask__impl__1uopb6(type_0);
    // Inline function 'androidx.compose.ui.internal.checkPrecondition' call
    if (!_this__u8e3s4.f4n().z8v_1) {
      var tmp$ret$28 = 'visitAncestors called on an unattached node';
      throwIllegalStateException(tmp$ret$28);
    }
    var node_2 = false ? _this__u8e3s4.f4n() : _this__u8e3s4.f4n().q8v_1;
    var layout_0 = requireLayoutNode(_this__u8e3s4);
    while (!(layout_0 == null)) {
      var head_0 = layout_0.d91_1.j99_1;
      if (!((head_0.p8v_1 & mask_0) === 0)) {
        while (!(node_2 == null)) {
          if (!((node_2.o8v_1 & mask_0) === 0)) {
            // Inline function 'androidx.compose.ui.node.dispatchForKind' call
            var stack_0 = null;
            var node_3 = node_2;
            $l$loop_0: while (!(node_3 == null)) {
              var tmp_4;
              if (node_3 instanceof FocusTargetNode) {
                var it_0 = node_3;
                var tmp0_safe_receiver_0 = previousAncestorTargetNodes;
                var removed = tmp0_safe_receiver_0 == null ? null : tmp0_safe_receiver_0.g10(it_0);
                if (removed === true) {
                  commonAncestorTargetNodes.zz(it_0);
                } else {
                  ancestorTargetNodes.zz(it_0);
                }
                if (it_0 === previousActiveNode)
                  shouldClearFocusFromPreviousActiveNode = false;
                tmp_4 = false;
              } else {
                tmp_4 = true;
              }
              var dispatchAgain_0 = tmp_4;
              var tmp_5;
              var tmp_6;
              if (dispatchAgain_0 || false) {
                // Inline function 'androidx.compose.ui.Node.isKind' call
                tmp_6 = !((node_3.o8v_1 & _NodeKind___get_mask__impl__1uopb6(type_0)) === 0);
              } else {
                tmp_6 = false;
              }
              if (tmp_6) {
                tmp_5 = node_3 instanceof DelegatingNode;
              } else {
                tmp_5 = false;
              }
              if (tmp_5) {
                var count_0 = 0;
                // Inline function 'androidx.compose.ui.node.DelegatingNode.forEachImmediateDelegate' call
                var node_4 = node_3.e9a_1;
                while (!(node_4 == null)) {
                  var next_0 = node_4;
                  // Inline function 'androidx.compose.ui.Node.isKind' call
                  if (!((next_0.o8v_1 & _NodeKind___get_mask__impl__1uopb6(type_0)) === 0)) {
                    count_0 = count_0 + 1 | 0;
                    if (count_0 === 1) {
                      node_3 = next_0;
                    } else {
                      var tmp0_elvis_lhs_0 = stack_0;
                      var tmp_7;
                      if (tmp0_elvis_lhs_0 == null) {
                        // Inline function 'androidx.compose.runtime.collection.mutableVectorOf' call
                        // Inline function 'androidx.compose.runtime.collection.MutableVector' call
                        // Inline function 'kotlin.arrayOfNulls' call
                        var tmp$ret$38 = Array(16);
                        tmp_7 = new MutableVector(tmp$ret$38, 0);
                      } else {
                        tmp_7 = tmp0_elvis_lhs_0;
                      }
                      stack_0 = tmp_7;
                      var theNode_0 = node_3;
                      if (!(theNode_0 == null)) {
                        var tmp1_safe_receiver_1 = stack_0;
                        if (tmp1_safe_receiver_1 == null)
                          null;
                        else
                          tmp1_safe_receiver_1.zz(theNode_0);
                        node_3 = null;
                      }
                      var tmp2_safe_receiver_0 = stack_0;
                      if (tmp2_safe_receiver_0 == null)
                        null;
                      else
                        tmp2_safe_receiver_0.zz(next_0);
                    }
                  }
                  node_4 = node_4.r8v_1;
                }
                if (count_0 === 1) {
                  continue $l$loop_0;
                }
              }
              node_3 = access$pop$tDelegatableNodeKt(stack_0);
            }
          }
          node_2 = node_2.q8v_1;
        }
      }
      layout_0 = layout_0.f9a();
      var tmp0_safe_receiver_1 = layout_0;
      var tmp1_safe_receiver_2 = tmp0_safe_receiver_1 == null ? null : tmp0_safe_receiver_1.d91_1;
      node_2 = tmp1_safe_receiver_2 == null ? null : tmp1_safe_receiver_2.i99_1;
    }
    if (shouldClearFocusFromPreviousActiveNode) {
      if ((previousActiveNode == null ? null : clearFocus_0(previousActiveNode, VOID, true)) === false) {
        return false;
      }
    }
    grantFocus(_this__u8e3s4);
    if (ComposeUiFlags_instance.w8u_1 && shouldClearFocusFromPreviousActiveNode) {
      if (previousActiveNode == null)
        null;
      else {
        previousActiveNode.b9e(FocusStateImpl_Active_getInstance(), FocusStateImpl_Inactive_getInstance());
      }
    }
    var tmp3_safe_receiver = previousAncestorTargetNodes;
    if (tmp3_safe_receiver == null)
      null;
    else {
      $l$block: {
        // Inline function 'androidx.compose.runtime.collection.MutableVector.forEachReversed' call
        var i = tmp3_safe_receiver.d3e_1 - 1 | 0;
        var tmp_8 = tmp3_safe_receiver.b3e_1;
        var content = isArray(tmp_8) ? tmp_8 : THROW_CCE();
        if (i >= content.length) {
          break $l$block;
        }
        while (i >= 0) {
          var it_1 = content[i];
          if (!(focusOwner.v9c() === _this__u8e3s4)) {
            return false;
          }
          it_1.b9e(FocusStateImpl_ActiveParent_getInstance(), FocusStateImpl_Inactive_getInstance());
          i = i - 1 | 0;
        }
      }
    }
    $l$block_0: {
      // Inline function 'androidx.compose.runtime.collection.MutableVector.forEachReversed' call
      var i_0 = ancestorTargetNodes.d3e_1 - 1 | 0;
      var tmp_9 = ancestorTargetNodes.b3e_1;
      var content_0 = isArray(tmp_9) ? tmp_9 : THROW_CCE();
      if (i_0 >= content_0.length) {
        break $l$block_0;
      }
      while (i_0 >= 0) {
        var it_2 = content_0[i_0];
        if (!(focusOwner.v9c() === _this__u8e3s4)) {
          return false;
        }
        it_2.b9e(it_2 === previousActiveNode ? FocusStateImpl_Active_getInstance() : FocusStateImpl_Inactive_getInstance(), FocusStateImpl_ActiveParent_getInstance());
        i_0 = i_0 - 1 | 0;
      }
    }
    if (!(focusOwner.v9c() === _this__u8e3s4)) {
      return false;
    }
    _this__u8e3s4.b9e(previousFocusState, FocusStateImpl_Active_getInstance());
    if (!(focusOwner.v9c() === _this__u8e3s4)) {
      return false;
    }
    if (ComposeUiFlags_instance.u8u_1) {
      // Inline function 'kotlin.run' call
      $l$block_1: {
        // Inline function 'androidx.compose.runtime.collection.MutableVector.lastOrNull' call
        var tmp_10;
        // Inline function 'androidx.compose.runtime.collection.MutableVector.isEmpty' call
        if (commonAncestorTargetNodes.d3e_1 === 0) {
          tmp_10 = null;
        } else {
          // Inline function 'androidx.compose.runtime.collection.MutableVector.lastIndex' call
          // Inline function 'androidx.compose.runtime.collection.MutableVector.get' call
          var index = commonAncestorTargetNodes.d3e_1 - 1 | 0;
          tmp_10 = commonAncestorTargetNodes.b3e_1[index];
        }
        var closestCommonAncestor = tmp_10;
        // Inline function 'androidx.compose.ui.node.Nodes.FocusTarget' call
        // Inline function 'androidx.compose.ui.node.visitAncestors' call
        var type_1 = _NodeKind___init__impl__ojsprp(1024);
        // Inline function 'androidx.compose.ui.node.visitAncestors' call
        var mask_1 = _NodeKind___get_mask__impl__1uopb6(type_1);
        // Inline function 'androidx.compose.ui.internal.checkPrecondition' call
        if (!_this__u8e3s4.f4n().z8v_1) {
          var tmp$ret$53 = 'visitAncestors called on an unattached node';
          throwIllegalStateException(tmp$ret$53);
        }
        var node_5 = false ? _this__u8e3s4.f4n() : _this__u8e3s4.f4n().q8v_1;
        var layout_1 = requireLayoutNode(_this__u8e3s4);
        while (!(layout_1 == null)) {
          var head_1 = layout_1.d91_1.j99_1;
          if (!((head_1.p8v_1 & mask_1) === 0)) {
            while (!(node_5 == null)) {
              if (!((node_5.o8v_1 & mask_1) === 0)) {
                // Inline function 'androidx.compose.ui.node.dispatchForKind' call
                var stack_1 = null;
                var node_6 = node_5;
                $l$loop_1: while (!(node_6 == null)) {
                  var tmp_11;
                  if (node_6 instanceof FocusTargetNode) {
                    var it_3 = node_6;
                    saveFocusedChild(it_3);
                    if (it_3 === closestCommonAncestor) {
                      break $l$block_1;
                    }
                    tmp_11 = false;
                  } else {
                    tmp_11 = true;
                  }
                  var dispatchAgain_1 = tmp_11;
                  var tmp_12;
                  var tmp_13;
                  if (dispatchAgain_1 || false) {
                    // Inline function 'androidx.compose.ui.Node.isKind' call
                    tmp_13 = !((node_6.o8v_1 & _NodeKind___get_mask__impl__1uopb6(type_1)) === 0);
                  } else {
                    tmp_13 = false;
                  }
                  if (tmp_13) {
                    tmp_12 = node_6 instanceof DelegatingNode;
                  } else {
                    tmp_12 = false;
                  }
                  if (tmp_12) {
                    var count_1 = 0;
                    // Inline function 'androidx.compose.ui.node.DelegatingNode.forEachImmediateDelegate' call
                    var node_7 = node_6.e9a_1;
                    while (!(node_7 == null)) {
                      var next_1 = node_7;
                      // Inline function 'androidx.compose.ui.Node.isKind' call
                      if (!((next_1.o8v_1 & _NodeKind___get_mask__impl__1uopb6(type_1)) === 0)) {
                        count_1 = count_1 + 1 | 0;
                        if (count_1 === 1) {
                          node_6 = next_1;
                        } else {
                          var tmp0_elvis_lhs_1 = stack_1;
                          var tmp_14;
                          if (tmp0_elvis_lhs_1 == null) {
                            // Inline function 'androidx.compose.runtime.collection.mutableVectorOf' call
                            // Inline function 'androidx.compose.runtime.collection.MutableVector' call
                            // Inline function 'kotlin.arrayOfNulls' call
                            var tmp$ret$63 = Array(16);
                            tmp_14 = new MutableVector(tmp$ret$63, 0);
                          } else {
                            tmp_14 = tmp0_elvis_lhs_1;
                          }
                          stack_1 = tmp_14;
                          var theNode_1 = node_6;
                          if (!(theNode_1 == null)) {
                            var tmp1_safe_receiver_3 = stack_1;
                            if (tmp1_safe_receiver_3 == null)
                              null;
                            else
                              tmp1_safe_receiver_3.zz(theNode_1);
                            node_6 = null;
                          }
                          var tmp2_safe_receiver_1 = stack_1;
                          if (tmp2_safe_receiver_1 == null)
                            null;
                          else
                            tmp2_safe_receiver_1.zz(next_1);
                        }
                      }
                      node_7 = node_7.r8v_1;
                    }
                    if (count_1 === 1) {
                      continue $l$loop_1;
                    }
                  }
                  node_6 = access$pop$tDelegatableNodeKt(stack_1);
                }
              }
              node_5 = node_5.q8v_1;
            }
          }
          layout_1 = layout_1.f9a();
          var tmp0_safe_receiver_2 = layout_1;
          var tmp1_safe_receiver_4 = tmp0_safe_receiver_2 == null ? null : tmp0_safe_receiver_2.d91_1;
          node_5 = tmp1_safe_receiver_4 == null ? null : tmp1_safe_receiver_4.i99_1;
        }
      }
    }
    if (ComposeUiFlags_instance.r8u_1 && requireLayoutNode(_this__u8e3s4).z9h() == null) {
      requestOwnerFocus(_this__u8e3s4, Companion_getInstance_30().k9b_1, null);
    }
    return true;
  }
  function clearFocus_0(_this__u8e3s4, forced, refreshFocusEvents) {
    forced = forced === VOID ? false : forced;
    var tmp;
    switch (_this__u8e3s4.x9c().a1_1) {
      case 0:
        if (!ComposeUiFlags_instance.w8u_1) {
          requireOwner(_this__u8e3s4).o9c().q9d(null);
          if (refreshFocusEvents) {
            _this__u8e3s4.b9e(FocusStateImpl_Active_getInstance(), FocusStateImpl_Inactive_getInstance());
          }
        }

        tmp = true;
        break;
      case 1:
        var tmp_0;
        if (clearChildFocus(_this__u8e3s4, forced, refreshFocusEvents)) {
          if (refreshFocusEvents) {
            _this__u8e3s4.b9e(FocusStateImpl_ActiveParent_getInstance(), FocusStateImpl_Inactive_getInstance());
          }
          tmp_0 = true;
        } else {
          tmp_0 = false;
        }

        tmp = tmp_0;
        break;
      case 2:
        if (forced) {
          if (!ComposeUiFlags_instance.w8u_1) {
            requireOwner(_this__u8e3s4).o9c().q9d(null);
            if (refreshFocusEvents) {
              _this__u8e3s4.b9e(FocusStateImpl_Captured_getInstance(), FocusStateImpl_Inactive_getInstance());
            }
          }
        }

        tmp = forced;
        break;
      case 3:
        tmp = true;
        break;
      default:
        noWhenBranchMatchedException();
        break;
    }
    return tmp;
  }
  function performCustomClearFocus(_this__u8e3s4, focusDirection) {
    var tmp;
    switch (_this__u8e3s4.x9c().a1_1) {
      case 0:
      case 3:
        tmp = CustomDestinationResult_None_getInstance();
        break;
      case 2:
        tmp = CustomDestinationResult_Cancelled_getInstance();
        break;
      case 1:
        // Inline function 'kotlin.takeUnless' call

        var this_0 = performCustomClearFocus(requireActiveChild(_this__u8e3s4), focusDirection);
        var tmp_0;
        if (!this_0.equals(CustomDestinationResult_None_getInstance())) {
          tmp_0 = this_0;
        } else {
          tmp_0 = null;
        }

        var tmp1_elvis_lhs = tmp_0;
        tmp = tmp1_elvis_lhs == null ? performCustomExit(_this__u8e3s4, focusDirection) : tmp1_elvis_lhs;
        break;
      default:
        noWhenBranchMatchedException();
        break;
    }
    return tmp;
  }
  function requireActiveChild(_this__u8e3s4) {
    var tmp0 = get_activeChild(_this__u8e3s4);
    var tmp$ret$0;
    $l$block: {
      // Inline function 'kotlin.requireNotNull' call
      if (tmp0 == null) {
        var message = 'ActiveParent with no focused child';
        throw IllegalArgumentException_init_$Create$(toString(message));
      } else {
        tmp$ret$0 = tmp0;
        break $l$block;
      }
    }
    return tmp$ret$0;
  }
  function performCustomEnter(_this__u8e3s4, focusDirection) {
    // Inline function 'androidx.compose.ui.focus.FocusTargetNode.fetchCustomEnter' call
    if (!access$_get_isProcessingCustomEnter__pxgf2f(_this__u8e3s4)) {
      access$_set_isProcessingCustomEnter__omi8n9(_this__u8e3s4, true);
      try {
        var focusProperties = _this__u8e3s4.v9h();
        var scope = new CancelIndicatingFocusBoundaryScope(focusDirection);
        var focusOwner = requireOwner(_this__u8e3s4).o9c();
        var activeNodeBefore = focusOwner.v9c();
        focusProperties.g9f()(scope);
        var activeNodeAfter = focusOwner.v9c();
        if (scope.q9g_1) {
          var it = Companion_getInstance_32().s9e_1;
          if (it === Companion_getInstance_32().s9e_1)
            return CustomDestinationResult_Cancelled_getInstance();
          else if (it === Companion_getInstance_32().t9e_1)
            return CustomDestinationResult_Redirected_getInstance();
          return it.u9g() ? CustomDestinationResult_Redirected_getInstance() : CustomDestinationResult_RedirectCancelled_getInstance();
        } else if (!(activeNodeBefore === activeNodeAfter) && !(activeNodeAfter == null)) {
          var it_0 = Companion_getInstance_32().t9e_1;
          if (it_0 === Companion_getInstance_32().s9e_1)
            return CustomDestinationResult_Cancelled_getInstance();
          else if (it_0 === Companion_getInstance_32().t9e_1)
            return CustomDestinationResult_Redirected_getInstance();
          return it_0.u9g() ? CustomDestinationResult_Redirected_getInstance() : CustomDestinationResult_RedirectCancelled_getInstance();
        }
      }finally {
        access$_set_isProcessingCustomEnter__omi8n9(_this__u8e3s4, false);
      }
    }
    return CustomDestinationResult_None_getInstance();
  }
  function requestOwnerFocus(_this__u8e3s4, focusDirection, previouslyFocusedRect) {
    focusDirection = focusDirection === VOID ? null : focusDirection;
    previouslyFocusedRect = previouslyFocusedRect === VOID ? null : previouslyFocusedRect;
    return requireOwner(_this__u8e3s4).o9c().k9d(focusDirection, previouslyFocusedRect);
  }
  function grantFocus(_this__u8e3s4) {
    observeReads(_this__u8e3s4, grantFocus$lambda(_this__u8e3s4));
    switch (_this__u8e3s4.x9c().a1_1) {
      case 3:
      case 1:
        requireOwner(_this__u8e3s4).o9c().q9d(_this__u8e3s4);
        break;
      case 0:
      case 2:
        break;
      default:
        noWhenBranchMatchedException();
        break;
    }
    return true;
  }
  function clearChildFocus(_this__u8e3s4, forced, refreshFocusEvents) {
    forced = forced === VOID ? false : forced;
    refreshFocusEvents = refreshFocusEvents === VOID ? true : refreshFocusEvents;
    var tmp0_safe_receiver = get_activeChild(_this__u8e3s4);
    var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : clearFocus_0(tmp0_safe_receiver, forced, refreshFocusEvents);
    return tmp1_elvis_lhs == null ? true : tmp1_elvis_lhs;
  }
  function performCustomExit(_this__u8e3s4, focusDirection) {
    // Inline function 'androidx.compose.ui.focus.FocusTargetNode.fetchCustomExit' call
    if (!access$_get_isProcessingCustomExit__f74o4h(_this__u8e3s4)) {
      access$_set_isProcessingCustomExit__xkvxez(_this__u8e3s4, true);
      try {
        var focusProperties = _this__u8e3s4.v9h();
        var scope = new CancelIndicatingFocusBoundaryScope(focusDirection);
        var focusOwner = requireOwner(_this__u8e3s4).o9c();
        var activeNodeBefore = focusOwner.v9c();
        focusProperties.i9f()(scope);
        var activeNodeAfter = focusOwner.v9c();
        if (scope.q9g_1) {
          var it = Companion_getInstance_32().s9e_1;
          if (it === Companion_getInstance_32().s9e_1)
            return CustomDestinationResult_Cancelled_getInstance();
          else if (it === Companion_getInstance_32().t9e_1)
            return CustomDestinationResult_Redirected_getInstance();
          return it.u9g() ? CustomDestinationResult_Redirected_getInstance() : CustomDestinationResult_RedirectCancelled_getInstance();
        } else if (!(activeNodeBefore === activeNodeAfter) && !(activeNodeAfter == null)) {
          var it_0 = Companion_getInstance_32().t9e_1;
          if (it_0 === Companion_getInstance_32().s9e_1)
            return CustomDestinationResult_Cancelled_getInstance();
          else if (it_0 === Companion_getInstance_32().t9e_1)
            return CustomDestinationResult_Redirected_getInstance();
          return it_0.u9g() ? CustomDestinationResult_Redirected_getInstance() : CustomDestinationResult_RedirectCancelled_getInstance();
        }
      }finally {
        access$_set_isProcessingCustomExit__xkvxez(_this__u8e3s4, false);
      }
    }
    return CustomDestinationResult_None_getInstance();
  }
  function grantFocus$lambda($this_grantFocus) {
    return function () {
      $this_grantFocus.v9h();
      return Unit_instance;
    };
  }
  function CustomDestinationResult_None_getInstance() {
    CustomDestinationResult_initEntries();
    return CustomDestinationResult_None_instance;
  }
  function CustomDestinationResult_Cancelled_getInstance() {
    CustomDestinationResult_initEntries();
    return CustomDestinationResult_Cancelled_instance;
  }
  function CustomDestinationResult_Redirected_getInstance() {
    CustomDestinationResult_initEntries();
    return CustomDestinationResult_Redirected_instance;
  }
  function CustomDestinationResult_RedirectCancelled_getInstance() {
    CustomDestinationResult_initEntries();
    return CustomDestinationResult_RedirectCancelled_instance;
  }
  function findActiveFocusNode(_this__u8e3s4) {
    var activeNode = requireOwner(_this__u8e3s4).o9c().v9c();
    return !(activeNode == null) && activeNode.z8v_1 ? activeNode : null;
  }
  function get_activeChild(_this__u8e3s4) {
    if (!_this__u8e3s4.m8v_1.z8v_1)
      return null;
    // Inline function 'androidx.compose.ui.node.Nodes.FocusTarget' call
    // Inline function 'androidx.compose.ui.node.visitChildren' call
    var type = _NodeKind___init__impl__ojsprp(1024);
    // Inline function 'androidx.compose.ui.node.visitChildren' call
    var mask = _NodeKind___get_mask__impl__1uopb6(type);
    // Inline function 'androidx.compose.ui.internal.checkPrecondition' call
    if (!_this__u8e3s4.f4n().z8v_1) {
      var tmp$ret$4 = 'visitChildren called on an unattached node';
      throwIllegalStateException(tmp$ret$4);
    }
    // Inline function 'androidx.compose.runtime.collection.mutableVectorOf' call
    // Inline function 'androidx.compose.runtime.collection.MutableVector' call
    // Inline function 'kotlin.arrayOfNulls' call
    var tmp$ret$7 = Array(16);
    var branches = new MutableVector(tmp$ret$7, 0);
    var child = _this__u8e3s4.f4n().r8v_1;
    if (child == null) {
      access$addLayoutNodeChildren$tDelegatableNodeKt(branches, _this__u8e3s4.f4n(), false);
    } else
      branches.zz(child);
    $l$loop_0: while (true) {
      // Inline function 'androidx.compose.runtime.collection.MutableVector.isNotEmpty' call
      if (!!(branches.d3e_1 === 0)) {
        break $l$loop_0;
      }
      // Inline function 'androidx.compose.runtime.collection.MutableVector.lastIndex' call
      var tmp$ret$9 = branches.d3e_1 - 1 | 0;
      var branch = branches.h3(tmp$ret$9);
      if ((branch.p8v_1 & mask) === 0) {
        access$addLayoutNodeChildren$tDelegatableNodeKt(branches, branch, false);
        continue $l$loop_0;
      }
      var node = branch;
      $l$loop_2: while (!(node == null)) {
        if (!((node.o8v_1 & mask) === 0)) {
          // Inline function 'androidx.compose.ui.node.dispatchForKind' call
          // Inline function 'androidx.compose.ui.node.dispatchForKind' call
          var stack = null;
          var node_0 = node;
          $l$loop_1: while (!(node_0 == null)) {
            var tmp;
            if (node_0 instanceof FocusTargetNode) {
              var tmp0 = node_0;
              $l$block_0: {
                if (!tmp0.m8v_1.z8v_1) {
                  break $l$block_0;
                }
                switch (tmp0.x9c().a1_1) {
                  case 0:
                  case 1:
                  case 2:
                    return tmp0;
                  case 3:
                    break $l$block_0;
                  default:
                    noWhenBranchMatchedException();
                    break;
                }
              }
              tmp = false;
            } else {
              tmp = true;
            }
            var dispatchAgain = tmp;
            var tmp_0;
            var tmp_1;
            if (dispatchAgain || false) {
              // Inline function 'androidx.compose.ui.Node.isKind' call
              tmp_1 = !((node_0.o8v_1 & _NodeKind___get_mask__impl__1uopb6(type)) === 0);
            } else {
              tmp_1 = false;
            }
            if (tmp_1) {
              tmp_0 = node_0 instanceof DelegatingNode;
            } else {
              tmp_0 = false;
            }
            if (tmp_0) {
              var count = 0;
              // Inline function 'androidx.compose.ui.node.DelegatingNode.forEachImmediateDelegate' call
              var node_1 = node_0.e9a_1;
              while (!(node_1 == null)) {
                var next = node_1;
                // Inline function 'androidx.compose.ui.Node.isKind' call
                if (!((next.o8v_1 & _NodeKind___get_mask__impl__1uopb6(type)) === 0)) {
                  count = count + 1 | 0;
                  if (count === 1) {
                    node_0 = next;
                  } else {
                    var tmp0_elvis_lhs = stack;
                    var tmp_2;
                    if (tmp0_elvis_lhs == null) {
                      // Inline function 'androidx.compose.runtime.collection.mutableVectorOf' call
                      // Inline function 'androidx.compose.runtime.collection.MutableVector' call
                      // Inline function 'kotlin.arrayOfNulls' call
                      var tmp$ret$20 = Array(16);
                      tmp_2 = new MutableVector(tmp$ret$20, 0);
                    } else {
                      tmp_2 = tmp0_elvis_lhs;
                    }
                    stack = tmp_2;
                    var theNode = node_0;
                    if (!(theNode == null)) {
                      var tmp1_safe_receiver = stack;
                      if (tmp1_safe_receiver == null)
                        null;
                      else
                        tmp1_safe_receiver.zz(theNode);
                      node_0 = null;
                    }
                    var tmp2_safe_receiver = stack;
                    if (tmp2_safe_receiver == null)
                      null;
                    else
                      tmp2_safe_receiver.zz(next);
                  }
                }
                node_1 = node_1.r8v_1;
              }
              if (count === 1) {
                continue $l$loop_1;
              }
            }
            node_0 = access$pop$tDelegatableNodeKt(stack);
          }
          break $l$loop_2;
        }
        node = node.r8v_1;
      }
    }
    return null;
  }
  function focusRect(_this__u8e3s4) {
    if (!_this__u8e3s4.z8v_1)
      return Companion_getInstance_2().j5d_1;
    var tmp0_safe_receiver = _this__u8e3s4.t8v_1;
    var tmp1_safe_receiver = tmp0_safe_receiver == null ? null : findRootCoordinates(tmp0_safe_receiver);
    var tmp;
    if (tmp1_safe_receiver == null) {
      tmp = null;
    } else {
      // Inline function 'kotlin.takeIf' call
      var tmp_0;
      if (tmp1_safe_receiver.y91()) {
        tmp_0 = tmp1_safe_receiver;
      } else {
        tmp_0 = null;
      }
      tmp = tmp_0;
    }
    var tmp2_elvis_lhs = tmp;
    var tmp_1;
    if (tmp2_elvis_lhs == null) {
      return Companion_getInstance_2().j5d_1;
    } else {
      tmp_1 = tmp2_elvis_lhs;
    }
    var rootCoordinates = tmp_1;
    return _this__u8e3s4.u9h(rootCoordinates);
  }
  function get_isEligibleForFocusSearch(_this__u8e3s4) {
    var tmp;
    var tmp0_safe_receiver = _this__u8e3s4.t8v_1;
    var tmp1_safe_receiver = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.a9i();
    if ((tmp1_safe_receiver == null ? null : tmp1_safe_receiver.b9i()) === true) {
      var tmp2_safe_receiver = _this__u8e3s4.t8v_1;
      var tmp3_safe_receiver = tmp2_safe_receiver == null ? null : tmp2_safe_receiver.a9i();
      tmp = (tmp3_safe_receiver == null ? null : tmp3_safe_receiver.y91()) === true;
    } else {
      tmp = false;
    }
    return tmp;
  }
  function customFocusSearch(_this__u8e3s4, focusDirection, layoutDirection) {
    var focusProperties = _this__u8e3s4.v9h();
    var tmp;
    if (focusDirection === Companion_getInstance_30().k9b_1) {
      tmp = focusProperties.c1o();
    } else if (focusDirection === Companion_getInstance_30().l9b_1) {
      tmp = focusProperties.b9f();
    } else if (focusDirection === Companion_getInstance_30().o9b_1) {
      tmp = focusProperties.c9f();
    } else if (focusDirection === Companion_getInstance_30().p9b_1) {
      tmp = focusProperties.d9f();
    } else if (focusDirection === Companion_getInstance_30().m9b_1) {
      var tmp_0;
      switch (layoutDirection.a1_1) {
        case 0:
          tmp_0 = focusProperties.e1();
          break;
        case 1:
          tmp_0 = focusProperties.f9f();
          break;
        default:
          noWhenBranchMatchedException();
          break;
      }
      // Inline function 'kotlin.takeUnless' call
      var this_0 = tmp_0;
      var tmp_1;
      if (!(this_0 === Companion_getInstance_32().r9e_1)) {
        tmp_1 = this_0;
      } else {
        tmp_1 = null;
      }
      var tmp2_elvis_lhs = tmp_1;
      tmp = tmp2_elvis_lhs == null ? focusProperties.e9f() : tmp2_elvis_lhs;
    } else if (focusDirection === Companion_getInstance_30().n9b_1) {
      var tmp_2;
      switch (layoutDirection.a1_1) {
        case 0:
          tmp_2 = focusProperties.f9f();
          break;
        case 1:
          tmp_2 = focusProperties.e1();
          break;
        default:
          noWhenBranchMatchedException();
          break;
      }
      // Inline function 'kotlin.takeUnless' call
      var this_1 = tmp_2;
      var tmp_3;
      if (!(this_1 === Companion_getInstance_32().r9e_1)) {
        tmp_3 = this_1;
      } else {
        tmp_3 = null;
      }
      var tmp4_elvis_lhs = tmp_3;
      tmp = tmp4_elvis_lhs == null ? focusProperties.x61() : tmp4_elvis_lhs;
    } else if (focusDirection === Companion_getInstance_30().q9b_1 || focusDirection === Companion_getInstance_30().r9b_1) {
      var scope = new CancelIndicatingFocusBoundaryScope(focusDirection);
      // Inline function 'kotlin.with' call
      var focusOwner = requireOwner(_this__u8e3s4).o9c();
      var activeNodeBefore = focusOwner.v9c();
      if (focusDirection === Companion_getInstance_30().q9b_1) {
        focusProperties.g9f()(scope);
      } else {
        focusProperties.i9f()(scope);
      }
      var tmp_4;
      if (scope.q9g_1) {
        tmp_4 = Companion_getInstance_32().s9e_1;
      } else if (!(activeNodeBefore === focusOwner.v9c())) {
        tmp_4 = Companion_getInstance_32().t9e_1;
      } else {
        tmp_4 = Companion_getInstance_32().r9e_1;
      }
      tmp = tmp_4;
    } else {
      // Inline function 'kotlin.error' call
      var message = 'invalid FocusDirection';
      throw IllegalStateException_init_$Create$(toString(message));
    }
    return tmp;
  }
  function focusSearch(_this__u8e3s4, focusDirection, layoutDirection, previouslyFocusedRect, onFound) {
    var tmp;
    if (focusDirection === Companion_getInstance_30().k9b_1 || focusDirection === Companion_getInstance_30().l9b_1) {
      tmp = oneDimensionalFocusSearch(_this__u8e3s4, focusDirection, onFound);
    } else if (focusDirection === Companion_getInstance_30().m9b_1 || focusDirection === Companion_getInstance_30().n9b_1 || (focusDirection === Companion_getInstance_30().o9b_1 || focusDirection === Companion_getInstance_30().p9b_1)) {
      tmp = twoDimensionalFocusSearch(_this__u8e3s4, focusDirection, previouslyFocusedRect, onFound);
    } else if (focusDirection === Companion_getInstance_30().q9b_1) {
      var tmp_0;
      switch (layoutDirection.a1_1) {
        case 1:
          tmp_0 = Companion_getInstance_30().m9b_1;
          break;
        case 0:
          tmp_0 = Companion_getInstance_30().n9b_1;
          break;
        default:
          noWhenBranchMatchedException();
          break;
      }
      var direction = tmp_0;
      var tmp2_safe_receiver = findActiveFocusNode(_this__u8e3s4);
      tmp = tmp2_safe_receiver == null ? null : twoDimensionalFocusSearch(tmp2_safe_receiver, direction, previouslyFocusedRect, onFound);
    } else if (focusDirection === Companion_getInstance_30().r9b_1) {
      var tmp3_safe_receiver = findActiveFocusNode(_this__u8e3s4);
      // Inline function 'kotlin.let' call
      var it = tmp3_safe_receiver == null ? null : findNonDeactivatedParent(tmp3_safe_receiver);
      tmp = it == null || equals(it, _this__u8e3s4) ? false : onFound(it);
    } else {
      // Inline function 'kotlin.error' call
      var message = 'Focus search invoked with invalid FocusDirection ' + FocusDirection__toString_impl_h9c1oa(focusDirection);
      throw IllegalStateException_init_$Create$(toString(message));
    }
    return tmp;
  }
  function findNonDeactivatedParent(_this__u8e3s4) {
    // Inline function 'androidx.compose.ui.node.Nodes.FocusTarget' call
    // Inline function 'androidx.compose.ui.node.visitAncestors' call
    var type = _NodeKind___init__impl__ojsprp(1024);
    // Inline function 'androidx.compose.ui.node.visitAncestors' call
    var mask = _NodeKind___get_mask__impl__1uopb6(type);
    // Inline function 'androidx.compose.ui.internal.checkPrecondition' call
    if (!_this__u8e3s4.f4n().z8v_1) {
      var tmp$ret$4 = 'visitAncestors called on an unattached node';
      throwIllegalStateException(tmp$ret$4);
    }
    var node = false ? _this__u8e3s4.f4n() : _this__u8e3s4.f4n().q8v_1;
    var layout = requireLayoutNode(_this__u8e3s4);
    while (!(layout == null)) {
      var head = layout.d91_1.j99_1;
      if (!((head.p8v_1 & mask) === 0)) {
        while (!(node == null)) {
          if (!((node.o8v_1 & mask) === 0)) {
            // Inline function 'androidx.compose.ui.node.dispatchForKind' call
            var stack = null;
            var node_0 = node;
            $l$loop: while (!(node_0 == null)) {
              var tmp;
              if (node_0 instanceof FocusTargetNode) {
                var it = node_0;
                if (it.v9h().a9f())
                  return it;
                tmp = false;
              } else {
                tmp = true;
              }
              var dispatchAgain = tmp;
              var tmp_0;
              var tmp_1;
              if (dispatchAgain || false) {
                // Inline function 'androidx.compose.ui.Node.isKind' call
                tmp_1 = !((node_0.o8v_1 & _NodeKind___get_mask__impl__1uopb6(type)) === 0);
              } else {
                tmp_1 = false;
              }
              if (tmp_1) {
                tmp_0 = node_0 instanceof DelegatingNode;
              } else {
                tmp_0 = false;
              }
              if (tmp_0) {
                var count = 0;
                // Inline function 'androidx.compose.ui.node.DelegatingNode.forEachImmediateDelegate' call
                var node_1 = node_0.e9a_1;
                while (!(node_1 == null)) {
                  var next = node_1;
                  // Inline function 'androidx.compose.ui.Node.isKind' call
                  if (!((next.o8v_1 & _NodeKind___get_mask__impl__1uopb6(type)) === 0)) {
                    count = count + 1 | 0;
                    if (count === 1) {
                      node_0 = next;
                    } else {
                      var tmp0_elvis_lhs = stack;
                      var tmp_2;
                      if (tmp0_elvis_lhs == null) {
                        // Inline function 'androidx.compose.runtime.collection.mutableVectorOf' call
                        // Inline function 'androidx.compose.runtime.collection.MutableVector' call
                        // Inline function 'kotlin.arrayOfNulls' call
                        var tmp$ret$14 = Array(16);
                        tmp_2 = new MutableVector(tmp$ret$14, 0);
                      } else {
                        tmp_2 = tmp0_elvis_lhs;
                      }
                      stack = tmp_2;
                      var theNode = node_0;
                      if (!(theNode == null)) {
                        var tmp1_safe_receiver = stack;
                        if (tmp1_safe_receiver == null)
                          null;
                        else
                          tmp1_safe_receiver.zz(theNode);
                        node_0 = null;
                      }
                      var tmp2_safe_receiver = stack;
                      if (tmp2_safe_receiver == null)
                        null;
                      else
                        tmp2_safe_receiver.zz(next);
                    }
                  }
                  node_1 = node_1.r8v_1;
                }
                if (count === 1) {
                  continue $l$loop;
                }
              }
              node_0 = access$pop$tDelegatableNodeKt(stack);
            }
          }
          node = node.q8v_1;
        }
      }
      layout = layout.f9a();
      var tmp0_safe_receiver = layout;
      var tmp1_safe_receiver_0 = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.d91_1;
      node = tmp1_safe_receiver_0 == null ? null : tmp1_safe_receiver_0.i99_1;
    }
    return null;
  }
  function _Focusability___init__impl__j4gdtb(value) {
    return value;
  }
  function Companion_7() {
    Companion_instance_12 = this;
    this.j9e_1 = _Focusability___init__impl__j4gdtb(1);
    this.k9e_1 = _Focusability___init__impl__j4gdtb(0);
    this.l9e_1 = _Focusability___init__impl__j4gdtb(2);
  }
  var Companion_instance_12;
  function Companion_getInstance_33() {
    if (Companion_instance_12 == null)
      new Companion_7();
    return Companion_instance_12;
  }
  function Focusability__canFocus_impl_2zet2l($this, node) {
    var tmp;
    if ($this === Companion_getInstance_33().j9e_1) {
      tmp = true;
    } else if ($this === Companion_getInstance_33().k9e_1) {
      tmp = systemDefinedCanFocus(node);
    } else if ($this === Companion_getInstance_33().l9e_1) {
      tmp = false;
    } else {
      // Inline function 'kotlin.error' call
      var message = 'Unknown Focusability';
      throw IllegalStateException_init_$Create$(toString(message));
    }
    return tmp;
  }
  function oneDimensionalFocusSearch(_this__u8e3s4, direction, onFound) {
    var tmp;
    if (direction === Companion_getInstance_30().k9b_1) {
      tmp = forwardFocusSearch(_this__u8e3s4, onFound);
    } else if (direction === Companion_getInstance_30().l9b_1) {
      tmp = backwardFocusSearch(_this__u8e3s4, onFound);
    } else {
      // Inline function 'kotlin.error' call
      var message = 'This function should only be used for 1-D focus search';
      throw IllegalStateException_init_$Create$(toString(message));
    }
    return tmp;
  }
  function forwardFocusSearch(_this__u8e3s4, onFound) {
    var tmp;
    switch (_this__u8e3s4.x9c().a1_1) {
      case 1:
        var tmp1_elvis_lhs = get_activeChild(_this__u8e3s4);
        var tmp_0;
        if (tmp1_elvis_lhs == null) {
          // Inline function 'kotlin.error' call
          var message = 'ActiveParent must have a focusedChild';
          throw IllegalStateException_init_$Create$(toString(message));
        } else {
          tmp_0 = tmp1_elvis_lhs;
        }

        var focusedChild = tmp_0;
        tmp = forwardFocusSearch(focusedChild, onFound) || generateAndSearchChildren(_this__u8e3s4, focusedChild, Companion_getInstance_30().k9b_1, onFound);
        break;
      case 0:
      case 2:
        tmp = pickChildForForwardSearch(_this__u8e3s4, onFound);
        break;
      case 3:
        var tmp_1;
        if (_this__u8e3s4.v9h().a9f()) {
          tmp_1 = onFound(_this__u8e3s4);
        } else {
          tmp_1 = pickChildForForwardSearch(_this__u8e3s4, onFound);
        }

        tmp = tmp_1;
        break;
      default:
        noWhenBranchMatchedException();
        break;
    }
    return tmp;
  }
  function backwardFocusSearch(_this__u8e3s4, onFound) {
    var tmp;
    switch (_this__u8e3s4.x9c().a1_1) {
      case 1:
        var tmp1_elvis_lhs = get_activeChild(_this__u8e3s4);
        var tmp_0;
        if (tmp1_elvis_lhs == null) {
          // Inline function 'kotlin.error' call
          var message = 'ActiveParent must have a focusedChild';
          throw IllegalStateException_init_$Create$(toString(message));
        } else {
          tmp_0 = tmp1_elvis_lhs;
        }

        var focusedChild = tmp_0;
        var tmp_1;
        switch (focusedChild.x9c().a1_1) {
          case 1:
            tmp_1 = backwardFocusSearch(focusedChild, onFound) || generateAndSearchChildren(_this__u8e3s4, focusedChild, Companion_getInstance_30().l9b_1, onFound) || (focusedChild.v9h().a9f() && onFound(focusedChild));
            break;
          case 0:
          case 2:
            tmp_1 = generateAndSearchChildren(_this__u8e3s4, focusedChild, Companion_getInstance_30().l9b_1, onFound);
            break;
          case 3:
            // Inline function 'kotlin.error' call

            var message_0 = 'ActiveParent must have a focusedChild';
            throw IllegalStateException_init_$Create$(toString(message_0));
          default:
            noWhenBranchMatchedException();
            break;
        }

        tmp = tmp_1;
        break;
      case 0:
      case 2:
        tmp = pickChildForBackwardSearch(_this__u8e3s4, onFound);
        break;
      case 3:
        tmp = pickChildForBackwardSearch(_this__u8e3s4, onFound) || (_this__u8e3s4.v9h().a9f() ? onFound(_this__u8e3s4) : false);
        break;
      default:
        noWhenBranchMatchedException();
        break;
    }
    return tmp;
  }
  function generateAndSearchChildren(_this__u8e3s4, focusedItem, direction, onFound) {
    if (searchChildren(_this__u8e3s4, focusedItem, direction, onFound)) {
      return true;
    }
    var activeNodeBeforeSearch = requireOwner(_this__u8e3s4).o9c().v9c();
    var tmp0_elvis_lhs = searchBeyondBounds(_this__u8e3s4, direction, generateAndSearchChildren$lambda(activeNodeBeforeSearch, _this__u8e3s4, focusedItem, direction, onFound));
    return tmp0_elvis_lhs == null ? false : tmp0_elvis_lhs;
  }
  function pickChildForForwardSearch(_this__u8e3s4, onFound) {
    // Inline function 'androidx.compose.runtime.collection.MutableVector' call
    // Inline function 'kotlin.arrayOfNulls' call
    var tmp$ret$1 = Array(16);
    // Inline function 'kotlin.apply' call
    var this_0 = new MutableVector(tmp$ret$1, 0);
    // Inline function 'androidx.compose.ui.node.Nodes.FocusTarget' call
    // Inline function 'androidx.compose.ui.node.visitChildren' call
    var type = _NodeKind___init__impl__ojsprp(1024);
    // Inline function 'androidx.compose.ui.node.visitChildren' call
    var mask = _NodeKind___get_mask__impl__1uopb6(type);
    // Inline function 'androidx.compose.ui.internal.checkPrecondition' call
    if (!_this__u8e3s4.f4n().z8v_1) {
      var tmp$ret$8 = 'visitChildren called on an unattached node';
      throwIllegalStateException(tmp$ret$8);
    }
    // Inline function 'androidx.compose.runtime.collection.mutableVectorOf' call
    // Inline function 'androidx.compose.runtime.collection.MutableVector' call
    // Inline function 'kotlin.arrayOfNulls' call
    var tmp$ret$11 = Array(16);
    var branches = new MutableVector(tmp$ret$11, 0);
    var child = _this__u8e3s4.f4n().r8v_1;
    if (child == null) {
      access$addLayoutNodeChildren$tDelegatableNodeKt(branches, _this__u8e3s4.f4n(), false);
    } else
      branches.zz(child);
    $l$loop_0: while (true) {
      // Inline function 'androidx.compose.runtime.collection.MutableVector.isNotEmpty' call
      if (!!(branches.d3e_1 === 0)) {
        break $l$loop_0;
      }
      // Inline function 'androidx.compose.runtime.collection.MutableVector.lastIndex' call
      var tmp$ret$13 = branches.d3e_1 - 1 | 0;
      var branch = branches.h3(tmp$ret$13);
      if ((branch.p8v_1 & mask) === 0) {
        access$addLayoutNodeChildren$tDelegatableNodeKt(branches, branch, false);
        continue $l$loop_0;
      }
      var node = branch;
      $l$loop_2: while (!(node == null)) {
        if (!((node.o8v_1 & mask) === 0)) {
          // Inline function 'androidx.compose.ui.node.dispatchForKind' call
          // Inline function 'androidx.compose.ui.node.dispatchForKind' call
          var stack = null;
          var node_0 = node;
          $l$loop_1: while (!(node_0 == null)) {
            var tmp;
            if (node_0 instanceof FocusTargetNode) {
              var it = node_0;
              this_0.zz(it);
              tmp = false;
            } else {
              tmp = true;
            }
            var dispatchAgain = tmp;
            var tmp_0;
            var tmp_1;
            if (dispatchAgain || false) {
              // Inline function 'androidx.compose.ui.Node.isKind' call
              tmp_1 = !((node_0.o8v_1 & _NodeKind___get_mask__impl__1uopb6(type)) === 0);
            } else {
              tmp_1 = false;
            }
            if (tmp_1) {
              tmp_0 = node_0 instanceof DelegatingNode;
            } else {
              tmp_0 = false;
            }
            if (tmp_0) {
              var count = 0;
              // Inline function 'androidx.compose.ui.node.DelegatingNode.forEachImmediateDelegate' call
              var node_1 = node_0.e9a_1;
              while (!(node_1 == null)) {
                var next = node_1;
                // Inline function 'androidx.compose.ui.Node.isKind' call
                if (!((next.o8v_1 & _NodeKind___get_mask__impl__1uopb6(type)) === 0)) {
                  count = count + 1 | 0;
                  if (count === 1) {
                    node_0 = next;
                  } else {
                    var tmp0_elvis_lhs = stack;
                    var tmp_2;
                    if (tmp0_elvis_lhs == null) {
                      // Inline function 'androidx.compose.runtime.collection.mutableVectorOf' call
                      // Inline function 'androidx.compose.runtime.collection.MutableVector' call
                      // Inline function 'kotlin.arrayOfNulls' call
                      var tmp$ret$24 = Array(16);
                      tmp_2 = new MutableVector(tmp$ret$24, 0);
                    } else {
                      tmp_2 = tmp0_elvis_lhs;
                    }
                    stack = tmp_2;
                    var theNode = node_0;
                    if (!(theNode == null)) {
                      var tmp1_safe_receiver = stack;
                      if (tmp1_safe_receiver == null)
                        null;
                      else
                        tmp1_safe_receiver.zz(theNode);
                      node_0 = null;
                    }
                    var tmp2_safe_receiver = stack;
                    if (tmp2_safe_receiver == null)
                      null;
                    else
                      tmp2_safe_receiver.zz(next);
                  }
                }
                node_1 = node_1.r8v_1;
              }
              if (count === 1) {
                continue $l$loop_1;
              }
            }
            node_0 = access$pop$tDelegatableNodeKt(stack);
          }
          break $l$loop_2;
        }
        node = node.r8v_1;
      }
    }
    var children = this_0;
    children.o4a(FocusableChildrenComparator_instance);
    var tmp$ret$25;
    $l$block: {
      // Inline function 'androidx.compose.runtime.collection.MutableVector.any' call
      var tmp_3 = children.b3e_1;
      var content = isArray(tmp_3) ? tmp_3 : THROW_CCE();
      var size = children.d3e_1;
      var inductionVariable = 0;
      if (inductionVariable < size)
        do {
          var i = inductionVariable;
          inductionVariable = inductionVariable + 1 | 0;
          var it_0 = content[i];
          if (get_isEligibleForFocusSearch(it_0) && forwardFocusSearch(it_0, onFound)) {
            tmp$ret$25 = true;
            break $l$block;
          }
        }
         while (inductionVariable < size);
      tmp$ret$25 = false;
    }
    return tmp$ret$25;
  }
  function pickChildForBackwardSearch(_this__u8e3s4, onFound) {
    // Inline function 'androidx.compose.runtime.collection.MutableVector' call
    // Inline function 'kotlin.arrayOfNulls' call
    var tmp$ret$1 = Array(16);
    // Inline function 'kotlin.apply' call
    var this_0 = new MutableVector(tmp$ret$1, 0);
    // Inline function 'androidx.compose.ui.node.Nodes.FocusTarget' call
    // Inline function 'androidx.compose.ui.node.visitChildren' call
    var type = _NodeKind___init__impl__ojsprp(1024);
    // Inline function 'androidx.compose.ui.node.visitChildren' call
    var mask = _NodeKind___get_mask__impl__1uopb6(type);
    // Inline function 'androidx.compose.ui.internal.checkPrecondition' call
    if (!_this__u8e3s4.f4n().z8v_1) {
      var tmp$ret$8 = 'visitChildren called on an unattached node';
      throwIllegalStateException(tmp$ret$8);
    }
    // Inline function 'androidx.compose.runtime.collection.mutableVectorOf' call
    // Inline function 'androidx.compose.runtime.collection.MutableVector' call
    // Inline function 'kotlin.arrayOfNulls' call
    var tmp$ret$11 = Array(16);
    var branches = new MutableVector(tmp$ret$11, 0);
    var child = _this__u8e3s4.f4n().r8v_1;
    if (child == null) {
      access$addLayoutNodeChildren$tDelegatableNodeKt(branches, _this__u8e3s4.f4n(), false);
    } else
      branches.zz(child);
    $l$loop_0: while (true) {
      // Inline function 'androidx.compose.runtime.collection.MutableVector.isNotEmpty' call
      if (!!(branches.d3e_1 === 0)) {
        break $l$loop_0;
      }
      // Inline function 'androidx.compose.runtime.collection.MutableVector.lastIndex' call
      var tmp$ret$13 = branches.d3e_1 - 1 | 0;
      var branch = branches.h3(tmp$ret$13);
      if ((branch.p8v_1 & mask) === 0) {
        access$addLayoutNodeChildren$tDelegatableNodeKt(branches, branch, false);
        continue $l$loop_0;
      }
      var node = branch;
      $l$loop_2: while (!(node == null)) {
        if (!((node.o8v_1 & mask) === 0)) {
          // Inline function 'androidx.compose.ui.node.dispatchForKind' call
          // Inline function 'androidx.compose.ui.node.dispatchForKind' call
          var stack = null;
          var node_0 = node;
          $l$loop_1: while (!(node_0 == null)) {
            var tmp;
            if (node_0 instanceof FocusTargetNode) {
              var it = node_0;
              this_0.zz(it);
              tmp = false;
            } else {
              tmp = true;
            }
            var dispatchAgain = tmp;
            var tmp_0;
            var tmp_1;
            if (dispatchAgain || false) {
              // Inline function 'androidx.compose.ui.Node.isKind' call
              tmp_1 = !((node_0.o8v_1 & _NodeKind___get_mask__impl__1uopb6(type)) === 0);
            } else {
              tmp_1 = false;
            }
            if (tmp_1) {
              tmp_0 = node_0 instanceof DelegatingNode;
            } else {
              tmp_0 = false;
            }
            if (tmp_0) {
              var count = 0;
              // Inline function 'androidx.compose.ui.node.DelegatingNode.forEachImmediateDelegate' call
              var node_1 = node_0.e9a_1;
              while (!(node_1 == null)) {
                var next = node_1;
                // Inline function 'androidx.compose.ui.Node.isKind' call
                if (!((next.o8v_1 & _NodeKind___get_mask__impl__1uopb6(type)) === 0)) {
                  count = count + 1 | 0;
                  if (count === 1) {
                    node_0 = next;
                  } else {
                    var tmp0_elvis_lhs = stack;
                    var tmp_2;
                    if (tmp0_elvis_lhs == null) {
                      // Inline function 'androidx.compose.runtime.collection.mutableVectorOf' call
                      // Inline function 'androidx.compose.runtime.collection.MutableVector' call
                      // Inline function 'kotlin.arrayOfNulls' call
                      var tmp$ret$24 = Array(16);
                      tmp_2 = new MutableVector(tmp$ret$24, 0);
                    } else {
                      tmp_2 = tmp0_elvis_lhs;
                    }
                    stack = tmp_2;
                    var theNode = node_0;
                    if (!(theNode == null)) {
                      var tmp1_safe_receiver = stack;
                      if (tmp1_safe_receiver == null)
                        null;
                      else
                        tmp1_safe_receiver.zz(theNode);
                      node_0 = null;
                    }
                    var tmp2_safe_receiver = stack;
                    if (tmp2_safe_receiver == null)
                      null;
                    else
                      tmp2_safe_receiver.zz(next);
                  }
                }
                node_1 = node_1.r8v_1;
              }
              if (count === 1) {
                continue $l$loop_1;
              }
            }
            node_0 = access$pop$tDelegatableNodeKt(stack);
          }
          break $l$loop_2;
        }
        node = node.r8v_1;
      }
    }
    var children = this_0;
    children.o4a(FocusableChildrenComparator_instance);
    $l$block: {
      // Inline function 'androidx.compose.runtime.collection.MutableVector.forEachReversed' call
      var i = children.d3e_1 - 1 | 0;
      var tmp_3 = children.b3e_1;
      var content = isArray(tmp_3) ? tmp_3 : THROW_CCE();
      if (i >= content.length) {
        break $l$block;
      }
      while (i >= 0) {
        var it_0 = content[i];
        if (get_isEligibleForFocusSearch(it_0) && backwardFocusSearch(it_0, onFound)) {
          return true;
        }
        i = i - 1 | 0;
      }
    }
    return false;
  }
  function searchChildren(_this__u8e3s4, focusedItem, direction, onFound) {
    // Inline function 'kotlin.check' call
    if (!_this__u8e3s4.x9c().equals(FocusStateImpl_ActiveParent_getInstance())) {
      var message = 'This function should only be used within a parent that has focus.';
      throw IllegalStateException_init_$Create$(toString(message));
    }
    // Inline function 'androidx.compose.runtime.collection.MutableVector' call
    // Inline function 'kotlin.arrayOfNulls' call
    var tmp$ret$3 = Array(16);
    // Inline function 'kotlin.apply' call
    var this_0 = new MutableVector(tmp$ret$3, 0);
    // Inline function 'androidx.compose.ui.node.Nodes.FocusTarget' call
    // Inline function 'androidx.compose.ui.node.visitChildren' call
    var type = _NodeKind___init__impl__ojsprp(1024);
    // Inline function 'androidx.compose.ui.node.visitChildren' call
    var mask = _NodeKind___get_mask__impl__1uopb6(type);
    // Inline function 'androidx.compose.ui.internal.checkPrecondition' call
    if (!_this__u8e3s4.f4n().z8v_1) {
      var tmp$ret$10 = 'visitChildren called on an unattached node';
      throwIllegalStateException(tmp$ret$10);
    }
    // Inline function 'androidx.compose.runtime.collection.mutableVectorOf' call
    // Inline function 'androidx.compose.runtime.collection.MutableVector' call
    // Inline function 'kotlin.arrayOfNulls' call
    var tmp$ret$13 = Array(16);
    var branches = new MutableVector(tmp$ret$13, 0);
    var child = _this__u8e3s4.f4n().r8v_1;
    if (child == null) {
      access$addLayoutNodeChildren$tDelegatableNodeKt(branches, _this__u8e3s4.f4n(), false);
    } else
      branches.zz(child);
    $l$loop_0: while (true) {
      // Inline function 'androidx.compose.runtime.collection.MutableVector.isNotEmpty' call
      if (!!(branches.d3e_1 === 0)) {
        break $l$loop_0;
      }
      // Inline function 'androidx.compose.runtime.collection.MutableVector.lastIndex' call
      var tmp$ret$15 = branches.d3e_1 - 1 | 0;
      var branch = branches.h3(tmp$ret$15);
      if ((branch.p8v_1 & mask) === 0) {
        access$addLayoutNodeChildren$tDelegatableNodeKt(branches, branch, false);
        continue $l$loop_0;
      }
      var node = branch;
      $l$loop_2: while (!(node == null)) {
        if (!((node.o8v_1 & mask) === 0)) {
          // Inline function 'androidx.compose.ui.node.dispatchForKind' call
          // Inline function 'androidx.compose.ui.node.dispatchForKind' call
          var stack = null;
          var node_0 = node;
          $l$loop_1: while (!(node_0 == null)) {
            var tmp;
            if (node_0 instanceof FocusTargetNode) {
              var it = node_0;
              this_0.zz(it);
              tmp = false;
            } else {
              tmp = true;
            }
            var dispatchAgain = tmp;
            var tmp_0;
            var tmp_1;
            if (dispatchAgain || false) {
              // Inline function 'androidx.compose.ui.Node.isKind' call
              tmp_1 = !((node_0.o8v_1 & _NodeKind___get_mask__impl__1uopb6(type)) === 0);
            } else {
              tmp_1 = false;
            }
            if (tmp_1) {
              tmp_0 = node_0 instanceof DelegatingNode;
            } else {
              tmp_0 = false;
            }
            if (tmp_0) {
              var count = 0;
              // Inline function 'androidx.compose.ui.node.DelegatingNode.forEachImmediateDelegate' call
              var node_1 = node_0.e9a_1;
              while (!(node_1 == null)) {
                var next = node_1;
                // Inline function 'androidx.compose.ui.Node.isKind' call
                if (!((next.o8v_1 & _NodeKind___get_mask__impl__1uopb6(type)) === 0)) {
                  count = count + 1 | 0;
                  if (count === 1) {
                    node_0 = next;
                  } else {
                    var tmp0_elvis_lhs = stack;
                    var tmp_2;
                    if (tmp0_elvis_lhs == null) {
                      // Inline function 'androidx.compose.runtime.collection.mutableVectorOf' call
                      // Inline function 'androidx.compose.runtime.collection.MutableVector' call
                      // Inline function 'kotlin.arrayOfNulls' call
                      var tmp$ret$26 = Array(16);
                      tmp_2 = new MutableVector(tmp$ret$26, 0);
                    } else {
                      tmp_2 = tmp0_elvis_lhs;
                    }
                    stack = tmp_2;
                    var theNode = node_0;
                    if (!(theNode == null)) {
                      var tmp1_safe_receiver = stack;
                      if (tmp1_safe_receiver == null)
                        null;
                      else
                        tmp1_safe_receiver.zz(theNode);
                      node_0 = null;
                    }
                    var tmp2_safe_receiver = stack;
                    if (tmp2_safe_receiver == null)
                      null;
                    else
                      tmp2_safe_receiver.zz(next);
                  }
                }
                node_1 = node_1.r8v_1;
              }
              if (count === 1) {
                continue $l$loop_1;
              }
            }
            node_0 = access$pop$tDelegatableNodeKt(stack);
          }
          break $l$loop_2;
        }
        node = node.r8v_1;
      }
    }
    var children = this_0;
    children.o4a(FocusableChildrenComparator_instance);
    if (direction === Companion_getInstance_30().k9b_1) {
      // Inline function 'androidx.compose.ui.focus.forEachItemAfter' call
      var itemFound = false;
      // Inline function 'androidx.compose.runtime.collection.MutableVector.indices' call
      var progression = until(0, children.d3e_1);
      var inductionVariable = progression.x1_1;
      var last = progression.y1_1;
      if (inductionVariable <= last)
        do {
          var index = inductionVariable;
          inductionVariable = inductionVariable + 1 | 0;
          if (itemFound) {
            // Inline function 'androidx.compose.runtime.collection.MutableVector.get' call
            var index_0 = index;
            var child_0 = children.b3e_1[index_0];
            if (get_isEligibleForFocusSearch(child_0) && forwardFocusSearch(child_0, onFound))
              return true;
          }
          // Inline function 'androidx.compose.runtime.collection.MutableVector.get' call
          var index_1 = index;
          var tmp$ret$31 = children.b3e_1[index_1];
          if (equals(tmp$ret$31, focusedItem)) {
            itemFound = true;
          }
        }
         while (!(index === last));
    } else if (direction === Companion_getInstance_30().l9b_1) {
      // Inline function 'androidx.compose.ui.focus.forEachItemBefore' call
      var itemFound_0 = false;
      // Inline function 'androidx.compose.runtime.collection.MutableVector.indices' call
      var progression_0 = until(0, children.d3e_1);
      var last_0 = progression_0.x1_1;
      var inductionVariable_0 = progression_0.y1_1;
      if (last_0 <= inductionVariable_0)
        do {
          var index_2 = inductionVariable_0;
          inductionVariable_0 = inductionVariable_0 + -1 | 0;
          if (itemFound_0) {
            // Inline function 'androidx.compose.runtime.collection.MutableVector.get' call
            var index_3 = index_2;
            var child_1 = children.b3e_1[index_3];
            if (get_isEligibleForFocusSearch(child_1) && backwardFocusSearch(child_1, onFound))
              return true;
          }
          // Inline function 'androidx.compose.runtime.collection.MutableVector.get' call
          var index_4 = index_2;
          var tmp$ret$36 = children.b3e_1[index_4];
          if (equals(tmp$ret$36, focusedItem)) {
            itemFound_0 = true;
          }
        }
         while (!(index_2 === last_0));
    } else {
      // Inline function 'kotlin.error' call
      var message_0 = 'This function should only be used for 1-D focus search';
      throw IllegalStateException_init_$Create$(toString(message_0));
    }
    if (direction === Companion_getInstance_30().k9b_1 || !_this__u8e3s4.v9h().a9f() || isRoot(_this__u8e3s4))
      return false;
    return onFound(_this__u8e3s4);
  }
  function pathFromRoot($this, layoutNode) {
    // Inline function 'androidx.compose.runtime.collection.mutableVectorOf' call
    // Inline function 'androidx.compose.runtime.collection.MutableVector' call
    // Inline function 'kotlin.arrayOfNulls' call
    var tmp$ret$2 = Array(16);
    var path = new MutableVector(tmp$ret$2, 0);
    var current = layoutNode;
    while (!(current == null)) {
      path.ni(0, current);
      current = current.f9a();
    }
    return path;
  }
  function FocusableChildrenComparator() {
  }
  protoOf(FocusableChildrenComparator).c9i = function (a, b) {
    if (!get_isEligibleForFocusSearch(a) || !get_isEligibleForFocusSearch(b)) {
      if (get_isEligibleForFocusSearch(a))
        return -1;
      if (get_isEligibleForFocusSearch(b))
        return 1;
      return 0;
    }
    var layoutNode1 = requireLayoutNode(a);
    var layoutNode2 = requireLayoutNode(b);
    if (equals(layoutNode1, layoutNode2))
      return 0;
    var pathFromRoot1 = pathFromRoot(this, layoutNode1);
    var pathFromRoot2 = pathFromRoot(this, layoutNode2);
    var inductionVariable = 0;
    // Inline function 'androidx.compose.runtime.collection.MutableVector.lastIndex' call
    var tmp0 = pathFromRoot1.d3e_1 - 1 | 0;
    // Inline function 'androidx.compose.runtime.collection.MutableVector.lastIndex' call
    // Inline function 'kotlin.comparisons.minOf' call
    var b_0 = pathFromRoot2.d3e_1 - 1 | 0;
    var last = Math.min(tmp0, b_0);
    if (inductionVariable <= last)
      do {
        var depth = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        // Inline function 'androidx.compose.runtime.collection.MutableVector.get' call
        var index = depth;
        var tmp = pathFromRoot1.b3e_1[index];
        // Inline function 'androidx.compose.runtime.collection.MutableVector.get' call
        var index_0 = depth;
        var tmp$ret$4 = pathFromRoot2.b3e_1[index_0];
        if (!equals(tmp, tmp$ret$4)) {
          // Inline function 'androidx.compose.runtime.collection.MutableVector.get' call
          var index_1 = depth;
          var tmp_0 = pathFromRoot1.b3e_1[index_1].d9i();
          // Inline function 'androidx.compose.runtime.collection.MutableVector.get' call
          var index_2 = depth;
          var tmp$ret$6 = pathFromRoot2.b3e_1[index_2];
          return compareTo(tmp_0, tmp$ret$6.d9i());
        }
      }
       while (!(depth === last));
    // Inline function 'kotlin.error' call
    var message = 'Could not find a common ancestor between the two FocusModifiers.';
    throw IllegalStateException_init_$Create$(toString(message));
  };
  protoOf(FocusableChildrenComparator).compare = function (a, b) {
    var tmp = a instanceof FocusTargetNode ? a : THROW_CCE();
    return this.c9i(tmp, b instanceof FocusTargetNode ? b : THROW_CCE());
  };
  var FocusableChildrenComparator_instance;
  function FocusableChildrenComparator_getInstance() {
    return FocusableChildrenComparator_instance;
  }
  function isRoot(_this__u8e3s4) {
    // Inline function 'androidx.compose.ui.node.Nodes.FocusTarget' call
    var tmp2 = _NodeKind___init__impl__ojsprp(1024);
    var tmp$ret$1;
    $l$block: {
      // Inline function 'androidx.compose.ui.node.nearestAncestor' call
      // Inline function 'androidx.compose.ui.node.visitAncestors' call
      // Inline function 'androidx.compose.ui.node.visitAncestors' call
      var mask = _NodeKind___get_mask__impl__1uopb6(tmp2);
      // Inline function 'androidx.compose.ui.internal.checkPrecondition' call
      if (!_this__u8e3s4.f4n().z8v_1) {
        var tmp$ret$5 = 'visitAncestors called on an unattached node';
        throwIllegalStateException(tmp$ret$5);
      }
      var node = false ? _this__u8e3s4.f4n() : _this__u8e3s4.f4n().q8v_1;
      var layout = requireLayoutNode(_this__u8e3s4);
      while (!(layout == null)) {
        var head = layout.d91_1.j99_1;
        if (!((head.p8v_1 & mask) === 0)) {
          while (!(node == null)) {
            if (!((node.o8v_1 & mask) === 0)) {
              // Inline function 'androidx.compose.ui.node.dispatchForKind' call
              var stack = null;
              var node_0 = node;
              $l$loop: while (!(node_0 == null)) {
                var tmp;
                if (node_0 instanceof FocusTargetNode) {
                  tmp$ret$1 = node_0;
                  break $l$block;
                } else {
                  tmp = true;
                }
                var dispatchAgain = tmp;
                var tmp_0;
                var tmp_1;
                if (dispatchAgain || false) {
                  // Inline function 'androidx.compose.ui.Node.isKind' call
                  tmp_1 = !((node_0.o8v_1 & _NodeKind___get_mask__impl__1uopb6(tmp2)) === 0);
                } else {
                  tmp_1 = false;
                }
                if (tmp_1) {
                  tmp_0 = node_0 instanceof DelegatingNode;
                } else {
                  tmp_0 = false;
                }
                if (tmp_0) {
                  var count = 0;
                  // Inline function 'androidx.compose.ui.node.DelegatingNode.forEachImmediateDelegate' call
                  var node_1 = node_0.e9a_1;
                  while (!(node_1 == null)) {
                    var next = node_1;
                    // Inline function 'androidx.compose.ui.Node.isKind' call
                    if (!((next.o8v_1 & _NodeKind___get_mask__impl__1uopb6(tmp2)) === 0)) {
                      count = count + 1 | 0;
                      if (count === 1) {
                        node_0 = next;
                      } else {
                        var tmp0_elvis_lhs = stack;
                        var tmp_2;
                        if (tmp0_elvis_lhs == null) {
                          // Inline function 'androidx.compose.runtime.collection.mutableVectorOf' call
                          // Inline function 'androidx.compose.runtime.collection.MutableVector' call
                          // Inline function 'kotlin.arrayOfNulls' call
                          var tmp$ret$15 = Array(16);
                          tmp_2 = new MutableVector(tmp$ret$15, 0);
                        } else {
                          tmp_2 = tmp0_elvis_lhs;
                        }
                        stack = tmp_2;
                        var theNode = node_0;
                        if (!(theNode == null)) {
                          var tmp1_safe_receiver = stack;
                          if (tmp1_safe_receiver == null)
                            null;
                          else
                            tmp1_safe_receiver.zz(theNode);
                          node_0 = null;
                        }
                        var tmp2_safe_receiver = stack;
                        if (tmp2_safe_receiver == null)
                          null;
                        else
                          tmp2_safe_receiver.zz(next);
                      }
                    }
                    node_1 = node_1.r8v_1;
                  }
                  if (count === 1) {
                    continue $l$loop;
                  }
                }
                node_0 = access$pop$tDelegatableNodeKt(stack);
              }
            }
            node = node.q8v_1;
          }
        }
        layout = layout.f9a();
        var tmp0_safe_receiver = layout;
        var tmp1_safe_receiver_0 = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.d91_1;
        node = tmp1_safe_receiver_0 == null ? null : tmp1_safe_receiver_0.i99_1;
      }
      tmp$ret$1 = null;
    }
    return tmp$ret$1 == null;
  }
  function generateAndSearchChildren$lambda($activeNodeBeforeSearch, $this_generateAndSearchChildren, $focusedItem, $direction, $onFound) {
    return function ($this$searchBeyondBounds) {
      var tmp;
      if (!($activeNodeBeforeSearch === requireOwner($this_generateAndSearchChildren).o9c().v9c())) {
        tmp = true;
      } else {
        // Inline function 'kotlin.takeIf' call
        var this_0 = searchChildren($this_generateAndSearchChildren, $focusedItem, $direction, $onFound);
        var tmp_0;
        if (this_0 || !$this$searchBeyondBounds.e9i()) {
          tmp_0 = this_0;
        } else {
          tmp_0 = null;
        }
        tmp = tmp_0;
      }
      return tmp;
    };
  }
  function PlatformFocusOwner() {
  }
  function findChildCorrespondingToFocusEnter(_this__u8e3s4, direction, onFound) {
    // Inline function 'androidx.compose.runtime.collection.MutableVector' call
    // Inline function 'kotlin.arrayOfNulls' call
    var tmp$ret$1 = Array(16);
    var focusableChildren = new MutableVector(tmp$ret$1, 0);
    collectAccessibleChildren(_this__u8e3s4, focusableChildren);
    if (focusableChildren.d3e_1 <= 1) {
      // Inline function 'androidx.compose.runtime.collection.MutableVector.firstOrNull' call
      var tmp;
      // Inline function 'androidx.compose.runtime.collection.MutableVector.isEmpty' call
      if (focusableChildren.d3e_1 === 0) {
        tmp = null;
      } else {
        // Inline function 'androidx.compose.runtime.collection.MutableVector.get' call
        tmp = focusableChildren.b3e_1[0];
      }
      var tmp0_safe_receiver = tmp;
      var tmp_0;
      if (tmp0_safe_receiver == null) {
        tmp_0 = null;
      } else {
        // Inline function 'kotlin.let' call
        tmp_0 = onFound(tmp0_safe_receiver);
      }
      var tmp1_elvis_lhs = tmp_0;
      return tmp1_elvis_lhs == null ? false : tmp1_elvis_lhs;
    }
    var requestedDirection = direction === Companion_getInstance_30().q9b_1 ? Companion_getInstance_30().n9b_1 : direction;
    var tmp_1;
    if (requestedDirection === Companion_getInstance_30().n9b_1 || requestedDirection === Companion_getInstance_30().p9b_1) {
      tmp_1 = topLeft(focusRect(_this__u8e3s4));
    } else if (requestedDirection === Companion_getInstance_30().m9b_1 || requestedDirection === Companion_getInstance_30().o9b_1) {
      tmp_1 = bottomRight(focusRect(_this__u8e3s4));
    } else {
      // Inline function 'kotlin.error' call
      var message = 'This function should only be used for 2-D focus search';
      throw IllegalStateException_init_$Create$(toString(message));
    }
    var initialFocusRect = tmp_1;
    var nextCandidate = findBestCandidate(focusableChildren, initialFocusRect, requestedDirection);
    var tmp_2;
    if (nextCandidate == null) {
      tmp_2 = null;
    } else {
      // Inline function 'kotlin.let' call
      tmp_2 = onFound(nextCandidate);
    }
    var tmp5_elvis_lhs = tmp_2;
    return tmp5_elvis_lhs == null ? false : tmp5_elvis_lhs;
  }
  function collectAccessibleChildren(_this__u8e3s4, accessibleChildren) {
    // Inline function 'androidx.compose.ui.node.Nodes.FocusTarget' call
    // Inline function 'androidx.compose.ui.node.visitChildren' call
    var type = _NodeKind___init__impl__ojsprp(1024);
    // Inline function 'androidx.compose.ui.node.visitChildren' call
    var mask = _NodeKind___get_mask__impl__1uopb6(type);
    // Inline function 'androidx.compose.ui.internal.checkPrecondition' call
    if (!_this__u8e3s4.f4n().z8v_1) {
      var tmp$ret$4 = 'visitChildren called on an unattached node';
      throwIllegalStateException(tmp$ret$4);
    }
    // Inline function 'androidx.compose.runtime.collection.mutableVectorOf' call
    // Inline function 'androidx.compose.runtime.collection.MutableVector' call
    // Inline function 'kotlin.arrayOfNulls' call
    var tmp$ret$7 = Array(16);
    var branches = new MutableVector(tmp$ret$7, 0);
    var child = _this__u8e3s4.f4n().r8v_1;
    if (child == null) {
      access$addLayoutNodeChildren$tDelegatableNodeKt(branches, _this__u8e3s4.f4n(), false);
    } else
      branches.zz(child);
    $l$loop_0: while (true) {
      // Inline function 'androidx.compose.runtime.collection.MutableVector.isNotEmpty' call
      if (!!(branches.d3e_1 === 0)) {
        break $l$loop_0;
      }
      // Inline function 'androidx.compose.runtime.collection.MutableVector.lastIndex' call
      var tmp$ret$9 = branches.d3e_1 - 1 | 0;
      var branch = branches.h3(tmp$ret$9);
      if ((branch.p8v_1 & mask) === 0) {
        access$addLayoutNodeChildren$tDelegatableNodeKt(branches, branch, false);
        continue $l$loop_0;
      }
      var node = branch;
      $l$loop_2: while (!(node == null)) {
        if (!((node.o8v_1 & mask) === 0)) {
          // Inline function 'androidx.compose.ui.node.dispatchForKind' call
          // Inline function 'androidx.compose.ui.node.dispatchForKind' call
          var stack = null;
          var node_0 = node;
          $l$loop_1: while (!(node_0 == null)) {
            var tmp;
            if (node_0 instanceof FocusTargetNode) {
              var tmp0 = node_0;
              $l$block: {
                if (!tmp0.z8v_1 || requireLayoutNode(tmp0).o91_1) {
                  break $l$block;
                }
                if (tmp0.v9h().a9f()) {
                  accessibleChildren.zz(tmp0);
                } else {
                  collectAccessibleChildren(tmp0, accessibleChildren);
                }
              }
              tmp = false;
            } else {
              tmp = true;
            }
            var dispatchAgain = tmp;
            var tmp_0;
            var tmp_1;
            if (dispatchAgain || false) {
              // Inline function 'androidx.compose.ui.Node.isKind' call
              tmp_1 = !((node_0.o8v_1 & _NodeKind___get_mask__impl__1uopb6(type)) === 0);
            } else {
              tmp_1 = false;
            }
            if (tmp_1) {
              tmp_0 = node_0 instanceof DelegatingNode;
            } else {
              tmp_0 = false;
            }
            if (tmp_0) {
              var count = 0;
              // Inline function 'androidx.compose.ui.node.DelegatingNode.forEachImmediateDelegate' call
              var node_1 = node_0.e9a_1;
              while (!(node_1 == null)) {
                var next = node_1;
                // Inline function 'androidx.compose.ui.Node.isKind' call
                if (!((next.o8v_1 & _NodeKind___get_mask__impl__1uopb6(type)) === 0)) {
                  count = count + 1 | 0;
                  if (count === 1) {
                    node_0 = next;
                  } else {
                    var tmp0_elvis_lhs = stack;
                    var tmp_2;
                    if (tmp0_elvis_lhs == null) {
                      // Inline function 'androidx.compose.runtime.collection.mutableVectorOf' call
                      // Inline function 'androidx.compose.runtime.collection.MutableVector' call
                      // Inline function 'kotlin.arrayOfNulls' call
                      var tmp$ret$20 = Array(16);
                      tmp_2 = new MutableVector(tmp$ret$20, 0);
                    } else {
                      tmp_2 = tmp0_elvis_lhs;
                    }
                    stack = tmp_2;
                    var theNode = node_0;
                    if (!(theNode == null)) {
                      var tmp1_safe_receiver = stack;
                      if (tmp1_safe_receiver == null)
                        null;
                      else
                        tmp1_safe_receiver.zz(theNode);
                      node_0 = null;
                    }
                    var tmp2_safe_receiver = stack;
                    if (tmp2_safe_receiver == null)
                      null;
                    else
                      tmp2_safe_receiver.zz(next);
                  }
                }
                node_1 = node_1.r8v_1;
              }
              if (count === 1) {
                continue $l$loop_1;
              }
            }
            node_0 = access$pop$tDelegatableNodeKt(stack);
          }
          break $l$loop_2;
        }
        node = node.r8v_1;
      }
    }
  }
  function topLeft(_this__u8e3s4) {
    return new Rect(_this__u8e3s4.k5d_1, _this__u8e3s4.l5d_1, _this__u8e3s4.k5d_1, _this__u8e3s4.l5d_1);
  }
  function bottomRight(_this__u8e3s4) {
    return new Rect(_this__u8e3s4.m5d_1, _this__u8e3s4.n5d_1, _this__u8e3s4.m5d_1, _this__u8e3s4.n5d_1);
  }
  function findBestCandidate(_this__u8e3s4, focusRect_0, direction) {
    var tmp;
    if (direction === Companion_getInstance_30().m9b_1) {
      // Inline function 'androidx.compose.ui.geometry.Rect.width' call
      var tmp$ret$0 = focusRect_0.m5d_1 - focusRect_0.k5d_1;
      tmp = focusRect_0.q5d(tmp$ret$0 + 1, 0.0);
    } else if (direction === Companion_getInstance_30().n9b_1) {
      // Inline function 'androidx.compose.ui.geometry.Rect.width' call
      var tmp$ret$1 = focusRect_0.m5d_1 - focusRect_0.k5d_1;
      tmp = focusRect_0.q5d(-(tmp$ret$1 + 1), 0.0);
    } else if (direction === Companion_getInstance_30().o9b_1) {
      // Inline function 'androidx.compose.ui.geometry.Rect.height' call
      var tmp$ret$2 = focusRect_0.n5d_1 - focusRect_0.l5d_1;
      tmp = focusRect_0.q5d(0.0, tmp$ret$2 + 1);
    } else if (direction === Companion_getInstance_30().p9b_1) {
      // Inline function 'androidx.compose.ui.geometry.Rect.height' call
      var tmp$ret$3 = focusRect_0.n5d_1 - focusRect_0.l5d_1;
      tmp = focusRect_0.q5d(0.0, -(tmp$ret$3 + 1));
    } else {
      // Inline function 'kotlin.error' call
      var message = 'This function should only be used for 2-D focus search';
      throw IllegalStateException_init_$Create$(toString(message));
    }
    var bestCandidate = tmp;
    var searchResult = null;
    // Inline function 'androidx.compose.runtime.collection.MutableVector.forEach' call
    var i = 0;
    var tmp_0 = _this__u8e3s4.b3e_1;
    var content = isArray(tmp_0) ? tmp_0 : THROW_CCE();
    var size = _this__u8e3s4.d3e_1;
    while (i < size) {
      var candidateNode = content[i];
      if (get_isEligibleForFocusSearch(candidateNode)) {
        var candidateRect = focusRect(candidateNode);
        if (isBetterCandidate(candidateRect, bestCandidate, focusRect_0, direction)) {
          bestCandidate = candidateRect;
          searchResult = candidateNode;
        }
      }
      i = i + 1 | 0;
    }
    return searchResult;
  }
  function isBetterCandidate(proposedCandidate, currentCandidate, focusedRect, direction) {
    return !isBetterCandidate$isCandidate(proposedCandidate, direction, focusedRect) ? false : !isBetterCandidate$isCandidate(currentCandidate, direction, focusedRect) ? true : beamBeats(focusedRect, proposedCandidate, currentCandidate, direction) ? true : beamBeats(focusedRect, currentCandidate, proposedCandidate, direction) ? false : compare(isBetterCandidate$weightedDistance(direction, focusedRect, proposedCandidate), isBetterCandidate$weightedDistance(direction, focusedRect, currentCandidate)) < 0;
  }
  function beamBeats(source, rect1, rect2, direction) {
    return beamBeats$inSourceBeam(rect2, direction, source) || !beamBeats$inSourceBeam(rect1, direction, source) ? false : !beamBeats$isInDirectionOfSearch(rect2, direction, source) ? true : direction === Companion_getInstance_30().m9b_1 || direction === Companion_getInstance_30().n9b_1 ? true : beamBeats$majorAxisDistance(rect1, direction, source) < beamBeats$majorAxisDistanceToFarEdge(rect2, direction, source);
  }
  function twoDimensionalFocusSearch(_this__u8e3s4, direction, previouslyFocusedRect, onFound) {
    switch (_this__u8e3s4.x9c().a1_1) {
      case 3:
        var tmp;
        if (_this__u8e3s4.v9h().a9f()) {
          tmp = onFound(_this__u8e3s4);
        } else if (previouslyFocusedRect == null) {
          tmp = findChildCorrespondingToFocusEnter(_this__u8e3s4, direction, onFound);
        } else {
          tmp = searchChildren_0(_this__u8e3s4, previouslyFocusedRect, direction, onFound);
        }

        return tmp;
      case 1:
        var tmp1_elvis_lhs = get_activeChild(_this__u8e3s4);
        var tmp_0;
        if (tmp1_elvis_lhs == null) {
          // Inline function 'kotlin.error' call
          var message = 'ActiveParent must have a focusedChild';
          throw IllegalStateException_init_$Create$(toString(message));
        } else {
          tmp_0 = tmp1_elvis_lhs;
        }

        var focusedChild = tmp_0;
        switch (focusedChild.x9c().a1_1) {
          case 1:
            var found = twoDimensionalFocusSearch(focusedChild, direction, previouslyFocusedRect, onFound);
            if (!(found === false))
              return found;
            return generateAndSearchChildren_0(_this__u8e3s4, previouslyFocusedRect == null ? focusRect(activeNode(focusedChild)) : previouslyFocusedRect, direction, onFound);
          case 0:
          case 2:
            return generateAndSearchChildren_0(_this__u8e3s4, previouslyFocusedRect == null ? focusRect(focusedChild) : previouslyFocusedRect, direction, onFound);
          case 3:
            // Inline function 'kotlin.error' call

            var message_0 = 'ActiveParent must have a focusedChild';
            throw IllegalStateException_init_$Create$(toString(message_0));
          default:
            noWhenBranchMatchedException();
            break;
        }

        break;
      case 0:
      case 2:
        return findChildCorrespondingToFocusEnter(_this__u8e3s4, direction, onFound);
      default:
        noWhenBranchMatchedException();
        break;
    }
  }
  function searchChildren_0(_this__u8e3s4, focusedItem, direction, onFound) {
    // Inline function 'androidx.compose.runtime.collection.MutableVector' call
    // Inline function 'kotlin.arrayOfNulls' call
    var tmp$ret$1 = Array(16);
    // Inline function 'kotlin.apply' call
    var this_0 = new MutableVector(tmp$ret$1, 0);
    // Inline function 'androidx.compose.ui.node.Nodes.FocusTarget' call
    // Inline function 'androidx.compose.ui.node.visitChildren' call
    var type = _NodeKind___init__impl__ojsprp(1024);
    // Inline function 'androidx.compose.ui.node.visitChildren' call
    var mask = _NodeKind___get_mask__impl__1uopb6(type);
    // Inline function 'androidx.compose.ui.internal.checkPrecondition' call
    if (!_this__u8e3s4.f4n().z8v_1) {
      var tmp$ret$8 = 'visitChildren called on an unattached node';
      throwIllegalStateException(tmp$ret$8);
    }
    // Inline function 'androidx.compose.runtime.collection.mutableVectorOf' call
    // Inline function 'androidx.compose.runtime.collection.MutableVector' call
    // Inline function 'kotlin.arrayOfNulls' call
    var tmp$ret$11 = Array(16);
    var branches = new MutableVector(tmp$ret$11, 0);
    var child = _this__u8e3s4.f4n().r8v_1;
    if (child == null) {
      access$addLayoutNodeChildren$tDelegatableNodeKt(branches, _this__u8e3s4.f4n(), false);
    } else
      branches.zz(child);
    $l$loop_0: while (true) {
      // Inline function 'androidx.compose.runtime.collection.MutableVector.isNotEmpty' call
      if (!!(branches.d3e_1 === 0)) {
        break $l$loop_0;
      }
      // Inline function 'androidx.compose.runtime.collection.MutableVector.lastIndex' call
      var tmp$ret$13 = branches.d3e_1 - 1 | 0;
      var branch = branches.h3(tmp$ret$13);
      if ((branch.p8v_1 & mask) === 0) {
        access$addLayoutNodeChildren$tDelegatableNodeKt(branches, branch, false);
        continue $l$loop_0;
      }
      var node = branch;
      $l$loop_2: while (!(node == null)) {
        if (!((node.o8v_1 & mask) === 0)) {
          // Inline function 'androidx.compose.ui.node.dispatchForKind' call
          // Inline function 'androidx.compose.ui.node.dispatchForKind' call
          var stack = null;
          var node_0 = node;
          $l$loop_1: while (!(node_0 == null)) {
            var tmp;
            if (node_0 instanceof FocusTargetNode) {
              var it = node_0;
              if (it.z8v_1) {
                this_0.zz(it);
              }
              tmp = false;
            } else {
              tmp = true;
            }
            var dispatchAgain = tmp;
            var tmp_0;
            var tmp_1;
            if (dispatchAgain || false) {
              // Inline function 'androidx.compose.ui.Node.isKind' call
              tmp_1 = !((node_0.o8v_1 & _NodeKind___get_mask__impl__1uopb6(type)) === 0);
            } else {
              tmp_1 = false;
            }
            if (tmp_1) {
              tmp_0 = node_0 instanceof DelegatingNode;
            } else {
              tmp_0 = false;
            }
            if (tmp_0) {
              var count = 0;
              // Inline function 'androidx.compose.ui.node.DelegatingNode.forEachImmediateDelegate' call
              var node_1 = node_0.e9a_1;
              while (!(node_1 == null)) {
                var next = node_1;
                // Inline function 'androidx.compose.ui.Node.isKind' call
                if (!((next.o8v_1 & _NodeKind___get_mask__impl__1uopb6(type)) === 0)) {
                  count = count + 1 | 0;
                  if (count === 1) {
                    node_0 = next;
                  } else {
                    var tmp0_elvis_lhs = stack;
                    var tmp_2;
                    if (tmp0_elvis_lhs == null) {
                      // Inline function 'androidx.compose.runtime.collection.mutableVectorOf' call
                      // Inline function 'androidx.compose.runtime.collection.MutableVector' call
                      // Inline function 'kotlin.arrayOfNulls' call
                      var tmp$ret$24 = Array(16);
                      tmp_2 = new MutableVector(tmp$ret$24, 0);
                    } else {
                      tmp_2 = tmp0_elvis_lhs;
                    }
                    stack = tmp_2;
                    var theNode = node_0;
                    if (!(theNode == null)) {
                      var tmp1_safe_receiver = stack;
                      if (tmp1_safe_receiver == null)
                        null;
                      else
                        tmp1_safe_receiver.zz(theNode);
                      node_0 = null;
                    }
                    var tmp2_safe_receiver = stack;
                    if (tmp2_safe_receiver == null)
                      null;
                    else
                      tmp2_safe_receiver.zz(next);
                  }
                }
                node_1 = node_1.r8v_1;
              }
              if (count === 1) {
                continue $l$loop_1;
              }
            }
            node_0 = access$pop$tDelegatableNodeKt(stack);
          }
          break $l$loop_2;
        }
        node = node.r8v_1;
      }
    }
    var children = this_0;
    $l$loop_3: while (true) {
      // Inline function 'androidx.compose.runtime.collection.MutableVector.isNotEmpty' call
      if (!!(children.d3e_1 === 0)) {
        break $l$loop_3;
      }
      var tmp0_elvis_lhs_0 = findBestCandidate(children, focusedItem, direction);
      var tmp_3;
      if (tmp0_elvis_lhs_0 == null) {
        return false;
      } else {
        tmp_3 = tmp0_elvis_lhs_0;
      }
      var nextItem = tmp_3;
      if (nextItem.v9h().a9f())
        return onFound(nextItem);
      if (generateAndSearchChildren_0(nextItem, focusedItem, direction, onFound))
        return true;
      children.g10(nextItem);
    }
    return false;
  }
  function generateAndSearchChildren_0(_this__u8e3s4, focusedItem, direction, onFound) {
    if (searchChildren_0(_this__u8e3s4, focusedItem, direction, onFound)) {
      return true;
    }
    var activeNodeBeforeSearch = requireOwner(_this__u8e3s4).o9c().v9c();
    var tmp0_elvis_lhs = searchBeyondBounds(_this__u8e3s4, direction, generateAndSearchChildren$lambda_0(activeNodeBeforeSearch, _this__u8e3s4, focusedItem, direction, onFound));
    return tmp0_elvis_lhs == null ? false : tmp0_elvis_lhs;
  }
  function activeNode(_this__u8e3s4) {
    // Inline function 'kotlin.check' call
    if (!_this__u8e3s4.x9c().equals(FocusStateImpl_ActiveParent_getInstance())) {
      var message = 'Searching for active node in inactive hierarchy';
      throw IllegalStateException_init_$Create$(toString(message));
    }
    var tmp0_elvis_lhs = findActiveFocusNode(_this__u8e3s4);
    var tmp;
    if (tmp0_elvis_lhs == null) {
      // Inline function 'kotlin.error' call
      var message_0 = 'ActiveParent must have a focusedChild';
      throw IllegalStateException_init_$Create$(toString(message_0));
    } else {
      tmp = tmp0_elvis_lhs;
    }
    return tmp;
  }
  function isBetterCandidate$isCandidate(_this__u8e3s4, $direction, $focusedRect) {
    var tmp;
    if ($direction === Companion_getInstance_30().m9b_1) {
      tmp = (($focusedRect.m5d_1 > _this__u8e3s4.m5d_1 || $focusedRect.k5d_1 >= _this__u8e3s4.m5d_1) && $focusedRect.k5d_1 > _this__u8e3s4.k5d_1);
    } else if ($direction === Companion_getInstance_30().n9b_1) {
      tmp = (($focusedRect.k5d_1 < _this__u8e3s4.k5d_1 || $focusedRect.m5d_1 <= _this__u8e3s4.k5d_1) && $focusedRect.m5d_1 < _this__u8e3s4.m5d_1);
    } else if ($direction === Companion_getInstance_30().o9b_1) {
      tmp = (($focusedRect.n5d_1 > _this__u8e3s4.n5d_1 || $focusedRect.l5d_1 >= _this__u8e3s4.n5d_1) && $focusedRect.l5d_1 > _this__u8e3s4.l5d_1);
    } else if ($direction === Companion_getInstance_30().p9b_1) {
      tmp = (($focusedRect.l5d_1 < _this__u8e3s4.l5d_1 || $focusedRect.n5d_1 <= _this__u8e3s4.l5d_1) && $focusedRect.n5d_1 < _this__u8e3s4.n5d_1);
    } else {
      // Inline function 'kotlin.error' call
      var message = 'This function should only be used for 2-D focus search';
      throw IllegalStateException_init_$Create$(toString(message));
    }
    return tmp;
  }
  function isBetterCandidate$majorAxisDistance(_this__u8e3s4, $direction, $focusedRect) {
    var tmp;
    if ($direction === Companion_getInstance_30().m9b_1) {
      tmp = $focusedRect.k5d_1 - _this__u8e3s4.m5d_1;
    } else if ($direction === Companion_getInstance_30().n9b_1) {
      tmp = _this__u8e3s4.k5d_1 - $focusedRect.m5d_1;
    } else if ($direction === Companion_getInstance_30().o9b_1) {
      tmp = $focusedRect.l5d_1 - _this__u8e3s4.n5d_1;
    } else if ($direction === Companion_getInstance_30().p9b_1) {
      tmp = _this__u8e3s4.l5d_1 - $focusedRect.n5d_1;
    } else {
      // Inline function 'kotlin.error' call
      var message = 'This function should only be used for 2-D focus search';
      throw IllegalStateException_init_$Create$(toString(message));
    }
    var majorAxisDistance = tmp;
    // Inline function 'androidx.compose.ui.util.fastCoerceAtLeast' call
    return majorAxisDistance < 0.0 ? 0.0 : majorAxisDistance;
  }
  function isBetterCandidate$minorAxisDistance(_this__u8e3s4, $direction, $focusedRect) {
    var tmp;
    if ($direction === Companion_getInstance_30().m9b_1 || $direction === Companion_getInstance_30().n9b_1) {
      // Inline function 'androidx.compose.ui.geometry.Rect.height' call
      var tmp$ret$0 = $focusedRect.n5d_1 - $focusedRect.l5d_1;
      var tmp_0 = $focusedRect.l5d_1 + tmp$ret$0 / 2;
      // Inline function 'androidx.compose.ui.geometry.Rect.height' call
      var tmp$ret$1 = _this__u8e3s4.n5d_1 - _this__u8e3s4.l5d_1;
      tmp = tmp_0 - (_this__u8e3s4.l5d_1 + tmp$ret$1 / 2);
    } else if ($direction === Companion_getInstance_30().o9b_1 || $direction === Companion_getInstance_30().p9b_1) {
      // Inline function 'androidx.compose.ui.geometry.Rect.width' call
      var tmp$ret$2 = $focusedRect.m5d_1 - $focusedRect.k5d_1;
      var tmp_1 = $focusedRect.k5d_1 + tmp$ret$2 / 2;
      // Inline function 'androidx.compose.ui.geometry.Rect.width' call
      var tmp$ret$3 = _this__u8e3s4.m5d_1 - _this__u8e3s4.k5d_1;
      tmp = tmp_1 - (_this__u8e3s4.k5d_1 + tmp$ret$3 / 2);
    } else {
      // Inline function 'kotlin.error' call
      var message = 'This function should only be used for 2-D focus search';
      throw IllegalStateException_init_$Create$(toString(message));
    }
    return tmp;
  }
  function isBetterCandidate$weightedDistance($direction, $focusedRect, candidate) {
    var majorAxisDistance = numberToLong(isBetterCandidate$majorAxisDistance(candidate, $direction, $focusedRect));
    var minorAxisDistance = numberToLong(isBetterCandidate$minorAxisDistance(candidate, $direction, $focusedRect));
    return add(multiply(multiply(numberToLong(13), majorAxisDistance), majorAxisDistance), multiply(minorAxisDistance, minorAxisDistance));
  }
  function beamBeats$inSourceBeam(_this__u8e3s4, $direction, $source) {
    var tmp;
    if ($direction === Companion_getInstance_30().m9b_1 || $direction === Companion_getInstance_30().n9b_1) {
      tmp = (_this__u8e3s4.n5d_1 > $source.l5d_1 && _this__u8e3s4.l5d_1 < $source.n5d_1);
    } else if ($direction === Companion_getInstance_30().o9b_1 || $direction === Companion_getInstance_30().p9b_1) {
      tmp = (_this__u8e3s4.m5d_1 > $source.k5d_1 && _this__u8e3s4.k5d_1 < $source.m5d_1);
    } else {
      // Inline function 'kotlin.error' call
      var message = 'This function should only be used for 2-D focus search';
      throw IllegalStateException_init_$Create$(toString(message));
    }
    return tmp;
  }
  function beamBeats$isInDirectionOfSearch(_this__u8e3s4, $direction, $source) {
    var tmp;
    if ($direction === Companion_getInstance_30().m9b_1) {
      tmp = $source.k5d_1 >= _this__u8e3s4.m5d_1;
    } else if ($direction === Companion_getInstance_30().n9b_1) {
      tmp = $source.m5d_1 <= _this__u8e3s4.k5d_1;
    } else if ($direction === Companion_getInstance_30().o9b_1) {
      tmp = $source.l5d_1 >= _this__u8e3s4.n5d_1;
    } else if ($direction === Companion_getInstance_30().p9b_1) {
      tmp = $source.n5d_1 <= _this__u8e3s4.l5d_1;
    } else {
      // Inline function 'kotlin.error' call
      var message = 'This function should only be used for 2-D focus search';
      throw IllegalStateException_init_$Create$(toString(message));
    }
    return tmp;
  }
  function beamBeats$majorAxisDistance(_this__u8e3s4, $direction, $source) {
    var tmp;
    if ($direction === Companion_getInstance_30().m9b_1) {
      tmp = $source.k5d_1 - _this__u8e3s4.m5d_1;
    } else if ($direction === Companion_getInstance_30().n9b_1) {
      tmp = _this__u8e3s4.k5d_1 - $source.m5d_1;
    } else if ($direction === Companion_getInstance_30().o9b_1) {
      tmp = $source.l5d_1 - _this__u8e3s4.n5d_1;
    } else if ($direction === Companion_getInstance_30().p9b_1) {
      tmp = _this__u8e3s4.l5d_1 - $source.n5d_1;
    } else {
      // Inline function 'kotlin.error' call
      var message = 'This function should only be used for 2-D focus search';
      throw IllegalStateException_init_$Create$(toString(message));
    }
    var majorAxisDistance = tmp;
    // Inline function 'androidx.compose.ui.util.fastCoerceAtLeast' call
    return majorAxisDistance < 0.0 ? 0.0 : majorAxisDistance;
  }
  function beamBeats$majorAxisDistanceToFarEdge(_this__u8e3s4, $direction, $source) {
    var tmp;
    if ($direction === Companion_getInstance_30().m9b_1) {
      tmp = $source.k5d_1 - _this__u8e3s4.k5d_1;
    } else if ($direction === Companion_getInstance_30().n9b_1) {
      tmp = _this__u8e3s4.m5d_1 - $source.m5d_1;
    } else if ($direction === Companion_getInstance_30().o9b_1) {
      tmp = $source.l5d_1 - _this__u8e3s4.l5d_1;
    } else if ($direction === Companion_getInstance_30().p9b_1) {
      tmp = _this__u8e3s4.n5d_1 - $source.n5d_1;
    } else {
      // Inline function 'kotlin.error' call
      var message = 'This function should only be used for 2-D focus search';
      throw IllegalStateException_init_$Create$(toString(message));
    }
    var majorAxisDistance = tmp;
    // Inline function 'androidx.compose.ui.util.fastCoerceAtLeast' call
    return majorAxisDistance < 1.0 ? 1.0 : majorAxisDistance;
  }
  function generateAndSearchChildren$lambda_0($activeNodeBeforeSearch, $this_generateAndSearchChildren, $focusedItem, $direction, $onFound) {
    return function ($this$searchBeyondBounds) {
      var tmp;
      if (!($activeNodeBeforeSearch === requireOwner($this_generateAndSearchChildren).o9c().v9c())) {
        tmp = true;
      } else {
        // Inline function 'kotlin.takeIf' call
        var this_0 = searchChildren_0($this_generateAndSearchChildren, $focusedItem, $direction, $onFound);
        var tmp_0;
        if (this_0 || !$this$searchBeyondBounds.e9i()) {
          tmp_0 = this_0;
        } else {
          tmp_0 = null;
        }
        tmp = tmp_0;
      }
      return tmp;
    };
  }
  var reusableGraphicsLayerScope;
  var androidx_compose_ui_graphics_BlockGraphicsLayerModifier$stable;
  function graphicsLayer(_this__u8e3s4, block) {
    return _this__u8e3s4.d8v(new BlockGraphicsLayerElement(block));
  }
  function graphicsLayer_0(_this__u8e3s4, scaleX, scaleY, alpha, translationX, translationY, shadowElevation, rotationX, rotationY, rotationZ, cameraDistance, transformOrigin, shape, clip, renderEffect, ambientShadowColor, spotShadowColor, compositingStrategy, blendMode, colorFilter) {
    scaleX = scaleX === VOID ? 1.0 : scaleX;
    scaleY = scaleY === VOID ? 1.0 : scaleY;
    alpha = alpha === VOID ? 1.0 : alpha;
    translationX = translationX === VOID ? 0.0 : translationX;
    translationY = translationY === VOID ? 0.0 : translationY;
    shadowElevation = shadowElevation === VOID ? 0.0 : shadowElevation;
    rotationX = rotationX === VOID ? 0.0 : rotationX;
    rotationY = rotationY === VOID ? 0.0 : rotationY;
    rotationZ = rotationZ === VOID ? 0.0 : rotationZ;
    cameraDistance = cameraDistance === VOID ? 8.0 : cameraDistance;
    transformOrigin = transformOrigin === VOID ? Companion_getInstance_35().f9i_1 : transformOrigin;
    shape = shape === VOID ? get_RectangleShape() : shape;
    clip = clip === VOID ? false : clip;
    renderEffect = renderEffect === VOID ? null : renderEffect;
    ambientShadowColor = ambientShadowColor === VOID ? get_DefaultShadowColor() : ambientShadowColor;
    spotShadowColor = spotShadowColor === VOID ? get_DefaultShadowColor() : spotShadowColor;
    compositingStrategy = compositingStrategy === VOID ? Companion_getInstance_34().g9i_1 : compositingStrategy;
    blendMode = blendMode === VOID ? Companion_getInstance_3().b6a_1 : blendMode;
    colorFilter = colorFilter === VOID ? null : colorFilter;
    return _this__u8e3s4.d8v(new GraphicsLayerElement(scaleX, scaleY, alpha, translationX, translationY, shadowElevation, rotationX, rotationY, rotationZ, cameraDistance, transformOrigin, shape, clip, renderEffect, ambientShadowColor, spotShadowColor, compositingStrategy, blendMode, colorFilter));
  }
  function BlockGraphicsLayerModifier$measure$lambda($placeable, this$0) {
    return function ($this$layout) {
      $this$layout.j9i($placeable, 0, 0, VOID, this$0.b99_1);
      return Unit_instance;
    };
  }
  function BlockGraphicsLayerModifier(layerBlock) {
    Node.call(this);
    this.b99_1 = layerBlock;
    this.c99_1 = false;
  }
  protoOf(BlockGraphicsLayerModifier).b8w = function () {
    return false;
  };
  protoOf(BlockGraphicsLayerModifier).k9i = function () {
    return this.c99_1;
  };
  protoOf(BlockGraphicsLayerModifier).d99 = function () {
    return updateLayerBlock(this, this.b99_1);
  };
  protoOf(BlockGraphicsLayerModifier).g8y = function (_this__u8e3s4, measurable, constraints) {
    var placeable = measurable.h8y(constraints);
    var tmp = placeable.i8y_1;
    var tmp_0 = placeable.j8y_1;
    return _this__u8e3s4.n8y(tmp, tmp_0, VOID, BlockGraphicsLayerModifier$measure$lambda(placeable, this));
  };
  protoOf(BlockGraphicsLayerModifier).toString = function () {
    return 'BlockGraphicsLayerModifier(' + ('block=' + toString(this.b99_1) + ')');
  };
  protoOf(BlockGraphicsLayerModifier).l9i = function (_this__u8e3s4) {
    if (!ComposeUiFlags_instance.x8u_1)
      return Unit_instance;
    // Inline function 'androidx.compose.ui.node.Nodes.Layout' call
    var tmp$ret$0 = _NodeKind___init__impl__ojsprp(2);
    var coordinator = requireCoordinator(this, tmp$ret$0);
    var shape;
    var clip;
    if (!coordinator.i95_1) {
      if (reusableGraphicsLayerScope == null) {
        reusableGraphicsLayerScope = new ReusableGraphicsLayerScope();
      } else {
        ensureNotNull(reusableGraphicsLayerScope).u4c();
      }
      var scope = ensureNotNull(reusableGraphicsLayerScope);
      scope.e9j_1 = coordinator.a9i().w90_1;
      scope.d9j_1 = toSize(coordinator.q95());
      $l$block: {
        // Inline function 'androidx.compose.runtime.snapshots.Companion.withoutReadObservation' call
        var previousSnapshot = Companion_instance.p52();
        var observer = previousSnapshot == null ? null : previousSnapshot.t3e();
        var newSnapshot = Companion_instance.q52(previousSnapshot);
        try {
          this.b99_1(scope);
          break $l$block;
        }finally {
          Companion_instance.c53(previousSnapshot, newSnapshot, observer);
        }
      }
      shape = scope.a9j_1;
      clip = scope.b9j_1;
    } else {
      shape = coordinator.g95_1;
      clip = coordinator.h95_1;
    }
    if (!clip) {
      return Unit_instance;
    }
    set_shape(_this__u8e3s4, shape);
  };
  function BlockGraphicsLayerElement(block) {
    ModifierNodeElement.call(this);
    this.n9j_1 = block;
  }
  protoOf(BlockGraphicsLayerElement).r3d = function () {
    return new BlockGraphicsLayerModifier(this.n9j_1);
  };
  protoOf(BlockGraphicsLayerElement).m98 = function (node) {
    node.b99_1 = this.n9j_1;
    node.d99();
  };
  protoOf(BlockGraphicsLayerElement).d8y = function (node) {
    return this.m98(node instanceof BlockGraphicsLayerModifier ? node : THROW_CCE());
  };
  protoOf(BlockGraphicsLayerElement).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof BlockGraphicsLayerElement))
      return false;
    if (!(this.n9j_1 === other.n9j_1))
      return false;
    return true;
  };
  protoOf(BlockGraphicsLayerElement).hashCode = function () {
    return hashCode(this.n9j_1);
  };
  function _CompositingStrategy___init__impl__pgr8e(value) {
    return value;
  }
  function Companion_8() {
    Companion_instance_13 = this;
    this.g9i_1 = _CompositingStrategy___init__impl__pgr8e(0);
    this.h9i_1 = _CompositingStrategy___init__impl__pgr8e(1);
    this.i9i_1 = _CompositingStrategy___init__impl__pgr8e(2);
  }
  var Companion_instance_13;
  function Companion_getInstance_34() {
    if (Companion_instance_13 == null)
      new Companion_8();
    return Companion_instance_13;
  }
  function CompositingStrategy__toString_impl_3ar76y($this) {
    return 'CompositingStrategy(value=' + $this + ')';
  }
  function CompositingStrategy__hashCode_impl_igeplx($this) {
    return $this;
  }
  function GraphicsLayerElement(scaleX, scaleY, alpha, translationX, translationY, shadowElevation, rotationX, rotationY, rotationZ, cameraDistance, transformOrigin, shape, clip, renderEffect, ambientShadowColor, spotShadowColor, compositingStrategy, blendMode, colorFilter) {
    ModifierNodeElement.call(this);
    this.p9j_1 = scaleX;
    this.q9j_1 = scaleY;
    this.r9j_1 = alpha;
    this.s9j_1 = translationX;
    this.t9j_1 = translationY;
    this.u9j_1 = shadowElevation;
    this.v9j_1 = rotationX;
    this.w9j_1 = rotationY;
    this.x9j_1 = rotationZ;
    this.y9j_1 = cameraDistance;
    this.z9j_1 = transformOrigin;
    this.a9k_1 = shape;
    this.b9k_1 = clip;
    this.c9k_1 = renderEffect;
    this.d9k_1 = ambientShadowColor;
    this.e9k_1 = spotShadowColor;
    this.f9k_1 = compositingStrategy;
    this.g9k_1 = blendMode;
    this.h9k_1 = colorFilter;
  }
  protoOf(GraphicsLayerElement).r3d = function () {
    return new SimpleGraphicsLayerModifier(this.p9j_1, this.q9j_1, this.r9j_1, this.s9j_1, this.t9j_1, this.u9j_1, this.v9j_1, this.w9j_1, this.x9j_1, this.y9j_1, this.z9j_1, this.a9k_1, this.b9k_1, this.c9k_1, this.d9k_1, this.e9k_1, this.f9k_1, this.g9k_1, this.h9k_1);
  };
  protoOf(GraphicsLayerElement).i9k = function (node) {
    node.x9k_1 = this.p9j_1;
    node.y9k_1 = this.q9j_1;
    node.z9k_1 = this.r9j_1;
    node.a9l_1 = this.s9j_1;
    node.b9l_1 = this.t9j_1;
    node.c9l_1 = this.u9j_1;
    node.d9l_1 = this.v9j_1;
    node.e9l_1 = this.w9j_1;
    node.f9l_1 = this.x9j_1;
    node.g9l_1 = this.y9j_1;
    node.h9l_1 = this.z9j_1;
    node.i9l_1 = this.a9k_1;
    node.j9l_1 = this.b9k_1;
    node.k9l_1 = this.c9k_1;
    node.l9l_1 = this.d9k_1;
    node.m9l_1 = this.e9k_1;
    node.n9l_1 = this.f9k_1;
    node.o9l_1 = this.g9k_1;
    node.p9l_1 = this.h9k_1;
    node.d99();
  };
  protoOf(GraphicsLayerElement).d8y = function (node) {
    return this.i9k(node instanceof SimpleGraphicsLayerModifier ? node : THROW_CCE());
  };
  protoOf(GraphicsLayerElement).toString = function () {
    return 'GraphicsLayerElement(scaleX=' + this.p9j_1 + ', scaleY=' + this.q9j_1 + ', alpha=' + this.r9j_1 + ', translationX=' + this.s9j_1 + ', translationY=' + this.t9j_1 + ', shadowElevation=' + this.u9j_1 + ', rotationX=' + this.v9j_1 + ', rotationY=' + this.w9j_1 + ', rotationZ=' + this.x9j_1 + ', cameraDistance=' + this.y9j_1 + ', transformOrigin=' + TransformOrigin__toString_impl_nn7ftd(this.z9j_1) + ', shape=' + toString(this.a9k_1) + ', clip=' + this.b9k_1 + ', renderEffect=' + toString_0(this.c9k_1) + ', ambientShadowColor=' + Color__toString_impl_hpzmaq(this.d9k_1) + ', spotShadowColor=' + Color__toString_impl_hpzmaq(this.e9k_1) + ', compositingStrategy=' + CompositingStrategy__toString_impl_3ar76y(this.f9k_1) + ', blendMode=' + BlendMode__toString_impl_uuibkd(this.g9k_1) + ', colorFilter=' + toString_0(this.h9k_1) + ')';
  };
  protoOf(GraphicsLayerElement).hashCode = function () {
    var result = getNumberHashCode(this.p9j_1);
    result = imul(result, 31) + getNumberHashCode(this.q9j_1) | 0;
    result = imul(result, 31) + getNumberHashCode(this.r9j_1) | 0;
    result = imul(result, 31) + getNumberHashCode(this.s9j_1) | 0;
    result = imul(result, 31) + getNumberHashCode(this.t9j_1) | 0;
    result = imul(result, 31) + getNumberHashCode(this.u9j_1) | 0;
    result = imul(result, 31) + getNumberHashCode(this.v9j_1) | 0;
    result = imul(result, 31) + getNumberHashCode(this.w9j_1) | 0;
    result = imul(result, 31) + getNumberHashCode(this.x9j_1) | 0;
    result = imul(result, 31) + getNumberHashCode(this.y9j_1) | 0;
    result = imul(result, 31) + TransformOrigin__hashCode_impl_pmqpcw(this.z9j_1) | 0;
    result = imul(result, 31) + hashCode(this.a9k_1) | 0;
    result = imul(result, 31) + getBooleanHashCode(this.b9k_1) | 0;
    result = imul(result, 31) + (this.c9k_1 == null ? 0 : hashCode(this.c9k_1)) | 0;
    result = imul(result, 31) + Color__hashCode_impl_vjyivj(this.d9k_1) | 0;
    result = imul(result, 31) + Color__hashCode_impl_vjyivj(this.e9k_1) | 0;
    result = imul(result, 31) + CompositingStrategy__hashCode_impl_igeplx(this.f9k_1) | 0;
    result = imul(result, 31) + BlendMode__hashCode_impl_93ceri(this.g9k_1) | 0;
    result = imul(result, 31) + (this.h9k_1 == null ? 0 : hashCode(this.h9k_1)) | 0;
    return result;
  };
  protoOf(GraphicsLayerElement).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof GraphicsLayerElement))
      return false;
    if (!equals(this.p9j_1, other.p9j_1))
      return false;
    if (!equals(this.q9j_1, other.q9j_1))
      return false;
    if (!equals(this.r9j_1, other.r9j_1))
      return false;
    if (!equals(this.s9j_1, other.s9j_1))
      return false;
    if (!equals(this.t9j_1, other.t9j_1))
      return false;
    if (!equals(this.u9j_1, other.u9j_1))
      return false;
    if (!equals(this.v9j_1, other.v9j_1))
      return false;
    if (!equals(this.w9j_1, other.w9j_1))
      return false;
    if (!equals(this.x9j_1, other.x9j_1))
      return false;
    if (!equals(this.y9j_1, other.y9j_1))
      return false;
    if (!equals(this.z9j_1, other.z9j_1))
      return false;
    if (!equals(this.a9k_1, other.a9k_1))
      return false;
    if (!(this.b9k_1 === other.b9k_1))
      return false;
    if (!equals(this.c9k_1, other.c9k_1))
      return false;
    if (!equals(this.d9k_1, other.d9k_1))
      return false;
    if (!equals(this.e9k_1, other.e9k_1))
      return false;
    if (!(this.f9k_1 === other.f9k_1))
      return false;
    if (!(this.g9k_1 === other.g9k_1))
      return false;
    if (!equals(this.h9k_1, other.h9k_1))
      return false;
    return true;
  };
  function SimpleGraphicsLayerModifier$layerBlock$lambda(this$0) {
    return function (_this__u8e3s4) {
      _this__u8e3s4.w66(this$0.x9k_1);
      _this__u8e3s4.x66(this$0.y9k_1);
      _this__u8e3s4.v66(this$0.z9k_1);
      _this__u8e3s4.y66(this$0.a9l_1);
      _this__u8e3s4.z66(this$0.b9l_1);
      _this__u8e3s4.a67(this$0.c9l_1);
      _this__u8e3s4.d67(this$0.d9l_1);
      _this__u8e3s4.e67(this$0.e9l_1);
      _this__u8e3s4.f67(this$0.f9l_1);
      _this__u8e3s4.g67(this$0.g9l_1);
      _this__u8e3s4.s9l(this$0.h9l_1);
      _this__u8e3s4.l98(this$0.i9l_1);
      _this__u8e3s4.n67(this$0.j9l_1);
      _this__u8e3s4.a70(this$0.k9l_1);
      _this__u8e3s4.y6z(this$0.l9l_1);
      _this__u8e3s4.z6z(this$0.m9l_1);
      _this__u8e3s4.t9l(this$0.n9l_1);
      _this__u8e3s4.b6p(this$0.o9l_1);
      _this__u8e3s4.z6o(this$0.p9l_1);
      return Unit_instance;
    };
  }
  function SimpleGraphicsLayerModifier$measure$lambda($placeable, this$0) {
    return function ($this$layout) {
      $this$layout.j9i($placeable, 0, 0, VOID, this$0.r9l_1);
      return Unit_instance;
    };
  }
  function SimpleGraphicsLayerModifier(scaleX, scaleY, alpha, translationX, translationY, shadowElevation, rotationX, rotationY, rotationZ, cameraDistance, transformOrigin, shape, clip, renderEffect, ambientShadowColor, spotShadowColor, compositingStrategy, blendMode, colorFilter) {
    compositingStrategy = compositingStrategy === VOID ? Companion_getInstance_34().g9i_1 : compositingStrategy;
    blendMode = blendMode === VOID ? Companion_getInstance_3().b6a_1 : blendMode;
    colorFilter = colorFilter === VOID ? null : colorFilter;
    Node.call(this);
    this.x9k_1 = scaleX;
    this.y9k_1 = scaleY;
    this.z9k_1 = alpha;
    this.a9l_1 = translationX;
    this.b9l_1 = translationY;
    this.c9l_1 = shadowElevation;
    this.d9l_1 = rotationX;
    this.e9l_1 = rotationY;
    this.f9l_1 = rotationZ;
    this.g9l_1 = cameraDistance;
    this.h9l_1 = transformOrigin;
    this.i9l_1 = shape;
    this.j9l_1 = clip;
    this.k9l_1 = renderEffect;
    this.l9l_1 = ambientShadowColor;
    this.m9l_1 = spotShadowColor;
    this.n9l_1 = compositingStrategy;
    this.o9l_1 = blendMode;
    this.p9l_1 = colorFilter;
    this.q9l_1 = false;
    var tmp = this;
    tmp.r9l_1 = SimpleGraphicsLayerModifier$layerBlock$lambda(this);
  }
  protoOf(SimpleGraphicsLayerModifier).b8w = function () {
    return false;
  };
  protoOf(SimpleGraphicsLayerModifier).k9i = function () {
    return this.q9l_1;
  };
  protoOf(SimpleGraphicsLayerModifier).d99 = function () {
    return updateLayerBlock(this, this.r9l_1);
  };
  protoOf(SimpleGraphicsLayerModifier).g8y = function (_this__u8e3s4, measurable, constraints) {
    var placeable = measurable.h8y(constraints);
    var tmp = placeable.i8y_1;
    var tmp_0 = placeable.j8y_1;
    return _this__u8e3s4.n8y(tmp, tmp_0, VOID, SimpleGraphicsLayerModifier$measure$lambda(placeable, this));
  };
  protoOf(SimpleGraphicsLayerModifier).toString = function () {
    // Inline function 'kotlin.text.buildString' call
    // Inline function 'kotlin.apply' call
    var this_0 = StringBuilder_init_$Create$();
    this_0.q('SimpleGraphicsLayerModifier(');
    this_0.q('scaleX=' + this.x9k_1 + ', ');
    this_0.q('scaleY=' + this.y9k_1 + ', ');
    this_0.q('alpha = ' + this.z9k_1 + ', ');
    this_0.q('translationX=' + this.a9l_1 + ', ');
    this_0.q('translationY=' + this.b9l_1 + ', ');
    this_0.q('shadowElevation=' + this.c9l_1 + ', ');
    this_0.q('rotationX=' + this.d9l_1 + ', ');
    this_0.q('rotationY=' + this.e9l_1 + ', ');
    this_0.q('rotationZ=' + this.f9l_1 + ', ');
    this_0.q('cameraDistance=' + this.g9l_1 + ', ');
    this_0.q('transformOrigin=' + TransformOrigin__toString_impl_nn7ftd(this.h9l_1) + ', ');
    this_0.q('shape=' + toString(this.i9l_1) + ', ');
    this_0.q('clip=' + this.j9l_1 + ', ');
    this_0.q('renderEffect=' + toString_0(this.k9l_1) + ', ');
    this_0.q('ambientShadowColor=' + Color__toString_impl_hpzmaq(this.l9l_1) + ', ');
    this_0.q('spotShadowColor=' + Color__toString_impl_hpzmaq(this.m9l_1) + ', ');
    this_0.q('compositingStrategy=' + CompositingStrategy__toString_impl_3ar76y(this.n9l_1) + '), ');
    this_0.q('blendMode=' + BlendMode__toString_impl_uuibkd(this.o9l_1) + ', ');
    this_0.q('colorFilter=' + toString_0(this.p9l_1));
    this_0.q(')');
    return this_0.toString();
  };
  protoOf(SimpleGraphicsLayerModifier).l9i = function (_this__u8e3s4) {
    if (!ComposeUiFlags_instance.x8u_1)
      return Unit_instance;
    if (!this.j9l_1) {
      return Unit_instance;
    }
    set_shape(_this__u8e3s4, this.i9l_1);
  };
  function toolingGraphicsLayer(_this__u8e3s4) {
    return get_isDebugInspectorInfoEnabled() ? _this__u8e3s4.d8v(graphicsLayer_0(Companion_instance_6)) : _this__u8e3s4;
  }
  function get_DefaultShadowColor() {
    _init_properties_GraphicsLayerScope_kt__7b4fv2();
    return DefaultShadowColor;
  }
  var DefaultShadowColor;
  var androidx_compose_ui_graphics_Fields$stable;
  var androidx_compose_ui_graphics_ReusableGraphicsLayerScope$stable;
  function GraphicsLayerScope() {
  }
  function ReusableGraphicsLayerScope() {
    this.m9i_1 = 0;
    this.n9i_1 = 1.0;
    this.o9i_1 = 1.0;
    this.p9i_1 = 1.0;
    this.q9i_1 = 0.0;
    this.r9i_1 = 0.0;
    this.s9i_1 = 0.0;
    this.t9i_1 = get_DefaultShadowColor();
    this.u9i_1 = get_DefaultShadowColor();
    this.v9i_1 = 0.0;
    this.w9i_1 = 0.0;
    this.x9i_1 = 0.0;
    this.y9i_1 = 8.0;
    this.z9i_1 = Companion_getInstance_35().f9i_1;
    this.a9j_1 = get_RectangleShape();
    this.b9j_1 = false;
    this.c9j_1 = Companion_getInstance_34().g9i_1;
    this.d9j_1 = Companion_getInstance_1().k5e_1;
    this.e9j_1 = Density_0(1.0);
    this.f9j_1 = LayoutDirection_Ltr_getInstance();
    this.g9j_1 = null;
    this.h9j_1 = null;
    this.i9j_1 = Companion_getInstance_3().b6a_1;
    this.j9j_1 = null;
  }
  protoOf(ReusableGraphicsLayerScope).w66 = function (value) {
    if (!(this.n9i_1 === value)) {
      this.m9i_1 = this.m9i_1 | 1;
      this.n9i_1 = value;
    }
  };
  protoOf(ReusableGraphicsLayerScope).u9l = function () {
    return this.n9i_1;
  };
  protoOf(ReusableGraphicsLayerScope).x66 = function (value) {
    if (!(this.o9i_1 === value)) {
      this.m9i_1 = this.m9i_1 | 2;
      this.o9i_1 = value;
    }
  };
  protoOf(ReusableGraphicsLayerScope).v9l = function () {
    return this.o9i_1;
  };
  protoOf(ReusableGraphicsLayerScope).v66 = function (value) {
    if (!(this.p9i_1 === value)) {
      this.m9i_1 = this.m9i_1 | 4;
      this.p9i_1 = value;
    }
  };
  protoOf(ReusableGraphicsLayerScope).y66 = function (value) {
    if (!(this.q9i_1 === value)) {
      this.m9i_1 = this.m9i_1 | 8;
      this.q9i_1 = value;
    }
  };
  protoOf(ReusableGraphicsLayerScope).w9l = function () {
    return this.q9i_1;
  };
  protoOf(ReusableGraphicsLayerScope).z66 = function (value) {
    if (!(this.r9i_1 === value)) {
      this.m9i_1 = this.m9i_1 | 16;
      this.r9i_1 = value;
    }
  };
  protoOf(ReusableGraphicsLayerScope).x9l = function () {
    return this.r9i_1;
  };
  protoOf(ReusableGraphicsLayerScope).a67 = function (value) {
    if (!(this.s9i_1 === value)) {
      this.m9i_1 = this.m9i_1 | 32;
      this.s9i_1 = value;
    }
  };
  protoOf(ReusableGraphicsLayerScope).y6z = function (value) {
    if (!equals(this.t9i_1, value)) {
      this.m9i_1 = this.m9i_1 | 64;
      this.t9i_1 = value;
    }
  };
  protoOf(ReusableGraphicsLayerScope).z6z = function (value) {
    if (!equals(this.u9i_1, value)) {
      this.m9i_1 = this.m9i_1 | 128;
      this.u9i_1 = value;
    }
  };
  protoOf(ReusableGraphicsLayerScope).d67 = function (value) {
    if (!(this.v9i_1 === value)) {
      this.m9i_1 = this.m9i_1 | 256;
      this.v9i_1 = value;
    }
  };
  protoOf(ReusableGraphicsLayerScope).y9l = function () {
    return this.v9i_1;
  };
  protoOf(ReusableGraphicsLayerScope).e67 = function (value) {
    if (!(this.w9i_1 === value)) {
      this.m9i_1 = this.m9i_1 | 512;
      this.w9i_1 = value;
    }
  };
  protoOf(ReusableGraphicsLayerScope).z9l = function () {
    return this.w9i_1;
  };
  protoOf(ReusableGraphicsLayerScope).f67 = function (value) {
    if (!(this.x9i_1 === value)) {
      this.m9i_1 = this.m9i_1 | 1024;
      this.x9i_1 = value;
    }
  };
  protoOf(ReusableGraphicsLayerScope).a9m = function () {
    return this.x9i_1;
  };
  protoOf(ReusableGraphicsLayerScope).g67 = function (value) {
    if (!(this.y9i_1 === value)) {
      this.m9i_1 = this.m9i_1 | 2048;
      this.y9i_1 = value;
    }
  };
  protoOf(ReusableGraphicsLayerScope).b9m = function () {
    return this.y9i_1;
  };
  protoOf(ReusableGraphicsLayerScope).s9l = function (value) {
    if (!equals(this.z9i_1, value)) {
      this.m9i_1 = this.m9i_1 | 4096;
      this.z9i_1 = value;
    }
  };
  protoOf(ReusableGraphicsLayerScope).c9m = function () {
    return this.z9i_1;
  };
  protoOf(ReusableGraphicsLayerScope).l98 = function (value) {
    if (!equals(this.a9j_1, value)) {
      this.m9i_1 = this.m9i_1 | 8192;
      this.a9j_1 = value;
    }
  };
  protoOf(ReusableGraphicsLayerScope).n67 = function (value) {
    if (!(this.b9j_1 === value)) {
      this.m9i_1 = this.m9i_1 | 16384;
      this.b9j_1 = value;
    }
  };
  protoOf(ReusableGraphicsLayerScope).t9l = function (value) {
    if (!(this.c9j_1 === value)) {
      this.m9i_1 = this.m9i_1 | 32768;
      this.c9j_1 = value;
    }
  };
  protoOf(ReusableGraphicsLayerScope).o5d = function () {
    return this.d9j_1;
  };
  protoOf(ReusableGraphicsLayerScope).u5e = function () {
    return this.e9j_1.u5e();
  };
  protoOf(ReusableGraphicsLayerScope).j5f = function () {
    return this.e9j_1.j5f();
  };
  protoOf(ReusableGraphicsLayerScope).a70 = function (value) {
    if (!equals(this.g9j_1, value)) {
      this.m9i_1 = this.m9i_1 | 131072;
      this.g9j_1 = value;
    }
  };
  protoOf(ReusableGraphicsLayerScope).z6o = function (value) {
    if (!equals(this.h9j_1, value)) {
      this.m9i_1 = this.m9i_1 | 262144;
      this.h9j_1 = value;
    }
  };
  protoOf(ReusableGraphicsLayerScope).b6p = function (value) {
    if (!(this.i9j_1 === value)) {
      this.m9i_1 = this.m9i_1 | 524288;
      this.i9j_1 = value;
    }
  };
  protoOf(ReusableGraphicsLayerScope).u4c = function () {
    this.w66(1.0);
    this.x66(1.0);
    this.v66(1.0);
    this.y66(0.0);
    this.z66(0.0);
    this.a67(0.0);
    this.y6z(get_DefaultShadowColor());
    this.z6z(get_DefaultShadowColor());
    this.d67(0.0);
    this.e67(0.0);
    this.f67(0.0);
    this.g67(8.0);
    this.s9l(Companion_getInstance_35().f9i_1);
    this.l98(get_RectangleShape());
    this.n67(false);
    this.a70(null);
    this.z6o(null);
    this.b6p(Companion_getInstance_3().b6a_1);
    this.t9l(Companion_getInstance_34().g9i_1);
    this.d9j_1 = Companion_getInstance_1().k5e_1;
    this.j9j_1 = null;
    this.m9i_1 = 0;
  };
  protoOf(ReusableGraphicsLayerScope).d9m = function () {
    this.j9j_1 = this.a9j_1.l6j(this.d9j_1, this.f9j_1, this.e9j_1);
  };
  var properties_initialized_GraphicsLayerScope_kt_mgrju8;
  function _init_properties_GraphicsLayerScope_kt__7b4fv2() {
    if (!properties_initialized_GraphicsLayerScope_kt_mgrju8) {
      properties_initialized_GraphicsLayerScope_kt_mgrju8 = true;
      DefaultShadowColor = Companion_getInstance_4().i6b_1;
      androidx_compose_ui_graphics_Fields$stable = 0;
      androidx_compose_ui_graphics_ReusableGraphicsLayerScope$stable = 0;
    }
  }
  function _TransformOrigin___init__impl__ats3ll(packedValue) {
    return packedValue;
  }
  function _TransformOrigin___get_packedValue__impl__iu9z4d($this) {
    return $this;
  }
  function _TransformOrigin___get_pivotFractionX__impl__a9pmci($this) {
    // Inline function 'androidx.compose.ui.util.unpackFloat1' call
    var value = _TransformOrigin___get_packedValue__impl__iu9z4d($this);
    // Inline function 'androidx.compose.ui.util.floatFromBits' call
    // Inline function 'kotlin.fromBits' call
    var bits = convertToInt(shiftRight(value, 32));
    return floatFromBits(bits);
  }
  function _TransformOrigin___get_pivotFractionY__impl__ijwupp($this) {
    // Inline function 'androidx.compose.ui.util.unpackFloat2' call
    var value = _TransformOrigin___get_packedValue__impl__iu9z4d($this);
    // Inline function 'androidx.compose.ui.util.floatFromBits' call
    // Inline function 'kotlin.fromBits' call
    var bits = convertToInt(bitwiseAnd(value, new Long(-1, 0)));
    return floatFromBits(bits);
  }
  function Companion_9() {
    Companion_instance_14 = this;
    this.f9i_1 = TransformOrigin_0(0.5, 0.5);
  }
  var Companion_instance_14;
  function Companion_getInstance_35() {
    if (Companion_instance_14 == null)
      new Companion_9();
    return Companion_instance_14;
  }
  function TransformOrigin__toString_impl_nn7ftd($this) {
    return 'TransformOrigin(packedValue=' + $this.toString() + ')';
  }
  function TransformOrigin__hashCode_impl_pmqpcw($this) {
    return $this.hashCode();
  }
  function TransformOrigin__equals_impl_jrzhoc($this, other) {
    if (!(other instanceof TransformOrigin))
      return false;
    var tmp0_other_with_cast = other.e9m_1;
    if (!equalsLong($this, tmp0_other_with_cast))
      return false;
    return true;
  }
  function TransformOrigin(packedValue) {
    Companion_getInstance_35();
    this.e9m_1 = packedValue;
  }
  protoOf(TransformOrigin).toString = function () {
    return TransformOrigin__toString_impl_nn7ftd(this.e9m_1);
  };
  protoOf(TransformOrigin).hashCode = function () {
    return TransformOrigin__hashCode_impl_pmqpcw(this.e9m_1);
  };
  protoOf(TransformOrigin).equals = function (other) {
    return TransformOrigin__equals_impl_jrzhoc(this.e9m_1, other);
  };
  function TransformOrigin_0(pivotFractionX, pivotFractionY) {
    // Inline function 'androidx.compose.ui.util.packFloats' call
    var v1 = fromInt(toRawBits(pivotFractionX));
    var v2 = fromInt(toRawBits(pivotFractionY));
    var tmp$ret$0 = bitwiseOr(shiftLeft(v1, 32), bitwiseAnd(v2, new Long(-1, 0)));
    return _TransformOrigin___init__impl__ats3ll(tmp$ret$0);
  }
  var androidx_compose_ui_graphics_vector_DrawCache$stable;
  function clear_0($this, $receiver) {
    $receiver.b6q(Companion_getInstance_4().i6b_1, VOID, VOID, VOID, VOID, VOID, Companion_getInstance_3().y69_1);
  }
  function DrawCache() {
    this.f9m_1 = null;
    this.g9m_1 = null;
    this.h9m_1 = null;
    this.i9m_1 = LayoutDirection_Ltr_getInstance();
    this.j9m_1 = Companion_getInstance_0().n5g_1;
    this.k9m_1 = Companion_getInstance_5().x6g_1;
    this.l9m_1 = new CanvasDrawScope();
  }
  protoOf(DrawCache).m9m = function (config, size, density, layoutDirection, block) {
    this.h9m_1 = density;
    this.i9m_1 = layoutDirection;
    var targetImage = this.f9m_1;
    var targetCanvas = this.g9m_1;
    var tmp;
    var tmp_0;
    var tmp_1;
    if (targetImage == null || targetCanvas == null) {
      tmp_1 = true;
    } else {
      // Inline function 'androidx.compose.ui.unit.IntSize.width' call
      // Inline function 'androidx.compose.ui.util.unpackInt1' call
      var value = _IntSize___get_packedValue__impl__uho7jf(size);
      tmp_1 = convertToInt(shiftRight(value, 32)) > targetImage.h5e();
    }
    if (tmp_1) {
      tmp_0 = true;
    } else {
      // Inline function 'androidx.compose.ui.unit.IntSize.height' call
      // Inline function 'androidx.compose.ui.util.unpackInt2' call
      var value_0 = _IntSize___get_packedValue__impl__uho7jf(size);
      tmp_0 = convertToInt(bitwiseAnd(value_0, new Long(-1, 0))) > targetImage.i5e();
    }
    if (tmp_0) {
      tmp = true;
    } else {
      tmp = !(this.k9m_1 === config);
    }
    if (tmp) {
      // Inline function 'androidx.compose.ui.unit.IntSize.width' call
      // Inline function 'androidx.compose.ui.util.unpackInt1' call
      var value_1 = _IntSize___get_packedValue__impl__uho7jf(size);
      var tmp_2 = convertToInt(shiftRight(value_1, 32));
      // Inline function 'androidx.compose.ui.unit.IntSize.height' call
      // Inline function 'androidx.compose.ui.util.unpackInt2' call
      var value_2 = _IntSize___get_packedValue__impl__uho7jf(size);
      var tmp$ret$6 = convertToInt(bitwiseAnd(value_2, new Long(-1, 0)));
      targetImage = ImageBitmap(tmp_2, tmp$ret$6, config);
      targetCanvas = Canvas(targetImage);
      this.f9m_1 = targetImage;
      this.g9m_1 = targetCanvas;
      this.k9m_1 = config;
    }
    this.j9m_1 = size;
    var tmp0 = this.l9m_1;
    var tmp6 = targetCanvas;
    // Inline function 'androidx.compose.ui.graphics.drawscope.CanvasDrawScope.draw' call
    var size_0 = toSize(size);
    var _destruct__k2r9zo = tmp0.h6o_1;
    var prevDensity = _destruct__k2r9zo.zh();
    var prevLayoutDirection = _destruct__k2r9zo.ai();
    var prevCanvas = _destruct__k2r9zo.hr();
    var prevSize = _destruct__k2r9zo.j6p();
    // Inline function 'kotlin.apply' call
    var this_0 = tmp0.h6o_1;
    this_0.f6p_1 = density;
    this_0.g6p_1 = layoutDirection;
    this_0.h6p_1 = tmp6;
    this_0.i6p_1 = size_0;
    tmp6.t6d();
    clear_0(this, tmp0);
    block(tmp0);
    tmp6.u6d();
    // Inline function 'kotlin.apply' call
    var this_1 = tmp0.h6o_1;
    this_1.f6p_1 = prevDensity;
    this_1.g6p_1 = prevLayoutDirection;
    this_1.h6p_1 = prevCanvas;
    this_1.i6p_1 = prevSize;
    targetImage.w6g();
  };
  protoOf(DrawCache).n9m = function (target, alpha, colorFilter) {
    var targetImage = this.f9m_1;
    // Inline function 'androidx.compose.ui.internal.checkPrecondition' call
    if (!!(targetImage == null)) {
      var tmp$ret$1 = 'drawCachedImage must be invoked first before attempting to draw the result into another destination';
      throwIllegalStateException(tmp$ret$1);
    }
    target.d6q(targetImage, VOID, this.j9m_1, VOID, VOID, alpha, VOID, colorFilter);
  };
  var androidx_compose_ui_graphics_vector_ImageVector_Builder$stable;
  var androidx_compose_ui_graphics_vector_ImageVector$stable;
  var androidx_compose_ui_graphics_vector_VectorNode$stable;
  var androidx_compose_ui_graphics_vector_VectorGroup$stable;
  var androidx_compose_ui_graphics_vector_VectorPath$stable;
  function _get_currentGroup__r31fut($this) {
    return peek($this.w9m_1);
  }
  function ensureNotConsumed($this) {
    // Inline function 'androidx.compose.ui.internal.checkPrecondition' call
    if (!!$this.y9m_1) {
      var tmp$ret$1 = 'ImageVector.Builder is single use, create a new instance to create a new ImageVector';
      throwIllegalStateException(tmp$ret$1);
    }
  }
  function asVectorGroup($this, $receiver) {
    return new VectorGroup($receiver.z9m_1, $receiver.a9n_1, $receiver.b9n_1, $receiver.c9n_1, $receiver.d9n_1, $receiver.e9n_1, $receiver.f9n_1, $receiver.g9n_1, $receiver.h9n_1, $receiver.i9n_1);
  }
  function GroupParams(name, rotate, pivotX, pivotY, scaleX, scaleY, translationX, translationY, clipPathData, children) {
    name = name === VOID ? '' : name;
    rotate = rotate === VOID ? 0.0 : rotate;
    pivotX = pivotX === VOID ? 0.0 : pivotX;
    pivotY = pivotY === VOID ? 0.0 : pivotY;
    scaleX = scaleX === VOID ? 1.0 : scaleX;
    scaleY = scaleY === VOID ? 1.0 : scaleY;
    translationX = translationX === VOID ? 0.0 : translationX;
    translationY = translationY === VOID ? 0.0 : translationY;
    clipPathData = clipPathData === VOID ? get_EmptyPath() : clipPathData;
    var tmp;
    if (children === VOID) {
      // Inline function 'kotlin.collections.mutableListOf' call
      tmp = ArrayList_init_$Create$();
    } else {
      tmp = children;
    }
    children = tmp;
    this.z9m_1 = name;
    this.a9n_1 = rotate;
    this.b9n_1 = pivotX;
    this.c9n_1 = pivotY;
    this.d9n_1 = scaleX;
    this.e9n_1 = scaleY;
    this.f9n_1 = translationX;
    this.g9n_1 = translationY;
    this.h9n_1 = clipPathData;
    this.i9n_1 = children;
  }
  function Builder(name, defaultWidth, defaultHeight, viewportWidth, viewportHeight, tintColor, tintBlendMode, autoMirror) {
    name = name === VOID ? '' : name;
    tintColor = tintColor === VOID ? Companion_getInstance_4().u6b_1 : tintColor;
    tintBlendMode = tintBlendMode === VOID ? Companion_getInstance_3().d6a_1 : tintBlendMode;
    autoMirror = autoMirror === VOID ? false : autoMirror;
    this.o9m_1 = name;
    this.p9m_1 = defaultWidth;
    this.q9m_1 = defaultHeight;
    this.r9m_1 = viewportWidth;
    this.s9m_1 = viewportHeight;
    this.t9m_1 = tintColor;
    this.u9m_1 = tintBlendMode;
    this.v9m_1 = autoMirror;
    this.w9m_1 = ArrayList_init_$Create$();
    this.x9m_1 = new GroupParams();
    this.y9m_1 = false;
    push(this.w9m_1, this.x9m_1);
  }
  protoOf(Builder).j9n = function (name, rotate, pivotX, pivotY, scaleX, scaleY, translationX, translationY, clipPathData) {
    ensureNotConsumed(this);
    var group = new GroupParams(name, rotate, pivotX, pivotY, scaleX, scaleY, translationX, translationY, clipPathData);
    push(this.w9m_1, group);
    return this;
  };
  protoOf(Builder).k9n = function (name, rotate, pivotX, pivotY, scaleX, scaleY, translationX, translationY, clipPathData, $super) {
    name = name === VOID ? '' : name;
    rotate = rotate === VOID ? 0.0 : rotate;
    pivotX = pivotX === VOID ? 0.0 : pivotX;
    pivotY = pivotY === VOID ? 0.0 : pivotY;
    scaleX = scaleX === VOID ? 1.0 : scaleX;
    scaleY = scaleY === VOID ? 1.0 : scaleY;
    translationX = translationX === VOID ? 0.0 : translationX;
    translationY = translationY === VOID ? 0.0 : translationY;
    clipPathData = clipPathData === VOID ? get_EmptyPath() : clipPathData;
    return $super === VOID ? this.j9n(name, rotate, pivotX, pivotY, scaleX, scaleY, translationX, translationY, clipPathData) : $super.j9n.call(this, name, rotate, pivotX, pivotY, scaleX, scaleY, translationX, translationY, clipPathData);
  };
  protoOf(Builder).l9n = function () {
    ensureNotConsumed(this);
    var popped = pop(this.w9m_1);
    _get_currentGroup__r31fut(this).i9n_1.j1(asVectorGroup(this, popped));
    return this;
  };
  protoOf(Builder).m9n = function (pathData, pathFillType, name, fill, fillAlpha, stroke, strokeAlpha, strokeLineWidth, strokeLineCap, strokeLineJoin, strokeLineMiter, trimPathStart, trimPathEnd, trimPathOffset) {
    ensureNotConsumed(this);
    _get_currentGroup__r31fut(this).i9n_1.j1(new VectorPath(name, pathData, pathFillType, fill, fillAlpha, stroke, strokeAlpha, strokeLineWidth, strokeLineCap, strokeLineJoin, strokeLineMiter, trimPathStart, trimPathEnd, trimPathOffset));
    return this;
  };
  protoOf(Builder).n9n = function (pathData, pathFillType, name, fill, fillAlpha, stroke, strokeAlpha, strokeLineWidth, strokeLineCap, strokeLineJoin, strokeLineMiter, trimPathStart, trimPathEnd, trimPathOffset, $super) {
    pathFillType = pathFillType === VOID ? get_DefaultFillType() : pathFillType;
    name = name === VOID ? '' : name;
    fill = fill === VOID ? null : fill;
    fillAlpha = fillAlpha === VOID ? 1.0 : fillAlpha;
    stroke = stroke === VOID ? null : stroke;
    strokeAlpha = strokeAlpha === VOID ? 1.0 : strokeAlpha;
    strokeLineWidth = strokeLineWidth === VOID ? 0.0 : strokeLineWidth;
    strokeLineCap = strokeLineCap === VOID ? get_DefaultStrokeLineCap() : strokeLineCap;
    strokeLineJoin = strokeLineJoin === VOID ? get_DefaultStrokeLineJoin() : strokeLineJoin;
    strokeLineMiter = strokeLineMiter === VOID ? 4.0 : strokeLineMiter;
    trimPathStart = trimPathStart === VOID ? 0.0 : trimPathStart;
    trimPathEnd = trimPathEnd === VOID ? 1.0 : trimPathEnd;
    trimPathOffset = trimPathOffset === VOID ? 0.0 : trimPathOffset;
    return $super === VOID ? this.m9n(pathData, pathFillType, name, fill, fillAlpha, stroke, strokeAlpha, strokeLineWidth, strokeLineCap, strokeLineJoin, strokeLineMiter, trimPathStart, trimPathEnd, trimPathOffset) : $super.m9n.call(this, pathData, new PathFillType(pathFillType), name, fill, fillAlpha, stroke, strokeAlpha, strokeLineWidth, new StrokeCap(strokeLineCap), new StrokeJoin(strokeLineJoin), strokeLineMiter, trimPathStart, trimPathEnd, trimPathOffset);
  };
  protoOf(Builder).g3d = function () {
    ensureNotConsumed(this);
    while (this.w9m_1.n1() > 1) {
      this.l9n();
    }
    var vectorImage = new ImageVector(this.o9m_1, this.p9m_1, this.q9m_1, this.r9m_1, this.s9m_1, asVectorGroup(this, this.x9m_1), this.t9m_1, this.u9m_1, this.v9m_1);
    this.y9m_1 = true;
    return vectorImage;
  };
  function Companion_10() {
    Companion_instance_15 = this;
    this.o9n_1 = 0;
    var tmp = this;
    // Inline function 'androidx.compose.ui.platform.makeSynchronizedObject' call
    tmp.p9n_1 = new SynchronizedObject();
  }
  protoOf(Companion_10).q9n = function () {
    // Inline function 'androidx.compose.ui.platform.synchronized' call
    // Inline function 'kotlinx.atomicfu.locks.synchronized' call
    this.p9n_1;
    var _unary__edvuaz = Companion_getInstance_36().o9n_1;
    Companion_getInstance_36().o9n_1 = _unary__edvuaz + 1 | 0;
    return _unary__edvuaz;
  };
  var Companion_instance_15;
  function Companion_getInstance_36() {
    if (Companion_instance_15 == null)
      new Companion_10();
    return Companion_instance_15;
  }
  function ImageVector(name, defaultWidth, defaultHeight, viewportWidth, viewportHeight, root, tintColor, tintBlendMode, autoMirror, genId) {
    Companion_getInstance_36();
    genId = genId === VOID ? Companion_getInstance_36().q9n() : genId;
    this.r9n_1 = name;
    this.s9n_1 = defaultWidth;
    this.t9n_1 = defaultHeight;
    this.u9n_1 = viewportWidth;
    this.v9n_1 = viewportHeight;
    this.w9n_1 = root;
    this.x9n_1 = tintColor;
    this.y9n_1 = tintBlendMode;
    this.z9n_1 = autoMirror;
    this.a9o_1 = genId;
  }
  protoOf(ImageVector).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof ImageVector))
      return false;
    if (!(this.r9n_1 === other.r9n_1))
      return false;
    if (!equals(this.s9n_1, other.s9n_1))
      return false;
    if (!equals(this.t9n_1, other.t9n_1))
      return false;
    if (!(this.u9n_1 === other.u9n_1))
      return false;
    if (!(this.v9n_1 === other.v9n_1))
      return false;
    if (!this.w9n_1.equals(other.w9n_1))
      return false;
    if (!equals(this.x9n_1, other.x9n_1))
      return false;
    if (!(this.y9n_1 === other.y9n_1))
      return false;
    if (!(this.z9n_1 === other.z9n_1))
      return false;
    return true;
  };
  protoOf(ImageVector).hashCode = function () {
    var result = getStringHashCode(this.r9n_1);
    result = imul(31, result) + Dp__hashCode_impl_sxkrra(this.s9n_1) | 0;
    result = imul(31, result) + Dp__hashCode_impl_sxkrra(this.t9n_1) | 0;
    result = imul(31, result) + getNumberHashCode(this.u9n_1) | 0;
    result = imul(31, result) + getNumberHashCode(this.v9n_1) | 0;
    result = imul(31, result) + this.w9n_1.hashCode() | 0;
    result = imul(31, result) + Color__hashCode_impl_vjyivj(this.x9n_1) | 0;
    result = imul(31, result) + BlendMode__hashCode_impl_93ceri(this.y9n_1) | 0;
    result = imul(31, result) + getBooleanHashCode(this.z9n_1) | 0;
    return result;
  };
  function VectorGroup$iterator$1(this$0) {
    this.b9o_1 = this$0.l9o_1.t();
  }
  protoOf(VectorGroup$iterator$1).u = function () {
    return this.b9o_1.u();
  };
  protoOf(VectorGroup$iterator$1).v = function () {
    return this.b9o_1.v();
  };
  function VectorGroup(name, rotation, pivotX, pivotY, scaleX, scaleY, translationX, translationY, clipPathData, children) {
    name = name === VOID ? '' : name;
    rotation = rotation === VOID ? 0.0 : rotation;
    pivotX = pivotX === VOID ? 0.0 : pivotX;
    pivotY = pivotY === VOID ? 0.0 : pivotY;
    scaleX = scaleX === VOID ? 1.0 : scaleX;
    scaleY = scaleY === VOID ? 1.0 : scaleY;
    translationX = translationX === VOID ? 0.0 : translationX;
    translationY = translationY === VOID ? 0.0 : translationY;
    clipPathData = clipPathData === VOID ? get_EmptyPath() : clipPathData;
    children = children === VOID ? emptyList() : children;
    VectorNode.call(this);
    this.c9o_1 = name;
    this.d9o_1 = rotation;
    this.e9o_1 = pivotX;
    this.f9o_1 = pivotY;
    this.g9o_1 = scaleX;
    this.h9o_1 = scaleY;
    this.i9o_1 = translationX;
    this.j9o_1 = translationY;
    this.k9o_1 = clipPathData;
    this.l9o_1 = children;
  }
  protoOf(VectorGroup).n1 = function () {
    return this.l9o_1.n1();
  };
  protoOf(VectorGroup).l1 = function (index) {
    return this.l9o_1.l1(index);
  };
  protoOf(VectorGroup).t = function () {
    return new VectorGroup$iterator$1(this);
  };
  protoOf(VectorGroup).equals = function (other) {
    if (this === other)
      return true;
    var tmp;
    if (other == null) {
      tmp = true;
    } else {
      tmp = !(other instanceof VectorGroup);
    }
    if (tmp)
      return false;
    if (!(this.c9o_1 === other.c9o_1))
      return false;
    if (!(this.d9o_1 === other.d9o_1))
      return false;
    if (!(this.e9o_1 === other.e9o_1))
      return false;
    if (!(this.f9o_1 === other.f9o_1))
      return false;
    if (!(this.g9o_1 === other.g9o_1))
      return false;
    if (!(this.h9o_1 === other.h9o_1))
      return false;
    if (!(this.i9o_1 === other.i9o_1))
      return false;
    if (!(this.j9o_1 === other.j9o_1))
      return false;
    if (!equals(this.k9o_1, other.k9o_1))
      return false;
    if (!equals(this.l9o_1, other.l9o_1))
      return false;
    return true;
  };
  protoOf(VectorGroup).hashCode = function () {
    var result = getStringHashCode(this.c9o_1);
    result = imul(31, result) + getNumberHashCode(this.d9o_1) | 0;
    result = imul(31, result) + getNumberHashCode(this.e9o_1) | 0;
    result = imul(31, result) + getNumberHashCode(this.f9o_1) | 0;
    result = imul(31, result) + getNumberHashCode(this.g9o_1) | 0;
    result = imul(31, result) + getNumberHashCode(this.h9o_1) | 0;
    result = imul(31, result) + getNumberHashCode(this.i9o_1) | 0;
    result = imul(31, result) + getNumberHashCode(this.j9o_1) | 0;
    result = imul(31, result) + hashCode(this.k9o_1) | 0;
    result = imul(31, result) + hashCode(this.l9o_1) | 0;
    return result;
  };
  function peek(_this__u8e3s4) {
    return _this__u8e3s4.l1(_this__u8e3s4.n1() - 1 | 0);
  }
  function push(_this__u8e3s4, value) {
    return _this__u8e3s4.j1(value);
  }
  function pop(_this__u8e3s4) {
    return _this__u8e3s4.h3(_this__u8e3s4.n1() - 1 | 0);
  }
  function VectorNode() {
  }
  function VectorPath(name, pathData, pathFillType, fill, fillAlpha, stroke, strokeAlpha, strokeLineWidth, strokeLineCap, strokeLineJoin, strokeLineMiter, trimPathStart, trimPathEnd, trimPathOffset) {
    name = name === VOID ? '' : name;
    fill = fill === VOID ? null : fill;
    fillAlpha = fillAlpha === VOID ? 1.0 : fillAlpha;
    stroke = stroke === VOID ? null : stroke;
    strokeAlpha = strokeAlpha === VOID ? 1.0 : strokeAlpha;
    strokeLineWidth = strokeLineWidth === VOID ? 0.0 : strokeLineWidth;
    strokeLineCap = strokeLineCap === VOID ? get_DefaultStrokeLineCap() : strokeLineCap;
    strokeLineJoin = strokeLineJoin === VOID ? get_DefaultStrokeLineJoin() : strokeLineJoin;
    strokeLineMiter = strokeLineMiter === VOID ? 4.0 : strokeLineMiter;
    trimPathStart = trimPathStart === VOID ? 0.0 : trimPathStart;
    trimPathEnd = trimPathEnd === VOID ? 1.0 : trimPathEnd;
    trimPathOffset = trimPathOffset === VOID ? 0.0 : trimPathOffset;
    VectorNode.call(this);
    this.m9o_1 = name;
    this.n9o_1 = pathData;
    this.o9o_1 = pathFillType;
    this.p9o_1 = fill;
    this.q9o_1 = fillAlpha;
    this.r9o_1 = stroke;
    this.s9o_1 = strokeAlpha;
    this.t9o_1 = strokeLineWidth;
    this.u9o_1 = strokeLineCap;
    this.v9o_1 = strokeLineJoin;
    this.w9o_1 = strokeLineMiter;
    this.x9o_1 = trimPathStart;
    this.y9o_1 = trimPathEnd;
    this.z9o_1 = trimPathOffset;
  }
  protoOf(VectorPath).equals = function (other) {
    if (this === other)
      return true;
    if (other == null || !getKClassFromExpression(this).equals(getKClassFromExpression(other)))
      return false;
    if (!(other instanceof VectorPath))
      THROW_CCE();
    if (!(this.m9o_1 === other.m9o_1))
      return false;
    if (!equals(this.p9o_1, other.p9o_1))
      return false;
    if (!(this.q9o_1 === other.q9o_1))
      return false;
    if (!equals(this.r9o_1, other.r9o_1))
      return false;
    if (!(this.s9o_1 === other.s9o_1))
      return false;
    if (!(this.t9o_1 === other.t9o_1))
      return false;
    if (!(this.u9o_1 === other.u9o_1))
      return false;
    if (!(this.v9o_1 === other.v9o_1))
      return false;
    if (!(this.w9o_1 === other.w9o_1))
      return false;
    if (!(this.x9o_1 === other.x9o_1))
      return false;
    if (!(this.y9o_1 === other.y9o_1))
      return false;
    if (!(this.z9o_1 === other.z9o_1))
      return false;
    if (!(this.o9o_1 === other.o9o_1))
      return false;
    if (!equals(this.n9o_1, other.n9o_1))
      return false;
    return true;
  };
  protoOf(VectorPath).hashCode = function () {
    var result = getStringHashCode(this.m9o_1);
    result = imul(31, result) + hashCode(this.n9o_1) | 0;
    var tmp = imul(31, result);
    var tmp0_safe_receiver = this.p9o_1;
    var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : hashCode(tmp0_safe_receiver);
    result = tmp + (tmp1_elvis_lhs == null ? 0 : tmp1_elvis_lhs) | 0;
    result = imul(31, result) + getNumberHashCode(this.q9o_1) | 0;
    var tmp_0 = imul(31, result);
    var tmp2_safe_receiver = this.r9o_1;
    var tmp3_elvis_lhs = tmp2_safe_receiver == null ? null : hashCode(tmp2_safe_receiver);
    result = tmp_0 + (tmp3_elvis_lhs == null ? 0 : tmp3_elvis_lhs) | 0;
    result = imul(31, result) + getNumberHashCode(this.s9o_1) | 0;
    result = imul(31, result) + getNumberHashCode(this.t9o_1) | 0;
    result = imul(31, result) + StrokeCap__hashCode_impl_posxk8(this.u9o_1) | 0;
    result = imul(31, result) + StrokeJoin__hashCode_impl_3pyh8w(this.v9o_1) | 0;
    result = imul(31, result) + getNumberHashCode(this.w9o_1) | 0;
    result = imul(31, result) + getNumberHashCode(this.x9o_1) | 0;
    result = imul(31, result) + getNumberHashCode(this.y9o_1) | 0;
    result = imul(31, result) + getNumberHashCode(this.z9o_1) | 0;
    result = imul(31, result) + PathFillType__hashCode_impl_pdqo4w(this.o9o_1) | 0;
    return result;
  };
  function get_EmptyPath() {
    _init_properties_Vector_kt__7ulyhp();
    return EmptyPath;
  }
  var EmptyPath;
  function get_DefaultStrokeLineCap() {
    _init_properties_Vector_kt__7ulyhp();
    return DefaultStrokeLineCap;
  }
  var DefaultStrokeLineCap;
  function get_DefaultStrokeLineJoin() {
    _init_properties_Vector_kt__7ulyhp();
    return DefaultStrokeLineJoin;
  }
  var DefaultStrokeLineJoin;
  var DefaultTintBlendMode;
  var DefaultTintColor;
  function get_DefaultFillType() {
    _init_properties_Vector_kt__7ulyhp();
    return DefaultFillType;
  }
  var DefaultFillType;
  var androidx_compose_ui_graphics_vector_VNode$stable;
  var androidx_compose_ui_graphics_vector_VectorComponent$stable;
  var androidx_compose_ui_graphics_vector_PathComponent$stable;
  var androidx_compose_ui_graphics_vector_GroupComponent$stable;
  function addPathNodes(pathStr) {
    _init_properties_Vector_kt__7ulyhp();
    var tmp;
    if (pathStr == null) {
      tmp = get_EmptyPath();
    } else {
      tmp = (new PathParser()).h6y(pathStr).j6y();
    }
    return tmp;
  }
  function markTintForBrush($this, brush) {
    if (!$this.d9p_1) {
      return Unit_instance;
    }
    if (!(brush == null)) {
      if (brush instanceof SolidColor) {
        markTintForColor($this, brush.d6b_1);
      } else {
        markNotTintable($this);
      }
    }
  }
  function markTintForColor($this, color) {
    if (!$this.d9p_1) {
      return Unit_instance;
    }
    // Inline function 'androidx.compose.ui.graphics.isSpecified' call
    if (!equals(_Color___get_value__impl__1pls5m(color), _ULong___init__impl__c78o9k(new Long(16, 0)))) {
      // Inline function 'androidx.compose.ui.graphics.isUnspecified' call
      var this_0 = $this.e9p_1;
      if (equals(_Color___get_value__impl__1pls5m(this_0), _ULong___init__impl__c78o9k(new Long(16, 0)))) {
        $this.e9p_1 = color;
      } else {
        if (!rgbEqual($this.e9p_1, color)) {
          markNotTintable($this);
        }
      }
    }
  }
  function markTintForVNode($this, node) {
    if (node instanceof PathComponent) {
      markTintForBrush($this, node.v9p_1);
      markTintForBrush($this, node.b9q_1);
    } else {
      if (node instanceof GroupComponent) {
        if (node.d9p_1 && $this.d9p_1) {
          markTintForColor($this, node.e9p_1);
        } else {
          markNotTintable($this);
        }
      }
    }
  }
  function markNotTintable($this) {
    $this.d9p_1 = false;
    $this.e9p_1 = Companion_getInstance_4().u6b_1;
  }
  function _get_willClipPath__5240v0($this) {
    // Inline function 'kotlin.collections.isNotEmpty' call
    return !$this.f9p_1.r();
  }
  function updateClipPath($this) {
    if (_get_willClipPath__5240v0($this)) {
      var targetClip = $this.h9p_1;
      if (targetClip == null) {
        targetClip = Path();
        $this.h9p_1 = targetClip;
      }
      toPath($this.f9p_1, targetClip);
    }
  }
  function updateMatrix($this) {
    var matrix;
    var target = $this.b9p_1;
    var tmp = target;
    if ((tmp == null ? null : new Matrix(tmp)) == null) {
      matrix = _Matrix___init__impl__q3kp4w();
      $this.b9p_1 = matrix;
    } else {
      matrix = target;
      Matrix__reset_impl_4l49i7(matrix);
    }
    Matrix__translate$default_impl_10t8ql(matrix, $this.q9p_1 + $this.m9p_1, $this.r9p_1 + $this.n9p_1);
    Matrix__rotateZ_impl_2g2pf5(matrix, $this.l9p_1);
    Matrix__scale_impl_6w89a4(matrix, $this.o9p_1, $this.p9p_1, 1.0);
    Matrix__translate$default_impl_10t8ql(matrix, -$this.m9p_1, -$this.n9p_1);
  }
  function GroupComponent$wrappedListener$lambda(this$0) {
    return function (node) {
      markTintForVNode(this$0, node);
      var tmp0_safe_receiver = this$0.i9p_1;
      if (tmp0_safe_receiver == null)
        null;
      else
        tmp0_safe_receiver(node);
      return Unit_instance;
    };
  }
  function GroupComponent() {
    VNode.call(this);
    this.b9p_1 = null;
    var tmp = this;
    // Inline function 'kotlin.collections.mutableListOf' call
    tmp.c9p_1 = ArrayList_init_$Create$();
    this.d9p_1 = true;
    this.e9p_1 = Companion_getInstance_4().u6b_1;
    this.f9p_1 = get_EmptyPath();
    this.g9p_1 = true;
    this.h9p_1 = null;
    this.i9p_1 = null;
    var tmp_0 = this;
    tmp_0.j9p_1 = GroupComponent$wrappedListener$lambda(this);
    this.k9p_1 = '';
    this.l9p_1 = 0.0;
    this.m9p_1 = 0.0;
    this.n9p_1 = 0.0;
    this.o9p_1 = 1.0;
    this.p9p_1 = 1.0;
    this.q9p_1 = 0.0;
    this.r9p_1 = 0.0;
    this.s9p_1 = true;
  }
  protoOf(GroupComponent).q9q = function (value) {
    this.f9p_1 = value;
    this.g9p_1 = true;
    this.m40();
  };
  protoOf(GroupComponent).s9q = function (_set____db54di) {
    this.i9p_1 = _set____db54di;
  };
  protoOf(GroupComponent).t9q = function () {
    return this.i9p_1;
  };
  protoOf(GroupComponent).u9q = function (value) {
    this.k9p_1 = value;
    this.m40();
  };
  protoOf(GroupComponent).v9q = function (value) {
    this.l9p_1 = value;
    this.s9p_1 = true;
    this.m40();
  };
  protoOf(GroupComponent).w9q = function (value) {
    this.m9p_1 = value;
    this.s9p_1 = true;
    this.m40();
  };
  protoOf(GroupComponent).x9q = function (value) {
    this.n9p_1 = value;
    this.s9p_1 = true;
    this.m40();
  };
  protoOf(GroupComponent).w66 = function (value) {
    this.o9p_1 = value;
    this.s9p_1 = true;
    this.m40();
  };
  protoOf(GroupComponent).x66 = function (value) {
    this.p9p_1 = value;
    this.s9p_1 = true;
    this.m40();
  };
  protoOf(GroupComponent).y66 = function (value) {
    this.q9p_1 = value;
    this.s9p_1 = true;
    this.m40();
  };
  protoOf(GroupComponent).z66 = function (value) {
    this.r9p_1 = value;
    this.s9p_1 = true;
    this.m40();
  };
  protoOf(GroupComponent).y9q = function () {
    return this.c9p_1.n1();
  };
  protoOf(GroupComponent).z9q = function (index, instance) {
    if (index < this.y9q()) {
      this.c9p_1.f3(index, instance);
    } else {
      this.c9p_1.j1(instance);
    }
    markTintForVNode(this, instance);
    instance.s9q(this.j9p_1);
    this.m40();
  };
  protoOf(GroupComponent).a9r = function (_this__u8e3s4) {
    if (this.s9p_1) {
      updateMatrix(this);
      this.s9p_1 = false;
    }
    if (this.g9p_1) {
      updateClipPath(this);
      this.g9p_1 = false;
    }
    // Inline function 'androidx.compose.ui.graphics.drawscope.withTransform' call
    // Inline function 'kotlin.with' call
    var $this$with = _this__u8e3s4.v6p();
    var previousSize = $this$with.o5d();
    $this$with.x5u().t6d();
    try {
      var $this$withTransform = $this$with.p6p();
      var tmp0_safe_receiver = this.b9p_1;
      var tmp = tmp0_safe_receiver;
      if ((tmp == null ? null : new Matrix(tmp)) == null)
        null;
      else {
        var tmp_0 = tmp0_safe_receiver;
        // Inline function 'kotlin.let' call
        var it = (tmp_0 == null ? null : new Matrix(tmp_0)).e6h_1;
        $this$withTransform.z6i(it);
      }
      var targetClip = this.h9p_1;
      if (_get_willClipPath__5240v0(this) && !(targetClip == null)) {
        $this$withTransform.s6q(targetClip);
      }
      // Inline function 'androidx.compose.ui.util.fastForEach' call
      var this_0 = this.c9p_1;
      var inductionVariable = 0;
      var last = this_0.n1() - 1 | 0;
      if (inductionVariable <= last)
        do {
          var index = inductionVariable;
          inductionVariable = inductionVariable + 1 | 0;
          var item = this_0.l1(index);
          // Inline function 'kotlin.with' call
          item.a9r(_this__u8e3s4);
        }
         while (inductionVariable <= last);
    }finally {
      $this$with.x5u().u6d();
      $this$with.o6p(previousSize);
    }
  };
  protoOf(GroupComponent).toString = function () {
    var sb = StringBuilder_init_$Create$().q('VGroup: ').q(this.k9p_1);
    // Inline function 'androidx.compose.ui.util.fastForEach' call
    var this_0 = this.c9p_1;
    var inductionVariable = 0;
    var last = this_0.n1() - 1 | 0;
    if (inductionVariable <= last)
      do {
        var index = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var item = this_0.l1(index);
        sb.q('\t').q(toString(item)).q('\n');
      }
       while (inductionVariable <= last);
    return sb.toString();
  };
  function doInvalidate($this) {
    $this.e9r_1 = true;
    $this.g9r_1();
  }
  function VectorComponent$lambda(this$0) {
    return function (it) {
      doInvalidate(this$0);
      return Unit_instance;
    };
  }
  function VectorComponent$invalidateCallback$lambda() {
    return Unit_instance;
  }
  function VectorComponent$_get_intrinsicColorFilter_$ref_abaj9q() {
    return constructCallableReference(function (p0) {
      return p0.o9r();
    }, 1, 0, 47);
  }
  function VectorComponent$_set_intrinsicColorFilter_$ref_5sxbmi() {
    return constructCallableReference(function (p0, p1) {
      p0.p9r(p1);
      return Unit_instance;
    }, 2, 0, 48);
  }
  function VectorComponent$_get_viewportSize_$ref_3uzc83() {
    return constructCallableReference(function (p0) {
      return new Size(p0.q9r());
    }, 1, 0, 49);
  }
  function VectorComponent$_set_viewportSize_$ref_wy3lav() {
    return constructCallableReference(function (p0, p1) {
      p0.r9r(p1.l5e_1);
      return Unit_instance;
    }, 2, 0, 50);
  }
  function VectorComponent$drawVectorBlock$lambda(this$0) {
    return function (_this__u8e3s4) {
      // Inline function 'kotlin.with' call
      var $this$with = this$0.c9r_1;
      var tmp2 = this$0.l9r_1;
      var tmp4 = this$0.m9r_1;
      // Inline function 'androidx.compose.ui.graphics.drawscope.scale' call
      var pivot = Companion_getInstance().g5d_1;
      // Inline function 'androidx.compose.ui.graphics.drawscope.withTransform' call
      // Inline function 'kotlin.with' call
      var $this$with_0 = _this__u8e3s4.v6p();
      var previousSize = $this$with_0.o5d();
      $this$with_0.x5u().t6d();
      try {
        $this$with_0.p6p().u6q(tmp2, tmp4, pivot);
        $this$with.a9r(_this__u8e3s4);
      }finally {
        $this$with_0.x5u().u6d();
        $this$with_0.o6p(previousSize);
      }
      return Unit_instance;
    };
  }
  function VectorComponent(root) {
    VNode.call(this);
    this.c9r_1 = root;
    var tmp = this.c9r_1;
    tmp.i9p_1 = VectorComponent$lambda(this);
    this.d9r_1 = '';
    this.e9r_1 = true;
    this.f9r_1 = new DrawCache();
    var tmp_0 = this;
    tmp_0.g9r_1 = VectorComponent$invalidateCallback$lambda;
    this.h9r_1 = mutableStateOf(null);
    this.i9r_1 = null;
    this.j9r_1 = mutableStateOf(new Size(Companion_getInstance_1().j5e_1));
    this.k9r_1 = Companion_getInstance_1().k5e_1;
    this.l9r_1 = 1.0;
    this.m9r_1 = 1.0;
    var tmp_1 = this;
    tmp_1.n9r_1 = VectorComponent$drawVectorBlock$lambda(this);
  }
  protoOf(VectorComponent).s9r = function () {
    var tmp0_safe_receiver = this.f9r_1.f9m_1;
    var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.v6g();
    var tmp;
    var tmp_0 = tmp1_elvis_lhs;
    if ((tmp_0 == null ? null : new ImageBitmapConfig(tmp_0)) == null) {
      tmp = Companion_getInstance_5().x6g_1;
    } else {
      tmp = tmp1_elvis_lhs;
    }
    return tmp;
  };
  protoOf(VectorComponent).p9r = function (_set____db54di) {
    var tmp0 = this.h9r_1;
    var tmp = KMutableProperty1;
    var tmp_0 = VectorComponent$_get_intrinsicColorFilter_$ref_abaj9q();
    // Inline function 'androidx.compose.runtime.setValue' call
    getPropertyCallableRef('intrinsicColorFilter', 1, tmp, tmp_0, VectorComponent$_set_intrinsicColorFilter_$ref_5sxbmi());
    tmp0.s21(_set____db54di);
    return Unit_instance;
  };
  protoOf(VectorComponent).o9r = function () {
    var tmp0 = this.h9r_1;
    var tmp = KMutableProperty1;
    var tmp_0 = VectorComponent$_get_intrinsicColorFilter_$ref_abaj9q();
    // Inline function 'androidx.compose.runtime.getValue' call
    getPropertyCallableRef('intrinsicColorFilter', 1, tmp, tmp_0, VectorComponent$_set_intrinsicColorFilter_$ref_5sxbmi());
    return tmp0.u1();
  };
  protoOf(VectorComponent).r9r = function (_set____db54di) {
    var tmp0 = this.j9r_1;
    var tmp = KMutableProperty1;
    var tmp_0 = VectorComponent$_get_viewportSize_$ref_3uzc83();
    getPropertyCallableRef('viewportSize', 1, tmp, tmp_0, VectorComponent$_set_viewportSize_$ref_wy3lav());
    // Inline function 'androidx.compose.runtime.setValue' call
    var value = new Size(_set____db54di);
    tmp0.s21(value);
    return Unit_instance;
  };
  protoOf(VectorComponent).q9r = function () {
    var tmp0 = this.j9r_1;
    var tmp = KMutableProperty1;
    var tmp_0 = VectorComponent$_get_viewportSize_$ref_3uzc83();
    // Inline function 'androidx.compose.runtime.getValue' call
    getPropertyCallableRef('viewportSize', 1, tmp, tmp_0, VectorComponent$_set_viewportSize_$ref_wy3lav());
    return tmp0.u1().l5e_1;
  };
  protoOf(VectorComponent).t9r = function (_this__u8e3s4, alpha, colorFilter) {
    var tmp;
    if (this.c9r_1.d9p_1) {
      // Inline function 'androidx.compose.ui.graphics.isSpecified' call
      var this_0 = this.c9r_1.e9p_1;
      tmp = !equals(_Color___get_value__impl__1pls5m(this_0), _ULong___init__impl__c78o9k(new Long(16, 0)));
    } else {
      tmp = false;
    }
    var isOneColor = tmp;
    var tmp_0;
    if (isOneColor && tintableWithAlphaMask(this.o9r()) && tintableWithAlphaMask(colorFilter)) {
      tmp_0 = Companion_getInstance_5().y6g_1;
    } else {
      tmp_0 = Companion_getInstance_5().x6g_1;
    }
    var targetImageConfig = tmp_0;
    if (this.e9r_1 || !equals(this.k9r_1, _this__u8e3s4.o5d()) || !(targetImageConfig === this.s9r())) {
      var tmp_1 = this;
      var tmp_2;
      if (targetImageConfig === Companion_getInstance_5().y6g_1) {
        tmp_2 = Companion_instance_0.i6g(toOpaque(this.c9r_1.e9p_1));
      } else {
        tmp_2 = null;
      }
      tmp_1.i9r_1 = tmp_2;
      var tmp_3 = this;
      // Inline function 'androidx.compose.ui.geometry.Size.width' call
      var this_1 = _this__u8e3s4.o5d();
      // Inline function 'androidx.compose.ui.util.unpackFloat1' call
      var value = _Size___get_packedValue__impl__7rlt1o(this_1);
      // Inline function 'androidx.compose.ui.util.floatFromBits' call
      // Inline function 'kotlin.fromBits' call
      var bits = convertToInt(shiftRight(value, 32));
      var tmp_4 = floatFromBits(bits);
      // Inline function 'androidx.compose.ui.geometry.Size.width' call
      var this_2 = this.q9r();
      // Inline function 'androidx.compose.ui.util.unpackFloat1' call
      var value_0 = _Size___get_packedValue__impl__7rlt1o(this_2);
      // Inline function 'androidx.compose.ui.util.floatFromBits' call
      // Inline function 'kotlin.fromBits' call
      var bits_0 = convertToInt(shiftRight(value_0, 32));
      tmp_3.l9r_1 = tmp_4 / floatFromBits(bits_0);
      var tmp_5 = this;
      // Inline function 'androidx.compose.ui.geometry.Size.height' call
      var this_3 = _this__u8e3s4.o5d();
      // Inline function 'androidx.compose.ui.util.unpackFloat2' call
      var value_1 = _Size___get_packedValue__impl__7rlt1o(this_3);
      // Inline function 'androidx.compose.ui.util.floatFromBits' call
      // Inline function 'kotlin.fromBits' call
      var bits_1 = convertToInt(bitwiseAnd(value_1, new Long(-1, 0)));
      var tmp_6 = floatFromBits(bits_1);
      // Inline function 'androidx.compose.ui.geometry.Size.height' call
      var this_4 = this.q9r();
      // Inline function 'androidx.compose.ui.util.unpackFloat2' call
      var value_2 = _Size___get_packedValue__impl__7rlt1o(this_4);
      // Inline function 'androidx.compose.ui.util.floatFromBits' call
      // Inline function 'kotlin.fromBits' call
      var bits_2 = convertToInt(bitwiseAnd(value_2, new Long(-1, 0)));
      tmp_5.m9r_1 = tmp_6 / floatFromBits(bits_2);
      // Inline function 'androidx.compose.ui.geometry.Size.width' call
      var this_5 = _this__u8e3s4.o5d();
      // Inline function 'androidx.compose.ui.util.unpackFloat1' call
      var value_3 = _Size___get_packedValue__impl__7rlt1o(this_5);
      // Inline function 'androidx.compose.ui.util.floatFromBits' call
      // Inline function 'kotlin.fromBits' call
      var bits_3 = convertToInt(shiftRight(value_3, 32));
      // Inline function 'kotlin.math.ceil' call
      var x = floatFromBits(bits_3);
      var tmp$ret$21 = Math.ceil(x);
      var tmp0 = numberToInt(tmp$ret$21);
      // Inline function 'androidx.compose.ui.geometry.Size.height' call
      var this_6 = _this__u8e3s4.o5d();
      // Inline function 'androidx.compose.ui.util.unpackFloat2' call
      var value_4 = _Size___get_packedValue__impl__7rlt1o(this_6);
      // Inline function 'androidx.compose.ui.util.floatFromBits' call
      // Inline function 'kotlin.fromBits' call
      var bits_4 = convertToInt(bitwiseAnd(value_4, new Long(-1, 0)));
      // Inline function 'kotlin.math.ceil' call
      var x_0 = floatFromBits(bits_4);
      var tmp$ret$26 = Math.ceil(x_0);
      // Inline function 'androidx.compose.ui.unit.IntSize' call
      // Inline function 'androidx.compose.ui.util.packInts' call
      var val2 = numberToInt(tmp$ret$26);
      var tmp$ret$28 = bitwiseOr(shiftLeft(fromInt(tmp0), 32), bitwiseAnd(fromInt(val2), new Long(-1, 0)));
      var tmp$ret$27 = _IntSize___init__impl__emcjft(tmp$ret$28);
      this.f9r_1.m9m(targetImageConfig, tmp$ret$27, _this__u8e3s4, _this__u8e3s4.r6p(), this.n9r_1);
      this.e9r_1 = false;
      this.k9r_1 = _this__u8e3s4.o5d();
    }
    var tmp_7;
    if (!(colorFilter == null)) {
      tmp_7 = colorFilter;
    } else if (!(this.o9r() == null)) {
      tmp_7 = this.o9r();
    } else {
      tmp_7 = this.i9r_1;
    }
    var targetFilter = tmp_7;
    this.f9r_1.n9m(_this__u8e3s4, alpha, targetFilter);
  };
  protoOf(VectorComponent).a9r = function (_this__u8e3s4) {
    this.t9r(_this__u8e3s4, 1.0, null);
  };
  protoOf(VectorComponent).toString = function () {
    // Inline function 'kotlin.text.buildString' call
    // Inline function 'kotlin.apply' call
    var this_0 = StringBuilder_init_$Create$();
    this_0.q('Params: ');
    this_0.q('\tname: ').q(this.d9r_1).q('\n');
    var tmp = this_0.q('\tviewportWidth: ');
    // Inline function 'androidx.compose.ui.geometry.Size.width' call
    var this_1 = this.q9r();
    // Inline function 'androidx.compose.ui.util.unpackFloat1' call
    var value = _Size___get_packedValue__impl__7rlt1o(this_1);
    // Inline function 'androidx.compose.ui.util.floatFromBits' call
    // Inline function 'kotlin.fromBits' call
    var bits = convertToInt(shiftRight(value, 32));
    var tmp$ret$3 = floatFromBits(bits);
    tmp.gd(tmp$ret$3).q('\n');
    var tmp_0 = this_0.q('\tviewportHeight: ');
    // Inline function 'androidx.compose.ui.geometry.Size.height' call
    var this_2 = this.q9r();
    // Inline function 'androidx.compose.ui.util.unpackFloat2' call
    var value_0 = _Size___get_packedValue__impl__7rlt1o(this_2);
    // Inline function 'androidx.compose.ui.util.floatFromBits' call
    // Inline function 'kotlin.fromBits' call
    var bits_0 = convertToInt(bitwiseAnd(value_0, new Long(-1, 0)));
    var tmp$ret$7 = floatFromBits(bits_0);
    tmp_0.gd(tmp$ret$7).q('\n');
    return this_0.toString();
  };
  function _get_tmpPath__aeqkaz($this) {
    var localTmp = $this.o9q_1;
    if (!(localTmp == null))
      return localTmp;
    // Inline function 'kotlin.also' call
    var this_0 = Path();
    $this.o9q_1 = this_0;
    return this_0;
  }
  function _get_pathMeasure__8eu6yw($this) {
    var tmp0 = $this.p9q_1;
    var tmp = KProperty1;
    // Inline function 'kotlin.getValue' call
    getPropertyCallableRef('pathMeasure', 1, tmp, PathComponent$_get_pathMeasure_$ref_v5922j(), null);
    return tmp0.u1();
  }
  function updatePath($this) {
    toPath($this.x9p_1, $this.m9q_1);
    updateRenderPath($this);
  }
  function updateRenderPath($this) {
    if ($this.f9q_1 === 0.0 && $this.g9q_1 === 1.0) {
      $this.n9q_1 = $this.m9q_1;
    } else {
      if (equals($this.n9q_1, $this.m9q_1)) {
        $this.n9q_1 = Path();
      } else {
        var fillType = $this.n9q_1.k6i();
        $this.n9q_1.y6i();
        $this.n9q_1.j6i(fillType);
      }
      _get_pathMeasure__8eu6yw($this).g6z($this.m9q_1, false);
      var length = _get_pathMeasure__8eu6yw($this).a();
      var start = ($this.f9q_1 + $this.h9q_1) % 1.0 * length;
      var end = ($this.g9q_1 + $this.h9q_1) % 1.0 * length;
      if (start > end) {
        var dstPath = _get_tmpPath__aeqkaz($this);
        dstPath.u4c();
        _get_pathMeasure__8eu6yw($this).h6z(start, length, dstPath, true);
        $this.n9q_1.c6i(dstPath);
        dstPath.u4c();
        _get_pathMeasure__8eu6yw($this).h6z(0.0, end, dstPath, true);
        $this.n9q_1.c6i(dstPath);
      } else {
        _get_pathMeasure__8eu6yw($this).h6z(start, end, $this.n9q_1, true);
      }
    }
  }
  function PathComponent$pathMeasure$delegate$lambda() {
    return PathMeasure();
  }
  function PathComponent$_get_pathMeasure_$ref_v5922j() {
    return constructCallableReference(function (p0) {
      return _get_pathMeasure__8eu6yw(p0);
    }, 1, 0, 51);
  }
  function PathComponent() {
    VNode.call(this);
    this.u9p_1 = '';
    this.v9p_1 = null;
    this.w9p_1 = 1.0;
    this.x9p_1 = get_EmptyPath();
    this.y9p_1 = get_DefaultFillType();
    this.z9p_1 = 1.0;
    this.a9q_1 = 0.0;
    this.b9q_1 = null;
    this.c9q_1 = get_DefaultStrokeLineCap();
    this.d9q_1 = get_DefaultStrokeLineJoin();
    this.e9q_1 = 4.0;
    this.f9q_1 = 0.0;
    this.g9q_1 = 1.0;
    this.h9q_1 = 0.0;
    this.i9q_1 = true;
    this.j9q_1 = true;
    this.k9q_1 = false;
    this.l9q_1 = null;
    this.m9q_1 = Path();
    this.n9q_1 = this.m9q_1;
    this.o9q_1 = null;
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_NONE_getInstance();
    tmp.p9q_1 = lazy(tmp_0, PathComponent$pathMeasure$delegate$lambda);
  }
  protoOf(PathComponent).u9q = function (value) {
    this.u9p_1 = value;
    this.m40();
  };
  protoOf(PathComponent).u9r = function (value) {
    this.v9p_1 = value;
    this.m40();
  };
  protoOf(PathComponent).v9r = function (value) {
    this.w9p_1 = value;
    this.m40();
  };
  protoOf(PathComponent).w9r = function (value) {
    this.x9p_1 = value;
    this.i9q_1 = true;
    this.m40();
  };
  protoOf(PathComponent).x9r = function (value) {
    this.y9p_1 = value;
    this.n9q_1.j6i(value);
    this.m40();
  };
  protoOf(PathComponent).y9r = function (value) {
    this.z9p_1 = value;
    this.m40();
  };
  protoOf(PathComponent).z9r = function (value) {
    this.a9q_1 = value;
    this.j9q_1 = true;
    this.m40();
  };
  protoOf(PathComponent).a9s = function (value) {
    this.b9q_1 = value;
    this.m40();
  };
  protoOf(PathComponent).b9s = function (value) {
    this.c9q_1 = value;
    this.j9q_1 = true;
    this.m40();
  };
  protoOf(PathComponent).c9s = function (value) {
    this.d9q_1 = value;
    this.j9q_1 = true;
    this.m40();
  };
  protoOf(PathComponent).d9s = function (value) {
    this.e9q_1 = value;
    this.j9q_1 = true;
    this.m40();
  };
  protoOf(PathComponent).e9s = function (value) {
    this.f9q_1 = value;
    this.k9q_1 = true;
    this.m40();
  };
  protoOf(PathComponent).f9s = function (value) {
    this.g9q_1 = value;
    this.k9q_1 = true;
    this.m40();
  };
  protoOf(PathComponent).g9s = function (value) {
    this.h9q_1 = value;
    this.k9q_1 = true;
    this.m40();
  };
  protoOf(PathComponent).a9r = function (_this__u8e3s4) {
    if (this.i9q_1) {
      updatePath(this);
    } else if (this.k9q_1) {
      updateRenderPath(this);
    }
    this.i9q_1 = false;
    this.k9q_1 = false;
    var tmp0_safe_receiver = this.v9p_1;
    if (tmp0_safe_receiver == null)
      null;
    else {
      // Inline function 'kotlin.let' call
      _this__u8e3s4.l6q(this.n9q_1, tmp0_safe_receiver, this.w9p_1);
    }
    var tmp1_safe_receiver = this.b9q_1;
    if (tmp1_safe_receiver == null)
      null;
    else {
      // Inline function 'kotlin.let' call
      var targetStroke = this.l9q_1;
      if (this.j9q_1 || targetStroke == null) {
        targetStroke = new Stroke(this.a9q_1, this.e9q_1, this.c9q_1, this.d9q_1);
        this.l9q_1 = targetStroke;
        this.j9q_1 = false;
      }
      _this__u8e3s4.l6q(this.n9q_1, tmp1_safe_receiver, this.z9p_1, targetStroke);
    }
  };
  protoOf(PathComponent).toString = function () {
    return toString(this.m9q_1);
  };
  function VNode() {
    this.r9q_1 = null;
  }
  protoOf(VNode).s9q = function (_set____db54di) {
    this.r9q_1 = _set____db54di;
  };
  protoOf(VNode).t9q = function () {
    return this.r9q_1;
  };
  protoOf(VNode).m40 = function () {
    var tmp0_safe_receiver = this.t9q();
    if (tmp0_safe_receiver == null)
      null;
    else
      tmp0_safe_receiver(this);
  };
  function rgbEqual(_this__u8e3s4, other) {
    _init_properties_Vector_kt__7ulyhp();
    return _Color___get_red__impl__cwrsk6(_this__u8e3s4) === _Color___get_red__impl__cwrsk6(other) && _Color___get_green__impl__bta9rs(_this__u8e3s4) === _Color___get_green__impl__bta9rs(other) && _Color___get_blue__impl__xwez13(_this__u8e3s4) === _Color___get_blue__impl__xwez13(other);
  }
  function tintableWithAlphaMask(_this__u8e3s4) {
    _init_properties_Vector_kt__7ulyhp();
    var tmp;
    if (_this__u8e3s4 instanceof BlendModeColorFilter) {
      tmp = _this__u8e3s4.n6g_1 === Companion_getInstance_3().d6a_1 || _this__u8e3s4.n6g_1 === Companion_getInstance_3().b6a_1;
    } else {
      tmp = _this__u8e3s4 == null;
    }
    return tmp;
  }
  function toOpaque(_this__u8e3s4) {
    _init_properties_Vector_kt__7ulyhp();
    return !(_Color___get_alpha__impl__wcfyv1(_this__u8e3s4) === 1.0) ? Color__copy$default_impl_ectz3s(_this__u8e3s4, 1.0) : _this__u8e3s4;
  }
  var properties_initialized_Vector_kt_6ddpp7;
  function _init_properties_Vector_kt__7ulyhp() {
    if (!properties_initialized_Vector_kt_6ddpp7) {
      properties_initialized_Vector_kt_6ddpp7 = true;
      EmptyPath = emptyList();
      DefaultStrokeLineCap = Companion_getInstance_6().s6j_1;
      DefaultStrokeLineJoin = Companion_getInstance_7().w6j_1;
      DefaultTintBlendMode = Companion_getInstance_3().d6a_1;
      DefaultTintColor = Companion_getInstance_4().t6b_1;
      DefaultFillType = Companion_getInstance_8().i6j_1;
      androidx_compose_ui_graphics_vector_VNode$stable = 8;
      androidx_compose_ui_graphics_vector_VectorComponent$stable = 8;
      androidx_compose_ui_graphics_vector_PathComponent$stable = 8;
      androidx_compose_ui_graphics_vector_GroupComponent$stable = 8;
    }
  }
  var androidx_compose_ui_graphics_vector_VectorPainter$stable;
  var androidx_compose_ui_graphics_vector_VectorProperty_Rotation$stable;
  var androidx_compose_ui_graphics_vector_VectorProperty_PivotX$stable;
  var androidx_compose_ui_graphics_vector_VectorProperty_PivotY$stable;
  var androidx_compose_ui_graphics_vector_VectorProperty_ScaleX$stable;
  var androidx_compose_ui_graphics_vector_VectorProperty_ScaleY$stable;
  var androidx_compose_ui_graphics_vector_VectorProperty_TranslateX$stable;
  var androidx_compose_ui_graphics_vector_VectorProperty_TranslateY$stable;
  var androidx_compose_ui_graphics_vector_VectorProperty_PathData$stable;
  var androidx_compose_ui_graphics_vector_VectorProperty_Fill$stable;
  var androidx_compose_ui_graphics_vector_VectorProperty_FillAlpha$stable;
  var androidx_compose_ui_graphics_vector_VectorProperty_Stroke$stable;
  var androidx_compose_ui_graphics_vector_VectorProperty_StrokeLineWidth$stable;
  var androidx_compose_ui_graphics_vector_VectorProperty_StrokeAlpha$stable;
  var androidx_compose_ui_graphics_vector_VectorProperty_TrimPathStart$stable;
  var androidx_compose_ui_graphics_vector_VectorProperty_TrimPathEnd$stable;
  var androidx_compose_ui_graphics_vector_VectorProperty_TrimPathOffset$stable;
  var androidx_compose_ui_graphics_vector_VectorProperty$stable;
  function _set_drawInvalidation__mw29ud($this, _set____db54di) {
    var tmp0 = $this.r9s_1;
    var tmp = KMutableProperty1;
    var tmp_0 = VectorPainter$_get_drawInvalidation_$ref_ub00fo();
    // Inline function 'androidx.compose.runtime.setValue' call
    getPropertyCallableRef('drawInvalidation', 1, tmp, tmp_0, VectorPainter$_set_drawInvalidation_$ref_qs1dj4());
    tmp0.s21(Unit_instance);
    return Unit_instance;
  }
  function _get_drawInvalidation__j1xj1z($this) {
    var tmp0 = $this.r9s_1;
    var tmp = KMutableProperty1;
    var tmp_0 = VectorPainter$_get_drawInvalidation_$ref_ub00fo();
    // Inline function 'androidx.compose.runtime.getValue' call
    getPropertyCallableRef('drawInvalidation', 1, tmp, tmp_0, VectorPainter$_set_drawInvalidation_$ref_qs1dj4());
    tmp0.u1();
    return Unit_instance;
  }
  function VectorPainter$_get_size_$ref_3x92ad() {
    return constructCallableReference(function (p0) {
      return new Size(p0.u9s());
    }, 1, 0, 52);
  }
  function VectorPainter$_set_size_$ref_gq5dr5() {
    return constructCallableReference(function (p0, p1) {
      p0.v9s(p1.l5e_1);
      return Unit_instance;
    }, 2, 0, 53);
  }
  function VectorPainter$_get_autoMirror_$ref_9mgelk() {
    return constructCallableReference(function (p0) {
      return p0.w9s();
    }, 1, 0, 54);
  }
  function VectorPainter$_set_autoMirror_$ref_fwn1fw() {
    return constructCallableReference(function (p0, p1) {
      p0.x9s(p1);
      return Unit_instance;
    }, 2, 0, 55);
  }
  function VectorPainter$vector$lambda(this$0) {
    return function () {
      _set_drawInvalidation__mw29ud(this$0, Unit_instance);
      return Unit_instance;
    };
  }
  function VectorPainter$_get_drawInvalidation_$ref_ub00fo() {
    return constructCallableReference(function (p0) {
      _get_drawInvalidation__j1xj1z(p0);
      return Unit_instance;
    }, 1, 0, 56);
  }
  function VectorPainter$_set_drawInvalidation_$ref_qs1dj4() {
    return constructCallableReference(function (p0, p1) {
      _set_drawInvalidation__mw29ud(p0, p1);
      return Unit_instance;
    }, 2, 0, 57);
  }
  function VectorPainter(root) {
    root = root === VOID ? new GroupComponent() : root;
    Painter.call(this);
    this.n9s_1 = mutableStateOf(new Size(Companion_getInstance_1().j5e_1));
    this.o9s_1 = mutableStateOf(false);
    var tmp = this;
    // Inline function 'kotlin.apply' call
    var this_0 = new VectorComponent(root);
    var tmp_0 = this_0;
    tmp_0.g9r_1 = VectorPainter$vector$lambda(this);
    tmp.p9s_1 = this_0;
    this.q9s_1 = null;
    this.r9s_1 = mutableStateOf(Unit_instance, neverEqualPolicy());
    this.s9s_1 = 1.0;
    this.t9s_1 = null;
  }
  protoOf(VectorPainter).v9s = function (_set____db54di) {
    var tmp0 = this.n9s_1;
    var tmp = KMutableProperty1;
    var tmp_0 = VectorPainter$_get_size_$ref_3x92ad();
    getPropertyCallableRef('size', 1, tmp, tmp_0, VectorPainter$_set_size_$ref_gq5dr5());
    // Inline function 'androidx.compose.runtime.setValue' call
    var value = new Size(_set____db54di);
    tmp0.s21(value);
    return Unit_instance;
  };
  protoOf(VectorPainter).u9s = function () {
    var tmp0 = this.n9s_1;
    var tmp = KMutableProperty1;
    var tmp_0 = VectorPainter$_get_size_$ref_3x92ad();
    // Inline function 'androidx.compose.runtime.getValue' call
    getPropertyCallableRef('size', 1, tmp, tmp_0, VectorPainter$_set_size_$ref_gq5dr5());
    return tmp0.u1().l5e_1;
  };
  protoOf(VectorPainter).x9s = function (_set____db54di) {
    var tmp0 = this.o9s_1;
    var tmp = KMutableProperty1;
    var tmp_0 = VectorPainter$_get_autoMirror_$ref_9mgelk();
    // Inline function 'androidx.compose.runtime.setValue' call
    getPropertyCallableRef('autoMirror', 1, tmp, tmp_0, VectorPainter$_set_autoMirror_$ref_fwn1fw());
    tmp0.s21(_set____db54di);
    return Unit_instance;
  };
  protoOf(VectorPainter).w9s = function () {
    var tmp0 = this.o9s_1;
    var tmp = KMutableProperty1;
    var tmp_0 = VectorPainter$_get_autoMirror_$ref_9mgelk();
    // Inline function 'androidx.compose.runtime.getValue' call
    getPropertyCallableRef('autoMirror', 1, tmp, tmp_0, VectorPainter$_set_autoMirror_$ref_fwn1fw());
    return tmp0.u1();
  };
  protoOf(VectorPainter).p9r = function (value) {
    this.p9s_1.p9r(value);
  };
  protoOf(VectorPainter).r9r = function (value) {
    this.p9s_1.r9r(value);
  };
  protoOf(VectorPainter).y9s = function (value) {
    this.p9s_1.d9r_1 = value;
  };
  protoOf(VectorPainter).g6t = function () {
    return this.u9s();
  };
  protoOf(VectorPainter).f6t = function (_this__u8e3s4) {
    // Inline function 'kotlin.with' call
    var $this$with = this.p9s_1;
    var tmp0_elvis_lhs = this.t9s_1;
    var filter = tmp0_elvis_lhs == null ? $this$with.o9r() : tmp0_elvis_lhs;
    if (this.w9s() && _this__u8e3s4.r6p().equals(LayoutDirection_Rtl_getInstance())) {
      // Inline function 'androidx.compose.ui.graphics.vector.mirror' call
      // Inline function 'androidx.compose.ui.graphics.drawscope.scale' call
      var scaleX = -1.0;
      var pivot = _this__u8e3s4.m6q();
      // Inline function 'androidx.compose.ui.graphics.drawscope.withTransform' call
      // Inline function 'kotlin.with' call
      var $this$with_0 = _this__u8e3s4.v6p();
      var previousSize = $this$with_0.o5d();
      $this$with_0.x5u().t6d();
      try {
        $this$with_0.p6p().u6q(scaleX, 1.0, pivot);
        $this$with.t9r(_this__u8e3s4, this.s9s_1, filter);
      }finally {
        $this$with_0.x5u().u6d();
        $this$with_0.o6p(previousSize);
      }
    } else {
      $this$with.t9r(_this__u8e3s4, this.s9s_1, filter);
    }
    _get_drawInvalidation__j1xj1z(this);
  };
  protoOf(VectorPainter).h6t = function (alpha) {
    this.s9s_1 = alpha;
    return true;
  };
  protoOf(VectorPainter).i6t = function (colorFilter) {
    this.t9s_1 = colorFilter;
    return true;
  };
  function rememberVectorPainter(image, $composer, $changed) {
    var $composer_0 = $composer;
    // Inline function 'androidx.compose.runtime.CompositionLocal.current' call
    var this_0 = get_LocalDensity();
    var $composer_1 = $composer_0;
    var density = $composer_1.u31(this_0);
    var tmp0 = image.a9o_1;
    // Inline function 'androidx.compose.ui.util.packFloats' call
    var val2 = density.u5e();
    var v1 = fromInt(toRawBits(tmp0));
    var v2 = fromInt(toRawBits(val2));
    var key = bitwiseOr(shiftLeft(v1, 32), bitwiseAnd(v2, new Long(-1, 0)));
    // Inline function 'androidx.compose.runtime.cache' call
    var invalid = $composer_0.o31(key);
    // Inline function 'kotlin.let' call
    var it = $composer_0.i31();
    var tmp;
    if (invalid || it === Companion_getInstance_9().f30_1) {
      // Inline function 'kotlin.apply' call
      var this_1 = new GroupComponent();
      createGroupComponent(this_1, image.w9n_1);
      var value = createVectorPainterFromImageVector(density, image, this_1);
      $composer_0.j31(value);
      tmp = value;
    } else {
      tmp = it;
    }
    return tmp;
  }
  function androidx_compose_ui_graphics_vector_VectorPainter$stableprop_getter() {
    return androidx_compose_ui_graphics_vector_VectorPainter$stable;
  }
  function createVectorPainterFromImageVector(density, imageVector, root) {
    var defaultSize = obtainSizePx(density, imageVector.s9n_1, imageVector.t9n_1);
    var viewport = obtainViewportSize(defaultSize, imageVector.u9n_1, imageVector.v9n_1);
    return configureVectorPainter(new VectorPainter(root), defaultSize, viewport, imageVector.r9n_1, createColorFilter(imageVector.x9n_1, imageVector.y9n_1), imageVector.z9n_1);
  }
  function createGroupComponent(_this__u8e3s4, currentGroup) {
    var inductionVariable = 0;
    var last = currentGroup.n1();
    if (inductionVariable < last)
      do {
        var index = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var vectorNode = currentGroup.l1(index);
        if (vectorNode instanceof VectorPath) {
          // Inline function 'kotlin.apply' call
          var this_0 = new PathComponent();
          this_0.w9r(vectorNode.n9o_1);
          this_0.x9r(vectorNode.o9o_1);
          this_0.u9q(vectorNode.m9o_1);
          this_0.u9r(vectorNode.p9o_1);
          this_0.v9r(vectorNode.q9o_1);
          this_0.a9s(vectorNode.r9o_1);
          this_0.y9r(vectorNode.s9o_1);
          this_0.z9r(vectorNode.t9o_1);
          this_0.b9s(vectorNode.u9o_1);
          this_0.c9s(vectorNode.v9o_1);
          this_0.d9s(vectorNode.w9o_1);
          this_0.e9s(vectorNode.x9o_1);
          this_0.f9s(vectorNode.y9o_1);
          this_0.g9s(vectorNode.z9o_1);
          var pathComponent = this_0;
          _this__u8e3s4.z9q(index, pathComponent);
        } else {
          if (vectorNode instanceof VectorGroup) {
            // Inline function 'kotlin.apply' call
            var this_1 = new GroupComponent();
            this_1.u9q(vectorNode.c9o_1);
            this_1.v9q(vectorNode.d9o_1);
            this_1.w66(vectorNode.g9o_1);
            this_1.x66(vectorNode.h9o_1);
            this_1.y66(vectorNode.i9o_1);
            this_1.z66(vectorNode.j9o_1);
            this_1.w9q(vectorNode.e9o_1);
            this_1.x9q(vectorNode.f9o_1);
            this_1.q9q(vectorNode.k9o_1);
            createGroupComponent(this_1, vectorNode);
            var groupComponent = this_1;
            _this__u8e3s4.z9q(index, groupComponent);
          }
        }
      }
       while (inductionVariable < last);
    return _this__u8e3s4;
  }
  function obtainSizePx(_this__u8e3s4, defaultWidth, defaultHeight) {
    var tmp0 = _this__u8e3s4.v5e(defaultWidth);
    // Inline function 'androidx.compose.ui.geometry.Size' call
    // Inline function 'androidx.compose.ui.util.packFloats' call
    var val2 = _this__u8e3s4.v5e(defaultHeight);
    var v1 = fromInt(toRawBits(tmp0));
    var v2 = fromInt(toRawBits(val2));
    var tmp$ret$1 = bitwiseOr(shiftLeft(v1, 32), bitwiseAnd(v2, new Long(-1, 0)));
    return _Size___init__impl__aywn0g(tmp$ret$1);
  }
  function obtainViewportSize(defaultSize, viewportWidth, viewportHeight) {
    var tmp;
    if (isNaN_0(viewportWidth)) {
      // Inline function 'androidx.compose.ui.geometry.Size.width' call
      // Inline function 'androidx.compose.ui.util.unpackFloat1' call
      var value = _Size___get_packedValue__impl__7rlt1o(defaultSize);
      // Inline function 'androidx.compose.ui.util.floatFromBits' call
      // Inline function 'kotlin.fromBits' call
      var bits = convertToInt(shiftRight(value, 32));
      tmp = floatFromBits(bits);
    } else {
      tmp = viewportWidth;
    }
    var tmp0 = tmp;
    var tmp_0;
    if (isNaN_0(viewportHeight)) {
      // Inline function 'androidx.compose.ui.geometry.Size.height' call
      // Inline function 'androidx.compose.ui.util.unpackFloat2' call
      var value_0 = _Size___get_packedValue__impl__7rlt1o(defaultSize);
      // Inline function 'androidx.compose.ui.util.floatFromBits' call
      // Inline function 'kotlin.fromBits' call
      var bits_0 = convertToInt(bitwiseAnd(value_0, new Long(-1, 0)));
      tmp_0 = floatFromBits(bits_0);
    } else {
      tmp_0 = viewportHeight;
    }
    // Inline function 'androidx.compose.ui.geometry.Size' call
    // Inline function 'androidx.compose.ui.util.packFloats' call
    var val2 = tmp_0;
    var v1 = fromInt(toRawBits(tmp0));
    var v2 = fromInt(toRawBits(val2));
    var tmp$ret$9 = bitwiseOr(shiftLeft(v1, 32), bitwiseAnd(v2, new Long(-1, 0)));
    return _Size___init__impl__aywn0g(tmp$ret$9);
  }
  function configureVectorPainter(_this__u8e3s4, defaultSize, viewportSize, name, intrinsicColorFilter, autoMirror) {
    name = name === VOID ? 'VectorRootGroup' : name;
    autoMirror = autoMirror === VOID ? false : autoMirror;
    // Inline function 'kotlin.apply' call
    _this__u8e3s4.v9s(defaultSize);
    _this__u8e3s4.x9s(autoMirror);
    _this__u8e3s4.p9r(intrinsicColorFilter);
    _this__u8e3s4.r9r(viewportSize);
    _this__u8e3s4.y9s(name);
    return _this__u8e3s4;
  }
  function createColorFilter(tintColor, tintBlendMode) {
    var tmp;
    // Inline function 'androidx.compose.ui.graphics.isSpecified' call
    if (!equals(_Color___get_value__impl__1pls5m(tintColor), _ULong___init__impl__c78o9k(new Long(16, 0)))) {
      tmp = Companion_instance_0.h6g(tintColor, tintBlendMode);
    } else {
      tmp = null;
    }
    return tmp;
  }
  function _HapticFeedbackType___init__impl__z5bkgl(value) {
    return value;
  }
  function HapticFeedbackType__toString_impl_a87iph($this) {
    return $this === Companion_instance_16.l9t() ? 'Confirm' : $this === Companion_instance_16.k9t() ? 'ContextClick' : $this === Companion_instance_16.j9t() ? 'GestureEnd' : $this === Companion_instance_16.i9t() ? 'GestureThresholdActivate' : $this === Companion_instance_16.h9t() ? 'KeyboardTap' : $this === Companion_instance_16.g9t() ? 'LongPress' : $this === Companion_instance_16.f9t() ? 'Reject' : $this === Companion_instance_16.e9t() ? 'SegmentFrequentTick' : $this === Companion_instance_16.d9t() ? 'SegmentTick' : $this === Companion_instance_16.c9t() ? 'TextHandleMove' : $this === Companion_instance_16.b9t() ? 'ToggleOff' : $this === Companion_instance_16.a9t() ? 'ToggleOn' : $this === Companion_instance_16.z9s() ? 'VirtualKey' : 'Invalid';
  }
  function Companion_11() {
  }
  protoOf(Companion_11).l9t = function () {
    return PlatformHapticFeedbackType_getInstance().m9t_1;
  };
  protoOf(Companion_11).k9t = function () {
    return PlatformHapticFeedbackType_getInstance().n9t_1;
  };
  protoOf(Companion_11).j9t = function () {
    return PlatformHapticFeedbackType_getInstance().o9t_1;
  };
  protoOf(Companion_11).i9t = function () {
    return PlatformHapticFeedbackType_getInstance().p9t_1;
  };
  protoOf(Companion_11).h9t = function () {
    return PlatformHapticFeedbackType_getInstance().q9t_1;
  };
  protoOf(Companion_11).g9t = function () {
    return PlatformHapticFeedbackType_getInstance().r9t_1;
  };
  protoOf(Companion_11).f9t = function () {
    return PlatformHapticFeedbackType_getInstance().s9t_1;
  };
  protoOf(Companion_11).e9t = function () {
    return PlatformHapticFeedbackType_getInstance().t9t_1;
  };
  protoOf(Companion_11).d9t = function () {
    return PlatformHapticFeedbackType_getInstance().u9t_1;
  };
  protoOf(Companion_11).c9t = function () {
    return PlatformHapticFeedbackType_getInstance().v9t_1;
  };
  protoOf(Companion_11).b9t = function () {
    return PlatformHapticFeedbackType_getInstance().x9t_1;
  };
  protoOf(Companion_11).a9t = function () {
    return PlatformHapticFeedbackType_getInstance().w9t_1;
  };
  protoOf(Companion_11).z9s = function () {
    return PlatformHapticFeedbackType_getInstance().y9t_1;
  };
  var Companion_instance_16;
  function Companion_getInstance_37() {
    return Companion_instance_16;
  }
  function HapticFeedbackType__hashCode_impl_vzdfic($this) {
    return $this;
  }
  function HapticFeedbackType__equals_impl_7pd0mg($this, other) {
    if (!(other instanceof HapticFeedbackType))
      return false;
    if (!($this === other.z9t_1))
      return false;
    return true;
  }
  function HapticFeedbackType(value) {
    this.z9t_1 = value;
  }
  protoOf(HapticFeedbackType).toString = function () {
    return HapticFeedbackType__toString_impl_a87iph(this.z9t_1);
  };
  protoOf(HapticFeedbackType).hashCode = function () {
    return HapticFeedbackType__hashCode_impl_vzdfic(this.z9t_1);
  };
  protoOf(HapticFeedbackType).equals = function (other) {
    return HapticFeedbackType__equals_impl_7pd0mg(this.z9t_1, other);
  };
  var androidx_compose_ui_input_InputModeManagerImpl$stable;
  function _InputMode___init__impl__v9lqz8(value) {
    return value;
  }
  function InputMode__toString_impl_z22qz0($this) {
    return $this === Companion_getInstance_38().a9u_1 ? 'Touch' : $this === Companion_getInstance_38().b9u_1 ? 'Keyboard' : 'Error';
  }
  function Companion_12() {
    Companion_instance_17 = this;
    this.a9u_1 = _InputMode___init__impl__v9lqz8(1);
    this.b9u_1 = _InputMode___init__impl__v9lqz8(2);
  }
  var Companion_instance_17;
  function Companion_getInstance_38() {
    if (Companion_instance_17 == null)
      new Companion_12();
    return Companion_instance_17;
  }
  function InputMode__hashCode_impl_e7ve79($this) {
    return $this;
  }
  function InputMode__equals_impl_rgqy7z($this, other) {
    if (!(other instanceof InputMode))
      return false;
    if (!($this === other.c9u_1))
      return false;
    return true;
  }
  function InputMode(value) {
    Companion_getInstance_38();
    this.c9u_1 = value;
  }
  protoOf(InputMode).toString = function () {
    return InputMode__toString_impl_z22qz0(this.c9u_1);
  };
  protoOf(InputMode).hashCode = function () {
    return InputMode__hashCode_impl_e7ve79(this.c9u_1);
  };
  protoOf(InputMode).equals = function (other) {
    return InputMode__equals_impl_rgqy7z(this.c9u_1, other);
  };
  var androidx_compose_ui_input_indirect_IndirectPointerInputChange$stable;
  function IndirectPointerInputModifierNode() {
  }
  function _KeyEvent___init__impl__411tom(nativeKeyEvent) {
    return nativeKeyEvent;
  }
  function _KeyEvent___get_nativeKeyEvent__impl__py13j5($this) {
    return $this;
  }
  function KeyEvent__toString_impl_1f7sp2($this) {
    return 'KeyEvent(nativeKeyEvent=' + toString($this) + ')';
  }
  function KeyEvent__hashCode_impl_kby43t($this) {
    return hashCode($this);
  }
  function KeyEvent__equals_impl_vn1w6l($this, other) {
    if (!(other instanceof KeyEvent))
      return false;
    var tmp0_other_with_cast = other.e9u_1;
    if (!equals($this, tmp0_other_with_cast))
      return false;
    return true;
  }
  function KeyEvent(nativeKeyEvent) {
    this.e9u_1 = nativeKeyEvent;
  }
  protoOf(KeyEvent).toString = function () {
    return KeyEvent__toString_impl_1f7sp2(this.e9u_1);
  };
  protoOf(KeyEvent).hashCode = function () {
    return KeyEvent__hashCode_impl_kby43t(this.e9u_1);
  };
  protoOf(KeyEvent).equals = function (other) {
    return KeyEvent__equals_impl_vn1w6l(this.e9u_1, other);
  };
  function _KeyEventType___init__impl__85599o(value) {
    return value;
  }
  function KeyEventType__toString_impl_auomc4($this) {
    return $this === Companion_getInstance_39().d9e_1 ? 'KeyUp' : $this === Companion_getInstance_39().e9e_1 ? 'KeyDown' : $this === Companion_getInstance_39().c9e_1 ? 'Unknown' : 'Invalid';
  }
  function Companion_13() {
    Companion_instance_18 = this;
    this.c9e_1 = _KeyEventType___init__impl__85599o(0);
    this.d9e_1 = _KeyEventType___init__impl__85599o(1);
    this.e9e_1 = _KeyEventType___init__impl__85599o(2);
  }
  var Companion_instance_18;
  function Companion_getInstance_39() {
    if (Companion_instance_18 == null)
      new Companion_13();
    return Companion_instance_18;
  }
  function KeyEventType__hashCode_impl_wluj4z($this) {
    return $this;
  }
  function onPreviewKeyEvent(_this__u8e3s4, onPreviewKeyEvent) {
    return _this__u8e3s4.d8v(new KeyInputElement(null, onPreviewKeyEvent));
  }
  function onKeyEvent(_this__u8e3s4, onKeyEvent) {
    return _this__u8e3s4.d8v(new KeyInputElement(onKeyEvent, null));
  }
  function KeyInputElement(onKeyEvent, onPreKeyEvent) {
    ModifierNodeElement.call(this);
    this.g9u_1 = onKeyEvent;
    this.h9u_1 = onPreKeyEvent;
  }
  protoOf(KeyInputElement).r3d = function () {
    return new KeyInputNode(this.g9u_1, this.h9u_1);
  };
  protoOf(KeyInputElement).i9u = function (node) {
    node.x9u_1 = this.g9u_1;
    node.y9u_1 = this.h9u_1;
  };
  protoOf(KeyInputElement).d8y = function (node) {
    return this.i9u(node instanceof KeyInputNode ? node : THROW_CCE());
  };
  protoOf(KeyInputElement).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof KeyInputElement))
      return false;
    if (!(this.g9u_1 === other.g9u_1))
      return false;
    if (!(this.h9u_1 === other.h9u_1))
      return false;
    return true;
  };
  protoOf(KeyInputElement).hashCode = function () {
    var tmp0_safe_receiver = this.g9u_1;
    var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : hashCode(tmp0_safe_receiver);
    var result = tmp1_elvis_lhs == null ? 0 : tmp1_elvis_lhs;
    var tmp = imul(31, result);
    var tmp2_safe_receiver = this.h9u_1;
    var tmp3_elvis_lhs = tmp2_safe_receiver == null ? null : hashCode(tmp2_safe_receiver);
    result = tmp + (tmp3_elvis_lhs == null ? 0 : tmp3_elvis_lhs) | 0;
    return result;
  };
  function KeyInputNode(onEvent, onPreEvent) {
    Node.call(this);
    this.x9u_1 = onEvent;
    this.y9u_1 = onPreEvent;
  }
  protoOf(KeyInputNode).w9e = function (event) {
    var tmp0_safe_receiver = this.x9u_1;
    var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : tmp0_safe_receiver(new KeyEvent(event));
    return tmp1_elvis_lhs == null ? false : tmp1_elvis_lhs;
  };
  protoOf(KeyInputNode).v9e = function (event) {
    var tmp0_safe_receiver = this.y9u_1;
    var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : tmp0_safe_receiver(new KeyEvent(event));
    return tmp1_elvis_lhs == null ? false : tmp1_elvis_lhs;
  };
  function KeyInputModifierNode() {
  }
  function SoftKeyboardInterceptionModifierNode() {
  }
  var androidx_compose_ui_input_nestedscroll_NestedScrollDispatcher$stable;
  function NestedScrollConnection() {
  }
  function _NestedScrollSource___init__impl__igf50i(value) {
    return value;
  }
  function Companion_14() {
    Companion_instance_19 = this;
    this.d9v_1 = _NestedScrollSource___init__impl__igf50i(1);
    this.e9v_1 = _NestedScrollSource___init__impl__igf50i(2);
    this.f9v_1 = this.d9v_1;
    this.g9v_1 = this.e9v_1;
    this.h9v_1 = _NestedScrollSource___init__impl__igf50i(3);
    this.i9v_1 = this.d9v_1;
  }
  var Companion_instance_19;
  function Companion_getInstance_40() {
    if (Companion_instance_19 == null)
      new Companion_14();
    return Companion_instance_19;
  }
  function NestedScrollDispatcher$calculateNestedScrollScope$lambda(this$0) {
    return function () {
      return this$0.m9v_1;
    };
  }
  function $dispatchPreFlingCOROUTINE$(_this__u8e3s4, available, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.v9v_1 = _this__u8e3s4;
    this.w9v_1 = available;
  }
  protoOf($dispatchPreFlingCOROUTINE$).v9 = function () {
    var suspendResult = this.p9_1;
    $sm: do
      try {
        var tmp = this.n9_1;
        switch (tmp) {
          case 0:
            this.o9_1 = 4;
            var tmp0_safe_receiver = this.v9v_1.f9a();
            if (tmp0_safe_receiver == null) {
              this.x9v_1 = null;
              this.n9_1 = 3;
              continue $sm;
            } else {
              this.n9_1 = 1;
              suspendResult = tmp0_safe_receiver.b9v(this.w9v_1, this);
              if (suspendResult === get_COROUTINE_SUSPENDED()) {
                return suspendResult;
              }
              this.n9_1 = 2;
              continue $sm;
            }

          case 1:
            var unboxed = suspendResult.t5g_1;
            suspendResult = new Velocity(unboxed);
            this.n9_1 = 2;
            continue $sm;
          case 2:
            var tmp_0 = this;
            var tmp_1 = suspendResult;
            tmp_0.x9v_1 = tmp_1 == null ? null : tmp_1.t5g_1;
            this.n9_1 = 3;
            continue $sm;
          case 3:
            var tmp1_elvis_lhs = this.x9v_1;
            var tmp_2;
            var tmp_3 = tmp1_elvis_lhs;
            if ((tmp_3 == null ? null : new Velocity(tmp_3)) == null) {
              tmp_2 = Companion_getInstance_10().v5g_1;
            } else {
              tmp_2 = tmp1_elvis_lhs;
            }

            return new Velocity(tmp_2);
          case 4:
            throw this.q9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.o9_1 === 4) {
          throw e;
        } else {
          this.n9_1 = this.o9_1;
          this.q9_1 = e;
        }
      }
     while (true);
  };
  function $dispatchPostFlingCOROUTINE$(_this__u8e3s4, consumed, available, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.g9w_1 = _this__u8e3s4;
    this.h9w_1 = consumed;
    this.i9w_1 = available;
  }
  protoOf($dispatchPostFlingCOROUTINE$).v9 = function () {
    var suspendResult = this.p9_1;
    $sm: do
      try {
        var tmp = this.n9_1;
        switch (tmp) {
          case 0:
            this.o9_1 = 8;
            if (this.g9w_1.f9a() == null) {
              var tmp0_safe_receiver = this.g9w_1.k9v_1;
              if (tmp0_safe_receiver == null) {
                this.k9w_1 = null;
                this.n9_1 = 6;
                continue $sm;
              } else {
                this.n9_1 = 4;
                suspendResult = tmp0_safe_receiver.c9v(this.h9w_1, this.i9w_1, this);
                if (suspendResult === get_COROUTINE_SUSPENDED()) {
                  return suspendResult;
                }
                this.n9_1 = 5;
                continue $sm;
              }
            } else {
              var tmp2_safe_receiver = this.g9w_1.f9a();
              if (tmp2_safe_receiver == null) {
                this.l9w_1 = null;
                this.n9_1 = 3;
                continue $sm;
              } else {
                this.n9_1 = 1;
                suspendResult = tmp2_safe_receiver.c9v(this.h9w_1, this.i9w_1, this);
                if (suspendResult === get_COROUTINE_SUSPENDED()) {
                  return suspendResult;
                }
                this.n9_1 = 2;
                continue $sm;
              }
            }

          case 1:
            var unboxed = suspendResult.t5g_1;
            suspendResult = new Velocity(unboxed);
            this.n9_1 = 2;
            continue $sm;
          case 2:
            var tmp_0 = this;
            var tmp_1 = suspendResult;
            tmp_0.l9w_1 = tmp_1 == null ? null : tmp_1.t5g_1;
            this.n9_1 = 3;
            continue $sm;
          case 3:
            var tmp3_elvis_lhs = this.l9w_1;
            var tmp_2 = this;
            var tmp_3;
            var tmp_4 = tmp3_elvis_lhs;
            if ((tmp_4 == null ? null : new Velocity(tmp_4)) == null) {
              tmp_3 = Companion_getInstance_10().v5g_1;
            } else {
              tmp_3 = tmp3_elvis_lhs;
            }

            tmp_2.j9w_1 = tmp_3;
            this.n9_1 = 7;
            continue $sm;
          case 4:
            var unboxed_0 = suspendResult.t5g_1;
            suspendResult = new Velocity(unboxed_0);
            this.n9_1 = 5;
            continue $sm;
          case 5:
            var tmp_5 = this;
            var tmp_6 = suspendResult;
            tmp_5.k9w_1 = tmp_6 == null ? null : tmp_6.t5g_1;
            this.n9_1 = 6;
            continue $sm;
          case 6:
            var tmp1_elvis_lhs = this.k9w_1;
            var tmp_7 = this;
            var tmp_8;
            var tmp_9 = tmp1_elvis_lhs;
            if ((tmp_9 == null ? null : new Velocity(tmp_9)) == null) {
              tmp_8 = Companion_getInstance_10().v5g_1;
            } else {
              tmp_8 = tmp1_elvis_lhs;
            }

            tmp_7.j9w_1 = tmp_8;
            this.n9_1 = 7;
            continue $sm;
          case 7:
            return new Velocity(this.j9w_1);
          case 8:
            throw this.q9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.o9_1 === 8) {
          throw e;
        } else {
          this.n9_1 = this.o9_1;
          this.q9_1 = e;
        }
      }
     while (true);
  };
  function NestedScrollDispatcher() {
    this.j9v_1 = null;
    this.k9v_1 = null;
    var tmp = this;
    tmp.l9v_1 = NestedScrollDispatcher$calculateNestedScrollScope$lambda(this);
    this.m9v_1 = null;
  }
  protoOf(NestedScrollDispatcher).a8w = function () {
    var tmp0_elvis_lhs = this.l9v_1();
    var tmp;
    if (tmp0_elvis_lhs == null) {
      throw IllegalStateException_init_$Create$('in order to access nested coroutine scope you need to attach dispatcher to the `Modifier.nestedScroll` first.');
    } else {
      tmp = tmp0_elvis_lhs;
    }
    return tmp;
  };
  protoOf(NestedScrollDispatcher).f9a = function () {
    var tmp0_safe_receiver = this.j9v_1;
    return tmp0_safe_receiver == null ? null : tmp0_safe_receiver.e9x();
  };
  protoOf(NestedScrollDispatcher).f9x = function (available, source) {
    var tmp0_safe_receiver = this.f9a();
    var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.z9u(available, source);
    var tmp;
    var tmp_0 = tmp1_elvis_lhs;
    if ((tmp_0 == null ? null : new Offset(tmp_0)) == null) {
      tmp = Companion_getInstance().g5d_1;
    } else {
      tmp = tmp1_elvis_lhs;
    }
    return tmp;
  };
  protoOf(NestedScrollDispatcher).g9x = function (consumed, available, source) {
    var tmp0_safe_receiver = this.f9a();
    var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.a9v(consumed, available, source);
    var tmp;
    var tmp_0 = tmp1_elvis_lhs;
    if ((tmp_0 == null ? null : new Offset(tmp_0)) == null) {
      tmp = Companion_getInstance().g5d_1;
    } else {
      tmp = tmp1_elvis_lhs;
    }
    return tmp;
  };
  protoOf(NestedScrollDispatcher).h9x = function (available, $completion) {
    var tmp = new $dispatchPreFlingCOROUTINE$(this, available, $completion);
    tmp.p9_1 = Unit_instance;
    tmp.q9_1 = null;
    var tmp_0 = tmp.v9();
    if (tmp_0 === get_COROUTINE_SUSPENDED())
      return tmp_0;
    return tmp_0;
  };
  protoOf(NestedScrollDispatcher).i9x = function (consumed, available, $completion) {
    var tmp = new $dispatchPostFlingCOROUTINE$(this, consumed, available, $completion);
    tmp.p9_1 = Unit_instance;
    tmp.q9_1 = null;
    var tmp_0 = tmp.v9();
    if (tmp_0 === get_COROUTINE_SUSPENDED())
      return tmp_0;
    return tmp_0;
  };
  function nestedScroll(_this__u8e3s4, connection, dispatcher) {
    dispatcher = dispatcher === VOID ? null : dispatcher;
    return _this__u8e3s4.d8v(new NestedScrollElement(connection, dispatcher));
  }
  function NestedScrollElement(connection, dispatcher) {
    ModifierNodeElement.call(this);
    this.k9x_1 = connection;
    this.l9x_1 = dispatcher;
  }
  protoOf(NestedScrollElement).r3d = function () {
    return new NestedScrollNode(this.k9x_1, this.l9x_1);
  };
  protoOf(NestedScrollElement).m9x = function (node) {
    node.n9x(this.k9x_1, this.l9x_1);
  };
  protoOf(NestedScrollElement).d8y = function (node) {
    return this.m9x(node instanceof NestedScrollNode ? node : THROW_CCE());
  };
  protoOf(NestedScrollElement).hashCode = function () {
    var result = hashCode(this.k9x_1);
    var tmp = imul(31, result);
    // Inline function 'kotlin.hashCode' call
    var tmp0_safe_receiver = this.l9x_1;
    var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : hashCode(tmp0_safe_receiver);
    result = tmp + (tmp1_elvis_lhs == null ? 0 : tmp1_elvis_lhs) | 0;
    return result;
  };
  protoOf(NestedScrollElement).equals = function (other) {
    if (!(other instanceof NestedScrollElement))
      return false;
    if (!equals(other.k9x_1, this.k9x_1))
      return false;
    if (!equals(other.l9x_1, this.l9x_1))
      return false;
    return true;
  };
  var androidx_compose_ui_input_nestedscroll_NestedScrollNode$stable;
  function nestedScrollModifierNode(connection, dispatcher) {
    return new NestedScrollNode(connection, dispatcher);
  }
  function _get_parentConnection__qqqlcz($this) {
    return $this.z8v_1 ? $this.e9x() : null;
  }
  function _get_nestedCoroutineScope__9ygy9k($this) {
    var tmp0_safe_receiver = $this.e9x();
    var parentCoroutineScope = tmp0_safe_receiver == null ? null : _get_nestedCoroutineScope__9ygy9k(tmp0_safe_receiver);
    var tmp;
    if ((parentCoroutineScope == null ? null : get_isActive(parentCoroutineScope)) === true) {
      tmp = parentCoroutineScope;
    } else {
      var tmp2_elvis_lhs = $this.b9x_1.m9v_1;
      var tmp_0;
      if (tmp2_elvis_lhs == null) {
        throw IllegalStateException_init_$Create$('in order to access nested coroutine scope you need to attach dispatcher to the `Modifier.nestedScroll` first.');
      } else {
        tmp_0 = tmp2_elvis_lhs;
      }
      tmp = tmp_0;
    }
    return tmp;
  }
  function updateDispatcher($this, newDispatcher) {
    resetDispatcherFields($this);
    if (newDispatcher == null) {
      $this.b9x_1 = new NestedScrollDispatcher();
    } else if (!equals(newDispatcher, $this.b9x_1)) {
      $this.b9x_1 = newDispatcher;
    }
    if ($this.z8v_1) {
      updateDispatcherFields($this);
    }
  }
  function updateDispatcherFields($this) {
    $this.b9x_1.j9v_1 = $this;
    $this.b9x_1.k9v_1 = null;
    $this.c9x_1 = null;
    var tmp = $this.b9x_1;
    tmp.l9v_1 = NestedScrollNode$updateDispatcherFields$lambda($this);
    $this.b9x_1.m9v_1 = $this.a8w();
  }
  function resetDispatcherFields($this) {
    if ($this.b9x_1.j9v_1 === $this)
      $this.b9x_1.j9v_1 = null;
  }
  function NestedScrollNode$updateDispatcherFields$lambda(this$0) {
    return function () {
      return _get_nestedCoroutineScope__9ygy9k(this$0);
    };
  }
  function $onPreFlingCOROUTINE$(_this__u8e3s4, available, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.w9x_1 = _this__u8e3s4;
    this.x9x_1 = available;
  }
  protoOf($onPreFlingCOROUTINE$).v9 = function () {
    var suspendResult = this.p9_1;
    $sm: do
      try {
        var tmp = this.n9_1;
        switch (tmp) {
          case 0:
            this.o9_1 = 6;
            var tmp0_safe_receiver = _get_parentConnection__qqqlcz(this.w9x_1);
            if (tmp0_safe_receiver == null) {
              this.z9x_1 = null;
              this.n9_1 = 3;
              continue $sm;
            } else {
              this.n9_1 = 1;
              suspendResult = tmp0_safe_receiver.b9v(this.x9x_1, this);
              if (suspendResult === get_COROUTINE_SUSPENDED()) {
                return suspendResult;
              }
              this.n9_1 = 2;
              continue $sm;
            }

          case 1:
            var unboxed = suspendResult.t5g_1;
            suspendResult = new Velocity(unboxed);
            this.n9_1 = 2;
            continue $sm;
          case 2:
            var tmp_0 = this;
            var tmp_1 = suspendResult;
            tmp_0.z9x_1 = tmp_1 == null ? null : tmp_1.t5g_1;
            this.n9_1 = 3;
            continue $sm;
          case 3:
            var tmp1_elvis_lhs = this.z9x_1;
            var tmp_2 = this;
            var tmp_3;
            var tmp_4 = tmp1_elvis_lhs;
            if ((tmp_4 == null ? null : new Velocity(tmp_4)) == null) {
              tmp_3 = Companion_getInstance_10().v5g_1;
            } else {
              tmp_3 = tmp1_elvis_lhs;
            }

            tmp_2.y9x_1 = tmp_3;
            this.n9_1 = 4;
            suspendResult = this.w9x_1.a9x_1.b9v(Velocity__minus_impl_w0cg92(this.x9x_1, this.y9x_1), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            this.n9_1 = 5;
            continue $sm;
          case 4:
            var unboxed_0 = suspendResult.t5g_1;
            suspendResult = new Velocity(unboxed_0);
            this.n9_1 = 5;
            continue $sm;
          case 5:
            var selfPreConsumed = suspendResult.t5g_1;
            return new Velocity(Velocity__plus_impl_9g3s6u(this.y9x_1, selfPreConsumed));
          case 6:
            throw this.q9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.o9_1 === 6) {
          throw e;
        } else {
          this.n9_1 = this.o9_1;
          this.q9_1 = e;
        }
      }
     while (true);
  };
  function $onPostFlingCOROUTINE$(_this__u8e3s4, consumed, available, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.i9y_1 = _this__u8e3s4;
    this.j9y_1 = consumed;
    this.k9y_1 = available;
  }
  protoOf($onPostFlingCOROUTINE$).v9 = function () {
    var suspendResult = this.p9_1;
    $sm: do
      try {
        var tmp = this.n9_1;
        switch (tmp) {
          case 0:
            this.o9_1 = 6;
            this.n9_1 = 1;
            suspendResult = this.i9y_1.a9x_1.c9v(this.j9y_1, this.k9y_1, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            this.n9_1 = 2;
            continue $sm;
          case 1:
            var unboxed = suspendResult.t5g_1;
            suspendResult = new Velocity(unboxed);
            this.n9_1 = 2;
            continue $sm;
          case 2:
            this.l9y_1 = suspendResult.t5g_1;
            var parent = this.i9y_1.z8v_1 ? _get_parentConnection__qqqlcz(this.i9y_1) : this.i9y_1.c9x_1;
            if (parent == null) {
              this.m9y_1 = null;
              this.n9_1 = 5;
              continue $sm;
            } else {
              this.n9_1 = 3;
              suspendResult = parent.c9v(Velocity__plus_impl_9g3s6u(this.j9y_1, this.l9y_1), Velocity__minus_impl_w0cg92(this.k9y_1, this.l9y_1), this);
              if (suspendResult === get_COROUTINE_SUSPENDED()) {
                return suspendResult;
              }
              this.n9_1 = 4;
              continue $sm;
            }

          case 3:
            var unboxed_0 = suspendResult.t5g_1;
            suspendResult = new Velocity(unboxed_0);
            this.n9_1 = 4;
            continue $sm;
          case 4:
            var tmp_0 = this;
            var tmp_1 = suspendResult;
            tmp_0.m9y_1 = tmp_1 == null ? null : tmp_1.t5g_1;
            this.n9_1 = 5;
            continue $sm;
          case 5:
            var tmp1_elvis_lhs = this.m9y_1;
            var tmp_2;
            var tmp_3 = tmp1_elvis_lhs;
            if ((tmp_3 == null ? null : new Velocity(tmp_3)) == null) {
              tmp_2 = Companion_getInstance_10().v5g_1;
            } else {
              tmp_2 = tmp1_elvis_lhs;
            }

            var parentConsumed = tmp_2;
            return new Velocity(Velocity__plus_impl_9g3s6u(this.l9y_1, parentConsumed));
          case 6:
            throw this.q9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.o9_1 === 6) {
          throw e;
        } else {
          this.n9_1 = this.o9_1;
          this.q9_1 = e;
        }
      }
     while (true);
  };
  function NestedScrollNode(connection, dispatcher) {
    Node.call(this);
    this.a9x_1 = connection;
    var tmp = this;
    tmp.b9x_1 = dispatcher == null ? new NestedScrollDispatcher() : dispatcher;
    this.c9x_1 = null;
    this.d9x_1 = 'androidx.compose.ui.input.nestedscroll.NestedScrollNode';
  }
  protoOf(NestedScrollNode).e9x = function () {
    return this.z8v_1 ? findNearestAncestor_0(this) : null;
  };
  protoOf(NestedScrollNode).t91 = function () {
    return this.d9x_1;
  };
  protoOf(NestedScrollNode).z9u = function (available, source) {
    var tmp0_safe_receiver = _get_parentConnection__qqqlcz(this);
    var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.z9u(available, source);
    var tmp;
    var tmp_0 = tmp1_elvis_lhs;
    if ((tmp_0 == null ? null : new Offset(tmp_0)) == null) {
      tmp = Companion_getInstance().g5d_1;
    } else {
      tmp = tmp1_elvis_lhs;
    }
    var parentPreConsumed = tmp;
    var selfPreConsumed = this.a9x_1.z9u(Offset__minus_impl_hoj2c0(available, parentPreConsumed), source);
    return Offset__plus_impl_c78cg0(parentPreConsumed, selfPreConsumed);
  };
  protoOf(NestedScrollNode).a9v = function (consumed, available, source) {
    var selfConsumed = this.a9x_1.a9v(consumed, available, source);
    var tmp0_safe_receiver = _get_parentConnection__qqqlcz(this);
    var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.a9v(Offset__plus_impl_c78cg0(consumed, selfConsumed), Offset__minus_impl_hoj2c0(available, selfConsumed), source);
    var tmp;
    var tmp_0 = tmp1_elvis_lhs;
    if ((tmp_0 == null ? null : new Offset(tmp_0)) == null) {
      tmp = Companion_getInstance().g5d_1;
    } else {
      tmp = tmp1_elvis_lhs;
    }
    var parentConsumed = tmp;
    return Offset__plus_impl_c78cg0(selfConsumed, parentConsumed);
  };
  protoOf(NestedScrollNode).b9v = function (available, $completion) {
    var tmp = new $onPreFlingCOROUTINE$(this, available, $completion);
    tmp.p9_1 = Unit_instance;
    tmp.q9_1 = null;
    var tmp_0 = tmp.v9();
    if (tmp_0 === get_COROUTINE_SUSPENDED())
      return tmp_0;
    return tmp_0;
  };
  protoOf(NestedScrollNode).c9v = function (consumed, available, $completion) {
    var tmp = new $onPostFlingCOROUTINE$(this, consumed, available, $completion);
    tmp.p9_1 = Unit_instance;
    tmp.q9_1 = null;
    var tmp_0 = tmp.v9();
    if (tmp_0 === get_COROUTINE_SUSPENDED())
      return tmp_0;
    return tmp_0;
  };
  protoOf(NestedScrollNode).f8w = function () {
    updateDispatcherFields(this);
  };
  protoOf(NestedScrollNode).h8w = function () {
    this.c9x_1 = findNearestAttachedAncestor(this);
    this.b9x_1.k9v_1 = this.c9x_1;
    resetDispatcherFields(this);
  };
  protoOf(NestedScrollNode).n9x = function (connection, dispatcher) {
    this.a9x_1 = connection;
    updateDispatcher(this, dispatcher);
  };
  function findNearestAttachedAncestor(_this__u8e3s4) {
    var node = {_v: null};
    traverseAncestors_0(_this__u8e3s4, findNearestAttachedAncestor$lambda(node));
    return node._v;
  }
  function findNearestAttachedAncestor$lambda($node) {
    return function (it) {
      var tmp;
      if (it.f4n().z8v_1) {
        $node._v = it;
        tmp = false;
      } else {
        tmp = true;
      }
      return tmp;
    };
  }
  var androidx_compose_ui_input_pointer_HitPathTracker$stable;
  var androidx_compose_ui_input_pointer_NodeParent$stable;
  var androidx_compose_ui_input_pointer_Node$stable;
  function removePointerInputModifierNode($this, pointerInputNode) {
    if ($this.o9y_1) {
      $this.r9y_1 = true;
      $this.s9y_1.j1(pointerInputNode);
      return Unit_instance;
    }
    $this.t9y_1.x9y(pointerInputNode);
  }
  function removeInvalidPointerIdsAndChanges($this, pointerId, hitNodes) {
    $this.t9y_1.y9y(pointerId, hitNodes);
  }
  function HitPathTracker$addHitPath$lambda(this$0, $pointerInputNode) {
    return function () {
      removePointerInputModifierNode(this$0, $pointerInputNode);
      return Unit_instance;
    };
  }
  function HitPathTracker(rootCoordinates) {
    this.n9y_1 = rootCoordinates;
    this.o9y_1 = false;
    this.p9y_1 = false;
    this.q9y_1 = false;
    this.r9y_1 = false;
    this.s9y_1 = new MutableObjectList();
    this.t9y_1 = new NodeParent();
    this.u9y_1 = new MutableLongObjectMap(10);
  }
  protoOf(HitPathTracker).z9y = function (pointerId, pointerInputNodes, prunePointerIdsAndChangesNotInNodesList) {
    var parent = this.t9y_1;
    var merging = true;
    var inductionVariable = 0;
    var last = pointerInputNodes.n1() - 1 | 0;
    if (inductionVariable <= last)
      eachPin: do {
        var i = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var pointerInputNode = pointerInputNodes.l1(i);
        if (pointerInputNode.z8v_1) {
          var tmp = pointerInputNode;
          tmp.y8v_1 = HitPathTracker$addHitPath$lambda(this, pointerInputNode);
          if (merging) {
            var tmp0 = parent.v9y_1;
            var tmp$ret$0;
            $l$block: {
              // Inline function 'androidx.compose.runtime.collection.MutableVector.firstOrNull' call
              var tmp_0 = tmp0.b3e_1;
              var content = isArray(tmp_0) ? tmp_0 : THROW_CCE();
              var size = tmp0.d3e_1;
              var inductionVariable_0 = 0;
              if (inductionVariable_0 < size)
                do {
                  var i_0 = inductionVariable_0;
                  inductionVariable_0 = inductionVariable_0 + 1 | 0;
                  var item = content[i_0];
                  if (equals(item.c9z_1, pointerInputNode)) {
                    tmp$ret$0 = item;
                    break $l$block;
                  }
                }
                 while (inductionVariable_0 < size);
              tmp$ret$0 = null;
            }
            var node = tmp$ret$0;
            if (!(node == null)) {
              node.j9z();
              // Inline function 'androidx.compose.ui.input.pointer.util.PointerIdArray.add' call
              node.d9z_1.uw(_PointerId___get_value__impl__odqw2d(pointerId));
              if (prunePointerIdsAndChangesNotInNodesList) {
                var tmp0_0 = this.u9y_1;
                // Inline function 'androidx.collection.MutableLongObjectMap.getOrPut' call
                var key = _PointerId___get_value__impl__odqw2d(pointerId);
                var tmp0_elvis_lhs = tmp0_0.lx(key);
                var tmp_1;
                if (tmp0_elvis_lhs == null) {
                  // Inline function 'androidx.collection.mutableObjectListOf' call
                  // Inline function 'kotlin.also' call
                  var this_0 = new MutableObjectList();
                  tmp0_0.jx(key, this_0);
                  tmp_1 = this_0;
                } else {
                  tmp_1 = tmp0_elvis_lhs;
                }
                var mutableObjectList = tmp_1;
                mutableObjectList.j1(node);
              }
              parent = node;
              continue eachPin;
            } else {
              merging = false;
            }
          }
          // Inline function 'kotlin.apply' call
          var this_1 = new Node_0(pointerInputNode);
          // Inline function 'androidx.compose.ui.input.pointer.util.PointerIdArray.add' call
          this_1.d9z_1.uw(_PointerId___get_value__impl__odqw2d(pointerId));
          var node_0 = this_1;
          if (prunePointerIdsAndChangesNotInNodesList) {
            var tmp0_1 = this.u9y_1;
            // Inline function 'androidx.collection.MutableLongObjectMap.getOrPut' call
            var key_0 = _PointerId___get_value__impl__odqw2d(pointerId);
            var tmp0_elvis_lhs_0 = tmp0_1.lx(key_0);
            var tmp_2;
            if (tmp0_elvis_lhs_0 == null) {
              // Inline function 'androidx.collection.mutableObjectListOf' call
              // Inline function 'kotlin.also' call
              var this_2 = new MutableObjectList();
              tmp0_1.jx(key_0, this_2);
              tmp_2 = this_2;
            } else {
              tmp_2 = tmp0_elvis_lhs_0;
            }
            var mutableObjectList_0 = tmp_2;
            mutableObjectList_0.j1(node_0);
          }
          parent.v9y_1.zz(node_0);
          parent = node_0;
        }
      }
       while (inductionVariable <= last);
    if (prunePointerIdsAndChangesNotInNodesList) {
      // Inline function 'androidx.collection.LongObjectMap.forEach' call
      var this_3 = this.u9y_1;
      var k = this_3.zw_1;
      var v = this_3.ax_1;
      $l$block_0: {
        // Inline function 'androidx.collection.LongObjectMap.forEachIndexed' call
        var m = this_3.yw_1;
        var lastIndex = m.length - 2 | 0;
        var inductionVariable_1 = 0;
        if (inductionVariable_1 <= lastIndex)
          do {
            var i_1 = inductionVariable_1;
            inductionVariable_1 = inductionVariable_1 + 1 | 0;
            var slot = m[i_1];
            // Inline function 'androidx.collection.maskEmptyOrDeleted' call
            var this_4 = slot;
            var tmp$ret$18 = bitwiseAnd(bitwiseAnd(this_4, shiftLeft(invert(this_4), 7)), new Long(-2139062144, -2139062144));
            if (!equalsLong(tmp$ret$18, new Long(-2139062144, -2139062144))) {
              var bitCount = 8 - (~(i_1 - lastIndex | 0) >>> 31 | 0) | 0;
              var inductionVariable_2 = 0;
              if (inductionVariable_2 < bitCount)
                do {
                  var j = inductionVariable_2;
                  inductionVariable_2 = inductionVariable_2 + 1 | 0;
                  // Inline function 'androidx.collection.isFull' call
                  var value = bitwiseAnd(slot, new Long(255, 0));
                  if (compare(value, new Long(128, 0)) < 0) {
                    var index = (i_1 << 3) + j | 0;
                    var tmp0_2 = k[index];
                    var value_0 = v[index];
                    removeInvalidPointerIdsAndChanges(this, tmp0_2, value_0);
                  }
                  slot = shiftRight(slot, 8);
                }
                 while (inductionVariable_2 < bitCount);
              if (!(bitCount === 8)) {
                break $l$block_0;
              }
            }
          }
           while (!(i_1 === lastIndex));
      }
    }
    this.u9y_1.c3();
  };
  protoOf(HitPathTracker).m9z = function (internalPointerEvent, isInBounds) {
    var changed = this.t9y_1.u9z(internalPointerEvent.o9z_1, this.n9y_1, internalPointerEvent, isInBounds);
    if (!changed) {
      this.t9y_1.v9z();
      return false;
    }
    this.o9y_1 = true;
    var dispatchHit = this.t9y_1.w9z(internalPointerEvent.o9z_1, this.n9y_1, internalPointerEvent, isInBounds);
    dispatchHit = this.t9y_1.x9z(internalPointerEvent) || dispatchHit;
    this.o9y_1 = false;
    if (this.r9y_1) {
      this.r9y_1 = false;
      var inductionVariable = 0;
      var last = this.s9y_1.n1();
      if (inductionVariable < last)
        do {
          var i = inductionVariable;
          inductionVariable = inductionVariable + 1 | 0;
          removePointerInputModifierNode(this, this.s9y_1.l1(i));
        }
         while (inductionVariable < last);
      this.s9y_1.c3();
    }
    if (this.p9y_1) {
      this.p9y_1 = false;
      this.y9z();
    }
    if (this.q9y_1) {
      this.q9y_1 = false;
      this.z9z();
    }
    return dispatchHit;
  };
  protoOf(HitPathTracker).z9z = function () {
    if (this.q9y_1) {
      this.q9y_1 = true;
      return Unit_instance;
    }
    this.t9y_1.c3();
  };
  protoOf(HitPathTracker).y9z = function () {
    if (this.o9y_1) {
      this.p9y_1 = true;
      return Unit_instance;
    }
    this.t9y_1.aa0();
    this.z9z();
  };
  function NodeParent() {
    var tmp = this;
    // Inline function 'androidx.compose.runtime.collection.mutableVectorOf' call
    // Inline function 'androidx.compose.runtime.collection.MutableVector' call
    // Inline function 'kotlin.arrayOfNulls' call
    var tmp$ret$2 = Array(16);
    tmp.v9y_1 = new MutableVector(tmp$ret$2, 0);
    this.w9y_1 = new MutableObjectList(10);
  }
  protoOf(NodeParent).u9z = function (changes, parentCoordinates, internalPointerEvent, isInBounds) {
    var changed = false;
    // Inline function 'androidx.compose.runtime.collection.MutableVector.forEach' call
    var this_0 = this.v9y_1;
    var i = 0;
    var tmp = this_0.b3e_1;
    var content = isArray(tmp) ? tmp : THROW_CCE();
    var size = this_0.d3e_1;
    while (i < size) {
      changed = content[i].u9z(changes, parentCoordinates, internalPointerEvent, isInBounds) || changed;
      i = i + 1 | 0;
    }
    return changed;
  };
  protoOf(NodeParent).w9z = function (changes, parentCoordinates, internalPointerEvent, isInBounds) {
    var dispatched = false;
    // Inline function 'androidx.compose.runtime.collection.MutableVector.forEach' call
    var this_0 = this.v9y_1;
    var i = 0;
    var tmp = this_0.b3e_1;
    var content = isArray(tmp) ? tmp : THROW_CCE();
    var size = this_0.d3e_1;
    while (i < size) {
      dispatched = content[i].w9z(changes, parentCoordinates, internalPointerEvent, isInBounds) || dispatched;
      i = i + 1 | 0;
    }
    return dispatched;
  };
  protoOf(NodeParent).x9z = function (internalPointerEvent) {
    var dispatched = false;
    // Inline function 'androidx.compose.runtime.collection.MutableVector.forEach' call
    var this_0 = this.v9y_1;
    var i = 0;
    var tmp = this_0.b3e_1;
    var content = isArray(tmp) ? tmp : THROW_CCE();
    var size = this_0.d3e_1;
    while (i < size) {
      dispatched = content[i].x9z(internalPointerEvent) || dispatched;
      i = i + 1 | 0;
    }
    this.ba0(internalPointerEvent);
    this.v9z();
    return dispatched;
  };
  protoOf(NodeParent).aa0 = function () {
    // Inline function 'androidx.compose.runtime.collection.MutableVector.forEach' call
    var this_0 = this.v9y_1;
    var i = 0;
    var tmp = this_0.b3e_1;
    var content = isArray(tmp) ? tmp : THROW_CCE();
    var size = this_0.d3e_1;
    while (i < size) {
      content[i].aa0();
      i = i + 1 | 0;
    }
  };
  protoOf(NodeParent).x9y = function (pointerInputModifierNode) {
    this.w9y_1.c3();
    this.w9y_1.j1(this);
    while (this.w9y_1.fv()) {
      var parent = this.w9y_1.h3(this.w9y_1.n1() - 1 | 0);
      var index = 0;
      while (index < parent.v9y_1.d3e_1) {
        var tmp0 = parent.v9y_1;
        // Inline function 'androidx.compose.runtime.collection.MutableVector.get' call
        var index_0 = index;
        var child = tmp0.b3e_1[index_0];
        if (equals(child.c9z_1, pointerInputModifierNode)) {
          parent.v9y_1.g10(child);
          child.aa0();
        } else {
          this.w9y_1.j1(child);
          index = index + 1 | 0;
        }
      }
    }
  };
  protoOf(NodeParent).c3 = function () {
    this.v9y_1.c3();
  };
  protoOf(NodeParent).y9y = function (pointerIdValue, hitNodes) {
    // Inline function 'androidx.compose.runtime.collection.MutableVector.forEach' call
    var this_0 = this.v9y_1;
    var i = 0;
    var tmp = this_0.b3e_1;
    var content = isArray(tmp) ? tmp : THROW_CCE();
    var size = this_0.d3e_1;
    while (i < size) {
      content[i].y9y(pointerIdValue, hitNodes);
      i = i + 1 | 0;
    }
  };
  protoOf(NodeParent).ba0 = function (internalPointerEvent) {
    // Inline function 'androidx.compose.runtime.collection.MutableVector.lastIndex' call
    var inductionVariable = this.v9y_1.d3e_1 - 1 | 0;
    if (0 <= inductionVariable)
      do {
        var i = inductionVariable;
        inductionVariable = inductionVariable + -1 | 0;
        // Inline function 'androidx.compose.runtime.collection.MutableVector.get' call
        var child = this.v9y_1.b3e_1[i];
        if (child.d9z_1.r()) {
          this.v9y_1.h3(i);
        }
      }
       while (0 <= inductionVariable);
  };
  protoOf(NodeParent).v9z = function () {
    // Inline function 'androidx.compose.runtime.collection.MutableVector.forEach' call
    var this_0 = this.v9y_1;
    var i = 0;
    var tmp = this_0.b3e_1;
    var content = isArray(tmp) ? tmp : THROW_CCE();
    var size = this_0.d3e_1;
    while (i < size) {
      content[i].v9z();
      i = i + 1 | 0;
    }
  };
  function hasPositionChanged($this, oldEvent, newEvent) {
    if (oldEvent == null || !(oldEvent.ca0_1.n1() === newEvent.ca0_1.n1())) {
      return true;
    }
    var inductionVariable = 0;
    var last = newEvent.ca0_1.n1();
    if (inductionVariable < last)
      do {
        var i = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var old = oldEvent.ca0_1.l1(i);
        var current = newEvent.ca0_1.l1(i);
        if (!equals(old.ka0_1, current.ka0_1)) {
          return true;
        }
      }
       while (inductionVariable < last);
    return false;
  }
  function clearCache($this) {
    $this.g9z_1.c3();
    $this.h9z_1 = null;
  }
  function Node_0(modifierNode) {
    NodeParent.call(this);
    this.c9z_1 = modifierNode;
    this.d9z_1 = new PointerIdArray();
    this.e9z_1 = true;
    this.f9z_1 = false;
    this.g9z_1 = new LongSparseArray(2);
    this.h9z_1 = null;
    this.i9z_1 = null;
  }
  protoOf(Node_0).y9y = function (pointerIdValue, hitNodes) {
    if (this.d9z_1.lm(pointerIdValue)) {
      if (!hitNodes.m1(this)) {
        this.d9z_1.kx(pointerIdValue);
        this.g9z_1.y18(pointerIdValue);
      }
    }
    // Inline function 'androidx.compose.runtime.collection.MutableVector.forEach' call
    var this_0 = this.v9y_1;
    var i = 0;
    var tmp = this_0.b3e_1;
    var content = isArray(tmp) ? tmp : THROW_CCE();
    var size = this_0.d3e_1;
    while (i < size) {
      content[i].y9y(pointerIdValue, hitNodes);
      i = i + 1 | 0;
    }
  };
  protoOf(Node_0).w9z = function (changes, parentCoordinates, internalPointerEvent, isInBounds) {
    var tmp$ret$0;
    $l$block_1: {
      // Inline function 'androidx.compose.ui.input.pointer.Node.dispatchIfNeeded' call
      if (this.g9z_1.r()) {
        tmp$ret$0 = false;
        break $l$block_1;
      }
      if (!this.c9z_1.z8v_1) {
        tmp$ret$0 = false;
        break $l$block_1;
      }
      var tmp0_safe_receiver = this.c9z_1.t8v_1;
      var tmp1_safe_receiver = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.a9i();
      var tmp2_elvis_lhs = tmp1_safe_receiver == null ? null : tmp1_safe_receiver.b9i();
      var isPlaced = tmp2_elvis_lhs == null ? false : tmp2_elvis_lhs;
      if (!isPlaced) {
        tmp$ret$0 = false;
        break $l$block_1;
      }
      var event = ensureNotNull(this.i9z_1);
      var size = ensureNotNull(this.h9z_1).q95();
      var tmp0 = this.c9z_1;
      // Inline function 'androidx.compose.ui.node.Nodes.PointerInput' call
      // Inline function 'androidx.compose.ui.node.dispatchForKind' call
      // Inline function 'androidx.compose.ui.node.dispatchForKind' call
      var kind = _NodeKind___init__impl__ojsprp(16);
      var stack = null;
      var node = tmp0;
      $l$loop: while (!(node == null)) {
        var tmp;
        if (isInterface(node, PointerInputModifierNode)) {
          node.aa1(event, PointerEventPass_Initial_getInstance(), size);
          tmp = false;
        } else {
          tmp = true;
        }
        var dispatchAgain = tmp;
        var tmp_0;
        var tmp_1;
        if (dispatchAgain || false) {
          // Inline function 'androidx.compose.ui.Node.isKind' call
          tmp_1 = !((node.o8v_1 & _NodeKind___get_mask__impl__1uopb6(kind)) === 0);
        } else {
          tmp_1 = false;
        }
        if (tmp_1) {
          tmp_0 = node instanceof DelegatingNode;
        } else {
          tmp_0 = false;
        }
        if (tmp_0) {
          var count = 0;
          // Inline function 'androidx.compose.ui.node.DelegatingNode.forEachImmediateDelegate' call
          var node_0 = node.e9a_1;
          while (!(node_0 == null)) {
            var next = node_0;
            // Inline function 'androidx.compose.ui.Node.isKind' call
            if (!((next.o8v_1 & _NodeKind___get_mask__impl__1uopb6(kind)) === 0)) {
              count = count + 1 | 0;
              if (count === 1) {
                node = next;
              } else {
                var tmp0_elvis_lhs = stack;
                var tmp_2;
                if (tmp0_elvis_lhs == null) {
                  // Inline function 'androidx.compose.runtime.collection.mutableVectorOf' call
                  // Inline function 'androidx.compose.runtime.collection.MutableVector' call
                  // Inline function 'kotlin.arrayOfNulls' call
                  var tmp$ret$12 = Array(16);
                  tmp_2 = new MutableVector(tmp$ret$12, 0);
                } else {
                  tmp_2 = tmp0_elvis_lhs;
                }
                stack = tmp_2;
                var theNode = node;
                if (!(theNode == null)) {
                  var tmp1_safe_receiver_0 = stack;
                  if (tmp1_safe_receiver_0 == null)
                    null;
                  else
                    tmp1_safe_receiver_0.zz(theNode);
                  node = null;
                }
                var tmp2_safe_receiver = stack;
                if (tmp2_safe_receiver == null)
                  null;
                else
                  tmp2_safe_receiver.zz(next);
              }
            }
            node_0 = node_0.r8v_1;
          }
          if (count === 1) {
            continue $l$loop;
          }
        }
        node = access$pop$tDelegatableNodeKt(stack);
      }
      if (this.c9z_1.z8v_1) {
        // Inline function 'androidx.compose.runtime.collection.MutableVector.forEach' call
        var this_0 = this.v9y_1;
        var i = 0;
        var tmp_3 = this_0.b3e_1;
        var content = isArray(tmp_3) ? tmp_3 : THROW_CCE();
        var size_0 = this_0.d3e_1;
        while (i < size_0) {
          content[i].w9z(this.g9z_1, ensureNotNull(this.h9z_1), internalPointerEvent, isInBounds);
          i = i + 1 | 0;
        }
      }
      if (this.c9z_1.z8v_1) {
        var tmp0_0 = this.c9z_1;
        // Inline function 'androidx.compose.ui.node.Nodes.PointerInput' call
        // Inline function 'androidx.compose.ui.node.dispatchForKind' call
        // Inline function 'androidx.compose.ui.node.dispatchForKind' call
        var kind_0 = _NodeKind___init__impl__ojsprp(16);
        var stack_0 = null;
        var node_1 = tmp0_0;
        $l$loop_0: while (!(node_1 == null)) {
          var tmp_4;
          if (isInterface(node_1, PointerInputModifierNode)) {
            node_1.aa1(event, PointerEventPass_Main_getInstance(), size);
            tmp_4 = false;
          } else {
            tmp_4 = true;
          }
          var dispatchAgain_0 = tmp_4;
          var tmp_5;
          var tmp_6;
          if (dispatchAgain_0 || false) {
            // Inline function 'androidx.compose.ui.Node.isKind' call
            tmp_6 = !((node_1.o8v_1 & _NodeKind___get_mask__impl__1uopb6(kind_0)) === 0);
          } else {
            tmp_6 = false;
          }
          if (tmp_6) {
            tmp_5 = node_1 instanceof DelegatingNode;
          } else {
            tmp_5 = false;
          }
          if (tmp_5) {
            var count_0 = 0;
            // Inline function 'androidx.compose.ui.node.DelegatingNode.forEachImmediateDelegate' call
            var node_2 = node_1.e9a_1;
            while (!(node_2 == null)) {
              var next_0 = node_2;
              // Inline function 'androidx.compose.ui.Node.isKind' call
              if (!((next_0.o8v_1 & _NodeKind___get_mask__impl__1uopb6(kind_0)) === 0)) {
                count_0 = count_0 + 1 | 0;
                if (count_0 === 1) {
                  node_1 = next_0;
                } else {
                  var tmp0_elvis_lhs_0 = stack_0;
                  var tmp_7;
                  if (tmp0_elvis_lhs_0 == null) {
                    // Inline function 'androidx.compose.runtime.collection.mutableVectorOf' call
                    // Inline function 'androidx.compose.runtime.collection.MutableVector' call
                    // Inline function 'kotlin.arrayOfNulls' call
                    var tmp$ret$25 = Array(16);
                    tmp_7 = new MutableVector(tmp$ret$25, 0);
                  } else {
                    tmp_7 = tmp0_elvis_lhs_0;
                  }
                  stack_0 = tmp_7;
                  var theNode_0 = node_1;
                  if (!(theNode_0 == null)) {
                    var tmp1_safe_receiver_1 = stack_0;
                    if (tmp1_safe_receiver_1 == null)
                      null;
                    else
                      tmp1_safe_receiver_1.zz(theNode_0);
                    node_1 = null;
                  }
                  var tmp2_safe_receiver_0 = stack_0;
                  if (tmp2_safe_receiver_0 == null)
                    null;
                  else
                    tmp2_safe_receiver_0.zz(next_0);
                }
              }
              node_2 = node_2.r8v_1;
            }
            if (count_0 === 1) {
              continue $l$loop_0;
            }
          }
          node_1 = access$pop$tDelegatableNodeKt(stack_0);
        }
      }
      tmp$ret$0 = true;
    }
    return tmp$ret$0;
  };
  protoOf(Node_0).x9z = function (internalPointerEvent) {
    var tmp$ret$0;
    $l$block_1: {
      // Inline function 'androidx.compose.ui.input.pointer.Node.dispatchIfNeeded' call
      if (this.g9z_1.r()) {
        tmp$ret$0 = false;
        break $l$block_1;
      }
      if (!this.c9z_1.z8v_1) {
        tmp$ret$0 = false;
        break $l$block_1;
      }
      var tmp0_safe_receiver = this.c9z_1.t8v_1;
      var tmp1_safe_receiver = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.a9i();
      var tmp2_elvis_lhs = tmp1_safe_receiver == null ? null : tmp1_safe_receiver.b9i();
      var isPlaced = tmp2_elvis_lhs == null ? false : tmp2_elvis_lhs;
      if (!isPlaced) {
        tmp$ret$0 = false;
        break $l$block_1;
      }
      var event = ensureNotNull(this.i9z_1);
      var size = ensureNotNull(this.h9z_1).q95();
      var tmp0 = this.c9z_1;
      // Inline function 'androidx.compose.ui.node.Nodes.PointerInput' call
      // Inline function 'androidx.compose.ui.node.dispatchForKind' call
      // Inline function 'androidx.compose.ui.node.dispatchForKind' call
      var kind = _NodeKind___init__impl__ojsprp(16);
      var stack = null;
      var node = tmp0;
      $l$loop: while (!(node == null)) {
        var tmp;
        if (isInterface(node, PointerInputModifierNode)) {
          node.aa1(event, PointerEventPass_Final_getInstance(), size);
          tmp = false;
        } else {
          tmp = true;
        }
        var dispatchAgain = tmp;
        var tmp_0;
        var tmp_1;
        if (dispatchAgain || false) {
          // Inline function 'androidx.compose.ui.Node.isKind' call
          tmp_1 = !((node.o8v_1 & _NodeKind___get_mask__impl__1uopb6(kind)) === 0);
        } else {
          tmp_1 = false;
        }
        if (tmp_1) {
          tmp_0 = node instanceof DelegatingNode;
        } else {
          tmp_0 = false;
        }
        if (tmp_0) {
          var count = 0;
          // Inline function 'androidx.compose.ui.node.DelegatingNode.forEachImmediateDelegate' call
          var node_0 = node.e9a_1;
          while (!(node_0 == null)) {
            var next = node_0;
            // Inline function 'androidx.compose.ui.Node.isKind' call
            if (!((next.o8v_1 & _NodeKind___get_mask__impl__1uopb6(kind)) === 0)) {
              count = count + 1 | 0;
              if (count === 1) {
                node = next;
              } else {
                var tmp0_elvis_lhs = stack;
                var tmp_2;
                if (tmp0_elvis_lhs == null) {
                  // Inline function 'androidx.compose.runtime.collection.mutableVectorOf' call
                  // Inline function 'androidx.compose.runtime.collection.MutableVector' call
                  // Inline function 'kotlin.arrayOfNulls' call
                  var tmp$ret$12 = Array(16);
                  tmp_2 = new MutableVector(tmp$ret$12, 0);
                } else {
                  tmp_2 = tmp0_elvis_lhs;
                }
                stack = tmp_2;
                var theNode = node;
                if (!(theNode == null)) {
                  var tmp1_safe_receiver_0 = stack;
                  if (tmp1_safe_receiver_0 == null)
                    null;
                  else
                    tmp1_safe_receiver_0.zz(theNode);
                  node = null;
                }
                var tmp2_safe_receiver = stack;
                if (tmp2_safe_receiver == null)
                  null;
                else
                  tmp2_safe_receiver.zz(next);
              }
            }
            node_0 = node_0.r8v_1;
          }
          if (count === 1) {
            continue $l$loop;
          }
        }
        node = access$pop$tDelegatableNodeKt(stack);
      }
      if (this.c9z_1.z8v_1) {
        // Inline function 'androidx.compose.runtime.collection.MutableVector.forEach' call
        var this_0 = this.v9y_1;
        var i = 0;
        var tmp_3 = this_0.b3e_1;
        var content = isArray(tmp_3) ? tmp_3 : THROW_CCE();
        var size_0 = this_0.d3e_1;
        while (i < size_0) {
          content[i].x9z(internalPointerEvent);
          i = i + 1 | 0;
        }
      }
      tmp$ret$0 = true;
    }
    var result = tmp$ret$0;
    this.ba0(internalPointerEvent);
    clearCache(this);
    return result;
  };
  protoOf(Node_0).u9z = function (changes, parentCoordinates, internalPointerEvent, isInBounds) {
    var childChanged = protoOf(NodeParent).u9z.call(this, changes, parentCoordinates, internalPointerEvent, isInBounds);
    if (!this.c9z_1.z8v_1)
      return true;
    var tmp0 = this.c9z_1;
    // Inline function 'androidx.compose.ui.node.Nodes.PointerInput' call
    // Inline function 'androidx.compose.ui.node.dispatchForKind' call
    // Inline function 'androidx.compose.ui.node.dispatchForKind' call
    var kind = _NodeKind___init__impl__ojsprp(16);
    var stack = null;
    var node = tmp0;
    $l$loop: while (!(node == null)) {
      var tmp;
      if (isInterface(node, PointerInputModifierNode)) {
        var it = node;
        this.h9z_1 = get_layoutCoordinates(it);
        tmp = false;
      } else {
        tmp = true;
      }
      var dispatchAgain = tmp;
      var tmp_0;
      var tmp_1;
      if (dispatchAgain || false) {
        // Inline function 'androidx.compose.ui.Node.isKind' call
        tmp_1 = !((node.o8v_1 & _NodeKind___get_mask__impl__1uopb6(kind)) === 0);
      } else {
        tmp_1 = false;
      }
      if (tmp_1) {
        tmp_0 = node instanceof DelegatingNode;
      } else {
        tmp_0 = false;
      }
      if (tmp_0) {
        var count = 0;
        // Inline function 'androidx.compose.ui.node.DelegatingNode.forEachImmediateDelegate' call
        var node_0 = node.e9a_1;
        while (!(node_0 == null)) {
          var next = node_0;
          // Inline function 'androidx.compose.ui.Node.isKind' call
          if (!((next.o8v_1 & _NodeKind___get_mask__impl__1uopb6(kind)) === 0)) {
            count = count + 1 | 0;
            if (count === 1) {
              node = next;
            } else {
              var tmp0_elvis_lhs = stack;
              var tmp_2;
              if (tmp0_elvis_lhs == null) {
                // Inline function 'androidx.compose.runtime.collection.mutableVectorOf' call
                // Inline function 'androidx.compose.runtime.collection.MutableVector' call
                // Inline function 'kotlin.arrayOfNulls' call
                var tmp$ret$10 = Array(16);
                tmp_2 = new MutableVector(tmp$ret$10, 0);
              } else {
                tmp_2 = tmp0_elvis_lhs;
              }
              stack = tmp_2;
              var theNode = node;
              if (!(theNode == null)) {
                var tmp1_safe_receiver = stack;
                if (tmp1_safe_receiver == null)
                  null;
                else
                  tmp1_safe_receiver.zz(theNode);
                node = null;
              }
              var tmp2_safe_receiver = stack;
              if (tmp2_safe_receiver == null)
                null;
              else
                tmp2_safe_receiver.zz(next);
            }
          }
          node_0 = node_0.r8v_1;
        }
        if (count === 1) {
          continue $l$loop;
        }
      }
      node = access$pop$tDelegatableNodeKt(stack);
    }
    if (this.h9z_1 == null)
      return true;
    var inductionVariable = 0;
    var last = changes.a19();
    if (inductionVariable < last)
      do {
        var j = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var keyValue = changes.b19(j);
        var change = changes.s18(j);
        if (this.d9z_1.lm(keyValue)) {
          var prevPosition = change.oa0_1;
          var currentPosition = change.ka0_1;
          var tmp_3;
          // Inline function 'androidx.compose.ui.geometry.Offset.isValid' call
          var v = bitwiseAnd(_Offset___get_packedValue__impl__xh2k8q(prevPosition), new Long(2147483647, 2147483647));
          if (equalsLong(bitwiseAnd(add(v, new Long(8388607, 8388607)), new Long(-2147483648, -2147483648)), new Long(0, 0))) {
            // Inline function 'androidx.compose.ui.geometry.Offset.isValid' call
            var v_0 = bitwiseAnd(_Offset___get_packedValue__impl__xh2k8q(currentPosition), new Long(2147483647, 2147483647));
            tmp_3 = equalsLong(bitwiseAnd(add(v_0, new Long(8388607, 8388607)), new Long(-2147483648, -2147483648)), new Long(0, 0));
          } else {
            tmp_3 = false;
          }
          if (tmp_3) {
            var historical = ArrayList_init_$Create$_0(change.ba1().n1());
            // Inline function 'androidx.compose.ui.util.fastForEach' call
            var this_0 = change.ba1();
            var inductionVariable_0 = 0;
            var last_0 = this_0.n1() - 1 | 0;
            if (inductionVariable_0 <= last_0)
              do {
                var index = inductionVariable_0;
                inductionVariable_0 = inductionVariable_0 + 1 | 0;
                var item = this_0.l1(index);
                var historicalPosition = item.da1_1;
                // Inline function 'androidx.compose.ui.geometry.Offset.isValid' call
                var v_1 = bitwiseAnd(_Offset___get_packedValue__impl__xh2k8q(historicalPosition), new Long(2147483647, 2147483647));
                if (equalsLong(bitwiseAnd(add(v_1, new Long(8388607, 8388607)), new Long(-2147483648, -2147483648)), new Long(0, 0))) {
                  historical.j1(HistoricalChange_init_$Create$(item.ca1_1, ensureNotNull(this.h9z_1).q91(parentCoordinates, historicalPosition), item.ea1_1, item.fa1_1, item.ga1_1));
                }
              }
               while (inductionVariable_0 <= last_0);
            var tmp0_previousPosition = ensureNotNull(this.h9z_1).q91(parentCoordinates, prevPosition);
            var tmp1_currentPosition = ensureNotNull(this.h9z_1).q91(parentCoordinates, currentPosition);
            this.g9z_1.z18(keyValue, change.ha1(VOID, VOID, tmp1_currentPosition, VOID, VOID, tmp0_previousPosition, VOID, VOID, historical));
          }
        }
      }
       while (inductionVariable < last);
    if (this.g9z_1.r()) {
      this.d9z_1.c3();
      this.v9y_1.c3();
      return true;
    }
    // Inline function 'androidx.compose.ui.input.pointer.util.PointerIdArray.lastIndex' call
    var inductionVariable_1 = this.d9z_1.k9z_1 - 1 | 0;
    if (0 <= inductionVariable_1)
      do {
        var i = inductionVariable_1;
        inductionVariable_1 = inductionVariable_1 + -1 | 0;
        var pointerId = this.d9z_1.ia1(i);
        if (!changes.mx(_PointerId___get_value__impl__odqw2d(pointerId))) {
          this.d9z_1.h3(i);
        }
      }
       while (0 <= inductionVariable_1);
    var changesList = ArrayList_init_$Create$_0(this.g9z_1.a19());
    var inductionVariable_2 = 0;
    var last_1 = this.g9z_1.a19();
    if (inductionVariable_2 < last_1)
      do {
        var i_0 = inductionVariable_2;
        inductionVariable_2 = inductionVariable_2 + 1 | 0;
        changesList.j1(this.g9z_1.s18(i_0));
      }
       while (inductionVariable_2 < last_1);
    var event = PointerEvent_init_$Create$(changesList, internalPointerEvent);
    var tmp0_0 = event.ca0_1;
    var tmp$ret$17;
    $l$block: {
      // Inline function 'androidx.compose.ui.util.fastFirstOrNull' call
      // Inline function 'androidx.compose.ui.util.fastForEach' call
      var inductionVariable_3 = 0;
      var last_2 = tmp0_0.n1() - 1 | 0;
      if (inductionVariable_3 <= last_2)
        do {
          var index_0 = inductionVariable_3;
          inductionVariable_3 = inductionVariable_3 + 1 | 0;
          var item_0 = tmp0_0.l1(index_0);
          if (internalPointerEvent.ja1(item_0.ia0_1)) {
            tmp$ret$17 = item_0;
            break $l$block;
          }
        }
         while (inductionVariable_3 <= last_2);
      tmp$ret$17 = null;
    }
    var activeHoverChange = tmp$ret$17;
    if (!(activeHoverChange == null)) {
      if (!isInBounds) {
        this.e9z_1 = false;
      } else if (!this.e9z_1 && (activeHoverChange.la0_1 || activeHoverChange.pa0_1)) {
        var size = ensureNotNull(this.h9z_1).q95();
        this.e9z_1 = !isOutOfBounds_0(activeHoverChange, size);
      }
      if (event.ha0_1 === Companion_getInstance_41().na1_1 || event.ha0_1 === Companion_getInstance_41().oa1_1 || event.ha0_1 === Companion_getInstance_41().pa1_1) {
        event.ha0_1 = !this.f9z_1 && this.e9z_1 ? Companion_getInstance_41().oa1_1 : this.f9z_1 && !this.e9z_1 ? Companion_getInstance_41().pa1_1 : Companion_getInstance_41().na1_1;
      }
      if (event.ha0_1 === Companion_getInstance_41().oa1_1)
        this.f9z_1 = true;
      if (event.ha0_1 === Companion_getInstance_41().pa1_1)
        this.f9z_1 = false;
    }
    var changed = childChanged || !(event.ha0_1 === Companion_getInstance_41().na1_1) || hasPositionChanged(this, this.i9z_1, event);
    this.i9z_1 = event;
    return changed;
  };
  protoOf(Node_0).aa0 = function () {
    // Inline function 'androidx.compose.runtime.collection.MutableVector.forEach' call
    var this_0 = this.v9y_1;
    var i = 0;
    var tmp = this_0.b3e_1;
    var content = isArray(tmp) ? tmp : THROW_CCE();
    var size = this_0.d3e_1;
    while (i < size) {
      content[i].aa0();
      i = i + 1 | 0;
    }
    var tmp0 = this.c9z_1;
    // Inline function 'androidx.compose.ui.node.Nodes.PointerInput' call
    // Inline function 'androidx.compose.ui.node.dispatchForKind' call
    // Inline function 'androidx.compose.ui.node.dispatchForKind' call
    var kind = _NodeKind___init__impl__ojsprp(16);
    var stack = null;
    var node = tmp0;
    $l$loop: while (!(node == null)) {
      var tmp_0;
      if (isInterface(node, PointerInputModifierNode)) {
        node.xa1();
        tmp_0 = false;
      } else {
        tmp_0 = true;
      }
      var dispatchAgain = tmp_0;
      var tmp_1;
      var tmp_2;
      if (dispatchAgain || false) {
        // Inline function 'androidx.compose.ui.Node.isKind' call
        tmp_2 = !((node.o8v_1 & _NodeKind___get_mask__impl__1uopb6(kind)) === 0);
      } else {
        tmp_2 = false;
      }
      if (tmp_2) {
        tmp_1 = node instanceof DelegatingNode;
      } else {
        tmp_1 = false;
      }
      if (tmp_1) {
        var count = 0;
        // Inline function 'androidx.compose.ui.node.DelegatingNode.forEachImmediateDelegate' call
        var node_0 = node.e9a_1;
        while (!(node_0 == null)) {
          var next = node_0;
          // Inline function 'androidx.compose.ui.Node.isKind' call
          if (!((next.o8v_1 & _NodeKind___get_mask__impl__1uopb6(kind)) === 0)) {
            count = count + 1 | 0;
            if (count === 1) {
              node = next;
            } else {
              var tmp0_elvis_lhs = stack;
              var tmp_3;
              if (tmp0_elvis_lhs == null) {
                // Inline function 'androidx.compose.runtime.collection.mutableVectorOf' call
                // Inline function 'androidx.compose.runtime.collection.MutableVector' call
                // Inline function 'kotlin.arrayOfNulls' call
                var tmp$ret$12 = Array(16);
                tmp_3 = new MutableVector(tmp$ret$12, 0);
              } else {
                tmp_3 = tmp0_elvis_lhs;
              }
              stack = tmp_3;
              var theNode = node;
              if (!(theNode == null)) {
                var tmp1_safe_receiver = stack;
                if (tmp1_safe_receiver == null)
                  null;
                else
                  tmp1_safe_receiver.zz(theNode);
                node = null;
              }
              var tmp2_safe_receiver = stack;
              if (tmp2_safe_receiver == null)
                null;
              else
                tmp2_safe_receiver.zz(next);
            }
          }
          node_0 = node_0.r8v_1;
        }
        if (count === 1) {
          continue $l$loop;
        }
      }
      node = access$pop$tDelegatableNodeKt(stack);
    }
  };
  protoOf(Node_0).j9z = function () {
    this.e9z_1 = true;
  };
  protoOf(Node_0).ba0 = function (internalPointerEvent) {
    protoOf(NodeParent).ba0.call(this, internalPointerEvent);
    var tmp0_elvis_lhs = this.i9z_1;
    var tmp;
    if (tmp0_elvis_lhs == null) {
      return Unit_instance;
    } else {
      tmp = tmp0_elvis_lhs;
    }
    var event = tmp;
    // Inline function 'androidx.compose.ui.util.fastForEach' call
    var this_0 = event.ca0_1;
    var inductionVariable = 0;
    var last = this_0.n1() - 1 | 0;
    if (inductionVariable <= last)
      do {
        var index = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var item = this_0.l1(index);
        var released = !item.la0_1;
        var nonHoverEventStream = !internalPointerEvent.ja1(item.ia0_1);
        var outsideArea = !this.e9z_1;
        var removePointerId = released && nonHoverEventStream || (released && outsideArea);
        if (removePointerId) {
          var tmp0 = this.d9z_1;
          // Inline function 'androidx.compose.ui.input.pointer.util.PointerIdArray.remove' call
          var pointerId = item.ia0_1;
          tmp0.kx(_PointerId___get_value__impl__odqw2d(pointerId));
        }
      }
       while (inductionVariable <= last);
  };
  protoOf(Node_0).v9z = function () {
    protoOf(NodeParent).v9z.call(this);
    this.e9z_1 = false;
  };
  protoOf(Node_0).toString = function () {
    return 'Node(modifierNode=' + toString(this.c9z_1) + ', children=' + toString(this.v9y_1) + ', ' + ('pointerIds=' + toString(this.d9z_1) + ')');
  };
  var androidx_compose_ui_input_pointer_PointerInputEventData$stable;
  function PointerInputEventData(id, uptime, positionOnScreen, position, down, pressure, type, activeHover, historical, scrollDelta, scaleGestureFactor, panGestureOffset, originalEventPosition) {
    activeHover = activeHover === VOID ? false : activeHover;
    var tmp;
    if (historical === VOID) {
      // Inline function 'kotlin.collections.mutableListOf' call
      tmp = ArrayList_init_$Create$();
    } else {
      tmp = historical;
    }
    historical = tmp;
    scrollDelta = scrollDelta === VOID ? Companion_getInstance().g5d_1 : scrollDelta;
    originalEventPosition = originalEventPosition === VOID ? Companion_getInstance().g5d_1 : originalEventPosition;
    this.ya1_1 = id;
    this.za1_1 = uptime;
    this.aa2_1 = positionOnScreen;
    this.ba2_1 = position;
    this.ca2_1 = down;
    this.da2_1 = pressure;
    this.ea2_1 = type;
    this.fa2_1 = activeHover;
    this.ga2_1 = historical;
    this.ha2_1 = scrollDelta;
    this.ia2_1 = scaleGestureFactor;
    this.ja2_1 = panGestureOffset;
    this.ka2_1 = originalEventPosition;
  }
  protoOf(PointerInputEventData).toString = function () {
    return 'PointerInputEventData(id=' + PointerId__toString_impl_9x5gyf(this.ya1_1) + ', uptime=' + this.za1_1.toString() + ', positionOnScreen=' + Offset__toString_impl_4ffbou(this.aa2_1) + ', position=' + Offset__toString_impl_4ffbou(this.ba2_1) + ', down=' + this.ca2_1 + ', pressure=' + this.da2_1 + ', type=' + PointerType__toString_impl_yrgca2(this.ea2_1) + ', activeHover=' + this.fa2_1 + ', historical=' + toString(this.ga2_1) + ', scrollDelta=' + Offset__toString_impl_4ffbou(this.ha2_1) + ', scaleGestureFactor=' + this.ia2_1 + ', panGestureOffset=' + Offset__toString_impl_4ffbou(this.ja2_1) + ', originalEventPosition=' + Offset__toString_impl_4ffbou(this.ka2_1) + ')';
  };
  protoOf(PointerInputEventData).hashCode = function () {
    var result = PointerId__hashCode_impl_vobdra(this.ya1_1);
    result = imul(result, 31) + this.za1_1.hashCode() | 0;
    result = imul(result, 31) + Offset__hashCode_impl_hbql41(this.aa2_1) | 0;
    result = imul(result, 31) + Offset__hashCode_impl_hbql41(this.ba2_1) | 0;
    result = imul(result, 31) + getBooleanHashCode(this.ca2_1) | 0;
    result = imul(result, 31) + getNumberHashCode(this.da2_1) | 0;
    result = imul(result, 31) + PointerType__hashCode_impl_d0afh7(this.ea2_1) | 0;
    result = imul(result, 31) + getBooleanHashCode(this.fa2_1) | 0;
    result = imul(result, 31) + hashCode(this.ga2_1) | 0;
    result = imul(result, 31) + Offset__hashCode_impl_hbql41(this.ha2_1) | 0;
    result = imul(result, 31) + getNumberHashCode(this.ia2_1) | 0;
    result = imul(result, 31) + Offset__hashCode_impl_hbql41(this.ja2_1) | 0;
    result = imul(result, 31) + Offset__hashCode_impl_hbql41(this.ka2_1) | 0;
    return result;
  };
  protoOf(PointerInputEventData).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof PointerInputEventData))
      return false;
    if (!equals(this.ya1_1, other.ya1_1))
      return false;
    if (!equalsLong(this.za1_1, other.za1_1))
      return false;
    if (!equals(this.aa2_1, other.aa2_1))
      return false;
    if (!equals(this.ba2_1, other.ba2_1))
      return false;
    if (!(this.ca2_1 === other.ca2_1))
      return false;
    if (!equals(this.da2_1, other.da2_1))
      return false;
    if (!(this.ea2_1 === other.ea2_1))
      return false;
    if (!(this.fa2_1 === other.fa2_1))
      return false;
    if (!equals(this.ga2_1, other.ga2_1))
      return false;
    if (!equals(this.ha2_1, other.ha2_1))
      return false;
    if (!equals(this.ia2_1, other.ia2_1))
      return false;
    if (!equals(this.ja2_1, other.ja2_1))
      return false;
    if (!equals(this.ka2_1, other.ka2_1))
      return false;
    return true;
  };
  var androidx_compose_ui_input_pointer_PointerInputFilter$stable;
  var androidx_compose_ui_input_pointer_PointerInputChange$stable;
  var androidx_compose_ui_input_pointer_HistoricalChange$stable;
  var androidx_compose_ui_input_pointer_ConsumedData$stable;
  function PointerInputChange_init_$Init$(id, uptimeMillis, position, pressed, pressure, previousUptimeMillis, previousPosition, previousPressed, isInitiallyConsumed, type, historical, scrollDelta, scaleFactor, panOffset, originalEventPosition, $this) {
    PointerInputChange.call($this, id, uptimeMillis, position, pressed, pressure, previousUptimeMillis, previousPosition, previousPressed, isInitiallyConsumed, type, scrollDelta, scaleFactor, panOffset);
    $this.ua0_1 = historical;
    $this.va0_1 = originalEventPosition;
    return $this;
  }
  function PointerInputChange_init_$Create$(id, uptimeMillis, position, pressed, pressure, previousUptimeMillis, previousPosition, previousPressed, isInitiallyConsumed, type, historical, scrollDelta, scaleFactor, panOffset, originalEventPosition) {
    return PointerInputChange_init_$Init$(id, uptimeMillis, position, pressed, pressure, previousUptimeMillis, previousPosition, previousPressed, isInitiallyConsumed, type, historical, scrollDelta, scaleFactor, panOffset, originalEventPosition, objectCreate(protoOf(PointerInputChange)));
  }
  function PointerInputChange(id, uptimeMillis, position, pressed, pressure, previousUptimeMillis, previousPosition, previousPressed, isInitiallyConsumed, type, scrollDelta, scaleFactor, panOffset) {
    type = type === VOID ? Companion_getInstance_42().ma2_1 : type;
    scrollDelta = scrollDelta === VOID ? Companion_getInstance().g5d_1 : scrollDelta;
    scaleFactor = scaleFactor === VOID ? 1.0 : scaleFactor;
    panOffset = panOffset === VOID ? Companion_getInstance().g5d_1 : panOffset;
    this.ia0_1 = id;
    this.ja0_1 = uptimeMillis;
    this.ka0_1 = position;
    this.la0_1 = pressed;
    this.ma0_1 = pressure;
    this.na0_1 = previousUptimeMillis;
    this.oa0_1 = previousPosition;
    this.pa0_1 = previousPressed;
    this.qa0_1 = type;
    this.ra0_1 = scrollDelta;
    this.sa0_1 = scaleFactor;
    this.ta0_1 = panOffset;
    this.ua0_1 = null;
    this.va0_1 = Companion_getInstance().g5d_1;
    this.wa0_1 = isInitiallyConsumed;
    this.xa0_1 = isInitiallyConsumed;
    this.ya0_1 = null;
    this.za0_1 = null;
  }
  protoOf(PointerInputChange).ba1 = function () {
    var tmp0_elvis_lhs = this.ua0_1;
    var tmp;
    if (tmp0_elvis_lhs == null) {
      // Inline function 'kotlin.collections.listOf' call
      tmp = emptyList();
    } else {
      tmp = tmp0_elvis_lhs;
    }
    return tmp;
  };
  protoOf(PointerInputChange).qa2 = function () {
    var tmp0_safe_receiver = this.ya0_1;
    var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.qa2();
    return tmp1_elvis_lhs == null ? this.wa0_1 || this.xa0_1 : tmp1_elvis_lhs;
  };
  protoOf(PointerInputChange).ra2 = function () {
    if (this.ya0_1 == null) {
      this.wa0_1 = true;
      this.xa0_1 = true;
    } else {
      var tmp0_safe_receiver = this.ya0_1;
      if (tmp0_safe_receiver == null)
        null;
      else {
        tmp0_safe_receiver.ra2();
      }
    }
  };
  protoOf(PointerInputChange).sa2 = function (id, currentTime, currentPosition, currentPressed, previousTime, previousPosition, previousPressed, type, historical, scrollDelta) {
    // Inline function 'kotlin.also' call
    var this_0 = this.ta2(id, currentTime, currentPosition, currentPressed, this.ma0_1, previousTime, previousPosition, previousPressed, type, historical, scrollDelta);
    var tmp = this_0;
    var tmp0_elvis_lhs = this.ya0_1;
    tmp.ya0_1 = tmp0_elvis_lhs == null ? this : tmp0_elvis_lhs;
    return this_0;
  };
  protoOf(PointerInputChange).ha1 = function (id, currentTime, currentPosition, currentPressed, previousTime, previousPosition, previousPressed, type, historical, scrollDelta, $super) {
    id = id === VOID ? this.ia0_1 : id;
    currentTime = currentTime === VOID ? this.ja0_1 : currentTime;
    currentPosition = currentPosition === VOID ? this.ka0_1 : currentPosition;
    currentPressed = currentPressed === VOID ? this.la0_1 : currentPressed;
    previousTime = previousTime === VOID ? this.na0_1 : previousTime;
    previousPosition = previousPosition === VOID ? this.oa0_1 : previousPosition;
    previousPressed = previousPressed === VOID ? this.pa0_1 : previousPressed;
    type = type === VOID ? this.qa0_1 : type;
    scrollDelta = scrollDelta === VOID ? this.ra0_1 : scrollDelta;
    return $super === VOID ? this.sa2(id, currentTime, currentPosition, currentPressed, previousTime, previousPosition, previousPressed, type, historical, scrollDelta) : $super.sa2.call(this, new PointerId(id), currentTime, new Offset(currentPosition), currentPressed, previousTime, new Offset(previousPosition), previousPressed, new PointerType(type), historical, new Offset(scrollDelta));
  };
  protoOf(PointerInputChange).ta2 = function (id, currentTime, currentPosition, currentPressed, pressure, previousTime, previousPosition, previousPressed, type, historical, scrollDelta) {
    // Inline function 'kotlin.also' call
    var this_0 = PointerInputChange_init_$Create$(id, currentTime, currentPosition, currentPressed, pressure, previousTime, previousPosition, previousPressed, false, type, historical, scrollDelta, this.sa0_1, this.ta0_1, this.va0_1);
    var tmp = this_0;
    var tmp0_elvis_lhs = this.ya0_1;
    tmp.ya0_1 = tmp0_elvis_lhs == null ? this : tmp0_elvis_lhs;
    return this_0;
  };
  protoOf(PointerInputChange).toString = function () {
    return 'PointerInputChange(id=' + PointerId__toString_impl_9x5gyf(this.ia0_1) + ', ' + ('uptimeMillis=' + this.ja0_1.toString() + ', ') + ('position=' + Offset__toString_impl_4ffbou(this.ka0_1) + ', ') + ('pressed=' + this.la0_1 + ', ') + ('pressure=' + this.ma0_1 + ', ') + ('previousUptimeMillis=' + this.na0_1.toString() + ', ') + ('previousPosition=' + Offset__toString_impl_4ffbou(this.oa0_1) + ', ') + ('previousPressed=' + this.pa0_1 + ', ') + ('isConsumed=' + this.qa2() + ', ') + ('type=' + PointerType__toString_impl_yrgca2(this.qa0_1) + ', ') + ('historical=' + toString(this.ba1()) + ', ') + ('scrollDelta=' + Offset__toString_impl_4ffbou(this.ra0_1) + ', ') + ('scaleFactor=' + this.sa0_1 + ', ') + ('panOffset=' + Offset__toString_impl_4ffbou(this.ta0_1) + ')');
  };
  var PointerEventPass_Initial_instance;
  var PointerEventPass_Main_instance;
  var PointerEventPass_Final_instance;
  var PointerEventPass_entriesInitialized;
  function PointerEventPass_initEntries() {
    if (PointerEventPass_entriesInitialized)
      return Unit_instance;
    PointerEventPass_entriesInitialized = true;
    PointerEventPass_Initial_instance = new PointerEventPass('Initial', 0);
    PointerEventPass_Main_instance = new PointerEventPass('Main', 1);
    PointerEventPass_Final_instance = new PointerEventPass('Final', 2);
  }
  function PointerEventPass(name, ordinal) {
    Enum.call(this, name, ordinal);
  }
  function changedToUp(_this__u8e3s4) {
    return !_this__u8e3s4.qa2() && _this__u8e3s4.pa0_1 && !_this__u8e3s4.la0_1;
  }
  function isOutOfBounds(_this__u8e3s4, size, extendedTouchPadding) {
    // Inline function 'androidx.compose.ui.input.pointer.toInt' call
    var isTouch = _this__u8e3s4.qa0_1 === Companion_getInstance_42().ma2_1 ? 1 : 0;
    var position = _this__u8e3s4.ka0_1;
    // Inline function 'androidx.compose.ui.geometry.Offset.x' call
    // Inline function 'androidx.compose.ui.util.unpackFloat1' call
    var value = _Offset___get_packedValue__impl__xh2k8q(position);
    // Inline function 'androidx.compose.ui.util.floatFromBits' call
    // Inline function 'kotlin.fromBits' call
    var bits = convertToInt(shiftRight(value, 32));
    var x = floatFromBits(bits);
    // Inline function 'androidx.compose.ui.geometry.Offset.y' call
    // Inline function 'androidx.compose.ui.util.unpackFloat2' call
    var value_0 = _Offset___get_packedValue__impl__xh2k8q(position);
    // Inline function 'androidx.compose.ui.util.floatFromBits' call
    // Inline function 'kotlin.fromBits' call
    var bits_0 = convertToInt(bitwiseAnd(value_0, new Long(-1, 0)));
    var y = floatFromBits(bits_0);
    // Inline function 'androidx.compose.ui.geometry.Size.width' call
    // Inline function 'androidx.compose.ui.util.unpackFloat1' call
    var value_1 = _Size___get_packedValue__impl__7rlt1o(extendedTouchPadding);
    // Inline function 'androidx.compose.ui.util.floatFromBits' call
    // Inline function 'kotlin.fromBits' call
    var bits_1 = convertToInt(shiftRight(value_1, 32));
    var extentX = floatFromBits(bits_1) * isTouch;
    // Inline function 'androidx.compose.ui.unit.IntSize.width' call
    // Inline function 'androidx.compose.ui.util.unpackInt1' call
    var value_2 = _IntSize___get_packedValue__impl__uho7jf(size);
    var maxX = convertToInt(shiftRight(value_2, 32)) + extentX;
    // Inline function 'androidx.compose.ui.geometry.Size.height' call
    // Inline function 'androidx.compose.ui.util.unpackFloat2' call
    var value_3 = _Size___get_packedValue__impl__7rlt1o(extendedTouchPadding);
    // Inline function 'androidx.compose.ui.util.floatFromBits' call
    // Inline function 'kotlin.fromBits' call
    var bits_2 = convertToInt(bitwiseAnd(value_3, new Long(-1, 0)));
    var extentY = floatFromBits(bits_2) * isTouch;
    // Inline function 'androidx.compose.ui.unit.IntSize.height' call
    // Inline function 'androidx.compose.ui.util.unpackInt2' call
    var value_4 = _IntSize___get_packedValue__impl__uho7jf(size);
    var maxY = convertToInt(bitwiseAnd(value_4, new Long(-1, 0))) + extentY;
    return !!(!!(!!(x < -extentX | x > maxX) | y < -extentY) | y > maxY);
  }
  function _PointerEventType___init__impl__k0lsty(value) {
    return value;
  }
  function _PointerEventType___get_value__impl__teq1fm($this) {
    return $this;
  }
  function Companion_15() {
    Companion_instance_20 = this;
    this.ka1_1 = _PointerEventType___init__impl__k0lsty(0);
    this.la1_1 = _PointerEventType___init__impl__k0lsty(1);
    this.ma1_1 = _PointerEventType___init__impl__k0lsty(2);
    this.na1_1 = _PointerEventType___init__impl__k0lsty(3);
    this.oa1_1 = _PointerEventType___init__impl__k0lsty(4);
    this.pa1_1 = _PointerEventType___init__impl__k0lsty(5);
    this.qa1_1 = _PointerEventType___init__impl__k0lsty(6);
    this.ra1_1 = _PointerEventType___init__impl__k0lsty(7);
    this.sa1_1 = _PointerEventType___init__impl__k0lsty(8);
    this.ta1_1 = _PointerEventType___init__impl__k0lsty(9);
    this.ua1_1 = _PointerEventType___init__impl__k0lsty(10);
    this.va1_1 = _PointerEventType___init__impl__k0lsty(11);
    this.wa1_1 = _PointerEventType___init__impl__k0lsty(12);
  }
  var Companion_instance_20;
  function Companion_getInstance_41() {
    if (Companion_instance_20 == null)
      new Companion_15();
    return Companion_instance_20;
  }
  function PointerEventType__toString_impl_o7j1va($this) {
    return $this === Companion_getInstance_41().la1_1 ? 'Press' : $this === Companion_getInstance_41().ma1_1 ? 'Release' : $this === Companion_getInstance_41().na1_1 ? 'Move' : $this === Companion_getInstance_41().oa1_1 ? 'Enter' : $this === Companion_getInstance_41().pa1_1 ? 'Exit' : $this === Companion_getInstance_41().qa1_1 ? 'Scroll' : $this === Companion_getInstance_41().ra1_1 ? 'ScaleStart' : $this === Companion_getInstance_41().sa1_1 ? 'ScaleChange' : $this === Companion_getInstance_41().ta1_1 ? 'ScaleFinish' : $this === Companion_getInstance_41().ua1_1 ? 'PanStart' : $this === Companion_getInstance_41().va1_1 ? 'Pan' : $this === Companion_getInstance_41().wa1_1 ? 'PanEnd' : 'Unknown';
  }
  function PointerEventType__hashCode_impl_p2f3az($this) {
    return $this;
  }
  function PointerEventType__equals_impl_w1bf55($this, other) {
    if (!(other instanceof PointerEventType))
      return false;
    if (!($this === other.ua2_1))
      return false;
    return true;
  }
  function PointerEventType(value) {
    Companion_getInstance_41();
    this.ua2_1 = value;
  }
  protoOf(PointerEventType).toString = function () {
    return PointerEventType__toString_impl_o7j1va(this.ua2_1);
  };
  protoOf(PointerEventType).hashCode = function () {
    return PointerEventType__hashCode_impl_p2f3az(this.ua2_1);
  };
  protoOf(PointerEventType).equals = function (other) {
    return PointerEventType__equals_impl_w1bf55(this.ua2_1, other);
  };
  function _PointerType___init__impl__8zawpu(value) {
    return value;
  }
  function _get_value__a43j40($this) {
    return $this;
  }
  function PointerType__toString_impl_yrgca2($this) {
    switch (_get_value__a43j40($this)) {
      case 1:
        return 'Touch';
      case 2:
        return 'Mouse';
      case 3:
        return 'Stylus';
      case 4:
        return 'Eraser';
      default:
        return 'Unknown';
    }
  }
  function Companion_16() {
    Companion_instance_21 = this;
    this.la2_1 = _PointerType___init__impl__8zawpu(0);
    this.ma2_1 = _PointerType___init__impl__8zawpu(1);
    this.na2_1 = _PointerType___init__impl__8zawpu(2);
    this.oa2_1 = _PointerType___init__impl__8zawpu(3);
    this.pa2_1 = _PointerType___init__impl__8zawpu(4);
  }
  var Companion_instance_21;
  function Companion_getInstance_42() {
    if (Companion_instance_21 == null)
      new Companion_16();
    return Companion_instance_21;
  }
  function PointerType__hashCode_impl_d0afh7($this) {
    return $this;
  }
  function PointerType__equals_impl_dkjp55($this, other) {
    if (!(other instanceof PointerType))
      return false;
    if (!($this === other.va2_1))
      return false;
    return true;
  }
  function PointerType(value) {
    Companion_getInstance_42();
    this.va2_1 = value;
  }
  protoOf(PointerType).toString = function () {
    return PointerType__toString_impl_yrgca2(this.va2_1);
  };
  protoOf(PointerType).hashCode = function () {
    return PointerType__hashCode_impl_d0afh7(this.va2_1);
  };
  protoOf(PointerType).equals = function (other) {
    return PointerType__equals_impl_dkjp55(this.va2_1, other);
  };
  function changedToDownIgnoreConsumed(_this__u8e3s4) {
    return !_this__u8e3s4.pa0_1 && _this__u8e3s4.la0_1;
  }
  function changedToUpIgnoreConsumed(_this__u8e3s4) {
    return _this__u8e3s4.pa0_1 && !_this__u8e3s4.la0_1;
  }
  function positionChange(_this__u8e3s4) {
    return positionChangeInternal(_this__u8e3s4, false);
  }
  function _PointerId___init__impl__w2urwh(value) {
    return value;
  }
  function _PointerId___get_value__impl__odqw2d($this) {
    return $this;
  }
  function PointerId__toString_impl_9x5gyf($this) {
    return 'PointerId(value=' + $this.toString() + ')';
  }
  function PointerId__hashCode_impl_vobdra($this) {
    return $this.hashCode();
  }
  function PointerId__equals_impl_gbfrzq($this, other) {
    if (!(other instanceof PointerId))
      return false;
    var tmp0_other_with_cast = other.wa2_1;
    if (!equalsLong($this, tmp0_other_with_cast))
      return false;
    return true;
  }
  function PointerId(value) {
    this.wa2_1 = value;
  }
  protoOf(PointerId).toString = function () {
    return PointerId__toString_impl_9x5gyf(this.wa2_1);
  };
  protoOf(PointerId).hashCode = function () {
    return PointerId__hashCode_impl_vobdra(this.wa2_1);
  };
  protoOf(PointerId).equals = function (other) {
    return PointerId__equals_impl_gbfrzq(this.wa2_1, other);
  };
  function positionChangeIgnoreConsumed(_this__u8e3s4) {
    return positionChangeInternal(_this__u8e3s4, true);
  }
  function _PointerButtons___init__impl__wq04zh(packedValue) {
    return packedValue;
  }
  function _PointerButtons___get_packedValue__impl__z09y3b($this) {
    return $this;
  }
  function PointerButtons__toString_impl_sncyql($this) {
    return 'PointerButtons(packedValue=' + $this + ')';
  }
  function PointerButtons__hashCode_impl_6w71xq($this) {
    return $this;
  }
  function PointerButtons__equals_impl_817jpy($this, other) {
    if (!(other instanceof PointerButtons))
      return false;
    if (!($this === other.xa2_1))
      return false;
    return true;
  }
  function PointerButtons(packedValue) {
    this.xa2_1 = packedValue;
  }
  protoOf(PointerButtons).toString = function () {
    return PointerButtons__toString_impl_sncyql(this.xa2_1);
  };
  protoOf(PointerButtons).hashCode = function () {
    return PointerButtons__hashCode_impl_6w71xq(this.xa2_1);
  };
  protoOf(PointerButtons).equals = function (other) {
    return PointerButtons__equals_impl_817jpy(this.xa2_1, other);
  };
  function changedToDown(_this__u8e3s4) {
    return !_this__u8e3s4.qa2() && !_this__u8e3s4.pa0_1 && _this__u8e3s4.la0_1;
  }
  function HistoricalChange_init_$Init$(uptimeMillis, position, scaleFactor, panOffset, originalEventPosition, $this) {
    HistoricalChange.call($this, uptimeMillis, position, scaleFactor, panOffset);
    $this.ga1_1 = originalEventPosition;
    return $this;
  }
  function HistoricalChange_init_$Create$(uptimeMillis, position, scaleFactor, panOffset, originalEventPosition) {
    return HistoricalChange_init_$Init$(uptimeMillis, position, scaleFactor, panOffset, originalEventPosition, objectCreate(protoOf(HistoricalChange)));
  }
  function HistoricalChange(uptimeMillis, position, scaleFactor, panOffset) {
    scaleFactor = scaleFactor === VOID ? 1.0 : scaleFactor;
    panOffset = panOffset === VOID ? Companion_getInstance().g5d_1 : panOffset;
    this.ca1_1 = uptimeMillis;
    this.da1_1 = position;
    this.ea1_1 = scaleFactor;
    this.fa1_1 = panOffset;
    this.ga1_1 = Companion_getInstance().g5d_1;
  }
  protoOf(HistoricalChange).toString = function () {
    return 'HistoricalChange(uptimeMillis=' + this.ca1_1.toString() + ', ' + ('position=' + Offset__toString_impl_4ffbou(this.da1_1) + ', ') + ('scaleFactor=' + this.ea1_1 + ', ') + ('panOffset=' + Offset__toString_impl_4ffbou(this.fa1_1) + ')');
  };
  function _PointerKeyboardModifiers___init__impl__bj99nt(packedValue) {
    return packedValue;
  }
  function _PointerKeyboardModifiers___get_packedValue__impl__7vcep7($this) {
    return $this;
  }
  function PointerKeyboardModifiers__toString_impl_rpr9l5($this) {
    return 'PointerKeyboardModifiers(packedValue=' + $this + ')';
  }
  function PointerKeyboardModifiers__hashCode_impl_5ylcsa($this) {
    return $this;
  }
  function PointerKeyboardModifiers__equals_impl_ekziza($this, other) {
    if (!(other instanceof PointerKeyboardModifiers))
      return false;
    if (!($this === other.ya2_1))
      return false;
    return true;
  }
  function PointerKeyboardModifiers(packedValue) {
    this.ya2_1 = packedValue;
  }
  protoOf(PointerKeyboardModifiers).toString = function () {
    return PointerKeyboardModifiers__toString_impl_rpr9l5(this.ya2_1);
  };
  protoOf(PointerKeyboardModifiers).hashCode = function () {
    return PointerKeyboardModifiers__hashCode_impl_5ylcsa(this.ya2_1);
  };
  protoOf(PointerKeyboardModifiers).equals = function (other) {
    return PointerKeyboardModifiers__equals_impl_ekziza(this.ya2_1, other);
  };
  function positionChangedIgnoreConsumed(_this__u8e3s4) {
    return !equals(positionChangeInternal(_this__u8e3s4, true), Companion_getInstance().g5d_1);
  }
  function positionChangeInternal(_this__u8e3s4, ignoreConsumed) {
    ignoreConsumed = ignoreConsumed === VOID ? false : ignoreConsumed;
    var previousPosition = _this__u8e3s4.oa0_1;
    var currentPosition = _this__u8e3s4.ka0_1;
    var offset = Offset__minus_impl_hoj2c0(currentPosition, previousPosition);
    return !ignoreConsumed && _this__u8e3s4.qa2() ? Companion_getInstance().g5d_1 : offset;
  }
  function PointerInputModifier() {
  }
  function positionChanged(_this__u8e3s4) {
    return !equals(positionChangeInternal(_this__u8e3s4, false), Companion_getInstance().g5d_1);
  }
  function isOutOfBounds_0(_this__u8e3s4, size) {
    var position = _this__u8e3s4.ka0_1;
    // Inline function 'androidx.compose.ui.geometry.Offset.x' call
    // Inline function 'androidx.compose.ui.util.unpackFloat1' call
    var value = _Offset___get_packedValue__impl__xh2k8q(position);
    // Inline function 'androidx.compose.ui.util.floatFromBits' call
    // Inline function 'kotlin.fromBits' call
    var bits = convertToInt(shiftRight(value, 32));
    var x = floatFromBits(bits);
    // Inline function 'androidx.compose.ui.geometry.Offset.y' call
    // Inline function 'androidx.compose.ui.util.unpackFloat2' call
    var value_0 = _Offset___get_packedValue__impl__xh2k8q(position);
    // Inline function 'androidx.compose.ui.util.floatFromBits' call
    // Inline function 'kotlin.fromBits' call
    var bits_0 = convertToInt(bitwiseAnd(value_0, new Long(-1, 0)));
    var y = floatFromBits(bits_0);
    // Inline function 'androidx.compose.ui.unit.IntSize.width' call
    // Inline function 'androidx.compose.ui.util.unpackInt1' call
    var value_1 = _IntSize___get_packedValue__impl__uho7jf(size);
    var width = convertToInt(shiftRight(value_1, 32));
    // Inline function 'androidx.compose.ui.unit.IntSize.height' call
    // Inline function 'androidx.compose.ui.util.unpackInt2' call
    var value_2 = _IntSize___get_packedValue__impl__uho7jf(size);
    var height = convertToInt(bitwiseAnd(value_2, new Long(-1, 0)));
    return !!(!!(!!(x < 0.0 | x > width) | y < 0.0) | y > height);
  }
  function PointerEventPass_Initial_getInstance() {
    PointerEventPass_initEntries();
    return PointerEventPass_Initial_instance;
  }
  function PointerEventPass_Main_getInstance() {
    PointerEventPass_initEntries();
    return PointerEventPass_Main_instance;
  }
  function PointerEventPass_Final_getInstance() {
    PointerEventPass_initEntries();
    return PointerEventPass_Final_instance;
  }
  var androidx_compose_ui_input_pointer_PointerHoverIconModifierElement$stable;
  var androidx_compose_ui_input_pointer_PointerHoverIconModifierNode$stable;
  var androidx_compose_ui_input_pointer_StylusHoverIconModifierElement$stable;
  var androidx_compose_ui_input_pointer_StylusHoverIconModifierNode$stable;
  var androidx_compose_ui_input_pointer_HoverIconModifierNode$stable;
  function pointerHoverIcon(_this__u8e3s4, icon, overrideDescendants) {
    overrideDescendants = overrideDescendants === VOID ? false : overrideDescendants;
    return _this__u8e3s4.d8v(new PointerHoverIconModifierElement(icon, overrideDescendants));
  }
  function Companion_17() {
    Companion_instance_22 = this;
    this.aa3_1 = get_pointerIconDefault();
    this.ba3_1 = get_pointerIconCrosshair();
    this.ca3_1 = get_pointerIconText();
    this.da3_1 = get_pointerIconHand();
  }
  var Companion_instance_22;
  function Companion_getInstance_43() {
    if (Companion_instance_22 == null)
      new Companion_17();
    return Companion_instance_22;
  }
  function stylusHoverIcon(_this__u8e3s4, icon, overrideDescendants, touchBoundsExpansion) {
    overrideDescendants = overrideDescendants === VOID ? false : overrideDescendants;
    touchBoundsExpansion = touchBoundsExpansion === VOID ? null : touchBoundsExpansion;
    return _this__u8e3s4.d8v(new StylusHoverIconModifierElement(icon, overrideDescendants, touchBoundsExpansion));
  }
  function PointerHoverIconModifierElement(icon, overrideDescendants) {
    overrideDescendants = overrideDescendants === VOID ? false : overrideDescendants;
    ModifierNodeElement.call(this);
    this.fa3_1 = icon;
    this.ga3_1 = overrideDescendants;
  }
  protoOf(PointerHoverIconModifierElement).r3d = function () {
    return new PointerHoverIconModifierNode(this.fa3_1, this.ga3_1);
  };
  protoOf(PointerHoverIconModifierElement).ha3 = function (node) {
    node.aa4(this.fa3_1);
    node.ba4(this.ga3_1);
  };
  protoOf(PointerHoverIconModifierElement).d8y = function (node) {
    return this.ha3(node instanceof PointerHoverIconModifierNode ? node : THROW_CCE());
  };
  protoOf(PointerHoverIconModifierElement).toString = function () {
    return 'PointerHoverIconModifierElement(icon=' + toString(this.fa3_1) + ', overrideDescendants=' + this.ga3_1 + ')';
  };
  protoOf(PointerHoverIconModifierElement).hashCode = function () {
    var result = hashCode(this.fa3_1);
    result = imul(result, 31) + getBooleanHashCode(this.ga3_1) | 0;
    return result;
  };
  protoOf(PointerHoverIconModifierElement).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof PointerHoverIconModifierElement))
      return false;
    if (!equals(this.fa3_1, other.fa3_1))
      return false;
    if (!(this.ga3_1 === other.ga3_1))
      return false;
    return true;
  };
  function StylusHoverIconModifierElement(icon, overrideDescendants, touchBoundsExpansion) {
    overrideDescendants = overrideDescendants === VOID ? false : overrideDescendants;
    touchBoundsExpansion = touchBoundsExpansion === VOID ? null : touchBoundsExpansion;
    ModifierNodeElement.call(this);
    this.da4_1 = icon;
    this.ea4_1 = overrideDescendants;
    this.fa4_1 = touchBoundsExpansion;
  }
  protoOf(StylusHoverIconModifierElement).r3d = function () {
    return new StylusHoverIconModifierNode(this.da4_1, this.ea4_1, this.fa4_1);
  };
  protoOf(StylusHoverIconModifierElement).ga4 = function (node) {
    node.aa4(this.da4_1);
    node.ba4(this.ea4_1);
    node.wa3_1 = this.fa4_1;
  };
  protoOf(StylusHoverIconModifierElement).d8y = function (node) {
    return this.ga4(node instanceof StylusHoverIconModifierNode ? node : THROW_CCE());
  };
  protoOf(StylusHoverIconModifierElement).toString = function () {
    return 'StylusHoverIconModifierElement(icon=' + toString(this.da4_1) + ', overrideDescendants=' + this.ea4_1 + ', touchBoundsExpansion=' + toString_0(this.fa4_1) + ')';
  };
  protoOf(StylusHoverIconModifierElement).hashCode = function () {
    var result = hashCode(this.da4_1);
    result = imul(result, 31) + getBooleanHashCode(this.ea4_1) | 0;
    result = imul(result, 31) + (this.fa4_1 == null ? 0 : this.fa4_1.hashCode()) | 0;
    return result;
  };
  protoOf(StylusHoverIconModifierElement).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof StylusHoverIconModifierElement))
      return false;
    if (!equals(this.da4_1, other.da4_1))
      return false;
    if (!(this.ea4_1 === other.ea4_1))
      return false;
    if (!equals(this.fa4_1, other.fa4_1))
      return false;
    return true;
  };
  function PointerHoverIconModifierNode(icon, overrideDescendants) {
    overrideDescendants = overrideDescendants === VOID ? false : overrideDescendants;
    HoverIconModifierNode.call(this, icon, overrideDescendants);
    this.za4_1 = 'androidx.compose.ui.input.pointer.PointerHoverIcon';
  }
  protoOf(PointerHoverIconModifierNode).t91 = function () {
    return this.za4_1;
  };
  protoOf(PointerHoverIconModifierNode).aa5 = function (pointerType) {
    return !(pointerType === Companion_getInstance_42().oa2_1) && !(pointerType === Companion_getInstance_42().pa2_1);
  };
  protoOf(PointerHoverIconModifierNode).ba5 = function (icon) {
    var tmp0_safe_receiver = this.ca5();
    if (tmp0_safe_receiver == null)
      null;
    else {
      tmp0_safe_receiver.da5(icon);
    }
  };
  function StylusHoverIconModifierNode(icon, overrideDescendants, touchBoundsExpansion) {
    overrideDescendants = overrideDescendants === VOID ? false : overrideDescendants;
    touchBoundsExpansion = touchBoundsExpansion === VOID ? null : touchBoundsExpansion;
    HoverIconModifierNode.call(this, icon, overrideDescendants, touchBoundsExpansion);
    this.aa6_1 = 'androidx.compose.ui.input.pointer.StylusHoverIcon';
  }
  protoOf(StylusHoverIconModifierNode).t91 = function () {
    return this.aa6_1;
  };
  protoOf(StylusHoverIconModifierNode).aa5 = function (pointerType) {
    return pointerType === Companion_getInstance_42().oa2_1 || pointerType === Companion_getInstance_42().pa2_1;
  };
  protoOf(StylusHoverIconModifierNode).ba5 = function (icon) {
    var tmp0_safe_receiver = this.ca5();
    if (tmp0_safe_receiver == null)
      null;
    else {
      tmp0_safe_receiver.ba6(icon);
    }
  };
  function onEnter($this) {
    $this.za3_1 = true;
    displayIconIfDescendantsDoNotHavePriority($this);
  }
  function onExit($this) {
    if ($this.za3_1) {
      $this.za3_1 = false;
      if ($this.z8v_1) {
        displayIconFromAncestorNodeWithCursorInBoundsOrDefaultIcon($this);
      }
    }
  }
  function displayIcon($this) {
    var tmp0_safe_receiver = findOverridingAncestorNode($this);
    var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.xa3_1;
    var iconToUse = tmp1_elvis_lhs == null ? $this.xa3_1 : tmp1_elvis_lhs;
    $this.ba5(iconToUse);
  }
  function displayIconIfDescendantsDoNotHavePriority($this) {
    var hasIconRightsOverDescendants = {_v: true};
    if (!$this.ya3_1) {
      traverseDescendants_0($this, HoverIconModifierNode$displayIconIfDescendantsDoNotHavePriority$lambda(hasIconRightsOverDescendants));
    }
    if (hasIconRightsOverDescendants._v) {
      displayIcon($this);
    }
  }
  function findDescendantNodeWithCursorInBounds($this) {
    var descendantNodeWithCursorInBounds = {_v: null};
    traverseDescendants_0($this, HoverIconModifierNode$findDescendantNodeWithCursorInBounds$lambda(descendantNodeWithCursorInBounds));
    return descendantNodeWithCursorInBounds._v;
  }
  function displayIconFromCurrentNodeOrDescendantsWithCursorInBounds($this) {
    if (!$this.za3_1)
      return Unit_instance;
    var hoverIconModifierNode = $this;
    if (!$this.ya3_1) {
      var tmp0_safe_receiver = findDescendantNodeWithCursorInBounds($this);
      if (tmp0_safe_receiver == null)
        null;
      else {
        // Inline function 'kotlin.let' call
        hoverIconModifierNode = tmp0_safe_receiver;
      }
    }
    displayIcon(hoverIconModifierNode);
  }
  function findOverridingAncestorNode($this) {
    var hoverIconModifierNode = {_v: null};
    traverseAncestors_0($this, HoverIconModifierNode$findOverridingAncestorNode$lambda(hoverIconModifierNode));
    return hoverIconModifierNode._v;
  }
  function displayIconFromAncestorNodeWithCursorInBoundsOrDefaultIcon($this) {
    var hoverIconModifierNode = {_v: null};
    traverseAncestors_0($this, HoverIconModifierNode$displayIconFromAncestorNodeWithCursorInBoundsOrDefaultIcon$lambda(hoverIconModifierNode));
    var tmp0_safe_receiver = hoverIconModifierNode._v;
    var tmp;
    if (tmp0_safe_receiver == null) {
      tmp = null;
    } else {
      displayIcon(tmp0_safe_receiver);
      tmp = Unit_instance;
    }
    if (tmp == null) {
      $this.ba5(null);
    }
  }
  function HoverIconModifierNode$displayIconIfDescendantsDoNotHavePriority$lambda($hasIconRightsOverDescendants) {
    return function (it) {
      var tmp;
      if (it.za3_1) {
        $hasIconRightsOverDescendants._v = false;
        tmp = TraverseDescendantsAction_CancelTraversal_getInstance();
      } else {
        tmp = TraverseDescendantsAction_ContinueTraversal_getInstance();
      }
      var continueTraversal = tmp;
      return continueTraversal;
    };
  }
  function HoverIconModifierNode$findDescendantNodeWithCursorInBounds$lambda($descendantNodeWithCursorInBounds) {
    return function (it) {
      var actionForSubtreeOfCurrentNode = TraverseDescendantsAction_ContinueTraversal_getInstance();
      var tmp;
      if (it.za3_1) {
        $descendantNodeWithCursorInBounds._v = it;
        var tmp_0;
        if (it.ya3_1) {
          actionForSubtreeOfCurrentNode = TraverseDescendantsAction_SkipSubtreeAndContinueTraversal_getInstance();
          tmp_0 = Unit_instance;
        }
        tmp = tmp_0;
      }
      return actionForSubtreeOfCurrentNode;
    };
  }
  function HoverIconModifierNode$findOverridingAncestorNode$lambda($hoverIconModifierNode) {
    return function (it) {
      var tmp;
      if (it.ya3_1 && it.za3_1) {
        $hoverIconModifierNode._v = it;
        tmp = Unit_instance;
      }
      return true;
    };
  }
  function HoverIconModifierNode$displayIconFromAncestorNodeWithCursorInBoundsOrDefaultIcon$lambda($hoverIconModifierNode) {
    return function (it) {
      var tmp;
      if ($hoverIconModifierNode._v == null && it.za3_1) {
        $hoverIconModifierNode._v = it;
        tmp = Unit_instance;
      } else if (!($hoverIconModifierNode._v == null) && it.ya3_1 && it.za3_1) {
        $hoverIconModifierNode._v = it;
        tmp = Unit_instance;
      }
      return true;
    };
  }
  function HoverIconModifierNode(icon, overrideDescendants, dpTouchBoundsExpansion) {
    overrideDescendants = overrideDescendants === VOID ? false : overrideDescendants;
    dpTouchBoundsExpansion = dpTouchBoundsExpansion === VOID ? null : dpTouchBoundsExpansion;
    Node.call(this);
    this.wa3_1 = dpTouchBoundsExpansion;
    this.xa3_1 = icon;
    this.ya3_1 = overrideDescendants;
    this.za3_1 = false;
  }
  protoOf(HoverIconModifierNode).aa4 = function (value) {
    if (!equals(this.xa3_1, value)) {
      this.xa3_1 = value;
      if (this.za3_1) {
        displayIconIfDescendantsDoNotHavePriority(this);
      }
    }
  };
  protoOf(HoverIconModifierNode).ba4 = function (value) {
    if (!(this.ya3_1 === value)) {
      this.ya3_1 = value;
      if (this.ya3_1) {
        if (this.za3_1) {
          displayIcon(this);
        }
      } else {
        if (this.za3_1) {
          displayIconFromCurrentNodeOrDescendantsWithCursorInBounds(this);
        }
      }
    }
  };
  protoOf(HoverIconModifierNode).ca5 = function () {
    return currentValueOf(this, get_LocalPointerIconService());
  };
  protoOf(HoverIconModifierNode).aa1 = function (pointerEvent, pass, bounds) {
    var tmp;
    if (pass.equals(PointerEventPass_Main_getInstance())) {
      var tmp0 = pointerEvent.ca0_1;
      var tmp$ret$0;
      $l$block: {
        // Inline function 'androidx.compose.ui.util.fastAny' call
        // Inline function 'androidx.compose.ui.util.fastForEach' call
        var inductionVariable = 0;
        var last = tmp0.n1() - 1 | 0;
        if (inductionVariable <= last)
          do {
            var index = inductionVariable;
            inductionVariable = inductionVariable + 1 | 0;
            var item = tmp0.l1(index);
            if (this.aa5(item.qa0_1)) {
              tmp$ret$0 = true;
              break $l$block;
            }
          }
           while (inductionVariable <= last);
        tmp$ret$0 = false;
      }
      tmp = tmp$ret$0;
    } else {
      tmp = false;
    }
    if (tmp) {
      if (pointerEvent.ha0_1 === Companion_getInstance_41().oa1_1) {
        onEnter(this);
      } else if (pointerEvent.ha0_1 === Companion_getInstance_41().pa1_1) {
        onExit(this);
      }
    }
  };
  protoOf(HoverIconModifierNode).xa1 = function () {
    onExit(this);
  };
  protoOf(HoverIconModifierNode).h8w = function () {
    onExit(this);
    protoOf(Node).h8w.call(this);
  };
  protoOf(HoverIconModifierNode).ea5 = function () {
    var tmp0_safe_receiver = this.wa3_1;
    var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.ha6(requireDensity(this));
    var tmp;
    var tmp_0 = tmp1_elvis_lhs;
    if ((tmp_0 == null ? null : new TouchBoundsExpansion(tmp_0)) == null) {
      tmp = Companion_getInstance_63().ia6_1;
    } else {
      tmp = tmp1_elvis_lhs;
    }
    return tmp;
  };
  var androidx_compose_ui_input_pointer_PointerInputEventProcessor$stable;
  function PointerInputEventProcessor(root) {
    this.na6_1 = root;
    this.oa6_1 = new HitPathTracker(this.na6_1.p91());
    this.pa6_1 = new PointerInputChangeEventProducer();
    this.qa6_1 = new HitTestResult();
    this.ra6_1 = false;
  }
  protoOf(PointerInputEventProcessor).sa6 = function (pointerEvent, positionCalculator, isInBounds) {
    if (this.ra6_1) {
      return ProcessResult(false, false, false);
    }
    try {
      this.ra6_1 = true;
      var internalPointerEvent = this.pa6_1.ua6(pointerEvent, positionCalculator);
      var isHover = true;
      var inductionVariable = 0;
      var last = internalPointerEvent.o9z_1.a19();
      if (inductionVariable < last)
        $l$loop: do {
          var i = inductionVariable;
          inductionVariable = inductionVariable + 1 | 0;
          var pointerInputChange = internalPointerEvent.o9z_1.s18(i);
          if (pointerInputChange.la0_1 || pointerInputChange.pa0_1) {
            isHover = false;
            break $l$loop;
          }
        }
         while (inductionVariable < last);
      var inductionVariable_0 = 0;
      var last_0 = internalPointerEvent.o9z_1.a19();
      if (inductionVariable_0 < last_0)
        do {
          var i_0 = inductionVariable_0;
          inductionVariable_0 = inductionVariable_0 + 1 | 0;
          var pointerInputChange_0 = internalPointerEvent.o9z_1.s18(i_0);
          if (isHover || changedToDownIgnoreConsumed(pointerInputChange_0)) {
            this.na6_1.va6(pointerInputChange_0.ka0_1, this.qa6_1, pointerInputChange_0.qa0_1);
            // Inline function 'kotlin.collections.isNotEmpty' call
            if (!this.qa6_1.r()) {
              this.oa6_1.z9y(pointerInputChange_0.ia0_1, this.qa6_1, changedToDownIgnoreConsumed(pointerInputChange_0));
              this.qa6_1.c3();
            }
          }
        }
         while (inductionVariable_0 < last_0);
      var dispatchedToSomething = this.oa6_1.m9z(internalPointerEvent, isInBounds);
      var tmp;
      if (internalPointerEvent.t9z_1) {
        tmp = false;
      } else {
        var result = false;
        var inductionVariable_1 = 0;
        var last_1 = internalPointerEvent.o9z_1.a19();
        if (inductionVariable_1 < last_1)
          $l$loop_0: do {
            var i_1 = inductionVariable_1;
            inductionVariable_1 = inductionVariable_1 + 1 | 0;
            var event = internalPointerEvent.o9z_1.s18(i_1);
            if (positionChangedIgnoreConsumed(event) && event.qa2()) {
              result = true;
              break $l$loop_0;
            }
          }
           while (inductionVariable_1 < last_1);
        tmp = result;
      }
      var anyMovementConsumed = tmp;
      var anyChangeConsumed = false;
      var inductionVariable_2 = 0;
      var last_2 = internalPointerEvent.o9z_1.a19();
      if (inductionVariable_2 < last_2)
        $l$loop_1: do {
          var i_2 = inductionVariable_2;
          inductionVariable_2 = inductionVariable_2 + 1 | 0;
          var change = internalPointerEvent.o9z_1.s18(i_2);
          if (change.qa2()) {
            anyChangeConsumed = true;
            break $l$loop_1;
          }
        }
         while (inductionVariable_2 < last_2);
      return ProcessResult(dispatchedToSomething, anyMovementConsumed, anyChangeConsumed);
    }finally {
      this.ra6_1 = false;
    }
  };
  protoOf(PointerInputEventProcessor).y9z = function () {
    if (!this.ra6_1) {
      this.pa6_1.c3();
      this.oa6_1.y9z();
    }
  };
  function _ProcessResult___init__impl__8o937x(value) {
    return value;
  }
  function _ProcessResult___get_value__impl__qmeswv($this) {
    return $this;
  }
  function PointerInputData(uptime, positionOnScreen, down) {
    this.za6_1 = uptime;
    this.aa7_1 = positionOnScreen;
    this.ba7_1 = down;
  }
  function PointerInputChangeEventProducer() {
    this.ta6_1 = new LongSparseArray();
  }
  protoOf(PointerInputChangeEventProducer).ua6 = function (pointerInputEvent, positionCalculator) {
    var changes = new LongSparseArray(pointerInputEvent.ea7_1.n1());
    // Inline function 'androidx.compose.ui.util.fastForEach' call
    var this_0 = pointerInputEvent.ea7_1;
    var inductionVariable = 0;
    var last = this_0.n1() - 1 | 0;
    if (inductionVariable <= last)
      do {
        var index = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var item = this_0.l1(index);
        var previousTime;
        var previousPosition;
        var previousDown;
        var previousData = this.ta6_1.lx(_PointerId___get_value__impl__odqw2d(item.ya1_1));
        if (previousData == null) {
          previousTime = item.za1_1;
          previousPosition = item.ba2_1;
          previousDown = false;
        } else {
          previousTime = previousData.za6_1;
          previousDown = previousData.ba7_1;
          previousPosition = positionCalculator.ja7(previousData.aa7_1);
        }
        changes.z18(_PointerId___get_value__impl__odqw2d(item.ya1_1), PointerInputChange_init_$Create$(item.ya1_1, item.za1_1, item.ba2_1, item.ca2_1, item.da2_1, previousTime, previousPosition, previousDown, false, item.ea2_1, item.ga2_1, item.ha2_1, item.ia2_1, item.ja2_1, item.ka2_1));
        if (item.ca2_1) {
          this.ta6_1.z18(_PointerId___get_value__impl__odqw2d(item.ya1_1), new PointerInputData(item.za1_1, item.aa2_1, item.ca2_1));
        } else {
          this.ta6_1.y18(_PointerId___get_value__impl__odqw2d(item.ya1_1));
        }
      }
       while (inductionVariable <= last);
    return InternalPointerEvent_init_$Create$(changes, pointerInputEvent);
  };
  protoOf(PointerInputChangeEventProducer).c3 = function () {
    this.ta6_1.c3();
  };
  function ProcessResult(dispatchedToAPointerInputModifier, anyMovementConsumed, anyChangeConsumed) {
    // Inline function 'androidx.compose.ui.input.pointer.toInt' call
    var tmp = dispatchedToAPointerInputModifier ? 1 : 0;
    // Inline function 'androidx.compose.ui.input.pointer.toInt' call
    var tmp_0 = tmp | (anyMovementConsumed ? 1 : 0) << 1;
    // Inline function 'androidx.compose.ui.input.pointer.toInt' call
    var tmp$ret$2 = anyChangeConsumed ? 1 : 0;
    return _ProcessResult___init__impl__8o937x(tmp_0 | tmp$ret$2 << 2);
  }
  function get_EmptyPointerEvent() {
    _init_properties_SuspendingPointerInputFilter_kt__r2lt1n();
    return EmptyPointerEvent;
  }
  var EmptyPointerEvent;
  var androidx_compose_ui_input_pointer_SuspendPointerInputElement$stable;
  var androidx_compose_ui_input_pointer_SuspendingPointerInputModifierNodeImpl$stable;
  var androidx_compose_ui_input_pointer_PointerInputResetException$stable;
  var androidx_compose_ui_input_pointer_CancelTimeoutCancellationException$stable;
  function pointerInput(_this__u8e3s4, key1, block) {
    _init_properties_SuspendingPointerInputFilter_kt__r2lt1n();
    return _this__u8e3s4.d8v(new SuspendPointerInputElement(key1, VOID, VOID, block));
  }
  function PointerInputEventHandler() {
  }
  function PointerInputScope() {
  }
  function AwaitPointerEventScope() {
  }
  function SuspendingPointerInputModifierNode(pointerInputEventHandler) {
    _init_properties_SuspendingPointerInputFilter_kt__r2lt1n();
    return new SuspendingPointerInputModifierNodeImpl(null, null, null, pointerInputEventHandler);
  }
  function pointerInput_0(_this__u8e3s4, key1, key2, block) {
    _init_properties_SuspendingPointerInputFilter_kt__r2lt1n();
    return _this__u8e3s4.d8v(new SuspendPointerInputElement(key1, key2, VOID, block));
  }
  function SuspendPointerInputElement(key1, key2, keys, pointerInputEventHandler) {
    key1 = key1 === VOID ? null : key1;
    key2 = key2 === VOID ? null : key2;
    keys = keys === VOID ? null : keys;
    ModifierNodeElement.call(this);
    this.ua7_1 = key1;
    this.va7_1 = key2;
    this.wa7_1 = keys;
    this.xa7_1 = pointerInputEventHandler;
  }
  protoOf(SuspendPointerInputElement).r3d = function () {
    return new SuspendingPointerInputModifierNodeImpl(this.ua7_1, this.va7_1, this.wa7_1, this.xa7_1);
  };
  protoOf(SuspendPointerInputElement).ya7 = function (node) {
    node.aa9(this.ua7_1, this.va7_1, this.wa7_1, this.xa7_1);
  };
  protoOf(SuspendPointerInputElement).d8y = function (node) {
    return this.ya7(node instanceof SuspendingPointerInputModifierNodeImpl ? node : THROW_CCE());
  };
  protoOf(SuspendPointerInputElement).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof SuspendPointerInputElement))
      return false;
    if (!equals(this.ua7_1, other.ua7_1))
      return false;
    if (!equals(this.va7_1, other.va7_1))
      return false;
    if (!(this.wa7_1 == null)) {
      if (other.wa7_1 == null)
        return false;
      if (!contentEquals(this.wa7_1, other.wa7_1))
        return false;
    } else if (!(other.wa7_1 == null))
      return false;
    return this.xa7_1 === other.xa7_1;
  };
  protoOf(SuspendPointerInputElement).hashCode = function () {
    var tmp0_safe_receiver = this.ua7_1;
    var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : hashCode(tmp0_safe_receiver);
    var result = tmp1_elvis_lhs == null ? 0 : tmp1_elvis_lhs;
    var tmp = imul(31, result);
    var tmp2_safe_receiver = this.va7_1;
    var tmp3_elvis_lhs = tmp2_safe_receiver == null ? null : hashCode(tmp2_safe_receiver);
    result = tmp + (tmp3_elvis_lhs == null ? 0 : tmp3_elvis_lhs) | 0;
    var tmp_0 = imul(31, result);
    var tmp4_safe_receiver = this.wa7_1;
    var tmp5_elvis_lhs = tmp4_safe_receiver == null ? null : contentHashCode(tmp4_safe_receiver);
    result = tmp_0 + (tmp5_elvis_lhs == null ? 0 : tmp5_elvis_lhs) | 0;
    result = imul(31, result) + hashCode(this.xa7_1) | 0;
    return result;
  };
  function SuspendingPointerInputModifierNodeImpl$PointerEventHandlerCoroutine$withTimeout$slambda($timeMillis, this$0, resultContinuation) {
    this.ja9_1 = $timeMillis;
    this.ka9_1 = this$0;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(SuspendingPointerInputModifierNodeImpl$PointerEventHandlerCoroutine$withTimeout$slambda).p24 = function ($this$launch, $completion) {
    var tmp = this.q24($this$launch, $completion);
    tmp.p9_1 = Unit_instance;
    tmp.q9_1 = null;
    return tmp.v9();
  };
  protoOf(SuspendingPointerInputModifierNodeImpl$PointerEventHandlerCoroutine$withTimeout$slambda).ja = function (p1, $completion) {
    return this.p24((!(p1 == null) ? isInterface(p1, CoroutineScope_0) : false) ? p1 : THROW_CCE(), $completion);
  };
  protoOf(SuspendingPointerInputModifierNodeImpl$PointerEventHandlerCoroutine$withTimeout$slambda).v9 = function () {
    var suspendResult = this.p9_1;
    $sm: do
      try {
        var tmp = this.n9_1;
        switch (tmp) {
          case 0:
            this.o9_1 = 3;
            this.n9_1 = 1;
            suspendResult = delay(subtract(this.ja9_1, new Long(8, 0)), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            this.n9_1 = 2;
            suspendResult = delay(new Long(8, 0), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 2:
            var tmp0_safe_receiver = this.ka9_1.oa9_1;
            if (tmp0_safe_receiver == null)
              null;
            else {
              var exception = new PointerEventTimeoutCancellationException(this.ja9_1);
              tmp0_safe_receiver.y9(_Result___init__impl__xyqfz8(createFailure(exception)));
            }

            return Unit_instance;
          case 3:
            throw this.q9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.o9_1 === 3) {
          throw e;
        } else {
          this.n9_1 = this.o9_1;
          this.q9_1 = e;
        }
      }
     while (true);
  };
  protoOf(SuspendingPointerInputModifierNodeImpl$PointerEventHandlerCoroutine$withTimeout$slambda).q24 = function ($this$launch, completion) {
    var i = new SuspendingPointerInputModifierNodeImpl$PointerEventHandlerCoroutine$withTimeout$slambda(this.ja9_1, this.ka9_1, completion);
    i.la9_1 = $this$launch;
    return i;
  };
  function SuspendingPointerInputModifierNodeImpl$PointerEventHandlerCoroutine$withTimeout$slambda_0($timeMillis, this$0, resultContinuation) {
    var i = new SuspendingPointerInputModifierNodeImpl$PointerEventHandlerCoroutine$withTimeout$slambda($timeMillis, this$0, resultContinuation);
    return constructCallableReference(function ($this$launch, $completion) {
      return i.p24($this$launch, $completion);
    }, 1);
  }
  function $withTimeoutOrNullCOROUTINE$(_this__u8e3s4, timeMillis, block, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.aaa_1 = _this__u8e3s4;
    this.baa_1 = timeMillis;
    this.caa_1 = block;
  }
  protoOf($withTimeoutOrNullCOROUTINE$).v9 = function () {
    var suspendResult = this.p9_1;
    $sm: do
      try {
        var tmp = this.n9_1;
        switch (tmp) {
          case 0:
            this.o9_1 = 3;
            this.o9_1 = 2;
            this.n9_1 = 1;
            suspendResult = this.aaa_1.sa7(this.baa_1, this.caa_1, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            this.daa_1 = suspendResult;
            this.o9_1 = 3;
            this.n9_1 = 4;
            continue $sm;
          case 2:
            this.o9_1 = 3;
            var tmp_0 = this.q9_1;
            if (tmp_0 instanceof PointerEventTimeoutCancellationException) {
              var _unused_var__etf5q3 = this.q9_1;
              var tmp_1 = this;
              tmp_1.daa_1 = null;
              this.n9_1 = 4;
              continue $sm;
            } else {
              throw this.q9_1;
            }

          case 3:
            throw this.q9_1;
          case 4:
            this.o9_1 = 3;
            return this.daa_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.o9_1 === 3) {
          throw e;
        } else {
          this.n9_1 = this.o9_1;
          this.q9_1 = e;
        }
      }
     while (true);
  };
  function $withTimeoutCOROUTINE$(_this__u8e3s4, timeMillis, block, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.maa_1 = _this__u8e3s4;
    this.naa_1 = timeMillis;
    this.oaa_1 = block;
  }
  protoOf($withTimeoutCOROUTINE$).v9 = function () {
    var suspendResult = this.p9_1;
    $sm: do
      try {
        var tmp = this.n9_1;
        switch (tmp) {
          case 0:
            this.o9_1 = 7;
            if (compare(this.naa_1, new Long(0, 0)) <= 0) {
              var tmp0_safe_receiver = this.maa_1.oa9_1;
              if (tmp0_safe_receiver == null)
                null;
              else {
                var exception = new PointerEventTimeoutCancellationException(this.naa_1);
                tmp0_safe_receiver.y9(_Result___init__impl__xyqfz8(createFailure(exception)));
              }
            }

            var tmp_0 = this;
            var tmp_1 = this.maa_1.ra9_1.a8w();
            tmp_0.paa_1 = launch(tmp_1, VOID, VOID, SuspendingPointerInputModifierNodeImpl$PointerEventHandlerCoroutine$withTimeout$slambda_0(this.naa_1, this.maa_1, null));
            this.n9_1 = 1;
            continue $sm;
          case 1:
            this.n9_1 = 2;
            continue $sm;
          case 2:
            this.o9_1 = 6;
            this.n9_1 = 3;
            suspendResult = this.oaa_1(this.maa_1, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 3:
            this.qaa_1 = suspendResult;
            this.o9_1 = 7;
            this.n9_1 = 4;
            var tmp_2 = this;
            continue $sm;
          case 4:
            var tmp_3 = this.qaa_1;
            this.o9_1 = 7;
            this.paa_1.a1b(CancelTimeoutCancellationException_getInstance());
            return tmp_3;
          case 5:
            this.o9_1 = 7;
            this.paa_1.a1b(CancelTimeoutCancellationException_getInstance());
            return Unit_instance;
          case 6:
            this.o9_1 = 7;
            var t = this.q9_1;
            this.paa_1.a1b(CancelTimeoutCancellationException_getInstance());
            throw t;
          case 7:
            throw this.q9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.o9_1 === 7) {
          throw e;
        } else {
          this.n9_1 = this.o9_1;
          this.q9_1 = e;
        }
      }
     while (true);
  };
  function dispatchPointerEvent($this, pointerEvent, pass) {
    // Inline function 'androidx.compose.ui.input.pointer.SuspendingPointerInputModifierNodeImpl.forEachCurrentPointerHandler' call
    // Inline function 'androidx.compose.ui.platform.synchronized' call
    // Inline function 'kotlinx.atomicfu.locks.synchronized' call
    $this.va8_1;
    var tmp0 = $this.wa8_1;
    // Inline function 'androidx.compose.runtime.collection.MutableVector.addAll' call
    var elements = $this.ua8_1;
    tmp0.m4a(tmp0.d3e_1, elements);
    try {
      switch (pass.a1_1) {
        case 0:
        case 2:
          // Inline function 'androidx.compose.runtime.collection.MutableVector.forEach' call

          var this_0 = $this.wa8_1;
          var i = 0;
          var tmp = this_0.b3e_1;
          var content = isArray(tmp) ? tmp : THROW_CCE();
          var size = this_0.d3e_1;
          while (i < size) {
            content[i].raa(pointerEvent, pass);
            i = i + 1 | 0;
          }

          break;
        case 1:
          var tmp0_0 = $this.wa8_1;
          $l$block: {
            // Inline function 'androidx.compose.runtime.collection.MutableVector.forEachReversed' call
            var i_0 = tmp0_0.d3e_1 - 1 | 0;
            var tmp_0 = tmp0_0.b3e_1;
            var content_0 = isArray(tmp_0) ? tmp_0 : THROW_CCE();
            if (i_0 >= content_0.length) {
              break $l$block;
            }
            while (i_0 >= 0) {
              content_0[i_0].raa(pointerEvent, pass);
              i_0 = i_0 - 1 | 0;
            }
          }

          break;
        default:
          noWhenBranchMatchedException();
          break;
      }
    }finally {
      $this.wa8_1.c3();
    }
  }
  function PointerEventHandlerCoroutine($outer, completion) {
    this.ra9_1 = $outer;
    this.ma9_1 = this.ra9_1;
    this.na9_1 = completion;
    this.oa9_1 = null;
    this.pa9_1 = PointerEventPass_Main_getInstance();
    this.qa9_1 = EmptyCoroutineContext_getInstance();
  }
  protoOf(PointerEventHandlerCoroutine).oa7 = function () {
    return this.ra9_1.ta8_1;
  };
  protoOf(PointerEventHandlerCoroutine).q95 = function () {
    return this.ra9_1.ya8_1;
  };
  protoOf(PointerEventHandlerCoroutine).la7 = function () {
    return this.ra9_1.la7();
  };
  protoOf(PointerEventHandlerCoroutine).na7 = function () {
    return this.ra9_1.na7();
  };
  protoOf(PointerEventHandlerCoroutine).raa = function (event, pass) {
    if (pass.equals(this.pa9_1)) {
      var tmp0_safe_receiver = this.oa9_1;
      if (tmp0_safe_receiver == null)
        null;
      else {
        // Inline function 'kotlin.run' call
        this.oa9_1 = null;
        // Inline function 'kotlin.coroutines.resume' call
        // Inline function 'kotlin.Companion.success' call
        var tmp$ret$3 = _Result___init__impl__xyqfz8(event);
        tmp0_safe_receiver.y9(tmp$ret$3);
      }
    }
  };
  protoOf(PointerEventHandlerCoroutine).saa = function (cause) {
    var tmp0_safe_receiver = this.oa9_1;
    if (tmp0_safe_receiver == null)
      null;
    else
      tmp0_safe_receiver.d1d(cause);
    this.oa9_1 = null;
  };
  protoOf(PointerEventHandlerCoroutine).t9 = function () {
    return this.qa9_1;
  };
  protoOf(PointerEventHandlerCoroutine).zq = function (result) {
    // Inline function 'androidx.compose.ui.platform.synchronized' call
    // Inline function 'kotlinx.atomicfu.locks.synchronized' call
    this.ra9_1.va8_1;
    // Inline function 'androidx.compose.runtime.collection.MutableVector.minusAssign' call
    this.ra9_1.ua8_1.g10(this);
    this.na9_1.y9(result);
  };
  protoOf(PointerEventHandlerCoroutine).y9 = function (result) {
    return this.zq(result);
  };
  protoOf(PointerEventHandlerCoroutine).pa7 = function (pass, $completion) {
    var cancellable = new CancellableContinuationImpl(intercepted($completion), 1);
    cancellable.v1e();
    this.pa9_1 = pass;
    this.oa9_1 = cancellable;
    return cancellable.x1b();
  };
  protoOf(PointerEventHandlerCoroutine).ra7 = function (timeMillis, block, $completion) {
    var tmp = new $withTimeoutOrNullCOROUTINE$(this, timeMillis, block, $completion);
    tmp.p9_1 = Unit_instance;
    tmp.q9_1 = null;
    return tmp.v9();
  };
  protoOf(PointerEventHandlerCoroutine).sa7 = function (timeMillis, block, $completion) {
    var tmp = new $withTimeoutCOROUTINE$(this, timeMillis, block, $completion);
    tmp.p9_1 = Unit_instance;
    tmp.q9_1 = null;
    return tmp.v9();
  };
  protoOf(PointerEventHandlerCoroutine).v5e = function (_this__u8e3s4) {
    return this.ma9_1.v5e(_this__u8e3s4);
  };
  protoOf(PointerEventHandlerCoroutine).x5e = function (_this__u8e3s4) {
    return this.ma9_1.x5e(_this__u8e3s4);
  };
  protoOf(PointerEventHandlerCoroutine).w5e = function (_this__u8e3s4) {
    return this.ma9_1.w5e(_this__u8e3s4);
  };
  protoOf(PointerEventHandlerCoroutine).c5f = function (_this__u8e3s4) {
    return this.ma9_1.c5f(_this__u8e3s4);
  };
  protoOf(PointerEventHandlerCoroutine).d5f = function (_this__u8e3s4) {
    return this.ma9_1.d5f(_this__u8e3s4);
  };
  protoOf(PointerEventHandlerCoroutine).e5f = function (_this__u8e3s4) {
    return this.ma9_1.e5f(_this__u8e3s4);
  };
  protoOf(PointerEventHandlerCoroutine).b5f = function (_this__u8e3s4) {
    return this.ma9_1.b5f(_this__u8e3s4);
  };
  protoOf(PointerEventHandlerCoroutine).f5f = function (_this__u8e3s4) {
    return this.ma9_1.f5f(_this__u8e3s4);
  };
  protoOf(PointerEventHandlerCoroutine).g5f = function (_this__u8e3s4) {
    return this.ma9_1.g5f(_this__u8e3s4);
  };
  protoOf(PointerEventHandlerCoroutine).u5e = function () {
    return this.ma9_1.u5e();
  };
  protoOf(PointerEventHandlerCoroutine).j5f = function () {
    return this.ma9_1.j5f();
  };
  function SuspendingPointerInputModifierNodeImpl$onPointerEvent$slambda(this$0, resultContinuation) {
    this.bab_1 = this$0;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(SuspendingPointerInputModifierNodeImpl$onPointerEvent$slambda).p24 = function ($this$launch, $completion) {
    var tmp = this.q24($this$launch, $completion);
    tmp.p9_1 = Unit_instance;
    tmp.q9_1 = null;
    return tmp.v9();
  };
  protoOf(SuspendingPointerInputModifierNodeImpl$onPointerEvent$slambda).ja = function (p1, $completion) {
    return this.p24((!(p1 == null) ? isInterface(p1, CoroutineScope_0) : false) ? p1 : THROW_CCE(), $completion);
  };
  protoOf(SuspendingPointerInputModifierNodeImpl$onPointerEvent$slambda).v9 = function () {
    var suspendResult = this.p9_1;
    $sm: do
      try {
        var tmp = this.n9_1;
        switch (tmp) {
          case 0:
            this.o9_1 = 4;
            if (!(this.bab_1.qa8_1 == null)) {
              this.n9_1 = 2;
              suspendResult = ensureNotNull(this.bab_1.qa8_1)(this.bab_1, this);
              if (suspendResult === get_COROUTINE_SUSPENDED()) {
                return suspendResult;
              }
              continue $sm;
            } else {
              var $this$with = this.bab_1.dab();
              this.n9_1 = 1;
              suspendResult = $this$with.ka7(this.bab_1, this);
              if (suspendResult === get_COROUTINE_SUSPENDED()) {
                return suspendResult;
              }
              continue $sm;
            }

          case 1:
            this.n9_1 = 3;
            continue $sm;
          case 2:
            this.n9_1 = 3;
            continue $sm;
          case 3:
            return Unit_instance;
          case 4:
            throw this.q9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.o9_1 === 4) {
          throw e;
        } else {
          this.n9_1 = this.o9_1;
          this.q9_1 = e;
        }
      }
     while (true);
  };
  protoOf(SuspendingPointerInputModifierNodeImpl$onPointerEvent$slambda).q24 = function ($this$launch, completion) {
    var i = new SuspendingPointerInputModifierNodeImpl$onPointerEvent$slambda(this.bab_1, completion);
    i.cab_1 = $this$launch;
    return i;
  };
  function SuspendingPointerInputModifierNodeImpl$onPointerEvent$slambda_0(this$0, resultContinuation) {
    var i = new SuspendingPointerInputModifierNodeImpl$onPointerEvent$slambda(this$0, resultContinuation);
    return constructCallableReference(function ($this$launch, $completion) {
      return i.p24($this$launch, $completion);
    }, 1);
  }
  function SuspendingPointerInputModifierNodeImpl$awaitPointerEventScope$lambda($handlerCoroutine) {
    return function (it) {
      $handlerCoroutine.saa(it);
      return Unit_instance;
    };
  }
  function SuspendingPointerInputModifierNodeImpl(key1, key2, keys, pointerInputEventHandler) {
    key1 = key1 === VOID ? null : key1;
    key2 = key2 === VOID ? null : key2;
    keys = keys === VOID ? null : keys;
    Node.call(this);
    this.na8_1 = key1;
    this.oa8_1 = key2;
    this.pa8_1 = keys;
    this.qa8_1 = null;
    this.ra8_1 = pointerInputEventHandler;
    this.sa8_1 = null;
    this.ta8_1 = get_EmptyPointerEvent();
    var tmp = this;
    // Inline function 'androidx.compose.runtime.collection.mutableVectorOf' call
    // Inline function 'androidx.compose.runtime.collection.MutableVector' call
    // Inline function 'kotlin.arrayOfNulls' call
    var tmp$ret$2 = Array(16);
    tmp.ua8_1 = new MutableVector(tmp$ret$2, 0);
    var tmp_0 = this;
    // Inline function 'androidx.compose.ui.platform.makeSynchronizedObject' call
    this.ua8_1;
    tmp_0.va8_1 = new SynchronizedObject();
    var tmp_1 = this;
    // Inline function 'androidx.compose.runtime.collection.mutableVectorOf' call
    // Inline function 'androidx.compose.runtime.collection.MutableVector' call
    // Inline function 'kotlin.arrayOfNulls' call
    var tmp$ret$6 = Array(16);
    tmp_1.wa8_1 = new MutableVector(tmp$ret$6, 0);
    this.xa8_1 = null;
    this.ya8_1 = Companion_getInstance_0().n5g_1;
    this.za8_1 = false;
  }
  protoOf(SuspendingPointerInputModifierNodeImpl).dab = function () {
    return this.ra8_1;
  };
  protoOf(SuspendingPointerInputModifierNodeImpl).u5e = function () {
    return requireLayoutNode(this).w90_1.u5e();
  };
  protoOf(SuspendingPointerInputModifierNodeImpl).j5f = function () {
    return requireLayoutNode(this).w90_1.j5f();
  };
  protoOf(SuspendingPointerInputModifierNodeImpl).la7 = function () {
    return requireLayoutNode(this).y90_1;
  };
  protoOf(SuspendingPointerInputModifierNodeImpl).q95 = function () {
    return this.ya8_1;
  };
  protoOf(SuspendingPointerInputModifierNodeImpl).na7 = function () {
    var minimumTouchTargetSize = this.f5f(this.la7().eab());
    var size = this.q95();
    // Inline function 'androidx.compose.ui.geometry.Size.width' call
    // Inline function 'androidx.compose.ui.util.unpackFloat1' call
    var value = _Size___get_packedValue__impl__7rlt1o(minimumTouchTargetSize);
    // Inline function 'androidx.compose.ui.util.floatFromBits' call
    // Inline function 'kotlin.fromBits' call
    var bits = convertToInt(shiftRight(value, 32));
    var tmp = floatFromBits(bits);
    // Inline function 'androidx.compose.ui.unit.IntSize.width' call
    // Inline function 'androidx.compose.ui.util.unpackInt1' call
    var value_0 = _IntSize___get_packedValue__impl__uho7jf(size);
    // Inline function 'kotlin.math.max' call
    var b = tmp - convertToInt(shiftRight(value_0, 32));
    var horizontal = Math.max(0.0, b) / 2.0;
    // Inline function 'androidx.compose.ui.geometry.Size.height' call
    // Inline function 'androidx.compose.ui.util.unpackFloat2' call
    var value_1 = _Size___get_packedValue__impl__7rlt1o(minimumTouchTargetSize);
    // Inline function 'androidx.compose.ui.util.floatFromBits' call
    // Inline function 'kotlin.fromBits' call
    var bits_0 = convertToInt(bitwiseAnd(value_1, new Long(-1, 0)));
    var tmp_0 = floatFromBits(bits_0);
    // Inline function 'androidx.compose.ui.unit.IntSize.height' call
    // Inline function 'androidx.compose.ui.util.unpackInt2' call
    var value_2 = _IntSize___get_packedValue__impl__uho7jf(size);
    // Inline function 'kotlin.math.max' call
    var b_0 = tmp_0 - convertToInt(bitwiseAnd(value_2, new Long(-1, 0)));
    var vertical = Math.max(0.0, b_0) / 2.0;
    // Inline function 'androidx.compose.ui.geometry.Size' call
    // Inline function 'androidx.compose.ui.util.packFloats' call
    var v1 = fromInt(toRawBits(horizontal));
    var v2 = fromInt(toRawBits(vertical));
    var tmp$ret$15 = bitwiseOr(shiftLeft(v1, 32), bitwiseAnd(v2, new Long(-1, 0)));
    return _Size___init__impl__aywn0g(tmp$ret$15);
  };
  protoOf(SuspendingPointerInputModifierNodeImpl).h8w = function () {
    this.fab();
    protoOf(Node).h8w.call(this);
  };
  protoOf(SuspendingPointerInputModifierNodeImpl).n8w = function () {
    this.fab();
  };
  protoOf(SuspendingPointerInputModifierNodeImpl).ha5 = function () {
    this.fab();
  };
  protoOf(SuspendingPointerInputModifierNodeImpl).fab = function () {
    var localJob = this.sa8_1;
    if (!(localJob == null)) {
      localJob.a1b(new PointerInputResetException());
      this.sa8_1 = null;
    }
  };
  protoOf(SuspendingPointerInputModifierNodeImpl).aa9 = function (key1, key2, keys, pointerInputEventHandler) {
    var needsReset = false;
    if (!equals(this.na8_1, key1)) {
      needsReset = true;
    }
    this.na8_1 = key1;
    if (!equals(this.oa8_1, key2)) {
      needsReset = true;
    }
    this.oa8_1 = key2;
    if (!(this.pa8_1 == null) && keys == null) {
      needsReset = true;
    }
    if (this.pa8_1 == null && !(keys == null)) {
      needsReset = true;
    }
    if (!(this.pa8_1 == null) && !(keys == null) && !contentEquals(keys, this.pa8_1)) {
      needsReset = true;
    }
    this.pa8_1 = keys;
    if (!getKClassFromExpression(this.dab()).equals(getKClassFromExpression(pointerInputEventHandler))) {
      needsReset = true;
    }
    if (needsReset) {
      this.fab();
    }
    this.ra8_1 = pointerInputEventHandler;
  };
  protoOf(SuspendingPointerInputModifierNodeImpl).aa1 = function (pointerEvent, pass, bounds) {
    this.ya8_1 = bounds;
    if (pass.equals(PointerEventPass_Initial_getInstance())) {
      this.ta8_1 = pointerEvent;
    }
    if (this.sa8_1 == null) {
      var tmp = this;
      var tmp_0 = this.a8w();
      var tmp_1 = CoroutineStart_UNDISPATCHED_getInstance();
      tmp.sa8_1 = launch(tmp_0, VOID, tmp_1, SuspendingPointerInputModifierNodeImpl$onPointerEvent$slambda_0(this, null));
    }
    dispatchPointerEvent(this, pointerEvent, pass);
    var tmp_2 = this;
    // Inline function 'kotlin.takeIf' call
    var tmp_3;
    var tmp0 = pointerEvent.ca0_1;
    var tmp$ret$2;
    $l$block: {
      // Inline function 'androidx.compose.ui.util.fastAll' call
      // Inline function 'androidx.compose.ui.util.fastForEach' call
      var inductionVariable = 0;
      var last = tmp0.n1() - 1 | 0;
      if (inductionVariable <= last)
        do {
          var index = inductionVariable;
          inductionVariable = inductionVariable + 1 | 0;
          var item = tmp0.l1(index);
          if (!changedToUpIgnoreConsumed(item)) {
            tmp$ret$2 = false;
            break $l$block;
          }
        }
         while (inductionVariable <= last);
      tmp$ret$2 = true;
    }
    if (!tmp$ret$2) {
      tmp_3 = pointerEvent;
    } else {
      tmp_3 = null;
    }
    tmp_2.xa8_1 = tmp_3;
  };
  protoOf(SuspendingPointerInputModifierNodeImpl).xa1 = function () {
    var tmp0_elvis_lhs = this.xa8_1;
    var tmp;
    if (tmp0_elvis_lhs == null) {
      return Unit_instance;
    } else {
      tmp = tmp0_elvis_lhs;
    }
    var lastEvent = tmp;
    var tmp0 = lastEvent.ca0_1;
    var tmp$ret$0;
    $l$block: {
      // Inline function 'androidx.compose.ui.util.fastAll' call
      // Inline function 'androidx.compose.ui.util.fastForEach' call
      var inductionVariable = 0;
      var last = tmp0.n1() - 1 | 0;
      if (inductionVariable <= last)
        do {
          var index = inductionVariable;
          inductionVariable = inductionVariable + 1 | 0;
          var item = tmp0.l1(index);
          if (!!item.la0_1) {
            tmp$ret$0 = false;
            break $l$block;
          }
        }
         while (inductionVariable <= last);
      tmp$ret$0 = true;
    }
    if (tmp$ret$0) {
      return Unit_instance;
    }
    // Inline function 'androidx.compose.ui.util.fastMapNotNull' call
    var this_0 = lastEvent.ca0_1;
    var target = ArrayList_init_$Create$_0(this_0.n1());
    // Inline function 'androidx.compose.ui.util.fastForEach' call
    var inductionVariable_0 = 0;
    var last_0 = this_0.n1() - 1 | 0;
    if (inductionVariable_0 <= last_0)
      do {
        var index_0 = inductionVariable_0;
        inductionVariable_0 = inductionVariable_0 + 1 | 0;
        var item_0 = this_0.l1(index_0);
        var tmp0_id = item_0.ia0_1;
        var tmp1_position = item_0.ka0_1;
        var tmp2_uptimeMillis = item_0.ja0_1;
        var tmp3_pressure = item_0.ma0_1;
        var tmp4_previousPosition = item_0.ka0_1;
        var tmp5_previousUptimeMillis = item_0.ja0_1;
        var tmp6_previousPressed = item_0.la0_1;
        var tmp7_isInitiallyConsumed = item_0.la0_1;
        var tmp8_type = item_0.qa0_1;
        var tmp0_safe_receiver = new PointerInputChange(tmp0_id, tmp2_uptimeMillis, tmp1_position, false, tmp3_pressure, tmp5_previousUptimeMillis, tmp4_previousPosition, tmp6_previousPressed, tmp7_isInitiallyConsumed, tmp8_type);
        if (tmp0_safe_receiver == null)
          null;
        else {
          // Inline function 'kotlin.let' call
          // Inline function 'kotlin.collections.plusAssign' call
          target.j1(tmp0_safe_receiver);
        }
      }
       while (inductionVariable_0 <= last_0);
    var newChanges = target;
    var cancelEvent = PointerEvent_init_$Create$_0(newChanges);
    this.ta8_1 = cancelEvent;
    dispatchPointerEvent(this, cancelEvent, PointerEventPass_Initial_getInstance());
    dispatchPointerEvent(this, cancelEvent, PointerEventPass_Main_getInstance());
    dispatchPointerEvent(this, cancelEvent, PointerEventPass_Final_getInstance());
    this.xa8_1 = null;
  };
  protoOf(SuspendingPointerInputModifierNodeImpl).ma7 = function (block, $completion) {
    var cancellable = new CancellableContinuationImpl(intercepted($completion), 1);
    cancellable.v1e();
    var handlerCoroutine = new PointerEventHandlerCoroutine(this, cancellable);
    // Inline function 'androidx.compose.ui.platform.synchronized' call
    // Inline function 'kotlinx.atomicfu.locks.synchronized' call
    this.va8_1;
    // Inline function 'androidx.compose.runtime.collection.MutableVector.plusAssign' call
    this.ua8_1.zz(handlerCoroutine);
    // Inline function 'kotlin.coroutines.resume' call
    var this_0 = createCoroutine(block, handlerCoroutine, handlerCoroutine);
    // Inline function 'kotlin.Companion.success' call
    var tmp$ret$7 = _Result___init__impl__xyqfz8(Unit_instance);
    this_0.y9(tmp$ret$7);
    cancellable.f1d(SuspendingPointerInputModifierNodeImpl$awaitPointerEventScope$lambda(handlerCoroutine));
    return cancellable.x1b();
  };
  function PointerInputResetException() {
    PlatformOptimizedCancellationException.call(this, 'Pointer input was reset');
    captureStack(this, PointerInputResetException);
  }
  function CancelTimeoutCancellationException() {
    CancelTimeoutCancellationException_instance = this;
    PlatformOptimizedCancellationException.call(this);
    captureStack(this, CancelTimeoutCancellationException);
  }
  var CancelTimeoutCancellationException_instance;
  function CancelTimeoutCancellationException_getInstance() {
    if (CancelTimeoutCancellationException_instance == null)
      new CancelTimeoutCancellationException();
    return CancelTimeoutCancellationException_instance;
  }
  var properties_initialized_SuspendingPointerInputFilter_kt_pwugul;
  function _init_properties_SuspendingPointerInputFilter_kt__r2lt1n() {
    if (!properties_initialized_SuspendingPointerInputFilter_kt_pwugul) {
      properties_initialized_SuspendingPointerInputFilter_kt_pwugul = true;
      EmptyPointerEvent = PointerEvent_init_$Create$_0(emptyList());
      androidx_compose_ui_input_pointer_SuspendPointerInputElement$stable = 0;
      androidx_compose_ui_input_pointer_SuspendingPointerInputModifierNodeImpl$stable = 0;
      androidx_compose_ui_input_pointer_PointerInputResetException$stable = 8;
      androidx_compose_ui_input_pointer_CancelTimeoutCancellationException$stable = 8;
    }
  }
  var androidx_compose_ui_input_pointer_util_DefaultVelocityTracker$stable;
  var androidx_compose_ui_input_pointer_util_PointerIdArray$stable;
  function resizeStorage($this, minSize) {
    var tmp = $this.l9z_1;
    // Inline function 'kotlin.comparisons.maxOf' call
    var b = imul($this.l9z_1.length, 2);
    var tmp$ret$0 = Math.max(minSize, b);
    // Inline function 'kotlin.apply' call
    var this_0 = copyOf(tmp, tmp$ret$0);
    $this.l9z_1 = this_0;
    return this_0;
  }
  function PointerIdArray() {
    this.k9z_1 = 0;
    this.l9z_1 = longArray(2);
  }
  protoOf(PointerIdArray).ia1 = function (index) {
    return _PointerId___init__impl__w2urwh(this.l9z_1[index]);
  };
  protoOf(PointerIdArray).kx = function (pointerIdValue) {
    var inductionVariable = 0;
    var last = this.k9z_1;
    if (inductionVariable < last)
      do {
        var i = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        if (equalsLong(pointerIdValue, this.l9z_1[i])) {
          var inductionVariable_0 = i;
          var last_0 = this.k9z_1 - 1 | 0;
          if (inductionVariable_0 < last_0)
            do {
              var j = inductionVariable_0;
              inductionVariable_0 = inductionVariable_0 + 1 | 0;
              this.l9z_1[j] = this.l9z_1[j + 1 | 0];
            }
             while (inductionVariable_0 < last_0);
          this.k9z_1 = this.k9z_1 - 1 | 0;
          return true;
        }
      }
       while (inductionVariable < last);
    return false;
  };
  protoOf(PointerIdArray).h3 = function (index) {
    if (index < this.k9z_1) {
      var inductionVariable = index;
      var last = this.k9z_1 - 1 | 0;
      if (inductionVariable < last)
        do {
          var i = inductionVariable;
          inductionVariable = inductionVariable + 1 | 0;
          this.l9z_1[i] = this.l9z_1[i + 1 | 0];
        }
         while (inductionVariable < last);
      this.k9z_1 = this.k9z_1 - 1 | 0;
      return true;
    }
    return false;
  };
  protoOf(PointerIdArray).r = function () {
    return this.k9z_1 === 0;
  };
  protoOf(PointerIdArray).uw = function (value) {
    if (!this.lm(value)) {
      this.gab(this.k9z_1, value);
      return true;
    }
    return false;
  };
  protoOf(PointerIdArray).gab = function (index, value) {
    var internalArray = this.l9z_1;
    if (index >= internalArray.length) {
      internalArray = resizeStorage(this, index + 1 | 0);
    }
    internalArray[index] = value;
    if (index >= this.k9z_1)
      this.k9z_1 = index + 1 | 0;
  };
  protoOf(PointerIdArray).c3 = function () {
    this.k9z_1 = 0;
  };
  protoOf(PointerIdArray).lm = function (pointerIdValue) {
    var inductionVariable = 0;
    var last = this.k9z_1;
    if (inductionVariable < last)
      do {
        var i = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        if (equalsLong(this.l9z_1[i], pointerIdValue))
          return true;
      }
       while (inductionVariable < last);
    return false;
  };
  function get_VelocityTrackerAddPointsFix() {
    return VelocityTrackerAddPointsFix;
  }
  var VelocityTrackerAddPointsFix;
  var androidx_compose_ui_input_pointer_util_VelocityTracker$stable;
  var androidx_compose_ui_input_pointer_util_VelocityTracker1D$stable;
  var androidx_compose_ui_input_pointer_util_DataPointAtTime$stable;
  function VelocityTracker() {
    this.hab_1 = PlatformVelocityTracker();
  }
  protoOf(VelocityTracker).iab = function (maximumVelocity) {
    return this.hab_1.iab(maximumVelocity);
  };
  protoOf(VelocityTracker).jab = function () {
    return this.hab_1.jab();
  };
  function addPointerInputChange(_this__u8e3s4, event) {
    return addPointerInputChange_0(_this__u8e3s4, event, Companion_getInstance().g5d_1);
  }
  function addPointerInputChange_0(_this__u8e3s4, event, offset) {
    return _this__u8e3s4.hab_1.kab(event, offset);
  }
  var Strategy_Lsq2_instance;
  var Strategy_Impulse_instance;
  var Strategy_entriesInitialized;
  function Strategy_initEntries() {
    if (Strategy_entriesInitialized)
      return Unit_instance;
    Strategy_entriesInitialized = true;
    Strategy_Lsq2_instance = new Strategy('Lsq2', 0);
    Strategy_Impulse_instance = new Strategy('Impulse', 1);
  }
  function VelocityTracker1D_init_$Init$(isDataDifferential, $this) {
    VelocityTracker1D.call($this, isDataDifferential, Strategy_Impulse_getInstance());
    return $this;
  }
  function VelocityTracker1D_init_$Create$(isDataDifferential) {
    return VelocityTracker1D_init_$Init$(isDataDifferential, objectCreate(protoOf(VelocityTracker1D)));
  }
  function Strategy(name, ordinal) {
    Enum.call(this, name, ordinal);
  }
  function calculateLeastSquaresVelocity($this, dataPoints, time, sampleCount) {
    var tmp;
    try {
      tmp = polyFitLeastSquares(time, dataPoints, sampleCount, 2, $this.sab_1)[1];
    } catch ($p) {
      var tmp_0;
      if ($p instanceof IllegalArgumentException) {
        var exception = $p;
        tmp_0 = 0.0;
      } else {
        throw $p;
      }
      tmp = tmp_0;
    }
    return tmp;
  }
  function Strategy_Lsq2_getInstance() {
    Strategy_initEntries();
    return Strategy_Lsq2_instance;
  }
  function Strategy_Impulse_getInstance() {
    Strategy_initEntries();
    return Strategy_Impulse_instance;
  }
  function VelocityTracker1D(isDataDifferential, strategy) {
    isDataDifferential = isDataDifferential === VOID ? false : isDataDifferential;
    strategy = strategy === VOID ? Strategy_Lsq2_getInstance() : strategy;
    this.lab_1 = isDataDifferential;
    this.mab_1 = strategy;
    if (this.lab_1 && this.mab_1.equals(Strategy_Lsq2_getInstance())) {
      throw IllegalStateException_init_$Create$('Lsq2 not (yet) supported for differential axes');
    }
    var tmp = this;
    var tmp_0;
    switch (this.mab_1.a1_1) {
      case 1:
        tmp_0 = 2;
        break;
      case 0:
        tmp_0 = 3;
        break;
      default:
        noWhenBranchMatchedException();
        break;
    }
    tmp.nab_1 = tmp_0;
    var tmp_1 = this;
    // Inline function 'kotlin.arrayOfNulls' call
    tmp_1.oab_1 = Array(20);
    this.pab_1 = 0;
    this.qab_1 = new Float32Array(20);
    this.rab_1 = new Float32Array(20);
    this.sab_1 = new Float32Array(3);
  }
  protoOf(VelocityTracker1D).tab = function (timeMillis, dataPoint) {
    this.pab_1 = (this.pab_1 + 1 | 0) % 20 | 0;
    set(this.oab_1, this.pab_1, timeMillis, dataPoint);
  };
  protoOf(VelocityTracker1D).uab = function () {
    var dataPoints = this.qab_1;
    var time = this.rab_1;
    var sampleCount = 0;
    var index = this.pab_1;
    var tmp0_elvis_lhs = this.oab_1[index];
    var tmp;
    if (tmp0_elvis_lhs == null) {
      return 0.0;
    } else {
      tmp = tmp0_elvis_lhs;
    }
    var newestSample = tmp;
    var previousSample = newestSample;
    $l$loop_0: do {
      var tmp1_elvis_lhs = this.oab_1[index];
      var tmp_0;
      if (tmp1_elvis_lhs == null) {
        break $l$loop_0;
      } else {
        tmp_0 = tmp1_elvis_lhs;
      }
      var sample = tmp_0;
      var age = toNumber(subtract(newestSample.vab_1, sample.vab_1));
      var delta = toNumber(abs(subtract(sample.vab_1, previousSample.vab_1)));
      var tmp_1;
      if (this.mab_1.equals(Strategy_Lsq2_getInstance()) || this.lab_1) {
        tmp_1 = sample;
      } else {
        tmp_1 = newestSample;
      }
      previousSample = tmp_1;
      if (age > 100 || delta > 40) {
        break $l$loop_0;
      }
      dataPoints[sampleCount] = sample.wab_1;
      time[sampleCount] = -age;
      index = (index === 0 ? 20 : index) - 1 | 0;
      sampleCount = sampleCount + 1 | 0;
    }
     while (sampleCount < 20);
    if (sampleCount >= this.nab_1) {
      var tmp_2;
      switch (this.mab_1.a1_1) {
        case 1:
          tmp_2 = calculateImpulseVelocity(dataPoints, time, sampleCount, this.lab_1);
          break;
        case 0:
          tmp_2 = calculateLeastSquaresVelocity(this, dataPoints, time, sampleCount);
          break;
        default:
          noWhenBranchMatchedException();
          break;
      }
      return tmp_2 * 1000;
    }
    return 0.0;
  };
  protoOf(VelocityTracker1D).xab = function (maximumVelocity) {
    // Inline function 'androidx.compose.ui.internal.checkPrecondition' call
    if (!(maximumVelocity > 0.0)) {
      var tmp$ret$1 = 'maximumVelocity should be a positive value. You specified=' + maximumVelocity;
      throwIllegalStateException(tmp$ret$1);
    }
    var velocity = this.uab();
    var tmp;
    if (velocity === 0.0 || isNaN_0(velocity)) {
      tmp = 0.0;
    } else if (velocity > 0) {
      tmp = coerceAtMost(velocity, maximumVelocity);
    } else {
      tmp = coerceAtLeast(velocity, -maximumVelocity);
    }
    return tmp;
  };
  function DataPointAtTime(time, dataPoint) {
    this.vab_1 = time;
    this.wab_1 = dataPoint;
  }
  protoOf(DataPointAtTime).toString = function () {
    return 'DataPointAtTime(time=' + this.vab_1.toString() + ', dataPoint=' + this.wab_1 + ')';
  };
  protoOf(DataPointAtTime).hashCode = function () {
    var result = this.vab_1.hashCode();
    result = imul(result, 31) + getNumberHashCode(this.wab_1) | 0;
    return result;
  };
  protoOf(DataPointAtTime).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof DataPointAtTime))
      return false;
    if (!equalsLong(this.vab_1, other.vab_1))
      return false;
    if (!equals(this.wab_1, other.wab_1))
      return false;
    return true;
  };
  function set(_this__u8e3s4, index, time, dataPoint) {
    var currentEntry = _this__u8e3s4[index];
    if (currentEntry == null) {
      _this__u8e3s4[index] = new DataPointAtTime(time, dataPoint);
    } else {
      currentEntry.vab_1 = time;
      currentEntry.wab_1 = dataPoint;
    }
  }
  function calculateImpulseVelocity(dataPoints, time, sampleCount, isDataDifferential) {
    var work = 0.0;
    var start = sampleCount - 1 | 0;
    var nextTime = time[start];
    var inductionVariable = start;
    if (1 <= inductionVariable)
      $l$loop: do {
        var i = inductionVariable;
        inductionVariable = inductionVariable + -1 | 0;
        var currentTime = nextTime;
        nextTime = time[i - 1 | 0];
        if (currentTime === nextTime) {
          continue $l$loop;
        }
        var dataPointsDelta = isDataDifferential ? -dataPoints[i - 1 | 0] : dataPoints[i] - dataPoints[i - 1 | 0];
        var vCurr = dataPointsDelta / (currentTime - nextTime);
        // Inline function 'androidx.compose.ui.input.pointer.util.kineticEnergyToVelocity' call
        var kineticEnergy = work;
        // Inline function 'kotlin.math.sign' call
        var tmp = sign(kineticEnergy);
        // Inline function 'kotlin.math.abs' call
        // Inline function 'kotlin.math.sqrt' call
        var x = 2 * Math.abs(kineticEnergy);
        var vPrev = tmp * Math.sqrt(x);
        var tmp_0 = work;
        var tmp_1 = vCurr - vPrev;
        // Inline function 'kotlin.math.abs' call
        work = tmp_0 + tmp_1 * Math.abs(vCurr);
        if (i === start) {
          work = work * 0.5;
        }
      }
       while (1 <= inductionVariable);
    // Inline function 'androidx.compose.ui.input.pointer.util.kineticEnergyToVelocity' call
    var kineticEnergy_0 = work;
    // Inline function 'kotlin.math.sign' call
    var tmp_2 = sign(kineticEnergy_0);
    // Inline function 'kotlin.math.abs' call
    // Inline function 'kotlin.math.sqrt' call
    var x_0 = 2 * Math.abs(kineticEnergy_0);
    return tmp_2 * Math.sqrt(x_0);
  }
  function polyFitLeastSquares(x, y, sampleCount, degree, coefficients) {
    coefficients = coefficients === VOID ? new Float32Array(coerceAtLeast_0(degree + 1 | 0, 0)) : coefficients;
    if (degree < 1) {
      throwIllegalArgumentException('The degree must be at positive integer');
    }
    if (sampleCount === 0) {
      throwIllegalArgumentException('At least one point must be provided');
    }
    var tmp;
    if (degree >= sampleCount) {
      tmp = sampleCount - 1 | 0;
    } else {
      tmp = degree;
    }
    var truncatedDegree = tmp;
    var m = sampleCount;
    var n = truncatedDegree + 1 | 0;
    // Inline function 'androidx.compose.ui.input.pointer.util.Matrix' call
    var tmp_0 = 0;
    // Inline function 'kotlin.arrayOfNulls' call
    var tmp_1 = Array(n);
    while (tmp_0 < n) {
      tmp_1[tmp_0] = new Float32Array(m);
      tmp_0 = tmp_0 + 1 | 0;
    }
    var a = tmp_1;
    var inductionVariable = 0;
    if (inductionVariable < m)
      do {
        var h = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        // Inline function 'androidx.compose.ui.input.pointer.util.set' call
        a[0][h] = 1.0;
        var inductionVariable_0 = 1;
        if (inductionVariable_0 < n)
          do {
            var i = inductionVariable_0;
            inductionVariable_0 = inductionVariable_0 + 1 | 0;
            // Inline function 'androidx.compose.ui.input.pointer.util.get' call
            // Inline function 'androidx.compose.ui.input.pointer.util.set' call
            var value = a[i - 1 | 0][h] * x[h];
            a[i][h] = value;
          }
           while (inductionVariable_0 < n);
      }
       while (inductionVariable < m);
    // Inline function 'androidx.compose.ui.input.pointer.util.Matrix' call
    var tmp_2 = 0;
    // Inline function 'kotlin.arrayOfNulls' call
    var tmp_3 = Array(n);
    while (tmp_2 < n) {
      tmp_3[tmp_2] = new Float32Array(m);
      tmp_2 = tmp_2 + 1 | 0;
    }
    var q = tmp_3;
    // Inline function 'androidx.compose.ui.input.pointer.util.Matrix' call
    var tmp_4 = 0;
    // Inline function 'kotlin.arrayOfNulls' call
    var tmp_5 = Array(n);
    while (tmp_4 < n) {
      tmp_5[tmp_4] = new Float32Array(n);
      tmp_4 = tmp_4 + 1 | 0;
    }
    var r = tmp_5;
    var inductionVariable_1 = 0;
    if (inductionVariable_1 < n)
      do {
        var j = inductionVariable_1;
        inductionVariable_1 = inductionVariable_1 + 1 | 0;
        var w = q[j];
        // Inline function 'kotlin.collections.copyInto' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        var tmp_6 = a[j];
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        arrayCopy(tmp_6, w, 0, 0, m);
        var inductionVariable_2 = 0;
        if (inductionVariable_2 < j)
          do {
            var i_0 = inductionVariable_2;
            inductionVariable_2 = inductionVariable_2 + 1 | 0;
            var z = q[i_0];
            var dot_0 = dot(w, z);
            var inductionVariable_3 = 0;
            if (inductionVariable_3 < m)
              do {
                var h_0 = inductionVariable_3;
                inductionVariable_3 = inductionVariable_3 + 1 | 0;
                w[h_0] = w[h_0] - dot_0 * z[h_0];
              }
               while (inductionVariable_3 < m);
          }
           while (inductionVariable_2 < j);
        // Inline function 'androidx.compose.ui.input.pointer.util.norm' call
        // Inline function 'kotlin.math.sqrt' call
        var x_0 = dot(w, w);
        // Inline function 'androidx.compose.ui.util.fastCoerceAtLeast' call
        var this_0 = Math.sqrt(x_0);
        var inverseNorm = 1.0 / (this_0 < 1.0E-6 ? 1.0E-6 : this_0);
        var inductionVariable_4 = 0;
        if (inductionVariable_4 < m)
          do {
            var h_1 = inductionVariable_4;
            inductionVariable_4 = inductionVariable_4 + 1 | 0;
            w[h_1] = w[h_1] * inverseNorm;
          }
           while (inductionVariable_4 < m);
        var v = r[j];
        var inductionVariable_5 = 0;
        if (inductionVariable_5 < n)
          do {
            var i_1 = inductionVariable_5;
            inductionVariable_5 = inductionVariable_5 + 1 | 0;
            v[i_1] = i_1 < j ? 0.0 : dot(w, a[i_1]);
          }
           while (inductionVariable_5 < n);
      }
       while (inductionVariable_1 < n);
    var wy = y;
    if (!(1.0 === 1.0)) {
      wy = new Float32Array(m);
      var inductionVariable_6 = 0;
      if (inductionVariable_6 < m)
        do {
          var h_2 = inductionVariable_6;
          inductionVariable_6 = inductionVariable_6 + 1 | 0;
          wy[h_2] = y[h_2] * 1.0;
        }
         while (inductionVariable_6 < m);
    }
    var inductionVariable_7 = n - 1 | 0;
    if (0 <= inductionVariable_7)
      do {
        var i_2 = inductionVariable_7;
        inductionVariable_7 = inductionVariable_7 + -1 | 0;
        var c = dot(q[i_2], wy);
        var ri = r[i_2];
        var inductionVariable_8 = n - 1 | 0;
        var last = i_2 + 1 | 0;
        if (last <= inductionVariable_8)
          do {
            var j_0 = inductionVariable_8;
            inductionVariable_8 = inductionVariable_8 + -1 | 0;
            c = c - ri[j_0] * coefficients[j_0];
          }
           while (!(j_0 === last));
        coefficients[i_2] = c / ri[i_2];
      }
       while (0 <= inductionVariable_7);
    return coefficients;
  }
  function dot(_this__u8e3s4, a) {
    var result = 0.0;
    var inductionVariable = 0;
    var last = _this__u8e3s4.length - 1 | 0;
    if (inductionVariable <= last)
      do {
        var i = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        result = result + _this__u8e3s4[i] * a[i];
      }
       while (inductionVariable <= last);
    return result;
  }
  function RotaryInputModifierNode() {
  }
  function throwIllegalArgumentException(message) {
    throw IllegalArgumentException_init_$Create$(message);
  }
  function throwIllegalStateException(message) {
    throw IllegalStateException_init_$Create$(message);
  }
  function throwIllegalStateExceptionForNullCheck(message) {
    throw IllegalStateException_init_$Create$(message);
  }
  function throwUnsupportedOperationException(message) {
    throw UnsupportedOperationException_init_$Create$(message);
  }
  function throwIndexOutOfBoundsException(message) {
    throw IndexOutOfBoundsException_init_$Create$(message);
  }
  function get_FirstBaseline() {
    _init_properties_AlignmentLine_kt__jh8eit();
    return FirstBaseline;
  }
  var FirstBaseline;
  function get_LastBaseline() {
    _init_properties_AlignmentLine_kt__jh8eit();
    return LastBaseline;
  }
  var LastBaseline;
  var androidx_compose_ui_layout_AlignmentLine$stable;
  var androidx_compose_ui_layout_VerticalAlignmentLine$stable;
  var androidx_compose_ui_layout_HorizontalAlignmentLine$stable;
  function HorizontalAlignmentLine(merger) {
    AlignmentLine.call(this, merger);
  }
  function VerticalAlignmentLine(merger) {
    AlignmentLine.call(this, merger);
  }
  function Companion_18() {
    this.yab_1 = -2147483648;
  }
  var Companion_instance_23;
  function Companion_getInstance_44() {
    return Companion_instance_23;
  }
  function AlignmentLine(merger) {
    this.zab_1 = merger;
  }
  function merge(_this__u8e3s4, position1, position2) {
    _init_properties_AlignmentLine_kt__jh8eit();
    return _this__u8e3s4.zab_1(position1, position2);
  }
  function min$ref() {
    return constructCallableReference(function (p0, p1) {
      // Inline function 'kotlin.math.min' call
      return Math.min(p0, p1);
    }, 2, 0, 58, 'min');
  }
  function max$ref() {
    return constructCallableReference(function (p0, p1) {
      // Inline function 'kotlin.math.max' call
      return Math.max(p0, p1);
    }, 2, 0, 59, 'max');
  }
  var properties_initialized_AlignmentLine_kt_1wfwg7;
  function _init_properties_AlignmentLine_kt__jh8eit() {
    if (!properties_initialized_AlignmentLine_kt_1wfwg7) {
      properties_initialized_AlignmentLine_kt_1wfwg7 = true;
      FirstBaseline = new HorizontalAlignmentLine(min$ref());
      LastBaseline = new HorizontalAlignmentLine(max$ref());
      androidx_compose_ui_layout_AlignmentLine$stable = 0;
      androidx_compose_ui_layout_VerticalAlignmentLine$stable = 0;
      androidx_compose_ui_layout_HorizontalAlignmentLine$stable = 0;
    }
  }
  function sam$androidx_compose_ui_node_NodeMeasuringIntrinsics_ApproachMeasureBlock$0(function_0) {
    this.aac_1 = function_0;
  }
  protoOf(sam$androidx_compose_ui_node_NodeMeasuringIntrinsics_ApproachMeasureBlock$0).bac = function (_this__u8e3s4, measurable, constraints) {
    return this.aac_1(_this__u8e3s4, measurable, new Constraints_0(constraints));
  };
  protoOf(sam$androidx_compose_ui_node_NodeMeasuringIntrinsics_ApproachMeasureBlock$0).q3 = function () {
    return this.aac_1;
  };
  protoOf(sam$androidx_compose_ui_node_NodeMeasuringIntrinsics_ApproachMeasureBlock$0).equals = function (other) {
    var tmp;
    if (!(other == null) ? isInterface(other, ApproachMeasureBlock) : false) {
      var tmp_0;
      if (!(other == null) ? isInterface(other, FunctionAdapter) : false) {
        tmp_0 = equals(this.q3(), other.q3());
      } else {
        tmp_0 = false;
      }
      tmp = tmp_0;
    } else {
      tmp = false;
    }
    return tmp;
  };
  protoOf(sam$androidx_compose_ui_node_NodeMeasuringIntrinsics_ApproachMeasureBlock$0).hashCode = function () {
    return hashCode(this.q3());
  };
  function sam$androidx_compose_ui_node_NodeMeasuringIntrinsics_ApproachMeasureBlock$0_0(function_0) {
    this.cac_1 = function_0;
  }
  protoOf(sam$androidx_compose_ui_node_NodeMeasuringIntrinsics_ApproachMeasureBlock$0_0).bac = function (_this__u8e3s4, measurable, constraints) {
    return this.cac_1(_this__u8e3s4, measurable, new Constraints_0(constraints));
  };
  protoOf(sam$androidx_compose_ui_node_NodeMeasuringIntrinsics_ApproachMeasureBlock$0_0).q3 = function () {
    return this.cac_1;
  };
  protoOf(sam$androidx_compose_ui_node_NodeMeasuringIntrinsics_ApproachMeasureBlock$0_0).equals = function (other) {
    var tmp;
    if (!(other == null) ? isInterface(other, ApproachMeasureBlock) : false) {
      var tmp_0;
      if (!(other == null) ? isInterface(other, FunctionAdapter) : false) {
        tmp_0 = equals(this.q3(), other.q3());
      } else {
        tmp_0 = false;
      }
      tmp = tmp_0;
    } else {
      tmp = false;
    }
    return tmp;
  };
  protoOf(sam$androidx_compose_ui_node_NodeMeasuringIntrinsics_ApproachMeasureBlock$0_0).hashCode = function () {
    return hashCode(this.q3());
  };
  function sam$androidx_compose_ui_node_NodeMeasuringIntrinsics_ApproachMeasureBlock$0_1(function_0) {
    this.dac_1 = function_0;
  }
  protoOf(sam$androidx_compose_ui_node_NodeMeasuringIntrinsics_ApproachMeasureBlock$0_1).bac = function (_this__u8e3s4, measurable, constraints) {
    return this.dac_1(_this__u8e3s4, measurable, new Constraints_0(constraints));
  };
  protoOf(sam$androidx_compose_ui_node_NodeMeasuringIntrinsics_ApproachMeasureBlock$0_1).q3 = function () {
    return this.dac_1;
  };
  protoOf(sam$androidx_compose_ui_node_NodeMeasuringIntrinsics_ApproachMeasureBlock$0_1).equals = function (other) {
    var tmp;
    if (!(other == null) ? isInterface(other, ApproachMeasureBlock) : false) {
      var tmp_0;
      if (!(other == null) ? isInterface(other, FunctionAdapter) : false) {
        tmp_0 = equals(this.q3(), other.q3());
      } else {
        tmp_0 = false;
      }
      tmp = tmp_0;
    } else {
      tmp = false;
    }
    return tmp;
  };
  protoOf(sam$androidx_compose_ui_node_NodeMeasuringIntrinsics_ApproachMeasureBlock$0_1).hashCode = function () {
    return hashCode(this.q3());
  };
  function sam$androidx_compose_ui_node_NodeMeasuringIntrinsics_ApproachMeasureBlock$0_2(function_0) {
    this.eac_1 = function_0;
  }
  protoOf(sam$androidx_compose_ui_node_NodeMeasuringIntrinsics_ApproachMeasureBlock$0_2).bac = function (_this__u8e3s4, measurable, constraints) {
    return this.eac_1(_this__u8e3s4, measurable, new Constraints_0(constraints));
  };
  protoOf(sam$androidx_compose_ui_node_NodeMeasuringIntrinsics_ApproachMeasureBlock$0_2).q3 = function () {
    return this.eac_1;
  };
  protoOf(sam$androidx_compose_ui_node_NodeMeasuringIntrinsics_ApproachMeasureBlock$0_2).equals = function (other) {
    var tmp;
    if (!(other == null) ? isInterface(other, ApproachMeasureBlock) : false) {
      var tmp_0;
      if (!(other == null) ? isInterface(other, FunctionAdapter) : false) {
        tmp_0 = equals(this.q3(), other.q3());
      } else {
        tmp_0 = false;
      }
      tmp = tmp_0;
    } else {
      tmp = false;
    }
    return tmp;
  };
  protoOf(sam$androidx_compose_ui_node_NodeMeasuringIntrinsics_ApproachMeasureBlock$0_2).hashCode = function () {
    return hashCode(this.q3());
  };
  function ApproachLayoutModifierNode$minApproachIntrinsicWidth$lambda(this$0) {
    return function ($this$ApproachMeasureBlock, intrinsicMeasurable, constraints) {
      return this$0.fac($this$ApproachMeasureBlock, intrinsicMeasurable, constraints.m5e_1);
    };
  }
  function ApproachLayoutModifierNode$minApproachIntrinsicHeight$lambda(this$0) {
    return function ($this$ApproachMeasureBlock, intrinsicMeasurable, constraints) {
      return this$0.fac($this$ApproachMeasureBlock, intrinsicMeasurable, constraints.m5e_1);
    };
  }
  function ApproachLayoutModifierNode$maxApproachIntrinsicWidth$lambda(this$0) {
    return function ($this$ApproachMeasureBlock, intrinsicMeasurable, constraints) {
      return this$0.fac($this$ApproachMeasureBlock, intrinsicMeasurable, constraints.m5e_1);
    };
  }
  function ApproachLayoutModifierNode$maxApproachIntrinsicHeight$lambda(this$0) {
    return function ($this$ApproachMeasureBlock, intrinsicMeasurable, constraints) {
      return this$0.fac($this$ApproachMeasureBlock, intrinsicMeasurable, constraints.m5e_1);
    };
  }
  function ApproachLayoutModifierNode() {
  }
  var androidx_compose_ui_layout_ApproachMeasureScopeImpl$stable;
  function ApproachMeasureScopeImpl$layout$1($width, $height, $alignmentLines, $rulers, $placementBlock, this$0) {
    this.qad_1 = $placementBlock;
    this.rad_1 = this$0;
    this.mad_1 = $width;
    this.nad_1 = $height;
    this.oad_1 = $alignmentLines;
    this.pad_1 = $rulers;
  }
  protoOf(ApproachMeasureScopeImpl$layout$1).h5e = function () {
    return this.mad_1;
  };
  protoOf(ApproachMeasureScopeImpl$layout$1).i5e = function () {
    return this.nad_1;
  };
  protoOf(ApproachMeasureScopeImpl$layout$1).sad = function () {
    return this.oad_1;
  };
  protoOf(ApproachMeasureScopeImpl$layout$1).tad = function () {
    return this.pad_1;
  };
  protoOf(ApproachMeasureScopeImpl$layout$1).uad = function () {
    this.qad_1(this.rad_1.jae_1.gae_1);
  };
  function ApproachMeasureScopeImpl(coordinator, approachNode) {
    this.jae_1 = coordinator;
    this.kae_1 = approachNode;
    this.lae_1 = false;
  }
  protoOf(ApproachMeasureScopeImpl).mae = function () {
    // Inline function 'kotlin.let' call
    var it = ensureNotNull(this.jae_1.eag_1).gag();
    var tmp0 = it.h5e();
    // Inline function 'androidx.compose.ui.unit.IntSize' call
    // Inline function 'androidx.compose.ui.util.packInts' call
    var val2 = it.i5e();
    var tmp$ret$3 = bitwiseOr(shiftLeft(fromInt(tmp0), 32), bitwiseAnd(fromInt(val2), new Long(-1, 0)));
    return _IntSize___init__impl__emcjft(tmp$ret$3);
  };
  protoOf(ApproachMeasureScopeImpl).hag = function (width, height, alignmentLines, rulers, placementBlock) {
    // Inline function 'androidx.compose.ui.node.checkMeasuredSize' call
    // Inline function 'androidx.compose.ui.internal.checkPrecondition' call
    if (!((width & -16777216) === 0 && (height & -16777216) === 0)) {
      var tmp$ret$2 = 'Size(' + width + ' x ' + height + ') is out of range. Each dimension must be between 0 and ' + '16777215.';
      throwIllegalStateException(tmp$ret$2);
    }
    return new ApproachMeasureScopeImpl$layout$1(width, height, alignmentLines, rulers, placementBlock, this);
  };
  protoOf(ApproachMeasureScopeImpl).jag = function () {
    return false;
  };
  protoOf(ApproachMeasureScopeImpl).r6p = function () {
    return this.jae_1.r6p();
  };
  protoOf(ApproachMeasureScopeImpl).v5e = function (_this__u8e3s4) {
    return this.jae_1.v5e(_this__u8e3s4);
  };
  protoOf(ApproachMeasureScopeImpl).x5e = function (_this__u8e3s4) {
    return this.jae_1.x5e(_this__u8e3s4);
  };
  protoOf(ApproachMeasureScopeImpl).w5e = function (_this__u8e3s4) {
    return this.jae_1.w5e(_this__u8e3s4);
  };
  protoOf(ApproachMeasureScopeImpl).c5f = function (_this__u8e3s4) {
    return this.jae_1.c5f(_this__u8e3s4);
  };
  protoOf(ApproachMeasureScopeImpl).d5f = function (_this__u8e3s4) {
    return this.jae_1.d5f(_this__u8e3s4);
  };
  protoOf(ApproachMeasureScopeImpl).e5f = function (_this__u8e3s4) {
    return this.jae_1.e5f(_this__u8e3s4);
  };
  protoOf(ApproachMeasureScopeImpl).b5f = function (_this__u8e3s4) {
    return this.jae_1.b5f(_this__u8e3s4);
  };
  protoOf(ApproachMeasureScopeImpl).f5f = function (_this__u8e3s4) {
    return this.jae_1.f5f(_this__u8e3s4);
  };
  protoOf(ApproachMeasureScopeImpl).g5f = function (_this__u8e3s4) {
    return this.jae_1.g5f(_this__u8e3s4);
  };
  protoOf(ApproachMeasureScopeImpl).u5e = function () {
    return this.jae_1.u5e();
  };
  protoOf(ApproachMeasureScopeImpl).j5f = function () {
    return this.jae_1.j5f();
  };
  protoOf(ApproachMeasureScopeImpl).kag = function (width, height, alignmentLines, placementBlock) {
    return this.jae_1.kag(width, height, alignmentLines, placementBlock);
  };
  function get_ModifierLocalBeyondBoundsLayout() {
    _init_properties_BeyondBoundsLayout_kt__6nr19u();
    return ModifierLocalBeyondBoundsLayout;
  }
  var ModifierLocalBeyondBoundsLayout;
  function _LayoutDirection___init__impl__nziunw(value) {
    return value;
  }
  function Companion_19() {
    Companion_instance_24 = this;
    this.e9b_1 = _LayoutDirection___init__impl__nziunw(1);
    this.f9b_1 = _LayoutDirection___init__impl__nziunw(2);
    this.g9b_1 = _LayoutDirection___init__impl__nziunw(3);
    this.h9b_1 = _LayoutDirection___init__impl__nziunw(4);
    this.i9b_1 = _LayoutDirection___init__impl__nziunw(5);
    this.j9b_1 = _LayoutDirection___init__impl__nziunw(6);
  }
  var Companion_instance_24;
  function Companion_getInstance_45() {
    if (Companion_instance_24 == null)
      new Companion_19();
    return Companion_instance_24;
  }
  function BeyondBoundsLayoutProviderModifierNode() {
  }
  function ModifierLocalBeyondBoundsLayout$lambda() {
    _init_properties_BeyondBoundsLayout_kt__6nr19u();
    return null;
  }
  var properties_initialized_BeyondBoundsLayout_kt_ydfa9c;
  function _init_properties_BeyondBoundsLayout_kt__6nr19u() {
    if (!properties_initialized_BeyondBoundsLayout_kt_ydfa9c) {
      properties_initialized_BeyondBoundsLayout_kt_ydfa9c = true;
      ModifierLocalBeyondBoundsLayout = modifierLocalOf(ModifierLocalBeyondBoundsLayout$lambda);
    }
  }
  var androidx_compose_ui_layout_FixedScale$stable;
  function ContentScale$Companion$Crop$1() {
  }
  protoOf(ContentScale$Companion$Crop$1).z97 = function (srcSize, dstSize) {
    // Inline function 'kotlin.let' call
    var it = computeFillMaxDimension(srcSize, dstSize);
    // Inline function 'androidx.compose.ui.layout.ScaleFactor' call
    // Inline function 'androidx.compose.ui.util.packFloats' call
    var v1 = fromInt(toRawBits(it));
    var v2 = fromInt(toRawBits(it));
    var tmp$ret$3 = bitwiseOr(shiftLeft(v1, 32), bitwiseAnd(v2, new Long(-1, 0)));
    return _ScaleFactor___init__impl__ttdtvk(tmp$ret$3);
  };
  function ContentScale$Companion$Fit$1() {
  }
  protoOf(ContentScale$Companion$Fit$1).z97 = function (srcSize, dstSize) {
    // Inline function 'kotlin.let' call
    var it = computeFillMinDimension(srcSize, dstSize);
    // Inline function 'androidx.compose.ui.layout.ScaleFactor' call
    // Inline function 'androidx.compose.ui.util.packFloats' call
    var v1 = fromInt(toRawBits(it));
    var v2 = fromInt(toRawBits(it));
    var tmp$ret$3 = bitwiseOr(shiftLeft(v1, 32), bitwiseAnd(v2, new Long(-1, 0)));
    return _ScaleFactor___init__impl__ttdtvk(tmp$ret$3);
  };
  function ContentScale$Companion$FillHeight$1() {
  }
  protoOf(ContentScale$Companion$FillHeight$1).z97 = function (srcSize, dstSize) {
    // Inline function 'androidx.compose.ui.layout.computeFillHeight' call
    // Inline function 'androidx.compose.ui.geometry.Size.height' call
    // Inline function 'androidx.compose.ui.util.unpackFloat2' call
    var value = _Size___get_packedValue__impl__7rlt1o(dstSize);
    // Inline function 'androidx.compose.ui.util.floatFromBits' call
    // Inline function 'kotlin.fromBits' call
    var bits = convertToInt(bitwiseAnd(value, new Long(-1, 0)));
    var tmp = floatFromBits(bits);
    // Inline function 'androidx.compose.ui.geometry.Size.height' call
    // Inline function 'androidx.compose.ui.util.unpackFloat2' call
    var value_0 = _Size___get_packedValue__impl__7rlt1o(srcSize);
    // Inline function 'androidx.compose.ui.util.floatFromBits' call
    // Inline function 'kotlin.fromBits' call
    var bits_0 = convertToInt(bitwiseAnd(value_0, new Long(-1, 0)));
    // Inline function 'kotlin.let' call
    var it = tmp / floatFromBits(bits_0);
    // Inline function 'androidx.compose.ui.layout.ScaleFactor' call
    // Inline function 'androidx.compose.ui.util.packFloats' call
    var v1 = fromInt(toRawBits(it));
    var v2 = fromInt(toRawBits(it));
    var tmp$ret$12 = bitwiseOr(shiftLeft(v1, 32), bitwiseAnd(v2, new Long(-1, 0)));
    return _ScaleFactor___init__impl__ttdtvk(tmp$ret$12);
  };
  function ContentScale$Companion$FillWidth$1() {
  }
  protoOf(ContentScale$Companion$FillWidth$1).z97 = function (srcSize, dstSize) {
    // Inline function 'androidx.compose.ui.layout.computeFillWidth' call
    // Inline function 'androidx.compose.ui.geometry.Size.width' call
    // Inline function 'androidx.compose.ui.util.unpackFloat1' call
    var value = _Size___get_packedValue__impl__7rlt1o(dstSize);
    // Inline function 'androidx.compose.ui.util.floatFromBits' call
    // Inline function 'kotlin.fromBits' call
    var bits = convertToInt(shiftRight(value, 32));
    var tmp = floatFromBits(bits);
    // Inline function 'androidx.compose.ui.geometry.Size.width' call
    // Inline function 'androidx.compose.ui.util.unpackFloat1' call
    var value_0 = _Size___get_packedValue__impl__7rlt1o(srcSize);
    // Inline function 'androidx.compose.ui.util.floatFromBits' call
    // Inline function 'kotlin.fromBits' call
    var bits_0 = convertToInt(shiftRight(value_0, 32));
    // Inline function 'kotlin.let' call
    var it = tmp / floatFromBits(bits_0);
    // Inline function 'androidx.compose.ui.layout.ScaleFactor' call
    // Inline function 'androidx.compose.ui.util.packFloats' call
    var v1 = fromInt(toRawBits(it));
    var v2 = fromInt(toRawBits(it));
    var tmp$ret$12 = bitwiseOr(shiftLeft(v1, 32), bitwiseAnd(v2, new Long(-1, 0)));
    return _ScaleFactor___init__impl__ttdtvk(tmp$ret$12);
  };
  function ContentScale$Companion$Inside$1() {
  }
  protoOf(ContentScale$Companion$Inside$1).z97 = function (srcSize, dstSize) {
    var tmp;
    var tmp_0;
    // Inline function 'androidx.compose.ui.geometry.Size.width' call
    // Inline function 'androidx.compose.ui.util.unpackFloat1' call
    var value = _Size___get_packedValue__impl__7rlt1o(srcSize);
    // Inline function 'androidx.compose.ui.util.floatFromBits' call
    // Inline function 'kotlin.fromBits' call
    var bits = convertToInt(shiftRight(value, 32));
    var tmp_1 = floatFromBits(bits);
    // Inline function 'androidx.compose.ui.geometry.Size.width' call
    // Inline function 'androidx.compose.ui.util.unpackFloat1' call
    var value_0 = _Size___get_packedValue__impl__7rlt1o(dstSize);
    // Inline function 'androidx.compose.ui.util.floatFromBits' call
    // Inline function 'kotlin.fromBits' call
    var bits_0 = convertToInt(shiftRight(value_0, 32));
    if (tmp_1 <= floatFromBits(bits_0)) {
      // Inline function 'androidx.compose.ui.geometry.Size.height' call
      // Inline function 'androidx.compose.ui.util.unpackFloat2' call
      var value_1 = _Size___get_packedValue__impl__7rlt1o(srcSize);
      // Inline function 'androidx.compose.ui.util.floatFromBits' call
      // Inline function 'kotlin.fromBits' call
      var bits_1 = convertToInt(bitwiseAnd(value_1, new Long(-1, 0)));
      var tmp_2 = floatFromBits(bits_1);
      // Inline function 'androidx.compose.ui.geometry.Size.height' call
      // Inline function 'androidx.compose.ui.util.unpackFloat2' call
      var value_2 = _Size___get_packedValue__impl__7rlt1o(dstSize);
      // Inline function 'androidx.compose.ui.util.floatFromBits' call
      // Inline function 'kotlin.fromBits' call
      var bits_2 = convertToInt(bitwiseAnd(value_2, new Long(-1, 0)));
      tmp_0 = tmp_2 <= floatFromBits(bits_2);
    } else {
      tmp_0 = false;
    }
    if (tmp_0) {
      // Inline function 'androidx.compose.ui.layout.ScaleFactor' call
      // Inline function 'androidx.compose.ui.util.packFloats' call
      var v1 = fromInt(toRawBits(1.0));
      var v2 = fromInt(toRawBits(1.0));
      var tmp$ret$17 = bitwiseOr(shiftLeft(v1, 32), bitwiseAnd(v2, new Long(-1, 0)));
      tmp = _ScaleFactor___init__impl__ttdtvk(tmp$ret$17);
    } else {
      // Inline function 'kotlin.let' call
      var it = computeFillMinDimension(srcSize, dstSize);
      // Inline function 'androidx.compose.ui.layout.ScaleFactor' call
      // Inline function 'androidx.compose.ui.util.packFloats' call
      var v1_0 = fromInt(toRawBits(it));
      var v2_0 = fromInt(toRawBits(it));
      var tmp$ret$21 = bitwiseOr(shiftLeft(v1_0, 32), bitwiseAnd(v2_0, new Long(-1, 0)));
      tmp = _ScaleFactor___init__impl__ttdtvk(tmp$ret$21);
    }
    return tmp;
  };
  function ContentScale$Companion$FillBounds$1() {
  }
  protoOf(ContentScale$Companion$FillBounds$1).z97 = function (srcSize, dstSize) {
    // Inline function 'androidx.compose.ui.layout.computeFillWidth' call
    // Inline function 'androidx.compose.ui.geometry.Size.width' call
    // Inline function 'androidx.compose.ui.util.unpackFloat1' call
    var value = _Size___get_packedValue__impl__7rlt1o(dstSize);
    // Inline function 'androidx.compose.ui.util.floatFromBits' call
    // Inline function 'kotlin.fromBits' call
    var bits = convertToInt(shiftRight(value, 32));
    var tmp = floatFromBits(bits);
    // Inline function 'androidx.compose.ui.geometry.Size.width' call
    // Inline function 'androidx.compose.ui.util.unpackFloat1' call
    var value_0 = _Size___get_packedValue__impl__7rlt1o(srcSize);
    // Inline function 'androidx.compose.ui.util.floatFromBits' call
    // Inline function 'kotlin.fromBits' call
    var bits_0 = convertToInt(shiftRight(value_0, 32));
    var tmp0 = tmp / floatFromBits(bits_0);
    // Inline function 'androidx.compose.ui.layout.computeFillHeight' call
    // Inline function 'androidx.compose.ui.geometry.Size.height' call
    // Inline function 'androidx.compose.ui.util.unpackFloat2' call
    var value_1 = _Size___get_packedValue__impl__7rlt1o(dstSize);
    // Inline function 'androidx.compose.ui.util.floatFromBits' call
    // Inline function 'kotlin.fromBits' call
    var bits_1 = convertToInt(bitwiseAnd(value_1, new Long(-1, 0)));
    var tmp_0 = floatFromBits(bits_1);
    // Inline function 'androidx.compose.ui.geometry.Size.height' call
    // Inline function 'androidx.compose.ui.util.unpackFloat2' call
    var value_2 = _Size___get_packedValue__impl__7rlt1o(srcSize);
    // Inline function 'androidx.compose.ui.util.floatFromBits' call
    // Inline function 'kotlin.fromBits' call
    var bits_2 = convertToInt(bitwiseAnd(value_2, new Long(-1, 0)));
    // Inline function 'androidx.compose.ui.layout.ScaleFactor' call
    // Inline function 'androidx.compose.ui.util.packFloats' call
    var val2 = tmp_0 / floatFromBits(bits_2);
    var v1 = fromInt(toRawBits(tmp0));
    var v2 = fromInt(toRawBits(val2));
    var tmp$ret$19 = bitwiseOr(shiftLeft(v1, 32), bitwiseAnd(v2, new Long(-1, 0)));
    return _ScaleFactor___init__impl__ttdtvk(tmp$ret$19);
  };
  function Companion_20() {
    Companion_instance_25 = this;
    var tmp = this;
    tmp.q96_1 = new ContentScale$Companion$Crop$1();
    var tmp_0 = this;
    tmp_0.r96_1 = new ContentScale$Companion$Fit$1();
    var tmp_1 = this;
    tmp_1.s96_1 = new ContentScale$Companion$FillHeight$1();
    var tmp_2 = this;
    tmp_2.t96_1 = new ContentScale$Companion$FillWidth$1();
    var tmp_3 = this;
    tmp_3.u96_1 = new ContentScale$Companion$Inside$1();
    this.v96_1 = new FixedScale(1.0);
    var tmp_4 = this;
    tmp_4.w96_1 = new ContentScale$Companion$FillBounds$1();
  }
  var Companion_instance_25;
  function Companion_getInstance_46() {
    if (Companion_instance_25 == null)
      new Companion_20();
    return Companion_instance_25;
  }
  function FixedScale(value) {
    this.nag_1 = value;
  }
  protoOf(FixedScale).z97 = function (srcSize, dstSize) {
    var tmp0 = this.nag_1;
    // Inline function 'androidx.compose.ui.layout.ScaleFactor' call
    // Inline function 'androidx.compose.ui.util.packFloats' call
    var val2 = this.nag_1;
    var v1 = fromInt(toRawBits(tmp0));
    var v2 = fromInt(toRawBits(val2));
    var tmp$ret$1 = bitwiseOr(shiftLeft(v1, 32), bitwiseAnd(v2, new Long(-1, 0)));
    return _ScaleFactor___init__impl__ttdtvk(tmp$ret$1);
  };
  protoOf(FixedScale).toString = function () {
    return 'FixedScale(value=' + this.nag_1 + ')';
  };
  protoOf(FixedScale).hashCode = function () {
    return getNumberHashCode(this.nag_1);
  };
  protoOf(FixedScale).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof FixedScale))
      return false;
    if (!equals(this.nag_1, other.nag_1))
      return false;
    return true;
  };
  function computeFillMaxDimension(srcSize, dstSize) {
    // Inline function 'androidx.compose.ui.layout.computeFillWidth' call
    // Inline function 'androidx.compose.ui.geometry.Size.width' call
    // Inline function 'androidx.compose.ui.util.unpackFloat1' call
    var value = _Size___get_packedValue__impl__7rlt1o(dstSize);
    // Inline function 'androidx.compose.ui.util.floatFromBits' call
    // Inline function 'kotlin.fromBits' call
    var bits = convertToInt(shiftRight(value, 32));
    var tmp = floatFromBits(bits);
    // Inline function 'androidx.compose.ui.geometry.Size.width' call
    // Inline function 'androidx.compose.ui.util.unpackFloat1' call
    var value_0 = _Size___get_packedValue__impl__7rlt1o(srcSize);
    // Inline function 'androidx.compose.ui.util.floatFromBits' call
    // Inline function 'kotlin.fromBits' call
    var bits_0 = convertToInt(shiftRight(value_0, 32));
    var widthScale = tmp / floatFromBits(bits_0);
    // Inline function 'androidx.compose.ui.layout.computeFillHeight' call
    // Inline function 'androidx.compose.ui.geometry.Size.height' call
    // Inline function 'androidx.compose.ui.util.unpackFloat2' call
    var value_1 = _Size___get_packedValue__impl__7rlt1o(dstSize);
    // Inline function 'androidx.compose.ui.util.floatFromBits' call
    // Inline function 'kotlin.fromBits' call
    var bits_1 = convertToInt(bitwiseAnd(value_1, new Long(-1, 0)));
    var tmp_0 = floatFromBits(bits_1);
    // Inline function 'androidx.compose.ui.geometry.Size.height' call
    // Inline function 'androidx.compose.ui.util.unpackFloat2' call
    var value_2 = _Size___get_packedValue__impl__7rlt1o(srcSize);
    // Inline function 'androidx.compose.ui.util.floatFromBits' call
    // Inline function 'kotlin.fromBits' call
    var bits_2 = convertToInt(bitwiseAnd(value_2, new Long(-1, 0)));
    var heightScale = tmp_0 / floatFromBits(bits_2);
    // Inline function 'kotlin.math.max' call
    return Math.max(widthScale, heightScale);
  }
  function computeFillMinDimension(srcSize, dstSize) {
    // Inline function 'androidx.compose.ui.layout.computeFillWidth' call
    // Inline function 'androidx.compose.ui.geometry.Size.width' call
    // Inline function 'androidx.compose.ui.util.unpackFloat1' call
    var value = _Size___get_packedValue__impl__7rlt1o(dstSize);
    // Inline function 'androidx.compose.ui.util.floatFromBits' call
    // Inline function 'kotlin.fromBits' call
    var bits = convertToInt(shiftRight(value, 32));
    var tmp = floatFromBits(bits);
    // Inline function 'androidx.compose.ui.geometry.Size.width' call
    // Inline function 'androidx.compose.ui.util.unpackFloat1' call
    var value_0 = _Size___get_packedValue__impl__7rlt1o(srcSize);
    // Inline function 'androidx.compose.ui.util.floatFromBits' call
    // Inline function 'kotlin.fromBits' call
    var bits_0 = convertToInt(shiftRight(value_0, 32));
    var widthScale = tmp / floatFromBits(bits_0);
    // Inline function 'androidx.compose.ui.layout.computeFillHeight' call
    // Inline function 'androidx.compose.ui.geometry.Size.height' call
    // Inline function 'androidx.compose.ui.util.unpackFloat2' call
    var value_1 = _Size___get_packedValue__impl__7rlt1o(dstSize);
    // Inline function 'androidx.compose.ui.util.floatFromBits' call
    // Inline function 'kotlin.fromBits' call
    var bits_1 = convertToInt(bitwiseAnd(value_1, new Long(-1, 0)));
    var tmp_0 = floatFromBits(bits_1);
    // Inline function 'androidx.compose.ui.geometry.Size.height' call
    // Inline function 'androidx.compose.ui.util.unpackFloat2' call
    var value_2 = _Size___get_packedValue__impl__7rlt1o(srcSize);
    // Inline function 'androidx.compose.ui.util.floatFromBits' call
    // Inline function 'kotlin.fromBits' call
    var bits_2 = convertToInt(bitwiseAnd(value_2, new Long(-1, 0)));
    var heightScale = tmp_0 / floatFromBits(bits_2);
    // Inline function 'kotlin.math.min' call
    return Math.min(widthScale, heightScale);
  }
  function IntrinsicMeasureScope() {
  }
  var androidx_compose_ui_layout_DefaultIntrinsicMeasurable$stable;
  var androidx_compose_ui_layout_IntrinsicsMeasureScope$stable;
  var androidx_compose_ui_layout_ApproachIntrinsicsMeasureScope$stable;
  function combineAsVirtualLayouts(contents) {
    return ComposableLambda$invoke$ref(composableLambdaInstance(1271844412, true, combineAsVirtualLayouts$lambda(contents)));
  }
  function IntrinsicsMeasureScope$layout$1($w, $h, $alignmentLines, $rulers) {
    this.oag_1 = $w;
    this.pag_1 = $h;
    this.qag_1 = $alignmentLines;
    this.rag_1 = $rulers;
  }
  protoOf(IntrinsicsMeasureScope$layout$1).h5e = function () {
    return this.oag_1;
  };
  protoOf(IntrinsicsMeasureScope$layout$1).i5e = function () {
    return this.pag_1;
  };
  protoOf(IntrinsicsMeasureScope$layout$1).sad = function () {
    return this.qag_1;
  };
  protoOf(IntrinsicsMeasureScope$layout$1).tad = function () {
    return this.rag_1;
  };
  protoOf(IntrinsicsMeasureScope$layout$1).uad = function () {
  };
  function IntrinsicsMeasureScope(intrinsicMeasureScope, layoutDirection) {
    this.sag_1 = intrinsicMeasureScope;
    this.tag_1 = layoutDirection;
  }
  protoOf(IntrinsicsMeasureScope).r6p = function () {
    return this.tag_1;
  };
  protoOf(IntrinsicsMeasureScope).hag = function (width, height, alignmentLines, rulers, placementBlock) {
    // Inline function 'androidx.compose.ui.util.fastCoerceAtLeast' call
    var w = width < 0 ? 0 : width;
    // Inline function 'androidx.compose.ui.util.fastCoerceAtLeast' call
    var h = height < 0 ? 0 : height;
    // Inline function 'androidx.compose.ui.node.checkMeasuredSize' call
    // Inline function 'androidx.compose.ui.internal.checkPrecondition' call
    if (!((w & -16777216) === 0 && (h & -16777216) === 0)) {
      var tmp$ret$4 = 'Size(' + w + ' x ' + h + ') is out of range. Each dimension must be between 0 and ' + '16777215.';
      throwIllegalStateException(tmp$ret$4);
    }
    return new IntrinsicsMeasureScope$layout$1(w, h, alignmentLines, rulers);
  };
  protoOf(IntrinsicsMeasureScope).jag = function () {
    return this.sag_1.jag();
  };
  protoOf(IntrinsicsMeasureScope).v5e = function (_this__u8e3s4) {
    return this.sag_1.v5e(_this__u8e3s4);
  };
  protoOf(IntrinsicsMeasureScope).x5e = function (_this__u8e3s4) {
    return this.sag_1.x5e(_this__u8e3s4);
  };
  protoOf(IntrinsicsMeasureScope).w5e = function (_this__u8e3s4) {
    return this.sag_1.w5e(_this__u8e3s4);
  };
  protoOf(IntrinsicsMeasureScope).c5f = function (_this__u8e3s4) {
    return this.sag_1.c5f(_this__u8e3s4);
  };
  protoOf(IntrinsicsMeasureScope).d5f = function (_this__u8e3s4) {
    return this.sag_1.d5f(_this__u8e3s4);
  };
  protoOf(IntrinsicsMeasureScope).e5f = function (_this__u8e3s4) {
    return this.sag_1.e5f(_this__u8e3s4);
  };
  protoOf(IntrinsicsMeasureScope).b5f = function (_this__u8e3s4) {
    return this.sag_1.b5f(_this__u8e3s4);
  };
  protoOf(IntrinsicsMeasureScope).f5f = function (_this__u8e3s4) {
    return this.sag_1.f5f(_this__u8e3s4);
  };
  protoOf(IntrinsicsMeasureScope).g5f = function (_this__u8e3s4) {
    return this.sag_1.g5f(_this__u8e3s4);
  };
  protoOf(IntrinsicsMeasureScope).u5e = function () {
    return this.sag_1.u5e();
  };
  protoOf(IntrinsicsMeasureScope).j5f = function () {
    return this.sag_1.j5f();
  };
  function DefaultIntrinsicMeasurable(measurable, minMax, widthHeight) {
    this.uag_1 = measurable;
    this.vag_1 = minMax;
    this.wag_1 = widthHeight;
  }
  protoOf(DefaultIntrinsicMeasurable).xag = function () {
    return this.uag_1.xag();
  };
  protoOf(DefaultIntrinsicMeasurable).h8y = function (constraints) {
    if (this.wag_1.equals(IntrinsicWidthHeight_Width_getInstance())) {
      var tmp;
      if (this.vag_1.equals(IntrinsicMinMax_Max_getInstance())) {
        tmp = this.uag_1.c98(_Constraints___get_maxHeight__impl__dt3e8z(constraints));
      } else {
        tmp = this.uag_1.b98(_Constraints___get_maxHeight__impl__dt3e8z(constraints));
      }
      var width = tmp;
      var height = _Constraints___get_hasBoundedHeight__impl__bsh4rw(constraints) ? _Constraints___get_maxHeight__impl__dt3e8z(constraints) : 32767;
      return new FixedSizeIntrinsicsPlaceable(width, height);
    }
    var tmp_0;
    if (this.vag_1.equals(IntrinsicMinMax_Max_getInstance())) {
      tmp_0 = this.uag_1.e98(_Constraints___get_maxWidth__impl__uuyqc(constraints));
    } else {
      tmp_0 = this.uag_1.d98(_Constraints___get_maxWidth__impl__uuyqc(constraints));
    }
    var height_0 = tmp_0;
    var width_0 = _Constraints___get_hasBoundedWidth__impl__7hd0wr(constraints) ? _Constraints___get_maxWidth__impl__uuyqc(constraints) : 32767;
    return new FixedSizeIntrinsicsPlaceable(width_0, height_0);
  };
  protoOf(DefaultIntrinsicMeasurable).b98 = function (height) {
    return this.uag_1.b98(height);
  };
  protoOf(DefaultIntrinsicMeasurable).c98 = function (height) {
    return this.uag_1.c98(height);
  };
  protoOf(DefaultIntrinsicMeasurable).d98 = function (width) {
    return this.uag_1.d98(width);
  };
  protoOf(DefaultIntrinsicMeasurable).e98 = function (width) {
    return this.uag_1.e98(width);
  };
  var IntrinsicMinMax_Min_instance;
  var IntrinsicMinMax_Max_instance;
  var IntrinsicMinMax_entriesInitialized;
  function IntrinsicMinMax_initEntries() {
    if (IntrinsicMinMax_entriesInitialized)
      return Unit_instance;
    IntrinsicMinMax_entriesInitialized = true;
    IntrinsicMinMax_Min_instance = new IntrinsicMinMax('Min', 0);
    IntrinsicMinMax_Max_instance = new IntrinsicMinMax('Max', 1);
  }
  function IntrinsicMinMax(name, ordinal) {
    Enum.call(this, name, ordinal);
  }
  var IntrinsicWidthHeight_Width_instance;
  var IntrinsicWidthHeight_Height_instance;
  var IntrinsicWidthHeight_entriesInitialized;
  function IntrinsicWidthHeight_initEntries() {
    if (IntrinsicWidthHeight_entriesInitialized)
      return Unit_instance;
    IntrinsicWidthHeight_entriesInitialized = true;
    IntrinsicWidthHeight_Width_instance = new IntrinsicWidthHeight('Width', 0);
    IntrinsicWidthHeight_Height_instance = new IntrinsicWidthHeight('Height', 1);
  }
  function IntrinsicWidthHeight(name, ordinal) {
    Enum.call(this, name, ordinal);
  }
  function ApproachIntrinsicsMeasureScope$layout$1($w, $h, $alignmentLines, $rulers) {
    this.yag_1 = $w;
    this.zag_1 = $h;
    this.aah_1 = $alignmentLines;
    this.bah_1 = $rulers;
  }
  protoOf(ApproachIntrinsicsMeasureScope$layout$1).h5e = function () {
    return this.yag_1;
  };
  protoOf(ApproachIntrinsicsMeasureScope$layout$1).i5e = function () {
    return this.zag_1;
  };
  protoOf(ApproachIntrinsicsMeasureScope$layout$1).sad = function () {
    return this.aah_1;
  };
  protoOf(ApproachIntrinsicsMeasureScope$layout$1).tad = function () {
    return this.bah_1;
  };
  protoOf(ApproachIntrinsicsMeasureScope$layout$1).uad = function () {
  };
  function ApproachIntrinsicsMeasureScope(intrinsicMeasureScope, layoutDirection) {
    this.cah_1 = intrinsicMeasureScope;
    this.dah_1 = layoutDirection;
  }
  protoOf(ApproachIntrinsicsMeasureScope).r6p = function () {
    return this.dah_1;
  };
  protoOf(ApproachIntrinsicsMeasureScope).hag = function (width, height, alignmentLines, rulers, placementBlock) {
    // Inline function 'androidx.compose.ui.util.fastCoerceAtLeast' call
    var w = width < 0 ? 0 : width;
    // Inline function 'androidx.compose.ui.util.fastCoerceAtLeast' call
    var h = height < 0 ? 0 : height;
    // Inline function 'androidx.compose.ui.node.checkMeasuredSize' call
    // Inline function 'androidx.compose.ui.internal.checkPrecondition' call
    if (!((w & -16777216) === 0 && (h & -16777216) === 0)) {
      var tmp$ret$4 = 'Size(' + w + ' x ' + h + ') is out of range. Each dimension must be between 0 and ' + '16777215.';
      throwIllegalStateException(tmp$ret$4);
    }
    return new ApproachIntrinsicsMeasureScope$layout$1(w, h, alignmentLines, rulers);
  };
  protoOf(ApproachIntrinsicsMeasureScope).jag = function () {
    return this.cah_1.jag();
  };
  protoOf(ApproachIntrinsicsMeasureScope).v5e = function (_this__u8e3s4) {
    return this.cah_1.v5e(_this__u8e3s4);
  };
  protoOf(ApproachIntrinsicsMeasureScope).x5e = function (_this__u8e3s4) {
    return this.cah_1.x5e(_this__u8e3s4);
  };
  protoOf(ApproachIntrinsicsMeasureScope).w5e = function (_this__u8e3s4) {
    return this.cah_1.w5e(_this__u8e3s4);
  };
  protoOf(ApproachIntrinsicsMeasureScope).c5f = function (_this__u8e3s4) {
    return this.cah_1.c5f(_this__u8e3s4);
  };
  protoOf(ApproachIntrinsicsMeasureScope).d5f = function (_this__u8e3s4) {
    return this.cah_1.d5f(_this__u8e3s4);
  };
  protoOf(ApproachIntrinsicsMeasureScope).e5f = function (_this__u8e3s4) {
    return this.cah_1.e5f(_this__u8e3s4);
  };
  protoOf(ApproachIntrinsicsMeasureScope).b5f = function (_this__u8e3s4) {
    return this.cah_1.b5f(_this__u8e3s4);
  };
  protoOf(ApproachIntrinsicsMeasureScope).f5f = function (_this__u8e3s4) {
    return this.cah_1.f5f(_this__u8e3s4);
  };
  protoOf(ApproachIntrinsicsMeasureScope).g5f = function (_this__u8e3s4) {
    return this.cah_1.g5f(_this__u8e3s4);
  };
  protoOf(ApproachIntrinsicsMeasureScope).u5e = function () {
    return this.cah_1.u5e();
  };
  protoOf(ApproachIntrinsicsMeasureScope).j5f = function () {
    return this.cah_1.j5f();
  };
  function FixedSizeIntrinsicsPlaceable(width, height) {
    Placeable.call(this);
    // Inline function 'androidx.compose.ui.unit.IntSize' call
    // Inline function 'androidx.compose.ui.util.packInts' call
    var tmp$ret$1 = bitwiseOr(shiftLeft(fromInt(width), 32), bitwiseAnd(fromInt(height), new Long(-1, 0)));
    var tmp$ret$0 = _IntSize___init__impl__emcjft(tmp$ret$1);
    this.eah(tmp$ret$0);
  }
  protoOf(FixedSizeIntrinsicsPlaceable).kah = function (alignmentLine) {
    return -2147483648;
  };
  protoOf(FixedSizeIntrinsicsPlaceable).lah = function (position, zIndex, layerBlock) {
  };
  function ComposableLambda$invoke$ref(p0) {
    return constructCallableReference(function (p0_0, p1) {
      p0.t50(p0_0, p1);
      return Unit_instance;
    }, 2, 0, 17, VOID, [p0]);
  }
  function combineAsVirtualLayouts$lambda($contents) {
    return function ($composer, $changed) {
      var $composer_0 = $composer;
      var tmp;
      if ($composer_0.r31(!(($changed & 3) === 2), $changed & 1)) {
        // Inline function 'androidx.compose.ui.util.fastForEach' call
        var this_0 = $contents;
        var inductionVariable = 0;
        var last = this_0.n1() - 1 | 0;
        if (inductionVariable <= last)
          do {
            var index = inductionVariable;
            inductionVariable = inductionVariable + 1 | 0;
            var item = this_0.l1(index);
            var compositeKeyHash = get_currentCompositeKeyHashCode($composer_0, 0).hashCode();
            // Inline function 'androidx.compose.runtime.ReusableComposeNode' call
            var factory = Companion_getInstance_53().pah_1;
            var $composer_1 = $composer_0;
            var tmp_0 = $composer_1.g30();
            if (!isInterface(tmp_0, Applier)) {
              invalidApplier();
            }
            $composer_1.b31();
            if ($composer_1.h30()) {
              $composer_1.c31(factory);
            } else {
              $composer_1.d31();
            }
            var $this$ReusableComposeNode = _Updater___init__impl__rbfxm8($composer_1);
            Updater__set_impl_v7kwss($this$ReusableComposeNode, compositeKeyHash, Companion_getInstance_53().wah_1);
            item($composer_1, 14 & 6 >> 6);
            $composer_1.e31();
          }
           while (inductionVariable <= last);
        tmp = Unit_instance;
      } else {
        $composer_0.z30();
        tmp = Unit_instance;
      }
      return Unit_instance;
    };
  }
  function IntrinsicMinMax_Min_getInstance() {
    IntrinsicMinMax_initEntries();
    return IntrinsicMinMax_Min_instance;
  }
  function IntrinsicMinMax_Max_getInstance() {
    IntrinsicMinMax_initEntries();
    return IntrinsicMinMax_Max_instance;
  }
  function IntrinsicWidthHeight_Width_getInstance() {
    IntrinsicWidthHeight_initEntries();
    return IntrinsicWidthHeight_Width_instance;
  }
  function IntrinsicWidthHeight_Height_getInstance() {
    IntrinsicWidthHeight_initEntries();
    return IntrinsicWidthHeight_Height_instance;
  }
  var androidx_compose_ui_layout_LayoutBoundsHolder$stable;
  var androidx_compose_ui_layout_LayoutBoundsElement$stable;
  var androidx_compose_ui_layout_LayoutBoundsNode$stable;
  function LayoutCoordinates() {
  }
  function positionInParent(_this__u8e3s4) {
    var tmp0_safe_receiver = _this__u8e3s4.yah();
    var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.q91(_this__u8e3s4, Companion_getInstance().g5d_1);
    var tmp;
    var tmp_0 = tmp1_elvis_lhs;
    if ((tmp_0 == null ? null : new Offset(tmp_0)) == null) {
      tmp = Companion_getInstance().g5d_1;
    } else {
      tmp = tmp1_elvis_lhs;
    }
    return tmp;
  }
  function positionInRoot(_this__u8e3s4) {
    return _this__u8e3s4.dai(Companion_getInstance().g5d_1);
  }
  function positionOnScreen(_this__u8e3s4) {
    return _this__u8e3s4.aai(Companion_getInstance().g5d_1);
  }
  function findRootCoordinates(_this__u8e3s4) {
    var root = _this__u8e3s4;
    var parent = root.yah();
    while (!(parent == null)) {
      root = parent;
      parent = root.yah();
    }
    var tmp0_elvis_lhs = root instanceof NodeCoordinator ? root : null;
    var tmp;
    if (tmp0_elvis_lhs == null) {
      return root;
    } else {
      tmp = tmp0_elvis_lhs;
    }
    var rootCoordinator = tmp;
    var parentCoordinator = rootCoordinator.t94_1;
    while (!(parentCoordinator == null)) {
      rootCoordinator = parentCoordinator;
      parentCoordinator = parentCoordinator.t94_1;
    }
    return rootCoordinator;
  }
  function positionInWindow(_this__u8e3s4) {
    return _this__u8e3s4.cai(Companion_getInstance().g5d_1);
  }
  function boundsInWindow(_this__u8e3s4, clipBounds) {
    clipBounds = clipBounds === VOID ? true : clipBounds;
    var root = findRootCoordinates(_this__u8e3s4);
    // Inline function 'androidx.compose.ui.unit.IntSize.width' call
    var this_0 = root.q95();
    // Inline function 'androidx.compose.ui.util.unpackInt1' call
    var value = _IntSize___get_packedValue__impl__uho7jf(this_0);
    var rootWidth = convertToInt(shiftRight(value, 32));
    // Inline function 'androidx.compose.ui.unit.IntSize.height' call
    var this_1 = root.q95();
    // Inline function 'androidx.compose.ui.util.unpackInt2' call
    var value_0 = _IntSize___get_packedValue__impl__uho7jf(this_1);
    var rootHeight = convertToInt(bitwiseAnd(value_0, new Long(-1, 0)));
    var bounds = root.x9h(_this__u8e3s4, clipBounds);
    var tmp;
    if (clipBounds) {
      // Inline function 'androidx.compose.ui.util.fastCoerceIn' call
      // Inline function 'androidx.compose.ui.util.fastCoerceAtLeast' call
      var this_2 = bounds.k5d_1;
      // Inline function 'androidx.compose.ui.util.fastCoerceAtMost' call
      var this_3 = this_2 < 0.0 ? 0.0 : this_2;
      tmp = this_3 > rootWidth ? rootWidth : this_3;
    } else {
      tmp = bounds.k5d_1;
    }
    var boundsLeft = tmp;
    var tmp_0;
    if (clipBounds) {
      // Inline function 'androidx.compose.ui.util.fastCoerceIn' call
      // Inline function 'androidx.compose.ui.util.fastCoerceAtLeast' call
      var this_4 = bounds.l5d_1;
      // Inline function 'androidx.compose.ui.util.fastCoerceAtMost' call
      var this_5 = this_4 < 0.0 ? 0.0 : this_4;
      tmp_0 = this_5 > rootHeight ? rootHeight : this_5;
    } else {
      tmp_0 = bounds.l5d_1;
    }
    var boundsTop = tmp_0;
    var tmp_1;
    if (clipBounds) {
      // Inline function 'androidx.compose.ui.util.fastCoerceIn' call
      // Inline function 'androidx.compose.ui.util.fastCoerceAtLeast' call
      var this_6 = bounds.m5d_1;
      // Inline function 'androidx.compose.ui.util.fastCoerceAtMost' call
      var this_7 = this_6 < 0.0 ? 0.0 : this_6;
      tmp_1 = this_7 > rootWidth ? rootWidth : this_7;
    } else {
      tmp_1 = bounds.m5d_1;
    }
    var boundsRight = tmp_1;
    var tmp_2;
    if (clipBounds) {
      // Inline function 'androidx.compose.ui.util.fastCoerceIn' call
      // Inline function 'androidx.compose.ui.util.fastCoerceAtLeast' call
      var this_8 = bounds.n5d_1;
      // Inline function 'androidx.compose.ui.util.fastCoerceAtMost' call
      var this_9 = this_8 < 0.0 ? 0.0 : this_8;
      tmp_2 = this_9 > rootHeight ? rootHeight : this_9;
    } else {
      tmp_2 = bounds.n5d_1;
    }
    var boundsBottom = tmp_2;
    if (boundsLeft === boundsRight || boundsTop === boundsBottom) {
      return Companion_getInstance_2().j5d_1;
    }
    // Inline function 'androidx.compose.ui.geometry.Offset' call
    // Inline function 'androidx.compose.ui.util.packFloats' call
    var v1 = fromInt(toRawBits(boundsLeft));
    var v2 = fromInt(toRawBits(boundsTop));
    var tmp$ret$17 = bitwiseOr(shiftLeft(v1, 32), bitwiseAnd(v2, new Long(-1, 0)));
    var tmp$ret$16 = _Offset___init__impl__c168vi(tmp$ret$17);
    var topLeft = root.cai(tmp$ret$16);
    // Inline function 'androidx.compose.ui.geometry.Offset' call
    // Inline function 'androidx.compose.ui.util.packFloats' call
    var v1_0 = fromInt(toRawBits(boundsRight));
    var v2_0 = fromInt(toRawBits(boundsTop));
    var tmp$ret$19 = bitwiseOr(shiftLeft(v1_0, 32), bitwiseAnd(v2_0, new Long(-1, 0)));
    var tmp$ret$18 = _Offset___init__impl__c168vi(tmp$ret$19);
    var topRight = root.cai(tmp$ret$18);
    // Inline function 'androidx.compose.ui.geometry.Offset' call
    // Inline function 'androidx.compose.ui.util.packFloats' call
    var v1_1 = fromInt(toRawBits(boundsRight));
    var v2_1 = fromInt(toRawBits(boundsBottom));
    var tmp$ret$21 = bitwiseOr(shiftLeft(v1_1, 32), bitwiseAnd(v2_1, new Long(-1, 0)));
    var tmp$ret$20 = _Offset___init__impl__c168vi(tmp$ret$21);
    var bottomRight = root.cai(tmp$ret$20);
    // Inline function 'androidx.compose.ui.geometry.Offset' call
    // Inline function 'androidx.compose.ui.util.packFloats' call
    var v1_2 = fromInt(toRawBits(boundsLeft));
    var v2_2 = fromInt(toRawBits(boundsBottom));
    var tmp$ret$23 = bitwiseOr(shiftLeft(v1_2, 32), bitwiseAnd(v2_2, new Long(-1, 0)));
    var tmp$ret$22 = _Offset___init__impl__c168vi(tmp$ret$23);
    var bottomLeft = root.cai(tmp$ret$22);
    // Inline function 'androidx.compose.ui.geometry.Offset.x' call
    // Inline function 'androidx.compose.ui.util.unpackFloat1' call
    var value_1 = _Offset___get_packedValue__impl__xh2k8q(topLeft);
    // Inline function 'androidx.compose.ui.util.floatFromBits' call
    // Inline function 'kotlin.fromBits' call
    var bits = convertToInt(shiftRight(value_1, 32));
    var topLeftX = floatFromBits(bits);
    // Inline function 'androidx.compose.ui.geometry.Offset.x' call
    // Inline function 'androidx.compose.ui.util.unpackFloat1' call
    var value_2 = _Offset___get_packedValue__impl__xh2k8q(topRight);
    // Inline function 'androidx.compose.ui.util.floatFromBits' call
    // Inline function 'kotlin.fromBits' call
    var bits_0 = convertToInt(shiftRight(value_2, 32));
    var topRightX = floatFromBits(bits_0);
    // Inline function 'androidx.compose.ui.geometry.Offset.x' call
    // Inline function 'androidx.compose.ui.util.unpackFloat1' call
    var value_3 = _Offset___get_packedValue__impl__xh2k8q(bottomLeft);
    // Inline function 'androidx.compose.ui.util.floatFromBits' call
    // Inline function 'kotlin.fromBits' call
    var bits_1 = convertToInt(shiftRight(value_3, 32));
    var bottomLeftX = floatFromBits(bits_1);
    // Inline function 'androidx.compose.ui.geometry.Offset.x' call
    // Inline function 'androidx.compose.ui.util.unpackFloat1' call
    var value_4 = _Offset___get_packedValue__impl__xh2k8q(bottomRight);
    // Inline function 'androidx.compose.ui.util.floatFromBits' call
    // Inline function 'kotlin.fromBits' call
    var bits_2 = convertToInt(shiftRight(value_4, 32));
    var bottomRightX = floatFromBits(bits_2);
    // Inline function 'androidx.compose.ui.util.fastMinOf' call
    // Inline function 'kotlin.comparisons.minOf' call
    // Inline function 'kotlin.comparisons.minOf' call
    var b = Math.min(bottomLeftX, bottomRightX);
    // Inline function 'kotlin.comparisons.minOf' call
    var b_0 = Math.min(topRightX, b);
    var left = Math.min(topLeftX, b_0);
    // Inline function 'androidx.compose.ui.util.fastMaxOf' call
    // Inline function 'kotlin.comparisons.maxOf' call
    // Inline function 'kotlin.comparisons.maxOf' call
    var b_1 = Math.max(bottomLeftX, bottomRightX);
    // Inline function 'kotlin.comparisons.maxOf' call
    var b_2 = Math.max(topRightX, b_1);
    var right = Math.max(topLeftX, b_2);
    // Inline function 'androidx.compose.ui.geometry.Offset.y' call
    // Inline function 'androidx.compose.ui.util.unpackFloat2' call
    var value_5 = _Offset___get_packedValue__impl__xh2k8q(topLeft);
    // Inline function 'androidx.compose.ui.util.floatFromBits' call
    // Inline function 'kotlin.fromBits' call
    var bits_3 = convertToInt(bitwiseAnd(value_5, new Long(-1, 0)));
    var topLeftY = floatFromBits(bits_3);
    // Inline function 'androidx.compose.ui.geometry.Offset.y' call
    // Inline function 'androidx.compose.ui.util.unpackFloat2' call
    var value_6 = _Offset___get_packedValue__impl__xh2k8q(topRight);
    // Inline function 'androidx.compose.ui.util.floatFromBits' call
    // Inline function 'kotlin.fromBits' call
    var bits_4 = convertToInt(bitwiseAnd(value_6, new Long(-1, 0)));
    var topRightY = floatFromBits(bits_4);
    // Inline function 'androidx.compose.ui.geometry.Offset.y' call
    // Inline function 'androidx.compose.ui.util.unpackFloat2' call
    var value_7 = _Offset___get_packedValue__impl__xh2k8q(bottomLeft);
    // Inline function 'androidx.compose.ui.util.floatFromBits' call
    // Inline function 'kotlin.fromBits' call
    var bits_5 = convertToInt(bitwiseAnd(value_7, new Long(-1, 0)));
    var bottomLeftY = floatFromBits(bits_5);
    // Inline function 'androidx.compose.ui.geometry.Offset.y' call
    // Inline function 'androidx.compose.ui.util.unpackFloat2' call
    var value_8 = _Offset___get_packedValue__impl__xh2k8q(bottomRight);
    // Inline function 'androidx.compose.ui.util.floatFromBits' call
    // Inline function 'kotlin.fromBits' call
    var bits_6 = convertToInt(bitwiseAnd(value_8, new Long(-1, 0)));
    var bottomRightY = floatFromBits(bits_6);
    // Inline function 'androidx.compose.ui.util.fastMinOf' call
    // Inline function 'kotlin.comparisons.minOf' call
    // Inline function 'kotlin.comparisons.minOf' call
    var b_3 = Math.min(bottomLeftY, bottomRightY);
    // Inline function 'kotlin.comparisons.minOf' call
    var b_4 = Math.min(topRightY, b_3);
    var top = Math.min(topLeftY, b_4);
    // Inline function 'androidx.compose.ui.util.fastMaxOf' call
    // Inline function 'kotlin.comparisons.maxOf' call
    // Inline function 'kotlin.comparisons.maxOf' call
    var b_5 = Math.max(bottomLeftY, bottomRightY);
    // Inline function 'kotlin.comparisons.maxOf' call
    var b_6 = Math.max(topRightY, b_5);
    var bottom = Math.max(topLeftY, b_6);
    return new Rect(left, top, right, bottom);
  }
  function boundsInRoot(_this__u8e3s4) {
    return findRootCoordinates(_this__u8e3s4).fai(_this__u8e3s4);
  }
  function boundsInWindow_0(_this__u8e3s4) {
    return boundsInWindow(_this__u8e3s4, true);
  }
  var androidx_compose_ui_layout_LayoutIdModifier$stable;
  function layoutId(_this__u8e3s4, layoutId) {
    return _this__u8e3s4.d8v(new LayoutIdElement(layoutId));
  }
  function get_layoutId(_this__u8e3s4) {
    var tmp = _this__u8e3s4.xag();
    var tmp0_safe_receiver = (!(tmp == null) ? isInterface(tmp, LayoutIdParentData) : false) ? tmp : null;
    return tmp0_safe_receiver == null ? null : tmp0_safe_receiver.hai();
  }
  function LayoutIdParentData() {
  }
  function LayoutIdElement(layoutId) {
    ModifierNodeElement.call(this);
    this.jai_1 = layoutId;
  }
  protoOf(LayoutIdElement).r3d = function () {
    return new LayoutIdModifier(this.jai_1);
  };
  protoOf(LayoutIdElement).kai = function (node) {
    node.zai_1 = this.jai_1;
  };
  protoOf(LayoutIdElement).d8y = function (node) {
    return this.kai(node instanceof LayoutIdModifier ? node : THROW_CCE());
  };
  protoOf(LayoutIdElement).toString = function () {
    return 'LayoutIdElement(layoutId=' + toString(this.jai_1) + ')';
  };
  protoOf(LayoutIdElement).hashCode = function () {
    return hashCode(this.jai_1);
  };
  protoOf(LayoutIdElement).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof LayoutIdElement))
      return false;
    if (!equals(this.jai_1, other.jai_1))
      return false;
    return true;
  };
  function LayoutIdModifier(layoutId) {
    Node.call(this);
    this.zai_1 = layoutId;
  }
  protoOf(LayoutIdModifier).hai = function () {
    return this.zai_1;
  };
  protoOf(LayoutIdModifier).aaj = function (_this__u8e3s4, parentData) {
    return this;
  };
  var androidx_compose_ui_layout_ModifierInfo$stable;
  var androidx_compose_ui_layout_LayoutModifierImpl$stable;
  function layout_1(_this__u8e3s4, measure) {
    return _this__u8e3s4.d8v(new LayoutElement(measure));
  }
  function LayoutModifier() {
  }
  function LayoutElement(measure) {
    ModifierNodeElement.call(this);
    this.gaj_1 = measure;
  }
  protoOf(LayoutElement).r3d = function () {
    return new LayoutModifierImpl(this.gaj_1);
  };
  protoOf(LayoutElement).haj = function (node) {
    node.waj_1 = this.gaj_1;
  };
  protoOf(LayoutElement).d8y = function (node) {
    return this.haj(node instanceof LayoutModifierImpl ? node : THROW_CCE());
  };
  protoOf(LayoutElement).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof LayoutElement))
      return false;
    if (!(this.gaj_1 === other.gaj_1))
      return false;
    return true;
  };
  protoOf(LayoutElement).hashCode = function () {
    return hashCode(this.gaj_1);
  };
  var IntrinsicMinMax_Min_instance_0;
  var IntrinsicMinMax_Max_instance_0;
  var IntrinsicMinMax_entriesInitialized_0;
  function IntrinsicMinMax_initEntries_0() {
    if (IntrinsicMinMax_entriesInitialized_0)
      return Unit_instance;
    IntrinsicMinMax_entriesInitialized_0 = true;
    IntrinsicMinMax_Min_instance_0 = new IntrinsicMinMax_0('Min', 0);
    IntrinsicMinMax_Max_instance_0 = new IntrinsicMinMax_0('Max', 1);
  }
  var IntrinsicWidthHeight_Width_instance_0;
  var IntrinsicWidthHeight_Height_instance_0;
  var IntrinsicWidthHeight_entriesInitialized_0;
  function IntrinsicWidthHeight_initEntries_0() {
    if (IntrinsicWidthHeight_entriesInitialized_0)
      return Unit_instance;
    IntrinsicWidthHeight_entriesInitialized_0 = true;
    IntrinsicWidthHeight_Width_instance_0 = new IntrinsicWidthHeight_0('Width', 0);
    IntrinsicWidthHeight_Height_instance_0 = new IntrinsicWidthHeight_0('Height', 1);
  }
  function DefaultIntrinsicMeasurable_0(measurable, minMax, widthHeight) {
    this.xaj_1 = measurable;
    this.yaj_1 = minMax;
    this.zaj_1 = widthHeight;
  }
  protoOf(DefaultIntrinsicMeasurable_0).xag = function () {
    return this.xaj_1.xag();
  };
  protoOf(DefaultIntrinsicMeasurable_0).h8y = function (constraints) {
    if (this.zaj_1.equals(IntrinsicWidthHeight_Width_getInstance_0())) {
      var tmp;
      if (this.yaj_1.equals(IntrinsicMinMax_Max_getInstance_0())) {
        tmp = this.xaj_1.c98(_Constraints___get_maxHeight__impl__dt3e8z(constraints));
      } else {
        tmp = this.xaj_1.b98(_Constraints___get_maxHeight__impl__dt3e8z(constraints));
      }
      var width = tmp;
      var height = _Constraints___get_hasBoundedHeight__impl__bsh4rw(constraints) ? _Constraints___get_maxHeight__impl__dt3e8z(constraints) : 32767;
      return new EmptyPlaceable(width, height);
    }
    var tmp_0;
    if (this.yaj_1.equals(IntrinsicMinMax_Max_getInstance_0())) {
      tmp_0 = this.xaj_1.e98(_Constraints___get_maxWidth__impl__uuyqc(constraints));
    } else {
      tmp_0 = this.xaj_1.d98(_Constraints___get_maxWidth__impl__uuyqc(constraints));
    }
    var height_0 = tmp_0;
    var width_0 = _Constraints___get_hasBoundedWidth__impl__7hd0wr(constraints) ? _Constraints___get_maxWidth__impl__uuyqc(constraints) : 32767;
    return new EmptyPlaceable(width_0, height_0);
  };
  protoOf(DefaultIntrinsicMeasurable_0).b98 = function (height) {
    return this.xaj_1.b98(height);
  };
  protoOf(DefaultIntrinsicMeasurable_0).c98 = function (height) {
    return this.xaj_1.c98(height);
  };
  protoOf(DefaultIntrinsicMeasurable_0).d98 = function (width) {
    return this.xaj_1.d98(width);
  };
  protoOf(DefaultIntrinsicMeasurable_0).e98 = function (width) {
    return this.xaj_1.e98(width);
  };
  function EmptyPlaceable(width, height) {
    Placeable.call(this);
    // Inline function 'androidx.compose.ui.unit.IntSize' call
    // Inline function 'androidx.compose.ui.util.packInts' call
    var tmp$ret$1 = bitwiseOr(shiftLeft(fromInt(width), 32), bitwiseAnd(fromInt(height), new Long(-1, 0)));
    var tmp$ret$0 = _IntSize___init__impl__emcjft(tmp$ret$1);
    this.eah(tmp$ret$0);
  }
  protoOf(EmptyPlaceable).kah = function (alignmentLine) {
    return -2147483648;
  };
  protoOf(EmptyPlaceable).lah = function (position, zIndex, layerBlock) {
  };
  function IntrinsicMinMax_0(name, ordinal) {
    Enum.call(this, name, ordinal);
  }
  function IntrinsicWidthHeight_0(name, ordinal) {
    Enum.call(this, name, ordinal);
  }
  function IntrinsicMinMax_Min_getInstance_0() {
    IntrinsicMinMax_initEntries_0();
    return IntrinsicMinMax_Min_instance_0;
  }
  function IntrinsicMinMax_Max_getInstance_0() {
    IntrinsicMinMax_initEntries_0();
    return IntrinsicMinMax_Max_instance_0;
  }
  function IntrinsicWidthHeight_Width_getInstance_0() {
    IntrinsicWidthHeight_initEntries_0();
    return IntrinsicWidthHeight_Width_instance_0;
  }
  function IntrinsicWidthHeight_Height_getInstance_0() {
    IntrinsicWidthHeight_initEntries_0();
    return IntrinsicWidthHeight_Height_instance_0;
  }
  function MeasuringIntrinsics() {
  }
  protoOf(MeasuringIntrinsics).baj = function (modifier, intrinsicMeasureScope, intrinsicMeasurable, h) {
    var measurable = new DefaultIntrinsicMeasurable_0(intrinsicMeasurable, IntrinsicMinMax_Min_getInstance_0(), IntrinsicWidthHeight_Width_getInstance_0());
    var constraints = Constraints(VOID, VOID, VOID, h);
    // Inline function 'kotlin.with' call
    var layoutResult = modifier.g8y(new IntrinsicsMeasureScope(intrinsicMeasureScope, intrinsicMeasureScope.r6p()), measurable, constraints);
    return layoutResult.h5e();
  };
  protoOf(MeasuringIntrinsics).caj = function (modifier, intrinsicMeasureScope, intrinsicMeasurable, w) {
    var measurable = new DefaultIntrinsicMeasurable_0(intrinsicMeasurable, IntrinsicMinMax_Min_getInstance_0(), IntrinsicWidthHeight_Height_getInstance_0());
    var constraints = Constraints(VOID, w);
    // Inline function 'kotlin.with' call
    var layoutResult = modifier.g8y(new IntrinsicsMeasureScope(intrinsicMeasureScope, intrinsicMeasureScope.r6p()), measurable, constraints);
    return layoutResult.i5e();
  };
  protoOf(MeasuringIntrinsics).daj = function (modifier, intrinsicMeasureScope, intrinsicMeasurable, h) {
    var measurable = new DefaultIntrinsicMeasurable_0(intrinsicMeasurable, IntrinsicMinMax_Max_getInstance_0(), IntrinsicWidthHeight_Width_getInstance_0());
    var constraints = Constraints(VOID, VOID, VOID, h);
    // Inline function 'kotlin.with' call
    var layoutResult = modifier.g8y(new IntrinsicsMeasureScope(intrinsicMeasureScope, intrinsicMeasureScope.r6p()), measurable, constraints);
    return layoutResult.h5e();
  };
  protoOf(MeasuringIntrinsics).eaj = function (modifier, intrinsicMeasureScope, intrinsicMeasurable, w) {
    var measurable = new DefaultIntrinsicMeasurable_0(intrinsicMeasurable, IntrinsicMinMax_Max_getInstance_0(), IntrinsicWidthHeight_Height_getInstance_0());
    var constraints = Constraints(VOID, w);
    // Inline function 'kotlin.with' call
    var layoutResult = modifier.g8y(new IntrinsicsMeasureScope(intrinsicMeasureScope, intrinsicMeasureScope.r6p()), measurable, constraints);
    return layoutResult.i5e();
  };
  var MeasuringIntrinsics_instance;
  function MeasuringIntrinsics_getInstance() {
    return MeasuringIntrinsics_instance;
  }
  function LayoutModifierImpl(measureBlock) {
    Node.call(this);
    this.waj_1 = measureBlock;
  }
  protoOf(LayoutModifierImpl).g8y = function (_this__u8e3s4, measurable, constraints) {
    return this.waj_1(_this__u8e3s4, measurable, new Constraints_0(constraints));
  };
  protoOf(LayoutModifierImpl).toString = function () {
    return 'LayoutModifierImpl(measureBlock=' + toString(this.waj_1) + ')';
  };
  var androidx_compose_ui_layout_LookaheadLayoutCoordinates$stable;
  function _get_lookaheadOffset__abxczo($this) {
    // Inline function 'kotlin.let' call
    var it = get_rootLookaheadDelegate($this.fak_1);
    return Offset__minus_impl_hoj2c0($this.q91(it.p91(), Companion_getInstance().g5d_1), $this.gak().q91(it.zac_1, Companion_getInstance().g5d_1));
  }
  function LookaheadLayoutCoordinates(lookaheadDelegate) {
    this.fak_1 = lookaheadDelegate;
  }
  protoOf(LookaheadLayoutCoordinates).gak = function () {
    return this.fak_1.zac_1;
  };
  protoOf(LookaheadLayoutCoordinates).q95 = function () {
    // Inline function 'kotlin.let' call
    var it = this.fak_1;
    var tmp0 = it.i8y_1;
    // Inline function 'androidx.compose.ui.unit.IntSize' call
    // Inline function 'androidx.compose.ui.util.packInts' call
    var val2 = it.j8y_1;
    var tmp$ret$3 = bitwiseOr(shiftLeft(fromInt(tmp0), 32), bitwiseAnd(fromInt(val2), new Long(-1, 0)));
    return _IntSize___init__impl__emcjft(tmp$ret$3);
  };
  protoOf(LookaheadLayoutCoordinates).yah = function () {
    // Inline function 'androidx.compose.ui.internal.checkPrecondition' call
    if (!this.y91()) {
      var tmp$ret$1 = 'LayoutCoordinate operations are only valid when isAttached is true';
      throwIllegalStateException(tmp$ret$1);
    }
    var tmp0_safe_receiver = this.gak().a9i().hak().t94_1;
    var tmp;
    if (tmp0_safe_receiver == null) {
      tmp = null;
    } else {
      // Inline function 'kotlin.let' call
      var tmp0_safe_receiver_0 = tmp0_safe_receiver.kac();
      tmp = tmp0_safe_receiver_0 == null ? null : tmp0_safe_receiver_0.p91();
    }
    return tmp;
  };
  protoOf(LookaheadLayoutCoordinates).zah = function () {
    // Inline function 'androidx.compose.ui.internal.checkPrecondition' call
    if (!this.y91()) {
      var tmp$ret$1 = 'LayoutCoordinate operations are only valid when isAttached is true';
      throwIllegalStateException(tmp$ret$1);
    }
    var tmp0_safe_receiver = this.gak().t94_1;
    var tmp1_safe_receiver = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.kac();
    return tmp1_safe_receiver == null ? null : tmp1_safe_receiver.p91();
  };
  protoOf(LookaheadLayoutCoordinates).y91 = function () {
    return this.gak().y91();
  };
  protoOf(LookaheadLayoutCoordinates).aai = function (relativeToLocal) {
    return this.gak().aai(Offset__plus_impl_c78cg0(relativeToLocal, _get_lookaheadOffset__abxczo(this)));
  };
  protoOf(LookaheadLayoutCoordinates).bai = function (relativeToWindow) {
    return Offset__plus_impl_c78cg0(this.gak().bai(relativeToWindow), _get_lookaheadOffset__abxczo(this));
  };
  protoOf(LookaheadLayoutCoordinates).cai = function (relativeToLocal) {
    return this.gak().cai(Offset__plus_impl_c78cg0(relativeToLocal, _get_lookaheadOffset__abxczo(this)));
  };
  protoOf(LookaheadLayoutCoordinates).dai = function (relativeToLocal) {
    return this.gak().dai(Offset__plus_impl_c78cg0(relativeToLocal, _get_lookaheadOffset__abxczo(this)));
  };
  protoOf(LookaheadLayoutCoordinates).q91 = function (sourceCoordinates, relativeToSource) {
    return this.eai(sourceCoordinates, relativeToSource, true);
  };
  protoOf(LookaheadLayoutCoordinates).eai = function (sourceCoordinates, relativeToSource, includeMotionFrameOfReference) {
    if (sourceCoordinates instanceof LookaheadLayoutCoordinates) {
      var source = sourceCoordinates.fak_1;
      source.zac_1.jak();
      var commonAncestor = this.gak().kak(source.zac_1);
      var tmp0_safe_receiver = commonAncestor.kac();
      var tmp;
      if (tmp0_safe_receiver == null) {
        tmp = null;
      } else {
        // Inline function 'kotlin.let' call
        var sourceInCommonAncestor = IntOffset__plus_impl_nqoa9b(source.lak(tmp0_safe_receiver, !includeMotionFrameOfReference), round(relativeToSource));
        var lookaheadPosInAncestor = this.fak_1.lak(tmp0_safe_receiver, !includeMotionFrameOfReference);
        // Inline function 'androidx.compose.ui.unit.toOffset' call
        var this_0 = IntOffset__minus_impl_4m69hb(sourceInCommonAncestor, lookaheadPosInAncestor);
        var tmp0 = _IntOffset___get_x__impl__qiqr5o(this_0);
        // Inline function 'androidx.compose.ui.geometry.Offset' call
        // Inline function 'androidx.compose.ui.util.packFloats' call
        var val2 = _IntOffset___get_y__impl__2avpwj(this_0);
        var v1 = fromInt(toRawBits(tmp0));
        var v2 = fromInt(toRawBits(val2));
        var tmp$ret$4 = bitwiseOr(shiftLeft(v1, 32), bitwiseAnd(v2, new Long(-1, 0)));
        tmp = _Offset___init__impl__c168vi(tmp$ret$4);
      }
      var tmp1_elvis_lhs = tmp;
      var tmp_0;
      var tmp_1 = tmp1_elvis_lhs;
      if ((tmp_1 == null ? null : new Offset(tmp_1)) == null) {
        // Inline function 'kotlin.let' call
        var sourceRoot = get_rootLookaheadDelegate(source);
        var sourcePosition = IntOffset__plus_impl_nqoa9b(IntOffset__plus_impl_nqoa9b(source.lak(sourceRoot, !includeMotionFrameOfReference), sourceRoot.iak()), round(relativeToSource));
        var rootDelegate = get_rootLookaheadDelegate(this.fak_1);
        var lookaheadPosition = IntOffset__plus_impl_nqoa9b(this.fak_1.lak(rootDelegate, !includeMotionFrameOfReference), rootDelegate.iak());
        // Inline function 'androidx.compose.ui.unit.toOffset' call
        var this_1 = IntOffset__minus_impl_4m69hb(sourcePosition, lookaheadPosition);
        var tmp0_0 = _IntOffset___get_x__impl__qiqr5o(this_1);
        // Inline function 'androidx.compose.ui.geometry.Offset' call
        // Inline function 'androidx.compose.ui.util.packFloats' call
        var val2_0 = _IntOffset___get_y__impl__2avpwj(this_1);
        var v1_0 = fromInt(toRawBits(tmp0_0));
        var v2_0 = fromInt(toRawBits(val2_0));
        var tmp$ret$9 = bitwiseOr(shiftLeft(v1_0, 32), bitwiseAnd(v2_0, new Long(-1, 0)));
        var relativePosition = _Offset___init__impl__c168vi(tmp$ret$9);
        tmp_0 = ensureNotNull(rootDelegate.zac_1.t94_1).eai(ensureNotNull(sourceRoot.zac_1.t94_1), relativePosition, includeMotionFrameOfReference);
      } else {
        tmp_0 = tmp1_elvis_lhs;
      }
      return tmp_0;
    } else {
      var rootDelegate_0 = get_rootLookaheadDelegate(this.fak_1);
      var tmp_2 = this.eai(rootDelegate_0.cad_1, relativeToSource, includeMotionFrameOfReference);
      // Inline function 'androidx.compose.ui.unit.toOffset' call
      var this_2 = rootDelegate_0.iak();
      var tmp0_1 = _IntOffset___get_x__impl__qiqr5o(this_2);
      // Inline function 'androidx.compose.ui.geometry.Offset' call
      // Inline function 'androidx.compose.ui.util.packFloats' call
      var val2_1 = _IntOffset___get_y__impl__2avpwj(this_2);
      var v1_1 = fromInt(toRawBits(tmp0_1));
      var v2_1 = fromInt(toRawBits(val2_1));
      var tmp$ret$12 = bitwiseOr(shiftLeft(v1_1, 32), bitwiseAnd(v2_1, new Long(-1, 0)));
      var tmp$ret$10 = _Offset___init__impl__c168vi(tmp$ret$12);
      var localLookaheadPos = Offset__minus_impl_hoj2c0(tmp_2, tmp$ret$10);
      var tmp2_elvis_lhs = rootDelegate_0.zac_1.zah();
      var rootDelegateCoordinates = tmp2_elvis_lhs == null ? rootDelegate_0.zac_1.p91() : tmp2_elvis_lhs;
      var localPos = rootDelegateCoordinates.eai(sourceCoordinates, Companion_getInstance().g5d_1, includeMotionFrameOfReference);
      return Offset__plus_impl_c78cg0(localLookaheadPos, localPos);
    }
  };
  protoOf(LookaheadLayoutCoordinates).x9h = function (sourceCoordinates, clipBounds) {
    return this.gak().x9h(sourceCoordinates, clipBounds);
  };
  protoOf(LookaheadLayoutCoordinates).gai = function (sourceCoordinates, matrix) {
    this.gak().gai(sourceCoordinates, matrix);
  };
  function get_rootLookaheadDelegate(_this__u8e3s4) {
    var root = _this__u8e3s4.a9i();
    $l$loop: while (true) {
      var tmp0_safe_receiver = root.f9a();
      if (!!((tmp0_safe_receiver == null ? null : tmp0_safe_receiver.f90_1) == null)) {
        break $l$loop;
      }
      var tmp1_safe_receiver = root.f9a();
      var lookaheadRoot = ensureNotNull(tmp1_safe_receiver == null ? null : tmp1_safe_receiver.f90_1);
      if (lookaheadRoot.e90_1) {
        root = ensureNotNull(root.f9a());
      } else {
        root = ensureNotNull(ensureNotNull(root.f9a()).f90_1);
      }
    }
    return ensureNotNull(root.hak().kac());
  }
  function MeasurePolicy() {
  }
  function MeasureResult() {
  }
  function MeasureScope$layout$1($width, $height, $alignmentLines, $rulers, this$0, $placementBlock) {
    this.vak_1 = $width;
    this.wak_1 = this$0;
    this.xak_1 = $placementBlock;
    this.rak_1 = $width;
    this.sak_1 = $height;
    this.tak_1 = $alignmentLines;
    this.uak_1 = $rulers;
  }
  protoOf(MeasureScope$layout$1).h5e = function () {
    return this.rak_1;
  };
  protoOf(MeasureScope$layout$1).i5e = function () {
    return this.sak_1;
  };
  protoOf(MeasureScope$layout$1).sad = function () {
    return this.tak_1;
  };
  protoOf(MeasureScope$layout$1).tad = function () {
    return this.uak_1;
  };
  protoOf(MeasureScope$layout$1).uad = function () {
    var tmp = this.wak_1;
    if (tmp instanceof LookaheadCapablePlaceable) {
      this.xak_1(this.wak_1.gae_1);
    } else {
      this.xak_1(new SimplePlacementScope(this.vak_1, this.wak_1.r6p(), this.wak_1.u5e(), this.wak_1.j5f()));
    }
  };
  function MeasureScope() {
  }
  function SimplePlacementScope(parentWidth, parentLayoutDirection, density, fontScale) {
    PlacementScope.call(this);
    this.zak_1 = parentWidth;
    this.aal_1 = parentLayoutDirection;
    this.bal_1 = density;
    this.cal_1 = fontScale;
  }
  protoOf(SimplePlacementScope).dal = function () {
    return this.zak_1;
  };
  protoOf(SimplePlacementScope).eal = function () {
    return this.aal_1;
  };
  protoOf(SimplePlacementScope).u5e = function () {
    return this.bal_1;
  };
  protoOf(SimplePlacementScope).j5f = function () {
    return this.cal_1;
  };
  function Measured() {
  }
  var androidx_compose_ui_layout_MultiContentMeasurePolicyImpl$stable;
  function MultiContentMeasurePolicy() {
  }
  function createMeasurePolicy(measurePolicy) {
    return new MultiContentMeasurePolicyImpl(measurePolicy);
  }
  function MultiContentMeasurePolicyImpl(measurePolicy) {
    this.dam_1 = measurePolicy;
  }
  protoOf(MultiContentMeasurePolicyImpl).mak = function (_this__u8e3s4, measurables, constraints) {
    // Inline function 'kotlin.with' call
    return this.dam_1.yal(_this__u8e3s4, getChildrenOfVirtualChildren(_this__u8e3s4), constraints);
  };
  protoOf(MultiContentMeasurePolicyImpl).nak = function (_this__u8e3s4, measurables, height) {
    // Inline function 'kotlin.with' call
    return this.dam_1.zal(_this__u8e3s4, getChildrenOfVirtualChildren(_this__u8e3s4), height);
  };
  protoOf(MultiContentMeasurePolicyImpl).oak = function (_this__u8e3s4, measurables, width) {
    // Inline function 'kotlin.with' call
    return this.dam_1.aam(_this__u8e3s4, getChildrenOfVirtualChildren(_this__u8e3s4), width);
  };
  protoOf(MultiContentMeasurePolicyImpl).pak = function (_this__u8e3s4, measurables, height) {
    // Inline function 'kotlin.with' call
    return this.dam_1.bam(_this__u8e3s4, getChildrenOfVirtualChildren(_this__u8e3s4), height);
  };
  protoOf(MultiContentMeasurePolicyImpl).qak = function (_this__u8e3s4, measurables, width) {
    // Inline function 'kotlin.with' call
    return this.dam_1.cam(_this__u8e3s4, getChildrenOfVirtualChildren(_this__u8e3s4), width);
  };
  protoOf(MultiContentMeasurePolicyImpl).toString = function () {
    return 'MultiContentMeasurePolicyImpl(measurePolicy=' + toString(this.dam_1) + ')';
  };
  protoOf(MultiContentMeasurePolicyImpl).hashCode = function () {
    return hashCode(this.dam_1);
  };
  protoOf(MultiContentMeasurePolicyImpl).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof MultiContentMeasurePolicyImpl))
      return false;
    if (!equals(this.dam_1, other.dam_1))
      return false;
    return true;
  };
  function onGloballyPositioned(_this__u8e3s4, onGloballyPositioned) {
    return _this__u8e3s4.d8v(new OnGloballyPositionedElement(onGloballyPositioned));
  }
  function OnGloballyPositionedModifier() {
  }
  function OnGloballyPositionedElement(onGloballyPositioned) {
    ModifierNodeElement.call(this);
    this.gam_1 = onGloballyPositioned;
  }
  protoOf(OnGloballyPositionedElement).r3d = function () {
    return new OnGloballyPositionedNode(this.gam_1);
  };
  protoOf(OnGloballyPositionedElement).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof OnGloballyPositionedElement))
      return false;
    return this.gam_1 === other.gam_1;
  };
  protoOf(OnGloballyPositionedElement).hashCode = function () {
    return hashCode(this.gam_1);
  };
  protoOf(OnGloballyPositionedElement).ham = function (node) {
    node.wam_1 = this.gam_1;
  };
  protoOf(OnGloballyPositionedElement).d8y = function (node) {
    return this.ham(node instanceof OnGloballyPositionedNode ? node : THROW_CCE());
  };
  function OnGloballyPositionedNode(callback) {
    Node.call(this);
    this.wam_1 = callback;
  }
  protoOf(OnGloballyPositionedNode).eam = function (coordinates) {
    this.wam_1(coordinates);
  };
  function registerOnLayoutRectChanged(_this__u8e3s4, throttleMillis, debounceMillis, callback) {
    var layoutNode = requireLayoutNode(_this__u8e3s4);
    var id = layoutNode.x8z_1;
    var rectManager = requireOwner_0(layoutNode).xam();
    return rectManager.kan(id, throttleMillis, debounceMillis, _this__u8e3s4, callback);
  }
  var androidx_compose_ui_layout_OnPlacedNode$stable;
  function OnPlacedModifier() {
  }
  function OnPlacedNode(callback) {
    Node.call(this);
    this.zan_1 = callback;
  }
  protoOf(OnPlacedNode).x91 = function (coordinates) {
    this.zan_1(coordinates);
  };
  function onPlaced_0(_this__u8e3s4, onPlaced) {
    return _this__u8e3s4.d8v(new OnPlacedElement(onPlaced));
  }
  function OnPlacedElement(onPlaced) {
    ModifierNodeElement.call(this);
    this.bao_1 = onPlaced;
  }
  protoOf(OnPlacedElement).r3d = function () {
    return new OnPlacedNode(this.bao_1);
  };
  protoOf(OnPlacedElement).cao = function (node) {
    node.zan_1 = this.bao_1;
  };
  protoOf(OnPlacedElement).d8y = function (node) {
    return this.cao(node instanceof OnPlacedNode ? node : THROW_CCE());
  };
  protoOf(OnPlacedElement).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof OnPlacedElement))
      return false;
    if (!(this.bao_1 === other.bao_1))
      return false;
    return true;
  };
  protoOf(OnPlacedElement).hashCode = function () {
    return hashCode(this.bao_1);
  };
  var androidx_compose_ui_layout_OnSizeChangedNode$stable;
  function onSizeChanged(_this__u8e3s4, onSizeChanged) {
    return _this__u8e3s4.d8v(new OnSizeChangedModifier(onSizeChanged));
  }
  function OnSizeChangedModifier(onSizeChanged) {
    ModifierNodeElement.call(this);
    this.eao_1 = onSizeChanged;
  }
  protoOf(OnSizeChangedModifier).r3d = function () {
    return new OnSizeChangedNode(this.eao_1);
  };
  protoOf(OnSizeChangedModifier).fao = function (node) {
    node.xao(this.eao_1);
  };
  protoOf(OnSizeChangedModifier).d8y = function (node) {
    return this.fao(node instanceof OnSizeChangedNode ? node : THROW_CCE());
  };
  protoOf(OnSizeChangedModifier).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof OnSizeChangedModifier))
      return false;
    return this.eao_1 === other.eao_1;
  };
  protoOf(OnSizeChangedModifier).hashCode = function () {
    return hashCode(this.eao_1);
  };
  function OnSizeChangedNode(onSizeChanged) {
    Node.call(this);
    this.uao_1 = onSizeChanged;
    this.vao_1 = true;
    var tmp = this;
    var tmp0 = -2147483648;
    // Inline function 'androidx.compose.ui.unit.IntSize' call
    // Inline function 'androidx.compose.ui.util.packInts' call
    var val2 = -2147483648;
    var tmp$ret$1 = bitwiseOr(shiftLeft(fromInt(tmp0), 32), bitwiseAnd(fromInt(val2), new Long(-1, 0)));
    tmp.wao_1 = _IntSize___init__impl__emcjft(tmp$ret$1);
  }
  protoOf(OnSizeChangedNode).b8w = function () {
    return this.vao_1;
  };
  protoOf(OnSizeChangedNode).xao = function (onSizeChanged) {
    this.uao_1 = onSizeChanged;
    var tmp = this;
    var tmp0 = -2147483648;
    // Inline function 'androidx.compose.ui.unit.IntSize' call
    // Inline function 'androidx.compose.ui.util.packInts' call
    var val2 = -2147483648;
    var tmp$ret$1 = bitwiseOr(shiftLeft(fromInt(tmp0), 32), bitwiseAnd(fromInt(val2), new Long(-1, 0)));
    tmp.wao_1 = _IntSize___init__impl__emcjft(tmp$ret$1);
  };
  protoOf(OnSizeChangedNode).u91 = function (size) {
    if (!equals(this.wao_1, size)) {
      this.uao_1(new IntSize(size));
      this.wao_1 = size;
    }
  };
  function OnRemeasuredModifier() {
  }
  var androidx_compose_ui_layout_OnVisibilityChangedNode$stable;
  function ParentDataModifier() {
  }
  function get_LocalPinnableContainer() {
    _init_properties_PinnableContainer_kt__enl3lo();
    return LocalPinnableContainer;
  }
  var LocalPinnableContainer;
  function LocalPinnableContainer$lambda() {
    _init_properties_PinnableContainer_kt__enl3lo();
    return null;
  }
  var properties_initialized_PinnableContainer_kt_aghfz6;
  function _init_properties_PinnableContainer_kt__enl3lo() {
    if (!properties_initialized_PinnableContainer_kt_aghfz6) {
      properties_initialized_PinnableContainer_kt_aghfz6 = true;
      LocalPinnableContainer = compositionLocalOf(VOID, LocalPinnableContainer$lambda);
    }
  }
  function get_DefaultLayerBlock() {
    _init_properties_Placeable_kt__czryj5();
    return DefaultLayerBlock;
  }
  var DefaultLayerBlock;
  function get_DefaultConstraints() {
    _init_properties_Placeable_kt__czryj5();
    return DefaultConstraints;
  }
  var DefaultConstraints;
  var androidx_compose_ui_layout_Placeable_PlacementScope$stable;
  var androidx_compose_ui_layout_Placeable$stable;
  function handleMotionFrameOfReferencePlacement($this, $receiver) {
    if (isInterface($receiver, MotionReferencePlacementDelegate)) {
      $receiver.yao($this.e8y_1);
    }
  }
  function access$handleMotionFrameOfReferencePlacement($this, $receiver) {
    return handleMotionFrameOfReferencePlacement($this, $receiver);
  }
  function onMeasuredSizeChanged($this) {
    var tmp = $this;
    // Inline function 'androidx.compose.ui.unit.IntSize.width' call
    var this_0 = $this.k8y_1;
    // Inline function 'androidx.compose.ui.util.unpackInt1' call
    var value = _IntSize___get_packedValue__impl__uho7jf(this_0);
    var tmp$ret$0 = convertToInt(shiftRight(value, 32));
    tmp.i8y_1 = coerceIn(tmp$ret$0, _Constraints___get_minWidth__impl__hi9lfi($this.l8y_1), _Constraints___get_maxWidth__impl__uuyqc($this.l8y_1));
    var tmp_0 = $this;
    // Inline function 'androidx.compose.ui.unit.IntSize.height' call
    var this_1 = $this.k8y_1;
    // Inline function 'androidx.compose.ui.util.unpackInt2' call
    var value_0 = _IntSize___get_packedValue__impl__uho7jf(this_1);
    var tmp$ret$2 = convertToInt(bitwiseAnd(value_0, new Long(-1, 0)));
    tmp_0.j8y_1 = coerceIn(tmp$ret$2, _Constraints___get_minHeight__impl__ev4bgx($this.l8y_1), _Constraints___get_maxHeight__impl__dt3e8z($this.l8y_1));
    var tmp_1 = $this;
    var tmp_2 = $this.i8y_1;
    // Inline function 'androidx.compose.ui.unit.IntSize.width' call
    var this_2 = $this.k8y_1;
    // Inline function 'androidx.compose.ui.util.unpackInt1' call
    var value_1 = _IntSize___get_packedValue__impl__uho7jf(this_2);
    var tmp0 = (tmp_2 - convertToInt(shiftRight(value_1, 32)) | 0) / 2 | 0;
    var tmp_3 = $this.j8y_1;
    // Inline function 'androidx.compose.ui.unit.IntSize.height' call
    var this_3 = $this.k8y_1;
    // Inline function 'androidx.compose.ui.util.unpackInt2' call
    var value_2 = _IntSize___get_packedValue__impl__uho7jf(this_3);
    // Inline function 'androidx.compose.ui.unit.IntOffset' call
    // Inline function 'androidx.compose.ui.util.packInts' call
    var val2 = (tmp_3 - convertToInt(bitwiseAnd(value_2, new Long(-1, 0))) | 0) / 2 | 0;
    var tmp$ret$9 = bitwiseOr(shiftLeft(fromInt(tmp0), 32), bitwiseAnd(fromInt(val2), new Long(-1, 0)));
    tmp_1.m8y_1 = _IntOffset___init__impl__rq8h7b(tmp$ret$9);
  }
  function PlacementScope() {
    this.e8y_1 = false;
  }
  protoOf(PlacementScope).u5e = function () {
    return 1.0;
  };
  protoOf(PlacementScope).j5f = function () {
    return 1.0;
  };
  protoOf(PlacementScope).fal = function (_this__u8e3s4, defaultValue) {
    return defaultValue;
  };
  protoOf(PlacementScope).gal = function (_this__u8e3s4, position, zIndex) {
    // Inline function 'androidx.compose.ui.layout.PlacementScope.placeAutoMirrored' call
    if (this.eal().equals(LayoutDirection_Ltr_getInstance()) || this.dal() === 0) {
      // Inline function 'androidx.compose.ui.layout.PlacementScope.placeApparentToRealOffset' call
      access$handleMotionFrameOfReferencePlacement(this, _this__u8e3s4);
      _this__u8e3s4.lah(IntOffset__plus_impl_nqoa9b(position, _this__u8e3s4.m8y_1), zIndex, null);
    } else {
      var tmp0 = (this.dal() - _this__u8e3s4.i8y_1 | 0) - _IntOffset___get_x__impl__qiqr5o(position) | 0;
      // Inline function 'androidx.compose.ui.unit.IntOffset' call
      // Inline function 'androidx.compose.ui.util.packInts' call
      var val2 = _IntOffset___get_y__impl__2avpwj(position);
      var tmp$ret$3 = bitwiseOr(shiftLeft(fromInt(tmp0), 32), bitwiseAnd(fromInt(val2), new Long(-1, 0)));
      // Inline function 'androidx.compose.ui.layout.PlacementScope.placeApparentToRealOffset' call
      var position_0 = _IntOffset___init__impl__rq8h7b(tmp$ret$3);
      access$handleMotionFrameOfReferencePlacement(this, _this__u8e3s4);
      _this__u8e3s4.lah(IntOffset__plus_impl_nqoa9b(position_0, _this__u8e3s4.m8y_1), zIndex, null);
    }
    return Unit_instance;
  };
  protoOf(PlacementScope).hal = function (_this__u8e3s4, position, zIndex, $super) {
    zIndex = zIndex === VOID ? 0.0 : zIndex;
    var tmp;
    if ($super === VOID) {
      this.gal(_this__u8e3s4, position, zIndex);
      tmp = Unit_instance;
    } else {
      tmp = $super.gal.call(this, _this__u8e3s4, new IntOffset(position), zIndex);
    }
    return tmp;
  };
  protoOf(PlacementScope).ial = function (_this__u8e3s4, x, y, zIndex) {
    // Inline function 'androidx.compose.ui.unit.IntOffset' call
    // Inline function 'androidx.compose.ui.util.packInts' call
    var tmp$ret$1 = bitwiseOr(shiftLeft(fromInt(x), 32), bitwiseAnd(fromInt(y), new Long(-1, 0)));
    // Inline function 'androidx.compose.ui.layout.PlacementScope.placeAutoMirrored' call
    var position = _IntOffset___init__impl__rq8h7b(tmp$ret$1);
    if (this.eal().equals(LayoutDirection_Ltr_getInstance()) || this.dal() === 0) {
      // Inline function 'androidx.compose.ui.layout.PlacementScope.placeApparentToRealOffset' call
      access$handleMotionFrameOfReferencePlacement(this, _this__u8e3s4);
      _this__u8e3s4.lah(IntOffset__plus_impl_nqoa9b(position, _this__u8e3s4.m8y_1), zIndex, null);
    } else {
      var tmp0 = (this.dal() - _this__u8e3s4.i8y_1 | 0) - _IntOffset___get_x__impl__qiqr5o(position) | 0;
      // Inline function 'androidx.compose.ui.unit.IntOffset' call
      // Inline function 'androidx.compose.ui.util.packInts' call
      var val2 = _IntOffset___get_y__impl__2avpwj(position);
      var tmp$ret$5 = bitwiseOr(shiftLeft(fromInt(tmp0), 32), bitwiseAnd(fromInt(val2), new Long(-1, 0)));
      // Inline function 'androidx.compose.ui.layout.PlacementScope.placeApparentToRealOffset' call
      var position_0 = _IntOffset___init__impl__rq8h7b(tmp$ret$5);
      access$handleMotionFrameOfReferencePlacement(this, _this__u8e3s4);
      _this__u8e3s4.lah(IntOffset__plus_impl_nqoa9b(position_0, _this__u8e3s4.m8y_1), zIndex, null);
    }
    return Unit_instance;
  };
  protoOf(PlacementScope).a98 = function (_this__u8e3s4, x, y, zIndex, $super) {
    zIndex = zIndex === VOID ? 0.0 : zIndex;
    var tmp;
    if ($super === VOID) {
      this.ial(_this__u8e3s4, x, y, zIndex);
      tmp = Unit_instance;
    } else {
      tmp = $super.ial.call(this, _this__u8e3s4, x, y, zIndex);
    }
    return tmp;
  };
  protoOf(PlacementScope).f8y = function (_this__u8e3s4, x, y, zIndex) {
    // Inline function 'androidx.compose.ui.unit.IntOffset' call
    // Inline function 'androidx.compose.ui.util.packInts' call
    var tmp$ret$1 = bitwiseOr(shiftLeft(fromInt(x), 32), bitwiseAnd(fromInt(y), new Long(-1, 0)));
    // Inline function 'androidx.compose.ui.layout.PlacementScope.placeApparentToRealOffset' call
    var position = _IntOffset___init__impl__rq8h7b(tmp$ret$1);
    access$handleMotionFrameOfReferencePlacement(this, _this__u8e3s4);
    _this__u8e3s4.lah(IntOffset__plus_impl_nqoa9b(position, _this__u8e3s4.m8y_1), zIndex, null);
    return Unit_instance;
  };
  protoOf(PlacementScope).jal = function (_this__u8e3s4, x, y, zIndex, $super) {
    zIndex = zIndex === VOID ? 0.0 : zIndex;
    var tmp;
    if ($super === VOID) {
      this.f8y(_this__u8e3s4, x, y, zIndex);
      tmp = Unit_instance;
    } else {
      tmp = $super.f8y.call(this, _this__u8e3s4, x, y, zIndex);
    }
    return tmp;
  };
  protoOf(PlacementScope).kal = function (_this__u8e3s4, position, zIndex) {
    // Inline function 'androidx.compose.ui.layout.PlacementScope.placeApparentToRealOffset' call
    access$handleMotionFrameOfReferencePlacement(this, _this__u8e3s4);
    _this__u8e3s4.lah(IntOffset__plus_impl_nqoa9b(position, _this__u8e3s4.m8y_1), zIndex, null);
    return Unit_instance;
  };
  protoOf(PlacementScope).lal = function (_this__u8e3s4, position, zIndex, $super) {
    zIndex = zIndex === VOID ? 0.0 : zIndex;
    var tmp;
    if ($super === VOID) {
      this.kal(_this__u8e3s4, position, zIndex);
      tmp = Unit_instance;
    } else {
      tmp = $super.kal.call(this, _this__u8e3s4, new IntOffset(position), zIndex);
    }
    return tmp;
  };
  protoOf(PlacementScope).mal = function (_this__u8e3s4, position, zIndex, layerBlock) {
    // Inline function 'androidx.compose.ui.layout.PlacementScope.placeAutoMirrored' call
    if (this.eal().equals(LayoutDirection_Ltr_getInstance()) || this.dal() === 0) {
      // Inline function 'androidx.compose.ui.layout.PlacementScope.placeApparentToRealOffset' call
      access$handleMotionFrameOfReferencePlacement(this, _this__u8e3s4);
      _this__u8e3s4.lah(IntOffset__plus_impl_nqoa9b(position, _this__u8e3s4.m8y_1), zIndex, layerBlock);
    } else {
      var tmp0 = (this.dal() - _this__u8e3s4.i8y_1 | 0) - _IntOffset___get_x__impl__qiqr5o(position) | 0;
      // Inline function 'androidx.compose.ui.unit.IntOffset' call
      // Inline function 'androidx.compose.ui.util.packInts' call
      var val2 = _IntOffset___get_y__impl__2avpwj(position);
      var tmp$ret$3 = bitwiseOr(shiftLeft(fromInt(tmp0), 32), bitwiseAnd(fromInt(val2), new Long(-1, 0)));
      // Inline function 'androidx.compose.ui.layout.PlacementScope.placeApparentToRealOffset' call
      var position_0 = _IntOffset___init__impl__rq8h7b(tmp$ret$3);
      access$handleMotionFrameOfReferencePlacement(this, _this__u8e3s4);
      _this__u8e3s4.lah(IntOffset__plus_impl_nqoa9b(position_0, _this__u8e3s4.m8y_1), zIndex, layerBlock);
    }
    return Unit_instance;
  };
  protoOf(PlacementScope).nal = function (_this__u8e3s4, position, zIndex, layerBlock, $super) {
    zIndex = zIndex === VOID ? 0.0 : zIndex;
    layerBlock = layerBlock === VOID ? get_DefaultLayerBlock() : layerBlock;
    var tmp;
    if ($super === VOID) {
      this.mal(_this__u8e3s4, position, zIndex, layerBlock);
      tmp = Unit_instance;
    } else {
      tmp = $super.mal.call(this, _this__u8e3s4, new IntOffset(position), zIndex, layerBlock);
    }
    return tmp;
  };
  protoOf(PlacementScope).oal = function (_this__u8e3s4, x, y, zIndex, layerBlock) {
    // Inline function 'androidx.compose.ui.unit.IntOffset' call
    // Inline function 'androidx.compose.ui.util.packInts' call
    var tmp$ret$1 = bitwiseOr(shiftLeft(fromInt(x), 32), bitwiseAnd(fromInt(y), new Long(-1, 0)));
    // Inline function 'androidx.compose.ui.layout.PlacementScope.placeAutoMirrored' call
    var position = _IntOffset___init__impl__rq8h7b(tmp$ret$1);
    if (this.eal().equals(LayoutDirection_Ltr_getInstance()) || this.dal() === 0) {
      // Inline function 'androidx.compose.ui.layout.PlacementScope.placeApparentToRealOffset' call
      access$handleMotionFrameOfReferencePlacement(this, _this__u8e3s4);
      _this__u8e3s4.lah(IntOffset__plus_impl_nqoa9b(position, _this__u8e3s4.m8y_1), zIndex, layerBlock);
    } else {
      var tmp0 = (this.dal() - _this__u8e3s4.i8y_1 | 0) - _IntOffset___get_x__impl__qiqr5o(position) | 0;
      // Inline function 'androidx.compose.ui.unit.IntOffset' call
      // Inline function 'androidx.compose.ui.util.packInts' call
      var val2 = _IntOffset___get_y__impl__2avpwj(position);
      var tmp$ret$5 = bitwiseOr(shiftLeft(fromInt(tmp0), 32), bitwiseAnd(fromInt(val2), new Long(-1, 0)));
      // Inline function 'androidx.compose.ui.layout.PlacementScope.placeApparentToRealOffset' call
      var position_0 = _IntOffset___init__impl__rq8h7b(tmp$ret$5);
      access$handleMotionFrameOfReferencePlacement(this, _this__u8e3s4);
      _this__u8e3s4.lah(IntOffset__plus_impl_nqoa9b(position_0, _this__u8e3s4.m8y_1), zIndex, layerBlock);
    }
    return Unit_instance;
  };
  protoOf(PlacementScope).pal = function (_this__u8e3s4, x, y, zIndex, layerBlock, $super) {
    zIndex = zIndex === VOID ? 0.0 : zIndex;
    layerBlock = layerBlock === VOID ? get_DefaultLayerBlock() : layerBlock;
    var tmp;
    if ($super === VOID) {
      this.oal(_this__u8e3s4, x, y, zIndex, layerBlock);
      tmp = Unit_instance;
    } else {
      tmp = $super.oal.call(this, _this__u8e3s4, x, y, zIndex, layerBlock);
    }
    return tmp;
  };
  protoOf(PlacementScope).sal = function (_this__u8e3s4, x, y, zIndex, layerBlock) {
    // Inline function 'androidx.compose.ui.unit.IntOffset' call
    // Inline function 'androidx.compose.ui.util.packInts' call
    var tmp$ret$1 = bitwiseOr(shiftLeft(fromInt(x), 32), bitwiseAnd(fromInt(y), new Long(-1, 0)));
    // Inline function 'androidx.compose.ui.layout.PlacementScope.placeApparentToRealOffset' call
    var position = _IntOffset___init__impl__rq8h7b(tmp$ret$1);
    access$handleMotionFrameOfReferencePlacement(this, _this__u8e3s4);
    _this__u8e3s4.lah(IntOffset__plus_impl_nqoa9b(position, _this__u8e3s4.m8y_1), zIndex, layerBlock);
    return Unit_instance;
  };
  protoOf(PlacementScope).j9i = function (_this__u8e3s4, x, y, zIndex, layerBlock, $super) {
    zIndex = zIndex === VOID ? 0.0 : zIndex;
    layerBlock = layerBlock === VOID ? get_DefaultLayerBlock() : layerBlock;
    var tmp;
    if ($super === VOID) {
      this.sal(_this__u8e3s4, x, y, zIndex, layerBlock);
      tmp = Unit_instance;
    } else {
      tmp = $super.sal.call(this, _this__u8e3s4, x, y, zIndex, layerBlock);
    }
    return tmp;
  };
  protoOf(PlacementScope).tal = function (_this__u8e3s4, position, zIndex, layerBlock) {
    // Inline function 'androidx.compose.ui.layout.PlacementScope.placeApparentToRealOffset' call
    access$handleMotionFrameOfReferencePlacement(this, _this__u8e3s4);
    _this__u8e3s4.lah(IntOffset__plus_impl_nqoa9b(position, _this__u8e3s4.m8y_1), zIndex, layerBlock);
    return Unit_instance;
  };
  protoOf(PlacementScope).ual = function (_this__u8e3s4, position, zIndex, layerBlock, $super) {
    zIndex = zIndex === VOID ? 0.0 : zIndex;
    layerBlock = layerBlock === VOID ? get_DefaultLayerBlock() : layerBlock;
    var tmp;
    if ($super === VOID) {
      this.tal(_this__u8e3s4, position, zIndex, layerBlock);
      tmp = Unit_instance;
    } else {
      tmp = $super.tal.call(this, _this__u8e3s4, new IntOffset(position), zIndex, layerBlock);
    }
    return tmp;
  };
  protoOf(PlacementScope).val = function (_this__u8e3s4, position, layer, zIndex) {
    // Inline function 'androidx.compose.ui.layout.PlacementScope.placeApparentToRealOffset' call
    access$handleMotionFrameOfReferencePlacement(this, _this__u8e3s4);
    _this__u8e3s4.nah(IntOffset__plus_impl_nqoa9b(position, _this__u8e3s4.m8y_1), zIndex, layer);
    return Unit_instance;
  };
  protoOf(PlacementScope).wal = function (_this__u8e3s4, position, layer, zIndex, $super) {
    zIndex = zIndex === VOID ? 0.0 : zIndex;
    var tmp;
    if ($super === VOID) {
      this.val(_this__u8e3s4, position, layer, zIndex);
      tmp = Unit_instance;
    } else {
      tmp = $super.val.call(this, _this__u8e3s4, new IntOffset(position), layer, zIndex);
    }
    return tmp;
  };
  protoOf(PlacementScope).qal = function (_this__u8e3s4, position, layer, zIndex) {
    // Inline function 'androidx.compose.ui.layout.PlacementScope.placeAutoMirrored' call
    if (this.eal().equals(LayoutDirection_Ltr_getInstance()) || this.dal() === 0) {
      // Inline function 'androidx.compose.ui.layout.PlacementScope.placeApparentToRealOffset' call
      access$handleMotionFrameOfReferencePlacement(this, _this__u8e3s4);
      _this__u8e3s4.nah(IntOffset__plus_impl_nqoa9b(position, _this__u8e3s4.m8y_1), zIndex, layer);
    } else {
      var tmp0 = (this.dal() - _this__u8e3s4.i8y_1 | 0) - _IntOffset___get_x__impl__qiqr5o(position) | 0;
      // Inline function 'androidx.compose.ui.unit.IntOffset' call
      // Inline function 'androidx.compose.ui.util.packInts' call
      var val2 = _IntOffset___get_y__impl__2avpwj(position);
      var tmp$ret$3 = bitwiseOr(shiftLeft(fromInt(tmp0), 32), bitwiseAnd(fromInt(val2), new Long(-1, 0)));
      // Inline function 'androidx.compose.ui.layout.PlacementScope.placeApparentToRealOffset' call
      var position_0 = _IntOffset___init__impl__rq8h7b(tmp$ret$3);
      access$handleMotionFrameOfReferencePlacement(this, _this__u8e3s4);
      _this__u8e3s4.nah(IntOffset__plus_impl_nqoa9b(position_0, _this__u8e3s4.m8y_1), zIndex, layer);
    }
    return Unit_instance;
  };
  protoOf(PlacementScope).ral = function (_this__u8e3s4, position, layer, zIndex, $super) {
    zIndex = zIndex === VOID ? 0.0 : zIndex;
    var tmp;
    if ($super === VOID) {
      this.qal(_this__u8e3s4, position, layer, zIndex);
      tmp = Unit_instance;
    } else {
      tmp = $super.qal.call(this, _this__u8e3s4, new IntOffset(position), layer, zIndex);
    }
    return tmp;
  };
  protoOf(PlacementScope).xal = function (block) {
    this.e8y_1 = true;
    block(this);
    this.e8y_1 = false;
  };
  function Placeable() {
    this.i8y_1 = 0;
    this.j8y_1 = 0;
    var tmp = this;
    // Inline function 'androidx.compose.ui.unit.IntSize' call
    // Inline function 'androidx.compose.ui.util.packInts' call
    var tmp$ret$1 = bitwiseOr(shiftLeft(fromInt(0), 32), bitwiseAnd(fromInt(0), new Long(-1, 0)));
    tmp.k8y_1 = _IntSize___init__impl__emcjft(tmp$ret$1);
    this.l8y_1 = get_DefaultConstraints();
    this.m8y_1 = Companion_getInstance_11().c5g_1;
  }
  protoOf(Placeable).mah = function () {
    // Inline function 'androidx.compose.ui.unit.IntSize.width' call
    var this_0 = this.k8y_1;
    // Inline function 'androidx.compose.ui.util.unpackInt1' call
    var value = _IntSize___get_packedValue__impl__uho7jf(this_0);
    return convertToInt(shiftRight(value, 32));
  };
  protoOf(Placeable).zao = function () {
    // Inline function 'androidx.compose.ui.unit.IntSize.height' call
    var this_0 = this.k8y_1;
    // Inline function 'androidx.compose.ui.util.unpackInt2' call
    var value = _IntSize___get_packedValue__impl__uho7jf(this_0);
    return convertToInt(bitwiseAnd(value, new Long(-1, 0)));
  };
  protoOf(Placeable).eah = function (value) {
    if (!equals(this.k8y_1, value)) {
      this.k8y_1 = value;
      onMeasuredSizeChanged(this);
    }
  };
  protoOf(Placeable).nah = function (position, zIndex, layer) {
    this.lah(position, zIndex, null);
  };
  protoOf(Placeable).aap = function (value) {
    if (!equals(this.l8y_1, value)) {
      this.l8y_1 = value;
      onMeasuredSizeChanged(this);
    }
  };
  function PlacementScope_0(lookaheadCapablePlaceable) {
    _init_properties_Placeable_kt__czryj5();
    return new LookaheadCapablePlacementScope(lookaheadCapablePlaceable);
  }
  function PlacementScope_1(owner) {
    _init_properties_Placeable_kt__czryj5();
    return new OuterPlacementScope(owner);
  }
  function LookaheadCapablePlacementScope(within) {
    PlacementScope.call(this);
    this.cap_1 = within;
  }
  protoOf(LookaheadCapablePlacementScope).dal = function () {
    return this.cap_1.mah();
  };
  protoOf(LookaheadCapablePlacementScope).eal = function () {
    return this.cap_1.r6p();
  };
  protoOf(LookaheadCapablePlacementScope).fal = function (_this__u8e3s4, defaultValue) {
    var tmp;
    if (!(_this__u8e3s4.eap_1 === null)) {
      tmp = _this__u8e3s4.eap_1(this, defaultValue);
    } else {
      tmp = this.cap_1.dap(_this__u8e3s4, defaultValue);
    }
    return tmp;
  };
  protoOf(LookaheadCapablePlacementScope).u5e = function () {
    return this.cap_1.u5e();
  };
  protoOf(LookaheadCapablePlacementScope).j5f = function () {
    return this.cap_1.j5f();
  };
  function OuterPlacementScope(owner) {
    PlacementScope.call(this);
    this.gap_1 = owner;
  }
  protoOf(OuterPlacementScope).dal = function () {
    return this.gap_1.n65().h5e();
  };
  protoOf(OuterPlacementScope).eal = function () {
    return this.gap_1.r6p();
  };
  protoOf(OuterPlacementScope).u5e = function () {
    return this.gap_1.u5e().u5e();
  };
  protoOf(OuterPlacementScope).j5f = function () {
    return this.gap_1.u5e().j5f();
  };
  function DefaultLayerBlock$lambda(_this__u8e3s4) {
    _init_properties_Placeable_kt__czryj5();
    return Unit_instance;
  }
  var properties_initialized_Placeable_kt_ibfqof;
  function _init_properties_Placeable_kt__czryj5() {
    if (!properties_initialized_Placeable_kt_ibfqof) {
      properties_initialized_Placeable_kt_ibfqof = true;
      DefaultLayerBlock = DefaultLayerBlock$lambda;
      DefaultConstraints = Constraints();
      androidx_compose_ui_layout_Placeable_PlacementScope$stable = 0;
      androidx_compose_ui_layout_Placeable$stable = 8;
    }
  }
  function Companion_21() {
  }
  var Companion_instance_26;
  function Companion_getInstance_47() {
    return Companion_instance_26;
  }
  function RectRulersImpl(name) {
    this.hap_1 = name;
    this.iap_1 = VerticalRuler_init_$Create$();
    this.jap_1 = HorizontalRuler_init_$Create$();
    this.kap_1 = VerticalRuler_init_$Create$();
    this.lap_1 = HorizontalRuler_init_$Create$();
  }
  protoOf(RectRulersImpl).e9f = function () {
    return this.iap_1;
  };
  protoOf(RectRulersImpl).map = function () {
    return this.jap_1;
  };
  protoOf(RectRulersImpl).x61 = function () {
    return this.kap_1;
  };
  protoOf(RectRulersImpl).nap = function () {
    return this.lap_1;
  };
  protoOf(RectRulersImpl).toString = function () {
    return !(this.hap_1 == null) ? 'RectRulers(' + this.hap_1 + ')' : anyToString(this);
  };
  function RectRulers(name) {
    return new RectRulersImpl(name);
  }
  function innermostOf(_this__u8e3s4, rulers) {
    return new InnerRectRulers(rulers);
  }
  function InnerRectRulers(rulers) {
    this.oap_1 = rulers;
    var tmp = this;
    var tmp_0 = Companion_instance_28;
    var tmp_1 = 0;
    var tmp_2 = this.oap_1.length;
    // Inline function 'kotlin.arrayOfNulls' call
    var tmp_3 = Array(tmp_2);
    while (tmp_1 < tmp_2) {
      var tmp_4 = tmp_1;
      tmp_3[tmp_4] = this.oap_1[tmp_4].e9f();
      tmp_1 = tmp_1 + 1 | 0;
    }
    tmp.pap_1 = tmp_0.tap(tmp_3.slice());
    var tmp_5 = this;
    var tmp_6 = Companion_instance_27;
    var tmp_7 = 0;
    var tmp_8 = this.oap_1.length;
    // Inline function 'kotlin.arrayOfNulls' call
    var tmp_9 = Array(tmp_8);
    while (tmp_7 < tmp_8) {
      var tmp_10 = tmp_7;
      tmp_9[tmp_10] = this.oap_1[tmp_10].map();
      tmp_7 = tmp_7 + 1 | 0;
    }
    tmp_5.qap_1 = tmp_6.uap(tmp_9.slice());
    var tmp_11 = this;
    var tmp_12 = Companion_instance_28;
    var tmp_13 = 0;
    var tmp_14 = this.oap_1.length;
    // Inline function 'kotlin.arrayOfNulls' call
    var tmp_15 = Array(tmp_14);
    while (tmp_13 < tmp_14) {
      var tmp_16 = tmp_13;
      tmp_15[tmp_16] = this.oap_1[tmp_16].x61();
      tmp_13 = tmp_13 + 1 | 0;
    }
    tmp_11.rap_1 = tmp_12.vap(tmp_15.slice());
    var tmp_17 = this;
    var tmp_18 = Companion_instance_27;
    var tmp_19 = 0;
    var tmp_20 = this.oap_1.length;
    // Inline function 'kotlin.arrayOfNulls' call
    var tmp_21 = Array(tmp_20);
    while (tmp_19 < tmp_20) {
      var tmp_22 = tmp_19;
      tmp_21[tmp_22] = this.oap_1[tmp_22].nap();
      tmp_19 = tmp_19 + 1 | 0;
    }
    tmp_17.sap_1 = tmp_18.wap(tmp_21.slice());
  }
  protoOf(InnerRectRulers).e9f = function () {
    return this.pap_1;
  };
  protoOf(InnerRectRulers).map = function () {
    return this.qap_1;
  };
  protoOf(InnerRectRulers).x61 = function () {
    return this.rap_1;
  };
  protoOf(InnerRectRulers).nap = function () {
    return this.sap_1;
  };
  protoOf(InnerRectRulers).toString = function () {
    return joinToString(this.oap_1, VOID, 'innermostOf(', ')');
  };
  function RemeasurementModifier() {
  }
  var androidx_compose_ui_layout_RootMeasurePolicy$stable;
  function RootMeasurePolicy$measure$lambda($this$layout) {
    return Unit_instance;
  }
  function RootMeasurePolicy$measure$lambda_0($placeable) {
    return function ($this$layout) {
      $this$layout.pal($placeable, 0, 0);
      return Unit_instance;
    };
  }
  function RootMeasurePolicy$measure$lambda_1($placeables) {
    return function ($this$layout) {
      // Inline function 'androidx.compose.ui.util.fastForEach' call
      var this_0 = $placeables;
      var inductionVariable = 0;
      var last = this_0.n1() - 1 | 0;
      if (inductionVariable <= last)
        do {
          var index = inductionVariable;
          inductionVariable = inductionVariable + 1 | 0;
          var item = this_0.l1(index);
          $this$layout.pal(item, 0, 0);
        }
         while (inductionVariable <= last);
      return Unit_instance;
    };
  }
  function RootMeasurePolicy() {
    RootMeasurePolicy_instance = this;
    NoIntrinsicsMeasurePolicy.call(this, 'Undefined intrinsics block and it is required');
  }
  protoOf(RootMeasurePolicy).mak = function (_this__u8e3s4, measurables, constraints) {
    var tmp;
    switch (measurables.n1()) {
      case 0:
        var tmp_0 = _Constraints___get_minWidth__impl__hi9lfi(constraints);
        var tmp_1 = _Constraints___get_minHeight__impl__ev4bgx(constraints);
        tmp = _this__u8e3s4.n8y(tmp_0, tmp_1, VOID, RootMeasurePolicy$measure$lambda);
        break;
      case 1:
        var placeable = measurables.l1(0).h8y(constraints);
        var tmp_2 = constrainWidth(constraints, placeable.i8y_1);
        var tmp_3 = constrainHeight(constraints, placeable.j8y_1);
        tmp = _this__u8e3s4.n8y(tmp_2, tmp_3, VOID, RootMeasurePolicy$measure$lambda_0(placeable));
        break;
      default:
        var maxWidth = 0;
        var maxHeight = 0;
        // Inline function 'androidx.compose.ui.util.fastMap' call

        var target = ArrayList_init_$Create$_0(measurables.n1());
        // Inline function 'androidx.compose.ui.util.fastForEach' call

        var inductionVariable = 0;
        var last = measurables.n1() - 1 | 0;
        if (inductionVariable <= last)
          do {
            var index = inductionVariable;
            inductionVariable = inductionVariable + 1 | 0;
            var item = measurables.l1(index);
            // Inline function 'kotlin.apply' call
            var this_0 = item.h8y(constraints);
            var tmp0 = this_0.i8y_1;
            // Inline function 'kotlin.comparisons.maxOf' call
            var b = maxWidth;
            maxWidth = Math.max(tmp0, b);
            var tmp0_0 = this_0.j8y_1;
            // Inline function 'kotlin.comparisons.maxOf' call
            var b_0 = maxHeight;
            maxHeight = Math.max(tmp0_0, b_0);
            // Inline function 'kotlin.collections.plusAssign' call
            target.j1(this_0);
          }
           while (inductionVariable <= last);
        var placeables = target;
        var tmp_4 = constrainWidth(constraints, maxWidth);
        var tmp_5 = constrainHeight(constraints, maxHeight);
        tmp = _this__u8e3s4.n8y(tmp_4, tmp_5, VOID, RootMeasurePolicy$measure$lambda_1(placeables));
        break;
    }
    return tmp;
  };
  var RootMeasurePolicy_instance;
  function RootMeasurePolicy_getInstance() {
    if (RootMeasurePolicy_instance == null)
      new RootMeasurePolicy();
    return RootMeasurePolicy_instance;
  }
  var androidx_compose_ui_layout_Ruler$stable;
  var androidx_compose_ui_layout_VerticalRuler$stable;
  var androidx_compose_ui_layout_HorizontalRuler$stable;
  function HorizontalRuler$Companion$maxOf$lambda($rulers) {
    return function ($this$HorizontalRuler, defaultValue) {
      return mergeRulerValues($this$HorizontalRuler, true, $rulers, defaultValue);
    };
  }
  function HorizontalRuler$Companion$minOf$lambda($rulers) {
    return function ($this$HorizontalRuler, defaultValue) {
      return mergeRulerValues($this$HorizontalRuler, false, $rulers, defaultValue);
    };
  }
  function HorizontalRuler_init_$Init$($this) {
    HorizontalRuler.call($this, null);
    return $this;
  }
  function HorizontalRuler_init_$Create$() {
    return HorizontalRuler_init_$Init$(objectCreate(protoOf(HorizontalRuler)));
  }
  function Companion_22() {
  }
  protoOf(Companion_22).uap = function (rulers) {
    return new HorizontalRuler(HorizontalRuler$Companion$maxOf$lambda(rulers));
  };
  protoOf(Companion_22).wap = function (rulers) {
    return new HorizontalRuler(HorizontalRuler$Companion$minOf$lambda(rulers));
  };
  var Companion_instance_27;
  function Companion_getInstance_48() {
    return Companion_instance_27;
  }
  function HorizontalRuler(calculation) {
    Ruler.call(this, calculation);
  }
  protoOf(HorizontalRuler).baq = function (coordinate, sourceCoordinates, targetCoordinates) {
    // Inline function 'androidx.compose.ui.unit.IntSize.width' call
    var this_0 = sourceCoordinates.q95();
    // Inline function 'androidx.compose.ui.util.unpackInt1' call
    var value = _IntSize___get_packedValue__impl__uho7jf(this_0);
    // Inline function 'androidx.compose.ui.geometry.Offset' call
    // Inline function 'androidx.compose.ui.util.packFloats' call
    var val1 = convertToInt(shiftRight(value, 32)) / 2.0;
    var v1 = fromInt(toRawBits(val1));
    var v2 = fromInt(toRawBits(coordinate));
    var tmp$ret$3 = bitwiseOr(shiftLeft(v1, 32), bitwiseAnd(v2, new Long(-1, 0)));
    var offset = _Offset___init__impl__c168vi(tmp$ret$3);
    // Inline function 'androidx.compose.ui.geometry.Offset.y' call
    var this_1 = targetCoordinates.q91(sourceCoordinates, offset);
    // Inline function 'androidx.compose.ui.util.unpackFloat2' call
    var value_0 = _Offset___get_packedValue__impl__xh2k8q(this_1);
    // Inline function 'androidx.compose.ui.util.floatFromBits' call
    // Inline function 'kotlin.fromBits' call
    var bits = convertToInt(bitwiseAnd(value_0, new Long(-1, 0)));
    return floatFromBits(bits);
  };
  function VerticalRuler$Companion$maxOf$lambda($rulers) {
    return function ($this$derived, defaultValue) {
      return mergeRulerValues($this$derived, true, $rulers, defaultValue);
    };
  }
  function VerticalRuler$Companion$minOf$lambda($rulers) {
    return function ($this$derived, defaultValue) {
      return mergeRulerValues($this$derived, false, $rulers, defaultValue);
    };
  }
  function VerticalRuler_init_$Init$($this) {
    VerticalRuler.call($this, null);
    return $this;
  }
  function VerticalRuler_init_$Create$() {
    return VerticalRuler_init_$Init$(objectCreate(protoOf(VerticalRuler)));
  }
  function Companion_23() {
  }
  protoOf(Companion_23).tap = function (rulers) {
    return this.caq(VerticalRuler$Companion$maxOf$lambda(rulers));
  };
  protoOf(Companion_23).vap = function (rulers) {
    return this.caq(VerticalRuler$Companion$minOf$lambda(rulers));
  };
  protoOf(Companion_23).caq = function (calculation) {
    return new VerticalRuler(calculation);
  };
  var Companion_instance_28;
  function Companion_getInstance_49() {
    return Companion_instance_28;
  }
  function VerticalRuler(calculation) {
    Ruler.call(this, calculation);
  }
  protoOf(VerticalRuler).baq = function (coordinate, sourceCoordinates, targetCoordinates) {
    // Inline function 'androidx.compose.ui.unit.IntSize.height' call
    var this_0 = sourceCoordinates.q95();
    // Inline function 'androidx.compose.ui.util.unpackInt2' call
    var value = _IntSize___get_packedValue__impl__uho7jf(this_0);
    // Inline function 'androidx.compose.ui.geometry.Offset' call
    // Inline function 'androidx.compose.ui.util.packFloats' call
    var val2 = convertToInt(bitwiseAnd(value, new Long(-1, 0))) / 2.0;
    var v1 = fromInt(toRawBits(coordinate));
    var v2 = fromInt(toRawBits(val2));
    var tmp$ret$3 = bitwiseOr(shiftLeft(v1, 32), bitwiseAnd(v2, new Long(-1, 0)));
    var offset = _Offset___init__impl__c168vi(tmp$ret$3);
    // Inline function 'androidx.compose.ui.geometry.Offset.x' call
    var this_1 = targetCoordinates.q91(sourceCoordinates, offset);
    // Inline function 'androidx.compose.ui.util.unpackFloat1' call
    var value_0 = _Offset___get_packedValue__impl__xh2k8q(this_1);
    // Inline function 'androidx.compose.ui.util.floatFromBits' call
    // Inline function 'kotlin.fromBits' call
    var bits = convertToInt(shiftRight(value_0, 32));
    return floatFromBits(bits);
  };
  function Ruler(calculate) {
    this.eap_1 = calculate;
  }
  function mergeRulerValues(_this__u8e3s4, useGreater, rulers, defaultValue) {
    var value = NaN;
    // Inline function 'kotlin.collections.forEach' call
    var inductionVariable = 0;
    var last = rulers.length;
    while (inductionVariable < last) {
      var element = rulers[inductionVariable];
      inductionVariable = inductionVariable + 1 | 0;
      var nextValue = _this__u8e3s4.fal(element, NaN);
      if (isNaN_0(value) || useGreater === nextValue > value) {
        value = nextValue;
      }
    }
    return isNaN_0(value) ? defaultValue : value;
  }
  function _ScaleFactor___init__impl__ttdtvk(packedValue) {
    return packedValue;
  }
  function _ScaleFactor___get_packedValue__impl__x2069g($this) {
    return $this;
  }
  function ScaleFactor__toString_impl_txub48($this) {
    // Inline function 'androidx.compose.ui.layout.ScaleFactor.scaleX' call
    // Inline function 'androidx.compose.ui.util.unpackFloat1' call
    var value = _ScaleFactor___get_packedValue__impl__x2069g($this);
    // Inline function 'androidx.compose.ui.util.floatFromBits' call
    // Inline function 'kotlin.fromBits' call
    var bits = convertToInt(shiftRight(value, 32));
    var tmp = floatFromBits(bits);
    // Inline function 'androidx.compose.ui.layout.ScaleFactor.scaleY' call
    // Inline function 'androidx.compose.ui.util.unpackFloat2' call
    var value_0 = _ScaleFactor___get_packedValue__impl__x2069g($this);
    // Inline function 'androidx.compose.ui.util.floatFromBits' call
    // Inline function 'kotlin.fromBits' call
    var bits_0 = convertToInt(bitwiseAnd(value_0, new Long(-1, 0)));
    return 'ScaleFactor(' + tmp + ', ' + floatFromBits(bits_0) + ')';
  }
  function Companion_24() {
    Companion_instance_29 = this;
    var tmp = this;
    // Inline function 'androidx.compose.ui.layout.ScaleFactor' call
    // Inline function 'androidx.compose.ui.util.packFloats' call
    var v1 = fromInt(toRawBits(NaN));
    var v2 = fromInt(toRawBits(NaN));
    var tmp$ret$1 = bitwiseOr(shiftLeft(v1, 32), bitwiseAnd(v2, new Long(-1, 0)));
    tmp.eaq_1 = _ScaleFactor___init__impl__ttdtvk(tmp$ret$1);
  }
  var Companion_instance_29;
  function Companion_getInstance_50() {
    if (Companion_instance_29 == null)
      new Companion_24();
    return Companion_instance_29;
  }
  function ScaleFactor__hashCode_impl_86oebd($this) {
    return $this.hashCode();
  }
  function ScaleFactor__equals_impl_7qimzv($this, other) {
    if (!(other instanceof ScaleFactor))
      return false;
    var tmp0_other_with_cast = other.mag_1;
    if (!equalsLong($this, tmp0_other_with_cast))
      return false;
    return true;
  }
  function ScaleFactor(packedValue) {
    Companion_getInstance_50();
    this.mag_1 = packedValue;
  }
  protoOf(ScaleFactor).toString = function () {
    return ScaleFactor__toString_impl_txub48(this.mag_1);
  };
  protoOf(ScaleFactor).hashCode = function () {
    return ScaleFactor__hashCode_impl_86oebd(this.mag_1);
  };
  protoOf(ScaleFactor).equals = function (other) {
    return ScaleFactor__equals_impl_7qimzv(this.mag_1, other);
  };
  function times(_this__u8e3s4, scaleFactor) {
    // Inline function 'androidx.compose.ui.geometry.Size.width' call
    // Inline function 'androidx.compose.ui.util.unpackFloat1' call
    var value = _Size___get_packedValue__impl__7rlt1o(_this__u8e3s4);
    // Inline function 'androidx.compose.ui.util.floatFromBits' call
    // Inline function 'kotlin.fromBits' call
    var bits = convertToInt(shiftRight(value, 32));
    var tmp = floatFromBits(bits);
    // Inline function 'androidx.compose.ui.layout.ScaleFactor.scaleX' call
    // Inline function 'androidx.compose.ui.util.unpackFloat1' call
    var value_0 = _ScaleFactor___get_packedValue__impl__x2069g(scaleFactor);
    // Inline function 'androidx.compose.ui.util.floatFromBits' call
    // Inline function 'kotlin.fromBits' call
    var bits_0 = convertToInt(shiftRight(value_0, 32));
    var tmp0 = tmp * floatFromBits(bits_0);
    // Inline function 'androidx.compose.ui.geometry.Size.height' call
    // Inline function 'androidx.compose.ui.util.unpackFloat2' call
    var value_1 = _Size___get_packedValue__impl__7rlt1o(_this__u8e3s4);
    // Inline function 'androidx.compose.ui.util.floatFromBits' call
    // Inline function 'kotlin.fromBits' call
    var bits_1 = convertToInt(bitwiseAnd(value_1, new Long(-1, 0)));
    var tmp_0 = floatFromBits(bits_1);
    // Inline function 'androidx.compose.ui.layout.ScaleFactor.scaleY' call
    // Inline function 'androidx.compose.ui.util.unpackFloat2' call
    var value_2 = _ScaleFactor___get_packedValue__impl__x2069g(scaleFactor);
    // Inline function 'androidx.compose.ui.util.floatFromBits' call
    // Inline function 'kotlin.fromBits' call
    var bits_2 = convertToInt(bitwiseAnd(value_2, new Long(-1, 0)));
    // Inline function 'androidx.compose.ui.geometry.Size' call
    // Inline function 'androidx.compose.ui.util.packFloats' call
    var val2 = tmp_0 * floatFromBits(bits_2);
    var v1 = fromInt(toRawBits(tmp0));
    var v2 = fromInt(toRawBits(val2));
    var tmp$ret$17 = bitwiseOr(shiftLeft(v1, 32), bitwiseAnd(v2, new Long(-1, 0)));
    return _Size___init__impl__aywn0g(tmp$ret$17);
  }
  function get_ReusedSlotId() {
    _init_properties_SubcomposeLayout_kt__9jde4k();
    return ReusedSlotId;
  }
  var ReusedSlotId;
  function get_UnspecifiedSlotId() {
    _init_properties_SubcomposeLayout_kt__9jde4k();
    return UnspecifiedSlotId;
  }
  var UnspecifiedSlotId;
  var androidx_compose_ui_layout_SubcomposeLayoutState$stable;
  var androidx_compose_ui_layout_SubcomposeSlotReusePolicy_SlotIdsSet$stable;
  var androidx_compose_ui_layout_LayoutNodeSubcompositionsState$stable;
  function LayoutNodeSubcompositionsState$Scope$layout$1($width, $height, $alignmentLines, $rulers, this$0, this$1, $placementBlock) {
    this.faq_1 = $width;
    this.gaq_1 = $height;
    this.haq_1 = $alignmentLines;
    this.iaq_1 = $rulers;
    this.jaq_1 = this$0;
    this.kaq_1 = this$1;
    this.laq_1 = $placementBlock;
  }
  protoOf(LayoutNodeSubcompositionsState$Scope$layout$1).h5e = function () {
    return this.faq_1;
  };
  protoOf(LayoutNodeSubcompositionsState$Scope$layout$1).i5e = function () {
    return this.gaq_1;
  };
  protoOf(LayoutNodeSubcompositionsState$Scope$layout$1).sad = function () {
    return this.haq_1;
  };
  protoOf(LayoutNodeSubcompositionsState$Scope$layout$1).tad = function () {
    return this.iaq_1;
  };
  protoOf(LayoutNodeSubcompositionsState$Scope$layout$1).uad = function () {
    if (this.jaq_1.jag()) {
      var delegate = this.kaq_1.maq_1.car().kac();
      if (!(delegate == null)) {
        this.laq_1(delegate.gae_1);
        return Unit_instance;
      }
    }
    this.laq_1(this.kaq_1.maq_1.car().gae_1);
  };
  function LayoutNodeSubcompositionsState$createMeasurePolicy$1$measure$$inlined$createMeasureResult$1($result, this$0, $indexAfterMeasure, $result$1) {
    this.iar_1 = this$0;
    this.jar_1 = $indexAfterMeasure;
    this.kar_1 = $result$1;
    this.har_1 = $result;
  }
  protoOf(LayoutNodeSubcompositionsState$createMeasurePolicy$1$measure$$inlined$createMeasureResult$1).uad = function () {
    this.iar_1.qaq_1 = this.jar_1;
    this.kar_1.uad();
    disposeUnusedSlotsInApproach(this.iar_1);
    this.iar_1.lar(this.iar_1.paq_1);
  };
  protoOf(LayoutNodeSubcompositionsState$createMeasurePolicy$1$measure$$inlined$createMeasureResult$1).h5e = function () {
    return this.har_1.h5e();
  };
  protoOf(LayoutNodeSubcompositionsState$createMeasurePolicy$1$measure$$inlined$createMeasureResult$1).i5e = function () {
    return this.har_1.i5e();
  };
  protoOf(LayoutNodeSubcompositionsState$createMeasurePolicy$1$measure$$inlined$createMeasureResult$1).sad = function () {
    return this.har_1.sad();
  };
  protoOf(LayoutNodeSubcompositionsState$createMeasurePolicy$1$measure$$inlined$createMeasureResult$1).tad = function () {
    return this.har_1.tad();
  };
  function LayoutNodeSubcompositionsState$createMeasurePolicy$1$measure$$inlined$createMeasureResult$2($result, this$0, $indexAfterMeasure, $result$1) {
    this.nar_1 = this$0;
    this.oar_1 = $indexAfterMeasure;
    this.par_1 = $result$1;
    this.mar_1 = $result;
  }
  protoOf(LayoutNodeSubcompositionsState$createMeasurePolicy$1$measure$$inlined$createMeasureResult$2).uad = function () {
    this.nar_1.paq_1 = this.oar_1;
    this.par_1.uad();
    if (this.nar_1.maq_1.f90_1 == null) {
      this.nar_1.lar(this.nar_1.paq_1);
    }
  };
  protoOf(LayoutNodeSubcompositionsState$createMeasurePolicy$1$measure$$inlined$createMeasureResult$2).h5e = function () {
    return this.mar_1.h5e();
  };
  protoOf(LayoutNodeSubcompositionsState$createMeasurePolicy$1$measure$$inlined$createMeasureResult$2).i5e = function () {
    return this.mar_1.i5e();
  };
  protoOf(LayoutNodeSubcompositionsState$createMeasurePolicy$1$measure$$inlined$createMeasureResult$2).sad = function () {
    return this.mar_1.sad();
  };
  protoOf(LayoutNodeSubcompositionsState$createMeasurePolicy$1$measure$$inlined$createMeasureResult$2).tad = function () {
    return this.mar_1.tad();
  };
  function subcompose($this, node, slotId, pausable, content) {
    // Inline function 'androidx.collection.MutableScatterMap.getOrPut' call
    var this_0 = $this.raq_1;
    var tmp0_elvis_lhs = this_0.w2(node);
    var tmp;
    if (tmp0_elvis_lhs == null) {
      // Inline function 'kotlin.also' call
      var this_1 = new NodeState(slotId, ComposableSingletons$SubcomposeLayoutKt_getInstance().qar_1);
      this_0.h13(node, this_1);
      tmp = this_1;
    } else {
      tmp = tmp0_elvis_lhs;
    }
    var nodeState = tmp;
    var contentChanged = !(nodeState.sar_1 === content);
    if (!(nodeState.war_1 == null)) {
      if (contentChanged) {
        cancelPausedPrecomposition($this, nodeState);
      } else if (pausable) {
        return Unit_instance;
      } else {
        applyPausedPrecomposition($this, nodeState, true);
      }
    }
    var tmp0_safe_receiver = nodeState.tar_1;
    var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.v39();
    var hasPendingChanges = tmp1_elvis_lhs == null ? true : tmp1_elvis_lhs;
    if (contentChanged || hasPendingChanges || nodeState.uar_1) {
      nodeState.sar_1 = content;
      subcompose_0($this, node, nodeState, pausable);
      nodeState.uar_1 = false;
    }
  }
  function _get_outOfFrameExecutor__itxcnk($this) {
    return requireOwner_0($this.maq_1).aas();
  }
  function subcompose_0($this, node, nodeState, pausable) {
    // Inline function 'androidx.compose.ui.internal.requirePrecondition' call
    if (!(nodeState.war_1 == null)) {
      var tmp$ret$1 = 'new subcompose call while paused composition is still active';
      throwIllegalArgumentException(tmp$ret$1);
    }
    $l$block: {
      // Inline function 'androidx.compose.runtime.snapshots.Companion.withoutReadObservation' call
      var previousSnapshot = Companion_instance.p52();
      var observer = previousSnapshot == null ? null : previousSnapshot.t3e();
      var newSnapshot = Companion_instance.q52(previousSnapshot);
      try {
        // Inline function 'androidx.compose.ui.layout.LayoutNodeSubcompositionsState.ignoreRemeasureRequests' call
        // Inline function 'androidx.compose.ui.node.LayoutNode.ignoreRemeasureRequests' call
        var this_0 = $this.maq_1;
        access$_set_ignoreRemeasureRequests__592r6g(this_0, true);
        var existing = nodeState.tar_1;
        var tmp0_elvis_lhs = $this.naq_1;
        var tmp;
        if (tmp0_elvis_lhs == null) {
          throwIllegalStateExceptionForNullCheck('parent composition reference not set');
        } else {
          tmp = tmp0_elvis_lhs;
        }
        var parentComposition = tmp;
        if (false) {
          nodeState.tas(existing == null ? Companion_getInstance_51().ias_1 : Companion_getInstance_51().has_1);
          if (pausable) {
            nodeState.tas(Companion_getInstance_51().jas_1);
          }
          if (nodeState.var_1) {
            nodeState.tas(Companion_getInstance_51().kas_1);
          }
        }
        var tmp_0;
        if (existing == null || existing.j39()) {
          var tmp_1;
          if (pausable) {
            tmp_1 = createPausableSubcomposition(node, parentComposition);
          } else {
            tmp_1 = createSubcomposition(node, parentComposition);
          }
          tmp_0 = tmp_1;
        } else {
          tmp_0 = existing;
        }
        var composition = tmp_0;
        nodeState.tar_1 = composition;
        var content = nodeState.sar_1;
        var tmp_2;
        if (!(_get_outOfFrameExecutor__itxcnk($this) == null)) {
          nodeState.yar_1 = false;
          tmp_2 = content;
        } else {
          nodeState.yar_1 = true;
          tmp_2 = ComposableLambda$invoke$ref(composableLambdaInstance(1524156494, true, LayoutNodeSubcompositionsState$subcompose$lambda(nodeState, content)));
        }
        var composable = tmp_2;
        if (pausable) {
          if (!isInterface(composition, PausableComposition))
            THROW_CCE();
          if (nodeState.var_1) {
            nodeState.war_1 = composition.n39(composable);
          } else {
            nodeState.war_1 = composition.m39(composable);
          }
        } else {
          if (nodeState.var_1) {
            composition.l39(composable);
          } else {
            composition.k39(composable);
          }
        }
        nodeState.var_1 = false;
        var result = Unit_instance;
        access$_set_ignoreRemeasureRequests__592r6g(this_0, false);
        break $l$block;
      }finally {
        Companion_instance.c53(previousSnapshot, newSnapshot, observer);
      }
    }
  }
  function getSlotIdAtIndex($this, foldedChildren, index) {
    var node = foldedChildren.l1(index);
    return ensureNotNull($this.raq_1.w2(node)).rar_1;
  }
  function deactivateOutOfFrame($this, $receiver, executor) {
    executor.uas(LayoutNodeSubcompositionsState$deactivateOutOfFrame$lambda($receiver));
  }
  function markActiveNodesAsReused($this, deactivate) {
    $this.aar_1 = 0;
    $this.vaq_1.c3();
    var foldedChildren = $this.maq_1.vas();
    var childCount = foldedChildren.n1();
    if (!($this.zaq_1 === childCount)) {
      $this.zaq_1 = childCount;
      $l$block: {
        // Inline function 'androidx.compose.runtime.snapshots.Companion.withoutReadObservation' call
        var previousSnapshot = Companion_instance.p52();
        var observer = previousSnapshot == null ? null : previousSnapshot.t3e();
        var newSnapshot = Companion_instance.q52(previousSnapshot);
        try {
          var inductionVariable = 0;
          if (inductionVariable < childCount)
            do {
              var i = inductionVariable;
              inductionVariable = inductionVariable + 1 | 0;
              var node = foldedChildren.l1(i);
              var nodeState = $this.raq_1.w2(node);
              if (!(nodeState == null) && nodeState.was()) {
                resetLayoutState($this, node);
                reuseComposition($this, nodeState, deactivate);
                nodeState.rar_1 = get_ReusedSlotId();
                if (false) {
                  if (deactivate) {
                    nodeState.tas(Companion_getInstance_51().nas_1);
                  } else {
                    nodeState.tas(Companion_getInstance_51().oas_1);
                  }
                }
              }
            }
             while (inductionVariable < childCount);
          break $l$block;
        }finally {
          Companion_instance.c53(previousSnapshot, newSnapshot, observer);
        }
      }
      $this.saq_1.c3();
    }
    $this.xas();
  }
  function disposeCurrentNodes($this) {
    // Inline function 'androidx.compose.ui.node.LayoutNode.ignoreRemeasureRequests' call
    var this_0 = $this.maq_1;
    access$_set_ignoreRemeasureRequests__592r6g(this_0, true);
    // Inline function 'androidx.collection.ScatterMap.forEachValue' call
    var this_1 = $this.raq_1;
    var v = this_1.y12_1;
    $l$block: {
      // Inline function 'androidx.collection.ScatterMap.forEachIndexed' call
      var m = this_1.w12_1;
      var lastIndex = m.length - 2 | 0;
      var inductionVariable = 0;
      if (inductionVariable <= lastIndex)
        do {
          var i = inductionVariable;
          inductionVariable = inductionVariable + 1 | 0;
          var slot = m[i];
          // Inline function 'androidx.collection.maskEmptyOrDeleted' call
          var this_2 = slot;
          var tmp$ret$4 = bitwiseAnd(bitwiseAnd(this_2, shiftLeft(invert(this_2), 7)), new Long(-2139062144, -2139062144));
          if (!equalsLong(tmp$ret$4, new Long(-2139062144, -2139062144))) {
            var bitCount = 8 - (~(i - lastIndex | 0) >>> 31 | 0) | 0;
            var inductionVariable_0 = 0;
            if (inductionVariable_0 < bitCount)
              do {
                var j = inductionVariable_0;
                inductionVariable_0 = inductionVariable_0 + 1 | 0;
                // Inline function 'androidx.collection.isFull' call
                var value = bitwiseAnd(slot, new Long(255, 0));
                if (compare(value, new Long(128, 0)) < 0) {
                  var index = (i << 3) + j | 0;
                  var tmp0_safe_receiver = v[index].tar_1;
                  if (tmp0_safe_receiver == null)
                    null;
                  else {
                    tmp0_safe_receiver.s1d();
                  }
                }
                slot = shiftRight(slot, 8);
              }
               while (inductionVariable_0 < bitCount);
            if (!(bitCount === 8)) {
              break $l$block;
            }
          }
        }
         while (!(i === lastIndex));
    }
    $this.maq_1.yas();
    var result = Unit_instance;
    access$_set_ignoreRemeasureRequests__592r6g(this_0, false);
    $this.raq_1.c3();
    $this.saq_1.c3();
    $this.aar_1 = 0;
    $this.zaq_1 = 0;
    $this.vaq_1.c3();
    $this.xas();
  }
  function resetLayoutState($this, $receiver) {
    $receiver.nau().kat_1 = UsageByParent_NotUsed_getInstance();
    var tmp0_safe_receiver = $receiver.oau();
    if (tmp0_safe_receiver == null)
      null;
    else {
      // Inline function 'kotlin.let' call
      tmp0_safe_receiver.yau_1 = UsageByParent_NotUsed_getInstance();
    }
  }
  function takeNodeFromReusables($this, slotId) {
    if ($this.zaq_1 === 0) {
      return null;
    }
    var foldedChildren = $this.maq_1.vas();
    var reusableNodesSectionEnd = foldedChildren.n1() - $this.aar_1 | 0;
    var reusableNodesSectionStart = reusableNodesSectionEnd - $this.zaq_1 | 0;
    var index = reusableNodesSectionEnd - 1 | 0;
    var chosenIndex = -1;
    $l$loop: while (index >= reusableNodesSectionStart) {
      if (equals(getSlotIdAtIndex($this, foldedChildren, index), slotId)) {
        chosenIndex = index;
        break $l$loop;
      } else {
        index = index - 1 | 0;
      }
    }
    if (chosenIndex === -1) {
      index = reusableNodesSectionEnd - 1 | 0;
      $l$loop_0: while (index >= reusableNodesSectionStart) {
        var node = foldedChildren.l1(index);
        var nodeState = ensureNotNull($this.raq_1.w2(node));
        if (nodeState.rar_1 === get_ReusedSlotId() || $this.oaq_1.uav(slotId, nodeState.rar_1)) {
          nodeState.rar_1 = slotId;
          chosenIndex = index;
          break $l$loop_0;
        }
        index = index - 1 | 0;
      }
    }
    var tmp;
    if (chosenIndex === -1) {
      tmp = null;
    } else {
      if (!(index === reusableNodesSectionStart)) {
        move($this, index, reusableNodesSectionStart, 1);
      }
      $this.zaq_1 = $this.zaq_1 - 1 | 0;
      var node_0 = foldedChildren.l1(reusableNodesSectionStart);
      var nodeState_0 = ensureNotNull($this.raq_1.w2(node_0));
      if (false) {
        nodeState_0.tas(Companion_getInstance_51().pas_1);
      }
      nodeState_0.xar_1 = mutableStateOf(true);
      nodeState_0.var_1 = true;
      nodeState_0.uar_1 = true;
      tmp = node_0;
    }
    return tmp;
  }
  function disposeUnusedSlotsInApproach($this) {
    // Inline function 'androidx.collection.MutableScatterMap.removeIf' call
    var this_0 = $this.xaq_1;
    $l$block: {
      // Inline function 'androidx.collection.ScatterMap.forEachIndexed' call
      var m = this_0.w12_1;
      var lastIndex = m.length - 2 | 0;
      var inductionVariable = 0;
      if (inductionVariable <= lastIndex)
        do {
          var i = inductionVariable;
          inductionVariable = inductionVariable + 1 | 0;
          var slot = m[i];
          // Inline function 'androidx.collection.maskEmptyOrDeleted' call
          var this_1 = slot;
          var tmp$ret$2 = bitwiseAnd(bitwiseAnd(this_1, shiftLeft(invert(this_1), 7)), new Long(-2139062144, -2139062144));
          if (!equalsLong(tmp$ret$2, new Long(-2139062144, -2139062144))) {
            var bitCount = 8 - (~(i - lastIndex | 0) >>> 31 | 0) | 0;
            var inductionVariable_0 = 0;
            if (inductionVariable_0 < bitCount)
              do {
                var j = inductionVariable_0;
                inductionVariable_0 = inductionVariable_0 + 1 | 0;
                // Inline function 'androidx.collection.isFull' call
                var value = bitwiseAnd(slot, new Long(255, 0));
                if (compare(value, new Long(128, 0)) < 0) {
                  var index = (i << 3) + j | 0;
                  var tmp0 = this_0.x12_1[index];
                  var handle = this_0.y12_1[index];
                  var id = $this.yaq_1.yz(tmp0);
                  var tmp;
                  if (id < 0 || id >= $this.qaq_1) {
                    if (id >= 0) {
                      $this.yaq_1.mi(id, get_UnspecifiedSlotId());
                    }
                    if ($this.vaq_1.d6(tmp0)) {
                      handle.s1d();
                    }
                    tmp = true;
                  } else {
                    tmp = false;
                  }
                  if (tmp) {
                    this_0.hw(index);
                  }
                }
                slot = shiftRight(slot, 8);
              }
               while (inductionVariable_0 < bitCount);
            if (!(bitCount === 8)) {
              break $l$block;
            }
          }
        }
         while (!(i === lastIndex));
    }
  }
  function precompose($this, slotId, content, pausable) {
    if (!$this.maq_1.y91()) {
      return Unit_instance;
    }
    $this.xas();
    if (!$this.saq_1.u2(slotId)) {
      $this.xaq_1.a3(slotId);
      // Inline function 'androidx.collection.MutableScatterMap.getOrPut' call
      var this_0 = $this.vaq_1;
      var tmp0_elvis_lhs = this_0.w2(slotId);
      var tmp;
      if (tmp0_elvis_lhs == null) {
        var reusedNode = takeNodeFromReusables($this, slotId);
        var tmp_0;
        if (!(reusedNode == null)) {
          var nodeIndex = $this.maq_1.vas().q1(reusedNode);
          move($this, nodeIndex, $this.maq_1.vas().n1(), 1);
          $this.aar_1 = $this.aar_1 + 1 | 0;
          tmp_0 = reusedNode;
        } else {
          // Inline function 'kotlin.also' call
          var this_1 = createNodeAt($this, $this.maq_1.vas().n1());
          $this.aar_1 = $this.aar_1 + 1 | 0;
          tmp_0 = this_1;
        }
        // Inline function 'kotlin.also' call
        var this_2 = tmp_0;
        this_0.h13(slotId, this_2);
        tmp = this_2;
      } else {
        tmp = tmp0_elvis_lhs;
      }
      var node = tmp;
      subcompose($this, node, slotId, pausable, content);
    }
  }
  function reuseComposition($this, $receiver, forceDeactivate) {
    if (!forceDeactivate && $receiver.yar_1) {
      $receiver.vav(false);
    } else {
      $receiver.xar_1 = mutableStateOf(false);
    }
    if (!($receiver.war_1 == null)) {
      cancelPausedPrecomposition($this, $receiver);
    } else if (forceDeactivate) {
      if (false) {
        $receiver.tas(Companion_getInstance_51().cas_1);
      }
      var tmp0_safe_receiver = $receiver.tar_1;
      if (tmp0_safe_receiver == null)
        null;
      else {
        tmp0_safe_receiver.k3b();
      }
    } else {
      var outOfFrameExecutor = _get_outOfFrameExecutor__itxcnk($this);
      if (!(outOfFrameExecutor == null)) {
        if (false) {
          $receiver.tas(Companion_getInstance_51().das_1);
        }
        deactivateOutOfFrame($this, $receiver, outOfFrameExecutor);
      } else {
        if (!$receiver.yar_1) {
          if (false) {
            $receiver.tas(Companion_getInstance_51().eas_1);
          }
          var tmp1_safe_receiver = $receiver.tar_1;
          if (tmp1_safe_receiver == null)
            null;
          else {
            tmp1_safe_receiver.k3b();
          }
        } else if (false) {
          $receiver.tas(Companion_getInstance_51().fas_1);
        }
      }
    }
  }
  function cancelPausedPrecomposition($this, $receiver) {
    var tmp0_safe_receiver = $receiver.war_1;
    if (tmp0_safe_receiver == null)
      null;
    else {
      // Inline function 'kotlin.let' call
      tmp0_safe_receiver.e2z();
      $receiver.war_1 = null;
      var tmp0_safe_receiver_0 = $receiver.tar_1;
      if (tmp0_safe_receiver_0 == null)
        null;
      else {
        tmp0_safe_receiver_0.s1d();
      }
      $receiver.tar_1 = null;
      if (false) {
        $receiver.tas(Companion_getInstance_51().bas_1);
      }
    }
  }
  function disposePrecomposedSlot($this, slotId) {
    $this.xas();
    var node = $this.vaq_1.a3(slotId);
    if (!(node == null)) {
      // Inline function 'androidx.compose.ui.internal.checkPrecondition' call
      if (!($this.aar_1 > 0)) {
        var tmp$ret$1 = 'No pre-composed items to dispose';
        throwIllegalStateException(tmp$ret$1);
      }
      var itemIndex = $this.maq_1.vas().q1(node);
      // Inline function 'androidx.compose.ui.internal.checkPrecondition' call
      if (!(itemIndex >= ($this.maq_1.vas().n1() - $this.aar_1 | 0))) {
        var tmp$ret$3 = 'Item is not in pre-composed item range';
        throwIllegalStateException(tmp$ret$3);
      }
      $this.zaq_1 = $this.zaq_1 + 1 | 0;
      $this.aar_1 = $this.aar_1 - 1 | 0;
      var tmp0_safe_receiver = $this.raq_1.w2(node);
      if (tmp0_safe_receiver == null)
        null;
      else {
        cancelPausedPrecomposition($this, tmp0_safe_receiver);
      }
      var reusableStart = ($this.maq_1.vas().n1() - $this.aar_1 | 0) - $this.zaq_1 | 0;
      move($this, itemIndex, reusableStart, 1);
      $this.lar(reusableStart);
    }
    if ($this.yaq_1.lh(slotId)) {
      $this.maq_1.wav(true);
    }
  }
  function createPrecomposedSlotHandle($this, slotId) {
    if (!$this.maq_1.y91()) {
      return new LayoutNodeSubcompositionsState$createPrecomposedSlotHandle$1();
    }
    return new LayoutNodeSubcompositionsState$createPrecomposedSlotHandle$2($this, slotId);
  }
  function createNodeAt($this, index) {
    // Inline function 'kotlin.also' call
    var this_0 = new LayoutNode(true);
    // Inline function 'androidx.compose.ui.layout.LayoutNodeSubcompositionsState.ignoreRemeasureRequests' call
    // Inline function 'androidx.compose.ui.node.LayoutNode.ignoreRemeasureRequests' call
    var this_1 = $this.maq_1;
    access$_set_ignoreRemeasureRequests__592r6g(this_1, true);
    $this.maq_1.xav(index, this_0);
    var result = Unit_instance;
    access$_set_ignoreRemeasureRequests__592r6g(this_1, false);
    return this_0;
  }
  function move($this, from, to, count) {
    count = count === VOID ? 1 : count;
    // Inline function 'androidx.compose.ui.layout.LayoutNodeSubcompositionsState.ignoreRemeasureRequests' call
    // Inline function 'androidx.compose.ui.node.LayoutNode.ignoreRemeasureRequests' call
    var this_0 = $this.maq_1;
    access$_set_ignoreRemeasureRequests__592r6g(this_0, true);
    $this.maq_1.yav(from, to, count);
    var result = Unit_instance;
    access$_set_ignoreRemeasureRequests__592r6g(this_0, false);
  }
  function applyPausedPrecomposition($this, $receiver, shouldComplete) {
    var pausedComposition = $receiver.war_1;
    if (!(pausedComposition == null)) {
      $l$block: {
        // Inline function 'androidx.compose.runtime.snapshots.Companion.withoutReadObservation' call
        var previousSnapshot = Companion_instance.p52();
        var observer = previousSnapshot == null ? null : previousSnapshot.t3e();
        var newSnapshot = Companion_instance.q52(previousSnapshot);
        try {
          // Inline function 'androidx.compose.ui.layout.LayoutNodeSubcompositionsState.ignoreRemeasureRequests' call
          // Inline function 'androidx.compose.ui.node.LayoutNode.ignoreRemeasureRequests' call
          var this_0 = $this.maq_1;
          access$_set_ignoreRemeasureRequests__592r6g(this_0, true);
          try {
            if (shouldComplete) {
              while (!pausedComposition.g3y()) {
                var tmp = LayoutNodeSubcompositionsState$applyPausedPrecomposition$lambda;
                pausedComposition.h3y(new sam$androidx_compose_runtime_ShouldPauseCallback$0(tmp));
              }
            }
            pausedComposition.i3y();
          } catch ($p) {
            if ($p instanceof Error) {
              var e = $p;
              var operations = $receiver.zar_1;
              if (!(operations == null)) {
                throw new SubcomposeLayoutPausableCompositionException(operations, $receiver.rar_1, e);
              } else {
                throw e;
              }
            } else {
              throw $p;
            }
          }
          $receiver.war_1 = null;
          var result = Unit_instance;
          access$_set_ignoreRemeasureRequests__592r6g(this_0, false);
          break $l$block;
        }finally {
          Companion_instance.c53(previousSnapshot, newSnapshot, observer);
        }
      }
    }
  }
  function NodeState(slotId, content, composition) {
    composition = composition === VOID ? null : composition;
    this.rar_1 = slotId;
    this.sar_1 = content;
    this.tar_1 = composition;
    this.uar_1 = false;
    this.var_1 = false;
    this.war_1 = null;
    this.xar_1 = mutableStateOf(true);
    this.yar_1 = false;
    var tmp = this;
    var tmp_0;
    if (false) {
      // Inline function 'androidx.collection.mutableIntListOf' call
      tmp_0 = new MutableIntList();
    } else {
      tmp_0 = null;
    }
    tmp.zar_1 = tmp_0;
  }
  protoOf(NodeState).vav = function (value) {
    this.xar_1.s21(value);
  };
  protoOf(NodeState).was = function () {
    return this.xar_1.u1();
  };
  protoOf(NodeState).tas = function (op) {
    var tmp0_elvis_lhs = this.zar_1;
    var tmp;
    if (tmp0_elvis_lhs == null) {
      return Unit_instance;
    } else {
      tmp = tmp0_elvis_lhs;
    }
    var operations = tmp;
    operations.pv(_SLOperation___get_value__impl__dz9j4v(op));
    // Inline function 'androidx.collection.IntList.size' call
    if (operations.jv_1 >= 50) {
      operations.e5(0, 10);
    }
  };
  function Scope($outer) {
    this.gar_1 = $outer;
    this.dar_1 = LayoutDirection_Rtl_getInstance();
    this.ear_1 = 0.0;
    this.far_1 = 0.0;
  }
  protoOf(Scope).r6p = function () {
    return this.dar_1;
  };
  protoOf(Scope).u5e = function () {
    return this.ear_1;
  };
  protoOf(Scope).j5f = function () {
    return this.far_1;
  };
  protoOf(Scope).jag = function () {
    return this.gar_1.maq_1.zav().equals(LayoutState_LookaheadLayingOut_getInstance()) || this.gar_1.maq_1.zav().equals(LayoutState_LookaheadMeasuring_getInstance());
  };
  protoOf(Scope).aaw = function (slotId, content) {
    return this.gar_1.aaw(slotId, content);
  };
  protoOf(Scope).hag = function (width, height, alignmentLines, rulers, placementBlock) {
    // Inline function 'androidx.compose.ui.node.checkMeasuredSize' call
    // Inline function 'androidx.compose.ui.internal.checkPrecondition' call
    if (!((width & -16777216) === 0 && (height & -16777216) === 0)) {
      var tmp$ret$2 = 'Size(' + width + ' x ' + height + ') is out of range. Each dimension must be between 0 and ' + '16777215.';
      throwIllegalStateException(tmp$ret$2);
    }
    return new LayoutNodeSubcompositionsState$Scope$layout$1(width, height, alignmentLines, rulers, this, this.gar_1, placementBlock);
  };
  function ApproachMeasureScopeImpl_0($outer) {
    this.caw_1 = $outer;
    this.baw_1 = this.caw_1.taq_1;
  }
  protoOf(ApproachMeasureScopeImpl_0).aaw = function (slotId, content) {
    var nodeInSlot = this.caw_1.saq_1.w2(slotId);
    if (!(nodeInSlot == null) && this.caw_1.maq_1.vas().q1(nodeInSlot) < this.caw_1.paq_1) {
      return nodeInSlot.daw();
    } else {
      return approachSubcompose(this.caw_1, slotId, content);
    }
  };
  protoOf(ApproachMeasureScopeImpl_0).kag = function (width, height, alignmentLines, placementBlock) {
    return this.baw_1.kag(width, height, alignmentLines, placementBlock);
  };
  protoOf(ApproachMeasureScopeImpl_0).hag = function (width, height, alignmentLines, rulers, placementBlock) {
    return this.baw_1.hag(width, height, alignmentLines, rulers, placementBlock);
  };
  protoOf(ApproachMeasureScopeImpl_0).r6p = function () {
    return this.baw_1.dar_1;
  };
  protoOf(ApproachMeasureScopeImpl_0).jag = function () {
    return this.baw_1.jag();
  };
  protoOf(ApproachMeasureScopeImpl_0).v5e = function (_this__u8e3s4) {
    return this.baw_1.v5e(_this__u8e3s4);
  };
  protoOf(ApproachMeasureScopeImpl_0).x5e = function (_this__u8e3s4) {
    return this.baw_1.x5e(_this__u8e3s4);
  };
  protoOf(ApproachMeasureScopeImpl_0).w5e = function (_this__u8e3s4) {
    return this.baw_1.w5e(_this__u8e3s4);
  };
  protoOf(ApproachMeasureScopeImpl_0).c5f = function (_this__u8e3s4) {
    return this.baw_1.c5f(_this__u8e3s4);
  };
  protoOf(ApproachMeasureScopeImpl_0).d5f = function (_this__u8e3s4) {
    return this.baw_1.d5f(_this__u8e3s4);
  };
  protoOf(ApproachMeasureScopeImpl_0).e5f = function (_this__u8e3s4) {
    return this.baw_1.e5f(_this__u8e3s4);
  };
  protoOf(ApproachMeasureScopeImpl_0).b5f = function (_this__u8e3s4) {
    return this.baw_1.b5f(_this__u8e3s4);
  };
  protoOf(ApproachMeasureScopeImpl_0).f5f = function (_this__u8e3s4) {
    return this.baw_1.f5f(_this__u8e3s4);
  };
  protoOf(ApproachMeasureScopeImpl_0).g5f = function (_this__u8e3s4) {
    return this.baw_1.g5f(_this__u8e3s4);
  };
  protoOf(ApproachMeasureScopeImpl_0).u5e = function () {
    return this.baw_1.ear_1;
  };
  protoOf(ApproachMeasureScopeImpl_0).j5f = function () {
    return this.baw_1.far_1;
  };
  function approachSubcompose($this, slotId, content) {
    // Inline function 'androidx.compose.ui.internal.requirePrecondition' call
    if (!($this.yaq_1.d3e_1 >= $this.qaq_1)) {
      var tmp$ret$1 = 'Error: currentApproachIndex cannot be greater than the size of theapproachComposedSlotIds list.';
      throwIllegalArgumentException(tmp$ret$1);
    }
    var nodeForSlot = $this.saq_1.w2(slotId);
    if ($this.yaq_1.d3e_1 === $this.qaq_1) {
      $this.yaq_1.zz(slotId);
    } else {
      $this.yaq_1.mi($this.qaq_1, slotId);
    }
    $this.qaq_1 = $this.qaq_1 + 1 | 0;
    var precomposed = $this.vaq_1.d6(slotId);
    if (!precomposed && nodeForSlot == null) {
      // Inline function 'kotlin.also' call
      var this_0 = $this.eaw(slotId, content);
      $this.xaq_1.h13(slotId, this_0);
    } else {
      if (!precomposed && !(nodeForSlot == null)) {
        var nodeIndex = $this.maq_1.vas().q1(nodeForSlot);
        move($this, nodeIndex, $this.maq_1.vas().n1(), 1);
        $this.aar_1 = $this.aar_1 + 1 | 0;
        $this.saq_1.a3(slotId);
        $this.vaq_1.h13(slotId, nodeForSlot);
        $this.xaq_1.h13(slotId, createPrecomposedSlotHandle($this, slotId));
        if ($this.maq_1.y91()) {
          $this.xas();
        }
      }
      var node = $this.vaq_1.w2(slotId);
      var tmp;
      if (node == null) {
        tmp = null;
      } else {
        // Inline function 'kotlin.let' call
        tmp = $this.raq_1.w2(node);
      }
      var nodeState = tmp;
      if ((nodeState == null ? null : nodeState.uar_1) === true) {
        subcompose($this, node, slotId, false, content);
      }
      if (!((nodeState == null ? null : nodeState.war_1) == null)) {
        applyPausedPrecomposition($this, nodeState, true);
      }
    }
    var tmp3_safe_receiver = $this.vaq_1.w2(slotId);
    var tmp_0;
    if (tmp3_safe_receiver == null) {
      tmp_0 = null;
    } else {
      // Inline function 'kotlin.run' call
      // Inline function 'kotlin.also' call
      var this_1 = tmp3_safe_receiver.nau().faw();
      // Inline function 'androidx.compose.ui.util.fastForEach' call
      var inductionVariable = 0;
      var last = this_1.n1() - 1 | 0;
      if (inductionVariable <= last)
        do {
          var index = inductionVariable;
          inductionVariable = inductionVariable + 1 | 0;
          var item = this_1.l1(index);
          item.gaw();
        }
         while (inductionVariable <= last);
      tmp_0 = this_1;
    }
    var tmp4_elvis_lhs = tmp_0;
    return tmp4_elvis_lhs == null ? emptyList() : tmp4_elvis_lhs;
  }
  function sam$androidx_compose_runtime_ShouldPauseCallback$0(function_0) {
    this.haw_1 = function_0;
  }
  protoOf(sam$androidx_compose_runtime_ShouldPauseCallback$0).o3o = function () {
    return this.haw_1();
  };
  protoOf(sam$androidx_compose_runtime_ShouldPauseCallback$0).q3 = function () {
    return this.haw_1;
  };
  protoOf(sam$androidx_compose_runtime_ShouldPauseCallback$0).equals = function (other) {
    var tmp;
    if (!(other == null) ? isInterface(other, ShouldPauseCallback) : false) {
      var tmp_0;
      if (!(other == null) ? isInterface(other, FunctionAdapter) : false) {
        tmp_0 = equals(this.q3(), other.q3());
      } else {
        tmp_0 = false;
      }
      tmp = tmp_0;
    } else {
      tmp = false;
    }
    return tmp;
  };
  protoOf(sam$androidx_compose_runtime_ShouldPauseCallback$0).hashCode = function () {
    return hashCode(this.q3());
  };
  function LayoutNodeSubcompositionsState$subcompose$lambda($nodeState, $content) {
    return function ($composer, $changed) {
      var $composer_0 = $composer;
      var tmp;
      if ($composer_0.r31(!(($changed & 3) === 2), $changed & 1)) {
        var tmp0 = $nodeState.was();
        // Inline function 'androidx.compose.runtime.ReusableContentHost' call
        var content = $content;
        var $composer_1 = $composer_0;
        $composer_1.f31(207, tmp0);
        var activeChanged = $composer_1.l31(tmp0);
        if (tmp0) {
          content($composer_1, 14 & 0 >> 3);
        } else {
          $composer_1.a31(activeChanged);
        }
        $composer_1.g31();
        tmp = Unit_instance;
      } else {
        $composer_0.z30();
        tmp = Unit_instance;
      }
      return Unit_instance;
    };
  }
  function LayoutNodeSubcompositionsState$deactivateOutOfFrame$lambda($this_deactivateOutOfFrame) {
    return function () {
      if (!$this_deactivateOutOfFrame.was()) {
        if (false) {
          $this_deactivateOutOfFrame.tas(Companion_getInstance_51().las_1);
        }
        var tmp0_safe_receiver = $this_deactivateOutOfFrame.tar_1;
        if (tmp0_safe_receiver == null)
          null;
        else {
          tmp0_safe_receiver.k3b();
        }
      } else {
        if (false) {
          $this_deactivateOutOfFrame.tas(Companion_getInstance_51().mas_1);
        }
      }
      return Unit_instance;
    };
  }
  function LayoutNodeSubcompositionsState$createMeasurePolicy$1(this$0, $block) {
    this.jaw_1 = this$0;
    this.kaw_1 = $block;
    NoIntrinsicsMeasurePolicy.call(this, this$0.bar_1);
  }
  protoOf(LayoutNodeSubcompositionsState$createMeasurePolicy$1).mak = function (_this__u8e3s4, measurables, constraints) {
    this.jaw_1.taq_1.dar_1 = _this__u8e3s4.r6p();
    this.jaw_1.taq_1.ear_1 = _this__u8e3s4.u5e();
    this.jaw_1.taq_1.far_1 = _this__u8e3s4.j5f();
    if (!_this__u8e3s4.jag() && !(this.jaw_1.maq_1.f90_1 == null)) {
      this.jaw_1.qaq_1 = 0;
      var result = this.kaw_1(this.jaw_1.uaq_1, new Constraints_0(constraints));
      var indexAfterMeasure = this.jaw_1.qaq_1;
      // Inline function 'androidx.compose.ui.layout.LayoutNodeSubcompositionsState.createMeasureResult' call
      this.jaw_1;
      return new LayoutNodeSubcompositionsState$createMeasurePolicy$1$measure$$inlined$createMeasureResult$1(result, this.jaw_1, indexAfterMeasure, result);
    } else {
      this.jaw_1.paq_1 = 0;
      var result_0 = this.kaw_1(this.jaw_1.taq_1, new Constraints_0(constraints));
      var indexAfterMeasure_0 = this.jaw_1.paq_1;
      // Inline function 'androidx.compose.ui.layout.LayoutNodeSubcompositionsState.createMeasureResult' call
      this.jaw_1;
      return new LayoutNodeSubcompositionsState$createMeasurePolicy$1$measure$$inlined$createMeasureResult$2(result_0, this.jaw_1, indexAfterMeasure_0, result_0);
    }
  };
  function LayoutNodeSubcompositionsState$createPrecomposedSlotHandle$1() {
  }
  protoOf(LayoutNodeSubcompositionsState$createPrecomposedSlotHandle$1).s1d = function () {
  };
  function LayoutNodeSubcompositionsState$createPrecomposedSlotHandle$2(this$0, $slotId) {
    this.oaw_1 = this$0;
    this.paw_1 = $slotId;
    this.naw_1 = mutableIntSetOf();
  }
  protoOf(LayoutNodeSubcompositionsState$createPrecomposedSlotHandle$2).s1d = function () {
    disposePrecomposedSlot(this.oaw_1, this.paw_1);
  };
  protoOf(LayoutNodeSubcompositionsState$createPrecomposedSlotHandle$2).law = function () {
    var tmp0_safe_receiver = this.oaw_1.vaq_1.w2(this.paw_1);
    var tmp1_safe_receiver = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.qaw();
    var tmp2_elvis_lhs = tmp1_safe_receiver == null ? null : tmp1_safe_receiver.n1();
    return tmp2_elvis_lhs == null ? 0 : tmp2_elvis_lhs;
  };
  protoOf(LayoutNodeSubcompositionsState$createPrecomposedSlotHandle$2).maw = function (index) {
    var node = this.oaw_1.vaq_1.w2(this.paw_1);
    if (!(node == null) && node.y91()) {
      var size = node.qaw().n1();
      if (index < 0 || index >= size) {
        throwIndexOutOfBoundsException('Index (' + index + ') is out of bound of [0, ' + size + ')');
      }
      if (this.naw_1.dm(index)) {
        var tmp0 = node.qaw().l1(index).h5e();
        // Inline function 'androidx.compose.ui.unit.IntSize' call
        // Inline function 'androidx.compose.ui.util.packInts' call
        var val2 = node.qaw().l1(index).i5e();
        var tmp$ret$1 = bitwiseOr(shiftLeft(fromInt(tmp0), 32), bitwiseAnd(fromInt(val2), new Long(-1, 0)));
        return _IntSize___init__impl__emcjft(tmp$ret$1);
      }
    }
    return Companion_getInstance_0().n5g_1;
  };
  function LayoutNodeSubcompositionsState$applyPausedPrecomposition$lambda() {
    return false;
  }
  function LayoutNodeSubcompositionsState(root, slotReusePolicy) {
    this.maq_1 = root;
    this.naq_1 = null;
    this.oaq_1 = slotReusePolicy;
    this.paq_1 = 0;
    this.qaq_1 = 0;
    this.raq_1 = mutableScatterMapOf();
    this.saq_1 = mutableScatterMapOf();
    this.taq_1 = new Scope(this);
    this.uaq_1 = new ApproachMeasureScopeImpl_0(this);
    this.vaq_1 = mutableScatterMapOf();
    this.waq_1 = new SlotIdsSet();
    this.xaq_1 = mutableScatterMapOf();
    var tmp = this;
    // Inline function 'androidx.compose.runtime.collection.mutableVectorOf' call
    // Inline function 'androidx.compose.runtime.collection.MutableVector' call
    // Inline function 'kotlin.arrayOfNulls' call
    var tmp$ret$2 = Array(16);
    tmp.yaq_1 = new MutableVector(tmp$ret$2, 0);
    this.zaq_1 = 0;
    this.aar_1 = 0;
    this.bar_1 = "Asking for intrinsic measurements of SubcomposeLayout layouts is not supported. This includes components that are built on top of SubcomposeLayout, such as lazy lists, BoxWithConstraints, TabRow, etc. To mitigate this:\n- if intrinsic measurements are used to achieve 'match parent' sizing, consider replacing the parent of the component with a custom layout which controls the order in which children are measured, making intrinsic measurement not needed\n- adding a size modifier to the component, in order to fast return the queried intrinsic measurement.";
  }
  protoOf(LayoutNodeSubcompositionsState).raw = function (value) {
    if (!(this.oaq_1 === value)) {
      this.oaq_1 = value;
      markActiveNodesAsReused(this, false);
      this.maq_1.wav();
    }
  };
  protoOf(LayoutNodeSubcompositionsState).p2y = function () {
    markActiveNodesAsReused(this, false);
  };
  protoOf(LayoutNodeSubcompositionsState).c30 = function () {
    markActiveNodesAsReused(this, true);
  };
  protoOf(LayoutNodeSubcompositionsState).d30 = function () {
    disposeCurrentNodes(this);
  };
  protoOf(LayoutNodeSubcompositionsState).aaw = function (slotId, content) {
    this.xas();
    var layoutState = this.maq_1.zav();
    // Inline function 'androidx.compose.ui.internal.checkPrecondition' call
    if (!(layoutState.equals(LayoutState_Measuring_getInstance()) || layoutState.equals(LayoutState_LayingOut_getInstance()) || layoutState.equals(LayoutState_LookaheadMeasuring_getInstance()) || layoutState.equals(LayoutState_LookaheadLayingOut_getInstance()))) {
      var tmp$ret$1 = 'subcompose can only be used inside the measure or layout blocks';
      throwIllegalStateException(tmp$ret$1);
    }
    // Inline function 'androidx.collection.MutableScatterMap.getOrPut' call
    var this_0 = this.saq_1;
    var tmp0_elvis_lhs = this_0.w2(slotId);
    var tmp;
    if (tmp0_elvis_lhs == null) {
      var precomposed = this.vaq_1.a3(slotId);
      var tmp_0;
      if (!(precomposed == null)) {
        var nodeState = this.raq_1.w2(precomposed);
        if (false) {
          if (nodeState == null)
            null;
          else {
            nodeState.tas(Companion_getInstance_51().gas_1);
          }
        }
        // Inline function 'androidx.compose.ui.internal.checkPrecondition' call
        if (!(this.aar_1 > 0)) {
          throwIllegalStateException('Check failed.');
        }
        this.aar_1 = this.aar_1 - 1 | 0;
        tmp_0 = precomposed;
      } else {
        var tmp1_elvis_lhs = takeNodeFromReusables(this, slotId);
        tmp_0 = tmp1_elvis_lhs == null ? createNodeAt(this, this.paq_1) : tmp1_elvis_lhs;
      }
      // Inline function 'kotlin.also' call
      var this_1 = tmp_0;
      this_0.h13(slotId, this_1);
      tmp = this_1;
    } else {
      tmp = tmp0_elvis_lhs;
    }
    var node = tmp;
    if (!(getOrNull(this.maq_1.vas(), this.paq_1) === node)) {
      var itemIndex = this.maq_1.vas().q1(node);
      // Inline function 'androidx.compose.ui.internal.requirePrecondition' call
      if (!(itemIndex >= this.paq_1)) {
        var tmp$ret$8 = 'Key "' + toString_0(slotId) + '" was already used. If you are using LazyColumn/Row please make ' + 'sure you provide a unique key for each item.';
        throwIllegalArgumentException(tmp$ret$8);
      }
      if (!(this.paq_1 === itemIndex)) {
        move(this, itemIndex, this.paq_1);
      }
    }
    this.paq_1 = this.paq_1 + 1 | 0;
    subcompose(this, node, slotId, false, content);
    var tmp_1;
    if (layoutState.equals(LayoutState_Measuring_getInstance()) || layoutState.equals(LayoutState_LayingOut_getInstance())) {
      tmp_1 = node.daw();
    } else {
      tmp_1 = node.saw();
    }
    return tmp_1;
  };
  protoOf(LayoutNodeSubcompositionsState).lar = function (startIndex) {
    this.zaq_1 = 0;
    var foldedChildren = this.maq_1.vas();
    var lastReusableIndex = (foldedChildren.n1() - this.aar_1 | 0) - 1 | 0;
    var needApplyNotification = false;
    if (startIndex <= lastReusableIndex) {
      this.waq_1.c3();
      var inductionVariable = startIndex;
      if (inductionVariable <= lastReusableIndex)
        do {
          var i = inductionVariable;
          inductionVariable = inductionVariable + 1 | 0;
          var slotId = getSlotIdAtIndex(this, foldedChildren, i);
          this.waq_1.uaw(slotId);
        }
         while (!(i === lastReusableIndex));
      this.oaq_1.vaw(this.waq_1);
      var i_0 = lastReusableIndex;
      $l$block: {
        // Inline function 'androidx.compose.runtime.snapshots.Companion.withoutReadObservation' call
        var previousSnapshot = Companion_instance.p52();
        var observer = previousSnapshot == null ? null : previousSnapshot.t3e();
        var newSnapshot = Companion_instance.q52(previousSnapshot);
        try {
          while (i_0 >= startIndex) {
            var node = foldedChildren.l1(i_0);
            var nodeState = ensureNotNull(this.raq_1.w2(node));
            var slotId_0 = nodeState.rar_1;
            if (this.waq_1.xaw(slotId_0)) {
              this.zaq_1 = this.zaq_1 + 1 | 0;
              if (nodeState.was()) {
                resetLayoutState(this, node);
                reuseComposition(this, nodeState, false);
                if (nodeState.yar_1) {
                  needApplyNotification = true;
                }
              }
            } else {
              // Inline function 'androidx.compose.ui.layout.LayoutNodeSubcompositionsState.ignoreRemeasureRequests' call
              // Inline function 'androidx.compose.ui.node.LayoutNode.ignoreRemeasureRequests' call
              var this_0 = this.maq_1;
              access$_set_ignoreRemeasureRequests__592r6g(this_0, true);
              this.raq_1.a3(node);
              var tmp0_safe_receiver = nodeState.tar_1;
              if (tmp0_safe_receiver == null)
                null;
              else {
                tmp0_safe_receiver.s1d();
              }
              this.maq_1.waw(i_0, 1);
              var result = Unit_instance;
              access$_set_ignoreRemeasureRequests__592r6g(this_0, false);
            }
            this.saq_1.a3(slotId_0);
            i_0 = i_0 - 1 | 0;
          }
          break $l$block;
        }finally {
          Companion_instance.c53(previousSnapshot, newSnapshot, observer);
        }
      }
    }
    if (needApplyNotification) {
      Companion_instance.w41();
    }
    this.xas();
  };
  protoOf(LayoutNodeSubcompositionsState).xas = function () {
    var childrenCount = this.maq_1.vas().n1();
    // Inline function 'androidx.compose.ui.internal.requirePrecondition' call
    if (!(this.raq_1.n1() === childrenCount)) {
      var tmp$ret$1 = 'Inconsistency between the count of nodes tracked by the state ' + ('(' + this.raq_1.n1() + ') and the children count on the SubcomposeLayout') + (' (' + childrenCount + '). Are you trying to use the state of the') + ' disposed SubcomposeLayout?';
      throwIllegalArgumentException(tmp$ret$1);
    }
    // Inline function 'androidx.compose.ui.internal.requirePrecondition' call
    if (!(((childrenCount - this.zaq_1 | 0) - this.aar_1 | 0) >= 0)) {
      var tmp$ret$3 = 'Incorrect state. Total children ' + childrenCount + '. Reusable children ' + ('' + this.zaq_1 + '. Precomposed children ' + this.aar_1);
      throwIllegalArgumentException(tmp$ret$3);
    }
    // Inline function 'androidx.compose.ui.internal.requirePrecondition' call
    if (!(this.vaq_1.n1() === this.aar_1)) {
      var tmp$ret$5 = 'Incorrect state. Precomposed children ' + this.aar_1 + '. Map size ' + ('' + this.vaq_1.n1());
      throwIllegalArgumentException(tmp$ret$5);
    }
  };
  protoOf(LayoutNodeSubcompositionsState).yaw = function (block) {
    return new LayoutNodeSubcompositionsState$createMeasurePolicy$1(this, block);
  };
  protoOf(LayoutNodeSubcompositionsState).eaw = function (slotId, content) {
    precompose(this, slotId, content, false);
    return createPrecomposedSlotHandle(this, slotId);
  };
  protoOf(LayoutNodeSubcompositionsState).zaw = function () {
    var childCount = this.maq_1.vas().n1();
    if (!(this.zaq_1 === childCount)) {
      // Inline function 'androidx.collection.ScatterMap.forEachValue' call
      var this_0 = this.raq_1;
      var v = this_0.y12_1;
      $l$block: {
        // Inline function 'androidx.collection.ScatterMap.forEachIndexed' call
        var m = this_0.w12_1;
        var lastIndex = m.length - 2 | 0;
        var inductionVariable = 0;
        if (inductionVariable <= lastIndex)
          do {
            var i = inductionVariable;
            inductionVariable = inductionVariable + 1 | 0;
            var slot = m[i];
            // Inline function 'androidx.collection.maskEmptyOrDeleted' call
            var this_1 = slot;
            var tmp$ret$2 = bitwiseAnd(bitwiseAnd(this_1, shiftLeft(invert(this_1), 7)), new Long(-2139062144, -2139062144));
            if (!equalsLong(tmp$ret$2, new Long(-2139062144, -2139062144))) {
              var bitCount = 8 - (~(i - lastIndex | 0) >>> 31 | 0) | 0;
              var inductionVariable_0 = 0;
              if (inductionVariable_0 < bitCount)
                do {
                  var j = inductionVariable_0;
                  inductionVariable_0 = inductionVariable_0 + 1 | 0;
                  // Inline function 'androidx.collection.isFull' call
                  var value = bitwiseAnd(slot, new Long(255, 0));
                  if (compare(value, new Long(128, 0)) < 0) {
                    var index = (i << 3) + j | 0;
                    v[index].uar_1 = true;
                  }
                  slot = shiftRight(slot, 8);
                }
                 while (inductionVariable_0 < bitCount);
              if (!(bitCount === 8)) {
                break $l$block;
              }
            }
          }
           while (!(i === lastIndex));
      }
      if (!(this.maq_1.f90_1 == null)) {
        if (!this.maq_1.cax()) {
          this.maq_1.bax();
        }
      } else {
        if (!this.maq_1.aax()) {
          this.maq_1.wav();
        }
      }
    }
  };
  function SlotIdsSet(set) {
    set = set === VOID ? mutableOrderedScatterSetOf() : set;
    this.taw_1 = set;
  }
  protoOf(SlotIdsSet).n1 = function () {
    return this.taw_1.n1();
  };
  protoOf(SlotIdsSet).r = function () {
    return this.taw_1.r();
  };
  protoOf(SlotIdsSet).dax = function (elements) {
    // Inline function 'kotlin.collections.forEach' call
    var _iterator__ex2g4s = elements.t();
    while (_iterator__ex2g4s.u()) {
      var element = _iterator__ex2g4s.v();
      if (!this.taw_1.m1(element)) {
        return false;
      }
    }
    return true;
  };
  protoOf(SlotIdsSet).r2 = function (elements) {
    return this.dax(elements);
  };
  protoOf(SlotIdsSet).xaw = function (element) {
    return this.taw_1.m1(element);
  };
  protoOf(SlotIdsSet).m1 = function (element) {
    if (!true)
      return false;
    return this.xaw(element);
  };
  protoOf(SlotIdsSet).uaw = function (slotId) {
    return this.taw_1.j1(slotId);
  };
  protoOf(SlotIdsSet).t = function () {
    return this.taw_1.k11().t();
  };
  protoOf(SlotIdsSet).eax = function (slotId) {
    return this.taw_1.d3(slotId);
  };
  protoOf(SlotIdsSet).c3 = function () {
    return this.taw_1.c3();
  };
  function SubcomposeLayoutState_init_$Init$($this) {
    SubcomposeLayoutState.call($this, NoOpSubcomposeSlotReusePolicy_instance);
    return $this;
  }
  function SubcomposeLayoutState_init_$Create$() {
    return SubcomposeLayoutState_init_$Init$(objectCreate(protoOf(SubcomposeLayoutState)));
  }
  function _get_state__b8zcm8($this) {
    var tmp0 = $this.gax_1;
    var tmp$ret$0;
    $l$block: {
      // Inline function 'kotlin.requireNotNull' call
      if (tmp0 == null) {
        var message = 'SubcomposeLayoutState is not attached to SubcomposeLayout';
        throw IllegalArgumentException_init_$Create$(toString(message));
      } else {
        tmp$ret$0 = tmp0;
        break $l$block;
      }
    }
    return tmp$ret$0;
  }
  function PrecomposedSlotHandle() {
  }
  function SubcomposeLayoutState$setRoot$lambda(this$0) {
    return function (_this__u8e3s4, it) {
      var tmp = this$0;
      var tmp0_elvis_lhs = _this__u8e3s4.f91_1;
      var tmp_0;
      if (tmp0_elvis_lhs == null) {
        // Inline function 'kotlin.also' call
        var this_0 = new LayoutNodeSubcompositionsState(_this__u8e3s4, this$0.fax_1);
        _this__u8e3s4.f91_1 = this_0;
        tmp_0 = this_0;
      } else {
        tmp_0 = tmp0_elvis_lhs;
      }
      tmp.gax_1 = tmp_0;
      _get_state__b8zcm8(this$0).xas();
      _get_state__b8zcm8(this$0).raw(this$0.fax_1);
      return Unit_instance;
    };
  }
  function SubcomposeLayoutState$setCompositionContext$lambda(this$0) {
    return function (_this__u8e3s4, it) {
      _get_state__b8zcm8(this$0).naq_1 = it;
      return Unit_instance;
    };
  }
  function SubcomposeLayoutState$setMeasurePolicy$lambda(this$0) {
    return function (_this__u8e3s4, it) {
      _this__u8e3s4.kax(_get_state__b8zcm8(this$0).yaw(it));
      return Unit_instance;
    };
  }
  function SubcomposeLayoutState(slotReusePolicy) {
    this.fax_1 = slotReusePolicy;
    this.gax_1 = null;
    var tmp = this;
    tmp.hax_1 = SubcomposeLayoutState$setRoot$lambda(this);
    var tmp_0 = this;
    tmp_0.iax_1 = SubcomposeLayoutState$setCompositionContext$lambda(this);
    var tmp_1 = this;
    tmp_1.jax_1 = SubcomposeLayoutState$setMeasurePolicy$lambda(this);
  }
  protoOf(SubcomposeLayoutState).lax = function () {
    return _get_state__b8zcm8(this).zaw();
  };
  function _SLOperation___init__impl__o81cuj(value) {
    return value;
  }
  function _SLOperation___get_value__impl__dz9j4v($this) {
    return $this;
  }
  function Companion_25() {
    Companion_instance_30 = this;
    this.bas_1 = _SLOperation___init__impl__o81cuj(0);
    this.cas_1 = _SLOperation___init__impl__o81cuj(1);
    this.das_1 = _SLOperation___init__impl__o81cuj(2);
    this.eas_1 = _SLOperation___init__impl__o81cuj(3);
    this.fas_1 = _SLOperation___init__impl__o81cuj(4);
    this.gas_1 = _SLOperation___init__impl__o81cuj(5);
    this.has_1 = _SLOperation___init__impl__o81cuj(6);
    this.ias_1 = _SLOperation___init__impl__o81cuj(7);
    this.jas_1 = _SLOperation___init__impl__o81cuj(8);
    this.kas_1 = _SLOperation___init__impl__o81cuj(9);
    this.las_1 = _SLOperation___init__impl__o81cuj(10);
    this.mas_1 = _SLOperation___init__impl__o81cuj(11);
    this.nas_1 = _SLOperation___init__impl__o81cuj(12);
    this.oas_1 = _SLOperation___init__impl__o81cuj(13);
    this.pas_1 = _SLOperation___init__impl__o81cuj(14);
    this.qas_1 = _SLOperation___init__impl__o81cuj(15);
    this.ras_1 = _SLOperation___init__impl__o81cuj(16);
    this.sas_1 = _SLOperation___init__impl__o81cuj(17);
  }
  var Companion_instance_30;
  function Companion_getInstance_51() {
    if (Companion_instance_30 == null)
      new Companion_25();
    return Companion_instance_30;
  }
  function ComposableSingletons$SubcomposeLayoutKt$lambda$641200809$lambda($composer, $changed) {
    var $composer_0 = $composer;
    if (!$composer_0.r31(!(($changed & 3) === 2), $changed & 1)) {
      $composer_0.z30();
    }
    return Unit_instance;
  }
  function ComposableSingletons$SubcomposeLayoutKt() {
    ComposableSingletons$SubcomposeLayoutKt_instance = this;
    var tmp = this;
    tmp.qar_1 = ComposableLambda$invoke$ref(composableLambdaInstance(641200809, false, ComposableSingletons$SubcomposeLayoutKt$lambda$641200809$lambda));
  }
  var ComposableSingletons$SubcomposeLayoutKt_instance;
  function ComposableSingletons$SubcomposeLayoutKt_getInstance() {
    if (ComposableSingletons$SubcomposeLayoutKt_instance == null)
      new ComposableSingletons$SubcomposeLayoutKt();
    return ComposableSingletons$SubcomposeLayoutKt_instance;
  }
  function operationsList($this) {
    // Inline function 'kotlin.collections.buildList' call
    // Inline function 'kotlin.collections.buildListInternal' call
    // Inline function 'kotlin.apply' call
    var this_0 = ArrayList_init_$Create$();
    // Inline function 'androidx.collection.IntList.size' call
    var currentOperation = $this.max_1.jv_1 - 1 | 0;
    while (currentOperation >= 0) {
      var operation = $this.max_1.l1(currentOperation);
      var tmp0_subject = _SLOperation___init__impl__o81cuj(operation);
      var stringValue = tmp0_subject === Companion_getInstance_51().bas_1 ? 'CancelPausedPrecomposition' : tmp0_subject === Companion_getInstance_51().cas_1 ? 'ReuseForceSyncDeactivation' : tmp0_subject === Companion_getInstance_51().das_1 ? 'ReuseScheduleOutOfFrameDeactivation' : tmp0_subject === Companion_getInstance_51().eas_1 ? 'ReuseSyncDeactivation' : tmp0_subject === Companion_getInstance_51().fas_1 ? 'ReuseDeactivationViaHost' : tmp0_subject === Companion_getInstance_51().gas_1 ? 'TookFromPrecomposeMap' : tmp0_subject === Companion_getInstance_51().has_1 ? 'Subcompose' : tmp0_subject === Companion_getInstance_51().ias_1 ? 'SubcomposeNew' : tmp0_subject === Companion_getInstance_51().jas_1 ? 'SubcomposePausable' : tmp0_subject === Companion_getInstance_51().kas_1 ? 'SubcomposeForceReuse' : tmp0_subject === Companion_getInstance_51().las_1 ? 'DeactivateOutOfFrame' : tmp0_subject === Companion_getInstance_51().mas_1 ? 'DeactivateOutOfFrameCancelled' : tmp0_subject === Companion_getInstance_51().nas_1 ? 'SlotToReusedFromOnDeactivate' : tmp0_subject === Companion_getInstance_51().oas_1 ? 'SlotToReusedFromOnReuse' : tmp0_subject === Companion_getInstance_51().pas_1 ? 'Reused' : tmp0_subject === Companion_getInstance_51().qas_1 ? 'ResumePaused' : tmp0_subject === Companion_getInstance_51().ras_1 ? 'PausePaused' : tmp0_subject === Companion_getInstance_51().sas_1 ? 'ApplyPaused' : 'Unexpected ' + operation;
      this_0.j1('' + currentOperation + ': ' + stringValue);
      currentOperation = currentOperation - 1 | 0;
    }
    return this_0.t5();
  }
  function SubcomposeLayoutPausableCompositionException(operations, slotId, cause) {
    IllegalStateException_init_$Init$(cause, this);
    captureStack(this, SubcomposeLayoutPausableCompositionException);
    this.max_1 = operations;
    this.nax_1 = slotId;
    delete this.message;
  }
  protoOf(SubcomposeLayoutPausableCompositionException).e = function () {
    return trimMargin('\n            |slotid=' + toString_0(this.nax_1) + '. Last operations:\n            |' + joinToString_0(operationsList(this), '\n') + '\n            ');
  };
  function NoOpSubcomposeSlotReusePolicy() {
  }
  protoOf(NoOpSubcomposeSlotReusePolicy).vaw = function (slotIds) {
    slotIds.c3();
  };
  protoOf(NoOpSubcomposeSlotReusePolicy).uav = function (slotId, reusableSlotId) {
    return false;
  };
  var NoOpSubcomposeSlotReusePolicy_instance;
  function NoOpSubcomposeSlotReusePolicy_getInstance() {
    return NoOpSubcomposeSlotReusePolicy_instance;
  }
  function SubcomposeLayout(modifier, measurePolicy, $composer, $changed, $default) {
    _init_properties_SubcomposeLayout_kt__9jde4k();
    var modifier_0 = {_v: modifier};
    var $composer_0 = $composer;
    $composer_0 = $composer_0.s30(-1298353104);
    var $dirty = $changed;
    if (!(($default & 1) === 0))
      $dirty = $dirty | 6;
    else if (($changed & 6) === 0)
      $dirty = $dirty | ($composer_0.k31(modifier_0._v) ? 4 : 2);
    if (($changed & 48) === 0)
      $dirty = $dirty | ($composer_0.q31(measurePolicy) ? 32 : 16);
    if ($composer_0.r31(!(($dirty & 19) === 18), $dirty & 1)) {
      if (!(($default & 1) === 0)) {
        modifier_0._v = Companion_instance_6;
      }
      // Inline function 'androidx.compose.runtime.cache' call
      var this_0 = $composer_0;
      // Inline function 'kotlin.let' call
      var it = this_0.i31();
      var tmp;
      if (false || it === Companion_getInstance_9().f30_1) {
        var value = SubcomposeLayoutState_init_$Create$();
        this_0.j31(value);
        tmp = value;
      } else {
        tmp = it;
      }
      var tmp$ret$0 = tmp;
      SubcomposeLayout_0(tmp$ret$0, modifier_0._v, measurePolicy, $composer_0, 112 & $dirty << 3 | 896 & $dirty << 3, 0);
    } else {
      $composer_0.z30();
    }
    var tmp0_safe_receiver = $composer_0.t30();
    if (tmp0_safe_receiver == null)
      null;
    else {
      tmp0_safe_receiver.p3c(SubcomposeLayout$lambda(modifier_0, measurePolicy, $changed, $default));
    }
  }
  function SubcomposeLayout_0(state, modifier, measurePolicy, $composer, $changed, $default) {
    _init_properties_SubcomposeLayout_kt__9jde4k();
    var modifier_0 = {_v: modifier};
    var $composer_0 = $composer;
    $composer_0 = $composer_0.s30(-511989831);
    var $dirty = $changed;
    if (($changed & 6) === 0)
      $dirty = $dirty | ($composer_0.q31(state) ? 4 : 2);
    if (!(($default & 2) === 0))
      $dirty = $dirty | 48;
    else if (($changed & 48) === 0)
      $dirty = $dirty | ($composer_0.k31(modifier_0._v) ? 32 : 16);
    if (($changed & 384) === 0)
      $dirty = $dirty | ($composer_0.q31(measurePolicy) ? 256 : 128);
    if ($composer_0.r31(!(($dirty & 147) === 146), $dirty & 1)) {
      if (!(($default & 2) === 0)) {
        modifier_0._v = Companion_instance_6;
      }
      var compositeKeyHash = get_currentCompositeKeyHashCode($composer_0, 0).hashCode();
      var compositionContext = rememberCompositionContext($composer_0, 0);
      var materialized = materialize($composer_0, modifier_0._v);
      var localMap = $composer_0.t31();
      var tmp0 = Companion_getInstance_56().qax_1;
      // Inline function 'androidx.compose.runtime.ReusableComposeNode' call
      var $composer_1 = $composer_0;
      var tmp = $composer_1.g30();
      if (!isInterface(tmp, Applier)) {
        invalidApplier();
      }
      $composer_1.b31();
      if ($composer_1.h30()) {
        $composer_1.c31(tmp0);
      } else {
        $composer_1.d31();
      }
      var $this$ReusableComposeNode = _Updater___init__impl__rbfxm8($composer_1);
      Updater__set_impl_v7kwss($this$ReusableComposeNode, state, state.hax_1);
      Updater__set_impl_v7kwss($this$ReusableComposeNode, compositionContext, state.iax_1);
      Updater__set_impl_v7kwss($this$ReusableComposeNode, measurePolicy, state.jax_1);
      Updater__set_impl_v7kwss($this$ReusableComposeNode, localMap, Companion_getInstance_53().sah_1);
      Updater__reconcile_impl_1mfi6g($this$ReusableComposeNode, Companion_getInstance_53().xah_1);
      Updater__set_impl_v7kwss($this$ReusableComposeNode, materialized, Companion_getInstance_53().qah_1);
      Updater__set_impl_v7kwss($this$ReusableComposeNode, compositeKeyHash, Companion_getInstance_53().wah_1);
      $composer_1.e31();
      if (!$composer_0.i30()) {
        $composer_0.m30(-1259245908);
        var tmp0_0 = $composer_0;
        // Inline function 'androidx.compose.runtime.cache' call
        var invalid = $composer_0.q31(state);
        // Inline function 'kotlin.let' call
        var it = tmp0_0.i31();
        var tmp_0;
        if (invalid || it === Companion_getInstance_9().f30_1) {
          var value = SubcomposeLayout$lambda_0(state);
          tmp0_0.j31(value);
          tmp_0 = value;
        } else {
          tmp_0 = it;
        }
        var tmp$ret$2 = tmp_0;
        SideEffect(tmp$ret$2, $composer_0, 0);
        $composer_0.n30();
      } else {
        $composer_0.m30(-1259187287);
        $composer_0.n30();
      }
    } else {
      $composer_0.z30();
    }
    var tmp0_safe_receiver = $composer_0.t30();
    if (tmp0_safe_receiver == null)
      null;
    else {
      tmp0_safe_receiver.p3c(SubcomposeLayout$lambda_1(state, modifier_0, measurePolicy, $changed, $default));
    }
  }
  function androidx_compose_ui_layout_SubcomposeLayoutState$stableprop_getter() {
    return androidx_compose_ui_layout_SubcomposeLayoutState$stable;
  }
  function ReusedSlotId$1() {
  }
  protoOf(ReusedSlotId$1).toString = function () {
    return 'ReusedSlotId';
  };
  function SubcomposeLayout$lambda($modifier, $measurePolicy, $$changed, $$default) {
    return function ($composer, $force) {
      SubcomposeLayout($modifier._v, $measurePolicy, $composer, updateChangedFlags($$changed | 1), $$default);
      return Unit_instance;
    };
  }
  function SubcomposeLayout$lambda_0($state) {
    return function () {
      $state.lax();
      return Unit_instance;
    };
  }
  function SubcomposeLayout$lambda_1($state, $modifier, $measurePolicy, $$changed, $$default) {
    return function ($composer, $force) {
      SubcomposeLayout_0($state, $modifier._v, $measurePolicy, $composer, updateChangedFlags($$changed | 1), $$default);
      return Unit_instance;
    };
  }
  var properties_initialized_SubcomposeLayout_kt_mr187y;
  function _init_properties_SubcomposeLayout_kt__9jde4k() {
    if (!properties_initialized_SubcomposeLayout_kt_mr187y) {
      properties_initialized_SubcomposeLayout_kt_mr187y = true;
      ReusedSlotId = new ReusedSlotId$1();
      UnspecifiedSlotId = new Object();
      androidx_compose_ui_layout_SubcomposeLayoutState$stable = 8;
      androidx_compose_ui_layout_SubcomposeSlotReusePolicy_SlotIdsSet$stable = 8;
      androidx_compose_ui_layout_LayoutNodeSubcompositionsState$stable = 8;
    }
  }
  var androidx_compose_ui_layout_TestModifierUpdater$stable;
  function Companion_26() {
    Companion_instance_31 = this;
    this.tax_1 = new WindowInsetsRulersImpl('caption bar');
    this.uax_1 = new WindowInsetsRulersImpl('display cutout');
    this.vax_1 = new WindowInsetsRulersImpl('ime');
    this.wax_1 = new WindowInsetsRulersImpl('mandatory system gestures');
    this.xax_1 = new WindowInsetsRulersImpl('navigation bars');
    this.yax_1 = new WindowInsetsRulersImpl('status bars');
    var tmp = this;
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$0 = [this.yax_1, this.xax_1, this.tax_1];
    tmp.zax_1 = new InnermostInsetsRulers('system bars', tmp$ret$0);
    this.aay_1 = new WindowInsetsRulersImpl('system gestures');
    this.bay_1 = new WindowInsetsRulersImpl('tappable element');
    this.cay_1 = new WindowInsetsRulersImpl('waterfall');
    var tmp_0 = this;
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$3 = [this.yax_1, this.xax_1, this.tax_1, this.uax_1, this.vax_1, this.bay_1];
    tmp_0.day_1 = new InnermostInsetsRulers('safe drawing', tmp$ret$3);
    var tmp_1 = this;
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$6 = [this.wax_1, this.aay_1, this.bay_1, this.cay_1];
    tmp_1.eay_1 = new InnermostInsetsRulers('safe gestures', tmp$ret$6);
    var tmp_2 = this;
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$9 = [this.yax_1, this.xax_1, this.tax_1, this.vax_1, this.aay_1, this.wax_1, this.bay_1, this.uax_1, this.cay_1];
    tmp_2.fay_1 = new InnermostInsetsRulers('safe content', tmp$ret$9);
  }
  var Companion_instance_31;
  function Companion_getInstance_52() {
    if (Companion_instance_31 == null)
      new Companion_26();
    return Companion_instance_31;
  }
  function WindowInsetsRulersImpl(name) {
    this.gay_1 = name;
    this.hay_1 = RectRulers(this.gay_1);
    this.iay_1 = RectRulers(this.gay_1 + ' maximum');
  }
  protoOf(WindowInsetsRulersImpl).e2y = function () {
    return this.hay_1;
  };
  protoOf(WindowInsetsRulersImpl).jay = function () {
    return this.iay_1;
  };
  protoOf(WindowInsetsRulersImpl).toString = function () {
    return this.gay_1;
  };
  function InnermostInsetsRulers(name, rulers) {
    this.kay_1 = name;
    this.lay_1 = rulers;
    var tmp = this;
    var tmp_0 = Companion_instance_26;
    // Inline function 'kotlin.collections.map' call
    var this_0 = this.lay_1;
    // Inline function 'kotlin.collections.mapTo' call
    var destination = ArrayList_init_$Create$_0(this_0.length);
    var inductionVariable = 0;
    var last = this_0.length;
    while (inductionVariable < last) {
      var item = this_0[inductionVariable];
      inductionVariable = inductionVariable + 1 | 0;
      var tmp$ret$2 = item.e2y();
      destination.j1(tmp$ret$2);
    }
    // Inline function 'kotlin.collections.toTypedArray' call
    var tmp$ret$3 = copyToArray(destination);
    tmp.may_1 = innermostOf(tmp_0, tmp$ret$3.slice());
    var tmp_1 = this;
    var tmp_2 = Companion_instance_26;
    // Inline function 'kotlin.collections.map' call
    var this_1 = this.lay_1;
    // Inline function 'kotlin.collections.mapTo' call
    var destination_0 = ArrayList_init_$Create$_0(this_1.length);
    var inductionVariable_0 = 0;
    var last_0 = this_1.length;
    while (inductionVariable_0 < last_0) {
      var item_0 = this_1[inductionVariable_0];
      inductionVariable_0 = inductionVariable_0 + 1 | 0;
      var tmp$ret$6 = item_0.jay();
      destination_0.j1(tmp$ret$6);
    }
    // Inline function 'kotlin.collections.toTypedArray' call
    var tmp$ret$7 = copyToArray(destination_0);
    tmp_1.nay_1 = innermostOf(tmp_2, tmp$ret$7.slice());
  }
  protoOf(InnermostInsetsRulers).e2y = function () {
    return this.may_1;
  };
  protoOf(InnermostInsetsRulers).jay = function () {
    return this.nay_1;
  };
  protoOf(InnermostInsetsRulers).toString = function () {
    var tmp0_elvis_lhs = this.kay_1;
    return tmp0_elvis_lhs == null ? joinToString(this.lay_1, VOID, 'innermostOf(', ')') : tmp0_elvis_lhs;
  };
  var androidx_compose_ui_modifier_ModifierLocal$stable;
  var androidx_compose_ui_modifier_ProvidableModifierLocal$stable;
  function ProvidableModifierLocal(defaultFactory) {
    ModifierLocal.call(this, defaultFactory);
  }
  function modifierLocalOf(defaultFactory) {
    return new ProvidableModifierLocal(defaultFactory);
  }
  function ModifierLocal(defaultFactory) {
    this.oay_1 = defaultFactory;
  }
  function ModifierLocalConsumer() {
  }
  var androidx_compose_ui_modifier_ModifierLocalManager$stable;
  function invalidateConsumersOfNodeForKey($this, node, key, set) {
    // Inline function 'androidx.compose.ui.node.Nodes.Locals' call
    // Inline function 'androidx.compose.ui.node.visitSubtreeIf' call
    var type = _NodeKind___init__impl__ojsprp(32);
    // Inline function 'androidx.compose.ui.node.visitSubtreeIf' call
    var mask = _NodeKind___get_mask__impl__1uopb6(type);
    // Inline function 'androidx.compose.ui.internal.checkPrecondition' call
    if (!node.f4n().z8v_1) {
      var tmp$ret$4 = 'visitSubtreeIf called on an unattached node';
      throwIllegalStateException(tmp$ret$4);
    }
    // Inline function 'androidx.compose.runtime.collection.mutableVectorOf' call
    // Inline function 'androidx.compose.runtime.collection.MutableVector' call
    // Inline function 'kotlin.arrayOfNulls' call
    var tmp$ret$7 = Array(16);
    var branches = new MutableVector(tmp$ret$7, 0);
    var child = node.f4n().r8v_1;
    if (child == null) {
      access$addLayoutNodeChildren$tDelegatableNodeKt(branches, node.f4n(), false);
    } else
      branches.zz(child);
    outer: while (true) {
      // Inline function 'androidx.compose.runtime.collection.MutableVector.isNotEmpty' call
      if (!!(branches.d3e_1 === 0)) {
        break outer;
      }
      var branch = branches.h3(branches.d3e_1 - 1 | 0);
      if (!((branch.p8v_1 & mask) === 0)) {
        var node_0 = branch;
        while (!(node_0 == null) && node_0.z8v_1) {
          if (!((node_0.o8v_1 & mask) === 0)) {
            var tmp0 = node_0;
            var tmp$ret$9;
            $l$block: {
              // Inline function 'androidx.compose.ui.node.dispatchForKind' call
              // Inline function 'androidx.compose.ui.node.dispatchForKind' call
              var stack = null;
              var node_1 = tmp0;
              $l$loop: while (!(node_1 == null)) {
                var tmp;
                if (isInterface(node_1, ModifierLocalModifierNode)) {
                  var it = node_1;
                  var tmp_0;
                  if (it instanceof BackwardsCompatNode) {
                    var tmp_1 = it.eaz_1;
                    tmp_0 = isInterface(tmp_1, ModifierLocalConsumer);
                  } else {
                    tmp_0 = false;
                  }
                  if (tmp_0) {
                    if (it.haz_1.m1(key)) {
                      set.j1(it);
                    }
                  }
                  if (!!it.y9h().jaz(key)) {
                    tmp$ret$9 = false;
                    break $l$block;
                  }
                  tmp = false;
                } else {
                  tmp = true;
                }
                var dispatchAgain = tmp;
                var tmp_2;
                var tmp_3;
                if (dispatchAgain || false) {
                  // Inline function 'androidx.compose.ui.Node.isKind' call
                  tmp_3 = !((node_1.o8v_1 & _NodeKind___get_mask__impl__1uopb6(type)) === 0);
                } else {
                  tmp_3 = false;
                }
                if (tmp_3) {
                  tmp_2 = node_1 instanceof DelegatingNode;
                } else {
                  tmp_2 = false;
                }
                if (tmp_2) {
                  var count = 0;
                  // Inline function 'androidx.compose.ui.node.DelegatingNode.forEachImmediateDelegate' call
                  var node_2 = node_1.e9a_1;
                  while (!(node_2 == null)) {
                    var next = node_2;
                    // Inline function 'androidx.compose.ui.Node.isKind' call
                    if (!((next.o8v_1 & _NodeKind___get_mask__impl__1uopb6(type)) === 0)) {
                      count = count + 1 | 0;
                      if (count === 1) {
                        node_1 = next;
                      } else {
                        var tmp0_elvis_lhs = stack;
                        var tmp_4;
                        if (tmp0_elvis_lhs == null) {
                          // Inline function 'androidx.compose.runtime.collection.mutableVectorOf' call
                          // Inline function 'androidx.compose.runtime.collection.MutableVector' call
                          // Inline function 'kotlin.arrayOfNulls' call
                          var tmp$ret$20 = Array(16);
                          tmp_4 = new MutableVector(tmp$ret$20, 0);
                        } else {
                          tmp_4 = tmp0_elvis_lhs;
                        }
                        stack = tmp_4;
                        var theNode = node_1;
                        if (!(theNode == null)) {
                          var tmp1_safe_receiver = stack;
                          if (tmp1_safe_receiver == null)
                            null;
                          else
                            tmp1_safe_receiver.zz(theNode);
                          node_1 = null;
                        }
                        var tmp2_safe_receiver = stack;
                        if (tmp2_safe_receiver == null)
                          null;
                        else
                          tmp2_safe_receiver.zz(next);
                      }
                    }
                    node_2 = node_2.r8v_1;
                  }
                  if (count === 1) {
                    continue $l$loop;
                  }
                }
                node_1 = access$pop$tDelegatableNodeKt(stack);
              }
              tmp$ret$9 = true;
            }
            var diveDeeper = tmp$ret$9;
            if (!diveDeeper)
              continue outer;
          }
          node_0 = node_0.r8v_1;
        }
      }
      access$addLayoutNodeChildren$tDelegatableNodeKt(branches, branch, false);
    }
  }
  function ModifierLocalManager$invalidate$lambda(this$0) {
    return function () {
      this$0.qaz();
      return Unit_instance;
    };
  }
  function ModifierLocalManager(owner) {
    this.kaz_1 = owner;
    var tmp = this;
    // Inline function 'androidx.compose.runtime.collection.mutableVectorOf' call
    // Inline function 'androidx.compose.runtime.collection.MutableVector' call
    // Inline function 'kotlin.arrayOfNulls' call
    var tmp$ret$2 = Array(16);
    tmp.laz_1 = new MutableVector(tmp$ret$2, 0);
    var tmp_0 = this;
    // Inline function 'androidx.compose.runtime.collection.mutableVectorOf' call
    // Inline function 'androidx.compose.runtime.collection.MutableVector' call
    // Inline function 'kotlin.arrayOfNulls' call
    var tmp$ret$5 = Array(16);
    tmp_0.maz_1 = new MutableVector(tmp$ret$5, 0);
    var tmp_1 = this;
    // Inline function 'androidx.compose.runtime.collection.mutableVectorOf' call
    // Inline function 'androidx.compose.runtime.collection.MutableVector' call
    // Inline function 'kotlin.arrayOfNulls' call
    var tmp$ret$8 = Array(16);
    tmp_1.naz_1 = new MutableVector(tmp$ret$8, 0);
    var tmp_2 = this;
    // Inline function 'androidx.compose.runtime.collection.mutableVectorOf' call
    // Inline function 'androidx.compose.runtime.collection.MutableVector' call
    // Inline function 'kotlin.arrayOfNulls' call
    var tmp$ret$11 = Array(16);
    tmp_2.oaz_1 = new MutableVector(tmp$ret$11, 0);
    this.paz_1 = false;
  }
  protoOf(ModifierLocalManager).m40 = function () {
    if (!this.paz_1) {
      this.paz_1 = true;
      this.kaz_1.l8w(ModifierLocalManager$invalidate$lambda(this));
    }
  };
  protoOf(ModifierLocalManager).qaz = function () {
    this.paz_1 = false;
    // Inline function 'kotlin.collections.hashSetOf' call
    var toUpdate = HashSet_init_$Create$();
    // Inline function 'androidx.compose.runtime.collection.MutableVector.forEachIndexed' call
    var this_0 = this.naz_1;
    var i = 0;
    var tmp = this_0.b3e_1;
    var content = isArray(tmp) ? tmp : THROW_CCE();
    var size = this_0.d3e_1;
    while (i < size) {
      var tmp0 = i;
      var layout = content[i];
      // Inline function 'androidx.compose.runtime.collection.MutableVector.get' call
      var key = this.oaz_1.b3e_1[tmp0];
      if (layout.d91_1.j99_1.z8v_1) {
        invalidateConsumersOfNodeForKey(this, layout.d91_1.j99_1, key, toUpdate);
      }
      i = i + 1 | 0;
    }
    this.naz_1.c3();
    this.oaz_1.c3();
    // Inline function 'androidx.compose.runtime.collection.MutableVector.forEachIndexed' call
    var this_1 = this.laz_1;
    var i_0 = 0;
    var tmp_0 = this_1.b3e_1;
    var content_0 = isArray(tmp_0) ? tmp_0 : THROW_CCE();
    var size_0 = this_1.d3e_1;
    while (i_0 < size_0) {
      var tmp0_0 = i_0;
      var node = content_0[i_0];
      // Inline function 'androidx.compose.runtime.collection.MutableVector.get' call
      var key_0 = this.maz_1.b3e_1[tmp0_0];
      if (node.z8v_1) {
        invalidateConsumersOfNodeForKey(this, node, key_0, toUpdate);
      }
      i_0 = i_0 + 1 | 0;
    }
    this.laz_1.c3();
    this.maz_1.c3();
    // Inline function 'kotlin.collections.forEach' call
    var _iterator__ex2g4s = toUpdate.t();
    while (_iterator__ex2g4s.u()) {
      var element = _iterator__ex2g4s.v();
      element.raz();
    }
  };
  protoOf(ModifierLocalManager).saz = function (node, key) {
    // Inline function 'androidx.compose.runtime.collection.MutableVector.plusAssign' call
    this.laz_1.zz(node);
    // Inline function 'androidx.compose.runtime.collection.MutableVector.plusAssign' call
    this.maz_1.zz(key);
    this.m40();
  };
  protoOf(ModifierLocalManager).taz = function (node, key) {
    // Inline function 'androidx.compose.runtime.collection.MutableVector.plusAssign' call
    this.laz_1.zz(node);
    // Inline function 'androidx.compose.runtime.collection.MutableVector.plusAssign' call
    this.maz_1.zz(key);
    this.m40();
  };
  protoOf(ModifierLocalManager).uaz = function (node, key) {
    var tmp0 = this.naz_1;
    // Inline function 'androidx.compose.runtime.collection.MutableVector.plusAssign' call
    var element = requireLayoutNode(node);
    tmp0.zz(element);
    // Inline function 'androidx.compose.runtime.collection.MutableVector.plusAssign' call
    this.oaz_1.zz(key);
    this.m40();
  };
  var androidx_compose_ui_modifier_ModifierLocalMap$stable;
  var androidx_compose_ui_modifier_SingleLocalMap$stable;
  var androidx_compose_ui_modifier_BackwardsCompatLocalMap$stable;
  var androidx_compose_ui_modifier_MultiLocalMap$stable;
  var androidx_compose_ui_modifier_EmptyMap$stable;
  function ModifierLocalModifierNode() {
  }
  function ModifierLocalMap() {
  }
  function EmptyMap() {
    EmptyMap_instance = this;
    ModifierLocalMap.call(this);
  }
  protoOf(EmptyMap).vaz = function (key) {
    // Inline function 'kotlin.error' call
    throw IllegalStateException_init_$Create$(toString(''));
  };
  protoOf(EmptyMap).jaz = function (key) {
    return false;
  };
  var EmptyMap_instance;
  function EmptyMap_getInstance() {
    if (EmptyMap_instance == null)
      new EmptyMap();
    return EmptyMap_instance;
  }
  function BackwardsCompatLocalMap(element) {
    ModifierLocalMap.call(this);
    this.waz_1 = element;
  }
  protoOf(BackwardsCompatLocalMap).vaz = function (key) {
    // Inline function 'androidx.compose.ui.internal.checkPrecondition' call
    if (!(key === this.waz_1.t1())) {
      throwIllegalStateException('Check failed.');
    }
    return this.waz_1.u1();
  };
  protoOf(BackwardsCompatLocalMap).jaz = function (key) {
    return key === this.waz_1.t1();
  };
  function modifierLocalMapOf() {
    return EmptyMap_getInstance();
  }
  function ModifierLocalProvider() {
  }
  function get_DetachedModifierLocalReadScope() {
    _init_properties_BackwardsCompatNode_kt__rwcpvm();
    return DetachedModifierLocalReadScope;
  }
  var DetachedModifierLocalReadScope;
  function get_onDrawCacheReadsChanged() {
    _init_properties_BackwardsCompatNode_kt__rwcpvm();
    return onDrawCacheReadsChanged;
  }
  var onDrawCacheReadsChanged;
  function get_updateModifierLocalConsumer() {
    _init_properties_BackwardsCompatNode_kt__rwcpvm();
    return updateModifierLocalConsumer;
  }
  var updateModifierLocalConsumer;
  var androidx_compose_ui_node_BackwardsCompatNode$stable;
  function unInitializeModifier($this) {
    // Inline function 'androidx.compose.ui.internal.checkPrecondition' call
    if (!$this.z8v_1) {
      var tmp$ret$1 = 'unInitializeModifier called on unattached node';
      throwIllegalStateException(tmp$ret$1);
    }
    var element = $this.eaz_1;
    // Inline function 'androidx.compose.ui.node.Nodes.Locals' call
    // Inline function 'androidx.compose.ui.Node.isKind' call
    var kind = _NodeKind___init__impl__ojsprp(32);
    if (!(($this.o8v_1 & _NodeKind___get_mask__impl__1uopb6(kind)) === 0)) {
      if (isInterface(element, ModifierLocalProvider)) {
        requireOwner($this).xaz().uaz($this, element.t1());
      }
      if (isInterface(element, ModifierLocalConsumer)) {
        element.pay(get_DetachedModifierLocalReadScope());
      }
    }
    // Inline function 'androidx.compose.ui.node.Nodes.Semantics' call
    // Inline function 'androidx.compose.ui.Node.isKind' call
    var kind_0 = _NodeKind___init__impl__ojsprp(8);
    if (!(($this.o8v_1 & _NodeKind___get_mask__impl__1uopb6(kind_0)) === 0)) {
      requireOwner($this).yaz();
    }
    if (isInterface(element, FocusRequesterModifier)) {
      // Inline function 'androidx.compose.runtime.collection.MutableVector.minusAssign' call
      element.n9h().u9e_1.g10($this);
    }
  }
  function initializeModifier($this, duringAttach) {
    // Inline function 'androidx.compose.ui.internal.checkPrecondition' call
    if (!$this.z8v_1) {
      var tmp$ret$1 = 'initializeModifier called on unattached node';
      throwIllegalStateException(tmp$ret$1);
    }
    var element = $this.eaz_1;
    // Inline function 'androidx.compose.ui.node.Nodes.Locals' call
    // Inline function 'androidx.compose.ui.Node.isKind' call
    var kind = _NodeKind___init__impl__ojsprp(32);
    if (!(($this.o8v_1 & _NodeKind___get_mask__impl__1uopb6(kind)) === 0)) {
      if (isInterface(element, ModifierLocalConsumer)) {
        $this.i3o(BackwardsCompatNode$initializeModifier$lambda($this));
      }
      if (isInterface(element, ModifierLocalProvider)) {
        updateModifierLocalProvider($this, element);
      }
    }
    // Inline function 'androidx.compose.ui.node.Nodes.Draw' call
    // Inline function 'androidx.compose.ui.Node.isKind' call
    var kind_0 = _NodeKind___init__impl__ojsprp(4);
    if (!(($this.o8v_1 & _NodeKind___get_mask__impl__1uopb6(kind_0)) === 0)) {
      if (isInterface(element, DrawCacheModifier)) {
        $this.faz_1 = true;
      }
      if (!duringAttach) {
        invalidateLayer($this);
      }
    }
    // Inline function 'androidx.compose.ui.node.Nodes.Layout' call
    // Inline function 'androidx.compose.ui.Node.isKind' call
    var kind_1 = _NodeKind___init__impl__ojsprp(2);
    if (!(($this.o8v_1 & _NodeKind___get_mask__impl__1uopb6(kind_1)) === 0)) {
      var isChainUpdate_0 = isChainUpdate($this);
      if (isChainUpdate_0) {
        var coordinator = ensureNotNull($this.t8v_1);
        if (!(coordinator instanceof LayoutModifierNodeCoordinator))
          THROW_CCE();
        coordinator.zaz($this);
        coordinator.ab0();
      }
      if (!duringAttach) {
        invalidateLayer($this);
        requireLayoutNode($this).bb0();
      }
    }
    if (isInterface(element, RemeasurementModifier)) {
      element.xap(requireLayoutNode($this));
    }
    var tmp;
    // Inline function 'androidx.compose.ui.node.Nodes.OnRemeasured' call
    // Inline function 'androidx.compose.ui.Node.isKind' call
    var kind_2 = _NodeKind___init__impl__ojsprp(128);
    if (!(($this.o8v_1 & _NodeKind___get_mask__impl__1uopb6(kind_2)) === 0)) {
      tmp = isInterface(element, OnRemeasuredModifier);
    } else {
      tmp = false;
    }
    if (tmp) {
      var isChainUpdate_1 = isChainUpdate($this);
      if (isChainUpdate_1) {
        requireLayoutNode($this).bb0();
      }
    }
    var tmp_0;
    // Inline function 'androidx.compose.ui.node.Nodes.OnPlaced' call
    // Inline function 'androidx.compose.ui.Node.isKind' call
    var kind_3 = _NodeKind___init__impl__ojsprp(4194304);
    if (!(($this.o8v_1 & _NodeKind___get_mask__impl__1uopb6(kind_3)) === 0)) {
      tmp_0 = isInterface(element, OnPlacedModifier);
    } else {
      tmp_0 = false;
    }
    if (tmp_0) {
      $this.iaz_1 = null;
      var isChainUpdate_2 = isChainUpdate($this);
      if (isChainUpdate_2) {
        var tmp_1 = requireOwner($this);
        tmp_1.cb0(new BackwardsCompatNode$initializeModifier$2($this));
      }
    }
    // Inline function 'androidx.compose.ui.node.Nodes.GlobalPositionAware' call
    // Inline function 'androidx.compose.ui.Node.isKind' call
    var kind_4 = _NodeKind___init__impl__ojsprp(256);
    if (!(($this.o8v_1 & _NodeKind___get_mask__impl__1uopb6(kind_4)) === 0)) {
      if (isInterface(element, OnGloballyPositionedModifier)) {
        var isChainUpdate_3 = isChainUpdate($this);
        if (isChainUpdate_3) {
          requireLayoutNode($this).bb0();
        }
      }
    }
    if (isInterface(element, FocusRequesterModifier)) {
      // Inline function 'androidx.compose.runtime.collection.MutableVector.plusAssign' call
      element.n9h().u9e_1.zz($this);
    }
    // Inline function 'androidx.compose.ui.node.Nodes.PointerInput' call
    // Inline function 'androidx.compose.ui.Node.isKind' call
    var kind_5 = _NodeKind___init__impl__ojsprp(16);
    if (!(($this.o8v_1 & _NodeKind___get_mask__impl__1uopb6(kind_5)) === 0)) {
      if (isInterface(element, PointerInputModifier)) {
        element.za2().db0_1 = $this.t8v_1;
      }
    }
    // Inline function 'androidx.compose.ui.node.Nodes.Semantics' call
    // Inline function 'androidx.compose.ui.Node.isKind' call
    var kind_6 = _NodeKind___init__impl__ojsprp(8);
    if (!(($this.o8v_1 & _NodeKind___get_mask__impl__1uopb6(kind_6)) === 0)) {
      requireOwner($this).yaz();
    }
  }
  function updateDrawCache($this) {
    var element = $this.eaz_1;
    if (isInterface(element, DrawCacheModifier)) {
      var tmp0 = requireOwner($this).fb0();
      var tmp4 = get_onDrawCacheReadsChanged();
      // Inline function 'androidx.compose.ui.node.OwnerSnapshotObserver.observeReads' call
      var block = BackwardsCompatNode$updateDrawCache$lambda(element, $this);
      access$_get_observer__zh6fij(tmp0).z5a($this, tmp4, block);
    }
    $this.faz_1 = false;
  }
  function updateModifierLocalProvider($this, element) {
    var providedValues = $this.gaz_1;
    if (!(providedValues == null) && providedValues.jaz(element.t1())) {
      providedValues.waz_1 = element;
      requireOwner($this).xaz().saz($this, element.t1());
    } else {
      $this.gaz_1 = new BackwardsCompatLocalMap(element);
      var isChainUpdate_0 = isChainUpdate($this);
      if (isChainUpdate_0) {
        requireOwner($this).xaz().taz($this, element.t1());
      }
    }
  }
  function BackwardsCompatNode$initializeModifier$lambda(this$0) {
    return function () {
      this$0.raz();
      return Unit_instance;
    };
  }
  function BackwardsCompatNode$initializeModifier$2(this$0) {
    this.gb0_1 = this$0;
  }
  protoOf(BackwardsCompatNode$initializeModifier$2).hb0 = function () {
    if (this.gb0_1.iaz_1 == null) {
      // Inline function 'androidx.compose.ui.node.Nodes.OnPlaced' call
      var tmp$ret$0 = _NodeKind___init__impl__ojsprp(4194304);
      this.gb0_1.x91(requireCoordinator(this.gb0_1, tmp$ret$0));
    }
  };
  function BackwardsCompatNode$updateDrawCache$lambda($element, this$0) {
    return function () {
      $element.p96(this$0);
      return Unit_instance;
    };
  }
  function BackwardsCompatNode$updateModifierLocalConsumer$lambda(this$0) {
    return function () {
      var tmp = this$0.eaz_1;
      (isInterface(tmp, ModifierLocalConsumer) ? tmp : THROW_CCE()).pay(this$0);
      return Unit_instance;
    };
  }
  function BackwardsCompatNode(element) {
    Node.call(this);
    this.o8v_1 = calculateNodeKindSetFrom(element);
    this.eaz_1 = element;
    this.faz_1 = true;
    this.gaz_1 = null;
    var tmp = this;
    // Inline function 'kotlin.collections.hashSetOf' call
    tmp.haz_1 = HashSet_init_$Create$();
    this.iaz_1 = null;
  }
  protoOf(BackwardsCompatNode).ib0 = function (value) {
    if (this.z8v_1) {
      unInitializeModifier(this);
    }
    this.eaz_1 = value;
    this.o8v_1 = calculateNodeKindSetFrom(value);
    if (this.z8v_1) {
      initializeModifier(this, false);
    }
  };
  protoOf(BackwardsCompatNode).f8w = function () {
    initializeModifier(this, true);
  };
  protoOf(BackwardsCompatNode).h8w = function () {
    unInitializeModifier(this);
  };
  protoOf(BackwardsCompatNode).u5e = function () {
    return requireLayoutNode(this).w90_1;
  };
  protoOf(BackwardsCompatNode).r6p = function () {
    return requireLayoutNode(this).x90_1;
  };
  protoOf(BackwardsCompatNode).o5d = function () {
    // Inline function 'androidx.compose.ui.node.Nodes.OnRemeasured' call
    var tmp$ret$0 = _NodeKind___init__impl__ojsprp(128);
    return toSize(requireCoordinator(this, tmp$ret$0).q95());
  };
  protoOf(BackwardsCompatNode).v95 = function () {
    this.faz_1 = true;
    invalidateDraw(this);
  };
  protoOf(BackwardsCompatNode).jb0 = function () {
    this.faz_1 = true;
    invalidateDraw(this);
  };
  protoOf(BackwardsCompatNode).y9h = function () {
    var tmp0_elvis_lhs = this.gaz_1;
    return tmp0_elvis_lhs == null ? modifierLocalMapOf() : tmp0_elvis_lhs;
  };
  protoOf(BackwardsCompatNode).raz = function () {
    if (this.z8v_1) {
      this.haz_1.c3();
      var tmp0 = requireOwner(this).fb0();
      var tmp4 = get_updateModifierLocalConsumer();
      // Inline function 'androidx.compose.ui.node.OwnerSnapshotObserver.observeReads' call
      var block = BackwardsCompatNode$updateModifierLocalConsumer$lambda(this);
      access$_get_observer__zh6fij(tmp0).z5a(this, tmp4, block);
    }
  };
  protoOf(BackwardsCompatNode).kb0 = function () {
    return this.z8v_1;
  };
  protoOf(BackwardsCompatNode).g8y = function (_this__u8e3s4, measurable, constraints) {
    var tmp = this.eaz_1;
    // Inline function 'kotlin.with' call
    return (isInterface(tmp, LayoutModifier) ? tmp : THROW_CCE()).g8y(_this__u8e3s4, measurable, constraints);
  };
  protoOf(BackwardsCompatNode).o8y = function (_this__u8e3s4, measurable, height) {
    var tmp = this.eaz_1;
    // Inline function 'kotlin.with' call
    return (isInterface(tmp, LayoutModifier) ? tmp : THROW_CCE()).o8y(_this__u8e3s4, measurable, height);
  };
  protoOf(BackwardsCompatNode).p8y = function (_this__u8e3s4, measurable, width) {
    var tmp = this.eaz_1;
    // Inline function 'kotlin.with' call
    return (isInterface(tmp, LayoutModifier) ? tmp : THROW_CCE()).p8y(_this__u8e3s4, measurable, width);
  };
  protoOf(BackwardsCompatNode).q8y = function (_this__u8e3s4, measurable, height) {
    var tmp = this.eaz_1;
    // Inline function 'kotlin.with' call
    return (isInterface(tmp, LayoutModifier) ? tmp : THROW_CCE()).q8y(_this__u8e3s4, measurable, height);
  };
  protoOf(BackwardsCompatNode).r8y = function (_this__u8e3s4, measurable, width) {
    var tmp = this.eaz_1;
    // Inline function 'kotlin.with' call
    return (isInterface(tmp, LayoutModifier) ? tmp : THROW_CCE()).r8y(_this__u8e3s4, measurable, width);
  };
  protoOf(BackwardsCompatNode).h92 = function (_this__u8e3s4) {
    var element = this.eaz_1;
    // Inline function 'kotlin.with' call
    var $this$with = isInterface(element, DrawModifier) ? element : THROW_CCE();
    var tmp;
    if (this.faz_1) {
      tmp = isInterface(element, DrawCacheModifier);
    } else {
      tmp = false;
    }
    if (tmp) {
      updateDrawCache(this);
    }
    $this$with.h92(_this__u8e3s4);
  };
  protoOf(BackwardsCompatNode).l9i = function (_this__u8e3s4) {
    var tmp = this.eaz_1;
    var config = (isInterface(tmp, SemanticsModifier) ? tmp : THROW_CCE()).lb0();
    var toMergeInto = _this__u8e3s4 instanceof SemanticsConfiguration ? _this__u8e3s4 : THROW_CCE();
    toMergeInto.rb0(config);
  };
  protoOf(BackwardsCompatNode).aa1 = function (pointerEvent, pass, bounds) {
    var tmp = this.eaz_1;
    // Inline function 'kotlin.with' call
    (isInterface(tmp, PointerInputModifier) ? tmp : THROW_CCE()).za2().aa1(pointerEvent, pass, bounds);
  };
  protoOf(BackwardsCompatNode).n8w = function () {
    var tmp = this.eaz_1;
    if (isInterface(tmp, PointerInputModifier)) {
      this.xa1();
    }
  };
  protoOf(BackwardsCompatNode).xa1 = function () {
    var tmp = this.eaz_1;
    // Inline function 'kotlin.with' call
    (isInterface(tmp, PointerInputModifier) ? tmp : THROW_CCE()).za2().sb0();
  };
  protoOf(BackwardsCompatNode).ga5 = function () {
    var tmp = this.eaz_1;
    // Inline function 'kotlin.with' call
    return (isInterface(tmp, PointerInputModifier) ? tmp : THROW_CCE()).za2().tb0();
  };
  protoOf(BackwardsCompatNode).fa5 = function () {
    var tmp = this.eaz_1;
    // Inline function 'kotlin.with' call
    return (isInterface(tmp, PointerInputModifier) ? tmp : THROW_CCE()).za2().ub0();
  };
  protoOf(BackwardsCompatNode).aaj = function (_this__u8e3s4, parentData) {
    var tmp = this.eaz_1;
    // Inline function 'kotlin.with' call
    return (isInterface(tmp, ParentDataModifier) ? tmp : THROW_CCE()).aaj(_this__u8e3s4, parentData);
  };
  protoOf(BackwardsCompatNode).eam = function (coordinates) {
    var tmp = this.eaz_1;
    (isInterface(tmp, OnGloballyPositionedModifier) ? tmp : THROW_CCE()).eam(coordinates);
  };
  protoOf(BackwardsCompatNode).u91 = function (size) {
    var element = this.eaz_1;
    if (isInterface(element, OnRemeasuredModifier)) {
      element.u91(size);
    }
  };
  protoOf(BackwardsCompatNode).x91 = function (coordinates) {
    this.iaz_1 = coordinates;
    var element = this.eaz_1;
    if (isInterface(element, OnPlacedModifier)) {
      element.x91(coordinates);
    }
  };
  protoOf(BackwardsCompatNode).m9c = function (focusState) {
    var focusEventModifier = this.eaz_1;
    // Inline function 'androidx.compose.ui.internal.checkPrecondition' call
    if (!isInterface(focusEventModifier, FocusEventModifier)) {
      var tmp$ret$1 = 'onFocusEvent called on wrong node';
      throwIllegalStateException(tmp$ret$1);
    }
    focusEventModifier.m9c(focusState);
  };
  protoOf(BackwardsCompatNode).c9g = function (focusProperties) {
    var focusOrderModifier = this.eaz_1;
    // Inline function 'androidx.compose.ui.internal.checkPrecondition' call
    if (!isInterface(focusOrderModifier, FocusOrderModifier)) {
      var tmp$ret$1 = 'applyFocusProperties called on wrong node';
      throwIllegalStateException(tmp$ret$1);
    }
    focusOrderModifier.h9d(new FocusOrder(focusProperties));
  };
  protoOf(BackwardsCompatNode).toString = function () {
    return toString(this.eaz_1);
  };
  function isChainUpdate(_this__u8e3s4) {
    _init_properties_BackwardsCompatNode_kt__rwcpvm();
    var tmp = requireLayoutNode(_this__u8e3s4).d91_1.i99_1;
    var tailNode = tmp instanceof TailModifierNode ? tmp : THROW_CCE();
    return tailNode.jb1_1;
  }
  function DetachedModifierLocalReadScope$1() {
  }
  function onDrawCacheReadsChanged$lambda(it) {
    _init_properties_BackwardsCompatNode_kt__rwcpvm();
    it.jb0();
    return Unit_instance;
  }
  function updateModifierLocalConsumer$lambda(it) {
    _init_properties_BackwardsCompatNode_kt__rwcpvm();
    it.raz();
    return Unit_instance;
  }
  var properties_initialized_BackwardsCompatNode_kt_vhlzc4;
  function _init_properties_BackwardsCompatNode_kt__rwcpvm() {
    if (!properties_initialized_BackwardsCompatNode_kt_vhlzc4) {
      properties_initialized_BackwardsCompatNode_kt_vhlzc4 = true;
      DetachedModifierLocalReadScope = new DetachedModifierLocalReadScope$1();
      onDrawCacheReadsChanged = onDrawCacheReadsChanged$lambda;
      updateModifierLocalConsumer = updateModifierLocalConsumer$lambda;
      androidx_compose_ui_node_BackwardsCompatNode$stable = 8;
    }
  }
  function ComposeUiNode$Companion$VirtualConstructor$lambda() {
    return new LayoutNode(true);
  }
  function ComposeUiNode$Companion$SetModifier$lambda(_this__u8e3s4, it) {
    _this__u8e3s4.kb1(it);
    return Unit_instance;
  }
  function ComposeUiNode$Companion$SetDensity$lambda(_this__u8e3s4, it) {
    _this__u8e3s4.s6p(it);
    return Unit_instance;
  }
  function ComposeUiNode$Companion$SetResolvedCompositionLocals$lambda(_this__u8e3s4, it) {
    _this__u8e3s4.lb1(it);
    return Unit_instance;
  }
  function ComposeUiNode$Companion$SetMeasurePolicy$lambda(_this__u8e3s4, it) {
    _this__u8e3s4.kax(it);
    return Unit_instance;
  }
  function ComposeUiNode$Companion$SetLayoutDirection$lambda(_this__u8e3s4, it) {
    _this__u8e3s4.q6p(it);
    return Unit_instance;
  }
  function ComposeUiNode$Companion$SetViewConfiguration$lambda(_this__u8e3s4, it) {
    _this__u8e3s4.mb1(it);
    return Unit_instance;
  }
  function ComposeUiNode$Companion$SetCompositeKeyHash$lambda(_this__u8e3s4, it) {
    _this__u8e3s4.nb1(it);
    return Unit_instance;
  }
  function ComposeUiNode$Companion$ApplyOnDeactivatedNodeAssertion$lambda(_this__u8e3s4) {
    var tmp0_safe_receiver = _this__u8e3s4 instanceof LayoutNode ? _this__u8e3s4 : null;
    // Inline function 'androidx.compose.ui.internal.checkPrecondition' call
    if (!!((tmp0_safe_receiver == null ? null : tmp0_safe_receiver.o91_1) === true)) {
      var tmp$ret$1 = 'Apply is called on deactivated node ' + toString(_this__u8e3s4);
      throwIllegalStateException(tmp$ret$1);
    }
    return Unit_instance;
  }
  function Companion_27() {
    Companion_instance_32 = this;
    this.oah_1 = Companion_getInstance_56().qax_1;
    var tmp = this;
    tmp.pah_1 = ComposeUiNode$Companion$VirtualConstructor$lambda;
    var tmp_0 = this;
    tmp_0.qah_1 = ComposeUiNode$Companion$SetModifier$lambda;
    var tmp_1 = this;
    tmp_1.rah_1 = ComposeUiNode$Companion$SetDensity$lambda;
    var tmp_2 = this;
    tmp_2.sah_1 = ComposeUiNode$Companion$SetResolvedCompositionLocals$lambda;
    var tmp_3 = this;
    tmp_3.tah_1 = ComposeUiNode$Companion$SetMeasurePolicy$lambda;
    var tmp_4 = this;
    tmp_4.uah_1 = ComposeUiNode$Companion$SetLayoutDirection$lambda;
    var tmp_5 = this;
    tmp_5.vah_1 = ComposeUiNode$Companion$SetViewConfiguration$lambda;
    var tmp_6 = this;
    tmp_6.wah_1 = ComposeUiNode$Companion$SetCompositeKeyHash$lambda;
    var tmp_7 = this;
    tmp_7.xah_1 = ComposeUiNode$Companion$ApplyOnDeactivatedNodeAssertion$lambda;
  }
  var Companion_instance_32;
  function Companion_getInstance_53() {
    if (Companion_instance_32 == null)
      new Companion_27();
    return Companion_instance_32;
  }
  function CompositionLocalConsumerModifierNode() {
  }
  function currentValueOf(_this__u8e3s4, local) {
    // Inline function 'androidx.compose.ui.internal.checkPrecondition' call
    if (!_this__u8e3s4.f4n().z8v_1) {
      var tmp$ret$1 = 'Cannot read CompositionLocal because the Modifier node is not currently attached.';
      throwIllegalStateException(tmp$ret$1);
    }
    return requireLayoutNode(_this__u8e3s4).z90_1.k51(local);
  }
  function DelegatableNode() {
  }
  function requireDensity(_this__u8e3s4) {
    return requireLayoutNode(_this__u8e3s4).w90_1;
  }
  function requireLayoutCoordinates(_this__u8e3s4) {
    // Inline function 'androidx.compose.ui.internal.checkPrecondition' call
    if (!_this__u8e3s4.f4n().z8v_1) {
      var tmp$ret$1 = 'Cannot get LayoutCoordinates, Modifier.Node is not attached.';
      throwIllegalStateException(tmp$ret$1);
    }
    // Inline function 'androidx.compose.ui.node.Nodes.Layout' call
    var tmp$ret$2 = _NodeKind___init__impl__ojsprp(2);
    var coordinates = requireCoordinator(_this__u8e3s4, tmp$ret$2).p91();
    // Inline function 'androidx.compose.ui.internal.checkPrecondition' call
    if (!coordinates.y91()) {
      var tmp$ret$4 = 'LayoutCoordinates is not attached.';
      throwIllegalStateException(tmp$ret$4);
    }
    return coordinates;
  }
  function requireGraphicsContext(_this__u8e3s4) {
    return requireOwner(_this__u8e3s4).z93();
  }
  function requireLayoutDirection(_this__u8e3s4) {
    return requireLayoutNode(_this__u8e3s4).x90_1;
  }
  function requestAutofill(_this__u8e3s4) {
    return requireLayoutNode(_this__u8e3s4).ob1();
  }
  function dispatchOnScrollChanged_0(_this__u8e3s4, delta) {
    return requireOwner(_this__u8e3s4).pb1(delta);
  }
  function requireOwner(_this__u8e3s4) {
    // Inline function 'androidx.compose.ui.internal.checkPreconditionNotNull' call
    var value = requireLayoutNode(_this__u8e3s4).l90_1;
    if (value == null) {
      var tmp$ret$1 = 'This node does not have an owner.';
      throwIllegalStateExceptionForNullCheck(tmp$ret$1);
    }
    return value;
  }
  function requireLayoutNode(_this__u8e3s4) {
    // Inline function 'androidx.compose.ui.internal.checkPreconditionNotNull' call
    var value = _this__u8e3s4.f4n().t8v_1;
    if (value == null) {
      var tmp$ret$1 = 'Cannot obtain node coordinator. Is the Modifier.Node attached?';
      throwIllegalStateExceptionForNullCheck(tmp$ret$1);
    }
    return value.a9i();
  }
  function requireCoordinator(_this__u8e3s4, kind) {
    var coordinator = ensureNotNull(_this__u8e3s4.f4n().t8v_1);
    return !(coordinator.qb1() === _this__u8e3s4) ? coordinator : get_includeSelfInTraversal(kind) ? ensureNotNull(coordinator.s94_1) : coordinator;
  }
  function findNearestBeyondBoundsLayoutAncestor(_this__u8e3s4) {
    // Inline function 'androidx.compose.ui.node.Nodes.BeyondBoundsLayout' call
    var tmp0 = _NodeKind___init__impl__ojsprp(8388608);
    // Inline function 'androidx.compose.ui.node.Nodes.Locals' call
    // Inline function 'androidx.compose.ui.node.NodeKind.or' call
    var other = _NodeKind___init__impl__ojsprp(32);
    // Inline function 'androidx.compose.ui.node.visitAncestors' call
    var mask = _NodeKind___get_mask__impl__1uopb6(tmp0) | _NodeKind___get_mask__impl__1uopb6(other);
    // Inline function 'androidx.compose.ui.internal.checkPrecondition' call
    if (!_this__u8e3s4.f4n().z8v_1) {
      var tmp$ret$5 = 'visitAncestors called on an unattached node';
      throwIllegalStateException(tmp$ret$5);
    }
    var node = false ? _this__u8e3s4.f4n() : _this__u8e3s4.f4n().q8v_1;
    var layout = requireLayoutNode(_this__u8e3s4);
    while (!(layout == null)) {
      var head = layout.d91_1.j99_1;
      if (!((head.p8v_1 & mask) === 0)) {
        while (!(node == null)) {
          if (!((node.o8v_1 & mask) === 0)) {
            var it = node;
            // Inline function 'androidx.compose.ui.node.Nodes.BeyondBoundsLayout' call
            // Inline function 'androidx.compose.ui.Node.isKind' call
            var kind = _NodeKind___init__impl__ojsprp(8388608);
            if (!((it.o8v_1 & _NodeKind___get_mask__impl__1uopb6(kind)) === 0)) {
              var beyondBoundsNode = null;
              if (isInterface(it, BeyondBoundsLayoutProviderModifierNode)) {
                beyondBoundsNode = it;
              } else {
                if (it instanceof DelegatingNode) {
                  // Inline function 'androidx.compose.ui.node.DelegatingNode.forEachImmediateDelegate' call
                  var node_0 = it.e9a_1;
                  while (!(node_0 == null)) {
                    var tmp0_0 = node_0;
                    $l$block: {
                      if (isInterface(tmp0_0, BeyondBoundsLayoutProviderModifierNode)) {
                        beyondBoundsNode = tmp0_0;
                        break $l$block;
                      }
                    }
                    node_0 = node_0.r8v_1;
                  }
                }
              }
              var tmp0_safe_receiver = beyondBoundsNode;
              return tmp0_safe_receiver == null ? null : tmp0_safe_receiver.lag();
            }
            // Inline function 'androidx.compose.ui.node.Nodes.Locals' call
            // Inline function 'androidx.compose.ui.Node.isKind' call
            var kind_0 = _NodeKind___init__impl__ojsprp(32);
            if (!((it.o8v_1 & _NodeKind___get_mask__impl__1uopb6(kind_0)) === 0)) {
              var modifierLocalNode = null;
              if (isInterface(it, ModifierLocalModifierNode)) {
                modifierLocalNode = it;
              } else {
                if (it instanceof DelegatingNode) {
                  // Inline function 'androidx.compose.ui.node.DelegatingNode.forEachImmediateDelegate' call
                  var node_1 = it.e9a_1;
                  while (!(node_1 == null)) {
                    var tmp0_1 = node_1;
                    $l$block_0: {
                      if (isInterface(tmp0_1, ModifierLocalModifierNode)) {
                        modifierLocalNode = tmp0_1;
                        break $l$block_0;
                      }
                    }
                    node_1 = node_1.r8v_1;
                  }
                }
              }
              var localNode = modifierLocalNode;
              if (!(localNode == null) && localNode.y9h().jaz(get_ModifierLocalBeyondBoundsLayout()))
                return localNode.y9h().vaz(get_ModifierLocalBeyondBoundsLayout());
            }
          }
          node = node.q8v_1;
        }
      }
      layout = layout.f9a();
      var tmp0_safe_receiver_0 = layout;
      var tmp1_safe_receiver = tmp0_safe_receiver_0 == null ? null : tmp0_safe_receiver_0.d91_1;
      node = tmp1_safe_receiver == null ? null : tmp1_safe_receiver.i99_1;
    }
    return null;
  }
  function addLayoutNodeChildren(_this__u8e3s4, node, zOrder) {
    var tmp0 = getChildren(requireLayoutNode(node), zOrder);
    $l$block: {
      // Inline function 'androidx.compose.runtime.collection.MutableVector.forEachReversed' call
      var i = tmp0.d3e_1 - 1 | 0;
      var tmp = tmp0.b3e_1;
      var content = isArray(tmp) ? tmp : THROW_CCE();
      if (i >= content.length) {
        break $l$block;
      }
      while (i >= 0) {
        var it = content[i];
        _this__u8e3s4.zz(it.d91_1.j99_1);
        i = i - 1 | 0;
      }
    }
  }
  function pop_0(_this__u8e3s4) {
    var tmp;
    var tmp_0;
    if (_this__u8e3s4 == null) {
      tmp_0 = true;
    } else {
      // Inline function 'androidx.compose.runtime.collection.MutableVector.isEmpty' call
      tmp_0 = _this__u8e3s4.d3e_1 === 0;
    }
    if (tmp_0) {
      tmp = null;
    } else {
      tmp = _this__u8e3s4.h3(_this__u8e3s4.d3e_1 - 1 | 0);
    }
    return tmp;
  }
  function getChildren(_this__u8e3s4, zOrder) {
    var tmp;
    if (zOrder) {
      tmp = _this__u8e3s4.sb1();
    } else {
      tmp = _this__u8e3s4.rb1();
    }
    return tmp;
  }
  function get_isDelegationRoot(_this__u8e3s4) {
    return _this__u8e3s4.f4n() === _this__u8e3s4;
  }
  function asLayoutModifierNode(_this__u8e3s4) {
    // Inline function 'androidx.compose.ui.node.Nodes.Layout' call
    // Inline function 'androidx.compose.ui.Node.isKind' call
    var kind = _NodeKind___init__impl__ojsprp(2);
    if (!!((_this__u8e3s4.o8v_1 & _NodeKind___get_mask__impl__1uopb6(kind)) === 0))
      return null;
    if (isInterface(_this__u8e3s4, LayoutModifierNode))
      return _this__u8e3s4;
    if (_this__u8e3s4 instanceof DelegatingNode) {
      var node = _this__u8e3s4.e9a_1;
      while (!(node == null)) {
        if (isInterface(node, LayoutModifierNode))
          return node;
        var tmp;
        var tmp_0;
        if (node instanceof DelegatingNode) {
          var tmp0 = node;
          // Inline function 'androidx.compose.ui.node.Nodes.Layout' call
          // Inline function 'androidx.compose.ui.Node.isKind' call
          var kind_0 = _NodeKind___init__impl__ojsprp(2);
          tmp_0 = !((tmp0.o8v_1 & _NodeKind___get_mask__impl__1uopb6(kind_0)) === 0);
        } else {
          tmp_0 = false;
        }
        if (tmp_0) {
          tmp = node.e9a_1;
        } else {
          tmp = node.r8v_1;
        }
        node = tmp;
      }
    }
    return null;
  }
  function has(_this__u8e3s4, type) {
    return !((_this__u8e3s4.f4n().p8v_1 & _NodeKind___get_mask__impl__1uopb6(type)) === 0);
  }
  function access$addLayoutNodeChildren$tDelegatableNodeKt($receiver, node, zOrder) {
    return addLayoutNodeChildren($receiver, node, zOrder);
  }
  function access$pop$tDelegatableNodeKt($receiver) {
    return pop_0($receiver);
  }
  var androidx_compose_ui_node_DelegatingNode$stable;
  function validateDelegateKindSet($this, delegateKindSet, delegateNode) {
    var current = $this.o8v_1;
    var tmp;
    // Inline function 'androidx.compose.ui.node.Nodes.Layout' call
    // Inline function 'androidx.compose.ui.node.contains' call
    var value = _NodeKind___init__impl__ojsprp(2);
    if (!((delegateKindSet & _NodeKind___get_mask__impl__1uopb6(value)) === 0)) {
      // Inline function 'androidx.compose.ui.node.Nodes.Layout' call
      // Inline function 'androidx.compose.ui.node.contains' call
      var value_0 = _NodeKind___init__impl__ojsprp(2);
      tmp = !((current & _NodeKind___get_mask__impl__1uopb6(value_0)) === 0);
    } else {
      tmp = false;
    }
    if (tmp) {
      // Inline function 'androidx.compose.ui.internal.checkPrecondition' call
      if (!isInterface($this, LayoutModifierNode)) {
        var tmp$ret$5 = 'Delegating to multiple LayoutModifierNodes without the delegating node implementing LayoutModifierNode itself is not allowed.' + ('\nDelegating Node: ' + toString($this)) + ('\nDelegate Node: ' + toString(delegateNode));
        throwIllegalStateException(tmp$ret$5);
      }
    }
  }
  function updateNodeKindSet($this, newKindSet, recalculateOwner) {
    var before = $this.o8v_1;
    $this.o8v_1 = newKindSet;
    if (!(before === newKindSet)) {
      var agg = newKindSet;
      if (get_isDelegationRoot($this)) {
        $this.p8v_1 = agg;
      }
      if ($this.z8v_1) {
        var owner = $this.m8v_1;
        var it = $this;
        $l$loop: while (!(it == null)) {
          agg = it.o8v_1 | agg;
          it.o8v_1 = agg;
          if (it === owner)
            break $l$loop;
          it = it.q8v_1;
        }
        if (recalculateOwner && it === owner) {
          agg = calculateNodeKindSetFromIncludingDelegates(owner);
          owner.o8v_1 = agg;
        }
        var tmp = agg;
        var tmp0_safe_receiver = it;
        var tmp1_safe_receiver = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.r8v_1;
        var tmp2_elvis_lhs = tmp1_safe_receiver == null ? null : tmp1_safe_receiver.p8v_1;
        agg = tmp | (tmp2_elvis_lhs == null ? 0 : tmp2_elvis_lhs);
        while (!(it == null)) {
          agg = it.o8v_1 | agg;
          it.p8v_1 = agg;
          it = it.q8v_1;
        }
      }
    }
  }
  function DelegatingNode() {
    Node.call(this);
    this.d9a_1 = calculateNodeKindSetFrom_0(this);
    this.e9a_1 = null;
  }
  protoOf(DelegatingNode).c8w = function (coordinator) {
    protoOf(Node).c8w.call(this, coordinator);
    // Inline function 'androidx.compose.ui.node.DelegatingNode.forEachImmediateDelegate' call
    var node = this.e9a_1;
    while (!(node == null)) {
      node.c8w(coordinator);
      node = node.r8v_1;
    }
  };
  protoOf(DelegatingNode).m8w = function (owner) {
    protoOf(Node).m8w.call(this, owner);
    // Inline function 'androidx.compose.ui.node.DelegatingNode.forEachImmediateDelegate' call
    var node = this.e9a_1;
    while (!(node == null)) {
      node.m8w(owner);
      node = node.r8v_1;
    }
  };
  protoOf(DelegatingNode).tb1 = function (delegatableNode) {
    var delegateNode = delegatableNode.f4n();
    var isAlreadyDelegated = !(delegateNode === delegatableNode);
    if (isAlreadyDelegated) {
      var tmp0_safe_receiver = delegatableNode instanceof Node ? delegatableNode : null;
      var delegator = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.q8v_1;
      var isDelegatedToThisNode = delegateNode === this.m8v_1 && equals(delegator, this);
      if (isDelegatedToThisNode) {
        return delegatableNode;
      } else {
        // Inline function 'kotlin.error' call
        var message = 'Cannot delegate to an already delegated node';
        throw IllegalStateException_init_$Create$(toString(message));
      }
    }
    // Inline function 'androidx.compose.ui.internal.checkPrecondition' call
    if (!!delegateNode.z8v_1) {
      var tmp$ret$2 = 'Cannot delegate to an already attached node';
      throwIllegalStateException(tmp$ret$2);
    }
    delegateNode.m8w(this.m8v_1);
    var beforeKindSet = this.o8v_1;
    var delegatedKindSet = calculateNodeKindSetFromIncludingDelegates(delegateNode);
    delegateNode.o8v_1 = delegatedKindSet;
    validateDelegateKindSet(this, delegatedKindSet, delegateNode);
    delegateNode.r8v_1 = this.e9a_1;
    this.e9a_1 = delegateNode;
    delegateNode.q8v_1 = this;
    updateNodeKindSet(this, this.o8v_1 | delegatedKindSet, false);
    if (this.z8v_1) {
      var tmp;
      // Inline function 'androidx.compose.ui.node.Nodes.Layout' call
      // Inline function 'androidx.compose.ui.node.contains' call
      var value = _NodeKind___init__impl__ojsprp(2);
      if (!((delegatedKindSet & _NodeKind___get_mask__impl__1uopb6(value)) === 0)) {
        // Inline function 'androidx.compose.ui.node.Nodes.Layout' call
        // Inline function 'androidx.compose.ui.node.contains' call
        var value_0 = _NodeKind___init__impl__ojsprp(2);
        tmp = !!((beforeKindSet & _NodeKind___get_mask__impl__1uopb6(value_0)) === 0);
      } else {
        tmp = false;
      }
      if (tmp) {
        var chain = requireLayoutNode(this).d91_1;
        this.m8v_1.c8w(null);
        chain.ub1();
      } else {
        this.c8w(this.t8v_1);
      }
      delegateNode.d8w();
      delegateNode.e8w();
      autoInvalidateInsertedNode(delegateNode);
    }
    return delegatableNode;
  };
  protoOf(DelegatingNode).vb1 = function (instance) {
    var prev = null;
    var it = this.e9a_1;
    var found = false;
    $l$loop: while (!(it == null)) {
      if (it === instance) {
        if (it.z8v_1) {
          autoInvalidateRemovedNode(it);
          it.g8w();
          it.i8w();
        }
        it.m8w(it);
        it.p8v_1 = 0;
        if (prev == null) {
          this.e9a_1 = it.r8v_1;
        } else {
          prev.r8v_1 = it.r8v_1;
        }
        it.r8v_1 = null;
        it.q8v_1 = null;
        found = true;
        break $l$loop;
      }
      prev = it;
      it = it.r8v_1;
    }
    if (found) {
      var beforeKindSet = this.o8v_1;
      var afterKindSet = calculateNodeKindSetFromIncludingDelegates(this);
      updateNodeKindSet(this, afterKindSet, true);
      var tmp;
      var tmp_0;
      if (this.z8v_1) {
        // Inline function 'androidx.compose.ui.node.Nodes.Layout' call
        // Inline function 'androidx.compose.ui.node.contains' call
        var value = _NodeKind___init__impl__ojsprp(2);
        tmp_0 = !((beforeKindSet & _NodeKind___get_mask__impl__1uopb6(value)) === 0);
      } else {
        tmp_0 = false;
      }
      if (tmp_0) {
        // Inline function 'androidx.compose.ui.node.Nodes.Layout' call
        // Inline function 'androidx.compose.ui.node.contains' call
        var value_0 = _NodeKind___init__impl__ojsprp(2);
        tmp = !!((afterKindSet & _NodeKind___get_mask__impl__1uopb6(value_0)) === 0);
      } else {
        tmp = false;
      }
      if (tmp) {
        var chain = requireLayoutNode(this).d91_1;
        this.m8v_1.c8w(null);
        chain.ub1();
      }
    } else {
      // Inline function 'kotlin.error' call
      var message = 'Could not find delegate: ' + toString(instance);
      throw IllegalStateException_init_$Create$(toString(message));
    }
  };
  protoOf(DelegatingNode).d8w = function () {
    protoOf(Node).d8w.call(this);
    // Inline function 'androidx.compose.ui.node.DelegatingNode.forEachImmediateDelegate' call
    var node = this.e9a_1;
    while (!(node == null)) {
      var it = node;
      it.c8w(this.t8v_1);
      if (!it.z8v_1) {
        it.d8w();
      }
      node = node.r8v_1;
    }
  };
  protoOf(DelegatingNode).e8w = function () {
    // Inline function 'androidx.compose.ui.node.DelegatingNode.forEachImmediateDelegate' call
    var node = this.e9a_1;
    while (!(node == null)) {
      node.e8w();
      node = node.r8v_1;
    }
    protoOf(Node).e8w.call(this);
  };
  protoOf(DelegatingNode).g8w = function () {
    protoOf(Node).g8w.call(this);
    // Inline function 'androidx.compose.ui.node.DelegatingNode.forEachImmediateDelegate' call
    var node = this.e9a_1;
    while (!(node == null)) {
      node.g8w();
      node = node.r8v_1;
    }
  };
  protoOf(DelegatingNode).i8w = function () {
    // Inline function 'androidx.compose.ui.node.DelegatingNode.forEachImmediateDelegate' call
    var node = this.e9a_1;
    while (!(node == null)) {
      node.i8w();
      node = node.r8v_1;
    }
    protoOf(Node).i8w.call(this);
  };
  protoOf(DelegatingNode).j8w = function () {
    protoOf(Node).j8w.call(this);
    // Inline function 'androidx.compose.ui.node.DelegatingNode.forEachImmediateDelegate' call
    var node = this.e9a_1;
    while (!(node == null)) {
      node.j8w();
      node = node.r8v_1;
    }
  };
  function get_DepthComparator() {
    _init_properties_DepthSortedSet_kt__n3cdoi();
    return DepthComparator;
  }
  var DepthComparator;
  var androidx_compose_ui_node_DepthSortedSet$stable;
  var androidx_compose_ui_node_DepthSortedSetsForDifferentPasses$stable;
  function access$_get_lookaheadAndAncestorMeasureSet__c8luvz($this) {
    return $this.wb1_1;
  }
  function access$_get_lookaheadAndAncestorPlaceSet__6br020($this) {
    return $this.xb1_1;
  }
  function access$_get_approachSet__q1cv7b($this) {
    return $this.yb1_1;
  }
  function DepthSortedSetsForDifferentPasses(extraAssertions) {
    this.wb1_1 = new DepthSortedSet(extraAssertions);
    this.xb1_1 = new DepthSortedSet(extraAssertions);
    this.yb1_1 = new DepthSortedSet(extraAssertions);
  }
  protoOf(DepthSortedSetsForDifferentPasses).zb1 = function (node, affectsLookahead) {
    var isAncestor = node.f90_1 == null;
    var containedInLookaheadAndAncestors = this.wb1_1.db2(node) || this.xb1_1.db2(node);
    var tmp;
    if (affectsLookahead) {
      tmp = (!isAncestor && containedInLookaheadAndAncestors);
    } else {
      tmp = isAncestor && containedInLookaheadAndAncestors || this.yb1_1.db2(node);
    }
    return tmp;
  };
  protoOf(DepthSortedSetsForDifferentPasses).db2 = function (node) {
    return this.wb1_1.db2(node) || this.xb1_1.db2(node) || this.yb1_1.db2(node);
  };
  protoOf(DepthSortedSetsForDifferentPasses).eb2 = function (node, invalidation) {
    switch (invalidation.a1_1) {
      case 0:
        this.wb1_1.fb2(node);
        this.yb1_1.fb2(node);
        break;
      case 1:
        this.xb1_1.fb2(node);
        this.yb1_1.fb2(node);
        break;
      case 2:
        if (!(node.f90_1 == null)) {
          this.yb1_1.fb2(node);
        } else {
          this.wb1_1.fb2(node);
        }

        break;
      case 3:
        if (!(node.f90_1 == null)) {
          this.yb1_1.fb2(node);
        } else {
          this.xb1_1.fb2(node);
        }

        break;
      default:
        noWhenBranchMatchedException();
        break;
    }
  };
  protoOf(DepthSortedSetsForDifferentPasses).gb2 = function (node) {
    var removedFromLookaheadMeasureSet = this.wb1_1.gb2(node);
    var removedFromLookaheadPlaceSet = this.xb1_1.gb2(node);
    return this.yb1_1.gb2(node) || removedFromLookaheadMeasureSet || removedFromLookaheadPlaceSet;
  };
  protoOf(DepthSortedSetsForDifferentPasses).r = function () {
    return this.wb1_1.r() && this.yb1_1.r() && this.xb1_1.r();
  };
  protoOf(DepthSortedSetsForDifferentPasses).fv = function () {
    return !this.r();
  };
  function safeMapOfOriginalDepth($this) {
    if ($this.bb2_1 == null) {
      $this.bb2_1 = mutableObjectIntMapOf();
    }
    return ensureNotNull($this.bb2_1);
  }
  function DepthSortedSet(extraAssertions) {
    this.ab2_1 = extraAssertions;
    this.bb2_1 = null;
    this.cb2_1 = new SortedSet(get_DepthComparator());
  }
  protoOf(DepthSortedSet).db2 = function (node) {
    var contains = this.cb2_1.m1(node);
    if (this.ab2_1) {
      // Inline function 'androidx.compose.ui.internal.checkPrecondition' call
      if (!(contains === safeMapOfOriginalDepth(this).u2(node))) {
        var tmp$ret$1 = 'inconsistency in TreeSet';
        throwIllegalStateException(tmp$ret$1);
      }
    }
    return contains;
  };
  protoOf(DepthSortedSet).fb2 = function (node) {
    // Inline function 'androidx.compose.ui.internal.checkPrecondition' call
    if (!node.y91()) {
      var tmp$ret$1 = 'DepthSortedSet.add called on an unattached node';
      throwIllegalStateException(tmp$ret$1);
    }
    if (this.ab2_1) {
      var map = safeMapOfOriginalDepth(this);
      var usedDepth = map.rz(node, 2147483647);
      if (usedDepth === 2147483647) {
        map.oz(node, node.n90_1);
      } else {
        // Inline function 'androidx.compose.ui.internal.checkPrecondition' call
        if (!(usedDepth === node.n90_1)) {
          var tmp$ret$3 = 'invalid node depth';
          throwIllegalStateException(tmp$ret$3);
        }
      }
    }
    this.cb2_1.j1(node);
  };
  protoOf(DepthSortedSet).gb2 = function (node) {
    // Inline function 'androidx.compose.ui.internal.checkPrecondition' call
    if (!node.y91()) {
      var tmp$ret$1 = 'DepthSortedSet.remove called on an unattached node';
      throwIllegalStateException(tmp$ret$1);
    }
    var contains = this.cb2_1.d3(node);
    if (this.ab2_1) {
      var map = safeMapOfOriginalDepth(this);
      // Inline function 'androidx.collection.ObjectIntMap.contains' call
      if (map.u2(node)) {
        var usedDepth = map.w2(node);
        map.qz(node);
        // Inline function 'androidx.compose.ui.internal.checkPrecondition' call
        if (!(usedDepth === (contains ? node.n90_1 : 2147483647))) {
          var tmp$ret$4 = 'invalid node depth';
          throwIllegalStateException(tmp$ret$4);
        }
      }
    }
    return contains;
  };
  protoOf(DepthSortedSet).k3j = function () {
    var node = this.cb2_1.vg();
    this.gb2(node);
    return node;
  };
  protoOf(DepthSortedSet).r = function () {
    return this.cb2_1.r();
  };
  protoOf(DepthSortedSet).toString = function () {
    return toString(this.cb2_1);
  };
  function DepthComparator$1() {
  }
  protoOf(DepthComparator$1).kb2 = function (a, b) {
    var depthDiff = compareTo(a.n90_1, b.n90_1);
    if (!(depthDiff === 0)) {
      return depthDiff;
    }
    return compareTo(hashCode(a), hashCode(b));
  };
  protoOf(DepthComparator$1).compare = function (a, b) {
    var tmp = a instanceof LayoutNode ? a : THROW_CCE();
    return this.kb2(tmp, b instanceof LayoutNode ? b : THROW_CCE());
  };
  var properties_initialized_DepthSortedSet_kt_4tfw4c;
  function _init_properties_DepthSortedSet_kt__n3cdoi() {
    if (!properties_initialized_DepthSortedSet_kt_4tfw4c) {
      properties_initialized_DepthSortedSet_kt_4tfw4c = true;
      DepthComparator = new DepthComparator$1();
      androidx_compose_ui_node_DepthSortedSet$stable = 8;
      androidx_compose_ui_node_DepthSortedSetsForDifferentPasses$stable = 8;
    }
  }
  function invalidateDraw(_this__u8e3s4) {
    if (_this__u8e3s4.f4n().z8v_1) {
      // Inline function 'androidx.compose.ui.node.Nodes.Any' call
      var tmp$ret$0 = _NodeKind___init__impl__ojsprp(1);
      requireCoordinator(_this__u8e3s4, tmp$ret$0).lb2();
    }
  }
  function DrawModifierNode() {
  }
  function GlobalPositionAwareModifierNode() {
  }
  var androidx_compose_ui_node_HitTestResult$stable;
  function findBestHitDistance($this) {
    var bestDistance = DistanceAndFlags(Infinity, false);
    var inductionVariable = $this.ya6_1 + 1 | 0;
    var last = get_lastIndex($this);
    if (inductionVariable <= last)
      do {
        var i = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var distance = _DistanceAndFlags___init__impl__yrj538($this.xa6_1.l1(i));
        bestDistance = DistanceAndFlags__compareTo_impl_if9dw2(distance, bestDistance) < 0 ? distance : bestDistance;
        if (_DistanceAndFlags___get_distance__impl__av2ooo(bestDistance) < 0.0 && _DistanceAndFlags___get_isInLayer__impl__win4ip(bestDistance)) {
          return bestDistance;
        }
      }
       while (!(i === last));
    return bestDistance;
  }
  function removeNodeAtDepth($this, depth) {
    $this.wa6_1.h3(depth);
    $this.xa6_1.h3(depth);
  }
  function removeNodesInRange($this, startDepth, endDepth) {
    if (startDepth >= endDepth) {
      return Unit_instance;
    }
    $this.wa6_1.e5(startDepth, endDepth);
    $this.xa6_1.e5(startDepth, endDepth);
  }
  function HitTestResultIterator($outer, index, minIndex, maxIndex) {
    index = index === VOID ? 0 : index;
    minIndex = minIndex === VOID ? 0 : minIndex;
    maxIndex = maxIndex === VOID ? $outer.n1() : maxIndex;
    this.pb2_1 = $outer;
    this.mb2_1 = index;
    this.nb2_1 = minIndex;
    this.ob2_1 = maxIndex;
  }
  protoOf(HitTestResultIterator).u = function () {
    return this.mb2_1 < this.ob2_1;
  };
  protoOf(HitTestResultIterator).v4 = function () {
    return this.mb2_1 > this.nb2_1;
  };
  protoOf(HitTestResultIterator).v = function () {
    var tmp = this.pb2_1.wa6_1;
    var _unary__edvuaz = this.mb2_1;
    this.mb2_1 = _unary__edvuaz + 1 | 0;
    var tmp_0 = tmp.l1(_unary__edvuaz);
    return tmp_0 instanceof Node ? tmp_0 : THROW_CCE();
  };
  protoOf(HitTestResultIterator).w4 = function () {
    return this.mb2_1 - this.nb2_1 | 0;
  };
  protoOf(HitTestResultIterator).x4 = function () {
    var tmp = this.pb2_1.wa6_1;
    this.mb2_1 = this.mb2_1 - 1 | 0;
    var tmp_0 = tmp.l1(this.mb2_1);
    return tmp_0 instanceof Node ? tmp_0 : THROW_CCE();
  };
  protoOf(HitTestResultIterator).y4 = function () {
    return (this.mb2_1 - this.nb2_1 | 0) - 1 | 0;
  };
  function SubList($outer, minIndex, maxIndex) {
    this.sb2_1 = $outer;
    this.qb2_1 = minIndex;
    this.rb2_1 = maxIndex;
  }
  protoOf(SubList).n1 = function () {
    return this.rb2_1 - this.qb2_1 | 0;
  };
  protoOf(SubList).tb2 = function (element) {
    return !(this.ub2(element) === -1);
  };
  protoOf(SubList).m1 = function (element) {
    if (!(element instanceof Node))
      return false;
    return this.tb2(element instanceof Node ? element : THROW_CCE());
  };
  protoOf(SubList).vb2 = function (elements) {
    // Inline function 'kotlin.collections.forEach' call
    var _iterator__ex2g4s = elements.t();
    while (_iterator__ex2g4s.u()) {
      var element = _iterator__ex2g4s.v();
      if (!this.tb2(element)) {
        return false;
      }
    }
    return true;
  };
  protoOf(SubList).r2 = function (elements) {
    return this.vb2(elements);
  };
  protoOf(SubList).l1 = function (index) {
    var tmp = this.sb2_1.wa6_1.l1(index + this.qb2_1 | 0);
    return tmp instanceof Node ? tmp : THROW_CCE();
  };
  protoOf(SubList).ub2 = function (element) {
    var inductionVariable = this.qb2_1;
    var last = this.rb2_1;
    if (inductionVariable <= last)
      do {
        var i = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        if (equals(this.sb2_1.wa6_1.l1(i), element)) {
          return i - this.qb2_1 | 0;
        }
      }
       while (!(i === last));
    return -1;
  };
  protoOf(SubList).q1 = function (element) {
    if (!(element instanceof Node))
      return -1;
    return this.ub2(element instanceof Node ? element : THROW_CCE());
  };
  protoOf(SubList).r = function () {
    return this.n1() === 0;
  };
  protoOf(SubList).t = function () {
    return new HitTestResultIterator(this.sb2_1, this.qb2_1, this.qb2_1, this.rb2_1);
  };
  protoOf(SubList).p1 = function (index) {
    return new HitTestResultIterator(this.sb2_1, this.qb2_1 + index | 0, this.qb2_1, this.rb2_1);
  };
  protoOf(SubList).t2 = function (fromIndex, toIndex) {
    return new SubList(this.sb2_1, this.qb2_1 + fromIndex | 0, this.qb2_1 + toIndex | 0);
  };
  function access$_get_values__6cbjvt($this) {
    return $this.wa6_1;
  }
  function access$_get_distanceFromEdgeAndFlags__osnxzz($this) {
    return $this.xa6_1;
  }
  function access$_get_hitDepth__j82o0r($this) {
    return $this.ya6_1;
  }
  function access$_set_hitDepth__w0yzhj($this, _set____db54di) {
    $this.ya6_1 = _set____db54di;
    return Unit_instance;
  }
  function access$removeNodesInRange($this, startDepth, endDepth) {
    return removeNodesInRange($this, startDepth, endDepth);
  }
  function HitTestResult() {
    this.wa6_1 = new MutableObjectList(16);
    this.xa6_1 = new MutableLongList(16);
    this.ya6_1 = -1;
  }
  protoOf(HitTestResult).n1 = function () {
    return this.wa6_1.n1();
  };
  protoOf(HitTestResult).wb2 = function () {
    var distance = findBestHitDistance(this);
    return _DistanceAndFlags___get_distance__impl__av2ooo(distance) < 0.0 && _DistanceAndFlags___get_isInLayer__impl__win4ip(distance) && !_DistanceAndFlags___get_isInExpandedBounds__impl__i93ue8(distance);
  };
  protoOf(HitTestResult).xb2 = function () {
    this.ya6_1 = this.n1() - 1 | 0;
  };
  protoOf(HitTestResult).yb2 = function (distanceFromEdge, isInLayer) {
    if (this.ya6_1 === get_lastIndex(this)) {
      return true;
    }
    var distanceAndFlags = DistanceAndFlags(distanceFromEdge, isInLayer);
    var bestDistance = findBestHitDistance(this);
    return DistanceAndFlags__compareTo_impl_if9dw2(bestDistance, distanceAndFlags) > 0;
  };
  protoOf(HitTestResult).zb2 = function (node, isInLayer, childHitTest) {
    if (this.ya6_1 === get_lastIndex(this)) {
      // Inline function 'androidx.compose.ui.node.HitTestResult.hitInMinimumTouchTarget' call
      var startDepth = access$_get_hitDepth__j82o0r(this);
      access$removeNodesInRange(this, access$_get_hitDepth__j82o0r(this) + 1 | 0, this.n1());
      var _unary__edvuaz = access$_get_hitDepth__j82o0r(this);
      access$_set_hitDepth__w0yzhj(this, _unary__edvuaz + 1 | 0);
      access$_get_values__6cbjvt(this).j1(node);
      access$_get_distanceFromEdgeAndFlags__osnxzz(this).uw(_DistanceAndFlags___get_packedValue__impl__qekawo(access$DistanceAndFlags$tHitTestResultKt(0.0, isInLayer, true)));
      childHitTest();
      access$_set_hitDepth__w0yzhj(this, startDepth);
      return Unit_instance;
    }
    var previousDistance = findBestHitDistance(this);
    var previousHitDepth = this.ya6_1;
    if (_DistanceAndFlags___get_isInExpandedBounds__impl__i93ue8(previousDistance)) {
      this.ya6_1 = get_lastIndex(this);
      // Inline function 'androidx.compose.ui.node.HitTestResult.hitInMinimumTouchTarget' call
      var startDepth_0 = access$_get_hitDepth__j82o0r(this);
      access$removeNodesInRange(this, access$_get_hitDepth__j82o0r(this) + 1 | 0, this.n1());
      var _unary__edvuaz_0 = access$_get_hitDepth__j82o0r(this);
      access$_set_hitDepth__w0yzhj(this, _unary__edvuaz_0 + 1 | 0);
      access$_get_values__6cbjvt(this).j1(node);
      access$_get_distanceFromEdgeAndFlags__osnxzz(this).uw(_DistanceAndFlags___get_packedValue__impl__qekawo(access$DistanceAndFlags$tHitTestResultKt(0.0, isInLayer, true)));
      childHitTest();
      access$_set_hitDepth__w0yzhj(this, startDepth_0);
      var newDistance = findBestHitDistance(this);
      if (_DistanceAndFlags___get_distance__impl__av2ooo(newDistance) < 0) {
        var startIndex = previousHitDepth + 1 | 0;
        var endIndex = this.ya6_1 + 1 | 0;
        removeNodesInRange(this, startIndex, endIndex);
      }
      this.ya6_1 = previousHitDepth;
    } else if (_DistanceAndFlags___get_distance__impl__av2ooo(previousDistance) > 0) {
      // Inline function 'androidx.compose.ui.node.HitTestResult.hitInMinimumTouchTarget' call
      var startDepth_1 = access$_get_hitDepth__j82o0r(this);
      access$removeNodesInRange(this, access$_get_hitDepth__j82o0r(this) + 1 | 0, this.n1());
      var _unary__edvuaz_1 = access$_get_hitDepth__j82o0r(this);
      access$_set_hitDepth__w0yzhj(this, _unary__edvuaz_1 + 1 | 0);
      access$_get_values__6cbjvt(this).j1(node);
      access$_get_distanceFromEdgeAndFlags__osnxzz(this).uw(_DistanceAndFlags___get_packedValue__impl__qekawo(access$DistanceAndFlags$tHitTestResultKt(0.0, isInLayer, true)));
      childHitTest();
      access$_set_hitDepth__w0yzhj(this, startDepth_1);
    }
  };
  protoOf(HitTestResult).ab3 = function (node, distanceFromEdge, isInLayer, childHitTest) {
    if (this.ya6_1 === get_lastIndex(this)) {
      // Inline function 'androidx.compose.ui.node.HitTestResult.hitInMinimumTouchTarget' call
      // Inline function 'androidx.compose.ui.node.HitTestResult.hitInMinimumTouchTarget' call
      var startDepth = access$_get_hitDepth__j82o0r(this);
      access$removeNodesInRange(this, access$_get_hitDepth__j82o0r(this) + 1 | 0, this.n1());
      var _unary__edvuaz = access$_get_hitDepth__j82o0r(this);
      access$_set_hitDepth__w0yzhj(this, _unary__edvuaz + 1 | 0);
      access$_get_values__6cbjvt(this).j1(node);
      access$_get_distanceFromEdgeAndFlags__osnxzz(this).uw(_DistanceAndFlags___get_packedValue__impl__qekawo(access$DistanceAndFlags$tHitTestResultKt(distanceFromEdge, isInLayer, false)));
      childHitTest();
      access$_set_hitDepth__w0yzhj(this, startDepth);
      if ((this.ya6_1 + 1 | 0) === get_lastIndex(this) || _DistanceAndFlags___get_isInExpandedBounds__impl__i93ue8(findBestHitDistance(this))) {
        removeNodeAtDepth(this, this.ya6_1 + 1 | 0);
      }
      return Unit_instance;
    }
    var previousDistance = findBestHitDistance(this);
    var previousHitDepth = this.ya6_1;
    this.ya6_1 = get_lastIndex(this);
    // Inline function 'androidx.compose.ui.node.HitTestResult.hitInMinimumTouchTarget' call
    // Inline function 'androidx.compose.ui.node.HitTestResult.hitInMinimumTouchTarget' call
    var startDepth_0 = access$_get_hitDepth__j82o0r(this);
    access$removeNodesInRange(this, access$_get_hitDepth__j82o0r(this) + 1 | 0, this.n1());
    var _unary__edvuaz_0 = access$_get_hitDepth__j82o0r(this);
    access$_set_hitDepth__w0yzhj(this, _unary__edvuaz_0 + 1 | 0);
    access$_get_values__6cbjvt(this).j1(node);
    access$_get_distanceFromEdgeAndFlags__osnxzz(this).uw(_DistanceAndFlags___get_packedValue__impl__qekawo(access$DistanceAndFlags$tHitTestResultKt(distanceFromEdge, isInLayer, false)));
    childHitTest();
    access$_set_hitDepth__w0yzhj(this, startDepth_0);
    var newBestDistance = findBestHitDistance(this);
    if ((this.ya6_1 + 1 | 0) < get_lastIndex(this) && DistanceAndFlags__compareTo_impl_if9dw2(previousDistance, newBestDistance) > 0) {
      var startIndex = previousHitDepth + 1 | 0;
      var tmp;
      if (_DistanceAndFlags___get_isInExpandedBounds__impl__i93ue8(newBestDistance)) {
        tmp = this.ya6_1 + 2 | 0;
      } else {
        tmp = this.ya6_1 + 1 | 0;
      }
      var endIndex = tmp;
      removeNodesInRange(this, startIndex, endIndex);
    } else {
      removeNodesInRange(this, this.ya6_1 + 1 | 0, this.n1());
    }
    this.ya6_1 = previousHitDepth;
  };
  protoOf(HitTestResult).tb2 = function (element) {
    return !(this.ub2(element) === -1);
  };
  protoOf(HitTestResult).m1 = function (element) {
    if (!(element instanceof Node))
      return false;
    return this.tb2(element instanceof Node ? element : THROW_CCE());
  };
  protoOf(HitTestResult).vb2 = function (elements) {
    // Inline function 'kotlin.collections.forEach' call
    var _iterator__ex2g4s = elements.t();
    while (_iterator__ex2g4s.u()) {
      var element = _iterator__ex2g4s.v();
      if (!this.tb2(element)) {
        return false;
      }
    }
    return true;
  };
  protoOf(HitTestResult).r2 = function (elements) {
    return this.vb2(elements);
  };
  protoOf(HitTestResult).l1 = function (index) {
    var tmp = this.wa6_1.l1(index);
    return tmp instanceof Node ? tmp : THROW_CCE();
  };
  protoOf(HitTestResult).ub2 = function (element) {
    var inductionVariable = 0;
    var last = get_lastIndex(this);
    if (inductionVariable <= last)
      do {
        var i = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        if (equals(this.wa6_1.l1(i), element)) {
          return i;
        }
      }
       while (!(i === last));
    return -1;
  };
  protoOf(HitTestResult).q1 = function (element) {
    if (!(element instanceof Node))
      return -1;
    return this.ub2(element instanceof Node ? element : THROW_CCE());
  };
  protoOf(HitTestResult).r = function () {
    return this.wa6_1.r();
  };
  protoOf(HitTestResult).t = function () {
    return new HitTestResultIterator(this);
  };
  protoOf(HitTestResult).p1 = function (index) {
    return new HitTestResultIterator(this, index);
  };
  protoOf(HitTestResult).t2 = function (fromIndex, toIndex) {
    return new SubList(this, fromIndex, toIndex);
  };
  protoOf(HitTestResult).c3 = function () {
    this.ya6_1 = -1;
    this.wa6_1.c3();
    this.xa6_1.c3();
  };
  function _DistanceAndFlags___init__impl__yrj538(packedValue) {
    return packedValue;
  }
  function _DistanceAndFlags___get_packedValue__impl__qekawo($this) {
    return $this;
  }
  function _DistanceAndFlags___get_distance__impl__av2ooo($this) {
    // Inline function 'androidx.compose.ui.util.unpackFloat1' call
    var value = _DistanceAndFlags___get_packedValue__impl__qekawo($this);
    // Inline function 'androidx.compose.ui.util.floatFromBits' call
    // Inline function 'kotlin.fromBits' call
    var bits = convertToInt(shiftRight(value, 32));
    return floatFromBits(bits);
  }
  function _DistanceAndFlags___get_isInLayer__impl__win4ip($this) {
    return !equalsLong(bitwiseAnd(_DistanceAndFlags___get_packedValue__impl__qekawo($this), new Long(1, 0)), new Long(0, 0));
  }
  function _DistanceAndFlags___get_isInExpandedBounds__impl__i93ue8($this) {
    return !equalsLong(bitwiseAnd(_DistanceAndFlags___get_packedValue__impl__qekawo($this), new Long(2, 0)), new Long(0, 0));
  }
  function DistanceAndFlags__compareTo_impl_if9dw2($this, other) {
    var thisIsInLayer = _DistanceAndFlags___get_isInLayer__impl__win4ip($this);
    var otherIsInLayer = _DistanceAndFlags___get_isInLayer__impl__win4ip(other);
    if (!(thisIsInLayer === otherIsInLayer)) {
      return thisIsInLayer ? -1 : 1;
    }
    // Inline function 'kotlin.math.sign' call
    var x = _DistanceAndFlags___get_distance__impl__av2ooo($this) - _DistanceAndFlags___get_distance__impl__av2ooo(other);
    var tmp$ret$0 = sign(x);
    var distanceDiff = numberToInt(tmp$ret$0);
    var tmp0 = _DistanceAndFlags___get_distance__impl__av2ooo($this);
    // Inline function 'kotlin.math.min' call
    var b = _DistanceAndFlags___get_distance__impl__av2ooo(other);
    if (Math.min(tmp0, b) < 0.0) {
      return distanceDiff;
    }
    if (!(_DistanceAndFlags___get_isInExpandedBounds__impl__i93ue8($this) === _DistanceAndFlags___get_isInExpandedBounds__impl__i93ue8(other))) {
      return _DistanceAndFlags___get_isInExpandedBounds__impl__i93ue8($this) ? -1 : 1;
    }
    return distanceDiff;
  }
  function DistanceAndFlags(distance, isInLayer, isInExpandedBounds) {
    isInExpandedBounds = isInExpandedBounds === VOID ? false : isInExpandedBounds;
    var v1 = fromInt(toRawBits(distance));
    var v2 = isInLayer ? new Long(1, 0) : new Long(0, 0);
    v2 = bitwiseOr(v2, isInExpandedBounds ? new Long(2, 0) : new Long(0, 0));
    return _DistanceAndFlags___init__impl__yrj538(bitwiseOr(shiftLeft(v1, 32), bitwiseAnd(v2, new Long(-1, 0))));
  }
  function access$DistanceAndFlags$tHitTestResultKt(distance, isInLayer, isInExpandedBounds) {
    isInExpandedBounds = isInExpandedBounds === VOID ? false : isInExpandedBounds;
    return DistanceAndFlags(distance, isInLayer, isInExpandedBounds);
  }
  var androidx_compose_ui_node_TailModifierNode$stable;
  var androidx_compose_ui_node_InnerNodeCoordinator$stable;
  function TailModifierNode() {
    Node.call(this);
    this.p8v_1 = 0;
    this.jb1_1 = false;
  }
  protoOf(TailModifierNode).toString = function () {
    return '<tail>';
  };
  protoOf(TailModifierNode).f8w = function () {
    this.jb1_1 = true;
  };
  protoOf(TailModifierNode).h8w = function () {
    this.jb1_1 = false;
  };
  function LookaheadDelegateImpl($outer) {
    this.vb3_1 = $outer;
    LookaheadDelegate.call(this, $outer);
  }
  protoOf(LookaheadDelegateImpl).h8y = function (constraints) {
    // Inline function 'androidx.compose.ui.node.LookaheadDelegate.performingMeasure' call
    this.aap(constraints);
    // Inline function 'androidx.compose.ui.node.LayoutNode.forEachChild' call
    // Inline function 'androidx.compose.runtime.collection.MutableVector.forEach' call
    var this_0 = this.a9i().rb1();
    var i = 0;
    var tmp = this_0.b3e_1;
    var content = isArray(tmp) ? tmp : THROW_CCE();
    var size = this_0.d3e_1;
    while (i < size) {
      var it = content[i];
      ensureNotNull(it.oau()).yau_1 = UsageByParent_NotUsed_getInstance();
      i = i + 1 | 0;
    }
    // Inline function 'kotlin.with' call
    var measureResult = this.a9i().u90_1.mak(this, this.a9i().saw(), constraints);
    access$_set__measureResult__oibadh(this, measureResult);
    return this;
  };
  protoOf(LookaheadDelegateImpl).wb3 = function (alignmentLine) {
    var tmp0_elvis_lhs = this.xb3().yb3().w2(alignmentLine);
    // Inline function 'kotlin.also' call
    var this_0 = tmp0_elvis_lhs == null ? -2147483648 : tmp0_elvis_lhs;
    this.ead_1.oz(alignmentLine, this_0);
    return this_0;
  };
  protoOf(LookaheadDelegateImpl).uad = function () {
    ensureNotNull(this.a9i().oau()).zb3();
  };
  protoOf(LookaheadDelegateImpl).b98 = function (height) {
    return this.a9i().ab4(height);
  };
  protoOf(LookaheadDelegateImpl).d98 = function (width) {
    return this.a9i().bb4(width);
  };
  protoOf(LookaheadDelegateImpl).c98 = function (height) {
    return this.a9i().cb4(height);
  };
  protoOf(LookaheadDelegateImpl).e98 = function (width) {
    return this.a9i().db4(width);
  };
  function onAfterPlaceAt($this) {
    if ($this.eae_1)
      return Unit_instance;
    $this.a9i().nau().zb3();
  }
  function Companion_28() {
    Companion_instance_33 = this;
    var tmp = this;
    // Inline function 'kotlin.also' call
    var this_0 = Paint();
    this_0.f6b(Companion_getInstance_4().n6b_1);
    this_0.e5r(1.0);
    this_0.l6o(Companion_getInstance_12().i6i_1);
    tmp.rb4_1 = this_0;
  }
  var Companion_instance_33;
  function Companion_getInstance_54() {
    if (Companion_instance_33 == null)
      new Companion_28();
    return Companion_instance_33;
  }
  function InnerNodeCoordinator(layoutNode) {
    Companion_getInstance_54();
    NodeCoordinator.call(this, layoutNode);
    this.hb6_1 = new TailModifierNode();
    this.hb6_1.c8w(this);
    this.ib6_1 = !(layoutNode.f90_1 == null) ? new LookaheadDelegateImpl(this) : null;
  }
  protoOf(InnerNodeCoordinator).qb1 = function () {
    return this.hb6_1;
  };
  protoOf(InnerNodeCoordinator).kac = function () {
    return this.ib6_1;
  };
  protoOf(InnerNodeCoordinator).jb6 = function () {
    if (this.ib6_1 == null) {
      this.ib6_1 = new LookaheadDelegateImpl(this);
    }
  };
  protoOf(InnerNodeCoordinator).h8y = function (constraints) {
    var tmp;
    if (this.r94_1) {
      tmp = ensureNotNull(this.ib6_1).hb4();
    } else {
      tmp = constraints;
    }
    var constraints_0 = tmp;
    // Inline function 'androidx.compose.ui.node.NodeCoordinator.performingMeasure' call
    this.aap(constraints_0);
    // Inline function 'androidx.compose.ui.node.LayoutNode.forEachChild' call
    // Inline function 'androidx.compose.runtime.collection.MutableVector.forEach' call
    var this_0 = this.a9i().rb1();
    var i = 0;
    var tmp_0 = this_0.b3e_1;
    var content = isArray(tmp_0) ? tmp_0 : THROW_CCE();
    var size = this_0.d3e_1;
    while (i < size) {
      content[i].nau().kat_1 = UsageByParent_NotUsed_getInstance();
      i = i + 1 | 0;
    }
    // Inline function 'kotlin.with' call
    var tmp$ret$5 = this.a9i().u90_1.mak(this, this.a9i().daw(), constraints_0);
    this.kb6(tmp$ret$5);
    this.lb6();
    return this;
  };
  protoOf(InnerNodeCoordinator).b98 = function (height) {
    return this.a9i().b98(height);
  };
  protoOf(InnerNodeCoordinator).d98 = function (width) {
    return this.a9i().d98(width);
  };
  protoOf(InnerNodeCoordinator).c98 = function (height) {
    return this.a9i().c98(height);
  };
  protoOf(InnerNodeCoordinator).e98 = function (width) {
    return this.a9i().e98(width);
  };
  protoOf(InnerNodeCoordinator).nah = function (position, zIndex, layer) {
    protoOf(NodeCoordinator).nah.call(this, position, zIndex, layer);
    onAfterPlaceAt(this);
  };
  protoOf(InnerNodeCoordinator).lah = function (position, zIndex, layerBlock) {
    protoOf(NodeCoordinator).lah.call(this, position, zIndex, layerBlock);
    onAfterPlaceAt(this);
  };
  protoOf(InnerNodeCoordinator).wb3 = function (alignmentLine) {
    var tmp0_safe_receiver = this.ib6_1;
    var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.wb3(alignmentLine);
    var tmp2_elvis_lhs = tmp1_elvis_lhs == null ? this.xb3().yb3().w2(alignmentLine) : tmp1_elvis_lhs;
    return tmp2_elvis_lhs == null ? -2147483648 : tmp2_elvis_lhs;
  };
  protoOf(InnerNodeCoordinator).mb6 = function (canvas, graphicsLayer) {
    var owner = requireOwner_0(this.a9i());
    // Inline function 'androidx.compose.runtime.collection.MutableVector.forEach' call
    var this_0 = this.a9i().sb1();
    var i = 0;
    var tmp = this_0.b3e_1;
    var content = isArray(tmp) ? tmp : THROW_CCE();
    var size = this_0.d3e_1;
    while (i < size) {
      var child = content[i];
      if (child.b9i()) {
        child.nb6(canvas, graphicsLayer);
      }
      i = i + 1 | 0;
    }
    if (owner.pb6()) {
      this.ob6(canvas, Companion_getInstance_54().rb4_1);
    }
  };
  protoOf(InnerNodeCoordinator).qb6 = function (hitTestSource, pointerPosition, hitTestResult, pointerType, isInLayer) {
    var inLayer = isInLayer;
    var hitTestChildren = false;
    if (hitTestSource.ub6(this.a9i())) {
      if (this.tb6(pointerPosition)) {
        hitTestChildren = true;
      } else {
        var tmp;
        if (pointerType === Companion_getInstance_42().ma2_1) {
          // Inline function 'androidx.compose.ui.util.fastIsFinite' call
          var this_0 = this.sb6(pointerPosition, this.rb6());
          tmp = (toRawBits(this_0) & 2147483647) < 2139095040;
        } else {
          tmp = false;
        }
        if (tmp) {
          inLayer = false;
          hitTestChildren = true;
        }
      }
    }
    if (hitTestChildren) {
      // Inline function 'androidx.compose.ui.node.HitTestResult.siblingHits' call
      var depth = access$_get_hitDepth__j82o0r(hitTestResult);
      var tmp0 = this.a9i().sb1();
      $l$block: {
        // Inline function 'androidx.compose.runtime.collection.MutableVector.reversedAny' call
        var tmp_0 = tmp0.b3e_1;
        var content = isArray(tmp_0) ? tmp_0 : THROW_CCE();
        var i = tmp0.d3e_1 - 1 | 0;
        while (i >= 0) {
          var child = content[i];
          var tmp_1;
          if (child.b9i()) {
            hitTestSource.vb6(child, pointerPosition, hitTestResult, pointerType, inLayer);
            var wasHit = hitTestResult.wb2();
            var continueHitTest;
            if (ComposeUiFlags_instance.c8v_1) {
              continueHitTest = !wasHit || hitTestSource.xb6(hitTestResult, child);
            } else {
              if (!wasHit) {
                continueHitTest = true;
              } else if (child.hak().wb6()) {
                hitTestResult.xb2();
                continueHitTest = true;
              } else {
                continueHitTest = false;
              }
            }
            tmp_1 = !continueHitTest;
          } else {
            tmp_1 = false;
          }
          if (tmp_1) {
            break $l$block;
          }
          i = i - 1 | 0;
        }
      }
      access$_set_hitDepth__w0yzhj(hitTestResult, depth);
    }
  };
  var androidx_compose_ui_node_IntrinsicsPolicy$stable;
  function _set_measurePolicyState__heh75i($this, _set____db54di) {
    var tmp0 = $this.vb7_1;
    var tmp = KMutableProperty1;
    var tmp_0 = IntrinsicsPolicy$_get_measurePolicyState_$ref_unkz9f();
    // Inline function 'androidx.compose.runtime.setValue' call
    getPropertyCallableRef('measurePolicyState', 1, tmp, tmp_0, IntrinsicsPolicy$_set_measurePolicyState_$ref_i4fma1());
    tmp0.s21(_set____db54di);
    return Unit_instance;
  }
  function _get_measurePolicyState__gje3yu($this) {
    var tmp0 = $this.vb7_1;
    var tmp = KMutableProperty1;
    var tmp_0 = IntrinsicsPolicy$_get_measurePolicyState_$ref_unkz9f();
    // Inline function 'androidx.compose.runtime.getValue' call
    getPropertyCallableRef('measurePolicyState', 1, tmp, tmp_0, IntrinsicsPolicy$_set_measurePolicyState_$ref_i4fma1());
    return tmp0.u1();
  }
  function IntrinsicsPolicy$_get_measurePolicyState_$ref_unkz9f() {
    return constructCallableReference(function (p0) {
      return _get_measurePolicyState__gje3yu(p0);
    }, 1, 0, 60);
  }
  function IntrinsicsPolicy$_set_measurePolicyState_$ref_i4fma1() {
    return constructCallableReference(function (p0, p1) {
      _set_measurePolicyState__heh75i(p0, p1);
      return Unit_instance;
    }, 2, 0, 61);
  }
  function IntrinsicsPolicy(layoutNode, policy) {
    this.ub7_1 = layoutNode;
    this.vb7_1 = mutableStateOf(policy);
  }
  protoOf(IntrinsicsPolicy).wb7 = function (measurePolicy) {
    _set_measurePolicyState__heh75i(this, measurePolicy);
  };
  protoOf(IntrinsicsPolicy).b98 = function (height) {
    // Inline function 'kotlin.with' call
    return _get_measurePolicyState__gje3yu(this).nak(this.ub7_1.hak(), this.ub7_1.daw(), height);
  };
  protoOf(IntrinsicsPolicy).d98 = function (width) {
    // Inline function 'kotlin.with' call
    return _get_measurePolicyState__gje3yu(this).oak(this.ub7_1.hak(), this.ub7_1.daw(), width);
  };
  protoOf(IntrinsicsPolicy).c98 = function (height) {
    // Inline function 'kotlin.with' call
    return _get_measurePolicyState__gje3yu(this).pak(this.ub7_1.hak(), this.ub7_1.daw(), height);
  };
  protoOf(IntrinsicsPolicy).e98 = function (width) {
    // Inline function 'kotlin.with' call
    return _get_measurePolicyState__gje3yu(this).qak(this.ub7_1.hak(), this.ub7_1.daw(), width);
  };
  protoOf(IntrinsicsPolicy).ab4 = function (height) {
    // Inline function 'kotlin.with' call
    return _get_measurePolicyState__gje3yu(this).nak(this.ub7_1.hak(), this.ub7_1.saw(), height);
  };
  protoOf(IntrinsicsPolicy).bb4 = function (width) {
    // Inline function 'kotlin.with' call
    return _get_measurePolicyState__gje3yu(this).oak(this.ub7_1.hak(), this.ub7_1.saw(), width);
  };
  protoOf(IntrinsicsPolicy).cb4 = function (height) {
    // Inline function 'kotlin.with' call
    return _get_measurePolicyState__gje3yu(this).pak(this.ub7_1.hak(), this.ub7_1.saw(), height);
  };
  protoOf(IntrinsicsPolicy).db4 = function (width) {
    // Inline function 'kotlin.with' call
    return _get_measurePolicyState__gje3yu(this).qak(this.ub7_1.hak(), this.ub7_1.saw(), width);
  };
  function LayoutAwareModifierNode() {
  }
  var androidx_compose_ui_node_NodeMeasuringIntrinsics$stable;
  function sam$androidx_compose_ui_node_NodeMeasuringIntrinsics_MeasureBlock$0(function_0) {
    this.xb7_1 = function_0;
  }
  protoOf(sam$androidx_compose_ui_node_NodeMeasuringIntrinsics_MeasureBlock$0).g8y = function (_this__u8e3s4, measurable, constraints) {
    return this.xb7_1(_this__u8e3s4, measurable, new Constraints_0(constraints));
  };
  protoOf(sam$androidx_compose_ui_node_NodeMeasuringIntrinsics_MeasureBlock$0).q3 = function () {
    return this.xb7_1;
  };
  protoOf(sam$androidx_compose_ui_node_NodeMeasuringIntrinsics_MeasureBlock$0).equals = function (other) {
    var tmp;
    if (!(other == null) ? isInterface(other, MeasureBlock) : false) {
      var tmp_0;
      if (!(other == null) ? isInterface(other, FunctionAdapter) : false) {
        tmp_0 = equals(this.q3(), other.q3());
      } else {
        tmp_0 = false;
      }
      tmp = tmp_0;
    } else {
      tmp = false;
    }
    return tmp;
  };
  protoOf(sam$androidx_compose_ui_node_NodeMeasuringIntrinsics_MeasureBlock$0).hashCode = function () {
    return hashCode(this.q3());
  };
  function sam$androidx_compose_ui_node_NodeMeasuringIntrinsics_MeasureBlock$0_0(function_0) {
    this.yb7_1 = function_0;
  }
  protoOf(sam$androidx_compose_ui_node_NodeMeasuringIntrinsics_MeasureBlock$0_0).g8y = function (_this__u8e3s4, measurable, constraints) {
    return this.yb7_1(_this__u8e3s4, measurable, new Constraints_0(constraints));
  };
  protoOf(sam$androidx_compose_ui_node_NodeMeasuringIntrinsics_MeasureBlock$0_0).q3 = function () {
    return this.yb7_1;
  };
  protoOf(sam$androidx_compose_ui_node_NodeMeasuringIntrinsics_MeasureBlock$0_0).equals = function (other) {
    var tmp;
    if (!(other == null) ? isInterface(other, MeasureBlock) : false) {
      var tmp_0;
      if (!(other == null) ? isInterface(other, FunctionAdapter) : false) {
        tmp_0 = equals(this.q3(), other.q3());
      } else {
        tmp_0 = false;
      }
      tmp = tmp_0;
    } else {
      tmp = false;
    }
    return tmp;
  };
  protoOf(sam$androidx_compose_ui_node_NodeMeasuringIntrinsics_MeasureBlock$0_0).hashCode = function () {
    return hashCode(this.q3());
  };
  function sam$androidx_compose_ui_node_NodeMeasuringIntrinsics_MeasureBlock$0_1(function_0) {
    this.zb7_1 = function_0;
  }
  protoOf(sam$androidx_compose_ui_node_NodeMeasuringIntrinsics_MeasureBlock$0_1).g8y = function (_this__u8e3s4, measurable, constraints) {
    return this.zb7_1(_this__u8e3s4, measurable, new Constraints_0(constraints));
  };
  protoOf(sam$androidx_compose_ui_node_NodeMeasuringIntrinsics_MeasureBlock$0_1).q3 = function () {
    return this.zb7_1;
  };
  protoOf(sam$androidx_compose_ui_node_NodeMeasuringIntrinsics_MeasureBlock$0_1).equals = function (other) {
    var tmp;
    if (!(other == null) ? isInterface(other, MeasureBlock) : false) {
      var tmp_0;
      if (!(other == null) ? isInterface(other, FunctionAdapter) : false) {
        tmp_0 = equals(this.q3(), other.q3());
      } else {
        tmp_0 = false;
      }
      tmp = tmp_0;
    } else {
      tmp = false;
    }
    return tmp;
  };
  protoOf(sam$androidx_compose_ui_node_NodeMeasuringIntrinsics_MeasureBlock$0_1).hashCode = function () {
    return hashCode(this.q3());
  };
  function sam$androidx_compose_ui_node_NodeMeasuringIntrinsics_MeasureBlock$0_2(function_0) {
    this.ab8_1 = function_0;
  }
  protoOf(sam$androidx_compose_ui_node_NodeMeasuringIntrinsics_MeasureBlock$0_2).g8y = function (_this__u8e3s4, measurable, constraints) {
    return this.ab8_1(_this__u8e3s4, measurable, new Constraints_0(constraints));
  };
  protoOf(sam$androidx_compose_ui_node_NodeMeasuringIntrinsics_MeasureBlock$0_2).q3 = function () {
    return this.ab8_1;
  };
  protoOf(sam$androidx_compose_ui_node_NodeMeasuringIntrinsics_MeasureBlock$0_2).equals = function (other) {
    var tmp;
    if (!(other == null) ? isInterface(other, MeasureBlock) : false) {
      var tmp_0;
      if (!(other == null) ? isInterface(other, FunctionAdapter) : false) {
        tmp_0 = equals(this.q3(), other.q3());
      } else {
        tmp_0 = false;
      }
      tmp = tmp_0;
    } else {
      tmp = false;
    }
    return tmp;
  };
  protoOf(sam$androidx_compose_ui_node_NodeMeasuringIntrinsics_MeasureBlock$0_2).hashCode = function () {
    return hashCode(this.q3());
  };
  function LayoutModifierNode$minIntrinsicWidth$lambda(this$0) {
    return function ($this$minWidth, intrinsicMeasurable, constraints) {
      return this$0.g8y($this$minWidth, intrinsicMeasurable, constraints.m5e_1);
    };
  }
  function LayoutModifierNode$minIntrinsicHeight$lambda(this$0) {
    return function ($this$minHeight, intrinsicMeasurable, constraints) {
      return this$0.g8y($this$minHeight, intrinsicMeasurable, constraints.m5e_1);
    };
  }
  function LayoutModifierNode$maxIntrinsicWidth$lambda(this$0) {
    return function ($this$maxWidth, intrinsicMeasurable, constraints) {
      return this$0.g8y($this$maxWidth, intrinsicMeasurable, constraints.m5e_1);
    };
  }
  function LayoutModifierNode$maxIntrinsicHeight$lambda(this$0) {
    return function ($this$maxHeight, intrinsicMeasurable, constraints) {
      return this$0.g8y($this$maxHeight, intrinsicMeasurable, constraints.m5e_1);
    };
  }
  function LayoutModifierNode() {
  }
  function invalidatePlacement(_this__u8e3s4) {
    return requireLayoutNode(_this__u8e3s4).fb8();
  }
  function invalidateMeasurement(_this__u8e3s4) {
    return requireLayoutNode(_this__u8e3s4).bb0();
  }
  function invalidateLayer(_this__u8e3s4) {
    // Inline function 'androidx.compose.ui.node.Nodes.Layout' call
    var tmp$ret$0 = _NodeKind___init__impl__ojsprp(2);
    return requireCoordinator(_this__u8e3s4, tmp$ret$0).lb2();
  }
  function updateLayerBlock(_this__u8e3s4, layerBlock) {
    if (!_this__u8e3s4.f4n().z8v_1)
      return Unit_instance;
    // Inline function 'androidx.compose.ui.node.Nodes.Layout' call
    var tmp$ret$0 = _NodeKind___init__impl__ojsprp(2);
    var tmp0_safe_receiver = requireCoordinator(_this__u8e3s4, tmp$ret$0).s94_1;
    if (tmp0_safe_receiver == null)
      null;
    else {
      tmp0_safe_receiver.hb7(layerBlock, true);
    }
  }
  var IntrinsicMinMax_Min_instance_1;
  var IntrinsicMinMax_Max_instance_1;
  var IntrinsicMinMax_entriesInitialized_1;
  function IntrinsicMinMax_initEntries_1() {
    if (IntrinsicMinMax_entriesInitialized_1)
      return Unit_instance;
    IntrinsicMinMax_entriesInitialized_1 = true;
    IntrinsicMinMax_Min_instance_1 = new IntrinsicMinMax_1('Min', 0);
    IntrinsicMinMax_Max_instance_1 = new IntrinsicMinMax_1('Max', 1);
  }
  var IntrinsicWidthHeight_Width_instance_1;
  var IntrinsicWidthHeight_Height_instance_1;
  var IntrinsicWidthHeight_entriesInitialized_1;
  function IntrinsicWidthHeight_initEntries_1() {
    if (IntrinsicWidthHeight_entriesInitialized_1)
      return Unit_instance;
    IntrinsicWidthHeight_entriesInitialized_1 = true;
    IntrinsicWidthHeight_Width_instance_1 = new IntrinsicWidthHeight_1('Width', 0);
    IntrinsicWidthHeight_Height_instance_1 = new IntrinsicWidthHeight_1('Height', 1);
  }
  function MeasureBlock() {
  }
  function ApproachMeasureBlock() {
  }
  function DefaultIntrinsicMeasurable_1(measurable, minMax, widthHeight) {
    this.gb8_1 = measurable;
    this.hb8_1 = minMax;
    this.ib8_1 = widthHeight;
  }
  protoOf(DefaultIntrinsicMeasurable_1).xag = function () {
    return this.gb8_1.xag();
  };
  protoOf(DefaultIntrinsicMeasurable_1).h8y = function (constraints) {
    if (this.ib8_1.equals(IntrinsicWidthHeight_Width_getInstance_1())) {
      var tmp;
      if (this.hb8_1.equals(IntrinsicMinMax_Max_getInstance_1())) {
        tmp = this.gb8_1.c98(_Constraints___get_maxHeight__impl__dt3e8z(constraints));
      } else {
        tmp = this.gb8_1.b98(_Constraints___get_maxHeight__impl__dt3e8z(constraints));
      }
      var width = tmp;
      var height = _Constraints___get_hasBoundedHeight__impl__bsh4rw(constraints) ? _Constraints___get_maxHeight__impl__dt3e8z(constraints) : 32767;
      return new EmptyPlaceable_0(width, height);
    }
    var tmp_0;
    if (this.hb8_1.equals(IntrinsicMinMax_Max_getInstance_1())) {
      tmp_0 = this.gb8_1.e98(_Constraints___get_maxWidth__impl__uuyqc(constraints));
    } else {
      tmp_0 = this.gb8_1.d98(_Constraints___get_maxWidth__impl__uuyqc(constraints));
    }
    var height_0 = tmp_0;
    var width_0 = _Constraints___get_hasBoundedWidth__impl__7hd0wr(constraints) ? _Constraints___get_maxWidth__impl__uuyqc(constraints) : 32767;
    return new EmptyPlaceable_0(width_0, height_0);
  };
  protoOf(DefaultIntrinsicMeasurable_1).b98 = function (height) {
    return this.gb8_1.b98(height);
  };
  protoOf(DefaultIntrinsicMeasurable_1).c98 = function (height) {
    return this.gb8_1.c98(height);
  };
  protoOf(DefaultIntrinsicMeasurable_1).d98 = function (width) {
    return this.gb8_1.d98(width);
  };
  protoOf(DefaultIntrinsicMeasurable_1).e98 = function (width) {
    return this.gb8_1.e98(width);
  };
  function EmptyPlaceable_0(width, height) {
    Placeable.call(this);
    // Inline function 'androidx.compose.ui.unit.IntSize' call
    // Inline function 'androidx.compose.ui.util.packInts' call
    var tmp$ret$1 = bitwiseOr(shiftLeft(fromInt(width), 32), bitwiseAnd(fromInt(height), new Long(-1, 0)));
    var tmp$ret$0 = _IntSize___init__impl__emcjft(tmp$ret$1);
    this.eah(tmp$ret$0);
  }
  protoOf(EmptyPlaceable_0).kah = function (alignmentLine) {
    return -2147483648;
  };
  protoOf(EmptyPlaceable_0).lah = function (position, zIndex, layerBlock) {
  };
  function IntrinsicMinMax_1(name, ordinal) {
    Enum.call(this, name, ordinal);
  }
  function IntrinsicWidthHeight_1(name, ordinal) {
    Enum.call(this, name, ordinal);
  }
  function IntrinsicMinMax_Min_getInstance_1() {
    IntrinsicMinMax_initEntries_1();
    return IntrinsicMinMax_Min_instance_1;
  }
  function IntrinsicMinMax_Max_getInstance_1() {
    IntrinsicMinMax_initEntries_1();
    return IntrinsicMinMax_Max_instance_1;
  }
  function IntrinsicWidthHeight_Width_getInstance_1() {
    IntrinsicWidthHeight_initEntries_1();
    return IntrinsicWidthHeight_Width_instance_1;
  }
  function IntrinsicWidthHeight_Height_getInstance_1() {
    IntrinsicWidthHeight_initEntries_1();
    return IntrinsicWidthHeight_Height_instance_1;
  }
  function NodeMeasuringIntrinsics() {
  }
  protoOf(NodeMeasuringIntrinsics).jac = function (measureBlock, intrinsicMeasureScope, intrinsicMeasurable, h) {
    var measurable = new DefaultIntrinsicMeasurable_1(intrinsicMeasurable, IntrinsicMinMax_Min_getInstance_1(), IntrinsicWidthHeight_Width_getInstance_1());
    var constraints = Constraints(VOID, VOID, VOID, h);
    // Inline function 'kotlin.with' call
    var layoutResult = measureBlock.bac(new ApproachIntrinsicsMeasureScope(intrinsicMeasureScope, intrinsicMeasureScope.r6p()), measurable, constraints);
    return layoutResult.h5e();
  };
  protoOf(NodeMeasuringIntrinsics).had = function (measureBlock, intrinsicMeasureScope, intrinsicMeasurable, w) {
    var measurable = new DefaultIntrinsicMeasurable_1(intrinsicMeasurable, IntrinsicMinMax_Min_getInstance_1(), IntrinsicWidthHeight_Height_getInstance_1());
    var constraints = Constraints(VOID, w);
    // Inline function 'kotlin.with' call
    var layoutResult = measureBlock.bac(new ApproachIntrinsicsMeasureScope(intrinsicMeasureScope, intrinsicMeasureScope.r6p()), measurable, constraints);
    return layoutResult.i5e();
  };
  protoOf(NodeMeasuringIntrinsics).jad = function (measureBlock, intrinsicMeasureScope, intrinsicMeasurable, h) {
    var measurable = new DefaultIntrinsicMeasurable_1(intrinsicMeasurable, IntrinsicMinMax_Max_getInstance_1(), IntrinsicWidthHeight_Width_getInstance_1());
    var constraints = Constraints(VOID, VOID, VOID, h);
    // Inline function 'kotlin.with' call
    var layoutResult = measureBlock.bac(new ApproachIntrinsicsMeasureScope(intrinsicMeasureScope, intrinsicMeasureScope.r6p()), measurable, constraints);
    return layoutResult.h5e();
  };
  protoOf(NodeMeasuringIntrinsics).lad = function (measureBlock, intrinsicMeasureScope, intrinsicMeasurable, w) {
    var measurable = new DefaultIntrinsicMeasurable_1(intrinsicMeasurable, IntrinsicMinMax_Max_getInstance_1(), IntrinsicWidthHeight_Height_getInstance_1());
    var constraints = Constraints(VOID, w);
    // Inline function 'kotlin.with' call
    var layoutResult = measureBlock.bac(new ApproachIntrinsicsMeasureScope(intrinsicMeasureScope, intrinsicMeasureScope.r6p()), measurable, constraints);
    return layoutResult.i5e();
  };
  protoOf(NodeMeasuringIntrinsics).bb8 = function (measureBlock, intrinsicMeasureScope, intrinsicMeasurable, h) {
    var measurable = new DefaultIntrinsicMeasurable_1(intrinsicMeasurable, IntrinsicMinMax_Min_getInstance_1(), IntrinsicWidthHeight_Width_getInstance_1());
    var constraints = Constraints(VOID, VOID, VOID, h);
    // Inline function 'kotlin.with' call
    var layoutResult = measureBlock.g8y(new IntrinsicsMeasureScope(intrinsicMeasureScope, intrinsicMeasureScope.r6p()), measurable, constraints);
    return layoutResult.h5e();
  };
  protoOf(NodeMeasuringIntrinsics).cb8 = function (measureBlock, intrinsicMeasureScope, intrinsicMeasurable, w) {
    var measurable = new DefaultIntrinsicMeasurable_1(intrinsicMeasurable, IntrinsicMinMax_Min_getInstance_1(), IntrinsicWidthHeight_Height_getInstance_1());
    var constraints = Constraints(VOID, w);
    // Inline function 'kotlin.with' call
    var layoutResult = measureBlock.g8y(new IntrinsicsMeasureScope(intrinsicMeasureScope, intrinsicMeasureScope.r6p()), measurable, constraints);
    return layoutResult.i5e();
  };
  protoOf(NodeMeasuringIntrinsics).db8 = function (measureBlock, intrinsicMeasureScope, intrinsicMeasurable, h) {
    var measurable = new DefaultIntrinsicMeasurable_1(intrinsicMeasurable, IntrinsicMinMax_Max_getInstance_1(), IntrinsicWidthHeight_Width_getInstance_1());
    var constraints = Constraints(VOID, VOID, VOID, h);
    // Inline function 'kotlin.with' call
    var layoutResult = measureBlock.g8y(new IntrinsicsMeasureScope(intrinsicMeasureScope, intrinsicMeasureScope.r6p()), measurable, constraints);
    return layoutResult.h5e();
  };
  protoOf(NodeMeasuringIntrinsics).eb8 = function (measureBlock, intrinsicMeasureScope, intrinsicMeasurable, w) {
    var measurable = new DefaultIntrinsicMeasurable_1(intrinsicMeasurable, IntrinsicMinMax_Max_getInstance_1(), IntrinsicWidthHeight_Height_getInstance_1());
    var constraints = Constraints(VOID, w);
    // Inline function 'kotlin.with' call
    var layoutResult = measureBlock.g8y(new IntrinsicsMeasureScope(intrinsicMeasureScope, intrinsicMeasureScope.r6p()), measurable, constraints);
    return layoutResult.i5e();
  };
  var NodeMeasuringIntrinsics_instance;
  function NodeMeasuringIntrinsics_getInstance() {
    return NodeMeasuringIntrinsics_instance;
  }
  function remeasureSync(_this__u8e3s4) {
    return requireLayoutNode(_this__u8e3s4).ob8();
  }
  function requestRemeasure(_this__u8e3s4) {
    return requireLayoutNode(_this__u8e3s4).wav();
  }
  var androidx_compose_ui_node_LayoutModifierNodeCoordinator$stable;
  function LookaheadDelegateForLayoutModifierNode($outer) {
    this.jb9_1 = $outer;
    LookaheadDelegate.call(this, $outer);
  }
  protoOf(LookaheadDelegateForLayoutModifierNode).h8y = function (constraints) {
    // Inline function 'androidx.compose.ui.node.LookaheadDelegate.performingMeasure' call
    this.aap(constraints);
    this.jb9_1.dag_1 = constraints;
    // Inline function 'kotlin.with' call
    var tmp$ret$1 = this.jb9_1.cag_1.g8y(this, ensureNotNull(this.jb9_1.kb9().kac()), constraints);
    access$_set__measureResult__oibadh(this, tmp$ret$1);
    return this;
  };
  protoOf(LookaheadDelegateForLayoutModifierNode).wb3 = function (alignmentLine) {
    // Inline function 'kotlin.also' call
    var this_0 = calculateAlignmentAndPlaceChildAsNeeded(this, alignmentLine);
    this.ead_1.oz(alignmentLine, this_0);
    return this_0;
  };
  protoOf(LookaheadDelegateForLayoutModifierNode).b98 = function (height) {
    // Inline function 'kotlin.with' call
    return this.jb9_1.cag_1.o8y(this, ensureNotNull(this.jb9_1.kb9().kac()), height);
  };
  protoOf(LookaheadDelegateForLayoutModifierNode).c98 = function (height) {
    // Inline function 'kotlin.with' call
    return this.jb9_1.cag_1.q8y(this, ensureNotNull(this.jb9_1.kb9().kac()), height);
  };
  protoOf(LookaheadDelegateForLayoutModifierNode).d98 = function (width) {
    // Inline function 'kotlin.with' call
    return this.jb9_1.cag_1.p8y(this, ensureNotNull(this.jb9_1.kb9().kac()), width);
  };
  protoOf(LookaheadDelegateForLayoutModifierNode).e98 = function (width) {
    // Inline function 'kotlin.with' call
    return this.jb9_1.cag_1.r8y(this, ensureNotNull(this.jb9_1.kb9().kac()), width);
  };
  function onAfterPlaceAt_0($this) {
    if ($this.eae_1)
      return Unit_instance;
    $this.gb7();
    var wrapped = $this.kb9();
    var tmp0_safe_receiver = $this.fag_1;
    if (tmp0_safe_receiver == null)
      null;
    else {
      // Inline function 'kotlin.let' call
      // Inline function 'kotlin.with' call
      var $this$with = tmp0_safe_receiver.kae_1;
      // Inline function 'kotlin.with' call
      var $this$with_0 = $this.gae_1;
      var tmp;
      var tmp_0;
      if (!$this$with.hac($this$with_0, ensureNotNull($this.eag_1).cad_1) && !tmp0_safe_receiver.lae_1) {
        var tmp_1 = $this.q95();
        var tmp0_safe_receiver_0 = $this.eag_1;
        var tmp_2 = tmp0_safe_receiver_0 == null ? null : tmp0_safe_receiver_0.gb4();
        tmp_0 = equals(new IntSize(tmp_1), tmp_2 == null ? null : new IntSize(tmp_2));
      } else {
        tmp_0 = false;
      }
      if (tmp_0) {
        var tmp_3 = wrapped.q95();
        var tmp1_safe_receiver = wrapped.kac();
        var tmp_4 = tmp1_safe_receiver == null ? null : tmp1_safe_receiver.gb4();
        tmp = equals(new IntSize(tmp_3), tmp_4 == null ? null : new IntSize(tmp_4));
      } else {
        tmp = false;
      }
      var approachComplete = tmp;
      wrapped.q94_1 = approachComplete;
    }
    wrapped.fae_1 = $this.fae_1;
    $this.gag().uad();
    wrapped.fae_1 = false;
    wrapped.q94_1 = false;
  }
  function Companion_29() {
    Companion_instance_34 = this;
    var tmp = this;
    // Inline function 'kotlin.also' call
    var this_0 = Paint();
    this_0.f6b(Companion_getInstance_4().p6b_1);
    this_0.e5r(1.0);
    this_0.l6o(Companion_getInstance_12().i6i_1);
    tmp.lb9_1 = this_0;
  }
  var Companion_instance_34;
  function Companion_getInstance_55() {
    if (Companion_instance_34 == null)
      new Companion_29();
    return Companion_instance_34;
  }
  function LayoutModifierNodeCoordinator$measure$1(this$0, $result) {
    this.mb9_1 = $result;
    this.nb9_1 = ensureNotNull(this$0.eag_1).i8y_1;
    this.ob9_1 = ensureNotNull(this$0.eag_1).j8y_1;
  }
  protoOf(LayoutModifierNodeCoordinator$measure$1).h5e = function () {
    return this.nb9_1;
  };
  protoOf(LayoutModifierNodeCoordinator$measure$1).i5e = function () {
    return this.ob9_1;
  };
  protoOf(LayoutModifierNodeCoordinator$measure$1).sad = function () {
    return this.mb9_1.sad();
  };
  protoOf(LayoutModifierNodeCoordinator$measure$1).tad = function () {
    return this.mb9_1.tad();
  };
  protoOf(LayoutModifierNodeCoordinator$measure$1).uad = function () {
    this.mb9_1.uad();
  };
  function LayoutModifierNodeCoordinator(layoutNode, measureNode) {
    Companion_getInstance_55();
    NodeCoordinator.call(this, layoutNode);
    this.cag_1 = measureNode;
    this.dag_1 = null;
    this.eag_1 = !(layoutNode.f90_1 == null) ? new LookaheadDelegateForLayoutModifierNode(this) : null;
    var tmp = this;
    var tmp_0;
    var tmp0 = measureNode.f4n();
    // Inline function 'androidx.compose.ui.node.Nodes.ApproachMeasure' call
    // Inline function 'androidx.compose.ui.Node.isKind' call
    var kind = _NodeKind___init__impl__ojsprp(512);
    if (!((tmp0.o8v_1 & _NodeKind___get_mask__impl__1uopb6(kind)) === 0)) {
      tmp_0 = new ApproachMeasureScopeImpl(this, isInterface(measureNode, ApproachLayoutModifierNode) ? measureNode : THROW_CCE());
    } else {
      tmp_0 = null;
    }
    tmp.fag_1 = tmp_0;
  }
  protoOf(LayoutModifierNodeCoordinator).zaz = function (value) {
    if (!equals(value, this.cag_1)) {
      var tmp0 = value.f4n();
      // Inline function 'androidx.compose.ui.node.Nodes.ApproachMeasure' call
      // Inline function 'androidx.compose.ui.Node.isKind' call
      var kind = _NodeKind___init__impl__ojsprp(512);
      if (!((tmp0.o8v_1 & _NodeKind___get_mask__impl__1uopb6(kind)) === 0)) {
        if (!isInterface(value, ApproachLayoutModifierNode))
          THROW_CCE();
        var tmp = this;
        var tmp0_safe_receiver = this.fag_1;
        var tmp_0;
        if (tmp0_safe_receiver == null) {
          tmp_0 = null;
        } else {
          // Inline function 'kotlin.also' call
          tmp0_safe_receiver.kae_1 = value;
          tmp_0 = tmp0_safe_receiver;
        }
        var tmp1_elvis_lhs = tmp_0;
        tmp.fag_1 = tmp1_elvis_lhs == null ? new ApproachMeasureScopeImpl(this, value) : tmp1_elvis_lhs;
      } else {
        this.fag_1 = null;
      }
    }
    this.cag_1 = value;
  };
  protoOf(LayoutModifierNodeCoordinator).qb1 = function () {
    return this.cag_1.f4n();
  };
  protoOf(LayoutModifierNodeCoordinator).kb9 = function () {
    return ensureNotNull(this.s94_1);
  };
  protoOf(LayoutModifierNodeCoordinator).kac = function () {
    return this.eag_1;
  };
  protoOf(LayoutModifierNodeCoordinator).jb6 = function () {
    if (this.eag_1 == null) {
      this.eag_1 = new LookaheadDelegateForLayoutModifierNode(this);
    }
  };
  protoOf(LayoutModifierNodeCoordinator).h8y = function (constraints) {
    var tmp;
    if (this.r94_1) {
      var tmp_0 = this.dag_1;
      var tmp0 = tmp_0 == null ? null : new Constraints_0(tmp_0);
      var tmp$ret$0;
      $l$block: {
        // Inline function 'kotlin.requireNotNull' call
        if (tmp0 == null) {
          var message = 'Lookahead constraints cannot be null in approach pass.';
          throw IllegalArgumentException_init_$Create$(toString(message));
        } else {
          tmp$ret$0 = tmp0.m5e_1;
          break $l$block;
        }
      }
      tmp = tmp$ret$0;
    } else {
      tmp = constraints;
    }
    var constraints_0 = tmp;
    // Inline function 'androidx.compose.ui.node.NodeCoordinator.performingMeasure' call
    this.aap(constraints_0);
    var tmp0_safe_receiver = this.fag_1;
    var tmp_1;
    if (tmp0_safe_receiver == null) {
      tmp_1 = null;
    } else {
      // Inline function 'kotlin.let' call
      // Inline function 'kotlin.with' call
      var $this$with = tmp0_safe_receiver.kae_1;
      var tmp_2 = tmp0_safe_receiver;
      var tmp_3;
      if ($this$with.gac(tmp0_safe_receiver.mae())) {
        tmp_3 = true;
      } else {
        var tmp_4 = this.dag_1;
        tmp_3 = !equals(new Constraints_0(constraints_0), tmp_4 == null ? null : new Constraints_0(tmp_4));
      }
      tmp_2.lae_1 = tmp_3;
      if (!tmp0_safe_receiver.lae_1) {
        this.kb9().r94_1 = true;
      }
      var result = $this$with.fac(tmp0_safe_receiver, this.kb9(), constraints_0);
      this.kb9().r94_1 = false;
      var reachedLookaheadSize = result.h5e() === ensureNotNull(this.eag_1).i8y_1 && result.i5e() === ensureNotNull(this.eag_1).j8y_1;
      var tmp_5;
      var tmp_6;
      var tmp_7;
      if (!tmp0_safe_receiver.lae_1) {
        var tmp_8 = this.kb9().q95();
        var tmp0_safe_receiver_0 = this.kb9().kac();
        var tmp_9 = tmp0_safe_receiver_0 == null ? null : tmp0_safe_receiver_0.gb4();
        tmp_7 = equals(new IntSize(tmp_8), tmp_9 == null ? null : new IntSize(tmp_9));
      } else {
        tmp_7 = false;
      }
      if (tmp_7) {
        tmp_6 = !reachedLookaheadSize;
      } else {
        tmp_6 = false;
      }
      if (tmp_6) {
        tmp_5 = new LayoutModifierNodeCoordinator$measure$1(this, result);
      } else {
        tmp_5 = result;
      }
      tmp_1 = tmp_5;
    }
    var tmp1_elvis_lhs = tmp_1;
    var tmp_10;
    if (tmp1_elvis_lhs == null) {
      // Inline function 'kotlin.with' call
      tmp_10 = this.cag_1.g8y(this, this.kb9(), constraints_0);
    } else {
      tmp_10 = tmp1_elvis_lhs;
    }
    this.kb6(tmp_10);
    this.lb6();
    return this;
  };
  protoOf(LayoutModifierNodeCoordinator).b98 = function (height) {
    var tmp0_safe_receiver = this.fag_1;
    var tmp;
    if (tmp0_safe_receiver == null) {
      tmp = null;
    } else {
      // Inline function 'kotlin.run' call
      // Inline function 'kotlin.with' call
      tmp = tmp0_safe_receiver.kae_1.iac(tmp0_safe_receiver, this.kb9(), height);
    }
    var tmp1_elvis_lhs = tmp;
    var tmp_0;
    if (tmp1_elvis_lhs == null) {
      // Inline function 'kotlin.with' call
      tmp_0 = this.cag_1.o8y(this, this.kb9(), height);
    } else {
      tmp_0 = tmp1_elvis_lhs;
    }
    return tmp_0;
  };
  protoOf(LayoutModifierNodeCoordinator).c98 = function (height) {
    var tmp0_safe_receiver = this.fag_1;
    var tmp;
    if (tmp0_safe_receiver == null) {
      tmp = null;
    } else {
      // Inline function 'kotlin.run' call
      // Inline function 'kotlin.with' call
      tmp = tmp0_safe_receiver.kae_1.iad(tmp0_safe_receiver, this.kb9(), height);
    }
    var tmp1_elvis_lhs = tmp;
    var tmp_0;
    if (tmp1_elvis_lhs == null) {
      // Inline function 'kotlin.with' call
      tmp_0 = this.cag_1.q8y(this, this.kb9(), height);
    } else {
      tmp_0 = tmp1_elvis_lhs;
    }
    return tmp_0;
  };
  protoOf(LayoutModifierNodeCoordinator).d98 = function (width) {
    var tmp0_safe_receiver = this.fag_1;
    var tmp;
    if (tmp0_safe_receiver == null) {
      tmp = null;
    } else {
      // Inline function 'kotlin.run' call
      // Inline function 'kotlin.with' call
      tmp = tmp0_safe_receiver.kae_1.gad(tmp0_safe_receiver, this.kb9(), width);
    }
    var tmp1_elvis_lhs = tmp;
    var tmp_0;
    if (tmp1_elvis_lhs == null) {
      // Inline function 'kotlin.with' call
      tmp_0 = this.cag_1.p8y(this, this.kb9(), width);
    } else {
      tmp_0 = tmp1_elvis_lhs;
    }
    return tmp_0;
  };
  protoOf(LayoutModifierNodeCoordinator).e98 = function (width) {
    var tmp0_safe_receiver = this.fag_1;
    var tmp;
    if (tmp0_safe_receiver == null) {
      tmp = null;
    } else {
      // Inline function 'kotlin.run' call
      // Inline function 'kotlin.with' call
      tmp = tmp0_safe_receiver.kae_1.kad(tmp0_safe_receiver, this.kb9(), width);
    }
    var tmp1_elvis_lhs = tmp;
    var tmp_0;
    if (tmp1_elvis_lhs == null) {
      // Inline function 'kotlin.with' call
      tmp_0 = this.cag_1.r8y(this, this.kb9(), width);
    } else {
      tmp_0 = tmp1_elvis_lhs;
    }
    return tmp_0;
  };
  protoOf(LayoutModifierNodeCoordinator).nah = function (position, zIndex, layer) {
    protoOf(NodeCoordinator).nah.call(this, position, zIndex, layer);
    onAfterPlaceAt_0(this);
  };
  protoOf(LayoutModifierNodeCoordinator).lah = function (position, zIndex, layerBlock) {
    protoOf(NodeCoordinator).lah.call(this, position, zIndex, layerBlock);
    onAfterPlaceAt_0(this);
  };
  protoOf(LayoutModifierNodeCoordinator).wb3 = function (alignmentLine) {
    var tmp0_safe_receiver = this.eag_1;
    var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.ib4(alignmentLine);
    return tmp1_elvis_lhs == null ? calculateAlignmentAndPlaceChildAsNeeded(this, alignmentLine) : tmp1_elvis_lhs;
  };
  protoOf(LayoutModifierNodeCoordinator).mb6 = function (canvas, graphicsLayer) {
    this.kb9().fb7(canvas, graphicsLayer);
    if (requireOwner_0(this.a9i()).pb6()) {
      var wrapped = this.s94_1;
      if (!(wrapped == null) && (!equals(this.q95(), wrapped.q95()) || !equals(wrapped.iak(), Companion_getInstance_11().c5g_1))) {
        this.ob6(canvas, Companion_getInstance_55().lb9_1);
      }
    }
  };
  function calculateAlignmentAndPlaceChildAsNeeded(_this__u8e3s4, alignmentLine) {
    var child = _this__u8e3s4.eb4();
    // Inline function 'androidx.compose.ui.internal.checkPrecondition' call
    if (!!(child == null)) {
      var tmp$ret$1 = 'Child of ' + toString(_this__u8e3s4) + ' cannot be null when calculating alignment line';
      throwIllegalStateException(tmp$ret$1);
    }
    if (_this__u8e3s4.gag().sad().u2(alignmentLine)) {
      var tmp0_elvis_lhs = _this__u8e3s4.gag().sad().w2(alignmentLine);
      return tmp0_elvis_lhs == null ? -2147483648 : tmp0_elvis_lhs;
    }
    var positionInWrapped = child.kah(alignmentLine);
    if (positionInWrapped === -2147483648) {
      return -2147483648;
    }
    child.eae_1 = true;
    _this__u8e3s4.fae_1 = true;
    _this__u8e3s4.jb4();
    child.eae_1 = false;
    _this__u8e3s4.fae_1 = false;
    var tmp;
    if (alignmentLine instanceof HorizontalAlignmentLine) {
      tmp = positionInWrapped + _IntOffset___get_y__impl__2avpwj(child.iak()) | 0;
    } else {
      tmp = positionInWrapped + _IntOffset___get_x__impl__qiqr5o(child.iak()) | 0;
    }
    return tmp;
  }
  function get_DefaultDensity() {
    _init_properties_LayoutNode_kt__2d4f1o();
    return DefaultDensity;
  }
  var DefaultDensity;
  var androidx_compose_ui_node_LayoutNode_NoIntrinsicsMeasurePolicy$stable;
  var androidx_compose_ui_node_LayoutNode$stable;
  function sam$kotlin_Comparator$0(function_0) {
    this.pb9_1 = function_0;
  }
  protoOf(sam$kotlin_Comparator$0).ze = function (a, b) {
    return this.pb9_1(a, b);
  };
  protoOf(sam$kotlin_Comparator$0).compare = function (a, b) {
    return this.ze(a, b);
  };
  protoOf(sam$kotlin_Comparator$0).q3 = function () {
    return this.pb9_1;
  };
  protoOf(sam$kotlin_Comparator$0).equals = function (other) {
    var tmp;
    if (!(other == null) ? isInterface(other, Comparator) : false) {
      var tmp_0;
      if (!(other == null) ? isInterface(other, FunctionAdapter) : false) {
        tmp_0 = equals(this.q3(), other.q3());
      } else {
        tmp_0 = false;
      }
      tmp = tmp_0;
    } else {
      tmp = false;
    }
    return tmp;
  };
  protoOf(sam$kotlin_Comparator$0).hashCode = function () {
    return hashCode(this.q3());
  };
  function LayoutNode$Companion$ErrorMeasurePolicy$1() {
    NoIntrinsicsMeasurePolicy.call(this, 'Undefined intrinsics block and it is required');
  }
  protoOf(LayoutNode$Companion$ErrorMeasurePolicy$1).mak = function (_this__u8e3s4, measurables, constraints) {
    // Inline function 'kotlin.error' call
    var message = 'Undefined measure and it is required';
    throw IllegalStateException_init_$Create$(toString(message));
  };
  function LayoutNode$Companion$Constructor$lambda() {
    return new LayoutNode();
  }
  function LayoutNode$Companion$DummyViewConfiguration$1() {
  }
  protoOf(LayoutNode$Companion$DummyViewConfiguration$1).rb9 = function () {
    return new Long(400, 0);
  };
  protoOf(LayoutNode$Companion$DummyViewConfiguration$1).sb9 = function () {
    return new Long(300, 0);
  };
  protoOf(LayoutNode$Companion$DummyViewConfiguration$1).tb9 = function () {
    return new Long(40, 0);
  };
  protoOf(LayoutNode$Companion$DummyViewConfiguration$1).ub9 = function () {
    return 16.0;
  };
  protoOf(LayoutNode$Companion$DummyViewConfiguration$1).eab = function () {
    return Companion_getInstance_13().h5f_1;
  };
  function LayoutNode$Companion$ZComparator$lambda(node1, node2) {
    var tmp;
    if (_get_zIndex__hypqqb(node1) === _get_zIndex__hypqqb(node2)) {
      tmp = compareTo(node1.d9i(), node2.d9i());
    } else {
      tmp = compareTo(_get_zIndex__hypqqb(node1), _get_zIndex__hypqqb(node2));
    }
    return tmp;
  }
  var LayoutState_Measuring_instance;
  var LayoutState_LookaheadMeasuring_instance;
  var LayoutState_LayingOut_instance;
  var LayoutState_LookaheadLayingOut_instance;
  var LayoutState_Idle_instance;
  var LayoutState_entriesInitialized;
  function LayoutState_initEntries() {
    if (LayoutState_entriesInitialized)
      return Unit_instance;
    LayoutState_entriesInitialized = true;
    LayoutState_Measuring_instance = new LayoutState('Measuring', 0);
    LayoutState_LookaheadMeasuring_instance = new LayoutState('LookaheadMeasuring', 1);
    LayoutState_LayingOut_instance = new LayoutState('LayingOut', 2);
    LayoutState_LookaheadLayingOut_instance = new LayoutState('LookaheadLayingOut', 3);
    LayoutState_Idle_instance = new LayoutState('Idle', 4);
  }
  var UsageByParent_InMeasureBlock_instance;
  var UsageByParent_InLayoutBlock_instance;
  var UsageByParent_NotUsed_instance;
  var UsageByParent_entriesInitialized;
  function UsageByParent_initEntries() {
    if (UsageByParent_entriesInitialized)
      return Unit_instance;
    UsageByParent_entriesInitialized = true;
    UsageByParent_InMeasureBlock_instance = new UsageByParent('InMeasureBlock', 0);
    UsageByParent_InLayoutBlock_instance = new UsageByParent('InLayoutBlock', 1);
    UsageByParent_NotUsed_instance = new UsageByParent('NotUsed', 2);
  }
  function _set_lookaheadRoot__8dq8u9($this, newRoot) {
    if (!equals(newRoot, $this.f90_1)) {
      $this.f90_1 = newRoot;
      if (!(newRoot == null)) {
        $this.e91_1.pba();
        // Inline function 'androidx.compose.ui.node.LayoutNode.forEachCoordinatorIncludingInner' call
        var delegate = $this.hak();
        var final = $this.car().s94_1;
        while (!equals(delegate, final) && !(delegate == null)) {
          delegate.jb6();
          delegate = delegate.s94_1;
        }
      } else {
        $this.e91_1.oba();
      }
      $this.bb0();
    }
  }
  function recreateUnfoldedChildrenIfDirty($this) {
    if ($this.j90_1) {
      $this.j90_1 = false;
      var tmp0_elvis_lhs = $this.i90_1;
      var tmp;
      if (tmp0_elvis_lhs == null) {
        // Inline function 'androidx.compose.runtime.collection.mutableVectorOf' call
        // Inline function 'androidx.compose.runtime.collection.MutableVector' call
        // Inline function 'kotlin.arrayOfNulls' call
        var tmp$ret$2 = Array(16);
        // Inline function 'kotlin.also' call
        var this_0 = new MutableVector(tmp$ret$2, 0);
        $this.i90_1 = this_0;
        tmp = this_0;
      } else {
        tmp = tmp0_elvis_lhs;
      }
      var unfoldedChildren = tmp;
      unfoldedChildren.c3();
      // Inline function 'androidx.compose.ui.node.MutableVectorWithMutationTracking.forEach' call
      // Inline function 'androidx.compose.runtime.collection.MutableVector.forEach' call
      var this_1 = $this.h90_1.qba_1;
      var i = 0;
      var tmp_0 = this_1.b3e_1;
      var content = isArray(tmp_0) ? tmp_0 : THROW_CCE();
      var size = this_1.d3e_1;
      while (i < size) {
        var it = content[i];
        if (it.w8z_1) {
          // Inline function 'androidx.compose.runtime.collection.MutableVector.addAll' call
          var elements = it.rb1();
          unfoldedChildren.m4a(unfoldedChildren.d3e_1, elements);
        } else {
          unfoldedChildren.zz(it);
        }
        i = i + 1 | 0;
      }
      $this.e91_1.sba();
    }
  }
  function invalidateUnfoldedVirtualChildren($this) {
    if ($this.g90_1 > 0) {
      $this.j90_1 = true;
    }
    if ($this.w8z_1) {
      var tmp0_safe_receiver = $this.k90_1;
      if (tmp0_safe_receiver == null)
        null;
      else {
        invalidateUnfoldedVirtualChildren(tmp0_safe_receiver);
      }
    }
  }
  function exceptionMessageForParentingOrOwnership($this, instance) {
    var tmp = 'Cannot insert ' + instance.toString() + ' because it already has a parent or an owner.' + ' This tree: ' + debugTreeToString($this) + ' Other tree: ';
    var tmp0_safe_receiver = instance.k90_1;
    return tmp + (tmp0_safe_receiver == null ? null : debugTreeToString(tmp0_safe_receiver));
  }
  function onChildRemoved($this, child) {
    if (child.e91_1.iba_1 > 0) {
      var _receiver__tnumb7 = $this.e91_1;
      var _unary__edvuaz = _receiver__tnumb7.iba_1;
      _receiver__tnumb7.tba(_unary__edvuaz - 1 | 0);
    }
    if (!($this.l90_1 == null)) {
      child.uba();
    }
    child.k90_1 = null;
    if (child.n91_1 > 0) {
      var _unary__edvuaz_0 = $this.n91_1;
      $this.vba(_unary__edvuaz_0 - 1 | 0);
    }
    child.hak().t94_1 = null;
    if (child.w8z_1) {
      $this.g90_1 = $this.g90_1 - 1 | 0;
      // Inline function 'androidx.compose.ui.node.MutableVectorWithMutationTracking.forEach' call
      // Inline function 'androidx.compose.runtime.collection.MutableVector.forEach' call
      var this_0 = child.h90_1.qba_1;
      var i = 0;
      var tmp = this_0.b3e_1;
      var content = isArray(tmp) ? tmp : THROW_CCE();
      var size = this_0.d3e_1;
      while (i < size) {
        content[i].hak().t94_1 = null;
        i = i + 1 | 0;
      }
    }
    invalidateUnfoldedVirtualChildren($this);
    $this.wba();
  }
  function calculateSemanticsConfiguration($this) {
    $this.r90_1 = true;
    var config = {_v: new SemanticsConfiguration()};
    var tmp0 = requireOwner_0($this).fb0();
    // Inline function 'androidx.compose.ui.node.OwnerSnapshotObserver.observeSemanticsReads' call
    var block = LayoutNode$calculateSemanticsConfiguration$lambda($this, config);
    // Inline function 'androidx.compose.ui.node.OwnerSnapshotObserver.observeReads' call
    var onChanged = access$_get_onCommitAffectingSemantics__m15jud(tmp0);
    access$_get_observer__zh6fij(tmp0).z5a($this, onChanged, block);
    $this.r90_1 = false;
    return config._v;
  }
  function debugTreeToString($this, depth) {
    depth = depth === VOID ? 0 : depth;
    var tree = StringBuilder_init_$Create$();
    var inductionVariable = 0;
    if (inductionVariable < depth)
      do {
        var i = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        tree.q('  ');
      }
       while (inductionVariable < depth);
    tree.q('|-');
    tree.q($this.toString());
    tree.s(_Char___init__impl__6a9atx(10));
    // Inline function 'androidx.compose.ui.node.LayoutNode.forEachChild' call
    // Inline function 'androidx.compose.runtime.collection.MutableVector.forEach' call
    var this_0 = $this.rb1();
    var i_0 = 0;
    var tmp = this_0.b3e_1;
    var content = isArray(tmp) ? tmp : THROW_CCE();
    var size = this_0.d3e_1;
    while (i_0 < size) {
      var child = content[i_0];
      tree.q(debugTreeToString(child, depth + 1 | 0));
      i_0 = i_0 + 1 | 0;
    }
    var treeString = tree.toString();
    if (depth === 0) {
      treeString = substring(treeString, 0, treeString.length - 1 | 0);
    }
    return treeString;
  }
  function NoIntrinsicsMeasurePolicy(error) {
    this.zap_1 = error;
  }
  protoOf(NoIntrinsicsMeasurePolicy).nak = function (_this__u8e3s4, measurables, height) {
    // Inline function 'kotlin.error' call
    var message = this.zap_1;
    throw IllegalStateException_init_$Create$(toString(message));
  };
  protoOf(NoIntrinsicsMeasurePolicy).oak = function (_this__u8e3s4, measurables, width) {
    // Inline function 'kotlin.error' call
    var message = this.zap_1;
    throw IllegalStateException_init_$Create$(toString(message));
  };
  protoOf(NoIntrinsicsMeasurePolicy).pak = function (_this__u8e3s4, measurables, height) {
    // Inline function 'kotlin.error' call
    var message = this.zap_1;
    throw IllegalStateException_init_$Create$(toString(message));
  };
  protoOf(NoIntrinsicsMeasurePolicy).qak = function (_this__u8e3s4, measurables, width) {
    // Inline function 'kotlin.error' call
    var message = this.zap_1;
    throw IllegalStateException_init_$Create$(toString(message));
  };
  function getOrCreateIntrinsicsPolicy($this) {
    var tmp0_elvis_lhs = $this.v90_1;
    var tmp;
    if (tmp0_elvis_lhs == null) {
      // Inline function 'kotlin.also' call
      var this_0 = new IntrinsicsPolicy($this, $this.u90_1);
      $this.v90_1 = this_0;
      tmp = this_0;
    } else {
      tmp = tmp0_elvis_lhs;
    }
    return tmp;
  }
  function _get_traceContext__kshe73($this) {
    return $this.z90_1.k51(get_LocalCompositionErrorContext());
  }
  function onDensityOrLayoutDirectionChanged($this) {
    $this.bb0();
    var tmp0_safe_receiver = $this.f9a();
    var tmp;
    if (tmp0_safe_receiver == null) {
      tmp = null;
    } else {
      tmp0_safe_receiver.xba();
      tmp = Unit_instance;
    }
    if (tmp == null) {
      var tmp2_safe_receiver = $this.l90_1;
      if (tmp2_safe_receiver == null)
        null;
      else {
        tmp2_safe_receiver.yba();
      }
    }
    $this.zba();
  }
  function _get_zIndex__hypqqb($this) {
    return $this.nau().eau_1;
  }
  function applyModifier($this, modifier) {
    // Inline function 'androidx.compose.ui.node.Nodes.PointerInput' call
    var tmp$ret$0 = _NodeKind___init__impl__ojsprp(16);
    var hadPointerInput = $this.d91_1.abb(tmp$ret$0);
    // Inline function 'androidx.compose.ui.node.Nodes.FocusTarget' call
    var tmp$ret$1 = _NodeKind___init__impl__ojsprp(1024);
    var hadFocusTarget = $this.d91_1.abb(tmp$ret$1);
    $this.i91_1 = modifier;
    $this.d91_1.bbb(modifier);
    // Inline function 'androidx.compose.ui.node.Nodes.PointerInput' call
    var tmp$ret$2 = _NodeKind___init__impl__ojsprp(16);
    var hasPointerInput = $this.d91_1.abb(tmp$ret$2);
    // Inline function 'androidx.compose.ui.node.Nodes.FocusTarget' call
    var tmp$ret$3 = _NodeKind___init__impl__ojsprp(1024);
    var hasFocusTarget = $this.d91_1.abb(tmp$ret$3);
    $this.e91_1.cbb();
    var tmp;
    if ($this.f90_1 == null) {
      // Inline function 'androidx.compose.ui.node.Nodes.ApproachMeasure' call
      var tmp$ret$4 = _NodeKind___init__impl__ojsprp(512);
      tmp = $this.d91_1.abb(tmp$ret$4);
    } else {
      tmp = false;
    }
    if (tmp) {
      _set_lookaheadRoot__8dq8u9($this, $this);
    }
    if (!(hadPointerInput === hasPointerInput) || !(hadFocusTarget === hasFocusTarget)) {
      requireOwner_0($this).xam().dbb($this, hasFocusTarget, hasPointerInput);
    }
  }
  function resetModifierState($this) {
    $this.d91_1.ebb();
  }
  function clearSubtreePlacementIntrinsicsUsage($this) {
    $this.b91_1 = $this.a91_1;
    $this.a91_1 = UsageByParent_NotUsed_getInstance();
    // Inline function 'androidx.compose.ui.node.LayoutNode.forEachChild' call
    // Inline function 'androidx.compose.runtime.collection.MutableVector.forEach' call
    var this_0 = $this.rb1();
    var i = 0;
    var tmp = this_0.b3e_1;
    var content = isArray(tmp) ? tmp : THROW_CCE();
    var size = this_0.d3e_1;
    while (i < size) {
      var it = content[i];
      if (it.a91_1.equals(UsageByParent_InLayoutBlock_getInstance())) {
        clearSubtreePlacementIntrinsicsUsage(it);
      }
      i = i + 1 | 0;
    }
  }
  function Companion_30() {
    Companion_instance_35 = this;
    var tmp = this;
    tmp.oax_1 = new LayoutNode$Companion$ErrorMeasurePolicy$1();
    this.pax_1 = 2147483647;
    var tmp_0 = this;
    tmp_0.qax_1 = LayoutNode$Companion$Constructor$lambda;
    var tmp_1 = this;
    tmp_1.rax_1 = new LayoutNode$Companion$DummyViewConfiguration$1();
    var tmp_2 = this;
    var tmp_3 = LayoutNode$Companion$ZComparator$lambda;
    tmp_2.sax_1 = new sam$kotlin_Comparator$0(tmp_3);
  }
  var Companion_instance_35;
  function Companion_getInstance_56() {
    if (Companion_instance_35 == null)
      new Companion_30();
    return Companion_instance_35;
  }
  function LayoutState(name, ordinal) {
    Enum.call(this, name, ordinal);
  }
  function UsageByParent(name, ordinal) {
    Enum.call(this, name, ordinal);
  }
  function access$_set_ignoreRemeasureRequests__592r6g($this, _set____db54di) {
    $this.o90_1 = _set____db54di;
    return Unit_instance;
  }
  function LayoutNode$_foldedChildren$lambda(this$0) {
    return function () {
      this$0.e91_1.sba();
      return Unit_instance;
    };
  }
  function LayoutNode$calculateSemanticsConfiguration$lambda(this$0, $config) {
    return function () {
      var tmp0 = this$0.d91_1;
      // Inline function 'androidx.compose.ui.node.Nodes.Semantics' call
      // Inline function 'androidx.compose.ui.node.NodeChain.tailToHead' call
      var type = _NodeKind___init__impl__ojsprp(8);
      var tmp2 = _NodeKind___get_mask__impl__1uopb6(type);
      $l$block: {
        // Inline function 'androidx.compose.ui.node.NodeChain.tailToHead' call
        if ((access$_get_aggregateChildKindSet__pv81sw(tmp0) & tmp2) === 0) {
          break $l$block;
        }
        // Inline function 'androidx.compose.ui.node.NodeChain.tailToHead' call
        var node = tmp0.i99_1;
        while (!(node == null)) {
          var it = node;
          if (!((it.o8v_1 & tmp2) === 0)) {
            // Inline function 'androidx.compose.ui.node.dispatchForKind' call
            // Inline function 'androidx.compose.ui.node.dispatchForKind' call
            var stack = null;
            var node_0 = it;
            $l$loop: while (!(node_0 == null)) {
              var tmp;
              if (isInterface(node_0, SemanticsModifierNode)) {
                var it_0 = node_0;
                if (it_0.k9j()) {
                  $config._v = new SemanticsConfiguration();
                  $config._v.qb0_1 = true;
                }
                if (it_0.l9j()) {
                  $config._v.pb0_1 = true;
                }
                // Inline function 'kotlin.with' call
                it_0.l9i($config._v);
                tmp = false;
              } else {
                tmp = true;
              }
              var dispatchAgain = tmp;
              var tmp_0;
              var tmp_1;
              if (dispatchAgain || false) {
                // Inline function 'androidx.compose.ui.Node.isKind' call
                tmp_1 = !((node_0.o8v_1 & _NodeKind___get_mask__impl__1uopb6(type)) === 0);
              } else {
                tmp_1 = false;
              }
              if (tmp_1) {
                tmp_0 = node_0 instanceof DelegatingNode;
              } else {
                tmp_0 = false;
              }
              if (tmp_0) {
                var count = 0;
                // Inline function 'androidx.compose.ui.node.DelegatingNode.forEachImmediateDelegate' call
                var node_1 = node_0.e9a_1;
                while (!(node_1 == null)) {
                  var next = node_1;
                  // Inline function 'androidx.compose.ui.Node.isKind' call
                  if (!((next.o8v_1 & _NodeKind___get_mask__impl__1uopb6(type)) === 0)) {
                    count = count + 1 | 0;
                    if (count === 1) {
                      node_0 = next;
                    } else {
                      var tmp0_elvis_lhs = stack;
                      var tmp_2;
                      if (tmp0_elvis_lhs == null) {
                        // Inline function 'androidx.compose.runtime.collection.mutableVectorOf' call
                        // Inline function 'androidx.compose.runtime.collection.MutableVector' call
                        // Inline function 'kotlin.arrayOfNulls' call
                        var tmp$ret$17 = Array(16);
                        tmp_2 = new MutableVector(tmp$ret$17, 0);
                      } else {
                        tmp_2 = tmp0_elvis_lhs;
                      }
                      stack = tmp_2;
                      var theNode = node_0;
                      if (!(theNode == null)) {
                        var tmp1_safe_receiver = stack;
                        if (tmp1_safe_receiver == null)
                          null;
                        else
                          tmp1_safe_receiver.zz(theNode);
                        node_0 = null;
                      }
                      var tmp2_safe_receiver = stack;
                      if (tmp2_safe_receiver == null)
                        null;
                      else
                        tmp2_safe_receiver.zz(next);
                    }
                  }
                  node_1 = node_1.r8v_1;
                }
                if (count === 1) {
                  continue $l$loop;
                }
              }
              node_0 = access$pop$tDelegatableNodeKt(stack);
            }
          }
          node = node.q8v_1;
        }
      }
      return Unit_instance;
    };
  }
  function LayoutState_Measuring_getInstance() {
    LayoutState_initEntries();
    return LayoutState_Measuring_instance;
  }
  function LayoutState_LookaheadMeasuring_getInstance() {
    LayoutState_initEntries();
    return LayoutState_LookaheadMeasuring_instance;
  }
  function LayoutState_LayingOut_getInstance() {
    LayoutState_initEntries();
    return LayoutState_LayingOut_instance;
  }
  function LayoutState_LookaheadLayingOut_getInstance() {
    LayoutState_initEntries();
    return LayoutState_LookaheadLayingOut_instance;
  }
  function LayoutState_Idle_getInstance() {
    LayoutState_initEntries();
    return LayoutState_Idle_instance;
  }
  function UsageByParent_InMeasureBlock_getInstance() {
    UsageByParent_initEntries();
    return UsageByParent_InMeasureBlock_instance;
  }
  function UsageByParent_InLayoutBlock_getInstance() {
    UsageByParent_initEntries();
    return UsageByParent_InLayoutBlock_instance;
  }
  function UsageByParent_NotUsed_getInstance() {
    UsageByParent_initEntries();
    return UsageByParent_NotUsed_instance;
  }
  function LayoutNode(isVirtual, semanticsId) {
    Companion_getInstance_56();
    isVirtual = isVirtual === VOID ? false : isVirtual;
    semanticsId = semanticsId === VOID ? generateSemanticsId() : semanticsId;
    this.w8z_1 = isVirtual;
    this.x8z_1 = semanticsId;
    this.y8z_1 = false;
    this.z8z_1 = Companion_getInstance_11().d5g_1;
    this.a90_1 = true;
    this.b90_1 = true;
    this.c90_1 = false;
    this.d90_1 = 0;
    this.e90_1 = false;
    this.f90_1 = null;
    this.g90_1 = 0;
    var tmp = this;
    // Inline function 'androidx.compose.runtime.collection.mutableVectorOf' call
    // Inline function 'androidx.compose.runtime.collection.MutableVector' call
    // Inline function 'kotlin.arrayOfNulls' call
    var tmp$ret$2 = Array(16);
    var tmp_0 = new MutableVector(tmp$ret$2, 0);
    tmp.h90_1 = new MutableVectorWithMutationTracking(tmp_0, LayoutNode$_foldedChildren$lambda(this));
    this.i90_1 = null;
    this.j90_1 = false;
    this.k90_1 = null;
    this.l90_1 = null;
    this.m90_1 = null;
    this.n90_1 = 0;
    this.o90_1 = false;
    this.p90_1 = false;
    this.q90_1 = null;
    this.r90_1 = false;
    var tmp_1 = this;
    // Inline function 'androidx.compose.runtime.collection.mutableVectorOf' call
    // Inline function 'androidx.compose.runtime.collection.MutableVector' call
    // Inline function 'kotlin.arrayOfNulls' call
    var tmp$ret$5 = Array(16);
    tmp_1.s90_1 = new MutableVector(tmp$ret$5, 0);
    this.t90_1 = true;
    this.u90_1 = Companion_getInstance_56().oax_1;
    this.v90_1 = null;
    this.w90_1 = get_DefaultDensity();
    this.x90_1 = LayoutDirection_Ltr_getInstance();
    this.y90_1 = Companion_getInstance_56().rax_1;
    this.z90_1 = Companion_getInstance_14().x3c_1;
    this.a91_1 = UsageByParent_NotUsed_getInstance();
    this.b91_1 = UsageByParent_NotUsed_getInstance();
    this.c91_1 = false;
    this.d91_1 = new NodeChain(this);
    this.e91_1 = new LayoutNodeLayoutDelegate(this);
    this.f91_1 = null;
    this.g91_1 = null;
    this.h91_1 = true;
    this.i91_1 = Companion_instance_6;
    this.j91_1 = null;
    this.k91_1 = null;
    this.l91_1 = null;
    this.m91_1 = false;
    this.n91_1 = 0;
    this.o91_1 = false;
  }
  protoOf(LayoutNode).nb1 = function (_set____db54di) {
    this.d90_1 = _set____db54di;
  };
  protoOf(LayoutNode).fbb = function () {
    var tmp0_safe_receiver = this.oau();
    return tmp0_safe_receiver == null ? null : tmp0_safe_receiver.gbb();
  };
  protoOf(LayoutNode).vas = function () {
    // Inline function 'androidx.compose.ui.node.MutableVectorWithMutationTracking.asList' call
    return this.h90_1.qba_1.q10();
  };
  protoOf(LayoutNode).daw = function () {
    return this.nau().faw();
  };
  protoOf(LayoutNode).saw = function () {
    return ensureNotNull(this.oau()).faw();
  };
  protoOf(LayoutNode).rb1 = function () {
    this.hbb();
    var tmp;
    if (this.g90_1 === 0) {
      tmp = this.h90_1.qba_1;
    } else {
      tmp = ensureNotNull(this.i90_1);
    }
    return tmp;
  };
  protoOf(LayoutNode).hbb = function () {
    if (this.g90_1 > 0) {
      recreateUnfoldedChildrenIfDirty(this);
    }
  };
  protoOf(LayoutNode).qaw = function () {
    return this.rb1().q10();
  };
  protoOf(LayoutNode).f9a = function () {
    var parent = this.k90_1;
    $l$loop: while (true) {
      var tmp0_safe_receiver = parent;
      if (!((tmp0_safe_receiver == null ? null : tmp0_safe_receiver.w8z_1) === true)) {
        break $l$loop;
      }
      parent = parent.k90_1;
    }
    return parent;
  };
  protoOf(LayoutNode).z9h = function () {
    var tmp0_safe_receiver = this.m90_1;
    return tmp0_safe_receiver == null ? null : tmp0_safe_receiver.z9h();
  };
  protoOf(LayoutNode).y91 = function () {
    return !(this.l90_1 == null);
  };
  protoOf(LayoutNode).zav = function () {
    return this.e91_1.aba_1;
  };
  protoOf(LayoutNode).oau = function () {
    return this.e91_1.nba_1;
  };
  protoOf(LayoutNode).nau = function () {
    return this.e91_1.mba_1;
  };
  protoOf(LayoutNode).xav = function (index, instance) {
    // Inline function 'androidx.compose.ui.internal.checkPrecondition' call
    if (!(instance.k90_1 == null || instance.l90_1 == null)) {
      var tmp$ret$1 = exceptionMessageForParentingOrOwnership(this, instance);
      throwIllegalStateException(tmp$ret$1);
    }
    if (false) {
      println(instance.toString() + ' added to ' + this.toString() + ' at index ' + index);
    }
    instance.k90_1 = this;
    this.h90_1.ni(index, instance);
    this.wba();
    if (instance.w8z_1) {
      this.g90_1 = this.g90_1 + 1 | 0;
    }
    invalidateUnfoldedVirtualChildren(this);
    var owner = this.l90_1;
    if (!(owner == null)) {
      instance.ibb(owner);
    }
    if (instance.e91_1.iba_1 > 0) {
      var _receiver__tnumb7 = this.e91_1;
      var _unary__edvuaz = _receiver__tnumb7.iba_1;
      _receiver__tnumb7.tba(_unary__edvuaz + 1 | 0);
    }
    if (instance.n91_1 > 0) {
      var _unary__edvuaz_0 = this.n91_1;
      this.vba(_unary__edvuaz_0 + 1 | 0);
    }
  };
  protoOf(LayoutNode).wba = function () {
    if (this.w8z_1) {
      var tmp0_safe_receiver = this.f9a();
      if (tmp0_safe_receiver == null)
        null;
      else {
        tmp0_safe_receiver.wba();
      }
    } else {
      this.t90_1 = true;
    }
  };
  protoOf(LayoutNode).waw = function (index, count) {
    // Inline function 'androidx.compose.ui.internal.requirePrecondition' call
    if (!(count >= 0)) {
      var tmp$ret$1 = 'count (' + count + ') must be greater than 0';
      throwIllegalArgumentException(tmp$ret$1);
    }
    var inductionVariable = (index + count | 0) - 1 | 0;
    if (index <= inductionVariable)
      do {
        var i = inductionVariable;
        inductionVariable = inductionVariable + -1 | 0;
        var tmp0 = this.h90_1;
        // Inline function 'androidx.compose.ui.node.MutableVectorWithMutationTracking.get' call
        var index_0 = i;
        // Inline function 'androidx.compose.runtime.collection.MutableVector.get' call
        var tmp$ret$2 = tmp0.qba_1.b3e_1[index_0];
        onChildRemoved(this, tmp$ret$2);
        var child = this.h90_1.h3(i);
        if (false) {
          println(child.toString() + ' removed from ' + this.toString() + ' at index ' + i);
        }
      }
       while (!(i === index));
  };
  protoOf(LayoutNode).yas = function () {
    // Inline function 'androidx.compose.ui.node.MutableVectorWithMutationTracking.size' call
    var inductionVariable = this.h90_1.qba_1.d3e_1 - 1 | 0;
    if (0 <= inductionVariable)
      do {
        var i = inductionVariable;
        inductionVariable = inductionVariable + -1 | 0;
        // Inline function 'androidx.compose.ui.node.MutableVectorWithMutationTracking.get' call
        // Inline function 'androidx.compose.runtime.collection.MutableVector.get' call
        var tmp$ret$1 = this.h90_1.qba_1.b3e_1[i];
        onChildRemoved(this, tmp$ret$1);
      }
       while (0 <= inductionVariable);
    this.h90_1.c3();
    if (false) {
      println('Removed all children from ' + this.toString());
    }
  };
  protoOf(LayoutNode).yav = function (from, to, count) {
    if (from === to) {
      return Unit_instance;
    }
    var inductionVariable = 0;
    if (inductionVariable < count)
      do {
        var i = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var fromIndex = from > to ? from + i | 0 : from;
        var toIndex = from > to ? to + i | 0 : (to + count | 0) - 2 | 0;
        var child = this.h90_1.h3(fromIndex);
        if (false) {
          println(child.toString() + ' moved in ' + this.toString() + ' from index ' + fromIndex + ' to ' + toIndex);
        }
        this.h90_1.ni(toIndex, child);
      }
       while (inductionVariable < count);
    this.wba();
    invalidateUnfoldedVirtualChildren(this);
    this.bb0();
  };
  protoOf(LayoutNode).ob1 = function () {
    if (this.r90_1)
      return Unit_instance;
    var owner = requireOwner_0(this);
    owner.jbb(this);
  };
  protoOf(LayoutNode).kbb = function () {
    if (this.r90_1)
      return Unit_instance;
    if (this.d91_1.rbb() || this.sbb()) {
      this.p90_1 = true;
    } else {
      var prev = this.q90_1;
      this.q90_1 = calculateSemanticsConfiguration(this);
      this.p90_1 = false;
      var owner = requireOwner_0(this);
      owner.lbb().qbb(this, prev);
      owner.yaz();
    }
  };
  protoOf(LayoutNode).lb0 = function () {
    var tmp;
    if (!this.y91() || this.o91_1) {
      tmp = true;
    } else {
      // Inline function 'androidx.compose.ui.node.Nodes.Semantics' call
      var tmp$ret$0 = _NodeKind___init__impl__ojsprp(8);
      tmp = !this.d91_1.abb(tmp$ret$0);
    }
    if (tmp)
      return null;
    return this.q90_1;
  };
  protoOf(LayoutNode).ibb = function (owner) {
    // Inline function 'androidx.compose.ui.internal.checkPrecondition' call
    if (!(this.l90_1 == null)) {
      var tmp$ret$1 = 'Cannot attach ' + this.toString() + ' as it already is attached.  Tree: ' + debugTreeToString(this);
      throwIllegalStateException(tmp$ret$1);
    }
    var tmp;
    if (this.k90_1 == null) {
      tmp = true;
    } else {
      var tmp0_safe_receiver = this.k90_1;
      tmp = equals(tmp0_safe_receiver == null ? null : tmp0_safe_receiver.l90_1, owner);
    }
    // Inline function 'androidx.compose.ui.internal.checkPrecondition' call
    if (!tmp) {
      var tmp_0 = toString(owner);
      var tmp0_safe_receiver_0 = this.f9a();
      var tmp_1 = 'Attaching to a different owner(' + tmp_0 + ") than the parent's owner(" + toString_0(tmp0_safe_receiver_0 == null ? null : tmp0_safe_receiver_0.l90_1) + ').' + ' This tree: ' + debugTreeToString(this) + ' Parent tree: ';
      var tmp1_safe_receiver = this.k90_1;
      var tmp$ret$3 = tmp_1 + (tmp1_safe_receiver == null ? null : debugTreeToString(tmp1_safe_receiver));
      throwIllegalStateException(tmp$ret$3);
    }
    var parent = this.f9a();
    if (parent == null) {
      this.nau().sat_1 = true;
      owner.xam().tbb(this);
      var tmp1_safe_receiver_0 = this.oau();
      if (tmp1_safe_receiver_0 == null)
        null;
      else {
        tmp1_safe_receiver_0.ubb();
      }
    }
    var tmp_2 = this.hak();
    tmp_2.t94_1 = parent == null ? null : parent.car();
    this.l90_1 = owner;
    var tmp_3 = this;
    var tmp4_elvis_lhs = parent == null ? null : parent.n90_1;
    tmp_3.n90_1 = (tmp4_elvis_lhs == null ? -1 : tmp4_elvis_lhs) + 1 | 0;
    var tmp5_safe_receiver = this.j91_1;
    if (tmp5_safe_receiver == null)
      null;
    else {
      // Inline function 'kotlin.let' call
      applyModifier(this, tmp5_safe_receiver);
    }
    this.j91_1 = null;
    owner.vbb(this);
    if (this.e90_1) {
      _set_lookaheadRoot__8dq8u9(this, this);
    } else {
      var tmp6_safe_receiver = this.k90_1;
      var tmp7_elvis_lhs = tmp6_safe_receiver == null ? null : tmp6_safe_receiver.f90_1;
      _set_lookaheadRoot__8dq8u9(this, tmp7_elvis_lhs == null ? this.f90_1 : tmp7_elvis_lhs);
      var tmp_4;
      if (this.f90_1 == null) {
        // Inline function 'androidx.compose.ui.node.Nodes.ApproachMeasure' call
        var tmp$ret$6 = _NodeKind___init__impl__ojsprp(512);
        tmp_4 = this.d91_1.abb(tmp$ret$6);
      } else {
        tmp_4 = false;
      }
      if (tmp_4) {
        _set_lookaheadRoot__8dq8u9(this, this);
      }
    }
    if (!this.o91_1) {
      this.d91_1.wbb();
    }
    // Inline function 'androidx.compose.ui.node.MutableVectorWithMutationTracking.forEach' call
    // Inline function 'androidx.compose.runtime.collection.MutableVector.forEach' call
    var this_0 = this.h90_1.qba_1;
    var i = 0;
    var tmp_5 = this_0.b3e_1;
    var content = isArray(tmp_5) ? tmp_5 : THROW_CCE();
    var size = this_0.d3e_1;
    while (i < size) {
      content[i].ibb(owner);
      i = i + 1 | 0;
    }
    if (!this.o91_1) {
      this.d91_1.xbb();
    }
    this.bb0();
    if (parent == null)
      null;
    else {
      parent.bb0();
    }
    var tmp9_safe_receiver = this.k91_1;
    if (tmp9_safe_receiver == null)
      null;
    else
      tmp9_safe_receiver(owner);
    this.e91_1.cbb();
    var tmp_6;
    if (!this.o91_1) {
      // Inline function 'androidx.compose.ui.node.Nodes.Semantics' call
      var tmp$ret$10 = _NodeKind___init__impl__ojsprp(8);
      tmp_6 = this.d91_1.abb(tmp$ret$10);
    } else {
      tmp_6 = false;
    }
    if (tmp_6) {
      this.kbb();
    }
    owner.ybb(this);
  };
  protoOf(LayoutNode).uba = function () {
    var owner = this.l90_1;
    // Inline function 'androidx.compose.ui.internal.checkPreconditionNotNull' call
    if (owner == null) {
      var tmp0_safe_receiver = this.f9a();
      var tmp$ret$1 = 'Cannot detach node that is already detached!  Tree: ' + (tmp0_safe_receiver == null ? null : debugTreeToString(tmp0_safe_receiver));
      throwIllegalStateExceptionForNullCheck(tmp$ret$1);
    }
    var parent = this.f9a();
    if (!(parent == null)) {
      parent.xba();
      parent.bb0();
      this.nau().kat_1 = UsageByParent_NotUsed_getInstance();
      var tmp0_safe_receiver_0 = this.oau();
      if (tmp0_safe_receiver_0 == null)
        null;
      else {
        // Inline function 'kotlin.let' call
        tmp0_safe_receiver_0.yau_1 = UsageByParent_NotUsed_getInstance();
      }
    }
    this.e91_1.zbb();
    // Inline function 'androidx.compose.ui.node.LayoutNode.forEachCoordinatorIncludingInner' call
    var delegate = this.hak();
    var final = this.car().s94_1;
    while (!equals(delegate, final) && !(delegate == null)) {
      delegate.ob7();
      delegate = delegate.s94_1;
    }
    var tmp1_safe_receiver = this.l91_1;
    if (tmp1_safe_receiver == null)
      null;
    else
      tmp1_safe_receiver(owner);
    this.d91_1.g8w();
    // Inline function 'androidx.compose.ui.node.LayoutNode.ignoreRemeasureRequests' call
    access$_set_ignoreRemeasureRequests__592r6g(this, true);
    // Inline function 'androidx.compose.ui.node.MutableVectorWithMutationTracking.forEach' call
    // Inline function 'androidx.compose.runtime.collection.MutableVector.forEach' call
    var this_0 = this.h90_1.qba_1;
    var i = 0;
    var tmp = this_0.b3e_1;
    var content = isArray(tmp) ? tmp : THROW_CCE();
    var size = this_0.d3e_1;
    while (i < size) {
      content[i].uba();
      i = i + 1 | 0;
    }
    var result = Unit_instance;
    access$_set_ignoreRemeasureRequests__592r6g(this, false);
    this.d91_1.i8w();
    owner.abc(this);
    owner.xam().bbc(this);
    this.l90_1 = null;
    _set_lookaheadRoot__8dq8u9(this, null);
    this.n90_1 = 0;
    this.nau().cbc();
    var tmp2_safe_receiver = this.oau();
    if (tmp2_safe_receiver == null)
      null;
    else {
      tmp2_safe_receiver.cbc();
    }
    // Inline function 'androidx.compose.ui.node.Nodes.Semantics' call
    var tmp$ret$11 = _NodeKind___init__impl__ojsprp(8);
    if (this.d91_1.abb(tmp$ret$11)) {
      var prev = this.q90_1;
      this.q90_1 = null;
      this.p90_1 = false;
      owner.lbb().qbb(this, prev);
      owner.yaz();
    }
  };
  protoOf(LayoutNode).sb1 = function () {
    if (this.t90_1) {
      this.s90_1.c3();
      var tmp0 = this.s90_1;
      // Inline function 'androidx.compose.runtime.collection.MutableVector.addAll' call
      var elements = this.rb1();
      tmp0.m4a(tmp0.d3e_1, elements);
      this.s90_1.o4a(Companion_getInstance_56().sax_1);
      this.t90_1 = false;
    }
    return this.s90_1;
  };
  protoOf(LayoutNode).kb0 = function () {
    return this.y91();
  };
  protoOf(LayoutNode).toString = function () {
    return simpleIdentityToString(this, null) + ' children: ' + this.qaw().n1() + ' ' + ('measurePolicy: ' + toString(this.u90_1) + ' deactivated: ' + this.o91_1);
  };
  protoOf(LayoutNode).kax = function (value) {
    if (!equals(this.u90_1, value)) {
      this.u90_1 = value;
      var tmp0_safe_receiver = this.v90_1;
      if (tmp0_safe_receiver == null)
        null;
      else {
        tmp0_safe_receiver.wb7(this.u90_1);
      }
      this.bb0();
    }
  };
  protoOf(LayoutNode).ab4 = function (height) {
    return getOrCreateIntrinsicsPolicy(this).ab4(height);
  };
  protoOf(LayoutNode).bb4 = function (width) {
    return getOrCreateIntrinsicsPolicy(this).bb4(width);
  };
  protoOf(LayoutNode).cb4 = function (height) {
    return getOrCreateIntrinsicsPolicy(this).cb4(height);
  };
  protoOf(LayoutNode).db4 = function (width) {
    return getOrCreateIntrinsicsPolicy(this).db4(width);
  };
  protoOf(LayoutNode).b98 = function (height) {
    return getOrCreateIntrinsicsPolicy(this).b98(height);
  };
  protoOf(LayoutNode).d98 = function (width) {
    return getOrCreateIntrinsicsPolicy(this).d98(width);
  };
  protoOf(LayoutNode).c98 = function (height) {
    return getOrCreateIntrinsicsPolicy(this).c98(height);
  };
  protoOf(LayoutNode).e98 = function (width) {
    return getOrCreateIntrinsicsPolicy(this).e98(width);
  };
  protoOf(LayoutNode).s6p = function (value) {
    if (!equals(this.w90_1, value)) {
      this.w90_1 = value;
      onDensityOrLayoutDirectionChanged(this);
      // Inline function 'androidx.compose.ui.node.NodeChain.headToTail' call
      var node = this.d91_1.j99_1;
      while (!(node == null)) {
        node.n8w();
        node = node.r8v_1;
      }
    }
  };
  protoOf(LayoutNode).q6p = function (value) {
    if (!this.x90_1.equals(value)) {
      this.x90_1 = value;
      onDensityOrLayoutDirectionChanged(this);
      // Inline function 'androidx.compose.ui.node.NodeChain.headToTail' call
      var node = this.d91_1.j99_1;
      while (!(node == null)) {
        node.o8w();
        node = node.r8v_1;
      }
    }
  };
  protoOf(LayoutNode).mb1 = function (value) {
    if (!equals(this.y90_1, value)) {
      this.y90_1 = value;
      var tmp0 = this.d91_1;
      // Inline function 'androidx.compose.ui.node.Nodes.PointerInput' call
      // Inline function 'androidx.compose.ui.node.NodeChain.headToTail' call
      var type = _NodeKind___init__impl__ojsprp(16);
      var tmp2 = _NodeKind___get_mask__impl__1uopb6(type);
      $l$block_0: {
        // Inline function 'androidx.compose.ui.node.NodeChain.headToTail' call
        if ((access$_get_aggregateChildKindSet__pv81sw(tmp0) & tmp2) === 0) {
          break $l$block_0;
        }
        // Inline function 'androidx.compose.ui.node.NodeChain.headToTail' call
        var node = tmp0.j99_1;
        while (!(node == null)) {
          var it = node;
          if (!((it.o8v_1 & tmp2) === 0)) {
            // Inline function 'androidx.compose.ui.node.dispatchForKind' call
            // Inline function 'androidx.compose.ui.node.dispatchForKind' call
            var stack = null;
            var node_0 = it;
            $l$loop: while (!(node_0 == null)) {
              var tmp;
              if (isInterface(node_0, PointerInputModifierNode)) {
                node_0.ha5();
                tmp = false;
              } else {
                tmp = true;
              }
              var dispatchAgain = tmp;
              var tmp_0;
              var tmp_1;
              if (dispatchAgain || false) {
                // Inline function 'androidx.compose.ui.Node.isKind' call
                tmp_1 = !((node_0.o8v_1 & _NodeKind___get_mask__impl__1uopb6(type)) === 0);
              } else {
                tmp_1 = false;
              }
              if (tmp_1) {
                tmp_0 = node_0 instanceof DelegatingNode;
              } else {
                tmp_0 = false;
              }
              if (tmp_0) {
                var count = 0;
                // Inline function 'androidx.compose.ui.node.DelegatingNode.forEachImmediateDelegate' call
                var node_1 = node_0.e9a_1;
                while (!(node_1 == null)) {
                  var next = node_1;
                  // Inline function 'androidx.compose.ui.Node.isKind' call
                  if (!((next.o8v_1 & _NodeKind___get_mask__impl__1uopb6(type)) === 0)) {
                    count = count + 1 | 0;
                    if (count === 1) {
                      node_0 = next;
                    } else {
                      var tmp0_elvis_lhs = stack;
                      var tmp_2;
                      if (tmp0_elvis_lhs == null) {
                        // Inline function 'androidx.compose.runtime.collection.mutableVectorOf' call
                        // Inline function 'androidx.compose.runtime.collection.MutableVector' call
                        // Inline function 'kotlin.arrayOfNulls' call
                        var tmp$ret$15 = Array(16);
                        tmp_2 = new MutableVector(tmp$ret$15, 0);
                      } else {
                        tmp_2 = tmp0_elvis_lhs;
                      }
                      stack = tmp_2;
                      var theNode = node_0;
                      if (!(theNode == null)) {
                        var tmp1_safe_receiver = stack;
                        if (tmp1_safe_receiver == null)
                          null;
                        else
                          tmp1_safe_receiver.zz(theNode);
                        node_0 = null;
                      }
                      var tmp2_safe_receiver = stack;
                      if (tmp2_safe_receiver == null)
                        null;
                      else
                        tmp2_safe_receiver.zz(next);
                    }
                  }
                  node_1 = node_1.r8v_1;
                }
                if (count === 1) {
                  continue $l$loop;
                }
              }
              node_0 = access$pop$tDelegatableNodeKt(stack);
            }
          }
          if ((it.p8v_1 & tmp2) === 0) {
            break $l$block_0;
          }
          node = node.r8v_1;
        }
      }
    }
  };
  protoOf(LayoutNode).lb1 = function (value) {
    this.z90_1 = value;
    this.s6p(value.k51(get_LocalDensity()));
    this.q6p(value.k51(get_LocalLayoutDirection()));
    this.mb1(value.k51(get_LocalViewConfiguration()));
    var tmp0 = this.d91_1;
    // Inline function 'androidx.compose.ui.node.Nodes.CompositionLocalConsumer' call
    // Inline function 'androidx.compose.ui.node.NodeChain.headToTail' call
    var type = _NodeKind___init__impl__ojsprp(32768);
    var tmp2 = _NodeKind___get_mask__impl__1uopb6(type);
    $l$block_0: {
      // Inline function 'androidx.compose.ui.node.NodeChain.headToTail' call
      if ((access$_get_aggregateChildKindSet__pv81sw(tmp0) & tmp2) === 0) {
        break $l$block_0;
      }
      // Inline function 'androidx.compose.ui.node.NodeChain.headToTail' call
      var node = tmp0.j99_1;
      while (!(node == null)) {
        var it = node;
        if (!((it.o8v_1 & tmp2) === 0)) {
          // Inline function 'androidx.compose.ui.node.dispatchForKind' call
          // Inline function 'androidx.compose.ui.node.dispatchForKind' call
          var stack = null;
          var node_0 = it;
          $l$loop: while (!(node_0 == null)) {
            var tmp;
            if (isInterface(node_0, CompositionLocalConsumerModifierNode)) {
              var delegatedNode = node_0.f4n();
              if (delegatedNode.z8v_1) {
                autoInvalidateUpdatedNode(delegatedNode);
              } else {
                delegatedNode.v8v_1 = true;
              }
              tmp = false;
            } else {
              tmp = true;
            }
            var dispatchAgain = tmp;
            var tmp_0;
            var tmp_1;
            if (dispatchAgain || false) {
              // Inline function 'androidx.compose.ui.Node.isKind' call
              tmp_1 = !((node_0.o8v_1 & _NodeKind___get_mask__impl__1uopb6(type)) === 0);
            } else {
              tmp_1 = false;
            }
            if (tmp_1) {
              tmp_0 = node_0 instanceof DelegatingNode;
            } else {
              tmp_0 = false;
            }
            if (tmp_0) {
              var count = 0;
              // Inline function 'androidx.compose.ui.node.DelegatingNode.forEachImmediateDelegate' call
              var node_1 = node_0.e9a_1;
              while (!(node_1 == null)) {
                var next = node_1;
                // Inline function 'androidx.compose.ui.Node.isKind' call
                if (!((next.o8v_1 & _NodeKind___get_mask__impl__1uopb6(type)) === 0)) {
                  count = count + 1 | 0;
                  if (count === 1) {
                    node_0 = next;
                  } else {
                    var tmp0_elvis_lhs = stack;
                    var tmp_2;
                    if (tmp0_elvis_lhs == null) {
                      // Inline function 'androidx.compose.runtime.collection.mutableVectorOf' call
                      // Inline function 'androidx.compose.runtime.collection.MutableVector' call
                      // Inline function 'kotlin.arrayOfNulls' call
                      var tmp$ret$15 = Array(16);
                      tmp_2 = new MutableVector(tmp$ret$15, 0);
                    } else {
                      tmp_2 = tmp0_elvis_lhs;
                    }
                    stack = tmp_2;
                    var theNode = node_0;
                    if (!(theNode == null)) {
                      var tmp1_safe_receiver = stack;
                      if (tmp1_safe_receiver == null)
                        null;
                      else
                        tmp1_safe_receiver.zz(theNode);
                      node_0 = null;
                    }
                    var tmp2_safe_receiver = stack;
                    if (tmp2_safe_receiver == null)
                      null;
                    else
                      tmp2_safe_receiver.zz(next);
                  }
                }
                node_1 = node_1.r8v_1;
              }
              if (count === 1) {
                continue $l$loop;
              }
            }
            node_0 = access$pop$tDelegatableNodeKt(stack);
          }
        }
        if ((it.p8v_1 & tmp2) === 0) {
          break $l$block_0;
        }
        node = node.r8v_1;
      }
    }
  };
  protoOf(LayoutNode).dbc = function (e) {
    // Inline function 'kotlin.also' call
    var tmp0_safe_receiver = _get_traceContext__kshe73(this);
    if (tmp0_safe_receiver == null)
      null;
    else {
      // Inline function 'kotlin.apply' call
      tmp0_safe_receiver.k3f(e, this);
    }
    throw e;
  };
  protoOf(LayoutNode).h5e = function () {
    return this.e91_1.ebc();
  };
  protoOf(LayoutNode).i5e = function () {
    return this.e91_1.fbc();
  };
  protoOf(LayoutNode).gbc = function () {
    // Inline function 'kotlin.run' call
    var $this$run = this.e91_1;
    var tmp;
    if ($this$run.sbc().sad().rbc()) {
      tmp = true;
    } else {
      var tmp0_safe_receiver = $this$run.hbc();
      var tmp1_safe_receiver = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.sad();
      tmp = (tmp1_safe_receiver == null ? null : tmp1_safe_receiver.rbc()) === true;
    }
    return tmp;
  };
  protoOf(LayoutNode).tbc = function () {
    return requireOwner_0(this).ubc();
  };
  protoOf(LayoutNode).b9i = function () {
    return this.nau().sat_1;
  };
  protoOf(LayoutNode).vbc = function () {
    return this.nau().tat_1;
  };
  protoOf(LayoutNode).d9i = function () {
    return this.nau().hat_1;
  };
  protoOf(LayoutNode).wbc = function () {
    return this.nau().kat_1;
  };
  protoOf(LayoutNode).xbc = function () {
    var tmp0_safe_receiver = this.oau();
    var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.yau_1;
    return tmp1_elvis_lhs == null ? UsageByParent_NotUsed_getInstance() : tmp1_elvis_lhs;
  };
  protoOf(LayoutNode).car = function () {
    return this.d91_1.g99_1;
  };
  protoOf(LayoutNode).hak = function () {
    return this.d91_1.h99_1;
  };
  protoOf(LayoutNode).ybc = function () {
    if (this.h91_1) {
      var coordinator = this.car();
      var final = this.hak().t94_1;
      this.g91_1 = null;
      $l$loop: while (!equals(coordinator, final)) {
        var tmp0_safe_receiver = coordinator;
        if (!((tmp0_safe_receiver == null ? null : tmp0_safe_receiver.o95_1) == null)) {
          this.g91_1 = coordinator;
          break $l$loop;
        }
        var tmp1_safe_receiver = coordinator;
        coordinator = tmp1_safe_receiver == null ? null : tmp1_safe_receiver.t94_1;
      }
      this.h91_1 = false;
    }
    var layerCoordinator = this.g91_1;
    if (!(layerCoordinator == null)) {
      // Inline function 'androidx.compose.ui.internal.checkPreconditionNotNull' call
      if (layerCoordinator.o95_1 == null) {
        var tmp$ret$1 = 'layer was not set. This error is usually caused by operating off of the UI thread. Did you call invalidate() instead of postInvalidate()?';
        throwIllegalStateExceptionForNullCheck(tmp$ret$1);
      }
    }
    return layerCoordinator;
  };
  protoOf(LayoutNode).xba = function () {
    var innerLayerCoordinator = this.ybc();
    if (!(innerLayerCoordinator == null)) {
      innerLayerCoordinator.lb2();
    } else {
      var parent = this.f9a();
      var tmp;
      if (parent == null) {
        tmp = null;
      } else {
        parent.xba();
        tmp = Unit_instance;
      }
      if (tmp == null) {
        var tmp2_safe_receiver = this.l90_1;
        if (tmp2_safe_receiver == null)
          null;
        else {
          tmp2_safe_receiver.yba();
        }
      }
    }
  };
  protoOf(LayoutNode).sbb = function () {
    return !(this.j91_1 == null);
  };
  protoOf(LayoutNode).kb1 = function (value) {
    // Inline function 'androidx.compose.ui.internal.requirePrecondition' call
    if (!(!this.w8z_1 || this.j9d() === Companion_instance_6)) {
      var tmp$ret$1 = 'Modifiers are not supported on virtual LayoutNodes';
      throwIllegalArgumentException(tmp$ret$1);
    }
    // Inline function 'androidx.compose.ui.internal.requirePrecondition' call
    if (!!this.o91_1) {
      var tmp$ret$3 = 'modifier is updated when deactivated';
      throwIllegalArgumentException(tmp$ret$3);
    }
    if (this.y91()) {
      applyModifier(this, value);
      if (this.p90_1) {
        this.kbb();
      }
    } else {
      this.j91_1 = value;
    }
  };
  protoOf(LayoutNode).j9d = function () {
    return this.i91_1;
  };
  protoOf(LayoutNode).zbc = function () {
    this.e91_1.abd();
  };
  protoOf(LayoutNode).p91 = function () {
    return this.car();
  };
  protoOf(LayoutNode).vba = function (value) {
    if (!(this.n91_1 === value)) {
      if (value > 0 && this.n91_1 === 0) {
        var tmp0_safe_receiver = this.f9a();
        if (tmp0_safe_receiver == null)
          null;
        else {
          var _unary__edvuaz = tmp0_safe_receiver.n91_1;
          tmp0_safe_receiver.vba(_unary__edvuaz + 1 | 0);
        }
      }
      if (value === 0 && this.n91_1 > 0) {
        var tmp1_safe_receiver = this.f9a();
        if (tmp1_safe_receiver == null)
          null;
        else {
          var _unary__edvuaz_0 = tmp1_safe_receiver.n91_1;
          tmp1_safe_receiver.vba(_unary__edvuaz_0 - 1 | 0);
        }
      }
      this.n91_1 = value;
    }
  };
  protoOf(LayoutNode).bbd = function (x, y) {
    if (this.a91_1.equals(UsageByParent_NotUsed_getInstance())) {
      clearSubtreePlacementIntrinsicsUsage(this);
    }
    var tmp0_safe_receiver = this.f9a();
    var tmp1_safe_receiver = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.car();
    var tmp2_elvis_lhs = tmp1_safe_receiver == null ? null : tmp1_safe_receiver.gae_1;
    // Inline function 'kotlin.with' call
    (tmp2_elvis_lhs == null ? requireOwner_0(this).cbd() : tmp2_elvis_lhs).a98(this.nau(), x, y);
  };
  protoOf(LayoutNode).jb4 = function () {
    if (this.a91_1.equals(UsageByParent_NotUsed_getInstance())) {
      clearSubtreePlacementIntrinsicsUsage(this);
    }
    this.nau().dbd();
  };
  protoOf(LayoutNode).ebd = function () {
    if (this.a91_1.equals(UsageByParent_NotUsed_getInstance())) {
      clearSubtreePlacementIntrinsicsUsage(this);
    }
    ensureNotNull(this.oau()).dbd();
  };
  protoOf(LayoutNode).nb6 = function (canvas, graphicsLayer) {
    // Inline function 'androidx.compose.ui.node.withComposeStackTrace' call
    try {
      this.hak().fb7(canvas, graphicsLayer);
    } catch ($p) {
      if ($p instanceof Error) {
        var e = $p;
        this.dbc(e);
      } else {
        throw $p;
      }
    }
    return Unit_instance;
  };
  protoOf(LayoutNode).fbd = function (pointerPosition, hitTestResult, pointerType, isInLayer) {
    var positionInWrapped = this.hak().nb7(pointerPosition);
    this.hak().jb7(Companion_getInstance_58().nbd_1, positionInWrapped, hitTestResult, pointerType, isInLayer);
  };
  protoOf(LayoutNode).va6 = function (pointerPosition, hitTestResult, pointerType, isInLayer, $super) {
    pointerType = pointerType === VOID ? Companion_getInstance_42().la2_1 : pointerType;
    isInLayer = isInLayer === VOID ? true : isInLayer;
    var tmp;
    if ($super === VOID) {
      this.fbd(pointerPosition, hitTestResult, pointerType, isInLayer);
      tmp = Unit_instance;
    } else {
      tmp = $super.fbd.call(this, new Offset(pointerPosition), hitTestResult, new PointerType(pointerType), isInLayer);
    }
    return tmp;
  };
  protoOf(LayoutNode).pbd = function (pointerPosition, hitSemanticsEntities, pointerType, isInLayer) {
    var positionInWrapped = this.hak().nb7(pointerPosition);
    this.hak().jb7(Companion_getInstance_58().obd_1, positionInWrapped, hitSemanticsEntities, Companion_getInstance_42().ma2_1, isInLayer);
  };
  protoOf(LayoutNode).qbd = function (it) {
    if (it.zav().a1_1 === 4) {
      if (it.cax()) {
        it.bax(true);
      } else {
        if (it.sbd()) {
          it.rbd(true);
        }
        if (it.aax()) {
          it.wav(true);
        } else if (it.ubd()) {
          it.tbd(true);
        }
      }
    } else
      throw IllegalStateException_init_$Create$('Unexpected state ' + it.zav().toString());
  };
  protoOf(LayoutNode).vbd = function (forceRequest, scheduleMeasureAndLayout, invalidateIntrinsics) {
    if (!this.o90_1 && !this.w8z_1) {
      var tmp0_elvis_lhs = this.l90_1;
      var tmp;
      if (tmp0_elvis_lhs == null) {
        return Unit_instance;
      } else {
        tmp = tmp0_elvis_lhs;
      }
      var owner = tmp;
      owner.wbd(this, VOID, forceRequest, scheduleMeasureAndLayout);
      if (invalidateIntrinsics) {
        this.nau().xbd(forceRequest);
      }
    }
  };
  protoOf(LayoutNode).wav = function (forceRequest, scheduleMeasureAndLayout, invalidateIntrinsics, $super) {
    forceRequest = forceRequest === VOID ? false : forceRequest;
    scheduleMeasureAndLayout = scheduleMeasureAndLayout === VOID ? true : scheduleMeasureAndLayout;
    invalidateIntrinsics = invalidateIntrinsics === VOID ? true : invalidateIntrinsics;
    var tmp;
    if ($super === VOID) {
      this.vbd(forceRequest, scheduleMeasureAndLayout, invalidateIntrinsics);
      tmp = Unit_instance;
    } else {
      tmp = $super.vbd.call(this, forceRequest, scheduleMeasureAndLayout, invalidateIntrinsics);
    }
    return tmp;
  };
  protoOf(LayoutNode).ybd = function (forceRequest, scheduleMeasureAndLayout, invalidateIntrinsics) {
    // Inline function 'androidx.compose.ui.internal.checkPrecondition' call
    if (!!(this.f90_1 == null)) {
      var tmp$ret$1 = 'Lookahead measure cannot be requested on a node that is not a part of the LookaheadScope';
      throwIllegalStateException(tmp$ret$1);
    }
    var tmp0_elvis_lhs = this.l90_1;
    var tmp;
    if (tmp0_elvis_lhs == null) {
      return Unit_instance;
    } else {
      tmp = tmp0_elvis_lhs;
    }
    var owner = tmp;
    if (!this.o90_1 && !this.w8z_1) {
      owner.zbd(this, true, forceRequest, scheduleMeasureAndLayout);
      if (invalidateIntrinsics) {
        ensureNotNull(this.oau()).xbd(forceRequest);
      }
    }
  };
  protoOf(LayoutNode).bax = function (forceRequest, scheduleMeasureAndLayout, invalidateIntrinsics, $super) {
    forceRequest = forceRequest === VOID ? false : forceRequest;
    scheduleMeasureAndLayout = scheduleMeasureAndLayout === VOID ? true : scheduleMeasureAndLayout;
    invalidateIntrinsics = invalidateIntrinsics === VOID ? true : invalidateIntrinsics;
    var tmp;
    if ($super === VOID) {
      this.ybd(forceRequest, scheduleMeasureAndLayout, invalidateIntrinsics);
      tmp = Unit_instance;
    } else {
      tmp = $super.ybd.call(this, forceRequest, scheduleMeasureAndLayout, invalidateIntrinsics);
    }
    return tmp;
  };
  protoOf(LayoutNode).bb0 = function () {
    if (this.w8z_1) {
      var tmp0_safe_receiver = this.f9a();
      if (tmp0_safe_receiver == null)
        null;
      else {
        tmp0_safe_receiver.bb0();
      }
      return Unit_instance;
    }
    if (!(this.f90_1 == null)) {
      this.bax();
    } else {
      this.wav();
    }
  };
  protoOf(LayoutNode).abe = function () {
    if (this.n91_1 === 0 || this.ubd() || this.aax() || this.m91_1)
      return Unit_instance;
    requireOwner_0(this).bbe(this);
  };
  protoOf(LayoutNode).cbe = function (coordinator) {
    var tmp0_safe_receiver = this.l90_1;
    var rectManager = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.xam();
    var placementPending = !this.zav().equals(LayoutState_Idle_getInstance()) || this.aax() || this.ubd();
    if (this.c90_1 && !(rectManager == null)) {
      if (coordinator === this.hak()) {
        this.b90_1 = true;
        if (!placementPending) {
          rectManager.tbb(this);
        }
      } else {
        this.a90_1 = true;
        // Inline function 'androidx.compose.ui.node.LayoutNode.forEachChild' call
        // Inline function 'androidx.compose.runtime.collection.MutableVector.forEach' call
        var this_0 = this.rb1();
        var i = 0;
        var tmp = this_0.b3e_1;
        var content = isArray(tmp) ? tmp : THROW_CCE();
        var size = this_0.d3e_1;
        while (i < size) {
          var it = content[i];
          it.b90_1 = true;
          if (!placementPending) {
            rectManager.tbb(it);
          }
          i = i + 1 | 0;
        }
        rectManager.dbe(this);
      }
    }
    this.e91_1.mba_1.ebe();
  };
  protoOf(LayoutNode).tbd = function (forceRequest) {
    if (!this.w8z_1) {
      var tmp0_safe_receiver = this.l90_1;
      if (tmp0_safe_receiver == null)
        null;
      else {
        tmp0_safe_receiver.fbe(this, VOID, forceRequest);
      }
    }
  };
  protoOf(LayoutNode).fb8 = function (forceRequest, $super) {
    forceRequest = forceRequest === VOID ? false : forceRequest;
    var tmp;
    if ($super === VOID) {
      this.tbd(forceRequest);
      tmp = Unit_instance;
    } else {
      tmp = $super.tbd.call(this, forceRequest);
    }
    return tmp;
  };
  protoOf(LayoutNode).rbd = function (forceRequest) {
    if (!this.w8z_1) {
      var tmp0_safe_receiver = this.l90_1;
      if (tmp0_safe_receiver == null)
        null;
      else {
        tmp0_safe_receiver.gbe(this, true, forceRequest);
      }
    }
  };
  protoOf(LayoutNode).hbe = function (forceRequest, $super) {
    forceRequest = forceRequest === VOID ? false : forceRequest;
    var tmp;
    if ($super === VOID) {
      this.rbd(forceRequest);
      tmp = Unit_instance;
    } else {
      tmp = $super.rbd.call(this, forceRequest);
    }
    return tmp;
  };
  protoOf(LayoutNode).ibe = function () {
    if (!this.zav().equals(LayoutState_Idle_getInstance()) || this.ubd() || this.aax() || this.o91_1) {
      return Unit_instance;
    }
    if (!this.b9i()) {
      return Unit_instance;
    }
    var tmp0 = this.d91_1;
    // Inline function 'androidx.compose.ui.node.Nodes.GlobalPositionAware' call
    // Inline function 'androidx.compose.ui.node.NodeChain.headToTail' call
    var type = _NodeKind___init__impl__ojsprp(256);
    var tmp2 = _NodeKind___get_mask__impl__1uopb6(type);
    $l$block_0: {
      // Inline function 'androidx.compose.ui.node.NodeChain.headToTail' call
      if ((access$_get_aggregateChildKindSet__pv81sw(tmp0) & tmp2) === 0) {
        break $l$block_0;
      }
      // Inline function 'androidx.compose.ui.node.NodeChain.headToTail' call
      var node = tmp0.j99_1;
      while (!(node == null)) {
        var it = node;
        if (!((it.o8v_1 & tmp2) === 0)) {
          // Inline function 'androidx.compose.ui.node.dispatchForKind' call
          // Inline function 'androidx.compose.ui.node.dispatchForKind' call
          var stack = null;
          var node_0 = it;
          $l$loop: while (!(node_0 == null)) {
            var tmp;
            if (isInterface(node_0, GlobalPositionAwareModifierNode)) {
              var it_0 = node_0;
              // Inline function 'androidx.compose.ui.node.Nodes.GlobalPositionAware' call
              var tmp$ret$9 = _NodeKind___init__impl__ojsprp(256);
              it_0.eam(requireCoordinator(it_0, tmp$ret$9));
              tmp = false;
            } else {
              tmp = true;
            }
            var dispatchAgain = tmp;
            var tmp_0;
            var tmp_1;
            if (dispatchAgain || false) {
              // Inline function 'androidx.compose.ui.Node.isKind' call
              tmp_1 = !((node_0.o8v_1 & _NodeKind___get_mask__impl__1uopb6(type)) === 0);
            } else {
              tmp_1 = false;
            }
            if (tmp_1) {
              tmp_0 = node_0 instanceof DelegatingNode;
            } else {
              tmp_0 = false;
            }
            if (tmp_0) {
              var count = 0;
              // Inline function 'androidx.compose.ui.node.DelegatingNode.forEachImmediateDelegate' call
              var node_1 = node_0.e9a_1;
              while (!(node_1 == null)) {
                var next = node_1;
                // Inline function 'androidx.compose.ui.Node.isKind' call
                if (!((next.o8v_1 & _NodeKind___get_mask__impl__1uopb6(type)) === 0)) {
                  count = count + 1 | 0;
                  if (count === 1) {
                    node_0 = next;
                  } else {
                    var tmp0_elvis_lhs = stack;
                    var tmp_2;
                    if (tmp0_elvis_lhs == null) {
                      // Inline function 'androidx.compose.runtime.collection.mutableVectorOf' call
                      // Inline function 'androidx.compose.runtime.collection.MutableVector' call
                      // Inline function 'kotlin.arrayOfNulls' call
                      var tmp$ret$16 = Array(16);
                      tmp_2 = new MutableVector(tmp$ret$16, 0);
                    } else {
                      tmp_2 = tmp0_elvis_lhs;
                    }
                    stack = tmp_2;
                    var theNode = node_0;
                    if (!(theNode == null)) {
                      var tmp1_safe_receiver = stack;
                      if (tmp1_safe_receiver == null)
                        null;
                      else
                        tmp1_safe_receiver.zz(theNode);
                      node_0 = null;
                    }
                    var tmp2_safe_receiver = stack;
                    if (tmp2_safe_receiver == null)
                      null;
                    else
                      tmp2_safe_receiver.zz(next);
                  }
                }
                node_1 = node_1.r8v_1;
              }
              if (count === 1) {
                continue $l$loop;
              }
            }
            node_0 = access$pop$tDelegatableNodeKt(stack);
          }
        }
        if ((it.p8v_1 & tmp2) === 0) {
          break $l$block_0;
        }
        node = node.r8v_1;
      }
    }
  };
  protoOf(LayoutNode).zba = function () {
    // Inline function 'androidx.compose.ui.node.LayoutNode.forEachCoordinator' call
    var coordinator = this.hak();
    var inner = this.car();
    while (!(coordinator === inner)) {
      var tmp0_safe_receiver = (coordinator instanceof LayoutModifierNodeCoordinator ? coordinator : THROW_CCE()).o95_1;
      if (tmp0_safe_receiver == null)
        null;
      else {
        tmp0_safe_receiver.m40();
      }
      coordinator = coordinator.s94_1;
    }
    var tmp0_safe_receiver_0 = this.car().o95_1;
    if (tmp0_safe_receiver_0 == null)
      null;
    else {
      tmp0_safe_receiver_0.m40();
    }
  };
  protoOf(LayoutNode).jbe = function (constraints) {
    var tmp;
    var tmp_0;
    var tmp_1 = constraints;
    if (!((tmp_1 == null ? null : new Constraints_0(tmp_1)) == null)) {
      tmp_0 = !(this.f90_1 == null);
    } else {
      tmp_0 = false;
    }
    if (tmp_0) {
      tmp = ensureNotNull(this.oau()).kbe(constraints);
    } else {
      tmp = false;
    }
    return tmp;
  };
  protoOf(LayoutNode).lbe = function (constraints, $super) {
    constraints = constraints === VOID ? this.e91_1.mbe() : constraints;
    var tmp;
    if ($super === VOID) {
      tmp = this.jbe(constraints);
    } else {
      var tmp_0 = $super.jbe;
      var tmp_1 = constraints;
      tmp = tmp_0.call(this, tmp_1 == null ? null : new Constraints_0(tmp_1));
    }
    return tmp;
  };
  protoOf(LayoutNode).nbe = function (constraints) {
    var tmp;
    var tmp_0 = constraints;
    if (!((tmp_0 == null ? null : new Constraints_0(tmp_0)) == null)) {
      if (this.a91_1.equals(UsageByParent_NotUsed_getInstance())) {
        this.obe();
      }
      tmp = this.nau().kbe(constraints);
    } else {
      tmp = false;
    }
    return tmp;
  };
  protoOf(LayoutNode).pbe = function (constraints, $super) {
    constraints = constraints === VOID ? this.e91_1.qbe() : constraints;
    var tmp;
    if ($super === VOID) {
      tmp = this.nbe(constraints);
    } else {
      var tmp_0 = $super.nbe;
      var tmp_1 = constraints;
      tmp = tmp_0.call(this, tmp_1 == null ? null : new Constraints_0(tmp_1));
    }
    return tmp;
  };
  protoOf(LayoutNode).aax = function () {
    return this.e91_1.aax();
  };
  protoOf(LayoutNode).ubd = function () {
    return this.e91_1.ubd();
  };
  protoOf(LayoutNode).cax = function () {
    return this.e91_1.bba_1;
  };
  protoOf(LayoutNode).sbd = function () {
    return this.e91_1.cba_1;
  };
  protoOf(LayoutNode).rbe = function () {
    return this.e91_1.rbe();
  };
  protoOf(LayoutNode).sbe = function () {
    return this.e91_1.sbe();
  };
  protoOf(LayoutNode).tbe = function () {
    return this.e91_1.tbe();
  };
  protoOf(LayoutNode).ube = function () {
    return this.e91_1.ube();
  };
  protoOf(LayoutNode).ob8 = function () {
    if (!(this.f90_1 == null)) {
      this.bax(VOID, false);
    } else {
      this.wav(VOID, false);
    }
    var lastConstraints = this.e91_1.qbe();
    var tmp = lastConstraints;
    if (!((tmp == null ? null : new Constraints_0(tmp)) == null)) {
      var tmp0_safe_receiver = this.l90_1;
      if (tmp0_safe_receiver == null)
        null;
      else {
        tmp0_safe_receiver.wbe(this, lastConstraints);
      }
    } else {
      var tmp1_safe_receiver = this.l90_1;
      if (tmp1_safe_receiver == null)
        null;
      else {
        tmp1_safe_receiver.vbe();
      }
    }
  };
  protoOf(LayoutNode).hb0 = function () {
    var tmp0 = this.car();
    // Inline function 'androidx.compose.ui.node.Nodes.OnPlaced' call
    // Inline function 'androidx.compose.ui.node.NodeCoordinator.visitNodes' call
    var type = _NodeKind___init__impl__ojsprp(4194304);
    var tmp2 = _NodeKind___get_mask__impl__1uopb6(type);
    var tmp4 = get_includeSelfInTraversal(type);
    $l$block_0: {
      // Inline function 'androidx.compose.ui.node.NodeCoordinator.visitNodes' call
      var tmp;
      if (tmp4) {
        tmp = tmp0.qb1();
      } else {
        var tmp0_elvis_lhs = tmp0.qb1().q8v_1;
        var tmp_0;
        if (tmp0_elvis_lhs == null) {
          break $l$block_0;
        } else {
          tmp_0 = tmp0_elvis_lhs;
        }
        tmp = tmp_0;
      }
      var stopNode = tmp;
      var node = access$headNode(tmp0, tmp4);
      $l$loop_0: while (!(node == null)) {
        if ((node.p8v_1 & tmp2) === 0) {
          break $l$block_0;
        }
        if (!((node.o8v_1 & tmp2) === 0)) {
          // Inline function 'androidx.compose.ui.node.dispatchForKind' call
          // Inline function 'androidx.compose.ui.node.dispatchForKind' call
          var stack = null;
          var node_0 = node;
          $l$loop: while (!(node_0 == null)) {
            var tmp_1;
            if (isInterface(node_0, LayoutAwareModifierNode)) {
              node_0.x91(this.car());
              tmp_1 = false;
            } else {
              tmp_1 = true;
            }
            var dispatchAgain = tmp_1;
            var tmp_2;
            var tmp_3;
            if (dispatchAgain || false) {
              // Inline function 'androidx.compose.ui.Node.isKind' call
              tmp_3 = !((node_0.o8v_1 & _NodeKind___get_mask__impl__1uopb6(type)) === 0);
            } else {
              tmp_3 = false;
            }
            if (tmp_3) {
              tmp_2 = node_0 instanceof DelegatingNode;
            } else {
              tmp_2 = false;
            }
            if (tmp_2) {
              var count = 0;
              // Inline function 'androidx.compose.ui.node.DelegatingNode.forEachImmediateDelegate' call
              var node_1 = node_0.e9a_1;
              while (!(node_1 == null)) {
                var next = node_1;
                // Inline function 'androidx.compose.ui.Node.isKind' call
                if (!((next.o8v_1 & _NodeKind___get_mask__impl__1uopb6(type)) === 0)) {
                  count = count + 1 | 0;
                  if (count === 1) {
                    node_0 = next;
                  } else {
                    var tmp0_elvis_lhs_0 = stack;
                    var tmp_4;
                    if (tmp0_elvis_lhs_0 == null) {
                      // Inline function 'androidx.compose.runtime.collection.mutableVectorOf' call
                      // Inline function 'androidx.compose.runtime.collection.MutableVector' call
                      // Inline function 'kotlin.arrayOfNulls' call
                      var tmp$ret$13 = Array(16);
                      tmp_4 = new MutableVector(tmp$ret$13, 0);
                    } else {
                      tmp_4 = tmp0_elvis_lhs_0;
                    }
                    stack = tmp_4;
                    var theNode = node_0;
                    if (!(theNode == null)) {
                      var tmp1_safe_receiver = stack;
                      if (tmp1_safe_receiver == null)
                        null;
                      else
                        tmp1_safe_receiver.zz(theNode);
                      node_0 = null;
                    }
                    var tmp2_safe_receiver = stack;
                    if (tmp2_safe_receiver == null)
                      null;
                    else
                      tmp2_safe_receiver.zz(next);
                  }
                }
                node_1 = node_1.r8v_1;
              }
              if (count === 1) {
                continue $l$loop;
              }
            }
            node_0 = access$pop$tDelegatableNodeKt(stack);
          }
        }
        if (node === stopNode)
          break $l$loop_0;
        node = node.r8v_1;
      }
    }
  };
  protoOf(LayoutNode).obe = function () {
    this.b91_1 = this.a91_1;
    this.a91_1 = UsageByParent_NotUsed_getInstance();
    // Inline function 'androidx.compose.ui.node.LayoutNode.forEachChild' call
    // Inline function 'androidx.compose.runtime.collection.MutableVector.forEach' call
    var this_0 = this.rb1();
    var i = 0;
    var tmp = this_0.b3e_1;
    var content = isArray(tmp) ? tmp : THROW_CCE();
    var size = this_0.d3e_1;
    while (i < size) {
      var it = content[i];
      if (!it.a91_1.equals(UsageByParent_NotUsed_getInstance())) {
        it.obe();
      }
      i = i + 1 | 0;
    }
  };
  protoOf(LayoutNode).xbe = function () {
    // Inline function 'androidx.compose.ui.node.LayoutNode.forEachChild' call
    // Inline function 'androidx.compose.runtime.collection.MutableVector.forEach' call
    var this_0 = this.rb1();
    var i = 0;
    var tmp = this_0.b3e_1;
    var content = isArray(tmp) ? tmp : THROW_CCE();
    var size = this_0.d3e_1;
    while (i < size) {
      var it = content[i];
      it.a91_1 = it.b91_1;
      if (!it.a91_1.equals(UsageByParent_NotUsed_getInstance())) {
        it.xbe();
      }
      i = i + 1 | 0;
    }
  };
  protoOf(LayoutNode).p2y = function () {
    // Inline function 'androidx.compose.ui.internal.requirePrecondition' call
    if (!this.y91()) {
      var tmp$ret$1 = 'onReuse is only expected on attached node';
      throwIllegalArgumentException(tmp$ret$1);
    }
    var tmp0_safe_receiver = this.m90_1;
    if (tmp0_safe_receiver == null)
      null;
    else {
      tmp0_safe_receiver.p2y();
    }
    var tmp1_safe_receiver = this.f91_1;
    if (tmp1_safe_receiver == null)
      null;
    else {
      tmp1_safe_receiver.p2y();
    }
    this.r90_1 = false;
    if (this.o91_1) {
      this.o91_1 = false;
    } else {
      resetModifierState(this);
    }
    var oldSemanticsId = this.x8z_1;
    var tmp2_safe_receiver = this.l90_1;
    var tmp3_safe_receiver = tmp2_safe_receiver == null ? null : tmp2_safe_receiver.xam();
    if (tmp3_safe_receiver == null)
      null;
    else {
      tmp3_safe_receiver.bbc(this);
    }
    this.x8z_1 = generateSemanticsId();
    var tmp4_safe_receiver = this.l90_1;
    if (tmp4_safe_receiver == null)
      null;
    else {
      tmp4_safe_receiver.ybe(this, oldSemanticsId);
    }
    this.d91_1.wbb();
    this.d91_1.xbb();
    // Inline function 'androidx.compose.ui.node.Nodes.Semantics' call
    var tmp$ret$2 = _NodeKind___init__impl__ojsprp(8);
    if (this.d91_1.abb(tmp$ret$2)) {
      this.kbb();
    }
    this.qbd(this);
    var tmp5_safe_receiver = this.l90_1;
    if (tmp5_safe_receiver == null)
      null;
    else {
      tmp5_safe_receiver.zbe(this, oldSemanticsId);
    }
    var tmp6_safe_receiver = this.l90_1;
    var tmp7_safe_receiver = tmp6_safe_receiver == null ? null : tmp6_safe_receiver.xam();
    if (tmp7_safe_receiver == null)
      null;
    else {
      tmp7_safe_receiver.tbb(this);
    }
  };
  protoOf(LayoutNode).c30 = function () {
    var tmp0_safe_receiver = this.m90_1;
    if (tmp0_safe_receiver == null)
      null;
    else {
      tmp0_safe_receiver.c30();
    }
    var tmp1_safe_receiver = this.f91_1;
    if (tmp1_safe_receiver == null)
      null;
    else {
      tmp1_safe_receiver.c30();
    }
    this.o91_1 = true;
    resetModifierState(this);
    if (this.y91()) {
      this.q90_1 = null;
      this.p90_1 = false;
    }
    var tmp2_safe_receiver = this.l90_1;
    if (tmp2_safe_receiver == null)
      null;
    else {
      tmp2_safe_receiver.abf(this);
    }
  };
  protoOf(LayoutNode).d30 = function () {
    var tmp0_safe_receiver = this.m90_1;
    if (tmp0_safe_receiver == null)
      null;
    else {
      tmp0_safe_receiver.d30();
    }
    var tmp1_safe_receiver = this.f91_1;
    if (tmp1_safe_receiver == null)
      null;
    else {
      tmp1_safe_receiver.d30();
    }
    // Inline function 'androidx.compose.ui.node.LayoutNode.forEachCoordinatorIncludingInner' call
    var delegate = this.hak();
    var final = this.car().s94_1;
    while (!equals(delegate, final) && !(delegate == null)) {
      delegate.d30();
      delegate = delegate.s94_1;
    }
  };
  function requireOwner_0(_this__u8e3s4) {
    _init_properties_LayoutNode_kt__2d4f1o();
    var owner = _this__u8e3s4.l90_1;
    // Inline function 'androidx.compose.ui.internal.checkPreconditionNotNull' call
    if (owner == null) {
      var tmp$ret$1 = 'LayoutNode should be attached to an owner';
      throwIllegalStateExceptionForNullCheck(tmp$ret$1);
    }
    return owner;
  }
  var properties_initialized_LayoutNode_kt_eynwaa;
  function _init_properties_LayoutNode_kt__2d4f1o() {
    if (!properties_initialized_LayoutNode_kt_eynwaa) {
      properties_initialized_LayoutNode_kt_eynwaa = true;
      DefaultDensity = Density_0(1.0);
      androidx_compose_ui_node_LayoutNode_NoIntrinsicsMeasurePolicy$stable = 0;
      androidx_compose_ui_node_LayoutNode$stable = 8;
    }
  }
  var androidx_compose_ui_node_AlignmentLines$stable;
  var androidx_compose_ui_node_LayoutNodeAlignmentLines$stable;
  var androidx_compose_ui_node_LookaheadAlignmentLines$stable;
  function addAlignmentLine($this, alignmentLine, initialPosition, initialCoordinator) {
    // Inline function 'androidx.compose.ui.geometry.Offset' call
    // Inline function 'androidx.compose.ui.util.packFloats' call
    var v1 = fromInt(toRawBits(initialPosition));
    var v2 = fromInt(toRawBits(initialPosition));
    var tmp$ret$1 = bitwiseOr(shiftLeft(v1, 32), bitwiseAnd(v2, new Long(-1, 0)));
    var position = _Offset___init__impl__c168vi(tmp$ret$1);
    var coordinator = initialCoordinator;
    $l$loop: while (true) {
      position = $this.bbf(coordinator, position);
      coordinator = ensureNotNull(coordinator.t94_1);
      if (equals(coordinator, $this.ibc_1.cbf()))
        break $l$loop;
      // Inline function 'kotlin.collections.contains' call
      // Inline function 'kotlin.collections.containsKey' call
      var this_0 = $this.dbf(coordinator);
      if ((isInterface(this_0, KtMap) ? this_0 : THROW_CCE()).u2(alignmentLine)) {
        var newPosition = $this.ebf(coordinator, alignmentLine);
        // Inline function 'androidx.compose.ui.geometry.Offset' call
        // Inline function 'androidx.compose.ui.util.packFloats' call
        var v1_0 = fromInt(toRawBits(newPosition));
        var v2_0 = fromInt(toRawBits(newPosition));
        var tmp$ret$5 = bitwiseOr(shiftLeft(v1_0, 32), bitwiseAnd(v2_0, new Long(-1, 0)));
        position = _Offset___init__impl__c168vi(tmp$ret$5);
      }
    }
    var tmp;
    if (alignmentLine instanceof HorizontalAlignmentLine) {
      // Inline function 'androidx.compose.ui.geometry.Offset.y' call
      var this_1 = position;
      // Inline function 'androidx.compose.ui.util.unpackFloat2' call
      var value = _Offset___get_packedValue__impl__xh2k8q(this_1);
      // Inline function 'androidx.compose.ui.util.floatFromBits' call
      // Inline function 'kotlin.fromBits' call
      var bits = convertToInt(bitwiseAnd(value, new Long(-1, 0)));
      tmp = floatFromBits(bits);
    } else {
      // Inline function 'androidx.compose.ui.geometry.Offset.x' call
      var this_2 = position;
      // Inline function 'androidx.compose.ui.util.unpackFloat1' call
      var value_0 = _Offset___get_packedValue__impl__xh2k8q(this_2);
      // Inline function 'androidx.compose.ui.util.floatFromBits' call
      // Inline function 'kotlin.fromBits' call
      var bits_0 = convertToInt(shiftRight(value_0, 32));
      tmp = floatFromBits(bits_0);
    }
    // Inline function 'androidx.compose.ui.util.fastRoundToInt' call
    var this_3 = tmp;
    var tmp_0;
    if (isNaN_0(this_3)) {
      tmp_0 = 0;
    } else {
      // Inline function 'kotlin.math.roundToInt' call
      tmp_0 = roundToInt(this_3);
    }
    var positionInContainer = tmp_0;
    var tmp0 = $this.qbc_1;
    var tmp_1;
    // Inline function 'kotlin.collections.contains' call
    // Inline function 'kotlin.collections.containsKey' call
    var this_4 = $this.qbc_1;
    if ((isInterface(this_4, KtMap) ? this_4 : THROW_CCE()).u2(alignmentLine)) {
      tmp_1 = merge(alignmentLine, getValue($this.qbc_1, alignmentLine), positionInContainer);
    } else {
      tmp_1 = positionInContainer;
    }
    // Inline function 'kotlin.collections.set' call
    var value_1 = tmp_1;
    tmp0.z2(alignmentLine, value_1);
  }
  function AlignmentLines$recalculate$lambda(this$0) {
    return function (childOwner) {
      var tmp;
      if (childOwner.fbf() === 2147483647) {
        return Unit_instance;
      }
      var tmp_0;
      if (childOwner.sad().jbc_1) {
        childOwner.gbf();
        tmp_0 = Unit_instance;
      }
      // Inline function 'kotlin.collections.forEach' call
      // Inline function 'kotlin.collections.iterator' call
      var _iterator__ex2g4s = childOwner.sad().qbc_1.s1().t();
      while (_iterator__ex2g4s.u()) {
        var element = _iterator__ex2g4s.v();
        // Inline function 'kotlin.collections.component1' call
        var childLine = element.t1();
        // Inline function 'kotlin.collections.component2' call
        var linePosition = element.u1();
        addAlignmentLine(this$0, childLine, linePosition, childOwner.cbf());
      }
      var coordinator = ensureNotNull(childOwner.cbf().t94_1);
      while (!equals(coordinator, this$0.ibc_1.cbf())) {
        // Inline function 'kotlin.collections.forEach' call
        var _iterator__ex2g4s_0 = this$0.dbf(coordinator).x2().t();
        while (_iterator__ex2g4s_0.u()) {
          var element_0 = _iterator__ex2g4s_0.v();
          addAlignmentLine(this$0, element_0, this$0.ebf(coordinator, element_0), coordinator);
        }
        coordinator = ensureNotNull(coordinator.t94_1);
      }
      return Unit_instance;
    };
  }
  function AlignmentLines(alignmentLinesOwner) {
    this.ibc_1 = alignmentLinesOwner;
    this.jbc_1 = true;
    this.kbc_1 = false;
    this.lbc_1 = false;
    this.mbc_1 = false;
    this.nbc_1 = false;
    this.obc_1 = false;
    this.pbc_1 = null;
    var tmp = this;
    // Inline function 'kotlin.collections.hashMapOf' call
    tmp.qbc_1 = HashMap_init_$Create$();
  }
  protoOf(AlignmentLines).hbf = function () {
    return this.kbc_1 || this.mbc_1 || this.nbc_1 || this.obc_1;
  };
  protoOf(AlignmentLines).rbc = function () {
    this.ibf();
    return !(this.pbc_1 == null);
  };
  protoOf(AlignmentLines).ibf = function () {
    var tmp = this;
    var tmp_0;
    if (this.hbf()) {
      tmp_0 = this.ibc_1;
    } else {
      var tmp0_elvis_lhs = this.ibc_1.jbf();
      var tmp_1;
      if (tmp0_elvis_lhs == null) {
        return Unit_instance;
      } else {
        tmp_1 = tmp0_elvis_lhs;
      }
      var parent = tmp_1;
      var parentQueryOwner = parent.sad().pbc_1;
      var tmp_2;
      if (!(parentQueryOwner == null) && parentQueryOwner.sad().hbf()) {
        tmp_2 = parentQueryOwner;
      } else {
        var owner = this.pbc_1;
        if (owner == null || owner.sad().hbf())
          return Unit_instance;
        var tmp1_safe_receiver = owner.jbf();
        var tmp2_safe_receiver = tmp1_safe_receiver == null ? null : tmp1_safe_receiver.sad();
        if (tmp2_safe_receiver == null)
          null;
        else {
          tmp2_safe_receiver.ibf();
        }
        var tmp3_safe_receiver = owner.jbf();
        var tmp4_safe_receiver = tmp3_safe_receiver == null ? null : tmp3_safe_receiver.sad();
        tmp_2 = tmp4_safe_receiver == null ? null : tmp4_safe_receiver.pbc_1;
      }
      tmp_0 = tmp_2;
    }
    tmp.pbc_1 = tmp_0;
  };
  protoOf(AlignmentLines).kbf = function () {
    return this.qbc_1;
  };
  protoOf(AlignmentLines).lbf = function () {
    this.qbc_1.c3();
    this.ibc_1.mbf(AlignmentLines$recalculate$lambda(this));
    var tmp0 = this.qbc_1;
    // Inline function 'kotlin.collections.plusAssign' call
    var map = this.dbf(this.ibc_1.cbf());
    tmp0.b3(map);
    this.jbc_1 = false;
  };
  protoOf(AlignmentLines).j8w = function () {
    this.jbc_1 = true;
    this.kbc_1 = false;
    this.mbc_1 = false;
    this.lbc_1 = false;
    this.nbc_1 = false;
    this.obc_1 = false;
    this.pbc_1 = null;
  };
  protoOf(AlignmentLines).nbf = function () {
    this.jbc_1 = true;
    var tmp0_elvis_lhs = this.ibc_1.jbf();
    var tmp;
    if (tmp0_elvis_lhs == null) {
      return Unit_instance;
    } else {
      tmp = tmp0_elvis_lhs;
    }
    var parent = tmp;
    if (this.kbc_1) {
      parent.pbf();
    } else if (this.mbc_1 || this.lbc_1) {
      parent.obf();
    }
    if (this.nbc_1) {
      this.ibc_1.pbf();
    }
    if (this.obc_1) {
      this.ibc_1.obf();
    }
    parent.sad().nbf();
  };
  function LookaheadAlignmentLines(alignmentLinesOwner) {
    AlignmentLines.call(this, alignmentLinesOwner);
  }
  protoOf(LookaheadAlignmentLines).dbf = function (_this__u8e3s4) {
    return ensureNotNull(_this__u8e3s4.kac()).gag().sad();
  };
  protoOf(LookaheadAlignmentLines).ebf = function (_this__u8e3s4, alignmentLine) {
    return ensureNotNull(_this__u8e3s4.kac()).kah(alignmentLine);
  };
  protoOf(LookaheadAlignmentLines).bbf = function (_this__u8e3s4, position) {
    // Inline function 'androidx.compose.ui.unit.toOffset' call
    var this_0 = ensureNotNull(_this__u8e3s4.kac()).iak();
    var tmp0 = _IntOffset___get_x__impl__qiqr5o(this_0);
    // Inline function 'androidx.compose.ui.geometry.Offset' call
    // Inline function 'androidx.compose.ui.util.packFloats' call
    var val2 = _IntOffset___get_y__impl__2avpwj(this_0);
    var v1 = fromInt(toRawBits(tmp0));
    var v2 = fromInt(toRawBits(val2));
    var tmp$ret$2 = bitwiseOr(shiftLeft(v1, 32), bitwiseAnd(v2, new Long(-1, 0)));
    var tmp$ret$0 = _Offset___init__impl__c168vi(tmp$ret$2);
    return Offset__plus_impl_c78cg0(tmp$ret$0, position);
  };
  function LayoutNodeAlignmentLines(alignmentLinesOwner) {
    AlignmentLines.call(this, alignmentLinesOwner);
  }
  protoOf(LayoutNodeAlignmentLines).dbf = function (_this__u8e3s4) {
    return _this__u8e3s4.gag().sad();
  };
  protoOf(LayoutNodeAlignmentLines).ebf = function (_this__u8e3s4, alignmentLine) {
    return _this__u8e3s4.kah(alignmentLine);
  };
  protoOf(LayoutNodeAlignmentLines).bbf = function (_this__u8e3s4, position) {
    return _this__u8e3s4.lb7(position);
  };
  var androidx_compose_ui_node_LayoutNodeDrawScope$stable;
  function LayoutNodeDrawScope$record$lambda(this$0, $currentDrawNode, $block) {
    return function ($this$record) {
      var previousDrawNode = this$0.jbg_1;
      this$0.jbg_1 = $currentDrawNode;
      var tmp;
      try {
        var tmp0 = this$0;
        var tmp2 = $this$record.v6p().u5e();
        var tmp4 = $this$record.v6p().r6p();
        var tmp6 = $this$record.v6p().x5u();
        var tmp8 = $this$record.v6p().o5d();
        var tmp10 = $this$record.v6p().u6p();
        // Inline function 'androidx.compose.ui.graphics.drawscope.draw' call
        var block = $block;
        var prevDensity = tmp0.v6p().u5e();
        var prevLayoutDirection = tmp0.v6p().r6p();
        var prevCanvas = tmp0.v6p().x5u();
        var prevSize = tmp0.v6p().o5d();
        var prevLayer = tmp0.v6p().u6p();
        // Inline function 'kotlin.apply' call
        var this_0 = tmp0.v6p();
        this_0.s6p(tmp2);
        this_0.q6p(tmp4);
        this_0.n6p(tmp6);
        this_0.o6p(tmp8);
        this_0.t6p(tmp10);
        tmp6.t6d();
        try {
          block(tmp0);
        }finally {
          tmp6.u6d();
          // Inline function 'kotlin.apply' call
          var this_1 = tmp0.v6p();
          this_1.s6p(prevDensity);
          this_1.q6p(prevLayoutDirection);
          this_1.n6p(prevCanvas);
          this_1.o6p(prevSize);
          this_1.t6p(prevLayer);
        }
        tmp = Unit_instance;
      }finally {
        this$0.jbg_1 = previousDrawNode;
      }
      return Unit_instance;
    };
  }
  function LayoutNodeDrawScope(canvasDrawScope) {
    canvasDrawScope = canvasDrawScope === VOID ? new CanvasDrawScope() : canvasDrawScope;
    this.ibg_1 = canvasDrawScope;
    this.jbg_1 = null;
  }
  protoOf(LayoutNodeDrawScope).z91 = function () {
    // Inline function 'androidx.compose.ui.graphics.drawscope.drawIntoCanvas' call
    var canvas = this.v6p().x5u();
    // Inline function 'androidx.compose.ui.internal.checkPreconditionNotNull' call
    var value = this.jbg_1;
    if (value == null) {
      var tmp$ret$3 = 'Attempting to drawContent for a `null` node. This usually means that a call to ContentDrawScope#drawContent() has been captured inside a lambda, and is being invoked outside of the draw pass. Capturing the scope this way is unsupported - if you are trying to record drawContent with graphicsLayer.record(), make sure you are using the GraphicsLayer#record function within DrawScope, instead of the member function on GraphicsLayer.';
      throwIllegalStateExceptionForNullCheck(tmp$ret$3);
    }
    var drawNode = value;
    var nextDrawNode_0 = nextDrawNode(drawNode);
    if (!(nextDrawNode_0 == null)) {
      // Inline function 'androidx.compose.ui.node.Nodes.Draw' call
      // Inline function 'androidx.compose.ui.node.dispatchForKind' call
      // Inline function 'androidx.compose.ui.node.dispatchForKind' call
      var kind = _NodeKind___init__impl__ojsprp(4);
      var stack = null;
      var node = nextDrawNode_0;
      $l$loop: while (!(node == null)) {
        var tmp;
        if (isInterface(node, DrawModifierNode)) {
          var it = node;
          this.kbg(it, canvas, this.v6p().u6p());
          tmp = false;
        } else {
          tmp = true;
        }
        var dispatchAgain = tmp;
        var tmp_0;
        var tmp_1;
        if (dispatchAgain || false) {
          // Inline function 'androidx.compose.ui.Node.isKind' call
          tmp_1 = !((node.o8v_1 & _NodeKind___get_mask__impl__1uopb6(kind)) === 0);
        } else {
          tmp_1 = false;
        }
        if (tmp_1) {
          tmp_0 = node instanceof DelegatingNode;
        } else {
          tmp_0 = false;
        }
        if (tmp_0) {
          var count = 0;
          // Inline function 'androidx.compose.ui.node.DelegatingNode.forEachImmediateDelegate' call
          var node_0 = node.e9a_1;
          while (!(node_0 == null)) {
            var next = node_0;
            // Inline function 'androidx.compose.ui.Node.isKind' call
            if (!((next.o8v_1 & _NodeKind___get_mask__impl__1uopb6(kind)) === 0)) {
              count = count + 1 | 0;
              if (count === 1) {
                node = next;
              } else {
                var tmp0_elvis_lhs = stack;
                var tmp_2;
                if (tmp0_elvis_lhs == null) {
                  // Inline function 'androidx.compose.runtime.collection.mutableVectorOf' call
                  // Inline function 'androidx.compose.runtime.collection.MutableVector' call
                  // Inline function 'kotlin.arrayOfNulls' call
                  var tmp$ret$14 = Array(16);
                  tmp_2 = new MutableVector(tmp$ret$14, 0);
                } else {
                  tmp_2 = tmp0_elvis_lhs;
                }
                stack = tmp_2;
                var theNode = node;
                if (!(theNode == null)) {
                  var tmp1_safe_receiver = stack;
                  if (tmp1_safe_receiver == null)
                    null;
                  else
                    tmp1_safe_receiver.zz(theNode);
                  node = null;
                }
                var tmp2_safe_receiver = stack;
                if (tmp2_safe_receiver == null)
                  null;
                else
                  tmp2_safe_receiver.zz(next);
              }
            }
            node_0 = node_0.r8v_1;
          }
          if (count === 1) {
            continue $l$loop;
          }
        }
        node = access$pop$tDelegatableNodeKt(stack);
      }
    } else {
      // Inline function 'androidx.compose.ui.node.Nodes.Draw' call
      var tmp$ret$15 = _NodeKind___init__impl__ojsprp(4);
      var coordinator = requireCoordinator(drawNode, tmp$ret$15);
      var nextCoordinator = coordinator.qb1() === drawNode.f4n() ? ensureNotNull(coordinator.s94_1) : coordinator;
      nextCoordinator.mb6(canvas, this.v6p().u6p());
    }
  };
  protoOf(LayoutNodeDrawScope).n6q = function (_this__u8e3s4, size, block) {
    var currentDrawNode = this.jbg_1;
    var tmp = this.r6p();
    _this__u8e3s4.e6s(this, tmp, size, LayoutNodeDrawScope$record$lambda(this, currentDrawNode, block));
  };
  protoOf(LayoutNodeDrawScope).kbg = function (_this__u8e3s4, canvas, layer) {
    // Inline function 'androidx.compose.ui.node.Nodes.Draw' call
    var tmp$ret$0 = _NodeKind___init__impl__ojsprp(4);
    var coordinator = requireCoordinator(_this__u8e3s4, tmp$ret$0);
    var size = toSize(coordinator.q95());
    var drawScope = coordinator.a9i().tbc();
    drawScope.lbg(canvas, size, coordinator, _this__u8e3s4, layer);
  };
  protoOf(LayoutNodeDrawScope).mbg = function (canvas, size, coordinator, drawNode, layer) {
    // Inline function 'androidx.compose.ui.node.Nodes.Draw' call
    // Inline function 'androidx.compose.ui.node.dispatchForKind' call
    // Inline function 'androidx.compose.ui.node.dispatchForKind' call
    var kind = _NodeKind___init__impl__ojsprp(4);
    var stack = null;
    var node = drawNode;
    $l$loop: while (!(node == null)) {
      var tmp;
      if (isInterface(node, DrawModifierNode)) {
        var it = node;
        this.lbg(canvas, size, coordinator, it, layer);
        tmp = false;
      } else {
        tmp = true;
      }
      var dispatchAgain = tmp;
      var tmp_0;
      var tmp_1;
      if (dispatchAgain || false) {
        // Inline function 'androidx.compose.ui.Node.isKind' call
        tmp_1 = !((node.o8v_1 & _NodeKind___get_mask__impl__1uopb6(kind)) === 0);
      } else {
        tmp_1 = false;
      }
      if (tmp_1) {
        tmp_0 = node instanceof DelegatingNode;
      } else {
        tmp_0 = false;
      }
      if (tmp_0) {
        var count = 0;
        // Inline function 'androidx.compose.ui.node.DelegatingNode.forEachImmediateDelegate' call
        var node_0 = node.e9a_1;
        while (!(node_0 == null)) {
          var next = node_0;
          // Inline function 'androidx.compose.ui.Node.isKind' call
          if (!((next.o8v_1 & _NodeKind___get_mask__impl__1uopb6(kind)) === 0)) {
            count = count + 1 | 0;
            if (count === 1) {
              node = next;
            } else {
              var tmp0_elvis_lhs = stack;
              var tmp_2;
              if (tmp0_elvis_lhs == null) {
                // Inline function 'androidx.compose.runtime.collection.mutableVectorOf' call
                // Inline function 'androidx.compose.runtime.collection.MutableVector' call
                // Inline function 'kotlin.arrayOfNulls' call
                var tmp$ret$10 = Array(16);
                tmp_2 = new MutableVector(tmp$ret$10, 0);
              } else {
                tmp_2 = tmp0_elvis_lhs;
              }
              stack = tmp_2;
              var theNode = node;
              if (!(theNode == null)) {
                var tmp1_safe_receiver = stack;
                if (tmp1_safe_receiver == null)
                  null;
                else
                  tmp1_safe_receiver.zz(theNode);
                node = null;
              }
              var tmp2_safe_receiver = stack;
              if (tmp2_safe_receiver == null)
                null;
              else
                tmp2_safe_receiver.zz(next);
            }
          }
          node_0 = node_0.r8v_1;
        }
        if (count === 1) {
          continue $l$loop;
        }
      }
      node = access$pop$tDelegatableNodeKt(stack);
    }
  };
  protoOf(LayoutNodeDrawScope).lbg = function (canvas, size, coordinator, drawNode, layer) {
    var previousDrawNode = this.jbg_1;
    this.jbg_1 = drawNode;
    var tmp0 = this.ibg_1;
    // Inline function 'androidx.compose.ui.graphics.drawscope.draw' call
    var layoutDirection = coordinator.r6p();
    var prevDensity = tmp0.v6p().u5e();
    var prevLayoutDirection = tmp0.v6p().r6p();
    var prevCanvas = tmp0.v6p().x5u();
    var prevSize = tmp0.v6p().o5d();
    var prevLayer = tmp0.v6p().u6p();
    // Inline function 'kotlin.apply' call
    var this_0 = tmp0.v6p();
    this_0.s6p(coordinator);
    this_0.q6p(layoutDirection);
    this_0.n6p(canvas);
    this_0.o6p(size);
    this_0.t6p(layer);
    canvas.t6d();
    try {
      // Inline function 'kotlin.with' call
      drawNode.h92(this);
    }finally {
      canvas.u6d();
      // Inline function 'kotlin.apply' call
      var this_1 = tmp0.v6p();
      this_1.s6p(prevDensity);
      this_1.q6p(prevLayoutDirection);
      this_1.n6p(prevCanvas);
      this_1.o6p(prevSize);
      this_1.t6p(prevLayer);
    }
    this.jbg_1 = previousDrawNode;
  };
  protoOf(LayoutNodeDrawScope).w6p = function (brush, start, end, strokeWidth, cap, pathEffect, alpha, colorFilter, blendMode) {
    this.ibg_1.w6p(brush, start, end, strokeWidth, cap, pathEffect, alpha, colorFilter, blendMode);
  };
  protoOf(LayoutNodeDrawScope).y6p = function (color, start, end, strokeWidth, cap, pathEffect, alpha, colorFilter, blendMode) {
    this.ibg_1.y6p(color, start, end, strokeWidth, cap, pathEffect, alpha, colorFilter, blendMode);
  };
  protoOf(LayoutNodeDrawScope).g6i = function (brush, topLeft, size, alpha, style, colorFilter, blendMode) {
    this.ibg_1.g6i(brush, topLeft, size, alpha, style, colorFilter, blendMode);
  };
  protoOf(LayoutNodeDrawScope).b6i = function (color, topLeft, size, alpha, style, colorFilter, blendMode) {
    this.ibg_1.b6i(color, topLeft, size, alpha, style, colorFilter, blendMode);
  };
  protoOf(LayoutNodeDrawScope).c6q = function (image, srcOffset, srcSize, dstOffset, dstSize, alpha, style, colorFilter, blendMode, filterQuality) {
    this.ibg_1.c6q(image, srcOffset, srcSize, dstOffset, dstSize, alpha, style, colorFilter, blendMode, filterQuality);
  };
  protoOf(LayoutNodeDrawScope).f6i = function (brush, topLeft, size, cornerRadius, alpha, style, colorFilter, blendMode) {
    this.ibg_1.f6i(brush, topLeft, size, cornerRadius, alpha, style, colorFilter, blendMode);
  };
  protoOf(LayoutNodeDrawScope).a6i = function (color, topLeft, size, cornerRadius, style, alpha, colorFilter, blendMode) {
    this.ibg_1.a6i(color, topLeft, size, cornerRadius, style, alpha, colorFilter, blendMode);
  };
  protoOf(LayoutNodeDrawScope).g6q = function (color, radius, center, alpha, style, colorFilter, blendMode) {
    this.ibg_1.g6q(color, radius, center, alpha, style, colorFilter, blendMode);
  };
  protoOf(LayoutNodeDrawScope).i6q = function (color, startAngle, sweepAngle, useCenter, topLeft, size, alpha, style, colorFilter, blendMode) {
    this.ibg_1.i6q(color, startAngle, sweepAngle, useCenter, topLeft, size, alpha, style, colorFilter, blendMode);
  };
  protoOf(LayoutNodeDrawScope).z6h = function (path, color, alpha, style, colorFilter, blendMode) {
    this.ibg_1.z6h(path, color, alpha, style, colorFilter, blendMode);
  };
  protoOf(LayoutNodeDrawScope).e6i = function (path, brush, alpha, style, colorFilter, blendMode) {
    this.ibg_1.e6i(path, brush, alpha, style, colorFilter, blendMode);
  };
  protoOf(LayoutNodeDrawScope).v6p = function () {
    return this.ibg_1.i6o_1;
  };
  protoOf(LayoutNodeDrawScope).m6q = function () {
    return this.ibg_1.m6q();
  };
  protoOf(LayoutNodeDrawScope).o5d = function () {
    return this.ibg_1.o5d();
  };
  protoOf(LayoutNodeDrawScope).r6p = function () {
    return this.ibg_1.r6p();
  };
  protoOf(LayoutNodeDrawScope).v5e = function (_this__u8e3s4) {
    return this.ibg_1.v5e(_this__u8e3s4);
  };
  protoOf(LayoutNodeDrawScope).x5e = function (_this__u8e3s4) {
    return this.ibg_1.x5e(_this__u8e3s4);
  };
  protoOf(LayoutNodeDrawScope).w5e = function (_this__u8e3s4) {
    return this.ibg_1.w5e(_this__u8e3s4);
  };
  protoOf(LayoutNodeDrawScope).c5f = function (_this__u8e3s4) {
    return this.ibg_1.c5f(_this__u8e3s4);
  };
  protoOf(LayoutNodeDrawScope).d5f = function (_this__u8e3s4) {
    return this.ibg_1.d5f(_this__u8e3s4);
  };
  protoOf(LayoutNodeDrawScope).e5f = function (_this__u8e3s4) {
    return this.ibg_1.e5f(_this__u8e3s4);
  };
  protoOf(LayoutNodeDrawScope).b5f = function (_this__u8e3s4) {
    return this.ibg_1.b5f(_this__u8e3s4);
  };
  protoOf(LayoutNodeDrawScope).f5f = function (_this__u8e3s4) {
    return this.ibg_1.f5f(_this__u8e3s4);
  };
  protoOf(LayoutNodeDrawScope).g5f = function (_this__u8e3s4) {
    return this.ibg_1.g5f(_this__u8e3s4);
  };
  protoOf(LayoutNodeDrawScope).u5e = function () {
    return this.ibg_1.u5e();
  };
  protoOf(LayoutNodeDrawScope).j5f = function () {
    return this.ibg_1.j5f();
  };
  function nextDrawNode(_this__u8e3s4) {
    // Inline function 'androidx.compose.ui.node.Nodes.Draw' call
    var tmp$ret$0 = _NodeKind___init__impl__ojsprp(4);
    var drawMask = _NodeKind___get_mask__impl__1uopb6(tmp$ret$0);
    // Inline function 'androidx.compose.ui.node.Nodes.Layout' call
    var tmp$ret$1 = _NodeKind___init__impl__ojsprp(2);
    var measureMask = _NodeKind___get_mask__impl__1uopb6(tmp$ret$1);
    var tmp0_elvis_lhs = _this__u8e3s4.f4n().r8v_1;
    var tmp;
    if (tmp0_elvis_lhs == null) {
      return null;
    } else {
      tmp = tmp0_elvis_lhs;
    }
    var child = tmp;
    if ((child.p8v_1 & drawMask) === 0)
      return null;
    var next = child;
    while (!(next == null)) {
      if (!((next.o8v_1 & measureMask) === 0))
        return null;
      if (!((next.o8v_1 & drawMask) === 0)) {
        return next;
      }
      next = next.r8v_1;
    }
    return null;
  }
  var androidx_compose_ui_node_LayoutNodeLayoutDelegate$stable;
  function MotionReferencePlacementDelegate() {
  }
  function LayoutNodeLayoutDelegate(layoutNode) {
    this.xb9_1 = layoutNode;
    this.yb9_1 = false;
    this.zb9_1 = false;
    this.aba_1 = LayoutState_Idle_getInstance();
    this.bba_1 = false;
    this.cba_1 = false;
    this.dba_1 = false;
    this.eba_1 = 0;
    this.fba_1 = 0;
    this.gba_1 = false;
    this.hba_1 = false;
    this.iba_1 = 0;
    this.jba_1 = false;
    this.kba_1 = false;
    this.lba_1 = 0;
    this.mba_1 = new MeasurePassDelegate(this);
    this.nba_1 = null;
  }
  protoOf(LayoutNodeLayoutDelegate).nbg = function () {
    return this.xb9_1.d91_1.h99_1;
  };
  protoOf(LayoutNodeLayoutDelegate).qbe = function () {
    return this.mba_1.qbe();
  };
  protoOf(LayoutNodeLayoutDelegate).mbe = function () {
    var tmp0_safe_receiver = this.nba_1;
    return tmp0_safe_receiver == null ? null : tmp0_safe_receiver.qbe();
  };
  protoOf(LayoutNodeLayoutDelegate).fbc = function () {
    return this.mba_1.j8y_1;
  };
  protoOf(LayoutNodeLayoutDelegate).ebc = function () {
    return this.mba_1.i8y_1;
  };
  protoOf(LayoutNodeLayoutDelegate).aax = function () {
    return this.mba_1.uat_1;
  };
  protoOf(LayoutNodeLayoutDelegate).ubd = function () {
    return this.mba_1.vat_1;
  };
  protoOf(LayoutNodeLayoutDelegate).rbe = function () {
    this.mba_1.obg();
  };
  protoOf(LayoutNodeLayoutDelegate).sbe = function () {
    this.mba_1.sbe();
  };
  protoOf(LayoutNodeLayoutDelegate).tbe = function () {
    this.cba_1 = true;
    this.dba_1 = true;
  };
  protoOf(LayoutNodeLayoutDelegate).ube = function () {
    this.bba_1 = true;
  };
  protoOf(LayoutNodeLayoutDelegate).sbc = function () {
    return this.mba_1;
  };
  protoOf(LayoutNodeLayoutDelegate).hbc = function () {
    return this.nba_1;
  };
  protoOf(LayoutNodeLayoutDelegate).pbg = function (value) {
    var oldValue = this.gba_1;
    if (!(oldValue === value)) {
      this.gba_1 = value;
      if (value && !this.hba_1) {
        var _unary__edvuaz = this.iba_1;
        this.tba(_unary__edvuaz + 1 | 0);
      } else if (!value && !this.hba_1) {
        var _unary__edvuaz_0 = this.iba_1;
        this.tba(_unary__edvuaz_0 - 1 | 0);
      }
    }
  };
  protoOf(LayoutNodeLayoutDelegate).qbg = function (value) {
    var oldValue = this.hba_1;
    if (!(oldValue === value)) {
      this.hba_1 = value;
      if (value && !this.gba_1) {
        var _unary__edvuaz = this.iba_1;
        this.tba(_unary__edvuaz + 1 | 0);
      } else if (!value && !this.gba_1) {
        var _unary__edvuaz_0 = this.iba_1;
        this.tba(_unary__edvuaz_0 - 1 | 0);
      }
    }
  };
  protoOf(LayoutNodeLayoutDelegate).tba = function (value) {
    var oldValue = this.iba_1;
    this.iba_1 = value;
    if (!(oldValue === 0 === (value === 0))) {
      var tmp0_safe_receiver = this.xb9_1.f9a();
      var parentLayoutDelegate = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.e91_1;
      if (!(parentLayoutDelegate == null)) {
        if (value === 0) {
          var _unary__edvuaz = parentLayoutDelegate.iba_1;
          parentLayoutDelegate.tba(_unary__edvuaz - 1 | 0);
        } else {
          var _unary__edvuaz_0 = parentLayoutDelegate.iba_1;
          parentLayoutDelegate.tba(_unary__edvuaz_0 + 1 | 0);
        }
      }
    }
  };
  protoOf(LayoutNodeLayoutDelegate).rbg = function (value) {
    var oldValue = this.jba_1;
    if (!(oldValue === value)) {
      this.jba_1 = value;
      if (value && !this.kba_1) {
        var _unary__edvuaz = this.lba_1;
        this.sbg(_unary__edvuaz + 1 | 0);
      } else if (!value && !this.kba_1) {
        var _unary__edvuaz_0 = this.lba_1;
        this.sbg(_unary__edvuaz_0 - 1 | 0);
      }
    }
  };
  protoOf(LayoutNodeLayoutDelegate).tbg = function (value) {
    var oldValue = this.kba_1;
    if (!(oldValue === value)) {
      this.kba_1 = value;
      if (value && !this.jba_1) {
        var _unary__edvuaz = this.lba_1;
        this.sbg(_unary__edvuaz + 1 | 0);
      } else if (!value && !this.jba_1) {
        var _unary__edvuaz_0 = this.lba_1;
        this.sbg(_unary__edvuaz_0 - 1 | 0);
      }
    }
  };
  protoOf(LayoutNodeLayoutDelegate).sbg = function (value) {
    var oldValue = this.lba_1;
    this.lba_1 = value;
    if (!(oldValue === 0 === (value === 0))) {
      var tmp0_safe_receiver = this.xb9_1.f9a();
      var parentLayoutDelegate = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.e91_1;
      if (!(parentLayoutDelegate == null)) {
        if (value === 0) {
          var _unary__edvuaz = parentLayoutDelegate.lba_1;
          parentLayoutDelegate.sbg(_unary__edvuaz - 1 | 0);
        } else {
          var _unary__edvuaz_0 = parentLayoutDelegate.lba_1;
          parentLayoutDelegate.sbg(_unary__edvuaz_0 + 1 | 0);
        }
      }
    }
  };
  protoOf(LayoutNodeLayoutDelegate).ubg = function () {
    var state = this.xb9_1.zav();
    if (state.equals(LayoutState_LayingOut_getInstance()) || state.equals(LayoutState_LookaheadLayingOut_getInstance())) {
      if (this.mba_1.aau_1) {
        this.pbg(true);
      } else {
        this.qbg(true);
      }
    }
    if (state.equals(LayoutState_LookaheadLayingOut_getInstance())) {
      var tmp0_safe_receiver = this.nba_1;
      if ((tmp0_safe_receiver == null ? null : tmp0_safe_receiver.lav_1) === true) {
        this.rbg(true);
      } else {
        this.tbg(true);
      }
    }
  };
  protoOf(LayoutNodeLayoutDelegate).vbg = function (constraints) {
    var tmp0_safe_receiver = this.nba_1;
    if (tmp0_safe_receiver == null)
      null;
    else {
      tmp0_safe_receiver.wbg(constraints);
    }
  };
  protoOf(LayoutNodeLayoutDelegate).pba = function () {
    if (this.nba_1 == null) {
      this.nba_1 = new LookaheadPassDelegate(this);
    }
  };
  protoOf(LayoutNodeLayoutDelegate).cbb = function () {
    if (this.mba_1.xbg()) {
      var tmp0_safe_receiver = this.xb9_1.f9a();
      if (tmp0_safe_receiver == null)
        null;
      else {
        tmp0_safe_receiver.wav();
      }
    }
    var tmp3_safe_receiver = this.nba_1;
    if ((tmp3_safe_receiver == null ? null : tmp3_safe_receiver.xbg()) === true) {
      if (get_isOutMostLookaheadRoot(this.xb9_1)) {
        var tmp1_safe_receiver = this.xb9_1.f9a();
        if (tmp1_safe_receiver == null)
          null;
        else {
          tmp1_safe_receiver.wav();
        }
      } else {
        var tmp2_safe_receiver = this.xb9_1.f9a();
        if (tmp2_safe_receiver == null)
          null;
        else {
          tmp2_safe_receiver.bax();
        }
      }
    }
  };
  protoOf(LayoutNodeLayoutDelegate).abd = function () {
    this.mba_1.abd();
    var tmp0_safe_receiver = this.nba_1;
    if (tmp0_safe_receiver == null)
      null;
    else {
      tmp0_safe_receiver.abd();
    }
  };
  protoOf(LayoutNodeLayoutDelegate).zbb = function () {
    this.mba_1.xat_1.j8w();
    var tmp0_safe_receiver = this.nba_1;
    var tmp1_safe_receiver = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.iav_1;
    if (tmp1_safe_receiver == null)
      null;
    else {
      tmp1_safe_receiver.j8w();
    }
  };
  protoOf(LayoutNodeLayoutDelegate).sba = function () {
    this.mba_1.zat_1 = true;
    var tmp0_safe_receiver = this.nba_1;
    if (tmp0_safe_receiver == null)
      null;
    else {
      // Inline function 'kotlin.let' call
      tmp0_safe_receiver.kav_1 = true;
    }
  };
  protoOf(LayoutNodeLayoutDelegate).oba = function () {
    this.nba_1 = null;
    this.cba_1 = false;
    this.bba_1 = false;
  };
  function get_isOutMostLookaheadRoot(_this__u8e3s4) {
    var tmp;
    if (!(_this__u8e3s4.f90_1 == null)) {
      var tmp_0;
      var tmp0_safe_receiver = _this__u8e3s4.f9a();
      if ((tmp0_safe_receiver == null ? null : tmp0_safe_receiver.f90_1) == null) {
        tmp_0 = true;
      } else {
        tmp_0 = _this__u8e3s4.e91_1.yb9_1;
      }
      tmp = tmp_0;
    } else {
      tmp = false;
    }
    return tmp;
  }
  var androidx_compose_ui_node_LayoutTreeConsistencyChecker$stable;
  function isTreeConsistent($this, node) {
    if (!consistentLayoutState($this, node)) {
      return false;
    }
    // Inline function 'androidx.compose.ui.util.fastForEach' call
    var this_0 = node.qaw();
    var inductionVariable = 0;
    var last = this_0.n1() - 1 | 0;
    if (inductionVariable <= last)
      do {
        var index = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var item = this_0.l1(index);
        if (!isTreeConsistent($this, item)) {
          return false;
        }
      }
       while (inductionVariable <= last);
    return true;
  }
  function consistentLayoutState($this, $receiver) {
    var parent = $receiver.f9a();
    var parentLayoutState = parent == null ? null : parent.zav();
    var tmp;
    if ($receiver.b9i()) {
      tmp = true;
    } else {
      var tmp_0;
      if (!($receiver.d9i() === 2147483647)) {
        tmp_0 = (parent == null ? null : parent.b9i()) === true;
      } else {
        tmp_0 = false;
      }
      tmp = tmp_0;
    }
    if (tmp) {
      var tmp_1;
      if ($receiver.aax()) {
        var tmp0 = $this.abh_1;
        var tmp$ret$0;
        $l$block: {
          // Inline function 'androidx.compose.ui.util.fastFirstOrNull' call
          // Inline function 'androidx.compose.ui.util.fastForEach' call
          var inductionVariable = 0;
          var last = tmp0.n1() - 1 | 0;
          if (inductionVariable <= last)
            do {
              var index = inductionVariable;
              inductionVariable = inductionVariable + 1 | 0;
              var item = tmp0.l1(index);
              if (equals(item.bbh_1, $receiver) && !item.cbh_1) {
                tmp$ret$0 = item;
                break $l$block;
              }
            }
             while (inductionVariable <= last);
          tmp$ret$0 = null;
        }
        tmp_1 = !(tmp$ret$0 == null);
      } else {
        tmp_1 = false;
      }
      if (tmp_1) {
        return true;
      }
      if ($receiver.o91_1) {
        return true;
      }
      if ($receiver.aax()) {
        var tmp_2;
        var tmp_3;
        var tmp_4;
        if ($this.zbg_1.db2($receiver) || $receiver.zav().equals(LayoutState_LookaheadMeasuring_getInstance())) {
          tmp_4 = true;
        } else {
          tmp_4 = (parent == null ? null : parent.aax()) === true;
        }
        if (tmp_4) {
          tmp_3 = true;
        } else {
          tmp_3 = (parent == null ? null : parent.cax()) === true;
        }
        if (tmp_3) {
          tmp_2 = true;
        } else {
          tmp_2 = equals(parentLayoutState, LayoutState_Measuring_getInstance());
        }
        return tmp_2;
      }
      if ($receiver.ubd()) {
        var tmp_5;
        var tmp_6;
        var tmp_7;
        if ($this.zbg_1.db2($receiver) || parent == null || parent.aax() || parent.ubd() || equals(parentLayoutState, LayoutState_Measuring_getInstance()) || equals(parentLayoutState, LayoutState_LayingOut_getInstance())) {
          tmp_7 = true;
        } else {
          var tmp0_0 = $this.abh_1;
          var tmp$ret$4;
          $l$block_0: {
            // Inline function 'androidx.compose.ui.util.fastAny' call
            // Inline function 'androidx.compose.ui.util.fastForEach' call
            var inductionVariable_0 = 0;
            var last_0 = tmp0_0.n1() - 1 | 0;
            if (inductionVariable_0 <= last_0)
              do {
                var index_0 = inductionVariable_0;
                inductionVariable_0 = inductionVariable_0 + 1 | 0;
                var item_0 = tmp0_0.l1(index_0);
                if (equals(item_0.bbh_1, $receiver)) {
                  tmp$ret$4 = true;
                  break $l$block_0;
                }
              }
               while (inductionVariable_0 <= last_0);
            tmp$ret$4 = false;
          }
          tmp_7 = tmp$ret$4;
        }
        if (tmp_7) {
          tmp_6 = true;
        } else {
          tmp_6 = $receiver.zav().equals(LayoutState_Measuring_getInstance());
        }
        if (tmp_6) {
          tmp_5 = true;
        } else {
          tmp_5 = $receiver.zav().equals(LayoutState_LayingOut_getInstance());
        }
        return tmp_5;
      }
    }
    if ($receiver.fbb() === true) {
      var tmp_8;
      if ($receiver.cax()) {
        var tmp0_1 = $this.abh_1;
        var tmp$ret$8;
        $l$block_1: {
          // Inline function 'androidx.compose.ui.util.fastFirstOrNull' call
          // Inline function 'androidx.compose.ui.util.fastForEach' call
          var inductionVariable_1 = 0;
          var last_1 = tmp0_1.n1() - 1 | 0;
          if (inductionVariable_1 <= last_1)
            do {
              var index_1 = inductionVariable_1;
              inductionVariable_1 = inductionVariable_1 + 1 | 0;
              var item_1 = tmp0_1.l1(index_1);
              if (equals(item_1.bbh_1, $receiver) && item_1.cbh_1) {
                tmp$ret$8 = item_1;
                break $l$block_1;
              }
            }
             while (inductionVariable_1 <= last_1);
          tmp$ret$8 = null;
        }
        tmp_8 = !(tmp$ret$8 == null);
      } else {
        tmp_8 = false;
      }
      if (tmp_8) {
        return true;
      }
      if ($receiver.cax()) {
        var tmp_9;
        var tmp_10;
        var tmp_11;
        if ($this.zbg_1.zb1($receiver, true)) {
          tmp_11 = true;
        } else {
          tmp_11 = (parent == null ? null : parent.cax()) === true;
        }
        if (tmp_11) {
          tmp_10 = true;
        } else {
          tmp_10 = equals(parentLayoutState, LayoutState_LookaheadMeasuring_getInstance());
        }
        if (tmp_10) {
          tmp_9 = true;
        } else {
          var tmp_12;
          if ((parent == null ? null : parent.aax()) === true) {
            tmp_12 = equals($receiver.f90_1, $receiver);
          } else {
            tmp_12 = false;
          }
          tmp_9 = tmp_12;
        }
        return tmp_9;
      }
      if ($receiver.sbd()) {
        return $this.zbg_1.zb1($receiver, true) || parent == null || parent.cax() || parent.sbd() || equals(parentLayoutState, LayoutState_LookaheadMeasuring_getInstance()) || equals(parentLayoutState, LayoutState_LookaheadLayingOut_getInstance()) || (parent.ubd() && equals($receiver.f90_1, $receiver));
      }
    }
    return true;
  }
  function nodeToString($this, node) {
    // Inline function 'kotlin.with' call
    var $this$with = StringBuilder_init_$Create$();
    $this$with.w(node);
    $this$with.q('[' + node.zav().toString() + ']');
    if (!node.b9i()) {
      $this$with.q('[!isPlaced]');
    }
    $this$with.q('[measuredByParent=' + node.wbc().toString() + ']');
    if (!consistentLayoutState($this, node)) {
      $this$with.q('[INCONSISTENT]');
    }
    return $this$with.toString();
  }
  function logTree($this) {
    var stringBuilder = StringBuilder_init_$Create$();
    // Inline function 'kotlin.text.appendLine' call
    var value = 'Tree state:';
    // Inline function 'kotlin.text.appendLine' call
    stringBuilder.q(value).s(_Char___init__impl__6a9atx(10));
    logTree$printSubTree($this, stringBuilder, $this.ybg_1, 0);
    return stringBuilder.toString();
  }
  function logTree$printSubTree(this$0, stringBuilder, node, depth) {
    var childrenDepth = depth;
    var nodeRepresentation = nodeToString(this$0, node);
    // Inline function 'kotlin.text.isNotEmpty' call
    if (charSequenceLength(nodeRepresentation) > 0) {
      var inductionVariable = 0;
      if (inductionVariable < depth)
        do {
          var i = inductionVariable;
          inductionVariable = inductionVariable + 1 | 0;
          stringBuilder.q('..');
        }
         while (inductionVariable < depth);
      // Inline function 'kotlin.text.appendLine' call
      // Inline function 'kotlin.text.appendLine' call
      stringBuilder.q(nodeRepresentation).s(_Char___init__impl__6a9atx(10));
      childrenDepth = childrenDepth + 1 | 0;
    }
    // Inline function 'androidx.compose.ui.util.fastForEach' call
    var this_0 = node.qaw();
    var inductionVariable_0 = 0;
    var last = this_0.n1() - 1 | 0;
    if (inductionVariable_0 <= last)
      do {
        var index = inductionVariable_0;
        inductionVariable_0 = inductionVariable_0 + 1 | 0;
        var item = this_0.l1(index);
        logTree$printSubTree(this$0, stringBuilder, item, childrenDepth);
      }
       while (inductionVariable_0 <= last);
  }
  function LayoutTreeConsistencyChecker(root, relayoutNodes, postponedMeasureRequests) {
    this.ybg_1 = root;
    this.zbg_1 = relayoutNodes;
    this.abh_1 = postponedMeasureRequests;
  }
  protoOf(LayoutTreeConsistencyChecker).ebh = function () {
    var inconsistencyFound = !isTreeConsistent(this, this.ybg_1);
    if (inconsistencyFound) {
      println(logTree(this));
      throw IllegalStateException_init_$Create$('Inconsistency found!');
    }
  };
  var androidx_compose_ui_node_LookaheadCapablePlaceable$stable;
  var androidx_compose_ui_node_LookaheadDelegate$stable;
  function _set__measureResult__ah39tn($this, result) {
    var tmp;
    if (result == null) {
      tmp = null;
    } else {
      // Inline function 'kotlin.let' call
      var tmp0 = result.h5e();
      // Inline function 'androidx.compose.ui.unit.IntSize' call
      // Inline function 'androidx.compose.ui.util.packInts' call
      var val2 = result.i5e();
      var tmp$ret$3 = bitwiseOr(shiftLeft(fromInt(tmp0), 32), bitwiseAnd(fromInt(val2), new Long(-1, 0)));
      var tmp$ret$2 = _IntSize___init__impl__emcjft(tmp$ret$3);
      $this.eah(tmp$ret$2);
      tmp = Unit_instance;
    }
    if (tmp == null) {
      // Inline function 'kotlin.run' call
      $this.eah(Companion_getInstance_0().n5g_1);
    }
    if (!equals($this.dad_1, result) && !(result == null)) {
      var tmp_0;
      var tmp_1;
      // Inline function 'kotlin.collections.isNullOrEmpty' call
      var this_0 = $this.bad_1;
      if (!(this_0 == null || this_0.r())) {
        tmp_1 = true;
      } else {
        // Inline function 'kotlin.collections.isNotEmpty' call
        tmp_1 = !result.sad().r();
      }
      if (tmp_1) {
        tmp_0 = !equals(result.sad(), $this.bad_1);
      } else {
        tmp_0 = false;
      }
      if (tmp_0) {
        $this.xb3().sad().nbf();
        var tmp2_elvis_lhs = $this.bad_1;
        var tmp_2;
        if (tmp2_elvis_lhs == null) {
          // Inline function 'kotlin.collections.mutableMapOf' call
          // Inline function 'kotlin.also' call
          var this_1 = LinkedHashMap_init_$Create$();
          $this.bad_1 = this_1;
          tmp_2 = this_1;
        } else {
          tmp_2 = tmp2_elvis_lhs;
        }
        var oldLines = tmp_2;
        oldLines.c3();
        oldLines.b3(result.sad());
      }
    }
    $this.dad_1 = result;
  }
  function placeSelf($this, position) {
    if (!equals($this.iak(), position)) {
      $this.fb4(position);
      var tmp0_safe_receiver = $this.a9i().e91_1.nba_1;
      if (tmp0_safe_receiver == null)
        null;
      else {
        tmp0_safe_receiver.fbh();
      }
      $this.nb4($this.zac_1);
    }
    if (!$this.fae_1) {
      $this.pb4($this.gag());
    }
  }
  function access$_set__measureResult__oibadh($this, result) {
    return _set__measureResult__ah39tn($this, result);
  }
  function LookaheadDelegate(coordinator) {
    LookaheadCapablePlaceable.call(this);
    this.zac_1 = coordinator;
    this.aad_1 = Companion_getInstance_11().c5g_1;
    this.bad_1 = null;
    this.cad_1 = new LookaheadLayoutCoordinates(this);
    this.dad_1 = null;
    this.ead_1 = mutableObjectIntMapOf();
  }
  protoOf(LookaheadDelegate).eb4 = function () {
    var tmp0_safe_receiver = this.zac_1.s94_1;
    return tmp0_safe_receiver == null ? null : tmp0_safe_receiver.kac();
  };
  protoOf(LookaheadDelegate).fad = function () {
    return !(this.dad_1 == null);
  };
  protoOf(LookaheadDelegate).fb4 = function (_set____db54di) {
    this.aad_1 = _set____db54di;
  };
  protoOf(LookaheadDelegate).iak = function () {
    return this.aad_1;
  };
  protoOf(LookaheadDelegate).gag = function () {
    var tmp0_elvis_lhs = this.dad_1;
    var tmp;
    if (tmp0_elvis_lhs == null) {
      throwIllegalStateExceptionForNullCheck('LookaheadDelegate has not been measured yet when measureResult is requested.');
    } else {
      tmp = tmp0_elvis_lhs;
    }
    return tmp;
  };
  protoOf(LookaheadDelegate).jag = function () {
    return true;
  };
  protoOf(LookaheadDelegate).r6p = function () {
    return this.zac_1.r6p();
  };
  protoOf(LookaheadDelegate).u5e = function () {
    return this.zac_1.u5e();
  };
  protoOf(LookaheadDelegate).j5f = function () {
    return this.zac_1.j5f();
  };
  protoOf(LookaheadDelegate).k1a = function () {
    var tmp0_safe_receiver = this.zac_1.t94_1;
    return tmp0_safe_receiver == null ? null : tmp0_safe_receiver.kac();
  };
  protoOf(LookaheadDelegate).a9i = function () {
    return this.zac_1.a9i();
  };
  protoOf(LookaheadDelegate).p91 = function () {
    return this.cad_1;
  };
  protoOf(LookaheadDelegate).gb4 = function () {
    var tmp0 = this.i8y_1;
    // Inline function 'androidx.compose.ui.unit.IntSize' call
    // Inline function 'androidx.compose.ui.util.packInts' call
    var val2 = this.j8y_1;
    var tmp$ret$1 = bitwiseOr(shiftLeft(fromInt(tmp0), 32), bitwiseAnd(fromInt(val2), new Long(-1, 0)));
    return _IntSize___init__impl__emcjft(tmp$ret$1);
  };
  protoOf(LookaheadDelegate).hb4 = function () {
    return this.l8y_1;
  };
  protoOf(LookaheadDelegate).xb3 = function () {
    return ensureNotNull(this.zac_1.a9i().e91_1.hbc());
  };
  protoOf(LookaheadDelegate).ib4 = function (alignmentLine) {
    return this.ead_1.rz(alignmentLine, -2147483648);
  };
  protoOf(LookaheadDelegate).jb4 = function () {
    this.lah(this.iak(), 0.0, null);
  };
  protoOf(LookaheadDelegate).lah = function (position, zIndex, layerBlock) {
    placeSelf(this, position);
    if (this.eae_1)
      return Unit_instance;
    this.uad();
  };
  protoOf(LookaheadDelegate).kb4 = function (position) {
    placeSelf(this, IntOffset__plus_impl_nqoa9b(position, this.m8y_1));
  };
  protoOf(LookaheadDelegate).uad = function () {
    this.gag().uad();
  };
  protoOf(LookaheadDelegate).xag = function () {
    return this.zac_1.xag();
  };
  protoOf(LookaheadDelegate).b98 = function (height) {
    return ensureNotNull(ensureNotNull(this.zac_1.s94_1).kac()).b98(height);
  };
  protoOf(LookaheadDelegate).c98 = function (height) {
    return ensureNotNull(ensureNotNull(this.zac_1.s94_1).kac()).c98(height);
  };
  protoOf(LookaheadDelegate).d98 = function (width) {
    return ensureNotNull(ensureNotNull(this.zac_1.s94_1).kac()).d98(width);
  };
  protoOf(LookaheadDelegate).e98 = function (width) {
    return ensureNotNull(ensureNotNull(this.zac_1.s94_1).kac()).e98(width);
  };
  protoOf(LookaheadDelegate).lak = function (ancestor, excludingAgnosticOffset) {
    var aggregatedOffset = Companion_getInstance_11().c5g_1;
    var lookaheadDelegate = this;
    while (!equals(lookaheadDelegate, ancestor)) {
      if (!lookaheadDelegate.mb4() || !excludingAgnosticOffset) {
        aggregatedOffset = IntOffset__plus_impl_nqoa9b(aggregatedOffset, lookaheadDelegate.iak());
      }
      lookaheadDelegate = ensureNotNull(ensureNotNull(lookaheadDelegate.zac_1.t94_1).kac());
    }
    return aggregatedOffset;
  };
  function LookaheadCapablePlaceable$Companion$onCommitAffectingRuler$lambda(result) {
    if (result.kb0()) {
      captureRulersIfNeeded(result.hbh_1, result);
    }
    return Unit_instance;
  }
  function _get_rulerScope__cmg4lp($this) {
    var tmp0_elvis_lhs = $this.aae_1;
    var tmp;
    if (tmp0_elvis_lhs == null) {
      // Inline function 'kotlin.also' call
      var this_0 = new ResettableRulerScope($this);
      $this.aae_1 = this_0;
      tmp = this_0;
    } else {
      tmp = tmp0_elvis_lhs;
    }
    return tmp;
  }
  function addRulerReader($this, layoutNode, ruler) {
    var tmp0_safe_receiver = $this.iae_1;
    if (tmp0_safe_receiver == null)
      null;
    else {
      // Inline function 'androidx.collection.ScatterMap.forEachValue' call
      var v = tmp0_safe_receiver.y12_1;
      $l$block_0: {
        // Inline function 'androidx.collection.ScatterMap.forEachIndexed' call
        var m = tmp0_safe_receiver.w12_1;
        var lastIndex = m.length - 2 | 0;
        var inductionVariable = 0;
        if (inductionVariable <= lastIndex)
          do {
            var i = inductionVariable;
            inductionVariable = inductionVariable + 1 | 0;
            var slot = m[i];
            // Inline function 'androidx.collection.maskEmptyOrDeleted' call
            var this_0 = slot;
            var tmp$ret$2 = bitwiseAnd(bitwiseAnd(this_0, shiftLeft(invert(this_0), 7)), new Long(-2139062144, -2139062144));
            if (!equalsLong(tmp$ret$2, new Long(-2139062144, -2139062144))) {
              var bitCount = 8 - (~(i - lastIndex | 0) >>> 31 | 0) | 0;
              var inductionVariable_0 = 0;
              if (inductionVariable_0 < bitCount)
                do {
                  var j = inductionVariable_0;
                  inductionVariable_0 = inductionVariable_0 + 1 | 0;
                  // Inline function 'androidx.collection.isFull' call
                  var value = bitwiseAnd(slot, new Long(255, 0));
                  if (compare(value, new Long(128, 0)) < 0) {
                    var index = (i << 3) + j | 0;
                    // Inline function 'androidx.collection.MutableScatterSet.removeIf' call
                    var this_1 = v[index];
                    var elements = this_1.k16_1;
                    $l$block: {
                      // Inline function 'androidx.collection.ScatterSet.forEachIndex' call
                      // Inline function 'kotlin.contracts.contract' call
                      var m_0 = this_1.j16_1;
                      var lastIndex_0 = m_0.length - 2 | 0;
                      var inductionVariable_1 = 0;
                      if (inductionVariable_1 <= lastIndex_0)
                        do {
                          var i_0 = inductionVariable_1;
                          inductionVariable_1 = inductionVariable_1 + 1 | 0;
                          var slot_0 = m_0[i_0];
                          // Inline function 'androidx.collection.maskEmptyOrDeleted' call
                          var this_2 = slot_0;
                          var tmp$ret$9 = bitwiseAnd(bitwiseAnd(this_2, shiftLeft(invert(this_2), 7)), new Long(-2139062144, -2139062144));
                          if (!equalsLong(tmp$ret$9, new Long(-2139062144, -2139062144))) {
                            var bitCount_0 = 8 - (~(i_0 - lastIndex_0 | 0) >>> 31 | 0) | 0;
                            var inductionVariable_2 = 0;
                            if (inductionVariable_2 < bitCount_0)
                              do {
                                var j_0 = inductionVariable_2;
                                inductionVariable_2 = inductionVariable_2 + 1 | 0;
                                // Inline function 'androidx.collection.isFull' call
                                var value_0 = bitwiseAnd(slot_0, new Long(255, 0));
                                if (compare(value_0, new Long(128, 0)) < 0) {
                                  var index_0 = (i_0 << 3) + j_0 | 0;
                                  var tmp0_safe_receiver_0 = elements[index_0].f1i();
                                  if (!((tmp0_safe_receiver_0 == null ? null : tmp0_safe_receiver_0.y91()) === true)) {
                                    this_1.j11(index_0);
                                  }
                                }
                                slot_0 = shiftRight(slot_0, 8);
                              }
                               while (inductionVariable_2 < bitCount_0);
                            if (!(bitCount_0 === 8)) {
                              break $l$block;
                            }
                          }
                        }
                         while (!(i_0 === lastIndex_0));
                    }
                  }
                  slot = shiftRight(slot, 8);
                }
                 while (inductionVariable_0 < bitCount);
              if (!(bitCount === 8)) {
                break $l$block_0;
              }
            }
          }
           while (!(i === lastIndex));
      }
    }
    var tmp1_safe_receiver = $this.iae_1;
    if (tmp1_safe_receiver == null)
      null;
    else {
      // Inline function 'androidx.collection.MutableScatterMap.removeIf' call
      $l$block_1: {
        // Inline function 'androidx.collection.ScatterMap.forEachIndexed' call
        var m_1 = tmp1_safe_receiver.w12_1;
        var lastIndex_1 = m_1.length - 2 | 0;
        var inductionVariable_3 = 0;
        if (inductionVariable_3 <= lastIndex_1)
          do {
            var i_1 = inductionVariable_3;
            inductionVariable_3 = inductionVariable_3 + 1 | 0;
            var slot_1 = m_1[i_1];
            // Inline function 'androidx.collection.maskEmptyOrDeleted' call
            var this_3 = slot_1;
            var tmp$ret$15 = bitwiseAnd(bitwiseAnd(this_3, shiftLeft(invert(this_3), 7)), new Long(-2139062144, -2139062144));
            if (!equalsLong(tmp$ret$15, new Long(-2139062144, -2139062144))) {
              var bitCount_1 = 8 - (~(i_1 - lastIndex_1 | 0) >>> 31 | 0) | 0;
              var inductionVariable_4 = 0;
              if (inductionVariable_4 < bitCount_1)
                do {
                  var j_1 = inductionVariable_4;
                  inductionVariable_4 = inductionVariable_4 + 1 | 0;
                  // Inline function 'androidx.collection.isFull' call
                  var value_1 = bitwiseAnd(slot_1, new Long(255, 0));
                  if (compare(value_1, new Long(128, 0)) < 0) {
                    var index_1 = (i_1 << 3) + j_1 | 0;
                    tmp1_safe_receiver.x12_1[index_1];
                    if (tmp1_safe_receiver.y12_1[index_1].r()) {
                      tmp1_safe_receiver.hw(index_1);
                    }
                  }
                  slot_1 = shiftRight(slot_1, 8);
                }
                 while (inductionVariable_4 < bitCount_1);
              if (!(bitCount_1 === 8)) {
                break $l$block_1;
              }
            }
          }
           while (!(i_1 === lastIndex_1));
      }
    }
    var tmp2_elvis_lhs = $this.iae_1;
    var tmp;
    if (tmp2_elvis_lhs == null) {
      // Inline function 'kotlin.also' call
      var this_4 = new MutableScatterMap();
      $this.iae_1 = this_4;
      tmp = this_4;
    } else {
      tmp = tmp2_elvis_lhs;
    }
    var readerMap = tmp;
    // Inline function 'androidx.collection.MutableScatterMap.getOrPut' call
    var tmp0_elvis_lhs = readerMap.w2(ruler);
    var tmp_0;
    if (tmp0_elvis_lhs == null) {
      // Inline function 'kotlin.also' call
      var this_5 = new MutableScatterSet();
      readerMap.h13(ruler, this_5);
      tmp_0 = this_5;
    } else {
      tmp_0 = tmp0_elvis_lhs;
    }
    var readers = tmp_0;
    readers.i11(new WeakReference(layoutNode));
  }
  function findAncestorRulerDefiner($this, ruler) {
    var p = $this;
    while (true) {
      var tmp0_safe_receiver = p.hae_1;
      if ((tmp0_safe_receiver == null ? null : tmp0_safe_receiver.pbh(ruler)) === true) {
        return p;
      }
      var tmp1_elvis_lhs = p.k1a();
      var tmp;
      if (tmp1_elvis_lhs == null) {
        return p;
      } else {
        tmp = tmp1_elvis_lhs;
      }
      var parent = tmp;
      p = parent;
    }
  }
  function captureRulers($this, placeableResult, positionOnScreen, size) {
    positionOnScreen = positionOnScreen === VOID ? Companion_getInstance_11().d5g_1 : positionOnScreen;
    size = size === VOID ? Companion_getInstance_0().n5g_1 : size;
    var rulerReaders = $this.iae_1;
    var tmp0_elvis_lhs = $this.hae_1;
    var tmp;
    if (tmp0_elvis_lhs == null) {
      // Inline function 'kotlin.also' call
      var this_0 = new RulerTrackingMap();
      $this.hae_1 = this_0;
      tmp = this_0;
    } else {
      tmp = tmp0_elvis_lhs;
    }
    var newValues = tmp;
    var tmp1_safe_receiver = $this.a9i().l90_1;
    var tmp2_safe_receiver = tmp1_safe_receiver == null ? null : tmp1_safe_receiver.fb0();
    if (tmp2_safe_receiver == null)
      null;
    else {
      var tmp4 = Companion_getInstance_57().qbh_1;
      // Inline function 'androidx.compose.ui.node.OwnerSnapshotObserver.observeReads' call
      var block = LookaheadCapablePlaceable$captureRulers$lambda($this, positionOnScreen, size, placeableResult);
      access$_get_observer__zh6fij(tmp2_safe_receiver).z5a(placeableResult, tmp4, block);
    }
    newValues.rbh($this.jag(), $this, rulerReaders);
  }
  function captureRulersIfNeeded($this, placeableResult) {
    if ($this.fae_1) {
      return Unit_instance;
    }
    var rulerLambda = placeableResult.gbh_1.tad();
    var rulerReaders = $this.iae_1;
    if (rulerLambda == null) {
      if (!(rulerReaders == null)) {
        // Inline function 'androidx.collection.ScatterMap.forEachValue' call
        var v = rulerReaders.y12_1;
        $l$block: {
          // Inline function 'androidx.collection.ScatterMap.forEachIndexed' call
          var m = rulerReaders.w12_1;
          var lastIndex = m.length - 2 | 0;
          var inductionVariable = 0;
          if (inductionVariable <= lastIndex)
            do {
              var i = inductionVariable;
              inductionVariable = inductionVariable + 1 | 0;
              var slot = m[i];
              // Inline function 'androidx.collection.maskEmptyOrDeleted' call
              var this_0 = slot;
              var tmp$ret$2 = bitwiseAnd(bitwiseAnd(this_0, shiftLeft(invert(this_0), 7)), new Long(-2139062144, -2139062144));
              if (!equalsLong(tmp$ret$2, new Long(-2139062144, -2139062144))) {
                var bitCount = 8 - (~(i - lastIndex | 0) >>> 31 | 0) | 0;
                var inductionVariable_0 = 0;
                if (inductionVariable_0 < bitCount)
                  do {
                    var j = inductionVariable_0;
                    inductionVariable_0 = inductionVariable_0 + 1 | 0;
                    // Inline function 'androidx.collection.isFull' call
                    var value = bitwiseAnd(slot, new Long(255, 0));
                    if (compare(value, new Long(128, 0)) < 0) {
                      var index = (i << 3) + j | 0;
                      var it = v[index];
                      notifyRulerValueChange($this, it);
                    }
                    slot = shiftRight(slot, 8);
                  }
                   while (inductionVariable_0 < bitCount);
                if (!(bitCount === 8)) {
                  break $l$block;
                }
              }
            }
             while (!(i === lastIndex));
        }
        rulerReaders.c3();
      }
    } else {
      captureRulers($this, placeableResult);
      $this.bae_1 = rulerLambda;
    }
  }
  function notifyRulerValueChange($this, layoutNodes) {
    // Inline function 'androidx.collection.ScatterSet.forEach' call
    // Inline function 'kotlin.contracts.contract' call
    var elements = layoutNodes.k16_1;
    $l$block: {
      // Inline function 'androidx.collection.ScatterSet.forEachIndex' call
      // Inline function 'kotlin.contracts.contract' call
      var m = layoutNodes.j16_1;
      var lastIndex = m.length - 2 | 0;
      var inductionVariable = 0;
      if (inductionVariable <= lastIndex)
        do {
          var i = inductionVariable;
          inductionVariable = inductionVariable + 1 | 0;
          var slot = m[i];
          // Inline function 'androidx.collection.maskEmptyOrDeleted' call
          var this_0 = slot;
          var tmp$ret$4 = bitwiseAnd(bitwiseAnd(this_0, shiftLeft(invert(this_0), 7)), new Long(-2139062144, -2139062144));
          if (!equalsLong(tmp$ret$4, new Long(-2139062144, -2139062144))) {
            var bitCount = 8 - (~(i - lastIndex | 0) >>> 31 | 0) | 0;
            var inductionVariable_0 = 0;
            if (inductionVariable_0 < bitCount)
              do {
                var j = inductionVariable_0;
                inductionVariable_0 = inductionVariable_0 + 1 | 0;
                // Inline function 'androidx.collection.isFull' call
                var value = bitwiseAnd(slot, new Long(255, 0));
                if (compare(value, new Long(128, 0)) < 0) {
                  var index = (i << 3) + j | 0;
                  var tmp0_safe_receiver = elements[index].f1i();
                  if (tmp0_safe_receiver == null)
                    null;
                  else {
                    // Inline function 'kotlin.let' call
                    if ($this.jag()) {
                      tmp0_safe_receiver.rbd(false);
                    } else {
                      tmp0_safe_receiver.tbd(false);
                    }
                  }
                }
                slot = shiftRight(slot, 8);
              }
               while (inductionVariable_0 < bitCount);
            if (!(bitCount === 8)) {
              break $l$block;
            }
          }
        }
         while (!(i === lastIndex));
    }
  }
  function ResettableRulerScope($outer) {
    this.vbh_1 = $outer;
    this.sbh_1 = false;
    this.tbh_1 = Companion_getInstance_11().d5g_1;
    this.ubh_1 = Companion_getInstance_0().n5g_1;
  }
  protoOf(ResettableRulerScope).p91 = function () {
    this.sbh_1 = true;
    var coords = this.vbh_1.p91();
    if (equals(this.tbh_1, Companion_getInstance_11().d5g_1)) {
      this.tbh_1 = round(positionOnScreen(coords));
      this.ubh_1 = coords.q95();
    }
    this.vbh_1.a9i().e91_1.ubg();
    return coords;
  };
  protoOf(ResettableRulerScope).wbh = function (_this__u8e3s4, value) {
    this.vbh_1.qb4(_this__u8e3s4, value);
  };
  protoOf(ResettableRulerScope).u5e = function () {
    return this.vbh_1.u5e();
  };
  protoOf(ResettableRulerScope).j5f = function () {
    return this.vbh_1.j5f();
  };
  function Companion_31() {
    Companion_instance_36 = this;
    var tmp = this;
    tmp.qbh_1 = LookaheadCapablePlaceable$Companion$onCommitAffectingRuler$lambda;
  }
  var Companion_instance_36;
  function Companion_getInstance_57() {
    if (Companion_instance_36 == null)
      new Companion_31();
    return Companion_instance_36;
  }
  function LookaheadCapablePlaceable$layout$1($width, $height, $alignmentLines, $rulers, $placementBlock, this$0) {
    this.xbh_1 = $width;
    this.ybh_1 = $height;
    this.zbh_1 = $alignmentLines;
    this.abi_1 = $rulers;
    this.bbi_1 = $placementBlock;
    this.cbi_1 = this$0;
  }
  protoOf(LookaheadCapablePlaceable$layout$1).h5e = function () {
    return this.xbh_1;
  };
  protoOf(LookaheadCapablePlaceable$layout$1).i5e = function () {
    return this.ybh_1;
  };
  protoOf(LookaheadCapablePlaceable$layout$1).sad = function () {
    return this.zbh_1;
  };
  protoOf(LookaheadCapablePlaceable$layout$1).tad = function () {
    return this.abi_1;
  };
  protoOf(LookaheadCapablePlaceable$layout$1).uad = function () {
    this.bbi_1(this.cbi_1.gae_1);
  };
  function LookaheadCapablePlaceable$captureRulers$lambda(this$0, $positionOnScreen, $size, $placeableResult) {
    return function () {
      _get_rulerScope__cmg4lp(this$0).sbh_1 = false;
      _get_rulerScope__cmg4lp(this$0).tbh_1 = $positionOnScreen;
      _get_rulerScope__cmg4lp(this$0).ubh_1 = $size;
      var tmp0_safe_receiver = $placeableResult.gbh_1.tad();
      if (tmp0_safe_receiver == null)
        null;
      else
        tmp0_safe_receiver(_get_rulerScope__cmg4lp(this$0));
      return Unit_instance;
    };
  }
  function LookaheadCapablePlaceable() {
    Companion_getInstance_57();
    Placeable.call(this);
    this.aae_1 = null;
    this.bae_1 = null;
    this.cae_1 = null;
    this.dae_1 = false;
    this.eae_1 = false;
    this.fae_1 = false;
    this.gae_1 = PlacementScope_0(this);
    this.hae_1 = null;
    this.iae_1 = null;
  }
  protoOf(LookaheadCapablePlaceable).lb4 = function (_set____db54di) {
    this.dae_1 = _set____db54di;
  };
  protoOf(LookaheadCapablePlaceable).mb4 = function () {
    return this.dae_1;
  };
  protoOf(LookaheadCapablePlaceable).yao = function (newMFR) {
    var tmp0_safe_receiver = this.k1a();
    var parentNode = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.a9i();
    if (equals(parentNode, this.a9i())) {
      this.lb4(newMFR);
    } else {
      var tmp;
      if (equals(parentNode == null ? null : parentNode.zav(), LayoutState_LayingOut_getInstance())) {
        tmp = true;
      } else {
        tmp = equals(parentNode == null ? null : parentNode.zav(), LayoutState_LookaheadLayingOut_getInstance());
      }
      if (tmp) {
        this.lb4(newMFR);
      }
    }
  };
  protoOf(LookaheadCapablePlaceable).kah = function (alignmentLine) {
    if (!this.fad())
      return -2147483648;
    var measuredPosition = this.wb3(alignmentLine);
    if (measuredPosition === -2147483648)
      return -2147483648;
    var tmp;
    if (alignmentLine instanceof VerticalAlignmentLine) {
      tmp = _IntOffset___get_x__impl__qiqr5o(this.m8y_1);
    } else {
      tmp = _IntOffset___get_y__impl__2avpwj(this.m8y_1);
    }
    return measuredPosition + tmp | 0;
  };
  protoOf(LookaheadCapablePlaceable).nb4 = function (_this__u8e3s4) {
    var tmp0_safe_receiver = _this__u8e3s4.s94_1;
    if (!equals(tmp0_safe_receiver == null ? null : tmp0_safe_receiver.a9i(), _this__u8e3s4.a9i())) {
      _this__u8e3s4.xb3().sad().nbf();
    } else {
      var tmp1_safe_receiver = _this__u8e3s4.xb3().jbf();
      var tmp2_safe_receiver = tmp1_safe_receiver == null ? null : tmp1_safe_receiver.sad();
      if (tmp2_safe_receiver == null)
        null;
      else {
        tmp2_safe_receiver.nbf();
      }
    }
  };
  protoOf(LookaheadCapablePlaceable).jag = function () {
    return false;
  };
  protoOf(LookaheadCapablePlaceable).dap = function (ruler, defaultValue) {
    if (this.fae_1) {
      return defaultValue;
    }
    var p = this;
    while (true) {
      var tmp0_safe_receiver = p.hae_1;
      var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.dbi(ruler, NaN);
      var rulerValue = tmp1_elvis_lhs == null ? NaN : tmp1_elvis_lhs;
      if (!isNaN_0(rulerValue)) {
        addRulerReader(p, this.a9i(), ruler);
        return ruler.baq(rulerValue, p.p91(), this.p91());
      }
      var parent = p.k1a();
      if (parent == null) {
        addRulerReader(p, this.a9i(), ruler);
        return defaultValue;
      }
      p = parent;
    }
  };
  protoOf(LookaheadCapablePlaceable).ob4 = function (ruler) {
    var definer = findAncestorRulerDefiner(this, ruler);
    var tmp0_safe_receiver = definer.iae_1;
    var readers = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.a3(ruler);
    if (!(readers == null)) {
      notifyRulerValueChange(this, readers);
    }
  };
  protoOf(LookaheadCapablePlaceable).hag = function (width, height, alignmentLines, rulers, placementBlock) {
    // Inline function 'androidx.compose.ui.node.checkMeasuredSize' call
    // Inline function 'androidx.compose.ui.internal.checkPrecondition' call
    if (!((width & -16777216) === 0 && (height & -16777216) === 0)) {
      var tmp$ret$2 = 'Size(' + width + ' x ' + height + ') is out of range. Each dimension must be between 0 and ' + '16777215.';
      throwIllegalStateException(tmp$ret$2);
    }
    return new LookaheadCapablePlaceable$layout$1(width, height, alignmentLines, rulers, placementBlock, this);
  };
  protoOf(LookaheadCapablePlaceable).pb4 = function (result) {
    var rulerReaders = this.iae_1;
    if (!(result == null)) {
      if (this.fae_1) {
        return Unit_instance;
      }
      var rulerLambda = result.tad();
      if (rulerLambda == null) {
        if (!(rulerReaders == null)) {
          // Inline function 'androidx.collection.ScatterMap.forEachValue' call
          var v = rulerReaders.y12_1;
          $l$block: {
            // Inline function 'androidx.collection.ScatterMap.forEachIndexed' call
            var m = rulerReaders.w12_1;
            var lastIndex = m.length - 2 | 0;
            var inductionVariable = 0;
            if (inductionVariable <= lastIndex)
              do {
                var i = inductionVariable;
                inductionVariable = inductionVariable + 1 | 0;
                var slot = m[i];
                // Inline function 'androidx.collection.maskEmptyOrDeleted' call
                var this_0 = slot;
                var tmp$ret$2 = bitwiseAnd(bitwiseAnd(this_0, shiftLeft(invert(this_0), 7)), new Long(-2139062144, -2139062144));
                if (!equalsLong(tmp$ret$2, new Long(-2139062144, -2139062144))) {
                  var bitCount = 8 - (~(i - lastIndex | 0) >>> 31 | 0) | 0;
                  var inductionVariable_0 = 0;
                  if (inductionVariable_0 < bitCount)
                    do {
                      var j = inductionVariable_0;
                      inductionVariable_0 = inductionVariable_0 + 1 | 0;
                      // Inline function 'androidx.collection.isFull' call
                      var value = bitwiseAnd(slot, new Long(255, 0));
                      if (compare(value, new Long(128, 0)) < 0) {
                        var index = (i << 3) + j | 0;
                        var it = v[index];
                        notifyRulerValueChange(this, it);
                      }
                      slot = shiftRight(slot, 8);
                    }
                     while (inductionVariable_0 < bitCount);
                  if (!(bitCount === 8)) {
                    break $l$block;
                  }
                }
              }
               while (!(i === lastIndex));
          }
          rulerReaders.c3();
        }
      } else {
        var recaptureRulers = !(this.bae_1 === rulerLambda);
        var positionOnScreen_0 = Companion_getInstance_11().d5g_1;
        var size = Companion_getInstance_0().n5g_1;
        if (!recaptureRulers && _get_rulerScope__cmg4lp(this).sbh_1) {
          var coordinates = this.p91();
          positionOnScreen_0 = round(positionOnScreen(coordinates));
          size = coordinates.q95();
          recaptureRulers = !equals(positionOnScreen_0, _get_rulerScope__cmg4lp(this).tbh_1) || !equals(size, _get_rulerScope__cmg4lp(this).ubh_1);
        }
        if (recaptureRulers) {
          var tmp0_safe_receiver = this.cae_1;
          var tmp;
          if (tmp0_safe_receiver == null) {
            tmp = null;
          } else {
            // Inline function 'kotlin.also' call
            tmp0_safe_receiver.gbh_1 = result;
            tmp = tmp0_safe_receiver;
          }
          var tmp1_elvis_lhs = tmp;
          var tmp_0;
          if (tmp1_elvis_lhs == null) {
            // Inline function 'kotlin.also' call
            var this_1 = new PlaceableResult(result, this);
            this.cae_1 = this_1;
            tmp_0 = this_1;
          } else {
            tmp_0 = tmp1_elvis_lhs;
          }
          var placeableResult = tmp_0;
          captureRulers(this, placeableResult, positionOnScreen_0, size);
          this.bae_1 = result.tad();
        }
      }
    } else {
      if (rulerReaders == null)
        null;
      else {
        // Inline function 'androidx.collection.ScatterMap.forEachValue' call
        var v_0 = rulerReaders.y12_1;
        $l$block_0: {
          // Inline function 'androidx.collection.ScatterMap.forEachIndexed' call
          var m_0 = rulerReaders.w12_1;
          var lastIndex_0 = m_0.length - 2 | 0;
          var inductionVariable_1 = 0;
          if (inductionVariable_1 <= lastIndex_0)
            do {
              var i_0 = inductionVariable_1;
              inductionVariable_1 = inductionVariable_1 + 1 | 0;
              var slot_0 = m_0[i_0];
              // Inline function 'androidx.collection.maskEmptyOrDeleted' call
              var this_2 = slot_0;
              var tmp$ret$12 = bitwiseAnd(bitwiseAnd(this_2, shiftLeft(invert(this_2), 7)), new Long(-2139062144, -2139062144));
              if (!equalsLong(tmp$ret$12, new Long(-2139062144, -2139062144))) {
                var bitCount_0 = 8 - (~(i_0 - lastIndex_0 | 0) >>> 31 | 0) | 0;
                var inductionVariable_2 = 0;
                if (inductionVariable_2 < bitCount_0)
                  do {
                    var j_0 = inductionVariable_2;
                    inductionVariable_2 = inductionVariable_2 + 1 | 0;
                    // Inline function 'androidx.collection.isFull' call
                    var value_0 = bitwiseAnd(slot_0, new Long(255, 0));
                    if (compare(value_0, new Long(128, 0)) < 0) {
                      var index_0 = (i_0 << 3) + j_0 | 0;
                      var it_0 = v_0[index_0];
                      notifyRulerValueChange(this, it_0);
                    }
                    slot_0 = shiftRight(slot_0, 8);
                  }
                   while (inductionVariable_2 < bitCount_0);
                if (!(bitCount_0 === 8)) {
                  break $l$block_0;
                }
              }
            }
             while (!(i_0 === lastIndex_0));
        }
      }
      if (rulerReaders == null)
        null;
      else {
        rulerReaders.c3();
      }
      var tmp4_safe_receiver = this.hae_1;
      if (tmp4_safe_receiver == null)
        null;
      else {
        tmp4_safe_receiver.c3();
      }
    }
  };
  protoOf(LookaheadCapablePlaceable).qb4 = function (ruler, value) {
    var tmp0_elvis_lhs = this.hae_1;
    var tmp;
    if (tmp0_elvis_lhs == null) {
      // Inline function 'kotlin.also' call
      var this_0 = new RulerTrackingMap();
      this.hae_1 = this_0;
      tmp = this_0;
    } else {
      tmp = tmp0_elvis_lhs;
    }
    var rulerValues = tmp;
    rulerValues.ebi(ruler, value);
  };
  function PlaceableResult(result, placeable) {
    this.gbh_1 = result;
    this.hbh_1 = placeable;
  }
  protoOf(PlaceableResult).kb0 = function () {
    return this.hbh_1.p91().y91();
  };
  function RulerTrackingMap() {
    this.jbh_1 = 0;
    var tmp = this;
    // Inline function 'kotlin.arrayOfNulls' call
    tmp.kbh_1 = Array(32);
    this.lbh_1 = new Float32Array(32);
    this.mbh_1 = new Int8Array(32);
    this.nbh_1 = mutableScatterSetOf();
    this.obh_1 = mutableScatterSetOf();
  }
  protoOf(RulerTrackingMap).dbi = function (ruler, defaultValue) {
    var index = indexOf(this.kbh_1, ruler);
    var tmp;
    if (index < 0) {
      tmp = defaultValue;
    } else {
      tmp = this.lbh_1[index];
    }
    return tmp;
  };
  protoOf(RulerTrackingMap).ebi = function (ruler, value) {
    var index = indexOf(this.kbh_1, ruler);
    if (index < 0) {
      var newIndex = this.jbh_1;
      if (newIndex === this.kbh_1.length) {
        var newSize = imul(newIndex, 2);
        this.kbh_1 = copyOf_0(this.kbh_1, newSize);
        this.lbh_1 = copyOf_1(this.lbh_1, newSize);
        this.mbh_1 = copyOf_2(this.mbh_1, newSize);
      }
      this.kbh_1[newIndex] = ruler;
      this.mbh_1[newIndex] = 3;
      this.lbh_1[newIndex] = value;
      this.jbh_1 = this.jbh_1 + 1 | 0;
    } else {
      var oldValue = this.lbh_1[index];
      if (!(oldValue === value)) {
        this.lbh_1[index] = value;
        this.mbh_1[index] = 1;
      } else if (this.mbh_1[index] === 2) {
        this.mbh_1[index] = 0;
      }
    }
  };
  protoOf(RulerTrackingMap).pbh = function (ruler) {
    return contains(this.kbh_1, ruler);
  };
  protoOf(RulerTrackingMap).rbh = function (isLookingAhead, node, rulerReaders) {
    var inductionVariable = 0;
    var last = this.jbh_1;
    if (inductionVariable < last)
      do {
        var i = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var access = this.mbh_1[i];
        if (access === 3) {
          this.obh_1.i11(ensureNotNull(this.kbh_1[i]));
        } else if (!(access === 0) && !(rulerReaders == null)) {
          var readers = rulerReaders.a3(ensureNotNull(this.kbh_1[i]));
          if (!(readers == null)) {
            this.nbh_1.t16(readers);
          }
        }
      }
       while (inductionVariable < last);
    var removed = 0;
    var inductionVariable_0 = 0;
    var last_0 = this.jbh_1;
    if (inductionVariable_0 < last_0)
      do {
        var sourceIndex = inductionVariable_0;
        inductionVariable_0 = inductionVariable_0 + 1 | 0;
        if (this.mbh_1[sourceIndex] === 2) {
          removed = removed + 1 | 0;
        } else if (removed > 0) {
          var destIndex = sourceIndex - removed | 0;
          this.kbh_1[destIndex] = this.kbh_1[sourceIndex];
        }
        this.mbh_1[sourceIndex] = 2;
      }
       while (inductionVariable_0 < last_0);
    var inductionVariable_1 = this.jbh_1 - removed | 0;
    var last_1 = this.jbh_1;
    if (inductionVariable_1 < last_1)
      do {
        var i_0 = inductionVariable_1;
        inductionVariable_1 = inductionVariable_1 + 1 | 0;
        this.kbh_1[i_0] = null;
      }
       while (inductionVariable_1 < last_1);
    this.jbh_1 = this.jbh_1 - removed | 0;
    var parent = node.k1a();
    // Inline function 'androidx.collection.ScatterSet.forEach' call
    var this_0 = this.obh_1;
    // Inline function 'kotlin.contracts.contract' call
    var elements = this_0.k16_1;
    $l$block: {
      // Inline function 'androidx.collection.ScatterSet.forEachIndex' call
      // Inline function 'kotlin.contracts.contract' call
      var m = this_0.j16_1;
      var lastIndex = m.length - 2 | 0;
      var inductionVariable_2 = 0;
      if (inductionVariable_2 <= lastIndex)
        do {
          var i_1 = inductionVariable_2;
          inductionVariable_2 = inductionVariable_2 + 1 | 0;
          var slot = m[i_1];
          // Inline function 'androidx.collection.maskEmptyOrDeleted' call
          var this_1 = slot;
          var tmp$ret$4 = bitwiseAnd(bitwiseAnd(this_1, shiftLeft(invert(this_1), 7)), new Long(-2139062144, -2139062144));
          if (!equalsLong(tmp$ret$4, new Long(-2139062144, -2139062144))) {
            var bitCount = 8 - (~(i_1 - lastIndex | 0) >>> 31 | 0) | 0;
            var inductionVariable_3 = 0;
            if (inductionVariable_3 < bitCount)
              do {
                var j = inductionVariable_3;
                inductionVariable_3 = inductionVariable_3 + 1 | 0;
                // Inline function 'androidx.collection.isFull' call
                var value = bitwiseAnd(slot, new Long(255, 0));
                if (compare(value, new Long(128, 0)) < 0) {
                  var index = (i_1 << 3) + j | 0;
                  var ruler = elements[index];
                  (parent == null ? node : parent).ob4(ruler);
                }
                slot = shiftRight(slot, 8);
              }
               while (inductionVariable_3 < bitCount);
            if (!(bitCount === 8)) {
              break $l$block;
            }
          }
        }
         while (!(i_1 === lastIndex));
    }
    this.obh_1.c3();
    // Inline function 'androidx.collection.ScatterSet.forEach' call
    var this_2 = this.nbh_1;
    // Inline function 'kotlin.contracts.contract' call
    var elements_0 = this_2.k16_1;
    $l$block_0: {
      // Inline function 'androidx.collection.ScatterSet.forEachIndex' call
      // Inline function 'kotlin.contracts.contract' call
      var m_0 = this_2.j16_1;
      var lastIndex_0 = m_0.length - 2 | 0;
      var inductionVariable_4 = 0;
      if (inductionVariable_4 <= lastIndex_0)
        do {
          var i_2 = inductionVariable_4;
          inductionVariable_4 = inductionVariable_4 + 1 | 0;
          var slot_0 = m_0[i_2];
          // Inline function 'androidx.collection.maskEmptyOrDeleted' call
          var this_3 = slot_0;
          var tmp$ret$12 = bitwiseAnd(bitwiseAnd(this_3, shiftLeft(invert(this_3), 7)), new Long(-2139062144, -2139062144));
          if (!equalsLong(tmp$ret$12, new Long(-2139062144, -2139062144))) {
            var bitCount_0 = 8 - (~(i_2 - lastIndex_0 | 0) >>> 31 | 0) | 0;
            var inductionVariable_5 = 0;
            if (inductionVariable_5 < bitCount_0)
              do {
                var j_0 = inductionVariable_5;
                inductionVariable_5 = inductionVariable_5 + 1 | 0;
                // Inline function 'androidx.collection.isFull' call
                var value_0 = bitwiseAnd(slot_0, new Long(255, 0));
                if (compare(value_0, new Long(128, 0)) < 0) {
                  var index_0 = (i_2 << 3) + j_0 | 0;
                  var tmp0_safe_receiver = elements_0[index_0].f1i();
                  if (tmp0_safe_receiver == null)
                    null;
                  else {
                    // Inline function 'kotlin.let' call
                    if (isLookingAhead) {
                      tmp0_safe_receiver.rbd(false);
                    } else {
                      tmp0_safe_receiver.tbd(false);
                    }
                  }
                }
                slot_0 = shiftRight(slot_0, 8);
              }
               while (inductionVariable_5 < bitCount_0);
            if (!(bitCount_0 === 8)) {
              break $l$block_0;
            }
          }
        }
         while (!(i_2 === lastIndex_0));
    }
    this.nbh_1.c3();
  };
  protoOf(RulerTrackingMap).c3 = function () {
    var inductionVariable = 0;
    var last = this.jbh_1;
    if (inductionVariable < last)
      do {
        var i = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        this.kbh_1[i] = null;
        this.lbh_1[i] = NaN;
        this.mbh_1[i] = 0;
      }
       while (inductionVariable < last);
    this.jbh_1 = 0;
  };
  var androidx_compose_ui_node_LookaheadPassDelegate$stable;
  var PlacedState_IsPlacedInLookahead_instance;
  var PlacedState_IsPlacedInApproach_instance;
  var PlacedState_IsNotPlaced_instance;
  var PlacedState_entriesInitialized;
  function PlacedState_initEntries() {
    if (PlacedState_entriesInitialized)
      return Unit_instance;
    PlacedState_entriesInitialized = true;
    PlacedState_IsPlacedInLookahead_instance = new PlacedState('IsPlacedInLookahead', 0);
    PlacedState_IsPlacedInApproach_instance = new PlacedState('IsPlacedInApproach', 1);
    PlacedState_IsNotPlaced_instance = new PlacedState('IsNotPlaced', 2);
  }
  function PlacedState(name, ordinal) {
    Enum.call(this, name, ordinal);
  }
  function _set_measurePending__3k9pzy($this, value) {
    $this.uau_1.bba_1 = value;
  }
  function _set_layoutPending__7ydkuw($this, value) {
    $this.uau_1.cba_1 = value;
  }
  function _get_layoutPending__79dxng($this) {
    return $this.uau_1.cba_1;
  }
  function _set_layoutPendingForAlignment__qris6a($this, value) {
    $this.uau_1.dba_1 = value;
  }
  function _get_layoutPendingForAlignment__t0db4m($this) {
    return $this.uau_1.dba_1;
  }
  function _get_layoutNode__1t5mf3($this) {
    return $this.uau_1.xb9_1;
  }
  function _get_outerCoordinator__reuldi($this) {
    return $this.uau_1.nbg();
  }
  function _set_layoutState__s9dmqm($this, value) {
    $this.uau_1.aba_1 = value;
  }
  function _get_layoutState__chc8wm($this) {
    return $this.uau_1.aba_1;
  }
  function _get_detachedFromParentLookaheadPlacement__4pbrcy($this) {
    return $this.uau_1.zb9_1;
  }
  function checkChildrenPlaceOrderForUpdates($this) {
    // Inline function 'androidx.compose.ui.node.LookaheadPassDelegate.forEachChildDelegate' call
    // Inline function 'androidx.compose.ui.node.LayoutNode.forEachChild' call
    // Inline function 'androidx.compose.runtime.collection.MutableVector.forEach' call
    var this_0 = _get_layoutNode__1t5mf3($this).rb1();
    var i = 0;
    var tmp = this_0.b3e_1;
    var content = isArray(tmp) ? tmp : THROW_CCE();
    var size = this_0.d3e_1;
    while (i < size) {
      var it = content[i];
      var child = ensureNotNull(it.e91_1.nba_1);
      if (!(child.wau_1 === child.xau_1)) {
        if (child.xau_1 === 2147483647) {
          child.fbi(true);
        }
      }
      i = i + 1 | 0;
    }
  }
  function trackLookaheadMeasurementByParent($this, node) {
    var parent = node.f9a();
    if (!(parent == null)) {
      // Inline function 'androidx.compose.ui.internal.checkPrecondition' call
      if (!($this.yau_1.equals(UsageByParent_NotUsed_getInstance()) || node.c91_1)) {
        var tmp$ret$1 = 'measure() may not be called multiple times on the same Measurable. If you want to get the content size of the Measurable before calculating the final constraints, please use methods like minIntrinsicWidth()/maxIntrinsicWidth() and minIntrinsicHeight()/maxIntrinsicHeight()';
        throwIllegalStateException(tmp$ret$1);
      }
      var tmp = $this;
      var tmp_0;
      switch (parent.zav().a1_1) {
        case 1:
        case 0:
          tmp_0 = UsageByParent_InMeasureBlock_getInstance();
          break;
        case 2:
        case 3:
          tmp_0 = UsageByParent_InLayoutBlock_getInstance();
          break;
        default:
          throw IllegalStateException_init_$Create$("Measurable could be only measured from the parent's measure or layout" + (' block. Parents state is ' + parent.zav().toString()));
      }
      tmp.yau_1 = tmp_0;
    } else {
      $this.yau_1 = UsageByParent_NotUsed_getInstance();
    }
  }
  function placeSelf_0($this, position, zIndex, layerBlock, layer) {
    // Inline function 'androidx.compose.ui.node.withComposeStackTrace' call
    var layoutNode = _get_layoutNode__1t5mf3($this);
    try {
      var tmp0_safe_receiver = _get_layoutNode__1t5mf3($this).f9a();
      if (equals(tmp0_safe_receiver == null ? null : tmp0_safe_receiver.zav(), LayoutState_LookaheadLayingOut_getInstance())) {
        $this.uau_1.zb9_1 = false;
      }
      // Inline function 'androidx.compose.ui.internal.requirePrecondition' call
      if (!!_get_layoutNode__1t5mf3($this).o91_1) {
        var tmp$ret$3 = 'place is called on a deactivated node';
        throwIllegalArgumentException(tmp$ret$3);
      }
      _set_layoutState__s9dmqm($this, LayoutState_LookaheadLayingOut_getInstance());
      $this.aav_1 = true;
      $this.tav_1 = false;
      if (!equals(position, $this.dav_1)) {
        if ($this.uau_1.kba_1 || $this.uau_1.jba_1) {
          _set_layoutPending__7ydkuw($this, true);
        }
        $this.fbh();
      }
      var owner = requireOwner_0(_get_layoutNode__1t5mf3($this));
      $this.dav_1 = position;
      if (!_get_layoutPending__79dxng($this) && $this.gbb()) {
        ensureNotNull(_get_outerCoordinator__reuldi($this).kac()).kb4(position);
        $this.zb3();
      } else {
        $this.uau_1.tbg(false);
        $this.iav_1.obc_1 = false;
        var tmp0 = owner.fb0();
        var tmp2 = _get_layoutNode__1t5mf3($this);
        // Inline function 'androidx.compose.ui.node.OwnerSnapshotObserver.observeLayoutModifierSnapshotReadsAffectingLookahead' call
        var block = $this.sav_1;
        // Inline function 'androidx.compose.ui.node.OwnerSnapshotObserver.observeReads' call
        var onChanged = access$_get_onCommitAffectingLayoutModifierInLookahead__ts6juu(tmp0);
        access$_get_observer__zh6fij(tmp0).z5a(tmp2, onChanged, block);
      }
      $this.eav_1 = zIndex;
      $this.fav_1 = layerBlock;
      $this.gav_1 = layer;
      _set_layoutState__s9dmqm($this, LayoutState_Idle_getInstance());
    } catch ($p) {
      if ($p instanceof Error) {
        var e = $p;
        layoutNode.dbc(e);
      } else {
        throw $p;
      }
    }
  }
  function onIntrinsicsQueried($this) {
    _get_layoutNode__1t5mf3($this).bax();
    var parent = _get_layoutNode__1t5mf3($this).f9a();
    if (!(parent == null) && _get_layoutNode__1t5mf3($this).a91_1.equals(UsageByParent_NotUsed_getInstance())) {
      var tmp = _get_layoutNode__1t5mf3($this);
      switch (parent.zav().a1_1) {
        case 0:
          tmp.a91_1 = UsageByParent_InMeasureBlock_getInstance();
          break;
        case 2:
          tmp.a91_1 = UsageByParent_InLayoutBlock_getInstance();
          break;
        default:
          tmp.a91_1 = parent.a91_1;
          break;
      }
    }
  }
  function clearPlaceOrder($this) {
    $this.uau_1.eba_1 = 0;
    // Inline function 'androidx.compose.ui.node.LookaheadPassDelegate.forEachChildDelegate' call
    // Inline function 'androidx.compose.ui.node.LayoutNode.forEachChild' call
    // Inline function 'androidx.compose.runtime.collection.MutableVector.forEach' call
    var this_0 = _get_layoutNode__1t5mf3($this).rb1();
    var i = 0;
    var tmp = this_0.b3e_1;
    var content = isArray(tmp) ? tmp : THROW_CCE();
    var size = this_0.d3e_1;
    while (i < size) {
      var it = content[i];
      var child = ensureNotNull(it.e91_1.nba_1);
      child.wau_1 = child.xau_1;
      child.xau_1 = 2147483647;
      if (child.yau_1.equals(UsageByParent_InLayoutBlock_getInstance())) {
        child.yau_1 = UsageByParent_NotUsed_getInstance();
      }
      i = i + 1 | 0;
    }
  }
  function markNodeAndSubtreeAsPlaced($this) {
    var prevPlacedState = $this.hav_1;
    if (_get_detachedFromParentLookaheadPlacement__4pbrcy($this)) {
      $this.hav_1 = PlacedState_IsPlacedInApproach_getInstance();
    } else {
      $this.hav_1 = PlacedState_IsPlacedInLookahead_getInstance();
    }
    if (!prevPlacedState.equals(PlacedState_IsPlacedInLookahead_getInstance())) {
      if ($this.uau_1.bba_1) {
        _get_layoutNode__1t5mf3($this).bax(true);
      }
    }
    // Inline function 'androidx.compose.ui.node.LayoutNode.forEachChild' call
    // Inline function 'androidx.compose.runtime.collection.MutableVector.forEach' call
    var this_0 = _get_layoutNode__1t5mf3($this).rb1();
    var i = 0;
    var tmp = this_0.b3e_1;
    var content = isArray(tmp) ? tmp : THROW_CCE();
    var size = this_0.d3e_1;
    while (i < size) {
      var it = content[i];
      var tmp0 = it.oau();
      var tmp$ret$3;
      $l$block: {
        // Inline function 'kotlin.requireNotNull' call
        if (tmp0 == null) {
          var message = "Error: Child node's lookahead pass delegate cannot be null when in a lookahead scope.";
          throw IllegalArgumentException_init_$Create$(toString(message));
        } else {
          tmp$ret$3 = tmp0;
          break $l$block;
        }
      }
      var childDelegate = tmp$ret$3;
      if (!(childDelegate.xau_1 === 2147483647)) {
        markNodeAndSubtreeAsPlaced(childDelegate);
        it.qbd(it);
      }
      i = i + 1 | 0;
    }
  }
  function onBeforeLayoutChildren($this) {
    // Inline function 'androidx.compose.ui.node.LayoutNode.forEachChild' call
    // Inline function 'androidx.compose.runtime.collection.MutableVector.forEach' call
    var this_0 = _get_layoutNode__1t5mf3($this).rb1();
    var i = 0;
    var tmp = this_0.b3e_1;
    var content = isArray(tmp) ? tmp : THROW_CCE();
    var size = this_0.d3e_1;
    while (i < size) {
      var it = content[i];
      if (it.cax() && it.xbc().equals(UsageByParent_InMeasureBlock_getInstance())) {
        var tmp_0 = ensureNotNull(it.e91_1.nba_1);
        var tmp_1 = it.e91_1.mbe();
        if (tmp_0.kbe(ensureNotNull(tmp_1 == null ? null : new Constraints_0(tmp_1)).m5e_1)) {
          _get_layoutNode__1t5mf3($this).bax();
        }
      }
      i = i + 1 | 0;
    }
  }
  function LookaheadPassDelegate$layoutChildrenBlock$lambda$lambda(child) {
    child.sad().lbc_1 = false;
    return Unit_instance;
  }
  function LookaheadPassDelegate$layoutChildrenBlock$lambda$lambda_0(child) {
    child.sad().mbc_1 = child.sad().lbc_1;
    return Unit_instance;
  }
  function LookaheadPassDelegate$layoutChildrenBlock$lambda(this$0) {
    return function () {
      clearPlaceOrder(this$0);
      this$0.mbf(LookaheadPassDelegate$layoutChildrenBlock$lambda$lambda);
      var tmp0_safe_receiver = this$0.cbf().kac();
      var tmp1_safe_receiver = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.fae_1;
      if (tmp1_safe_receiver == null)
        null;
      else {
        // Inline function 'kotlin.let' call
        // Inline function 'androidx.compose.ui.util.fastForEach' call
        var this_0 = _get_layoutNode__1t5mf3(this$0).qaw();
        var inductionVariable = 0;
        var last = this_0.n1() - 1 | 0;
        if (inductionVariable <= last)
          do {
            var index = inductionVariable;
            inductionVariable = inductionVariable + 1 | 0;
            var item = this_0.l1(index);
            var tmp0_safe_receiver_0 = item.hak().kac();
            if (tmp0_safe_receiver_0 == null)
              null;
            else {
              tmp0_safe_receiver_0.fae_1 = tmp1_safe_receiver;
            }
          }
           while (inductionVariable <= last);
      }
      ensureNotNull(this$0.cbf().kac()).gag().uad();
      var tmp2_safe_receiver = this$0.cbf().kac();
      if ((tmp2_safe_receiver == null ? null : tmp2_safe_receiver.fae_1) == null)
        null;
      else {
        // Inline function 'kotlin.let' call
        // Inline function 'androidx.compose.ui.util.fastForEach' call
        var this_1 = _get_layoutNode__1t5mf3(this$0).qaw();
        var inductionVariable_0 = 0;
        var last_0 = this_1.n1() - 1 | 0;
        if (inductionVariable_0 <= last_0)
          do {
            var index_0 = inductionVariable_0;
            inductionVariable_0 = inductionVariable_0 + 1 | 0;
            var item_0 = this_1.l1(index_0);
            var tmp0_safe_receiver_1 = item_0.hak().kac();
            if (tmp0_safe_receiver_1 == null)
              null;
            else {
              tmp0_safe_receiver_1.fae_1 = false;
            }
          }
           while (inductionVariable_0 <= last_0);
      }
      checkChildrenPlaceOrderForUpdates(this$0);
      this$0.mbf(LookaheadPassDelegate$layoutChildrenBlock$lambda$lambda_0);
      return Unit_instance;
    };
  }
  function LookaheadPassDelegate$performMeasureBlock$lambda(this$0) {
    return function () {
      ensureNotNull(_get_outerCoordinator__reuldi(this$0).kac()).h8y(this$0.pav_1);
      return Unit_instance;
    };
  }
  function LookaheadPassDelegate$remeasure$lambda(it) {
    it.sad().kbc_1 = false;
    return Unit_instance;
  }
  function LookaheadPassDelegate$layoutModifierBlock$lambda(this$0) {
    return function () {
      var expectsLookaheadPlacementFromParent = !get_isOutMostLookaheadRoot(_get_layoutNode__1t5mf3(this$0)) && !this$0.uau_1.zb9_1;
      var tmp;
      if (expectsLookaheadPlacementFromParent) {
        var tmp0_safe_receiver = _get_outerCoordinator__reuldi(this$0).t94_1;
        var tmp1_safe_receiver = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.kac();
        tmp = tmp1_safe_receiver == null ? null : tmp1_safe_receiver.gae_1;
      } else {
        var tmp2_safe_receiver = _get_outerCoordinator__reuldi(this$0).t94_1;
        tmp = tmp2_safe_receiver == null ? null : tmp2_safe_receiver.gae_1;
      }
      var tmp3_elvis_lhs = tmp;
      var scope = tmp3_elvis_lhs == null ? requireOwner_0(_get_layoutNode__1t5mf3(this$0)).cbd() : tmp3_elvis_lhs;
      // Inline function 'kotlin.with' call
      scope.lal(ensureNotNull(_get_outerCoordinator__reuldi(this$0).kac()), this$0.dav_1);
      return Unit_instance;
    };
  }
  function PlacedState_IsPlacedInLookahead_getInstance() {
    PlacedState_initEntries();
    return PlacedState_IsPlacedInLookahead_instance;
  }
  function PlacedState_IsPlacedInApproach_getInstance() {
    PlacedState_initEntries();
    return PlacedState_IsPlacedInApproach_instance;
  }
  function PlacedState_IsNotPlaced_getInstance() {
    PlacedState_initEntries();
    return PlacedState_IsNotPlaced_instance;
  }
  function LookaheadPassDelegate(layoutNodeLayoutDelegate) {
    Placeable.call(this);
    this.uau_1 = layoutNodeLayoutDelegate;
    this.vau_1 = false;
    this.wau_1 = 2147483647;
    this.xau_1 = 2147483647;
    this.yau_1 = UsageByParent_NotUsed_getInstance();
    this.zau_1 = false;
    this.aav_1 = false;
    this.bav_1 = false;
    this.cav_1 = null;
    this.dav_1 = Companion_getInstance_11().c5g_1;
    this.eav_1 = 0.0;
    this.fav_1 = null;
    this.gav_1 = null;
    this.hav_1 = PlacedState_IsNotPlaced_getInstance();
    this.iav_1 = new LookaheadAlignmentLines(this);
    var tmp = this;
    // Inline function 'androidx.compose.runtime.collection.MutableVector' call
    // Inline function 'kotlin.arrayOfNulls' call
    var tmp$ret$1 = Array(16);
    tmp.jav_1 = new MutableVector(tmp$ret$1, 0);
    this.kav_1 = true;
    this.lav_1 = false;
    var tmp_0 = this;
    tmp_0.mav_1 = LookaheadPassDelegate$layoutChildrenBlock$lambda(this);
    this.nav_1 = true;
    this.oav_1 = this.nau().rat_1;
    this.pav_1 = Constraints();
    var tmp_1 = this;
    tmp_1.qav_1 = LookaheadPassDelegate$performMeasureBlock$lambda(this);
    this.rav_1 = false;
    var tmp_2 = this;
    tmp_2.sav_1 = LookaheadPassDelegate$layoutModifierBlock$lambda(this);
    this.tav_1 = false;
  }
  protoOf(LookaheadPassDelegate).rbe = function () {
    _set_layoutPending__7ydkuw(this, true);
    _set_layoutPendingForAlignment__qris6a(this, true);
  };
  protoOf(LookaheadPassDelegate).fbf = function () {
    return this.xau_1;
  };
  protoOf(LookaheadPassDelegate).nau = function () {
    return this.uau_1.mba_1;
  };
  protoOf(LookaheadPassDelegate).qbe = function () {
    return this.cav_1;
  };
  protoOf(LookaheadPassDelegate).gbb = function () {
    return !this.hav_1.equals(PlacedState_IsNotPlaced_getInstance());
  };
  protoOf(LookaheadPassDelegate).cbf = function () {
    return _get_layoutNode__1t5mf3(this).car();
  };
  protoOf(LookaheadPassDelegate).sad = function () {
    return this.iav_1;
  };
  protoOf(LookaheadPassDelegate).gbi = function () {
    if (this.hav_1.equals(PlacedState_IsNotPlaced_getInstance())) {
      if (get_isOutMostLookaheadRoot(_get_layoutNode__1t5mf3(this))) {
        return Unit_instance;
      } else {
        this.uau_1.zb9_1 = true;
      }
    }
  };
  protoOf(LookaheadPassDelegate).hbi = function () {
    return get_isOutMostLookaheadRoot(_get_layoutNode__1t5mf3(this)) || _get_detachedFromParentLookaheadPlacement__4pbrcy(this);
  };
  protoOf(LookaheadPassDelegate).faw = function () {
    // Inline function 'kotlin.let' call
    _get_layoutNode__1t5mf3(this).qaw();
    if (!this.kav_1)
      return this.jav_1.q10();
    var tmp0 = _get_layoutNode__1t5mf3(this);
    // Inline function 'androidx.compose.ui.node.updateChildMeasurables' call
    var destination = this.jav_1;
    // Inline function 'androidx.compose.ui.node.LayoutNode.forEachChildIndexed' call
    // Inline function 'androidx.compose.runtime.collection.MutableVector.forEachIndexed' call
    var this_0 = tmp0.rb1();
    var i = 0;
    var tmp = this_0.b3e_1;
    var content = isArray(tmp) ? tmp : THROW_CCE();
    var size = this_0.d3e_1;
    while (i < size) {
      var tmp0_0 = i;
      var layoutNode = content[i];
      if (destination.d3e_1 <= tmp0_0) {
        var tmp$ret$6 = ensureNotNull(layoutNode.e91_1.nba_1);
        destination.zz(tmp$ret$6);
      } else {
        var tmp$ret$7 = ensureNotNull(layoutNode.e91_1.nba_1);
        destination.mi(tmp0_0, tmp$ret$7);
      }
      i = i + 1 | 0;
    }
    destination.e5(tmp0.qaw().n1(), destination.d3e_1);
    this.kav_1 = false;
    return this.jav_1.q10();
  };
  protoOf(LookaheadPassDelegate).gbf = function () {
    this.lav_1 = true;
    this.iav_1.ibf();
    if (_get_layoutPending__79dxng(this)) {
      onBeforeLayoutChildren(this);
    }
    var lookaheadDelegate = ensureNotNull(this.cbf().kac());
    if (_get_layoutPendingForAlignment__t0db4m(this) || (!this.zau_1 && !lookaheadDelegate.fae_1 && _get_layoutPending__79dxng(this))) {
      _set_layoutPending__7ydkuw(this, false);
      var oldLayoutState = _get_layoutState__chc8wm(this);
      _set_layoutState__s9dmqm(this, LayoutState_LookaheadLayingOut_getInstance());
      this.uau_1.rbg(false);
      var observer = requireOwner_0(_get_layoutNode__1t5mf3(this)).fb0();
      var tmp2 = _get_layoutNode__1t5mf3(this);
      // Inline function 'androidx.compose.ui.node.OwnerSnapshotObserver.observeLayoutSnapshotReadsAffectingLookahead' call
      var block = this.mav_1;
      // Inline function 'androidx.compose.ui.node.OwnerSnapshotObserver.observeReads' call
      var onChanged = access$_get_onCommitAffectingLookahead__ez3ps0(observer);
      access$_get_observer__zh6fij(observer).z5a(tmp2, onChanged, block);
      _set_layoutState__s9dmqm(this, oldLayoutState);
      if (this.uau_1.jba_1 && lookaheadDelegate.fae_1) {
        this.obf();
      }
      _set_layoutPendingForAlignment__qris6a(this, false);
    }
    if (this.iav_1.lbc_1) {
      this.iav_1.mbc_1 = true;
    }
    if (this.iav_1.jbc_1 && this.iav_1.rbc()) {
      this.iav_1.lbf();
    }
    this.lav_1 = false;
  };
  protoOf(LookaheadPassDelegate).fbi = function (inLookahead) {
    if (inLookahead && this.hbi() || (!inLookahead && !this.hbi())) {
      return Unit_instance;
    }
    this.hav_1 = PlacedState_IsNotPlaced_getInstance();
    // Inline function 'androidx.compose.ui.node.LookaheadPassDelegate.forEachChildDelegate' call
    // Inline function 'androidx.compose.ui.node.LayoutNode.forEachChild' call
    // Inline function 'androidx.compose.runtime.collection.MutableVector.forEach' call
    var this_0 = _get_layoutNode__1t5mf3(this).rb1();
    var i = 0;
    var tmp = this_0.b3e_1;
    var content = isArray(tmp) ? tmp : THROW_CCE();
    var size = this_0.d3e_1;
    while (i < size) {
      var it = content[i];
      ensureNotNull(it.e91_1.nba_1).fbi(true);
      i = i + 1 | 0;
    }
  };
  protoOf(LookaheadPassDelegate).yb3 = function () {
    if (!this.zau_1) {
      if (_get_layoutState__chc8wm(this).equals(LayoutState_LookaheadMeasuring_getInstance())) {
        this.iav_1.nbc_1 = true;
        if (this.iav_1.jbc_1) {
          this.uau_1.tbe();
        }
      } else {
        this.iav_1.obc_1 = true;
      }
    }
    var tmp0_safe_receiver = this.cbf().kac();
    if (tmp0_safe_receiver == null)
      null;
    else {
      tmp0_safe_receiver.fae_1 = true;
    }
    this.gbf();
    var tmp1_safe_receiver = this.cbf().kac();
    if (tmp1_safe_receiver == null)
      null;
    else {
      tmp1_safe_receiver.fae_1 = false;
    }
    return this.iav_1.kbf();
  };
  protoOf(LookaheadPassDelegate).jbf = function () {
    var tmp0_safe_receiver = _get_layoutNode__1t5mf3(this).f9a();
    var tmp1_safe_receiver = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.e91_1;
    return tmp1_safe_receiver == null ? null : tmp1_safe_receiver.hbc();
  };
  protoOf(LookaheadPassDelegate).mbf = function (block) {
    // Inline function 'androidx.compose.ui.node.LayoutNode.forEachChild' call
    // Inline function 'androidx.compose.runtime.collection.MutableVector.forEach' call
    var this_0 = _get_layoutNode__1t5mf3(this).rb1();
    var i = 0;
    var tmp = this_0.b3e_1;
    var content = isArray(tmp) ? tmp : THROW_CCE();
    var size = this_0.d3e_1;
    while (i < size) {
      var it = content[i];
      block(ensureNotNull(it.e91_1.hbc()));
      i = i + 1 | 0;
    }
  };
  protoOf(LookaheadPassDelegate).obf = function () {
    _get_layoutNode__1t5mf3(this).hbe();
  };
  protoOf(LookaheadPassDelegate).pbf = function () {
    _get_layoutNode__1t5mf3(this).bax();
  };
  protoOf(LookaheadPassDelegate).fbh = function () {
    if (this.uau_1.lba_1 > 0) {
      // Inline function 'androidx.compose.ui.node.LayoutNode.forEachChild' call
      // Inline function 'androidx.compose.runtime.collection.MutableVector.forEach' call
      var this_0 = _get_layoutNode__1t5mf3(this).rb1();
      var i = 0;
      var tmp = this_0.b3e_1;
      var content = isArray(tmp) ? tmp : THROW_CCE();
      var size = this_0.d3e_1;
      while (i < size) {
        var child = content[i];
        var childLayoutDelegate = child.e91_1;
        var accessed = childLayoutDelegate.jba_1 || childLayoutDelegate.kba_1;
        if (accessed && !childLayoutDelegate.cba_1) {
          child.hbe();
        }
        var tmp0_safe_receiver = childLayoutDelegate.nba_1;
        if (tmp0_safe_receiver == null)
          null;
        else {
          tmp0_safe_receiver.fbh();
        }
        i = i + 1 | 0;
      }
    }
  };
  protoOf(LookaheadPassDelegate).h8y = function (constraints) {
    var tmp;
    var tmp0_safe_receiver = _get_layoutNode__1t5mf3(this).f9a();
    if (equals(tmp0_safe_receiver == null ? null : tmp0_safe_receiver.zav(), LayoutState_LookaheadMeasuring_getInstance())) {
      tmp = true;
    } else {
      var tmp1_safe_receiver = _get_layoutNode__1t5mf3(this).f9a();
      tmp = equals(tmp1_safe_receiver == null ? null : tmp1_safe_receiver.zav(), LayoutState_LookaheadLayingOut_getInstance());
    }
    if (tmp) {
      this.uau_1.yb9_1 = false;
    }
    trackLookaheadMeasurementByParent(this, _get_layoutNode__1t5mf3(this));
    if (_get_layoutNode__1t5mf3(this).a91_1.equals(UsageByParent_NotUsed_getInstance())) {
      _get_layoutNode__1t5mf3(this).obe();
    }
    this.kbe(constraints);
    return this;
  };
  protoOf(LookaheadPassDelegate).xag = function () {
    return this.oav_1;
  };
  protoOf(LookaheadPassDelegate).wbg = function (constraints) {
    _set_layoutState__s9dmqm(this, LayoutState_LookaheadMeasuring_getInstance());
    _set_measurePending__3k9pzy(this, false);
    this.pav_1 = constraints;
    var observer = requireOwner_0(_get_layoutNode__1t5mf3(this)).fb0();
    var tmp2 = _get_layoutNode__1t5mf3(this);
    // Inline function 'androidx.compose.ui.node.OwnerSnapshotObserver.observeMeasureSnapshotReadsAffectingLookahead' call
    var block = this.qav_1;
    // Inline function 'androidx.compose.ui.node.OwnerSnapshotObserver.observeReads' call
    var onChanged = access$_get_onCommitAffectingLookaheadMeasure__239e9u(observer);
    access$_get_observer__zh6fij(observer).z5a(tmp2, onChanged, block);
    this.rbe();
    if (get_isOutMostLookaheadRoot(_get_layoutNode__1t5mf3(this))) {
      this.nau().obg();
    } else {
      this.nau().sbe();
    }
    _set_layoutState__s9dmqm(this, LayoutState_Idle_getInstance());
  };
  protoOf(LookaheadPassDelegate).kbe = function (constraints) {
    // Inline function 'androidx.compose.ui.node.withComposeStackTrace' call
    var layoutNode = _get_layoutNode__1t5mf3(this);
    var tmp;
    try {
      // Inline function 'androidx.compose.ui.internal.requirePrecondition' call
      if (!!_get_layoutNode__1t5mf3(this).o91_1) {
        var tmp$ret$3 = 'measure is called on a deactivated node';
        throwIllegalArgumentException(tmp$ret$3);
      }
      var parent = _get_layoutNode__1t5mf3(this).f9a();
      _get_layoutNode__1t5mf3(this).c91_1 = _get_layoutNode__1t5mf3(this).c91_1 || (!(parent == null) && parent.c91_1);
      var tmp_0;
      if (_get_layoutNode__1t5mf3(this).cax()) {
        tmp_0 = true;
      } else {
        var tmp_1 = this.cav_1;
        tmp_0 = !equals(tmp_1 == null ? null : new Constraints_0(tmp_1), new Constraints_0(constraints));
      }
      if (tmp_0) {
        this.cav_1 = constraints;
        this.aap(constraints);
        this.iav_1.nbc_1 = false;
        this.mbf(LookaheadPassDelegate$remeasure$lambda);
        var tmp_2;
        if (this.bav_1) {
          tmp_2 = this.k8y_1;
        } else {
          var tmp0 = -2147483648;
          // Inline function 'androidx.compose.ui.unit.IntSize' call
          // Inline function 'androidx.compose.ui.util.packInts' call
          var val2 = -2147483648;
          var tmp$ret$5 = bitwiseOr(shiftLeft(fromInt(tmp0), 32), bitwiseAnd(fromInt(val2), new Long(-1, 0)));
          tmp_2 = _IntSize___init__impl__emcjft(tmp$ret$5);
        }
        var lastLookaheadSize = tmp_2;
        this.bav_1 = true;
        var lookaheadDelegate = _get_outerCoordinator__reuldi(this).kac();
        // Inline function 'androidx.compose.ui.internal.checkPrecondition' call
        if (!!(lookaheadDelegate == null)) {
          var tmp$ret$7 = 'Lookahead result from lookaheadRemeasure cannot be null';
          throwIllegalStateException(tmp$ret$7);
        }
        this.uau_1.vbg(constraints);
        var tmp0_0 = lookaheadDelegate.i8y_1;
        // Inline function 'androidx.compose.ui.unit.IntSize' call
        // Inline function 'androidx.compose.ui.util.packInts' call
        var val2_0 = lookaheadDelegate.j8y_1;
        var tmp$ret$9 = bitwiseOr(shiftLeft(fromInt(tmp0_0), 32), bitwiseAnd(fromInt(val2_0), new Long(-1, 0)));
        var tmp$ret$8 = _IntSize___init__impl__emcjft(tmp$ret$9);
        this.eah(tmp$ret$8);
        var tmp_3;
        // Inline function 'androidx.compose.ui.unit.IntSize.width' call
        // Inline function 'androidx.compose.ui.util.unpackInt1' call
        var value = _IntSize___get_packedValue__impl__uho7jf(lastLookaheadSize);
        if (!(convertToInt(shiftRight(value, 32)) === lookaheadDelegate.i8y_1)) {
          tmp_3 = true;
        } else {
          // Inline function 'androidx.compose.ui.unit.IntSize.height' call
          // Inline function 'androidx.compose.ui.util.unpackInt2' call
          var value_0 = _IntSize___get_packedValue__impl__uho7jf(lastLookaheadSize);
          tmp_3 = !(convertToInt(bitwiseAnd(value_0, new Long(-1, 0))) === lookaheadDelegate.j8y_1);
        }
        var sizeChanged = tmp_3;
        return sizeChanged;
      } else {
        var tmp0_safe_receiver = _get_layoutNode__1t5mf3(this).l90_1;
        if (tmp0_safe_receiver == null)
          null;
        else {
          tmp0_safe_receiver.ibi(_get_layoutNode__1t5mf3(this), true);
        }
        _get_layoutNode__1t5mf3(this).xbe();
      }
      return false;
    } catch ($p) {
      var tmp_4;
      if ($p instanceof Error) {
        var e = $p;
        layoutNode.dbc(e);
      } else {
        throw $p;
      }
      tmp = tmp_4;
    }
  };
  protoOf(LookaheadPassDelegate).lah = function (position, zIndex, layerBlock) {
    placeSelf_0(this, position, zIndex, layerBlock, null);
  };
  protoOf(LookaheadPassDelegate).nah = function (position, zIndex, layer) {
    placeSelf_0(this, position, zIndex, null, layer);
  };
  protoOf(LookaheadPassDelegate).yao = function (newMFR) {
    var tmp0_safe_receiver = _get_outerCoordinator__reuldi(this).kac();
    var old = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.mb4();
    if (!(newMFR === old)) {
      var tmp1_safe_receiver = _get_outerCoordinator__reuldi(this).kac();
      if (tmp1_safe_receiver == null)
        null;
      else {
        tmp1_safe_receiver.lb4(newMFR);
      }
    }
    this.rav_1 = newMFR;
  };
  protoOf(LookaheadPassDelegate).mah = function () {
    return ensureNotNull(_get_outerCoordinator__reuldi(this).kac()).mah();
  };
  protoOf(LookaheadPassDelegate).kah = function (alignmentLine) {
    var tmp0_safe_receiver = _get_layoutNode__1t5mf3(this).f9a();
    if (equals(tmp0_safe_receiver == null ? null : tmp0_safe_receiver.zav(), LayoutState_LookaheadMeasuring_getInstance())) {
      this.iav_1.kbc_1 = true;
    } else {
      var tmp1_safe_receiver = _get_layoutNode__1t5mf3(this).f9a();
      if (equals(tmp1_safe_receiver == null ? null : tmp1_safe_receiver.zav(), LayoutState_LookaheadLayingOut_getInstance())) {
        this.iav_1.lbc_1 = true;
      }
    }
    this.zau_1 = true;
    var result = ensureNotNull(_get_outerCoordinator__reuldi(this).kac()).kah(alignmentLine);
    this.zau_1 = false;
    return result;
  };
  protoOf(LookaheadPassDelegate).b98 = function (height) {
    onIntrinsicsQueried(this);
    return ensureNotNull(_get_outerCoordinator__reuldi(this).kac()).b98(height);
  };
  protoOf(LookaheadPassDelegate).c98 = function (height) {
    onIntrinsicsQueried(this);
    return ensureNotNull(_get_outerCoordinator__reuldi(this).kac()).c98(height);
  };
  protoOf(LookaheadPassDelegate).d98 = function (width) {
    onIntrinsicsQueried(this);
    return ensureNotNull(_get_outerCoordinator__reuldi(this).kac()).d98(width);
  };
  protoOf(LookaheadPassDelegate).e98 = function (width) {
    onIntrinsicsQueried(this);
    return ensureNotNull(_get_outerCoordinator__reuldi(this).kac()).e98(width);
  };
  protoOf(LookaheadPassDelegate).xbd = function (forceRequest) {
    var parent = _get_layoutNode__1t5mf3(this).f9a();
    var intrinsicsUsageByParent = _get_layoutNode__1t5mf3(this).a91_1;
    if (!(parent == null) && !intrinsicsUsageByParent.equals(UsageByParent_NotUsed_getInstance())) {
      var intrinsicsUsingParent = parent;
      $l$loop: while (intrinsicsUsingParent.a91_1.equals(intrinsicsUsageByParent)) {
        var tmp0_elvis_lhs = intrinsicsUsingParent.f9a();
        var tmp;
        if (tmp0_elvis_lhs == null) {
          break $l$loop;
        } else {
          tmp = tmp0_elvis_lhs;
        }
        intrinsicsUsingParent = tmp;
      }
      switch (intrinsicsUsageByParent.a1_1) {
        case 0:
          if (!(intrinsicsUsingParent.f90_1 == null)) {
            intrinsicsUsingParent.bax(forceRequest);
          } else {
            intrinsicsUsingParent.wav(forceRequest);
          }

          break;
        case 1:
          if (!(intrinsicsUsingParent.f90_1 == null)) {
            intrinsicsUsingParent.rbd(forceRequest);
          } else {
            intrinsicsUsingParent.tbd(forceRequest);
          }

          break;
        default:
          // Inline function 'kotlin.error' call

          var message = "Intrinsics isn't used by the parent";
          throw IllegalStateException_init_$Create$(toString(message));
      }
    }
  };
  protoOf(LookaheadPassDelegate).abd = function () {
    this.nav_1 = true;
  };
  protoOf(LookaheadPassDelegate).xbg = function () {
    if (this.oav_1 == null && ensureNotNull(_get_outerCoordinator__reuldi(this).kac()).xag() == null) {
      return false;
    }
    if (!this.nav_1)
      return false;
    this.nav_1 = false;
    this.oav_1 = ensureNotNull(_get_outerCoordinator__reuldi(this).kac()).xag();
    return true;
  };
  protoOf(LookaheadPassDelegate).zb3 = function () {
    this.tav_1 = true;
    var parent = _get_layoutNode__1t5mf3(this).f9a();
    if (!this.hav_1.equals(PlacedState_IsPlacedInLookahead_getInstance()) && !_get_detachedFromParentLookaheadPlacement__4pbrcy(this) || (!this.hav_1.equals(PlacedState_IsPlacedInApproach_getInstance()) && _get_detachedFromParentLookaheadPlacement__4pbrcy(this))) {
      markNodeAndSubtreeAsPlaced(this);
      if (this.vau_1) {
        if (parent == null)
          null;
        else {
          parent.hbe();
        }
      }
    }
    if (!(parent == null)) {
      if (!this.vau_1 && (parent.zav().equals(LayoutState_LayingOut_getInstance()) || parent.zav().equals(LayoutState_LookaheadLayingOut_getInstance()))) {
        // Inline function 'androidx.compose.ui.internal.checkPrecondition' call
        if (!(this.xau_1 === 2147483647)) {
          var tmp$ret$1 = 'Place was called on a node which was placed already';
          throwIllegalStateException(tmp$ret$1);
        }
        this.xau_1 = parent.e91_1.eba_1;
        var _receiver__tnumb7 = parent.e91_1;
        _receiver__tnumb7.eba_1 = _receiver__tnumb7.eba_1 + 1 | 0;
      }
    } else {
      this.xau_1 = 0;
    }
    this.gbf();
  };
  protoOf(LookaheadPassDelegate).dbd = function () {
    try {
      this.vau_1 = true;
      // Inline function 'androidx.compose.ui.internal.checkPrecondition' call
      if (!this.aav_1) {
        var tmp$ret$1 = 'replace() called on item that was not placed';
        throwIllegalStateException(tmp$ret$1);
      }
      this.tav_1 = false;
      var wasPlacedBefore = this.gbb();
      placeSelf_0(this, this.dav_1, 0.0, this.fav_1, this.gav_1);
      if (wasPlacedBefore && !this.tav_1) {
        var tmp0_safe_receiver = _get_layoutNode__1t5mf3(this).f9a();
        if (tmp0_safe_receiver == null)
          null;
        else {
          tmp0_safe_receiver.hbe();
        }
      }
    }finally {
      this.vau_1 = false;
    }
  };
  protoOf(LookaheadPassDelegate).cbc = function () {
    this.xau_1 = 2147483647;
    this.wau_1 = 2147483647;
    this.hav_1 = PlacedState_IsNotPlaced_getInstance();
  };
  protoOf(LookaheadPassDelegate).ubb = function () {
    this.hav_1 = PlacedState_IsPlacedInLookahead_getInstance();
  };
  var androidx_compose_ui_node_MeasureAndLayoutDelegate_PostponedRequest$stable;
  var androidx_compose_ui_node_MeasureAndLayoutDelegate$stable;
  function doLookaheadRemeasure($this, layoutNode, constraints) {
    if (layoutNode.f90_1 == null)
      return false;
    var tmp;
    var tmp_0 = constraints;
    if (!((tmp_0 == null ? null : new Constraints_0(tmp_0)) == null)) {
      tmp = layoutNode.jbe(constraints);
    } else {
      tmp = layoutNode.lbe();
    }
    var lookaheadSizeChanged = tmp;
    var parent = layoutNode.f9a();
    if (lookaheadSizeChanged && !(parent == null)) {
      if (parent.f90_1 == null) {
        parent.wav(VOID, VOID, false);
      } else if (layoutNode.xbc().equals(UsageByParent_InMeasureBlock_getInstance())) {
        parent.bax(VOID, VOID, false);
      } else if (layoutNode.xbc().equals(UsageByParent_InLayoutBlock_getInstance())) {
        parent.hbe();
      }
    }
    return lookaheadSizeChanged;
  }
  function doRemeasure($this, layoutNode, constraints) {
    var tmp;
    var tmp_0 = constraints;
    if (!((tmp_0 == null ? null : new Constraints_0(tmp_0)) == null)) {
      tmp = layoutNode.nbe(constraints);
    } else {
      tmp = layoutNode.pbe();
    }
    var sizeChanged = tmp;
    var parent = layoutNode.f9a();
    if (sizeChanged && !(parent == null)) {
      if (layoutNode.wbc().equals(UsageByParent_InMeasureBlock_getInstance())) {
        parent.wav(VOID, VOID, false);
      } else if (layoutNode.wbc().equals(UsageByParent_InLayoutBlock_getInstance())) {
        parent.fb8();
      }
    }
    return sizeChanged;
  }
  function ensureSubtreeLookaheadReplaced($this, layoutNode) {
    // Inline function 'androidx.compose.ui.node.LayoutNode.forEachChild' call
    // Inline function 'androidx.compose.runtime.collection.MutableVector.forEach' call
    var this_0 = layoutNode.rb1();
    var i = 0;
    var tmp = this_0.b3e_1;
    var content = isArray(tmp) ? tmp : THROW_CCE();
    var size = this_0.d3e_1;
    while (i < size) {
      var it = content[i];
      if (it.fbb() === true && !it.o91_1) {
        if ($this.kbi_1.zb1(it, true)) {
          it.ebd();
        }
        ensureSubtreeLookaheadReplaced($this, it);
      }
      i = i + 1 | 0;
    }
  }
  function callOnLayoutCompletedListeners($this) {
    // Inline function 'androidx.compose.runtime.collection.MutableVector.forEach' call
    var this_0 = $this.obi_1;
    var i = 0;
    var tmp = this_0.b3e_1;
    var content = isArray(tmp) ? tmp : THROW_CCE();
    var size = this_0.d3e_1;
    while (i < size) {
      content[i].hb0();
      i = i + 1 | 0;
    }
    $this.obi_1.c3();
  }
  function remeasureAndRelayoutIfNeeded($this, layoutNode, affectsLookahead) {
    affectsLookahead = affectsLookahead === VOID ? true : affectsLookahead;
    var sizeChanged = false;
    if (layoutNode.o91_1) {
      return false;
    }
    if (_get_isUsedInMeasureOrLayout__ndt6lu($this, layoutNode)) {
      var tmp;
      if (layoutNode === $this.jbi_1) {
        var tmp_0 = $this.rbi_1;
        tmp = ensureNotNull(tmp_0 == null ? null : new Constraints_0(tmp_0)).m5e_1;
      } else {
        tmp = null;
      }
      var constraints = tmp;
      if (affectsLookahead) {
        if (layoutNode.cax()) {
          // Inline function 'androidx.compose.ui.node.traceMeasureLayout' call
          var tmp_1;
          if (ComposeToolingFlags_instance.f3f_1) {
            // Inline function 'androidx.compose.ui.util.trace' call
            tmp_1 = doLookaheadRemeasure($this, layoutNode, constraints);
          } else {
            tmp_1 = doLookaheadRemeasure($this, layoutNode, constraints);
          }
          sizeChanged = tmp_1;
        }
        if ((sizeChanged || layoutNode.sbd()) && layoutNode.fbb() === true) {
          // Inline function 'androidx.compose.ui.node.traceMeasureLayout' call
          if (ComposeToolingFlags_instance.f3f_1) {
            // Inline function 'androidx.compose.ui.util.trace' call
            layoutNode.ebd();
          } else {
            layoutNode.ebd();
          }
        }
      } else {
        if (layoutNode.aax()) {
          // Inline function 'androidx.compose.ui.node.traceMeasureLayout' call
          var tmp_2;
          if (ComposeToolingFlags_instance.f3f_1) {
            // Inline function 'androidx.compose.ui.util.trace' call
            tmp_2 = doRemeasure($this, layoutNode, constraints);
          } else {
            tmp_2 = doRemeasure($this, layoutNode, constraints);
          }
          sizeChanged = tmp_2;
        }
        if (layoutNode.ubd()) {
          var tmp_3;
          if (layoutNode === $this.jbi_1) {
            tmp_3 = true;
          } else {
            var tmp_4;
            var tmp0_safe_receiver = layoutNode.f9a();
            if ((tmp0_safe_receiver == null ? null : tmp0_safe_receiver.b9i()) === true) {
              tmp_4 = layoutNode.vbc();
            } else {
              tmp_4 = false;
            }
            tmp_3 = tmp_4;
          }
          var isPlacedByPlacedParent = tmp_3;
          if (isPlacedByPlacedParent) {
            // Inline function 'androidx.compose.ui.node.traceMeasureLayout' call
            if (ComposeToolingFlags_instance.f3f_1) {
              // Inline function 'androidx.compose.ui.util.trace' call
              if (layoutNode === $this.jbi_1) {
                layoutNode.bbd(0, 0);
              } else {
                layoutNode.jb4();
              }
            } else {
              if (layoutNode === $this.jbi_1) {
                layoutNode.bbd(0, 0);
              } else {
                layoutNode.jb4();
              }
            }
            $this.nbi_1.wbi(layoutNode);
            var tmp1_safe_receiver = $this.tbi_1;
            if (tmp1_safe_receiver == null)
              null;
            else {
              tmp1_safe_receiver.ebh();
            }
          }
        }
      }
      drainPostponedMeasureRequests($this);
    }
    return sizeChanged;
  }
  function remeasureIfNeeded($this, layoutNode, affectsLookahead, shouldTraceMeasure) {
    affectsLookahead = affectsLookahead === VOID ? true : affectsLookahead;
    shouldTraceMeasure = shouldTraceMeasure === VOID ? false : shouldTraceMeasure;
    var sizeChanged = false;
    if (layoutNode.o91_1) {
      return false;
    }
    if (_get_isUsedInMeasureOrLayout__ndt6lu($this, layoutNode)) {
      var tmp;
      if (layoutNode === $this.jbi_1) {
        var tmp_0 = $this.rbi_1;
        tmp = ensureNotNull(tmp_0 == null ? null : new Constraints_0(tmp_0)).m5e_1;
      } else {
        tmp = null;
      }
      var constraints = tmp;
      if (affectsLookahead) {
        if (layoutNode.cax()) {
          // Inline function 'androidx.compose.ui.node.traceMeasureLayoutIf' call
          var tmp_1;
          if (ComposeToolingFlags_instance.f3f_1 && shouldTraceMeasure) {
            // Inline function 'androidx.compose.ui.util.trace' call
            tmp_1 = doLookaheadRemeasure($this, layoutNode, constraints);
          } else {
            tmp_1 = doLookaheadRemeasure($this, layoutNode, constraints);
          }
          sizeChanged = tmp_1;
        }
      } else {
        if (layoutNode.aax()) {
          // Inline function 'androidx.compose.ui.node.traceMeasureLayoutIf' call
          var tmp_2;
          if (ComposeToolingFlags_instance.f3f_1 && shouldTraceMeasure) {
            // Inline function 'androidx.compose.ui.util.trace' call
            tmp_2 = doRemeasure($this, layoutNode, constraints);
          } else {
            tmp_2 = doRemeasure($this, layoutNode, constraints);
          }
          sizeChanged = tmp_2;
        }
      }
      drainPostponedMeasureRequests($this);
    }
    return sizeChanged;
  }
  function _get_isUsedInMeasureOrLayout__ndt6lu($this, $receiver) {
    return $receiver.b9i() || $receiver.vbc() || _get_canAffectPlacedParent__sbi00r($this, $receiver) || $receiver.fbb() === true || _get_canAffectParentInLookahead__1mzpbx($this, $receiver) || $receiver.gbc();
  }
  function drainPostponedMeasureRequests($this) {
    // Inline function 'androidx.compose.runtime.collection.MutableVector.isNotEmpty' call
    if (!($this.qbi_1.d3e_1 === 0)) {
      // Inline function 'androidx.compose.runtime.collection.MutableVector.forEach' call
      var this_0 = $this.qbi_1;
      var i = 0;
      var tmp = this_0.b3e_1;
      var content = isArray(tmp) ? tmp : THROW_CCE();
      var size = this_0.d3e_1;
      while (i < size) {
        var request = content[i];
        if (request.bbh_1.y91()) {
          if (!request.cbh_1) {
            request.bbh_1.wav(request.dbh_1, VOID, false);
          } else {
            request.bbh_1.bax(request.dbh_1, VOID, false);
          }
        }
        i = i + 1 | 0;
      }
      $this.qbi_1.c3();
    }
  }
  function onlyRemeasureIfPending($this, node, affectsLookahead) {
    if (measurePending($this, node, affectsLookahead)) {
      remeasureIfNeeded($this, node, affectsLookahead);
    }
  }
  function forceMeasureTheSubtreeInternal($this, layoutNode, affectsLookahead) {
    // Inline function 'androidx.compose.ui.node.LayoutNode.forEachChild' call
    // Inline function 'androidx.compose.runtime.collection.MutableVector.forEach' call
    var this_0 = layoutNode.rb1();
    var i = 0;
    var tmp = this_0.b3e_1;
    var content = isArray(tmp) ? tmp : THROW_CCE();
    var size = this_0.d3e_1;
    while (i < size) {
      var child = content[i];
      if (!affectsLookahead && _get_remeasureCanAffectParentSize__xiyu4a($this, child) || (affectsLookahead && _get_lookaheadRemeasureCanAffectParentSize__hrq816($this, child))) {
        if (get_isOutMostLookaheadRoot(child) && !affectsLookahead) {
          if (child.cax() && $this.kbi_1.zb1(child, true)) {
            remeasureIfNeeded($this, child, true);
          } else {
            $this.ibi(child, true);
          }
        }
        onlyRemeasureIfPending($this, child, affectsLookahead);
        if (!measurePending($this, child, affectsLookahead)) {
          forceMeasureTheSubtreeInternal($this, child, affectsLookahead);
        }
      }
      i = i + 1 | 0;
    }
    onlyRemeasureIfPending($this, layoutNode, affectsLookahead);
  }
  function _get_remeasureCanAffectParentSize__xiyu4a($this, $receiver) {
    return $receiver.wbc().equals(UsageByParent_InMeasureBlock_getInstance()) || $receiver.e91_1.sbc().sad().rbc();
  }
  function _get_measuredByPlacedParent__i2czc7($this, $receiver) {
    var node = $receiver;
    $l$loop: while (true) {
      var tmp;
      if (!node.wbc().equals(UsageByParent_NotUsed_getInstance()) || node.e91_1.sbc().sad().rbc()) {
        tmp = true;
      } else {
        var tmp0_safe_receiver = node.f9a();
        tmp = equals(tmp0_safe_receiver == null ? null : tmp0_safe_receiver.zav(), LayoutState_Measuring_getInstance());
      }
      if (!tmp) {
        break $l$loop;
      }
      var tmp1_elvis_lhs = node.f9a();
      var tmp_0;
      if (tmp1_elvis_lhs == null) {
        return false;
      } else {
        tmp_0 = tmp1_elvis_lhs;
      }
      var parent = tmp_0;
      if (parent.b9i()) {
        return true;
      }
      node = parent;
    }
    return false;
  }
  function _get_canAffectPlacedParent__sbi00r($this, $receiver) {
    return $receiver.aax() && _get_measuredByPlacedParent__i2czc7($this, $receiver);
  }
  function _get_canAffectParentInLookahead__1mzpbx($this, $receiver) {
    var tmp;
    if ($receiver.cax()) {
      var tmp_0;
      if (!$receiver.xbc().equals(UsageByParent_NotUsed_getInstance())) {
        tmp_0 = true;
      } else {
        var tmp0_safe_receiver = $receiver.e91_1.hbc();
        var tmp1_safe_receiver = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.sad();
        tmp_0 = (tmp1_safe_receiver == null ? null : tmp1_safe_receiver.rbc()) === true;
      }
      tmp = tmp_0;
    } else {
      tmp = false;
    }
    return tmp;
  }
  function _get_lookaheadRemeasureCanAffectParentSize__hrq816($this, $receiver) {
    var tmp;
    if ($receiver.xbc().equals(UsageByParent_InMeasureBlock_getInstance())) {
      tmp = true;
    } else {
      var tmp0_safe_receiver = $receiver.e91_1.hbc();
      var tmp1_safe_receiver = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.sad();
      tmp = (tmp1_safe_receiver == null ? null : tmp1_safe_receiver.rbc()) === true;
    }
    return tmp;
  }
  function measurePending($this, $receiver, affectsLookahead) {
    return affectsLookahead ? $receiver.cax() : $receiver.aax();
  }
  function PostponedRequest(node, isLookahead, isForced) {
    this.bbh_1 = node;
    this.cbh_1 = isLookahead;
    this.dbh_1 = isForced;
  }
  function MeasureAndLayoutDelegate(root) {
    this.jbi_1 = root;
    this.kbi_1 = new DepthSortedSetsForDifferentPasses(Companion_instance_40.xbi_1);
    this.lbi_1 = false;
    this.mbi_1 = false;
    this.nbi_1 = new OnPositionedDispatcher();
    var tmp = this;
    // Inline function 'androidx.compose.runtime.collection.mutableVectorOf' call
    // Inline function 'androidx.compose.runtime.collection.MutableVector' call
    // Inline function 'kotlin.arrayOfNulls' call
    var tmp$ret$2 = Array(16);
    tmp.obi_1 = new MutableVector(tmp$ret$2, 0);
    this.pbi_1 = new Long(1, 0);
    var tmp_0 = this;
    // Inline function 'androidx.compose.runtime.collection.mutableVectorOf' call
    // Inline function 'androidx.compose.runtime.collection.MutableVector' call
    // Inline function 'kotlin.arrayOfNulls' call
    var tmp$ret$5 = Array(16);
    tmp_0.qbi_1 = new MutableVector(tmp$ret$5, 0);
    this.rbi_1 = null;
    this.sbi_1 = null;
    var tmp_1 = this;
    var tmp_2;
    if (Companion_instance_40.xbi_1) {
      tmp_2 = new LayoutTreeConsistencyChecker(this.jbi_1, this.kbi_1, this.qbi_1.q10());
    } else {
      tmp_2 = null;
    }
    tmp_1.tbi_1 = tmp_2;
  }
  protoOf(MeasureAndLayoutDelegate).ybi = function () {
    return this.kbi_1.fv();
  };
  protoOf(MeasureAndLayoutDelegate).zbi = function () {
    return this.nbi_1.fv();
  };
  protoOf(MeasureAndLayoutDelegate).abj = function (constraints) {
    var tmp = this.rbi_1;
    if (!equals(tmp == null ? null : new Constraints_0(tmp), new Constraints_0(constraints))) {
      // Inline function 'androidx.compose.ui.internal.requirePrecondition' call
      if (!!this.lbi_1) {
        var tmp$ret$1 = 'updateRootConstraints called while measuring';
        throwIllegalArgumentException(tmp$ret$1);
      }
      this.rbi_1 = constraints;
      if (!(this.jbi_1.f90_1 == null)) {
        this.jbi_1.ube();
      }
      this.jbi_1.sbe();
      var tmp_0;
      if (!(this.jbi_1.f90_1 == null)) {
        tmp_0 = Invalidation_LookaheadMeasurement_getInstance();
      } else {
        tmp_0 = Invalidation_Measurement_getInstance();
      }
      this.kbi_1.eb2(this.jbi_1, tmp_0);
    }
  };
  protoOf(MeasureAndLayoutDelegate).bbj = function (layoutNode, forced) {
    // Inline function 'androidx.compose.ui.internal.checkPrecondition' call
    if (!!(layoutNode.f90_1 == null)) {
      var tmp$ret$1 = 'Error: requestLookaheadRemeasure cannot be called on a node outside LookaheadScope';
      throwIllegalStateException(tmp$ret$1);
    }
    var tmp;
    switch (layoutNode.zav().a1_1) {
      case 1:
        tmp = false;
        break;
      case 0:
      case 3:
      case 2:
        this.qbi_1.zz(new PostponedRequest(layoutNode, true, forced));
        var tmp1_safe_receiver = this.tbi_1;
        if (tmp1_safe_receiver == null)
          null;
        else {
          tmp1_safe_receiver.ebh();
        }

        tmp = false;
        break;
      case 4:
        var tmp_0;
        if (layoutNode.cax() && !forced) {
          tmp_0 = false;
        } else {
          layoutNode.ube();
          layoutNode.sbe();
          var tmp_1;
          if (layoutNode.o91_1) {
            tmp_1 = false;
          } else {
            var tmp_2;
            if (layoutNode.fbb() === true || _get_canAffectParentInLookahead__1mzpbx(this, layoutNode)) {
              var tmp2_safe_receiver = layoutNode.f9a();
              tmp_2 = !((tmp2_safe_receiver == null ? null : tmp2_safe_receiver.cax()) === true);
            } else {
              tmp_2 = false;
            }
            if (tmp_2) {
              this.kbi_1.eb2(layoutNode, Invalidation_LookaheadMeasurement_getInstance());
            } else {
              var tmp_3;
              if (layoutNode.b9i() || _get_canAffectPlacedParent__sbi00r(this, layoutNode)) {
                var tmp3_safe_receiver = layoutNode.f9a();
                tmp_3 = !((tmp3_safe_receiver == null ? null : tmp3_safe_receiver.aax()) === true);
              } else {
                tmp_3 = false;
              }
              if (tmp_3) {
                this.kbi_1.eb2(layoutNode, Invalidation_Measurement_getInstance());
              }
            }
            tmp_1 = !this.mbi_1;
          }
          tmp_0 = tmp_1;
        }

        tmp = tmp_0;
        break;
      default:
        noWhenBranchMatchedException();
        break;
    }
    return tmp;
  };
  protoOf(MeasureAndLayoutDelegate).cbj = function (layoutNode, forced) {
    var tmp;
    switch (layoutNode.zav().a1_1) {
      case 0:
      case 1:
        tmp = false;
        break;
      case 3:
      case 2:
        this.qbi_1.zz(new PostponedRequest(layoutNode, false, forced));
        var tmp1_safe_receiver = this.tbi_1;
        if (tmp1_safe_receiver == null)
          null;
        else {
          tmp1_safe_receiver.ebh();
        }

        tmp = false;
        break;
      case 4:
        var tmp_0;
        if (layoutNode.aax() && !forced) {
          tmp_0 = false;
        } else {
          layoutNode.sbe();
          var tmp_1;
          if (layoutNode.o91_1) {
            tmp_1 = false;
          } else {
            var tmp_2;
            if (layoutNode.b9i() || _get_canAffectPlacedParent__sbi00r(this, layoutNode)) {
              var tmp2_safe_receiver = layoutNode.f9a();
              if (!((tmp2_safe_receiver == null ? null : tmp2_safe_receiver.aax()) === true)) {
                this.kbi_1.eb2(layoutNode, Invalidation_Measurement_getInstance());
              }
              tmp_2 = !this.mbi_1;
            } else {
              tmp_2 = false;
            }
            tmp_1 = tmp_2;
          }
          tmp_0 = tmp_1;
        }

        tmp = tmp_0;
        break;
      default:
        noWhenBranchMatchedException();
        break;
    }
    return tmp;
  };
  protoOf(MeasureAndLayoutDelegate).dbj = function (layoutNode, forced) {
    var tmp;
    switch (layoutNode.zav().a1_1) {
      case 1:
      case 3:
        var tmp1_safe_receiver = this.tbi_1;
        if (tmp1_safe_receiver == null)
          null;
        else {
          tmp1_safe_receiver.ebh();
        }

        tmp = false;
        break;
      case 0:
      case 2:
      case 4:
        var tmp_0;
        if ((layoutNode.cax() || layoutNode.sbd()) && !forced) {
          var tmp2_safe_receiver = this.tbi_1;
          if (tmp2_safe_receiver == null)
            null;
          else {
            tmp2_safe_receiver.ebh();
          }
          tmp_0 = false;
        } else {
          layoutNode.tbe();
          layoutNode.rbe();
          var tmp_1;
          if (layoutNode.o91_1) {
            tmp_1 = false;
          } else {
            var parent = layoutNode.f9a();
            var tmp_2;
            var tmp_3;
            if (layoutNode.fbb() === true) {
              tmp_3 = !((parent == null ? null : parent.cax()) === true);
            } else {
              tmp_3 = false;
            }
            if (tmp_3) {
              tmp_2 = !((parent == null ? null : parent.sbd()) === true);
            } else {
              tmp_2 = false;
            }
            if (tmp_2) {
              this.kbi_1.eb2(layoutNode, Invalidation_LookaheadPlacement_getInstance());
            } else {
              var tmp_4;
              var tmp_5;
              if (layoutNode.b9i()) {
                tmp_5 = !((parent == null ? null : parent.ubd()) === true);
              } else {
                tmp_5 = false;
              }
              if (tmp_5) {
                tmp_4 = !((parent == null ? null : parent.aax()) === true);
              } else {
                tmp_4 = false;
              }
              if (tmp_4) {
                this.kbi_1.eb2(layoutNode, Invalidation_Placement_getInstance());
              }
            }
            tmp_1 = !this.mbi_1;
          }
          tmp_0 = tmp_1;
        }

        tmp = tmp_0;
        break;
      default:
        noWhenBranchMatchedException();
        break;
    }
    return tmp;
  };
  protoOf(MeasureAndLayoutDelegate).ebj = function (layoutNode, forced) {
    var tmp;
    switch (layoutNode.zav().a1_1) {
      case 0:
      case 1:
      case 3:
      case 2:
        var tmp1_safe_receiver = this.tbi_1;
        if (tmp1_safe_receiver == null)
          null;
        else {
          tmp1_safe_receiver.ebh();
        }

        tmp = false;
        break;
      case 4:
        var parent = layoutNode.f9a();
        var parentIsPlaced = parent == null || parent.b9i();
        var tmp_0;
        if (!forced && (layoutNode.aax() || (layoutNode.ubd() && layoutNode.b9i() === parentIsPlaced && layoutNode.b9i() === layoutNode.vbc()))) {
          var tmp2_safe_receiver = this.tbi_1;
          if (tmp2_safe_receiver == null)
            null;
          else {
            tmp2_safe_receiver.ebh();
          }
          tmp_0 = false;
        } else {
          layoutNode.rbe();
          var tmp_1;
          if (layoutNode.o91_1) {
            tmp_1 = false;
          } else {
            var tmp_2;
            if (layoutNode.vbc() && parentIsPlaced) {
              var tmp_3;
              if (!((parent == null ? null : parent.ubd()) === true)) {
                tmp_3 = !((parent == null ? null : parent.aax()) === true);
              } else {
                tmp_3 = false;
              }
              if (tmp_3) {
                this.kbi_1.eb2(layoutNode, Invalidation_Placement_getInstance());
              }
              tmp_2 = !this.mbi_1;
            } else {
              tmp_2 = false;
            }
            tmp_1 = tmp_2;
          }
          tmp_0 = tmp_1;
        }

        tmp = tmp_0;
        break;
      default:
        noWhenBranchMatchedException();
        break;
    }
    return tmp;
  };
  protoOf(MeasureAndLayoutDelegate).bbe = function (layoutNode) {
    this.nbi_1.wbi(layoutNode);
  };
  protoOf(MeasureAndLayoutDelegate).fbj = function (onLayout) {
    var rootNodeResized = {_v: false};
    // Inline function 'androidx.compose.ui.node.MeasureAndLayoutDelegate.performMeasureAndLayout' call
    // Inline function 'androidx.compose.ui.internal.requirePrecondition' call
    if (!this.jbi_1.y91()) {
      var tmp$ret$2 = 'performMeasureAndLayout called with unattached root';
      throwIllegalArgumentException(tmp$ret$2);
    }
    // Inline function 'androidx.compose.ui.internal.requirePrecondition' call
    if (!this.jbi_1.b9i()) {
      var tmp$ret$4 = 'performMeasureAndLayout called with unplaced root';
      throwIllegalArgumentException(tmp$ret$4);
    }
    // Inline function 'androidx.compose.ui.internal.requirePrecondition' call
    if (!!this.lbi_1) {
      var tmp$ret$6 = 'performMeasureAndLayout called during measure layout';
      throwIllegalArgumentException(tmp$ret$6);
    }
    var tmp = this.rbi_1;
    if (!((tmp == null ? null : new Constraints_0(tmp)) == null)) {
      this.lbi_1 = true;
      this.mbi_1 = true;
      try {
        if (this.kbi_1.fv()) {
          // Inline function 'androidx.compose.ui.node.DepthSortedSetsForDifferentPasses.popEach' call
          var this_0 = this.kbi_1;
          $l$loop: while (true) {
            var affectsLookahead;
            var relayoutNeeded;
            var node;
            // Inline function 'androidx.compose.ui.node.DepthSortedSet.isNotEmpty' call
            if (!access$_get_lookaheadAndAncestorMeasureSet__c8luvz(this_0).r()) {
              relayoutNeeded = false;
              node = access$_get_lookaheadAndAncestorMeasureSet__c8luvz(this_0).k3j();
              affectsLookahead = !(node.f90_1 == null);
            } else {
              // Inline function 'androidx.compose.ui.node.DepthSortedSet.isNotEmpty' call
              if (!access$_get_lookaheadAndAncestorPlaceSet__6br020(this_0).r()) {
                relayoutNeeded = true;
                node = access$_get_lookaheadAndAncestorPlaceSet__6br020(this_0).k3j();
                affectsLookahead = !(node.f90_1 == null);
              } else {
                // Inline function 'androidx.compose.ui.node.DepthSortedSet.isNotEmpty' call
                if (!access$_get_approachSet__q1cv7b(this_0).r()) {
                  affectsLookahead = false;
                  node = access$_get_approachSet__q1cv7b(this_0).k3j();
                  relayoutNeeded = true;
                } else {
                  break $l$loop;
                }
              }
            }
            var tmp0 = node;
            var tmp2 = affectsLookahead;
            var tmp_0;
            if (relayoutNeeded) {
              tmp_0 = remeasureAndRelayoutIfNeeded(this, tmp0, tmp2);
            } else {
              var sizeChanged = remeasureIfNeeded(this, tmp0, tmp2, true);
              if (tmp0.sbd()) {
                this.kbi_1.eb2(tmp0, Invalidation_LookaheadPlacement_getInstance());
              }
              if (tmp0.ubd()) {
                this.kbi_1.eb2(tmp0, Invalidation_Placement_getInstance());
              }
              tmp_0 = sizeChanged;
            }
            var sizeChanged_0 = tmp_0;
            if (tmp0 === this.jbi_1 && sizeChanged_0) {
              rootNodeResized._v = true;
            }
          }
          if (onLayout == null)
            null;
          else
            onLayout();
        }
      } catch ($p) {
        if ($p instanceof Error) {
          var t = $p;
          var tmp0_safe_receiver = this.sbi_1;
          var tmp_1;
          if (tmp0_safe_receiver == null) {
            tmp_1 = null;
          } else {
            tmp0_safe_receiver.gbj(t);
            tmp_1 = Unit_instance;
          }
          if (tmp_1 == null)
            throw t;
        } else {
          throw $p;
        }
      }
      finally {
        this.lbi_1 = false;
        this.mbi_1 = false;
      }
      var tmp2_safe_receiver = this.tbi_1;
      if (tmp2_safe_receiver == null)
        null;
      else {
        tmp2_safe_receiver.ebh();
      }
    }
    callOnLayoutCompletedListeners(this);
    return rootNodeResized._v;
  };
  protoOf(MeasureAndLayoutDelegate).wbe = function (layoutNode, constraints) {
    if (layoutNode.o91_1) {
      return Unit_instance;
    }
    // Inline function 'androidx.compose.ui.internal.requirePrecondition' call
    if (!!equals(layoutNode, this.jbi_1)) {
      var tmp$ret$1 = 'measureAndLayout called on root';
      throwIllegalArgumentException(tmp$ret$1);
    }
    // Inline function 'androidx.compose.ui.node.MeasureAndLayoutDelegate.performMeasureAndLayout' call
    // Inline function 'androidx.compose.ui.internal.requirePrecondition' call
    if (!this.jbi_1.y91()) {
      var tmp$ret$4 = 'performMeasureAndLayout called with unattached root';
      throwIllegalArgumentException(tmp$ret$4);
    }
    // Inline function 'androidx.compose.ui.internal.requirePrecondition' call
    if (!this.jbi_1.b9i()) {
      var tmp$ret$6 = 'performMeasureAndLayout called with unplaced root';
      throwIllegalArgumentException(tmp$ret$6);
    }
    // Inline function 'androidx.compose.ui.internal.requirePrecondition' call
    if (!!this.lbi_1) {
      var tmp$ret$8 = 'performMeasureAndLayout called during measure layout';
      throwIllegalArgumentException(tmp$ret$8);
    }
    var tmp = this.rbi_1;
    if (!((tmp == null ? null : new Constraints_0(tmp)) == null)) {
      this.lbi_1 = true;
      this.mbi_1 = false;
      try {
        this.kbi_1.gb2(layoutNode);
        var lookaheadSizeChanged = doLookaheadRemeasure(this, layoutNode, constraints);
        if ((lookaheadSizeChanged || layoutNode.sbd()) && layoutNode.fbb() === true) {
          layoutNode.ebd();
        }
        ensureSubtreeLookaheadReplaced(this, layoutNode);
        doRemeasure(this, layoutNode, constraints);
        if (layoutNode.ubd() && layoutNode.b9i()) {
          layoutNode.jb4();
          this.nbi_1.wbi(layoutNode);
        }
        drainPostponedMeasureRequests(this);
      } catch ($p) {
        if ($p instanceof Error) {
          var t = $p;
          var tmp0_safe_receiver = this.sbi_1;
          var tmp_0;
          if (tmp0_safe_receiver == null) {
            tmp_0 = null;
          } else {
            tmp0_safe_receiver.gbj(t);
            tmp_0 = Unit_instance;
          }
          if (tmp_0 == null)
            throw t;
        } else {
          throw $p;
        }
      }
      finally {
        this.lbi_1 = false;
        this.mbi_1 = false;
      }
      var tmp2_safe_receiver = this.tbi_1;
      if (tmp2_safe_receiver == null)
        null;
      else {
        tmp2_safe_receiver.ebh();
      }
    }
    callOnLayoutCompletedListeners(this);
  };
  protoOf(MeasureAndLayoutDelegate).cb0 = function (listener) {
    // Inline function 'androidx.compose.runtime.collection.MutableVector.plusAssign' call
    this.obi_1.zz(listener);
  };
  protoOf(MeasureAndLayoutDelegate).ibi = function (layoutNode, affectsLookahead) {
    // Inline function 'androidx.compose.ui.internal.checkPrecondition' call
    if (!this.lbi_1) {
      var tmp$ret$1 = 'forceMeasureTheSubtree should be executed during the measureAndLayout pass';
      throwIllegalStateException(tmp$ret$1);
    }
    // Inline function 'androidx.compose.ui.internal.requirePrecondition' call
    if (!!measurePending(this, layoutNode, affectsLookahead)) {
      var tmp$ret$3 = 'node not yet measured';
      throwIllegalArgumentException(tmp$ret$3);
    }
    forceMeasureTheSubtreeInternal(this, layoutNode, affectsLookahead);
  };
  protoOf(MeasureAndLayoutDelegate).hbj = function (forceDispatch) {
    if (forceDispatch) {
      this.nbi_1.ibj(this.jbi_1);
    }
    if (this.nbi_1.fv()) {
      // Inline function 'androidx.compose.ui.util.trace' call
      this.nbi_1.jbj();
    }
  };
  protoOf(MeasureAndLayoutDelegate).kbj = function (forceDispatch, $super) {
    forceDispatch = forceDispatch === VOID ? false : forceDispatch;
    var tmp;
    if ($super === VOID) {
      this.hbj(forceDispatch);
      tmp = Unit_instance;
    } else {
      tmp = $super.hbj.call(this, forceDispatch);
    }
    return tmp;
  };
  protoOf(MeasureAndLayoutDelegate).lbj = function (node) {
    this.kbi_1.gb2(node);
    this.nbi_1.bbc(node);
  };
  var Invalidation_LookaheadMeasurement_instance;
  var Invalidation_LookaheadPlacement_instance;
  var Invalidation_Measurement_instance;
  var Invalidation_Placement_instance;
  var Invalidation_entriesInitialized;
  function Invalidation_initEntries() {
    if (Invalidation_entriesInitialized)
      return Unit_instance;
    Invalidation_entriesInitialized = true;
    Invalidation_LookaheadMeasurement_instance = new Invalidation('LookaheadMeasurement', 0);
    Invalidation_LookaheadPlacement_instance = new Invalidation('LookaheadPlacement', 1);
    Invalidation_Measurement_instance = new Invalidation('Measurement', 2);
    Invalidation_Placement_instance = new Invalidation('Placement', 3);
  }
  function Invalidation(name, ordinal) {
    Enum.call(this, name, ordinal);
  }
  function Invalidation_LookaheadMeasurement_getInstance() {
    Invalidation_initEntries();
    return Invalidation_LookaheadMeasurement_instance;
  }
  function Invalidation_LookaheadPlacement_getInstance() {
    Invalidation_initEntries();
    return Invalidation_LookaheadPlacement_instance;
  }
  function Invalidation_Measurement_getInstance() {
    Invalidation_initEntries();
    return Invalidation_Measurement_instance;
  }
  function Invalidation_Placement_getInstance() {
    Invalidation_initEntries();
    return Invalidation_Placement_instance;
  }
  var androidx_compose_ui_node_MeasurePassDelegate$stable;
  function _get_lookaheadPassDelegate__ajcz95($this) {
    return $this.eat_1.nba_1;
  }
  function checkChildrenPlaceOrderForUpdates_0($this) {
    // Inline function 'kotlin.with' call
    var $this$with = $this.a9i();
    // Inline function 'androidx.compose.ui.node.LayoutNode.forEachChild' call
    // Inline function 'androidx.compose.runtime.collection.MutableVector.forEach' call
    var this_0 = $this$with.rb1();
    var i = 0;
    var tmp = this_0.b3e_1;
    var content = isArray(tmp) ? tmp : THROW_CCE();
    var size = this_0.d3e_1;
    while (i < size) {
      var child = content[i];
      if (!(child.nau().gat_1 === child.d9i())) {
        $this$with.wba();
        $this$with.xba();
        if (child.d9i() === 2147483647) {
          if (child.e91_1.zb9_1 || get_isOutMostLookaheadRoot(child)) {
            ensureNotNull(child.oau()).fbi(false);
          }
          markSubtreeAsNotPlaced(child.nau());
        }
      }
      i = i + 1 | 0;
    }
  }
  function markSubtreeAsNotPlaced($this) {
    if ($this.sat_1) {
      $this.sat_1 = false;
      requireOwner_0($this.a9i()).xam().bbc($this.a9i());
      // Inline function 'androidx.compose.ui.node.LayoutNode.forEachCoordinatorIncludingInner' call
      var this_0 = $this.a9i();
      var delegate = this_0.hak();
      var final = this_0.car().s94_1;
      while (!equals(delegate, final) && !(delegate == null)) {
        var it = delegate;
        it.cb7();
        it.db7();
        delegate = delegate.s94_1;
      }
      // Inline function 'androidx.compose.ui.node.MeasurePassDelegate.forEachChildDelegate' call
      // Inline function 'androidx.compose.ui.node.LayoutNode.forEachChild' call
      // Inline function 'androidx.compose.runtime.collection.MutableVector.forEach' call
      var this_1 = $this.a9i().rb1();
      var i = 0;
      var tmp = this_1.b3e_1;
      var content = isArray(tmp) ? tmp : THROW_CCE();
      var size = this_1.d3e_1;
      while (i < size) {
        var it_0 = content[i].nau();
        markSubtreeAsNotPlaced(it_0);
        i = i + 1 | 0;
      }
    }
  }
  function markNodeAndSubtreeAsPlaced_0($this) {
    var wasPlaced = $this.sat_1;
    $this.sat_1 = true;
    // Inline function 'kotlin.with' call
    var $this$with = $this.a9i();
    if (!wasPlaced) {
      $this$with.car().gb7();
      requireOwner_0($this$with).xam().tbb($this.a9i());
      if ($this$with.aax()) {
        $this$with.wav(true);
      } else if ($this$with.cax()) {
        $this$with.bax(true);
      }
    }
    // Inline function 'androidx.compose.ui.node.LayoutNode.forEachCoordinatorIncludingInner' call
    var delegate = $this$with.hak();
    var final = $this$with.car().s94_1;
    while (!equals(delegate, final) && !(delegate == null)) {
      var it = delegate;
      if (it.n95_1) {
        it.lb2();
      }
      delegate = delegate.s94_1;
    }
    // Inline function 'androidx.compose.ui.node.LayoutNode.forEachChild' call
    // Inline function 'androidx.compose.runtime.collection.MutableVector.forEach' call
    var this_0 = $this$with.rb1();
    var i = 0;
    var tmp = this_0.b3e_1;
    var content = isArray(tmp) ? tmp : THROW_CCE();
    var size = this_0.d3e_1;
    while (i < size) {
      var it_0 = content[i];
      if (!(it_0.d9i() === 2147483647)) {
        markNodeAndSubtreeAsPlaced_0(it_0.nau());
        $this$with.qbd(it_0);
      }
      i = i + 1 | 0;
    }
  }
  function clearPlaceOrder_0($this) {
    $this.eat_1.fba_1 = 0;
    // Inline function 'androidx.compose.ui.node.MeasurePassDelegate.forEachChildDelegate' call
    // Inline function 'androidx.compose.ui.node.LayoutNode.forEachChild' call
    // Inline function 'androidx.compose.runtime.collection.MutableVector.forEach' call
    var this_0 = $this.a9i().rb1();
    var i = 0;
    var tmp = this_0.b3e_1;
    var content = isArray(tmp) ? tmp : THROW_CCE();
    var size = this_0.d3e_1;
    while (i < size) {
      var child = content[i].nau();
      child.gat_1 = child.hat_1;
      child.hat_1 = 2147483647;
      child.tat_1 = false;
      if (child.kat_1.equals(UsageByParent_InLayoutBlock_getInstance())) {
        child.kat_1 = UsageByParent_NotUsed_getInstance();
      }
      i = i + 1 | 0;
    }
  }
  function trackMeasurementByParent($this, node) {
    var parent = node.f9a();
    if (!(parent == null)) {
      // Inline function 'androidx.compose.ui.internal.checkPrecondition' call
      if (!($this.kat_1.equals(UsageByParent_NotUsed_getInstance()) || node.c91_1)) {
        var tmp$ret$1 = 'measure() may not be called multiple times on the same Measurable. If you want to get the content size of the Measurable before calculating the final constraints, please use methods like minIntrinsicWidth()/maxIntrinsicWidth() and minIntrinsicHeight()/maxIntrinsicHeight()';
        throwIllegalStateException(tmp$ret$1);
      }
      var tmp = $this;
      var tmp_0;
      switch (parent.zav().a1_1) {
        case 0:
          tmp_0 = UsageByParent_InMeasureBlock_getInstance();
          break;
        case 2:
          tmp_0 = UsageByParent_InLayoutBlock_getInstance();
          break;
        default:
          throw IllegalStateException_init_$Create$("Measurable could be only measured from the parent's measure or layout" + (' block. Parents state is ' + parent.zav().toString()));
      }
      tmp.kat_1 = tmp_0;
    } else {
      $this.kat_1 = UsageByParent_NotUsed_getInstance();
    }
  }
  function placeSelf_1($this, position, zIndex, layerBlock, layer) {
    // Inline function 'androidx.compose.ui.node.withComposeStackTrace' call
    var layoutNode = $this.a9i();
    try {
      $this.tat_1 = true;
      if (!equals(position, $this.mat_1) || !(layerBlock === $this.nat_1) || $this.lau_1) {
        if ($this.eat_1.hba_1 || $this.eat_1.gba_1 || $this.lau_1) {
          $this.vat_1 = true;
          $this.lau_1 = false;
        }
      }
      var tmp0_safe_receiver = _get_lookaheadPassDelegate__ajcz95($this);
      if (tmp0_safe_receiver == null)
        null;
      else {
        tmp0_safe_receiver.gbi();
      }
      var tmp3_safe_receiver = _get_lookaheadPassDelegate__ajcz95($this);
      if ((tmp3_safe_receiver == null ? null : tmp3_safe_receiver.hbi()) === true) {
        var tmp1_safe_receiver = $this.nbg().t94_1;
        var tmp2_elvis_lhs = tmp1_safe_receiver == null ? null : tmp1_safe_receiver.gae_1;
        var scope = tmp2_elvis_lhs == null ? requireOwner_0($this.a9i()).cbd() : tmp2_elvis_lhs;
        // Inline function 'kotlin.with' call
        // Inline function 'kotlin.let' call
        var it = ensureNotNull(_get_lookaheadPassDelegate__ajcz95($this));
        var tmp0_safe_receiver_0 = $this.a9i().f9a();
        if (tmp0_safe_receiver_0 == null)
          null;
        else {
          // Inline function 'kotlin.run' call
          tmp0_safe_receiver_0.e91_1.eba_1 = 0;
        }
        it.xau_1 = 2147483647;
        scope.jal(it, _IntOffset___get_x__impl__qiqr5o(position), _IntOffset___get_y__impl__2avpwj(position));
      }
      var tmp4_safe_receiver = _get_lookaheadPassDelegate__ajcz95($this);
      // Inline function 'androidx.compose.ui.internal.checkPrecondition' call
      if (!!((tmp4_safe_receiver == null ? null : tmp4_safe_receiver.aav_1) === false)) {
        var tmp$ret$9 = 'Error: Placement happened before lookahead.';
        throwIllegalStateException(tmp$ret$9);
      }
      placeOuterCoordinator($this, position, zIndex, layerBlock, layer);
    } catch ($p) {
      if ($p instanceof Error) {
        var e = $p;
        layoutNode.dbc(e);
      } else {
        throw $p;
      }
    }
  }
  function placeOuterCoordinator($this, position, zIndex, layerBlock, layer) {
    // Inline function 'androidx.compose.ui.internal.requirePrecondition' call
    if (!!$this.a9i().o91_1) {
      var tmp$ret$1 = 'place is called on a deactivated node';
      throwIllegalArgumentException(tmp$ret$1);
    }
    $this.mbj(LayoutState_LayingOut_getInstance());
    $this.mat_1 = position;
    $this.pat_1 = zIndex;
    $this.nat_1 = layerBlock;
    $this.oat_1 = layer;
    $this.fau_1 = false;
    var owner = requireOwner_0($this.a9i());
    if (!$this.vat_1 && $this.sat_1) {
      $this.nbg().eb7(position, zIndex, layerBlock, layer);
      $this.zb3();
    } else {
      $this.xat_1.obc_1 = false;
      $this.eat_1.qbg(false);
      $this.gau_1 = layerBlock;
      $this.iau_1 = position;
      $this.jau_1 = zIndex;
      $this.hau_1 = layer;
      var tmp0 = owner.fb0();
      var tmp2 = $this.a9i();
      // Inline function 'androidx.compose.ui.node.OwnerSnapshotObserver.observeLayoutModifierSnapshotReads' call
      var block = $this.kau_1;
      // Inline function 'androidx.compose.ui.node.OwnerSnapshotObserver.observeReads' call
      var onChanged = access$_get_onCommitAffectingLayoutModifier__ychcah(tmp0);
      access$_get_observer__zh6fij(tmp0).z5a(tmp2, onChanged, block);
    }
    $this.mbj(LayoutState_Idle_getInstance());
    if ($this.nbg().fae_1 && ($this.eat_1.hba_1 || $this.eat_1.gba_1)) {
      $this.obf();
    }
    $this.jat_1 = true;
  }
  function onIntrinsicsQueried_0($this) {
    $this.a9i().wav();
    var parent = $this.a9i().f9a();
    if (!(parent == null) && $this.a9i().a91_1.equals(UsageByParent_NotUsed_getInstance())) {
      var tmp = $this.a9i();
      switch (parent.zav().a1_1) {
        case 0:
          tmp.a91_1 = UsageByParent_InMeasureBlock_getInstance();
          break;
        case 2:
          tmp.a91_1 = UsageByParent_InLayoutBlock_getInstance();
          break;
        default:
          tmp.a91_1 = parent.a91_1;
          break;
      }
    }
  }
  function onBeforeLayoutChildren_0($this) {
    // Inline function 'androidx.compose.ui.node.LayoutNode.forEachChild' call
    // Inline function 'androidx.compose.runtime.collection.MutableVector.forEach' call
    var this_0 = $this.a9i().rb1();
    var i = 0;
    var tmp = this_0.b3e_1;
    var content = isArray(tmp) ? tmp : THROW_CCE();
    var size = this_0.d3e_1;
    while (i < size) {
      var it = content[i];
      if (it.aax() && it.wbc().equals(UsageByParent_InMeasureBlock_getInstance())) {
        if (it.pbe()) {
          $this.a9i().wav();
        }
      }
      i = i + 1 | 0;
    }
  }
  function access$_set_measurePending__vf4u76($this, _set____db54di) {
    $this.uat_1 = _set____db54di;
    return Unit_instance;
  }
  function access$_set_performMeasureConstraints__or39uc($this, _set____db54di) {
    $this.bau_1 = _set____db54di;
    return Unit_instance;
  }
  function MeasurePassDelegate$performMeasureBlock$lambda(this$0) {
    return function () {
      this$0.nbg().h8y(this$0.bau_1);
      return Unit_instance;
    };
  }
  function MeasurePassDelegate$layoutChildrenBlock$lambda$lambda(it) {
    it.sad().lbc_1 = false;
    return Unit_instance;
  }
  function MeasurePassDelegate$layoutChildrenBlock$lambda$lambda_0(it) {
    it.sad().mbc_1 = it.sad().lbc_1;
    return Unit_instance;
  }
  function MeasurePassDelegate$layoutChildrenBlock$lambda(this$0) {
    return function () {
      clearPlaceOrder_0(this$0);
      this$0.mbf(MeasurePassDelegate$layoutChildrenBlock$lambda$lambda);
      var tmp;
      if (this$0.cbf().fae_1) {
        // Inline function 'androidx.compose.ui.util.fastForEach' call
        var this_0 = this$0.a9i().qaw();
        var inductionVariable = 0;
        var last = this_0.n1() - 1 | 0;
        if (inductionVariable <= last)
          do {
            var index = inductionVariable;
            inductionVariable = inductionVariable + 1 | 0;
            var item = this_0.l1(index);
            item.hak().fae_1 = true;
          }
           while (inductionVariable <= last);
        tmp = Unit_instance;
      }
      this$0.cbf().gag().uad();
      var tmp_0;
      if (this$0.cbf().fae_1) {
        // Inline function 'androidx.compose.ui.util.fastForEach' call
        var this_1 = this$0.a9i().qaw();
        var inductionVariable_0 = 0;
        var last_0 = this_1.n1() - 1 | 0;
        if (inductionVariable_0 <= last_0)
          do {
            var index_0 = inductionVariable_0;
            inductionVariable_0 = inductionVariable_0 + 1 | 0;
            var item_0 = this_1.l1(index_0);
            item_0.hak().fae_1 = false;
          }
           while (inductionVariable_0 <= last_0);
        tmp_0 = Unit_instance;
      }
      checkChildrenPlaceOrderForUpdates_0(this$0);
      this$0.mbf(MeasurePassDelegate$layoutChildrenBlock$lambda$lambda_0);
      return Unit_instance;
    };
  }
  function MeasurePassDelegate$placeOuterCoordinatorBlock$lambda(this$0) {
    return function () {
      var tmp0_safe_receiver = this$0.nbg().t94_1;
      var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.gae_1;
      var scope = tmp1_elvis_lhs == null ? requireOwner_0(this$0.a9i()).cbd() : tmp1_elvis_lhs;
      // Inline function 'kotlin.with' call
      var layerBlock = this$0.gau_1;
      var layer = this$0.hau_1;
      if (!(layer == null)) {
        scope.val(this$0.nbg(), this$0.iau_1, layer, this$0.jau_1);
      } else if (layerBlock == null) {
        scope.kal(this$0.nbg(), this$0.iau_1, this$0.jau_1);
      } else {
        scope.tal(this$0.nbg(), this$0.iau_1, this$0.jau_1, layerBlock);
      }
      return Unit_instance;
    };
  }
  function MeasurePassDelegate$remeasure$lambda(it) {
    it.sad().kbc_1 = false;
    return Unit_instance;
  }
  function MeasurePassDelegate(layoutNodeLayoutDelegate) {
    Placeable.call(this);
    this.eat_1 = layoutNodeLayoutDelegate;
    this.fat_1 = false;
    this.gat_1 = 2147483647;
    this.hat_1 = 2147483647;
    this.iat_1 = false;
    this.jat_1 = false;
    this.kat_1 = UsageByParent_NotUsed_getInstance();
    this.lat_1 = false;
    this.mat_1 = Companion_getInstance_11().c5g_1;
    this.nat_1 = null;
    this.oat_1 = null;
    this.pat_1 = 0.0;
    this.qat_1 = true;
    this.rat_1 = null;
    this.sat_1 = false;
    this.tat_1 = false;
    this.uat_1 = false;
    this.vat_1 = false;
    this.wat_1 = false;
    this.xat_1 = new LayoutNodeAlignmentLines(this);
    var tmp = this;
    // Inline function 'androidx.compose.runtime.collection.MutableVector' call
    // Inline function 'kotlin.arrayOfNulls' call
    var tmp$ret$1 = Array(16);
    tmp.yat_1 = new MutableVector(tmp$ret$1, 0);
    this.zat_1 = true;
    this.aau_1 = false;
    this.bau_1 = Constraints();
    var tmp_0 = this;
    tmp_0.cau_1 = MeasurePassDelegate$performMeasureBlock$lambda(this);
    var tmp_1 = this;
    tmp_1.dau_1 = MeasurePassDelegate$layoutChildrenBlock$lambda(this);
    this.eau_1 = 0.0;
    this.fau_1 = false;
    this.gau_1 = null;
    this.hau_1 = null;
    this.iau_1 = Companion_getInstance_11().c5g_1;
    this.jau_1 = 0.0;
    var tmp_2 = this;
    tmp_2.kau_1 = MeasurePassDelegate$placeOuterCoordinatorBlock$lambda(this);
    this.lau_1 = false;
    this.mau_1 = false;
  }
  protoOf(MeasurePassDelegate).fbf = function () {
    return this.hat_1;
  };
  protoOf(MeasurePassDelegate).qbe = function () {
    var tmp;
    if (this.iat_1) {
      tmp = this.l8y_1;
    } else {
      tmp = null;
    }
    return tmp;
  };
  protoOf(MeasurePassDelegate).a9i = function () {
    return this.eat_1.xb9_1;
  };
  protoOf(MeasurePassDelegate).xag = function () {
    return this.rat_1;
  };
  protoOf(MeasurePassDelegate).mbj = function (value) {
    this.eat_1.aba_1 = value;
  };
  protoOf(MeasurePassDelegate).nbj = function () {
    return this.eat_1.aba_1;
  };
  protoOf(MeasurePassDelegate).nbg = function () {
    return this.eat_1.nbg();
  };
  protoOf(MeasurePassDelegate).cbf = function () {
    return this.a9i().car();
  };
  protoOf(MeasurePassDelegate).sad = function () {
    return this.xat_1;
  };
  protoOf(MeasurePassDelegate).faw = function () {
    this.a9i().hbb();
    if (!this.zat_1)
      return this.yat_1.q10();
    var tmp0 = this.a9i();
    // Inline function 'androidx.compose.ui.node.updateChildMeasurables' call
    var destination = this.yat_1;
    // Inline function 'androidx.compose.ui.node.LayoutNode.forEachChildIndexed' call
    // Inline function 'androidx.compose.runtime.collection.MutableVector.forEachIndexed' call
    var this_0 = tmp0.rb1();
    var i = 0;
    var tmp = this_0.b3e_1;
    var content = isArray(tmp) ? tmp : THROW_CCE();
    var size = this_0.d3e_1;
    while (i < size) {
      var tmp0_0 = i;
      var layoutNode = content[i];
      if (destination.d3e_1 <= tmp0_0) {
        var tmp$ret$4 = layoutNode.e91_1.mba_1;
        destination.zz(tmp$ret$4);
      } else {
        var tmp$ret$5 = layoutNode.e91_1.mba_1;
        destination.mi(tmp0_0, tmp$ret$5);
      }
      i = i + 1 | 0;
    }
    destination.e5(tmp0.qaw().n1(), destination.d3e_1);
    this.zat_1 = false;
    return this.yat_1.q10();
  };
  protoOf(MeasurePassDelegate).gaw = function () {
    this.eat_1.yb9_1 = true;
  };
  protoOf(MeasurePassDelegate).gbf = function () {
    this.aau_1 = true;
    this.xat_1.ibf();
    if (this.vat_1) {
      onBeforeLayoutChildren_0(this);
    }
    if (this.wat_1 || (!this.lat_1 && !this.cbf().fae_1 && this.vat_1)) {
      this.vat_1 = false;
      var oldLayoutState = this.nbj();
      this.mbj(LayoutState_LayingOut_getInstance());
      this.eat_1.pbg(false);
      // Inline function 'kotlin.with' call
      var $this$with = this.a9i();
      var owner = requireOwner_0($this$with);
      var tmp0 = owner.fb0();
      // Inline function 'androidx.compose.ui.node.OwnerSnapshotObserver.observeLayoutSnapshotReads' call
      var block = this.dau_1;
      // Inline function 'androidx.compose.ui.node.OwnerSnapshotObserver.observeReads' call
      var onChanged = access$_get_onCommitAffectingLayout__6g68og(tmp0);
      access$_get_observer__zh6fij(tmp0).z5a($this$with, onChanged, block);
      this.mbj(oldLayoutState);
      this.wat_1 = false;
    }
    if (this.xat_1.lbc_1) {
      this.xat_1.mbc_1 = true;
    }
    if (this.xat_1.jbc_1 && this.xat_1.rbc()) {
      this.xat_1.lbf();
    }
    this.aau_1 = false;
  };
  protoOf(MeasurePassDelegate).zb3 = function () {
    this.fau_1 = true;
    var parent = this.a9i().f9a();
    var newZIndex = this.cbf().d95_1;
    // Inline function 'androidx.compose.ui.node.LayoutNode.forEachCoordinator' call
    var this_0 = this.a9i();
    var coordinator = this_0.hak();
    var inner = this_0.car();
    while (!(coordinator === inner)) {
      newZIndex = newZIndex + (coordinator instanceof LayoutModifierNodeCoordinator ? coordinator : THROW_CCE()).d95_1;
      coordinator = coordinator.s94_1;
    }
    if (!(newZIndex === this.eau_1)) {
      this.eau_1 = newZIndex;
      if (parent == null)
        null;
      else {
        parent.wba();
      }
      if (parent == null)
        null;
      else {
        parent.xba();
      }
    }
    if (!this.cbf().fae_1) {
      var wasPlaced = this.sat_1;
      if (!wasPlaced || this.xat_1.hbf()) {
        markNodeAndSubtreeAsPlaced_0(this);
      }
      if (!wasPlaced) {
        if (parent == null)
          null;
        else {
          parent.xba();
        }
        if (this.fat_1) {
          if (parent == null)
            null;
          else {
            parent.fb8();
          }
        }
      } else {
        this.a9i().car().gb7();
      }
    }
    if (!(parent == null)) {
      if (!this.fat_1 && parent.zav().equals(LayoutState_LayingOut_getInstance())) {
        // Inline function 'androidx.compose.ui.internal.checkPrecondition' call
        if (!(this.hat_1 === 2147483647)) {
          var tmp$ret$3 = 'Place was called on a node which was placed already';
          throwIllegalStateException(tmp$ret$3);
        }
        this.hat_1 = parent.e91_1.fba_1;
        var _receiver__tnumb7 = parent.e91_1;
        _receiver__tnumb7.fba_1 = _receiver__tnumb7.fba_1 + 1 | 0;
      }
    } else {
      this.hat_1 = 0;
    }
    this.gbf();
  };
  protoOf(MeasurePassDelegate).h8y = function (constraints) {
    if (this.a9i().a91_1.equals(UsageByParent_NotUsed_getInstance())) {
      this.a9i().obe();
    }
    if (get_isOutMostLookaheadRoot(this.a9i())) {
      // Inline function 'kotlin.run' call
      var $this$run = ensureNotNull(_get_lookaheadPassDelegate__ajcz95(this));
      $this$run.yau_1 = UsageByParent_NotUsed_getInstance();
      // Inline function 'androidx.compose.ui.node.traceMeasureLayout' call
      var tmp;
      if (ComposeToolingFlags_instance.f3f_1) {
        // Inline function 'androidx.compose.ui.util.trace' call
        tmp = $this$run.h8y(constraints);
      } else {
        tmp = $this$run.h8y(constraints);
      }
    }
    trackMeasurementByParent(this, this.a9i());
    this.kbe(constraints);
    return this;
  };
  protoOf(MeasurePassDelegate).kbe = function (constraints) {
    // Inline function 'androidx.compose.ui.node.withComposeStackTrace' call
    var layoutNode = this.a9i();
    var tmp;
    try {
      // Inline function 'androidx.compose.ui.internal.requirePrecondition' call
      if (!!this.a9i().o91_1) {
        var tmp$ret$3 = 'measure is called on a deactivated node';
        throwIllegalArgumentException(tmp$ret$3);
      }
      var owner = requireOwner_0(this.a9i());
      var parent = this.a9i().f9a();
      this.a9i().c91_1 = this.a9i().c91_1 || (!(parent == null) && parent.c91_1);
      if (this.a9i().aax() || !equals(this.l8y_1, constraints)) {
        this.xat_1.nbc_1 = false;
        this.mbf(MeasurePassDelegate$remeasure$lambda);
        this.iat_1 = true;
        var outerPreviousMeasuredSize = this.nbg().q95();
        this.aap(constraints);
        // Inline function 'androidx.compose.ui.node.MeasurePassDelegate.performMeasure' call
        // Inline function 'androidx.compose.ui.internal.checkPrecondition' call
        if (!this.nbj().equals(LayoutState_Idle_getInstance())) {
          var tmp$ret$6 = 'layout state is not idle before measure starts';
          throwIllegalStateException(tmp$ret$6);
        }
        access$_set_performMeasureConstraints__or39uc(this, constraints);
        this.mbj(LayoutState_Measuring_getInstance());
        access$_set_measurePending__vf4u76(this, false);
        var tmp0 = requireOwner_0(this.a9i()).fb0();
        var tmp2 = this.a9i();
        // Inline function 'androidx.compose.ui.node.OwnerSnapshotObserver.observeMeasureSnapshotReads' call
        var block = this.cau_1;
        // Inline function 'androidx.compose.ui.node.OwnerSnapshotObserver.observeReads' call
        var onChanged = access$_get_onCommitAffectingMeasure__id6h9g(tmp0);
        access$_get_observer__zh6fij(tmp0).z5a(tmp2, onChanged, block);
        if (this.nbj().equals(LayoutState_Measuring_getInstance())) {
          this.obg();
          this.mbj(LayoutState_Idle_getInstance());
        }
        var sizeChanged = !equals(this.nbg().q95(), outerPreviousMeasuredSize) || !(this.nbg().i8y_1 === this.i8y_1) || !(this.nbg().j8y_1 === this.j8y_1);
        var tmp0_0 = this.nbg().i8y_1;
        // Inline function 'androidx.compose.ui.unit.IntSize' call
        // Inline function 'androidx.compose.ui.util.packInts' call
        var val2 = this.nbg().j8y_1;
        var tmp$ret$10 = bitwiseOr(shiftLeft(fromInt(tmp0_0), 32), bitwiseAnd(fromInt(val2), new Long(-1, 0)));
        var tmp$ret$9 = _IntSize___init__impl__emcjft(tmp$ret$10);
        this.eah(tmp$ret$9);
        return sizeChanged;
      } else {
        owner.obj(this.a9i());
        this.a9i().xbe();
      }
      return false;
    } catch ($p) {
      var tmp_0;
      if ($p instanceof Error) {
        var e = $p;
        layoutNode.dbc(e);
      } else {
        throw $p;
      }
      tmp = tmp_0;
    }
  };
  protoOf(MeasurePassDelegate).mah = function () {
    return this.nbg().mah();
  };
  protoOf(MeasurePassDelegate).zao = function () {
    return this.nbg().zao();
  };
  protoOf(MeasurePassDelegate).kah = function (alignmentLine) {
    var tmp0_safe_receiver = this.a9i().f9a();
    if (equals(tmp0_safe_receiver == null ? null : tmp0_safe_receiver.zav(), LayoutState_Measuring_getInstance())) {
      this.xat_1.kbc_1 = true;
    } else {
      var tmp1_safe_receiver = this.a9i().f9a();
      if (equals(tmp1_safe_receiver == null ? null : tmp1_safe_receiver.zav(), LayoutState_LayingOut_getInstance())) {
        this.xat_1.lbc_1 = true;
      }
    }
    this.lat_1 = true;
    var result = this.nbg().kah(alignmentLine);
    this.lat_1 = false;
    return result;
  };
  protoOf(MeasurePassDelegate).lah = function (position, zIndex, layerBlock) {
    placeSelf_1(this, position, zIndex, layerBlock, null);
  };
  protoOf(MeasurePassDelegate).nah = function (position, zIndex, layer) {
    placeSelf_1(this, position, zIndex, null, layer);
  };
  protoOf(MeasurePassDelegate).yao = function (newMFR) {
    var old = this.nbg().mb4();
    if (!(newMFR === old)) {
      this.nbg().lb4(newMFR);
      this.lau_1 = true;
    }
    this.mau_1 = newMFR;
  };
  protoOf(MeasurePassDelegate).dbd = function () {
    try {
      this.fat_1 = true;
      // Inline function 'androidx.compose.ui.internal.checkPrecondition' call
      if (!this.jat_1) {
        var tmp$ret$1 = 'replace called on unplaced item';
        throwIllegalStateException(tmp$ret$1);
      }
      var wasPlacedBefore = this.sat_1;
      placeOuterCoordinator(this, this.mat_1, this.pat_1, this.nat_1, this.oat_1);
      if (wasPlacedBefore && !this.fau_1) {
        var tmp0_safe_receiver = this.a9i().f9a();
        if (tmp0_safe_receiver == null)
          null;
        else {
          tmp0_safe_receiver.fb8();
        }
      }
    } catch ($p) {
      if ($p instanceof Error) {
        var e = $p;
        this.a9i().dbc(e);
      } else {
        throw $p;
      }
    }
    finally {
      this.fat_1 = false;
    }
  };
  protoOf(MeasurePassDelegate).b98 = function (height) {
    if (get_isOutMostLookaheadRoot(this.a9i())) {
      return ensureNotNull(_get_lookaheadPassDelegate__ajcz95(this)).b98(height);
    }
    onIntrinsicsQueried_0(this);
    return this.nbg().b98(height);
  };
  protoOf(MeasurePassDelegate).c98 = function (height) {
    if (get_isOutMostLookaheadRoot(this.a9i())) {
      return ensureNotNull(_get_lookaheadPassDelegate__ajcz95(this)).c98(height);
    }
    onIntrinsicsQueried_0(this);
    return this.nbg().c98(height);
  };
  protoOf(MeasurePassDelegate).d98 = function (width) {
    if (get_isOutMostLookaheadRoot(this.a9i())) {
      return ensureNotNull(_get_lookaheadPassDelegate__ajcz95(this)).d98(width);
    }
    onIntrinsicsQueried_0(this);
    return this.nbg().d98(width);
  };
  protoOf(MeasurePassDelegate).e98 = function (width) {
    if (get_isOutMostLookaheadRoot(this.a9i())) {
      return ensureNotNull(_get_lookaheadPassDelegate__ajcz95(this)).e98(width);
    }
    onIntrinsicsQueried_0(this);
    return this.nbg().e98(width);
  };
  protoOf(MeasurePassDelegate).abd = function () {
    this.qat_1 = true;
  };
  protoOf(MeasurePassDelegate).xbg = function () {
    if (this.rat_1 == null && this.nbg().xag() == null)
      return false;
    if (!this.qat_1)
      return false;
    this.qat_1 = false;
    this.rat_1 = this.nbg().xag();
    return true;
  };
  protoOf(MeasurePassDelegate).yb3 = function () {
    if (!this.lat_1) {
      if (this.nbj().equals(LayoutState_Measuring_getInstance())) {
        this.xat_1.nbc_1 = true;
        if (this.xat_1.jbc_1) {
          this.obg();
        }
      } else {
        this.xat_1.obc_1 = true;
      }
    }
    // Inline function 'kotlin.with' call
    var $this$with = this.cbf();
    var previousIsPlacingForAlignment = $this$with.fae_1;
    $this$with.fae_1 = true;
    this.gbf();
    $this$with.fae_1 = previousIsPlacingForAlignment;
    return this.xat_1.kbf();
  };
  protoOf(MeasurePassDelegate).jbf = function () {
    var tmp0_safe_receiver = this.a9i().f9a();
    var tmp1_safe_receiver = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.e91_1;
    return tmp1_safe_receiver == null ? null : tmp1_safe_receiver.sbc();
  };
  protoOf(MeasurePassDelegate).mbf = function (block) {
    // Inline function 'androidx.compose.ui.node.LayoutNode.forEachChild' call
    // Inline function 'androidx.compose.runtime.collection.MutableVector.forEach' call
    var this_0 = this.a9i().rb1();
    var i = 0;
    var tmp = this_0.b3e_1;
    var content = isArray(tmp) ? tmp : THROW_CCE();
    var size = this_0.d3e_1;
    while (i < size) {
      block(content[i].e91_1.sbc());
      i = i + 1 | 0;
    }
  };
  protoOf(MeasurePassDelegate).obf = function () {
    this.a9i().fb8();
  };
  protoOf(MeasurePassDelegate).pbf = function () {
    this.a9i().wav();
  };
  protoOf(MeasurePassDelegate).ebe = function () {
    if (this.a9i().b9i() && this.eat_1.iba_1 > 0) {
      var childLayoutDelegate = this.a9i().e91_1;
      var accessed = childLayoutDelegate.gba_1 || childLayoutDelegate.hba_1;
      if (accessed && !childLayoutDelegate.ubd()) {
        this.a9i().fb8();
      }
      // Inline function 'androidx.compose.ui.node.LayoutNode.forEachChild' call
      // Inline function 'androidx.compose.runtime.collection.MutableVector.forEach' call
      var this_0 = this.a9i().rb1();
      var i = 0;
      var tmp = this_0.b3e_1;
      var content = isArray(tmp) ? tmp : THROW_CCE();
      var size = this_0.d3e_1;
      while (i < size) {
        content[i].nau().ebe();
        i = i + 1 | 0;
      }
    }
  };
  protoOf(MeasurePassDelegate).xbd = function (forceRequest) {
    var parent = this.a9i().f9a();
    var intrinsicsUsageByParent = this.a9i().a91_1;
    if (!(parent == null) && !intrinsicsUsageByParent.equals(UsageByParent_NotUsed_getInstance())) {
      var intrinsicsUsingParent = parent;
      $l$loop: while (intrinsicsUsingParent.a91_1.equals(intrinsicsUsageByParent)) {
        var tmp0_elvis_lhs = intrinsicsUsingParent.f9a();
        var tmp;
        if (tmp0_elvis_lhs == null) {
          break $l$loop;
        } else {
          tmp = tmp0_elvis_lhs;
        }
        intrinsicsUsingParent = tmp;
      }
      switch (intrinsicsUsageByParent.a1_1) {
        case 0:
          intrinsicsUsingParent.wav(forceRequest);
          break;
        case 1:
          intrinsicsUsingParent.tbd(forceRequest);
          break;
        default:
          // Inline function 'kotlin.error' call

          var message = "Intrinsics isn't used by the parent";
          throw IllegalStateException_init_$Create$(toString(message));
      }
    }
  };
  protoOf(MeasurePassDelegate).cbc = function () {
    this.hat_1 = 2147483647;
    this.gat_1 = 2147483647;
    this.sat_1 = false;
  };
  protoOf(MeasurePassDelegate).obg = function () {
    this.vat_1 = true;
    this.wat_1 = true;
  };
  protoOf(MeasurePassDelegate).sbe = function () {
    this.uat_1 = true;
  };
  function getChildrenOfVirtualChildren(scope) {
    var layoutNode = (isInterface(scope, MeasureScopeWithLayoutNode) ? scope : THROW_CCE()).a9i();
    var lookahead = isInLookaheadPass(layoutNode);
    // Inline function 'androidx.compose.ui.util.fastMap' call
    var this_0 = layoutNode.vas();
    var target = ArrayList_init_$Create$_0(this_0.n1());
    // Inline function 'androidx.compose.ui.util.fastForEach' call
    var inductionVariable = 0;
    var last = this_0.n1() - 1 | 0;
    if (inductionVariable <= last)
      do {
        var index = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var item = this_0.l1(index);
        // Inline function 'kotlin.collections.plusAssign' call
        var element = lookahead ? item.saw() : item.daw();
        target.j1(element);
      }
       while (inductionVariable <= last);
    return target;
  }
  function MeasureScopeWithLayoutNode() {
  }
  function isInLookaheadPass(_this__u8e3s4) {
    var tmp;
    switch (_this__u8e3s4.zav().a1_1) {
      case 1:
      case 3:
        tmp = true;
        break;
      case 0:
      case 2:
        tmp = false;
        break;
      case 4:
        var tmp0 = _this__u8e3s4.f9a();
        var tmp$ret$0;
        $l$block: {
          // Inline function 'kotlin.requireNotNull' call
          if (tmp0 == null) {
            var message = 'no parent for idle node';
            throw IllegalArgumentException_init_$Create$(toString(message));
          } else {
            tmp$ret$0 = tmp0;
            break $l$block;
          }
        }

        tmp = isInLookaheadPass(tmp$ret$0);
        break;
      default:
        noWhenBranchMatchedException();
        break;
    }
    return tmp;
  }
  function MeasuredSizeAwareModifierNode() {
  }
  var androidx_compose_ui_node_ModifierNodeElement$stable;
  function ModifierNodeElement() {
    this.pbj_1 = null;
  }
  function MutableVectorWithMutationTracking(vector, onVectorMutated) {
    this.qba_1 = vector;
    this.rba_1 = onVectorMutated;
  }
  protoOf(MutableVectorWithMutationTracking).c3 = function () {
    this.qba_1.c3();
    this.rba_1();
  };
  protoOf(MutableVectorWithMutationTracking).ni = function (index, element) {
    this.qba_1.ni(index, element);
    this.rba_1();
  };
  protoOf(MutableVectorWithMutationTracking).h3 = function (index) {
    // Inline function 'kotlin.also' call
    var this_0 = this.qba_1.h3(index);
    this.rba_1();
    return this_0;
  };
  function executeDiff(oldSize, newSize, callback) {
    var diagonals = calculateDiff(oldSize, newSize, callback);
    applyDiff(diagonals, callback);
  }
  function resizeStack($this, stack) {
    var copy = copyOf_3(stack, imul(stack.length, 2));
    $this.qbj_1 = copy;
    return copy;
  }
  function quickSort($this, start, end, elSize) {
    if (start < end) {
      var i = partition($this, start, end, elSize);
      quickSort($this, start, i - elSize | 0, elSize);
      quickSort($this, i + elSize | 0, end, elSize);
    }
  }
  function partition($this, start, end, elSize) {
    var i = start - elSize | 0;
    var j = start;
    while (j < end) {
      if (compareDiagonal($this, j, end)) {
        i = i + elSize | 0;
        swapDiagonal($this, i, j);
      }
      j = j + elSize | 0;
    }
    swapDiagonal($this, i + elSize | 0, end);
    return i + elSize | 0;
  }
  function swapDiagonal($this, i, j) {
    var stack = $this.qbj_1;
    swap(stack, i, j);
    swap(stack, i + 1 | 0, j + 1 | 0);
    swap(stack, i + 2 | 0, j + 2 | 0);
  }
  function compareDiagonal($this, a, b) {
    var stack = $this.qbj_1;
    var a0 = stack[a];
    var b0 = stack[b];
    return a0 < b0 || (a0 === b0 && stack[a + 1 | 0] <= stack[b + 1 | 0]);
  }
  function IntStack(initialCapacity) {
    this.qbj_1 = new Int32Array(initialCapacity);
    this.rbj_1 = 0;
  }
  protoOf(IntStack).l1 = function (index) {
    return this.qbj_1[index];
  };
  protoOf(IntStack).n1 = function () {
    return this.rbj_1;
  };
  protoOf(IntStack).sbj = function (oldStart, oldEnd, newStart, newEnd) {
    var i = this.rbj_1;
    var stack = this.qbj_1;
    if ((i + 4 | 0) >= stack.length) {
      stack = resizeStack(this, stack);
    }
    stack[i + 0 | 0] = oldStart;
    stack[i + 1 | 0] = oldEnd;
    stack[i + 2 | 0] = newStart;
    stack[i + 3 | 0] = newEnd;
    this.rbj_1 = i + 4 | 0;
  };
  protoOf(IntStack).tbj = function (x, y, size) {
    var i = this.rbj_1;
    var stack = this.qbj_1;
    if ((i + 3 | 0) >= stack.length) {
      stack = resizeStack(this, stack);
    }
    stack[i + 0 | 0] = x + size | 0;
    stack[i + 1 | 0] = y + size | 0;
    stack[i + 2 | 0] = size;
    this.rbj_1 = i + 3 | 0;
  };
  protoOf(IntStack).k3j = function () {
    var tmp = this.qbj_1;
    this.rbj_1 = this.rbj_1 - 1 | 0;
    return tmp[this.rbj_1];
  };
  protoOf(IntStack).fv = function () {
    return !(this.rbj_1 === 0);
  };
  protoOf(IntStack).ubj = function () {
    var i = this.rbj_1;
    // Inline function 'androidx.compose.ui.internal.checkPrecondition' call
    if (!((i % 3 | 0) === 0)) {
      var tmp$ret$1 = 'Array size not a multiple of 3';
      throwIllegalStateException(tmp$ret$1);
    }
    if (i > 3) {
      quickSort(this, 0, i - 3 | 0, 3);
    }
  };
  function calculateDiff(oldSize, newSize, cb) {
    var max = ((oldSize + newSize | 0) + 1 | 0) / 2 | 0;
    var diagonals = new IntStack(imul(max, 3));
    var stack = new IntStack(imul(max, 4));
    stack.sbj(0, oldSize, 0, newSize);
    var forward = _CenteredArray___init__impl__szwv5g(new Int32Array(imul(max, 2) + 1 | 0));
    var backward = _CenteredArray___init__impl__szwv5g(new Int32Array(imul(max, 2) + 1 | 0));
    var snake = _Snake___init__impl__60pk1l(new Int32Array(5));
    while (stack.fv()) {
      var newEnd = stack.k3j();
      var newStart = stack.k3j();
      var oldEnd = stack.k3j();
      var oldStart = stack.k3j();
      var found = midPoint(oldStart, oldEnd, newStart, newEnd, cb, forward, backward, _Snake___get_data__impl__z3h2ly(snake));
      if (found) {
        // Inline function 'androidx.compose.ui.node.Snake.diagonalSize' call
        // Inline function 'androidx.compose.ui.node.Snake.endX' call
        var tmp = _Snake___get_data__impl__z3h2ly(snake)[2];
        // Inline function 'androidx.compose.ui.node.Snake.startX' call
        var tmp0 = tmp - _Snake___get_data__impl__z3h2ly(snake)[0] | 0;
        // Inline function 'androidx.compose.ui.node.Snake.endY' call
        var tmp_0 = _Snake___get_data__impl__z3h2ly(snake)[3];
        // Inline function 'androidx.compose.ui.node.Snake.startY' call
        // Inline function 'kotlin.math.min' call
        var b = tmp_0 - _Snake___get_data__impl__z3h2ly(snake)[1] | 0;
        if (Math.min(tmp0, b) > 0) {
          Snake__addDiagonalToStack_impl_z26l6y(snake, diagonals);
        }
        // Inline function 'androidx.compose.ui.node.Snake.startX' call
        var tmp_1 = _Snake___get_data__impl__z3h2ly(snake)[0];
        // Inline function 'androidx.compose.ui.node.Snake.startY' call
        var tmp$ret$7 = _Snake___get_data__impl__z3h2ly(snake)[1];
        stack.sbj(oldStart, tmp_1, newStart, tmp$ret$7);
        // Inline function 'androidx.compose.ui.node.Snake.endX' call
        var tmp_2 = _Snake___get_data__impl__z3h2ly(snake)[2];
        // Inline function 'androidx.compose.ui.node.Snake.endY' call
        var tmp$ret$9 = _Snake___get_data__impl__z3h2ly(snake)[3];
        stack.sbj(tmp_2, oldEnd, tmp$ret$9, newEnd);
      }
    }
    diagonals.ubj();
    diagonals.tbj(oldSize, newSize, 0);
    return diagonals;
  }
  function applyDiff(diagonals, callback) {
    var posX = 0;
    var posY = 0;
    var i = 0;
    while (i < diagonals.n1()) {
      var startX = diagonals.l1(i) - diagonals.l1(i + 2 | 0) | 0;
      var startY = diagonals.l1(i + 1 | 0) - diagonals.l1(i + 2 | 0) | 0;
      var len = diagonals.l1(i + 2 | 0);
      i = i + 3 | 0;
      while (posX < startX) {
        callback.l2y(posY, posX);
        posX = posX + 1 | 0;
      }
      while (posY < startY) {
        callback.vbj(posY);
        posY = posY + 1 | 0;
      }
      $l$loop: while (true) {
        var _unary__edvuaz = len;
        len = _unary__edvuaz - 1 | 0;
        if (!(_unary__edvuaz > 0)) {
          break $l$loop;
        }
        callback.wbj(posX, posY);
        posX = posX + 1 | 0;
        posY = posY + 1 | 0;
      }
    }
  }
  function swap(_this__u8e3s4, i, j) {
    var tmp = _this__u8e3s4[i];
    _this__u8e3s4[i] = _this__u8e3s4[j];
    _this__u8e3s4[j] = tmp;
  }
  function _CenteredArray___init__impl__szwv5g(data) {
    return data;
  }
  function _get_data__d5abxd($this) {
    return $this;
  }
  function _get_mid__e6ctop($this) {
    return _get_data__d5abxd($this).length / 2 | 0;
  }
  function CenteredArray__get_impl_zhm9j0($this, index) {
    return _get_data__d5abxd($this)[index + _get_mid__e6ctop($this) | 0];
  }
  function CenteredArray__set_impl_q7jods($this, index, value) {
    _get_data__d5abxd($this)[index + _get_mid__e6ctop($this) | 0] = value;
  }
  function _Snake___init__impl__60pk1l(data) {
    return data;
  }
  function _Snake___get_data__impl__z3h2ly($this) {
    return $this;
  }
  function _get_hasAdditionOrRemoval__guekso($this) {
    // Inline function 'androidx.compose.ui.node.Snake.endY' call
    var tmp = _Snake___get_data__impl__z3h2ly($this)[3];
    // Inline function 'androidx.compose.ui.node.Snake.startY' call
    var tmp_0 = tmp - _Snake___get_data__impl__z3h2ly($this)[1] | 0;
    // Inline function 'androidx.compose.ui.node.Snake.endX' call
    var tmp_1 = _Snake___get_data__impl__z3h2ly($this)[2];
    // Inline function 'androidx.compose.ui.node.Snake.startX' call
    return !(tmp_0 === (tmp_1 - _Snake___get_data__impl__z3h2ly($this)[0] | 0));
  }
  function _get_isAddition__1a40e3($this) {
    // Inline function 'androidx.compose.ui.node.Snake.endY' call
    var tmp = _Snake___get_data__impl__z3h2ly($this)[3];
    // Inline function 'androidx.compose.ui.node.Snake.startY' call
    var tmp_0 = tmp - _Snake___get_data__impl__z3h2ly($this)[1] | 0;
    // Inline function 'androidx.compose.ui.node.Snake.endX' call
    var tmp_1 = _Snake___get_data__impl__z3h2ly($this)[2];
    // Inline function 'androidx.compose.ui.node.Snake.startX' call
    return tmp_0 > (tmp_1 - _Snake___get_data__impl__z3h2ly($this)[0] | 0);
  }
  function Snake__addDiagonalToStack_impl_z26l6y($this, diagonals) {
    var size;
    // Inline function 'androidx.compose.ui.node.Snake.startX' call
    var x = _Snake___get_data__impl__z3h2ly($this)[0];
    // Inline function 'androidx.compose.ui.node.Snake.startY' call
    var y = _Snake___get_data__impl__z3h2ly($this)[1];
    if (_get_hasAdditionOrRemoval__guekso($this)) {
      // Inline function 'androidx.compose.ui.node.Snake.diagonalSize' call
      // Inline function 'androidx.compose.ui.node.Snake.endX' call
      var tmp = _Snake___get_data__impl__z3h2ly($this)[2];
      // Inline function 'androidx.compose.ui.node.Snake.startX' call
      var tmp0 = tmp - _Snake___get_data__impl__z3h2ly($this)[0] | 0;
      // Inline function 'androidx.compose.ui.node.Snake.endY' call
      var tmp_0 = _Snake___get_data__impl__z3h2ly($this)[3];
      // Inline function 'androidx.compose.ui.node.Snake.startY' call
      // Inline function 'kotlin.math.min' call
      var b = tmp_0 - _Snake___get_data__impl__z3h2ly($this)[1] | 0;
      size = Math.min(tmp0, b);
      var tmp_1 = x;
      // Inline function 'androidx.compose.ui.node.Snake.reverse' call
      // Inline function 'androidx.compose.ui.node.toInt' call
      x = tmp_1 + (!!!(!(_Snake___get_data__impl__z3h2ly($this)[4] === 0) | _get_isAddition__1a40e3($this)) ? 1 : 0) | 0;
      var tmp_2 = y;
      // Inline function 'androidx.compose.ui.node.Snake.reverse' call
      // Inline function 'androidx.compose.ui.node.toInt' call
      y = tmp_2 + (!!!(!(_Snake___get_data__impl__z3h2ly($this)[4] === 0) | !_get_isAddition__1a40e3($this)) ? 1 : 0) | 0;
    } else {
      // Inline function 'androidx.compose.ui.node.Snake.endX' call
      var tmp_3 = _Snake___get_data__impl__z3h2ly($this)[2];
      // Inline function 'androidx.compose.ui.node.Snake.startX' call
      size = tmp_3 - _Snake___get_data__impl__z3h2ly($this)[0] | 0;
    }
    diagonals.tbj(x, y, size);
  }
  function midPoint(oldStart, oldEnd, newStart, newEnd, cb, forward_0, backward_0, snake) {
    var oldSize = oldEnd - oldStart | 0;
    var newSize = newEnd - newStart | 0;
    if (oldSize < 1 || newSize < 1) {
      return false;
    }
    var max = ((oldSize + newSize | 0) + 1 | 0) / 2 | 0;
    CenteredArray__set_impl_q7jods(forward_0, 1, oldStart);
    CenteredArray__set_impl_q7jods(backward_0, 1, oldEnd);
    var inductionVariable = 0;
    if (inductionVariable < max)
      do {
        var d = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var found = forward(oldStart, oldEnd, newStart, newEnd, cb, forward_0, backward_0, d, snake);
        if (found) {
          return true;
        }
        var found2 = backward(oldStart, oldEnd, newStart, newEnd, cb, forward_0, backward_0, d, snake);
        if (found2) {
          return true;
        }
      }
       while (inductionVariable < max);
    return false;
  }
  function forward(oldStart, oldEnd, newStart, newEnd, cb, forward, backward, d, snake) {
    var oldSize = oldEnd - oldStart | 0;
    var newSize = newEnd - newStart | 0;
    var checkForSnake = (abs_0(oldSize - newSize | 0) & 1) === 1;
    var delta = oldSize - newSize | 0;
    var k = -d | 0;
    while (k <= d) {
      var startX;
      var startY;
      var x;
      if (k === (-d | 0) || (!(k === d) && CenteredArray__get_impl_zhm9j0(forward, k + 1 | 0) > CenteredArray__get_impl_zhm9j0(forward, k - 1 | 0))) {
        startX = CenteredArray__get_impl_zhm9j0(forward, k + 1 | 0);
        x = startX;
      } else {
        startX = CenteredArray__get_impl_zhm9j0(forward, k - 1 | 0);
        x = startX + 1 | 0;
      }
      var y = (newStart + (x - oldStart | 0) | 0) - k | 0;
      var tmp = y;
      // Inline function 'androidx.compose.ui.node.toInt' call
      startY = tmp - (!!(!(d === 0) & x === startX) ? 1 : 0) | 0;
      while (x < oldEnd && y < newEnd && cb.xbj(x, y)) {
        x = x + 1 | 0;
        y = y + 1 | 0;
      }
      CenteredArray__set_impl_q7jods(forward, k, x);
      if (checkForSnake) {
        var backwardsK = delta - k | 0;
        if (backwardsK >= ((-d | 0) + 1 | 0) && backwardsK <= (d - 1 | 0) && CenteredArray__get_impl_zhm9j0(backward, backwardsK) <= x) {
          fillSnake(startX, startY, x, y, false, snake);
          return true;
        }
      }
      k = k + 2 | 0;
    }
    return false;
  }
  function backward(oldStart, oldEnd, newStart, newEnd, cb, forward, backward, d, snake) {
    var oldSize = oldEnd - oldStart | 0;
    var newSize = newEnd - newStart | 0;
    var checkForSnake = ((oldSize - newSize | 0) & 1) === 0;
    var delta = oldSize - newSize | 0;
    var k = -d | 0;
    while (k <= d) {
      var startX;
      var x;
      if (k === (-d | 0) || (!(k === d) && CenteredArray__get_impl_zhm9j0(backward, k + 1 | 0) < CenteredArray__get_impl_zhm9j0(backward, k - 1 | 0))) {
        startX = CenteredArray__get_impl_zhm9j0(backward, k + 1 | 0);
        x = startX;
      } else {
        startX = CenteredArray__get_impl_zhm9j0(backward, k - 1 | 0);
        x = startX - 1 | 0;
      }
      var y = newEnd - ((oldEnd - x | 0) - k | 0) | 0;
      var tmp = y;
      // Inline function 'androidx.compose.ui.node.toInt' call
      var startY = tmp + (!!(!(d === 0) & x === startX) ? 1 : 0) | 0;
      while (x > oldStart && y > newStart && cb.xbj(x - 1 | 0, y - 1 | 0)) {
        x = x - 1 | 0;
        y = y - 1 | 0;
      }
      CenteredArray__set_impl_q7jods(backward, k, x);
      if (checkForSnake) {
        var forwardsK = delta - k | 0;
        if (forwardsK >= (-d | 0) && forwardsK <= d && CenteredArray__get_impl_zhm9j0(forward, forwardsK) >= x) {
          fillSnake(x, y, startX, startY, true, snake);
          return true;
        }
      }
      k = k + 2 | 0;
    }
    return false;
  }
  function fillSnake(startX, startY, endX, endY, reverse, data) {
    if (data.length < 5)
      return Unit_instance;
    data[0] = startX;
    data[1] = startY;
    data[2] = endX;
    data[3] = endY;
    data[4] = reverse ? 1 : 0;
  }
  var androidx_compose_ui_node_NodeChain$stable;
  function _get_aggregateChildKindSet__bx3g2o($this) {
    return $this.j99_1.p8v_1;
  }
  function padChain($this) {
    // Inline function 'androidx.compose.ui.internal.checkPrecondition' call
    if (!!($this.j99_1 === $this.f99_1)) {
      var tmp$ret$1 = 'padChain called on already padded chain';
      throwIllegalStateException(tmp$ret$1);
    }
    var currentHead = $this.j99_1;
    currentHead.q8v_1 = $this.f99_1;
    $this.f99_1.r8v_1 = currentHead;
    return $this.f99_1;
  }
  function trimChain($this, paddedHead) {
    // Inline function 'androidx.compose.ui.internal.checkPrecondition' call
    if (!(paddedHead === $this.f99_1)) {
      var tmp$ret$1 = 'trimChain called on already trimmed chain';
      throwIllegalStateException(tmp$ret$1);
    }
    var tmp0_elvis_lhs = $this.f99_1.r8v_1;
    var result = tmp0_elvis_lhs == null ? $this.i99_1 : tmp0_elvis_lhs;
    result.q8v_1 = null;
    $this.f99_1.r8v_1 = null;
    $this.f99_1.p8v_1 = -1;
    $this.f99_1.c8w(null);
    // Inline function 'androidx.compose.ui.internal.checkPrecondition' call
    if (!!(result === $this.f99_1)) {
      var tmp$ret$3 = 'trimChain did not update the head';
      throwIllegalStateException(tmp$ret$3);
    }
    return result;
  }
  function syncAggregateChildKindSet($this) {
    var node = $this.i99_1.q8v_1;
    var aggregateChildKindSet = 0;
    while (!(node == null) && !(node === $this.f99_1)) {
      aggregateChildKindSet = aggregateChildKindSet | node.o8v_1;
      node.p8v_1 = aggregateChildKindSet;
      node = node.q8v_1;
    }
  }
  function getDiffer($this, head, offset, before, after, shouldAttachOnInsert) {
    var current = $this.n99_1;
    var tmp;
    if (current == null) {
      // Inline function 'kotlin.also' call
      var this_0 = new Differ($this, head, offset, before, after, shouldAttachOnInsert);
      $this.n99_1 = this_0;
      tmp = this_0;
    } else {
      // Inline function 'kotlin.also' call
      current.ybj_1 = head;
      current.zbj_1 = offset;
      current.abk_1 = before;
      current.bbk_1 = after;
      current.cbk_1 = shouldAttachOnInsert;
      tmp = current;
    }
    return tmp;
  }
  function propagateCoordinator($this, start, coordinator) {
    var node = start.q8v_1;
    $l$loop_0: while (!(node == null)) {
      if (node === $this.f99_1) {
        var tmp = coordinator;
        var tmp0_safe_receiver = $this.e99_1.f9a();
        tmp.t94_1 = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.car();
        $this.h99_1 = coordinator;
        break $l$loop_0;
      }
      var tmp0 = node;
      // Inline function 'androidx.compose.ui.node.Nodes.Layout' call
      // Inline function 'androidx.compose.ui.Node.isKind' call
      var kind = _NodeKind___init__impl__ojsprp(2);
      if (!((tmp0.o8v_1 & _NodeKind___get_mask__impl__1uopb6(kind)) === 0))
        break $l$loop_0;
      node.c8w(coordinator);
      node = node.q8v_1;
    }
  }
  function Differ($outer, node, offset, before, after, shouldAttachOnInsert) {
    this.dbk_1 = $outer;
    this.ybj_1 = node;
    this.zbj_1 = offset;
    this.abk_1 = before;
    this.bbk_1 = after;
    this.cbk_1 = shouldAttachOnInsert;
  }
  protoOf(Differ).xbj = function (oldIndex, newIndex) {
    var tmp0 = this.abk_1;
    // Inline function 'androidx.compose.runtime.collection.MutableVector.get' call
    var index = this.zbj_1 + oldIndex | 0;
    var tmp = tmp0.b3e_1[index];
    var tmp0_0 = this.bbk_1;
    // Inline function 'androidx.compose.runtime.collection.MutableVector.get' call
    var index_0 = this.zbj_1 + newIndex | 0;
    var tmp$ret$1 = tmp0_0.b3e_1[index_0];
    return !(actionForModifiers(tmp, tmp$ret$1) === 0);
  };
  protoOf(Differ).vbj = function (newIndex) {
    var index = this.zbj_1 + newIndex | 0;
    var parent = this.ybj_1;
    var tmp = this;
    // Inline function 'androidx.compose.runtime.collection.MutableVector.get' call
    var tmp$ret$0 = this.bbk_1.b3e_1[index];
    tmp.ybj_1 = createAndInsertNodeAsChild(this.dbk_1, tmp$ret$0, parent);
    var tmp0_safe_receiver = this.dbk_1.o99_1;
    if (tmp0_safe_receiver == null)
      null;
    else {
      // Inline function 'androidx.compose.runtime.collection.MutableVector.get' call
      var tmp$ret$1 = this.bbk_1.b3e_1[index];
      tmp0_safe_receiver.ebk(index, index, tmp$ret$1, parent, this.ybj_1);
    }
    if (this.cbk_1) {
      var childCoordinator = ensureNotNull(ensureNotNull(this.ybj_1.r8v_1).t8v_1);
      var layoutmod = asLayoutModifierNode(this.ybj_1);
      if (!(layoutmod == null)) {
        var thisCoordinator = new LayoutModifierNodeCoordinator(this.dbk_1.e99_1, layoutmod);
        this.ybj_1.c8w(thisCoordinator);
        propagateCoordinator(this.dbk_1, this.ybj_1, thisCoordinator);
        thisCoordinator.t94_1 = childCoordinator.t94_1;
        thisCoordinator.s94_1 = childCoordinator;
        childCoordinator.t94_1 = thisCoordinator;
      } else {
        this.ybj_1.c8w(childCoordinator);
      }
      this.ybj_1.d8w();
      this.ybj_1.e8w();
      autoInvalidateInsertedNode(this.ybj_1);
    } else {
      this.ybj_1.u8v_1 = true;
    }
  };
  protoOf(Differ).l2y = function (atIndex, oldIndex) {
    var toRemove = ensureNotNull(this.ybj_1.r8v_1);
    var tmp0_safe_receiver = this.dbk_1.o99_1;
    if (tmp0_safe_receiver == null)
      null;
    else {
      var tmp0 = this.abk_1;
      // Inline function 'androidx.compose.runtime.collection.MutableVector.get' call
      var index = this.zbj_1 + oldIndex | 0;
      var tmp$ret$0 = tmp0.b3e_1[index];
      tmp0_safe_receiver.fbk(oldIndex, tmp$ret$0, toRemove);
    }
    // Inline function 'androidx.compose.ui.node.Nodes.Layout' call
    // Inline function 'androidx.compose.ui.Node.isKind' call
    var kind = _NodeKind___init__impl__ojsprp(2);
    if (!((toRemove.o8v_1 & _NodeKind___get_mask__impl__1uopb6(kind)) === 0)) {
      var removedCoordinator = ensureNotNull(toRemove.t8v_1);
      var parentCoordinator = removedCoordinator.t94_1;
      var childCoordinator = ensureNotNull(removedCoordinator.s94_1);
      if (parentCoordinator == null)
        null;
      else {
        parentCoordinator.s94_1 = childCoordinator;
      }
      childCoordinator.t94_1 = parentCoordinator;
      propagateCoordinator(this.dbk_1, this.ybj_1, childCoordinator);
    }
    this.ybj_1 = detachAndRemoveNode(this.dbk_1, toRemove);
  };
  protoOf(Differ).wbj = function (oldIndex, newIndex) {
    this.ybj_1 = ensureNotNull(this.ybj_1.r8v_1);
    var tmp0 = this.abk_1;
    // Inline function 'androidx.compose.runtime.collection.MutableVector.get' call
    var index = this.zbj_1 + oldIndex | 0;
    var prev = tmp0.b3e_1[index];
    var tmp0_0 = this.bbk_1;
    // Inline function 'androidx.compose.runtime.collection.MutableVector.get' call
    var index_0 = this.zbj_1 + newIndex | 0;
    var next = tmp0_0.b3e_1[index_0];
    if (!equals(prev, next)) {
      updateNode(this.dbk_1, prev, next, this.ybj_1);
      var tmp0_safe_receiver = this.dbk_1.o99_1;
      if (tmp0_safe_receiver == null)
        null;
      else {
        tmp0_safe_receiver.hbk(this.zbj_1 + oldIndex | 0, this.zbj_1 + newIndex | 0, prev, next, this.ybj_1);
      }
    } else {
      var tmp1_safe_receiver = this.dbk_1.o99_1;
      if (tmp1_safe_receiver == null)
        null;
      else {
        tmp1_safe_receiver.gbk(this.zbj_1 + oldIndex | 0, this.zbj_1 + newIndex | 0, prev, next, this.ybj_1);
      }
    }
  };
  function structuralUpdate($this, offset, before, after, tail, shouldAttachOnInsert) {
    var differ = getDiffer($this, tail, offset, before, after, shouldAttachOnInsert);
    executeDiff(before.d3e_1 - offset | 0, after.d3e_1 - offset | 0, differ);
    syncAggregateChildKindSet($this);
  }
  function detachAndRemoveNode($this, node) {
    if (node.z8v_1) {
      autoInvalidateRemovedNode(node);
      node.g8w();
      node.i8w();
    }
    return removeNode($this, node);
  }
  function removeNode($this, node) {
    var child = node.r8v_1;
    var parent = node.q8v_1;
    if (!(child == null)) {
      child.q8v_1 = parent;
      node.r8v_1 = null;
    }
    if (!(parent == null)) {
      parent.r8v_1 = child;
      node.q8v_1 = null;
    }
    return ensureNotNull(parent);
  }
  function createAndInsertNodeAsChild($this, element, parent) {
    var tmp;
    if (element instanceof ModifierNodeElement) {
      // Inline function 'kotlin.also' call
      var this_0 = element.r3d();
      this_0.o8v_1 = calculateNodeKindSetFromIncludingDelegates(this_0);
      tmp = this_0;
    } else {
      tmp = new BackwardsCompatNode(element);
    }
    var node = tmp;
    // Inline function 'androidx.compose.ui.internal.checkPrecondition' call
    if (!!node.z8v_1) {
      var tmp$ret$3 = 'A ModifierNodeElement cannot return an already attached node from create() ';
      throwIllegalStateException(tmp$ret$3);
    }
    node.u8v_1 = true;
    return insertChild($this, node, parent);
  }
  function insertChild($this, node, parent) {
    var theChild = parent.r8v_1;
    if (!(theChild == null)) {
      theChild.q8v_1 = node;
      node.r8v_1 = theChild;
    }
    parent.r8v_1 = node;
    node.q8v_1 = parent;
    return node;
  }
  function updateNode($this, prev, next, node) {
    var tmp;
    if (prev instanceof ModifierNodeElement) {
      tmp = next instanceof ModifierNodeElement;
    } else {
      tmp = false;
    }
    if (tmp) {
      updateUnsafe(next, node);
      if (node.z8v_1) {
        autoInvalidateUpdatedNode(node);
      } else {
        node.v8v_1 = true;
      }
    } else {
      if (node instanceof BackwardsCompatNode) {
        node.ib0(next);
        if (node.z8v_1) {
          autoInvalidateUpdatedNode(node);
        } else {
          node.v8v_1 = true;
        }
      } else {
        throwIllegalStateException('Unknown Modifier.Node type');
      }
    }
  }
  function access$_get_aggregateChildKindSet__pv81sw($this) {
    return _get_aggregateChildKindSet__bx3g2o($this);
  }
  function NodeChain$sentinelHead$1() {
    Node.call(this);
  }
  protoOf(NodeChain$sentinelHead$1).toString = function () {
    return '<Head>';
  };
  function NodeChain(layoutNode) {
    this.e99_1 = layoutNode;
    var tmp = this;
    // Inline function 'kotlin.apply' call
    var this_0 = new NodeChain$sentinelHead$1();
    this_0.p8v_1 = -1;
    tmp.f99_1 = this_0;
    this.g99_1 = new InnerNodeCoordinator(this.e99_1);
    this.h99_1 = this.g99_1;
    this.i99_1 = this.g99_1.hb6_1;
    this.j99_1 = this.i99_1;
    this.k99_1 = null;
    this.l99_1 = null;
    var tmp_0 = this;
    // Inline function 'androidx.compose.runtime.collection.MutableVector' call
    // Inline function 'kotlin.arrayOfNulls' call
    var tmp$ret$3 = Array(16);
    tmp_0.m99_1 = new MutableVector(tmp$ret$3, 0);
    this.n99_1 = null;
    this.o99_1 = null;
  }
  protoOf(NodeChain).rbb = function () {
    return !(this.f99_1.r8v_1 == null);
  };
  protoOf(NodeChain).bbb = function (m) {
    var coordinatorSyncNeeded = false;
    var paddedHead = padChain(this);
    var before = this.k99_1;
    var tmp0_safe_receiver = before;
    var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.d3e_1;
    var beforeSize = tmp1_elvis_lhs == null ? 0 : tmp1_elvis_lhs;
    var tmp2_elvis_lhs = this.l99_1;
    var tmp;
    if (tmp2_elvis_lhs == null) {
      // Inline function 'androidx.compose.runtime.collection.mutableVectorOf' call
      // Inline function 'androidx.compose.runtime.collection.MutableVector' call
      // Inline function 'kotlin.arrayOfNulls' call
      var tmp$ret$2 = Array(16);
      tmp = new MutableVector(tmp$ret$2, 0);
    } else {
      tmp = tmp2_elvis_lhs;
    }
    var after = fillVector(m, tmp, this.m99_1);
    var i = 0;
    if (after.d3e_1 === beforeSize) {
      var node = paddedHead.r8v_1;
      $l$loop: while (!(node == null) && i < beforeSize) {
        // Inline function 'androidx.compose.ui.internal.checkPreconditionNotNull' call
        if (before == null) {
          var tmp$ret$4 = 'expected prior modifier list to be non-empty';
          throwIllegalStateExceptionForNullCheck(tmp$ret$4);
        }
        var tmp0 = before;
        // Inline function 'androidx.compose.runtime.collection.MutableVector.get' call
        var index = i;
        var prev = tmp0.b3e_1[index];
        // Inline function 'androidx.compose.runtime.collection.MutableVector.get' call
        var index_0 = i;
        var next = after.b3e_1[index_0];
        switch (actionForModifiers(prev, next)) {
          case 0:
            var tmp4_safe_receiver = this.o99_1;
            if (tmp4_safe_receiver == null)
              null;
            else {
              tmp4_safe_receiver.ibk(i, prev, next, node);
            }

            node = node.q8v_1;
            break $l$loop;
          case 1:
            updateNode(this, prev, next, node);
            var tmp5_safe_receiver = this.o99_1;
            if (tmp5_safe_receiver == null)
              null;
            else {
              tmp5_safe_receiver.hbk(i, i, prev, next, node);
            }

            break;
          case 2:
            var tmp6_safe_receiver = this.o99_1;
            if (tmp6_safe_receiver == null)
              null;
            else {
              tmp6_safe_receiver.gbk(i, i, prev, next, node);
            }

            break;
        }
        node = node.r8v_1;
        i = i + 1 | 0;
      }
      if (i < beforeSize) {
        coordinatorSyncNeeded = true;
        // Inline function 'androidx.compose.ui.internal.checkPreconditionNotNull' call
        if (before == null) {
          var tmp$ret$8 = 'expected prior modifier list to be non-empty';
          throwIllegalStateExceptionForNullCheck(tmp$ret$8);
        }
        // Inline function 'androidx.compose.ui.internal.checkPreconditionNotNull' call
        if (node == null) {
          var tmp$ret$10 = 'structuralUpdate requires a non-null tail';
          throwIllegalStateExceptionForNullCheck(tmp$ret$10);
        }
        structuralUpdate(this, i, before, after, node, !this.e99_1.sbb());
      }
    } else if (this.e99_1.sbb() && beforeSize === 0) {
      coordinatorSyncNeeded = true;
      var node_0 = paddedHead;
      while (i < after.d3e_1) {
        // Inline function 'androidx.compose.runtime.collection.MutableVector.get' call
        var index_1 = i;
        var next_0 = after.b3e_1[index_1];
        var parent = node_0;
        node_0 = createAndInsertNodeAsChild(this, next_0, parent);
        var tmp7_safe_receiver = this.o99_1;
        if (tmp7_safe_receiver == null)
          null;
        else {
          tmp7_safe_receiver.ebk(0, i, next_0, parent, node_0);
        }
        i = i + 1 | 0;
      }
      syncAggregateChildKindSet(this);
    } else if (after.d3e_1 === 0) {
      // Inline function 'androidx.compose.ui.internal.checkPreconditionNotNull' call
      if (before == null) {
        var tmp$ret$13 = 'expected prior modifier list to be non-empty';
        throwIllegalStateExceptionForNullCheck(tmp$ret$13);
      }
      var node_1 = paddedHead.r8v_1;
      while (!(node_1 == null) && i < before.d3e_1) {
        var tmp8_safe_receiver = this.o99_1;
        if (tmp8_safe_receiver == null)
          null;
        else {
          var tmp_0 = i;
          var tmp0_0 = before;
          // Inline function 'androidx.compose.runtime.collection.MutableVector.get' call
          var index_2 = i;
          var tmp$ret$14 = tmp0_0.b3e_1[index_2];
          tmp8_safe_receiver.fbk(tmp_0, tmp$ret$14, node_1);
        }
        node_1 = detachAndRemoveNode(this, node_1).r8v_1;
        i = i + 1 | 0;
      }
      var tmp_1 = this.g99_1;
      var tmp9_safe_receiver = this.e99_1.f9a();
      tmp_1.t94_1 = tmp9_safe_receiver == null ? null : tmp9_safe_receiver.car();
      this.h99_1 = this.g99_1;
    } else {
      coordinatorSyncNeeded = true;
      var tmp10_elvis_lhs = before;
      var tmp_2;
      if (tmp10_elvis_lhs == null) {
        // Inline function 'androidx.compose.runtime.collection.MutableVector' call
        // Inline function 'kotlin.arrayOfNulls' call
        var tmp$ret$16 = Array(16);
        tmp_2 = new MutableVector(tmp$ret$16, 0);
      } else {
        tmp_2 = tmp10_elvis_lhs;
      }
      before = tmp_2;
      structuralUpdate(this, 0, before, after, paddedHead, !this.e99_1.sbb());
    }
    this.k99_1 = after;
    var tmp_3 = this;
    var tmp11_safe_receiver = before;
    var tmp_4;
    if (tmp11_safe_receiver == null) {
      tmp_4 = null;
    } else {
      // Inline function 'kotlin.also' call
      tmp11_safe_receiver.c3();
      tmp_4 = tmp11_safe_receiver;
    }
    tmp_3.l99_1 = tmp_4;
    this.j99_1 = trimChain(this, paddedHead);
    if (coordinatorSyncNeeded) {
      this.ub1();
    }
  };
  protoOf(NodeChain).ebb = function () {
    // Inline function 'androidx.compose.ui.node.NodeChain.tailToHead' call
    var node = this.i99_1;
    while (!(node == null)) {
      var it = node;
      if (it.z8v_1) {
        it.j8w();
      }
      node = node.q8v_1;
    }
    this.g8w();
    this.i8w();
  };
  protoOf(NodeChain).ub1 = function () {
    var coordinator = this.g99_1;
    var node = this.i99_1.q8v_1;
    while (!(node == null)) {
      var layoutmod = asLayoutModifierNode(node);
      if (!(layoutmod == null)) {
        var tmp;
        if (!(node.t8v_1 == null)) {
          var tmp_0 = node.t8v_1;
          var c = tmp_0 instanceof LayoutModifierNodeCoordinator ? tmp_0 : THROW_CCE();
          var prevNode = c.cag_1;
          c.zaz(layoutmod);
          if (!(prevNode === node)) {
            c.ab0();
          }
          tmp = c;
        } else {
          var c_0 = new LayoutModifierNodeCoordinator(this.e99_1, layoutmod);
          node.c8w(c_0);
          tmp = c_0;
        }
        var next = tmp;
        coordinator.t94_1 = next;
        next.s94_1 = coordinator;
        coordinator = next;
      } else {
        node.c8w(coordinator);
      }
      node = node.q8v_1;
    }
    var tmp_1 = coordinator;
    var tmp0_safe_receiver = this.e99_1.f9a();
    tmp_1.t94_1 = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.car();
    this.h99_1 = coordinator;
  };
  protoOf(NodeChain).wbb = function () {
    // Inline function 'androidx.compose.ui.node.NodeChain.headToTail' call
    var node = this.j99_1;
    while (!(node == null)) {
      node.d8w();
      node = node.r8v_1;
    }
  };
  protoOf(NodeChain).xbb = function () {
    // Inline function 'androidx.compose.ui.node.NodeChain.headToTail' call
    var node = this.j99_1;
    while (!(node == null)) {
      var it = node;
      it.e8w();
      if (it.u8v_1) {
        autoInvalidateInsertedNode(it);
      }
      if (it.v8v_1) {
        autoInvalidateUpdatedNode(it);
      }
      it.u8v_1 = false;
      it.v8v_1 = false;
      node = node.r8v_1;
    }
  };
  protoOf(NodeChain).i8w = function () {
    // Inline function 'androidx.compose.ui.node.NodeChain.tailToHead' call
    var node = this.i99_1;
    while (!(node == null)) {
      var it = node;
      if (it.z8v_1) {
        it.i8w();
      }
      node = node.q8v_1;
    }
  };
  protoOf(NodeChain).g8w = function () {
    // Inline function 'androidx.compose.ui.node.NodeChain.tailToHead' call
    var node = this.i99_1;
    while (!(node == null)) {
      var it = node;
      if (it.z8v_1) {
        it.g8w();
      }
      node = node.q8v_1;
    }
  };
  protoOf(NodeChain).abb = function (type) {
    return !((_get_aggregateChildKindSet__bx3g2o(this) & _NodeKind___get_mask__impl__1uopb6(type)) === 0);
  };
  protoOf(NodeChain).toString = function () {
    // Inline function 'kotlin.text.buildString' call
    // Inline function 'kotlin.apply' call
    var this_0 = StringBuilder_init_$Create$();
    $l$block_0: {
      this_0.q('[');
      if (this.j99_1 === this.i99_1) {
        this_0.q(']');
        break $l$block_0;
      }
      // Inline function 'androidx.compose.ui.node.NodeChain.headToTailExclusive' call
      var node = this.j99_1;
      while (!(node == null) && !(node === this.i99_1)) {
        var it = node;
        this_0.q(toString(it));
        if (it.r8v_1 === this.i99_1) {
          this_0.q(']');
          break $l$block_0;
        }
        this_0.q(',');
        node = node.r8v_1;
      }
    }
    return this_0.toString();
  };
  function fillVector(_this__u8e3s4, result, stack) {
    stack.zz(_this__u8e3s4);
    var predicate = null;
    $l$loop: while (true) {
      // Inline function 'androidx.compose.runtime.collection.MutableVector.isNotEmpty' call
      if (!!(stack.d3e_1 === 0)) {
        break $l$loop;
      }
      var next = stack.h3(stack.d3e_1 - 1 | 0);
      if (next instanceof CombinedModifier) {
        stack.zz(next.q8w_1);
        stack.zz(next.p8w_1);
      } else {
        if (isInterface(next, Element_0))
          result.zz(next);
        else {
          var tmp0_elvis_lhs = predicate;
          var tmp;
          if (tmp0_elvis_lhs == null) {
            // Inline function 'kotlin.also' call
            var this_0 = fillVector$lambda(result);
            predicate = this_0;
            tmp = this_0;
          } else {
            tmp = tmp0_elvis_lhs;
          }
          next.i8v(tmp);
        }
      }
    }
    return result;
  }
  function actionForModifiers(prev, next) {
    var tmp;
    if (equals(prev, next)) {
      tmp = 2;
    } else if (areObjectsOfSameType(prev, next)) {
      tmp = 1;
    } else {
      tmp = 0;
    }
    return tmp;
  }
  function updateUnsafe(_this__u8e3s4, node) {
    _this__u8e3s4.d8y(node instanceof Node ? node : THROW_CCE());
  }
  function fillVector$lambda($result) {
    return function (element) {
      $result.zz(element);
      return true;
    };
  }
  var androidx_compose_ui_node_NodeCoordinator$stable;
  function NodeCoordinator$Companion$onCommitAffectingLayerParams$lambda(coordinator) {
    // Inline function 'androidx.compose.ui.node.withComposeStackTrace' call
    var layoutNode = coordinator.a9i();
    try {
      if (coordinator.kb0()) {
        updateLayerParameters(coordinator);
      }
    } catch ($p) {
      if ($p instanceof Error) {
        var e = $p;
        layoutNode.dbc(e);
      } else {
        throw $p;
      }
    }
    return Unit_instance;
  }
  function NodeCoordinator$Companion$onCommitAffectingLayer$lambda(coordinator) {
    var tmp0_safe_receiver = coordinator.o95_1;
    if (tmp0_safe_receiver == null)
      null;
    else {
      tmp0_safe_receiver.m40();
    }
    return Unit_instance;
  }
  function NodeCoordinator$Companion$PointerInputSource$1() {
  }
  protoOf(NodeCoordinator$Companion$PointerInputSource$1).jbk = function () {
    // Inline function 'androidx.compose.ui.node.Nodes.PointerInput' call
    return _NodeKind___init__impl__ojsprp(16);
  };
  protoOf(NodeCoordinator$Companion$PointerInputSource$1).kbk = function () {
    return this.jbk();
  };
  protoOf(NodeCoordinator$Companion$PointerInputSource$1).lbk = function (node) {
    // Inline function 'androidx.compose.ui.node.Nodes.PointerInput' call
    // Inline function 'androidx.compose.ui.node.dispatchForKind' call
    // Inline function 'androidx.compose.ui.node.dispatchForKind' call
    var kind = _NodeKind___init__impl__ojsprp(16);
    var stack = null;
    var node_0 = node;
    $l$loop: while (!(node_0 == null)) {
      var tmp;
      if (isInterface(node_0, PointerInputModifierNode)) {
        if (node_0.fa5())
          return true;
        tmp = false;
      } else {
        tmp = true;
      }
      var dispatchAgain = tmp;
      var tmp_0;
      var tmp_1;
      if (dispatchAgain || false) {
        // Inline function 'androidx.compose.ui.Node.isKind' call
        tmp_1 = !((node_0.o8v_1 & _NodeKind___get_mask__impl__1uopb6(kind)) === 0);
      } else {
        tmp_1 = false;
      }
      if (tmp_1) {
        tmp_0 = node_0 instanceof DelegatingNode;
      } else {
        tmp_0 = false;
      }
      if (tmp_0) {
        var count = 0;
        // Inline function 'androidx.compose.ui.node.DelegatingNode.forEachImmediateDelegate' call
        var node_1 = node_0.e9a_1;
        while (!(node_1 == null)) {
          var next = node_1;
          // Inline function 'androidx.compose.ui.Node.isKind' call
          if (!((next.o8v_1 & _NodeKind___get_mask__impl__1uopb6(kind)) === 0)) {
            count = count + 1 | 0;
            if (count === 1) {
              node_0 = next;
            } else {
              var tmp0_elvis_lhs = stack;
              var tmp_2;
              if (tmp0_elvis_lhs == null) {
                // Inline function 'androidx.compose.runtime.collection.mutableVectorOf' call
                // Inline function 'androidx.compose.runtime.collection.MutableVector' call
                // Inline function 'kotlin.arrayOfNulls' call
                var tmp$ret$10 = Array(16);
                tmp_2 = new MutableVector(tmp$ret$10, 0);
              } else {
                tmp_2 = tmp0_elvis_lhs;
              }
              stack = tmp_2;
              var theNode = node_0;
              if (!(theNode == null)) {
                var tmp1_safe_receiver = stack;
                if (tmp1_safe_receiver == null)
                  null;
                else
                  tmp1_safe_receiver.zz(theNode);
                node_0 = null;
              }
              var tmp2_safe_receiver = stack;
              if (tmp2_safe_receiver == null)
                null;
              else
                tmp2_safe_receiver.zz(next);
            }
          }
          node_1 = node_1.r8v_1;
        }
        if (count === 1) {
          continue $l$loop;
        }
      }
      node_0 = access$pop$tDelegatableNodeKt(stack);
    }
    return false;
  };
  protoOf(NodeCoordinator$Companion$PointerInputSource$1).ub6 = function (parentLayoutNode) {
    return true;
  };
  protoOf(NodeCoordinator$Companion$PointerInputSource$1).vb6 = function (layoutNode, pointerPosition, hitTestResult, pointerType, isInLayer) {
    return layoutNode.fbd(pointerPosition, hitTestResult, pointerType, isInLayer);
  };
  protoOf(NodeCoordinator$Companion$PointerInputSource$1).xb6 = function (hitTestResult, child) {
    if (child.hak().wb6()) {
      hitTestResult.xb2();
      return true;
    }
    return false;
  };
  function NodeCoordinator$Companion$SemanticsSource$1() {
  }
  protoOf(NodeCoordinator$Companion$SemanticsSource$1).nbk = function () {
    // Inline function 'androidx.compose.ui.node.Nodes.Semantics' call
    return _NodeKind___init__impl__ojsprp(8);
  };
  protoOf(NodeCoordinator$Companion$SemanticsSource$1).kbk = function () {
    return this.nbk();
  };
  protoOf(NodeCoordinator$Companion$SemanticsSource$1).lbk = function (node) {
    return false;
  };
  protoOf(NodeCoordinator$Companion$SemanticsSource$1).ub6 = function (parentLayoutNode) {
    var tmp0_safe_receiver = parentLayoutNode.lb0();
    return !((tmp0_safe_receiver == null ? null : tmp0_safe_receiver.qb0_1) === true);
  };
  protoOf(NodeCoordinator$Companion$SemanticsSource$1).vb6 = function (layoutNode, pointerPosition, hitTestResult, pointerType, isInLayer) {
    return layoutNode.pbd(pointerPosition, hitTestResult, pointerType, isInLayer);
  };
  protoOf(NodeCoordinator$Companion$SemanticsSource$1).mbk = function (node) {
    if (!ComposeUiFlags_instance.c8v_1)
      return true;
    return isImportantForAccessibility(SemanticsNode_0(requireLayoutNode(node), false));
  };
  protoOf(NodeCoordinator$Companion$SemanticsSource$1).xb6 = function (hitTestResult, child) {
    return false;
  };
  function headNode($this, includeTail) {
    var tmp;
    if ($this.a9i().hak() === $this) {
      tmp = $this.a9i().d91_1.j99_1;
    } else if (includeTail) {
      var tmp0_safe_receiver = $this.t94_1;
      var tmp1_safe_receiver = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.qb1();
      tmp = tmp1_safe_receiver == null ? null : tmp1_safe_receiver.r8v_1;
    } else {
      var tmp2_safe_receiver = $this.t94_1;
      tmp = tmp2_safe_receiver == null ? null : tmp2_safe_receiver.qb1();
    }
    return tmp;
  }
  function hasNode($this, type) {
    var tmp0_safe_receiver = headNode($this, get_includeSelfInTraversal(type));
    return (tmp0_safe_receiver == null ? null : has(tmp0_safe_receiver, type)) === true;
  }
  function _get_snapshotObserver__i94x1t($this) {
    return requireOwner_0($this.a9i()).fb0();
  }
  function placeSelf_2($this, position, zIndex, layerBlock, explicitLayer) {
    if (!(explicitLayer == null)) {
      // Inline function 'androidx.compose.ui.internal.requirePrecondition' call
      if (!(layerBlock == null)) {
        var tmp$ret$1 = "both ways to create layers shouldn't be used together";
        throwIllegalArgumentException(tmp$ret$1);
      }
      if (!($this.p95_1 === explicitLayer)) {
        $this.p95_1 = null;
        $this.ib7(null);
        $this.p95_1 = explicitLayer;
      }
      if ($this.o95_1 == null) {
        var tmp = $this;
        // Inline function 'kotlin.apply' call
        var this_0 = requireOwner_0($this.a9i()).obk(_get_drawBlock__v9gcvs($this), $this.m95_1, explicitLayer);
        this_0.pbk($this.k8y_1);
        this_0.qbk(position);
        tmp.o95_1 = this_0;
        $this.a9i().h91_1 = true;
        $this.m95_1();
      }
    } else {
      if (!($this.p95_1 == null)) {
        $this.p95_1 = null;
        $this.ib7(null);
      }
      $this.ib7(layerBlock);
    }
    if (!equals($this.iak(), position)) {
      requireOwner_0($this.a9i()).rbk(_FrameRateCategory___get_value__impl__e037z6(Companion_getInstance_26().l8v_1));
      $this.fb4(position);
      var layer = $this.o95_1;
      if (!(layer == null)) {
        layer.qbk(position);
      } else {
        var tmp0_safe_receiver = $this.t94_1;
        if (tmp0_safe_receiver == null)
          null;
        else {
          tmp0_safe_receiver.lb2();
        }
      }
      $this.a9i().cbe($this);
      $this.nb4($this);
      var tmp1_safe_receiver = $this.a9i().l90_1;
      if (tmp1_safe_receiver == null)
        null;
      else {
        tmp1_safe_receiver.sbk($this.a9i());
      }
    }
    $this.d95_1 = zIndex;
    if ($this === $this.a9i().hak()) {
      requireOwner_0($this.a9i()).xam().tbb($this.a9i());
    }
    if (!$this.fae_1) {
      $this.pb4($this.gag());
    }
  }
  function drawContainedDrawModifiers($this, canvas, graphicsLayer) {
    // Inline function 'androidx.compose.ui.node.Nodes.Draw' call
    var tmp$ret$0 = _NodeKind___init__impl__ojsprp(4);
    var head = $this.yb6(tmp$ret$0);
    if (head == null) {
      $this.mb6(canvas, graphicsLayer);
    } else {
      var drawScope = $this.a9i().tbc();
      drawScope.mbg(canvas, toSize($this.q95()), $this, head, graphicsLayer);
    }
  }
  function _get_drawBlock__v9gcvs($this) {
    var block = $this.l95_1;
    if (block == null) {
      var drawBlockCallToDrawModifiers = NodeCoordinator$_get_drawBlock_$lambda_6zkogp($this);
      block = NodeCoordinator$_get_drawBlock_$lambda_6zkogp_0($this, drawBlockCallToDrawModifiers);
      $this.l95_1 = block;
    }
    return block;
  }
  function updateLayerParameters($this, invokeOnLayoutChange) {
    invokeOnLayoutChange = invokeOnLayoutChange === VOID ? true : invokeOnLayoutChange;
    if (!($this.p95_1 == null)) {
      return Unit_instance;
    }
    var layer = $this.o95_1;
    if (!(layer == null)) {
      // Inline function 'androidx.compose.ui.internal.checkPreconditionNotNull' call
      var value = $this.w94_1;
      if (value == null) {
        var tmp$ret$1 = 'updateLayerParameters requires a non-null layerBlock';
        throwIllegalStateExceptionForNullCheck(tmp$ret$1);
      }
      var layerBlock = value;
      Companion_getInstance_58().kbd_1.u4c();
      Companion_getInstance_58().kbd_1.e9j_1 = $this.a9i().w90_1;
      Companion_getInstance_58().kbd_1.f9j_1 = $this.a9i().x90_1;
      Companion_getInstance_58().kbd_1.d9j_1 = toSize($this.q95());
      var tmp0 = _get_snapshotObserver__i94x1t($this);
      var tmp4 = Companion_getInstance_58().ibd_1;
      // Inline function 'androidx.compose.ui.node.OwnerSnapshotObserver.observeReads' call
      var block = NodeCoordinator$updateLayerParameters$lambda(layerBlock, $this);
      access$_get_observer__zh6fij(tmp0).z5a($this, tmp4, block);
      var tmp0_elvis_lhs = $this.f95_1;
      var tmp;
      if (tmp0_elvis_lhs == null) {
        // Inline function 'kotlin.also' call
        var this_0 = new LayerPositionalProperties();
        $this.f95_1 = this_0;
        tmp = this_0;
      } else {
        tmp = tmp0_elvis_lhs;
      }
      var layerPositionalProperties = tmp;
      Companion_getInstance_58().lbd_1.cbl(layerPositionalProperties);
      layerPositionalProperties.dbl(Companion_getInstance_58().kbd_1);
      layer.ebl(Companion_getInstance_58().kbd_1);
      var wasClipping = $this.v94_1;
      $this.v94_1 = Companion_getInstance_58().kbd_1.b9j_1;
      $this.z94_1 = Companion_getInstance_58().kbd_1.p9i_1;
      var positionalPropertiesChanged = !Companion_getInstance_58().lbd_1.fbl(layerPositionalProperties);
      if (invokeOnLayoutChange && (positionalPropertiesChanged || !(wasClipping === $this.v94_1))) {
        var tmp1_safe_receiver = $this.a9i().l90_1;
        if (tmp1_safe_receiver == null)
          null;
        else {
          tmp1_safe_receiver.sbk($this.a9i());
        }
      }
      if (positionalPropertiesChanged) {
        var layoutNode = $this.a9i();
        layoutNode.cbe($this);
        if (layoutNode.n91_1 > 0) {
          requireOwner_0(layoutNode).bbe(layoutNode);
        }
      }
    } else {
      // Inline function 'androidx.compose.ui.internal.checkPrecondition' call
      if (!($this.w94_1 == null)) {
        var tmp$ret$6 = 'null layer with a non-null layerBlock';
        throwIllegalStateException(tmp$ret$6);
      }
    }
  }
  function hit($this, $receiver, hitTestSource, pointerPosition, hitTestResult, pointerType, isInLayer) {
    if ($receiver == null) {
      $this.qb6(hitTestSource, pointerPosition, hitTestResult, pointerType, isInLayer);
    } else if (!hitTestSource.mbk($receiver)) {
      var tmp = hitTestSource.kbk();
      // Inline function 'androidx.compose.ui.node.Nodes.Layout' call
      var tmp$ret$0 = _NodeKind___init__impl__ojsprp(2);
      hit($this, nextUntil($receiver, tmp, tmp$ret$0), hitTestSource, pointerPosition, hitTestResult, pointerType, isInLayer);
    } else {
      // Inline function 'androidx.compose.ui.node.HitTestResult.hit' call
      // Inline function 'androidx.compose.ui.node.HitTestResult.hitInMinimumTouchTarget' call
      // Inline function 'androidx.compose.ui.node.HitTestResult.hitInMinimumTouchTarget' call
      var distanceFromEdge = -1.0;
      var startDepth = access$_get_hitDepth__j82o0r(hitTestResult);
      access$removeNodesInRange(hitTestResult, access$_get_hitDepth__j82o0r(hitTestResult) + 1 | 0, hitTestResult.n1());
      var _unary__edvuaz = access$_get_hitDepth__j82o0r(hitTestResult);
      access$_set_hitDepth__w0yzhj(hitTestResult, _unary__edvuaz + 1 | 0);
      access$_get_values__6cbjvt(hitTestResult).j1($receiver);
      access$_get_distanceFromEdgeAndFlags__osnxzz(hitTestResult).uw(_DistanceAndFlags___get_packedValue__impl__qekawo(access$DistanceAndFlags$tHitTestResultKt(distanceFromEdge, isInLayer, false)));
      var tmp_0 = hitTestSource.kbk();
      // Inline function 'androidx.compose.ui.node.Nodes.Layout' call
      var tmp$ret$5 = _NodeKind___init__impl__ojsprp(2);
      hit($this, nextUntil($receiver, tmp_0, tmp$ret$5), hitTestSource, pointerPosition, hitTestResult, pointerType, isInLayer);
      access$_set_hitDepth__w0yzhj(hitTestResult, startDepth);
    }
  }
  function outOfBoundsHit($this, $receiver, hitTestSource, pointerPosition, hitTestResult, pointerType, isInLayer, distanceFromEdge, isHitInMinimumTouchTargetBetter) {
    if ($receiver == null) {
      $this.qb6(hitTestSource, pointerPosition, hitTestResult, pointerType, isInLayer);
    } else if (!hitTestSource.mbk($receiver)) {
      var tmp = hitTestSource.kbk();
      // Inline function 'androidx.compose.ui.node.Nodes.Layout' call
      var tmp$ret$0 = _NodeKind___init__impl__ojsprp(2);
      outOfBoundsHit($this, nextUntil($receiver, tmp, tmp$ret$0), hitTestSource, pointerPosition, hitTestResult, pointerType, isInLayer, distanceFromEdge, isHitInMinimumTouchTargetBetter);
    } else if (isInExpandedTouchBounds($this, $receiver, pointerPosition, pointerType)) {
      hitTestResult.zb2($receiver, isInLayer, NodeCoordinator$outOfBoundsHit$lambda($this, $receiver, hitTestSource, pointerPosition, hitTestResult, pointerType, isInLayer, distanceFromEdge, isHitInMinimumTouchTargetBetter));
    } else if (isHitInMinimumTouchTargetBetter) {
      hitNear($this, $receiver, hitTestSource, pointerPosition, hitTestResult, pointerType, isInLayer, distanceFromEdge);
    } else {
      speculativeHit($this, $receiver, hitTestSource, pointerPosition, hitTestResult, pointerType, isInLayer, distanceFromEdge);
    }
  }
  function hitNear($this, $receiver, hitTestSource, pointerPosition, hitTestResult, pointerType, isInLayer, distanceFromEdge) {
    if ($receiver == null) {
      $this.qb6(hitTestSource, pointerPosition, hitTestResult, pointerType, isInLayer);
    } else if (!hitTestSource.mbk($receiver)) {
      var tmp = hitTestSource.kbk();
      // Inline function 'androidx.compose.ui.node.Nodes.Layout' call
      var tmp$ret$0 = _NodeKind___init__impl__ojsprp(2);
      hitNear($this, nextUntil($receiver, tmp, tmp$ret$0), hitTestSource, pointerPosition, hitTestResult, pointerType, isInLayer, distanceFromEdge);
    } else {
      // Inline function 'androidx.compose.ui.node.HitTestResult.hitInMinimumTouchTarget' call
      // Inline function 'androidx.compose.ui.node.HitTestResult.hitInMinimumTouchTarget' call
      var startDepth = access$_get_hitDepth__j82o0r(hitTestResult);
      access$removeNodesInRange(hitTestResult, access$_get_hitDepth__j82o0r(hitTestResult) + 1 | 0, hitTestResult.n1());
      var _unary__edvuaz = access$_get_hitDepth__j82o0r(hitTestResult);
      access$_set_hitDepth__w0yzhj(hitTestResult, _unary__edvuaz + 1 | 0);
      access$_get_values__6cbjvt(hitTestResult).j1($receiver);
      access$_get_distanceFromEdgeAndFlags__osnxzz(hitTestResult).uw(_DistanceAndFlags___get_packedValue__impl__qekawo(access$DistanceAndFlags$tHitTestResultKt(distanceFromEdge, isInLayer, false)));
      var tmp_0 = hitTestSource.kbk();
      // Inline function 'androidx.compose.ui.node.Nodes.Layout' call
      var tmp$ret$4 = _NodeKind___init__impl__ojsprp(2);
      outOfBoundsHit($this, nextUntil($receiver, tmp_0, tmp$ret$4), hitTestSource, pointerPosition, hitTestResult, pointerType, isInLayer, distanceFromEdge, true);
      access$_set_hitDepth__w0yzhj(hitTestResult, startDepth);
    }
  }
  function speculativeHit($this, $receiver, hitTestSource, pointerPosition, hitTestResult, pointerType, isInLayer, distanceFromEdge) {
    if ($receiver == null) {
      $this.qb6(hitTestSource, pointerPosition, hitTestResult, pointerType, isInLayer);
    } else if (!hitTestSource.mbk($receiver)) {
      var tmp = hitTestSource.kbk();
      // Inline function 'androidx.compose.ui.node.Nodes.Layout' call
      var tmp$ret$0 = _NodeKind___init__impl__ojsprp(2);
      speculativeHit($this, nextUntil($receiver, tmp, tmp$ret$0), hitTestSource, pointerPosition, hitTestResult, pointerType, isInLayer, distanceFromEdge);
    } else if (hitTestSource.lbk($receiver)) {
      hitTestResult.ab3($receiver, distanceFromEdge, isInLayer, NodeCoordinator$speculativeHit$lambda($this, $receiver, hitTestSource, pointerPosition, hitTestResult, pointerType, isInLayer, distanceFromEdge));
    } else {
      var tmp_0 = hitTestSource.kbk();
      // Inline function 'androidx.compose.ui.node.Nodes.Layout' call
      var tmp$ret$1 = _NodeKind___init__impl__ojsprp(2);
      outOfBoundsHit($this, nextUntil($receiver, tmp_0, tmp$ret$1), hitTestSource, pointerPosition, hitTestResult, pointerType, isInLayer, distanceFromEdge, false);
    }
  }
  function isInExpandedTouchBounds($this, $receiver, pointerPosition, pointerType) {
    if ($receiver == null) {
      return false;
    }
    if (!(pointerType === Companion_getInstance_42().oa2_1) && !(pointerType === Companion_getInstance_42().pa2_1)) {
      return false;
    }
    // Inline function 'androidx.compose.ui.node.Nodes.PointerInput' call
    // Inline function 'androidx.compose.ui.node.dispatchForKind' call
    // Inline function 'androidx.compose.ui.node.dispatchForKind' call
    var kind = _NodeKind___init__impl__ojsprp(16);
    var stack = null;
    var node = $receiver;
    $l$loop: while (!(node == null)) {
      var tmp;
      if (isInterface(node, PointerInputModifierNode)) {
        var expansion = node.ea5();
        var tmp_0;
        var tmp_1;
        var tmp_2;
        // Inline function 'androidx.compose.ui.geometry.Offset.x' call
        // Inline function 'androidx.compose.ui.util.unpackFloat1' call
        var value = _Offset___get_packedValue__impl__xh2k8q(pointerPosition);
        // Inline function 'androidx.compose.ui.util.floatFromBits' call
        // Inline function 'kotlin.fromBits' call
        var bits = convertToInt(shiftRight(value, 32));
        if (floatFromBits(bits) >= (-TouchBoundsExpansion__computeLeft_impl_tubjra(expansion, $this.r6p()) | 0)) {
          // Inline function 'androidx.compose.ui.geometry.Offset.x' call
          // Inline function 'androidx.compose.ui.util.unpackFloat1' call
          var value_0 = _Offset___get_packedValue__impl__xh2k8q(pointerPosition);
          // Inline function 'androidx.compose.ui.util.floatFromBits' call
          // Inline function 'kotlin.fromBits' call
          var bits_0 = convertToInt(shiftRight(value_0, 32));
          tmp_2 = floatFromBits(bits_0) < ($this.mah() + TouchBoundsExpansion__computeRight_impl_sqizz1(expansion, $this.r6p()) | 0);
        } else {
          tmp_2 = false;
        }
        if (tmp_2) {
          // Inline function 'androidx.compose.ui.geometry.Offset.y' call
          // Inline function 'androidx.compose.ui.util.unpackFloat2' call
          var value_1 = _Offset___get_packedValue__impl__xh2k8q(pointerPosition);
          // Inline function 'androidx.compose.ui.util.floatFromBits' call
          // Inline function 'kotlin.fromBits' call
          var bits_1 = convertToInt(bitwiseAnd(value_1, new Long(-1, 0)));
          tmp_1 = floatFromBits(bits_1) >= (-_TouchBoundsExpansion___get_top__impl__mce72e(expansion) | 0);
        } else {
          tmp_1 = false;
        }
        if (tmp_1) {
          // Inline function 'androidx.compose.ui.geometry.Offset.y' call
          // Inline function 'androidx.compose.ui.util.unpackFloat2' call
          var value_2 = _Offset___get_packedValue__impl__xh2k8q(pointerPosition);
          // Inline function 'androidx.compose.ui.util.floatFromBits' call
          // Inline function 'kotlin.fromBits' call
          var bits_2 = convertToInt(bitwiseAnd(value_2, new Long(-1, 0)));
          tmp_0 = floatFromBits(bits_2) < ($this.zao() + _TouchBoundsExpansion___get_bottom__impl__c1cspk(expansion) | 0);
        } else {
          tmp_0 = false;
        }
        return tmp_0;
      } else {
        tmp = true;
      }
      var dispatchAgain = tmp;
      var tmp_3;
      var tmp_4;
      if (dispatchAgain || false) {
        // Inline function 'androidx.compose.ui.Node.isKind' call
        tmp_4 = !((node.o8v_1 & _NodeKind___get_mask__impl__1uopb6(kind)) === 0);
      } else {
        tmp_4 = false;
      }
      if (tmp_4) {
        tmp_3 = node instanceof DelegatingNode;
      } else {
        tmp_3 = false;
      }
      if (tmp_3) {
        var count = 0;
        // Inline function 'androidx.compose.ui.node.DelegatingNode.forEachImmediateDelegate' call
        var node_0 = node.e9a_1;
        while (!(node_0 == null)) {
          var next = node_0;
          // Inline function 'androidx.compose.ui.Node.isKind' call
          if (!((next.o8v_1 & _NodeKind___get_mask__impl__1uopb6(kind)) === 0)) {
            count = count + 1 | 0;
            if (count === 1) {
              node = next;
            } else {
              var tmp0_elvis_lhs = stack;
              var tmp_5;
              if (tmp0_elvis_lhs == null) {
                // Inline function 'androidx.compose.runtime.collection.mutableVectorOf' call
                // Inline function 'androidx.compose.runtime.collection.MutableVector' call
                // Inline function 'kotlin.arrayOfNulls' call
                var tmp$ret$26 = Array(16);
                tmp_5 = new MutableVector(tmp$ret$26, 0);
              } else {
                tmp_5 = tmp0_elvis_lhs;
              }
              stack = tmp_5;
              var theNode = node;
              if (!(theNode == null)) {
                var tmp1_safe_receiver = stack;
                if (tmp1_safe_receiver == null)
                  null;
                else
                  tmp1_safe_receiver.zz(theNode);
                node = null;
              }
              var tmp2_safe_receiver = stack;
              if (tmp2_safe_receiver == null)
                null;
              else
                tmp2_safe_receiver.zz(next);
            }
          }
          node_0 = node_0.r8v_1;
        }
        if (count === 1) {
          continue $l$loop;
        }
      }
      node = access$pop$tDelegatableNodeKt(stack);
    }
    return false;
  }
  function toCoordinator($this, $receiver) {
    var tmp0_safe_receiver = $receiver instanceof LookaheadLayoutCoordinates ? $receiver : null;
    var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.gak();
    var tmp;
    if (tmp1_elvis_lhs == null) {
      tmp = $receiver instanceof NodeCoordinator ? $receiver : THROW_CCE();
    } else {
      tmp = tmp1_elvis_lhs;
    }
    return tmp;
  }
  function transformToAncestor($this, ancestor, matrix) {
    var wrapper = $this;
    while (!equals(wrapper, ancestor)) {
      var tmp0_safe_receiver = wrapper.o95_1;
      if (tmp0_safe_receiver == null)
        null;
      else {
        tmp0_safe_receiver.z6i(matrix);
      }
      var position = wrapper.iak();
      if (!equals(position, Companion_getInstance_11().c5g_1)) {
        Matrix__reset_impl_4l49i7(Companion_getInstance_58().mbd_1);
        Matrix__translate$default_impl_10t8ql(Companion_getInstance_58().mbd_1, _IntOffset___get_x__impl__qiqr5o(position), _IntOffset___get_y__impl__2avpwj(position));
        Matrix__timesAssign_impl_oas521(matrix, Companion_getInstance_58().mbd_1);
      }
      wrapper = ensureNotNull(wrapper.t94_1);
    }
  }
  function transformFromAncestor($this, ancestor, matrix) {
    if (!equals(ancestor, $this)) {
      transformFromAncestor(ensureNotNull($this.t94_1), ancestor, matrix);
      if (!equals($this.iak(), Companion_getInstance_11().c5g_1)) {
        Matrix__reset_impl_4l49i7(Companion_getInstance_58().mbd_1);
        Matrix__translate$default_impl_10t8ql(Companion_getInstance_58().mbd_1, -_IntOffset___get_x__impl__qiqr5o($this.iak()), -_IntOffset___get_y__impl__2avpwj($this.iak()));
        Matrix__timesAssign_impl_oas521(matrix, Companion_getInstance_58().mbd_1);
      }
      var tmp0_safe_receiver = $this.o95_1;
      if (tmp0_safe_receiver == null)
        null;
      else {
        tmp0_safe_receiver.gbl(matrix);
      }
    }
  }
  function ancestorToLocal($this, ancestor, offset, includeMotionFrameOfReference) {
    if (ancestor === $this) {
      return offset;
    }
    var wrappedBy = $this.t94_1;
    if (wrappedBy == null || equals(ancestor, wrappedBy)) {
      return $this.mb7(offset, includeMotionFrameOfReference);
    }
    return $this.mb7(ancestorToLocal(wrappedBy, ancestor, offset, includeMotionFrameOfReference), includeMotionFrameOfReference);
  }
  function ancestorToLocal_0($this, ancestor, rect, clipBounds) {
    if (ancestor === $this) {
      return Unit_instance;
    }
    var tmp0_safe_receiver = $this.t94_1;
    if (tmp0_safe_receiver == null)
      null;
    else {
      ancestorToLocal_0(tmp0_safe_receiver, ancestor, rect, clipBounds);
    }
    return fromParentRect($this, rect, clipBounds);
  }
  function fromParentRect($this, bounds, clipBounds) {
    var x = _IntOffset___get_x__impl__qiqr5o($this.iak());
    bounds.w5c_1 = bounds.w5c_1 - x;
    bounds.y5c_1 = bounds.y5c_1 - x;
    var y = _IntOffset___get_y__impl__2avpwj($this.iak());
    bounds.x5c_1 = bounds.x5c_1 - y;
    bounds.z5c_1 = bounds.z5c_1 - y;
    var layer = $this.o95_1;
    if (!(layer == null)) {
      layer.hbl(bounds, true);
      if ($this.v94_1 && clipBounds) {
        // Inline function 'androidx.compose.ui.unit.IntSize.width' call
        var this_0 = $this.q95();
        // Inline function 'androidx.compose.ui.util.unpackInt1' call
        var value = _IntSize___get_packedValue__impl__uho7jf(this_0);
        var tmp = convertToInt(shiftRight(value, 32));
        // Inline function 'androidx.compose.ui.unit.IntSize.height' call
        var this_1 = $this.q95();
        // Inline function 'androidx.compose.ui.util.unpackInt2' call
        var value_0 = _IntSize___get_packedValue__impl__uho7jf(this_1);
        var tmp$ret$2 = convertToInt(bitwiseAnd(value_0, new Long(-1, 0)));
        bounds.c5d(0.0, 0.0, tmp, tmp$ret$2);
        if (bounds.oy()) {
          return Unit_instance;
        }
      }
    }
  }
  function offsetFromEdge($this, pointerPosition) {
    // Inline function 'androidx.compose.ui.geometry.Offset.x' call
    // Inline function 'androidx.compose.ui.util.unpackFloat1' call
    var value = _Offset___get_packedValue__impl__xh2k8q(pointerPosition);
    // Inline function 'androidx.compose.ui.util.floatFromBits' call
    // Inline function 'kotlin.fromBits' call
    var bits = convertToInt(shiftRight(value, 32));
    var x = floatFromBits(bits);
    // Inline function 'kotlin.comparisons.maxOf' call
    var b = x < 0 ? -x : x - $this.mah();
    var horizontal = Math.max(0.0, b);
    // Inline function 'androidx.compose.ui.geometry.Offset.y' call
    // Inline function 'androidx.compose.ui.util.unpackFloat2' call
    var value_0 = _Offset___get_packedValue__impl__xh2k8q(pointerPosition);
    // Inline function 'androidx.compose.ui.util.floatFromBits' call
    // Inline function 'kotlin.fromBits' call
    var bits_0 = convertToInt(bitwiseAnd(value_0, new Long(-1, 0)));
    var y = floatFromBits(bits_0);
    // Inline function 'kotlin.comparisons.maxOf' call
    var b_0 = y < 0 ? -y : y - $this.zao();
    var vertical = Math.max(0.0, b_0);
    // Inline function 'androidx.compose.ui.geometry.Offset' call
    // Inline function 'androidx.compose.ui.util.packFloats' call
    var v1 = fromInt(toRawBits(horizontal));
    var v2 = fromInt(toRawBits(vertical));
    var tmp$ret$11 = bitwiseOr(shiftLeft(v1, 32), bitwiseAnd(v2, new Long(-1, 0)));
    return _Offset___init__impl__c168vi(tmp$ret$11);
  }
  function HitTestSource() {
  }
  function Companion_32() {
    Companion_instance_37 = this;
    this.gbd_1 = 'LayoutCoordinate operations are only valid when isAttached is true';
    this.hbd_1 = 'Asking for measurement result of unmeasured layout modifier';
    var tmp = this;
    tmp.ibd_1 = NodeCoordinator$Companion$onCommitAffectingLayerParams$lambda;
    var tmp_0 = this;
    tmp_0.jbd_1 = NodeCoordinator$Companion$onCommitAffectingLayer$lambda;
    this.kbd_1 = new ReusableGraphicsLayerScope();
    this.lbd_1 = new LayerPositionalProperties();
    this.mbd_1 = _Matrix___init__impl__q3kp4w();
    var tmp_1 = this;
    tmp_1.nbd_1 = new NodeCoordinator$Companion$PointerInputSource$1();
    var tmp_2 = this;
    tmp_2.obd_1 = new NodeCoordinator$Companion$SemanticsSource$1();
  }
  var Companion_instance_37;
  function Companion_getInstance_58() {
    if (Companion_instance_37 == null)
      new Companion_32();
    return Companion_instance_37;
  }
  function access$headNode($this, includeTail) {
    return headNode($this, includeTail);
  }
  function NodeCoordinator$_get_drawBlock_$lambda_6zkogp(this$0) {
    return function () {
      drawContainedDrawModifiers(this$0, ensureNotNull(this$0.k95_1), this$0.j95_1);
      return Unit_instance;
    };
  }
  function NodeCoordinator$_get_drawBlock_$lambda_6zkogp_0(this$0, $drawBlockCallToDrawModifiers) {
    return function (canvas, parentLayer) {
      var tmp;
      if (this$0.a9i().b9i()) {
        this$0.k95_1 = canvas;
        this$0.j95_1 = parentLayer;
        var tmp0 = _get_snapshotObserver__i94x1t(this$0);
        var tmp2 = this$0;
        var tmp4 = Companion_getInstance_58().jbd_1;
        // Inline function 'androidx.compose.ui.node.OwnerSnapshotObserver.observeReads' call
        var block = $drawBlockCallToDrawModifiers;
        access$_get_observer__zh6fij(tmp0).z5a(tmp2, tmp4, block);
        this$0.n95_1 = false;
        tmp = Unit_instance;
      } else {
        this$0.n95_1 = true;
        tmp = Unit_instance;
      }
      return Unit_instance;
    };
  }
  function NodeCoordinator$updateLayerParameters$lambda($layerBlock, this$0) {
    return function () {
      $layerBlock(Companion_getInstance_58().kbd_1);
      var hasShapeChanged = !equals(this$0.g95_1, Companion_getInstance_58().kbd_1.a9j_1);
      var hasClipChanged = !(this$0.h95_1 === Companion_getInstance_58().kbd_1.b9j_1);
      var tmp;
      if (hasShapeChanged || hasClipChanged) {
        this$0.g95_1 = Companion_getInstance_58().kbd_1.a9j_1;
        this$0.h95_1 = Companion_getInstance_58().kbd_1.b9j_1;
        var tmp_0;
        if (this$0.i95_1 && (hasClipChanged || (this$0.h95_1 && hasShapeChanged))) {
          this$0.a9i().kbb();
          tmp_0 = Unit_instance;
        }
        tmp = tmp_0;
      }
      this$0.i95_1 = true;
      Companion_getInstance_58().kbd_1.d9m();
      return Unit_instance;
    };
  }
  function NodeCoordinator$invalidateParentLayer$lambda(this$0) {
    return function () {
      var tmp0_safe_receiver = this$0.t94_1;
      if (tmp0_safe_receiver == null)
        null;
      else {
        tmp0_safe_receiver.lb2();
      }
      return Unit_instance;
    };
  }
  function NodeCoordinator$outOfBoundsHit$lambda(this$0, $this_outOfBoundsHit, $hitTestSource, $pointerPosition, $hitTestResult, $pointerType, $isInLayer, $distanceFromEdge, $isHitInMinimumTouchTargetBetter) {
    return function () {
      var tmp = $hitTestSource.kbk();
      // Inline function 'androidx.compose.ui.node.Nodes.Layout' call
      var tmp$ret$0 = _NodeKind___init__impl__ojsprp(2);
      outOfBoundsHit(this$0, nextUntil($this_outOfBoundsHit, tmp, tmp$ret$0), $hitTestSource, $pointerPosition, $hitTestResult, $pointerType, $isInLayer, $distanceFromEdge, $isHitInMinimumTouchTargetBetter);
      return Unit_instance;
    };
  }
  function NodeCoordinator$speculativeHit$lambda(this$0, $this_speculativeHit, $hitTestSource, $pointerPosition, $hitTestResult, $pointerType, $isInLayer, $distanceFromEdge) {
    return function () {
      var tmp = $hitTestSource.kbk();
      // Inline function 'androidx.compose.ui.node.Nodes.Layout' call
      var tmp$ret$0 = _NodeKind___init__impl__ojsprp(2);
      outOfBoundsHit(this$0, nextUntil($this_speculativeHit, tmp, tmp$ret$0), $hitTestSource, $pointerPosition, $hitTestResult, $pointerType, $isInLayer, $distanceFromEdge, false);
      return Unit_instance;
    };
  }
  function NodeCoordinator(layoutNode) {
    Companion_getInstance_58();
    LookaheadCapablePlaceable.call(this);
    this.p94_1 = layoutNode;
    this.q94_1 = false;
    this.r94_1 = false;
    this.s94_1 = null;
    this.t94_1 = null;
    this.u94_1 = false;
    this.v94_1 = false;
    this.w94_1 = null;
    this.x94_1 = this.a9i().w90_1;
    this.y94_1 = this.a9i().x90_1;
    this.z94_1 = 0.8;
    this.a95_1 = null;
    this.b95_1 = null;
    this.c95_1 = Companion_getInstance_11().c5g_1;
    this.d95_1 = 0.0;
    this.e95_1 = null;
    this.f95_1 = null;
    this.g95_1 = get_RectangleShape();
    this.h95_1 = false;
    this.i95_1 = false;
    this.j95_1 = null;
    this.k95_1 = null;
    this.l95_1 = null;
    var tmp = this;
    tmp.m95_1 = NodeCoordinator$invalidateParentLayer$lambda(this);
    this.n95_1 = false;
    this.o95_1 = null;
    this.p95_1 = null;
  }
  protoOf(NodeCoordinator).a9i = function () {
    return this.p94_1;
  };
  protoOf(NodeCoordinator).r6p = function () {
    return this.a9i().x90_1;
  };
  protoOf(NodeCoordinator).u5e = function () {
    return this.a9i().w90_1.u5e();
  };
  protoOf(NodeCoordinator).j5f = function () {
    return this.a9i().w90_1.j5f();
  };
  protoOf(NodeCoordinator).k1a = function () {
    return this.t94_1;
  };
  protoOf(NodeCoordinator).p91 = function () {
    return this;
  };
  protoOf(NodeCoordinator).yb6 = function (type) {
    var tmp2 = _NodeKind___get_mask__impl__1uopb6(type);
    var tmp4 = get_includeSelfInTraversal(type);
    $l$block_0: {
      // Inline function 'androidx.compose.ui.node.NodeCoordinator.visitNodes' call
      var tmp;
      if (tmp4) {
        tmp = this.qb1();
      } else {
        var tmp0_elvis_lhs = this.qb1().q8v_1;
        var tmp_0;
        if (tmp0_elvis_lhs == null) {
          break $l$block_0;
        } else {
          tmp_0 = tmp0_elvis_lhs;
        }
        tmp = tmp_0;
      }
      var stopNode = tmp;
      var node = access$headNode(this, tmp4);
      $l$loop: while (!(node == null)) {
        if ((node.p8v_1 & tmp2) === 0) {
          break $l$block_0;
        }
        if (!((node.o8v_1 & tmp2) === 0)) {
          return node;
        }
        if (node === stopNode)
          break $l$loop;
        node = node.r8v_1;
      }
    }
    return null;
  };
  protoOf(NodeCoordinator).q95 = function () {
    return this.k8y_1;
  };
  protoOf(NodeCoordinator).zb6 = function () {
    if (!(this.o95_1 == null) && this.z94_1 <= 0.0)
      return true;
    var tmp0_safe_receiver = this.t94_1;
    var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.zb6();
    var tmp;
    if (tmp1_elvis_lhs == null) {
      return false;
    } else {
      tmp = tmp1_elvis_lhs;
    }
    return tmp;
  };
  protoOf(NodeCoordinator).xb3 = function () {
    return this.a9i().e91_1.sbc();
  };
  protoOf(NodeCoordinator).eb4 = function () {
    return this.s94_1;
  };
  protoOf(NodeCoordinator).jb4 = function () {
    var explicitLayer = this.p95_1;
    if (!(explicitLayer == null)) {
      this.nah(this.iak(), this.d95_1, explicitLayer);
    } else {
      this.lah(this.iak(), this.d95_1, this.w94_1);
    }
  };
  protoOf(NodeCoordinator).fad = function () {
    return !(this.a95_1 == null);
  };
  protoOf(NodeCoordinator).y91 = function () {
    return this.qb1().z8v_1;
  };
  protoOf(NodeCoordinator).kb6 = function (value) {
    var old = this.a95_1;
    if (!(value === old)) {
      this.a95_1 = value;
      if (old == null || !(value.h5e() === old.h5e()) || !(value.i5e() === old.i5e())) {
        this.ab7(value.h5e(), value.i5e());
      }
      var tmp;
      var tmp_0;
      if (!(this.b95_1 == null) && ensureNotNull(this.b95_1).fv()) {
        tmp_0 = true;
      } else {
        // Inline function 'kotlin.collections.isNotEmpty' call
        tmp_0 = !value.sad().r();
      }
      if (tmp_0) {
        tmp = !compareEquals(this.b95_1, value.sad());
      } else {
        tmp = false;
      }
      if (tmp) {
        this.xb3().sad().nbf();
        var tmp0_elvis_lhs = this.b95_1;
        var tmp_1;
        if (tmp0_elvis_lhs == null) {
          // Inline function 'kotlin.also' call
          var this_0 = mutableObjectIntMapOf();
          this.b95_1 = this_0;
          tmp_1 = this_0;
        } else {
          tmp_1 = tmp0_elvis_lhs;
        }
        var oldLines = tmp_1;
        oldLines.c3();
        // Inline function 'kotlin.collections.forEach' call
        // Inline function 'kotlin.collections.iterator' call
        var _iterator__ex2g4s = value.sad().s1().t();
        while (_iterator__ex2g4s.u()) {
          var element = _iterator__ex2g4s.v();
          oldLines.oz(element.t1(), element.u1());
        }
      }
    }
  };
  protoOf(NodeCoordinator).gag = function () {
    var tmp0_elvis_lhs = this.a95_1;
    var tmp;
    if (tmp0_elvis_lhs == null) {
      // Inline function 'kotlin.error' call
      var message = 'Asking for measurement result of unmeasured layout modifier';
      throw IllegalStateException_init_$Create$(toString(message));
    } else {
      tmp = tmp0_elvis_lhs;
    }
    return tmp;
  };
  protoOf(NodeCoordinator).ab7 = function (width, height) {
    var layer = this.o95_1;
    if (!(layer == null)) {
      // Inline function 'androidx.compose.ui.unit.IntSize' call
      // Inline function 'androidx.compose.ui.util.packInts' call
      var tmp$ret$1 = bitwiseOr(shiftLeft(fromInt(width), 32), bitwiseAnd(fromInt(height), new Long(-1, 0)));
      var tmp$ret$0 = _IntSize___init__impl__emcjft(tmp$ret$1);
      layer.pbk(tmp$ret$0);
    } else {
      if (this.a9i().b9i()) {
        var tmp0_safe_receiver = this.t94_1;
        if (tmp0_safe_receiver == null)
          null;
        else {
          tmp0_safe_receiver.lb2();
        }
      }
    }
    // Inline function 'androidx.compose.ui.unit.IntSize' call
    // Inline function 'androidx.compose.ui.util.packInts' call
    var tmp$ret$3 = bitwiseOr(shiftLeft(fromInt(width), 32), bitwiseAnd(fromInt(height), new Long(-1, 0)));
    var tmp$ret$2 = _IntSize___init__impl__emcjft(tmp$ret$3);
    this.eah(tmp$ret$2);
    if (!(this.w94_1 == null)) {
      updateLayerParameters(this, false);
    }
    // Inline function 'androidx.compose.ui.node.Nodes.Draw' call
    // Inline function 'androidx.compose.ui.node.NodeCoordinator.visitNodes' call
    var type = _NodeKind___init__impl__ojsprp(4);
    var tmp2 = _NodeKind___get_mask__impl__1uopb6(type);
    var tmp4 = get_includeSelfInTraversal(type);
    $l$block_0: {
      // Inline function 'androidx.compose.ui.node.NodeCoordinator.visitNodes' call
      var tmp;
      if (tmp4) {
        tmp = this.qb1();
      } else {
        var tmp0_elvis_lhs = this.qb1().q8v_1;
        var tmp_0;
        if (tmp0_elvis_lhs == null) {
          break $l$block_0;
        } else {
          tmp_0 = tmp0_elvis_lhs;
        }
        tmp = tmp_0;
      }
      var stopNode = tmp;
      var node = access$headNode(this, tmp4);
      $l$loop_0: while (!(node == null)) {
        if ((node.p8v_1 & tmp2) === 0) {
          break $l$block_0;
        }
        if (!((node.o8v_1 & tmp2) === 0)) {
          // Inline function 'androidx.compose.ui.node.dispatchForKind' call
          // Inline function 'androidx.compose.ui.node.dispatchForKind' call
          var stack = null;
          var node_0 = node;
          $l$loop: while (!(node_0 == null)) {
            var tmp_1;
            if (isInterface(node_0, DrawModifierNode)) {
              node_0.v95();
              tmp_1 = false;
            } else {
              tmp_1 = true;
            }
            var dispatchAgain = tmp_1;
            var tmp_2;
            var tmp_3;
            if (dispatchAgain || false) {
              // Inline function 'androidx.compose.ui.Node.isKind' call
              tmp_3 = !((node_0.o8v_1 & _NodeKind___get_mask__impl__1uopb6(type)) === 0);
            } else {
              tmp_3 = false;
            }
            if (tmp_3) {
              tmp_2 = node_0 instanceof DelegatingNode;
            } else {
              tmp_2 = false;
            }
            if (tmp_2) {
              var count = 0;
              // Inline function 'androidx.compose.ui.node.DelegatingNode.forEachImmediateDelegate' call
              var node_1 = node_0.e9a_1;
              while (!(node_1 == null)) {
                var next = node_1;
                // Inline function 'androidx.compose.ui.Node.isKind' call
                if (!((next.o8v_1 & _NodeKind___get_mask__impl__1uopb6(type)) === 0)) {
                  count = count + 1 | 0;
                  if (count === 1) {
                    node_0 = next;
                  } else {
                    var tmp0_elvis_lhs_0 = stack;
                    var tmp_4;
                    if (tmp0_elvis_lhs_0 == null) {
                      // Inline function 'androidx.compose.runtime.collection.mutableVectorOf' call
                      // Inline function 'androidx.compose.runtime.collection.MutableVector' call
                      // Inline function 'kotlin.arrayOfNulls' call
                      var tmp$ret$17 = Array(16);
                      tmp_4 = new MutableVector(tmp$ret$17, 0);
                    } else {
                      tmp_4 = tmp0_elvis_lhs_0;
                    }
                    stack = tmp_4;
                    var theNode = node_0;
                    if (!(theNode == null)) {
                      var tmp1_safe_receiver = stack;
                      if (tmp1_safe_receiver == null)
                        null;
                      else
                        tmp1_safe_receiver.zz(theNode);
                      node_0 = null;
                    }
                    var tmp2_safe_receiver = stack;
                    if (tmp2_safe_receiver == null)
                      null;
                    else
                      tmp2_safe_receiver.zz(next);
                  }
                }
                node_1 = node_1.r8v_1;
              }
              if (count === 1) {
                continue $l$loop;
              }
            }
            node_0 = access$pop$tDelegatableNodeKt(stack);
          }
        }
        if (node === stopNode)
          break $l$loop_0;
        node = node.r8v_1;
      }
    }
    var tmp1_safe_receiver_0 = this.a9i().l90_1;
    if (tmp1_safe_receiver_0 == null)
      null;
    else {
      tmp1_safe_receiver_0.sbk(this.a9i());
    }
    this.a9i().cbe(this);
  };
  protoOf(NodeCoordinator).fb4 = function (_set____db54di) {
    this.c95_1 = _set____db54di;
  };
  protoOf(NodeCoordinator).iak = function () {
    return this.c95_1;
  };
  protoOf(NodeCoordinator).xag = function () {
    var tmp = this.a9i().d91_1;
    // Inline function 'androidx.compose.ui.node.Nodes.ParentData' call
    var tmp$ret$0 = _NodeKind___init__impl__ojsprp(64);
    if (tmp.abb(tmp$ret$0)) {
      var thisNode = this.qb1();
      var data = null;
      // Inline function 'androidx.compose.ui.node.NodeChain.tailToHead' call
      var node = this.a9i().d91_1.i99_1;
      while (!(node == null)) {
        var tmp0 = node;
        $l$block: {
          // Inline function 'androidx.compose.ui.node.Nodes.ParentData' call
          // Inline function 'androidx.compose.ui.Node.isKind' call
          var kind = _NodeKind___init__impl__ojsprp(64);
          if (!((tmp0.o8v_1 & _NodeKind___get_mask__impl__1uopb6(kind)) === 0)) {
            // Inline function 'androidx.compose.ui.node.Nodes.ParentData' call
            // Inline function 'androidx.compose.ui.node.dispatchForKind' call
            // Inline function 'androidx.compose.ui.node.dispatchForKind' call
            var kind_0 = _NodeKind___init__impl__ojsprp(64);
            var stack = null;
            var node_0 = tmp0;
            $l$loop: while (!(node_0 == null)) {
              var tmp_0;
              if (isInterface(node_0, ParentDataModifierNode)) {
                // Inline function 'kotlin.with' call
                data = node_0.aaj(this.a9i().w90_1, data);
                tmp_0 = false;
              } else {
                tmp_0 = true;
              }
              var dispatchAgain = tmp_0;
              var tmp_1;
              var tmp_2;
              if (dispatchAgain || false) {
                // Inline function 'androidx.compose.ui.Node.isKind' call
                tmp_2 = !((node_0.o8v_1 & _NodeKind___get_mask__impl__1uopb6(kind_0)) === 0);
              } else {
                tmp_2 = false;
              }
              if (tmp_2) {
                tmp_1 = node_0 instanceof DelegatingNode;
              } else {
                tmp_1 = false;
              }
              if (tmp_1) {
                var count = 0;
                // Inline function 'androidx.compose.ui.node.DelegatingNode.forEachImmediateDelegate' call
                var node_1 = node_0.e9a_1;
                while (!(node_1 == null)) {
                  var next = node_1;
                  // Inline function 'androidx.compose.ui.Node.isKind' call
                  if (!((next.o8v_1 & _NodeKind___get_mask__impl__1uopb6(kind_0)) === 0)) {
                    count = count + 1 | 0;
                    if (count === 1) {
                      node_0 = next;
                    } else {
                      var tmp0_elvis_lhs = stack;
                      var tmp_3;
                      if (tmp0_elvis_lhs == null) {
                        // Inline function 'androidx.compose.runtime.collection.mutableVectorOf' call
                        // Inline function 'androidx.compose.runtime.collection.MutableVector' call
                        // Inline function 'kotlin.arrayOfNulls' call
                        var tmp$ret$17 = Array(16);
                        tmp_3 = new MutableVector(tmp$ret$17, 0);
                      } else {
                        tmp_3 = tmp0_elvis_lhs;
                      }
                      stack = tmp_3;
                      var theNode = node_0;
                      if (!(theNode == null)) {
                        var tmp1_safe_receiver = stack;
                        if (tmp1_safe_receiver == null)
                          null;
                        else
                          tmp1_safe_receiver.zz(theNode);
                        node_0 = null;
                      }
                      var tmp2_safe_receiver = stack;
                      if (tmp2_safe_receiver == null)
                        null;
                      else
                        tmp2_safe_receiver.zz(next);
                    }
                  }
                  node_1 = node_1.r8v_1;
                }
                if (count === 1) {
                  continue $l$loop;
                }
              }
              node_0 = access$pop$tDelegatableNodeKt(stack);
            }
          }
          if (tmp0 === thisNode) {
            break $l$block;
          }
        }
        node = node.q8v_1;
      }
      return data;
    }
    return null;
  };
  protoOf(NodeCoordinator).jak = function () {
    this.a9i().e91_1.ubg();
  };
  protoOf(NodeCoordinator).yah = function () {
    // Inline function 'androidx.compose.ui.internal.checkPrecondition' call
    if (!this.y91()) {
      var builder = new StringBuilder('LayoutCoordinate operations are only valid when isAttached is true');
      var node = this.a9i();
      while (!(node == null)) {
        // Inline function 'kotlin.text.appendLine' call
        builder.s(_Char___init__impl__6a9atx(10));
        builder.q('|');
        builder.w(node);
        builder.q(' isAttached=');
        builder.dd(node.y91());
        builder.q(' modifier=');
        builder.w(node.j9d());
        builder.q(' tail=');
        builder.w(this.qb1());
        node = node.f9a();
      }
      var tmp$ret$1 = builder.toString();
      throwIllegalStateException(tmp$ret$1);
    }
    this.jak();
    return this.a9i().hak().t94_1;
  };
  protoOf(NodeCoordinator).zah = function () {
    // Inline function 'androidx.compose.ui.internal.checkPrecondition' call
    if (!this.y91()) {
      var tmp$ret$1 = 'LayoutCoordinate operations are only valid when isAttached is true';
      throwIllegalStateException(tmp$ret$1);
    }
    this.jak();
    return this.t94_1;
  };
  protoOf(NodeCoordinator).bb7 = function () {
    var tmp0_elvis_lhs = this.e95_1;
    var tmp;
    if (tmp0_elvis_lhs == null) {
      // Inline function 'kotlin.also' call
      var this_0 = new MutableRect(0.0, 0.0, 0.0, 0.0);
      this.e95_1 = this_0;
      tmp = this_0;
    } else {
      tmp = tmp0_elvis_lhs;
    }
    return tmp;
  };
  protoOf(NodeCoordinator).lb6 = function () {
    // Inline function 'androidx.compose.ui.node.Nodes.OnRemeasured' call
    var tmp$ret$0 = _NodeKind___init__impl__ojsprp(128);
    if (hasNode(this, tmp$ret$0)) {
      $l$block_1: {
        // Inline function 'androidx.compose.runtime.snapshots.Companion.withoutReadObservation' call
        var previousSnapshot = Companion_instance.p52();
        var observer = previousSnapshot == null ? null : previousSnapshot.t3e();
        var newSnapshot = Companion_instance.q52(previousSnapshot);
        try {
          // Inline function 'androidx.compose.ui.node.Nodes.OnRemeasured' call
          // Inline function 'androidx.compose.ui.node.NodeCoordinator.visitNodes' call
          var type = _NodeKind___init__impl__ojsprp(128);
          var tmp2 = _NodeKind___get_mask__impl__1uopb6(type);
          var tmp4 = get_includeSelfInTraversal(type);
          $l$block_0: {
            // Inline function 'androidx.compose.ui.node.NodeCoordinator.visitNodes' call
            var tmp;
            if (tmp4) {
              tmp = this.qb1();
            } else {
              var tmp0_elvis_lhs = this.qb1().q8v_1;
              var tmp_0;
              if (tmp0_elvis_lhs == null) {
                break $l$block_0;
              } else {
                tmp_0 = tmp0_elvis_lhs;
              }
              tmp = tmp_0;
            }
            var stopNode = tmp;
            var node = access$headNode(this, tmp4);
            $l$loop_0: while (!(node == null)) {
              if ((node.p8v_1 & tmp2) === 0) {
                break $l$block_0;
              }
              if (!((node.o8v_1 & tmp2) === 0)) {
                // Inline function 'androidx.compose.ui.node.dispatchForKind' call
                // Inline function 'androidx.compose.ui.node.dispatchForKind' call
                var stack = null;
                var node_0 = node;
                $l$loop: while (!(node_0 == null)) {
                  var tmp_1;
                  if (isInterface(node_0, MeasuredSizeAwareModifierNode)) {
                    node_0.u91(this.k8y_1);
                    tmp_1 = false;
                  } else {
                    tmp_1 = true;
                  }
                  var dispatchAgain = tmp_1;
                  var tmp_2;
                  var tmp_3;
                  if (dispatchAgain || false) {
                    // Inline function 'androidx.compose.ui.Node.isKind' call
                    tmp_3 = !((node_0.o8v_1 & _NodeKind___get_mask__impl__1uopb6(type)) === 0);
                  } else {
                    tmp_3 = false;
                  }
                  if (tmp_3) {
                    tmp_2 = node_0 instanceof DelegatingNode;
                  } else {
                    tmp_2 = false;
                  }
                  if (tmp_2) {
                    var count = 0;
                    // Inline function 'androidx.compose.ui.node.DelegatingNode.forEachImmediateDelegate' call
                    var node_1 = node_0.e9a_1;
                    while (!(node_1 == null)) {
                      var next = node_1;
                      // Inline function 'androidx.compose.ui.Node.isKind' call
                      if (!((next.o8v_1 & _NodeKind___get_mask__impl__1uopb6(type)) === 0)) {
                        count = count + 1 | 0;
                        if (count === 1) {
                          node_0 = next;
                        } else {
                          var tmp0_elvis_lhs_0 = stack;
                          var tmp_4;
                          if (tmp0_elvis_lhs_0 == null) {
                            // Inline function 'androidx.compose.runtime.collection.mutableVectorOf' call
                            // Inline function 'androidx.compose.runtime.collection.MutableVector' call
                            // Inline function 'kotlin.arrayOfNulls' call
                            var tmp$ret$16 = Array(16);
                            tmp_4 = new MutableVector(tmp$ret$16, 0);
                          } else {
                            tmp_4 = tmp0_elvis_lhs_0;
                          }
                          stack = tmp_4;
                          var theNode = node_0;
                          if (!(theNode == null)) {
                            var tmp1_safe_receiver = stack;
                            if (tmp1_safe_receiver == null)
                              null;
                            else
                              tmp1_safe_receiver.zz(theNode);
                            node_0 = null;
                          }
                          var tmp2_safe_receiver = stack;
                          if (tmp2_safe_receiver == null)
                            null;
                          else
                            tmp2_safe_receiver.zz(next);
                        }
                      }
                      node_1 = node_1.r8v_1;
                    }
                    if (count === 1) {
                      continue $l$loop;
                    }
                  }
                  node_0 = access$pop$tDelegatableNodeKt(stack);
                }
              }
              if (node === stopNode)
                break $l$loop_0;
              node = node.r8v_1;
            }
          }
          break $l$block_1;
        }finally {
          Companion_instance.c53(previousSnapshot, newSnapshot, observer);
        }
      }
    }
  };
  protoOf(NodeCoordinator).cb7 = function () {
    // Inline function 'androidx.compose.ui.node.Nodes.Unplaced' call
    var tmp$ret$0 = _NodeKind___init__impl__ojsprp(1048576);
    if (hasNode(this, tmp$ret$0)) {
      // Inline function 'androidx.compose.ui.node.Nodes.Unplaced' call
      // Inline function 'androidx.compose.ui.node.NodeCoordinator.visitNodes' call
      var type = _NodeKind___init__impl__ojsprp(1048576);
      var tmp2 = _NodeKind___get_mask__impl__1uopb6(type);
      var tmp4 = get_includeSelfInTraversal(type);
      $l$block_0: {
        // Inline function 'androidx.compose.ui.node.NodeCoordinator.visitNodes' call
        var tmp;
        if (tmp4) {
          tmp = this.qb1();
        } else {
          var tmp0_elvis_lhs = this.qb1().q8v_1;
          var tmp_0;
          if (tmp0_elvis_lhs == null) {
            break $l$block_0;
          } else {
            tmp_0 = tmp0_elvis_lhs;
          }
          tmp = tmp_0;
        }
        var stopNode = tmp;
        var node = access$headNode(this, tmp4);
        $l$loop_0: while (!(node == null)) {
          if ((node.p8v_1 & tmp2) === 0) {
            break $l$block_0;
          }
          if (!((node.o8v_1 & tmp2) === 0)) {
            // Inline function 'androidx.compose.ui.node.dispatchForKind' call
            // Inline function 'androidx.compose.ui.node.dispatchForKind' call
            var stack = null;
            var node_0 = node;
            $l$loop: while (!(node_0 == null)) {
              var tmp_1;
              if (isInterface(node_0, UnplacedAwareModifierNode)) {
                node_0.cb7();
                tmp_1 = false;
              } else {
                tmp_1 = true;
              }
              var dispatchAgain = tmp_1;
              var tmp_2;
              var tmp_3;
              if (dispatchAgain || false) {
                // Inline function 'androidx.compose.ui.Node.isKind' call
                tmp_3 = !((node_0.o8v_1 & _NodeKind___get_mask__impl__1uopb6(type)) === 0);
              } else {
                tmp_3 = false;
              }
              if (tmp_3) {
                tmp_2 = node_0 instanceof DelegatingNode;
              } else {
                tmp_2 = false;
              }
              if (tmp_2) {
                var count = 0;
                // Inline function 'androidx.compose.ui.node.DelegatingNode.forEachImmediateDelegate' call
                var node_1 = node_0.e9a_1;
                while (!(node_1 == null)) {
                  var next = node_1;
                  // Inline function 'androidx.compose.ui.Node.isKind' call
                  if (!((next.o8v_1 & _NodeKind___get_mask__impl__1uopb6(type)) === 0)) {
                    count = count + 1 | 0;
                    if (count === 1) {
                      node_0 = next;
                    } else {
                      var tmp0_elvis_lhs_0 = stack;
                      var tmp_4;
                      if (tmp0_elvis_lhs_0 == null) {
                        // Inline function 'androidx.compose.runtime.collection.mutableVectorOf' call
                        // Inline function 'androidx.compose.runtime.collection.MutableVector' call
                        // Inline function 'kotlin.arrayOfNulls' call
                        var tmp$ret$14 = Array(16);
                        tmp_4 = new MutableVector(tmp$ret$14, 0);
                      } else {
                        tmp_4 = tmp0_elvis_lhs_0;
                      }
                      stack = tmp_4;
                      var theNode = node_0;
                      if (!(theNode == null)) {
                        var tmp1_safe_receiver = stack;
                        if (tmp1_safe_receiver == null)
                          null;
                        else
                          tmp1_safe_receiver.zz(theNode);
                        node_0 = null;
                      }
                      var tmp2_safe_receiver = stack;
                      if (tmp2_safe_receiver == null)
                        null;
                      else
                        tmp2_safe_receiver.zz(next);
                    }
                  }
                  node_1 = node_1.r8v_1;
                }
                if (count === 1) {
                  continue $l$loop;
                }
              }
              node_0 = access$pop$tDelegatableNodeKt(stack);
            }
          }
          if (node === stopNode)
            break $l$loop_0;
          node = node.r8v_1;
        }
      }
    }
  };
  protoOf(NodeCoordinator).lah = function (position, zIndex, layerBlock) {
    if (this.q94_1) {
      placeSelf_2(this, ensureNotNull(this.kac()).iak(), zIndex, layerBlock, null);
    } else {
      placeSelf_2(this, position, zIndex, layerBlock, null);
    }
  };
  protoOf(NodeCoordinator).nah = function (position, zIndex, layer) {
    if (this.q94_1) {
      placeSelf_2(this, ensureNotNull(this.kac()).iak(), zIndex, null, layer);
    } else {
      placeSelf_2(this, position, zIndex, null, layer);
    }
  };
  protoOf(NodeCoordinator).db7 = function () {
    if (!(this.o95_1 == null)) {
      if (!(this.p95_1 == null)) {
        this.p95_1 = null;
      }
      this.ib7(null);
      this.a9i().fb8();
    }
  };
  protoOf(NodeCoordinator).eb7 = function (position, zIndex, layerBlock, layer) {
    placeSelf_2(this, IntOffset__plus_impl_nqoa9b(position, this.m8y_1), zIndex, layerBlock, layer);
  };
  protoOf(NodeCoordinator).fb7 = function (canvas, graphicsLayer) {
    var layer = this.o95_1;
    if (!(layer == null)) {
      layer.ibl(canvas, graphicsLayer);
    } else {
      var x = _IntOffset___get_x__impl__qiqr5o(this.iak());
      var y = _IntOffset___get_y__impl__2avpwj(this.iak());
      canvas.b5d(x, y);
      drawContainedDrawModifiers(this, canvas, graphicsLayer);
      canvas.b5d(-x, -y);
    }
  };
  protoOf(NodeCoordinator).mb6 = function (canvas, graphicsLayer) {
    var tmp0_safe_receiver = this.s94_1;
    if (tmp0_safe_receiver == null)
      null;
    else {
      tmp0_safe_receiver.fb7(canvas, graphicsLayer);
    }
  };
  protoOf(NodeCoordinator).gb7 = function () {
    // Inline function 'androidx.compose.ui.node.Nodes.OnPlaced' call
    // Inline function 'androidx.compose.ui.node.NodeCoordinator.visitNodes' call
    var type = _NodeKind___init__impl__ojsprp(4194304);
    var tmp2 = _NodeKind___get_mask__impl__1uopb6(type);
    var tmp4 = get_includeSelfInTraversal(type);
    $l$block_0: {
      // Inline function 'androidx.compose.ui.node.NodeCoordinator.visitNodes' call
      var tmp;
      if (tmp4) {
        tmp = this.qb1();
      } else {
        var tmp0_elvis_lhs = this.qb1().q8v_1;
        var tmp_0;
        if (tmp0_elvis_lhs == null) {
          break $l$block_0;
        } else {
          tmp_0 = tmp0_elvis_lhs;
        }
        tmp = tmp_0;
      }
      var stopNode = tmp;
      var node = access$headNode(this, tmp4);
      $l$loop_0: while (!(node == null)) {
        if ((node.p8v_1 & tmp2) === 0) {
          break $l$block_0;
        }
        if (!((node.o8v_1 & tmp2) === 0)) {
          // Inline function 'androidx.compose.ui.node.dispatchForKind' call
          // Inline function 'androidx.compose.ui.node.dispatchForKind' call
          var stack = null;
          var node_0 = node;
          $l$loop: while (!(node_0 == null)) {
            var tmp_1;
            if (isInterface(node_0, LayoutAwareModifierNode)) {
              node_0.x91(this);
              tmp_1 = false;
            } else {
              tmp_1 = true;
            }
            var dispatchAgain = tmp_1;
            var tmp_2;
            var tmp_3;
            if (dispatchAgain || false) {
              // Inline function 'androidx.compose.ui.Node.isKind' call
              tmp_3 = !((node_0.o8v_1 & _NodeKind___get_mask__impl__1uopb6(type)) === 0);
            } else {
              tmp_3 = false;
            }
            if (tmp_3) {
              tmp_2 = node_0 instanceof DelegatingNode;
            } else {
              tmp_2 = false;
            }
            if (tmp_2) {
              var count = 0;
              // Inline function 'androidx.compose.ui.node.DelegatingNode.forEachImmediateDelegate' call
              var node_1 = node_0.e9a_1;
              while (!(node_1 == null)) {
                var next = node_1;
                // Inline function 'androidx.compose.ui.Node.isKind' call
                if (!((next.o8v_1 & _NodeKind___get_mask__impl__1uopb6(type)) === 0)) {
                  count = count + 1 | 0;
                  if (count === 1) {
                    node_0 = next;
                  } else {
                    var tmp0_elvis_lhs_0 = stack;
                    var tmp_4;
                    if (tmp0_elvis_lhs_0 == null) {
                      // Inline function 'androidx.compose.runtime.collection.mutableVectorOf' call
                      // Inline function 'androidx.compose.runtime.collection.MutableVector' call
                      // Inline function 'kotlin.arrayOfNulls' call
                      var tmp$ret$13 = Array(16);
                      tmp_4 = new MutableVector(tmp$ret$13, 0);
                    } else {
                      tmp_4 = tmp0_elvis_lhs_0;
                    }
                    stack = tmp_4;
                    var theNode = node_0;
                    if (!(theNode == null)) {
                      var tmp1_safe_receiver = stack;
                      if (tmp1_safe_receiver == null)
                        null;
                      else
                        tmp1_safe_receiver.zz(theNode);
                      node_0 = null;
                    }
                    var tmp2_safe_receiver = stack;
                    if (tmp2_safe_receiver == null)
                      null;
                    else
                      tmp2_safe_receiver.zz(next);
                  }
                }
                node_1 = node_1.r8v_1;
              }
              if (count === 1) {
                continue $l$loop;
              }
            }
            node_0 = access$pop$tDelegatableNodeKt(stack);
          }
        }
        if (node === stopNode)
          break $l$loop_0;
        node = node.r8v_1;
      }
    }
  };
  protoOf(NodeCoordinator).hb7 = function (layerBlock, forceUpdateLayerParameters) {
    // Inline function 'androidx.compose.ui.internal.requirePrecondition' call
    if (!(layerBlock == null || this.p95_1 == null)) {
      var tmp$ret$1 = "layerBlock can't be provided when explicitLayer is provided";
      throwIllegalArgumentException(tmp$ret$1);
    }
    var layoutNode = this.a9i();
    var updateParameters = forceUpdateLayerParameters || !(this.w94_1 === layerBlock) || !equals(this.x94_1, layoutNode.w90_1) || !this.y94_1.equals(layoutNode.x90_1);
    this.x94_1 = layoutNode.w90_1;
    this.y94_1 = layoutNode.x90_1;
    if (layoutNode.y91() && !(layerBlock == null)) {
      this.w94_1 = layerBlock;
      if (this.o95_1 == null) {
        var tmp = this;
        // Inline function 'kotlin.apply' call
        var this_0 = requireOwner_0(layoutNode).lbl(_get_drawBlock__v9gcvs(this), this.m95_1);
        this_0.pbk(this.k8y_1);
        this_0.qbk(this.iak());
        tmp.o95_1 = this_0;
        updateLayerParameters(this);
        layoutNode.h91_1 = true;
        this.m95_1();
      } else if (updateParameters) {
        updateLayerParameters(this);
      }
    } else {
      this.w94_1 = null;
      var tmp0_safe_receiver = this.o95_1;
      if (tmp0_safe_receiver == null)
        null;
      else {
        // Inline function 'kotlin.let' call
        if (!isIdentity(tmp0_safe_receiver.jbl())) {
          layoutNode.cbe(this);
        }
        tmp0_safe_receiver.kbl();
        this.o95_1 = null;
        layoutNode.h91_1 = true;
        this.m95_1();
        if (this.y91() && layoutNode.b9i()) {
          var tmp0_safe_receiver_0 = layoutNode.l90_1;
          if (tmp0_safe_receiver_0 == null)
            null;
          else {
            tmp0_safe_receiver_0.sbk(layoutNode);
          }
        }
      }
      this.n95_1 = false;
    }
  };
  protoOf(NodeCoordinator).ib7 = function (layerBlock, forceUpdateLayerParameters, $super) {
    forceUpdateLayerParameters = forceUpdateLayerParameters === VOID ? false : forceUpdateLayerParameters;
    var tmp;
    if ($super === VOID) {
      this.hb7(layerBlock, forceUpdateLayerParameters);
      tmp = Unit_instance;
    } else {
      tmp = $super.hb7.call(this, layerBlock, forceUpdateLayerParameters);
    }
    return tmp;
  };
  protoOf(NodeCoordinator).kb0 = function () {
    return !(this.o95_1 == null) && !this.u94_1 && this.a9i().y91();
  };
  protoOf(NodeCoordinator).rb6 = function () {
    // Inline function 'kotlin.with' call
    return this.x94_1.f5f(this.a9i().y90_1.eab());
  };
  protoOf(NodeCoordinator).jb7 = function (hitTestSource, pointerPosition, hitTestResult, pointerType, isInLayer) {
    var head = this.yb6(hitTestSource.kbk());
    if (!this.tb6(pointerPosition)) {
      if (pointerType === Companion_getInstance_42().ma2_1) {
        var distanceFromEdge = this.sb6(pointerPosition, this.rb6());
        var tmp;
        // Inline function 'androidx.compose.ui.util.fastIsFinite' call
        if ((toRawBits(distanceFromEdge) & 2147483647) < 2139095040) {
          tmp = hitTestResult.yb2(distanceFromEdge, false);
        } else {
          tmp = false;
        }
        if (tmp) {
          hitNear(this, head, hitTestSource, pointerPosition, hitTestResult, pointerType, false, distanceFromEdge);
        }
      }
    } else if (head == null) {
      this.qb6(hitTestSource, pointerPosition, hitTestResult, pointerType, isInLayer);
    } else if (this.rb7(pointerPosition)) {
      hit(this, head, hitTestSource, pointerPosition, hitTestResult, pointerType, isInLayer);
    } else {
      var tmp_0;
      if (!(pointerType === Companion_getInstance_42().ma2_1)) {
        tmp_0 = Infinity;
      } else {
        tmp_0 = this.sb6(pointerPosition, this.rb6());
      }
      var distanceFromEdge_0 = tmp_0;
      var tmp_1;
      // Inline function 'androidx.compose.ui.util.fastIsFinite' call
      if ((toRawBits(distanceFromEdge_0) & 2147483647) < 2139095040) {
        tmp_1 = hitTestResult.yb2(distanceFromEdge_0, isInLayer);
      } else {
        tmp_1 = false;
      }
      var isHitInMinimumTouchTargetBetter = tmp_1;
      outOfBoundsHit(this, head, hitTestSource, pointerPosition, hitTestResult, pointerType, isInLayer, distanceFromEdge_0, isHitInMinimumTouchTargetBetter);
    }
  };
  protoOf(NodeCoordinator).qb6 = function (hitTestSource, pointerPosition, hitTestResult, pointerType, isInLayer) {
    var wrapped = this.s94_1;
    if (!(wrapped == null)) {
      var positionInWrapped = wrapped.nb7(pointerPosition);
      wrapped.jb7(hitTestSource, positionInWrapped, hitTestResult, pointerType, isInLayer);
    }
  };
  protoOf(NodeCoordinator).aai = function (relativeToLocal) {
    // Inline function 'androidx.compose.ui.internal.checkPrecondition' call
    if (!this.y91()) {
      var tmp$ret$1 = 'LayoutCoordinate operations are only valid when isAttached is true';
      throwIllegalStateException(tmp$ret$1);
    }
    var positionInRoot = this.dai(relativeToLocal);
    var owner = requireOwner_0(this.a9i());
    return owner.aai(positionInRoot);
  };
  protoOf(NodeCoordinator).bai = function (relativeToWindow) {
    // Inline function 'androidx.compose.ui.internal.checkPrecondition' call
    if (!this.y91()) {
      var tmp$ret$1 = 'LayoutCoordinate operations are only valid when isAttached is true';
      throwIllegalStateException(tmp$ret$1);
    }
    var root = findRootCoordinates(this);
    var positionInRoot_0 = Offset__minus_impl_hoj2c0(requireOwner_0(this.a9i()).mbl(relativeToWindow), positionInRoot(root));
    return this.q91(root, positionInRoot_0);
  };
  protoOf(NodeCoordinator).cai = function (relativeToLocal) {
    var positionInRoot = this.dai(relativeToLocal);
    var owner = requireOwner_0(this.a9i());
    return owner.nbl(positionInRoot);
  };
  protoOf(NodeCoordinator).q91 = function (sourceCoordinates, relativeToSource) {
    return this.eai(sourceCoordinates, relativeToSource, true);
  };
  protoOf(NodeCoordinator).eai = function (sourceCoordinates, relativeToSource, includeMotionFrameOfReference) {
    if (sourceCoordinates instanceof LookaheadLayoutCoordinates) {
      sourceCoordinates.gak().jak();
      // Inline function 'androidx.compose.ui.geometry.Offset.unaryMinus' call
      var tmp$ret$0 = _Offset___init__impl__c168vi(bitwiseXor(_Offset___get_packedValue__impl__xh2k8q(relativeToSource), new Long(-2147483648, -2147483648)));
      // Inline function 'androidx.compose.ui.geometry.Offset.unaryMinus' call
      var this_0 = sourceCoordinates.eai(this, tmp$ret$0, includeMotionFrameOfReference);
      return _Offset___init__impl__c168vi(bitwiseXor(_Offset___get_packedValue__impl__xh2k8q(this_0), new Long(-2147483648, -2147483648)));
    }
    var nodeCoordinator = toCoordinator(this, sourceCoordinates);
    nodeCoordinator.jak();
    var commonAncestor = this.kak(nodeCoordinator);
    var position = relativeToSource;
    var coordinator = nodeCoordinator;
    while (!(coordinator === commonAncestor)) {
      position = coordinator.kb7(position, includeMotionFrameOfReference);
      coordinator = ensureNotNull(coordinator.t94_1);
    }
    return ancestorToLocal(this, commonAncestor, position, includeMotionFrameOfReference);
  };
  protoOf(NodeCoordinator).gai = function (sourceCoordinates, matrix) {
    var coordinator = toCoordinator(this, sourceCoordinates);
    coordinator.jak();
    var commonAncestor = this.kak(coordinator);
    Matrix__reset_impl_4l49i7(matrix);
    transformToAncestor(coordinator, commonAncestor, matrix);
    transformFromAncestor(this, commonAncestor, matrix);
  };
  protoOf(NodeCoordinator).x9h = function (sourceCoordinates, clipBounds) {
    // Inline function 'androidx.compose.ui.internal.checkPrecondition' call
    if (!this.y91()) {
      var tmp$ret$1 = 'LayoutCoordinate operations are only valid when isAttached is true';
      throwIllegalStateException(tmp$ret$1);
    }
    // Inline function 'androidx.compose.ui.internal.checkPrecondition' call
    if (!sourceCoordinates.y91()) {
      var tmp$ret$3 = 'LayoutCoordinates ' + toString(sourceCoordinates) + ' is not attached!';
      throwIllegalStateException(tmp$ret$3);
    }
    var srcCoordinator = toCoordinator(this, sourceCoordinates);
    srcCoordinator.jak();
    var commonAncestor = this.kak(srcCoordinator);
    var bounds = this.bb7();
    bounds.w5c_1 = 0.0;
    bounds.x5c_1 = 0.0;
    var tmp = bounds;
    // Inline function 'androidx.compose.ui.unit.IntSize.width' call
    var this_0 = sourceCoordinates.q95();
    // Inline function 'androidx.compose.ui.util.unpackInt1' call
    var value = _IntSize___get_packedValue__impl__uho7jf(this_0);
    tmp.y5c_1 = convertToInt(shiftRight(value, 32));
    var tmp_0 = bounds;
    // Inline function 'androidx.compose.ui.unit.IntSize.height' call
    var this_1 = sourceCoordinates.q95();
    // Inline function 'androidx.compose.ui.util.unpackInt2' call
    var value_0 = _IntSize___get_packedValue__impl__uho7jf(this_1);
    tmp_0.z5c_1 = convertToInt(bitwiseAnd(value_0, new Long(-1, 0)));
    var coordinator = srcCoordinator;
    while (!(coordinator === commonAncestor)) {
      coordinator.qb7(bounds, clipBounds);
      if (bounds.oy()) {
        return Companion_getInstance_2().j5d_1;
      }
      coordinator = ensureNotNull(coordinator.t94_1);
    }
    ancestorToLocal_0(this, commonAncestor, bounds, clipBounds);
    return toRect_0(bounds);
  };
  protoOf(NodeCoordinator).dai = function (relativeToLocal) {
    // Inline function 'androidx.compose.ui.internal.checkPrecondition' call
    if (!this.y91()) {
      var tmp$ret$1 = 'LayoutCoordinate operations are only valid when isAttached is true';
      throwIllegalStateException(tmp$ret$1);
    }
    this.jak();
    var coordinator = this;
    var position = relativeToLocal;
    while (!(coordinator == null)) {
      var layoutNode = coordinator.a9i();
      if (coordinator === layoutNode.hak() && !layoutNode.y8z_1) {
        var offsetFromRectList = requireOwner_0(layoutNode).xam().obl(layoutNode);
        if (!equals(offsetFromRectList, Companion_getInstance_11().d5g_1)) {
          return plus(position, offsetFromRectList);
        }
      }
      position = coordinator.lb7(position);
      coordinator = coordinator.t94_1;
    }
    return position;
  };
  protoOf(NodeCoordinator).kb7 = function (position, includeMotionFrameOfReference) {
    var layer = this.o95_1;
    var tmp1_elvis_lhs = layer == null ? null : layer.pbl(position, false);
    var tmp;
    var tmp_0 = tmp1_elvis_lhs;
    if ((tmp_0 == null ? null : new Offset(tmp_0)) == null) {
      tmp = position;
    } else {
      tmp = tmp1_elvis_lhs;
    }
    var targetPosition = tmp;
    var tmp_1;
    if (!includeMotionFrameOfReference && this.mb4()) {
      tmp_1 = targetPosition;
    } else {
      tmp_1 = plus(targetPosition, this.iak());
    }
    return tmp_1;
  };
  protoOf(NodeCoordinator).lb7 = function (position, includeMotionFrameOfReference, $super) {
    includeMotionFrameOfReference = includeMotionFrameOfReference === VOID ? true : includeMotionFrameOfReference;
    return $super === VOID ? this.kb7(position, includeMotionFrameOfReference) : $super.kb7.call(this, new Offset(position), includeMotionFrameOfReference).e5d_1;
  };
  protoOf(NodeCoordinator).mb7 = function (position, includeMotionFrameOfReference) {
    var tmp;
    if (!includeMotionFrameOfReference && this.mb4()) {
      tmp = position;
    } else {
      tmp = minus(position, this.iak());
    }
    var relativeToPosition = tmp;
    var layer = this.o95_1;
    var tmp1_elvis_lhs = layer == null ? null : layer.pbl(relativeToPosition, true);
    var tmp_0;
    var tmp_1 = tmp1_elvis_lhs;
    if ((tmp_1 == null ? null : new Offset(tmp_1)) == null) {
      tmp_0 = relativeToPosition;
    } else {
      tmp_0 = tmp1_elvis_lhs;
    }
    return tmp_0;
  };
  protoOf(NodeCoordinator).nb7 = function (position, includeMotionFrameOfReference, $super) {
    includeMotionFrameOfReference = includeMotionFrameOfReference === VOID ? true : includeMotionFrameOfReference;
    return $super === VOID ? this.mb7(position, includeMotionFrameOfReference) : $super.mb7.call(this, new Offset(position), includeMotionFrameOfReference).e5d_1;
  };
  protoOf(NodeCoordinator).ob6 = function (canvas, paint) {
    // Inline function 'androidx.compose.ui.unit.IntSize.width' call
    var this_0 = this.k8y_1;
    // Inline function 'androidx.compose.ui.util.unpackInt1' call
    var value = _IntSize___get_packedValue__impl__uho7jf(this_0);
    var tmp = convertToInt(shiftRight(value, 32)) - 0.5;
    // Inline function 'androidx.compose.ui.unit.IntSize.height' call
    var this_1 = this.k8y_1;
    // Inline function 'androidx.compose.ui.util.unpackInt2' call
    var value_0 = _IntSize___get_packedValue__impl__uho7jf(this_1);
    var tmp$ret$2 = convertToInt(bitwiseAnd(value_0, new Long(-1, 0)));
    canvas.i6e(0.5, 0.5, tmp, tmp$ret$2 - 0.5, paint);
  };
  protoOf(NodeCoordinator).ob7 = function () {
    this.db7();
    if (this.a9i().b9i()) {
      this.cb7();
    }
  };
  protoOf(NodeCoordinator).d30 = function () {
    this.u94_1 = true;
    this.m95_1();
    this.db7();
    if (!equals(this.iak(), Companion_getInstance_11().c5g_1)) {
      this.a9i().cbe(this);
    }
  };
  protoOf(NodeCoordinator).pb7 = function (bounds, clipBounds, clipToMinimumTouchTargetSize) {
    var layer = this.o95_1;
    if (!(layer == null)) {
      if (this.v94_1) {
        if (clipToMinimumTouchTargetSize) {
          var minTouch = this.rb6();
          var _destruct__k2r9zo = this.tb7(bounds, minTouch);
          // Inline function 'androidx.compose.ui.geometry.Offset.component1' call
          // Inline function 'androidx.compose.ui.geometry.Offset.x' call
          // Inline function 'androidx.compose.ui.util.unpackFloat1' call
          var value = _Offset___get_packedValue__impl__xh2k8q(_destruct__k2r9zo);
          // Inline function 'androidx.compose.ui.util.floatFromBits' call
          // Inline function 'kotlin.fromBits' call
          var bits = convertToInt(shiftRight(value, 32));
          var left = floatFromBits(bits);
          // Inline function 'androidx.compose.ui.geometry.Offset.component2' call
          // Inline function 'androidx.compose.ui.geometry.Offset.y' call
          // Inline function 'androidx.compose.ui.util.unpackFloat2' call
          var value_0 = _Offset___get_packedValue__impl__xh2k8q(_destruct__k2r9zo);
          // Inline function 'androidx.compose.ui.util.floatFromBits' call
          // Inline function 'kotlin.fromBits' call
          var bits_0 = convertToInt(bitwiseAnd(value_0, new Long(-1, 0)));
          var top = floatFromBits(bits_0);
          var _destruct__k2r9zo_0 = this.q95();
          // Inline function 'androidx.compose.ui.unit.IntSize.component1' call
          // Inline function 'androidx.compose.ui.unit.IntSize.width' call
          // Inline function 'androidx.compose.ui.util.unpackInt1' call
          var value_1 = _IntSize___get_packedValue__impl__uho7jf(_destruct__k2r9zo_0);
          var width = convertToInt(shiftRight(value_1, 32));
          // Inline function 'androidx.compose.ui.unit.IntSize.component2' call
          // Inline function 'androidx.compose.ui.unit.IntSize.height' call
          // Inline function 'androidx.compose.ui.util.unpackInt2' call
          var value_2 = _IntSize___get_packedValue__impl__uho7jf(_destruct__k2r9zo_0);
          var height = convertToInt(bitwiseAnd(value_2, new Long(-1, 0)));
          // Inline function 'androidx.compose.ui.geometry.Size.width' call
          // Inline function 'androidx.compose.ui.util.unpackFloat1' call
          var value_3 = _Size___get_packedValue__impl__7rlt1o(minTouch);
          // Inline function 'androidx.compose.ui.util.floatFromBits' call
          // Inline function 'kotlin.fromBits' call
          var bits_1 = convertToInt(shiftRight(value_3, 32));
          var tmp0 = width + floatFromBits(bits_1);
          // Inline function 'androidx.compose.ui.geometry.Size.width' call
          // Inline function 'androidx.compose.ui.util.unpackFloat1' call
          var value_4 = _Size___get_packedValue__impl__7rlt1o(minTouch);
          // Inline function 'androidx.compose.ui.util.floatFromBits' call
          // Inline function 'kotlin.fromBits' call
          var bits_2 = convertToInt(shiftRight(value_4, 32));
          // Inline function 'kotlin.comparisons.maxOf' call
          var b = left + floatFromBits(bits_2);
          // Inline function 'kotlin.comparisons.minOf' call
          var b_0 = Math.max(width, b);
          var right = Math.min(tmp0, b_0);
          // Inline function 'androidx.compose.ui.geometry.Size.height' call
          // Inline function 'androidx.compose.ui.util.unpackFloat2' call
          var value_5 = _Size___get_packedValue__impl__7rlt1o(minTouch);
          // Inline function 'androidx.compose.ui.util.floatFromBits' call
          // Inline function 'kotlin.fromBits' call
          var bits_3 = convertToInt(bitwiseAnd(value_5, new Long(-1, 0)));
          var tmp0_0 = height + floatFromBits(bits_3);
          // Inline function 'androidx.compose.ui.geometry.Size.height' call
          // Inline function 'androidx.compose.ui.util.unpackFloat2' call
          var value_6 = _Size___get_packedValue__impl__7rlt1o(minTouch);
          // Inline function 'androidx.compose.ui.util.floatFromBits' call
          // Inline function 'kotlin.fromBits' call
          var bits_4 = convertToInt(bitwiseAnd(value_6, new Long(-1, 0)));
          // Inline function 'kotlin.comparisons.maxOf' call
          var b_1 = top + floatFromBits(bits_4);
          // Inline function 'kotlin.comparisons.minOf' call
          var b_2 = Math.max(height, b_1);
          var bottom = Math.min(tmp0_0, b_2);
          bounds.c5d(left, top, right, bottom);
        } else if (clipBounds) {
          // Inline function 'androidx.compose.ui.unit.IntSize.width' call
          var this_0 = this.q95();
          // Inline function 'androidx.compose.ui.util.unpackInt1' call
          var value_7 = _IntSize___get_packedValue__impl__uho7jf(this_0);
          var tmp = convertToInt(shiftRight(value_7, 32));
          // Inline function 'androidx.compose.ui.unit.IntSize.height' call
          var this_1 = this.q95();
          // Inline function 'androidx.compose.ui.util.unpackInt2' call
          var value_8 = _IntSize___get_packedValue__impl__uho7jf(this_1);
          var tmp$ret$38 = convertToInt(bitwiseAnd(value_8, new Long(-1, 0)));
          bounds.c5d(0.0, 0.0, tmp, tmp$ret$38);
        }
        if (bounds.oy()) {
          return Unit_instance;
        }
      }
      layer.hbl(bounds, false);
    }
    var x = _IntOffset___get_x__impl__qiqr5o(this.iak());
    bounds.w5c_1 = bounds.w5c_1 + x;
    bounds.y5c_1 = bounds.y5c_1 + x;
    var y = _IntOffset___get_y__impl__2avpwj(this.iak());
    bounds.x5c_1 = bounds.x5c_1 + y;
    bounds.z5c_1 = bounds.z5c_1 + y;
  };
  protoOf(NodeCoordinator).qb7 = function (bounds, clipBounds, clipToMinimumTouchTargetSize, $super) {
    clipToMinimumTouchTargetSize = clipToMinimumTouchTargetSize === VOID ? false : clipToMinimumTouchTargetSize;
    var tmp;
    if ($super === VOID) {
      this.pb7(bounds, clipBounds, clipToMinimumTouchTargetSize);
      tmp = Unit_instance;
    } else {
      tmp = $super.pb7.call(this, bounds, clipBounds, clipToMinimumTouchTargetSize);
    }
    return tmp;
  };
  protoOf(NodeCoordinator).tb6 = function (pointerPosition) {
    // Inline function 'androidx.compose.ui.geometry.isFinite' call
    var v = bitwiseXor(bitwiseAnd(_Offset___get_packedValue__impl__xh2k8q(pointerPosition), new Long(2139095040, 2139095040)), new Long(2139095040, 2139095040));
    if (!equalsLong(bitwiseAnd(subtract(v, new Long(1, 1)), new Long(-2147483648, -2147483648)), new Long(0, 0))) {
      return false;
    }
    var layer = this.o95_1;
    return layer == null || !this.v94_1 || layer.qbl(pointerPosition);
  };
  protoOf(NodeCoordinator).rb7 = function (pointerPosition) {
    // Inline function 'androidx.compose.ui.geometry.Offset.x' call
    // Inline function 'androidx.compose.ui.util.unpackFloat1' call
    var value = _Offset___get_packedValue__impl__xh2k8q(pointerPosition);
    // Inline function 'androidx.compose.ui.util.floatFromBits' call
    // Inline function 'kotlin.fromBits' call
    var bits = convertToInt(shiftRight(value, 32));
    var x = floatFromBits(bits);
    // Inline function 'androidx.compose.ui.geometry.Offset.y' call
    // Inline function 'androidx.compose.ui.util.unpackFloat2' call
    var value_0 = _Offset___get_packedValue__impl__xh2k8q(pointerPosition);
    // Inline function 'androidx.compose.ui.util.floatFromBits' call
    // Inline function 'kotlin.fromBits' call
    var bits_0 = convertToInt(bitwiseAnd(value_0, new Long(-1, 0)));
    var y = floatFromBits(bits_0);
    return x >= 0.0 && y >= 0.0 && x < this.mah() && y < this.zao();
  };
  protoOf(NodeCoordinator).lb2 = function () {
    var layer = this.o95_1;
    if (!(layer == null)) {
      layer.m40();
    } else {
      var tmp0_safe_receiver = this.t94_1;
      if (tmp0_safe_receiver == null)
        null;
      else {
        tmp0_safe_receiver.lb2();
      }
    }
  };
  protoOf(NodeCoordinator).ab0 = function () {
    var tmp0_safe_receiver = this.o95_1;
    if (tmp0_safe_receiver == null)
      null;
    else {
      tmp0_safe_receiver.m40();
    }
  };
  protoOf(NodeCoordinator).kak = function (other) {
    var ancestor1 = other.a9i();
    var ancestor2 = this.a9i();
    if (ancestor1 === ancestor2) {
      var otherNode = other.qb1();
      var tmp0 = this.qb1();
      // Inline function 'androidx.compose.ui.node.Nodes.Layout' call
      var tmp$ret$0 = _NodeKind___init__impl__ojsprp(2);
      // Inline function 'androidx.compose.ui.node.visitLocalAncestors' call
      var mask = _NodeKind___get_mask__impl__1uopb6(tmp$ret$0);
      // Inline function 'androidx.compose.ui.internal.checkPrecondition' call
      if (!tmp0.f4n().z8v_1) {
        var tmp$ret$3 = 'visitLocalAncestors called on an unattached node';
        throwIllegalStateException(tmp$ret$3);
      }
      var next = tmp0.f4n().q8v_1;
      while (!(next == null)) {
        if (!((next.o8v_1 & mask) === 0)) {
          if (next === otherNode)
            return other;
        }
        next = next.q8v_1;
      }
      return this;
    }
    while (ancestor1.n90_1 > ancestor2.n90_1) {
      ancestor1 = ensureNotNull(ancestor1.f9a());
    }
    while (ancestor2.n90_1 > ancestor1.n90_1) {
      ancestor2 = ensureNotNull(ancestor2.f9a());
    }
    while (!(ancestor1 === ancestor2)) {
      var parent1 = ancestor1.f9a();
      var parent2 = ancestor2.f9a();
      if (parent1 == null || parent2 == null) {
        throw IllegalArgumentException_init_$Create$('layouts are not part of the same hierarchy');
      }
      ancestor1 = parent1;
      ancestor2 = parent2;
    }
    return ancestor2 === this.a9i() ? this : ancestor1 === other.a9i() ? other : ancestor1.car();
  };
  protoOf(NodeCoordinator).wb6 = function () {
    // Inline function 'androidx.compose.ui.node.Nodes.PointerInput' call
    var tmp$ret$0 = _NodeKind___init__impl__ojsprp(16);
    var tmp0_elvis_lhs = headNode(this, get_includeSelfInTraversal(tmp$ret$0));
    var tmp;
    if (tmp0_elvis_lhs == null) {
      return false;
    } else {
      tmp = tmp0_elvis_lhs;
    }
    var start = tmp;
    if (start.z8v_1) {
      // Inline function 'androidx.compose.ui.node.Nodes.PointerInput' call
      // Inline function 'androidx.compose.ui.node.visitSelfAndLocalDescendants' call
      var type = _NodeKind___init__impl__ojsprp(16);
      var tmp2 = _NodeKind___get_mask__impl__1uopb6(type);
      $l$block: {
        // Inline function 'androidx.compose.ui.node.visitLocalDescendants' call
        // Inline function 'androidx.compose.ui.internal.checkPrecondition' call
        if (!start.f4n().z8v_1) {
          var tmp$ret$5 = 'visitLocalDescendants called on an unattached node';
          throwIllegalStateException(tmp$ret$5);
        }
        var self_0 = start.f4n();
        if ((self_0.p8v_1 & tmp2) === 0) {
          break $l$block;
        }
        var next = true ? self_0 : self_0.r8v_1;
        while (!(next == null)) {
          if (!((next.o8v_1 & tmp2) === 0)) {
            // Inline function 'androidx.compose.ui.node.dispatchForKind' call
            // Inline function 'androidx.compose.ui.node.dispatchForKind' call
            var stack = null;
            var node = next;
            $l$loop: while (!(node == null)) {
              var tmp_0;
              if (isInterface(node, PointerInputModifierNode)) {
                if (node.ga5())
                  return true;
                tmp_0 = false;
              } else {
                tmp_0 = true;
              }
              var dispatchAgain = tmp_0;
              var tmp_1;
              var tmp_2;
              if (dispatchAgain || false) {
                // Inline function 'androidx.compose.ui.Node.isKind' call
                tmp_2 = !((node.o8v_1 & _NodeKind___get_mask__impl__1uopb6(type)) === 0);
              } else {
                tmp_2 = false;
              }
              if (tmp_2) {
                tmp_1 = node instanceof DelegatingNode;
              } else {
                tmp_1 = false;
              }
              if (tmp_1) {
                var count = 0;
                // Inline function 'androidx.compose.ui.node.DelegatingNode.forEachImmediateDelegate' call
                var node_0 = node.e9a_1;
                while (!(node_0 == null)) {
                  var next_0 = node_0;
                  // Inline function 'androidx.compose.ui.Node.isKind' call
                  if (!((next_0.o8v_1 & _NodeKind___get_mask__impl__1uopb6(type)) === 0)) {
                    count = count + 1 | 0;
                    if (count === 1) {
                      node = next_0;
                    } else {
                      var tmp0_elvis_lhs_0 = stack;
                      var tmp_3;
                      if (tmp0_elvis_lhs_0 == null) {
                        // Inline function 'androidx.compose.runtime.collection.mutableVectorOf' call
                        // Inline function 'androidx.compose.runtime.collection.MutableVector' call
                        // Inline function 'kotlin.arrayOfNulls' call
                        var tmp$ret$16 = Array(16);
                        tmp_3 = new MutableVector(tmp$ret$16, 0);
                      } else {
                        tmp_3 = tmp0_elvis_lhs_0;
                      }
                      stack = tmp_3;
                      var theNode = node;
                      if (!(theNode == null)) {
                        var tmp1_safe_receiver = stack;
                        if (tmp1_safe_receiver == null)
                          null;
                        else
                          tmp1_safe_receiver.zz(theNode);
                        node = null;
                      }
                      var tmp2_safe_receiver = stack;
                      if (tmp2_safe_receiver == null)
                        null;
                      else
                        tmp2_safe_receiver.zz(next_0);
                    }
                  }
                  node_0 = node_0.r8v_1;
                }
                if (count === 1) {
                  continue $l$loop;
                }
              }
              node = access$pop$tDelegatableNodeKt(stack);
            }
          }
          next = next.r8v_1;
        }
      }
    }
    return false;
  };
  protoOf(NodeCoordinator).sb7 = function (minimumTouchTargetSize) {
    // Inline function 'androidx.compose.ui.geometry.Size.width' call
    // Inline function 'androidx.compose.ui.util.unpackFloat1' call
    var value = _Size___get_packedValue__impl__7rlt1o(minimumTouchTargetSize);
    // Inline function 'androidx.compose.ui.util.floatFromBits' call
    // Inline function 'kotlin.fromBits' call
    var bits = convertToInt(shiftRight(value, 32));
    var widthDiff = floatFromBits(bits) - this.mah();
    // Inline function 'androidx.compose.ui.geometry.Size.height' call
    // Inline function 'androidx.compose.ui.util.unpackFloat2' call
    var value_0 = _Size___get_packedValue__impl__7rlt1o(minimumTouchTargetSize);
    // Inline function 'androidx.compose.ui.util.floatFromBits' call
    // Inline function 'kotlin.fromBits' call
    var bits_0 = convertToInt(bitwiseAnd(value_0, new Long(-1, 0)));
    var heightDiff = floatFromBits(bits_0) - this.zao();
    // Inline function 'kotlin.comparisons.maxOf' call
    var b = widthDiff / 2.0;
    var tmp0 = Math.max(0.0, b);
    // Inline function 'kotlin.comparisons.maxOf' call
    var b_0 = heightDiff / 2.0;
    // Inline function 'androidx.compose.ui.geometry.Size' call
    // Inline function 'androidx.compose.ui.util.packFloats' call
    var val2 = Math.max(0.0, b_0);
    var v1 = fromInt(toRawBits(tmp0));
    var v2 = fromInt(toRawBits(val2));
    var tmp$ret$11 = bitwiseOr(shiftLeft(v1, 32), bitwiseAnd(v2, new Long(-1, 0)));
    return _Size___init__impl__aywn0g(tmp$ret$11);
  };
  protoOf(NodeCoordinator).tb7 = function (childRect, minimumTouchTargetSize) {
    var childLeft = childRect.w5c_1;
    var childTop = childRect.x5c_1;
    var tmp;
    var tmp_0;
    var tmp_1;
    if (childRect.y5c_1 < 0) {
      tmp_1 = true;
    } else {
      // Inline function 'androidx.compose.ui.unit.IntSize.width' call
      var this_0 = this.q95();
      // Inline function 'androidx.compose.ui.util.unpackInt1' call
      var value = _IntSize___get_packedValue__impl__uho7jf(this_0);
      tmp_1 = childLeft > convertToInt(shiftRight(value, 32));
    }
    if (tmp_1) {
      tmp_0 = true;
    } else {
      tmp_0 = childRect.z5c_1 < 0;
    }
    if (tmp_0) {
      tmp = true;
    } else {
      // Inline function 'androidx.compose.ui.unit.IntSize.height' call
      var this_1 = this.q95();
      // Inline function 'androidx.compose.ui.util.unpackInt2' call
      var value_0 = _IntSize___get_packedValue__impl__uho7jf(this_1);
      tmp = childTop > convertToInt(bitwiseAnd(value_0, new Long(-1, 0)));
    }
    if (tmp) {
      return Companion_getInstance().g5d_1;
    }
    // Inline function 'androidx.compose.ui.geometry.Size.component1' call
    // Inline function 'androidx.compose.ui.geometry.Size.width' call
    // Inline function 'androidx.compose.ui.util.unpackFloat1' call
    var value_1 = _Size___get_packedValue__impl__7rlt1o(minimumTouchTargetSize);
    // Inline function 'androidx.compose.ui.util.floatFromBits' call
    // Inline function 'kotlin.fromBits' call
    var bits = convertToInt(shiftRight(value_1, 32));
    var mttWidth = floatFromBits(bits);
    // Inline function 'androidx.compose.ui.geometry.Size.component2' call
    // Inline function 'androidx.compose.ui.geometry.Size.height' call
    // Inline function 'androidx.compose.ui.util.unpackFloat2' call
    var value_2 = _Size___get_packedValue__impl__7rlt1o(minimumTouchTargetSize);
    // Inline function 'androidx.compose.ui.util.floatFromBits' call
    // Inline function 'kotlin.fromBits' call
    var bits_0 = convertToInt(bitwiseAnd(value_2, new Long(-1, 0)));
    var mttHeight = floatFromBits(bits_0);
    // Inline function 'androidx.compose.ui.geometry.MutableRect.width' call
    var underWidth = (mttWidth - (childRect.y5c_1 - childRect.w5c_1)) / 2.0;
    var tmp_2;
    if (underWidth > 0) {
      tmp_2 = childLeft - underWidth;
    } else {
      tmp_2 = coerceAtLeast(childLeft, -mttWidth / 2.0);
    }
    var left = tmp_2;
    // Inline function 'androidx.compose.ui.geometry.MutableRect.height' call
    var underHeight = (mttHeight - (childRect.z5c_1 - childRect.x5c_1)) / 2.0;
    var tmp_3;
    if (underHeight > 0) {
      tmp_3 = childTop - underHeight;
    } else {
      tmp_3 = coerceAtLeast(childTop, -mttHeight / 2.0);
    }
    var top = tmp_3;
    // Inline function 'androidx.compose.ui.geometry.Offset' call
    // Inline function 'androidx.compose.ui.util.packFloats' call
    var v1 = fromInt(toRawBits(left));
    var v2 = fromInt(toRawBits(top));
    var tmp$ret$17 = bitwiseOr(shiftLeft(v1, 32), bitwiseAnd(v2, new Long(-1, 0)));
    return _Offset___init__impl__c168vi(tmp$ret$17);
  };
  protoOf(NodeCoordinator).sb6 = function (pointerPosition, minimumTouchTargetSize) {
    var tmp;
    var tmp_0 = this.mah();
    // Inline function 'androidx.compose.ui.geometry.Size.width' call
    // Inline function 'androidx.compose.ui.util.unpackFloat1' call
    var value = _Size___get_packedValue__impl__7rlt1o(minimumTouchTargetSize);
    // Inline function 'androidx.compose.ui.util.floatFromBits' call
    // Inline function 'kotlin.fromBits' call
    var bits = convertToInt(shiftRight(value, 32));
    if (tmp_0 >= floatFromBits(bits)) {
      var tmp_1 = this.zao();
      // Inline function 'androidx.compose.ui.geometry.Size.height' call
      // Inline function 'androidx.compose.ui.util.unpackFloat2' call
      var value_0 = _Size___get_packedValue__impl__7rlt1o(minimumTouchTargetSize);
      // Inline function 'androidx.compose.ui.util.floatFromBits' call
      // Inline function 'kotlin.fromBits' call
      var bits_0 = convertToInt(bitwiseAnd(value_0, new Long(-1, 0)));
      tmp = tmp_1 >= floatFromBits(bits_0);
    } else {
      tmp = false;
    }
    if (tmp) {
      return Infinity;
    }
    var _destruct__k2r9zo = this.sb7(minimumTouchTargetSize);
    // Inline function 'androidx.compose.ui.geometry.Size.component1' call
    // Inline function 'androidx.compose.ui.geometry.Size.width' call
    // Inline function 'androidx.compose.ui.util.unpackFloat1' call
    var value_1 = _Size___get_packedValue__impl__7rlt1o(_destruct__k2r9zo);
    // Inline function 'androidx.compose.ui.util.floatFromBits' call
    // Inline function 'kotlin.fromBits' call
    var bits_1 = convertToInt(shiftRight(value_1, 32));
    var width = floatFromBits(bits_1);
    // Inline function 'androidx.compose.ui.geometry.Size.component2' call
    // Inline function 'androidx.compose.ui.geometry.Size.height' call
    // Inline function 'androidx.compose.ui.util.unpackFloat2' call
    var value_2 = _Size___get_packedValue__impl__7rlt1o(_destruct__k2r9zo);
    // Inline function 'androidx.compose.ui.util.floatFromBits' call
    // Inline function 'kotlin.fromBits' call
    var bits_2 = convertToInt(bitwiseAnd(value_2, new Long(-1, 0)));
    var height = floatFromBits(bits_2);
    var offsetFromEdge_0 = offsetFromEdge(this, pointerPosition);
    var tmp_2;
    var tmp_3;
    var tmp_4;
    if (width > 0.0 || height > 0.0) {
      // Inline function 'androidx.compose.ui.geometry.Offset.x' call
      // Inline function 'androidx.compose.ui.util.unpackFloat1' call
      var value_3 = _Offset___get_packedValue__impl__xh2k8q(offsetFromEdge_0);
      // Inline function 'androidx.compose.ui.util.floatFromBits' call
      // Inline function 'kotlin.fromBits' call
      var bits_3 = convertToInt(shiftRight(value_3, 32));
      tmp_4 = floatFromBits(bits_3) <= width;
    } else {
      tmp_4 = false;
    }
    if (tmp_4) {
      // Inline function 'androidx.compose.ui.geometry.Offset.y' call
      // Inline function 'androidx.compose.ui.util.unpackFloat2' call
      var value_4 = _Offset___get_packedValue__impl__xh2k8q(offsetFromEdge_0);
      // Inline function 'androidx.compose.ui.util.floatFromBits' call
      // Inline function 'kotlin.fromBits' call
      var bits_4 = convertToInt(bitwiseAnd(value_4, new Long(-1, 0)));
      tmp_3 = floatFromBits(bits_4) <= height;
    } else {
      tmp_3 = false;
    }
    if (tmp_3) {
      tmp_2 = Offset__getDistanceSquared_impl_97mhi6(offsetFromEdge_0);
    } else {
      tmp_2 = Infinity;
    }
    return tmp_2;
  };
  function compareEquals(a, b) {
    if (a == null)
      return false;
    if (!(a.n1() === b.n1()))
      return false;
    // Inline function 'androidx.collection.ObjectIntMap.forEach' call
    var k = a.ez_1;
    var v = a.fz_1;
    $l$block: {
      // Inline function 'androidx.collection.ObjectIntMap.forEachIndexed' call
      var m = a.dz_1;
      var lastIndex = m.length - 2 | 0;
      var inductionVariable = 0;
      if (inductionVariable <= lastIndex)
        do {
          var i = inductionVariable;
          inductionVariable = inductionVariable + 1 | 0;
          var slot = m[i];
          // Inline function 'androidx.collection.maskEmptyOrDeleted' call
          var this_0 = slot;
          var tmp$ret$2 = bitwiseAnd(bitwiseAnd(this_0, shiftLeft(invert(this_0), 7)), new Long(-2139062144, -2139062144));
          if (!equalsLong(tmp$ret$2, new Long(-2139062144, -2139062144))) {
            var bitCount = 8 - (~(i - lastIndex | 0) >>> 31 | 0) | 0;
            var inductionVariable_0 = 0;
            if (inductionVariable_0 < bitCount)
              do {
                var j = inductionVariable_0;
                inductionVariable_0 = inductionVariable_0 + 1 | 0;
                // Inline function 'androidx.collection.isFull' call
                var value = bitwiseAnd(slot, new Long(255, 0));
                if (compare(value, new Long(128, 0)) < 0) {
                  var index = (i << 3) + j | 0;
                  var tmp0 = k[index];
                  var v_0 = v[index];
                  if (!(b.w2(tmp0) === v_0))
                    return false;
                }
                slot = shiftRight(slot, 8);
              }
               while (inductionVariable_0 < bitCount);
            if (!(bitCount === 8)) {
              break $l$block;
            }
          }
        }
         while (!(i === lastIndex));
    }
    return true;
  }
  function LayerPositionalProperties() {
    this.tbk_1 = 1.0;
    this.ubk_1 = 1.0;
    this.vbk_1 = 0.0;
    this.wbk_1 = 0.0;
    this.xbk_1 = 0.0;
    this.ybk_1 = 0.0;
    this.zbk_1 = 0.0;
    this.abl_1 = 8.0;
    this.bbl_1 = Companion_getInstance_35().f9i_1;
  }
  protoOf(LayerPositionalProperties).cbl = function (other) {
    this.tbk_1 = other.tbk_1;
    this.ubk_1 = other.ubk_1;
    this.vbk_1 = other.vbk_1;
    this.wbk_1 = other.wbk_1;
    this.xbk_1 = other.xbk_1;
    this.ybk_1 = other.ybk_1;
    this.zbk_1 = other.zbk_1;
    this.abl_1 = other.abl_1;
    this.bbl_1 = other.bbl_1;
  };
  protoOf(LayerPositionalProperties).dbl = function (scope) {
    this.tbk_1 = scope.u9l();
    this.ubk_1 = scope.v9l();
    this.vbk_1 = scope.w9l();
    this.wbk_1 = scope.x9l();
    this.xbk_1 = scope.y9l();
    this.ybk_1 = scope.z9l();
    this.zbk_1 = scope.a9m();
    this.abl_1 = scope.b9m();
    this.bbl_1 = scope.c9m();
  };
  protoOf(LayerPositionalProperties).fbl = function (other) {
    return this.tbk_1 === other.tbk_1 && this.ubk_1 === other.ubk_1 && this.vbk_1 === other.vbk_1 && this.wbk_1 === other.wbk_1 && this.xbk_1 === other.xbk_1 && this.ybk_1 === other.ybk_1 && this.zbk_1 === other.zbk_1 && this.abl_1 === other.abl_1 && equals(this.bbl_1, other.bbl_1);
  };
  function nextUntil(_this__u8e3s4, type, stopType) {
    var tmp0_elvis_lhs = _this__u8e3s4.f4n().r8v_1;
    var tmp;
    if (tmp0_elvis_lhs == null) {
      return null;
    } else {
      tmp = tmp0_elvis_lhs;
    }
    var child = tmp;
    if ((child.p8v_1 & _NodeKind___get_mask__impl__1uopb6(type)) === 0)
      return null;
    var next = child;
    while (!(next == null)) {
      var kindSet = next.o8v_1;
      if (!((kindSet & _NodeKind___get_mask__impl__1uopb6(stopType)) === 0))
        return null;
      if (!((kindSet & _NodeKind___get_mask__impl__1uopb6(type)) === 0)) {
        return next;
      }
      next = next.r8v_1;
    }
    return null;
  }
  function get_classToKindSetMap() {
    _init_properties_NodeKind_kt__t3lelm();
    return classToKindSetMap;
  }
  var classToKindSetMap;
  var androidx_compose_ui_node_Nodes$stable;
  function _NodeKind___init__impl__ojsprp(mask) {
    return mask;
  }
  function _NodeKind___get_mask__impl__1uopb6($this) {
    return $this;
  }
  function Nodes() {
  }
  var Nodes_instance;
  function Nodes_getInstance() {
    return Nodes_instance;
  }
  function calculateNodeKindSetFrom(element) {
    _init_properties_NodeKind_kt__t3lelm();
    // Inline function 'androidx.compose.ui.node.Nodes.Any' call
    var tmp$ret$0 = _NodeKind___init__impl__ojsprp(1);
    var mask = _NodeKind___get_mask__impl__1uopb6(tmp$ret$0);
    if (isInterface(element, LayoutModifier)) {
      var tmp0 = mask;
      // Inline function 'androidx.compose.ui.node.Nodes.Layout' call
      // Inline function 'androidx.compose.ui.node.or' call
      var other = _NodeKind___init__impl__ojsprp(2);
      mask = tmp0 | _NodeKind___get_mask__impl__1uopb6(other);
    }
    if (isInterface(element, DrawModifier)) {
      var tmp0_0 = mask;
      // Inline function 'androidx.compose.ui.node.Nodes.Draw' call
      // Inline function 'androidx.compose.ui.node.or' call
      var other_0 = _NodeKind___init__impl__ojsprp(4);
      mask = tmp0_0 | _NodeKind___get_mask__impl__1uopb6(other_0);
    }
    if (isInterface(element, SemanticsModifier)) {
      var tmp0_1 = mask;
      // Inline function 'androidx.compose.ui.node.Nodes.Semantics' call
      // Inline function 'androidx.compose.ui.node.or' call
      var other_1 = _NodeKind___init__impl__ojsprp(8);
      mask = tmp0_1 | _NodeKind___get_mask__impl__1uopb6(other_1);
    }
    if (isInterface(element, PointerInputModifier)) {
      var tmp0_2 = mask;
      // Inline function 'androidx.compose.ui.node.Nodes.PointerInput' call
      // Inline function 'androidx.compose.ui.node.or' call
      var other_2 = _NodeKind___init__impl__ojsprp(16);
      mask = tmp0_2 | _NodeKind___get_mask__impl__1uopb6(other_2);
    }
    var tmp;
    if (isInterface(element, ModifierLocalConsumer)) {
      tmp = true;
    } else {
      tmp = isInterface(element, ModifierLocalProvider);
    }
    if (tmp) {
      var tmp0_3 = mask;
      // Inline function 'androidx.compose.ui.node.Nodes.Locals' call
      // Inline function 'androidx.compose.ui.node.or' call
      var other_3 = _NodeKind___init__impl__ojsprp(32);
      mask = tmp0_3 | _NodeKind___get_mask__impl__1uopb6(other_3);
    }
    if (isInterface(element, FocusEventModifier)) {
      var tmp0_4 = mask;
      // Inline function 'androidx.compose.ui.node.Nodes.FocusEvent' call
      // Inline function 'androidx.compose.ui.node.or' call
      var other_4 = _NodeKind___init__impl__ojsprp(4096);
      mask = tmp0_4 | _NodeKind___get_mask__impl__1uopb6(other_4);
    }
    if (isInterface(element, FocusOrderModifier)) {
      var tmp0_5 = mask;
      // Inline function 'androidx.compose.ui.node.Nodes.FocusProperties' call
      // Inline function 'androidx.compose.ui.node.or' call
      var other_5 = _NodeKind___init__impl__ojsprp(2048);
      mask = tmp0_5 | _NodeKind___get_mask__impl__1uopb6(other_5);
    }
    if (isInterface(element, OnGloballyPositionedModifier)) {
      var tmp0_6 = mask;
      // Inline function 'androidx.compose.ui.node.Nodes.GlobalPositionAware' call
      // Inline function 'androidx.compose.ui.node.or' call
      var other_6 = _NodeKind___init__impl__ojsprp(256);
      mask = tmp0_6 | _NodeKind___get_mask__impl__1uopb6(other_6);
    }
    if (isInterface(element, ParentDataModifier)) {
      var tmp0_7 = mask;
      // Inline function 'androidx.compose.ui.node.Nodes.ParentData' call
      // Inline function 'androidx.compose.ui.node.or' call
      var other_7 = _NodeKind___init__impl__ojsprp(64);
      mask = tmp0_7 | _NodeKind___get_mask__impl__1uopb6(other_7);
    }
    if (isInterface(element, OnPlacedModifier)) {
      var tmp0_8 = mask;
      // Inline function 'androidx.compose.ui.node.Nodes.OnPlaced' call
      // Inline function 'androidx.compose.ui.node.or' call
      var other_8 = _NodeKind___init__impl__ojsprp(4194304);
      mask = tmp0_8 | _NodeKind___get_mask__impl__1uopb6(other_8);
    }
    if (isInterface(element, OnRemeasuredModifier)) {
      var tmp0_9 = mask;
      // Inline function 'androidx.compose.ui.node.Nodes.OnRemeasured' call
      // Inline function 'androidx.compose.ui.node.or' call
      var other_9 = _NodeKind___init__impl__ojsprp(128);
      mask = tmp0_9 | _NodeKind___get_mask__impl__1uopb6(other_9);
    }
    if (isInterface(element, BringIntoViewModifierNode)) {
      var tmp0_10 = mask;
      // Inline function 'androidx.compose.ui.node.Nodes.BringIntoView' call
      // Inline function 'androidx.compose.ui.node.or' call
      var other_10 = _NodeKind___init__impl__ojsprp(524288);
      mask = tmp0_10 | _NodeKind___get_mask__impl__1uopb6(other_10);
    }
    return mask;
  }
  function get_includeSelfInTraversal(_this__u8e3s4) {
    _init_properties_NodeKind_kt__t3lelm();
    var tmp = _NodeKind___get_mask__impl__1uopb6(_this__u8e3s4);
    // Inline function 'androidx.compose.ui.node.Nodes.OnRemeasured' call
    var tmp$ret$0 = _NodeKind___init__impl__ojsprp(128);
    var tmp_0 = !((tmp & _NodeKind___get_mask__impl__1uopb6(tmp$ret$0)) === 0);
    var tmp_1 = _NodeKind___get_mask__impl__1uopb6(_this__u8e3s4);
    // Inline function 'androidx.compose.ui.node.Nodes.OnPlaced' call
    var tmp$ret$1 = _NodeKind___init__impl__ojsprp(4194304);
    return !!(tmp_0 | !((tmp_1 & _NodeKind___get_mask__impl__1uopb6(tmp$ret$1)) === 0));
  }
  function calculateNodeKindSetFrom_0(node) {
    _init_properties_NodeKind_kt__t3lelm();
    if (!(node.o8v_1 === 0))
      return node.o8v_1;
    var tmp0 = get_classToKindSetMap();
    var tmp2 = classKeyForObject(node);
    var tmp$ret$0;
    $l$block: {
      // Inline function 'androidx.collection.MutableObjectIntMap.getOrPut' call
      var index = tmp0.cz(tmp2);
      if (index >= 0) {
        tmp$ret$0 = tmp0.fz_1[index];
        break $l$block;
      }
      // Inline function 'androidx.compose.ui.node.Nodes.Any' call
      var tmp$ret$2 = _NodeKind___init__impl__ojsprp(1);
      var mask = _NodeKind___get_mask__impl__1uopb6(tmp$ret$2);
      if (isInterface(node, LayoutModifierNode)) {
        var tmp0_0 = mask;
        // Inline function 'androidx.compose.ui.node.Nodes.Layout' call
        // Inline function 'androidx.compose.ui.node.or' call
        var other = _NodeKind___init__impl__ojsprp(2);
        mask = tmp0_0 | _NodeKind___get_mask__impl__1uopb6(other);
      }
      if (isInterface(node, DrawModifierNode)) {
        var tmp0_1 = mask;
        // Inline function 'androidx.compose.ui.node.Nodes.Draw' call
        // Inline function 'androidx.compose.ui.node.or' call
        var other_0 = _NodeKind___init__impl__ojsprp(4);
        mask = tmp0_1 | _NodeKind___get_mask__impl__1uopb6(other_0);
      }
      if (isInterface(node, SemanticsModifierNode)) {
        var tmp0_2 = mask;
        // Inline function 'androidx.compose.ui.node.Nodes.Semantics' call
        // Inline function 'androidx.compose.ui.node.or' call
        var other_1 = _NodeKind___init__impl__ojsprp(8);
        mask = tmp0_2 | _NodeKind___get_mask__impl__1uopb6(other_1);
      }
      if (isInterface(node, PointerInputModifierNode)) {
        var tmp0_3 = mask;
        // Inline function 'androidx.compose.ui.node.Nodes.PointerInput' call
        // Inline function 'androidx.compose.ui.node.or' call
        var other_2 = _NodeKind___init__impl__ojsprp(16);
        mask = tmp0_3 | _NodeKind___get_mask__impl__1uopb6(other_2);
      }
      if (isInterface(node, ModifierLocalModifierNode)) {
        var tmp0_4 = mask;
        // Inline function 'androidx.compose.ui.node.Nodes.Locals' call
        // Inline function 'androidx.compose.ui.node.or' call
        var other_3 = _NodeKind___init__impl__ojsprp(32);
        mask = tmp0_4 | _NodeKind___get_mask__impl__1uopb6(other_3);
      }
      if (isInterface(node, ParentDataModifierNode)) {
        var tmp0_5 = mask;
        // Inline function 'androidx.compose.ui.node.Nodes.ParentData' call
        // Inline function 'androidx.compose.ui.node.or' call
        var other_4 = _NodeKind___init__impl__ojsprp(64);
        mask = tmp0_5 | _NodeKind___get_mask__impl__1uopb6(other_4);
      }
      if (node instanceof OnPlacedNode) {
        var tmp0_6 = mask;
        // Inline function 'androidx.compose.ui.node.Nodes.OnPlaced' call
        // Inline function 'androidx.compose.ui.node.or' call
        var other_5 = _NodeKind___init__impl__ojsprp(4194304);
        mask = tmp0_6 | _NodeKind___get_mask__impl__1uopb6(other_5);
      } else {
        if (isInterface(node, LayoutAwareModifierNode)) {
          var tmp0_7 = mask;
          // Inline function 'androidx.compose.ui.node.Nodes.OnRemeasured' call
          // Inline function 'androidx.compose.ui.node.or' call
          var other_6 = _NodeKind___init__impl__ojsprp(128);
          mask = tmp0_7 | _NodeKind___get_mask__impl__1uopb6(other_6);
          var tmp0_8 = mask;
          // Inline function 'androidx.compose.ui.node.Nodes.OnPlaced' call
          // Inline function 'androidx.compose.ui.node.or' call
          var other_7 = _NodeKind___init__impl__ojsprp(4194304);
          mask = tmp0_8 | _NodeKind___get_mask__impl__1uopb6(other_7);
        } else {
          if (isInterface(node, MeasuredSizeAwareModifierNode)) {
            var tmp0_9 = mask;
            // Inline function 'androidx.compose.ui.node.Nodes.OnRemeasured' call
            // Inline function 'androidx.compose.ui.node.or' call
            var other_8 = _NodeKind___init__impl__ojsprp(128);
            mask = tmp0_9 | _NodeKind___get_mask__impl__1uopb6(other_8);
          }
        }
      }
      if (isInterface(node, GlobalPositionAwareModifierNode)) {
        var tmp0_10 = mask;
        // Inline function 'androidx.compose.ui.node.Nodes.GlobalPositionAware' call
        // Inline function 'androidx.compose.ui.node.or' call
        var other_9 = _NodeKind___init__impl__ojsprp(256);
        mask = tmp0_10 | _NodeKind___get_mask__impl__1uopb6(other_9);
      }
      if (isInterface(node, ApproachLayoutModifierNode)) {
        var tmp0_11 = mask;
        // Inline function 'androidx.compose.ui.node.Nodes.ApproachMeasure' call
        // Inline function 'androidx.compose.ui.node.or' call
        var other_10 = _NodeKind___init__impl__ojsprp(512);
        mask = tmp0_11 | _NodeKind___get_mask__impl__1uopb6(other_10);
      }
      if (node instanceof FocusTargetNode) {
        var tmp0_12 = mask;
        // Inline function 'androidx.compose.ui.node.Nodes.FocusTarget' call
        // Inline function 'androidx.compose.ui.node.or' call
        var other_11 = _NodeKind___init__impl__ojsprp(1024);
        mask = tmp0_12 | _NodeKind___get_mask__impl__1uopb6(other_11);
      }
      if (isInterface(node, FocusPropertiesModifierNode)) {
        var tmp0_13 = mask;
        // Inline function 'androidx.compose.ui.node.Nodes.FocusProperties' call
        // Inline function 'androidx.compose.ui.node.or' call
        var other_12 = _NodeKind___init__impl__ojsprp(2048);
        mask = tmp0_13 | _NodeKind___get_mask__impl__1uopb6(other_12);
      }
      if (isInterface(node, FocusEventModifierNode)) {
        var tmp0_14 = mask;
        // Inline function 'androidx.compose.ui.node.Nodes.FocusEvent' call
        // Inline function 'androidx.compose.ui.node.or' call
        var other_13 = _NodeKind___init__impl__ojsprp(4096);
        mask = tmp0_14 | _NodeKind___get_mask__impl__1uopb6(other_13);
      }
      if (isInterface(node, KeyInputModifierNode)) {
        var tmp0_15 = mask;
        // Inline function 'androidx.compose.ui.node.Nodes.KeyInput' call
        // Inline function 'androidx.compose.ui.node.or' call
        var other_14 = _NodeKind___init__impl__ojsprp(8192);
        mask = tmp0_15 | _NodeKind___get_mask__impl__1uopb6(other_14);
      }
      if (isInterface(node, RotaryInputModifierNode)) {
        var tmp0_16 = mask;
        // Inline function 'androidx.compose.ui.node.Nodes.RotaryInput' call
        // Inline function 'androidx.compose.ui.node.or' call
        var other_15 = _NodeKind___init__impl__ojsprp(16384);
        mask = tmp0_16 | _NodeKind___get_mask__impl__1uopb6(other_15);
      }
      if (isInterface(node, CompositionLocalConsumerModifierNode)) {
        var tmp0_17 = mask;
        // Inline function 'androidx.compose.ui.node.Nodes.CompositionLocalConsumer' call
        // Inline function 'androidx.compose.ui.node.or' call
        var other_16 = _NodeKind___init__impl__ojsprp(32768);
        mask = tmp0_17 | _NodeKind___get_mask__impl__1uopb6(other_16);
      }
      if (isInterface(node, SoftKeyboardInterceptionModifierNode)) {
        var tmp0_18 = mask;
        // Inline function 'androidx.compose.ui.node.Nodes.SoftKeyboardKeyInput' call
        // Inline function 'androidx.compose.ui.node.or' call
        var other_17 = _NodeKind___init__impl__ojsprp(131072);
        mask = tmp0_18 | _NodeKind___get_mask__impl__1uopb6(other_17);
      }
      if (isInterface(node, TraversableNode)) {
        var tmp0_19 = mask;
        // Inline function 'androidx.compose.ui.node.Nodes.Traversable' call
        // Inline function 'androidx.compose.ui.node.or' call
        var other_18 = _NodeKind___init__impl__ojsprp(262144);
        mask = tmp0_19 | _NodeKind___get_mask__impl__1uopb6(other_18);
      }
      if (isInterface(node, BringIntoViewModifierNode)) {
        var tmp0_20 = mask;
        // Inline function 'androidx.compose.ui.node.Nodes.BringIntoView' call
        // Inline function 'androidx.compose.ui.node.or' call
        var other_19 = _NodeKind___init__impl__ojsprp(524288);
        mask = tmp0_20 | _NodeKind___get_mask__impl__1uopb6(other_19);
      }
      if (isInterface(node, UnplacedAwareModifierNode)) {
        var tmp0_21 = mask;
        // Inline function 'androidx.compose.ui.node.Nodes.Unplaced' call
        // Inline function 'androidx.compose.ui.node.or' call
        var other_20 = _NodeKind___init__impl__ojsprp(1048576);
        mask = tmp0_21 | _NodeKind___get_mask__impl__1uopb6(other_20);
      }
      if (isInterface(node, IndirectPointerInputModifierNode)) {
        var tmp0_22 = mask;
        // Inline function 'androidx.compose.ui.node.Nodes.IndirectPointerInput' call
        // Inline function 'androidx.compose.ui.node.or' call
        var other_21 = _NodeKind___init__impl__ojsprp(2097152);
        mask = tmp0_22 | _NodeKind___get_mask__impl__1uopb6(other_21);
      }
      if (isInterface(node, BeyondBoundsLayoutProviderModifierNode)) {
        var tmp0_23 = mask;
        // Inline function 'androidx.compose.ui.node.Nodes.BeyondBoundsLayout' call
        // Inline function 'androidx.compose.ui.node.or' call
        var other_22 = _NodeKind___init__impl__ojsprp(8388608);
        mask = tmp0_23 | _NodeKind___get_mask__impl__1uopb6(other_22);
      }
      var value = mask;
      tmp0.oz(tmp2, value);
      tmp$ret$0 = value;
    }
    return tmp$ret$0;
  }
  function calculateNodeKindSetFromIncludingDelegates(node) {
    _init_properties_NodeKind_kt__t3lelm();
    var tmp;
    if (node instanceof DelegatingNode) {
      var mask = node.d9a_1;
      // Inline function 'androidx.compose.ui.node.DelegatingNode.forEachImmediateDelegate' call
      var node_0 = node.e9a_1;
      while (!(node_0 == null)) {
        var it = node_0;
        mask = mask | calculateNodeKindSetFromIncludingDelegates(it);
        node_0 = node_0.r8v_1;
      }
      tmp = mask;
    } else {
      tmp = calculateNodeKindSetFrom_0(node);
    }
    return tmp;
  }
  function autoInvalidateInsertedNode(node) {
    _init_properties_NodeKind_kt__t3lelm();
    // Inline function 'androidx.compose.ui.internal.checkPrecondition' call
    if (!node.z8v_1) {
      var tmp$ret$1 = 'autoInvalidateInsertedNode called on unattached node';
      throwIllegalStateException(tmp$ret$1);
    }
    autoInvalidateNodeIncludingDelegates(node, -1, 1);
  }
  function autoInvalidateRemovedNode(node) {
    _init_properties_NodeKind_kt__t3lelm();
    // Inline function 'androidx.compose.ui.internal.checkPrecondition' call
    if (!node.z8v_1) {
      var tmp$ret$1 = 'autoInvalidateRemovedNode called on unattached node';
      throwIllegalStateException(tmp$ret$1);
    }
    autoInvalidateNodeIncludingDelegates(node, -1, 2);
  }
  function autoInvalidateUpdatedNode(node) {
    _init_properties_NodeKind_kt__t3lelm();
    // Inline function 'androidx.compose.ui.internal.checkPrecondition' call
    if (!node.z8v_1) {
      var tmp$ret$1 = 'autoInvalidateUpdatedNode called on unattached node';
      throwIllegalStateException(tmp$ret$1);
    }
    autoInvalidateNodeIncludingDelegates(node, -1, 0);
  }
  function autoInvalidateNodeIncludingDelegates(node, remainingSet, phase) {
    _init_properties_NodeKind_kt__t3lelm();
    if (node instanceof DelegatingNode) {
      autoInvalidateNodeSelf(node, node.d9a_1 & remainingSet, phase);
      var newRemaining = remainingSet & ~node.d9a_1;
      // Inline function 'androidx.compose.ui.node.DelegatingNode.forEachImmediateDelegate' call
      var node_0 = node.e9a_1;
      while (!(node_0 == null)) {
        var it = node_0;
        autoInvalidateNodeIncludingDelegates(it, newRemaining, phase);
        node_0 = node_0.r8v_1;
      }
    } else {
      autoInvalidateNodeSelf(node, node.o8v_1 & remainingSet, phase);
    }
  }
  function autoInvalidateNodeSelf(node, selfKindSet, phase) {
    _init_properties_NodeKind_kt__t3lelm();
    if (phase === 0 && !node.b8w())
      return Unit_instance;
    var tmp;
    // Inline function 'androidx.compose.ui.node.Nodes.Layout' call
    // Inline function 'androidx.compose.ui.node.contains' call
    var value = _NodeKind___init__impl__ojsprp(2);
    if (!((selfKindSet & _NodeKind___get_mask__impl__1uopb6(value)) === 0)) {
      tmp = isInterface(node, LayoutModifierNode);
    } else {
      tmp = false;
    }
    if (tmp) {
      invalidateMeasurement(node);
      if (phase === 2) {
        // Inline function 'androidx.compose.ui.node.Nodes.Layout' call
        var tmp$ret$2 = _NodeKind___init__impl__ojsprp(2);
        var coordinator = requireCoordinator(node, tmp$ret$2);
        coordinator.d30();
      }
    }
    // Inline function 'androidx.compose.ui.node.Nodes.OnRemeasured' call
    // Inline function 'androidx.compose.ui.node.contains' call
    var value_0 = _NodeKind___init__impl__ojsprp(128);
    if (!((selfKindSet & _NodeKind___get_mask__impl__1uopb6(value_0)) === 0)) {
      if (!(phase === 2)) {
        requireLayoutNode(node).bb0();
      }
    }
    // Inline function 'androidx.compose.ui.node.Nodes.OnPlaced' call
    // Inline function 'androidx.compose.ui.node.contains' call
    var value_1 = _NodeKind___init__impl__ojsprp(4194304);
    if (!((selfKindSet & _NodeKind___get_mask__impl__1uopb6(value_1)) === 0)) {
      if (!(phase === 2)) {
        requireLayoutNode(node).fb8();
      }
    }
    var tmp_0;
    // Inline function 'androidx.compose.ui.node.Nodes.GlobalPositionAware' call
    // Inline function 'androidx.compose.ui.node.contains' call
    var value_2 = _NodeKind___init__impl__ojsprp(256);
    if (!((selfKindSet & _NodeKind___get_mask__impl__1uopb6(value_2)) === 0)) {
      tmp_0 = isInterface(node, GlobalPositionAwareModifierNode);
    } else {
      tmp_0 = false;
    }
    if (tmp_0) {
      if (phase === 1) {
        var _receiver__tnumb7 = requireLayoutNode(node);
        var _unary__edvuaz = _receiver__tnumb7.n91_1;
        _receiver__tnumb7.vba(_unary__edvuaz + 1 | 0);
      } else if (phase === 2) {
        var _receiver__tnumb7_0 = requireLayoutNode(node);
        var _unary__edvuaz_0 = _receiver__tnumb7_0.n91_1;
        _receiver__tnumb7_0.vba(_unary__edvuaz_0 - 1 | 0);
      }
      if (!(phase === 2)) {
        requireLayoutNode(node).abe();
      }
    }
    var tmp_1;
    // Inline function 'androidx.compose.ui.node.Nodes.Draw' call
    // Inline function 'androidx.compose.ui.node.contains' call
    var value_3 = _NodeKind___init__impl__ojsprp(4);
    if (!((selfKindSet & _NodeKind___get_mask__impl__1uopb6(value_3)) === 0)) {
      tmp_1 = isInterface(node, DrawModifierNode);
    } else {
      tmp_1 = false;
    }
    if (tmp_1) {
      invalidateDraw(node);
    }
    var tmp_2;
    // Inline function 'androidx.compose.ui.node.Nodes.Semantics' call
    // Inline function 'androidx.compose.ui.node.contains' call
    var value_4 = _NodeKind___init__impl__ojsprp(8);
    if (!((selfKindSet & _NodeKind___get_mask__impl__1uopb6(value_4)) === 0)) {
      tmp_2 = isInterface(node, SemanticsModifierNode);
    } else {
      tmp_2 = false;
    }
    if (tmp_2) {
      requireLayoutNode(node).p90_1 = true;
    }
    var tmp_3;
    // Inline function 'androidx.compose.ui.node.Nodes.ParentData' call
    // Inline function 'androidx.compose.ui.node.contains' call
    var value_5 = _NodeKind___init__impl__ojsprp(64);
    if (!((selfKindSet & _NodeKind___get_mask__impl__1uopb6(value_5)) === 0)) {
      tmp_3 = isInterface(node, ParentDataModifierNode);
    } else {
      tmp_3 = false;
    }
    if (tmp_3) {
      invalidateParentData(node);
    }
    var tmp_4;
    var tmp_5;
    // Inline function 'androidx.compose.ui.node.Nodes.FocusProperties' call
    // Inline function 'androidx.compose.ui.node.contains' call
    var value_6 = _NodeKind___init__impl__ojsprp(2048);
    if (!((selfKindSet & _NodeKind___get_mask__impl__1uopb6(value_6)) === 0)) {
      tmp_5 = isInterface(node, FocusPropertiesModifierNode);
    } else {
      tmp_5 = false;
    }
    if (tmp_5) {
      tmp_4 = specifiesCanFocusProperty(node);
    } else {
      tmp_4 = false;
    }
    if (tmp_4) {
      invalidateFocusProperties(node);
    }
    var tmp_6;
    // Inline function 'androidx.compose.ui.node.Nodes.FocusEvent' call
    // Inline function 'androidx.compose.ui.node.contains' call
    var value_7 = _NodeKind___init__impl__ojsprp(4096);
    if (!((selfKindSet & _NodeKind___get_mask__impl__1uopb6(value_7)) === 0)) {
      tmp_6 = isInterface(node, FocusEventModifierNode);
    } else {
      tmp_6 = false;
    }
    if (tmp_6) {
      invalidateFocusEvent(node);
    }
    var tmp_7;
    var tmp_8;
    // Inline function 'androidx.compose.ui.node.Nodes.IndirectPointerInput' call
    // Inline function 'androidx.compose.ui.node.contains' call
    var value_8 = _NodeKind___init__impl__ojsprp(2097152);
    if (!((selfKindSet & _NodeKind___get_mask__impl__1uopb6(value_8)) === 0)) {
      tmp_8 = isInterface(node, IndirectPointerInputModifierNode);
    } else {
      tmp_8 = false;
    }
    if (tmp_8) {
      tmp_7 = phase === 2;
    } else {
      tmp_7 = false;
    }
    if (tmp_7) {
      node.d9u();
    }
  }
  function specifiesCanFocusProperty(_this__u8e3s4) {
    _init_properties_NodeKind_kt__t3lelm();
    CanFocusChecker_instance.u4c();
    _this__u8e3s4.c9g(CanFocusChecker_instance);
    return CanFocusChecker_instance.sbl();
  }
  function CanFocusChecker() {
    this.rbl_1 = null;
  }
  protoOf(CanFocusChecker).a9f = function () {
    // Inline function 'androidx.compose.ui.internal.checkPreconditionNotNull' call
    var value = this.rbl_1;
    if (value == null) {
      var tmp$ret$1 = 'canFocus is read before it is written';
      throwIllegalStateExceptionForNullCheck(tmp$ret$1);
    }
    return value;
  };
  protoOf(CanFocusChecker).sbl = function () {
    return !(this.rbl_1 == null);
  };
  protoOf(CanFocusChecker).u4c = function () {
    this.rbl_1 = null;
  };
  var CanFocusChecker_instance;
  function CanFocusChecker_getInstance() {
    return CanFocusChecker_instance;
  }
  var properties_initialized_NodeKind_kt_77djd4;
  function _init_properties_NodeKind_kt__t3lelm() {
    if (!properties_initialized_NodeKind_kt_77djd4) {
      properties_initialized_NodeKind_kt_77djd4 = true;
      classToKindSetMap = mutableObjectIntMapOf();
      androidx_compose_ui_node_Nodes$stable = 0;
    }
  }
  var androidx_compose_ui_node_ObserverNodeOwnerScope$stable;
  function observeReads(_this__u8e3s4, block) {
    var tmp0_elvis_lhs = _this__u8e3s4.s8v_1;
    var tmp;
    if (tmp0_elvis_lhs == null) {
      // Inline function 'kotlin.also' call
      var this_0 = new ObserverNodeOwnerScope(_this__u8e3s4);
      _this__u8e3s4.s8v_1 = this_0;
      tmp = this_0;
    } else {
      tmp = tmp0_elvis_lhs;
    }
    var target = tmp;
    var tmp0 = requireOwner(_this__u8e3s4).fb0();
    // Inline function 'androidx.compose.ui.node.OwnerSnapshotObserver.observeReads' call
    var onChanged = Companion_getInstance_59().tbl_1;
    access$_get_observer__zh6fij(tmp0).z5a(target, onChanged, block);
  }
  function ObserverNodeOwnerScope$Companion$OnObserveReadsChanged$lambda(it) {
    if (it.kb0()) {
      it.ubl_1.w95();
    }
    return Unit_instance;
  }
  function Companion_33() {
    Companion_instance_38 = this;
    var tmp = this;
    tmp.tbl_1 = ObserverNodeOwnerScope$Companion$OnObserveReadsChanged$lambda;
  }
  var Companion_instance_38;
  function Companion_getInstance_59() {
    if (Companion_instance_38 == null)
      new Companion_33();
    return Companion_instance_38;
  }
  function ObserverNodeOwnerScope(observerNode) {
    Companion_getInstance_59();
    this.ubl_1 = observerNode;
  }
  protoOf(ObserverNodeOwnerScope).kb0 = function () {
    return this.ubl_1.f4n().z8v_1;
  };
  var androidx_compose_ui_node_OnPositionedDispatcher$stable;
  function DepthComparator_0() {
  }
  protoOf(DepthComparator_0).kb2 = function (a, b) {
    var depthDiff = compareTo(b.n90_1, a.n90_1);
    if (!(depthDiff === 0)) {
      return depthDiff;
    }
    return compareTo(hashCode(a), hashCode(b));
  };
  protoOf(DepthComparator_0).compare = function (a, b) {
    var tmp = a instanceof LayoutNode ? a : THROW_CCE();
    return this.kb2(tmp, b instanceof LayoutNode ? b : THROW_CCE());
  };
  var DepthComparator_instance;
  function DepthComparator_getInstance() {
    return DepthComparator_instance;
  }
  function dispatchHierarchy($this, layoutNode) {
    if (layoutNode.n91_1 > 0) {
      layoutNode.ibe();
      layoutNode.m91_1 = false;
      // Inline function 'androidx.compose.ui.node.LayoutNode.forEachChild' call
      // Inline function 'androidx.compose.runtime.collection.MutableVector.forEach' call
      var this_0 = layoutNode.rb1();
      var i = 0;
      var tmp = this_0.b3e_1;
      var content = isArray(tmp) ? tmp : THROW_CCE();
      var size = this_0.d3e_1;
      while (i < size) {
        var child = content[i];
        dispatchHierarchy($this, child);
        i = i + 1 | 0;
      }
    }
  }
  function Companion_34() {
    this.vbl_1 = 16;
  }
  var Companion_instance_39;
  function Companion_getInstance_60() {
    return Companion_instance_39;
  }
  function OnPositionedDispatcher() {
    var tmp = this;
    // Inline function 'androidx.compose.runtime.collection.mutableVectorOf' call
    // Inline function 'androidx.compose.runtime.collection.MutableVector' call
    // Inline function 'kotlin.arrayOfNulls' call
    var tmp$ret$2 = Array(16);
    tmp.ubi_1 = new MutableVector(tmp$ret$2, 0);
    this.vbi_1 = null;
  }
  protoOf(OnPositionedDispatcher).fv = function () {
    // Inline function 'androidx.compose.runtime.collection.MutableVector.isNotEmpty' call
    return !(this.ubi_1.d3e_1 === 0);
  };
  protoOf(OnPositionedDispatcher).wbi = function (node) {
    if (node.n91_1 > 0) {
      // Inline function 'androidx.compose.runtime.collection.MutableVector.plusAssign' call
      this.ubi_1.zz(node);
      node.m91_1 = true;
    }
  };
  protoOf(OnPositionedDispatcher).bbc = function (node) {
    this.ubi_1.g10(node);
  };
  protoOf(OnPositionedDispatcher).ibj = function (rootNode) {
    if (rootNode.n91_1 > 0) {
      this.ubi_1.c3();
      // Inline function 'androidx.compose.runtime.collection.MutableVector.plusAssign' call
      this.ubi_1.zz(rootNode);
      rootNode.m91_1 = true;
    }
  };
  protoOf(OnPositionedDispatcher).jbj = function () {
    this.ubi_1.o4a(DepthComparator_instance);
    var cache;
    var size = this.ubi_1.d3e_1;
    var cachedNodes = this.vbi_1;
    if (cachedNodes == null || cachedNodes.length < size) {
      // Inline function 'kotlin.comparisons.maxOf' call
      var b = this.ubi_1.d3e_1;
      // Inline function 'kotlin.arrayOfNulls' call
      var size_0 = Math.max(16, b);
      cache = Array(size_0);
    } else {
      cache = cachedNodes;
    }
    this.vbi_1 = null;
    var inductionVariable = 0;
    if (inductionVariable < size)
      do {
        var i = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        // Inline function 'androidx.compose.runtime.collection.MutableVector.get' call
        cache[i] = this.ubi_1.b3e_1[i];
      }
       while (inductionVariable < size);
    this.ubi_1.c3();
    var inductionVariable_0 = size - 1 | 0;
    if (0 <= inductionVariable_0)
      do {
        var i_0 = inductionVariable_0;
        inductionVariable_0 = inductionVariable_0 + -1 | 0;
        var layoutNode = ensureNotNull(cache[i_0]);
        if (layoutNode.m91_1) {
          dispatchHierarchy(this, layoutNode);
        }
        cache[i_0] = null;
      }
       while (0 <= inductionVariable_0);
    this.vbi_1 = cache;
  };
  function Companion_35() {
    this.xbi_1 = false;
  }
  var Companion_instance_40;
  function Companion_getInstance_61() {
    return Companion_instance_40;
  }
  function Owner() {
  }
  function OwnerScope() {
  }
  function access$_get_observer__zh6fij($this) {
    return $this.pbm_1;
  }
  function access$_get_onCommitAffectingLookaheadMeasure__239e9u($this) {
    return $this.qbm_1;
  }
  function access$_get_onCommitAffectingMeasure__id6h9g($this) {
    return $this.rbm_1;
  }
  function access$_get_onCommitAffectingSemantics__m15jud($this) {
    return $this.sbm_1;
  }
  function access$_get_onCommitAffectingLayout__6g68og($this) {
    return $this.tbm_1;
  }
  function access$_get_onCommitAffectingLayoutModifier__ychcah($this) {
    return $this.ubm_1;
  }
  function access$_get_onCommitAffectingLayoutModifierInLookahead__ts6juu($this) {
    return $this.vbm_1;
  }
  function access$_get_onCommitAffectingLookahead__ez3ps0($this) {
    return $this.wbm_1;
  }
  function OwnerSnapshotObserver$onCommitAffectingLookaheadMeasure$lambda(layoutNode) {
    if (layoutNode.kb0()) {
      layoutNode.bax();
    }
    return Unit_instance;
  }
  function OwnerSnapshotObserver$onCommitAffectingMeasure$lambda(layoutNode) {
    if (layoutNode.kb0()) {
      layoutNode.wav();
    }
    return Unit_instance;
  }
  function OwnerSnapshotObserver$onCommitAffectingSemantics$lambda(layoutNode) {
    if (layoutNode.kb0()) {
      layoutNode.kbb();
    }
    return Unit_instance;
  }
  function OwnerSnapshotObserver$onCommitAffectingLayout$lambda(layoutNode) {
    if (layoutNode.kb0()) {
      layoutNode.fb8();
    }
    return Unit_instance;
  }
  function OwnerSnapshotObserver$onCommitAffectingLayoutModifier$lambda(layoutNode) {
    if (layoutNode.kb0()) {
      layoutNode.fb8();
    }
    return Unit_instance;
  }
  function OwnerSnapshotObserver$onCommitAffectingLayoutModifierInLookahead$lambda(layoutNode) {
    if (layoutNode.kb0()) {
      layoutNode.hbe();
    }
    return Unit_instance;
  }
  function OwnerSnapshotObserver$onCommitAffectingLookahead$lambda(layoutNode) {
    if (layoutNode.kb0()) {
      layoutNode.hbe();
    }
    return Unit_instance;
  }
  function OwnerSnapshotObserver$clearInvalidObservations$lambda(it) {
    return !(isInterface(it, OwnerScope) ? it : THROW_CCE()).kb0();
  }
  function OwnerSnapshotObserver(onChangedExecutor) {
    this.pbm_1 = new SnapshotStateObserver(onChangedExecutor);
    var tmp = this;
    tmp.qbm_1 = OwnerSnapshotObserver$onCommitAffectingLookaheadMeasure$lambda;
    var tmp_0 = this;
    tmp_0.rbm_1 = OwnerSnapshotObserver$onCommitAffectingMeasure$lambda;
    var tmp_1 = this;
    tmp_1.sbm_1 = OwnerSnapshotObserver$onCommitAffectingSemantics$lambda;
    var tmp_2 = this;
    tmp_2.tbm_1 = OwnerSnapshotObserver$onCommitAffectingLayout$lambda;
    var tmp_3 = this;
    tmp_3.ubm_1 = OwnerSnapshotObserver$onCommitAffectingLayoutModifier$lambda;
    var tmp_4 = this;
    tmp_4.vbm_1 = OwnerSnapshotObserver$onCommitAffectingLayoutModifierInLookahead$lambda;
    var tmp_5 = this;
    tmp_5.wbm_1 = OwnerSnapshotObserver$onCommitAffectingLookahead$lambda;
  }
  protoOf(OwnerSnapshotObserver).xbm = function () {
    this.pbm_1.b5b(OwnerSnapshotObserver$clearInvalidObservations$lambda);
  };
  protoOf(OwnerSnapshotObserver).ybm = function (target) {
    this.pbm_1.a5b(target);
  };
  protoOf(OwnerSnapshotObserver).zbm = function () {
    this.pbm_1.c5b();
  };
  protoOf(OwnerSnapshotObserver).abn = function () {
    this.pbm_1.d5b();
    this.pbm_1.c3();
  };
  function ParentDataModifierNode() {
  }
  function invalidateParentData(_this__u8e3s4) {
    return requireLayoutNode(_this__u8e3s4).zbc();
  }
  function PointerInputModifierNode() {
  }
  function get_layoutCoordinates(_this__u8e3s4) {
    // Inline function 'androidx.compose.ui.node.Nodes.PointerInput' call
    var tmp$ret$0 = _NodeKind___init__impl__ojsprp(16);
    return requireCoordinator(_this__u8e3s4, tmp$ret$0);
  }
  var androidx_compose_ui_node_Ref$stable;
  function SemanticsModifierNode() {
  }
  function invalidateSemantics(_this__u8e3s4) {
    return requireLayoutNode(_this__u8e3s4).kbb();
  }
  var androidx_compose_ui_node_DpTouchBoundsExpansion$stable;
  function Companion_36() {
  }
  var Companion_instance_41;
  function Companion_getInstance_62() {
    return Companion_instance_41;
  }
  function DpTouchBoundsExpansion(start, top, end, bottom, isLayoutDirectionAware) {
    this.ca6_1 = start;
    this.da6_1 = top;
    this.ea6_1 = end;
    this.fa6_1 = bottom;
    this.ga6_1 = isLayoutDirectionAware;
    // Inline function 'androidx.compose.ui.internal.requirePrecondition' call
    if (!(_Dp___get_value__impl__geb1vb(this.ca6_1) >= 0)) {
      var tmp$ret$1 = 'Left must be non-negative';
      throwIllegalArgumentException(tmp$ret$1);
    }
    // Inline function 'androidx.compose.ui.internal.requirePrecondition' call
    if (!(_Dp___get_value__impl__geb1vb(this.da6_1) >= 0)) {
      var tmp$ret$3 = 'Top must be non-negative';
      throwIllegalArgumentException(tmp$ret$3);
    }
    // Inline function 'androidx.compose.ui.internal.requirePrecondition' call
    if (!(_Dp___get_value__impl__geb1vb(this.ea6_1) >= 0)) {
      var tmp$ret$5 = 'Right must be non-negative';
      throwIllegalArgumentException(tmp$ret$5);
    }
    // Inline function 'androidx.compose.ui.internal.requirePrecondition' call
    if (!(_Dp___get_value__impl__geb1vb(this.fa6_1) >= 0)) {
      var tmp$ret$7 = 'Bottom must be non-negative';
      throwIllegalArgumentException(tmp$ret$7);
    }
  }
  protoOf(DpTouchBoundsExpansion).ha6 = function (density) {
    // Inline function 'kotlin.with' call
    return _TouchBoundsExpansion___init__impl__5jqlkm(Companion_getInstance_63().bbn(density.w5e(this.ca6_1), density.w5e(this.da6_1), density.w5e(this.ea6_1), density.w5e(this.fa6_1), this.ga6_1));
  };
  protoOf(DpTouchBoundsExpansion).toString = function () {
    return 'DpTouchBoundsExpansion(start=' + Dp__toString_impl_kcddez(this.ca6_1) + ', top=' + Dp__toString_impl_kcddez(this.da6_1) + ', end=' + Dp__toString_impl_kcddez(this.ea6_1) + ', bottom=' + Dp__toString_impl_kcddez(this.fa6_1) + ', isLayoutDirectionAware=' + this.ga6_1 + ')';
  };
  protoOf(DpTouchBoundsExpansion).hashCode = function () {
    var result = Dp__hashCode_impl_sxkrra(this.ca6_1);
    result = imul(result, 31) + Dp__hashCode_impl_sxkrra(this.da6_1) | 0;
    result = imul(result, 31) + Dp__hashCode_impl_sxkrra(this.ea6_1) | 0;
    result = imul(result, 31) + Dp__hashCode_impl_sxkrra(this.fa6_1) | 0;
    result = imul(result, 31) + getBooleanHashCode(this.ga6_1) | 0;
    return result;
  };
  protoOf(DpTouchBoundsExpansion).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof DpTouchBoundsExpansion))
      return false;
    if (!equals(this.ca6_1, other.ca6_1))
      return false;
    if (!equals(this.da6_1, other.da6_1))
      return false;
    if (!equals(this.ea6_1, other.ea6_1))
      return false;
    if (!equals(this.fa6_1, other.fa6_1))
      return false;
    if (!(this.ga6_1 === other.ga6_1))
      return false;
    return true;
  };
  function DpTouchBoundsExpansion_0(start, top, end, bottom) {
    var tmp;
    if (start === VOID) {
      // Inline function 'androidx.compose.ui.unit.dp' call
      tmp = _Dp___init__impl__ms3zkb(0);
    } else {
      tmp = start;
    }
    start = tmp;
    var tmp_0;
    if (top === VOID) {
      // Inline function 'androidx.compose.ui.unit.dp' call
      tmp_0 = _Dp___init__impl__ms3zkb(0);
    } else {
      tmp_0 = top;
    }
    top = tmp_0;
    var tmp_1;
    if (end === VOID) {
      // Inline function 'androidx.compose.ui.unit.dp' call
      tmp_1 = _Dp___init__impl__ms3zkb(0);
    } else {
      tmp_1 = end;
    }
    end = tmp_1;
    var tmp_2;
    if (bottom === VOID) {
      // Inline function 'androidx.compose.ui.unit.dp' call
      tmp_2 = _Dp___init__impl__ms3zkb(0);
    } else {
      tmp_2 = bottom;
    }
    bottom = tmp_2;
    return new DpTouchBoundsExpansion(start, top, end, bottom, true);
  }
  function unpack($this, packedValue, position) {
    return convertToInt(shiftRight(packedValue, imul(position, 15))) & 32767;
  }
  function trimAndShift($this, int, position) {
    return shiftLeft(fromInt(int & 32767), imul(position, 15));
  }
  function _TouchBoundsExpansion___init__impl__5jqlkm(packedValue) {
    return packedValue;
  }
  function _get_packedValue__aj623s($this) {
    return $this;
  }
  function Companion_37() {
    Companion_instance_42 = this;
    this.ia6_1 = TouchBoundsExpansion_0(0);
    this.ja6_1 = 32767;
    this.ka6_1 = 15;
    this.la6_1 = 32767;
    this.ma6_1 = new Long(0, -2147483648);
  }
  protoOf(Companion_37).bbn = function (start, top, end, bottom, isLayoutDirectionAware) {
    return bitwiseOr(bitwiseOr(bitwiseOr(bitwiseOr(trimAndShift(this, start, 0), trimAndShift(this, top, 1)), trimAndShift(this, end, 2)), trimAndShift(this, bottom, 3)), isLayoutDirectionAware ? new Long(0, -2147483648) : new Long(0, 0));
  };
  var Companion_instance_42;
  function Companion_getInstance_63() {
    if (Companion_instance_42 == null)
      new Companion_37();
    return Companion_instance_42;
  }
  function _TouchBoundsExpansion___get_start__impl__y608ex($this) {
    return unpack(Companion_getInstance_63(), _get_packedValue__aj623s($this), 0);
  }
  function _TouchBoundsExpansion___get_top__impl__mce72e($this) {
    return unpack(Companion_getInstance_63(), _get_packedValue__aj623s($this), 1);
  }
  function _TouchBoundsExpansion___get_end__impl__vsnt34($this) {
    return unpack(Companion_getInstance_63(), _get_packedValue__aj623s($this), 2);
  }
  function _TouchBoundsExpansion___get_bottom__impl__c1cspk($this) {
    return unpack(Companion_getInstance_63(), _get_packedValue__aj623s($this), 3);
  }
  function _TouchBoundsExpansion___get_isLayoutDirectionAware__impl__e0dn4g($this) {
    return !equalsLong(bitwiseAnd(_get_packedValue__aj623s($this), new Long(0, -2147483648)), new Long(0, 0));
  }
  function TouchBoundsExpansion__computeLeft_impl_tubjra($this, layoutDirection) {
    var tmp;
    if (!_TouchBoundsExpansion___get_isLayoutDirectionAware__impl__e0dn4g($this) || layoutDirection.equals(LayoutDirection_Ltr_getInstance())) {
      tmp = _TouchBoundsExpansion___get_start__impl__y608ex($this);
    } else {
      tmp = _TouchBoundsExpansion___get_end__impl__vsnt34($this);
    }
    return tmp;
  }
  function TouchBoundsExpansion__computeRight_impl_sqizz1($this, layoutDirection) {
    var tmp;
    if (!_TouchBoundsExpansion___get_isLayoutDirectionAware__impl__e0dn4g($this) || layoutDirection.equals(LayoutDirection_Ltr_getInstance())) {
      tmp = _TouchBoundsExpansion___get_end__impl__vsnt34($this);
    } else {
      tmp = _TouchBoundsExpansion___get_start__impl__y608ex($this);
    }
    return tmp;
  }
  function TouchBoundsExpansion__toString_impl_cgzygm($this) {
    return 'TouchBoundsExpansion(packedValue=' + $this.toString() + ')';
  }
  function TouchBoundsExpansion__hashCode_impl_9a5yc9($this) {
    return $this.hashCode();
  }
  function TouchBoundsExpansion__equals_impl_7wxp1f($this, other) {
    if (!(other instanceof TouchBoundsExpansion))
      return false;
    var tmp0_other_with_cast = other.cbn_1;
    if (!equalsLong($this, tmp0_other_with_cast))
      return false;
    return true;
  }
  function TouchBoundsExpansion(packedValue) {
    Companion_getInstance_63();
    this.cbn_1 = packedValue;
  }
  protoOf(TouchBoundsExpansion).toString = function () {
    return TouchBoundsExpansion__toString_impl_cgzygm(this.cbn_1);
  };
  protoOf(TouchBoundsExpansion).hashCode = function () {
    return TouchBoundsExpansion__hashCode_impl_9a5yc9(this.cbn_1);
  };
  protoOf(TouchBoundsExpansion).equals = function (other) {
    return TouchBoundsExpansion__equals_impl_7wxp1f(this.cbn_1, other);
  };
  function TouchBoundsExpansion_0(start, top, end, bottom) {
    start = start === VOID ? 0 : start;
    top = top === VOID ? 0 : top;
    end = end === VOID ? 0 : end;
    bottom = bottom === VOID ? 0 : bottom;
    // Inline function 'androidx.compose.ui.internal.requirePrecondition' call
    if (!(0 <= start ? start <= 32767 : false)) {
      var tmp$ret$1 = 'Start must be in the range of 0 .. 32767';
      throwIllegalArgumentException(tmp$ret$1);
    }
    // Inline function 'androidx.compose.ui.internal.requirePrecondition' call
    if (!(0 <= top ? top <= 32767 : false)) {
      var tmp$ret$3 = 'Top must be in the range of 0 .. 32767';
      throwIllegalArgumentException(tmp$ret$3);
    }
    // Inline function 'androidx.compose.ui.internal.requirePrecondition' call
    if (!(0 <= end ? end <= 32767 : false)) {
      var tmp$ret$5 = 'End must be in the range of 0 .. 32767';
      throwIllegalArgumentException(tmp$ret$5);
    }
    // Inline function 'androidx.compose.ui.internal.requirePrecondition' call
    if (!(0 <= bottom ? bottom <= 32767 : false)) {
      var tmp$ret$7 = 'Bottom must be in the range of 0 .. 32767';
      throwIllegalArgumentException(tmp$ret$7);
    }
    return _TouchBoundsExpansion___init__impl__5jqlkm(Companion_getInstance_63().bbn(start, top, end, bottom, true));
  }
  var TraverseDescendantsAction_ContinueTraversal_instance;
  var TraverseDescendantsAction_SkipSubtreeAndContinueTraversal_instance;
  var TraverseDescendantsAction_CancelTraversal_instance;
  var TraverseDescendantsAction_entriesInitialized;
  function TraverseDescendantsAction_initEntries() {
    if (TraverseDescendantsAction_entriesInitialized)
      return Unit_instance;
    TraverseDescendantsAction_entriesInitialized = true;
    TraverseDescendantsAction_ContinueTraversal_instance = new TraverseDescendantsAction('ContinueTraversal', 0);
    TraverseDescendantsAction_SkipSubtreeAndContinueTraversal_instance = new TraverseDescendantsAction('SkipSubtreeAndContinueTraversal', 1);
    TraverseDescendantsAction_CancelTraversal_instance = new TraverseDescendantsAction('CancelTraversal', 2);
  }
  function TraverseDescendantsAction(name, ordinal) {
    Enum.call(this, name, ordinal);
  }
  function TraverseDescendantsAction_ContinueTraversal_getInstance() {
    TraverseDescendantsAction_initEntries();
    return TraverseDescendantsAction_ContinueTraversal_instance;
  }
  function TraverseDescendantsAction_SkipSubtreeAndContinueTraversal_getInstance() {
    TraverseDescendantsAction_initEntries();
    return TraverseDescendantsAction_SkipSubtreeAndContinueTraversal_instance;
  }
  function TraverseDescendantsAction_CancelTraversal_getInstance() {
    TraverseDescendantsAction_initEntries();
    return TraverseDescendantsAction_CancelTraversal_instance;
  }
  function TraversableNode() {
  }
  function traverseAncestors(_this__u8e3s4, key, block) {
    // Inline function 'androidx.compose.ui.node.Nodes.Traversable' call
    // Inline function 'androidx.compose.ui.node.visitAncestors' call
    var type = _NodeKind___init__impl__ojsprp(262144);
    // Inline function 'androidx.compose.ui.node.visitAncestors' call
    var mask = _NodeKind___get_mask__impl__1uopb6(type);
    // Inline function 'androidx.compose.ui.internal.checkPrecondition' call
    if (!_this__u8e3s4.f4n().z8v_1) {
      var tmp$ret$4 = 'visitAncestors called on an unattached node';
      throwIllegalStateException(tmp$ret$4);
    }
    var node = false ? _this__u8e3s4.f4n() : _this__u8e3s4.f4n().q8v_1;
    var layout = requireLayoutNode(_this__u8e3s4);
    while (!(layout == null)) {
      var head = layout.d91_1.j99_1;
      if (!((head.p8v_1 & mask) === 0)) {
        while (!(node == null)) {
          if (!((node.o8v_1 & mask) === 0)) {
            // Inline function 'androidx.compose.ui.node.dispatchForKind' call
            var stack = null;
            var node_0 = node;
            $l$loop: while (!(node_0 == null)) {
              var tmp;
              if (isInterface(node_0, TraversableNode)) {
                var it = node_0;
                var tmp_0;
                if (equals(key, it.t91())) {
                  tmp_0 = block(it);
                } else {
                  tmp_0 = true;
                }
                var continueTraversal = tmp_0;
                if (!continueTraversal)
                  return Unit_instance;
                tmp = false;
              } else {
                tmp = true;
              }
              var dispatchAgain = tmp;
              var tmp_1;
              var tmp_2;
              if (dispatchAgain || false) {
                // Inline function 'androidx.compose.ui.Node.isKind' call
                tmp_2 = !((node_0.o8v_1 & _NodeKind___get_mask__impl__1uopb6(type)) === 0);
              } else {
                tmp_2 = false;
              }
              if (tmp_2) {
                tmp_1 = node_0 instanceof DelegatingNode;
              } else {
                tmp_1 = false;
              }
              if (tmp_1) {
                var count = 0;
                // Inline function 'androidx.compose.ui.node.DelegatingNode.forEachImmediateDelegate' call
                var node_1 = node_0.e9a_1;
                while (!(node_1 == null)) {
                  var next = node_1;
                  // Inline function 'androidx.compose.ui.Node.isKind' call
                  if (!((next.o8v_1 & _NodeKind___get_mask__impl__1uopb6(type)) === 0)) {
                    count = count + 1 | 0;
                    if (count === 1) {
                      node_0 = next;
                    } else {
                      var tmp0_elvis_lhs = stack;
                      var tmp_3;
                      if (tmp0_elvis_lhs == null) {
                        // Inline function 'androidx.compose.runtime.collection.mutableVectorOf' call
                        // Inline function 'androidx.compose.runtime.collection.MutableVector' call
                        // Inline function 'kotlin.arrayOfNulls' call
                        var tmp$ret$14 = Array(16);
                        tmp_3 = new MutableVector(tmp$ret$14, 0);
                      } else {
                        tmp_3 = tmp0_elvis_lhs;
                      }
                      stack = tmp_3;
                      var theNode = node_0;
                      if (!(theNode == null)) {
                        var tmp1_safe_receiver = stack;
                        if (tmp1_safe_receiver == null)
                          null;
                        else
                          tmp1_safe_receiver.zz(theNode);
                        node_0 = null;
                      }
                      var tmp2_safe_receiver = stack;
                      if (tmp2_safe_receiver == null)
                        null;
                      else
                        tmp2_safe_receiver.zz(next);
                    }
                  }
                  node_1 = node_1.r8v_1;
                }
                if (count === 1) {
                  continue $l$loop;
                }
              }
              node_0 = access$pop$tDelegatableNodeKt(stack);
            }
          }
          node = node.q8v_1;
        }
      }
      layout = layout.f9a();
      var tmp0_safe_receiver = layout;
      var tmp1_safe_receiver_0 = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.d91_1;
      node = tmp1_safe_receiver_0 == null ? null : tmp1_safe_receiver_0.i99_1;
    }
  }
  function traverseDescendants(_this__u8e3s4, key, block) {
    // Inline function 'androidx.compose.ui.node.Nodes.Traversable' call
    // Inline function 'androidx.compose.ui.node.visitSubtreeIf' call
    var type = _NodeKind___init__impl__ojsprp(262144);
    // Inline function 'androidx.compose.ui.node.visitSubtreeIf' call
    var mask = _NodeKind___get_mask__impl__1uopb6(type);
    // Inline function 'androidx.compose.ui.internal.checkPrecondition' call
    if (!_this__u8e3s4.f4n().z8v_1) {
      var tmp$ret$4 = 'visitSubtreeIf called on an unattached node';
      throwIllegalStateException(tmp$ret$4);
    }
    // Inline function 'androidx.compose.runtime.collection.mutableVectorOf' call
    // Inline function 'androidx.compose.runtime.collection.MutableVector' call
    // Inline function 'kotlin.arrayOfNulls' call
    var tmp$ret$7 = Array(16);
    var branches = new MutableVector(tmp$ret$7, 0);
    var child = _this__u8e3s4.f4n().r8v_1;
    if (child == null) {
      access$addLayoutNodeChildren$tDelegatableNodeKt(branches, _this__u8e3s4.f4n(), false);
    } else
      branches.zz(child);
    outer: while (true) {
      // Inline function 'androidx.compose.runtime.collection.MutableVector.isNotEmpty' call
      if (!!(branches.d3e_1 === 0)) {
        break outer;
      }
      var branch = branches.h3(branches.d3e_1 - 1 | 0);
      if (!((branch.p8v_1 & mask) === 0)) {
        var node = branch;
        while (!(node == null) && node.z8v_1) {
          if (!((node.o8v_1 & mask) === 0)) {
            var tmp0 = node;
            var tmp$ret$9;
            $l$block: {
              // Inline function 'androidx.compose.ui.node.dispatchForKind' call
              // Inline function 'androidx.compose.ui.node.dispatchForKind' call
              var stack = null;
              var node_0 = tmp0;
              $l$loop: while (!(node_0 == null)) {
                var tmp;
                if (isInterface(node_0, TraversableNode)) {
                  var it = node_0;
                  var tmp_0;
                  if (equals(key, it.t91())) {
                    tmp_0 = block(it);
                  } else {
                    tmp_0 = TraverseDescendantsAction_ContinueTraversal_getInstance();
                  }
                  var action = tmp_0;
                  if (action.equals(TraverseDescendantsAction_CancelTraversal_getInstance()))
                    return Unit_instance;
                  if (!!action.equals(TraverseDescendantsAction_SkipSubtreeAndContinueTraversal_getInstance())) {
                    tmp$ret$9 = false;
                    break $l$block;
                  }
                  tmp = false;
                } else {
                  tmp = true;
                }
                var dispatchAgain = tmp;
                var tmp_1;
                var tmp_2;
                if (dispatchAgain || false) {
                  // Inline function 'androidx.compose.ui.Node.isKind' call
                  tmp_2 = !((node_0.o8v_1 & _NodeKind___get_mask__impl__1uopb6(type)) === 0);
                } else {
                  tmp_2 = false;
                }
                if (tmp_2) {
                  tmp_1 = node_0 instanceof DelegatingNode;
                } else {
                  tmp_1 = false;
                }
                if (tmp_1) {
                  var count = 0;
                  // Inline function 'androidx.compose.ui.node.DelegatingNode.forEachImmediateDelegate' call
                  var node_1 = node_0.e9a_1;
                  while (!(node_1 == null)) {
                    var next = node_1;
                    // Inline function 'androidx.compose.ui.Node.isKind' call
                    if (!((next.o8v_1 & _NodeKind___get_mask__impl__1uopb6(type)) === 0)) {
                      count = count + 1 | 0;
                      if (count === 1) {
                        node_0 = next;
                      } else {
                        var tmp0_elvis_lhs = stack;
                        var tmp_3;
                        if (tmp0_elvis_lhs == null) {
                          // Inline function 'androidx.compose.runtime.collection.mutableVectorOf' call
                          // Inline function 'androidx.compose.runtime.collection.MutableVector' call
                          // Inline function 'kotlin.arrayOfNulls' call
                          var tmp$ret$20 = Array(16);
                          tmp_3 = new MutableVector(tmp$ret$20, 0);
                        } else {
                          tmp_3 = tmp0_elvis_lhs;
                        }
                        stack = tmp_3;
                        var theNode = node_0;
                        if (!(theNode == null)) {
                          var tmp1_safe_receiver = stack;
                          if (tmp1_safe_receiver == null)
                            null;
                          else
                            tmp1_safe_receiver.zz(theNode);
                          node_0 = null;
                        }
                        var tmp2_safe_receiver = stack;
                        if (tmp2_safe_receiver == null)
                          null;
                        else
                          tmp2_safe_receiver.zz(next);
                      }
                    }
                    node_1 = node_1.r8v_1;
                  }
                  if (count === 1) {
                    continue $l$loop;
                  }
                }
                node_0 = access$pop$tDelegatableNodeKt(stack);
              }
              tmp$ret$9 = true;
            }
            var diveDeeper = tmp$ret$9;
            if (!diveDeeper)
              continue outer;
          }
          node = node.r8v_1;
        }
      }
      access$addLayoutNodeChildren$tDelegatableNodeKt(branches, branch, false);
    }
  }
  function findNearestAncestor(_this__u8e3s4, key) {
    // Inline function 'androidx.compose.ui.node.Nodes.Traversable' call
    var tmp2 = _NodeKind___init__impl__ojsprp(262144);
    // Inline function 'androidx.compose.ui.node.visitAncestors' call
    var includeDelegates = ComposeUiFlags_instance.y8u_1;
    // Inline function 'androidx.compose.ui.node.visitAncestors' call
    var mask = _NodeKind___get_mask__impl__1uopb6(tmp2);
    // Inline function 'androidx.compose.ui.internal.checkPrecondition' call
    if (!_this__u8e3s4.f4n().z8v_1) {
      var tmp$ret$4 = 'visitAncestors called on an unattached node';
      throwIllegalStateException(tmp$ret$4);
    }
    var node = false ? _this__u8e3s4.f4n() : _this__u8e3s4.f4n().q8v_1;
    var layout = requireLayoutNode(_this__u8e3s4);
    while (!(layout == null)) {
      var head = layout.d91_1.j99_1;
      if (!((head.p8v_1 & mask) === 0)) {
        while (!(node == null)) {
          if (!((node.o8v_1 & mask) === 0)) {
            // Inline function 'androidx.compose.ui.node.dispatchForKind' call
            var stack = null;
            var node_0 = node;
            $l$loop: while (!(node_0 == null)) {
              var tmp;
              if (isInterface(node_0, TraversableNode)) {
                var it = node_0;
                if (equals(key, it.t91())) {
                  return it;
                }
                tmp = false;
              } else {
                tmp = true;
              }
              var dispatchAgain = tmp;
              var tmp_0;
              var tmp_1;
              if (dispatchAgain || includeDelegates) {
                // Inline function 'androidx.compose.ui.Node.isKind' call
                tmp_1 = !((node_0.o8v_1 & _NodeKind___get_mask__impl__1uopb6(tmp2)) === 0);
              } else {
                tmp_1 = false;
              }
              if (tmp_1) {
                tmp_0 = node_0 instanceof DelegatingNode;
              } else {
                tmp_0 = false;
              }
              if (tmp_0) {
                var count = 0;
                // Inline function 'androidx.compose.ui.node.DelegatingNode.forEachImmediateDelegate' call
                var node_1 = node_0.e9a_1;
                while (!(node_1 == null)) {
                  var next = node_1;
                  // Inline function 'androidx.compose.ui.Node.isKind' call
                  if (!((next.o8v_1 & _NodeKind___get_mask__impl__1uopb6(tmp2)) === 0)) {
                    count = count + 1 | 0;
                    if (count === 1) {
                      node_0 = next;
                    } else {
                      var tmp0_elvis_lhs = stack;
                      var tmp_2;
                      if (tmp0_elvis_lhs == null) {
                        // Inline function 'androidx.compose.runtime.collection.mutableVectorOf' call
                        // Inline function 'androidx.compose.runtime.collection.MutableVector' call
                        // Inline function 'kotlin.arrayOfNulls' call
                        var tmp$ret$14 = Array(16);
                        tmp_2 = new MutableVector(tmp$ret$14, 0);
                      } else {
                        tmp_2 = tmp0_elvis_lhs;
                      }
                      stack = tmp_2;
                      var theNode = node_0;
                      if (!(theNode == null)) {
                        var tmp1_safe_receiver = stack;
                        if (tmp1_safe_receiver == null)
                          null;
                        else
                          tmp1_safe_receiver.zz(theNode);
                        node_0 = null;
                      }
                      var tmp2_safe_receiver = stack;
                      if (tmp2_safe_receiver == null)
                        null;
                      else
                        tmp2_safe_receiver.zz(next);
                    }
                  }
                  node_1 = node_1.r8v_1;
                }
                if (count === 1) {
                  continue $l$loop;
                }
              }
              node_0 = access$pop$tDelegatableNodeKt(stack);
            }
          }
          node = node.q8v_1;
        }
      }
      layout = layout.f9a();
      var tmp0_safe_receiver = layout;
      var tmp1_safe_receiver_0 = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.d91_1;
      node = tmp1_safe_receiver_0 == null ? null : tmp1_safe_receiver_0.i99_1;
    }
    return null;
  }
  function findNearestAncestor_0(_this__u8e3s4) {
    // Inline function 'androidx.compose.ui.node.Nodes.Traversable' call
    var tmp2 = _NodeKind___init__impl__ojsprp(262144);
    // Inline function 'androidx.compose.ui.node.visitAncestors' call
    var includeDelegates = ComposeUiFlags_instance.y8u_1;
    // Inline function 'androidx.compose.ui.node.visitAncestors' call
    var mask = _NodeKind___get_mask__impl__1uopb6(tmp2);
    // Inline function 'androidx.compose.ui.internal.checkPrecondition' call
    if (!_this__u8e3s4.f4n().z8v_1) {
      var tmp$ret$4 = 'visitAncestors called on an unattached node';
      throwIllegalStateException(tmp$ret$4);
    }
    var node = false ? _this__u8e3s4.f4n() : _this__u8e3s4.f4n().q8v_1;
    var layout = requireLayoutNode(_this__u8e3s4);
    while (!(layout == null)) {
      var head = layout.d91_1.j99_1;
      if (!((head.p8v_1 & mask) === 0)) {
        while (!(node == null)) {
          if (!((node.o8v_1 & mask) === 0)) {
            // Inline function 'androidx.compose.ui.node.dispatchForKind' call
            var stack = null;
            var node_0 = node;
            $l$loop: while (!(node_0 == null)) {
              var tmp;
              if (isInterface(node_0, TraversableNode)) {
                var it = node_0;
                if (equals(_this__u8e3s4.t91(), it.t91()) && areObjectsOfSameType(_this__u8e3s4, it)) {
                  return isInterface(it, TraversableNode) ? it : THROW_CCE();
                }
                tmp = false;
              } else {
                tmp = true;
              }
              var dispatchAgain = tmp;
              var tmp_0;
              var tmp_1;
              if (dispatchAgain || includeDelegates) {
                // Inline function 'androidx.compose.ui.Node.isKind' call
                tmp_1 = !((node_0.o8v_1 & _NodeKind___get_mask__impl__1uopb6(tmp2)) === 0);
              } else {
                tmp_1 = false;
              }
              if (tmp_1) {
                tmp_0 = node_0 instanceof DelegatingNode;
              } else {
                tmp_0 = false;
              }
              if (tmp_0) {
                var count = 0;
                // Inline function 'androidx.compose.ui.node.DelegatingNode.forEachImmediateDelegate' call
                var node_1 = node_0.e9a_1;
                while (!(node_1 == null)) {
                  var next = node_1;
                  // Inline function 'androidx.compose.ui.Node.isKind' call
                  if (!((next.o8v_1 & _NodeKind___get_mask__impl__1uopb6(tmp2)) === 0)) {
                    count = count + 1 | 0;
                    if (count === 1) {
                      node_0 = next;
                    } else {
                      var tmp0_elvis_lhs = stack;
                      var tmp_2;
                      if (tmp0_elvis_lhs == null) {
                        // Inline function 'androidx.compose.runtime.collection.mutableVectorOf' call
                        // Inline function 'androidx.compose.runtime.collection.MutableVector' call
                        // Inline function 'kotlin.arrayOfNulls' call
                        var tmp$ret$14 = Array(16);
                        tmp_2 = new MutableVector(tmp$ret$14, 0);
                      } else {
                        tmp_2 = tmp0_elvis_lhs;
                      }
                      stack = tmp_2;
                      var theNode = node_0;
                      if (!(theNode == null)) {
                        var tmp1_safe_receiver = stack;
                        if (tmp1_safe_receiver == null)
                          null;
                        else
                          tmp1_safe_receiver.zz(theNode);
                        node_0 = null;
                      }
                      var tmp2_safe_receiver = stack;
                      if (tmp2_safe_receiver == null)
                        null;
                      else
                        tmp2_safe_receiver.zz(next);
                    }
                  }
                  node_1 = node_1.r8v_1;
                }
                if (count === 1) {
                  continue $l$loop;
                }
              }
              node_0 = access$pop$tDelegatableNodeKt(stack);
            }
          }
          node = node.q8v_1;
        }
      }
      layout = layout.f9a();
      var tmp0_safe_receiver = layout;
      var tmp1_safe_receiver_0 = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.d91_1;
      node = tmp1_safe_receiver_0 == null ? null : tmp1_safe_receiver_0.i99_1;
    }
    return null;
  }
  function traverseDescendants_0(_this__u8e3s4, block) {
    // Inline function 'androidx.compose.ui.node.Nodes.Traversable' call
    // Inline function 'androidx.compose.ui.node.visitSubtreeIf' call
    var type = _NodeKind___init__impl__ojsprp(262144);
    // Inline function 'androidx.compose.ui.node.visitSubtreeIf' call
    var mask = _NodeKind___get_mask__impl__1uopb6(type);
    // Inline function 'androidx.compose.ui.internal.checkPrecondition' call
    if (!_this__u8e3s4.f4n().z8v_1) {
      var tmp$ret$4 = 'visitSubtreeIf called on an unattached node';
      throwIllegalStateException(tmp$ret$4);
    }
    // Inline function 'androidx.compose.runtime.collection.mutableVectorOf' call
    // Inline function 'androidx.compose.runtime.collection.MutableVector' call
    // Inline function 'kotlin.arrayOfNulls' call
    var tmp$ret$7 = Array(16);
    var branches = new MutableVector(tmp$ret$7, 0);
    var child = _this__u8e3s4.f4n().r8v_1;
    if (child == null) {
      access$addLayoutNodeChildren$tDelegatableNodeKt(branches, _this__u8e3s4.f4n(), false);
    } else
      branches.zz(child);
    outer: while (true) {
      // Inline function 'androidx.compose.runtime.collection.MutableVector.isNotEmpty' call
      if (!!(branches.d3e_1 === 0)) {
        break outer;
      }
      var branch = branches.h3(branches.d3e_1 - 1 | 0);
      if (!((branch.p8v_1 & mask) === 0)) {
        var node = branch;
        while (!(node == null) && node.z8v_1) {
          if (!((node.o8v_1 & mask) === 0)) {
            var tmp0 = node;
            var tmp$ret$9;
            $l$block: {
              // Inline function 'androidx.compose.ui.node.dispatchForKind' call
              // Inline function 'androidx.compose.ui.node.dispatchForKind' call
              var stack = null;
              var node_0 = tmp0;
              $l$loop: while (!(node_0 == null)) {
                var tmp;
                if (isInterface(node_0, TraversableNode)) {
                  var it = node_0;
                  var tmp_0;
                  if (equals(_this__u8e3s4.t91(), it.t91()) && areObjectsOfSameType(_this__u8e3s4, it)) {
                    tmp_0 = block(isInterface(it, TraversableNode) ? it : THROW_CCE());
                  } else {
                    tmp_0 = TraverseDescendantsAction_ContinueTraversal_getInstance();
                  }
                  var action = tmp_0;
                  if (action.equals(TraverseDescendantsAction_CancelTraversal_getInstance()))
                    return Unit_instance;
                  if (!!action.equals(TraverseDescendantsAction_SkipSubtreeAndContinueTraversal_getInstance())) {
                    tmp$ret$9 = false;
                    break $l$block;
                  }
                  tmp = false;
                } else {
                  tmp = true;
                }
                var dispatchAgain = tmp;
                var tmp_1;
                var tmp_2;
                if (dispatchAgain || false) {
                  // Inline function 'androidx.compose.ui.Node.isKind' call
                  tmp_2 = !((node_0.o8v_1 & _NodeKind___get_mask__impl__1uopb6(type)) === 0);
                } else {
                  tmp_2 = false;
                }
                if (tmp_2) {
                  tmp_1 = node_0 instanceof DelegatingNode;
                } else {
                  tmp_1 = false;
                }
                if (tmp_1) {
                  var count = 0;
                  // Inline function 'androidx.compose.ui.node.DelegatingNode.forEachImmediateDelegate' call
                  var node_1 = node_0.e9a_1;
                  while (!(node_1 == null)) {
                    var next = node_1;
                    // Inline function 'androidx.compose.ui.Node.isKind' call
                    if (!((next.o8v_1 & _NodeKind___get_mask__impl__1uopb6(type)) === 0)) {
                      count = count + 1 | 0;
                      if (count === 1) {
                        node_0 = next;
                      } else {
                        var tmp0_elvis_lhs = stack;
                        var tmp_3;
                        if (tmp0_elvis_lhs == null) {
                          // Inline function 'androidx.compose.runtime.collection.mutableVectorOf' call
                          // Inline function 'androidx.compose.runtime.collection.MutableVector' call
                          // Inline function 'kotlin.arrayOfNulls' call
                          var tmp$ret$20 = Array(16);
                          tmp_3 = new MutableVector(tmp$ret$20, 0);
                        } else {
                          tmp_3 = tmp0_elvis_lhs;
                        }
                        stack = tmp_3;
                        var theNode = node_0;
                        if (!(theNode == null)) {
                          var tmp1_safe_receiver = stack;
                          if (tmp1_safe_receiver == null)
                            null;
                          else
                            tmp1_safe_receiver.zz(theNode);
                          node_0 = null;
                        }
                        var tmp2_safe_receiver = stack;
                        if (tmp2_safe_receiver == null)
                          null;
                        else
                          tmp2_safe_receiver.zz(next);
                      }
                    }
                    node_1 = node_1.r8v_1;
                  }
                  if (count === 1) {
                    continue $l$loop;
                  }
                }
                node_0 = access$pop$tDelegatableNodeKt(stack);
              }
              tmp$ret$9 = true;
            }
            var diveDeeper = tmp$ret$9;
            if (!diveDeeper)
              continue outer;
          }
          node = node.r8v_1;
        }
      }
      access$addLayoutNodeChildren$tDelegatableNodeKt(branches, branch, false);
    }
  }
  function traverseAncestors_0(_this__u8e3s4, block) {
    // Inline function 'androidx.compose.ui.node.Nodes.Traversable' call
    // Inline function 'androidx.compose.ui.node.visitAncestors' call
    var type = _NodeKind___init__impl__ojsprp(262144);
    // Inline function 'androidx.compose.ui.node.visitAncestors' call
    var mask = _NodeKind___get_mask__impl__1uopb6(type);
    // Inline function 'androidx.compose.ui.internal.checkPrecondition' call
    if (!_this__u8e3s4.f4n().z8v_1) {
      var tmp$ret$4 = 'visitAncestors called on an unattached node';
      throwIllegalStateException(tmp$ret$4);
    }
    var node = false ? _this__u8e3s4.f4n() : _this__u8e3s4.f4n().q8v_1;
    var layout = requireLayoutNode(_this__u8e3s4);
    while (!(layout == null)) {
      var head = layout.d91_1.j99_1;
      if (!((head.p8v_1 & mask) === 0)) {
        while (!(node == null)) {
          if (!((node.o8v_1 & mask) === 0)) {
            // Inline function 'androidx.compose.ui.node.dispatchForKind' call
            var stack = null;
            var node_0 = node;
            $l$loop: while (!(node_0 == null)) {
              var tmp;
              if (isInterface(node_0, TraversableNode)) {
                var it = node_0;
                var tmp_0;
                if (equals(_this__u8e3s4.t91(), it.t91()) && areObjectsOfSameType(_this__u8e3s4, it)) {
                  tmp_0 = block(isInterface(it, TraversableNode) ? it : THROW_CCE());
                } else {
                  tmp_0 = true;
                }
                var continueTraversal = tmp_0;
                if (!continueTraversal)
                  return Unit_instance;
                tmp = false;
              } else {
                tmp = true;
              }
              var dispatchAgain = tmp;
              var tmp_1;
              var tmp_2;
              if (dispatchAgain || false) {
                // Inline function 'androidx.compose.ui.Node.isKind' call
                tmp_2 = !((node_0.o8v_1 & _NodeKind___get_mask__impl__1uopb6(type)) === 0);
              } else {
                tmp_2 = false;
              }
              if (tmp_2) {
                tmp_1 = node_0 instanceof DelegatingNode;
              } else {
                tmp_1 = false;
              }
              if (tmp_1) {
                var count = 0;
                // Inline function 'androidx.compose.ui.node.DelegatingNode.forEachImmediateDelegate' call
                var node_1 = node_0.e9a_1;
                while (!(node_1 == null)) {
                  var next = node_1;
                  // Inline function 'androidx.compose.ui.Node.isKind' call
                  if (!((next.o8v_1 & _NodeKind___get_mask__impl__1uopb6(type)) === 0)) {
                    count = count + 1 | 0;
                    if (count === 1) {
                      node_0 = next;
                    } else {
                      var tmp0_elvis_lhs = stack;
                      var tmp_3;
                      if (tmp0_elvis_lhs == null) {
                        // Inline function 'androidx.compose.runtime.collection.mutableVectorOf' call
                        // Inline function 'androidx.compose.runtime.collection.MutableVector' call
                        // Inline function 'kotlin.arrayOfNulls' call
                        var tmp$ret$14 = Array(16);
                        tmp_3 = new MutableVector(tmp$ret$14, 0);
                      } else {
                        tmp_3 = tmp0_elvis_lhs;
                      }
                      stack = tmp_3;
                      var theNode = node_0;
                      if (!(theNode == null)) {
                        var tmp1_safe_receiver = stack;
                        if (tmp1_safe_receiver == null)
                          null;
                        else
                          tmp1_safe_receiver.zz(theNode);
                        node_0 = null;
                      }
                      var tmp2_safe_receiver = stack;
                      if (tmp2_safe_receiver == null)
                        null;
                      else
                        tmp2_safe_receiver.zz(next);
                    }
                  }
                  node_1 = node_1.r8v_1;
                }
                if (count === 1) {
                  continue $l$loop;
                }
              }
              node_0 = access$pop$tDelegatableNodeKt(stack);
            }
          }
          node = node.q8v_1;
        }
      }
      layout = layout.f9a();
      var tmp0_safe_receiver = layout;
      var tmp1_safe_receiver_0 = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.d91_1;
      node = tmp1_safe_receiver_0 == null ? null : tmp1_safe_receiver_0.i99_1;
    }
  }
  function UnplacedAwareModifierNode() {
  }
  function get_LocalAccessibilityManager() {
    _init_properties_CompositionLocals_kt__uo3k1s();
    return LocalAccessibilityManager;
  }
  var LocalAccessibilityManager;
  function get_LocalAutofill() {
    _init_properties_CompositionLocals_kt__uo3k1s();
    return LocalAutofill;
  }
  var LocalAutofill;
  function get_LocalAutofillTree() {
    _init_properties_CompositionLocals_kt__uo3k1s();
    return LocalAutofillTree;
  }
  var LocalAutofillTree;
  function get_LocalAutofillManager() {
    _init_properties_CompositionLocals_kt__uo3k1s();
    return LocalAutofillManager;
  }
  var LocalAutofillManager;
  function get_LocalClipboardManager() {
    _init_properties_CompositionLocals_kt__uo3k1s();
    return LocalClipboardManager;
  }
  var LocalClipboardManager;
  function get_LocalClipboard() {
    _init_properties_CompositionLocals_kt__uo3k1s();
    return LocalClipboard;
  }
  var LocalClipboard;
  function get_LocalGraphicsContext() {
    _init_properties_CompositionLocals_kt__uo3k1s();
    return LocalGraphicsContext;
  }
  var LocalGraphicsContext;
  function get_LocalDensity() {
    _init_properties_CompositionLocals_kt__uo3k1s();
    return LocalDensity;
  }
  var LocalDensity;
  function get_LocalFocusManager() {
    _init_properties_CompositionLocals_kt__uo3k1s();
    return LocalFocusManager;
  }
  var LocalFocusManager;
  function get_LocalFontLoader() {
    _init_properties_CompositionLocals_kt__uo3k1s();
    return LocalFontLoader;
  }
  var LocalFontLoader;
  function get_LocalFontFamilyResolver() {
    _init_properties_CompositionLocals_kt__uo3k1s();
    return LocalFontFamilyResolver;
  }
  var LocalFontFamilyResolver;
  function get_LocalHapticFeedback() {
    _init_properties_CompositionLocals_kt__uo3k1s();
    return LocalHapticFeedback;
  }
  var LocalHapticFeedback;
  function get_LocalInputModeManager() {
    _init_properties_CompositionLocals_kt__uo3k1s();
    return LocalInputModeManager;
  }
  var LocalInputModeManager;
  function get_LocalLayoutDirection() {
    _init_properties_CompositionLocals_kt__uo3k1s();
    return LocalLayoutDirection;
  }
  var LocalLayoutDirection;
  function get_LocalProvidableLocaleList() {
    _init_properties_CompositionLocals_kt__uo3k1s();
    return LocalProvidableLocaleList;
  }
  var LocalProvidableLocaleList;
  var LocalLocale;
  function get_LocalTextInputService() {
    _init_properties_CompositionLocals_kt__uo3k1s();
    return LocalTextInputService;
  }
  var LocalTextInputService;
  function get_LocalSoftwareKeyboardController() {
    _init_properties_CompositionLocals_kt__uo3k1s();
    return LocalSoftwareKeyboardController;
  }
  var LocalSoftwareKeyboardController;
  function get_LocalTextToolbar() {
    _init_properties_CompositionLocals_kt__uo3k1s();
    return LocalTextToolbar;
  }
  var LocalTextToolbar;
  function get_LocalUriHandler() {
    _init_properties_CompositionLocals_kt__uo3k1s();
    return LocalUriHandler;
  }
  var LocalUriHandler;
  function get_LocalViewConfiguration() {
    _init_properties_CompositionLocals_kt__uo3k1s();
    return LocalViewConfiguration;
  }
  var LocalViewConfiguration;
  function get_LocalWindowInfo() {
    _init_properties_CompositionLocals_kt__uo3k1s();
    return LocalWindowInfo;
  }
  var LocalWindowInfo;
  function get_LocalPointerIconService() {
    _init_properties_CompositionLocals_kt__uo3k1s();
    return LocalPointerIconService;
  }
  var LocalPointerIconService;
  function get_LocalProvidableScrollCaptureInProgress() {
    _init_properties_CompositionLocals_kt__uo3k1s();
    return LocalProvidableScrollCaptureInProgress;
  }
  var LocalProvidableScrollCaptureInProgress;
  function get_LocalCursorBlinkEnabled() {
    _init_properties_CompositionLocals_kt__uo3k1s();
    return LocalCursorBlinkEnabled;
  }
  var LocalCursorBlinkEnabled;
  function noLocalProvidedFor(name) {
    _init_properties_CompositionLocals_kt__uo3k1s();
    // Inline function 'kotlin.error' call
    var message = 'CompositionLocal ' + name + ' not present';
    throw IllegalStateException_init_$Create$(toString(message));
  }
  function get_LocalLocaleList() {
    _init_properties_CompositionLocals_kt__uo3k1s();
    return get_LocalProvidableLocaleList();
  }
  function get_LocalScrollCaptureInProgress() {
    _init_properties_CompositionLocals_kt__uo3k1s();
    return get_LocalProvidableScrollCaptureInProgress();
  }
  function ProvideCommonCompositionLocals(owner, uriHandler, content, $composer, $changed) {
    _init_properties_CompositionLocals_kt__uo3k1s();
    var $composer_0 = $composer;
    $composer_0 = $composer_0.s30(1925803616);
    var $dirty = $changed;
    if (($changed & 6) === 0)
      $dirty = $dirty | ((($changed & 8) === 0 ? $composer_0.k31(owner) : $composer_0.q31(owner)) ? 4 : 2);
    if (($changed & 48) === 0)
      $dirty = $dirty | ((($changed & 64) === 0 ? $composer_0.k31(uriHandler) : $composer_0.q31(uriHandler)) ? 32 : 16);
    if (($changed & 384) === 0)
      $dirty = $dirty | ($composer_0.q31(content) ? 256 : 128);
    if ($composer_0.r31(!(($dirty & 147) === 146), $dirty & 1)) {
      CompositionLocalProvider([get_LocalAccessibilityManager().h3c(owner.abm()), get_LocalAutofill().h3c(owner.dbm()), get_LocalAutofillManager().h3c(owner.ebm()), get_LocalAutofillTree().h3c(owner.cbm()), get_LocalClipboardManager().h3c(owner.ybl()), get_LocalClipboard().h3c(owner.zbl()), get_LocalDensity().h3c(owner.u5e()), get_LocalFocusManager().h3c(owner.o9c()), get_LocalFontLoader().i3c(owner.jbm()), get_LocalFontFamilyResolver().i3c(owner.kbm()), get_LocalHapticFeedback().h3c(owner.wbl()), get_LocalInputModeManager().h3c(owner.xbl()), get_LocalLayoutDirection().h3c(owner.r6p()), get_LocalTextInputService().h3c(owner.fbm()), get_LocalSoftwareKeyboardController().h3c(owner.gbm()), get_LocalTextToolbar().h3c(owner.bbm()), get_LocalUriHandler().h3c(uriHandler), get_LocalViewConfiguration().h3c(owner.la7()), get_LocalWindowInfo().h3c(owner.hbm()), get_LocalPointerIconService().h3c(owner.ca5()), get_LocalGraphicsContext().h3c(owner.z93()), get_LocalRetainedValuesStore().h3c(owner.ibm()), get_LocalProvidableLocaleList().h3c(owner.n82())], content, $composer_0, androidx_compose_runtime_ProvidedValue$stableprop_getter() | 112 & $dirty >> 3);
    } else {
      $composer_0.z30();
    }
    var tmp0_safe_receiver = $composer_0.t30();
    if (tmp0_safe_receiver == null)
      null;
    else {
      tmp0_safe_receiver.p3c(ProvideCommonCompositionLocals$lambda(owner, uriHandler, content, $changed));
    }
  }
  function LocalAccessibilityManager$lambda() {
    _init_properties_CompositionLocals_kt__uo3k1s();
    return null;
  }
  function LocalAutofill$lambda() {
    _init_properties_CompositionLocals_kt__uo3k1s();
    return null;
  }
  function LocalAutofillTree$lambda() {
    _init_properties_CompositionLocals_kt__uo3k1s();
    noLocalProvidedFor('LocalAutofillTree');
  }
  function LocalAutofillManager$lambda() {
    _init_properties_CompositionLocals_kt__uo3k1s();
    noLocalProvidedFor('LocalAutofillManager');
  }
  function LocalClipboardManager$lambda() {
    _init_properties_CompositionLocals_kt__uo3k1s();
    noLocalProvidedFor('LocalClipboardManager');
  }
  function LocalClipboard$lambda() {
    _init_properties_CompositionLocals_kt__uo3k1s();
    noLocalProvidedFor('LocalClipboard');
  }
  function LocalGraphicsContext$lambda() {
    _init_properties_CompositionLocals_kt__uo3k1s();
    noLocalProvidedFor('LocalGraphicsContext');
  }
  function LocalDensity$lambda() {
    _init_properties_CompositionLocals_kt__uo3k1s();
    noLocalProvidedFor('LocalDensity');
  }
  function LocalFocusManager$lambda() {
    _init_properties_CompositionLocals_kt__uo3k1s();
    noLocalProvidedFor('LocalFocusManager');
  }
  function LocalFontLoader$lambda() {
    _init_properties_CompositionLocals_kt__uo3k1s();
    noLocalProvidedFor('LocalFontLoader');
  }
  function LocalFontFamilyResolver$lambda() {
    _init_properties_CompositionLocals_kt__uo3k1s();
    noLocalProvidedFor('LocalFontFamilyResolver');
  }
  function LocalHapticFeedback$lambda() {
    _init_properties_CompositionLocals_kt__uo3k1s();
    noLocalProvidedFor('LocalHapticFeedback');
  }
  function LocalInputModeManager$lambda() {
    _init_properties_CompositionLocals_kt__uo3k1s();
    noLocalProvidedFor('LocalInputManager');
  }
  function LocalLayoutDirection$lambda() {
    _init_properties_CompositionLocals_kt__uo3k1s();
    noLocalProvidedFor('LocalLayoutDirection');
  }
  function LocalProvidableLocaleList$lambda() {
    _init_properties_CompositionLocals_kt__uo3k1s();
    noLocalProvidedFor('LocalProvidableLocaleList');
  }
  function LocalLocale$lambda($this$compositionLocalWithComputedDefaultOf) {
    _init_properties_CompositionLocals_kt__uo3k1s();
    return first($this$compositionLocalWithComputedDefaultOf.z3c(get_LocalLocaleList()));
  }
  function LocalTextInputService$lambda() {
    _init_properties_CompositionLocals_kt__uo3k1s();
    return null;
  }
  function LocalSoftwareKeyboardController$lambda() {
    _init_properties_CompositionLocals_kt__uo3k1s();
    return null;
  }
  function LocalTextToolbar$lambda() {
    _init_properties_CompositionLocals_kt__uo3k1s();
    noLocalProvidedFor('LocalTextToolbar');
  }
  function LocalUriHandler$lambda() {
    _init_properties_CompositionLocals_kt__uo3k1s();
    noLocalProvidedFor('LocalUriHandler');
  }
  function LocalViewConfiguration$lambda() {
    _init_properties_CompositionLocals_kt__uo3k1s();
    noLocalProvidedFor('LocalViewConfiguration');
  }
  function LocalWindowInfo$lambda() {
    _init_properties_CompositionLocals_kt__uo3k1s();
    noLocalProvidedFor('LocalWindowInfo');
  }
  function LocalPointerIconService$lambda() {
    _init_properties_CompositionLocals_kt__uo3k1s();
    return null;
  }
  function LocalProvidableScrollCaptureInProgress$lambda() {
    _init_properties_CompositionLocals_kt__uo3k1s();
    return false;
  }
  function LocalCursorBlinkEnabled$lambda() {
    _init_properties_CompositionLocals_kt__uo3k1s();
    return true;
  }
  function ProvideCommonCompositionLocals$lambda($owner, $uriHandler, $content, $$changed) {
    return function ($composer, $force) {
      ProvideCommonCompositionLocals($owner, $uriHandler, $content, $composer, updateChangedFlags($$changed | 1));
      return Unit_instance;
    };
  }
  var properties_initialized_CompositionLocals_kt_24dxlq;
  function _init_properties_CompositionLocals_kt__uo3k1s() {
    if (!properties_initialized_CompositionLocals_kt_24dxlq) {
      properties_initialized_CompositionLocals_kt_24dxlq = true;
      LocalAccessibilityManager = staticCompositionLocalOf(LocalAccessibilityManager$lambda);
      LocalAutofill = staticCompositionLocalOf(LocalAutofill$lambda);
      LocalAutofillTree = staticCompositionLocalOf(LocalAutofillTree$lambda);
      LocalAutofillManager = staticCompositionLocalOf(LocalAutofillManager$lambda);
      LocalClipboardManager = staticCompositionLocalOf(LocalClipboardManager$lambda);
      LocalClipboard = staticCompositionLocalOf(LocalClipboard$lambda);
      LocalGraphicsContext = staticCompositionLocalOf(LocalGraphicsContext$lambda);
      LocalDensity = staticCompositionLocalOf(LocalDensity$lambda);
      LocalFocusManager = staticCompositionLocalOf(LocalFocusManager$lambda);
      LocalFontLoader = staticCompositionLocalOf(LocalFontLoader$lambda);
      LocalFontFamilyResolver = staticCompositionLocalOf(LocalFontFamilyResolver$lambda);
      LocalHapticFeedback = staticCompositionLocalOf(LocalHapticFeedback$lambda);
      LocalInputModeManager = staticCompositionLocalOf(LocalInputModeManager$lambda);
      LocalLayoutDirection = staticCompositionLocalOf(LocalLayoutDirection$lambda);
      LocalProvidableLocaleList = staticCompositionLocalOf(LocalProvidableLocaleList$lambda);
      LocalLocale = compositionLocalWithComputedDefaultOf(LocalLocale$lambda);
      LocalTextInputService = staticCompositionLocalOf(LocalTextInputService$lambda);
      LocalSoftwareKeyboardController = staticCompositionLocalOf(LocalSoftwareKeyboardController$lambda);
      LocalTextToolbar = staticCompositionLocalOf(LocalTextToolbar$lambda);
      LocalUriHandler = staticCompositionLocalOf(LocalUriHandler$lambda);
      LocalViewConfiguration = staticCompositionLocalOf(LocalViewConfiguration$lambda);
      LocalWindowInfo = staticCompositionLocalOf(LocalWindowInfo$lambda);
      LocalPointerIconService = staticCompositionLocalOf(LocalPointerIconService$lambda);
      LocalProvidableScrollCaptureInProgress = compositionLocalOf(VOID, LocalProvidableScrollCaptureInProgress$lambda);
      LocalCursorBlinkEnabled = staticCompositionLocalOf(LocalCursorBlinkEnabled$lambda);
    }
  }
  function Key_0() {
  }
  var Key_instance_1;
  function Key_getInstance_0() {
    return Key_instance_1;
  }
  function get_NoInspectorInfo() {
    _init_properties_InspectableValue_kt__dlvdqb();
    return NoInspectorInfo;
  }
  var NoInspectorInfo;
  function get_isDebugInspectorInfoEnabled() {
    _init_properties_InspectableValue_kt__dlvdqb();
    return isDebugInspectorInfoEnabled;
  }
  var isDebugInspectorInfoEnabled;
  var androidx_compose_ui_platform_ValueElement$stable;
  var androidx_compose_ui_platform_InspectorInfo$stable;
  var androidx_compose_ui_platform_ValueElementSequence$stable;
  var androidx_compose_ui_platform_InspectorValueInfo$stable;
  var androidx_compose_ui_platform_InspectableModifier$stable;
  function ValueElement(name, value) {
    this.dbn_1 = name;
    this.ebn_1 = value;
  }
  protoOf(ValueElement).toString = function () {
    return 'ValueElement(name=' + this.dbn_1 + ', value=' + toString_0(this.ebn_1) + ')';
  };
  protoOf(ValueElement).hashCode = function () {
    var result = getStringHashCode(this.dbn_1);
    result = imul(result, 31) + (this.ebn_1 == null ? 0 : hashCode(this.ebn_1)) | 0;
    return result;
  };
  protoOf(ValueElement).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof ValueElement))
      return false;
    if (!(this.dbn_1 === other.dbn_1))
      return false;
    if (!equals(this.ebn_1, other.ebn_1))
      return false;
    return true;
  };
  function InspectorValueInfo(info) {
    this.fbn_1 = info;
    this.gbn_1 = null;
  }
  function NoInspectorInfo$lambda(_this__u8e3s4) {
    _init_properties_InspectableValue_kt__dlvdqb();
    return Unit_instance;
  }
  var properties_initialized_InspectableValue_kt_898af9;
  function _init_properties_InspectableValue_kt__dlvdqb() {
    if (!properties_initialized_InspectableValue_kt_898af9) {
      properties_initialized_InspectableValue_kt_898af9 = true;
      NoInspectorInfo = NoInspectorInfo$lambda;
      isDebugInspectorInfoEnabled = false;
      androidx_compose_ui_platform_ValueElement$stable = 8;
      androidx_compose_ui_platform_InspectorInfo$stable = 8;
      androidx_compose_ui_platform_ValueElementSequence$stable = 8;
      androidx_compose_ui_platform_InspectorValueInfo$stable = 8;
      androidx_compose_ui_platform_InspectableModifier$stable = 0;
    }
  }
  function get_LocalInspectionMode() {
    _init_properties_InspectionMode_kt__lajbx3();
    return LocalInspectionMode;
  }
  var LocalInspectionMode;
  function LocalInspectionMode$lambda() {
    _init_properties_InspectionMode_kt__lajbx3();
    return false;
  }
  var properties_initialized_InspectionMode_kt_ksrhev;
  function _init_properties_InspectionMode_kt__lajbx3() {
    if (!properties_initialized_InspectionMode_kt_ksrhev) {
      properties_initialized_InspectionMode_kt_ksrhev = true;
      LocalInspectionMode = staticCompositionLocalOf(LocalInspectionMode$lambda);
    }
  }
  function invertTo(_this__u8e3s4, other) {
    if (_Matrix___get_values__impl__fblr7b(_this__u8e3s4).length < 16 || _Matrix___get_values__impl__fblr7b(other).length < 16)
      return false;
    // Inline function 'androidx.compose.ui.graphics.Matrix.get' call
    var a00 = _Matrix___get_values__impl__fblr7b(_this__u8e3s4)[imul(0, 4) + 0 | 0];
    // Inline function 'androidx.compose.ui.graphics.Matrix.get' call
    var a01 = _Matrix___get_values__impl__fblr7b(_this__u8e3s4)[imul(0, 4) + 1 | 0];
    // Inline function 'androidx.compose.ui.graphics.Matrix.get' call
    var a02 = _Matrix___get_values__impl__fblr7b(_this__u8e3s4)[imul(0, 4) + 2 | 0];
    // Inline function 'androidx.compose.ui.graphics.Matrix.get' call
    var a03 = _Matrix___get_values__impl__fblr7b(_this__u8e3s4)[imul(0, 4) + 3 | 0];
    // Inline function 'androidx.compose.ui.graphics.Matrix.get' call
    var a10 = _Matrix___get_values__impl__fblr7b(_this__u8e3s4)[imul(1, 4) + 0 | 0];
    // Inline function 'androidx.compose.ui.graphics.Matrix.get' call
    var a11 = _Matrix___get_values__impl__fblr7b(_this__u8e3s4)[imul(1, 4) + 1 | 0];
    // Inline function 'androidx.compose.ui.graphics.Matrix.get' call
    var a12 = _Matrix___get_values__impl__fblr7b(_this__u8e3s4)[imul(1, 4) + 2 | 0];
    // Inline function 'androidx.compose.ui.graphics.Matrix.get' call
    var a13 = _Matrix___get_values__impl__fblr7b(_this__u8e3s4)[imul(1, 4) + 3 | 0];
    // Inline function 'androidx.compose.ui.graphics.Matrix.get' call
    var a20 = _Matrix___get_values__impl__fblr7b(_this__u8e3s4)[imul(2, 4) + 0 | 0];
    // Inline function 'androidx.compose.ui.graphics.Matrix.get' call
    var a21 = _Matrix___get_values__impl__fblr7b(_this__u8e3s4)[imul(2, 4) + 1 | 0];
    // Inline function 'androidx.compose.ui.graphics.Matrix.get' call
    var a22 = _Matrix___get_values__impl__fblr7b(_this__u8e3s4)[imul(2, 4) + 2 | 0];
    // Inline function 'androidx.compose.ui.graphics.Matrix.get' call
    var a23 = _Matrix___get_values__impl__fblr7b(_this__u8e3s4)[imul(2, 4) + 3 | 0];
    // Inline function 'androidx.compose.ui.graphics.Matrix.get' call
    var a30 = _Matrix___get_values__impl__fblr7b(_this__u8e3s4)[imul(3, 4) + 0 | 0];
    // Inline function 'androidx.compose.ui.graphics.Matrix.get' call
    var a31 = _Matrix___get_values__impl__fblr7b(_this__u8e3s4)[imul(3, 4) + 1 | 0];
    // Inline function 'androidx.compose.ui.graphics.Matrix.get' call
    var a32 = _Matrix___get_values__impl__fblr7b(_this__u8e3s4)[imul(3, 4) + 2 | 0];
    // Inline function 'androidx.compose.ui.graphics.Matrix.get' call
    var a33 = _Matrix___get_values__impl__fblr7b(_this__u8e3s4)[imul(3, 4) + 3 | 0];
    var b00 = a00 * a11 - a01 * a10;
    var b01 = a00 * a12 - a02 * a10;
    var b02 = a00 * a13 - a03 * a10;
    var b03 = a01 * a12 - a02 * a11;
    var b04 = a01 * a13 - a03 * a11;
    var b05 = a02 * a13 - a03 * a12;
    var b06 = a20 * a31 - a21 * a30;
    var b07 = a20 * a32 - a22 * a30;
    var b08 = a20 * a33 - a23 * a30;
    var b09 = a21 * a32 - a22 * a31;
    var b10 = a21 * a33 - a23 * a31;
    var b11 = a22 * a33 - a23 * a32;
    var det = b00 * b11 - b01 * b10 + b02 * b09 + b03 * b08 - b04 * b07 + b05 * b06;
    if (!(det === 0.0)) {
      var invDet = 1.0 / det;
      // Inline function 'androidx.compose.ui.graphics.Matrix.set' call
      var v = (a11 * b11 - a12 * b10 + a13 * b09) * invDet;
      _Matrix___get_values__impl__fblr7b(other)[imul(0, 4) + 0 | 0] = v;
      // Inline function 'androidx.compose.ui.graphics.Matrix.set' call
      var v_0 = (-a01 * b11 + a02 * b10 - a03 * b09) * invDet;
      _Matrix___get_values__impl__fblr7b(other)[imul(0, 4) + 1 | 0] = v_0;
      // Inline function 'androidx.compose.ui.graphics.Matrix.set' call
      var v_1 = (a31 * b05 - a32 * b04 + a33 * b03) * invDet;
      _Matrix___get_values__impl__fblr7b(other)[imul(0, 4) + 2 | 0] = v_1;
      // Inline function 'androidx.compose.ui.graphics.Matrix.set' call
      var v_2 = (-a21 * b05 + a22 * b04 - a23 * b03) * invDet;
      _Matrix___get_values__impl__fblr7b(other)[imul(0, 4) + 3 | 0] = v_2;
      // Inline function 'androidx.compose.ui.graphics.Matrix.set' call
      var v_3 = (-a10 * b11 + a12 * b08 - a13 * b07) * invDet;
      _Matrix___get_values__impl__fblr7b(other)[imul(1, 4) + 0 | 0] = v_3;
      // Inline function 'androidx.compose.ui.graphics.Matrix.set' call
      var v_4 = (a00 * b11 - a02 * b08 + a03 * b07) * invDet;
      _Matrix___get_values__impl__fblr7b(other)[imul(1, 4) + 1 | 0] = v_4;
      // Inline function 'androidx.compose.ui.graphics.Matrix.set' call
      var v_5 = (-a30 * b05 + a32 * b02 - a33 * b01) * invDet;
      _Matrix___get_values__impl__fblr7b(other)[imul(1, 4) + 2 | 0] = v_5;
      // Inline function 'androidx.compose.ui.graphics.Matrix.set' call
      var v_6 = (a20 * b05 - a22 * b02 + a23 * b01) * invDet;
      _Matrix___get_values__impl__fblr7b(other)[imul(1, 4) + 3 | 0] = v_6;
      // Inline function 'androidx.compose.ui.graphics.Matrix.set' call
      var v_7 = (a10 * b10 - a11 * b08 + a13 * b06) * invDet;
      _Matrix___get_values__impl__fblr7b(other)[imul(2, 4) + 0 | 0] = v_7;
      // Inline function 'androidx.compose.ui.graphics.Matrix.set' call
      var v_8 = (-a00 * b10 + a01 * b08 - a03 * b06) * invDet;
      _Matrix___get_values__impl__fblr7b(other)[imul(2, 4) + 1 | 0] = v_8;
      // Inline function 'androidx.compose.ui.graphics.Matrix.set' call
      var v_9 = (a30 * b04 - a31 * b02 + a33 * b00) * invDet;
      _Matrix___get_values__impl__fblr7b(other)[imul(2, 4) + 2 | 0] = v_9;
      // Inline function 'androidx.compose.ui.graphics.Matrix.set' call
      var v_10 = (-a20 * b04 + a21 * b02 - a23 * b00) * invDet;
      _Matrix___get_values__impl__fblr7b(other)[imul(2, 4) + 3 | 0] = v_10;
      // Inline function 'androidx.compose.ui.graphics.Matrix.set' call
      var v_11 = (-a10 * b09 + a11 * b07 - a12 * b06) * invDet;
      _Matrix___get_values__impl__fblr7b(other)[imul(3, 4) + 0 | 0] = v_11;
      // Inline function 'androidx.compose.ui.graphics.Matrix.set' call
      var v_12 = (a00 * b09 - a01 * b07 + a02 * b06) * invDet;
      _Matrix___get_values__impl__fblr7b(other)[imul(3, 4) + 1 | 0] = v_12;
      // Inline function 'androidx.compose.ui.graphics.Matrix.set' call
      var v_13 = (-a30 * b03 + a31 * b01 - a32 * b00) * invDet;
      _Matrix___get_values__impl__fblr7b(other)[imul(3, 4) + 2 | 0] = v_13;
      // Inline function 'androidx.compose.ui.graphics.Matrix.set' call
      var v_14 = (a20 * b03 - a21 * b01 + a22 * b00) * invDet;
      _Matrix___get_values__impl__fblr7b(other)[imul(3, 4) + 3 | 0] = v_14;
    }
    return !(det === 0.0);
  }
  function get_LocalChainedPlatformTextInputInterceptor() {
    _init_properties_PlatformTextInputModifierNode_kt__ty52i7();
    return LocalChainedPlatformTextInputInterceptor;
  }
  var LocalChainedPlatformTextInputInterceptor;
  function establishTextInputSession(_this__u8e3s4, block, $completion) {
    var tmp = new $establishTextInputSessionCOROUTINE$(_this__u8e3s4, block, $completion);
    tmp.p9_1 = Unit_instance;
    tmp.q9_1 = null;
    return tmp.v9();
  }
  function PlatformTextInputSessionScope() {
  }
  function ChainedPlatformTextInputInterceptor$textInputSession$slambda$o$startInputMethod$slambda$lambda(this$0) {
    return function () {
      return _get_interceptor__8m2498(this$0);
    };
  }
  function ChainedPlatformTextInputInterceptor$textInputSession$slambda$o$startInputMethod$slambda$slambda($request, $parentSession, resultContinuation) {
    this.zbn_1 = $request;
    this.abo_1 = $parentSession;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(ChainedPlatformTextInputInterceptor$textInputSession$slambda$o$startInputMethod$slambda$slambda).cbo = function (interceptor, $completion) {
    var tmp = this.dbo(interceptor, $completion);
    tmp.p9_1 = Unit_instance;
    tmp.q9_1 = null;
    return tmp.v9();
  };
  protoOf(ChainedPlatformTextInputInterceptor$textInputSession$slambda$o$startInputMethod$slambda$slambda).ja = function (p1, $completion) {
    return this.cbo((!(p1 == null) ? isInterface(p1, PlatformTextInputInterceptor) : false) ? p1 : THROW_CCE(), $completion);
  };
  protoOf(ChainedPlatformTextInputInterceptor$textInputSession$slambda$o$startInputMethod$slambda$slambda).v9 = function () {
    var suspendResult = this.p9_1;
    $sm: do
      try {
        var tmp = this.n9_1;
        switch (tmp) {
          case 0:
            this.o9_1 = 2;
            this.n9_1 = 1;
            suspendResult = this.bbo_1.ebo(this.zbn_1, this.abo_1, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            throwKotlinNothingValueException();
            break;
          case 2:
            throw this.q9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.o9_1 === 2) {
          throw e;
        } else {
          this.n9_1 = this.o9_1;
          this.q9_1 = e;
        }
      }
     while (true);
  };
  protoOf(ChainedPlatformTextInputInterceptor$textInputSession$slambda$o$startInputMethod$slambda$slambda).dbo = function (interceptor, completion) {
    var i = new ChainedPlatformTextInputInterceptor$textInputSession$slambda$o$startInputMethod$slambda$slambda(this.zbn_1, this.abo_1, completion);
    i.bbo_1 = interceptor;
    return i;
  };
  function ChainedPlatformTextInputInterceptor$textInputSession$slambda$o$startInputMethod$slambda$slambda_0($request, $parentSession, resultContinuation) {
    var i = new ChainedPlatformTextInputInterceptor$textInputSession$slambda$o$startInputMethod$slambda$slambda($request, $parentSession, resultContinuation);
    return constructCallableReference(function (interceptor, $completion) {
      return i.cbo(interceptor, $completion);
    }, 1);
  }
  function ChainedPlatformTextInputInterceptor$textInputSession$slambda$o$startInputMethod$lambda(it) {
    return Unit_instance;
  }
  function ChainedPlatformTextInputInterceptor$textInputSession$slambda$o$startInputMethod$slambda(this$0, $request, $parentSession, resultContinuation) {
    this.nbo_1 = this$0;
    this.obo_1 = $request;
    this.pbo_1 = $parentSession;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(ChainedPlatformTextInputInterceptor$textInputSession$slambda$o$startInputMethod$slambda).rbo = function (it, $completion) {
    var tmp = this.sbo(it, $completion);
    tmp.p9_1 = Unit_instance;
    tmp.q9_1 = null;
    return tmp.v9();
  };
  protoOf(ChainedPlatformTextInputInterceptor$textInputSession$slambda$o$startInputMethod$slambda).ja = function (p1, $completion) {
    return this.rbo(p1 instanceof Unit ? p1 : THROW_CCE(), $completion);
  };
  protoOf(ChainedPlatformTextInputInterceptor$textInputSession$slambda$o$startInputMethod$slambda).v9 = function () {
    var suspendResult = this.p9_1;
    $sm: do
      try {
        var tmp = this.n9_1;
        switch (tmp) {
          case 0:
            this.o9_1 = 2;
            this.n9_1 = 1;
            var tmp_0 = snapshotFlow(ChainedPlatformTextInputInterceptor$textInputSession$slambda$o$startInputMethod$slambda$lambda(this.nbo_1));
            suspendResult = collectLatest(tmp_0, ChainedPlatformTextInputInterceptor$textInputSession$slambda$o$startInputMethod$slambda$slambda_0(this.obo_1, this.pbo_1, null), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            var message = 'Interceptors flow should never terminate.';
            throw IllegalStateException_init_$Create$(toString(message));
          case 2:
            throw this.q9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.o9_1 === 2) {
          throw e;
        } else {
          this.n9_1 = this.o9_1;
          this.q9_1 = e;
        }
      }
     while (true);
  };
  protoOf(ChainedPlatformTextInputInterceptor$textInputSession$slambda$o$startInputMethod$slambda).sbo = function (it, completion) {
    var i = new ChainedPlatformTextInputInterceptor$textInputSession$slambda$o$startInputMethod$slambda(this.nbo_1, this.obo_1, this.pbo_1, completion);
    i.qbo_1 = it;
    return i;
  };
  function ChainedPlatformTextInputInterceptor$textInputSession$slambda$o$startInputMethod$slambda_0(this$0, $request, $parentSession, resultContinuation) {
    var i = new ChainedPlatformTextInputInterceptor$textInputSession$slambda$o$startInputMethod$slambda(this$0, $request, $parentSession, resultContinuation);
    return constructCallableReference(function (it, $completion) {
      return i.rbo(it, $completion);
    }, 1);
  }
  function $startInputMethodCOROUTINE$(_this__u8e3s4, request, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.bbp_1 = _this__u8e3s4;
    this.cbp_1 = request;
  }
  protoOf($startInputMethodCOROUTINE$).v9 = function () {
    var suspendResult = this.p9_1;
    $sm: do
      try {
        var tmp = this.n9_1;
        switch (tmp) {
          case 0:
            this.o9_1 = 2;
            this.n9_1 = 1;
            var tmp_0 = ChainedPlatformTextInputInterceptor$textInputSession$slambda$o$startInputMethod$lambda;
            suspendResult = SessionMutex__withSessionCancellingPrevious_impl_9g140v(this.bbp_1.fbp_1, tmp_0, ChainedPlatformTextInputInterceptor$textInputSession$slambda$o$startInputMethod$slambda_0(this.bbp_1.gbp_1, this.cbp_1, this.bbp_1.ebp_1, null), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            throwKotlinNothingValueException();
            break;
          case 2:
            throw this.q9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.o9_1 === 2) {
          throw e;
        } else {
          this.n9_1 = this.o9_1;
          this.q9_1 = e;
        }
      }
     while (true);
  };
  function ChainedPlatformTextInputInterceptor$textInputSession$2$scope$1($parentSession, $inputMethodMutex, this$0) {
    this.ebp_1 = $parentSession;
    this.fbp_1 = $inputMethodMutex;
    this.gbp_1 = this$0;
    this.dbp_1 = $parentSession;
  }
  protoOf(ChainedPlatformTextInputInterceptor$textInputSession$2$scope$1).hbp = function (request, $completion) {
    var tmp = new $startInputMethodCOROUTINE$(this, request, $completion);
    tmp.p9_1 = Unit_instance;
    tmp.q9_1 = null;
    return tmp.v9();
  };
  protoOf(ChainedPlatformTextInputInterceptor$textInputSession$2$scope$1).q19 = function () {
    return this.dbp_1.q19();
  };
  function _set_interceptor__loc22o($this, _set____db54di) {
    var tmp0 = $this.jbp_1;
    var tmp = KMutableProperty1;
    var tmp_0 = ChainedPlatformTextInputInterceptor$_get_interceptor_$ref_s19mr2();
    // Inline function 'androidx.compose.runtime.setValue' call
    getPropertyCallableRef('interceptor', 1, tmp, tmp_0, ChainedPlatformTextInputInterceptor$_set_interceptor_$ref_ww47pi());
    tmp0.s21(_set____db54di);
    return Unit_instance;
  }
  function _get_interceptor__8m2498($this) {
    var tmp0 = $this.jbp_1;
    var tmp = KMutableProperty1;
    var tmp_0 = ChainedPlatformTextInputInterceptor$_get_interceptor_$ref_s19mr2();
    // Inline function 'androidx.compose.runtime.getValue' call
    getPropertyCallableRef('interceptor', 1, tmp, tmp_0, ChainedPlatformTextInputInterceptor$_set_interceptor_$ref_ww47pi());
    return tmp0.u1();
  }
  function ChainedPlatformTextInputInterceptor$_get_interceptor_$ref_s19mr2() {
    return constructCallableReference(function (p0) {
      return _get_interceptor__8m2498(p0);
    }, 1, 0, 62);
  }
  function ChainedPlatformTextInputInterceptor$_set_interceptor_$ref_ww47pi() {
    return constructCallableReference(function (p0, p1) {
      _set_interceptor__loc22o(p0, p1);
      return Unit_instance;
    }, 2, 0, 63);
  }
  function ChainedPlatformTextInputInterceptor$textInputSession$slambda($session, this$0, resultContinuation) {
    this.sbp_1 = $session;
    this.tbp_1 = this$0;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(ChainedPlatformTextInputInterceptor$textInputSession$slambda).vbp = function ($this$interceptedTextInputSession, $completion) {
    var tmp = this.wbp($this$interceptedTextInputSession, $completion);
    tmp.p9_1 = Unit_instance;
    tmp.q9_1 = null;
    return tmp.v9();
  };
  protoOf(ChainedPlatformTextInputInterceptor$textInputSession$slambda).ja = function (p1, $completion) {
    return this.vbp((!(p1 == null) ? isInterface(p1, PlatformTextInputSessionScope) : false) ? p1 : THROW_CCE(), $completion);
  };
  protoOf(ChainedPlatformTextInputInterceptor$textInputSession$slambda).v9 = function () {
    var suspendResult = this.p9_1;
    $sm: do
      try {
        var tmp = this.n9_1;
        switch (tmp) {
          case 0:
            this.o9_1 = 2;
            var parentSession = this.ubp_1;
            var inputMethodMutex = _SessionMutex___init__impl__v390co_0();
            var scope = new ChainedPlatformTextInputInterceptor$textInputSession$2$scope$1(parentSession, inputMethodMutex, this.tbp_1);
            this.n9_1 = 1;
            suspendResult = this.sbp_1(scope, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            throwKotlinNothingValueException();
            break;
          case 2:
            throw this.q9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.o9_1 === 2) {
          throw e;
        } else {
          this.n9_1 = this.o9_1;
          this.q9_1 = e;
        }
      }
     while (true);
  };
  protoOf(ChainedPlatformTextInputInterceptor$textInputSession$slambda).wbp = function ($this$interceptedTextInputSession, completion) {
    var i = new ChainedPlatformTextInputInterceptor$textInputSession$slambda(this.sbp_1, this.tbp_1, completion);
    i.ubp_1 = $this$interceptedTextInputSession;
    return i;
  };
  function ChainedPlatformTextInputInterceptor$textInputSession$slambda_0($session, this$0, resultContinuation) {
    var i = new ChainedPlatformTextInputInterceptor$textInputSession$slambda($session, this$0, resultContinuation);
    return constructCallableReference(function ($this$interceptedTextInputSession, $completion) {
      return i.vbp($this$interceptedTextInputSession, $completion);
    }, 1);
  }
  function $textInputSessionCOROUTINE$(_this__u8e3s4, owner, session, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.fbq_1 = _this__u8e3s4;
    this.gbq_1 = owner;
    this.hbq_1 = session;
  }
  protoOf($textInputSessionCOROUTINE$).v9 = function () {
    var suspendResult = this.p9_1;
    $sm: do
      try {
        var tmp = this.n9_1;
        switch (tmp) {
          case 0:
            this.o9_1 = 2;
            this.n9_1 = 1;
            suspendResult = interceptedTextInputSession(this.gbq_1, this.fbq_1.ibp_1, ChainedPlatformTextInputInterceptor$textInputSession$slambda_0(this.hbq_1, this.fbq_1, null), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            throwKotlinNothingValueException();
            break;
          case 2:
            throw this.q9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.o9_1 === 2) {
          throw e;
        } else {
          this.n9_1 = this.o9_1;
          this.q9_1 = e;
        }
      }
     while (true);
  };
  function interceptedTextInputSession(_this__u8e3s4, chainedInterceptor, session, $completion) {
    var tmp = new $interceptedTextInputSessionCOROUTINE$(_this__u8e3s4, chainedInterceptor, session, $completion);
    tmp.p9_1 = Unit_instance;
    tmp.q9_1 = null;
    return tmp.v9();
  }
  function PlatformTextInputInterceptor() {
  }
  function LocalChainedPlatformTextInputInterceptor$lambda() {
    _init_properties_PlatformTextInputModifierNode_kt__ty52i7();
    return null;
  }
  function $establishTextInputSessionCOROUTINE$(_this__u8e3s4, block, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.pbn_1 = _this__u8e3s4;
    this.qbn_1 = block;
  }
  protoOf($establishTextInputSessionCOROUTINE$).v9 = function () {
    var suspendResult = this.p9_1;
    $sm: do
      try {
        var tmp = this.n9_1;
        switch (tmp) {
          case 0:
            this.o9_1 = 2;
            if (!this.pbn_1.f4n().z8v_1) {
              var message = 'establishTextInputSession called from an unattached node';
              throw IllegalArgumentException_init_$Create$(toString(message));
            }

            var owner = requireOwner(this.pbn_1);
            var handler = requireLayoutNode(this.pbn_1).z90_1.k51(get_LocalChainedPlatformTextInputInterceptor());
            this.n9_1 = 1;
            suspendResult = interceptedTextInputSession(owner, handler, this.qbn_1, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            throwKotlinNothingValueException();
            break;
          case 2:
            throw this.q9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.o9_1 === 2) {
          throw e;
        } else {
          this.n9_1 = this.o9_1;
          this.q9_1 = e;
        }
      }
     while (true);
  };
  function $interceptedTextInputSessionCOROUTINE$(_this__u8e3s4, chainedInterceptor, session, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.qbq_1 = _this__u8e3s4;
    this.rbq_1 = chainedInterceptor;
    this.sbq_1 = session;
  }
  protoOf($interceptedTextInputSessionCOROUTINE$).v9 = function () {
    var suspendResult = this.p9_1;
    $sm: do
      try {
        var tmp = this.n9_1;
        switch (tmp) {
          case 0:
            this.o9_1 = 3;
            if (this.rbq_1 == null) {
              this.n9_1 = 2;
              suspendResult = this.qbq_1.obm(this.sbq_1, this);
              if (suspendResult === get_COROUTINE_SUSPENDED()) {
                return suspendResult;
              }
              continue $sm;
            } else {
              this.n9_1 = 1;
              suspendResult = this.rbq_1.tbq(this.qbq_1, this.sbq_1, this);
              if (suspendResult === get_COROUTINE_SUSPENDED()) {
                return suspendResult;
              }
              continue $sm;
            }

          case 1:
            throwKotlinNothingValueException();
            break;
          case 2:
            throwKotlinNothingValueException();
            break;
          case 3:
            throw this.q9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.o9_1 === 3) {
          throw e;
        } else {
          this.n9_1 = this.o9_1;
          this.q9_1 = e;
        }
      }
     while (true);
  };
  var properties_initialized_PlatformTextInputModifierNode_kt_ysnlyl;
  function _init_properties_PlatformTextInputModifierNode_kt__ty52i7() {
    if (!properties_initialized_PlatformTextInputModifierNode_kt_ysnlyl) {
      properties_initialized_PlatformTextInputModifierNode_kt_ysnlyl = true;
      LocalChainedPlatformTextInputInterceptor = staticCompositionLocalOf(LocalChainedPlatformTextInputInterceptor$lambda);
    }
  }
  function isInOutline(outline, x, y, tmpTouchPointPath, tmpOpPath) {
    tmpTouchPointPath = tmpTouchPointPath === VOID ? null : tmpTouchPointPath;
    tmpOpPath = tmpOpPath === VOID ? null : tmpOpPath;
    var tmp;
    if (outline instanceof Rectangle) {
      tmp = isInRectangle(outline.s6h_1, x, y);
    } else {
      if (outline instanceof Rounded) {
        tmp = isInRoundedRect(outline, x, y, tmpTouchPointPath, tmpOpPath);
      } else {
        if (outline instanceof Generic) {
          tmp = isInPath(outline.w6h_1, x, y, tmpTouchPointPath, tmpOpPath);
        } else {
          noWhenBranchMatchedException();
        }
      }
    }
    return tmp;
  }
  function isInRectangle(rect, x, y) {
    return rect.k5d_1 <= x && x < rect.m5d_1 && rect.l5d_1 <= y && y < rect.n5d_1;
  }
  function isInRoundedRect(outline, x, y, touchPointPath, opPath) {
    var rrect = outline.t6h_1;
    if (x < rrect.x5d_1 || x >= rrect.z5d_1 || y < rrect.y5d_1 || y >= rrect.a5e_1) {
      return false;
    }
    if (!cornersFit(rrect)) {
      var path = opPath == null ? Path() : opPath;
      path.v6h(rrect);
      return isInPath(path, x, y, touchPointPath, opPath);
    }
    // Inline function 'androidx.compose.ui.geometry.CornerRadius.x' call
    var this_0 = rrect.b5e_1;
    // Inline function 'androidx.compose.ui.util.unpackFloat1' call
    var value = _CornerRadius___get_packedValue__impl__okv4jq(this_0);
    // Inline function 'androidx.compose.ui.util.floatFromBits' call
    // Inline function 'kotlin.fromBits' call
    var bits = convertToInt(shiftRight(value, 32));
    var tmp$ret$0 = floatFromBits(bits);
    var topLeftX = rrect.x5d_1 + tmp$ret$0;
    // Inline function 'androidx.compose.ui.geometry.CornerRadius.y' call
    var this_1 = rrect.b5e_1;
    // Inline function 'androidx.compose.ui.util.unpackFloat2' call
    var value_0 = _CornerRadius___get_packedValue__impl__okv4jq(this_1);
    // Inline function 'androidx.compose.ui.util.floatFromBits' call
    // Inline function 'kotlin.fromBits' call
    var bits_0 = convertToInt(bitwiseAnd(value_0, new Long(-1, 0)));
    var tmp$ret$4 = floatFromBits(bits_0);
    var topLeftY = rrect.y5d_1 + tmp$ret$4;
    // Inline function 'androidx.compose.ui.geometry.CornerRadius.x' call
    var this_2 = rrect.c5e_1;
    // Inline function 'androidx.compose.ui.util.unpackFloat1' call
    var value_1 = _CornerRadius___get_packedValue__impl__okv4jq(this_2);
    // Inline function 'androidx.compose.ui.util.floatFromBits' call
    // Inline function 'kotlin.fromBits' call
    var bits_1 = convertToInt(shiftRight(value_1, 32));
    var tmp$ret$8 = floatFromBits(bits_1);
    var topRightX = rrect.z5d_1 - tmp$ret$8;
    // Inline function 'androidx.compose.ui.geometry.CornerRadius.y' call
    var this_3 = rrect.c5e_1;
    // Inline function 'androidx.compose.ui.util.unpackFloat2' call
    var value_2 = _CornerRadius___get_packedValue__impl__okv4jq(this_3);
    // Inline function 'androidx.compose.ui.util.floatFromBits' call
    // Inline function 'kotlin.fromBits' call
    var bits_2 = convertToInt(bitwiseAnd(value_2, new Long(-1, 0)));
    var tmp$ret$12 = floatFromBits(bits_2);
    var topRightY = rrect.y5d_1 + tmp$ret$12;
    // Inline function 'androidx.compose.ui.geometry.CornerRadius.x' call
    var this_4 = rrect.d5e_1;
    // Inline function 'androidx.compose.ui.util.unpackFloat1' call
    var value_3 = _CornerRadius___get_packedValue__impl__okv4jq(this_4);
    // Inline function 'androidx.compose.ui.util.floatFromBits' call
    // Inline function 'kotlin.fromBits' call
    var bits_3 = convertToInt(shiftRight(value_3, 32));
    var tmp$ret$16 = floatFromBits(bits_3);
    var bottomRightX = rrect.z5d_1 - tmp$ret$16;
    // Inline function 'androidx.compose.ui.geometry.CornerRadius.y' call
    var this_5 = rrect.d5e_1;
    // Inline function 'androidx.compose.ui.util.unpackFloat2' call
    var value_4 = _CornerRadius___get_packedValue__impl__okv4jq(this_5);
    // Inline function 'androidx.compose.ui.util.floatFromBits' call
    // Inline function 'kotlin.fromBits' call
    var bits_4 = convertToInt(bitwiseAnd(value_4, new Long(-1, 0)));
    var tmp$ret$20 = floatFromBits(bits_4);
    var bottomRightY = rrect.a5e_1 - tmp$ret$20;
    // Inline function 'androidx.compose.ui.geometry.CornerRadius.y' call
    var this_6 = rrect.e5e_1;
    // Inline function 'androidx.compose.ui.util.unpackFloat2' call
    var value_5 = _CornerRadius___get_packedValue__impl__okv4jq(this_6);
    // Inline function 'androidx.compose.ui.util.floatFromBits' call
    // Inline function 'kotlin.fromBits' call
    var bits_5 = convertToInt(bitwiseAnd(value_5, new Long(-1, 0)));
    var tmp$ret$24 = floatFromBits(bits_5);
    var bottomLeftX = rrect.a5e_1 - tmp$ret$24;
    // Inline function 'androidx.compose.ui.geometry.CornerRadius.x' call
    var this_7 = rrect.e5e_1;
    // Inline function 'androidx.compose.ui.util.unpackFloat1' call
    var value_6 = _CornerRadius___get_packedValue__impl__okv4jq(this_7);
    // Inline function 'androidx.compose.ui.util.floatFromBits' call
    // Inline function 'kotlin.fromBits' call
    var bits_6 = convertToInt(shiftRight(value_6, 32));
    var tmp$ret$28 = floatFromBits(bits_6);
    var bottomLeftY = rrect.x5d_1 + tmp$ret$28;
    var tmp;
    if (x < topLeftX && y < topLeftY) {
      tmp = isWithinEllipse(x, y, rrect.b5e_1, topLeftX, topLeftY);
    } else if (x < bottomLeftY && y > bottomLeftX) {
      tmp = isWithinEllipse(x, y, rrect.e5e_1, bottomLeftY, bottomLeftX);
    } else if (x > topRightX && y < topRightY) {
      tmp = isWithinEllipse(x, y, rrect.c5e_1, topRightX, topRightY);
    } else if (x > bottomRightX && y > bottomRightY) {
      tmp = isWithinEllipse(x, y, rrect.d5e_1, bottomRightX, bottomRightY);
    } else {
      tmp = true;
    }
    return tmp;
  }
  function isInPath(path, x, y, tmpTouchPointPath, tmpOpPath) {
    var rect = new Rect(x - 0.005, y - 0.005, x + 0.005, y + 0.005);
    var touchPointPath = tmpTouchPointPath == null ? Path() : tmpTouchPointPath;
    touchPointPath.d6i(rect);
    var opPath = tmpOpPath == null ? Path() : tmpOpPath;
    opPath.b6j(path, touchPointPath, Companion_getInstance_15().e6j_1);
    var isClipped = opPath.oy();
    opPath.u4c();
    touchPointPath.u4c();
    return !isClipped;
  }
  function cornersFit(_this__u8e3s4) {
    var tmp;
    var tmp_0;
    var tmp_1;
    // Inline function 'androidx.compose.ui.geometry.CornerRadius.x' call
    var this_0 = _this__u8e3s4.b5e_1;
    // Inline function 'androidx.compose.ui.util.unpackFloat1' call
    var value = _CornerRadius___get_packedValue__impl__okv4jq(this_0);
    // Inline function 'androidx.compose.ui.util.floatFromBits' call
    // Inline function 'kotlin.fromBits' call
    var bits = convertToInt(shiftRight(value, 32));
    var tmp_2 = floatFromBits(bits);
    // Inline function 'androidx.compose.ui.geometry.CornerRadius.x' call
    var this_1 = _this__u8e3s4.c5e_1;
    // Inline function 'androidx.compose.ui.util.unpackFloat1' call
    var value_0 = _CornerRadius___get_packedValue__impl__okv4jq(this_1);
    // Inline function 'androidx.compose.ui.util.floatFromBits' call
    // Inline function 'kotlin.fromBits' call
    var bits_0 = convertToInt(shiftRight(value_0, 32));
    if (tmp_2 + floatFromBits(bits_0) <= _this__u8e3s4.h5e()) {
      // Inline function 'androidx.compose.ui.geometry.CornerRadius.x' call
      var this_2 = _this__u8e3s4.e5e_1;
      // Inline function 'androidx.compose.ui.util.unpackFloat1' call
      var value_1 = _CornerRadius___get_packedValue__impl__okv4jq(this_2);
      // Inline function 'androidx.compose.ui.util.floatFromBits' call
      // Inline function 'kotlin.fromBits' call
      var bits_1 = convertToInt(shiftRight(value_1, 32));
      var tmp_3 = floatFromBits(bits_1);
      // Inline function 'androidx.compose.ui.geometry.CornerRadius.x' call
      var this_3 = _this__u8e3s4.d5e_1;
      // Inline function 'androidx.compose.ui.util.unpackFloat1' call
      var value_2 = _CornerRadius___get_packedValue__impl__okv4jq(this_3);
      // Inline function 'androidx.compose.ui.util.floatFromBits' call
      // Inline function 'kotlin.fromBits' call
      var bits_2 = convertToInt(shiftRight(value_2, 32));
      tmp_1 = tmp_3 + floatFromBits(bits_2) <= _this__u8e3s4.h5e();
    } else {
      tmp_1 = false;
    }
    if (tmp_1) {
      // Inline function 'androidx.compose.ui.geometry.CornerRadius.y' call
      var this_4 = _this__u8e3s4.b5e_1;
      // Inline function 'androidx.compose.ui.util.unpackFloat2' call
      var value_3 = _CornerRadius___get_packedValue__impl__okv4jq(this_4);
      // Inline function 'androidx.compose.ui.util.floatFromBits' call
      // Inline function 'kotlin.fromBits' call
      var bits_3 = convertToInt(bitwiseAnd(value_3, new Long(-1, 0)));
      var tmp_4 = floatFromBits(bits_3);
      // Inline function 'androidx.compose.ui.geometry.CornerRadius.y' call
      var this_5 = _this__u8e3s4.e5e_1;
      // Inline function 'androidx.compose.ui.util.unpackFloat2' call
      var value_4 = _CornerRadius___get_packedValue__impl__okv4jq(this_5);
      // Inline function 'androidx.compose.ui.util.floatFromBits' call
      // Inline function 'kotlin.fromBits' call
      var bits_4 = convertToInt(bitwiseAnd(value_4, new Long(-1, 0)));
      tmp_0 = tmp_4 + floatFromBits(bits_4) <= _this__u8e3s4.i5e();
    } else {
      tmp_0 = false;
    }
    if (tmp_0) {
      // Inline function 'androidx.compose.ui.geometry.CornerRadius.y' call
      var this_6 = _this__u8e3s4.c5e_1;
      // Inline function 'androidx.compose.ui.util.unpackFloat2' call
      var value_5 = _CornerRadius___get_packedValue__impl__okv4jq(this_6);
      // Inline function 'androidx.compose.ui.util.floatFromBits' call
      // Inline function 'kotlin.fromBits' call
      var bits_5 = convertToInt(bitwiseAnd(value_5, new Long(-1, 0)));
      var tmp_5 = floatFromBits(bits_5);
      // Inline function 'androidx.compose.ui.geometry.CornerRadius.y' call
      var this_7 = _this__u8e3s4.d5e_1;
      // Inline function 'androidx.compose.ui.util.unpackFloat2' call
      var value_6 = _CornerRadius___get_packedValue__impl__okv4jq(this_7);
      // Inline function 'androidx.compose.ui.util.floatFromBits' call
      // Inline function 'kotlin.fromBits' call
      var bits_6 = convertToInt(bitwiseAnd(value_6, new Long(-1, 0)));
      tmp = tmp_5 + floatFromBits(bits_6) <= _this__u8e3s4.i5e();
    } else {
      tmp = false;
    }
    return tmp;
  }
  function isWithinEllipse(x, y, cornerRadius, centerX, centerY) {
    var px = x - centerX;
    var py = y - centerY;
    // Inline function 'androidx.compose.ui.geometry.CornerRadius.x' call
    // Inline function 'androidx.compose.ui.util.unpackFloat1' call
    var value = _CornerRadius___get_packedValue__impl__okv4jq(cornerRadius);
    // Inline function 'androidx.compose.ui.util.floatFromBits' call
    // Inline function 'kotlin.fromBits' call
    var bits = convertToInt(shiftRight(value, 32));
    var radiusX = floatFromBits(bits);
    // Inline function 'androidx.compose.ui.geometry.CornerRadius.y' call
    // Inline function 'androidx.compose.ui.util.unpackFloat2' call
    var value_0 = _CornerRadius___get_packedValue__impl__okv4jq(cornerRadius);
    // Inline function 'androidx.compose.ui.util.floatFromBits' call
    // Inline function 'kotlin.fromBits' call
    var bits_0 = convertToInt(bitwiseAnd(value_0, new Long(-1, 0)));
    var radiusY = floatFromBits(bits_0);
    return px * px / (radiusX * radiusX) + py * py / (radiusY * radiusY) <= 1.0;
  }
  var androidx_compose_ui_platform_DelegatingSoftwareKeyboardController$stable;
  function DelegatingSoftwareKeyboardController(textInputService) {
    this.ubq_1 = textInputService;
  }
  protoOf(DelegatingSoftwareKeyboardController).vbq = function () {
    this.ubq_1.e8d();
  };
  protoOf(DelegatingSoftwareKeyboardController).wbq = function () {
    this.ubq_1.f8d();
  };
  function createPausableSubcomposition(container, parent) {
    return PausableComposition_0(createApplier(container), parent);
  }
  function createSubcomposition(container, parent) {
    return ReusableComposition(createApplier(container), parent);
  }
  function TextToolbar() {
  }
  var TextToolbarStatus_Shown_instance;
  var TextToolbarStatus_Hidden_instance;
  var TextToolbarStatus_entriesInitialized;
  function TextToolbarStatus_initEntries() {
    if (TextToolbarStatus_entriesInitialized)
      return Unit_instance;
    TextToolbarStatus_entriesInitialized = true;
    TextToolbarStatus_Shown_instance = new TextToolbarStatus('Shown', 0);
    TextToolbarStatus_Hidden_instance = new TextToolbarStatus('Hidden', 1);
  }
  function TextToolbarStatus(name, ordinal) {
    Enum.call(this, name, ordinal);
  }
  function TextToolbarStatus_Shown_getInstance() {
    TextToolbarStatus_initEntries();
    return TextToolbarStatus_Shown_instance;
  }
  function TextToolbarStatus_Hidden_getInstance() {
    TextToolbarStatus_initEntries();
    return TextToolbarStatus_Hidden_instance;
  }
  function ViewConfiguration() {
  }
  var androidx_compose_ui_platform_WindowInfoImpl$stable;
  function WindowInfo() {
  }
  function Companion_38() {
    Companion_instance_43 = this;
    this.cbr_1 = mutableStateOf(new PointerKeyboardModifiers(EmptyPointerKeyboardModifiers()));
  }
  var Companion_instance_43;
  function Companion_getInstance_64() {
    if (Companion_instance_43 == null)
      new Companion_38();
    return Companion_instance_43;
  }
  function WindowInfoImpl$_get_isWindowFocused_$ref_esmu65() {
    return constructCallableReference(function (p0) {
      return p0.abr();
    }, 1, 0, 64);
  }
  function WindowInfoImpl$_set_isWindowFocused_$ref_1hwl9t() {
    return constructCallableReference(function (p0, p1) {
      p0.gbr(p1);
      return Unit_instance;
    }, 2, 0, 65);
  }
  function WindowInfoImpl() {
    Companion_getInstance_64();
    this.dbr_1 = mutableStateOf(new IntSize(Companion_getInstance_0().n5g_1));
    this.ebr_1 = mutableStateOf(new DpSize_0(Companion_getInstance_13().h5f_1));
    this.fbr_1 = mutableStateOf(false);
  }
  protoOf(WindowInfoImpl).gbr = function (_set____db54di) {
    var tmp0 = this.fbr_1;
    var tmp = KMutableProperty1;
    var tmp_0 = WindowInfoImpl$_get_isWindowFocused_$ref_esmu65();
    // Inline function 'androidx.compose.runtime.setValue' call
    getPropertyCallableRef('isWindowFocused', 1, tmp, tmp_0, WindowInfoImpl$_set_isWindowFocused_$ref_1hwl9t());
    tmp0.s21(_set____db54di);
    return Unit_instance;
  };
  protoOf(WindowInfoImpl).abr = function () {
    var tmp0 = this.fbr_1;
    var tmp = KMutableProperty1;
    var tmp_0 = WindowInfoImpl$_get_isWindowFocused_$ref_esmu65();
    // Inline function 'androidx.compose.runtime.getValue' call
    getPropertyCallableRef('isWindowFocused', 1, tmp, tmp_0, WindowInfoImpl$_set_isWindowFocused_$ref_1hwl9t());
    return tmp0.u1();
  };
  protoOf(WindowInfoImpl).hbr = function (value) {
    this.dbr_1.s21(new IntSize(value));
  };
  protoOf(WindowInfoImpl).bbr = function () {
    return this.dbr_1.u1().o5g_1;
  };
  protoOf(WindowInfoImpl).ibr = function (value) {
    this.ebr_1.s21(new DpSize_0(value));
  };
  function bringIntoView(_this__u8e3s4, bounds, $completion) {
    bounds = bounds === VOID ? null : bounds;
    if (!_this__u8e3s4.f4n().z8v_1)
      return Unit_instance;
    // Inline function 'androidx.compose.ui.node.Nodes.BringIntoView' call
    var tmp2 = _NodeKind___init__impl__ojsprp(524288);
    var tmp$ret$1;
    $l$block: {
      // Inline function 'androidx.compose.ui.node.nearestAncestor' call
      // Inline function 'androidx.compose.ui.node.visitAncestors' call
      // Inline function 'androidx.compose.ui.node.visitAncestors' call
      var mask = _NodeKind___get_mask__impl__1uopb6(tmp2);
      // Inline function 'androidx.compose.ui.internal.checkPrecondition' call
      if (!_this__u8e3s4.f4n().z8v_1) {
        var tmp$ret$5 = 'visitAncestors called on an unattached node';
        throwIllegalStateException(tmp$ret$5);
      }
      var node = false ? _this__u8e3s4.f4n() : _this__u8e3s4.f4n().q8v_1;
      var layout = requireLayoutNode(_this__u8e3s4);
      while (!(layout == null)) {
        var head = layout.d91_1.j99_1;
        if (!((head.p8v_1 & mask) === 0)) {
          while (!(node == null)) {
            if (!((node.o8v_1 & mask) === 0)) {
              // Inline function 'androidx.compose.ui.node.dispatchForKind' call
              var stack = null;
              var node_0 = node;
              $l$loop: while (!(node_0 == null)) {
                var tmp;
                if (isInterface(node_0, BringIntoViewModifierNode)) {
                  tmp$ret$1 = node_0;
                  break $l$block;
                } else {
                  tmp = true;
                }
                var dispatchAgain = tmp;
                var tmp_0;
                var tmp_1;
                if (dispatchAgain || false) {
                  // Inline function 'androidx.compose.ui.Node.isKind' call
                  tmp_1 = !((node_0.o8v_1 & _NodeKind___get_mask__impl__1uopb6(tmp2)) === 0);
                } else {
                  tmp_1 = false;
                }
                if (tmp_1) {
                  tmp_0 = node_0 instanceof DelegatingNode;
                } else {
                  tmp_0 = false;
                }
                if (tmp_0) {
                  var count = 0;
                  // Inline function 'androidx.compose.ui.node.DelegatingNode.forEachImmediateDelegate' call
                  var node_1 = node_0.e9a_1;
                  while (!(node_1 == null)) {
                    var next = node_1;
                    // Inline function 'androidx.compose.ui.Node.isKind' call
                    if (!((next.o8v_1 & _NodeKind___get_mask__impl__1uopb6(tmp2)) === 0)) {
                      count = count + 1 | 0;
                      if (count === 1) {
                        node_0 = next;
                      } else {
                        var tmp0_elvis_lhs = stack;
                        var tmp_2;
                        if (tmp0_elvis_lhs == null) {
                          // Inline function 'androidx.compose.runtime.collection.mutableVectorOf' call
                          // Inline function 'androidx.compose.runtime.collection.MutableVector' call
                          // Inline function 'kotlin.arrayOfNulls' call
                          var tmp$ret$15 = Array(16);
                          tmp_2 = new MutableVector(tmp$ret$15, 0);
                        } else {
                          tmp_2 = tmp0_elvis_lhs;
                        }
                        stack = tmp_2;
                        var theNode = node_0;
                        if (!(theNode == null)) {
                          var tmp1_safe_receiver = stack;
                          if (tmp1_safe_receiver == null)
                            null;
                          else
                            tmp1_safe_receiver.zz(theNode);
                          node_0 = null;
                        }
                        var tmp2_safe_receiver = stack;
                        if (tmp2_safe_receiver == null)
                          null;
                        else
                          tmp2_safe_receiver.zz(next);
                      }
                    }
                    node_1 = node_1.r8v_1;
                  }
                  if (count === 1) {
                    continue $l$loop;
                  }
                }
                node_0 = access$pop$tDelegatableNodeKt(stack);
              }
            }
            node = node.q8v_1;
          }
        }
        layout = layout.f9a();
        var tmp0_safe_receiver = layout;
        var tmp1_safe_receiver_0 = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.d91_1;
        node = tmp1_safe_receiver_0 == null ? null : tmp1_safe_receiver_0.i99_1;
      }
      tmp$ret$1 = null;
    }
    var tmp0_elvis_lhs_0 = tmp$ret$1;
    var tmp_3;
    if (tmp0_elvis_lhs_0 == null) {
      return Unit_instance;
    } else {
      tmp_3 = tmp0_elvis_lhs_0;
    }
    var parent = tmp_3;
    var layoutCoordinates = requireLayoutCoordinates(_this__u8e3s4);
    return parent.jbr(layoutCoordinates, bringIntoView$lambda(bounds, layoutCoordinates), $completion);
  }
  function BringIntoViewModifierNode() {
  }
  function bringIntoView$lambda($bounds, $layoutCoordinates) {
    return function () {
      var tmp0_safe_receiver = $bounds;
      var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : tmp0_safe_receiver();
      var tmp;
      if (tmp1_elvis_lhs == null) {
        // Inline function 'kotlin.takeIf' call
        var this_0 = $layoutCoordinates;
        var tmp_0;
        if (this_0.y91()) {
          tmp_0 = this_0;
        } else {
          tmp_0 = null;
        }
        var tmp2_safe_receiver = tmp_0;
        var tmp3_safe_receiver = tmp2_safe_receiver == null ? null : tmp2_safe_receiver.q95();
        var tmp_1;
        var tmp_2 = tmp3_safe_receiver;
        if ((tmp_2 == null ? null : new IntSize(tmp_2)) == null) {
          tmp_1 = null;
        } else {
          tmp_1 = toSize(tmp3_safe_receiver);
        }
        var tmp4_safe_receiver = tmp_1;
        var tmp_3;
        var tmp_4 = tmp4_safe_receiver;
        if ((tmp_4 == null ? null : new Size(tmp_4)) == null) {
          tmp_3 = null;
        } else {
          tmp_3 = toRect(tmp4_safe_receiver);
        }
        tmp = tmp_3;
      } else {
        tmp = tmp1_elvis_lhs;
      }
      return tmp;
    };
  }
  var androidx_compose_ui_semantics_SemanticsConfiguration$stable;
  function SemanticsConfiguration() {
    this.mb0_1 = mutableScatterMapOf();
    this.nb0_1 = null;
    this.ob0_1 = null;
    this.pb0_1 = false;
    this.qb0_1 = false;
  }
  protoOf(SemanticsConfiguration).kbr = function (key) {
    // Inline function 'androidx.collection.ScatterMap.getOrElse' call
    var tmp0_elvis_lhs = this.mb0_1.w2(key);
    var tmp;
    if (tmp0_elvis_lhs == null) {
      throw IllegalStateException_init_$Create$('Key not present: ' + key.toString() + ' - consider getOrElse or getOrNull');
    } else {
      tmp = tmp0_elvis_lhs;
    }
    return tmp;
  };
  protoOf(SemanticsConfiguration).lbr = function (key, defaultValue) {
    // Inline function 'androidx.collection.ScatterMap.getOrElse' call
    var tmp0_elvis_lhs = this.mb0_1.w2(key);
    return tmp0_elvis_lhs == null ? defaultValue() : tmp0_elvis_lhs;
  };
  protoOf(SemanticsConfiguration).t = function () {
    var tmp0_elvis_lhs = this.nb0_1;
    var tmp;
    if (tmp0_elvis_lhs == null) {
      // Inline function 'kotlin.apply' call
      var this_0 = this.mb0_1.l13();
      this.nb0_1 = this_0;
      tmp = this_0;
    } else {
      tmp = tmp0_elvis_lhs;
    }
    var mapWrapper = tmp;
    // Inline function 'kotlin.collections.iterator' call
    return mapWrapper.s1().t();
  };
  protoOf(SemanticsConfiguration).mbr = function (key, value) {
    var tmp;
    if (value instanceof AccessibilityAction) {
      tmp = this.nbr(key);
    } else {
      tmp = false;
    }
    if (tmp) {
      var tmp_0 = this.mb0_1.w2(key);
      var prev = tmp_0 instanceof AccessibilityAction ? tmp_0 : THROW_CCE();
      var tmp0_elvis_lhs = value.obr_1;
      var tmp_1 = tmp0_elvis_lhs == null ? prev.obr_1 : tmp0_elvis_lhs;
      var tmp1_elvis_lhs = value.pbr_1;
      this.mb0_1.h13(key, new AccessibilityAction(tmp_1, tmp1_elvis_lhs == null ? prev.pbr_1 : tmp1_elvis_lhs));
    } else {
      this.mb0_1.h13(key, value);
    }
    if (!(key.tbr_1 == null)) {
      if (this.ob0_1 == null)
        this.ob0_1 = mutableScatterSetOf();
      var tmp2_safe_receiver = this.ob0_1;
      if (tmp2_safe_receiver == null)
        null;
      else
        tmp2_safe_receiver.j1(key);
    }
  };
  protoOf(SemanticsConfiguration).nbr = function (key) {
    return this.mb0_1.u2(key);
  };
  protoOf(SemanticsConfiguration).ubr = function () {
    var tmp0 = this.mb0_1;
    var tmp$ret$0;
    $l$block: {
      // Inline function 'androidx.collection.ScatterMap.any' call
      // Inline function 'androidx.collection.ScatterMap.forEach' call
      var k = tmp0.x12_1;
      var v = tmp0.y12_1;
      $l$block_0: {
        // Inline function 'androidx.collection.ScatterMap.forEachIndexed' call
        var m = tmp0.w12_1;
        var lastIndex = m.length - 2 | 0;
        var inductionVariable = 0;
        if (inductionVariable <= lastIndex)
          do {
            var i = inductionVariable;
            inductionVariable = inductionVariable + 1 | 0;
            var slot = m[i];
            // Inline function 'androidx.collection.maskEmptyOrDeleted' call
            var this_0 = slot;
            var tmp$ret$3 = bitwiseAnd(bitwiseAnd(this_0, shiftLeft(invert(this_0), 7)), new Long(-2139062144, -2139062144));
            if (!equalsLong(tmp$ret$3, new Long(-2139062144, -2139062144))) {
              var bitCount = 8 - (~(i - lastIndex | 0) >>> 31 | 0) | 0;
              var inductionVariable_0 = 0;
              if (inductionVariable_0 < bitCount)
                do {
                  var j = inductionVariable_0;
                  inductionVariable_0 = inductionVariable_0 + 1 | 0;
                  // Inline function 'androidx.collection.isFull' call
                  var value = bitwiseAnd(slot, new Long(255, 0));
                  if (compare(value, new Long(128, 0)) < 0) {
                    var index = (i << 3) + j | 0;
                    var tmp0_0 = k[index];
                    v[index];
                    if (tmp0_0.sbr_1) {
                      tmp$ret$0 = true;
                      break $l$block;
                    }
                  }
                  slot = shiftRight(slot, 8);
                }
                 while (inductionVariable_0 < bitCount);
              if (!(bitCount === 8)) {
                break $l$block_0;
              }
            }
          }
           while (!(i === lastIndex));
      }
      tmp$ret$0 = false;
    }
    return tmp$ret$0;
  };
  protoOf(SemanticsConfiguration).vbr = function (child) {
    // Inline function 'androidx.collection.ScatterMap.forEach' call
    var this_0 = child.mb0_1;
    var k = this_0.x12_1;
    var v = this_0.y12_1;
    $l$block: {
      // Inline function 'androidx.collection.ScatterMap.forEachIndexed' call
      var m = this_0.w12_1;
      var lastIndex = m.length - 2 | 0;
      var inductionVariable = 0;
      if (inductionVariable <= lastIndex)
        do {
          var i = inductionVariable;
          inductionVariable = inductionVariable + 1 | 0;
          var slot = m[i];
          // Inline function 'androidx.collection.maskEmptyOrDeleted' call
          var this_1 = slot;
          var tmp$ret$2 = bitwiseAnd(bitwiseAnd(this_1, shiftLeft(invert(this_1), 7)), new Long(-2139062144, -2139062144));
          if (!equalsLong(tmp$ret$2, new Long(-2139062144, -2139062144))) {
            var bitCount = 8 - (~(i - lastIndex | 0) >>> 31 | 0) | 0;
            var inductionVariable_0 = 0;
            if (inductionVariable_0 < bitCount)
              do {
                var j = inductionVariable_0;
                inductionVariable_0 = inductionVariable_0 + 1 | 0;
                // Inline function 'androidx.collection.isFull' call
                var value = bitwiseAnd(slot, new Long(255, 0));
                if (compare(value, new Long(128, 0)) < 0) {
                  var index = (i << 3) + j | 0;
                  var tmp0 = k[index];
                  var nextValue = v[index];
                  var existingValue = this.mb0_1.w2(tmp0);
                  var mergeResult = (tmp0 instanceof SemanticsPropertyKey ? tmp0 : THROW_CCE()).wbr(existingValue, nextValue);
                  if (!(mergeResult == null)) {
                    this.mb0_1.h13(tmp0, mergeResult);
                  }
                }
                slot = shiftRight(slot, 8);
              }
               while (inductionVariable_0 < bitCount);
            if (!(bitCount === 8)) {
              break $l$block;
            }
          }
        }
         while (!(i === lastIndex));
    }
  };
  protoOf(SemanticsConfiguration).rb0 = function (peer) {
    if (peer.pb0_1) {
      this.pb0_1 = true;
    }
    if (peer.qb0_1) {
      this.qb0_1 = true;
    }
    // Inline function 'androidx.collection.ScatterMap.forEach' call
    var this_0 = peer.mb0_1;
    var k = this_0.x12_1;
    var v = this_0.y12_1;
    $l$block: {
      // Inline function 'androidx.collection.ScatterMap.forEachIndexed' call
      var m = this_0.w12_1;
      var lastIndex = m.length - 2 | 0;
      var inductionVariable = 0;
      if (inductionVariable <= lastIndex)
        do {
          var i = inductionVariable;
          inductionVariable = inductionVariable + 1 | 0;
          var slot = m[i];
          // Inline function 'androidx.collection.maskEmptyOrDeleted' call
          var this_1 = slot;
          var tmp$ret$2 = bitwiseAnd(bitwiseAnd(this_1, shiftLeft(invert(this_1), 7)), new Long(-2139062144, -2139062144));
          if (!equalsLong(tmp$ret$2, new Long(-2139062144, -2139062144))) {
            var bitCount = 8 - (~(i - lastIndex | 0) >>> 31 | 0) | 0;
            var inductionVariable_0 = 0;
            if (inductionVariable_0 < bitCount)
              do {
                var j = inductionVariable_0;
                inductionVariable_0 = inductionVariable_0 + 1 | 0;
                // Inline function 'androidx.collection.isFull' call
                var value = bitwiseAnd(slot, new Long(255, 0));
                if (compare(value, new Long(128, 0)) < 0) {
                  var index = (i << 3) + j | 0;
                  var tmp0 = k[index];
                  var nextValue = v[index];
                  if (!this.mb0_1.d6(tmp0)) {
                    this.mb0_1.h13(tmp0, nextValue);
                  } else {
                    if (nextValue instanceof AccessibilityAction) {
                      var tmp = this.mb0_1.w2(tmp0);
                      var value_0 = tmp instanceof AccessibilityAction ? tmp : THROW_CCE();
                      var tmp0_elvis_lhs = value_0.obr_1;
                      var tmp_0 = tmp0_elvis_lhs == null ? nextValue.obr_1 : tmp0_elvis_lhs;
                      var tmp1_elvis_lhs = value_0.pbr_1;
                      this.mb0_1.h13(tmp0, new AccessibilityAction(tmp_0, tmp1_elvis_lhs == null ? nextValue.pbr_1 : tmp1_elvis_lhs));
                    }
                  }
                }
                slot = shiftRight(slot, 8);
              }
               while (inductionVariable_0 < bitCount);
            if (!(bitCount === 8)) {
              break $l$block;
            }
          }
        }
         while (!(i === lastIndex));
    }
  };
  protoOf(SemanticsConfiguration).xbr = function () {
    var copy = new SemanticsConfiguration();
    copy.pb0_1 = this.pb0_1;
    copy.qb0_1 = this.qb0_1;
    copy.mb0_1.k13(this.mb0_1);
    return copy;
  };
  protoOf(SemanticsConfiguration).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof SemanticsConfiguration))
      return false;
    if (!this.mb0_1.equals(other.mb0_1))
      return false;
    if (!(this.pb0_1 === other.pb0_1))
      return false;
    if (!(this.qb0_1 === other.qb0_1))
      return false;
    return true;
  };
  protoOf(SemanticsConfiguration).hashCode = function () {
    var result = this.mb0_1.hashCode();
    result = imul(31, result) + getBooleanHashCode(this.pb0_1) | 0;
    result = imul(31, result) + getBooleanHashCode(this.qb0_1) | 0;
    return result;
  };
  protoOf(SemanticsConfiguration).toString = function () {
    var propsString = StringBuilder_init_$Create$();
    var nextSeparator = '';
    if (this.pb0_1) {
      propsString.q(nextSeparator);
      propsString.q('mergeDescendants=true');
      nextSeparator = ', ';
    }
    if (this.qb0_1) {
      propsString.q(nextSeparator);
      propsString.q('isClearingSemantics=true');
      nextSeparator = ', ';
    }
    // Inline function 'androidx.collection.ScatterMap.forEach' call
    var this_0 = this.mb0_1;
    var k = this_0.x12_1;
    var v = this_0.y12_1;
    $l$block: {
      // Inline function 'androidx.collection.ScatterMap.forEachIndexed' call
      var m = this_0.w12_1;
      var lastIndex = m.length - 2 | 0;
      var inductionVariable = 0;
      if (inductionVariable <= lastIndex)
        do {
          var i = inductionVariable;
          inductionVariable = inductionVariable + 1 | 0;
          var slot = m[i];
          // Inline function 'androidx.collection.maskEmptyOrDeleted' call
          var this_1 = slot;
          var tmp$ret$2 = bitwiseAnd(bitwiseAnd(this_1, shiftLeft(invert(this_1), 7)), new Long(-2139062144, -2139062144));
          if (!equalsLong(tmp$ret$2, new Long(-2139062144, -2139062144))) {
            var bitCount = 8 - (~(i - lastIndex | 0) >>> 31 | 0) | 0;
            var inductionVariable_0 = 0;
            if (inductionVariable_0 < bitCount)
              do {
                var j = inductionVariable_0;
                inductionVariable_0 = inductionVariable_0 + 1 | 0;
                // Inline function 'androidx.collection.isFull' call
                var value = bitwiseAnd(slot, new Long(255, 0));
                if (compare(value, new Long(128, 0)) < 0) {
                  var index = (i << 3) + j | 0;
                  var tmp0 = k[index];
                  var value_0 = v[index];
                  propsString.q(nextSeparator);
                  propsString.q(tmp0.qbr_1);
                  propsString.q(' : ');
                  propsString.w(value_0);
                  nextSeparator = ', ';
                }
                slot = shiftRight(slot, 8);
              }
               while (inductionVariable_0 < bitCount);
            if (!(bitCount === 8)) {
              break $l$block;
            }
          }
        }
         while (!(i === lastIndex));
    }
    return simpleIdentityToString(this, null) + '{ ' + propsString.toString() + ' }';
  };
  function getOrNull_0(_this__u8e3s4, key) {
    return _this__u8e3s4.lbr(key, getOrNull$lambda);
  }
  function getOrNull$lambda() {
    return null;
  }
  function get_lastIdentifier() {
    _init_properties_SemanticsModifier_kt__yd9o4y();
    return lastIdentifier;
  }
  var lastIdentifier;
  var androidx_compose_ui_semantics_CoreSemanticsModifierNode$stable;
  var androidx_compose_ui_semantics_EmptySemanticsModifier$stable;
  var androidx_compose_ui_semantics_AppendedSemanticsElement$stable;
  var androidx_compose_ui_semantics_ClearAndSetSemanticsElement$stable;
  function clearAndSetSemantics(_this__u8e3s4, properties) {
    _init_properties_SemanticsModifier_kt__yd9o4y();
    return _this__u8e3s4.d8v(new ClearAndSetSemanticsElement(properties));
  }
  function semantics(_this__u8e3s4, mergeDescendants, properties) {
    mergeDescendants = mergeDescendants === VOID ? false : mergeDescendants;
    _init_properties_SemanticsModifier_kt__yd9o4y();
    return _this__u8e3s4.d8v(new AppendedSemanticsElement(mergeDescendants, properties));
  }
  function SemanticsModifier() {
  }
  function generateSemanticsId() {
    _init_properties_SemanticsModifier_kt__yd9o4y();
    return get_lastIdentifier().zbr(1);
  }
  function ClearAndSetSemanticsElement(properties) {
    ModifierNodeElement.call(this);
    this.bbs_1 = properties;
  }
  protoOf(ClearAndSetSemanticsElement).lb0 = function () {
    // Inline function 'kotlin.apply' call
    var this_0 = new SemanticsConfiguration();
    this_0.pb0_1 = false;
    this_0.qb0_1 = true;
    this.bbs_1(this_0);
    return this_0;
  };
  protoOf(ClearAndSetSemanticsElement).r3d = function () {
    return new CoreSemanticsModifierNode(false, true, this.bbs_1);
  };
  protoOf(ClearAndSetSemanticsElement).cbs = function (node) {
    node.tbs_1 = this.bbs_1;
  };
  protoOf(ClearAndSetSemanticsElement).d8y = function (node) {
    return this.cbs(node instanceof CoreSemanticsModifierNode ? node : THROW_CCE());
  };
  protoOf(ClearAndSetSemanticsElement).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof ClearAndSetSemanticsElement))
      return false;
    if (!(this.bbs_1 === other.bbs_1))
      return false;
    return true;
  };
  protoOf(ClearAndSetSemanticsElement).hashCode = function () {
    return hashCode(this.bbs_1);
  };
  function AppendedSemanticsElement(mergeDescendants, properties) {
    ModifierNodeElement.call(this);
    this.vbs_1 = mergeDescendants;
    this.wbs_1 = properties;
  }
  protoOf(AppendedSemanticsElement).lb0 = function () {
    // Inline function 'kotlin.apply' call
    var this_0 = new SemanticsConfiguration();
    this_0.pb0_1 = this.vbs_1;
    this.wbs_1(this_0);
    return this_0;
  };
  protoOf(AppendedSemanticsElement).r3d = function () {
    return new CoreSemanticsModifierNode(this.vbs_1, false, this.wbs_1);
  };
  protoOf(AppendedSemanticsElement).cbs = function (node) {
    node.rbs_1 = this.vbs_1;
    node.tbs_1 = this.wbs_1;
  };
  protoOf(AppendedSemanticsElement).d8y = function (node) {
    return this.cbs(node instanceof CoreSemanticsModifierNode ? node : THROW_CCE());
  };
  protoOf(AppendedSemanticsElement).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof AppendedSemanticsElement))
      return false;
    if (!(this.vbs_1 === other.vbs_1))
      return false;
    if (!(this.wbs_1 === other.wbs_1))
      return false;
    return true;
  };
  protoOf(AppendedSemanticsElement).hashCode = function () {
    var result = getBooleanHashCode(this.vbs_1);
    result = imul(31, result) + hashCode(this.wbs_1) | 0;
    return result;
  };
  function CoreSemanticsModifierNode(mergeDescendants, isClearingSemantics, properties) {
    Node.call(this);
    this.rbs_1 = mergeDescendants;
    this.sbs_1 = isClearingSemantics;
    this.tbs_1 = properties;
  }
  protoOf(CoreSemanticsModifierNode).k9j = function () {
    return this.sbs_1;
  };
  protoOf(CoreSemanticsModifierNode).l9j = function () {
    return this.rbs_1;
  };
  protoOf(CoreSemanticsModifierNode).l9i = function (_this__u8e3s4) {
    this.tbs_1(_this__u8e3s4);
  };
  function EmptySemanticsModifier() {
    Node.call(this);
  }
  protoOf(EmptySemanticsModifier).l9i = function (_this__u8e3s4) {
  };
  var properties_initialized_SemanticsModifier_kt_d25qs;
  function _init_properties_SemanticsModifier_kt__yd9o4y() {
    if (!properties_initialized_SemanticsModifier_kt_d25qs) {
      properties_initialized_SemanticsModifier_kt_d25qs = true;
      lastIdentifier = new AtomicInt(0);
      androidx_compose_ui_semantics_CoreSemanticsModifierNode$stable = 8;
      androidx_compose_ui_semantics_EmptySemanticsModifier$stable = 8;
      androidx_compose_ui_semantics_AppendedSemanticsElement$stable = 0;
      androidx_compose_ui_semantics_ClearAndSetSemanticsElement$stable = 0;
    }
  }
  var androidx_compose_ui_semantics_SemanticsNode$stable;
  function mergeConfig($this, unmergedChildren, mergedConfig) {
    if (!$this.obt_1.qb0_1) {
      // Inline function 'androidx.compose.ui.semantics.SemanticsNode.forEachUnmergedChild' call
      var start = unmergedChildren.n1();
      $this.rbt(unmergedChildren);
      var end = unmergedChildren.n1();
      var inductionVariable = start;
      if (inductionVariable < end)
        do {
          var i = inductionVariable;
          inductionVariable = inductionVariable + 1 | 0;
          var child = unmergedChildren.l1(i);
          if (!_get_isMergingSemanticsOfDescendants__b73llg(child)) {
            mergedConfig.vbr(child.obt_1);
            mergeConfig(child, unmergedChildren, mergedConfig);
          }
        }
         while (inductionVariable < end);
    }
  }
  function _get_isMergingSemanticsOfDescendants__b73llg($this) {
    return $this.mbt_1 && $this.obt_1.pb0_1;
  }
  function fillOneLayerOfSemanticsWrappers($this, $receiver, list, includeDeactivatedNodes) {
    // Inline function 'androidx.compose.runtime.collection.MutableVector.forEach' call
    var this_0 = $receiver.sb1();
    var i = 0;
    var tmp = this_0.b3e_1;
    var content = isArray(tmp) ? tmp : THROW_CCE();
    var size = this_0.d3e_1;
    while (i < size) {
      var child = content[i];
      if (child.y91() && (includeDeactivatedNodes || !child.o91_1)) {
        // Inline function 'androidx.compose.ui.node.Nodes.Semantics' call
        var tmp$ret$2 = _NodeKind___init__impl__ojsprp(8);
        if (child.d91_1.abb(tmp$ret$2)) {
          list.j1(SemanticsNode_0(child, $this.mbt_1));
        } else {
          fillOneLayerOfSemanticsWrappers($this, child, list, includeDeactivatedNodes);
        }
      }
      i = i + 1 | 0;
    }
  }
  function findOneLayerOfMergingSemanticsNodes($this, unmergedChildren, list) {
    var tmp;
    if (list === VOID) {
      // Inline function 'kotlin.collections.mutableListOf' call
      tmp = ArrayList_init_$Create$();
    } else {
      tmp = list;
    }
    list = tmp;
    // Inline function 'androidx.compose.ui.semantics.SemanticsNode.forEachUnmergedChild' call
    var start = unmergedChildren.n1();
    $this.rbt(unmergedChildren);
    var end = unmergedChildren.n1();
    var inductionVariable = start;
    if (inductionVariable < end)
      do {
        var i = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var child = unmergedChildren.l1(i);
        if (_get_isMergingSemanticsOfDescendants__b73llg(child)) {
          list.j1(child);
        } else {
          if (!child.obt_1.qb0_1) {
            findOneLayerOfMergingSemanticsNodes(child, unmergedChildren, list);
          }
        }
      }
       while (inductionVariable < end);
    return list;
  }
  function findSemanticsModifierNodeToGetBounds($this) {
    var nodeForBounds = null;
    if ($this.obt_1.pb0_1) {
      var tmp0 = $this.nbt_1.d91_1;
      // Inline function 'androidx.compose.ui.node.Nodes.Semantics' call
      // Inline function 'androidx.compose.ui.node.NodeChain.headToTail' call
      var type = _NodeKind___init__impl__ojsprp(8);
      var tmp2 = _NodeKind___get_mask__impl__1uopb6(type);
      $l$block_0: {
        // Inline function 'androidx.compose.ui.node.NodeChain.headToTail' call
        if ((access$_get_aggregateChildKindSet__pv81sw(tmp0) & tmp2) === 0) {
          break $l$block_0;
        }
        // Inline function 'androidx.compose.ui.node.NodeChain.headToTail' call
        var node = tmp0.j99_1;
        while (!(node == null)) {
          var it = node;
          if (!((it.o8v_1 & tmp2) === 0)) {
            // Inline function 'androidx.compose.ui.node.dispatchForKind' call
            // Inline function 'androidx.compose.ui.node.dispatchForKind' call
            var stack = null;
            var node_0 = it;
            $l$loop: while (!(node_0 == null)) {
              var tmp;
              if (isInterface(node_0, SemanticsModifierNode)) {
                var it_0 = node_0;
                if (it_0.k9i()) {
                  if (it_0.l9j())
                    return it_0;
                  if (nodeForBounds == null)
                    nodeForBounds = it_0;
                }
                tmp = false;
              } else {
                tmp = true;
              }
              var dispatchAgain = tmp;
              var tmp_0;
              var tmp_1;
              if (dispatchAgain || false) {
                // Inline function 'androidx.compose.ui.Node.isKind' call
                tmp_1 = !((node_0.o8v_1 & _NodeKind___get_mask__impl__1uopb6(type)) === 0);
              } else {
                tmp_1 = false;
              }
              if (tmp_1) {
                tmp_0 = node_0 instanceof DelegatingNode;
              } else {
                tmp_0 = false;
              }
              if (tmp_0) {
                var count = 0;
                // Inline function 'androidx.compose.ui.node.DelegatingNode.forEachImmediateDelegate' call
                var node_1 = node_0.e9a_1;
                while (!(node_1 == null)) {
                  var next = node_1;
                  // Inline function 'androidx.compose.ui.Node.isKind' call
                  if (!((next.o8v_1 & _NodeKind___get_mask__impl__1uopb6(type)) === 0)) {
                    count = count + 1 | 0;
                    if (count === 1) {
                      node_0 = next;
                    } else {
                      var tmp0_elvis_lhs = stack;
                      var tmp_2;
                      if (tmp0_elvis_lhs == null) {
                        // Inline function 'androidx.compose.runtime.collection.mutableVectorOf' call
                        // Inline function 'androidx.compose.runtime.collection.MutableVector' call
                        // Inline function 'kotlin.arrayOfNulls' call
                        var tmp$ret$15 = Array(16);
                        tmp_2 = new MutableVector(tmp$ret$15, 0);
                      } else {
                        tmp_2 = tmp0_elvis_lhs;
                      }
                      stack = tmp_2;
                      var theNode = node_0;
                      if (!(theNode == null)) {
                        var tmp1_safe_receiver = stack;
                        if (tmp1_safe_receiver == null)
                          null;
                        else
                          tmp1_safe_receiver.zz(theNode);
                        node_0 = null;
                      }
                      var tmp2_safe_receiver = stack;
                      if (tmp2_safe_receiver == null)
                        null;
                      else
                        tmp2_safe_receiver.zz(next);
                    }
                  }
                  node_1 = node_1.r8v_1;
                }
                if (count === 1) {
                  continue $l$loop;
                }
              }
              node_0 = access$pop$tDelegatableNodeKt(stack);
            }
          }
          if ((it.p8v_1 & tmp2) === 0) {
            break $l$block_0;
          }
          node = node.r8v_1;
        }
      }
    } else {
      var tmp0_0 = $this.nbt_1.d91_1;
      // Inline function 'androidx.compose.ui.node.Nodes.Semantics' call
      var tmp2_0 = _NodeKind___init__impl__ojsprp(8);
      var tmp$ret$17;
      $l$block_2: {
        // Inline function 'androidx.compose.ui.node.NodeChain.firstFromHead' call
        // Inline function 'androidx.compose.ui.node.NodeChain.headToTail' call
        var tmp2_1 = _NodeKind___get_mask__impl__1uopb6(tmp2_0);
        $l$block_3: {
          // Inline function 'androidx.compose.ui.node.NodeChain.headToTail' call
          if ((access$_get_aggregateChildKindSet__pv81sw(tmp0_0) & tmp2_1) === 0) {
            break $l$block_3;
          }
          // Inline function 'androidx.compose.ui.node.NodeChain.headToTail' call
          var node_2 = tmp0_0.j99_1;
          while (!(node_2 == null)) {
            var it_1 = node_2;
            if (!((it_1.o8v_1 & tmp2_1) === 0)) {
              // Inline function 'androidx.compose.ui.node.dispatchForKind' call
              // Inline function 'androidx.compose.ui.node.dispatchForKind' call
              var stack_0 = null;
              var node_3 = it_1;
              $l$loop_0: while (!(node_3 == null)) {
                var tmp_3;
                if (isInterface(node_3, SemanticsModifierNode)) {
                  var it_2 = node_3;
                  if (it_2.k9i()) {
                    tmp$ret$17 = it_2;
                    break $l$block_2;
                  }
                  tmp_3 = false;
                } else {
                  tmp_3 = true;
                }
                var dispatchAgain_0 = tmp_3;
                var tmp_4;
                var tmp_5;
                if (dispatchAgain_0 || false) {
                  // Inline function 'androidx.compose.ui.Node.isKind' call
                  tmp_5 = !((node_3.o8v_1 & _NodeKind___get_mask__impl__1uopb6(tmp2_0)) === 0);
                } else {
                  tmp_5 = false;
                }
                if (tmp_5) {
                  tmp_4 = node_3 instanceof DelegatingNode;
                } else {
                  tmp_4 = false;
                }
                if (tmp_4) {
                  var count_0 = 0;
                  // Inline function 'androidx.compose.ui.node.DelegatingNode.forEachImmediateDelegate' call
                  var node_4 = node_3.e9a_1;
                  while (!(node_4 == null)) {
                    var next_0 = node_4;
                    // Inline function 'androidx.compose.ui.Node.isKind' call
                    if (!((next_0.o8v_1 & _NodeKind___get_mask__impl__1uopb6(tmp2_0)) === 0)) {
                      count_0 = count_0 + 1 | 0;
                      if (count_0 === 1) {
                        node_3 = next_0;
                      } else {
                        var tmp0_elvis_lhs_0 = stack_0;
                        var tmp_6;
                        if (tmp0_elvis_lhs_0 == null) {
                          // Inline function 'androidx.compose.runtime.collection.mutableVectorOf' call
                          // Inline function 'androidx.compose.runtime.collection.MutableVector' call
                          // Inline function 'kotlin.arrayOfNulls' call
                          var tmp$ret$33 = Array(16);
                          tmp_6 = new MutableVector(tmp$ret$33, 0);
                        } else {
                          tmp_6 = tmp0_elvis_lhs_0;
                        }
                        stack_0 = tmp_6;
                        var theNode_0 = node_3;
                        if (!(theNode_0 == null)) {
                          var tmp1_safe_receiver_0 = stack_0;
                          if (tmp1_safe_receiver_0 == null)
                            null;
                          else
                            tmp1_safe_receiver_0.zz(theNode_0);
                          node_3 = null;
                        }
                        var tmp2_safe_receiver_0 = stack_0;
                        if (tmp2_safe_receiver_0 == null)
                          null;
                        else
                          tmp2_safe_receiver_0.zz(next_0);
                      }
                    }
                    node_4 = node_4.r8v_1;
                  }
                  if (count_0 === 1) {
                    continue $l$loop_0;
                  }
                }
                node_3 = access$pop$tDelegatableNodeKt(stack_0);
              }
            }
            if ((it_1.p8v_1 & tmp2_1) === 0) {
              break $l$block_3;
            }
            node_2 = node_2.r8v_1;
          }
        }
        tmp$ret$17 = null;
      }
      nodeForBounds = tmp$ret$17;
    }
    return nodeForBounds;
  }
  function emitFakeNodes($this, unmergedChildren) {
    var nodeRole = get_role($this);
    var tmp;
    var tmp_0;
    var tmp_1 = nodeRole;
    if (!((tmp_1 == null ? null : new Role(tmp_1)) == null)) {
      tmp_0 = $this.obt_1.pb0_1;
    } else {
      tmp_0 = false;
    }
    if (tmp_0) {
      // Inline function 'kotlin.collections.isNotEmpty' call
      tmp = !unmergedChildren.r();
    } else {
      tmp = false;
    }
    if (tmp) {
      var fakeNode = fakeSemanticsNode($this, nodeRole, SemanticsNode$emitFakeNodes$lambda(nodeRole));
      unmergedChildren.j1(fakeNode);
    }
    var tmp_2;
    var tmp_3;
    if ($this.obt_1.nbr(SemanticsProperties_getInstance().sbt_1)) {
      // Inline function 'kotlin.collections.isNotEmpty' call
      tmp_3 = !unmergedChildren.r();
    } else {
      tmp_3 = false;
    }
    if (tmp_3) {
      tmp_2 = $this.obt_1.pb0_1;
    } else {
      tmp_2 = false;
    }
    if (tmp_2) {
      var tmp0_safe_receiver = getOrNull_0($this.obt_1, SemanticsProperties_getInstance().sbt_1);
      var contentDescription = tmp0_safe_receiver == null ? null : firstOrNull(tmp0_safe_receiver);
      if (!(contentDescription == null)) {
        var fakeNode_0 = fakeSemanticsNode($this, null, SemanticsNode$emitFakeNodes$lambda_0(contentDescription));
        unmergedChildren.g3(0, fakeNode_0);
      }
    }
  }
  function fakeSemanticsNode($this, role, properties) {
    // Inline function 'kotlin.also' call
    var this_0 = new SemanticsConfiguration();
    this_0.pb0_1 = false;
    this_0.qb0_1 = false;
    properties(this_0);
    var configuration = this_0;
    var tmp = new SemanticsNode$fakeSemanticsNode$fakeNode$1(properties);
    var tmp_0;
    var tmp_1 = role;
    if (!((tmp_1 == null ? null : new Role(tmp_1)) == null)) {
      tmp_0 = roleFakeNodeId($this);
    } else {
      tmp_0 = contentDescriptionFakeNodeId($this);
    }
    var fakeNode = new SemanticsNode(tmp, false, new LayoutNode(true, tmp_0), configuration);
    fakeNode.pbt_1 = $this;
    return fakeNode;
  }
  function SemanticsNode$emitFakeNodes$lambda($nodeRole) {
    return function ($this$fakeSemanticsNode) {
      set_role($this$fakeSemanticsNode, $nodeRole);
      return Unit_instance;
    };
  }
  function SemanticsNode$emitFakeNodes$lambda_0($contentDescription) {
    return function ($this$fakeSemanticsNode) {
      set_contentDescription($this$fakeSemanticsNode, $contentDescription);
      return Unit_instance;
    };
  }
  function SemanticsNode$fakeSemanticsNode$fakeNode$1($properties) {
    this.zbv_1 = $properties;
    Node.call(this);
  }
  protoOf(SemanticsNode$fakeSemanticsNode$fakeNode$1).l9i = function (_this__u8e3s4) {
    this.zbv_1(_this__u8e3s4);
  };
  function SemanticsNode(outerSemanticsNode, mergingEnabled, layoutNode, unmergedConfig) {
    this.lbt_1 = outerSemanticsNode;
    this.mbt_1 = mergingEnabled;
    this.nbt_1 = layoutNode;
    this.obt_1 = unmergedConfig;
    this.pbt_1 = null;
    this.qbt_1 = this.nbt_1.x8z_1;
  }
  protoOf(SemanticsNode).abw = function () {
    return !(this.pbt_1 == null);
  };
  protoOf(SemanticsNode).bbw = function () {
    var tmp0_safe_receiver = this.cbw();
    var tmp;
    if (tmp0_safe_receiver == null) {
      tmp = null;
    } else {
      // Inline function 'kotlin.takeIf' call
      var tmp_0;
      if (tmp0_safe_receiver.y91()) {
        tmp_0 = tmp0_safe_receiver;
      } else {
        tmp_0 = null;
      }
      tmp = tmp_0;
    }
    var tmp1_safe_receiver = tmp;
    var tmp2_elvis_lhs = tmp1_safe_receiver == null ? null : boundsInRoot(tmp1_safe_receiver);
    return tmp2_elvis_lhs == null ? Companion_getInstance_2().j5d_1 : tmp2_elvis_lhs;
  };
  protoOf(SemanticsNode).dbw = function () {
    var tmp0_safe_receiver = this.cbw();
    var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.zb6();
    return tmp1_elvis_lhs == null ? false : tmp1_elvis_lhs;
  };
  protoOf(SemanticsNode).ebw = function () {
    if (_get_isMergingSemanticsOfDescendants__b73llg(this)) {
      var mergedConfig = this.obt_1.xbr();
      // Inline function 'kotlin.collections.mutableListOf' call
      var tmp$ret$0 = ArrayList_init_$Create$();
      mergeConfig(this, tmp$ret$0, mergedConfig);
      return mergedConfig;
    } else {
      return this.obt_1;
    }
  };
  protoOf(SemanticsNode).fbw = function (unmergedChildren, includeFakeNodes, includeDeactivatedNodes) {
    if (this.abw())
      return emptyList();
    fillOneLayerOfSemanticsWrappers(this, this.nbt_1, unmergedChildren, includeDeactivatedNodes);
    if (includeFakeNodes) {
      emitFakeNodes(this, unmergedChildren);
    }
    return unmergedChildren;
  };
  protoOf(SemanticsNode).rbt = function (unmergedChildren, includeFakeNodes, includeDeactivatedNodes, $super) {
    var tmp;
    if (unmergedChildren === VOID) {
      // Inline function 'kotlin.collections.mutableListOf' call
      tmp = ArrayList_init_$Create$();
    } else {
      tmp = unmergedChildren;
    }
    unmergedChildren = tmp;
    includeFakeNodes = includeFakeNodes === VOID ? false : includeFakeNodes;
    includeDeactivatedNodes = includeDeactivatedNodes === VOID ? false : includeDeactivatedNodes;
    return $super === VOID ? this.fbw(unmergedChildren, includeFakeNodes, includeDeactivatedNodes) : $super.fbw.call(this, unmergedChildren, includeFakeNodes, includeDeactivatedNodes);
  };
  protoOf(SemanticsNode).gbw = function () {
    return this.hbw(false, true);
  };
  protoOf(SemanticsNode).ibw = function (includeReplacedSemantics, includeFakeNodes, includeDeactivatedNodes) {
    if (!includeReplacedSemantics && this.obt_1.qb0_1) {
      return emptyList();
    }
    // Inline function 'kotlin.collections.mutableListOf' call
    var unmergedChildren = ArrayList_init_$Create$();
    if (_get_isMergingSemanticsOfDescendants__b73llg(this)) {
      return findOneLayerOfMergingSemanticsNodes(this, unmergedChildren);
    }
    return this.fbw(unmergedChildren, includeFakeNodes, includeDeactivatedNodes);
  };
  protoOf(SemanticsNode).hbw = function (includeReplacedSemantics, includeFakeNodes, includeDeactivatedNodes, $super) {
    includeReplacedSemantics = includeReplacedSemantics === VOID ? !this.mbt_1 : includeReplacedSemantics;
    includeFakeNodes = includeFakeNodes === VOID ? false : includeFakeNodes;
    includeDeactivatedNodes = includeDeactivatedNodes === VOID ? false : includeDeactivatedNodes;
    return $super === VOID ? this.ibw(includeReplacedSemantics, includeFakeNodes, includeDeactivatedNodes) : $super.ibw.call(this, includeReplacedSemantics, includeFakeNodes, includeDeactivatedNodes);
  };
  protoOf(SemanticsNode).k1a = function () {
    if (!(this.pbt_1 == null))
      return this.pbt_1;
    var node = null;
    if (this.mbt_1) {
      var tmp0 = this.nbt_1;
      var tmp$ret$0;
      $l$block: {
        // Inline function 'androidx.compose.ui.semantics.findClosestParentNode' call
        var currentParent = tmp0.f9a();
        while (!(currentParent == null)) {
          var tmp0_safe_receiver = currentParent.lb0();
          if ((tmp0_safe_receiver == null ? null : tmp0_safe_receiver.pb0_1) === true) {
            tmp$ret$0 = currentParent;
            break $l$block;
          } else {
            currentParent = currentParent.f9a();
          }
        }
        tmp$ret$0 = null;
      }
      node = tmp$ret$0;
    }
    if (node == null) {
      var tmp0_0 = this.nbt_1;
      var tmp$ret$2;
      $l$block_0: {
        // Inline function 'androidx.compose.ui.semantics.findClosestParentNode' call
        var currentParent_0 = tmp0_0.f9a();
        while (!(currentParent_0 == null)) {
          var it = currentParent_0;
          // Inline function 'androidx.compose.ui.node.Nodes.Semantics' call
          var tmp$ret$4 = _NodeKind___init__impl__ojsprp(8);
          if (it.d91_1.abb(tmp$ret$4)) {
            tmp$ret$2 = currentParent_0;
            break $l$block_0;
          } else {
            currentParent_0 = currentParent_0.f9a();
          }
        }
        tmp$ret$2 = null;
      }
      node = tmp$ret$2;
    }
    if (node == null)
      return null;
    return SemanticsNode_0(node, this.mbt_1);
  };
  protoOf(SemanticsNode).cbw = function () {
    if (this.abw()) {
      var tmp0_safe_receiver = this.k1a();
      return tmp0_safe_receiver == null ? null : tmp0_safe_receiver.cbw();
    }
    var tmp1_safe_receiver = findSemanticsModifierNodeToGetBounds(this);
    var tmp;
    if (tmp1_safe_receiver == null) {
      tmp = null;
    } else {
      // Inline function 'androidx.compose.ui.node.Nodes.Semantics' call
      var tmp$ret$0 = _NodeKind___init__impl__ojsprp(8);
      tmp = requireCoordinator(tmp1_safe_receiver, tmp$ret$0);
    }
    var tmp2_elvis_lhs = tmp;
    return tmp2_elvis_lhs == null ? this.nbt_1.car() : tmp2_elvis_lhs;
  };
  function SemanticsNode_0(layoutNode, mergingEnabled) {
    var tmp0 = layoutNode.d91_1;
    // Inline function 'androidx.compose.ui.node.Nodes.Semantics' call
    var tmp2 = _NodeKind___init__impl__ojsprp(8);
    var tmp$ret$1;
    $l$block_0: {
      // Inline function 'androidx.compose.ui.node.NodeChain.head' call
      // Inline function 'androidx.compose.ui.node.NodeChain.headToTail' call
      var tmp2_0 = _NodeKind___get_mask__impl__1uopb6(tmp2);
      $l$block_1: {
        // Inline function 'androidx.compose.ui.node.NodeChain.headToTail' call
        if ((access$_get_aggregateChildKindSet__pv81sw(tmp0) & tmp2_0) === 0) {
          break $l$block_1;
        }
        // Inline function 'androidx.compose.ui.node.NodeChain.headToTail' call
        var node = tmp0.j99_1;
        while (!(node == null)) {
          var it = node;
          if (!((it.o8v_1 & tmp2_0) === 0)) {
            // Inline function 'androidx.compose.ui.node.dispatchForKind' call
            // Inline function 'androidx.compose.ui.node.dispatchForKind' call
            var stack = null;
            var node_0 = it;
            $l$loop: while (!(node_0 == null)) {
              var tmp;
              if (isInterface(node_0, SemanticsModifierNode)) {
                tmp$ret$1 = node_0;
                break $l$block_0;
              } else {
                tmp = true;
              }
              var dispatchAgain = tmp;
              var tmp_0;
              var tmp_1;
              if (dispatchAgain || false) {
                // Inline function 'androidx.compose.ui.Node.isKind' call
                tmp_1 = !((node_0.o8v_1 & _NodeKind___get_mask__impl__1uopb6(tmp2)) === 0);
              } else {
                tmp_1 = false;
              }
              if (tmp_1) {
                tmp_0 = node_0 instanceof DelegatingNode;
              } else {
                tmp_0 = false;
              }
              if (tmp_0) {
                var count = 0;
                // Inline function 'androidx.compose.ui.node.DelegatingNode.forEachImmediateDelegate' call
                var node_1 = node_0.e9a_1;
                while (!(node_1 == null)) {
                  var next = node_1;
                  // Inline function 'androidx.compose.ui.Node.isKind' call
                  if (!((next.o8v_1 & _NodeKind___get_mask__impl__1uopb6(tmp2)) === 0)) {
                    count = count + 1 | 0;
                    if (count === 1) {
                      node_0 = next;
                    } else {
                      var tmp0_elvis_lhs = stack;
                      var tmp_2;
                      if (tmp0_elvis_lhs == null) {
                        // Inline function 'androidx.compose.runtime.collection.mutableVectorOf' call
                        // Inline function 'androidx.compose.runtime.collection.MutableVector' call
                        // Inline function 'kotlin.arrayOfNulls' call
                        var tmp$ret$16 = Array(16);
                        tmp_2 = new MutableVector(tmp$ret$16, 0);
                      } else {
                        tmp_2 = tmp0_elvis_lhs;
                      }
                      stack = tmp_2;
                      var theNode = node_0;
                      if (!(theNode == null)) {
                        var tmp1_safe_receiver = stack;
                        if (tmp1_safe_receiver == null)
                          null;
                        else
                          tmp1_safe_receiver.zz(theNode);
                        node_0 = null;
                      }
                      var tmp2_safe_receiver = stack;
                      if (tmp2_safe_receiver == null)
                        null;
                      else
                        tmp2_safe_receiver.zz(next);
                    }
                  }
                  node_1 = node_1.r8v_1;
                }
                if (count === 1) {
                  continue $l$loop;
                }
              }
              node_0 = access$pop$tDelegatableNodeKt(stack);
            }
          }
          if ((it.p8v_1 & tmp2_0) === 0) {
            break $l$block_1;
          }
          node = node.r8v_1;
        }
      }
      tmp$ret$1 = null;
    }
    var tmp_3 = ensureNotNull(tmp$ret$1).f4n();
    var tmp0_elvis_lhs_0 = layoutNode.lb0();
    return new SemanticsNode(tmp_3, mergingEnabled, layoutNode, tmp0_elvis_lhs_0 == null ? new SemanticsConfiguration() : tmp0_elvis_lhs_0);
  }
  function get_role(_this__u8e3s4) {
    var tmp = getOrNull_0(_this__u8e3s4.obt_1, SemanticsProperties_getInstance().rbu_1);
    return tmp == null ? null : tmp.jbw_1;
  }
  function roleFakeNodeId(_this__u8e3s4) {
    return _this__u8e3s4.qbt_1 + 1000000000 | 0;
  }
  function contentDescriptionFakeNodeId(_this__u8e3s4) {
    return _this__u8e3s4.qbt_1 + 2000000000 | 0;
  }
  var DefaultFakeNodeBounds;
  var androidx_compose_ui_semantics_SemanticsOwner$stable;
  var androidx_compose_ui_semantics_SemanticsNodeWithAdjustedBounds$stable;
  function SemanticsOwner(rootNode, outerSemanticsNode, nodes) {
    this.mbb_1 = rootNode;
    this.nbb_1 = outerSemanticsNode;
    this.obb_1 = nodes;
    this.pbb_1 = new MutableObjectList(2);
  }
  protoOf(SemanticsOwner).kbw = function () {
    return SemanticsNode_0(this.mbb_1, true);
  };
  protoOf(SemanticsOwner).qbb = function (semanticsInfo, previousSemanticsConfiguration) {
    // Inline function 'androidx.collection.ObjectList.forEach' call
    var this_0 = this.pbb_1;
    // Inline function 'kotlin.contracts.contract' call
    var content = this_0.sz_1;
    var inductionVariable = 0;
    var last = this_0.tz_1;
    if (inductionVariable < last)
      do {
        var i = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        content[i].lbw(semanticsInfo, previousSemanticsConfiguration);
      }
       while (inductionVariable < last);
  };
  function isImportantForAccessibility(_this__u8e3s4) {
    _init_properties_SemanticsOwner_kt__ibhdwm();
    return !get_isHidden(_this__u8e3s4) && (_this__u8e3s4.obt_1.pb0_1 || _this__u8e3s4.obt_1.ubr());
  }
  function get_isHidden(_this__u8e3s4) {
    _init_properties_SemanticsOwner_kt__ibhdwm();
    return _this__u8e3s4.dbw() || (_this__u8e3s4.obt_1.nbr(SemanticsProperties_getInstance().ibu_1) || _this__u8e3s4.obt_1.nbr(SemanticsProperties_getInstance().hbu_1));
  }
  var properties_initialized_SemanticsOwner_kt_paa9h4;
  function _init_properties_SemanticsOwner_kt__ibhdwm() {
    if (!properties_initialized_SemanticsOwner_kt_paa9h4) {
      properties_initialized_SemanticsOwner_kt_paa9h4 = true;
      DefaultFakeNodeBounds = new Rect(0.0, 0.0, 10.0, 10.0);
      androidx_compose_ui_semantics_SemanticsOwner$stable = 8;
      androidx_compose_ui_semantics_SemanticsNodeWithAdjustedBounds$stable = 8;
    }
  }
  function set_stateDescription(_this__u8e3s4, _set____db54di) {
    _init_properties_SemanticsProperties_kt__mp85yq();
    var tmp = KMutableProperty1;
    var tmp_0 = _get_stateDescription_$ref_nxr2xd();
    return stateDescription$delegate.mbw(_this__u8e3s4, getPropertyCallableRef('stateDescription', 1, tmp, tmp_0, _set_stateDescription_$ref_9zoex1()), _set____db54di);
  }
  function get_stateDescription(_this__u8e3s4) {
    _init_properties_SemanticsProperties_kt__mp85yq();
    var tmp = KMutableProperty1;
    var tmp_0 = _get_stateDescription_$ref_nxr2xd();
    return stateDescription$delegate.nbw(_this__u8e3s4, getPropertyCallableRef('stateDescription', 1, tmp, tmp_0, _set_stateDescription_$ref_9zoex1()));
  }
  var stateDescription$delegate;
  function set_progressBarRangeInfo(_this__u8e3s4, _set____db54di) {
    _init_properties_SemanticsProperties_kt__mp85yq();
    var tmp = KMutableProperty1;
    var tmp_0 = _get_progressBarRangeInfo_$ref_wpds2d();
    return progressBarRangeInfo$delegate.mbw(_this__u8e3s4, getPropertyCallableRef('progressBarRangeInfo', 1, tmp, tmp_0, _set_progressBarRangeInfo_$ref_s70kf5()), _set____db54di);
  }
  function get_progressBarRangeInfo(_this__u8e3s4) {
    _init_properties_SemanticsProperties_kt__mp85yq();
    var tmp = KMutableProperty1;
    var tmp_0 = _get_progressBarRangeInfo_$ref_wpds2d();
    return progressBarRangeInfo$delegate.nbw(_this__u8e3s4, getPropertyCallableRef('progressBarRangeInfo', 1, tmp, tmp_0, _set_progressBarRangeInfo_$ref_s70kf5()));
  }
  var progressBarRangeInfo$delegate;
  function set_paneTitle(_this__u8e3s4, _set____db54di) {
    _init_properties_SemanticsProperties_kt__mp85yq();
    var tmp = KMutableProperty1;
    var tmp_0 = _get_paneTitle_$ref_sry228();
    return paneTitle$delegate.mbw(_this__u8e3s4, getPropertyCallableRef('paneTitle', 1, tmp, tmp_0, _set_paneTitle_$ref_r1ehek()), _set____db54di);
  }
  function get_paneTitle(_this__u8e3s4) {
    _init_properties_SemanticsProperties_kt__mp85yq();
    var tmp = KMutableProperty1;
    var tmp_0 = _get_paneTitle_$ref_sry228();
    return paneTitle$delegate.nbw(_this__u8e3s4, getPropertyCallableRef('paneTitle', 1, tmp, tmp_0, _set_paneTitle_$ref_r1ehek()));
  }
  var paneTitle$delegate;
  function set_liveRegion(_this__u8e3s4, _set____db54di) {
    _init_properties_SemanticsProperties_kt__mp85yq();
    var tmp = KMutableProperty1;
    var tmp_0 = _get_liveRegion_$ref_nj2rcq();
    return liveRegion$delegate.mbw(_this__u8e3s4, getPropertyCallableRef('liveRegion', 1, tmp, tmp_0, _set_liveRegion_$ref_200ooq()), new LiveRegionMode(_set____db54di));
  }
  function get_liveRegion(_this__u8e3s4) {
    _init_properties_SemanticsProperties_kt__mp85yq();
    var tmp = KMutableProperty1;
    var tmp_0 = _get_liveRegion_$ref_nj2rcq();
    return liveRegion$delegate.nbw(_this__u8e3s4, getPropertyCallableRef('liveRegion', 1, tmp, tmp_0, _set_liveRegion_$ref_200ooq())).obw_1;
  }
  var liveRegion$delegate;
  function set_focused(_this__u8e3s4, _set____db54di) {
    _init_properties_SemanticsProperties_kt__mp85yq();
    var tmp = KMutableProperty1;
    var tmp_0 = _get_focused_$ref_wjz889();
    return focused$delegate.mbw(_this__u8e3s4, getPropertyCallableRef('focused', 1, tmp, tmp_0, _set_focused_$ref_29l1wd()), _set____db54di);
  }
  function get_focused(_this__u8e3s4) {
    _init_properties_SemanticsProperties_kt__mp85yq();
    var tmp = KMutableProperty1;
    var tmp_0 = _get_focused_$ref_wjz889();
    return focused$delegate.nbw(_this__u8e3s4, getPropertyCallableRef('focused', 1, tmp, tmp_0, _set_focused_$ref_29l1wd()));
  }
  var focused$delegate;
  function set_isContainer(_this__u8e3s4, _set____db54di) {
    _init_properties_SemanticsProperties_kt__mp85yq();
    var tmp = KMutableProperty1;
    var tmp_0 = _get_isContainer_$ref_r5icx5();
    return isContainer$delegate.mbw(_this__u8e3s4, getPropertyCallableRef('isContainer', 1, tmp, tmp_0, _set_isContainer_$ref_h1s5el()), _set____db54di);
  }
  function get_isContainer(_this__u8e3s4) {
    _init_properties_SemanticsProperties_kt__mp85yq();
    var tmp = KMutableProperty1;
    var tmp_0 = _get_isContainer_$ref_r5icx5();
    return isContainer$delegate.nbw(_this__u8e3s4, getPropertyCallableRef('isContainer', 1, tmp, tmp_0, _set_isContainer_$ref_h1s5el()));
  }
  var isContainer$delegate;
  function set_isTraversalGroup(_this__u8e3s4, _set____db54di) {
    _init_properties_SemanticsProperties_kt__mp85yq();
    var tmp = KMutableProperty1;
    var tmp_0 = _get_isTraversalGroup_$ref_hzo9ox();
    return isTraversalGroup$delegate.mbw(_this__u8e3s4, getPropertyCallableRef('isTraversalGroup', 1, tmp, tmp_0, _set_isTraversalGroup_$ref_41llol()), _set____db54di);
  }
  function get_isTraversalGroup(_this__u8e3s4) {
    _init_properties_SemanticsProperties_kt__mp85yq();
    var tmp = KMutableProperty1;
    var tmp_0 = _get_isTraversalGroup_$ref_hzo9ox();
    return isTraversalGroup$delegate.nbw(_this__u8e3s4, getPropertyCallableRef('isTraversalGroup', 1, tmp, tmp_0, _set_isTraversalGroup_$ref_41llol()));
  }
  var isTraversalGroup$delegate;
  var isSensitiveData$delegate;
  function set_contentType(_this__u8e3s4, _set____db54di) {
    _init_properties_SemanticsProperties_kt__mp85yq();
    var tmp = KMutableProperty1;
    var tmp_0 = _get_contentType_$ref_ae09sd();
    return contentType$delegate.mbw(_this__u8e3s4, getPropertyCallableRef('contentType', 1, tmp, tmp_0, _set_contentType_$ref_aa29t()), _set____db54di);
  }
  function get_contentType(_this__u8e3s4) {
    _init_properties_SemanticsProperties_kt__mp85yq();
    var tmp = KMutableProperty1;
    var tmp_0 = _get_contentType_$ref_ae09sd();
    return contentType$delegate.nbw(_this__u8e3s4, getPropertyCallableRef('contentType', 1, tmp, tmp_0, _set_contentType_$ref_aa29t()));
  }
  var contentType$delegate;
  function set_contentDataType(_this__u8e3s4, _set____db54di) {
    _init_properties_SemanticsProperties_kt__mp85yq();
    var tmp = KMutableProperty1;
    var tmp_0 = _get_contentDataType_$ref_t9e7er();
    return contentDataType$delegate.mbw(_this__u8e3s4, getPropertyCallableRef('contentDataType', 1, tmp, tmp_0, _set_contentDataType_$ref_fynyif()), _set____db54di);
  }
  function get_contentDataType(_this__u8e3s4) {
    _init_properties_SemanticsProperties_kt__mp85yq();
    var tmp = KMutableProperty1;
    var tmp_0 = _get_contentDataType_$ref_t9e7er();
    return contentDataType$delegate.nbw(_this__u8e3s4, getPropertyCallableRef('contentDataType', 1, tmp, tmp_0, _set_contentDataType_$ref_fynyif()));
  }
  var contentDataType$delegate;
  function set_fillableData(_this__u8e3s4, _set____db54di) {
    _init_properties_SemanticsProperties_kt__mp85yq();
    var tmp = KMutableProperty1;
    var tmp_0 = _get_fillableData_$ref_xc9jlf();
    return fillableData$delegate.mbw(_this__u8e3s4, getPropertyCallableRef('fillableData', 1, tmp, tmp_0, _set_fillableData_$ref_495ain()), _set____db54di);
  }
  function get_fillableData(_this__u8e3s4) {
    _init_properties_SemanticsProperties_kt__mp85yq();
    var tmp = KMutableProperty1;
    var tmp_0 = _get_fillableData_$ref_xc9jlf();
    return fillableData$delegate.nbw(_this__u8e3s4, getPropertyCallableRef('fillableData', 1, tmp, tmp_0, _set_fillableData_$ref_495ain()));
  }
  var fillableData$delegate;
  function set_traversalIndex(_this__u8e3s4, _set____db54di) {
    _init_properties_SemanticsProperties_kt__mp85yq();
    var tmp = KMutableProperty1;
    var tmp_0 = _get_traversalIndex_$ref_f97zgm();
    return traversalIndex$delegate.mbw(_this__u8e3s4, getPropertyCallableRef('traversalIndex', 1, tmp, tmp_0, _set_traversalIndex_$ref_lu0re6()), _set____db54di);
  }
  function get_traversalIndex(_this__u8e3s4) {
    _init_properties_SemanticsProperties_kt__mp85yq();
    var tmp = KMutableProperty1;
    var tmp_0 = _get_traversalIndex_$ref_f97zgm();
    return traversalIndex$delegate.nbw(_this__u8e3s4, getPropertyCallableRef('traversalIndex', 1, tmp, tmp_0, _set_traversalIndex_$ref_lu0re6()));
  }
  var traversalIndex$delegate;
  function set_horizontalScrollAxisRange(_this__u8e3s4, _set____db54di) {
    _init_properties_SemanticsProperties_kt__mp85yq();
    var tmp = KMutableProperty1;
    var tmp_0 = _get_horizontalScrollAxisRange_$ref_z3ym51();
    return horizontalScrollAxisRange$delegate.mbw(_this__u8e3s4, getPropertyCallableRef('horizontalScrollAxisRange', 1, tmp, tmp_0, _set_horizontalScrollAxisRange_$ref_pj8oi1()), _set____db54di);
  }
  function get_horizontalScrollAxisRange(_this__u8e3s4) {
    _init_properties_SemanticsProperties_kt__mp85yq();
    var tmp = KMutableProperty1;
    var tmp_0 = _get_horizontalScrollAxisRange_$ref_z3ym51();
    return horizontalScrollAxisRange$delegate.nbw(_this__u8e3s4, getPropertyCallableRef('horizontalScrollAxisRange', 1, tmp, tmp_0, _set_horizontalScrollAxisRange_$ref_pj8oi1()));
  }
  var horizontalScrollAxisRange$delegate;
  function set_verticalScrollAxisRange(_this__u8e3s4, _set____db54di) {
    _init_properties_SemanticsProperties_kt__mp85yq();
    var tmp = KMutableProperty1;
    var tmp_0 = _get_verticalScrollAxisRange_$ref_fvd607();
    return verticalScrollAxisRange$delegate.mbw(_this__u8e3s4, getPropertyCallableRef('verticalScrollAxisRange', 1, tmp, tmp_0, _set_verticalScrollAxisRange_$ref_rw8kpx()), _set____db54di);
  }
  function get_verticalScrollAxisRange(_this__u8e3s4) {
    _init_properties_SemanticsProperties_kt__mp85yq();
    var tmp = KMutableProperty1;
    var tmp_0 = _get_verticalScrollAxisRange_$ref_fvd607();
    return verticalScrollAxisRange$delegate.nbw(_this__u8e3s4, getPropertyCallableRef('verticalScrollAxisRange', 1, tmp, tmp_0, _set_verticalScrollAxisRange_$ref_rw8kpx()));
  }
  var verticalScrollAxisRange$delegate;
  function set_role(_this__u8e3s4, _set____db54di) {
    _init_properties_SemanticsProperties_kt__mp85yq();
    var tmp = KMutableProperty1;
    var tmp_0 = _get_role_$ref_tir090();
    return role$delegate.mbw(_this__u8e3s4, getPropertyCallableRef('role', 1, tmp, tmp_0, _set_role_$ref_spgq9c()), new Role(_set____db54di));
  }
  function get_role_0(_this__u8e3s4) {
    _init_properties_SemanticsProperties_kt__mp85yq();
    var tmp = KMutableProperty1;
    var tmp_0 = _get_role_$ref_tir090();
    return role$delegate.nbw(_this__u8e3s4, getPropertyCallableRef('role', 1, tmp, tmp_0, _set_role_$ref_spgq9c())).jbw_1;
  }
  var role$delegate;
  var testTag$delegate;
  function set_textSubstitution(_this__u8e3s4, _set____db54di) {
    _init_properties_SemanticsProperties_kt__mp85yq();
    var tmp = KMutableProperty1;
    var tmp_0 = _get_textSubstitution_$ref_dsq0y8();
    return textSubstitution$delegate.mbw(_this__u8e3s4, getPropertyCallableRef('textSubstitution', 1, tmp, tmp_0, _set_textSubstitution_$ref_5cn24()), _set____db54di);
  }
  function get_textSubstitution(_this__u8e3s4) {
    _init_properties_SemanticsProperties_kt__mp85yq();
    var tmp = KMutableProperty1;
    var tmp_0 = _get_textSubstitution_$ref_dsq0y8();
    return textSubstitution$delegate.nbw(_this__u8e3s4, getPropertyCallableRef('textSubstitution', 1, tmp, tmp_0, _set_textSubstitution_$ref_5cn24()));
  }
  var textSubstitution$delegate;
  function set_isShowingTextSubstitution(_this__u8e3s4, _set____db54di) {
    _init_properties_SemanticsProperties_kt__mp85yq();
    var tmp = KMutableProperty1;
    var tmp_0 = _get_isShowingTextSubstitution_$ref_x5tuwr();
    return isShowingTextSubstitution$delegate.mbw(_this__u8e3s4, getPropertyCallableRef('isShowingTextSubstitution', 1, tmp, tmp_0, _set_isShowingTextSubstitution_$ref_nl3x9r()), _set____db54di);
  }
  function get_isShowingTextSubstitution(_this__u8e3s4) {
    _init_properties_SemanticsProperties_kt__mp85yq();
    var tmp = KMutableProperty1;
    var tmp_0 = _get_isShowingTextSubstitution_$ref_x5tuwr();
    return isShowingTextSubstitution$delegate.nbw(_this__u8e3s4, getPropertyCallableRef('isShowingTextSubstitution', 1, tmp, tmp_0, _set_isShowingTextSubstitution_$ref_nl3x9r()));
  }
  var isShowingTextSubstitution$delegate;
  function set_inputText(_this__u8e3s4, _set____db54di) {
    _init_properties_SemanticsProperties_kt__mp85yq();
    var tmp = KMutableProperty1;
    var tmp_0 = _get_inputText_$ref_ubbzzr();
    return inputText$delegate.mbw(_this__u8e3s4, getPropertyCallableRef('inputText', 1, tmp, tmp_0, _set_inputText_$ref_f3khhf()), _set____db54di);
  }
  function get_inputText(_this__u8e3s4) {
    _init_properties_SemanticsProperties_kt__mp85yq();
    var tmp = KMutableProperty1;
    var tmp_0 = _get_inputText_$ref_ubbzzr();
    return inputText$delegate.nbw(_this__u8e3s4, getPropertyCallableRef('inputText', 1, tmp, tmp_0, _set_inputText_$ref_f3khhf()));
  }
  var inputText$delegate;
  function set_editableText(_this__u8e3s4, _set____db54di) {
    _init_properties_SemanticsProperties_kt__mp85yq();
    var tmp = KMutableProperty1;
    var tmp_0 = _get_editableText_$ref_smlf13();
    return editableText$delegate.mbw(_this__u8e3s4, getPropertyCallableRef('editableText', 1, tmp, tmp_0, _set_editableText_$ref_dbedv9()), _set____db54di);
  }
  function get_editableText(_this__u8e3s4) {
    _init_properties_SemanticsProperties_kt__mp85yq();
    var tmp = KMutableProperty1;
    var tmp_0 = _get_editableText_$ref_smlf13();
    return editableText$delegate.nbw(_this__u8e3s4, getPropertyCallableRef('editableText', 1, tmp, tmp_0, _set_editableText_$ref_dbedv9()));
  }
  var editableText$delegate;
  function set_textSelectionRange(_this__u8e3s4, _set____db54di) {
    _init_properties_SemanticsProperties_kt__mp85yq();
    var tmp = KMutableProperty1;
    var tmp_0 = _get_textSelectionRange_$ref_yq5ihw();
    return textSelectionRange$delegate.mbw(_this__u8e3s4, getPropertyCallableRef('textSelectionRange', 1, tmp, tmp_0, _set_textSelectionRange_$ref_e1v31k()), new TextRange(_set____db54di));
  }
  function get_textSelectionRange(_this__u8e3s4) {
    _init_properties_SemanticsProperties_kt__mp85yq();
    var tmp = KMutableProperty1;
    var tmp_0 = _get_textSelectionRange_$ref_yq5ihw();
    return textSelectionRange$delegate.nbw(_this__u8e3s4, getPropertyCallableRef('textSelectionRange', 1, tmp, tmp_0, _set_textSelectionRange_$ref_e1v31k())).b7u_1;
  }
  var textSelectionRange$delegate;
  var textCompositionRange$delegate;
  var imeAction$delegate;
  function set_selected(_this__u8e3s4, _set____db54di) {
    _init_properties_SemanticsProperties_kt__mp85yq();
    var tmp = KMutableProperty1;
    var tmp_0 = _get_selected_$ref_j8rczj();
    return selected$delegate.mbw(_this__u8e3s4, getPropertyCallableRef('selected', 1, tmp, tmp_0, _set_selected_$ref_3p0mff()), _set____db54di);
  }
  function get_selected(_this__u8e3s4) {
    _init_properties_SemanticsProperties_kt__mp85yq();
    var tmp = KMutableProperty1;
    var tmp_0 = _get_selected_$ref_j8rczj();
    return selected$delegate.nbw(_this__u8e3s4, getPropertyCallableRef('selected', 1, tmp, tmp_0, _set_selected_$ref_3p0mff()));
  }
  var selected$delegate;
  function set_collectionInfo(_this__u8e3s4, _set____db54di) {
    _init_properties_SemanticsProperties_kt__mp85yq();
    var tmp = KMutableProperty1;
    var tmp_0 = _get_collectionInfo_$ref_n7coky();
    return collectionInfo$delegate.mbw(_this__u8e3s4, getPropertyCallableRef('collectionInfo', 1, tmp, tmp_0, _set_collectionInfo_$ref_aqimje()), _set____db54di);
  }
  function get_collectionInfo(_this__u8e3s4) {
    _init_properties_SemanticsProperties_kt__mp85yq();
    var tmp = KMutableProperty1;
    var tmp_0 = _get_collectionInfo_$ref_n7coky();
    return collectionInfo$delegate.nbw(_this__u8e3s4, getPropertyCallableRef('collectionInfo', 1, tmp, tmp_0, _set_collectionInfo_$ref_aqimje()));
  }
  var collectionInfo$delegate;
  var collectionItemInfo$delegate;
  function set_toggleableState(_this__u8e3s4, _set____db54di) {
    _init_properties_SemanticsProperties_kt__mp85yq();
    var tmp = KMutableProperty1;
    var tmp_0 = _get_toggleableState_$ref_rh1ucd();
    return toggleableState$delegate.mbw(_this__u8e3s4, getPropertyCallableRef('toggleableState', 1, tmp, tmp_0, _set_toggleableState_$ref_e6blg1()), _set____db54di);
  }
  function get_toggleableState(_this__u8e3s4) {
    _init_properties_SemanticsProperties_kt__mp85yq();
    var tmp = KMutableProperty1;
    var tmp_0 = _get_toggleableState_$ref_rh1ucd();
    return toggleableState$delegate.nbw(_this__u8e3s4, getPropertyCallableRef('toggleableState', 1, tmp, tmp_0, _set_toggleableState_$ref_e6blg1()));
  }
  var toggleableState$delegate;
  var inputTextSuggestionState$delegate;
  function set_isEditable(_this__u8e3s4, _set____db54di) {
    _init_properties_SemanticsProperties_kt__mp85yq();
    var tmp = KMutableProperty1;
    var tmp_0 = _get_isEditable_$ref_838bnw();
    return isEditable$delegate.mbw(_this__u8e3s4, getPropertyCallableRef('isEditable', 1, tmp, tmp_0, _set_isEditable_$ref_hfv4dk()), _set____db54di);
  }
  function get_isEditable(_this__u8e3s4) {
    _init_properties_SemanticsProperties_kt__mp85yq();
    var tmp = KMutableProperty1;
    var tmp_0 = _get_isEditable_$ref_838bnw();
    return isEditable$delegate.nbw(_this__u8e3s4, getPropertyCallableRef('isEditable', 1, tmp, tmp_0, _set_isEditable_$ref_hfv4dk()));
  }
  var isEditable$delegate;
  var maxTextLength$delegate;
  function set_shape(_this__u8e3s4, _set____db54di) {
    _init_properties_SemanticsProperties_kt__mp85yq();
    var tmp = KMutableProperty1;
    var tmp_0 = _get_shape_$ref_a2d2v5();
    return shape$delegate.mbw(_this__u8e3s4, getPropertyCallableRef('shape', 1, tmp, tmp_0, _set_shape_$ref_vnwipf()), _set____db54di);
  }
  function get_shape(_this__u8e3s4) {
    _init_properties_SemanticsProperties_kt__mp85yq();
    var tmp = KMutableProperty1;
    var tmp_0 = _get_shape_$ref_a2d2v5();
    return shape$delegate.nbw(_this__u8e3s4, getPropertyCallableRef('shape', 1, tmp, tmp_0, _set_shape_$ref_vnwipf()));
  }
  var shape$delegate;
  var customActions$delegate;
  var androidx_compose_ui_semantics_SemanticsProperties$stable;
  var androidx_compose_ui_semantics_SemanticsActions$stable;
  var androidx_compose_ui_semantics_SemanticsPropertyKey$stable;
  var androidx_compose_ui_semantics_AccessibilityAction$stable;
  var androidx_compose_ui_semantics_CustomAccessibilityAction$stable;
  var androidx_compose_ui_semantics_ProgressBarRangeInfo$stable;
  var androidx_compose_ui_semantics_CollectionInfo$stable;
  var androidx_compose_ui_semantics_CollectionItemInfo$stable;
  var androidx_compose_ui_semantics_ScrollAxisRange$stable;
  var androidx_compose_ui_semantics_InputTextSuggestionState$stable;
  function SemanticsPropertyKey_init_$Init$(name, isImportantForAccessibility, $this) {
    SemanticsPropertyKey.call($this, name);
    $this.sbr_1 = isImportantForAccessibility;
    return $this;
  }
  function SemanticsPropertyKey_init_$Create$(name, isImportantForAccessibility) {
    return SemanticsPropertyKey_init_$Init$(name, isImportantForAccessibility, objectCreate(protoOf(SemanticsPropertyKey)));
  }
  function SemanticsPropertyKey_init_$Init$_0(name, isImportantForAccessibility, mergePolicy, accessibilityExtraKey, $this) {
    accessibilityExtraKey = accessibilityExtraKey === VOID ? null : accessibilityExtraKey;
    SemanticsPropertyKey.call($this, name, mergePolicy);
    $this.sbr_1 = isImportantForAccessibility;
    $this.tbr_1 = accessibilityExtraKey;
    return $this;
  }
  function SemanticsPropertyKey_init_$Create$_0(name, isImportantForAccessibility, mergePolicy, accessibilityExtraKey) {
    return SemanticsPropertyKey_init_$Init$_0(name, isImportantForAccessibility, mergePolicy, accessibilityExtraKey, objectCreate(protoOf(SemanticsPropertyKey)));
  }
  function SemanticsPropertyKey$_init_$lambda_wl0qjy(parentValue, childValue) {
    return parentValue == null ? childValue : parentValue;
  }
  function SemanticsPropertyKey(name, mergePolicy) {
    var tmp;
    if (mergePolicy === VOID) {
      tmp = SemanticsPropertyKey$_init_$lambda_wl0qjy;
    } else {
      tmp = mergePolicy;
    }
    mergePolicy = tmp;
    this.qbr_1 = name;
    this.rbr_1 = mergePolicy;
    this.sbr_1 = false;
    this.tbr_1 = null;
  }
  protoOf(SemanticsPropertyKey).wbr = function (parentValue, childValue) {
    return this.rbr_1(parentValue, childValue);
  };
  protoOf(SemanticsPropertyKey).nbw = function (thisRef, property) {
    return throwSemanticsGetNotSupported();
  };
  protoOf(SemanticsPropertyKey).mbw = function (thisRef, property, value) {
    thisRef.mbr(this, value);
  };
  protoOf(SemanticsPropertyKey).toString = function () {
    return 'AccessibilityKey: ' + this.qbr_1;
  };
  function onClick(_this__u8e3s4, label, action) {
    label = label === VOID ? null : label;
    _init_properties_SemanticsProperties_kt__mp85yq();
    _this__u8e3s4.mbr(SemanticsActions_getInstance().qbw_1, new AccessibilityAction(label, action));
  }
  function set_contentDescription(_this__u8e3s4, value) {
    _init_properties_SemanticsProperties_kt__mp85yq();
    _this__u8e3s4.mbr(SemanticsProperties_getInstance().sbt_1, listOf(value));
  }
  function _Role___init__impl__464ukr(value) {
    return value;
  }
  function Companion_39() {
    Companion_instance_44 = this;
    this.tbx_1 = _Role___init__impl__464ukr(0);
    this.ubx_1 = _Role___init__impl__464ukr(1);
    this.vbx_1 = _Role___init__impl__464ukr(2);
    this.wbx_1 = _Role___init__impl__464ukr(3);
    this.xbx_1 = _Role___init__impl__464ukr(4);
    this.ybx_1 = _Role___init__impl__464ukr(5);
    this.zbx_1 = _Role___init__impl__464ukr(6);
    this.aby_1 = _Role___init__impl__464ukr(7);
    this.bby_1 = _Role___init__impl__464ukr(8);
  }
  var Companion_instance_44;
  function Companion_getInstance_65() {
    if (Companion_instance_44 == null)
      new Companion_39();
    return Companion_instance_44;
  }
  function Role__toString_impl_ixe5w5($this) {
    return $this === Companion_getInstance_65().tbx_1 ? 'Button' : $this === Companion_getInstance_65().ubx_1 ? 'Checkbox' : $this === Companion_getInstance_65().vbx_1 ? 'Switch' : $this === Companion_getInstance_65().wbx_1 ? 'RadioButton' : $this === Companion_getInstance_65().xbx_1 ? 'Tab' : $this === Companion_getInstance_65().ybx_1 ? 'Image' : $this === Companion_getInstance_65().zbx_1 ? 'DropdownList' : $this === Companion_getInstance_65().aby_1 ? 'Picker' : $this === Companion_getInstance_65().bby_1 ? 'Carousel' : 'Unknown';
  }
  function Role__hashCode_impl_ucjza4($this) {
    return $this;
  }
  function Role__equals_impl_cvy6o8($this, other) {
    if (!(other instanceof Role))
      return false;
    if (!($this === other.jbw_1))
      return false;
    return true;
  }
  function Role(value) {
    Companion_getInstance_65();
    this.jbw_1 = value;
  }
  protoOf(Role).toString = function () {
    return Role__toString_impl_ixe5w5(this.jbw_1);
  };
  protoOf(Role).hashCode = function () {
    return Role__hashCode_impl_ucjza4(this.jbw_1);
  };
  protoOf(Role).equals = function (other) {
    return Role__equals_impl_cvy6o8(this.jbw_1, other);
  };
  function disabled(_this__u8e3s4) {
    _init_properties_SemanticsProperties_kt__mp85yq();
    _this__u8e3s4.mbr(SemanticsProperties_getInstance().bbu_1, Unit_instance);
  }
  function requestFocus_1(_this__u8e3s4, label, action) {
    label = label === VOID ? null : label;
    _init_properties_SemanticsProperties_kt__mp85yq();
    _this__u8e3s4.mbr(SemanticsActions_getInstance().mbx_1, new AccessibilityAction(label, action));
  }
  function selectableGroup(_this__u8e3s4) {
    _init_properties_SemanticsProperties_kt__mp85yq();
    _this__u8e3s4.mbr(SemanticsProperties_getInstance().wbt_1, Unit_instance);
  }
  function onFillData(_this__u8e3s4, label, action) {
    label = label === VOID ? null : label;
    _init_properties_SemanticsProperties_kt__mp85yq();
    _this__u8e3s4.mbr(SemanticsActions_getInstance().wbw_1, new AccessibilityAction(label, action));
  }
  function password(_this__u8e3s4) {
    _init_properties_SemanticsProperties_kt__mp85yq();
    _this__u8e3s4.mbr(SemanticsProperties_getInstance().fbv_1, Unit_instance);
  }
  function getTextLayoutResult(_this__u8e3s4, label, action) {
    label = label === VOID ? null : label;
    _init_properties_SemanticsProperties_kt__mp85yq();
    _this__u8e3s4.mbr(SemanticsActions_getInstance().pbw_1, new AccessibilityAction(label, action));
  }
  function setText(_this__u8e3s4, label, action) {
    label = label === VOID ? null : label;
    _init_properties_SemanticsProperties_kt__mp85yq();
    _this__u8e3s4.mbr(SemanticsActions_getInstance().zbw_1, new AccessibilityAction(label, action));
  }
  function insertTextAtCursor(_this__u8e3s4, label, action) {
    label = label === VOID ? null : label;
    _init_properties_SemanticsProperties_kt__mp85yq();
    _this__u8e3s4.mbr(SemanticsActions_getInstance().dbx_1, new AccessibilityAction(label, action));
  }
  function setSelection(_this__u8e3s4, label, action) {
    label = label === VOID ? null : label;
    _init_properties_SemanticsProperties_kt__mp85yq();
    _this__u8e3s4.mbr(SemanticsActions_getInstance().ybw_1, new AccessibilityAction(label, action));
  }
  function onImeAction(_this__u8e3s4, imeActionType, label, action) {
    label = label === VOID ? null : label;
    _init_properties_SemanticsProperties_kt__mp85yq();
    _this__u8e3s4.mbr(SemanticsProperties_getInstance().bbv_1, new ImeAction(imeActionType));
    _this__u8e3s4.mbr(SemanticsActions_getInstance().ebx_1, new AccessibilityAction(label, action));
  }
  function onLongClick(_this__u8e3s4, label, action) {
    label = label === VOID ? null : label;
    _init_properties_SemanticsProperties_kt__mp85yq();
    _this__u8e3s4.mbr(SemanticsActions_getInstance().rbw_1, new AccessibilityAction(label, action));
  }
  function copyText(_this__u8e3s4, label, action) {
    label = label === VOID ? null : label;
    _init_properties_SemanticsProperties_kt__mp85yq();
    _this__u8e3s4.mbr(SemanticsActions_getInstance().gbx_1, new AccessibilityAction(label, action));
  }
  function cutText(_this__u8e3s4, label, action) {
    label = label === VOID ? null : label;
    _init_properties_SemanticsProperties_kt__mp85yq();
    _this__u8e3s4.mbr(SemanticsActions_getInstance().hbx_1, new AccessibilityAction(label, action));
  }
  function pasteText(_this__u8e3s4, label, action) {
    label = label === VOID ? null : label;
    _init_properties_SemanticsProperties_kt__mp85yq();
    _this__u8e3s4.mbr(SemanticsActions_getInstance().ibx_1, new AccessibilityAction(label, action));
  }
  function scrollBy(_this__u8e3s4, label, action) {
    label = label === VOID ? null : label;
    _init_properties_SemanticsProperties_kt__mp85yq();
    _this__u8e3s4.mbr(SemanticsActions_getInstance().sbw_1, new AccessibilityAction(label, action));
  }
  function scrollByOffset(_this__u8e3s4, action) {
    _init_properties_SemanticsProperties_kt__mp85yq();
    _this__u8e3s4.mbr(SemanticsActions_getInstance().tbw_1, action);
  }
  function ScrollAxisRange(value, maxValue, reverseScrolling) {
    reverseScrolling = reverseScrolling === VOID ? false : reverseScrolling;
    this.cby_1 = value;
    this.dby_1 = maxValue;
    this.eby_1 = reverseScrolling;
  }
  protoOf(ScrollAxisRange).toString = function () {
    return 'ScrollAxisRange(value=' + this.cby_1() + ', maxValue=' + this.dby_1() + ', ' + ('reverseScrolling=' + this.eby_1 + ')');
  };
  function set_text(_this__u8e3s4, value) {
    _init_properties_SemanticsProperties_kt__mp85yq();
    _this__u8e3s4.mbr(SemanticsProperties_getInstance().ubu_1, listOf(value));
  }
  function setTextSubstitution(_this__u8e3s4, label, action) {
    label = label === VOID ? null : label;
    _init_properties_SemanticsProperties_kt__mp85yq();
    _this__u8e3s4.mbr(SemanticsActions_getInstance().abx_1, new AccessibilityAction(label, action));
  }
  function showTextSubstitution(_this__u8e3s4, label, action) {
    label = label === VOID ? null : label;
    _init_properties_SemanticsProperties_kt__mp85yq();
    _this__u8e3s4.mbr(SemanticsActions_getInstance().bbx_1, new AccessibilityAction(label, action));
  }
  function clearTextSubstitution(_this__u8e3s4, label, action) {
    label = label === VOID ? null : label;
    _init_properties_SemanticsProperties_kt__mp85yq();
    _this__u8e3s4.mbr(SemanticsActions_getInstance().cbx_1, new AccessibilityAction(label, action));
  }
  function AccessibilityAction(label, action) {
    this.obr_1 = label;
    this.pbr_1 = action;
  }
  protoOf(AccessibilityAction).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof AccessibilityAction))
      return false;
    if (!(this.obr_1 == other.obr_1))
      return false;
    if (!equals(this.pbr_1, other.pbr_1))
      return false;
    return true;
  };
  protoOf(AccessibilityAction).hashCode = function () {
    var tmp0_safe_receiver = this.obr_1;
    var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : getStringHashCode(tmp0_safe_receiver);
    var result = tmp1_elvis_lhs == null ? 0 : tmp1_elvis_lhs;
    var tmp = imul(31, result);
    // Inline function 'kotlin.hashCode' call
    var tmp0_safe_receiver_0 = this.pbr_1;
    var tmp1_elvis_lhs_0 = tmp0_safe_receiver_0 == null ? null : hashCode(tmp0_safe_receiver_0);
    result = tmp + (tmp1_elvis_lhs_0 == null ? 0 : tmp1_elvis_lhs_0) | 0;
    return result;
  };
  protoOf(AccessibilityAction).toString = function () {
    return 'AccessibilityAction(label=' + this.obr_1 + ', action=' + toString_0(this.pbr_1) + ')';
  };
  function SemanticsProperties$ContentDescription$lambda(parentValue, childValue) {
    var tmp1_safe_receiver = parentValue == null ? null : toMutableList(parentValue);
    var tmp;
    if (tmp1_safe_receiver == null) {
      tmp = null;
    } else {
      // Inline function 'kotlin.also' call
      tmp1_safe_receiver.o1(childValue);
      tmp = tmp1_safe_receiver;
    }
    var tmp2_elvis_lhs = tmp;
    return tmp2_elvis_lhs == null ? childValue : tmp2_elvis_lhs;
  }
  function SemanticsProperties$PaneTitle$lambda(_unused_var__etf5q3, _unused_var__etf5q3_0) {
    throw IllegalStateException_init_$Create$('merge function called on unmergeable property PaneTitle.');
  }
  function SemanticsProperties$InvisibleToUser$lambda(parentValue, _unused_var__etf5q3) {
    return parentValue;
  }
  function SemanticsProperties$HideFromAccessibility$lambda(parentValue, _unused_var__etf5q3) {
    return parentValue;
  }
  function SemanticsProperties$ContentType$lambda(parentValue, _unused_var__etf5q3) {
    return parentValue;
  }
  function SemanticsProperties$ContentDataType$lambda(parentValue, _unused_var__etf5q3) {
    return parentValue;
  }
  function SemanticsProperties$FillableData$lambda(parentValue, _unused_var__etf5q3) {
    return parentValue;
  }
  function SemanticsProperties$TraversalIndex$lambda(parentValue, _unused_var__etf5q3) {
    return parentValue;
  }
  function SemanticsProperties$IsPopup$lambda(_unused_var__etf5q3, _unused_var__etf5q3_0) {
    throw IllegalStateException_init_$Create$('merge function called on unmergeable property IsPopup. A popup should not be a child of a clickable/focusable node.');
  }
  function SemanticsProperties$IsDialog$lambda(_unused_var__etf5q3, _unused_var__etf5q3_0) {
    throw IllegalStateException_init_$Create$('merge function called on unmergeable property IsDialog. A dialog should not be a child of a clickable/focusable node.');
  }
  function SemanticsProperties$Role$lambda(parentValue, _unused_var__etf5q3) {
    return parentValue;
  }
  function SemanticsProperties$TestTag$lambda(parentValue, _unused_var__etf5q3) {
    return parentValue;
  }
  function SemanticsProperties$LinkTestMarker$lambda(parentValue, _unused_var__etf5q3) {
    return parentValue;
  }
  function SemanticsProperties$Text$lambda(parentValue, childValue) {
    var tmp1_safe_receiver = parentValue == null ? null : toMutableList(parentValue);
    var tmp;
    if (tmp1_safe_receiver == null) {
      tmp = null;
    } else {
      // Inline function 'kotlin.also' call
      tmp1_safe_receiver.o1(childValue);
      tmp = tmp1_safe_receiver;
    }
    var tmp2_elvis_lhs = tmp;
    return tmp2_elvis_lhs == null ? childValue : tmp2_elvis_lhs;
  }
  function SemanticsProperties$Shape$lambda(parentValue, _unused_var__etf5q3) {
    return parentValue;
  }
  function SemanticsProperties() {
    SemanticsProperties_instance = this;
    var tmp = this;
    var tmp0 = 'ContentDescription';
    // Inline function 'androidx.compose.ui.semantics.AccessibilityKey' call
    var mergePolicy = SemanticsProperties$ContentDescription$lambda;
    tmp.sbt_1 = SemanticsPropertyKey_init_$Create$_0(tmp0, true, mergePolicy);
    var tmp_0 = this;
    // Inline function 'androidx.compose.ui.semantics.AccessibilityKey' call
    var name = 'StateDescription';
    tmp_0.tbt_1 = SemanticsPropertyKey_init_$Create$(name, true);
    var tmp_1 = this;
    // Inline function 'androidx.compose.ui.semantics.AccessibilityKey' call
    var name_0 = 'ProgressBarRangeInfo';
    tmp_1.ubt_1 = SemanticsPropertyKey_init_$Create$(name_0, true);
    var tmp_2 = this;
    var tmp0_0 = 'PaneTitle';
    // Inline function 'androidx.compose.ui.semantics.AccessibilityKey' call
    var mergePolicy_0 = SemanticsProperties$PaneTitle$lambda;
    tmp_2.vbt_1 = SemanticsPropertyKey_init_$Create$_0(tmp0_0, true, mergePolicy_0);
    var tmp_3 = this;
    // Inline function 'androidx.compose.ui.semantics.AccessibilityKey' call
    var name_1 = 'SelectableGroup';
    tmp_3.wbt_1 = SemanticsPropertyKey_init_$Create$(name_1, true);
    var tmp_4 = this;
    // Inline function 'androidx.compose.ui.semantics.AccessibilityKey' call
    var name_2 = 'CollectionInfo';
    tmp_4.xbt_1 = SemanticsPropertyKey_init_$Create$(name_2, true);
    var tmp_5 = this;
    // Inline function 'androidx.compose.ui.semantics.AccessibilityKey' call
    var name_3 = 'CollectionItemInfo';
    tmp_5.ybt_1 = SemanticsPropertyKey_init_$Create$(name_3, true);
    var tmp_6 = this;
    // Inline function 'androidx.compose.ui.semantics.AccessibilityKey' call
    tmp_6.zbt_1 = SemanticsPropertyKey_init_$Create$('Heading', true);
    var tmp_7 = this;
    // Inline function 'androidx.compose.ui.semantics.AccessibilityKey' call
    var name_4 = 'TextEntryKey';
    tmp_7.abu_1 = SemanticsPropertyKey_init_$Create$(name_4, true);
    var tmp_8 = this;
    // Inline function 'androidx.compose.ui.semantics.AccessibilityKey' call
    var name_5 = 'Disabled';
    tmp_8.bbu_1 = SemanticsPropertyKey_init_$Create$(name_5, true);
    var tmp_9 = this;
    // Inline function 'androidx.compose.ui.semantics.AccessibilityKey' call
    var name_6 = 'LiveRegion';
    tmp_9.cbu_1 = SemanticsPropertyKey_init_$Create$(name_6, true);
    var tmp_10 = this;
    // Inline function 'androidx.compose.ui.semantics.AccessibilityKey' call
    tmp_10.dbu_1 = SemanticsPropertyKey_init_$Create$('Focused', true);
    var tmp_11 = this;
    // Inline function 'androidx.compose.ui.semantics.AccessibilityKey' call
    var name_7 = 'IsContainer';
    tmp_11.ebu_1 = SemanticsPropertyKey_init_$Create$(name_7, true);
    this.fbu_1 = new SemanticsPropertyKey('IsTraversalGroup');
    this.gbu_1 = new SemanticsPropertyKey('IsSensitiveData');
    var tmp_12 = this;
    tmp_12.hbu_1 = new SemanticsPropertyKey('InvisibleToUser', SemanticsProperties$InvisibleToUser$lambda);
    var tmp_13 = this;
    tmp_13.ibu_1 = new SemanticsPropertyKey('HideFromAccessibility', SemanticsProperties$HideFromAccessibility$lambda);
    var tmp_14 = this;
    tmp_14.jbu_1 = new SemanticsPropertyKey('ContentType', SemanticsProperties$ContentType$lambda);
    var tmp_15 = this;
    tmp_15.kbu_1 = new SemanticsPropertyKey('ContentDataType', SemanticsProperties$ContentDataType$lambda);
    var tmp_16 = this;
    tmp_16.lbu_1 = new SemanticsPropertyKey('FillableData', SemanticsProperties$FillableData$lambda);
    var tmp_17 = this;
    tmp_17.mbu_1 = new SemanticsPropertyKey('TraversalIndex', SemanticsProperties$TraversalIndex$lambda);
    var tmp_18 = this;
    // Inline function 'androidx.compose.ui.semantics.AccessibilityKey' call
    var name_8 = 'HorizontalScrollAxisRange';
    tmp_18.nbu_1 = SemanticsPropertyKey_init_$Create$(name_8, true);
    var tmp_19 = this;
    // Inline function 'androidx.compose.ui.semantics.AccessibilityKey' call
    var name_9 = 'VerticalScrollAxisRange';
    tmp_19.obu_1 = SemanticsPropertyKey_init_$Create$(name_9, true);
    var tmp_20 = this;
    // Inline function 'androidx.compose.ui.semantics.AccessibilityKey' call
    var mergePolicy_1 = SemanticsProperties$IsPopup$lambda;
    tmp_20.pbu_1 = SemanticsPropertyKey_init_$Create$_0('IsPopup', true, mergePolicy_1);
    var tmp_21 = this;
    var tmp0_1 = 'IsDialog';
    // Inline function 'androidx.compose.ui.semantics.AccessibilityKey' call
    var mergePolicy_2 = SemanticsProperties$IsDialog$lambda;
    tmp_21.qbu_1 = SemanticsPropertyKey_init_$Create$_0(tmp0_1, true, mergePolicy_2);
    var tmp_22 = this;
    // Inline function 'androidx.compose.ui.semantics.AccessibilityKey' call
    var mergePolicy_3 = SemanticsProperties$Role$lambda;
    tmp_22.rbu_1 = SemanticsPropertyKey_init_$Create$_0('Role', true, mergePolicy_3);
    var tmp_23 = this;
    tmp_23.sbu_1 = SemanticsPropertyKey_init_$Create$_0('TestTag', false, SemanticsProperties$TestTag$lambda);
    var tmp_24 = this;
    tmp_24.tbu_1 = SemanticsPropertyKey_init_$Create$_0('LinkTestMarker', false, SemanticsProperties$LinkTestMarker$lambda);
    var tmp_25 = this;
    // Inline function 'androidx.compose.ui.semantics.AccessibilityKey' call
    var mergePolicy_4 = SemanticsProperties$Text$lambda;
    tmp_25.ubu_1 = SemanticsPropertyKey_init_$Create$_0('Text', true, mergePolicy_4);
    this.vbu_1 = new SemanticsPropertyKey('TextSubstitution');
    this.wbu_1 = new SemanticsPropertyKey('IsShowingTextSubstitution');
    var tmp_26 = this;
    // Inline function 'androidx.compose.ui.semantics.AccessibilityKey' call
    var name_10 = 'InputText';
    tmp_26.xbu_1 = SemanticsPropertyKey_init_$Create$(name_10, true);
    var tmp_27 = this;
    // Inline function 'androidx.compose.ui.semantics.AccessibilityKey' call
    var name_11 = 'EditableText';
    tmp_27.ybu_1 = SemanticsPropertyKey_init_$Create$(name_11, true);
    var tmp_28 = this;
    // Inline function 'androidx.compose.ui.semantics.AccessibilityKey' call
    var name_12 = 'TextSelectionRange';
    tmp_28.zbu_1 = SemanticsPropertyKey_init_$Create$(name_12, true);
    var tmp_29 = this;
    // Inline function 'androidx.compose.ui.semantics.AccessibilityKey' call
    var name_13 = 'TextCompositionRange';
    tmp_29.abv_1 = SemanticsPropertyKey_init_$Create$(name_13, true);
    var tmp_30 = this;
    // Inline function 'androidx.compose.ui.semantics.AccessibilityKey' call
    var name_14 = 'ImeAction';
    tmp_30.bbv_1 = SemanticsPropertyKey_init_$Create$(name_14, true);
    var tmp_31 = this;
    // Inline function 'androidx.compose.ui.semantics.AccessibilityKey' call
    var name_15 = 'Selected';
    tmp_31.cbv_1 = SemanticsPropertyKey_init_$Create$(name_15, true);
    var tmp_32 = this;
    // Inline function 'androidx.compose.ui.semantics.AccessibilityKey' call
    var name_16 = 'ToggleableState';
    tmp_32.dbv_1 = SemanticsPropertyKey_init_$Create$(name_16, true);
    var tmp_33 = this;
    // Inline function 'androidx.compose.ui.semantics.AccessibilityKey' call
    var name_17 = 'InputTextSuggestionState';
    tmp_33.ebv_1 = SemanticsPropertyKey_init_$Create$(name_17, true);
    var tmp_34 = this;
    // Inline function 'androidx.compose.ui.semantics.AccessibilityKey' call
    var name_18 = 'Password';
    tmp_34.fbv_1 = SemanticsPropertyKey_init_$Create$(name_18, true);
    var tmp_35 = this;
    // Inline function 'androidx.compose.ui.semantics.AccessibilityKey' call
    tmp_35.gbv_1 = SemanticsPropertyKey_init_$Create$('Error', true);
    this.hbv_1 = new SemanticsPropertyKey('IndexForKey');
    this.ibv_1 = new SemanticsPropertyKey('IsEditable');
    this.jbv_1 = new SemanticsPropertyKey('MaxTextLength');
    var tmp_36 = this;
    tmp_36.kbv_1 = SemanticsPropertyKey_init_$Create$_0('Shape', false, SemanticsProperties$Shape$lambda);
  }
  var SemanticsProperties_instance;
  function SemanticsProperties_getInstance() {
    if (SemanticsProperties_instance == null)
      new SemanticsProperties();
    return SemanticsProperties_instance;
  }
  function Companion_40() {
    Companion_instance_45 = this;
    this.fby_1 = new ProgressBarRangeInfo(0.0, rangeTo(0.0, 0.0));
  }
  var Companion_instance_45;
  function Companion_getInstance_66() {
    if (Companion_instance_45 == null)
      new Companion_40();
    return Companion_instance_45;
  }
  function ProgressBarRangeInfo(current, range, steps) {
    Companion_getInstance_66();
    steps = steps === VOID ? 0 : steps;
    this.gby_1 = current;
    this.hby_1 = range;
    this.iby_1 = steps;
    // Inline function 'kotlin.require' call
    if (!!isNaN_0(this.gby_1)) {
      var message = 'current must not be NaN';
      throw IllegalArgumentException_init_$Create$(toString(message));
    }
  }
  protoOf(ProgressBarRangeInfo).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof ProgressBarRangeInfo))
      return false;
    if (!(this.gby_1 === other.gby_1))
      return false;
    if (!equals(this.hby_1, other.hby_1))
      return false;
    if (!(this.iby_1 === other.iby_1))
      return false;
    return true;
  };
  protoOf(ProgressBarRangeInfo).hashCode = function () {
    var result = getNumberHashCode(this.gby_1);
    result = imul(31, result) + hashCode(this.hby_1) | 0;
    result = imul(31, result) + this.iby_1 | 0;
    return result;
  };
  protoOf(ProgressBarRangeInfo).toString = function () {
    return 'ProgressBarRangeInfo(current=' + this.gby_1 + ', range=' + toString(this.hby_1) + ', steps=' + this.iby_1 + ')';
  };
  function _LiveRegionMode___init__impl__qe4nr2(value) {
    return value;
  }
  function Companion_41() {
    Companion_instance_46 = this;
    this.jby_1 = _LiveRegionMode___init__impl__qe4nr2(0);
    this.kby_1 = _LiveRegionMode___init__impl__qe4nr2(1);
  }
  var Companion_instance_46;
  function Companion_getInstance_67() {
    if (Companion_instance_46 == null)
      new Companion_41();
    return Companion_instance_46;
  }
  function LiveRegionMode__toString_impl_bs4n26($this) {
    return $this === Companion_getInstance_67().jby_1 ? 'Polite' : $this === Companion_getInstance_67().kby_1 ? 'Assertive' : 'Unknown';
  }
  function LiveRegionMode__hashCode_impl_9z19qp($this) {
    return $this;
  }
  function LiveRegionMode__equals_impl_87jxjf($this, other) {
    if (!(other instanceof LiveRegionMode))
      return false;
    if (!($this === other.obw_1))
      return false;
    return true;
  }
  function LiveRegionMode(value) {
    Companion_getInstance_67();
    this.obw_1 = value;
  }
  protoOf(LiveRegionMode).toString = function () {
    return LiveRegionMode__toString_impl_bs4n26(this.obw_1);
  };
  protoOf(LiveRegionMode).hashCode = function () {
    return LiveRegionMode__hashCode_impl_9z19qp(this.obw_1);
  };
  protoOf(LiveRegionMode).equals = function (other) {
    return LiveRegionMode__equals_impl_87jxjf(this.obw_1, other);
  };
  function CollectionInfo(rowCount, columnCount) {
    this.lby_1 = rowCount;
    this.mby_1 = columnCount;
  }
  protoOf(CollectionInfo).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof CollectionInfo))
      return false;
    if (!(this.lby_1 === other.lby_1))
      return false;
    if (!(this.mby_1 === other.mby_1))
      return false;
    return true;
  };
  protoOf(CollectionInfo).hashCode = function () {
    var result = this.lby_1;
    result = imul(31, result) + this.mby_1 | 0;
    return result;
  };
  protoOf(CollectionInfo).toString = function () {
    return 'CollectionInfo(rowCount=' + this.lby_1 + ', columnCount=' + this.mby_1 + ')';
  };
  function SemanticsActions$GetTextLayoutResult$lambda(parentValue, childValue) {
    var tmp1_elvis_lhs = parentValue == null ? null : parentValue.obr_1;
    var tmp = tmp1_elvis_lhs == null ? childValue.obr_1 : tmp1_elvis_lhs;
    var tmp3_elvis_lhs = parentValue == null ? null : parentValue.pbr_1;
    return new AccessibilityAction(tmp, tmp3_elvis_lhs == null ? childValue.pbr_1 : tmp3_elvis_lhs);
  }
  function SemanticsActions$OnClick$lambda(parentValue, childValue) {
    var tmp1_elvis_lhs = parentValue == null ? null : parentValue.obr_1;
    var tmp = tmp1_elvis_lhs == null ? childValue.obr_1 : tmp1_elvis_lhs;
    var tmp3_elvis_lhs = parentValue == null ? null : parentValue.pbr_1;
    return new AccessibilityAction(tmp, tmp3_elvis_lhs == null ? childValue.pbr_1 : tmp3_elvis_lhs);
  }
  function SemanticsActions$OnLongClick$lambda(parentValue, childValue) {
    var tmp1_elvis_lhs = parentValue == null ? null : parentValue.obr_1;
    var tmp = tmp1_elvis_lhs == null ? childValue.obr_1 : tmp1_elvis_lhs;
    var tmp3_elvis_lhs = parentValue == null ? null : parentValue.pbr_1;
    return new AccessibilityAction(tmp, tmp3_elvis_lhs == null ? childValue.pbr_1 : tmp3_elvis_lhs);
  }
  function SemanticsActions$ScrollBy$lambda(parentValue, childValue) {
    var tmp1_elvis_lhs = parentValue == null ? null : parentValue.obr_1;
    var tmp = tmp1_elvis_lhs == null ? childValue.obr_1 : tmp1_elvis_lhs;
    var tmp3_elvis_lhs = parentValue == null ? null : parentValue.pbr_1;
    return new AccessibilityAction(tmp, tmp3_elvis_lhs == null ? childValue.pbr_1 : tmp3_elvis_lhs);
  }
  function SemanticsActions$ScrollToIndex$lambda(parentValue, childValue) {
    var tmp1_elvis_lhs = parentValue == null ? null : parentValue.obr_1;
    var tmp = tmp1_elvis_lhs == null ? childValue.obr_1 : tmp1_elvis_lhs;
    var tmp3_elvis_lhs = parentValue == null ? null : parentValue.pbr_1;
    return new AccessibilityAction(tmp, tmp3_elvis_lhs == null ? childValue.pbr_1 : tmp3_elvis_lhs);
  }
  function SemanticsActions$OnAutofillText$lambda(parentValue, childValue) {
    var tmp1_elvis_lhs = parentValue == null ? null : parentValue.obr_1;
    var tmp = tmp1_elvis_lhs == null ? childValue.obr_1 : tmp1_elvis_lhs;
    var tmp3_elvis_lhs = parentValue == null ? null : parentValue.pbr_1;
    return new AccessibilityAction(tmp, tmp3_elvis_lhs == null ? childValue.pbr_1 : tmp3_elvis_lhs);
  }
  function SemanticsActions$OnFillData$lambda(parentValue, childValue) {
    var tmp1_elvis_lhs = parentValue == null ? null : parentValue.obr_1;
    var tmp = tmp1_elvis_lhs == null ? childValue.obr_1 : tmp1_elvis_lhs;
    var tmp3_elvis_lhs = parentValue == null ? null : parentValue.pbr_1;
    return new AccessibilityAction(tmp, tmp3_elvis_lhs == null ? childValue.pbr_1 : tmp3_elvis_lhs);
  }
  function SemanticsActions$SetProgress$lambda(parentValue, childValue) {
    var tmp1_elvis_lhs = parentValue == null ? null : parentValue.obr_1;
    var tmp = tmp1_elvis_lhs == null ? childValue.obr_1 : tmp1_elvis_lhs;
    var tmp3_elvis_lhs = parentValue == null ? null : parentValue.pbr_1;
    return new AccessibilityAction(tmp, tmp3_elvis_lhs == null ? childValue.pbr_1 : tmp3_elvis_lhs);
  }
  function SemanticsActions$SetSelection$lambda(parentValue, childValue) {
    var tmp1_elvis_lhs = parentValue == null ? null : parentValue.obr_1;
    var tmp = tmp1_elvis_lhs == null ? childValue.obr_1 : tmp1_elvis_lhs;
    var tmp3_elvis_lhs = parentValue == null ? null : parentValue.pbr_1;
    return new AccessibilityAction(tmp, tmp3_elvis_lhs == null ? childValue.pbr_1 : tmp3_elvis_lhs);
  }
  function SemanticsActions$SetText$lambda(parentValue, childValue) {
    var tmp1_elvis_lhs = parentValue == null ? null : parentValue.obr_1;
    var tmp = tmp1_elvis_lhs == null ? childValue.obr_1 : tmp1_elvis_lhs;
    var tmp3_elvis_lhs = parentValue == null ? null : parentValue.pbr_1;
    return new AccessibilityAction(tmp, tmp3_elvis_lhs == null ? childValue.pbr_1 : tmp3_elvis_lhs);
  }
  function SemanticsActions$SetTextSubstitution$lambda(parentValue, childValue) {
    var tmp1_elvis_lhs = parentValue == null ? null : parentValue.obr_1;
    var tmp = tmp1_elvis_lhs == null ? childValue.obr_1 : tmp1_elvis_lhs;
    var tmp3_elvis_lhs = parentValue == null ? null : parentValue.pbr_1;
    return new AccessibilityAction(tmp, tmp3_elvis_lhs == null ? childValue.pbr_1 : tmp3_elvis_lhs);
  }
  function SemanticsActions$ShowTextSubstitution$lambda(parentValue, childValue) {
    var tmp1_elvis_lhs = parentValue == null ? null : parentValue.obr_1;
    var tmp = tmp1_elvis_lhs == null ? childValue.obr_1 : tmp1_elvis_lhs;
    var tmp3_elvis_lhs = parentValue == null ? null : parentValue.pbr_1;
    return new AccessibilityAction(tmp, tmp3_elvis_lhs == null ? childValue.pbr_1 : tmp3_elvis_lhs);
  }
  function SemanticsActions$ClearTextSubstitution$lambda(parentValue, childValue) {
    var tmp1_elvis_lhs = parentValue == null ? null : parentValue.obr_1;
    var tmp = tmp1_elvis_lhs == null ? childValue.obr_1 : tmp1_elvis_lhs;
    var tmp3_elvis_lhs = parentValue == null ? null : parentValue.pbr_1;
    return new AccessibilityAction(tmp, tmp3_elvis_lhs == null ? childValue.pbr_1 : tmp3_elvis_lhs);
  }
  function SemanticsActions$InsertTextAtCursor$lambda(parentValue, childValue) {
    var tmp1_elvis_lhs = parentValue == null ? null : parentValue.obr_1;
    var tmp = tmp1_elvis_lhs == null ? childValue.obr_1 : tmp1_elvis_lhs;
    var tmp3_elvis_lhs = parentValue == null ? null : parentValue.pbr_1;
    return new AccessibilityAction(tmp, tmp3_elvis_lhs == null ? childValue.pbr_1 : tmp3_elvis_lhs);
  }
  function SemanticsActions$OnImeAction$lambda(parentValue, childValue) {
    var tmp1_elvis_lhs = parentValue == null ? null : parentValue.obr_1;
    var tmp = tmp1_elvis_lhs == null ? childValue.obr_1 : tmp1_elvis_lhs;
    var tmp3_elvis_lhs = parentValue == null ? null : parentValue.pbr_1;
    return new AccessibilityAction(tmp, tmp3_elvis_lhs == null ? childValue.pbr_1 : tmp3_elvis_lhs);
  }
  function SemanticsActions$PerformImeAction$lambda(parentValue, childValue) {
    var tmp1_elvis_lhs = parentValue == null ? null : parentValue.obr_1;
    var tmp = tmp1_elvis_lhs == null ? childValue.obr_1 : tmp1_elvis_lhs;
    var tmp3_elvis_lhs = parentValue == null ? null : parentValue.pbr_1;
    return new AccessibilityAction(tmp, tmp3_elvis_lhs == null ? childValue.pbr_1 : tmp3_elvis_lhs);
  }
  function SemanticsActions$CopyText$lambda(parentValue, childValue) {
    var tmp1_elvis_lhs = parentValue == null ? null : parentValue.obr_1;
    var tmp = tmp1_elvis_lhs == null ? childValue.obr_1 : tmp1_elvis_lhs;
    var tmp3_elvis_lhs = parentValue == null ? null : parentValue.pbr_1;
    return new AccessibilityAction(tmp, tmp3_elvis_lhs == null ? childValue.pbr_1 : tmp3_elvis_lhs);
  }
  function SemanticsActions$CutText$lambda(parentValue, childValue) {
    var tmp1_elvis_lhs = parentValue == null ? null : parentValue.obr_1;
    var tmp = tmp1_elvis_lhs == null ? childValue.obr_1 : tmp1_elvis_lhs;
    var tmp3_elvis_lhs = parentValue == null ? null : parentValue.pbr_1;
    return new AccessibilityAction(tmp, tmp3_elvis_lhs == null ? childValue.pbr_1 : tmp3_elvis_lhs);
  }
  function SemanticsActions$PasteText$lambda(parentValue, childValue) {
    var tmp1_elvis_lhs = parentValue == null ? null : parentValue.obr_1;
    var tmp = tmp1_elvis_lhs == null ? childValue.obr_1 : tmp1_elvis_lhs;
    var tmp3_elvis_lhs = parentValue == null ? null : parentValue.pbr_1;
    return new AccessibilityAction(tmp, tmp3_elvis_lhs == null ? childValue.pbr_1 : tmp3_elvis_lhs);
  }
  function SemanticsActions$Expand$lambda(parentValue, childValue) {
    var tmp1_elvis_lhs = parentValue == null ? null : parentValue.obr_1;
    var tmp = tmp1_elvis_lhs == null ? childValue.obr_1 : tmp1_elvis_lhs;
    var tmp3_elvis_lhs = parentValue == null ? null : parentValue.pbr_1;
    return new AccessibilityAction(tmp, tmp3_elvis_lhs == null ? childValue.pbr_1 : tmp3_elvis_lhs);
  }
  function SemanticsActions$Collapse$lambda(parentValue, childValue) {
    var tmp1_elvis_lhs = parentValue == null ? null : parentValue.obr_1;
    var tmp = tmp1_elvis_lhs == null ? childValue.obr_1 : tmp1_elvis_lhs;
    var tmp3_elvis_lhs = parentValue == null ? null : parentValue.pbr_1;
    return new AccessibilityAction(tmp, tmp3_elvis_lhs == null ? childValue.pbr_1 : tmp3_elvis_lhs);
  }
  function SemanticsActions$Dismiss$lambda(parentValue, childValue) {
    var tmp1_elvis_lhs = parentValue == null ? null : parentValue.obr_1;
    var tmp = tmp1_elvis_lhs == null ? childValue.obr_1 : tmp1_elvis_lhs;
    var tmp3_elvis_lhs = parentValue == null ? null : parentValue.pbr_1;
    return new AccessibilityAction(tmp, tmp3_elvis_lhs == null ? childValue.pbr_1 : tmp3_elvis_lhs);
  }
  function SemanticsActions$RequestFocus$lambda(parentValue, childValue) {
    var tmp1_elvis_lhs = parentValue == null ? null : parentValue.obr_1;
    var tmp = tmp1_elvis_lhs == null ? childValue.obr_1 : tmp1_elvis_lhs;
    var tmp3_elvis_lhs = parentValue == null ? null : parentValue.pbr_1;
    return new AccessibilityAction(tmp, tmp3_elvis_lhs == null ? childValue.pbr_1 : tmp3_elvis_lhs);
  }
  function SemanticsActions$CustomActions$lambda(parentValue, childValue) {
    // Inline function 'kotlin.collections.orEmpty' call
    var tmp$ret$0 = parentValue == null ? emptyList() : parentValue;
    return plus_0(tmp$ret$0, childValue);
  }
  function SemanticsActions$PageUp$lambda(parentValue, childValue) {
    var tmp1_elvis_lhs = parentValue == null ? null : parentValue.obr_1;
    var tmp = tmp1_elvis_lhs == null ? childValue.obr_1 : tmp1_elvis_lhs;
    var tmp3_elvis_lhs = parentValue == null ? null : parentValue.pbr_1;
    return new AccessibilityAction(tmp, tmp3_elvis_lhs == null ? childValue.pbr_1 : tmp3_elvis_lhs);
  }
  function SemanticsActions$PageLeft$lambda(parentValue, childValue) {
    var tmp1_elvis_lhs = parentValue == null ? null : parentValue.obr_1;
    var tmp = tmp1_elvis_lhs == null ? childValue.obr_1 : tmp1_elvis_lhs;
    var tmp3_elvis_lhs = parentValue == null ? null : parentValue.pbr_1;
    return new AccessibilityAction(tmp, tmp3_elvis_lhs == null ? childValue.pbr_1 : tmp3_elvis_lhs);
  }
  function SemanticsActions$PageDown$lambda(parentValue, childValue) {
    var tmp1_elvis_lhs = parentValue == null ? null : parentValue.obr_1;
    var tmp = tmp1_elvis_lhs == null ? childValue.obr_1 : tmp1_elvis_lhs;
    var tmp3_elvis_lhs = parentValue == null ? null : parentValue.pbr_1;
    return new AccessibilityAction(tmp, tmp3_elvis_lhs == null ? childValue.pbr_1 : tmp3_elvis_lhs);
  }
  function SemanticsActions$PageRight$lambda(parentValue, childValue) {
    var tmp1_elvis_lhs = parentValue == null ? null : parentValue.obr_1;
    var tmp = tmp1_elvis_lhs == null ? childValue.obr_1 : tmp1_elvis_lhs;
    var tmp3_elvis_lhs = parentValue == null ? null : parentValue.pbr_1;
    return new AccessibilityAction(tmp, tmp3_elvis_lhs == null ? childValue.pbr_1 : tmp3_elvis_lhs);
  }
  function SemanticsActions$GetScrollViewportLength$lambda(parentValue, childValue) {
    var tmp1_elvis_lhs = parentValue == null ? null : parentValue.obr_1;
    var tmp = tmp1_elvis_lhs == null ? childValue.obr_1 : tmp1_elvis_lhs;
    var tmp3_elvis_lhs = parentValue == null ? null : parentValue.pbr_1;
    return new AccessibilityAction(tmp, tmp3_elvis_lhs == null ? childValue.pbr_1 : tmp3_elvis_lhs);
  }
  function SemanticsActions() {
    SemanticsActions_instance = this;
    var tmp = this;
    // Inline function 'androidx.compose.ui.semantics.ActionPropertyKey' call
    var tmp0 = 'GetTextLayoutResult';
    // Inline function 'androidx.compose.ui.semantics.AccessibilityKey' call
    var mergePolicy = SemanticsActions$GetTextLayoutResult$lambda;
    tmp.pbw_1 = SemanticsPropertyKey_init_$Create$_0(tmp0, true, mergePolicy);
    var tmp_0 = this;
    // Inline function 'androidx.compose.ui.semantics.ActionPropertyKey' call
    // Inline function 'androidx.compose.ui.semantics.AccessibilityKey' call
    var mergePolicy_0 = SemanticsActions$OnClick$lambda;
    tmp_0.qbw_1 = SemanticsPropertyKey_init_$Create$_0('OnClick', true, mergePolicy_0);
    var tmp_1 = this;
    // Inline function 'androidx.compose.ui.semantics.ActionPropertyKey' call
    var tmp0_0 = 'OnLongClick';
    // Inline function 'androidx.compose.ui.semantics.AccessibilityKey' call
    var mergePolicy_1 = SemanticsActions$OnLongClick$lambda;
    tmp_1.rbw_1 = SemanticsPropertyKey_init_$Create$_0(tmp0_0, true, mergePolicy_1);
    var tmp_2 = this;
    // Inline function 'androidx.compose.ui.semantics.ActionPropertyKey' call
    var tmp0_1 = 'ScrollBy';
    // Inline function 'androidx.compose.ui.semantics.AccessibilityKey' call
    var mergePolicy_2 = SemanticsActions$ScrollBy$lambda;
    tmp_2.sbw_1 = SemanticsPropertyKey_init_$Create$_0(tmp0_1, true, mergePolicy_2);
    this.tbw_1 = new SemanticsPropertyKey('ScrollByOffset');
    var tmp_3 = this;
    // Inline function 'androidx.compose.ui.semantics.ActionPropertyKey' call
    var tmp0_2 = 'ScrollToIndex';
    // Inline function 'androidx.compose.ui.semantics.AccessibilityKey' call
    var mergePolicy_3 = SemanticsActions$ScrollToIndex$lambda;
    tmp_3.ubw_1 = SemanticsPropertyKey_init_$Create$_0(tmp0_2, true, mergePolicy_3);
    var tmp_4 = this;
    // Inline function 'androidx.compose.ui.semantics.ActionPropertyKey' call
    var tmp0_3 = 'OnAutofillText';
    // Inline function 'androidx.compose.ui.semantics.AccessibilityKey' call
    var mergePolicy_4 = SemanticsActions$OnAutofillText$lambda;
    tmp_4.vbw_1 = SemanticsPropertyKey_init_$Create$_0(tmp0_3, true, mergePolicy_4);
    var tmp_5 = this;
    // Inline function 'androidx.compose.ui.semantics.ActionPropertyKey' call
    var tmp0_4 = 'OnFillData';
    // Inline function 'androidx.compose.ui.semantics.AccessibilityKey' call
    var mergePolicy_5 = SemanticsActions$OnFillData$lambda;
    tmp_5.wbw_1 = SemanticsPropertyKey_init_$Create$_0(tmp0_4, true, mergePolicy_5);
    var tmp_6 = this;
    // Inline function 'androidx.compose.ui.semantics.ActionPropertyKey' call
    var tmp0_5 = 'SetProgress';
    // Inline function 'androidx.compose.ui.semantics.AccessibilityKey' call
    var mergePolicy_6 = SemanticsActions$SetProgress$lambda;
    tmp_6.xbw_1 = SemanticsPropertyKey_init_$Create$_0(tmp0_5, true, mergePolicy_6);
    var tmp_7 = this;
    // Inline function 'androidx.compose.ui.semantics.ActionPropertyKey' call
    var tmp0_6 = 'SetSelection';
    // Inline function 'androidx.compose.ui.semantics.AccessibilityKey' call
    var mergePolicy_7 = SemanticsActions$SetSelection$lambda;
    tmp_7.ybw_1 = SemanticsPropertyKey_init_$Create$_0(tmp0_6, true, mergePolicy_7);
    var tmp_8 = this;
    // Inline function 'androidx.compose.ui.semantics.ActionPropertyKey' call
    // Inline function 'androidx.compose.ui.semantics.AccessibilityKey' call
    var mergePolicy_8 = SemanticsActions$SetText$lambda;
    tmp_8.zbw_1 = SemanticsPropertyKey_init_$Create$_0('SetText', true, mergePolicy_8);
    var tmp_9 = this;
    // Inline function 'androidx.compose.ui.semantics.ActionPropertyKey' call
    var tmp0_7 = 'SetTextSubstitution';
    // Inline function 'androidx.compose.ui.semantics.AccessibilityKey' call
    var mergePolicy_9 = SemanticsActions$SetTextSubstitution$lambda;
    tmp_9.abx_1 = SemanticsPropertyKey_init_$Create$_0(tmp0_7, true, mergePolicy_9);
    var tmp_10 = this;
    // Inline function 'androidx.compose.ui.semantics.ActionPropertyKey' call
    var tmp0_8 = 'ShowTextSubstitution';
    // Inline function 'androidx.compose.ui.semantics.AccessibilityKey' call
    var mergePolicy_10 = SemanticsActions$ShowTextSubstitution$lambda;
    tmp_10.bbx_1 = SemanticsPropertyKey_init_$Create$_0(tmp0_8, true, mergePolicy_10);
    var tmp_11 = this;
    // Inline function 'androidx.compose.ui.semantics.ActionPropertyKey' call
    var tmp0_9 = 'ClearTextSubstitution';
    // Inline function 'androidx.compose.ui.semantics.AccessibilityKey' call
    var mergePolicy_11 = SemanticsActions$ClearTextSubstitution$lambda;
    tmp_11.cbx_1 = SemanticsPropertyKey_init_$Create$_0(tmp0_9, true, mergePolicy_11);
    var tmp_12 = this;
    // Inline function 'androidx.compose.ui.semantics.ActionPropertyKey' call
    var tmp0_10 = 'InsertTextAtCursor';
    // Inline function 'androidx.compose.ui.semantics.AccessibilityKey' call
    var mergePolicy_12 = SemanticsActions$InsertTextAtCursor$lambda;
    tmp_12.dbx_1 = SemanticsPropertyKey_init_$Create$_0(tmp0_10, true, mergePolicy_12);
    var tmp_13 = this;
    // Inline function 'androidx.compose.ui.semantics.ActionPropertyKey' call
    var tmp0_11 = 'PerformImeAction';
    // Inline function 'androidx.compose.ui.semantics.AccessibilityKey' call
    var mergePolicy_13 = SemanticsActions$OnImeAction$lambda;
    tmp_13.ebx_1 = SemanticsPropertyKey_init_$Create$_0(tmp0_11, true, mergePolicy_13);
    var tmp_14 = this;
    // Inline function 'androidx.compose.ui.semantics.ActionPropertyKey' call
    var tmp0_12 = 'PerformImeAction';
    // Inline function 'androidx.compose.ui.semantics.AccessibilityKey' call
    var mergePolicy_14 = SemanticsActions$PerformImeAction$lambda;
    tmp_14.fbx_1 = SemanticsPropertyKey_init_$Create$_0(tmp0_12, true, mergePolicy_14);
    var tmp_15 = this;
    // Inline function 'androidx.compose.ui.semantics.ActionPropertyKey' call
    var tmp0_13 = 'CopyText';
    // Inline function 'androidx.compose.ui.semantics.AccessibilityKey' call
    var mergePolicy_15 = SemanticsActions$CopyText$lambda;
    tmp_15.gbx_1 = SemanticsPropertyKey_init_$Create$_0(tmp0_13, true, mergePolicy_15);
    var tmp_16 = this;
    // Inline function 'androidx.compose.ui.semantics.ActionPropertyKey' call
    // Inline function 'androidx.compose.ui.semantics.AccessibilityKey' call
    var mergePolicy_16 = SemanticsActions$CutText$lambda;
    tmp_16.hbx_1 = SemanticsPropertyKey_init_$Create$_0('CutText', true, mergePolicy_16);
    var tmp_17 = this;
    // Inline function 'androidx.compose.ui.semantics.ActionPropertyKey' call
    var tmp0_14 = 'PasteText';
    // Inline function 'androidx.compose.ui.semantics.AccessibilityKey' call
    var mergePolicy_17 = SemanticsActions$PasteText$lambda;
    tmp_17.ibx_1 = SemanticsPropertyKey_init_$Create$_0(tmp0_14, true, mergePolicy_17);
    var tmp_18 = this;
    // Inline function 'androidx.compose.ui.semantics.ActionPropertyKey' call
    // Inline function 'androidx.compose.ui.semantics.AccessibilityKey' call
    var mergePolicy_18 = SemanticsActions$Expand$lambda;
    tmp_18.jbx_1 = SemanticsPropertyKey_init_$Create$_0('Expand', true, mergePolicy_18);
    var tmp_19 = this;
    // Inline function 'androidx.compose.ui.semantics.ActionPropertyKey' call
    var tmp0_15 = 'Collapse';
    // Inline function 'androidx.compose.ui.semantics.AccessibilityKey' call
    var mergePolicy_19 = SemanticsActions$Collapse$lambda;
    tmp_19.kbx_1 = SemanticsPropertyKey_init_$Create$_0(tmp0_15, true, mergePolicy_19);
    var tmp_20 = this;
    // Inline function 'androidx.compose.ui.semantics.ActionPropertyKey' call
    // Inline function 'androidx.compose.ui.semantics.AccessibilityKey' call
    var mergePolicy_20 = SemanticsActions$Dismiss$lambda;
    tmp_20.lbx_1 = SemanticsPropertyKey_init_$Create$_0('Dismiss', true, mergePolicy_20);
    var tmp_21 = this;
    // Inline function 'androidx.compose.ui.semantics.ActionPropertyKey' call
    var tmp0_16 = 'RequestFocus';
    // Inline function 'androidx.compose.ui.semantics.AccessibilityKey' call
    var mergePolicy_21 = SemanticsActions$RequestFocus$lambda;
    tmp_21.mbx_1 = SemanticsPropertyKey_init_$Create$_0(tmp0_16, true, mergePolicy_21);
    var tmp_22 = this;
    var tmp0_17 = 'CustomActions';
    // Inline function 'androidx.compose.ui.semantics.AccessibilityKey' call
    var mergePolicy_22 = SemanticsActions$CustomActions$lambda;
    tmp_22.nbx_1 = SemanticsPropertyKey_init_$Create$_0(tmp0_17, true, mergePolicy_22);
    var tmp_23 = this;
    // Inline function 'androidx.compose.ui.semantics.ActionPropertyKey' call
    // Inline function 'androidx.compose.ui.semantics.AccessibilityKey' call
    var mergePolicy_23 = SemanticsActions$PageUp$lambda;
    tmp_23.obx_1 = SemanticsPropertyKey_init_$Create$_0('PageUp', true, mergePolicy_23);
    var tmp_24 = this;
    // Inline function 'androidx.compose.ui.semantics.ActionPropertyKey' call
    var tmp0_18 = 'PageLeft';
    // Inline function 'androidx.compose.ui.semantics.AccessibilityKey' call
    var mergePolicy_24 = SemanticsActions$PageLeft$lambda;
    tmp_24.pbx_1 = SemanticsPropertyKey_init_$Create$_0(tmp0_18, true, mergePolicy_24);
    var tmp_25 = this;
    // Inline function 'androidx.compose.ui.semantics.ActionPropertyKey' call
    var tmp0_19 = 'PageDown';
    // Inline function 'androidx.compose.ui.semantics.AccessibilityKey' call
    var mergePolicy_25 = SemanticsActions$PageDown$lambda;
    tmp_25.qbx_1 = SemanticsPropertyKey_init_$Create$_0(tmp0_19, true, mergePolicy_25);
    var tmp_26 = this;
    // Inline function 'androidx.compose.ui.semantics.ActionPropertyKey' call
    var tmp0_20 = 'PageRight';
    // Inline function 'androidx.compose.ui.semantics.AccessibilityKey' call
    var mergePolicy_26 = SemanticsActions$PageRight$lambda;
    tmp_26.rbx_1 = SemanticsPropertyKey_init_$Create$_0(tmp0_20, true, mergePolicy_26);
    var tmp_27 = this;
    // Inline function 'androidx.compose.ui.semantics.ActionPropertyKey' call
    var tmp0_21 = 'GetScrollViewportLength';
    // Inline function 'androidx.compose.ui.semantics.AccessibilityKey' call
    var mergePolicy_27 = SemanticsActions$GetScrollViewportLength$lambda;
    tmp_27.sbx_1 = SemanticsPropertyKey_init_$Create$_0(tmp0_21, true, mergePolicy_27);
  }
  var SemanticsActions_instance;
  function SemanticsActions_getInstance() {
    if (SemanticsActions_instance == null)
      new SemanticsActions();
    return SemanticsActions_instance;
  }
  function throwSemanticsGetNotSupported() {
    _init_properties_SemanticsProperties_kt__mp85yq();
    throw UnsupportedOperationException_init_$Create$('You cannot retrieve a semantics property directly - use one of the SemanticsConfiguration.getOr* methods instead');
  }
  function dialog(_this__u8e3s4) {
    _init_properties_SemanticsProperties_kt__mp85yq();
    _this__u8e3s4.mbr(SemanticsProperties_getInstance().qbu_1, Unit_instance);
  }
  function popup(_this__u8e3s4) {
    _init_properties_SemanticsProperties_kt__mp85yq();
    _this__u8e3s4.mbr(SemanticsProperties_getInstance().pbu_1, Unit_instance);
  }
  function dismiss(_this__u8e3s4, label, action) {
    label = label === VOID ? null : label;
    _init_properties_SemanticsProperties_kt__mp85yq();
    _this__u8e3s4.mbr(SemanticsActions_getInstance().lbx_1, new AccessibilityAction(label, action));
  }
  function expand(_this__u8e3s4, label, action) {
    label = label === VOID ? null : label;
    _init_properties_SemanticsProperties_kt__mp85yq();
    _this__u8e3s4.mbr(SemanticsActions_getInstance().jbx_1, new AccessibilityAction(label, action));
  }
  function collapse(_this__u8e3s4, label, action) {
    label = label === VOID ? null : label;
    _init_properties_SemanticsProperties_kt__mp85yq();
    _this__u8e3s4.mbr(SemanticsActions_getInstance().kbx_1, new AccessibilityAction(label, action));
  }
  function setProgress(_this__u8e3s4, label, action) {
    label = label === VOID ? null : label;
    _init_properties_SemanticsProperties_kt__mp85yq();
    _this__u8e3s4.mbr(SemanticsActions_getInstance().xbw_1, new AccessibilityAction(label, action));
  }
  function error(_this__u8e3s4, description) {
    _init_properties_SemanticsProperties_kt__mp85yq();
    _this__u8e3s4.mbr(SemanticsProperties_getInstance().gbv_1, description);
  }
  function indexForKey(_this__u8e3s4, mapping) {
    _init_properties_SemanticsProperties_kt__mp85yq();
    _this__u8e3s4.mbr(SemanticsProperties_getInstance().hbv_1, mapping);
  }
  function scrollToIndex(_this__u8e3s4, label, action) {
    label = label === VOID ? null : label;
    _init_properties_SemanticsProperties_kt__mp85yq();
    _this__u8e3s4.mbr(SemanticsActions_getInstance().ubw_1, new AccessibilityAction(label, action));
  }
  function getScrollViewportLength(_this__u8e3s4, label, action) {
    label = label === VOID ? null : label;
    _init_properties_SemanticsProperties_kt__mp85yq();
    var tmp = SemanticsActions_getInstance().sbx_1;
    _this__u8e3s4.mbr(tmp, new AccessibilityAction(label, getScrollViewportLength$lambda(action)));
  }
  function pageUp(_this__u8e3s4, label, action) {
    label = label === VOID ? null : label;
    _init_properties_SemanticsProperties_kt__mp85yq();
    _this__u8e3s4.mbr(SemanticsActions_getInstance().obx_1, new AccessibilityAction(label, action));
  }
  function pageDown(_this__u8e3s4, label, action) {
    label = label === VOID ? null : label;
    _init_properties_SemanticsProperties_kt__mp85yq();
    _this__u8e3s4.mbr(SemanticsActions_getInstance().qbx_1, new AccessibilityAction(label, action));
  }
  function pageLeft(_this__u8e3s4, label, action) {
    label = label === VOID ? null : label;
    _init_properties_SemanticsProperties_kt__mp85yq();
    _this__u8e3s4.mbr(SemanticsActions_getInstance().pbx_1, new AccessibilityAction(label, action));
  }
  function pageRight(_this__u8e3s4, label, action) {
    label = label === VOID ? null : label;
    _init_properties_SemanticsProperties_kt__mp85yq();
    _this__u8e3s4.mbr(SemanticsActions_getInstance().rbx_1, new AccessibilityAction(label, action));
  }
  function _get_stateDescription_$ref_nxr2xd() {
    return constructCallableReference(function (p0) {
      return get_stateDescription(p0);
    }, 1, 0, 66);
  }
  function _set_stateDescription_$ref_9zoex1() {
    return constructCallableReference(function (p0, p1) {
      set_stateDescription(p0, p1);
      return Unit_instance;
    }, 2, 0, 67);
  }
  function _get_progressBarRangeInfo_$ref_wpds2d() {
    return constructCallableReference(function (p0) {
      return get_progressBarRangeInfo(p0);
    }, 1, 0, 68);
  }
  function _set_progressBarRangeInfo_$ref_s70kf5() {
    return constructCallableReference(function (p0, p1) {
      set_progressBarRangeInfo(p0, p1);
      return Unit_instance;
    }, 2, 0, 69);
  }
  function _get_paneTitle_$ref_sry228() {
    return constructCallableReference(function (p0) {
      return get_paneTitle(p0);
    }, 1, 0, 70);
  }
  function _set_paneTitle_$ref_r1ehek() {
    return constructCallableReference(function (p0, p1) {
      set_paneTitle(p0, p1);
      return Unit_instance;
    }, 2, 0, 71);
  }
  function _get_liveRegion_$ref_nj2rcq() {
    return constructCallableReference(function (p0) {
      return new LiveRegionMode(get_liveRegion(p0));
    }, 1, 0, 72);
  }
  function _set_liveRegion_$ref_200ooq() {
    return constructCallableReference(function (p0, p1) {
      set_liveRegion(p0, p1.obw_1);
      return Unit_instance;
    }, 2, 0, 73);
  }
  function _get_focused_$ref_wjz889() {
    return constructCallableReference(function (p0) {
      return get_focused(p0);
    }, 1, 0, 74);
  }
  function _set_focused_$ref_29l1wd() {
    return constructCallableReference(function (p0, p1) {
      set_focused(p0, p1);
      return Unit_instance;
    }, 2, 0, 75);
  }
  function _get_isContainer_$ref_r5icx5() {
    return constructCallableReference(function (p0) {
      return get_isContainer(p0);
    }, 1, 0, 76);
  }
  function _set_isContainer_$ref_h1s5el() {
    return constructCallableReference(function (p0, p1) {
      set_isContainer(p0, p1);
      return Unit_instance;
    }, 2, 0, 77);
  }
  function _get_isTraversalGroup_$ref_hzo9ox() {
    return constructCallableReference(function (p0) {
      return get_isTraversalGroup(p0);
    }, 1, 0, 78);
  }
  function _set_isTraversalGroup_$ref_41llol() {
    return constructCallableReference(function (p0, p1) {
      set_isTraversalGroup(p0, p1);
      return Unit_instance;
    }, 2, 0, 79);
  }
  function _get_contentType_$ref_ae09sd() {
    return constructCallableReference(function (p0) {
      return get_contentType(p0);
    }, 1, 0, 80);
  }
  function _set_contentType_$ref_aa29t() {
    return constructCallableReference(function (p0, p1) {
      set_contentType(p0, p1);
      return Unit_instance;
    }, 2, 0, 81);
  }
  function _get_contentDataType_$ref_t9e7er() {
    return constructCallableReference(function (p0) {
      return get_contentDataType(p0);
    }, 1, 0, 82);
  }
  function _set_contentDataType_$ref_fynyif() {
    return constructCallableReference(function (p0, p1) {
      set_contentDataType(p0, p1);
      return Unit_instance;
    }, 2, 0, 83);
  }
  function _get_fillableData_$ref_xc9jlf() {
    return constructCallableReference(function (p0) {
      return get_fillableData(p0);
    }, 1, 0, 84);
  }
  function _set_fillableData_$ref_495ain() {
    return constructCallableReference(function (p0, p1) {
      set_fillableData(p0, p1);
      return Unit_instance;
    }, 2, 0, 85);
  }
  function _get_traversalIndex_$ref_f97zgm() {
    return constructCallableReference(function (p0) {
      return get_traversalIndex(p0);
    }, 1, 0, 86);
  }
  function _set_traversalIndex_$ref_lu0re6() {
    return constructCallableReference(function (p0, p1) {
      set_traversalIndex(p0, p1);
      return Unit_instance;
    }, 2, 0, 87);
  }
  function _get_horizontalScrollAxisRange_$ref_z3ym51() {
    return constructCallableReference(function (p0) {
      return get_horizontalScrollAxisRange(p0);
    }, 1, 0, 88);
  }
  function _set_horizontalScrollAxisRange_$ref_pj8oi1() {
    return constructCallableReference(function (p0, p1) {
      set_horizontalScrollAxisRange(p0, p1);
      return Unit_instance;
    }, 2, 0, 89);
  }
  function _get_verticalScrollAxisRange_$ref_fvd607() {
    return constructCallableReference(function (p0) {
      return get_verticalScrollAxisRange(p0);
    }, 1, 0, 90);
  }
  function _set_verticalScrollAxisRange_$ref_rw8kpx() {
    return constructCallableReference(function (p0, p1) {
      set_verticalScrollAxisRange(p0, p1);
      return Unit_instance;
    }, 2, 0, 91);
  }
  function _get_role_$ref_tir090() {
    return constructCallableReference(function (p0) {
      return new Role(get_role_0(p0));
    }, 1, 0, 92);
  }
  function _set_role_$ref_spgq9c() {
    return constructCallableReference(function (p0, p1) {
      set_role(p0, p1.jbw_1);
      return Unit_instance;
    }, 2, 0, 93);
  }
  function _get_textSubstitution_$ref_dsq0y8() {
    return constructCallableReference(function (p0) {
      return get_textSubstitution(p0);
    }, 1, 0, 94);
  }
  function _set_textSubstitution_$ref_5cn24() {
    return constructCallableReference(function (p0, p1) {
      set_textSubstitution(p0, p1);
      return Unit_instance;
    }, 2, 0, 95);
  }
  function _get_isShowingTextSubstitution_$ref_x5tuwr() {
    return constructCallableReference(function (p0) {
      return get_isShowingTextSubstitution(p0);
    }, 1, 0, 96);
  }
  function _set_isShowingTextSubstitution_$ref_nl3x9r() {
    return constructCallableReference(function (p0, p1) {
      set_isShowingTextSubstitution(p0, p1);
      return Unit_instance;
    }, 2, 0, 97);
  }
  function _get_inputText_$ref_ubbzzr() {
    return constructCallableReference(function (p0) {
      return get_inputText(p0);
    }, 1, 0, 98);
  }
  function _set_inputText_$ref_f3khhf() {
    return constructCallableReference(function (p0, p1) {
      set_inputText(p0, p1);
      return Unit_instance;
    }, 2, 0, 99);
  }
  function _get_editableText_$ref_smlf13() {
    return constructCallableReference(function (p0) {
      return get_editableText(p0);
    }, 1, 0, 100);
  }
  function _set_editableText_$ref_dbedv9() {
    return constructCallableReference(function (p0, p1) {
      set_editableText(p0, p1);
      return Unit_instance;
    }, 2, 0, 101);
  }
  function _get_textSelectionRange_$ref_yq5ihw() {
    return constructCallableReference(function (p0) {
      return new TextRange(get_textSelectionRange(p0));
    }, 1, 0, 102);
  }
  function _set_textSelectionRange_$ref_e1v31k() {
    return constructCallableReference(function (p0, p1) {
      set_textSelectionRange(p0, p1.b7u_1);
      return Unit_instance;
    }, 2, 0, 103);
  }
  function _get_selected_$ref_j8rczj() {
    return constructCallableReference(function (p0) {
      return get_selected(p0);
    }, 1, 0, 104);
  }
  function _set_selected_$ref_3p0mff() {
    return constructCallableReference(function (p0, p1) {
      set_selected(p0, p1);
      return Unit_instance;
    }, 2, 0, 105);
  }
  function _get_collectionInfo_$ref_n7coky() {
    return constructCallableReference(function (p0) {
      return get_collectionInfo(p0);
    }, 1, 0, 106);
  }
  function _set_collectionInfo_$ref_aqimje() {
    return constructCallableReference(function (p0, p1) {
      set_collectionInfo(p0, p1);
      return Unit_instance;
    }, 2, 0, 107);
  }
  function _get_toggleableState_$ref_rh1ucd() {
    return constructCallableReference(function (p0) {
      return get_toggleableState(p0);
    }, 1, 0, 108);
  }
  function _set_toggleableState_$ref_e6blg1() {
    return constructCallableReference(function (p0, p1) {
      set_toggleableState(p0, p1);
      return Unit_instance;
    }, 2, 0, 109);
  }
  function _get_isEditable_$ref_838bnw() {
    return constructCallableReference(function (p0) {
      return get_isEditable(p0);
    }, 1, 0, 110);
  }
  function _set_isEditable_$ref_hfv4dk() {
    return constructCallableReference(function (p0, p1) {
      set_isEditable(p0, p1);
      return Unit_instance;
    }, 2, 0, 111);
  }
  function _get_shape_$ref_a2d2v5() {
    return constructCallableReference(function (p0) {
      return get_shape(p0);
    }, 1, 0, 112);
  }
  function _set_shape_$ref_vnwipf() {
    return constructCallableReference(function (p0, p1) {
      set_shape(p0, p1);
      return Unit_instance;
    }, 2, 0, 113);
  }
  function getScrollViewportLength$lambda($action) {
    return function (it) {
      var viewport = $action();
      var tmp;
      if (viewport == null) {
        tmp = false;
      } else {
        it.j1(viewport);
        tmp = true;
      }
      return tmp;
    };
  }
  var properties_initialized_SemanticsProperties_kt_cpdmz4;
  function _init_properties_SemanticsProperties_kt__mp85yq() {
    if (!properties_initialized_SemanticsProperties_kt_cpdmz4) {
      properties_initialized_SemanticsProperties_kt_cpdmz4 = true;
      stateDescription$delegate = SemanticsProperties_getInstance().tbt_1;
      progressBarRangeInfo$delegate = SemanticsProperties_getInstance().ubt_1;
      paneTitle$delegate = SemanticsProperties_getInstance().vbt_1;
      liveRegion$delegate = SemanticsProperties_getInstance().cbu_1;
      focused$delegate = SemanticsProperties_getInstance().dbu_1;
      isContainer$delegate = SemanticsProperties_getInstance().ebu_1;
      isTraversalGroup$delegate = SemanticsProperties_getInstance().fbu_1;
      isSensitiveData$delegate = SemanticsProperties_getInstance().gbu_1;
      contentType$delegate = SemanticsProperties_getInstance().jbu_1;
      contentDataType$delegate = SemanticsProperties_getInstance().kbu_1;
      fillableData$delegate = SemanticsProperties_getInstance().lbu_1;
      traversalIndex$delegate = SemanticsProperties_getInstance().mbu_1;
      horizontalScrollAxisRange$delegate = SemanticsProperties_getInstance().nbu_1;
      verticalScrollAxisRange$delegate = SemanticsProperties_getInstance().obu_1;
      role$delegate = SemanticsProperties_getInstance().rbu_1;
      testTag$delegate = SemanticsProperties_getInstance().sbu_1;
      textSubstitution$delegate = SemanticsProperties_getInstance().vbu_1;
      isShowingTextSubstitution$delegate = SemanticsProperties_getInstance().wbu_1;
      inputText$delegate = SemanticsProperties_getInstance().xbu_1;
      editableText$delegate = SemanticsProperties_getInstance().ybu_1;
      textSelectionRange$delegate = SemanticsProperties_getInstance().zbu_1;
      textCompositionRange$delegate = SemanticsProperties_getInstance().abv_1;
      imeAction$delegate = SemanticsProperties_getInstance().bbv_1;
      selected$delegate = SemanticsProperties_getInstance().cbv_1;
      collectionInfo$delegate = SemanticsProperties_getInstance().xbt_1;
      collectionItemInfo$delegate = SemanticsProperties_getInstance().ybt_1;
      toggleableState$delegate = SemanticsProperties_getInstance().dbv_1;
      inputTextSuggestionState$delegate = SemanticsProperties_getInstance().ebv_1;
      isEditable$delegate = SemanticsProperties_getInstance().ibv_1;
      maxTextLength$delegate = SemanticsProperties_getInstance().jbv_1;
      shape$delegate = SemanticsProperties_getInstance().kbv_1;
      customActions$delegate = SemanticsActions_getInstance().nbx_1;
      androidx_compose_ui_semantics_SemanticsProperties$stable = 8;
      androidx_compose_ui_semantics_SemanticsActions$stable = 8;
      androidx_compose_ui_semantics_SemanticsPropertyKey$stable = 8;
      androidx_compose_ui_semantics_AccessibilityAction$stable = 0;
      androidx_compose_ui_semantics_CustomAccessibilityAction$stable = 0;
      androidx_compose_ui_semantics_ProgressBarRangeInfo$stable = 0;
      androidx_compose_ui_semantics_CollectionInfo$stable = 0;
      androidx_compose_ui_semantics_CollectionItemInfo$stable = 0;
      androidx_compose_ui_semantics_ScrollAxisRange$stable = 0;
      androidx_compose_ui_semantics_InputTextSuggestionState$stable = 0;
    }
  }
  function get_EverythingButLastChildOffset() {
    _init_properties_RectList_kt__4zlfpe();
    return EverythingButLastChildOffset;
  }
  var EverythingButLastChildOffset;
  function get_EverythingButParentId() {
    _init_properties_RectList_kt__4zlfpe();
    return EverythingButParentId;
  }
  var EverythingButParentId;
  function get_TombStone() {
    _init_properties_RectList_kt__4zlfpe();
    return TombStone;
  }
  var TombStone;
  var androidx_compose_ui_spatial_RectList$stable;
  function resizeStorage_0($this, actualSize, currentSize, currentItems) {
    var tmp0 = imul(actualSize, 2);
    // Inline function 'kotlin.math.max' call
    var b = currentSize + 3 | 0;
    var newSize = Math.max(tmp0, b);
    $this.nby_1 = copyOf(currentItems, newSize);
    $this.oby_1 = copyOf($this.oby_1, newSize);
  }
  function updateSubhierarchy($this, stackMeta, deltaX, deltaY) {
    var items = $this.nby_1;
    var stack = $this.oby_1;
    var size = $this.n1();
    stack[0] = stackMeta;
    var stackSize = 1;
    $l$loop: while (stackSize > 0) {
      stackSize = stackSize - 1 | 0;
      var idAndStartAndOffset = stack[stackSize];
      // Inline function 'androidx.compose.ui.spatial.unpackMetaValue' call
      var parentId = convertToInt(idAndStartAndOffset) & 33554431;
      // Inline function 'androidx.compose.ui.spatial.unpackMetaParentId' call
      var i = convertToInt(shiftRight(idAndStartAndOffset, 25)) & 33554431;
      // Inline function 'androidx.compose.ui.spatial.unpackMetaLastChildOffset' call
      var offset = convertToInt(shiftRight(idAndStartAndOffset, 50)) & 1023;
      var endIndex = offset === 1023 ? $this.pby_1 : i + imul(offset, 3) | 0;
      if (i < 0)
        break $l$loop;
      $l$loop_0: while (i < (items.length - 2 | 0) && i < endIndex) {
        var meta = items[i + 2 | 0];
        // Inline function 'androidx.compose.ui.spatial.unpackMetaParentId' call
        if ((convertToInt(shiftRight(meta, 25)) & 33554431) === parentId) {
          var topLeft = items[i + 0 | 0];
          var bottomRight = items[i + 1 | 0];
          var tmp = i + 0 | 0;
          // Inline function 'androidx.compose.ui.spatial.unpackX' call
          var tmp0 = convertToInt(shiftRight(topLeft, 32)) + deltaX | 0;
          // Inline function 'androidx.compose.ui.spatial.unpackY' call
          // Inline function 'androidx.compose.ui.spatial.packXY' call
          var y = convertToInt(topLeft) + deltaY | 0;
          items[tmp] = bitwiseOr(shiftLeft(fromInt(tmp0), 32), bitwiseAnd(fromInt(y), new Long(-1, 0)));
          var tmp_0 = i + 1 | 0;
          // Inline function 'androidx.compose.ui.spatial.unpackX' call
          var tmp0_0 = convertToInt(shiftRight(bottomRight, 32)) + deltaX | 0;
          // Inline function 'androidx.compose.ui.spatial.unpackY' call
          // Inline function 'androidx.compose.ui.spatial.packXY' call
          var y_0 = convertToInt(bottomRight) + deltaY | 0;
          items[tmp_0] = bitwiseOr(shiftLeft(fromInt(tmp0_0), 32), bitwiseAnd(fromInt(y_0), new Long(-1, 0)));
          var tmp_1 = i + 2 | 0;
          // Inline function 'androidx.compose.ui.spatial.metaMarkUpdatedIfHasCallbacks' call
          items[tmp_1] = bitwiseOr(meta, shiftLeft(bitwiseAnd(shiftRight(meta, 63), new Long(1, 0)), 60));
          // Inline function 'androidx.compose.ui.spatial.unpackMetaLastChildOffset' call
          if ((convertToInt(shiftRight(meta, 50)) & 1023) > 0) {
            var _unary__edvuaz = stackSize;
            stackSize = _unary__edvuaz + 1 | 0;
            // Inline function 'androidx.compose.ui.spatial.metaWithParentId' call
            var parentId_0 = i + 3 | 0;
            stack[_unary__edvuaz] = bitwiseOr(bitwiseAnd(meta, get_EverythingButParentId()), shiftLeft(fromInt(parentId_0 & 33554431), 25));
          }
        }
        i = i + 3 | 0;
      }
    }
  }
  function RectList() {
    this.nby_1 = longArray(192);
    this.oby_1 = longArray(192);
    this.pby_1 = 0;
  }
  protoOf(RectList).n1 = function () {
    return this.pby_1 / 3 | 0;
  };
  protoOf(RectList).qby = function (value, l, t, r, b, parentId, focusable, gesturable, hasCallbacks, parentIndexInRectList) {
    var value_0 = value & 33554431;
    // Inline function 'androidx.compose.ui.spatial.RectList.allocateItemsIndex' call
    var currentItems = this.nby_1;
    var currentSize = this.pby_1;
    this.pby_1 = currentSize + 3 | 0;
    var actualSize = currentItems.length;
    if (actualSize <= (currentSize + 3 | 0)) {
      resizeStorage_0(this, actualSize, currentSize, currentItems);
    }
    var index = currentSize;
    var items = this.nby_1;
    var tmp = index + 0 | 0;
    // Inline function 'androidx.compose.ui.spatial.packXY' call
    items[tmp] = bitwiseOr(shiftLeft(fromInt(l), 32), bitwiseAnd(fromInt(t), new Long(-1, 0)));
    var tmp_0 = index + 1 | 0;
    // Inline function 'androidx.compose.ui.spatial.packXY' call
    items[tmp_0] = bitwiseOr(shiftLeft(fromInt(r), 32), bitwiseAnd(fromInt(b), new Long(-1, 0)));
    var tmp_1 = index + 2 | 0;
    // Inline function 'androidx.compose.ui.spatial.packMeta' call
    // Inline function 'androidx.compose.ui.spatial.toLong' call
    var tmp$ret$4 = fromInt(hasCallbacks ? 1 : 0);
    var tmp_2 = shiftLeft(tmp$ret$4, 63);
    // Inline function 'androidx.compose.ui.spatial.toLong' call
    var tmp$ret$5 = fromInt(gesturable ? 1 : 0);
    var tmp_3 = bitwiseOr(tmp_2, shiftLeft(tmp$ret$5, 62));
    // Inline function 'androidx.compose.ui.spatial.toLong' call
    var tmp$ret$6 = fromInt(focusable ? 1 : 0);
    var tmp_4 = bitwiseOr(tmp_3, shiftLeft(tmp$ret$6, 61));
    // Inline function 'androidx.compose.ui.spatial.toLong' call
    var tmp$ret$7 = fromInt(true ? 1 : 0);
    var tmp_5 = bitwiseOr(tmp_4, shiftLeft(tmp$ret$7, 60));
    // Inline function 'kotlin.comparisons.minOf' call
    var tmp$ret$8 = Math.min(0, 1023);
    items[tmp_1] = bitwiseOr(bitwiseOr(bitwiseOr(tmp_5, shiftLeft(fromInt(tmp$ret$8), 50)), shiftLeft(fromInt(parentId & 33554431), 25)), fromInt(value_0 & 33554431));
    if (parentId < 0)
      return Unit_instance;
    var parentId_0 = parentId & 33554431;
    var i = !(parentIndexInRectList === -1) ? parentIndexInRectList : index - 3 | 0;
    while (i >= 0) {
      var meta = items[i + 2 | 0];
      // Inline function 'androidx.compose.ui.spatial.unpackMetaValue' call
      if ((convertToInt(meta) & 33554431) === parentId_0) {
        var lastChildOffset = (index - i | 0) / 3 | 0;
        var tmp_6 = i + 2 | 0;
        // Inline function 'androidx.compose.ui.spatial.metaWithLastChildOffset' call
        var tmp_7 = bitwiseAnd(meta, get_EverythingButLastChildOffset());
        // Inline function 'kotlin.comparisons.minOf' call
        var tmp$ret$11 = Math.min(lastChildOffset, 1023);
        items[tmp_6] = bitwiseOr(tmp_7, shiftLeft(fromInt(tmp$ret$11), 50));
        return Unit_instance;
      }
      i = i - 3 | 0;
    }
  };
  protoOf(RectList).rby = function (value, l, t, r, b, parentId, focusable, gesturable, hasCallbacks, parentIndexInRectList, $super) {
    parentId = parentId === VOID ? -1 : parentId;
    focusable = focusable === VOID ? false : focusable;
    gesturable = gesturable === VOID ? false : gesturable;
    hasCallbacks = hasCallbacks === VOID ? false : hasCallbacks;
    parentIndexInRectList = parentIndexInRectList === VOID ? -1 : parentIndexInRectList;
    var tmp;
    if ($super === VOID) {
      this.qby(value, l, t, r, b, parentId, focusable, gesturable, hasCallbacks, parentIndexInRectList);
      tmp = Unit_instance;
    } else {
      tmp = $super.qby.call(this, value, l, t, r, b, parentId, focusable, gesturable, hasCallbacks, parentIndexInRectList);
    }
    return tmp;
  };
  protoOf(RectList).sby = function (value, parentId, offsetFromParentX, offsetFromParentY, width, height, focusable, gesturable, hasCallbacks) {
    var value_0 = value & 33554431;
    var items = this.nby_1;
    var size = this.pby_1;
    var i = size - 3 | 0;
    while (i >= 0) {
      var meta = items[i + 2 | 0];
      // Inline function 'androidx.compose.ui.spatial.unpackMetaValue' call
      if ((convertToInt(meta) & 33554431) === parentId) {
        var parentLT = items[i + 0 | 0];
        // Inline function 'androidx.compose.ui.spatial.unpackX' call
        var parentX = convertToInt(shiftRight(parentLT, 32));
        // Inline function 'androidx.compose.ui.spatial.unpackY' call
        var parentY = convertToInt(parentLT);
        var l = parentX + offsetFromParentX | 0;
        var t = parentY + offsetFromParentY | 0;
        var r = l + width | 0;
        var b = t + height | 0;
        this.qby(value_0, l, t, r, b, parentId, focusable, gesturable, hasCallbacks, i);
        return Unit_instance;
      }
      i = i - 3 | 0;
    }
  };
  protoOf(RectList).gw = function (value) {
    var value_0 = value & 33554431;
    var items = this.nby_1;
    var size = this.pby_1;
    var i = 0;
    $l$loop: while (i < (items.length - 2 | 0) && i < size) {
      var meta = items[i + 2 | 0];
      // Inline function 'androidx.compose.ui.spatial.unpackMetaValue' call
      if ((convertToInt(meta) & 33554431) === value_0) {
        var tmp = i + 0 | 0;
        // Inline function 'kotlin.ULong.toLong' call
        var this_0 = _ULong___init__impl__c78o9k(new Long(-1, -1));
        items[tmp] = _ULong___get_data__impl__fggpzb(this_0);
        var tmp_0 = i + 1 | 0;
        // Inline function 'kotlin.ULong.toLong' call
        var this_1 = _ULong___init__impl__c78o9k(new Long(-1, -1));
        items[tmp_0] = _ULong___get_data__impl__fggpzb(this_1);
        items[i + 2 | 0] = get_TombStone();
        return true;
      }
      i = i + 3 | 0;
    }
    return false;
  };
  protoOf(RectList).tby = function (value, l, t, r, b) {
    var value_0 = value & 33554431;
    var items = this.nby_1;
    var size = this.pby_1;
    var i = 0;
    $l$loop: while (i < (items.length - 2 | 0) && i < size) {
      var meta = items[i + 2 | 0];
      // Inline function 'androidx.compose.ui.spatial.unpackMetaValue' call
      if ((convertToInt(meta) & 33554431) === value_0) {
        var tmp = i + 0 | 0;
        // Inline function 'androidx.compose.ui.spatial.packXY' call
        items[tmp] = bitwiseOr(shiftLeft(fromInt(l), 32), bitwiseAnd(fromInt(t), new Long(-1, 0)));
        var tmp_0 = i + 1 | 0;
        // Inline function 'androidx.compose.ui.spatial.packXY' call
        items[tmp_0] = bitwiseOr(shiftLeft(fromInt(r), 32), bitwiseAnd(fromInt(b), new Long(-1, 0)));
        var tmp_1 = i + 2 | 0;
        // Inline function 'androidx.compose.ui.spatial.metaMarkUpdatedIfHasCallbacks' call
        items[tmp_1] = bitwiseOr(meta, shiftLeft(bitwiseAnd(shiftRight(meta, 63), new Long(1, 0)), 60));
        return true;
      }
      i = i + 3 | 0;
    }
    return false;
  };
  protoOf(RectList).uby = function (value, focusable, gesturable) {
    var value_0 = value & 33554431;
    var items = this.nby_1;
    var size = this.pby_1;
    var i = 0;
    $l$loop: while (i < (items.length - 2 | 0) && i < size) {
      var meta = items[i + 2 | 0];
      // Inline function 'androidx.compose.ui.spatial.unpackMetaValue' call
      if ((convertToInt(meta) & 33554431) === value_0) {
        var tmp = i + 2 | 0;
        // Inline function 'androidx.compose.ui.spatial.metaMarkFlags' call
        var tmp_0 = bitwiseAnd(bitwiseAnd(meta, new Long(-1, -536870913)), new Long(-1, -1073741825));
        var tmp0 = new Long(0, 536870912);
        // Inline function 'androidx.compose.ui.spatial.toInt' call
        // Inline function 'kotlin.Long.times' call
        var other = focusable ? 1 : 0;
        var tmp$ret$3 = multiply(tmp0, fromInt(other));
        var tmp_1 = bitwiseOr(tmp_0, tmp$ret$3);
        var tmp0_0 = new Long(0, 1073741824);
        // Inline function 'androidx.compose.ui.spatial.toInt' call
        // Inline function 'kotlin.Long.times' call
        var other_0 = gesturable ? 1 : 0;
        var tmp$ret$5 = multiply(tmp0_0, fromInt(other_0));
        items[tmp] = bitwiseOr(tmp_1, tmp$ret$5);
        return true;
      }
      i = i + 3 | 0;
    }
    return false;
  };
  protoOf(RectList).vby = function (value, hasCallbacks) {
    var value_0 = value & 33554431;
    var items = this.nby_1;
    var size = this.pby_1;
    var i = 0;
    $l$loop: while (i < (items.length - 2 | 0) && i < size) {
      var meta = items[i + 2 | 0];
      // Inline function 'androidx.compose.ui.spatial.unpackMetaValue' call
      if ((convertToInt(meta) & 33554431) === value_0) {
        var tmp = i + 2 | 0;
        // Inline function 'androidx.compose.ui.spatial.metaMarkUpdatedAndHasCallbacks' call
        var tmp_0 = bitwiseAnd(bitwiseAnd(meta, new Long(-1, -268435457)), new Long(-1, 2147483647));
        var tmp0 = new Long(0, 268435456);
        // Inline function 'androidx.compose.ui.spatial.toInt' call
        // Inline function 'kotlin.Long.times' call
        var other = hasCallbacks ? 1 : 0;
        var tmp$ret$3 = multiply(tmp0, fromInt(other));
        var tmp_1 = bitwiseOr(tmp_0, tmp$ret$3);
        var tmp0_0 = new Long(0, -2147483648);
        // Inline function 'androidx.compose.ui.spatial.toInt' call
        // Inline function 'kotlin.Long.times' call
        var other_0 = hasCallbacks ? 1 : 0;
        var tmp$ret$5 = multiply(tmp0_0, fromInt(other_0));
        items[tmp] = bitwiseOr(tmp_1, tmp$ret$5);
        return true;
      }
      i = i + 3 | 0;
    }
    return false;
  };
  protoOf(RectList).wby = function (value, l, t, r, b) {
    var value_0 = value & 33554431;
    var items = this.nby_1;
    var size = this.pby_1;
    var i = 0;
    $l$loop: while (i < (items.length - 2 | 0) && i < size) {
      var meta = items[i + 2 | 0];
      // Inline function 'androidx.compose.ui.spatial.unpackMetaValue' call
      if ((convertToInt(meta) & 33554431) === value_0) {
        var prevLT = items[i + 0 | 0];
        var tmp = i + 0 | 0;
        // Inline function 'androidx.compose.ui.spatial.packXY' call
        items[tmp] = bitwiseOr(shiftLeft(fromInt(l), 32), bitwiseAnd(fromInt(t), new Long(-1, 0)));
        var tmp_0 = i + 1 | 0;
        // Inline function 'androidx.compose.ui.spatial.packXY' call
        items[tmp_0] = bitwiseOr(shiftLeft(fromInt(r), 32), bitwiseAnd(fromInt(b), new Long(-1, 0)));
        var tmp_1 = i + 2 | 0;
        // Inline function 'androidx.compose.ui.spatial.metaMarkUpdatedIfHasCallbacks' call
        items[tmp_1] = bitwiseOr(meta, shiftLeft(bitwiseAnd(shiftRight(meta, 63), new Long(1, 0)), 60));
        // Inline function 'androidx.compose.ui.spatial.unpackX' call
        var deltaX = l - convertToInt(shiftRight(prevLT, 32)) | 0;
        // Inline function 'androidx.compose.ui.spatial.unpackY' call
        var deltaY = t - convertToInt(prevLT) | 0;
        if (!!(!(deltaX === 0) | !(deltaY === 0))) {
          // Inline function 'androidx.compose.ui.spatial.metaWithParentId' call
          var parentId = i + 3 | 0;
          var tmp$ret$6 = bitwiseOr(bitwiseAnd(meta, get_EverythingButParentId()), shiftLeft(fromInt(parentId & 33554431), 25));
          updateSubhierarchy(this, tmp$ret$6, deltaX, deltaY);
        }
        return Unit_instance;
      }
      i = i + 3 | 0;
    }
  };
  protoOf(RectList).xby = function (value, parentId, offsetFromParentX, offsetFromParentY, width, height) {
    var value_0 = value & 33554431;
    var items = this.nby_1;
    var size = this.pby_1;
    var i = 0;
    $l$loop: while (i < (items.length - 2 | 0) && i < size) {
      var meta = items[i + 2 | 0];
      // Inline function 'androidx.compose.ui.spatial.unpackMetaValue' call
      if ((convertToInt(meta) & 33554431) === parentId) {
        var parentLT = items[i + 0 | 0];
        // Inline function 'androidx.compose.ui.spatial.unpackX' call
        var parentX = convertToInt(shiftRight(parentLT, 32));
        // Inline function 'androidx.compose.ui.spatial.unpackY' call
        var parentY = convertToInt(parentLT);
        var l = parentX + offsetFromParentX | 0;
        var t = parentY + offsetFromParentY | 0;
        var r = l + width | 0;
        var b = t + height | 0;
        i = i + 3 | 0;
        $l$loop_0: while (i < (items.length - 2 | 0) && i < size) {
          var meta_0 = items[i + 2 | 0];
          // Inline function 'androidx.compose.ui.spatial.unpackMetaValue' call
          if ((convertToInt(meta_0) & 33554431) === value_0) {
            var oldLT = items[i + 0 | 0];
            // Inline function 'androidx.compose.ui.spatial.unpackX' call
            var oldL = convertToInt(shiftRight(oldLT, 32));
            // Inline function 'androidx.compose.ui.spatial.unpackY' call
            var oldT = convertToInt(oldLT);
            var deltaX = l - oldL | 0;
            var deltaY = t - oldT | 0;
            var tmp = i + 0 | 0;
            // Inline function 'androidx.compose.ui.spatial.packXY' call
            items[tmp] = bitwiseOr(shiftLeft(fromInt(l), 32), bitwiseAnd(fromInt(t), new Long(-1, 0)));
            var tmp_0 = i + 1 | 0;
            // Inline function 'androidx.compose.ui.spatial.packXY' call
            items[tmp_0] = bitwiseOr(shiftLeft(fromInt(r), 32), bitwiseAnd(fromInt(b), new Long(-1, 0)));
            var tmp_1 = i + 2 | 0;
            // Inline function 'androidx.compose.ui.spatial.metaMarkUpdatedIfHasCallbacks' call
            items[tmp_1] = bitwiseOr(meta_0, shiftLeft(bitwiseAnd(shiftRight(meta_0, 63), new Long(1, 0)), 60));
            if (!(deltaX === 0) || !(deltaY === 0)) {
              // Inline function 'androidx.compose.ui.spatial.metaWithParentId' call
              var parentId_0 = i + 3 | 0;
              var tmp$ret$9 = bitwiseOr(bitwiseAnd(meta_0, get_EverythingButParentId()), shiftLeft(fromInt(parentId_0 & 33554431), 25));
              updateSubhierarchy(this, tmp$ret$9, deltaX, deltaY);
            }
            return Unit_instance;
          }
          i = i + 3 | 0;
        }
      }
      i = i + 3 | 0;
    }
  };
  protoOf(RectList).yby = function (value) {
    var value_0 = value & 33554431;
    var items = this.nby_1;
    var size = this.pby_1;
    var i = 0;
    $l$loop: while (i < (items.length - 2 | 0) && i < size) {
      var meta = items[i + 2 | 0];
      // Inline function 'androidx.compose.ui.spatial.unpackMetaValue' call
      if ((convertToInt(meta) & 33554431) === value_0) {
        var tmp = i + 2 | 0;
        // Inline function 'androidx.compose.ui.spatial.metaMarkUpdatedIfHasCallbacks' call
        items[tmp] = bitwiseOr(meta, shiftLeft(bitwiseAnd(shiftRight(meta, 63), new Long(1, 0)), 60));
        return Unit_instance;
      }
      i = i + 3 | 0;
    }
  };
  protoOf(RectList).zby = function (value) {
    var value_0 = value & 33554431;
    var items = this.nby_1;
    var size = this.pby_1;
    var i = 0;
    $l$loop: while (i < (items.length - 2 | 0) && i < size) {
      var meta = items[i + 2 | 0];
      // Inline function 'androidx.compose.ui.spatial.unpackMetaValue' call
      if ((convertToInt(meta) & 33554431) === value_0) {
        var topLeft = items[i + 0 | 0];
        return topLeft;
      }
      i = i + 3 | 0;
    }
    return new Long(-1, 2147483647);
  };
  protoOf(RectList).abz = function () {
    var from = this.nby_1;
    var size = this.pby_1;
    var to = this.oby_1;
    var i = 0;
    var j = 0;
    $l$loop_0: while (i < (from.length - 2 | 0) && j < (to.length - 2 | 0) && i < size) {
      if (!equalsLong(from[i + 2 | 0], get_TombStone())) {
        to[j + 0 | 0] = from[i + 0 | 0];
        to[j + 1 | 0] = from[i + 1 | 0];
        to[j + 2 | 0] = from[i + 2 | 0];
        j = j + 3 | 0;
      }
      i = i + 3 | 0;
    }
    this.pby_1 = j;
    this.nby_1 = to;
    this.oby_1 = from;
  };
  protoOf(RectList).bbz = function () {
    var items = this.nby_1;
    var size = this.pby_1;
    var i = 0;
    $l$loop: while (i < (items.length - 2 | 0) && i < size) {
      var tmp = i + 2 | 0;
      // Inline function 'androidx.compose.ui.spatial.metaUnMarkUpdated' call
      var meta = items[i + 2 | 0];
      items[tmp] = bitwiseAnd(meta, new Long(-1, -268435457));
      i = i + 3 | 0;
    }
  };
  var properties_initialized_RectList_kt_scu52c;
  function _init_properties_RectList_kt__4zlfpe() {
    if (!properties_initialized_RectList_kt_scu52c) {
      properties_initialized_RectList_kt_scu52c = true;
      var tmp0 = _ULong___init__impl__c78o9k(new Long(-1, -1));
      // Inline function 'kotlin.toULong' call
      // Inline function 'kotlin.ULong.shl' call
      var this_0 = _ULong___init__impl__c78o9k(fromInt(1023));
      // Inline function 'kotlin.ULong.xor' call
      var other = _ULong___init__impl__c78o9k(shiftLeft(_ULong___get_data__impl__fggpzb(this_0), 50));
      // Inline function 'kotlin.ULong.toLong' call
      var this_1 = _ULong___init__impl__c78o9k(bitwiseXor(_ULong___get_data__impl__fggpzb(tmp0), _ULong___get_data__impl__fggpzb(other)));
      EverythingButLastChildOffset = _ULong___get_data__impl__fggpzb(this_1);
      var tmp0_0 = _ULong___init__impl__c78o9k(new Long(-1, -1));
      // Inline function 'kotlin.toULong' call
      // Inline function 'kotlin.ULong.shl' call
      var this_2 = _ULong___init__impl__c78o9k(fromInt(33554431));
      // Inline function 'kotlin.ULong.xor' call
      var other_0 = _ULong___init__impl__c78o9k(shiftLeft(_ULong___get_data__impl__fggpzb(this_2), 25));
      // Inline function 'kotlin.ULong.toLong' call
      var this_3 = _ULong___init__impl__c78o9k(bitwiseXor(_ULong___get_data__impl__fggpzb(tmp0_0), _ULong___get_data__impl__fggpzb(other_0)));
      EverythingButParentId = _ULong___get_data__impl__fggpzb(this_3);
      // Inline function 'androidx.compose.ui.spatial.packMeta' call
      // Inline function 'androidx.compose.ui.spatial.toLong' call
      var tmp$ret$1 = fromInt(false ? 1 : 0);
      var tmp = shiftLeft(tmp$ret$1, 63);
      // Inline function 'androidx.compose.ui.spatial.toLong' call
      var tmp$ret$2 = fromInt(false ? 1 : 0);
      var tmp_0 = bitwiseOr(tmp, shiftLeft(tmp$ret$2, 62));
      // Inline function 'androidx.compose.ui.spatial.toLong' call
      var tmp$ret$3 = fromInt(false ? 1 : 0);
      var tmp_1 = bitwiseOr(tmp_0, shiftLeft(tmp$ret$3, 61));
      // Inline function 'androidx.compose.ui.spatial.toLong' call
      var tmp$ret$4 = fromInt(false ? 1 : 0);
      var tmp_2 = bitwiseOr(tmp_1, shiftLeft(tmp$ret$4, 60));
      // Inline function 'kotlin.comparisons.minOf' call
      var tmp$ret$5 = Math.min(0, 1023);
      TombStone = bitwiseOr(bitwiseOr(bitwiseOr(tmp_2, shiftLeft(fromInt(tmp$ret$5), 50)), shiftLeft(fromInt(-1 & 33554431), 25)), fromInt(-1 & 33554431));
      androidx_compose_ui_spatial_RectList$stable = 8;
    }
  }
  var androidx_compose_ui_spatial_RectManager$stable;
  function resetHasPositionalLayerTransformationsForSubtreeIfNeeded($this, $receiver) {
    if ($receiver.y8z_1 && !hasPositionalLayerTransformations($this, $receiver.hak())) {
      $receiver.y8z_1 = false;
      if ($receiver.a90_1) {
        var it = outerToInnerOffset($this, $receiver);
        $receiver.z8z_1 = it;
        $receiver.a90_1 = false;
      }
      if (!equals($receiver.z8z_1, Companion_getInstance_11().d5g_1)) {
        // Inline function 'androidx.compose.ui.node.LayoutNode.forEachChild' call
        // Inline function 'androidx.compose.runtime.collection.MutableVector.forEach' call
        var this_0 = $receiver.rb1();
        var i = 0;
        var tmp = this_0.b3e_1;
        var content = isArray(tmp) ? tmp : THROW_CCE();
        var size = this_0.d3e_1;
        while (i < size) {
          var it_0 = content[i];
          resetHasPositionalLayerTransformationsForSubtreeIfNeeded($this, it_0);
          i = i + 1 | 0;
        }
      }
    }
  }
  function insertOrUpdateTransformedNodeSubhierarchy($this, layoutNode) {
    insertOrUpdateTransformedNode($this, layoutNode);
    // Inline function 'androidx.compose.ui.node.LayoutNode.forEachChild' call
    // Inline function 'androidx.compose.runtime.collection.MutableVector.forEach' call
    var this_0 = layoutNode.rb1();
    var i = 0;
    var tmp = this_0.b3e_1;
    var content = isArray(tmp) ? tmp : THROW_CCE();
    var size = this_0.d3e_1;
    while (i < size) {
      var it = content[i];
      if (it.b9i()) {
        insertOrUpdateTransformedNodeSubhierarchy($this, it);
      }
      i = i + 1 | 0;
    }
  }
  function insertOrUpdateTransformedNode($this, layoutNode) {
    layoutNode.y8z_1 = true;
    var coord = layoutNode.hak();
    var delegate = layoutNode.nau();
    var width = delegate.mah();
    var height = delegate.zao();
    var rect = $this.jan_1;
    rect.d5d(0.0, 0.0, width, height);
    boundingRectInRoot($this, coord, rect);
    var l = numberToInt(rect.w5c_1);
    var t = numberToInt(rect.x5c_1);
    var r = numberToInt(rect.y5c_1);
    var b = numberToInt(rect.z5c_1);
    var id = layoutNode.x8z_1;
    var firstPlacement = !layoutNode.c90_1;
    layoutNode.c90_1 = true;
    if (firstPlacement || !$this.aan_1.tby(id, l, t, r, b)) {
      var tmp0_safe_receiver = layoutNode.f9a();
      var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.x8z_1;
      var parentId = tmp1_elvis_lhs == null ? -1 : tmp1_elvis_lhs;
      // Inline function 'androidx.compose.ui.node.Nodes.FocusTarget' call
      var tmp$ret$0 = _NodeKind___init__impl__ojsprp(1024);
      var tmp = layoutNode.d91_1.abb(tmp$ret$0);
      // Inline function 'androidx.compose.ui.node.Nodes.PointerInput' call
      var tmp$ret$1 = _NodeKind___init__impl__ojsprp(16);
      $this.aan_1.rby(id, l, t, r, b, parentId, tmp, layoutNode.d91_1.abb(tmp$ret$1), $this.ban_1.cbz_1.hv(id));
    }
    layoutNode.b90_1 = false;
    $this.m40();
  }
  function boundingRectInRoot($this, $receiver, rect) {
    var coordinator = $receiver;
    while (!(coordinator == null)) {
      var layoutNode = coordinator.a9i();
      if (coordinator === layoutNode.hak() && !layoutNode.y8z_1) {
        var offset = $this.obl(layoutNode);
        if (!equals(offset, Companion_getInstance_11().d5g_1)) {
          // Inline function 'androidx.compose.ui.unit.toOffset' call
          var tmp0 = _IntOffset___get_x__impl__qiqr5o(offset);
          // Inline function 'androidx.compose.ui.geometry.Offset' call
          // Inline function 'androidx.compose.ui.util.packFloats' call
          var val2 = _IntOffset___get_y__impl__2avpwj(offset);
          var v1 = fromInt(toRawBits(tmp0));
          var v2 = fromInt(toRawBits(val2));
          var tmp$ret$2 = bitwiseOr(shiftLeft(v1, 32), bitwiseAnd(v2, new Long(-1, 0)));
          var tmp$ret$0 = _Offset___init__impl__c168vi(tmp$ret$2);
          rect.a5d(tmp$ret$0);
          return Unit_instance;
        }
      }
      var layer = coordinator.o95_1;
      if (!(layer == null)) {
        var matrix = layer.jbl();
        if (!isIdentity(matrix)) {
          Matrix__map_impl_7meu7m(matrix, rect);
        }
      }
      // Inline function 'androidx.compose.ui.unit.toOffset' call
      var this_0 = coordinator.iak();
      var tmp0_0 = _IntOffset___get_x__impl__qiqr5o(this_0);
      // Inline function 'androidx.compose.ui.geometry.Offset' call
      // Inline function 'androidx.compose.ui.util.packFloats' call
      var val2_0 = _IntOffset___get_y__impl__2avpwj(this_0);
      var v1_0 = fromInt(toRawBits(tmp0_0));
      var v2_0 = fromInt(toRawBits(val2_0));
      var tmp$ret$5 = bitwiseOr(shiftLeft(v1_0, 32), bitwiseAnd(v2_0, new Long(-1, 0)));
      var tmp$ret$3 = _Offset___init__impl__c168vi(tmp$ret$5);
      rect.a5d(tmp$ret$3);
      coordinator = coordinator.t94_1;
    }
  }
  function hasPositionalLayerTransformations($this, $receiver) {
    var tmp0_safe_receiver = $receiver.o95_1;
    var tmp1_safe_receiver = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.jbl();
    var tmp;
    var tmp_0 = tmp1_safe_receiver;
    if ((tmp_0 == null ? null : new Matrix(tmp_0)) == null) {
      tmp = null;
    } else {
      tmp = isIdentity(tmp1_safe_receiver);
    }
    return tmp === false;
  }
  function outerToInnerOffset($this, $receiver) {
    var terminator = $receiver.hak();
    var position = Companion_getInstance_11().c5g_1;
    var coordinator = $receiver.car();
    $l$loop: while (!(coordinator == null) && coordinator !== terminator) {
      if (hasPositionalLayerTransformations($this, coordinator)) {
        return Companion_getInstance_11().d5g_1;
      }
      position = IntOffset__plus_impl_nqoa9b(position, coordinator.iak());
      coordinator = coordinator.t94_1;
    }
    return position;
  }
  function RectManager$dispatchLambda$lambda(this$0) {
    return function () {
      this$0.gan_1 = null;
      // Inline function 'androidx.compose.ui.util.trace' call
      this$0.jbz();
      return Unit_instance;
    };
  }
  function RectManager(layoutNodes, executeDelayed) {
    layoutNodes = layoutNodes === VOID ? intObjectMapOf() : layoutNodes;
    executeDelayed = executeDelayed === VOID ? ExecuteDelayUsingPostAndRemove_instance : executeDelayed;
    this.yam_1 = layoutNodes;
    this.zam_1 = executeDelayed;
    this.aan_1 = new RectList();
    this.ban_1 = new ThrottledCallbacks();
    var tmp = this;
    // Inline function 'androidx.collection.mutableObjectListOf' call
    tmp.can_1 = new MutableObjectList();
    this.dan_1 = false;
    this.ean_1 = false;
    this.fan_1 = false;
    this.gan_1 = null;
    this.han_1 = new Long(-1, -1);
    var tmp_0 = this;
    tmp_0.ian_1 = RectManager$dispatchLambda$lambda(this);
    this.jan_1 = new MutableRect(0.0, 0.0, 0.0, 0.0);
  }
  protoOf(RectManager).m40 = function () {
    this.dan_1 = true;
  };
  protoOf(RectManager).kbz = function (screenOffset, windowOffset, viewToWindowMatrix, windowWidth, windowHeight) {
    var analysis = analyzeComponents(viewToWindowMatrix);
    var tmp = this;
    var tmp_0;
    var tmp_1;
    // Inline function 'androidx.compose.ui.spatial.hasNonTranslationComponents' call
    if ((analysis & 2) === 0) {
      tmp_1 = viewToWindowMatrix;
    } else {
      tmp_1 = null;
    }
    if (this.ban_1.lbz(screenOffset, windowOffset, tmp_1, windowWidth, windowHeight)) {
      tmp_0 = true;
    } else {
      tmp_0 = this.ean_1;
    }
    tmp.ean_1 = tmp_0;
  };
  protoOf(RectManager).jbz = function () {
    this.mbz();
    var currentTime = currentTimeMillis();
    var isDispatchGlobalCallbacks = this.dan_1 || this.ean_1;
    if (this.dan_1) {
      this.dan_1 = false;
      // Inline function 'androidx.collection.ObjectList.forEach' call
      var this_0 = this.can_1;
      // Inline function 'kotlin.contracts.contract' call
      var content = this_0.sz_1;
      var inductionVariable = 0;
      var last = this_0.tz_1;
      if (inductionVariable < last)
        do {
          var i = inductionVariable;
          inductionVariable = inductionVariable + 1 | 0;
          content[i]();
        }
         while (inductionVariable < last);
      // Inline function 'androidx.compose.ui.spatial.RectList.forEachUpdatedRect' call
      var this_1 = this.aan_1;
      var items = this_1.nby_1;
      var size = this_1.pby_1;
      var i_0 = 0;
      $l$loop: while (i_0 < (items.length - 2 | 0) && i_0 < size) {
        var meta = items[i_0 + 2 | 0];
        // Inline function 'androidx.compose.ui.spatial.unpackMetaUpdated' call
        if (!((convertToInt(shiftRight(meta, 60)) & 1) === 0)) {
          var topLeft = items[i_0 + 0 | 0];
          var bottomRight = items[i_0 + 1 | 0];
          // Inline function 'androidx.compose.ui.spatial.unpackMetaValue' call
          var id = convertToInt(meta) & 33554431;
          this.ban_1.nbz(id, topLeft, bottomRight, currentTime);
        }
        i_0 = i_0 + 3 | 0;
      }
      this.aan_1.bbz();
    }
    if (this.ean_1) {
      this.ean_1 = false;
      this.ban_1.obz(currentTime);
    }
    if (isDispatchGlobalCallbacks) {
      this.ban_1.pbz(currentTime);
    }
    if (this.fan_1) {
      this.fan_1 = false;
      this.aan_1.abz();
    }
    this.ban_1.qbz(currentTime);
    if (compare(this.ban_1.ebz_1, new Long(0, 0)) > 0) {
      this.rbz(true);
    }
  };
  protoOf(RectManager).rbz = function (ensureSomethingScheduled) {
    var canExitEarly = !ensureSomethingScheduled || !(this.gan_1 == null);
    var nextDeadline = this.ban_1.ebz_1;
    if (compare(nextDeadline, new Long(0, 0)) < 0 && canExitEarly) {
      return Unit_instance;
    }
    var currentScheduledDeadline = this.han_1;
    if (equalsLong(currentScheduledDeadline, nextDeadline) && canExitEarly) {
      return Unit_instance;
    }
    var tmp0_safe_receiver = this.gan_1;
    if (tmp0_safe_receiver == null)
      null;
    else {
      // Inline function 'kotlin.let' call
      this.zam_1.sbz(tmp0_safe_receiver);
    }
    var currentTime = currentTimeMillis();
    // Inline function 'kotlin.Long.plus' call
    var nextFrameIsh = add(currentTime, fromInt(16));
    // Inline function 'kotlin.math.max' call
    var deadline = compare(nextDeadline, nextFrameIsh) >= 0 ? nextDeadline : nextFrameIsh;
    this.han_1 = deadline;
    var delay = subtract(deadline, currentTime);
    this.gan_1 = this.zam_1.tbz(delay, this.ian_1);
  };
  protoOf(RectManager).mbz = function () {
    var tmp0_safe_receiver = this.gan_1;
    if (tmp0_safe_receiver == null)
      null;
    else {
      // Inline function 'kotlin.let' call
      this.zam_1.sbz(tmp0_safe_receiver);
      this.gan_1 = null;
    }
  };
  protoOf(RectManager).kan = function (id, throttleMillis, debounceMillis, node, callback) {
    // Inline function 'kotlin.also' call
    var this_0 = this.ban_1.ubz(id, throttleMillis, debounceMillis, node, callback);
    var layoutNode = requireLayoutNode(node.f4n());
    if (layoutNode.c90_1) {
      this.aan_1.vby(id, true);
    }
    this.m40();
    this.rbz(true);
    return this_0;
  };
  protoOf(RectManager).dbe = function (layoutNode) {
    if (layoutNode.c90_1) {
      this.dan_1 = true;
      this.aan_1.yby(layoutNode.x8z_1);
    }
    this.rbz(true);
  };
  protoOf(RectManager).dbb = function (layoutNode, focusable, gesturable) {
    if (layoutNode.y91()) {
      this.aan_1.uby(layoutNode.x8z_1, focusable, gesturable);
    }
  };
  protoOf(RectManager).tbb = function (layoutNode) {
    if (!layoutNode.b9i() || !layoutNode.b90_1)
      return Unit_instance;
    var parent = layoutNode.f9a();
    var tmp;
    if (!(parent == null) && !parent.y8z_1) {
      if (parent.a90_1) {
        parent.a90_1 = false;
        parent.z8z_1 = outerToInnerOffset(this, parent);
      }
      tmp = parent.z8z_1;
    } else if (parent == null) {
      tmp = Companion_getInstance_11().c5g_1;
    } else {
      tmp = Companion_getInstance_11().d5g_1;
    }
    var parentOuterInnerOffset = tmp;
    var outer = layoutNode.hak();
    if (get_isSet(parentOuterInnerOffset) && !hasPositionalLayerTransformations(this, outer)) {
      if (!layoutNode.y8z_1) {
        var offsetFromParent = IntOffset__plus_impl_nqoa9b(parentOuterInnerOffset, outer.iak());
        var delegate = layoutNode.nau();
        var width = delegate.mah();
        var height = delegate.zao();
        var semanticsId = layoutNode.x8z_1;
        if (layoutNode.c90_1) {
          if (!(parent == null)) {
            this.aan_1.xby(semanticsId, parent.x8z_1, _IntOffset___get_x__impl__qiqr5o(offsetFromParent), _IntOffset___get_y__impl__2avpwj(offsetFromParent), width, height);
          } else {
            this.aan_1.wby(semanticsId, _IntOffset___get_x__impl__qiqr5o(offsetFromParent), _IntOffset___get_y__impl__2avpwj(offsetFromParent), _IntOffset___get_x__impl__qiqr5o(offsetFromParent) + width | 0, _IntOffset___get_y__impl__2avpwj(offsetFromParent) + height | 0);
          }
        } else {
          layoutNode.c90_1 = true;
          // Inline function 'androidx.compose.ui.node.Nodes.FocusTarget' call
          var tmp$ret$0 = _NodeKind___init__impl__ojsprp(1024);
          var focusable = layoutNode.d91_1.abb(tmp$ret$0);
          // Inline function 'androidx.compose.ui.node.Nodes.PointerInput' call
          var tmp$ret$1 = _NodeKind___init__impl__ojsprp(16);
          var gesturable = layoutNode.d91_1.abb(tmp$ret$1);
          var hasCallbacks = this.ban_1.cbz_1.hv(semanticsId);
          if (!(parent == null)) {
            this.aan_1.sby(semanticsId, parent.x8z_1, _IntOffset___get_x__impl__qiqr5o(offsetFromParent), _IntOffset___get_y__impl__2avpwj(offsetFromParent), width, height, focusable, gesturable, hasCallbacks);
          } else {
            this.aan_1.rby(semanticsId, _IntOffset___get_x__impl__qiqr5o(offsetFromParent), _IntOffset___get_y__impl__2avpwj(offsetFromParent), _IntOffset___get_x__impl__qiqr5o(offsetFromParent) + width | 0, _IntOffset___get_y__impl__2avpwj(offsetFromParent) + height | 0, VOID, focusable, gesturable, hasCallbacks);
          }
        }
      } else {
        insertOrUpdateTransformedNodeSubhierarchy(this, layoutNode);
        resetHasPositionalLayerTransformationsForSubtreeIfNeeded(this, layoutNode);
      }
    } else {
      insertOrUpdateTransformedNodeSubhierarchy(this, layoutNode);
    }
    layoutNode.b90_1 = false;
    this.m40();
    this.rbz(true);
  };
  protoOf(RectManager).obl = function (layoutNode) {
    var topLeft = this.aan_1.zby(layoutNode.x8z_1);
    var tmp;
    if (equalsLong(topLeft, new Long(-1, 2147483647))) {
      tmp = Companion_getInstance_11().d5g_1;
    } else {
      // Inline function 'androidx.compose.ui.spatial.unpackX' call
      var tmp0 = convertToInt(shiftRight(topLeft, 32));
      // Inline function 'androidx.compose.ui.spatial.unpackY' call
      // Inline function 'androidx.compose.ui.unit.IntOffset' call
      // Inline function 'androidx.compose.ui.util.packInts' call
      var val2 = convertToInt(topLeft);
      var tmp$ret$3 = bitwiseOr(shiftLeft(fromInt(tmp0), 32), bitwiseAnd(fromInt(val2), new Long(-1, 0)));
      tmp = _IntOffset___init__impl__rq8h7b(tmp$ret$3);
    }
    return tmp;
  };
  protoOf(RectManager).bbc = function (layoutNode) {
    if (layoutNode.c90_1) {
      this.aan_1.gw(layoutNode.x8z_1);
      layoutNode.c90_1 = false;
      layoutNode.b90_1 = true;
      this.m40();
      this.fan_1 = true;
    }
  };
  protoOf(RectManager).vbz = function (layoutNode) {
    this.aan_1.vby(layoutNode.x8z_1, false);
  };
  function ExecuteDelayUsingPostAndRemove() {
  }
  protoOf(ExecuteDelayUsingPostAndRemove).tbz = function (delayMillis, block) {
    return postDelayed(delayMillis, block);
  };
  protoOf(ExecuteDelayUsingPostAndRemove).sbz = function (token) {
    return removePost(token);
  };
  var ExecuteDelayUsingPostAndRemove_instance;
  function ExecuteDelayUsingPostAndRemove_getInstance() {
    return ExecuteDelayUsingPostAndRemove_instance;
  }
  function analyzeComponents(_this__u8e3s4) {
    var v = _Matrix___get_values__impl__fblr7b(_this__u8e3s4);
    if (v.length < 16)
      return 0;
    var isIdentity3x3 = v[0] === 1.0 && v[1] === 0.0 && v[2] === 0.0 && v[4] === 0.0 && v[5] === 1.0 && v[6] === 0.0 && v[8] === 0.0 && v[9] === 0.0 && v[10] === 1.0;
    var hasNoTranslationComponents = v[12] === 0.0 && v[13] === 0.0 && v[14] === 0.0 && v[15] === 1.0;
    // Inline function 'androidx.compose.ui.spatial.toInt' call
    var tmp = (isIdentity3x3 ? 1 : 0) << 1;
    // Inline function 'androidx.compose.ui.spatial.toInt' call
    return tmp | (hasNoTranslationComponents ? 1 : 0);
  }
  function get_isSet(_this__u8e3s4) {
    return !equals(_this__u8e3s4, Companion_getInstance_11().d5g_1);
  }
  var androidx_compose_ui_spatial_RelativeLayoutBounds$stable;
  function RelativeLayoutBounds(topLeft, bottomRight, windowOffset, screenOffset, windowSize, viewToWindowMatrix, node) {
    this.wbz_1 = topLeft;
    this.xbz_1 = bottomRight;
    this.ybz_1 = windowOffset;
    this.zbz_1 = screenOffset;
    this.ac0_1 = windowSize;
    this.bc0_1 = viewToWindowMatrix;
    this.cc0_1 = node;
  }
  protoOf(RelativeLayoutBounds).equals = function (other) {
    if (this === other)
      return true;
    if (other == null || !getKClassFromExpression(this).equals(getKClassFromExpression(other)))
      return false;
    if (!(other instanceof RelativeLayoutBounds))
      THROW_CCE();
    if (!equalsLong(this.wbz_1, other.wbz_1))
      return false;
    if (!equalsLong(this.xbz_1, other.xbz_1))
      return false;
    if (!equalsLong(this.ac0_1, other.ac0_1))
      return false;
    if (!equals(this.ybz_1, other.ybz_1))
      return false;
    if (!equals(this.zbz_1, other.zbz_1))
      return false;
    var tmp = this.bc0_1;
    var tmp_0 = tmp == null ? null : new Matrix(tmp);
    var tmp_1 = other.bc0_1;
    if (!equals(tmp_0, tmp_1 == null ? null : new Matrix(tmp_1)))
      return false;
    if (!equals(this.cc0_1, other.cc0_1))
      return false;
    return true;
  };
  protoOf(RelativeLayoutBounds).hashCode = function () {
    var result = this.wbz_1.hashCode();
    result = imul(31, result) + this.xbz_1.hashCode() | 0;
    result = imul(31, result) + this.ac0_1.hashCode() | 0;
    result = imul(31, result) + IntOffset__hashCode_impl_w5rrxs(this.ybz_1) | 0;
    result = imul(31, result) + IntOffset__hashCode_impl_w5rrxs(this.zbz_1) | 0;
    var tmp = imul(31, result);
    var tmp0_safe_receiver = this.bc0_1;
    var tmp_0;
    var tmp_1 = tmp0_safe_receiver;
    if ((tmp_1 == null ? null : new Matrix(tmp_1)) == null) {
      tmp_0 = null;
    } else {
      tmp_0 = Matrix__hashCode_impl_s9ntm9(tmp0_safe_receiver);
    }
    var tmp1_elvis_lhs = tmp_0;
    result = tmp + (tmp1_elvis_lhs == null ? 0 : tmp1_elvis_lhs) | 0;
    result = imul(31, result) + hashCode(this.cc0_1) | 0;
    return result;
  };
  var androidx_compose_ui_spatial_ThrottledCallbacks$stable;
  function Entry($outer, id, throttleMillis, debounceMillis, node, callback) {
    this.nc0_1 = $outer;
    this.dc0_1 = id;
    this.ec0_1 = throttleMillis;
    this.fc0_1 = debounceMillis;
    this.gc0_1 = node;
    this.hc0_1 = callback;
    this.ic0_1 = null;
    this.jc0_1 = new Long(0, 0);
    this.kc0_1 = new Long(0, 0);
    this.lc0_1 = new Long(0, -2147483648);
    this.mc0_1 = new Long(-1, -1);
  }
  protoOf(Entry).n7o = function () {
    var result = multiRemove(this.nc0_1, this.nc0_1.cbz_1, this.dc0_1, this);
    if (!result) {
      removeFromGlobalEntries(this.nc0_1, this);
    }
  };
  protoOf(Entry).oc0 = function (topLeft, bottomRight, windowOffset, screenOffset, viewToWindowMatrix) {
    var rect = rectInfoFor(this.gc0_1, topLeft, bottomRight, windowOffset, screenOffset, this.nc0_1.hbz_1, viewToWindowMatrix);
    if (rect == null) {
      return Unit_instance;
    }
    this.hc0_1(rect);
  };
  function fire($this, entry, windowOffset, screenOffset, viewToWindowMatrix, currentMillis) {
    var lastInvokeMillis = entry.lc0_1;
    var throttleOkay = compare(subtract(currentMillis, lastInvokeMillis), entry.ec0_1) > 0 || equalsLong(lastInvokeMillis, new Long(0, -2147483648));
    var debounceOkay = equalsLong(entry.fc0_1, new Long(0, 0));
    entry.mc0_1 = currentMillis;
    if (throttleOkay && debounceOkay) {
      entry.lc0_1 = currentMillis;
      entry.oc0(entry.jc0_1, entry.kc0_1, windowOffset, screenOffset, viewToWindowMatrix);
    }
    if (!debounceOkay) {
      var currentMinDeadline = $this.ebz_1;
      var thisDeadline = add(currentMillis, entry.fc0_1);
      if (compare(currentMinDeadline, new Long(0, 0)) > 0 && compare(thisDeadline, currentMinDeadline) < 0) {
        $this.ebz_1 = currentMinDeadline;
      }
    }
  }
  function debounceEntry($this, entry, windowOffset, screenOffset, viewToWindowMatrix, currentMillis, minDeadline) {
    var newMinDeadline = minDeadline;
    if (compare(entry.fc0_1, new Long(0, 0)) > 0 && compare(entry.mc0_1, new Long(0, 0)) > 0) {
      if (compare(subtract(currentMillis, entry.mc0_1), entry.fc0_1) >= 0) {
        entry.lc0_1 = currentMillis;
        entry.mc0_1 = new Long(-1, -1);
        var topLeft = entry.jc0_1;
        var bottomRight = entry.kc0_1;
        entry.oc0(topLeft, bottomRight, windowOffset, screenOffset, viewToWindowMatrix);
      } else {
        var tmp0 = newMinDeadline;
        // Inline function 'kotlin.math.min' call
        var b = add(entry.mc0_1, entry.fc0_1);
        newMinDeadline = compare(tmp0, b) <= 0 ? tmp0 : b;
      }
    }
    return newMinDeadline;
  }
  function removeFromGlobalEntries($this, entry) {
    var initialGlobalEntry = $this.dbz_1;
    if (initialGlobalEntry === entry) {
      $this.dbz_1 = initialGlobalEntry.ic0_1;
      entry.ic0_1 = null;
      return true;
    }
    var last = initialGlobalEntry;
    var tmp0_safe_receiver = last;
    var node = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.ic0_1;
    while (!(node == null)) {
      if (node === entry) {
        var tmp1_safe_receiver = last;
        if (tmp1_safe_receiver == null)
          null;
        else {
          tmp1_safe_receiver.ic0_1 = node.ic0_1;
        }
        entry.ic0_1 = null;
        return true;
      }
      last = node;
      node = node.ic0_1;
    }
    return false;
  }
  function multiPut($this, $receiver, key, value) {
    // Inline function 'androidx.collection.MutableIntObjectMap.getOrPut' call
    var tmp0_elvis_lhs = $receiver.l1(key);
    var tmp;
    if (tmp0_elvis_lhs == null) {
      // Inline function 'kotlin.also' call
      $receiver.ew(key, value);
      tmp = value;
    } else {
      tmp = tmp0_elvis_lhs;
    }
    var entry = tmp;
    if (!(entry === value)) {
      while (!(entry.ic0_1 == null)) {
        entry = ensureNotNull(entry.ic0_1);
      }
      entry.ic0_1 = value;
    }
    return value;
  }
  function multiRemove($this, $receiver, key, value) {
    var result = $receiver.gw(key);
    var tmp;
    if (result == null) {
      tmp = false;
    } else if (equals(result, value)) {
      var next = value.ic0_1;
      value.ic0_1 = null;
      if (!(next == null)) {
        $receiver.fw(key, next);
      } else {
        var layoutNode = requireLayoutNode(value.gc0_1.f4n());
        if (layoutNode.c90_1) {
          requireOwner_0(layoutNode).xam().vbz(layoutNode);
        }
      }
      tmp = true;
    } else {
      $receiver.fw(key, result);
      var entry = result;
      $l$loop: while (!(entry == null)) {
        var tmp0_elvis_lhs = entry.ic0_1;
        var tmp_0;
        if (tmp0_elvis_lhs == null) {
          return false;
        } else {
          tmp_0 = tmp0_elvis_lhs;
        }
        var next_0 = tmp_0;
        if (next_0 === value) {
          entry.ic0_1 = value.ic0_1;
          value.ic0_1 = null;
          break $l$loop;
        }
        entry = entry.ic0_1;
      }
      tmp = true;
    }
    return tmp;
  }
  function ThrottledCallbacks() {
    this.cbz_1 = mutableIntObjectMapOf();
    this.dbz_1 = null;
    this.ebz_1 = new Long(-1, -1);
    this.fbz_1 = Companion_getInstance_11().c5g_1;
    this.gbz_1 = Companion_getInstance_11().c5g_1;
    this.hbz_1 = new Long(0, 0);
    this.ibz_1 = null;
  }
  protoOf(ThrottledCallbacks).lbz = function (screen, window_0, matrix, windowWidth, windowHeight) {
    var updated = false;
    if (!equals(window_0, this.fbz_1)) {
      this.fbz_1 = window_0;
      updated = true;
    }
    if (!equals(screen, this.gbz_1)) {
      this.gbz_1 = screen;
      updated = true;
    }
    var tmp = matrix;
    if (!((tmp == null ? null : new Matrix(tmp)) == null)) {
      this.ibz_1 = matrix;
      updated = true;
    }
    // Inline function 'androidx.compose.ui.spatial.packXY' call
    var size = bitwiseOr(shiftLeft(fromInt(windowWidth), 32), bitwiseAnd(fromInt(windowHeight), new Long(-1, 0)));
    if (!equalsLong(size, this.hbz_1)) {
      this.hbz_1 = size;
      updated = true;
    }
    return updated;
  };
  protoOf(ThrottledCallbacks).ubz = function (id, throttleMillis, debounceMillis, node, callback) {
    var debounceToUse = equalsLong(debounceMillis, new Long(0, 0)) ? throttleMillis : debounceMillis;
    return multiPut(this, this.cbz_1, id, new Entry(this, id, throttleMillis, debounceToUse, node, callback));
  };
  protoOf(ThrottledCallbacks).nbz = function (id, topLeft, bottomRight, currentMillis) {
    // Inline function 'androidx.compose.ui.spatial.ThrottledCallbacks.runFor' call
    var entry = this.cbz_1.l1(id);
    while (!(entry == null)) {
      var next = entry.ic0_1;
      var entry_0 = entry;
      this.pc0(entry_0, topLeft, bottomRight, currentMillis);
      entry = next;
    }
  };
  protoOf(ThrottledCallbacks).obz = function (currentMillis) {
    var windowOffset = this.fbz_1;
    var screenOffset = this.gbz_1;
    var viewToWindowMatrix = this.ibz_1;
    // Inline function 'androidx.compose.ui.spatial.ThrottledCallbacks.multiForEach' call
    // Inline function 'androidx.collection.IntObjectMap.forEachValue' call
    var this_0 = this.cbz_1;
    var v = this_0.vv_1;
    $l$block: {
      // Inline function 'androidx.collection.IntObjectMap.forEachIndexed' call
      var m = this_0.tv_1;
      var lastIndex = m.length - 2 | 0;
      var inductionVariable = 0;
      if (inductionVariable <= lastIndex)
        do {
          var i = inductionVariable;
          inductionVariable = inductionVariable + 1 | 0;
          var slot = m[i];
          // Inline function 'androidx.collection.maskEmptyOrDeleted' call
          var this_1 = slot;
          var tmp$ret$3 = bitwiseAnd(bitwiseAnd(this_1, shiftLeft(invert(this_1), 7)), new Long(-2139062144, -2139062144));
          if (!equalsLong(tmp$ret$3, new Long(-2139062144, -2139062144))) {
            var bitCount = 8 - (~(i - lastIndex | 0) >>> 31 | 0) | 0;
            var inductionVariable_0 = 0;
            if (inductionVariable_0 < bitCount)
              do {
                var j = inductionVariable_0;
                inductionVariable_0 = inductionVariable_0 + 1 | 0;
                // Inline function 'androidx.collection.isFull' call
                var value = bitwiseAnd(slot, new Long(255, 0));
                if (compare(value, new Long(128, 0)) < 0) {
                  var index = (i << 3) + j | 0;
                  var entry = v[index];
                  while (!(entry == null)) {
                    var entry_0 = entry;
                    fire(this, entry_0, windowOffset, screenOffset, viewToWindowMatrix, currentMillis);
                    entry = entry.ic0_1;
                  }
                }
                slot = shiftRight(slot, 8);
              }
               while (inductionVariable_0 < bitCount);
            if (!(bitCount === 8)) {
              break $l$block;
            }
          }
        }
         while (!(i === lastIndex));
    }
  };
  protoOf(ThrottledCallbacks).pbz = function (currentMillis) {
    var windowOffset = this.fbz_1;
    var screenOffset = this.gbz_1;
    var viewToWindowMatrix = this.ibz_1;
    var tmp0_safe_receiver = this.dbz_1;
    if (tmp0_safe_receiver == null)
      null;
    else {
      // Inline function 'androidx.compose.ui.spatial.ThrottledCallbacks.linkedForEach' call
      var node = tmp0_safe_receiver;
      while (!(node == null)) {
        var entry = node;
        var node_0 = requireLayoutNode(entry.gc0_1);
        var offsetFromRoot = requireOwner_0(node_0).xam().obl(node_0);
        entry.jc0_1 = _IntOffset___get_packedValue__impl__982pbx(offsetFromRoot);
        var tmp = entry;
        var tmp0 = _IntOffset___get_x__impl__qiqr5o(offsetFromRoot) + node_0.h5e() | 0;
        // Inline function 'androidx.compose.ui.spatial.packXY' call
        var y = _IntOffset___get_y__impl__2avpwj(offsetFromRoot) + node_0.i5e() | 0;
        tmp.kc0_1 = bitwiseOr(shiftLeft(fromInt(tmp0), 32), bitwiseAnd(fromInt(y), new Long(-1, 0)));
        fire(this, entry, windowOffset, screenOffset, viewToWindowMatrix, currentMillis);
        node = node.ic0_1;
      }
    }
  };
  protoOf(ThrottledCallbacks).qbz = function (currentMillis) {
    if (compare(this.ebz_1, currentMillis) > 0)
      return Unit_instance;
    var windowOffset = this.fbz_1;
    var screenOffset = this.gbz_1;
    var viewToWindowMatrix = this.ibz_1;
    var minDeadline = new Long(-1, 2147483647);
    // Inline function 'androidx.compose.ui.spatial.ThrottledCallbacks.multiForEach' call
    // Inline function 'androidx.collection.IntObjectMap.forEachValue' call
    var this_0 = this.cbz_1;
    var v = this_0.vv_1;
    $l$block: {
      // Inline function 'androidx.collection.IntObjectMap.forEachIndexed' call
      var m = this_0.tv_1;
      var lastIndex = m.length - 2 | 0;
      var inductionVariable = 0;
      if (inductionVariable <= lastIndex)
        do {
          var i = inductionVariable;
          inductionVariable = inductionVariable + 1 | 0;
          var slot = m[i];
          // Inline function 'androidx.collection.maskEmptyOrDeleted' call
          var this_1 = slot;
          var tmp$ret$3 = bitwiseAnd(bitwiseAnd(this_1, shiftLeft(invert(this_1), 7)), new Long(-2139062144, -2139062144));
          if (!equalsLong(tmp$ret$3, new Long(-2139062144, -2139062144))) {
            var bitCount = 8 - (~(i - lastIndex | 0) >>> 31 | 0) | 0;
            var inductionVariable_0 = 0;
            if (inductionVariable_0 < bitCount)
              do {
                var j = inductionVariable_0;
                inductionVariable_0 = inductionVariable_0 + 1 | 0;
                // Inline function 'androidx.collection.isFull' call
                var value = bitwiseAnd(slot, new Long(255, 0));
                if (compare(value, new Long(128, 0)) < 0) {
                  var index = (i << 3) + j | 0;
                  var entry = v[index];
                  while (!(entry == null)) {
                    var entry_0 = entry;
                    minDeadline = debounceEntry(this, entry_0, windowOffset, screenOffset, viewToWindowMatrix, currentMillis, minDeadline);
                    entry = entry.ic0_1;
                  }
                }
                slot = shiftRight(slot, 8);
              }
               while (inductionVariable_0 < bitCount);
            if (!(bitCount === 8)) {
              break $l$block;
            }
          }
        }
         while (!(i === lastIndex));
    }
    var tmp0_safe_receiver = this.dbz_1;
    if (tmp0_safe_receiver == null)
      null;
    else {
      // Inline function 'androidx.compose.ui.spatial.ThrottledCallbacks.linkedForEach' call
      var node = tmp0_safe_receiver;
      while (!(node == null)) {
        var entry_1 = node;
        minDeadline = debounceEntry(this, entry_1, windowOffset, screenOffset, viewToWindowMatrix, currentMillis, minDeadline);
        node = node.ic0_1;
      }
    }
    this.ebz_1 = equalsLong(minDeadline, new Long(-1, 2147483647)) ? new Long(-1, -1) : minDeadline;
  };
  protoOf(ThrottledCallbacks).pc0 = function (entry, topLeft, bottomRight, currentMillis) {
    var lastInvokeMillis = entry.lc0_1;
    var throttleMillis = entry.ec0_1;
    var debounceMillis = entry.fc0_1;
    var pastThrottleDeadline = compare(subtract(currentMillis, lastInvokeMillis), throttleMillis) >= 0 || equalsLong(lastInvokeMillis, new Long(0, -2147483648));
    var zeroDebounce = equalsLong(debounceMillis, new Long(0, 0));
    var zeroThrottle = equalsLong(throttleMillis, new Long(0, 0));
    entry.jc0_1 = topLeft;
    entry.kc0_1 = bottomRight;
    var canInvoke = !zeroDebounce && !zeroThrottle || zeroDebounce;
    if (pastThrottleDeadline && canInvoke) {
      entry.mc0_1 = new Long(-1, -1);
      entry.lc0_1 = currentMillis;
      entry.oc0(topLeft, bottomRight, this.fbz_1, this.gbz_1, this.ibz_1);
    } else if (!zeroDebounce) {
      entry.mc0_1 = currentMillis;
      var currentMinDeadline = this.ebz_1;
      var thisDeadline = add(currentMillis, debounceMillis);
      if (compare(currentMinDeadline, new Long(0, 0)) > 0 && compare(thisDeadline, currentMinDeadline) < 0) {
        this.ebz_1 = currentMinDeadline;
      }
    }
  };
  function rectInfoFor(node, topLeft, bottomRight, windowOffset, screenOffset, windowSize, viewToWindowMatrix) {
    // Inline function 'androidx.compose.ui.node.Nodes.Layout' call
    var tmp$ret$0 = _NodeKind___init__impl__ojsprp(2);
    var coordinator = requireCoordinator(node, tmp$ret$0);
    var layoutNode = requireLayoutNode(node);
    if (!layoutNode.b9i())
      return null;
    var needsTransform = !(layoutNode.hak() === coordinator);
    var tmp;
    if (needsTransform) {
      // Inline function 'androidx.compose.ui.unit.toOffset' call
      var this_0 = _IntOffset___init__impl__rq8h7b(topLeft);
      var tmp0 = _IntOffset___get_x__impl__qiqr5o(this_0);
      // Inline function 'androidx.compose.ui.geometry.Offset' call
      // Inline function 'androidx.compose.ui.util.packFloats' call
      var val2 = _IntOffset___get_y__impl__2avpwj(this_0);
      var v1 = fromInt(toRawBits(tmp0));
      var v2 = fromInt(toRawBits(val2));
      var tmp$ret$3 = bitwiseOr(shiftLeft(v1, 32), bitwiseAnd(v2, new Long(-1, 0)));
      var topLeftOffset = _Offset___init__impl__c168vi(tmp$ret$3);
      var size = coordinator.p91().q95();
      var transformedPos = round(layoutNode.hak().p91().q91(coordinator, topLeftOffset));
      var tmp_0 = _IntOffset___get_packedValue__impl__982pbx(transformedPos);
      var tmp_1 = _IntOffset___get_x__impl__qiqr5o(transformedPos);
      // Inline function 'androidx.compose.ui.unit.IntSize.width' call
      // Inline function 'androidx.compose.ui.util.unpackInt1' call
      var value = _IntSize___get_packedValue__impl__uho7jf(size);
      var tmp0_0 = tmp_1 + convertToInt(shiftRight(value, 32)) | 0;
      var tmp_2 = _IntOffset___get_y__impl__2avpwj(transformedPos);
      // Inline function 'androidx.compose.ui.unit.IntSize.height' call
      // Inline function 'androidx.compose.ui.util.unpackInt2' call
      var value_0 = _IntSize___get_packedValue__impl__uho7jf(size);
      // Inline function 'androidx.compose.ui.unit.IntOffset' call
      // Inline function 'androidx.compose.ui.util.packInts' call
      var val2_0 = tmp_2 + convertToInt(bitwiseAnd(value_0, new Long(-1, 0))) | 0;
      var tmp$ret$9 = bitwiseOr(shiftLeft(fromInt(tmp0_0), 32), bitwiseAnd(fromInt(val2_0), new Long(-1, 0)));
      var tmp$ret$8 = _IntOffset___init__impl__rq8h7b(tmp$ret$9);
      tmp = new RelativeLayoutBounds(tmp_0, _IntOffset___get_packedValue__impl__982pbx(tmp$ret$8), windowOffset, screenOffset, windowSize, viewToWindowMatrix, node);
    } else {
      tmp = new RelativeLayoutBounds(topLeft, bottomRight, windowOffset, screenOffset, windowSize, viewToWindowMatrix, node);
    }
    return tmp;
  }
  var ToggleableState_On_instance;
  var ToggleableState_Off_instance;
  var ToggleableState_Indeterminate_instance;
  var ToggleableState_entriesInitialized;
  function ToggleableState_initEntries() {
    if (ToggleableState_entriesInitialized)
      return Unit_instance;
    ToggleableState_entriesInitialized = true;
    ToggleableState_On_instance = new ToggleableState('On', 0);
    ToggleableState_Off_instance = new ToggleableState('Off', 1);
    ToggleableState_Indeterminate_instance = new ToggleableState('Indeterminate', 2);
  }
  function ToggleableState(name, ordinal) {
    Enum.call(this, name, ordinal);
  }
  function ToggleableState_0(value) {
    return value ? ToggleableState_On_getInstance() : ToggleableState_Off_getInstance();
  }
  function ToggleableState_On_getInstance() {
    ToggleableState_initEntries();
    return ToggleableState_On_instance;
  }
  function ToggleableState_Off_getInstance() {
    ToggleableState_initEntries();
    return ToggleableState_Off_instance;
  }
  function ToggleableState_Indeterminate_getInstance() {
    ToggleableState_initEntries();
    return ToggleableState_Indeterminate_instance;
  }
  var DefaultCacheSize;
  function rememberTextMeasurer(cacheSize, $composer, $changed, $default) {
    var cacheSize_0 = cacheSize;
    var $composer_0 = $composer;
    if (!(($default & 1) === 0))
      cacheSize_0 = DefaultCacheSize;
    // Inline function 'androidx.compose.runtime.CompositionLocal.current' call
    var this_0 = get_LocalFontFamilyResolver();
    var $composer_1 = $composer_0;
    var fontFamilyResolver = $composer_1.u31(this_0);
    // Inline function 'androidx.compose.runtime.CompositionLocal.current' call
    var this_1 = get_LocalDensity();
    var $composer_2 = $composer_0;
    var density = $composer_2.u31(this_1);
    // Inline function 'androidx.compose.runtime.CompositionLocal.current' call
    var this_2 = get_LocalLayoutDirection();
    var $composer_3 = $composer_0;
    var layoutDirection = $composer_3.u31(this_2);
    // Inline function 'androidx.compose.runtime.cache' call
    var invalid = !!(!!(!!($composer_0.k31(fontFamilyResolver) | $composer_0.k31(density)) | $composer_0.m31(layoutDirection.a1_1)) | (($changed & 14 ^ 6) > 4 && $composer_0.m31(cacheSize_0) || ($changed & 6) === 4));
    // Inline function 'kotlin.let' call
    var it = $composer_0.i31();
    var tmp;
    if (invalid || it === Companion_getInstance_9().f30_1) {
      var value = new TextMeasurer(fontFamilyResolver, density, layoutDirection, cacheSize_0);
      $composer_0.j31(value);
      tmp = value;
    } else {
      tmp = it;
    }
    return tmp;
  }
  var androidx_compose_ui_window_AlignmentOffsetPositionProvider$stable;
  function areObjectsOfSameType(a, b) {
    var tmp = Object.getPrototypeOf(a).constructor == Object.getPrototypeOf(b).constructor;
    return (!(tmp == null) ? typeof tmp === 'boolean' : false) ? tmp : THROW_CCE();
  }
  function currentTimeMillis() {
    return numberToLong(window.performance.now());
  }
  function set_nextHash(_set____db54di) {
    _init_properties_System_js_kt__dn51u2();
    nextHash = _set____db54di;
  }
  function get_nextHash() {
    _init_properties_System_js_kt__dn51u2();
    return nextHash;
  }
  var nextHash;
  function get_weakMap() {
    _init_properties_System_js_kt__dn51u2();
    return weakMap;
  }
  var weakMap;
  function identityHashCode(instance) {
    _init_properties_System_js_kt__dn51u2();
    if (instance == null) {
      return 0;
    }
    var tmp0_elvis_lhs = get_weakMap().get(instance);
    return tmp0_elvis_lhs == null ? memoizeIdentityHashCode(instance) : tmp0_elvis_lhs;
  }
  function memoizeIdentityHashCode(instance) {
    _init_properties_System_js_kt__dn51u2();
    var _unary__edvuaz = get_nextHash();
    set_nextHash(_unary__edvuaz + 1 | 0);
    var value = _unary__edvuaz;
    get_weakMap().set(instance, value);
    return value;
  }
  var properties_initialized_System_js_kt_4jrb3c;
  function _init_properties_System_js_kt__dn51u2() {
    if (!properties_initialized_System_js_kt_4jrb3c) {
      properties_initialized_System_js_kt_4jrb3c = true;
      nextHash = 1;
      weakMap = new WeakMap();
    }
  }
  function get_browserClipboard() {
    _init_properties_PlatformClipboard_js_kt__l1djfw();
    var tmp0 = browserClipboard$delegate;
    var tmp = KProperty0;
    // Inline function 'kotlin.getValue' call
    getPropertyCallableRef('browserClipboard', 0, tmp, _get_browserClipboard_$ref_z05x78(), null);
    return tmp0.u1();
  }
  var browserClipboard$delegate;
  function get_isSecureContext() {
    _init_properties_PlatformClipboard_js_kt__l1djfw();
    var tmp0 = isSecureContext$delegate;
    var tmp = KProperty0;
    // Inline function 'kotlin.getValue' call
    getPropertyCallableRef('isSecureContext', 0, tmp, _get_isSecureContext_$ref_2psgsy(), null);
    return tmp0.u1();
  }
  var isSecureContext$delegate;
  function get_isFullClipboardApiSupported() {
    _init_properties_PlatformClipboard_js_kt__l1djfw();
    var tmp0 = isFullClipboardApiSupported$delegate;
    var tmp = KProperty0;
    // Inline function 'kotlin.getValue' call
    getPropertyCallableRef('isFullClipboardApiSupported', 0, tmp, _get_isFullClipboardApiSupported_$ref_q4q9vz(), null);
    return tmp0.u1();
  }
  var isFullClipboardApiSupported$delegate;
  function get_isFallbackWriteTextApiAvailable() {
    _init_properties_PlatformClipboard_js_kt__l1djfw();
    var tmp0 = isFallbackWriteTextApiAvailable$delegate;
    var tmp = KProperty0;
    // Inline function 'kotlin.getValue' call
    getPropertyCallableRef('isFallbackWriteTextApiAvailable', 0, tmp, _get_isFallbackWriteTextApiAvailable_$ref_iovytt(), null);
    return tmp0.u1();
  }
  var isFallbackWriteTextApiAvailable$delegate;
  var androidx_compose_ui_platform_ClipEntry$stable;
  function Companion_42() {
  }
  protoOf(Companion_42).qc0 = function (text) {
    var tmp;
    if (get_isFullClipboardApiSupported()) {
      var tmp_0;
      if (get_isSecureContext()) {
        tmp_0 = createClipboardItemWithPlainText(text);
      } else {
        tmp_0 = emptyClipboardItems();
      }
      tmp = new ClipEntry(tmp_0);
    } else {
      // Inline function 'kotlin.emptyArray' call
      var tmp$ret$0 = [];
      // Inline function 'kotlin.apply' call
      var this_0 = new ClipEntry(tmp$ret$0);
      this_0.sc0_1 = text;
      tmp = this_0;
    }
    return tmp;
  };
  var Companion_instance_47;
  function Companion_getInstance_68() {
    return Companion_instance_47;
  }
  function ClipEntry(clipboardItems) {
    this.rc0_1 = clipboardItems;
    this.sc0_1 = null;
  }
  function createClipboardItemWithPlainText(text) {
    _init_properties_PlatformClipboard_js_kt__l1djfw();
    return [new ClipboardItem({'text/plain': new Blob([text], {type: 'text/plain'})})];
  }
  function emptyClipboardItems() {
    _init_properties_PlatformClipboard_js_kt__l1djfw();
    return [new ClipboardItem({'text/plain': new Blob([''], {type: 'text/plain'})})];
  }
  function createPlatformClipboardManager() {
    _init_properties_PlatformClipboard_js_kt__l1djfw();
    return new JsPlatformClipboardManager();
  }
  function createPlatformClipboard() {
    _init_properties_PlatformClipboard_js_kt__l1djfw();
    return new JsPlatformClipboard();
  }
  function JsPlatformClipboardManager() {
  }
  function JsPlatformClipboard$getClipEntry$lambda(this$0) {
    return function (it) {
      println('Failed to read from Clipboard: ' + it.toString());
      return this$0.tc0_1;
    };
  }
  function $getClipEntryCOROUTINE$(_this__u8e3s4, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.cc1_1 = _this__u8e3s4;
  }
  protoOf($getClipEntryCOROUTINE$).v9 = function () {
    var suspendResult = this.p9_1;
    $sm: do
      try {
        var tmp = this.n9_1;
        switch (tmp) {
          case 0:
            this.o9_1 = 2;
            if (!get_isFullClipboardApiSupported()) {
              console.warn("The browser doesn't support Clipboard.read()");
              return null;
            }

            this.n9_1 = 1;
            var tmp_0 = this.cc1_1.dc1().read();
            suspendResult = await_0(tmp_0.catch(JsPlatformClipboard$getClipEntry$lambda(this.cc1_1)), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            var items = suspendResult;
            return new ClipEntry(items);
          case 2:
            throw this.q9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.o9_1 === 2) {
          throw e;
        } else {
          this.n9_1 = this.o9_1;
          this.q9_1 = e;
        }
      }
     while (true);
  };
  function $setClipEntryCOROUTINE$(_this__u8e3s4, clipEntry, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.mc1_1 = _this__u8e3s4;
    this.nc1_1 = clipEntry;
  }
  protoOf($setClipEntryCOROUTINE$).v9 = function () {
    var suspendResult = this.p9_1;
    $sm: do
      try {
        var tmp = this.n9_1;
        switch (tmp) {
          case 0:
            this.o9_1 = 6;
            if (get_isFullClipboardApiSupported()) {
              if (this.nc1_1 == null) {
                this.n9_1 = 3;
                suspendResult = await_0(this.mc1_1.dc1().write(emptyClipboardItems()), this);
                if (suspendResult === get_COROUTINE_SUSPENDED()) {
                  return suspendResult;
                }
                continue $sm;
              } else {
                this.n9_1 = 2;
                suspendResult = await_0(this.mc1_1.dc1().write(this.nc1_1.rc0_1), this);
                if (suspendResult === get_COROUTINE_SUSPENDED()) {
                  return suspendResult;
                }
                continue $sm;
              }
            } else {
              if (isFallbackWriteTextApiAvailable()) {
                var tmp0_safe_receiver = this.nc1_1;
                var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.sc0_1;
                var text = tmp1_elvis_lhs == null ? '' : tmp1_elvis_lhs;
                this.n9_1 = 1;
                suspendResult = await_0(this.mc1_1.dc1().writeText(text), this);
                if (suspendResult === get_COROUTINE_SUSPENDED()) {
                  return suspendResult;
                }
                continue $sm;
              } else {
                var tmp_0 = this;
                console.warn("The browser doesn't support Clipboard.write() and Clipboard.writeText()");
                tmp_0.oc1_1 = Unit_instance;
                this.n9_1 = 5;
                continue $sm;
              }
            }

          case 1:
            this.oc1_1 = suspendResult;
            this.n9_1 = 5;
            continue $sm;
          case 2:
            this.pc1_1 = suspendResult;
            this.n9_1 = 4;
            continue $sm;
          case 3:
            this.pc1_1 = suspendResult;
            this.n9_1 = 4;
            continue $sm;
          case 4:
            this.oc1_1 = this.pc1_1;
            this.n9_1 = 5;
            continue $sm;
          case 5:
            return Unit_instance;
          case 6:
            throw this.q9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.o9_1 === 6) {
          throw e;
        } else {
          this.n9_1 = this.o9_1;
          this.q9_1 = e;
        }
      }
     while (true);
  };
  function JsPlatformClipboard() {
    if (!get_isSecureContext()) {
      console.warn('Clipboard API is not available in insecure contexts.');
    } else if (!get_isFallbackWriteTextApiAvailable()) {
      console.warn("The browser doesn't support Clipboard.read(), Clipboard.write() and Clipboard.writeText()");
    } else if (!get_isFullClipboardApiSupported()) {
      console.warn("The browser doesn't support Clipboard.read() and Clipboard.write()");
    }
    var tmp = this;
    // Inline function 'kotlin.emptyArray' call
    tmp.tc0_1 = [];
  }
  protoOf(JsPlatformClipboard).qc1 = function ($completion) {
    var tmp = new $getClipEntryCOROUTINE$(this, $completion);
    tmp.p9_1 = Unit_instance;
    tmp.q9_1 = null;
    return tmp.v9();
  };
  protoOf(JsPlatformClipboard).rc1 = function (clipEntry, $completion) {
    var tmp = new $setClipEntryCOROUTINE$(this, clipEntry, $completion);
    tmp.p9_1 = Unit_instance;
    tmp.q9_1 = null;
    return tmp.v9();
  };
  protoOf(JsPlatformClipboard).dc1 = function () {
    return get_browserClipboard();
  };
  function browserClipboard$delegate$lambda() {
    _init_properties_PlatformClipboard_js_kt__l1djfw();
    return getW3CClipboard();
  }
  function _get_browserClipboard_$ref_z05x78() {
    return constructCallableReference(function () {
      return get_browserClipboard();
    }, 0, 0, 114);
  }
  function isSecureContext$delegate$lambda() {
    _init_properties_PlatformClipboard_js_kt__l1djfw();
    return isSecureContext();
  }
  function _get_isSecureContext_$ref_2psgsy() {
    return constructCallableReference(function () {
      return get_isSecureContext();
    }, 0, 0, 115);
  }
  function isFullClipboardApiSupported$delegate$lambda() {
    _init_properties_PlatformClipboard_js_kt__l1djfw();
    return get_isSecureContext() && isFullClipboardApiSupported();
  }
  function _get_isFullClipboardApiSupported_$ref_q4q9vz() {
    return constructCallableReference(function () {
      return get_isFullClipboardApiSupported();
    }, 0, 0, 116);
  }
  function isFallbackWriteTextApiAvailable$delegate$lambda() {
    _init_properties_PlatformClipboard_js_kt__l1djfw();
    return get_isSecureContext() && isFallbackWriteTextApiAvailable();
  }
  function _get_isFallbackWriteTextApiAvailable_$ref_iovytt() {
    return constructCallableReference(function () {
      return get_isFallbackWriteTextApiAvailable();
    }, 0, 0, 117);
  }
  var properties_initialized_PlatformClipboard_js_kt_clql8q;
  function _init_properties_PlatformClipboard_js_kt__l1djfw() {
    if (!properties_initialized_PlatformClipboard_js_kt_clql8q) {
      properties_initialized_PlatformClipboard_js_kt_clql8q = true;
      browserClipboard$delegate = lazy_0(browserClipboard$delegate$lambda);
      isSecureContext$delegate = lazy_0(isSecureContext$delegate$lambda);
      isFullClipboardApiSupported$delegate = lazy_0(isFullClipboardApiSupported$delegate$lambda);
      isFallbackWriteTextApiAvailable$delegate = lazy_0(isFallbackWriteTextApiAvailable$delegate$lambda);
      androidx_compose_ui_platform_ClipEntry$stable = 8;
    }
  }
  function classKeyForObject(a) {
    return getKClassFromExpression(a);
  }
  function get_PostDelayedDispatcher() {
    return Dispatchers_getInstance().m1h();
  }
  var androidx_compose_ui_AtomicReference$stable;
  function AtomicReference(value) {
    this.k8x_1 = atomic$ref$1(value);
  }
  protoOf(AtomicReference).x21 = function (value) {
    return this.k8x_1.atomicfu$getAndSet(value);
  };
  protoOf(AtomicReference).w21 = function (expect, newValue) {
    return this.k8x_1.atomicfu$compareAndSet(expect, newValue);
  };
  var androidx_compose_ui_input_pointer_PointerEventTimeoutCancellationException$stable;
  function PointerEventTimeoutCancellationException(time) {
    CancellationException_init_$Init$('Timed out waiting for ' + time.toString() + ' ms', this);
    captureStack(this, PointerEventTimeoutCancellationException);
  }
  var androidx_compose_ui_internal_PlatformOptimizedCancellationException$stable;
  function PlatformOptimizedCancellationException(message) {
    message = message === VOID ? null : message;
    CancellationException_init_$Init$(message, this);
    captureStack(this, PlatformOptimizedCancellationException);
  }
  var androidx_compose_ui_node_SortedSet$stable;
  function _get_isRootIndex__yg6dsb($this, $receiver) {
    return $receiver === 0;
  }
  function _get_parentIndex__ux4alz($this, $receiver) {
    return ($receiver - 1 | 0) >> 1;
  }
  function _get_leftChildIndex__oy58oe($this, $receiver) {
    return ($receiver << 1) + 1 | 0;
  }
  function _get_rightChildIndex__8r727z($this, $receiver) {
    return ($receiver << 1) + 2 | 0;
  }
  function heapifyUp($this, index) {
    var element = $this.ib2_1.l1(index);
    var currentIndex = index;
    $l$loop: while (!_get_isRootIndex__yg6dsb($this, currentIndex)) {
      var parentIndex = _get_parentIndex__ux4alz($this, currentIndex);
      // Inline function 'androidx.compose.ui.node.SortedSet.compareTo' call
      var this_0 = $this.ib2_1.l1(parentIndex);
      if ($this.hb2_1.compare(this_0, element) <= 0) {
        break $l$loop;
      }
      swap_0($this, currentIndex, parentIndex);
      currentIndex = parentIndex;
    }
  }
  function heapifyDown($this, index) {
    var element = $this.ib2_1.l1(index);
    var currentIndex = index;
    $l$loop_0: while (true) {
      var leftChildIndex = _get_leftChildIndex__oy58oe($this, currentIndex);
      if (leftChildIndex >= $this.ib2_1.n1()) {
        break $l$loop_0;
      }
      var leftChildElement = $this.ib2_1.l1(leftChildIndex);
      var rightChildIndex = _get_rightChildIndex__8r727z($this, currentIndex);
      var indexOfSmallerElement;
      var smallerElement;
      if (rightChildIndex >= $this.ib2_1.n1()) {
        indexOfSmallerElement = leftChildIndex;
        smallerElement = leftChildElement;
      } else {
        var rightChildElement = $this.ib2_1.l1(rightChildIndex);
        // Inline function 'androidx.compose.ui.node.SortedSet.compareTo' call
        if ($this.hb2_1.compare(leftChildElement, rightChildElement) < 0) {
          indexOfSmallerElement = leftChildIndex;
          smallerElement = leftChildElement;
        } else {
          indexOfSmallerElement = rightChildIndex;
          smallerElement = rightChildElement;
        }
      }
      // Inline function 'androidx.compose.ui.node.SortedSet.compareTo' call
      var value = smallerElement;
      if ($this.hb2_1.compare(element, value) <= 0) {
        break $l$loop_0;
      }
      swap_0($this, currentIndex, indexOfSmallerElement);
      currentIndex = indexOfSmallerElement;
    }
  }
  function swap_0($this, index1, index2) {
    var item1 = $this.ib2_1.l1(index1);
    var item2 = $this.ib2_1.l1(index2);
    $this.ib2_1.f3(index1, item2);
    $this.ib2_1.f3(index2, item1);
    // Inline function 'kotlin.collections.set' call
    $this.jb2_1.z2(item1, index2);
    // Inline function 'kotlin.collections.set' call
    $this.jb2_1.z2(item2, index1);
  }
  function SortedSet(comparator) {
    this.hb2_1 = comparator;
    var tmp = this;
    // Inline function 'kotlin.collections.arrayListOf' call
    tmp.ib2_1 = ArrayList_init_$Create$();
    var tmp_0 = this;
    // Inline function 'kotlin.collections.mutableMapOf' call
    tmp_0.jb2_1 = LinkedHashMap_init_$Create$();
  }
  protoOf(SortedSet).j1 = function (element) {
    // Inline function 'kotlin.collections.contains' call
    // Inline function 'kotlin.collections.containsKey' call
    var this_0 = this.jb2_1;
    if ((isInterface(this_0, KtMap) ? this_0 : THROW_CCE()).u2(element)) {
      return false;
    }
    var index = this.ib2_1.n1();
    this.ib2_1.j1(element);
    // Inline function 'kotlin.collections.set' call
    this.jb2_1.z2(element, index);
    heapifyUp(this, index);
    return true;
  };
  protoOf(SortedSet).d3 = function (element) {
    var tmp0_elvis_lhs = this.jb2_1.a3(element);
    var tmp;
    if (tmp0_elvis_lhs == null) {
      return false;
    } else {
      tmp = tmp0_elvis_lhs;
    }
    var index = tmp;
    var rightMostLeafElement = removeLast(this.ib2_1);
    if (index < this.ib2_1.n1()) {
      this.ib2_1.f3(index, rightMostLeafElement);
      // Inline function 'kotlin.collections.set' call
      this.jb2_1.z2(rightMostLeafElement, index);
      var tmp_0;
      if (!_get_isRootIndex__yg6dsb(this, index)) {
        var tmp2 = this.ib2_1.l1(_get_parentIndex__ux4alz(this, index));
        // Inline function 'androidx.compose.ui.node.SortedSet.compareTo' call
        var value = this.ib2_1.l1(index);
        tmp_0 = this.hb2_1.compare(tmp2, value) >= 0;
      } else {
        tmp_0 = false;
      }
      if (tmp_0) {
        heapifyUp(this, index);
      } else {
        heapifyDown(this, index);
      }
      if (!(this.jb2_1.n1() === this.ib2_1.n1())) {
        this.jb2_1.c3();
        // Inline function 'kotlin.collections.forEachIndexed' call
        var index_0 = 0;
        var _iterator__ex2g4s = this.ib2_1.t();
        while (_iterator__ex2g4s.u()) {
          var item = _iterator__ex2g4s.v();
          var _unary__edvuaz = index_0;
          index_0 = _unary__edvuaz + 1 | 0;
          var index_1 = checkIndexOverflow(_unary__edvuaz);
          // Inline function 'kotlin.collections.set' call
          this.jb2_1.z2(item, index_1);
        }
      }
    }
    return true;
  };
  protoOf(SortedSet).vg = function () {
    return this.ib2_1.l1(0);
  };
  protoOf(SortedSet).r = function () {
    return this.ib2_1.r();
  };
  protoOf(SortedSet).m1 = function (element) {
    // Inline function 'kotlin.collections.contains' call
    // Inline function 'kotlin.collections.containsKey' call
    var this_0 = this.jb2_1;
    return (isInterface(this_0, KtMap) ? this_0 : THROW_CCE()).u2(element);
  };
  var androidx_compose_ui_platform_AtomicInt$stable;
  function AtomicInt(value) {
    this.ybr_1 = atomic$int$1(value);
  }
  protoOf(AtomicInt).zbr = function (delta) {
    return this.ybr_1.atomicfu$addAndGet(delta);
  };
  function postDelayed(delayMillis, block) {
    var tmp = GlobalScope_instance;
    var tmp_0 = get_PostDelayedDispatcher();
    return launch(tmp, tmp_0, VOID, postDelayed$slambda_0(delayMillis, block, null));
  }
  function removePost(token) {
    var job = (token == null ? true : isInterface(token, Job_0)) ? token : null;
    if (job == null)
      null;
    else {
      job.b1b();
    }
  }
  function postDelayed$slambda($delayMillis, $block, resultContinuation) {
    this.ac2_1 = $delayMillis;
    this.bc2_1 = $block;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(postDelayed$slambda).p24 = function ($this$launch, $completion) {
    var tmp = this.q24($this$launch, $completion);
    tmp.p9_1 = Unit_instance;
    tmp.q9_1 = null;
    return tmp.v9();
  };
  protoOf(postDelayed$slambda).ja = function (p1, $completion) {
    return this.p24((!(p1 == null) ? isInterface(p1, CoroutineScope_0) : false) ? p1 : THROW_CCE(), $completion);
  };
  protoOf(postDelayed$slambda).v9 = function () {
    var suspendResult = this.p9_1;
    $sm: do
      try {
        var tmp = this.n9_1;
        switch (tmp) {
          case 0:
            this.o9_1 = 2;
            this.n9_1 = 1;
            suspendResult = delay(this.ac2_1, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            this.bc2_1();
            return Unit_instance;
          case 2:
            throw this.q9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.o9_1 === 2) {
          throw e;
        } else {
          this.n9_1 = this.o9_1;
          this.q9_1 = e;
        }
      }
     while (true);
  };
  protoOf(postDelayed$slambda).q24 = function ($this$launch, completion) {
    var i = new postDelayed$slambda(this.ac2_1, this.bc2_1, completion);
    i.cc2_1 = $this$launch;
    return i;
  };
  function postDelayed$slambda_0($delayMillis, $block, resultContinuation) {
    var i = new postDelayed$slambda($delayMillis, $block, resultContinuation);
    return constructCallableReference(function ($this$launch, $completion) {
      return i.p24($this$launch, $completion);
    }, 1);
  }
  function set_useLegacyRenderNodeLayers(_this__u8e3s4, _set____db54di) {
    _init_properties_ComposeUiFlags_skiko_kt__466nlk();
    var tmp0 = useLegacyRenderNodeLayers$delegate;
    var tmp = KMutableProperty1;
    var tmp_0 = _get_useLegacyRenderNodeLayers_$ref_bt8ktm();
    // Inline function 'kotlin.setValue' call
    getPropertyCallableRef('useLegacyRenderNodeLayers', 1, tmp, tmp_0, _set_useLegacyRenderNodeLayers_$ref_ldyigm());
    tmp0.set(_set____db54di);
    return Unit_instance;
  }
  function get_useLegacyRenderNodeLayers(_this__u8e3s4) {
    _init_properties_ComposeUiFlags_skiko_kt__466nlk();
    var tmp0 = useLegacyRenderNodeLayers$delegate;
    var tmp = KMutableProperty1;
    var tmp_0 = _get_useLegacyRenderNodeLayers_$ref_bt8ktm();
    // Inline function 'kotlin.getValue' call
    getPropertyCallableRef('useLegacyRenderNodeLayers', 1, tmp, tmp_0, _set_useLegacyRenderNodeLayers_$ref_ldyigm());
    return tmp0.get();
  }
  var useLegacyRenderNodeLayers$delegate;
  function set_isClearFocusOnMouseDownEnabled(_this__u8e3s4, _set____db54di) {
    _init_properties_ComposeUiFlags_skiko_kt__466nlk();
    var tmp0 = isClearFocusOnMouseDownEnabled$delegate;
    var tmp = KMutableProperty1;
    var tmp_0 = _get_isClearFocusOnMouseDownEnabled_$ref_a8hpd8();
    // Inline function 'kotlin.setValue' call
    getPropertyCallableRef('isClearFocusOnMouseDownEnabled', 1, tmp, tmp_0, _set_isClearFocusOnMouseDownEnabled_$ref_utdx6w());
    tmp0.set(_set____db54di);
    return Unit_instance;
  }
  function get_isClearFocusOnMouseDownEnabled_0(_this__u8e3s4) {
    _init_properties_ComposeUiFlags_skiko_kt__466nlk();
    var tmp0 = isClearFocusOnMouseDownEnabled$delegate;
    var tmp = KMutableProperty1;
    var tmp_0 = _get_isClearFocusOnMouseDownEnabled_$ref_a8hpd8();
    // Inline function 'kotlin.getValue' call
    getPropertyCallableRef('isClearFocusOnMouseDownEnabled', 1, tmp, tmp_0, _set_isClearFocusOnMouseDownEnabled_$ref_utdx6w());
    return tmp0.get();
  }
  var isClearFocusOnMouseDownEnabled$delegate;
  function set_isDialogAnimationEnabled(_this__u8e3s4, _set____db54di) {
    _init_properties_ComposeUiFlags_skiko_kt__466nlk();
    var tmp0 = isDialogAnimationEnabled$delegate;
    var tmp = KMutableProperty1;
    var tmp_0 = _get_isDialogAnimationEnabled_$ref_o3kpth();
    // Inline function 'kotlin.setValue' call
    getPropertyCallableRef('isDialogAnimationEnabled', 1, tmp, tmp_0, _set_isDialogAnimationEnabled_$ref_va5ort());
    tmp0.set(_set____db54di);
    return Unit_instance;
  }
  function get_isDialogAnimationEnabled(_this__u8e3s4) {
    _init_properties_ComposeUiFlags_skiko_kt__466nlk();
    var tmp0 = isDialogAnimationEnabled$delegate;
    var tmp = KMutableProperty1;
    var tmp_0 = _get_isDialogAnimationEnabled_$ref_o3kpth();
    // Inline function 'kotlin.getValue' call
    getPropertyCallableRef('isDialogAnimationEnabled', 1, tmp, tmp_0, _set_isDialogAnimationEnabled_$ref_va5ort());
    return tmp0.get();
  }
  var isDialogAnimationEnabled$delegate;
  function set_areWindowInsetsRulersEnabled(_this__u8e3s4, _set____db54di) {
    _init_properties_ComposeUiFlags_skiko_kt__466nlk();
    var tmp0 = areWindowInsetsRulersEnabled$delegate;
    var tmp = KMutableProperty1;
    var tmp_0 = _get_areWindowInsetsRulersEnabled_$ref_e18emo();
    // Inline function 'kotlin.setValue' call
    getPropertyCallableRef('areWindowInsetsRulersEnabled', 1, tmp, tmp_0, _set_areWindowInsetsRulersEnabled_$ref_8g4nbw());
    tmp0.set(_set____db54di);
    return Unit_instance;
  }
  function get_areWindowInsetsRulersEnabled(_this__u8e3s4) {
    _init_properties_ComposeUiFlags_skiko_kt__466nlk();
    var tmp0 = areWindowInsetsRulersEnabled$delegate;
    var tmp = KMutableProperty1;
    var tmp_0 = _get_areWindowInsetsRulersEnabled_$ref_e18emo();
    // Inline function 'kotlin.getValue' call
    getPropertyCallableRef('areWindowInsetsRulersEnabled', 1, tmp, tmp_0, _set_areWindowInsetsRulersEnabled_$ref_8g4nbw());
    return tmp0.get();
  }
  var areWindowInsetsRulersEnabled$delegate;
  var androidx_compose_ui_SkikoComposeUiFlags$stable;
  function SkikoComposeUiFlags() {
    this.dc2_1 = false;
    this.ec2_1 = false;
    this.fc2_1 = true;
    this.gc2_1 = true;
  }
  var SkikoComposeUiFlags_instance;
  function SkikoComposeUiFlags_getInstance() {
    return SkikoComposeUiFlags_instance;
  }
  function SkikoComposeUiFlags$_get_useLegacyRenderNodeLayers_$ref_enumrs(p0) {
    return constructCallableReference(function () {
      return p0.dc2_1;
    }, 0, 0, 118, VOID, [p0]);
  }
  function SkikoComposeUiFlags$_set_useLegacyRenderNodeLayers_$ref_534p4s(p0) {
    return constructCallableReference(function (p0_0) {
      p0.dc2_1 = p0_0;
      return Unit_instance;
    }, 1, 0, 119, VOID, [p0]);
  }
  function _get_useLegacyRenderNodeLayers_$ref_bt8ktm() {
    return constructCallableReference(function (p0) {
      return get_useLegacyRenderNodeLayers(p0);
    }, 1, 0, 120);
  }
  function _set_useLegacyRenderNodeLayers_$ref_ldyigm() {
    return constructCallableReference(function (p0, p1) {
      set_useLegacyRenderNodeLayers(p0, p1);
      return Unit_instance;
    }, 2, 0, 121);
  }
  function SkikoComposeUiFlags$_get_isClearFocusOnMouseDownEnabled_$ref_r5lwee(p0) {
    return constructCallableReference(function () {
      return p0.ec2_1;
    }, 0, 0, 122, VOID, [p0]);
  }
  function SkikoComposeUiFlags$_set_isClearFocusOnMouseDownEnabled_$ref_2tmj0m(p0) {
    return constructCallableReference(function (p0_0) {
      p0.ec2_1 = p0_0;
      return Unit_instance;
    }, 1, 0, 123, VOID, [p0]);
  }
  function _get_isClearFocusOnMouseDownEnabled_$ref_a8hpd8() {
    return constructCallableReference(function (p0) {
      return get_isClearFocusOnMouseDownEnabled_0(p0);
    }, 1, 0, 124);
  }
  function _set_isClearFocusOnMouseDownEnabled_$ref_utdx6w() {
    return constructCallableReference(function (p0, p1) {
      set_isClearFocusOnMouseDownEnabled(p0, p1);
      return Unit_instance;
    }, 2, 0, 125);
  }
  function SkikoComposeUiFlags$_get_isDialogAnimationEnabled_$ref_ovendl(p0) {
    return constructCallableReference(function () {
      return p0.fc2_1;
    }, 0, 0, 126, VOID, [p0]);
  }
  function SkikoComposeUiFlags$_set_isDialogAnimationEnabled_$ref_hotof9(p0) {
    return constructCallableReference(function (p0_0) {
      p0.fc2_1 = p0_0;
      return Unit_instance;
    }, 1, 0, 127, VOID, [p0]);
  }
  function _get_isDialogAnimationEnabled_$ref_o3kpth() {
    return constructCallableReference(function (p0) {
      return get_isDialogAnimationEnabled(p0);
    }, 1, 0, 128);
  }
  function _set_isDialogAnimationEnabled_$ref_va5ort() {
    return constructCallableReference(function (p0, p1) {
      set_isDialogAnimationEnabled(p0, p1);
      return Unit_instance;
    }, 2, 0, 129);
  }
  function SkikoComposeUiFlags$_get_areWindowInsetsRulersEnabled_$ref_5dbiaq(p0) {
    return constructCallableReference(function () {
      return p0.gc2_1;
    }, 0, 0, 130, VOID, [p0]);
  }
  function SkikoComposeUiFlags$_set_areWindowInsetsRulersEnabled_$ref_ayf9li(p0) {
    return constructCallableReference(function (p0_0) {
      p0.gc2_1 = p0_0;
      return Unit_instance;
    }, 1, 0, 131, VOID, [p0]);
  }
  function _get_areWindowInsetsRulersEnabled_$ref_e18emo() {
    return constructCallableReference(function (p0) {
      return get_areWindowInsetsRulersEnabled(p0);
    }, 1, 0, 132);
  }
  function _set_areWindowInsetsRulersEnabled_$ref_8g4nbw() {
    return constructCallableReference(function (p0, p1) {
      set_areWindowInsetsRulersEnabled(p0, p1);
      return Unit_instance;
    }, 2, 0, 133);
  }
  var properties_initialized_ComposeUiFlags_skiko_kt_s3g6qy;
  function _init_properties_ComposeUiFlags_skiko_kt__466nlk() {
    if (!properties_initialized_ComposeUiFlags_skiko_kt_s3g6qy) {
      properties_initialized_ComposeUiFlags_skiko_kt_s3g6qy = true;
      var tmp = KMutableProperty0;
      var tmp_0 = SkikoComposeUiFlags$_get_useLegacyRenderNodeLayers_$ref_enumrs(SkikoComposeUiFlags_instance);
      useLegacyRenderNodeLayers$delegate = getPropertyCallableRef('useLegacyRenderNodeLayers', 0, tmp, tmp_0, SkikoComposeUiFlags$_set_useLegacyRenderNodeLayers_$ref_534p4s(SkikoComposeUiFlags_instance));
      var tmp_1 = KMutableProperty0;
      var tmp_2 = SkikoComposeUiFlags$_get_isClearFocusOnMouseDownEnabled_$ref_r5lwee(SkikoComposeUiFlags_instance);
      isClearFocusOnMouseDownEnabled$delegate = getPropertyCallableRef('isClearFocusOnMouseDownEnabled', 0, tmp_1, tmp_2, SkikoComposeUiFlags$_set_isClearFocusOnMouseDownEnabled_$ref_2tmj0m(SkikoComposeUiFlags_instance));
      var tmp_3 = KMutableProperty0;
      var tmp_4 = SkikoComposeUiFlags$_get_isDialogAnimationEnabled_$ref_ovendl(SkikoComposeUiFlags_instance);
      isDialogAnimationEnabled$delegate = getPropertyCallableRef('isDialogAnimationEnabled', 0, tmp_3, tmp_4, SkikoComposeUiFlags$_set_isDialogAnimationEnabled_$ref_hotof9(SkikoComposeUiFlags_instance));
      var tmp_5 = KMutableProperty0;
      var tmp_6 = SkikoComposeUiFlags$_get_areWindowInsetsRulersEnabled_$ref_5dbiaq(SkikoComposeUiFlags_instance);
      areWindowInsetsRulersEnabled$delegate = getPropertyCallableRef('areWindowInsetsRulersEnabled', 0, tmp_5, tmp_6, SkikoComposeUiFlags$_set_areWindowInsetsRulersEnabled_$ref_ayf9li(SkikoComposeUiFlags_instance));
      androidx_compose_ui_SkikoComposeUiFlags$stable = 8;
    }
  }
  var androidx_compose_ui_ImageComposeScene$stable;
  function get_LocalSystemTheme() {
    _init_properties_SystemTheme_kt__a9f6so();
    return LocalSystemTheme;
  }
  var LocalSystemTheme;
  var SystemTheme_Dark_instance;
  var SystemTheme_Light_instance;
  var SystemTheme_Unknown_instance;
  var SystemTheme_entriesInitialized;
  function SystemTheme_initEntries() {
    if (SystemTheme_entriesInitialized)
      return Unit_instance;
    SystemTheme_entriesInitialized = true;
    SystemTheme_Dark_instance = new SystemTheme('Dark', 0);
    SystemTheme_Light_instance = new SystemTheme('Light', 1);
    SystemTheme_Unknown_instance = new SystemTheme('Unknown', 2);
  }
  function SystemTheme(name, ordinal) {
    Enum.call(this, name, ordinal);
  }
  function asComposeSystemTheme(_this__u8e3s4) {
    _init_properties_SystemTheme_kt__a9f6so();
    var tmp;
    switch (_this__u8e3s4.a1_1) {
      case 0:
        tmp = SystemTheme_Dark_getInstance();
        break;
      case 1:
        tmp = SystemTheme_Light_getInstance();
        break;
      case 2:
        tmp = SystemTheme_Unknown_getInstance();
        break;
      default:
        noWhenBranchMatchedException();
        break;
    }
    return tmp;
  }
  function LocalSystemTheme$lambda() {
    _init_properties_SystemTheme_kt__a9f6so();
    return asComposeSystemTheme(get_currentSystemTheme());
  }
  function SystemTheme_Dark_getInstance() {
    SystemTheme_initEntries();
    return SystemTheme_Dark_instance;
  }
  function SystemTheme_Light_getInstance() {
    SystemTheme_initEntries();
    return SystemTheme_Light_instance;
  }
  function SystemTheme_Unknown_getInstance() {
    SystemTheme_initEntries();
    return SystemTheme_Unknown_instance;
  }
  var properties_initialized_SystemTheme_kt_xc7ieu;
  function _init_properties_SystemTheme_kt__a9f6so() {
    if (!properties_initialized_SystemTheme_kt_xc7ieu) {
      properties_initialized_SystemTheme_kt_xc7ieu = true;
      LocalSystemTheme = staticCompositionLocalOf(LocalSystemTheme$lambda);
    }
  }
  function withAnimationProgress(duration, timingFunction, update, $completion) {
    var tmp;
    if (timingFunction === VOID) {
      tmp = easeInOutTimingFunction$ref();
    } else {
      tmp = timingFunction;
    }
    timingFunction = tmp;
    var tmp_0 = new $withAnimationProgressCOROUTINE$(duration, timingFunction, update, $completion);
    tmp_0.p9_1 = Unit_instance;
    tmp_0.q9_1 = null;
    return tmp_0.v9();
  }
  function easeOutTimingFunction(progress) {
    return -progress * (progress - 2.0);
  }
  function easeInOutTimingFunction(progress) {
    var tmp;
    if (progress < 0.5) {
      tmp = 2.0 * progress * progress;
    } else {
      tmp = -2.0 * progress * progress + 4.0 * progress - 1.0;
    }
    return tmp;
  }
  function easeInOutTimingFunction$ref() {
    return constructCallableReference(function (p0) {
      return easeInOutTimingFunction(p0);
    }, 1, 0, 134, 'easeInOutTimingFunction');
  }
  function withAnimationProgress$lambda($firstFrameTime, $progressDuration, $timingFunction, $duration, $update) {
    return function (frameTime) {
      var tmp;
      if (equalsLong($firstFrameTime._v, new Long(-1, -1))) {
        $firstFrameTime._v = frameTime;
        tmp = Unit_instance;
      }
      Companion_getInstance_16();
      // Inline function 'kotlin.time.Companion.nanoseconds' call
      var this_0 = subtract(frameTime, $firstFrameTime._v);
      var tmp$ret$0 = toDuration(this_0, DurationUnit_NANOSECONDS_getInstance());
      $progressDuration._v = new Duration(tmp$ret$0);
      // Inline function 'kotlin.math.min' call
      var b = Duration__div_impl_dknbf4($progressDuration._v.sf_1, $duration);
      var tmp$ret$1 = Math.min(1.0, b);
      var progress = $timingFunction(tmp$ret$1);
      $update(progress);
      return Unit_instance;
    };
  }
  function $withAnimationProgressCOROUTINE$(duration, timingFunction, update, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.pc2_1 = duration;
    this.qc2_1 = timingFunction;
    this.rc2_1 = update;
  }
  protoOf($withAnimationProgressCOROUTINE$).v9 = function () {
    var suspendResult = this.p9_1;
    $sm: do
      try {
        var tmp = this.n9_1;
        switch (tmp) {
          case 0:
            this.o9_1 = 4;
            this.rc2_1(0.0);
            this.tc2_1 = {_v: new Long(-1, -1)};
            this.sc2_1 = {_v: new Duration(Companion_getInstance_16().tf_1)};
            this.n9_1 = 1;
            continue $sm;
          case 1:
            if (!(Duration__compareTo_impl_pchp0f(this.sc2_1._v.sf_1, this.pc2_1) < 0)) {
              this.n9_1 = 3;
              continue $sm;
            }

            this.n9_1 = 2;
            suspendResult = withFrameNanos(withAnimationProgress$lambda(this.tc2_1, this.sc2_1, this.qc2_1, this.pc2_1, this.rc2_1), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 2:
            this.n9_1 = 1;
            continue $sm;
          case 3:
            return Unit_instance;
          case 4:
            throw this.q9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.o9_1 === 4) {
          throw e;
        } else {
          this.n9_1 = this.o9_1;
          this.q9_1 = e;
        }
      }
     while (true);
  };
  function easeOutTimingFunction$ref() {
    return constructCallableReference(function (p0) {
      return easeOutTimingFunction(p0);
    }, 1, 0, 135, 'easeOutTimingFunction');
  }
  function Companion_43() {
    Companion_instance_48 = this;
    this.uc2_1 = new PlatformContentDataType(_PlatformContentDataType___init__impl__wkyzm7(0));
    this.vc2_1 = new PlatformContentDataType(_PlatformContentDataType___init__impl__wkyzm7(1));
    this.wc2_1 = new PlatformContentDataType(_PlatformContentDataType___init__impl__wkyzm7(2));
    this.xc2_1 = new PlatformContentDataType(_PlatformContentDataType___init__impl__wkyzm7(3));
    this.yc2_1 = new PlatformContentDataType(_PlatformContentDataType___init__impl__wkyzm7(4));
  }
  var Companion_instance_48;
  function Companion_getInstance_69() {
    if (Companion_instance_48 == null)
      new Companion_43();
    return Companion_instance_48;
  }
  function _PlatformContentDataType___init__impl__wkyzm7(type) {
    return type;
  }
  function PlatformContentDataType__toString_impl_yngv61($this) {
    return 'PlatformContentDataType(type=' + $this + ')';
  }
  function PlatformContentDataType__hashCode_impl_emha08($this) {
    return $this;
  }
  function PlatformContentDataType__equals_impl_sc8if8($this, other) {
    if (!(other instanceof PlatformContentDataType))
      return false;
    if (!($this === other.zc2_1))
      return false;
    return true;
  }
  function PlatformContentDataType(type) {
    this.zc2_1 = type;
  }
  protoOf(PlatformContentDataType).toString = function () {
    return PlatformContentDataType__toString_impl_yngv61(this.zc2_1);
  };
  protoOf(PlatformContentDataType).hashCode = function () {
    return PlatformContentDataType__hashCode_impl_emha08(this.zc2_1);
  };
  protoOf(PlatformContentDataType).equals = function (other) {
    return PlatformContentDataType__equals_impl_sc8if8(this.zc2_1, other);
  };
  function Companion_44() {
    Companion_instance_49 = this;
    this.ac3_1 = new PlatformContentType(_PlatformContentType___init__impl__9ny909(new Long(1, 0)));
    this.bc3_1 = new PlatformContentType(_PlatformContentType___init__impl__9ny909(new Long(2, 0)));
    this.cc3_1 = new PlatformContentType(_PlatformContentType___init__impl__9ny909(new Long(4, 0)));
    this.dc3_1 = new PlatformContentType(_PlatformContentType___init__impl__9ny909(new Long(8, 0)));
    this.ec3_1 = new PlatformContentType(_PlatformContentType___init__impl__9ny909(new Long(16, 0)));
    this.fc3_1 = new PlatformContentType(_PlatformContentType___init__impl__9ny909(new Long(32, 0)));
    this.gc3_1 = new PlatformContentType(_PlatformContentType___init__impl__9ny909(new Long(64, 0)));
    this.hc3_1 = new PlatformContentType(_PlatformContentType___init__impl__9ny909(new Long(128, 0)));
    this.ic3_1 = new PlatformContentType(_PlatformContentType___init__impl__9ny909(new Long(256, 0)));
    this.jc3_1 = new PlatformContentType(_PlatformContentType___init__impl__9ny909(new Long(512, 0)));
    this.kc3_1 = new PlatformContentType(_PlatformContentType___init__impl__9ny909(new Long(1024, 0)));
    this.lc3_1 = new PlatformContentType(_PlatformContentType___init__impl__9ny909(new Long(2048, 0)));
    this.mc3_1 = new PlatformContentType(_PlatformContentType___init__impl__9ny909(new Long(4096, 0)));
    this.nc3_1 = new PlatformContentType(_PlatformContentType___init__impl__9ny909(new Long(8192, 0)));
    this.oc3_1 = new PlatformContentType(_PlatformContentType___init__impl__9ny909(new Long(16384, 0)));
    this.pc3_1 = new PlatformContentType(_PlatformContentType___init__impl__9ny909(new Long(32768, 0)));
    this.qc3_1 = new PlatformContentType(_PlatformContentType___init__impl__9ny909(new Long(65536, 0)));
    this.rc3_1 = new PlatformContentType(_PlatformContentType___init__impl__9ny909(new Long(131072, 0)));
    this.sc3_1 = new PlatformContentType(_PlatformContentType___init__impl__9ny909(new Long(262144, 0)));
    this.tc3_1 = new PlatformContentType(_PlatformContentType___init__impl__9ny909(new Long(524288, 0)));
    this.uc3_1 = new PlatformContentType(_PlatformContentType___init__impl__9ny909(new Long(1048576, 0)));
    this.vc3_1 = new PlatformContentType(_PlatformContentType___init__impl__9ny909(new Long(2097152, 0)));
    this.wc3_1 = new PlatformContentType(_PlatformContentType___init__impl__9ny909(new Long(4194304, 0)));
    this.xc3_1 = new PlatformContentType(_PlatformContentType___init__impl__9ny909(new Long(8388608, 0)));
    this.yc3_1 = new PlatformContentType(_PlatformContentType___init__impl__9ny909(new Long(16777216, 0)));
    this.zc3_1 = new PlatformContentType(_PlatformContentType___init__impl__9ny909(new Long(33554432, 0)));
    this.ac4_1 = new PlatformContentType(_PlatformContentType___init__impl__9ny909(new Long(67108864, 0)));
    this.bc4_1 = new PlatformContentType(_PlatformContentType___init__impl__9ny909(new Long(134217728, 0)));
    this.cc4_1 = new PlatformContentType(_PlatformContentType___init__impl__9ny909(new Long(268435456, 0)));
    this.dc4_1 = new PlatformContentType(_PlatformContentType___init__impl__9ny909(new Long(536870912, 0)));
    this.ec4_1 = new PlatformContentType(_PlatformContentType___init__impl__9ny909(new Long(1073741824, 0)));
    this.fc4_1 = new PlatformContentType(_PlatformContentType___init__impl__9ny909(new Long(-2147483648, 0)));
    this.gc4_1 = new PlatformContentType(_PlatformContentType___init__impl__9ny909(new Long(0, 1)));
    this.hc4_1 = new PlatformContentType(_PlatformContentType___init__impl__9ny909(new Long(0, 2)));
    this.ic4_1 = new PlatformContentType(_PlatformContentType___init__impl__9ny909(new Long(0, 4)));
    this.jc4_1 = new PlatformContentType(_PlatformContentType___init__impl__9ny909(new Long(0, 8)));
  }
  var Companion_instance_49;
  function Companion_getInstance_70() {
    if (Companion_instance_49 == null)
      new Companion_44();
    return Companion_instance_49;
  }
  function _PlatformContentType___init__impl__9ny909(type) {
    return type;
  }
  function PlatformContentType__toString_impl_y4pscf($this) {
    return 'PlatformContentType(type=' + $this.toString() + ')';
  }
  function PlatformContentType__hashCode_impl_f58ctu($this) {
    return $this.hashCode();
  }
  function PlatformContentType__equals_impl_rwagni($this, other) {
    if (!(other instanceof PlatformContentType))
      return false;
    var tmp0_other_with_cast = other.kc4_1;
    if (!equalsLong($this, tmp0_other_with_cast))
      return false;
    return true;
  }
  function PlatformContentType(type) {
    this.kc4_1 = type;
  }
  protoOf(PlatformContentType).toString = function () {
    return PlatformContentType__toString_impl_y4pscf(this.kc4_1);
  };
  protoOf(PlatformContentType).hashCode = function () {
    return PlatformContentType__hashCode_impl_f58ctu(this.kc4_1);
  };
  protoOf(PlatformContentType).equals = function (other) {
    return PlatformContentType__equals_impl_rwagni(this.kc4_1, other);
  };
  function createFromText(_this__u8e3s4, textValue) {
    return null;
  }
  function createFromBoolean(_this__u8e3s4, booleanValue) {
    return null;
  }
  var androidx_compose_ui_hapticfeedback_PlatformHapticFeedbackType$stable;
  function PlatformHapticFeedbackType() {
    PlatformHapticFeedbackType_instance = this;
    this.m9t_1 = _HapticFeedbackType___init__impl__z5bkgl(0);
    this.n9t_1 = _HapticFeedbackType___init__impl__z5bkgl(1);
    this.o9t_1 = _HapticFeedbackType___init__impl__z5bkgl(2);
    this.p9t_1 = _HapticFeedbackType___init__impl__z5bkgl(3);
    this.q9t_1 = _HapticFeedbackType___init__impl__z5bkgl(4);
    this.r9t_1 = _HapticFeedbackType___init__impl__z5bkgl(5);
    this.s9t_1 = _HapticFeedbackType___init__impl__z5bkgl(6);
    this.t9t_1 = _HapticFeedbackType___init__impl__z5bkgl(7);
    this.u9t_1 = _HapticFeedbackType___init__impl__z5bkgl(8);
    this.v9t_1 = _HapticFeedbackType___init__impl__z5bkgl(9);
    this.w9t_1 = _HapticFeedbackType___init__impl__z5bkgl(10);
    this.x9t_1 = _HapticFeedbackType___init__impl__z5bkgl(11);
    this.y9t_1 = _HapticFeedbackType___init__impl__z5bkgl(12);
  }
  var PlatformHapticFeedbackType_instance;
  function PlatformHapticFeedbackType_getInstance() {
    if (PlatformHapticFeedbackType_instance == null)
      new PlatformHapticFeedbackType();
    return PlatformHapticFeedbackType_instance;
  }
  var androidx_compose_ui_input_key_InternalKeyEvent$stable;
  function get_key_0(_this__u8e3s4) {
    return get_internal(_this__u8e3s4).lc4_1;
  }
  function get_type(_this__u8e3s4) {
    return get_internal(_this__u8e3s4).mc4_1;
  }
  function get_isAltPressed(_this__u8e3s4) {
    return get_isAltPressed_0(get_internal(_this__u8e3s4).oc4_1) || get_isAltGraphPressed(get_internal(_this__u8e3s4).oc4_1);
  }
  function get_isCtrlPressed(_this__u8e3s4) {
    return get_isCtrlPressed_0(get_internal(_this__u8e3s4).oc4_1);
  }
  function get_isMetaPressed(_this__u8e3s4) {
    return get_isMetaPressed_0(get_internal(_this__u8e3s4).oc4_1);
  }
  function get_isShiftPressed(_this__u8e3s4) {
    return get_isShiftPressed_0(get_internal(_this__u8e3s4).oc4_1);
  }
  function get_utf16CodePoint(_this__u8e3s4) {
    return get_internal(_this__u8e3s4).nc4_1;
  }
  function InternalKeyEvent(key, type, codePoint, modifiers, nativeEvent) {
    nativeEvent = nativeEvent === VOID ? null : nativeEvent;
    this.lc4_1 = key;
    this.mc4_1 = type;
    this.nc4_1 = codePoint;
    this.oc4_1 = modifiers;
    this.pc4_1 = nativeEvent;
  }
  protoOf(InternalKeyEvent).toString = function () {
    return 'InternalKeyEvent(key=' + Key__toString_impl_q8hli6(this.lc4_1) + ', type=' + KeyEventType__toString_impl_auomc4(this.mc4_1) + ', codePoint=' + this.nc4_1 + ', modifiers=' + PointerKeyboardModifiers__toString_impl_rpr9l5(this.oc4_1) + ', nativeEvent=' + toString_0(this.pc4_1) + ')';
  };
  protoOf(InternalKeyEvent).hashCode = function () {
    var result = Key__hashCode_impl_n1gjo3(this.lc4_1);
    result = imul(result, 31) + KeyEventType__hashCode_impl_wluj4z(this.mc4_1) | 0;
    result = imul(result, 31) + this.nc4_1 | 0;
    result = imul(result, 31) + PointerKeyboardModifiers__hashCode_impl_5ylcsa(this.oc4_1) | 0;
    result = imul(result, 31) + (this.pc4_1 == null ? 0 : hashCode(this.pc4_1)) | 0;
    return result;
  };
  protoOf(InternalKeyEvent).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof InternalKeyEvent))
      return false;
    if (!equals(this.lc4_1, other.lc4_1))
      return false;
    if (!(this.mc4_1 === other.mc4_1))
      return false;
    if (!(this.nc4_1 === other.nc4_1))
      return false;
    if (!(this.oc4_1 === other.oc4_1))
      return false;
    if (!equals(this.pc4_1, other.pc4_1))
      return false;
    return true;
  };
  function get_internal(_this__u8e3s4) {
    var tmp = _KeyEvent___get_nativeKeyEvent__impl__py13j5(_this__u8e3s4);
    return tmp instanceof InternalKeyEvent ? tmp : THROW_CCE();
  }
  function copy(_this__u8e3s4, key, type, codePoint, modifiers, nativeEvent) {
    key = key === VOID ? get_internal(_this__u8e3s4).lc4_1 : key;
    type = type === VOID ? get_internal(_this__u8e3s4).mc4_1 : type;
    codePoint = codePoint === VOID ? get_internal(_this__u8e3s4).nc4_1 : codePoint;
    modifiers = modifiers === VOID ? get_internal(_this__u8e3s4).oc4_1 : modifiers;
    nativeEvent = nativeEvent === VOID ? get_internal(_this__u8e3s4).pc4_1 : nativeEvent;
    return _KeyEvent___init__impl__411tom(new InternalKeyEvent(key, type, codePoint, modifiers, nativeEvent));
  }
  var androidx_compose_ui_input_pointer_InternalPointerEvent$stable;
  function InternalPointerEvent_init_$Init$(changes, pointerInputEvent, $this) {
    InternalPointerEvent.call($this, pointerInputEvent.ca7_1, changes, pointerInputEvent.fa7_1, pointerInputEvent.ga7_1, pointerInputEvent.ha7_1, pointerInputEvent.ia7_1);
    return $this;
  }
  function InternalPointerEvent_init_$Create$(changes, pointerInputEvent) {
    return InternalPointerEvent_init_$Init$(changes, pointerInputEvent, objectCreate(protoOf(InternalPointerEvent)));
  }
  function InternalPointerEvent(type, changes, buttons, keyboardModifiers, nativeEvent, button) {
    this.n9z_1 = type;
    this.o9z_1 = changes;
    this.p9z_1 = buttons;
    this.q9z_1 = keyboardModifiers;
    this.r9z_1 = nativeEvent;
    this.s9z_1 = button;
    this.t9z_1 = false;
  }
  protoOf(InternalPointerEvent).ja1 = function (pointerId) {
    var tmp0_safe_receiver = this.o9z_1.lx(_PointerId___get_value__impl__odqw2d(pointerId));
    var tmp = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.qa0_1;
    return equals(tmp == null ? null : new PointerType(tmp), new PointerType(Companion_getInstance_42().na2_1));
  };
  function _PointerButton___init__impl__7ge8a2(index) {
    return index;
  }
  function Companion_45() {
    Companion_instance_50 = this;
    this.qc4_1 = _PointerButton___init__impl__7ge8a2(0);
    this.rc4_1 = _PointerButton___init__impl__7ge8a2(1);
    this.sc4_1 = _PointerButton___init__impl__7ge8a2(2);
    this.tc4_1 = _PointerButton___init__impl__7ge8a2(3);
    this.uc4_1 = _PointerButton___init__impl__7ge8a2(4);
  }
  var Companion_instance_50;
  function Companion_getInstance_71() {
    if (Companion_instance_50 == null)
      new Companion_45();
    return Companion_instance_50;
  }
  function PointerButton__toString_impl_6o1u32($this) {
    return 'PointerButton(index=' + $this + ')';
  }
  function PointerButton__hashCode_impl_sf7qvx($this) {
    return $this;
  }
  function PointerButton__equals_impl_7hirj($this, other) {
    if (!(other instanceof PointerButton))
      return false;
    if (!($this === other.vc4_1))
      return false;
    return true;
  }
  function PointerButton(index) {
    Companion_getInstance_71();
    this.vc4_1 = index;
  }
  protoOf(PointerButton).toString = function () {
    return PointerButton__toString_impl_6o1u32(this.vc4_1);
  };
  protoOf(PointerButton).hashCode = function () {
    return PointerButton__hashCode_impl_sf7qvx(this.vc4_1);
  };
  protoOf(PointerButton).equals = function (other) {
    return PointerButton__equals_impl_7hirj(this.vc4_1, other);
  };
  var androidx_compose_ui_input_pointer_PointerEvent$stable;
  function calculatePointerEventType($this, changes) {
    if (changes.r()) {
      return Companion_getInstance_41().ka1_1;
    }
    // Inline function 'androidx.compose.ui.util.fastForEach' call
    var inductionVariable = 0;
    var last = changes.n1() - 1 | 0;
    if (inductionVariable <= last)
      do {
        var index = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var item = changes.l1(index);
        if (changedToUpIgnoreConsumed(item)) {
          return Companion_getInstance_41().ma1_1;
        }
        if (changedToDownIgnoreConsumed(item)) {
          return Companion_getInstance_41().la1_1;
        }
      }
       while (inductionVariable <= last);
    return Companion_getInstance_41().na1_1;
  }
  function PointerEvent_init_$Init$(changes, internalPointerEvent, $this) {
    var tmp1_elvis_lhs = internalPointerEvent == null ? null : internalPointerEvent.p9z_1;
    var tmp;
    var tmp_0 = tmp1_elvis_lhs;
    if ((tmp_0 == null ? null : new PointerButtons(tmp_0)) == null) {
      tmp = _PointerButtons___init__impl__wq04zh(0);
    } else {
      tmp = tmp1_elvis_lhs;
    }
    var tmp_1 = tmp;
    var tmp3_elvis_lhs = internalPointerEvent == null ? null : internalPointerEvent.q9z_1;
    var tmp_2;
    var tmp_3 = tmp3_elvis_lhs;
    if ((tmp_3 == null ? null : new PointerKeyboardModifiers(tmp_3)) == null) {
      tmp_2 = _PointerKeyboardModifiers___init__impl__bj99nt(0);
    } else {
      tmp_2 = tmp3_elvis_lhs;
    }
    var tmp_4 = tmp_2;
    var tmp5_elvis_lhs = internalPointerEvent == null ? null : internalPointerEvent.n9z_1;
    var tmp_5;
    var tmp_6 = tmp5_elvis_lhs;
    if ((tmp_6 == null ? null : new PointerEventType(tmp_6)) == null) {
      tmp_5 = Companion_getInstance_41().ka1_1;
    } else {
      tmp_5 = tmp5_elvis_lhs;
    }
    var tmp_7 = tmp_5;
    var tmp_8 = internalPointerEvent == null ? null : internalPointerEvent.r9z_1;
    PointerEvent.call($this, changes, tmp_1, tmp_4, tmp_7, tmp_8, internalPointerEvent == null ? null : internalPointerEvent.s9z_1);
    return $this;
  }
  function PointerEvent_init_$Create$(changes, internalPointerEvent) {
    return PointerEvent_init_$Init$(changes, internalPointerEvent, objectCreate(protoOf(PointerEvent)));
  }
  function PointerEvent_init_$Init$_0(changes, $this) {
    PointerEvent.call($this, changes, _PointerButtons___init__impl__wq04zh(0), _PointerKeyboardModifiers___init__impl__bj99nt(0), calculatePointerEventType(Companion_instance_51, changes), null, null);
    return $this;
  }
  function PointerEvent_init_$Create$_0(changes) {
    return PointerEvent_init_$Init$_0(changes, objectCreate(protoOf(PointerEvent)));
  }
  function Companion_46() {
  }
  var Companion_instance_51;
  function Companion_getInstance_72() {
    return Companion_instance_51;
  }
  function PointerEvent(changes, buttons, keyboardModifiers, type, nativeEvent, button) {
    this.ca0_1 = changes;
    this.da0_1 = buttons;
    this.ea0_1 = keyboardModifiers;
    this.fa0_1 = nativeEvent;
    this.ga0_1 = button;
    this.ha0_1 = type;
  }
  protoOf(PointerEvent).equals = function (other) {
    if (this === other)
      return true;
    if (other == null || !getKClassFromExpression(this).equals(getKClassFromExpression(other)))
      return false;
    if (!(other instanceof PointerEvent))
      THROW_CCE();
    if (!equals(this.ca0_1, other.ca0_1))
      return false;
    if (!(this.da0_1 === other.da0_1))
      return false;
    if (!(this.ea0_1 === other.ea0_1))
      return false;
    if (!equals(this.fa0_1, other.fa0_1))
      return false;
    var tmp = this.ga0_1;
    var tmp_0 = tmp == null ? null : new PointerButton(tmp);
    var tmp_1 = other.ga0_1;
    if (!equals(tmp_0, tmp_1 == null ? null : new PointerButton(tmp_1)))
      return false;
    if (!(this.ha0_1 === other.ha0_1))
      return false;
    return true;
  };
  protoOf(PointerEvent).hashCode = function () {
    var result = hashCode(this.ca0_1);
    result = imul(31, result) + PointerButtons__hashCode_impl_6w71xq(this.da0_1) | 0;
    result = imul(31, result) + PointerKeyboardModifiers__hashCode_impl_5ylcsa(this.ea0_1) | 0;
    var tmp = imul(31, result);
    var tmp0_safe_receiver = this.fa0_1;
    var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : hashCode(tmp0_safe_receiver);
    result = tmp + (tmp1_elvis_lhs == null ? 0 : tmp1_elvis_lhs) | 0;
    var tmp_0 = imul(31, result);
    var tmp2_safe_receiver = this.ga0_1;
    var tmp_1;
    var tmp_2 = tmp2_safe_receiver;
    if ((tmp_2 == null ? null : new PointerButton(tmp_2)) == null) {
      tmp_1 = null;
    } else {
      tmp_1 = PointerButton__hashCode_impl_sf7qvx(tmp2_safe_receiver);
    }
    var tmp3_elvis_lhs = tmp_1;
    result = tmp_0 + (tmp3_elvis_lhs == null ? 0 : tmp3_elvis_lhs) | 0;
    result = imul(31, result) + PointerEventType__hashCode_impl_p2f3az(this.ha0_1) | 0;
    return result;
  };
  protoOf(PointerEvent).toString = function () {
    var tmp = 'PointerEvent(changes=' + toString(this.ca0_1);
    var tmp_0 = ', buttons=' + PointerButtons__toString_impl_sncyql(this.da0_1);
    var tmp_1 = ', keyboardModifiers=' + PointerKeyboardModifiers__toString_impl_rpr9l5(this.ea0_1);
    var tmp_2 = ', nativeEvent=' + toString_0(this.fa0_1);
    var tmp_3 = this.ga0_1;
    return tmp + tmp_0 + tmp_1 + tmp_2 + (', button=' + toString_0(tmp_3 == null ? null : new PointerButton(tmp_3))) + (', type=' + PointerEventType__toString_impl_o7j1va(this.ha0_1)) + ')';
  };
  function get_isPrimaryPressed(_this__u8e3s4) {
    return !((_PointerButtons___get_packedValue__impl__z09y3b(_this__u8e3s4) & 1) === 0);
  }
  function get_isSecondaryPressed(_this__u8e3s4) {
    return !((_PointerButtons___get_packedValue__impl__z09y3b(_this__u8e3s4) & 2) === 0);
  }
  function get_isShiftPressed_0(_this__u8e3s4) {
    return !((_PointerKeyboardModifiers___get_packedValue__impl__7vcep7(_this__u8e3s4) & 32) === 0);
  }
  function EmptyPointerKeyboardModifiers() {
    return PointerKeyboardModifiers_0();
  }
  function get_isAltPressed_0(_this__u8e3s4) {
    return !((_PointerKeyboardModifiers___get_packedValue__impl__7vcep7(_this__u8e3s4) & 4) === 0);
  }
  function get_isAltGraphPressed(_this__u8e3s4) {
    return !((_PointerKeyboardModifiers___get_packedValue__impl__7vcep7(_this__u8e3s4) & 8) === 0);
  }
  function get_isCtrlPressed_0(_this__u8e3s4) {
    return !((_PointerKeyboardModifiers___get_packedValue__impl__7vcep7(_this__u8e3s4) & 1) === 0);
  }
  function get_isMetaPressed_0(_this__u8e3s4) {
    return !((_PointerKeyboardModifiers___get_packedValue__impl__7vcep7(_this__u8e3s4) & 2) === 0);
  }
  function PointerKeyboardModifiers_0(isCtrlPressed, isMetaPressed, isAltPressed, isShiftPressed, isAltGraphPressed, isSymPressed, isFunctionPressed, isCapsLockOn, isScrollLockOn, isNumLockOn) {
    isCtrlPressed = isCtrlPressed === VOID ? false : isCtrlPressed;
    isMetaPressed = isMetaPressed === VOID ? false : isMetaPressed;
    isAltPressed = isAltPressed === VOID ? false : isAltPressed;
    isShiftPressed = isShiftPressed === VOID ? false : isShiftPressed;
    isAltGraphPressed = isAltGraphPressed === VOID ? false : isAltGraphPressed;
    isSymPressed = isSymPressed === VOID ? false : isSymPressed;
    isFunctionPressed = isFunctionPressed === VOID ? false : isFunctionPressed;
    isCapsLockOn = isCapsLockOn === VOID ? false : isCapsLockOn;
    isScrollLockOn = isScrollLockOn === VOID ? false : isScrollLockOn;
    isNumLockOn = isNumLockOn === VOID ? false : isNumLockOn;
    var res = 0;
    if (isCtrlPressed)
      res = res | 1;
    if (isMetaPressed)
      res = res | 2;
    if (isAltPressed)
      res = res | 4;
    if (isShiftPressed)
      res = res | 32;
    if (isAltGraphPressed)
      res = res | 8;
    if (isSymPressed)
      res = res | 16;
    if (isFunctionPressed)
      res = res | 64;
    if (isCapsLockOn)
      res = res | 128;
    if (isScrollLockOn)
      res = res | 256;
    if (isNumLockOn)
      res = res | 512;
    return _PointerKeyboardModifiers___init__impl__bj99nt(res);
  }
  function PointerButtons_0(isPrimaryPressed, isSecondaryPressed, isTertiaryPressed, isBackPressed, isForwardPressed) {
    isPrimaryPressed = isPrimaryPressed === VOID ? false : isPrimaryPressed;
    isSecondaryPressed = isSecondaryPressed === VOID ? false : isSecondaryPressed;
    isTertiaryPressed = isTertiaryPressed === VOID ? false : isTertiaryPressed;
    isBackPressed = isBackPressed === VOID ? false : isBackPressed;
    isForwardPressed = isForwardPressed === VOID ? false : isForwardPressed;
    var res = 0;
    if (isPrimaryPressed)
      res = res | 1;
    if (isSecondaryPressed)
      res = res | 2;
    if (isTertiaryPressed)
      res = res | 4;
    if (isBackPressed)
      res = res | 8;
    if (isForwardPressed)
      res = res | 16;
    return _PointerButtons___init__impl__wq04zh(res);
  }
  function get_areAnyPressed(_this__u8e3s4) {
    return get_isPrimaryPressed(_this__u8e3s4) || get_isSecondaryPressed(_this__u8e3s4) || get_isTertiaryPressed(_this__u8e3s4) || get_isBackPressed(_this__u8e3s4) || get_isForwardPressed(_this__u8e3s4);
  }
  function copy_0(_this__u8e3s4, isPrimaryPressed, isSecondaryPressed, isTertiaryPressed, isBackPressed, isForwardPressed) {
    isPrimaryPressed = isPrimaryPressed === VOID ? get_isPrimaryPressed(_this__u8e3s4) : isPrimaryPressed;
    isSecondaryPressed = isSecondaryPressed === VOID ? get_isSecondaryPressed(_this__u8e3s4) : isSecondaryPressed;
    isTertiaryPressed = isTertiaryPressed === VOID ? get_isTertiaryPressed(_this__u8e3s4) : isTertiaryPressed;
    isBackPressed = isBackPressed === VOID ? get_isBackPressed(_this__u8e3s4) : isBackPressed;
    isForwardPressed = isForwardPressed === VOID ? get_isForwardPressed(_this__u8e3s4) : isForwardPressed;
    return PointerButtons_0(isPrimaryPressed, isSecondaryPressed, isTertiaryPressed, isBackPressed, isForwardPressed);
  }
  function copy_1(_this__u8e3s4, isCtrlPressed, isMetaPressed, isAltPressed, isShiftPressed, isAltGraphPressed, isSymPressed, isFunctionPressed, isCapsLockOn, isScrollLockOn, isNumLockOn) {
    isCtrlPressed = isCtrlPressed === VOID ? get_isCtrlPressed_0(_this__u8e3s4) : isCtrlPressed;
    isMetaPressed = isMetaPressed === VOID ? get_isMetaPressed_0(_this__u8e3s4) : isMetaPressed;
    isAltPressed = isAltPressed === VOID ? get_isAltPressed_0(_this__u8e3s4) : isAltPressed;
    isShiftPressed = isShiftPressed === VOID ? get_isShiftPressed_0(_this__u8e3s4) : isShiftPressed;
    isAltGraphPressed = isAltGraphPressed === VOID ? get_isAltGraphPressed(_this__u8e3s4) : isAltGraphPressed;
    isSymPressed = isSymPressed === VOID ? get_isSymPressed(_this__u8e3s4) : isSymPressed;
    isFunctionPressed = isFunctionPressed === VOID ? get_isFunctionPressed(_this__u8e3s4) : isFunctionPressed;
    isCapsLockOn = isCapsLockOn === VOID ? get_isCapsLockOn(_this__u8e3s4) : isCapsLockOn;
    isScrollLockOn = isScrollLockOn === VOID ? get_isScrollLockOn(_this__u8e3s4) : isScrollLockOn;
    isNumLockOn = isNumLockOn === VOID ? get_isNumLockOn(_this__u8e3s4) : isNumLockOn;
    return PointerKeyboardModifiers_0(isCtrlPressed, isMetaPressed, isAltPressed, isShiftPressed, isAltGraphPressed, isSymPressed, isFunctionPressed, isCapsLockOn, isScrollLockOn, isNumLockOn);
  }
  function get_isTertiaryPressed(_this__u8e3s4) {
    return !((_PointerButtons___get_packedValue__impl__z09y3b(_this__u8e3s4) & 4) === 0);
  }
  function get_isBackPressed(_this__u8e3s4) {
    return !((_PointerButtons___get_packedValue__impl__z09y3b(_this__u8e3s4) & 8) === 0);
  }
  function get_isForwardPressed(_this__u8e3s4) {
    return !((_PointerButtons___get_packedValue__impl__z09y3b(_this__u8e3s4) & 16) === 0);
  }
  function get_isSymPressed(_this__u8e3s4) {
    return !((_PointerKeyboardModifiers___get_packedValue__impl__7vcep7(_this__u8e3s4) & 16) === 0);
  }
  function get_isFunctionPressed(_this__u8e3s4) {
    return !((_PointerKeyboardModifiers___get_packedValue__impl__7vcep7(_this__u8e3s4) & 64) === 0);
  }
  function get_isCapsLockOn(_this__u8e3s4) {
    return !((_PointerKeyboardModifiers___get_packedValue__impl__7vcep7(_this__u8e3s4) & 128) === 0);
  }
  function get_isScrollLockOn(_this__u8e3s4) {
    return !((_PointerKeyboardModifiers___get_packedValue__impl__7vcep7(_this__u8e3s4) & 256) === 0);
  }
  function get_isNumLockOn(_this__u8e3s4) {
    return !((_PointerKeyboardModifiers___get_packedValue__impl__7vcep7(_this__u8e3s4) & 512) === 0);
  }
  var androidx_compose_ui_input_pointer_PointerInputEvent$stable;
  function PointerInputEvent(eventType, uptime, pointers, buttons, keyboardModifiers, nativeEvent, button) {
    buttons = buttons === VOID ? _PointerButtons___init__impl__wq04zh(0) : buttons;
    keyboardModifiers = keyboardModifiers === VOID ? _PointerKeyboardModifiers___init__impl__bj99nt(0) : keyboardModifiers;
    nativeEvent = nativeEvent === VOID ? null : nativeEvent;
    button = button === VOID ? null : button;
    this.ca7_1 = eventType;
    this.da7_1 = uptime;
    this.ea7_1 = pointers;
    this.fa7_1 = buttons;
    this.ga7_1 = keyboardModifiers;
    this.ha7_1 = nativeEvent;
    this.ia7_1 = button;
  }
  protoOf(PointerInputEvent).wc4 = function (eventType, uptime, pointers, buttons, keyboardModifiers, nativeEvent, button) {
    return new PointerInputEvent(eventType, uptime, pointers, buttons, keyboardModifiers, nativeEvent, button);
  };
  protoOf(PointerInputEvent).xc4 = function (eventType, uptime, pointers, buttons, keyboardModifiers, nativeEvent, button, $super) {
    eventType = eventType === VOID ? this.ca7_1 : eventType;
    uptime = uptime === VOID ? this.da7_1 : uptime;
    pointers = pointers === VOID ? this.ea7_1 : pointers;
    buttons = buttons === VOID ? this.fa7_1 : buttons;
    keyboardModifiers = keyboardModifiers === VOID ? this.ga7_1 : keyboardModifiers;
    nativeEvent = nativeEvent === VOID ? this.ha7_1 : nativeEvent;
    button = button === VOID ? this.ia7_1 : button;
    var tmp;
    if ($super === VOID) {
      tmp = this.wc4(eventType, uptime, pointers, buttons, keyboardModifiers, nativeEvent, button);
    } else {
      var tmp_0 = $super.wc4;
      var tmp_1 = button;
      tmp = tmp_0.call(this, new PointerEventType(eventType), uptime, pointers, new PointerButtons(buttons), new PointerKeyboardModifiers(keyboardModifiers), nativeEvent, tmp_1 == null ? null : new PointerButton(tmp_1));
    }
    return tmp;
  };
  protoOf(PointerInputEvent).toString = function () {
    var tmp = PointerEventType__toString_impl_o7j1va(this.ca7_1);
    var tmp_0 = this.da7_1.toString();
    var tmp_1 = toString(this.ea7_1);
    var tmp_2 = PointerButtons__toString_impl_sncyql(this.fa7_1);
    var tmp_3 = PointerKeyboardModifiers__toString_impl_rpr9l5(this.ga7_1);
    var tmp_4 = toString_0(this.ha7_1);
    var tmp_5 = this.ia7_1;
    return 'PointerInputEvent(eventType=' + tmp + ', uptime=' + tmp_0 + ', pointers=' + tmp_1 + ', buttons=' + tmp_2 + ', keyboardModifiers=' + tmp_3 + ', nativeEvent=' + tmp_4 + ', button=' + toString_0(tmp_5 == null ? null : new PointerButton(tmp_5)) + ')';
  };
  protoOf(PointerInputEvent).hashCode = function () {
    var result = PointerEventType__hashCode_impl_p2f3az(this.ca7_1);
    result = imul(result, 31) + this.da7_1.hashCode() | 0;
    result = imul(result, 31) + hashCode(this.ea7_1) | 0;
    result = imul(result, 31) + PointerButtons__hashCode_impl_6w71xq(this.fa7_1) | 0;
    result = imul(result, 31) + PointerKeyboardModifiers__hashCode_impl_5ylcsa(this.ga7_1) | 0;
    result = imul(result, 31) + (this.ha7_1 == null ? 0 : hashCode(this.ha7_1)) | 0;
    var tmp = imul(result, 31);
    var tmp_0;
    var tmp_1 = this.ia7_1;
    if ((tmp_1 == null ? null : new PointerButton(tmp_1)) == null) {
      tmp_0 = 0;
    } else {
      tmp_0 = PointerButton__hashCode_impl_sf7qvx(this.ia7_1);
    }
    result = tmp + tmp_0 | 0;
    return result;
  };
  protoOf(PointerInputEvent).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof PointerInputEvent))
      return false;
    if (!(this.ca7_1 === other.ca7_1))
      return false;
    if (!equalsLong(this.da7_1, other.da7_1))
      return false;
    if (!equals(this.ea7_1, other.ea7_1))
      return false;
    if (!(this.fa7_1 === other.fa7_1))
      return false;
    if (!(this.ga7_1 === other.ga7_1))
      return false;
    if (!equals(this.ha7_1, other.ha7_1))
      return false;
    var tmp = this.ia7_1;
    var tmp_0 = tmp == null ? null : new PointerButton(tmp);
    var tmp_1 = other.ia7_1;
    if (!equals(tmp_0, tmp_1 == null ? null : new PointerButton(tmp_1)))
      return false;
    return true;
  };
  function onPointerEvent(_this__u8e3s4, eventType, pass, onEvent) {
    pass = pass === VOID ? PointerEventPass_Main_getInstance() : pass;
    return _this__u8e3s4.d8v(new OnPointerEventModifierElement(eventType, pass, onEvent));
  }
  function OnPointerEventModifierElement(eventType, pass, onEvent) {
    ModifierNodeElement.call(this);
    this.zc4_1 = eventType;
    this.ac5_1 = pass;
    this.bc5_1 = onEvent;
  }
  protoOf(OnPointerEventModifierElement).r3d = function () {
    return new OnPointerEventModifierNode(this.zc4_1, this.ac5_1, this.bc5_1);
  };
  protoOf(OnPointerEventModifierElement).cc5 = function (node) {
    return node.xc5(this.zc4_1, this.ac5_1, this.bc5_1);
  };
  protoOf(OnPointerEventModifierElement).d8y = function (node) {
    return this.cc5(node instanceof OnPointerEventModifierNode ? node : THROW_CCE());
  };
  protoOf(OnPointerEventModifierElement).hashCode = function () {
    var result = PointerEventType__hashCode_impl_p2f3az(this.zc4_1);
    result = imul(31, result) + this.ac5_1.hashCode() | 0;
    result = imul(31, result) + hashCode(this.bc5_1) | 0;
    return result;
  };
  protoOf(OnPointerEventModifierElement).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof OnPointerEventModifierElement))
      return false;
    return this.zc4_1 === other.zc4_1 && this.ac5_1.equals(other.ac5_1) && this.bc5_1 === other.bc5_1;
  };
  function OnPointerEventModifierNode$pointerInputNode$slambda$slambda(this$0, resultContinuation) {
    this.gc6_1 = this$0;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(OnPointerEventModifierNode$pointerInputNode$slambda$slambda).ic6 = function ($this$awaitPointerEventScope, $completion) {
    var tmp = this.jc6($this$awaitPointerEventScope, $completion);
    tmp.p9_1 = Unit_instance;
    tmp.q9_1 = null;
    return tmp.v9();
  };
  protoOf(OnPointerEventModifierNode$pointerInputNode$slambda$slambda).ja = function (p1, $completion) {
    return this.ic6((!(p1 == null) ? isInterface(p1, AwaitPointerEventScope) : false) ? p1 : THROW_CCE(), $completion);
  };
  protoOf(OnPointerEventModifierNode$pointerInputNode$slambda$slambda).v9 = function () {
    var suspendResult = this.p9_1;
    $sm: do
      try {
        var tmp = this.n9_1;
        switch (tmp) {
          case 0:
            this.o9_1 = 3;
            this.n9_1 = 1;
            continue $sm;
          case 1:
            if (!true) {
              this.n9_1 = 4;
              continue $sm;
            }

            this.n9_1 = 2;
            suspendResult = this.hc6_1.pa7(this.gc6_1.uc5_1, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 2:
            var event = suspendResult;
            if (event.ha0_1 === this.gc6_1.tc5_1) {
              this.gc6_1.vc5_1(this.hc6_1, event);
            }

            this.n9_1 = 1;
            continue $sm;
          case 3:
            throw this.q9_1;
          case 4:
            return Unit_instance;
        }
      } catch ($p) {
        var e = $p;
        if (this.o9_1 === 3) {
          throw e;
        } else {
          this.n9_1 = this.o9_1;
          this.q9_1 = e;
        }
      }
     while (true);
  };
  protoOf(OnPointerEventModifierNode$pointerInputNode$slambda$slambda).jc6 = function ($this$awaitPointerEventScope, completion) {
    var i = new OnPointerEventModifierNode$pointerInputNode$slambda$slambda(this.gc6_1, completion);
    i.hc6_1 = $this$awaitPointerEventScope;
    return i;
  };
  function OnPointerEventModifierNode$pointerInputNode$slambda$slambda_0(this$0, resultContinuation) {
    var i = new OnPointerEventModifierNode$pointerInputNode$slambda$slambda(this$0, resultContinuation);
    return constructCallableReference(function ($this$awaitPointerEventScope, $completion) {
      return i.ic6($this$awaitPointerEventScope, $completion);
    }, 1);
  }
  function sam$androidx_compose_ui_input_pointer_PointerInputEventHandler$0(function_0) {
    this.kc6_1 = function_0;
  }
  protoOf(sam$androidx_compose_ui_input_pointer_PointerInputEventHandler$0).ka7 = function (_this__u8e3s4, $completion) {
    return this.kc6_1(_this__u8e3s4, $completion);
  };
  protoOf(sam$androidx_compose_ui_input_pointer_PointerInputEventHandler$0).q3 = function () {
    return this.kc6_1;
  };
  protoOf(sam$androidx_compose_ui_input_pointer_PointerInputEventHandler$0).equals = function (other) {
    var tmp;
    if (!(other == null) ? isInterface(other, PointerInputEventHandler) : false) {
      var tmp_0;
      if (!(other == null) ? isInterface(other, FunctionAdapter) : false) {
        tmp_0 = equals(this.q3(), other.q3());
      } else {
        tmp_0 = false;
      }
      tmp = tmp_0;
    } else {
      tmp = false;
    }
    return tmp;
  };
  protoOf(sam$androidx_compose_ui_input_pointer_PointerInputEventHandler$0).hashCode = function () {
    return hashCode(this.q3());
  };
  function OnPointerEventModifierNode$pointerInputNode$slambda(this$0, resultContinuation) {
    this.tc6_1 = this$0;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(OnPointerEventModifierNode$pointerInputNode$slambda).vc6 = function ($this$SuspendingPointerInputModifierNode, $completion) {
    var tmp = this.wc6($this$SuspendingPointerInputModifierNode, $completion);
    tmp.p9_1 = Unit_instance;
    tmp.q9_1 = null;
    return tmp.v9();
  };
  protoOf(OnPointerEventModifierNode$pointerInputNode$slambda).ja = function (p1, $completion) {
    return this.vc6((!(p1 == null) ? isInterface(p1, PointerInputScope) : false) ? p1 : THROW_CCE(), $completion);
  };
  protoOf(OnPointerEventModifierNode$pointerInputNode$slambda).v9 = function () {
    var suspendResult = this.p9_1;
    $sm: do
      try {
        var tmp = this.n9_1;
        switch (tmp) {
          case 0:
            this.o9_1 = 2;
            this.n9_1 = 1;
            suspendResult = this.uc6_1.ma7(OnPointerEventModifierNode$pointerInputNode$slambda$slambda_0(this.tc6_1, null), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            return Unit_instance;
          case 2:
            throw this.q9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.o9_1 === 2) {
          throw e;
        } else {
          this.n9_1 = this.o9_1;
          this.q9_1 = e;
        }
      }
     while (true);
  };
  protoOf(OnPointerEventModifierNode$pointerInputNode$slambda).wc6 = function ($this$SuspendingPointerInputModifierNode, completion) {
    var i = new OnPointerEventModifierNode$pointerInputNode$slambda(this.tc6_1, completion);
    i.uc6_1 = $this$SuspendingPointerInputModifierNode;
    return i;
  };
  function OnPointerEventModifierNode$pointerInputNode$slambda_0(this$0, resultContinuation) {
    var i = new OnPointerEventModifierNode$pointerInputNode$slambda(this$0, resultContinuation);
    return constructCallableReference(function ($this$SuspendingPointerInputModifierNode, $completion) {
      return i.vc6($this$SuspendingPointerInputModifierNode, $completion);
    }, 1);
  }
  function OnPointerEventModifierNode(eventType, pass, onEvent) {
    DelegatingNode.call(this);
    this.tc5_1 = eventType;
    this.uc5_1 = pass;
    this.vc5_1 = onEvent;
    var tmp = this;
    var tmp_0 = OnPointerEventModifierNode$pointerInputNode$slambda_0(this, null);
    tmp.wc5_1 = this.tb1(SuspendingPointerInputModifierNode(new sam$androidx_compose_ui_input_pointer_PointerInputEventHandler$0(tmp_0)));
  }
  protoOf(OnPointerEventModifierNode).xc5 = function (eventType, pass, onEvent) {
    var pointerInputNodeNeedsReset = false;
    this.tc5_1 = eventType;
    this.vc5_1 = onEvent;
    if (!this.uc5_1.equals(pass)) {
      this.uc5_1 = pass;
      pointerInputNodeNeedsReset = true;
    }
    if (pointerInputNodeNeedsReset) {
      this.wc5_1.fab();
    }
  };
  function get_UnconsumedEventResult() {
    _init_properties_SyntheticEventSender_skiko_kt__330nf5();
    return UnconsumedEventResult;
  }
  var UnconsumedEventResult;
  var androidx_compose_ui_input_pointer_SyntheticEventSender$stable;
  function trackMousePointerState($this, event) {
    var tmp0 = event.ea7_1;
    var tmp$ret$0;
    $l$block: {
      // Inline function 'androidx.compose.ui.util.fastAny' call
      // Inline function 'androidx.compose.ui.util.fastForEach' call
      var inductionVariable = 0;
      var last = tmp0.n1() - 1 | 0;
      if (inductionVariable <= last)
        do {
          var index = inductionVariable;
          inductionVariable = inductionVariable + 1 | 0;
          var item = tmp0.l1(index);
          if (item.ea2_1 === Companion_getInstance_42().na2_1) {
            tmp$ret$0 = true;
            break $l$block;
          }
        }
         while (inductionVariable <= last);
      tmp$ret$0 = false;
    }
    if (!tmp$ret$0)
      return Unit_instance;
    var tmp0_subject = event.ca7_1;
    if (tmp0_subject === Companion_getInstance_41().oa1_1 || tmp0_subject === Companion_getInstance_41().na1_1 || (tmp0_subject === Companion_getInstance_41().la1_1 || (tmp0_subject === Companion_getInstance_41().qa1_1 || tmp0_subject === Companion_getInstance_41().ra1_1)) || (tmp0_subject === Companion_getInstance_41().sa1_1 || tmp0_subject === Companion_getInstance_41().ta1_1 || (tmp0_subject === Companion_getInstance_41().ua1_1 || (tmp0_subject === Companion_getInstance_41().va1_1 || tmp0_subject === Companion_getInstance_41().wa1_1))))
      $this.zc6_1 = true;
    else if (tmp0_subject === Companion_getInstance_41().pa1_1)
      $this.zc6_1 = false;
  }
  function shouldSend($this, event) {
    if (event.ca7_1 === Companion_getInstance_41().la1_1) {
      var prevEvent = $this.yc6_1;
      if (!(prevEvent == null) && shouldSend$areSameParams($this, event, prevEvent))
        return false;
    }
    if (event.ca7_1 === Companion_getInstance_41().ma1_1) {
      var tmp0_elvis_lhs = $this.yc6_1;
      var tmp;
      if (tmp0_elvis_lhs == null) {
        return false;
      } else {
        tmp = tmp0_elvis_lhs;
      }
      var prevEvent_0 = tmp;
      if (shouldSend$areSameParams($this, event, prevEvent_0))
        return false;
    }
    return true;
  }
  function sendNativeEventOnly($this, event) {
    if (event.ha7_1 == null)
      return get_UnconsumedEventResult();
    return $this.xc6_1(event.xc4(Companion_getInstance_41().ka1_1)).dc7_1;
  }
  function sendSyntheticMove($this, pointersSourceEvent) {
    var tmp0_elvis_lhs = $this.yc6_1;
    var tmp;
    if (tmp0_elvis_lhs == null) {
      return get_UnconsumedEventResult();
    } else {
      tmp = tmp0_elvis_lhs;
    }
    var previousEvent = tmp;
    // Inline function 'kotlin.collections.associate' call
    var this_0 = pointersSourceEvent.ea7_1;
    var capacity = coerceAtLeast_0(mapCapacity(collectionSizeOrDefault(this_0, 10)), 16);
    // Inline function 'kotlin.collections.associateTo' call
    var destination = LinkedHashMap_init_$Create$_0(capacity);
    var _iterator__ex2g4s = this_0.t();
    while (_iterator__ex2g4s.u()) {
      var element = _iterator__ex2g4s.v();
      // Inline function 'kotlin.collections.plusAssign' call
      var pair = to(new PointerId(element.ya1_1), new Offset(element.ba2_1));
      destination.z2(pair.xh_1, pair.yh_1);
    }
    var idToPosition = destination;
    var tmp_0 = Companion_getInstance_41().na1_1;
    return sendInternal($this, copySynthetic($this, previousEvent, tmp_0, SyntheticEventSender$sendSyntheticMove$lambda($this, idToPosition)));
  }
  function sendMissingMoveForHover($this, currentEvent) {
    var tmp;
    var tmp_0;
    var tmp0 = currentEvent.ea7_1;
    var tmp$ret$0;
    $l$block: {
      // Inline function 'androidx.compose.ui.util.fastAny' call
      // Inline function 'androidx.compose.ui.util.fastForEach' call
      var inductionVariable = 0;
      var last = tmp0.n1() - 1 | 0;
      if (inductionVariable <= last)
        do {
          var index = inductionVariable;
          inductionVariable = inductionVariable + 1 | 0;
          var item = tmp0.l1(index);
          if (item.fa2_1) {
            tmp$ret$0 = true;
            break $l$block;
          }
        }
         while (inductionVariable <= last);
      tmp$ret$0 = false;
    }
    if (tmp$ret$0) {
      tmp_0 = isMoveEventMissing($this, $this.yc6_1, currentEvent);
    } else {
      tmp_0 = false;
    }
    if (tmp_0) {
      tmp = sendSyntheticMove($this, currentEvent);
    } else {
      tmp = get_UnconsumedEventResult();
    }
    return tmp;
  }
  function sendMissingReleases($this, currentEvent) {
    var tmp0_elvis_lhs = $this.yc6_1;
    var tmp;
    if (tmp0_elvis_lhs == null) {
      return get_UnconsumedEventResult();
    } else {
      tmp = tmp0_elvis_lhs;
    }
    var previousEvent = tmp;
    var previousPressed = pressedIds($this, previousEvent);
    var currentPressed = pressedIds($this, currentEvent);
    var newReleased = toList(minus_0(previousPressed, toSet(currentPressed)));
    var sendingAsUp = HashSet_init_$Create$_0(newReleased.n1());
    var result = get_UnconsumedEventResult();
    var lastIndex = currentEvent.ca7_1 === Companion_getInstance_41().ma1_1 ? get_lastIndex(newReleased) - 1 | 0 : get_lastIndex(newReleased);
    var inductionVariable = lastIndex;
    if (0 <= inductionVariable)
      do {
        var i = inductionVariable;
        inductionVariable = inductionVariable + -1 | 0;
        sendingAsUp.j1(newReleased.l1(i));
        var tmp_0 = Companion_getInstance_41().ma1_1;
        // Inline function 'kotlin.also' call
        var this_0 = new PointerEventResult(sendInternal($this, copySynthetic($this, previousEvent, tmp_0, SyntheticEventSender$sendMissingReleases$lambda($this, sendingAsUp))));
        var it = this_0.dc7_1;
        result = merging(result, it);
        this_0.dc7_1;
      }
       while (0 <= inductionVariable);
    return result;
  }
  function sendMissingPresses($this, currentEvent) {
    var tmp0_safe_receiver = $this.yc6_1;
    // Inline function 'kotlin.collections.orEmpty' call
    var tmp0_elvis_lhs = tmp0_safe_receiver == null ? null : pressedIds($this, tmp0_safe_receiver);
    var tmp$ret$0 = tmp0_elvis_lhs == null ? emptyList() : tmp0_elvis_lhs;
    var previousPressed = toSet(tmp$ret$0);
    var currentPressed = pressedIds($this, currentEvent);
    var newPressed = toList(minus_0(currentPressed, previousPressed));
    var sendingAsDown = HashSet_init_$Create$_0(newPressed.n1());
    var result = get_UnconsumedEventResult();
    var lastIndex = currentEvent.ca7_1 === Companion_getInstance_41().la1_1 ? get_lastIndex(newPressed) - 1 | 0 : get_lastIndex(newPressed);
    var inductionVariable = 0;
    if (inductionVariable <= lastIndex)
      do {
        var i = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        sendingAsDown.j1(newPressed.l1(i));
        var tmp = Companion_getInstance_41().la1_1;
        // Inline function 'kotlin.also' call
        var this_0 = new PointerEventResult(sendInternal($this, copySynthetic($this, currentEvent, tmp, SyntheticEventSender$sendMissingPresses$lambda($this, previousPressed, sendingAsDown))));
        var it = this_0.dc7_1;
        result = merging(result, it);
        this_0.dc7_1;
      }
       while (!(i === lastIndex));
    return result;
  }
  function pressedIds($this, $receiver) {
    // Inline function 'androidx.compose.ui.util.fastMapNotNull' call
    var this_0 = $receiver.ea7_1;
    var target = ArrayList_init_$Create$_0(this_0.n1());
    // Inline function 'androidx.compose.ui.util.fastForEach' call
    var inductionVariable = 0;
    var last = this_0.n1() - 1 | 0;
    if (inductionVariable <= last)
      do {
        var index = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var item = this_0.l1(index);
        var tmp = item.ca2_1 ? item.ya1_1 : null;
        var tmp0_safe_receiver = tmp == null ? null : new PointerId(tmp);
        if (tmp0_safe_receiver == null)
          null;
        else {
          // Inline function 'kotlin.let' call
          // Inline function 'kotlin.collections.plusAssign' call
          target.j1(tmp0_safe_receiver);
        }
      }
       while (inductionVariable <= last);
    return target;
  }
  function sendInternal($this, event) {
    var tmp0_subject = event.ca7_1;
    if (tmp0_subject === Companion_getInstance_41().ra1_1)
      $this.ac7_1 = true;
    else if (tmp0_subject === Companion_getInstance_41().ta1_1)
      $this.ac7_1 = false;
    else if (tmp0_subject === Companion_getInstance_41().ua1_1)
      $this.bc7_1 = true;
    else if (tmp0_subject === Companion_getInstance_41().wa1_1)
      $this.bc7_1 = false;
    var result = $this.xc6_1(event).dc7_1;
    // Inline function 'androidx.compose.ui.scene.PointerEventResult.dispatchedToAPointerInputModifier' call
    if (!!((_PointerEventResult___get_value__impl__1zjqdh(result) & 1) === 0)) {
      sendNativeEventOnly($this, event);
    }
    var tmp = $this;
    var tmp1_pointers = toList(event.ea7_1);
    tmp.yc6_1 = event.xc4(VOID, VOID, tmp1_pointers, VOID, VOID, null);
    return result;
  }
  function sendMissingScaleStart($this, event) {
    var tmp;
    if (!$this.ac7_1 && (event.ca7_1 === Companion_getInstance_41().sa1_1 || event.ca7_1 === Companion_getInstance_41().ta1_1)) {
      var tmp_0 = Companion_getInstance_41().ra1_1;
      tmp = sendInternal($this, copySynthetic($this, event, tmp_0, SyntheticEventSender$sendMissingScaleStart$lambda($this)));
    } else {
      tmp = get_UnconsumedEventResult();
    }
    return tmp;
  }
  function sendMissingScaleEnd($this, event) {
    var tmp;
    if ($this.ac7_1 && event.ca7_1 === Companion_getInstance_41().ra1_1) {
      var tmp_0 = Companion_getInstance_41().ta1_1;
      tmp = sendInternal($this, copySynthetic($this, event, tmp_0, SyntheticEventSender$sendMissingScaleEnd$lambda($this)));
    } else {
      tmp = get_UnconsumedEventResult();
    }
    return tmp;
  }
  function sendMissingPanStart($this, event) {
    var tmp;
    if (!$this.bc7_1 && (event.ca7_1 === Companion_getInstance_41().va1_1 || event.ca7_1 === Companion_getInstance_41().wa1_1)) {
      var tmp_0 = Companion_getInstance_41().ua1_1;
      tmp = sendInternal($this, copySynthetic($this, event, tmp_0, SyntheticEventSender$sendMissingPanStart$lambda($this)));
    } else {
      tmp = get_UnconsumedEventResult();
    }
    return tmp;
  }
  function sendMissingPanEnd($this, event) {
    var tmp;
    if ($this.bc7_1 && event.ca7_1 === Companion_getInstance_41().ua1_1) {
      var tmp_0 = Companion_getInstance_41().wa1_1;
      tmp = sendInternal($this, copySynthetic($this, event, tmp_0, SyntheticEventSender$sendMissingPanEnd$lambda($this)));
    } else {
      tmp = get_UnconsumedEventResult();
    }
    return tmp;
  }
  function isMoveEventMissing($this, previousEvent, currentEvent) {
    return !isMove($this, currentEvent) && !isSamePosition($this, currentEvent, previousEvent);
  }
  function isMove($this, $receiver) {
    return $receiver.ca7_1 === Companion_getInstance_41().na1_1 || $receiver.ca7_1 === Companion_getInstance_41().oa1_1 || $receiver.ca7_1 === Companion_getInstance_41().pa1_1;
  }
  function isSamePosition($this, $receiver, previousEvent) {
    var tmp1_safe_receiver = previousEvent == null ? null : previousEvent.ea7_1;
    var tmp;
    if (tmp1_safe_receiver == null) {
      tmp = null;
    } else {
      // Inline function 'kotlin.collections.associate' call
      var capacity = coerceAtLeast_0(mapCapacity(collectionSizeOrDefault(tmp1_safe_receiver, 10)), 16);
      // Inline function 'kotlin.collections.associateTo' call
      var destination = LinkedHashMap_init_$Create$_0(capacity);
      var _iterator__ex2g4s = tmp1_safe_receiver.t();
      while (_iterator__ex2g4s.u()) {
        var element = _iterator__ex2g4s.v();
        // Inline function 'kotlin.collections.plusAssign' call
        var pair = to(new PointerId(element.ya1_1), new Offset(element.ba2_1));
        destination.z2(pair.xh_1, pair.yh_1);
      }
      tmp = destination;
    }
    var previousIdToPosition = tmp;
    var tmp0 = $receiver.ea7_1;
    var tmp$ret$4;
    $l$block: {
      // Inline function 'androidx.compose.ui.util.fastAll' call
      // Inline function 'androidx.compose.ui.util.fastForEach' call
      var inductionVariable = 0;
      var last = tmp0.n1() - 1 | 0;
      if (inductionVariable <= last)
        do {
          var index = inductionVariable;
          inductionVariable = inductionVariable + 1 | 0;
          var item = tmp0.l1(index);
          var tmp_0;
          if (previousIdToPosition == null) {
            tmp_0 = null;
          } else {
            var tmp_1 = previousIdToPosition.w2(new PointerId(item.ya1_1));
            tmp_0 = tmp_1 == null ? null : tmp_1.e5d_1;
          }
          var previousPosition = tmp_0;
          var tmp_2;
          var tmp_3 = previousPosition;
          if ((tmp_3 == null ? null : new Offset(tmp_3)) == null) {
            tmp_2 = true;
          } else {
            var tmp_4 = previousPosition;
            tmp_2 = equals(new Offset(item.ba2_1), tmp_4 == null ? null : new Offset(tmp_4));
          }
          if (!tmp_2) {
            tmp$ret$4 = false;
            break $l$block;
          }
        }
         while (inductionVariable <= last);
      tmp$ret$4 = true;
    }
    return tmp$ret$4;
  }
  function copySynthetic($this, $receiver, type, copyPointer) {
    // Inline function 'androidx.compose.ui.util.fastMap' call
    var this_0 = $receiver.ea7_1;
    var target = ArrayList_init_$Create$_0(this_0.n1());
    // Inline function 'androidx.compose.ui.util.fastForEach' call
    var inductionVariable = 0;
    var last = this_0.n1() - 1 | 0;
    if (inductionVariable <= last)
      do {
        var index = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var item = this_0.l1(index);
        // Inline function 'kotlin.collections.plusAssign' call
        var element = copyPointer(item);
        target.j1(element);
      }
       while (inductionVariable <= last);
    var tmp1_uptime = $receiver.da7_1;
    var tmp2_buttons = $receiver.fa7_1;
    var tmp3_keyboardModifiers = $receiver.ga7_1;
    return new PointerInputEvent(type, tmp1_uptime, target, tmp2_buttons, tmp3_keyboardModifiers, null, null);
  }
  function copySynthetic_0($this, $receiver, position, down) {
    position = position === VOID ? $receiver.ba2_1 : position;
    down = down === VOID ? $receiver.ca2_1 : down;
    var tmp0_id = $receiver.ya1_1;
    var tmp1_uptime = $receiver.za1_1;
    var tmp2_pressure = $receiver.da2_1;
    var tmp3_type = $receiver.ea2_1;
    var tmp4_activeHover = $receiver.fa2_1;
    var tmp5_scrollDelta = Companion_getInstance().g5d_1;
    var tmp6_historical = emptyList();
    var tmp7_panGestureOffset = Companion_getInstance().g5d_1;
    return new PointerInputEventData(tmp0_id, tmp1_uptime, position, position, down, tmp2_pressure, tmp3_type, tmp4_activeHover, tmp6_historical, tmp5_scrollDelta, 1.0, tmp7_panGestureOffset, position);
  }
  function shouldSend$areSameParams(this$0, e1, e2) {
    if (!equals(toSet(pressedIds(this$0, e1)), toSet(pressedIds(this$0, e2))))
      return false;
    if (!(e1.fa7_1 === e2.fa7_1))
      return false;
    if (!(e1.ga7_1 === e2.ga7_1))
      return false;
    return true;
  }
  function SyntheticEventSender$sendSyntheticMove$lambda(this$0, $idToPosition) {
    return function (it) {
      var tmp = $idToPosition.w2(new PointerId(it.ya1_1));
      var tmp0_elvis_lhs = tmp == null ? null : tmp.e5d_1;
      var tmp_0;
      var tmp_1 = tmp0_elvis_lhs;
      if ((tmp_1 == null ? null : new Offset(tmp_1)) == null) {
        tmp_0 = it.ba2_1;
      } else {
        tmp_0 = tmp0_elvis_lhs;
      }
      return copySynthetic_0(this$0, it, tmp_0);
    };
  }
  function SyntheticEventSender$sendMissingReleases$lambda(this$0, $sendingAsUp) {
    return function (it) {
      return copySynthetic_0(this$0, it, VOID, it.ca2_1 && !$sendingAsUp.m1(new PointerId(it.ya1_1)));
    };
  }
  function SyntheticEventSender$sendMissingPresses$lambda(this$0, $previousPressed, $sendingAsDown) {
    return function (it) {
      return copySynthetic_0(this$0, it, VOID, $previousPressed.m1(new PointerId(it.ya1_1)) || $sendingAsDown.m1(new PointerId(it.ya1_1)));
    };
  }
  function SyntheticEventSender$sendMissingScaleStart$lambda(this$0) {
    return function (it) {
      return copySynthetic_0(this$0, it);
    };
  }
  function SyntheticEventSender$sendMissingScaleEnd$lambda(this$0) {
    return function (it) {
      return copySynthetic_0(this$0, it);
    };
  }
  function SyntheticEventSender$sendMissingPanStart$lambda(this$0) {
    return function (it) {
      return copySynthetic_0(this$0, it);
    };
  }
  function SyntheticEventSender$sendMissingPanEnd$lambda(this$0) {
    return function (it) {
      return copySynthetic_0(this$0, it);
    };
  }
  function SyntheticEventSender(send) {
    this.xc6_1 = send;
    this.yc6_1 = null;
    this.zc6_1 = false;
    this.ac7_1 = false;
    this.bc7_1 = false;
    this.cc7_1 = false;
  }
  protoOf(SyntheticEventSender).u4c = function () {
    this.cc7_1 = false;
    this.yc6_1 = null;
    this.ac7_1 = false;
    this.bc7_1 = false;
  };
  protoOf(SyntheticEventSender).ec7 = function (event) {
    trackMousePointerState(this, event);
    var syntheticMoveForHoverResult = sendMissingMoveForHover(this, event);
    var syntheticReleasesResult = sendMissingReleases(this, event);
    var syntheticPressesResult = sendMissingPresses(this, event);
    var syntheticScaleEndResult = sendMissingScaleEnd(this, event);
    var syntheticScaleStartResult = sendMissingScaleStart(this, event);
    var syntheticPanEndResult = sendMissingPanEnd(this, event);
    var syntheticPanStartResult = sendMissingPanStart(this, event);
    var eventResult = shouldSend(this, event) ? sendInternal(this, event) : sendNativeEventOnly(this, event);
    return merging(syntheticMoveForHoverResult, syntheticReleasesResult, syntheticPressesResult, syntheticScaleEndResult, syntheticScaleStartResult, syntheticPanEndResult, syntheticPanStartResult, eventResult);
  };
  protoOf(SyntheticEventSender).fc7 = function () {
    var nothingConsumed = get_UnconsumedEventResult();
    if (!this.cc7_1)
      return nothingConsumed;
    this.cc7_1 = false;
    var tmp0_elvis_lhs = this.yc6_1;
    var tmp;
    if (tmp0_elvis_lhs == null) {
      return nothingConsumed;
    } else {
      tmp = tmp0_elvis_lhs;
    }
    var previousEvent = tmp;
    var tmp0 = previousEvent.ea7_1;
    var tmp$ret$0;
    $l$block: {
      // Inline function 'androidx.compose.ui.util.fastFirstOrNull' call
      // Inline function 'androidx.compose.ui.util.fastForEach' call
      var inductionVariable = 0;
      var last = tmp0.n1() - 1 | 0;
      if (inductionVariable <= last)
        do {
          var index = inductionVariable;
          inductionVariable = inductionVariable + 1 | 0;
          var item = tmp0.l1(index);
          if (item.ea2_1 === Companion_getInstance_42().na2_1) {
            tmp$ret$0 = item;
            break $l$block;
          }
        }
         while (inductionVariable <= last);
      tmp$ret$0 = null;
    }
    var tmp1_elvis_lhs = tmp$ret$0;
    var tmp_0;
    if (tmp1_elvis_lhs == null) {
      return nothingConsumed;
    } else {
      tmp_0 = tmp1_elvis_lhs;
    }
    var mousePointer = tmp_0;
    var tmp_1;
    if (this.zc6_1 || mousePointer.ca2_1) {
      tmp_1 = sendSyntheticMove(this, previousEvent);
    } else {
      tmp_1 = nothingConsumed;
    }
    return tmp_1;
  };
  var properties_initialized_SyntheticEventSender_skiko_kt_d1oq1f;
  function _init_properties_SyntheticEventSender_skiko_kt__330nf5() {
    if (!properties_initialized_SyntheticEventSender_skiko_kt_d1oq1f) {
      properties_initialized_SyntheticEventSender_skiko_kt_d1oq1f = true;
      UnconsumedEventResult = _PointerEventResult___init__impl__b3e4iv_0(false);
      androidx_compose_ui_input_pointer_SyntheticEventSender$stable = 8;
    }
  }
  var androidx_compose_ui_input_pointer_TestPointerInputEventData$stable;
  var androidx_compose_ui_input_pointer_util_PointerVelocityTracker1D$stable;
  var Strategy_Lsq2_instance_0;
  var Strategy_Impulse_instance_0;
  var Strategy_entriesInitialized_0;
  function Strategy_initEntries_0() {
    if (Strategy_entriesInitialized_0)
      return Unit_instance;
    Strategy_entriesInitialized_0 = true;
    Strategy_Lsq2_instance_0 = new Strategy_0('Lsq2', 0);
    Strategy_Impulse_instance_0 = new Strategy_0('Impulse', 1);
  }
  function Strategy_0(name, ordinal) {
    Enum.call(this, name, ordinal);
  }
  function adjustDataPointsIfNeeded($this, sampleCount) {
    if (!$this.hc7_1.equals(Strategy_Lsq2_getInstance_0()))
      return sampleCount;
    if (sampleCount > 3)
      return sampleCount;
    if (sampleCount < 2)
      return sampleCount;
    var firstPoint = $this.mc7_1[0];
    var firstTime = $this.nc7_1[0];
    var lastPoint = $this.mc7_1[sampleCount - 1 | 0];
    var lastTime = $this.nc7_1[sampleCount - 1 | 0];
    $this.mc7_1[1] = (firstPoint + 2 * lastPoint) / 3.0;
    $this.nc7_1[1] = (2 * firstTime + lastTime) / 3.0;
    $this.mc7_1[2] = lastPoint;
    $this.nc7_1[2] = lastTime;
    return 3;
  }
  function calculateLeastSquaresVelocity_0($this, dataPoints, time, sampleCount) {
    var tmp;
    try {
      tmp = polyFitLeastSquares(time, dataPoints, sampleCount, 2, $this.oc7_1)[1];
    } catch ($p) {
      var tmp_0;
      if ($p instanceof IllegalArgumentException) {
        var _unused_var__etf5q3 = $p;
        tmp_0 = 0.0;
      } else {
        throw $p;
      }
      tmp = tmp_0;
    }
    return tmp;
  }
  function Strategy_Lsq2_getInstance_0() {
    Strategy_initEntries_0();
    return Strategy_Lsq2_instance_0;
  }
  function PointerVelocityTracker1D(isDataDifferential, strategy, preventOppositeVelocity) {
    isDataDifferential = isDataDifferential === VOID ? false : isDataDifferential;
    strategy = strategy === VOID ? Strategy_Lsq2_getInstance_0() : strategy;
    preventOppositeVelocity = preventOppositeVelocity === VOID ? false : preventOppositeVelocity;
    this.gc7_1 = isDataDifferential;
    this.hc7_1 = strategy;
    this.ic7_1 = preventOppositeVelocity;
    if (this.gc7_1 && this.hc7_1.equals(Strategy_Lsq2_getInstance_0())) {
      throw IllegalStateException_init_$Create$('Lsq2 not (yet) supported for differential axes');
    }
    var tmp = this;
    var tmp_0;
    switch (this.hc7_1.a1_1) {
      case 1:
        tmp_0 = 2;
        break;
      case 0:
        tmp_0 = 3;
        break;
      default:
        noWhenBranchMatchedException();
        break;
    }
    tmp.jc7_1 = tmp_0;
    var tmp_1 = this;
    // Inline function 'kotlin.arrayOfNulls' call
    tmp_1.kc7_1 = Array(20);
    this.lc7_1 = 0;
    this.mc7_1 = new Float32Array(20);
    this.nc7_1 = new Float32Array(20);
    this.oc7_1 = new Float32Array(3);
  }
  protoOf(PointerVelocityTracker1D).tab = function (timeMillis, dataPoint) {
    this.lc7_1 = (this.lc7_1 + 1 | 0) % 20 | 0;
    set_0(this.kc7_1, this.lc7_1, timeMillis, dataPoint);
  };
  protoOf(PointerVelocityTracker1D).uab = function () {
    var dataPoints = this.mc7_1;
    var time = this.nc7_1;
    var sampleCount = 0;
    var index = this.lc7_1;
    var tmp0_elvis_lhs = this.kc7_1[index];
    var tmp;
    if (tmp0_elvis_lhs == null) {
      return 0.0;
    } else {
      tmp = tmp0_elvis_lhs;
    }
    var newestSample = tmp;
    var previousSample = newestSample;
    $l$loop_0: do {
      var tmp1_elvis_lhs = this.kc7_1[index];
      var tmp_0;
      if (tmp1_elvis_lhs == null) {
        break $l$loop_0;
      } else {
        tmp_0 = tmp1_elvis_lhs;
      }
      var sample = tmp_0;
      var age = toNumber(subtract(newestSample.vab_1, sample.vab_1));
      var delta = toNumber(abs(subtract(sample.vab_1, previousSample.vab_1)));
      var tmp_1;
      if (this.hc7_1.equals(Strategy_Lsq2_getInstance_0()) || this.gc7_1) {
        tmp_1 = sample;
      } else {
        tmp_1 = newestSample;
      }
      previousSample = tmp_1;
      if (age > 100 || delta > 40) {
        break $l$loop_0;
      }
      dataPoints[sampleCount] = sample.wab_1;
      time[sampleCount] = -age;
      index = (index === 0 ? 20 : index) - 1 | 0;
      sampleCount = sampleCount + 1 | 0;
    }
     while (sampleCount < 20);
    sampleCount = adjustDataPointsIfNeeded(this, sampleCount);
    if (sampleCount >= this.jc7_1) {
      var tmp_2;
      switch (this.hc7_1.a1_1) {
        case 1:
          tmp_2 = calculateImpulseVelocity_0(dataPoints, time, sampleCount, this.gc7_1);
          break;
        case 0:
          tmp_2 = calculateLeastSquaresVelocity_0(this, dataPoints, time, sampleCount);
          break;
        default:
          noWhenBranchMatchedException();
          break;
      }
      var velocity = tmp_2 * 1000;
      if (this.ic7_1) {
        if (dataPoints[sampleCount - 1 | 0] < dataPoints[0] && velocity < 0) {
          return 0.0;
        }
        if (dataPoints[sampleCount - 1 | 0] > dataPoints[0] && velocity > 0) {
          return 0.0;
        }
      }
      return velocity;
    }
    return 0.0;
  };
  protoOf(PointerVelocityTracker1D).xab = function (maximumVelocity) {
    // Inline function 'androidx.compose.ui.internal.checkPrecondition' call
    if (!(maximumVelocity > 0.0)) {
      var tmp$ret$1 = 'maximumVelocity should be a positive value. You specified=' + maximumVelocity;
      throwIllegalStateException(tmp$ret$1);
    }
    var velocity = this.uab();
    var tmp;
    if (velocity === 0.0 || isNaN_0(velocity)) {
      tmp = 0.0;
    } else if (velocity > 0) {
      tmp = coerceAtMost(velocity, maximumVelocity);
    } else {
      tmp = coerceAtLeast(velocity, -maximumVelocity);
    }
    return tmp;
  };
  protoOf(PointerVelocityTracker1D).jab = function () {
    fill(this.kc7_1, null);
    this.lc7_1 = 0;
  };
  function set_0(_this__u8e3s4, index, time, dataPoint) {
    var currentEntry = _this__u8e3s4[index];
    if (currentEntry == null) {
      _this__u8e3s4[index] = new DataPointAtTime(time, dataPoint);
    } else {
      currentEntry.vab_1 = time;
      currentEntry.wab_1 = dataPoint;
    }
  }
  function calculateImpulseVelocity_0(dataPoints, time, sampleCount, isDataDifferential) {
    var work = 0.0;
    var start = sampleCount - 1 | 0;
    var nextTime = time[start];
    var inductionVariable = start;
    if (1 <= inductionVariable)
      $l$loop: do {
        var i = inductionVariable;
        inductionVariable = inductionVariable + -1 | 0;
        var currentTime = nextTime;
        nextTime = time[i - 1 | 0];
        if (currentTime === nextTime) {
          continue $l$loop;
        }
        var dataPointsDelta = isDataDifferential ? -dataPoints[i - 1 | 0] : dataPoints[i] - dataPoints[i - 1 | 0];
        var vCurr = dataPointsDelta / (currentTime - nextTime);
        // Inline function 'androidx.compose.ui.input.pointer.util.kineticEnergyToVelocity' call
        var kineticEnergy = work;
        // Inline function 'kotlin.math.sign' call
        var tmp = sign(kineticEnergy);
        // Inline function 'kotlin.math.abs' call
        // Inline function 'kotlin.math.sqrt' call
        var x = 2 * Math.abs(kineticEnergy);
        var vPrev = tmp * Math.sqrt(x);
        var tmp_0 = work;
        var tmp_1 = vCurr - vPrev;
        // Inline function 'kotlin.math.abs' call
        work = tmp_0 + tmp_1 * Math.abs(vCurr);
        if (i === start) {
          work = work * 0.5;
        }
      }
       while (1 <= inductionVariable);
    // Inline function 'androidx.compose.ui.input.pointer.util.kineticEnergyToVelocity' call
    var kineticEnergy_0 = work;
    // Inline function 'kotlin.math.sign' call
    var tmp_2 = sign(kineticEnergy_0);
    // Inline function 'kotlin.math.abs' call
    // Inline function 'kotlin.math.sqrt' call
    var x_0 = 2 * Math.abs(kineticEnergy_0);
    return tmp_2 * Math.sqrt(x_0);
  }
  var androidx_compose_ui_input_rotary_RotaryScrollEvent$stable;
  function EmptyLayout(modifier, $composer, $changed) {
    var $composer_0 = $composer;
    $composer_0 = $composer_0.s30(2081474711);
    var $dirty = $changed;
    if (($changed & 6) === 0)
      $dirty = $dirty | ($composer_0.k31(modifier) ? 4 : 2);
    if ($composer_0.r31(!(($dirty & 3) === 2), $dirty & 1)) {
      // Inline function 'androidx.compose.runtime.cache' call
      var this_0 = $composer_0;
      // Inline function 'kotlin.let' call
      var it = this_0.i31();
      var tmp;
      if (false || it === Companion_getInstance_9().f30_1) {
        var tmp_0 = EmptyLayout$lambda;
        var value = new sam$androidx_compose_ui_layout_MeasurePolicy$0(tmp_0);
        this_0.j31(value);
        tmp = value;
      } else {
        tmp = it;
      }
      var tmp2 = tmp;
      // Inline function 'androidx.compose.ui.layout.Layout' call
      var modifier_0 = modifier;
      var $composer_1 = $composer_0;
      if (!((0 & 2) === 0))
        modifier_0 = Companion_instance_6;
      var compositeKeyHash = get_currentCompositeKeyHashCode($composer_1, 0).hashCode();
      var localMap = $composer_1.t31();
      var materialized = materialize($composer_1, modifier_0);
      var tmp0 = Companion_getInstance_53().oah_1;
      // Inline function 'androidx.compose.runtime.ReusableComposeNode' call
      var $composer_2 = $composer_1;
      var tmp_1 = $composer_2.g30();
      if (!isInterface(tmp_1, Applier)) {
        invalidApplier();
      }
      $composer_2.b31();
      if ($composer_2.h30()) {
        $composer_2.c31(tmp0);
      } else {
        $composer_2.d31();
      }
      var $this$ReusableComposeNode = _Updater___init__impl__rbfxm8($composer_2);
      Updater__set_impl_v7kwss($this$ReusableComposeNode, tmp2, Companion_getInstance_53().tah_1);
      Updater__set_impl_v7kwss($this$ReusableComposeNode, localMap, Companion_getInstance_53().sah_1);
      Updater__set_impl_v7kwss($this$ReusableComposeNode, compositeKeyHash, Companion_getInstance_53().wah_1);
      Updater__reconcile_impl_1mfi6g($this$ReusableComposeNode, Companion_getInstance_53().xah_1);
      Updater__set_impl_v7kwss($this$ReusableComposeNode, materialized, Companion_getInstance_53().qah_1);
      var $composer_3 = $composer_2;
      $composer_2.e31();
    } else {
      $composer_0.z30();
    }
    var tmp0_safe_receiver = $composer_0.t30();
    if (tmp0_safe_receiver == null)
      null;
    else {
      tmp0_safe_receiver.p3c(EmptyLayout$lambda_0(modifier, $changed));
    }
  }
  function sam$androidx_compose_ui_layout_MeasurePolicy$0(function_0) {
    this.pc7_1 = function_0;
  }
  protoOf(sam$androidx_compose_ui_layout_MeasurePolicy$0).mak = function (_this__u8e3s4, measurables, constraints) {
    return this.pc7_1(_this__u8e3s4, measurables, new Constraints_0(constraints));
  };
  protoOf(sam$androidx_compose_ui_layout_MeasurePolicy$0).q3 = function () {
    return this.pc7_1;
  };
  protoOf(sam$androidx_compose_ui_layout_MeasurePolicy$0).equals = function (other) {
    var tmp;
    if (!(other == null) ? isInterface(other, MeasurePolicy) : false) {
      var tmp_0;
      if (!(other == null) ? isInterface(other, FunctionAdapter) : false) {
        tmp_0 = equals(this.q3(), other.q3());
      } else {
        tmp_0 = false;
      }
      tmp = tmp_0;
    } else {
      tmp = false;
    }
    return tmp;
  };
  protoOf(sam$androidx_compose_ui_layout_MeasurePolicy$0).hashCode = function () {
    return hashCode(this.q3());
  };
  function EmptyLayout$lambda($this$Layout, _unused_var__etf5q3, constraints) {
    var tmp = _Constraints___get_minWidth__impl__hi9lfi(constraints.m5e_1);
    var tmp_0 = _Constraints___get_minHeight__impl__ev4bgx(constraints.m5e_1);
    return $this$Layout.n8y(tmp, tmp_0, VOID, EmptyLayout$lambda$lambda);
  }
  function EmptyLayout$lambda$lambda($this$layout) {
    return Unit_instance;
  }
  function EmptyLayout$lambda_0($modifier, $$changed) {
    return function ($composer, $force) {
      EmptyLayout($modifier, $composer, updateChangedFlags($$changed | 1));
      return Unit_instance;
    };
  }
  function OverlayLayout(modifier, content, $composer, $changed) {
    var $composer_0 = $composer;
    $composer_0 = $composer_0.s30(-1212813232);
    var $dirty = $changed;
    if (($changed & 6) === 0)
      $dirty = $dirty | ($composer_0.k31(modifier) ? 4 : 2);
    if (($changed & 48) === 0)
      $dirty = $dirty | ($composer_0.q31(content) ? 32 : 16);
    if ($composer_0.r31(!(($dirty & 19) === 18), $dirty & 1)) {
      // Inline function 'androidx.compose.runtime.cache' call
      var this_0 = $composer_0;
      // Inline function 'kotlin.let' call
      var it = this_0.i31();
      var tmp;
      if (false || it === Companion_getInstance_9().f30_1) {
        var tmp_0 = OverlayLayout$lambda;
        var value = new sam$androidx_compose_ui_layout_MeasurePolicy$0_0(tmp_0);
        this_0.j31(value);
        tmp = value;
      } else {
        tmp = it;
      }
      var tmp4 = tmp;
      var tmp6 = $composer_0;
      // Inline function 'androidx.compose.ui.layout.Layout' call
      var $changed_0 = 384 | 14 & $dirty >> 3 | 112 & $dirty << 3;
      var modifier_0 = modifier;
      var $composer_1 = tmp6;
      if (!((0 & 2) === 0))
        modifier_0 = Companion_instance_6;
      var compositeKeyHash = get_currentCompositeKeyHashCode($composer_1, 0).hashCode();
      var localMap = $composer_1.t31();
      var materialized = materialize($composer_1, modifier_0);
      var tmp0 = Companion_getInstance_53().oah_1;
      // Inline function 'androidx.compose.runtime.ReusableComposeNode' call
      var $changed_1 = 6 | 896 & $changed_0 << 6;
      var $composer_2 = $composer_1;
      var tmp_1 = $composer_2.g30();
      if (!isInterface(tmp_1, Applier)) {
        invalidApplier();
      }
      $composer_2.b31();
      if ($composer_2.h30()) {
        $composer_2.c31(tmp0);
      } else {
        $composer_2.d31();
      }
      var $this$ReusableComposeNode = _Updater___init__impl__rbfxm8($composer_2);
      Updater__set_impl_v7kwss($this$ReusableComposeNode, tmp4, Companion_getInstance_53().tah_1);
      Updater__set_impl_v7kwss($this$ReusableComposeNode, localMap, Companion_getInstance_53().sah_1);
      Updater__set_impl_v7kwss($this$ReusableComposeNode, compositeKeyHash, Companion_getInstance_53().wah_1);
      Updater__reconcile_impl_1mfi6g($this$ReusableComposeNode, Companion_getInstance_53().xah_1);
      Updater__set_impl_v7kwss($this$ReusableComposeNode, materialized, Companion_getInstance_53().qah_1);
      content($composer_2, 14 & $changed_1 >> 6);
      $composer_2.e31();
    } else {
      $composer_0.z30();
    }
    var tmp0_safe_receiver = $composer_0.t30();
    if (tmp0_safe_receiver == null)
      null;
    else {
      tmp0_safe_receiver.p3c(OverlayLayout$lambda_0(modifier, content, $changed));
    }
  }
  function sam$androidx_compose_ui_layout_MeasurePolicy$0_0(function_0) {
    this.qc7_1 = function_0;
  }
  protoOf(sam$androidx_compose_ui_layout_MeasurePolicy$0_0).mak = function (_this__u8e3s4, measurables, constraints) {
    return this.qc7_1(_this__u8e3s4, measurables, new Constraints_0(constraints));
  };
  protoOf(sam$androidx_compose_ui_layout_MeasurePolicy$0_0).q3 = function () {
    return this.qc7_1;
  };
  protoOf(sam$androidx_compose_ui_layout_MeasurePolicy$0_0).equals = function (other) {
    var tmp;
    if (!(other == null) ? isInterface(other, MeasurePolicy) : false) {
      var tmp_0;
      if (!(other == null) ? isInterface(other, FunctionAdapter) : false) {
        tmp_0 = equals(this.q3(), other.q3());
      } else {
        tmp_0 = false;
      }
      tmp = tmp_0;
    } else {
      tmp = false;
    }
    return tmp;
  };
  protoOf(sam$androidx_compose_ui_layout_MeasurePolicy$0_0).hashCode = function () {
    return hashCode(this.q3());
  };
  function OverlayLayout$lambda($this$Layout, measurables, constraints) {
    // Inline function 'androidx.compose.ui.util.fastMap' call
    var target = ArrayList_init_$Create$_0(measurables.n1());
    // Inline function 'androidx.compose.ui.util.fastForEach' call
    var inductionVariable = 0;
    var last = measurables.n1() - 1 | 0;
    if (inductionVariable <= last)
      do {
        var index = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var item = measurables.l1(index);
        // Inline function 'kotlin.collections.plusAssign' call
        var element = item.h8y(constraints.m5e_1);
        target.j1(element);
      }
       while (inductionVariable <= last);
    var placeables = target;
    var tmp2 = _Constraints___get_minWidth__impl__hi9lfi(constraints.m5e_1);
    var tmp$ret$5;
    $l$block: {
      // Inline function 'androidx.compose.ui.util.fastMaxOfOrDefault' call
      if (placeables.r()) {
        tmp$ret$5 = tmp2;
        break $l$block;
      }
      var maxValue = placeables.l1(0).i8y_1;
      var inductionVariable_0 = 1;
      var last_0 = get_lastIndex(placeables);
      if (inductionVariable_0 <= last_0)
        do {
          var i = inductionVariable_0;
          inductionVariable_0 = inductionVariable_0 + 1 | 0;
          var v = placeables.l1(i).i8y_1;
          if (compareTo(v, maxValue) > 0)
            maxValue = v;
        }
         while (!(i === last_0));
      tmp$ret$5 = maxValue;
    }
    var tmp = tmp$ret$5;
    var tmp2_0 = _Constraints___get_minHeight__impl__ev4bgx(constraints.m5e_1);
    var tmp$ret$8;
    $l$block_0: {
      // Inline function 'androidx.compose.ui.util.fastMaxOfOrDefault' call
      if (placeables.r()) {
        tmp$ret$8 = tmp2_0;
        break $l$block_0;
      }
      var maxValue_0 = placeables.l1(0).j8y_1;
      var inductionVariable_1 = 1;
      var last_1 = get_lastIndex(placeables);
      if (inductionVariable_1 <= last_1)
        do {
          var i_0 = inductionVariable_1;
          inductionVariable_1 = inductionVariable_1 + 1 | 0;
          var v_0 = placeables.l1(i_0).j8y_1;
          if (compareTo(v_0, maxValue_0) > 0)
            maxValue_0 = v_0;
        }
         while (!(i_0 === last_1));
      tmp$ret$8 = maxValue_0;
    }
    var tmp_0 = tmp$ret$8;
    return $this$Layout.n8y(tmp, tmp_0, VOID, OverlayLayout$lambda$lambda(placeables));
  }
  function OverlayLayout$lambda$lambda($placeables) {
    return function ($this$layout) {
      // Inline function 'androidx.compose.ui.util.fastForEach' call
      var this_0 = $placeables;
      var inductionVariable = 0;
      var last = this_0.n1() - 1 | 0;
      if (inductionVariable <= last)
        do {
          var index = inductionVariable;
          inductionVariable = inductionVariable + 1 | 0;
          var item = this_0.l1(index);
          $this$layout.jal(item, 0, 0);
        }
         while (inductionVariable <= last);
      return Unit_instance;
    };
  }
  function OverlayLayout$lambda_0($modifier, $content, $$changed) {
    return function ($composer, $force) {
      OverlayLayout($modifier, $content, $composer, updateChangedFlags($$changed | 1));
      return Unit_instance;
    };
  }
  var androidx_compose_ui_layout_RulerProviderModifierElement$stable;
  var androidx_compose_ui_layout_RulerProviderModifierNode$stable;
  function RulerProviderModifierElement(windowInsets) {
    ModifierNodeElement.call(this);
    this.sc7_1 = windowInsets;
  }
  protoOf(RulerProviderModifierElement).r3d = function () {
    return new RulerProviderModifierNode(this.sc7_1);
  };
  protoOf(RulerProviderModifierElement).tc7 = function (node) {
    node.kc8(this.sc7_1);
  };
  protoOf(RulerProviderModifierElement).d8y = function (node) {
    return this.tc7(node instanceof RulerProviderModifierNode ? node : THROW_CCE());
  };
  protoOf(RulerProviderModifierElement).toString = function () {
    return 'RulerProviderModifierElement(windowInsets=' + toString(this.sc7_1) + ')';
  };
  protoOf(RulerProviderModifierElement).hashCode = function () {
    return hashCode(this.sc7_1);
  };
  protoOf(RulerProviderModifierElement).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof RulerProviderModifierElement))
      return false;
    if (!equals(this.sc7_1, other.sc7_1))
      return false;
    return true;
  };
  function provideInsetsValues($this, $receiver, rulers, platformInsets, width, height) {
    provideInsetsValues_0($this, $receiver, rulers.e2y(), platformInsets, width, height);
    provideInsetsValues_0($this, $receiver, rulers.jay(), platformInsets, width, height);
  }
  function provideInsetsValues_0($this, $receiver, rulers, insets, width, height) {
    var left = insets.e9f();
    var top = insets.map();
    var right = width - insets.x61() | 0;
    var bottom = height - insets.nap() | 0;
    $receiver.wbh(rulers.e9f(), left);
    $receiver.wbh(rulers.map(), top);
    $receiver.wbh(rulers.x61(), right);
    $receiver.wbh(rulers.nap(), bottom);
  }
  function RulerProviderModifierNode$rulerLambda$lambda(this$0, $width, $height) {
    return function (_this__u8e3s4) {
      provideInsetsValues(this$0, _this__u8e3s4, Companion_getInstance_52().tax_1, this$0.jc8_1.lc8(), $width, $height);
      provideInsetsValues(this$0, _this__u8e3s4, Companion_getInstance_52().uax_1, this$0.jc8_1.mc8(), $width, $height);
      provideInsetsValues(this$0, _this__u8e3s4, Companion_getInstance_52().vax_1, this$0.jc8_1.nc8(), $width, $height);
      provideInsetsValues(this$0, _this__u8e3s4, Companion_getInstance_52().wax_1, this$0.jc8_1.oc8(), $width, $height);
      provideInsetsValues(this$0, _this__u8e3s4, Companion_getInstance_52().xax_1, this$0.jc8_1.pc8(), $width, $height);
      provideInsetsValues(this$0, _this__u8e3s4, Companion_getInstance_52().yax_1, this$0.jc8_1.qc8(), $width, $height);
      provideInsetsValues(this$0, _this__u8e3s4, Companion_getInstance_52().aay_1, this$0.jc8_1.rc8(), $width, $height);
      provideInsetsValues(this$0, _this__u8e3s4, Companion_getInstance_52().bay_1, this$0.jc8_1.sc8(), $width, $height);
      provideInsetsValues(this$0, _this__u8e3s4, Companion_getInstance_52().cay_1, this$0.jc8_1.tc8(), $width, $height);
      var displayCutouts = this$0.jc8_1.uc8();
      var tmp;
      if (displayCutouts.r()) {
        this$0.ic8_1.c3();
        tmp = Unit_instance;
      } else if (displayCutouts.n1() < this$0.ic8_1.n1()) {
        this$0.ic8_1.e5(displayCutouts.n1(), this$0.ic8_1.n1());
        tmp = Unit_instance;
      } else {
        // Inline function 'kotlin.repeat' call
        var times = displayCutouts.n1() - this$0.ic8_1.n1() | 0;
        var inductionVariable = 0;
        if (inductionVariable < times)
          do {
            var index = inductionVariable;
            inductionVariable = inductionVariable + 1 | 0;
            var tmp0 = this$0.ic8_1;
            // Inline function 'kotlin.collections.plusAssign' call
            var element = RectRulers('display cutout rect ' + this$0.ic8_1.n1());
            tmp0.j1(element);
          }
           while (inductionVariable < times);
        tmp = Unit_instance;
      }
      // Inline function 'androidx.compose.ui.util.fastForEachIndexed' call
      var inductionVariable_0 = 0;
      var last = displayCutouts.n1() - 1 | 0;
      if (inductionVariable_0 <= last)
        do {
          var index_0 = inductionVariable_0;
          inductionVariable_0 = inductionVariable_0 + 1 | 0;
          var item = displayCutouts.l1(index_0);
          var rulers = this$0.ic8_1.l1(index_0);
          _this__u8e3s4.wbh(rulers.e9f(), item.k5d_1);
          _this__u8e3s4.wbh(rulers.map(), item.l5d_1);
          _this__u8e3s4.wbh(rulers.x61(), item.m5d_1);
          _this__u8e3s4.wbh(rulers.nap(), item.n5d_1);
        }
         while (inductionVariable_0 <= last);
      return Unit_instance;
    };
  }
  function RulerProviderModifierNode$measure$lambda($placeable) {
    return function ($this$layout) {
      $this$layout.jal($placeable, 0, 0);
      return Unit_instance;
    };
  }
  function RulerProviderModifierNode(windowInsets) {
    Node.call(this);
    this.ic8_1 = mutableStateListOf();
    this.jc8_1 = windowInsets;
  }
  protoOf(RulerProviderModifierNode).kc8 = function (value) {
    if (!(this.jc8_1 === value)) {
      this.jc8_1 = value;
      requestRemeasure(this);
    }
  };
  protoOf(RulerProviderModifierNode).vc8 = function (width, height) {
    return RulerProviderModifierNode$rulerLambda$lambda(this, width, height);
  };
  protoOf(RulerProviderModifierNode).g8y = function (_this__u8e3s4, measurable, constraints) {
    var placeable = measurable.h8y(constraints);
    var width = placeable.i8y_1;
    var height = placeable.j8y_1;
    var tmp = this.vc8(width, height);
    return _this__u8e3s4.iag(width, height, VOID, tmp, RulerProviderModifierNode$measure$lambda(placeable));
  };
  protoOf(RulerProviderModifierNode).t91 = function () {
    return 'androidx.compose.ui.layout.WindowInsetsRulers';
  };
  var androidx_compose_ui_navigationevent_BackNavigationEventInput$stable;
  function BackNavigationEventInput() {
    NavigationEventInput.call(this);
  }
  protoOf(BackNavigationEventInput).w9e = function (event) {
    if (get_type(event) === Companion_getInstance_39().e9e_1 && equals(get_key_0(event), Companion_getInstance_75().dcb_1)) {
      this.q8p();
      return true;
    } else {
      return false;
    }
  };
  var androidx_compose_ui_node_DragAndDropOwner$stable;
  function DragAndDropOwner(platformDragAndDropManager) {
    this.lck_1 = platformDragAndDropManager;
    this.mck_1 = new DragAndDropNode();
    this.nck_1 = new ArraySet();
    this.ock_1 = new RootDragAndDropElement(this.mck_1);
  }
  protoOf(DragAndDropOwner).r91 = function (target) {
    this.nck_1.j1(target);
  };
  protoOf(DragAndDropOwner).s91 = function (target) {
    return this.nck_1.m1(target);
  };
  protoOf(DragAndDropOwner).v8y = function (event) {
    return this.mck_1.v8y(event);
  };
  protoOf(DragAndDropOwner).w8y = function (event) {
    // Inline function 'kotlin.collections.forEach' call
    var _iterator__ex2g4s = this.nck_1.t();
    while (_iterator__ex2g4s.u()) {
      var element = _iterator__ex2g4s.v();
      element.w8y(event);
    }
  };
  protoOf(DragAndDropOwner).x8y = function (event) {
    return this.mck_1.x8y(event);
  };
  protoOf(DragAndDropOwner).y8y = function (event) {
    return this.mck_1.y8y(event);
  };
  protoOf(DragAndDropOwner).z8y = function (event) {
    return this.mck_1.z8y(event);
  };
  protoOf(DragAndDropOwner).a8z = function (event) {
    this.mck_1.a8z(event);
    this.nck_1.c3();
  };
  function RootDragAndDropElement(dragAndDropNode) {
    ModifierNodeElement.call(this);
    this.qck_1 = dragAndDropNode;
  }
  protoOf(RootDragAndDropElement).r3d = function () {
    return this.qck_1;
  };
  protoOf(RootDragAndDropElement).rck = function (node) {
    return Unit_instance;
  };
  protoOf(RootDragAndDropElement).d8y = function (node) {
    return this.rck(node instanceof DragAndDropNode ? node : THROW_CCE());
  };
  protoOf(RootDragAndDropElement).equals = function (other) {
    return other === this;
  };
  protoOf(RootDragAndDropElement).hashCode = function () {
    return hashCode(this.qck_1);
  };
  var androidx_compose_ui_node_EmptySemanticsElement$stable;
  function EmptySemanticsElement(node) {
    ModifierNodeElement.call(this);
    this.tck_1 = node;
  }
  protoOf(EmptySemanticsElement).r3d = function () {
    return this.tck_1;
  };
  protoOf(EmptySemanticsElement).uck = function (node) {
  };
  protoOf(EmptySemanticsElement).d8y = function (node) {
    return this.uck(node instanceof EmptySemanticsModifier ? node : THROW_CCE());
  };
  protoOf(EmptySemanticsElement).hashCode = function () {
    return identityHashCode(this);
  };
  protoOf(EmptySemanticsElement).equals = function (other) {
    return other === this;
  };
  var androidx_compose_ui_node_RootNodeOwner$stable;
  function RootNodeOwner$OwnerImpl$TextInputSession$startInputMethod$slambda$slambda$slambda$lambda(this$0) {
    return function (it) {
      this$0.hcl_1.d8d();
      return Unit_instance;
    };
  }
  function RootNodeOwner$OwnerImpl$TextInputSession$startInputMethod$slambda$slambda$slambda(this$0, resultContinuation) {
    this.dcm_1 = this$0;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(RootNodeOwner$OwnerImpl$TextInputSession$startInputMethod$slambda$slambda$slambda).p24 = function ($this$launch, $completion) {
    var tmp = this.q24($this$launch, $completion);
    tmp.p9_1 = Unit_instance;
    tmp.q9_1 = null;
    return tmp.v9();
  };
  protoOf(RootNodeOwner$OwnerImpl$TextInputSession$startInputMethod$slambda$slambda$slambda).ja = function (p1, $completion) {
    return this.p24((!(p1 == null) ? isInterface(p1, CoroutineScope_0) : false) ? p1 : THROW_CCE(), $completion);
  };
  protoOf(RootNodeOwner$OwnerImpl$TextInputSession$startInputMethod$slambda$slambda$slambda).v9 = function () {
    var suspendResult = this.p9_1;
    $sm: do
      try {
        var tmp = this.n9_1;
        switch (tmp) {
          case 0:
            this.o9_1 = 2;
            this.n9_1 = 1;
            var cancellable = new CancellableContinuationImpl(intercepted(this), 1);
            cancellable.v1e();
            this.dcm_1.hcl_1.b8d();
            cancellable.f1d(RootNodeOwner$OwnerImpl$TextInputSession$startInputMethod$slambda$slambda$slambda$lambda(this.dcm_1));
            suspendResult = returnIfSuspended(cancellable.x1b(), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            return Unit_instance;
          case 2:
            throw this.q9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.o9_1 === 2) {
          throw e;
        } else {
          this.n9_1 = this.o9_1;
          this.q9_1 = e;
        }
      }
     while (true);
  };
  protoOf(RootNodeOwner$OwnerImpl$TextInputSession$startInputMethod$slambda$slambda$slambda).q24 = function ($this$launch, completion) {
    var i = new RootNodeOwner$OwnerImpl$TextInputSession$startInputMethod$slambda$slambda$slambda(this.dcm_1, completion);
    i.ecm_1 = $this$launch;
    return i;
  };
  function RootNodeOwner$OwnerImpl$TextInputSession$startInputMethod$slambda$slambda$slambda_0(this$0, resultContinuation) {
    var i = new RootNodeOwner$OwnerImpl$TextInputSession$startInputMethod$slambda$slambda$slambda(this$0, resultContinuation);
    return constructCallableReference(function ($this$launch, $completion) {
      return i.p24($this$launch, $completion);
    }, 1);
  }
  function RootNodeOwner$OwnerImpl$TextInputSession$startInputMethod$slambda$slambda(this$0, $request, this$1, resultContinuation) {
    this.ncm_1 = this$0;
    this.ocm_1 = $request;
    this.pcm_1 = this$1;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(RootNodeOwner$OwnerImpl$TextInputSession$startInputMethod$slambda$slambda).rcm = function ($this$coroutineScope, $completion) {
    var tmp = this.q24($this$coroutineScope, $completion);
    tmp.p9_1 = Unit_instance;
    tmp.q9_1 = null;
    return tmp.v9();
  };
  protoOf(RootNodeOwner$OwnerImpl$TextInputSession$startInputMethod$slambda$slambda).ja = function (p1, $completion) {
    return this.rcm((!(p1 == null) ? isInterface(p1, CoroutineScope_0) : false) ? p1 : THROW_CCE(), $completion);
  };
  protoOf(RootNodeOwner$OwnerImpl$TextInputSession$startInputMethod$slambda$slambda).v9 = function () {
    var suspendResult = this.p9_1;
    $sm: do
      try {
        var tmp = this.n9_1;
        switch (tmp) {
          case 0:
            this.o9_1 = 2;
            var tmp_0 = CoroutineStart_UNDISPATCHED_getInstance();
            launch(this.qcm_1, VOID, tmp_0, RootNodeOwner$OwnerImpl$TextInputSession$startInputMethod$slambda$slambda$slambda_0(this.pcm_1, null));
            this.n9_1 = 1;
            suspendResult = this.ncm_1.scm_1.hbp(this.ocm_1, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            throwKotlinNothingValueException();
            break;
          case 2:
            throw this.q9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.o9_1 === 2) {
          throw e;
        } else {
          this.n9_1 = this.o9_1;
          this.q9_1 = e;
        }
      }
     while (true);
  };
  protoOf(RootNodeOwner$OwnerImpl$TextInputSession$startInputMethod$slambda$slambda).q24 = function ($this$coroutineScope, completion) {
    var i = new RootNodeOwner$OwnerImpl$TextInputSession$startInputMethod$slambda$slambda(this.ncm_1, this.ocm_1, this.pcm_1, completion);
    i.qcm_1 = $this$coroutineScope;
    return i;
  };
  function RootNodeOwner$OwnerImpl$TextInputSession$startInputMethod$slambda$slambda_0(this$0, $request, this$1, resultContinuation) {
    var i = new RootNodeOwner$OwnerImpl$TextInputSession$startInputMethod$slambda$slambda(this$0, $request, this$1, resultContinuation);
    return constructCallableReference(function ($this$coroutineScope, $completion) {
      return i.rcm($this$coroutineScope, $completion);
    }, 1);
  }
  function RootNodeOwner$OwnerImpl$TextInputSession$startInputMethod$lambda(it) {
    return null;
  }
  function RootNodeOwner$OwnerImpl$TextInputSession$startInputMethod$slambda(this$0, $request, this$1, resultContinuation) {
    this.vcn_1 = this$0;
    this.wcn_1 = $request;
    this.xcn_1 = this$1;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(RootNodeOwner$OwnerImpl$TextInputSession$startInputMethod$slambda).zcn = function (it, $completion) {
    var tmp = this.aco(it, $completion);
    tmp.p9_1 = Unit_instance;
    tmp.q9_1 = null;
    return tmp.v9();
  };
  protoOf(RootNodeOwner$OwnerImpl$TextInputSession$startInputMethod$slambda).ja = function (p1, $completion) {
    var tmp;
    var tmp_0;
    if (p1 == null) {
      tmp_0 = true;
    } else {
      tmp_0 = false;
    }
    if (tmp_0) {
      tmp = p1;
    } else {
      tmp = THROW_CCE();
    }
    return this.zcn(tmp, $completion);
  };
  protoOf(RootNodeOwner$OwnerImpl$TextInputSession$startInputMethod$slambda).v9 = function () {
    var suspendResult = this.p9_1;
    $sm: do
      try {
        var tmp = this.n9_1;
        switch (tmp) {
          case 0:
            this.o9_1 = 2;
            this.n9_1 = 1;
            suspendResult = coroutineScope(RootNodeOwner$OwnerImpl$TextInputSession$startInputMethod$slambda$slambda_0(this.vcn_1, this.wcn_1, this.xcn_1, null), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            throwKotlinNothingValueException();
            break;
          case 2:
            throw this.q9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.o9_1 === 2) {
          throw e;
        } else {
          this.n9_1 = this.o9_1;
          this.q9_1 = e;
        }
      }
     while (true);
  };
  protoOf(RootNodeOwner$OwnerImpl$TextInputSession$startInputMethod$slambda).aco = function (it, completion) {
    var i = new RootNodeOwner$OwnerImpl$TextInputSession$startInputMethod$slambda(this.vcn_1, this.wcn_1, this.xcn_1, completion);
    i.ycn_1 = it;
    return i;
  };
  function RootNodeOwner$OwnerImpl$TextInputSession$startInputMethod$slambda_0(this$0, $request, this$1, resultContinuation) {
    var i = new RootNodeOwner$OwnerImpl$TextInputSession$startInputMethod$slambda(this$0, $request, this$1, resultContinuation);
    return constructCallableReference(function (it, $completion) {
      return i.zcn(it, $completion);
    }, 1);
  }
  function $startInputMethodCOROUTINE$_0(_this__u8e3s4, request, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.jco_1 = _this__u8e3s4;
    this.kco_1 = request;
  }
  protoOf($startInputMethodCOROUTINE$_0).v9 = function () {
    var suspendResult = this.p9_1;
    $sm: do
      try {
        var tmp = this.n9_1;
        switch (tmp) {
          case 0:
            this.o9_1 = 2;
            this.n9_1 = 1;
            var tmp_0 = RootNodeOwner$OwnerImpl$TextInputSession$startInputMethod$lambda;
            suspendResult = SessionMutex__withSessionCancellingPrevious_impl_9g140v(this.jco_1.mco_1, tmp_0, RootNodeOwner$OwnerImpl$TextInputSession$startInputMethod$slambda_0(this.jco_1.nco_1.ucl_1, this.kco_1, this.jco_1.nco_1, null), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            throwKotlinNothingValueException();
            break;
          case 2:
            throw this.q9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.o9_1 === 2) {
          throw e;
        } else {
          this.n9_1 = this.o9_1;
          this.q9_1 = e;
        }
      }
     while (true);
  };
  function TextInputSession($outer, coroutineScope) {
    this.nco_1 = $outer;
    this.lco_1 = coroutineScope;
    this.mco_1 = _SessionMutex___init__impl__v390co_0();
  }
  protoOf(TextInputSession).hbp = function (request, $completion) {
    var tmp = new $startInputMethodCOROUTINE$_0(this, request, $completion);
    tmp.p9_1 = Unit_instance;
    tmp.q9_1 = null;
    return tmp.v9();
  };
  protoOf(TextInputSession).q19 = function () {
    return this.lco_1.q19();
  };
  function RootNodeOwner$OwnerImpl$platformFocusOwner$1(this$0) {
    this.oco_1 = this$0;
  }
  protoOf(RootNodeOwner$OwnerImpl$platformFocusOwner$1).k9d = function (focusDirection, previouslyFocusedRect) {
    return this.oco_1.scm_1.pco();
  };
  protoOf(RootNodeOwner$OwnerImpl$platformFocusOwner$1).y9c = function () {
    this.oco_1.scm_1.qco().d9d(true);
  };
  protoOf(RootNodeOwner$OwnerImpl$platformFocusOwner$1).p9e = function (focusDirection) {
    return false;
  };
  protoOf(RootNodeOwner$OwnerImpl$platformFocusOwner$1).q9e = function () {
    return null;
  };
  function RootNodeOwner$OwnerImpl$rootModifier$lambda$lambda(this$0) {
    return function (_this__u8e3s4) {
      var tmp;
      if (this$0.scm_1.qco().f9d(_this__u8e3s4.r9g())) {
        _this__u8e3s4.s9g();
        tmp = Unit_instance;
      }
      return Unit_instance;
    };
  }
  function RootNodeOwner$OwnerImpl$rootModifier$lambda(this$0) {
    return function ($this$focusProperties) {
      $this$focusProperties.h9f(RootNodeOwner$OwnerImpl$rootModifier$lambda$lambda(this$0));
      return Unit_instance;
    };
  }
  function RootNodeOwner$OwnerImpl$rootModifier$lambda_0($this$semantics) {
    set_isTraversalGroup($this$semantics, true);
    return Unit_instance;
  }
  function RootNodeOwner$OwnerImpl$TextInputSession$_init_$ref_c76ure(p0) {
    return constructCallableReference(function (p0_0) {
      var tmp0 = p0;
      return new TextInputSession(tmp0, p0_0);
    }, 1, 0, 136, '<init>', [p0]);
  }
  function RootNodeOwner$OwnerImpl$_get_showLayoutBounds_$ref_uw38ro() {
    return constructCallableReference(function (p0) {
      return p0.pb6();
    }, 1, 0, 137);
  }
  function RootNodeOwner$OwnerImpl$_set_showLayoutBounds_$ref_q6y574() {
    return constructCallableReference(function (p0, p1) {
      p0.lbm(p1);
      return Unit_instance;
    }, 2, 0, 138);
  }
  function $textInputSessionCOROUTINE$_0(_this__u8e3s4, session, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.zco_1 = _this__u8e3s4;
    this.acp_1 = session;
  }
  protoOf($textInputSessionCOROUTINE$_0).v9 = function () {
    var suspendResult = this.p9_1;
    $sm: do
      try {
        var tmp = this.n9_1;
        switch (tmp) {
          case 0:
            this.o9_1 = 2;
            this.n9_1 = 1;
            suspendResult = SessionMutex__withSessionCancellingPrevious_impl_9g140v(this.zco_1.jcl_1, RootNodeOwner$OwnerImpl$TextInputSession$_init_$ref_c76ure(this.zco_1), this.acp_1, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            throwKotlinNothingValueException();
            break;
          case 2:
            throw this.q9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.o9_1 === 2) {
          throw e;
        } else {
          this.n9_1 = this.o9_1;
          this.q9_1 = e;
        }
      }
     while (true);
  };
  function RootNodeOwner$OwnedLayerManagerImpl$createLayer$lambda(this$0) {
    return function () {
      return this$0.ycm_1.l6z_1 > 0;
    };
  }
  function RootNodeOwner$slambda$lambda(this$0) {
    return function () {
      return new IntSize(this$0.scm_1.hbm().bbr());
    };
  }
  function RootNodeOwner$slambda$slambda(this$0, resultContinuation) {
    this.jcp_1 = this$0;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(RootNodeOwner$slambda$slambda).lcp = function (it, $completion) {
    var tmp = this.mcp(it, $completion);
    tmp.p9_1 = Unit_instance;
    tmp.q9_1 = null;
    return tmp.v9();
  };
  protoOf(RootNodeOwner$slambda$slambda).ja = function (p1, $completion) {
    return this.lcp(p1 instanceof IntSize ? p1.o5g_1 : THROW_CCE(), $completion);
  };
  protoOf(RootNodeOwner$slambda$slambda).v9 = function () {
    var suspendResult = this.p9_1;
    $sm: do
      try {
        var tmp = this.n9_1;
        if (tmp === 0) {
          this.o9_1 = 1;
          updatePositionCacheAndDispatch(this.jcp_1, true);
          return Unit_instance;
        } else if (tmp === 1) {
          throw this.q9_1;
        }
      } catch ($p) {
        var e = $p;
        throw e;
      }
     while (true);
  };
  protoOf(RootNodeOwner$slambda$slambda).mcp = function (it, completion) {
    var i = new RootNodeOwner$slambda$slambda(this.jcp_1, completion);
    i.kcp_1 = it;
    return i;
  };
  function RootNodeOwner$slambda$slambda_0(this$0, resultContinuation) {
    var i = new RootNodeOwner$slambda$slambda(this$0, resultContinuation);
    return constructCallableReference(function (it, $completion) {
      return i.lcp(it.o5g_1, $completion);
    }, 1);
  }
  function _set__layoutDirection__9qttup($this, _set____db54di) {
    var tmp0 = $this.dcn_1;
    var tmp = KMutableProperty1;
    var tmp_0 = RootNodeOwner$_get__layoutDirection_$ref_sl6fl3();
    // Inline function 'androidx.compose.runtime.setValue' call
    getPropertyCallableRef('_layoutDirection', 1, tmp, tmp_0, RootNodeOwner$_set__layoutDirection_$ref_en3rkr());
    tmp0.s21(_set____db54di);
    return Unit_instance;
  }
  function _get__layoutDirection__w75z1n($this) {
    var tmp0 = $this.dcn_1;
    var tmp = KMutableProperty1;
    var tmp_0 = RootNodeOwner$_get__layoutDirection_$ref_sl6fl3();
    // Inline function 'androidx.compose.runtime.getValue' call
    getPropertyCallableRef('_layoutDirection', 1, tmp, tmp_0, RootNodeOwner$_set__layoutDirection_$ref_en3rkr());
    return tmp0.u1();
  }
  function clearInvalidObservations($this) {
    if ($this.mcn_1) {
      $this.xcm_1.xbm();
      $this.mcn_1 = false;
    }
  }
  function updatePositionCacheAndDispatch($this, hasContainerSizeChanged) {
    hasContainerSizeChanged = hasContainerSizeChanged === VOID ? false : hasContainerSizeChanged;
    var positionOnScreen = $this.scm_1.ncp(Companion_getInstance().g5d_1);
    var tmp;
    if ($this.scm_1.ocp()) {
      $this.kcn_1 = null;
      tmp = true;
    } else {
      var tmp_0 = $this.kcn_1;
      if (!equals(new Offset(positionOnScreen), tmp_0 == null ? null : new Offset(tmp_0))) {
        $this.kcn_1 = positionOnScreen;
        tmp = true;
      } else {
        tmp = false;
      }
    }
    var hasPositionOnScreenChanged = tmp;
    var positionInWindow = $this.scm_1.pcp(Companion_getInstance().g5d_1);
    var tmp_1;
    if ($this.scm_1.ocp()) {
      $this.jcn_1 = null;
      tmp_1 = true;
    } else {
      var tmp_2 = $this.jcn_1;
      if (!equals(new Offset(positionInWindow), tmp_2 == null ? null : new Offset(tmp_2))) {
        $this.jcn_1 = positionInWindow;
        tmp_1 = true;
      } else {
        tmp_1 = false;
      }
    }
    var hasPositionInWindowChanged = tmp_1;
    if (hasPositionOnScreenChanged || hasPositionInWindowChanged) {
      $this.qcp().n65().e91_1.mba_1.ebe();
    }
    var containerSize = $this.scm_1.hbm().bbr();
    var tmp_3 = $this.qcp().xam();
    var tmp_4 = round(positionOnScreen);
    var tmp_5 = round(positionInWindow);
    // Inline function 'androidx.compose.ui.unit.IntSize.width' call
    // Inline function 'androidx.compose.ui.util.unpackInt1' call
    var value = _IntSize___get_packedValue__impl__uho7jf(containerSize);
    var tmp_6 = convertToInt(shiftRight(value, 32));
    // Inline function 'androidx.compose.ui.unit.IntSize.height' call
    // Inline function 'androidx.compose.ui.util.unpackInt2' call
    var value_0 = _IntSize___get_packedValue__impl__uho7jf(containerSize);
    var tmp$ret$2 = convertToInt(bitwiseAnd(value_0, new Long(-1, 0)));
    tmp_3.kbz(tmp_4, tmp_5, $this.lcn_1, tmp_6, tmp$ret$2);
    $this.hcn_1.hbj(hasPositionOnScreenChanged || hasPositionInWindowChanged);
    $this.qcp().xam().jbz();
    if (hasPositionInWindowChanged || hasContainerSizeChanged) {
      setLightingInfo($this.ycm_1, positionInWindow, $this.u5e(), containerSize);
    }
  }
  function onRootConstrainsChanged($this, constraints) {
    updateRootConstraintsWithInfinityCheck($this.hcn_1, constraints);
    if ($this.hcn_1.ybi()) {
      $this.tcm_1.wcp();
    }
  }
  function handleFocusKeys($this, keyEvent) {
    var focusDirection = getFocusDirection($this, keyEvent);
    var tmp;
    var tmp_0 = focusDirection;
    if ((tmp_0 == null ? null : new FocusDirection(tmp_0)) == null) {
      tmp = true;
    } else {
      tmp = !(get_type(keyEvent) === Companion_getInstance_39().e9e_1);
    }
    if (tmp)
      return false;
    $this.scm_1.xbl().xcp(Companion_getInstance_38().b9u_1);
    return $this.o9c().f9d(focusDirection);
  }
  function getFocusDirection($this, keyEvent) {
    var tmp0_subject = get_key_0(keyEvent);
    return equals(tmp0_subject, Companion_getInstance_75().yca_1) ? get_isShiftPressed(keyEvent) ? Companion_getInstance_30().l9b_1 : Companion_getInstance_30().k9b_1 : equals(tmp0_subject, Companion_getInstance_75().mcd_1) ? Companion_getInstance_30().q9b_1 : equals(tmp0_subject, Companion_getInstance_75().bcd_1) ? Companion_getInstance_30().r9b_1 : null;
  }
  function isInBounds($this, localPosition) {
    var tmp0_safe_receiver = $this.bcn_1;
    var tmp;
    var tmp_0 = tmp0_safe_receiver;
    if ((tmp_0 == null ? null : new IntSize(tmp_0)) == null) {
      tmp = null;
    } else {
      // Inline function 'androidx.compose.ui.unit.toRect' call
      // Inline function 'androidx.compose.ui.unit.IntSize.width' call
      // Inline function 'androidx.compose.ui.util.unpackInt1' call
      var value = _IntSize___get_packedValue__impl__uho7jf(tmp0_safe_receiver);
      var tmp_1 = convertToInt(shiftRight(value, 32));
      // Inline function 'androidx.compose.ui.unit.IntSize.height' call
      // Inline function 'androidx.compose.ui.util.unpackInt2' call
      var value_0 = _IntSize___get_packedValue__impl__uho7jf(tmp0_safe_receiver);
      var tmp$ret$3 = convertToInt(bitwiseAnd(value_0, new Long(-1, 0)));
      tmp = new Rect(0.0, 0.0, tmp_1, tmp$ret$3);
    }
    var tmp1_safe_receiver = tmp;
    var tmp2_elvis_lhs = tmp1_safe_receiver == null ? null : tmp1_safe_receiver.u5d(localPosition);
    return tmp2_elvis_lhs == null ? true : tmp2_elvis_lhs;
  }
  function OwnerImpl($outer, layoutDirection, coroutineContext) {
    this.ucl_1 = $outer;
    this.vck_1 = coroutineContext;
    var tmp = this;
    tmp.wck_1 = new RootNodeOwner$OwnerImpl$platformFocusOwner$1(this.ucl_1);
    this.xck_1 = new FocusOwnerImpl(this.wck_1, this);
    var tmp_0 = this;
    var tmp_1 = rulerProvider(Companion_instance_6.d8v(new RootWindowInsetsProviderModifierElement(this.ucl_1.scm_1.ycp())), this.ucl_1.scm_1.ycp()).d8v(new EmptySemanticsElement(this.ucl_1.wcm_1));
    var tmp_2 = focusProperties(tmp_1, RootNodeOwner$OwnerImpl$rootModifier$lambda(this.ucl_1)).d8v(this.xck_1.j9d()).d8v(this.ucl_1.vcm_1.ock_1);
    tmp_0.yck_1 = semantics(tmp_2, VOID, RootNodeOwner$OwnerImpl$rootModifier$lambda_0);
    var tmp_3 = this;
    // Inline function 'kotlin.also' call
    var this_0 = new LayoutNode();
    this_0.q6p(layoutDirection);
    this_0.kax(RootMeasurePolicy_getInstance());
    this_0.kb1(this.yck_1);
    tmp_3.zck_1 = this_0;
    this.acl_1 = new LayoutNodeDrawScope();
    this.bcl_1 = mutableIntObjectMapOf();
    this.ccl_1 = new DefaultHapticFeedback();
    this.dcl_1 = createPlatformClipboardManager();
    this.ecl_1 = createPlatformClipboard();
    this.fcl_1 = new DefaultAccessibilityManager();
    this.gcl_1 = new AutofillTree();
    this.hcl_1 = new TextInputService(this.ucl_1.scm_1.fbm());
    this.icl_1 = new DelegatingSoftwareKeyboardController(this.hcl_1);
    this.jcl_1 = _SessionMutex___init__impl__v390co_0();
    this.kcl_1 = this.ucl_1.vcm_1;
    this.lcl_1 = new PointerIconServiceImpl(this.ucl_1);
    this.mcl_1 = new SemanticsOwner(this.zck_1, this.ucl_1.wcm_1, this.bcl_1);
    this.ncl_1 = new RectManager();
    this.ocl_1 = new FontLoader();
    this.pcl_1 = createFontFamilyResolver();
    this.qcl_1 = mutableStateOf(false);
    this.rcl_1 = new ModifierLocalManager(this);
    var tmp_4 = this;
    // Inline function 'androidx.compose.runtime.collection.mutableVectorOf' call
    // Inline function 'androidx.compose.runtime.collection.MutableVector' call
    // Inline function 'kotlin.arrayOfNulls' call
    var tmp$ret$4 = Array(16);
    tmp_4.scl_1 = new MutableVector(tmp$ret$4, 0);
    this.tcl_1 = 0;
  }
  protoOf(OwnerImpl).q19 = function () {
    return this.vck_1;
  };
  protoOf(OwnerImpl).o9c = function () {
    return this.xck_1;
  };
  protoOf(OwnerImpl).n65 = function () {
    return this.zck_1;
  };
  protoOf(OwnerImpl).ubc = function () {
    return this.acl_1;
  };
  protoOf(OwnerImpl).wbl = function () {
    return this.ccl_1;
  };
  protoOf(OwnerImpl).xbl = function () {
    return this.ucl_1.scm_1.xbl();
  };
  protoOf(OwnerImpl).ybl = function () {
    return this.dcl_1;
  };
  protoOf(OwnerImpl).zbl = function () {
    return this.ecl_1;
  };
  protoOf(OwnerImpl).abm = function () {
    return this.fcl_1;
  };
  protoOf(OwnerImpl).z93 = function () {
    return this.ucl_1.ycm_1;
  };
  protoOf(OwnerImpl).bbm = function () {
    return this.ucl_1.scm_1.bbm();
  };
  protoOf(OwnerImpl).cbm = function () {
    return this.gcl_1;
  };
  protoOf(OwnerImpl).dbm = function () {
    return null;
  };
  protoOf(OwnerImpl).ebm = function () {
    return null;
  };
  protoOf(OwnerImpl).u5e = function () {
    return this.ucl_1.u5e();
  };
  protoOf(OwnerImpl).fbm = function () {
    return this.hcl_1;
  };
  protoOf(OwnerImpl).gbm = function () {
    return this.icl_1;
  };
  protoOf(OwnerImpl).obm = function (session, $completion) {
    var tmp = new $textInputSessionCOROUTINE$_0(this, session, $completion);
    tmp.p9_1 = Unit_instance;
    tmp.q9_1 = null;
    return tmp.v9();
  };
  protoOf(OwnerImpl).b8z = function () {
    return this.kcl_1;
  };
  protoOf(OwnerImpl).ca5 = function () {
    return this.lcl_1;
  };
  protoOf(OwnerImpl).lbb = function () {
    return this.mcl_1;
  };
  protoOf(OwnerImpl).hbm = function () {
    return this.ucl_1.scm_1.hbm();
  };
  protoOf(OwnerImpl).ibm = function () {
    return ForgetfulRetainedValuesStore_instance;
  };
  protoOf(OwnerImpl).xam = function () {
    return this.ncl_1;
  };
  protoOf(OwnerImpl).jbm = function () {
    return this.ocl_1;
  };
  protoOf(OwnerImpl).kbm = function () {
    return this.pcl_1;
  };
  protoOf(OwnerImpl).r6p = function () {
    return _get__layoutDirection__w75z1n(this.ucl_1);
  };
  protoOf(OwnerImpl).n82 = function () {
    return this.ucl_1.scm_1.n82();
  };
  protoOf(OwnerImpl).lbm = function (_set____db54di) {
    var tmp0 = this.qcl_1;
    var tmp = KMutableProperty1;
    var tmp_0 = RootNodeOwner$OwnerImpl$_get_showLayoutBounds_$ref_uw38ro();
    // Inline function 'androidx.compose.runtime.setValue' call
    getPropertyCallableRef('showLayoutBounds', 1, tmp, tmp_0, RootNodeOwner$OwnerImpl$_set_showLayoutBounds_$ref_q6y574());
    tmp0.s21(_set____db54di);
    return Unit_instance;
  };
  protoOf(OwnerImpl).pb6 = function () {
    var tmp0 = this.qcl_1;
    var tmp = KMutableProperty1;
    var tmp_0 = RootNodeOwner$OwnerImpl$_get_showLayoutBounds_$ref_uw38ro();
    // Inline function 'androidx.compose.runtime.getValue' call
    getPropertyCallableRef('showLayoutBounds', 1, tmp, tmp_0, RootNodeOwner$OwnerImpl$_set_showLayoutBounds_$ref_q6y574());
    return tmp0.u1();
  };
  protoOf(OwnerImpl).xaz = function () {
    return this.rcl_1;
  };
  protoOf(OwnerImpl).fb0 = function () {
    return this.ucl_1.xcm_1;
  };
  protoOf(OwnerImpl).la7 = function () {
    return this.ucl_1.scm_1.la7();
  };
  protoOf(OwnerImpl).jbb = function (node) {
  };
  protoOf(OwnerImpl).vbb = function (node) {
    this.bcl_1.ew(node.x8z_1, node);
  };
  protoOf(OwnerImpl).ybb = function (node) {
  };
  protoOf(OwnerImpl).abc = function (node) {
    var existing = this.bcl_1.gw(node.x8z_1);
    $l$block: {
      // Inline function 'kotlin.checkNotNull' call
      if (existing == null) {
        var message = 'Invalid usage of Owner.onDetach: layoutNode was not previously attached';
        throw IllegalStateException_init_$Create$(toString(message));
      } else {
        break $l$block;
      }
    }
    this.ucl_1.hcn_1.lbj(node);
    this.fb0().ybm(node);
    this.ucl_1.mcn_1 = true;
    this.ncl_1.bbc(node);
  };
  protoOf(OwnerImpl).mbm = function (sendPointerUpdate) {
    if (this.ucl_1.hcn_1.ybi() || this.ucl_1.hcn_1.zbi()) {
      // Inline function 'androidx.compose.ui.util.trace' call
      var tmp;
      if (sendPointerUpdate) {
        tmp = ComposeSceneInputHandler$onPointerUpdate$ref(this.ucl_1.ucm_1);
      } else {
        tmp = null;
      }
      var resend = tmp;
      var rootNodeResized = this.ucl_1.hcn_1.fbj(resend);
      if (rootNodeResized) {
        this.ucl_1.tcm_1.zcp();
      }
      this.ucl_1.hcn_1.kbj();
      this.ncl_1.jbz();
    }
  };
  protoOf(OwnerImpl).wbe = function (layoutNode, constraints) {
    // Inline function 'androidx.compose.ui.util.trace' call
    this.ucl_1.hcn_1.wbe(layoutNode, constraints);
    this.ucl_1.ucm_1.gcq();
    if (!this.ucl_1.hcn_1.ybi()) {
      this.ucl_1.hcn_1.kbj();
    }
    this.ncl_1.jbz();
  };
  protoOf(OwnerImpl).ibi = function (layoutNode, affectsLookahead) {
    this.ucl_1.hcn_1.ibi(layoutNode, affectsLookahead);
  };
  protoOf(OwnerImpl).zbd = function (layoutNode, affectsLookahead, forceRequest, scheduleMeasureAndLayout) {
    if (affectsLookahead) {
      if (this.ucl_1.hcn_1.bbj(layoutNode, forceRequest) && scheduleMeasureAndLayout) {
        this.ucl_1.tcm_1.wcp();
      }
    } else if (this.ucl_1.hcn_1.cbj(layoutNode, forceRequest) && scheduleMeasureAndLayout) {
      this.ucl_1.tcm_1.wcp();
    }
  };
  protoOf(OwnerImpl).gbe = function (layoutNode, affectsLookahead, forceRequest) {
    if (affectsLookahead) {
      if (this.ucl_1.hcn_1.dbj(layoutNode, forceRequest)) {
        this.ucl_1.tcm_1.wcp();
      }
    } else {
      if (this.ucl_1.hcn_1.ebj(layoutNode, forceRequest)) {
        this.ucl_1.tcm_1.wcp();
      }
    }
  };
  protoOf(OwnerImpl).bbe = function (layoutNode) {
    this.ucl_1.hcn_1.bbe(layoutNode);
    this.ucl_1.tcm_1.wcp();
  };
  protoOf(OwnerImpl).obk = function (drawBlock, invalidateParentLayer, explicitLayer) {
    return this.ucl_1.fcn_1.obk(drawBlock, invalidateParentLayer, explicitLayer);
  };
  protoOf(OwnerImpl).yaz = function () {
    var tmp0_safe_receiver = this.ucl_1.scm_1.ncq();
    if (tmp0_safe_receiver == null)
      null;
    else {
      tmp0_safe_receiver.ocq(this.mcl_1);
    }
  };
  protoOf(OwnerImpl).sbk = function (layoutNode) {
    var tmp0_safe_receiver = this.ucl_1.scm_1.ncq();
    if (tmp0_safe_receiver == null)
      null;
    else {
      tmp0_safe_receiver.pcq(this.mcl_1, layoutNode.x8z_1);
    }
  };
  protoOf(OwnerImpl).abf = function (layoutNode) {
    this.ncl_1.bbc(layoutNode);
  };
  protoOf(OwnerImpl).ybe = function (layoutNode, oldSemanticsId) {
    var existing = this.bcl_1.gw(oldSemanticsId);
    $l$block: {
      // Inline function 'kotlin.checkNotNull' call
      if (existing == null) {
        var message = 'Invalid usage of Owner.onPreLayoutNodeReused: layoutNode is not found';
        throw IllegalStateException_init_$Create$(toString(message));
      } else {
        break $l$block;
      }
    }
    // Inline function 'kotlin.check' call
    if (!equals(existing, layoutNode)) {
      var message_0 = 'Invalid usage of Owner.onPreLayoutNodeReused: previous semanticsId refers another layoutNode';
      throw IllegalStateException_init_$Create$(toString(message_0));
    }
    this.bcl_1.ew(layoutNode.x8z_1, layoutNode);
  };
  protoOf(OwnerImpl).nbl = function (localPosition) {
    return this.ucl_1.scm_1.pcp(localPosition);
  };
  protoOf(OwnerImpl).mbl = function (positionInWindow) {
    return this.ucl_1.scm_1.qcq(positionInWindow);
  };
  protoOf(OwnerImpl).ja7 = function (positionOnScreen) {
    return this.ucl_1.scm_1.rcq(positionOnScreen);
  };
  protoOf(OwnerImpl).aai = function (localPosition) {
    return this.ucl_1.scm_1.ncp(localPosition);
  };
  protoOf(OwnerImpl).nbm = function () {
    clearInvalidObservations(this.ucl_1);
    $l$loop: while (true) {
      // Inline function 'androidx.compose.runtime.collection.MutableVector.isNotEmpty' call
      if (!!(this.scl_1.d3e_1 === 0)) {
        break $l$loop;
      }
      var size = this.scl_1.d3e_1;
      var inductionVariable = 0;
      if (inductionVariable < size)
        do {
          var i = inductionVariable;
          inductionVariable = inductionVariable + 1 | 0;
          // Inline function 'androidx.compose.runtime.collection.MutableVector.get' call
          var listener = this.scl_1.b3e_1[i];
          this.scl_1.mi(i, null);
          if (listener == null)
            null;
          else
            listener();
        }
         while (inductionVariable < size);
      this.scl_1.e5(0, size);
    }
  };
  protoOf(OwnerImpl).l8w = function (listener) {
    if (!this.scl_1.lh(listener)) {
      // Inline function 'androidx.compose.runtime.collection.MutableVector.plusAssign' call
      this.scl_1.zz(listener);
    }
  };
  protoOf(OwnerImpl).cb0 = function (listener) {
    this.ucl_1.hcn_1.cb0(listener);
    this.ucl_1.tcm_1.wcp();
  };
  protoOf(OwnerImpl).rbk = function (frameRate) {
    this.ucl_1.fcn_1.rbk(frameRate);
  };
  protoOf(OwnerImpl).yba = function () {
    this.ucl_1.fcn_1.m40();
  };
  protoOf(OwnerImpl).s1d = function () {
    this.ncl_1.mbz();
  };
  function PlatformRootForTestImpl($outer) {
    this.scq_1 = $outer;
  }
  function PointerIconServiceImpl($outer) {
    this.ucq_1 = $outer;
    this.tcq_1 = null;
  }
  protoOf(PointerIconServiceImpl).da5 = function (value) {
    this.tcq_1 = value;
    var tmp0_elvis_lhs = this.tcq_1;
    this.ucq_1.scm_1.vcq(tmp0_elvis_lhs == null ? Companion_getInstance_43().aa3_1 : tmp0_elvis_lhs);
  };
  protoOf(PointerIconServiceImpl).ba6 = function (value) {
  };
  function OwnedLayerManagerImpl($outer) {
    this.mcq_1 = $outer;
    var tmp = this;
    // Inline function 'kotlin.collections.mutableListOf' call
    tmp.hcq_1 = ArrayList_init_$Create$();
    this.icq_1 = null;
    this.jcq_1 = false;
    this.kcq_1 = NaN;
    this.lcq_1 = 0.0;
  }
  protoOf(OwnedLayerManagerImpl).obk = function (drawBlock, invalidateParentLayer, explicitLayer) {
    var tmp;
    if (!(explicitLayer == null) || !get_useLegacyRenderNodeLayers(ComposeUiFlags_instance)) {
      tmp = new GraphicsLayerOwnerLayer(explicitLayer == null ? this.mcq_1.ycm_1.m6z() : explicitLayer, !(explicitLayer == null) ? null : this.mcq_1.ycm_1, this, drawBlock, invalidateParentLayer);
    } else {
      var tmp$ret$0;
      $l$block: {
        // Inline function 'androidx.compose.runtime.snapshots.Companion.withoutReadObservation' call
        var previousSnapshot = Companion_instance.p52();
        var observer = previousSnapshot == null ? null : previousSnapshot.t3e();
        var newSnapshot = Companion_instance.q52(previousSnapshot);
        try {
          tmp$ret$0 = this.mcq_1.u5e();
          break $l$block;
        }finally {
          Companion_instance.c53(previousSnapshot, newSnapshot, observer);
        }
      }
      var tmp_0 = tmp$ret$0;
      var tmp_1 = this.mcq_1.scm_1.wcq();
      tmp = new LegacyRenderNodeLayer(tmp_0, tmp_1, this, RootNodeOwner$OwnedLayerManagerImpl$createLayer$lambda(this.mcq_1), invalidateParentLayer, drawBlock);
    }
    return tmp;
  };
  protoOf(OwnedLayerManagerImpl).xcq = function (layer) {
    this.mcq_1.mcn_1 = true;
    // Inline function 'kotlin.collections.minusAssign' call
    this.hcq_1.d3(layer);
    return false;
  };
  protoOf(OwnedLayerManagerImpl).ycq = function (layer, isDirty) {
    if (!isDirty) {
      if (!this.jcq_1) {
        this.hcq_1.d3(layer);
        var tmp0_safe_receiver = this.icq_1;
        if (tmp0_safe_receiver == null)
          null;
        else
          tmp0_safe_receiver.d3(layer);
      }
    } else if (!this.jcq_1) {
      // Inline function 'kotlin.collections.plusAssign' call
      this.hcq_1.j1(layer);
    } else {
      var tmp1_elvis_lhs = this.icq_1;
      var tmp;
      if (tmp1_elvis_lhs == null) {
        // Inline function 'kotlin.collections.mutableListOf' call
        // Inline function 'kotlin.also' call
        var this_0 = ArrayList_init_$Create$();
        this.icq_1 = this_0;
        tmp = this_0;
      } else {
        tmp = tmp1_elvis_lhs;
      }
      var postponed = tmp;
      // Inline function 'kotlin.collections.plusAssign' call
      postponed.j1(layer);
    }
  };
  protoOf(OwnedLayerManagerImpl).m40 = function () {
    this.mcq_1.tcm_1.zcp();
  };
  protoOf(OwnedLayerManagerImpl).rbk = function (frameRate) {
    var isCurrentFrameRateUnset = isNaN_0(this.kcq_1);
    var isCurrentFrameRateCategoryUnset = this.lcq_1 === 0.0;
    if (frameRate > 0) {
      if (isCurrentFrameRateUnset || frameRate > this.kcq_1) {
        this.kcq_1 = frameRate;
      }
    } else if (isNaN_0(frameRate) && isCurrentFrameRateCategoryUnset) {
      this.lcq_1 = frameRate;
    } else if (!isNaN_0(frameRate) && frameRate < 0 && (isNaN_0(this.lcq_1) || frameRate < this.lcq_1)) {
      this.lcq_1 = frameRate;
    }
  };
  protoOf(OwnedLayerManagerImpl).zcq = function (canvas) {
    this.jcq_1 = true;
    // Inline function 'kotlin.collections.isNotEmpty' call
    if (!this.hcq_1.r()) {
      var inductionVariable = 0;
      var last = this.hcq_1.n1();
      if (inductionVariable < last)
        do {
          var i = inductionVariable;
          inductionVariable = inductionVariable + 1 | 0;
          var layer = this.hcq_1.l1(i);
          layer.acr();
        }
         while (inductionVariable < last);
    }
    this.hcq_1.c3();
    this.mcq_1.qcp().n65().nb6(canvas, null);
    if (!(this.icq_1 == null)) {
      var postponed = ensureNotNull(this.icq_1);
      this.hcq_1.o1(postponed);
      postponed.c3();
    }
    var isAnyCurrentFrameRateSet = !isNaN_0(this.kcq_1) || !(this.lcq_1 === 0.0);
    if (isAnyCurrentFrameRateSet) {
      this.mcq_1.scm_1.bcr(this.kcq_1, this.lcq_1);
      this.kcq_1 = NaN;
      this.lcq_1 = 0.0;
    }
    this.jcq_1 = false;
  };
  function sam$kotlinx_coroutines_flow_FlowCollector$0(function_0) {
    this.ccr_1 = function_0;
  }
  protoOf(sam$kotlinx_coroutines_flow_FlowCollector$0).a1v = function (value, $completion) {
    return this.ccr_1(value, $completion);
  };
  protoOf(sam$kotlinx_coroutines_flow_FlowCollector$0).q3 = function () {
    return this.ccr_1;
  };
  protoOf(sam$kotlinx_coroutines_flow_FlowCollector$0).equals = function (other) {
    var tmp;
    if (!(other == null) ? isInterface(other, FlowCollector) : false) {
      var tmp_0;
      if (!(other == null) ? isInterface(other, FunctionAdapter) : false) {
        tmp_0 = equals(this.q3(), other.q3());
      } else {
        tmp_0 = false;
      }
      tmp = tmp_0;
    } else {
      tmp = false;
    }
    return tmp;
  };
  protoOf(sam$kotlinx_coroutines_flow_FlowCollector$0).hashCode = function () {
    return hashCode(this.q3());
  };
  function RootNodeOwner$_get_density_$ref_6pt2al() {
    return constructCallableReference(function (p0) {
      return p0.u5e();
    }, 1, 0, 139);
  }
  function RootNodeOwner$_set_density_$ref_y0wtcn() {
    return constructCallableReference(function (p0, p1) {
      p0.s6p(p1);
      return Unit_instance;
    }, 2, 0, 140);
  }
  function RootNodeOwner$_get__layoutDirection_$ref_sl6fl3() {
    return constructCallableReference(function (p0) {
      return _get__layoutDirection__w75z1n(p0);
    }, 1, 0, 141);
  }
  function RootNodeOwner$_set__layoutDirection_$ref_en3rkr() {
    return constructCallableReference(function (p0, p1) {
      _set__layoutDirection__9qttup(p0, p1);
      return Unit_instance;
    }, 2, 0, 142);
  }
  function RootNodeOwner$slambda(this$0, resultContinuation) {
    this.lcr_1 = this$0;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(RootNodeOwner$slambda).p24 = function ($this$launch, $completion) {
    var tmp = this.q24($this$launch, $completion);
    tmp.p9_1 = Unit_instance;
    tmp.q9_1 = null;
    return tmp.v9();
  };
  protoOf(RootNodeOwner$slambda).ja = function (p1, $completion) {
    return this.p24((!(p1 == null) ? isInterface(p1, CoroutineScope_0) : false) ? p1 : THROW_CCE(), $completion);
  };
  protoOf(RootNodeOwner$slambda).v9 = function () {
    var suspendResult = this.p9_1;
    $sm: do
      try {
        var tmp = this.n9_1;
        switch (tmp) {
          case 0:
            this.o9_1 = 2;
            this.n9_1 = 1;
            var tmp_0 = snapshotFlow(RootNodeOwner$slambda$lambda(this.lcr_1));
            var tmp_1 = RootNodeOwner$slambda$slambda_0(this.lcr_1, null);
            suspendResult = tmp_0.l1u(new sam$kotlinx_coroutines_flow_FlowCollector$0(tmp_1), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            return Unit_instance;
          case 2:
            throw this.q9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.o9_1 === 2) {
          throw e;
        } else {
          this.n9_1 = this.o9_1;
          this.q9_1 = e;
        }
      }
     while (true);
  };
  protoOf(RootNodeOwner$slambda).q24 = function ($this$launch, completion) {
    var i = new RootNodeOwner$slambda(this.lcr_1, completion);
    i.mcr_1 = $this$launch;
    return i;
  };
  function RootNodeOwner$slambda_0(this$0, resultContinuation) {
    var i = new RootNodeOwner$slambda(this$0, resultContinuation);
    return constructCallableReference(function ($this$launch, $completion) {
      return i.p24($this$launch, $completion);
    }, 1);
  }
  function RootNodeOwner(density, layoutDirection, size, coroutineContext, platformContext, snapshotInvalidationTracker, inputHandler) {
    this.scm_1 = platformContext;
    this.tcm_1 = snapshotInvalidationTracker;
    this.ucm_1 = inputHandler;
    this.vcm_1 = new DragAndDropOwner(this.scm_1.b8z());
    this.wcm_1 = new EmptySemanticsModifier();
    this.xcm_1 = this.tcm_1.ncr();
    this.ycm_1 = new SkiaGraphicsContext(this.scm_1.wcq());
    this.zcm_1 = CoroutineScope(coroutineContext.xj(Job(coroutineContext.aa(Key_instance))));
    this.acn_1 = new OwnerImpl(this, layoutDirection, coroutineContext);
    this.bcn_1 = size;
    this.ccn_1 = mutableStateOf(density);
    this.dcn_1 = mutableStateOf(layoutDirection);
    this.ecn_1 = new PlatformRootForTestImpl(this);
    this.fcn_1 = new OwnedLayerManagerImpl(this);
    this.gcn_1 = new PointerInputEventProcessor(this.qcp().n65());
    this.hcn_1 = new MeasureAndLayoutDelegate(this.qcp().n65());
    this.icn_1 = false;
    this.jcn_1 = null;
    this.kcn_1 = null;
    this.lcn_1 = _Matrix___init__impl__q3kp4w();
    this.xcm_1.zbm();
    this.qcp().n65().ibb(this.qcp());
    var tmp0_safe_receiver = this.scm_1.ocr();
    if (tmp0_safe_receiver == null)
      null;
    else {
      tmp0_safe_receiver.pcr(this.ecn_1);
    }
    var tmp;
    var tmp_0 = size;
    if ((tmp_0 == null ? null : new IntSize(tmp_0)) == null) {
      tmp = null;
    } else {
      tmp = toConstraints(size);
    }
    onRootConstrainsChanged(this, tmp);
    updatePositionCacheAndDispatch(this);
    launch(this.zcm_1, VOID, VOID, RootNodeOwner$slambda_0(this, null));
    this.mcn_1 = false;
  }
  protoOf(RootNodeOwner).o9c = function () {
    return this.acn_1.xck_1;
  };
  protoOf(RootNodeOwner).qcp = function () {
    return this.acn_1;
  };
  protoOf(RootNodeOwner).lbb = function () {
    return this.qcp().lbb();
  };
  protoOf(RootNodeOwner).qcr = function (value) {
    var tmp = this.bcn_1;
    var tmp_0 = tmp == null ? null : new IntSize(tmp);
    var tmp_1 = value;
    if (!equals(tmp_0, tmp_1 == null ? null : new IntSize(tmp_1))) {
      this.bcn_1 = value;
      var tmp_2;
      var tmp_3 = value;
      if ((tmp_3 == null ? null : new IntSize(tmp_3)) == null) {
        tmp_2 = null;
      } else {
        tmp_2 = toConstraints(value);
      }
      onRootConstrainsChanged(this, tmp_2);
    }
  };
  protoOf(RootNodeOwner).s6p = function (_set____db54di) {
    var tmp0 = this.ccn_1;
    var tmp = KMutableProperty1;
    var tmp_0 = RootNodeOwner$_get_density_$ref_6pt2al();
    // Inline function 'androidx.compose.runtime.setValue' call
    getPropertyCallableRef('density', 1, tmp, tmp_0, RootNodeOwner$_set_density_$ref_y0wtcn());
    tmp0.s21(_set____db54di);
    return Unit_instance;
  };
  protoOf(RootNodeOwner).u5e = function () {
    var tmp0 = this.ccn_1;
    var tmp = KMutableProperty1;
    var tmp_0 = RootNodeOwner$_get_density_$ref_6pt2al();
    // Inline function 'androidx.compose.runtime.getValue' call
    getPropertyCallableRef('density', 1, tmp, tmp_0, RootNodeOwner$_set_density_$ref_y0wtcn());
    return tmp0.u1();
  };
  protoOf(RootNodeOwner).q6p = function (value) {
    _set__layoutDirection__9qttup(this, value);
    this.qcp().n65().q6p(value);
  };
  protoOf(RootNodeOwner).r6p = function () {
    return _get__layoutDirection__w75z1n(this);
  };
  protoOf(RootNodeOwner).s1d = function () {
    // Inline function 'kotlin.check' call
    if (!!this.icn_1) {
      var message = 'RootNodeOwner is already disposed';
      throw IllegalStateException_init_$Create$(toString(message));
    }
    cancel(this.zcm_1);
    var tmp0_safe_receiver = this.scm_1.ocr();
    if (tmp0_safe_receiver == null)
      null;
    else {
      tmp0_safe_receiver.rcr(this.ecn_1);
    }
    this.xcm_1.abn();
    this.ycm_1.s1d();
    this.acn_1.s1d();
    this.icn_1 = true;
  };
  protoOf(RootNodeOwner).scr = function () {
    this.qcp().mbm(true);
    updatePositionCacheAndDispatch(this);
  };
  protoOf(RootNodeOwner).zcq = function (canvas) {
    // Inline function 'androidx.compose.ui.util.trace' call
    this.fcn_1.zcq(canvas);
    clearInvalidObservations(this);
    this.qcp().xam().jbz();
    return Unit_instance;
  };
  protoOf(RootNodeOwner).tcr = function (modifier) {
    this.qcp().n65().kb1(this.acn_1.yck_1.d8v(modifier));
  };
  protoOf(RootNodeOwner).xa1 = function () {
    this.gcn_1.y9z();
  };
  protoOf(RootNodeOwner).ucr = function (event) {
    var tmp = event.ia7_1;
    if (!((tmp == null ? null : new PointerButton(tmp)) == null)) {
      this.scm_1.xbl().xcp(Companion_getInstance_38().a9u_1);
    }
    var tmp_0;
    if (!(event.ca7_1 === Companion_getInstance_41().pa1_1)) {
      var tmp0 = event.ea7_1;
      var tmp$ret$0;
      $l$block: {
        // Inline function 'androidx.compose.ui.util.fastAll' call
        // Inline function 'androidx.compose.ui.util.fastForEach' call
        var inductionVariable = 0;
        var last = tmp0.n1() - 1 | 0;
        if (inductionVariable <= last)
          do {
            var index = inductionVariable;
            inductionVariable = inductionVariable + 1 | 0;
            var item = tmp0.l1(index);
            if (!isInBounds(this, item.ba2_1)) {
              tmp$ret$0 = false;
              break $l$block;
            }
          }
           while (inductionVariable <= last);
        tmp$ret$0 = true;
      }
      tmp_0 = tmp$ret$0;
    } else {
      tmp_0 = false;
    }
    var isInBounds_0 = tmp_0;
    var result = this.gcn_1.sa6(event, IdentityPositionCalculator_instance, isInBounds_0);
    return _PointerEventResult___init__impl__b3e4iv(_ProcessResult___get_value__impl__qmeswv(result));
  };
  protoOf(RootNodeOwner).w9e = function (keyEvent) {
    return this.o9c().n9d(keyEvent) || handleFocusKeys(this, keyEvent);
  };
  function toConstraints(_this__u8e3s4) {
    // Inline function 'androidx.compose.ui.unit.IntSize.width' call
    // Inline function 'androidx.compose.ui.util.unpackInt1' call
    var value = _IntSize___get_packedValue__impl__uho7jf(_this__u8e3s4);
    var tmp = convertToInt(shiftRight(value, 32));
    // Inline function 'androidx.compose.ui.unit.IntSize.height' call
    // Inline function 'androidx.compose.ui.util.unpackInt2' call
    var value_0 = _IntSize___get_packedValue__impl__uho7jf(_this__u8e3s4);
    var tmp$ret$2 = convertToInt(bitwiseAnd(value_0, new Long(-1, 0)));
    return Constraints(VOID, tmp, VOID, tmp$ret$2);
  }
  function updateRootConstraintsWithInfinityCheck(_this__u8e3s4, constraints) {
    var tmp;
    var tmp_0 = constraints;
    if ((tmp_0 == null ? null : new Constraints_0(tmp_0)) == null) {
      tmp = null;
    } else {
      tmp = _Constraints___get_minWidth__impl__hi9lfi(constraints);
    }
    var tmp1_elvis_lhs = tmp;
    var tmp_1 = tmp1_elvis_lhs == null ? 0 : tmp1_elvis_lhs;
    var tmp_2;
    var tmp_3;
    var tmp_4 = constraints;
    if (!((tmp_4 == null ? null : new Constraints_0(tmp_4)) == null)) {
      tmp_3 = _Constraints___get_hasBoundedWidth__impl__7hd0wr(constraints);
    } else {
      tmp_3 = false;
    }
    if (tmp_3) {
      tmp_2 = _Constraints___get_maxWidth__impl__uuyqc(constraints);
    } else {
      tmp_2 = 32766;
    }
    var tmp_5 = tmp_2;
    var tmp_6;
    var tmp_7 = constraints;
    if ((tmp_7 == null ? null : new Constraints_0(tmp_7)) == null) {
      tmp_6 = null;
    } else {
      tmp_6 = _Constraints___get_minHeight__impl__ev4bgx(constraints);
    }
    var tmp3_elvis_lhs = tmp_6;
    var tmp_8 = tmp3_elvis_lhs == null ? 0 : tmp3_elvis_lhs;
    var tmp_9;
    var tmp_10;
    var tmp_11 = constraints;
    if (!((tmp_11 == null ? null : new Constraints_0(tmp_11)) == null)) {
      tmp_10 = _Constraints___get_hasBoundedHeight__impl__bsh4rw(constraints);
    } else {
      tmp_10 = false;
    }
    if (tmp_10) {
      tmp_9 = _Constraints___get_maxHeight__impl__dt3e8z(constraints);
    } else {
      tmp_9 = 32766;
    }
    _this__u8e3s4.abj(Constraints(tmp_1, tmp_5, tmp_8, tmp_9));
  }
  function IdentityPositionCalculator() {
  }
  protoOf(IdentityPositionCalculator).ja7 = function (positionOnScreen) {
    return positionOnScreen;
  };
  protoOf(IdentityPositionCalculator).aai = function (localPosition) {
    return localPosition;
  };
  var IdentityPositionCalculator_instance;
  function IdentityPositionCalculator_getInstance() {
    return IdentityPositionCalculator_instance;
  }
  function rulerProvider(_this__u8e3s4, windowInsets) {
    return get_areWindowInsetsRulersEnabled(ComposeUiFlags_instance) ? _this__u8e3s4.d8v(new RulerProviderModifierElement(windowInsets)) : _this__u8e3s4;
  }
  function RootWindowInsetsProviderModifierElement(windowInsets) {
    ModifierNodeElement.call(this);
    this.wcr_1 = windowInsets;
  }
  protoOf(RootWindowInsetsProviderModifierElement).r3d = function () {
    return new RootPlatformWindowInsetsProviderNode(this.wcr_1);
  };
  protoOf(RootWindowInsetsProviderModifierElement).xcr = function (node) {
    return node.rcs(this.wcr_1);
  };
  protoOf(RootWindowInsetsProviderModifierElement).d8y = function (node) {
    return this.xcr(node instanceof RootPlatformWindowInsetsProviderNode ? node : THROW_CCE());
  };
  protoOf(RootWindowInsetsProviderModifierElement).toString = function () {
    return 'RootWindowInsetsProviderModifierElement(windowInsets=' + toString(this.wcr_1) + ')';
  };
  protoOf(RootWindowInsetsProviderModifierElement).hashCode = function () {
    return hashCode(this.wcr_1);
  };
  protoOf(RootWindowInsetsProviderModifierElement).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof RootWindowInsetsProviderModifierElement))
      return false;
    if (!equals(this.wcr_1, other.wcr_1))
      return false;
    return true;
  };
  function RootPlatformWindowInsetsProviderNode(insets) {
    PlatformWindowInsetsProviderNode.call(this, insets);
    this.qcs_1 = insets;
  }
  protoOf(RootPlatformWindowInsetsProviderNode).scs = function (ancestorWindowInsets) {
    return this.qcs_1;
  };
  protoOf(RootPlatformWindowInsetsProviderNode).rcs = function (windowInsets) {
    if (!equals(this.qcs_1, windowInsets)) {
      this.qcs_1 = windowInsets;
      this.lct();
    }
  };
  function RootNodeOwner$_get_density_$ref_6pt2al_0(p0) {
    return constructCallableReference(function () {
      return p0.u5e();
    }, 0, 0, 139, VOID, [p0]);
  }
  function RootNodeOwner$_set_density_$ref_y0wtcn_0(p0) {
    return constructCallableReference(function (p0_0) {
      p0.s6p(p0_0);
      return Unit_instance;
    }, 1, 0, 140, VOID, [p0]);
  }
  function RootNodeOwner$_get_layoutDirection_$ref_68hoi2(p0) {
    return constructCallableReference(function () {
      return p0.r6p();
    }, 0, 0, 143, VOID, [p0]);
  }
  function RootNodeOwner$_set_layoutDirection_$ref_jj7xee(p0) {
    return constructCallableReference(function (p0_0) {
      p0.q6p(p0_0);
      return Unit_instance;
    }, 1, 0, 144, VOID, [p0]);
  }
  var androidx_compose_ui_node_SnapshotInvalidationTracker$stable;
  function _set_renderingThreadId__9b5jlg($this, _set____db54di) {
    var tmp0 = $this.vcp_1;
    var tmp = KMutableProperty1;
    var tmp_0 = SnapshotInvalidationTracker$_get_renderingThreadId_$ref_9jdgw1();
    // Inline function 'kotlinx.atomicfu.AtomicRef.setValue' call
    getPropertyCallableRef('renderingThreadId', 1, tmp, tmp_0, SnapshotInvalidationTracker$_set_renderingThreadId_$ref_foztbp());
    tmp0.kotlinx$atomicfu$value = _set____db54di;
    return Unit_instance;
  }
  function _get_renderingThreadId__cencow($this) {
    var tmp0 = $this.vcp_1;
    var tmp = KMutableProperty1;
    var tmp_0 = SnapshotInvalidationTracker$_get_renderingThreadId_$ref_9jdgw1();
    // Inline function 'kotlinx.atomicfu.AtomicRef.getValue' call
    getPropertyCallableRef('renderingThreadId', 1, tmp, tmp_0, SnapshotInvalidationTracker$_set_renderingThreadId_$ref_foztbp());
    return tmp0.kotlinx$atomicfu$value;
  }
  function access$_set_renderingThreadId__hexfbg($this, _set____db54di) {
    return _set_renderingThreadId__9b5jlg($this, _set____db54di);
  }
  function SnapshotInvalidationTracker$_init_$lambda_sbho5n() {
    return Unit_instance;
  }
  function SnapshotInvalidationTracker$_get_renderingThreadId_$ref_9jdgw1() {
    return constructCallableReference(function (p0) {
      return _get_renderingThreadId__cencow(p0);
    }, 1, 0, 145);
  }
  function SnapshotInvalidationTracker$_set_renderingThreadId_$ref_foztbp() {
    return constructCallableReference(function (p0, p1) {
      _set_renderingThreadId__9b5jlg(p0, p1);
      return Unit_instance;
    }, 2, 0, 146);
  }
  function SnapshotInvalidationTracker$snapshotObserver$lambda(this$0) {
    return function (command) {
      var tmp;
      if (equals(_get_renderingThreadId__cencow(this$0), getCurrentThreadId())) {
        tmp = command();
      } else {
        this$0.scp_1.qct(command);
        tmp = Unit_instance;
      }
      return Unit_instance;
    };
  }
  function SnapshotInvalidationTracker(invalidate) {
    var tmp;
    if (invalidate === VOID) {
      tmp = SnapshotInvalidationTracker$_init_$lambda_sbho5n;
    } else {
      tmp = invalidate;
    }
    invalidate = tmp;
    this.rcp_1 = invalidate;
    this.scp_1 = new CommandList(this.rcp_1);
    this.tcp_1 = true;
    this.ucp_1 = true;
    this.vcp_1 = atomic$ref$1(null);
  }
  protoOf(SnapshotInvalidationTracker).v39 = function () {
    return this.tcp_1 || this.ucp_1 || this.scp_1.rct();
  };
  protoOf(SnapshotInvalidationTracker).wcp = function () {
    this.tcp_1 = true;
    this.rcp_1();
  };
  protoOf(SnapshotInvalidationTracker).sct = function () {
    this.tcp_1 = false;
  };
  protoOf(SnapshotInvalidationTracker).zcp = function () {
    this.ucp_1 = true;
    this.rcp_1();
  };
  protoOf(SnapshotInvalidationTracker).tct = function () {
    this.ucp_1 = false;
  };
  protoOf(SnapshotInvalidationTracker).ncr = function () {
    return new OwnerSnapshotObserver(SnapshotInvalidationTracker$snapshotObserver$lambda(this));
  };
  protoOf(SnapshotInvalidationTracker).uct = function () {
    Companion_instance.w41();
    this.scp_1.vct();
  };
  function CommandList(onNewCommand) {
    this.mct_1 = onNewCommand;
    var tmp = this;
    // Inline function 'androidx.compose.ui.platform.makeSynchronizedObject' call
    tmp.nct_1 = new SynchronizedObject();
    var tmp_0 = this;
    // Inline function 'kotlin.collections.mutableListOf' call
    tmp_0.oct_1 = ArrayList_init_$Create$();
    var tmp_1 = this;
    // Inline function 'kotlin.collections.mutableListOf' call
    tmp_1.pct_1 = ArrayList_init_$Create$();
  }
  protoOf(CommandList).rct = function () {
    // Inline function 'androidx.compose.ui.platform.synchronized' call
    // Inline function 'kotlinx.atomicfu.locks.synchronized' call
    this.nct_1;
    // Inline function 'kotlin.collections.isNotEmpty' call
    return !this.oct_1.r();
  };
  protoOf(CommandList).qct = function (command) {
    // Inline function 'androidx.compose.ui.platform.synchronized' call
    // Inline function 'kotlinx.atomicfu.locks.synchronized' call
    this.nct_1;
    this.oct_1.j1(command);
    this.mct_1();
  };
  protoOf(CommandList).vct = function () {
    // Inline function 'androidx.compose.ui.platform.synchronized' call
    // Inline function 'kotlinx.atomicfu.locks.synchronized' call
    this.nct_1;
    this.pct_1.o1(this.oct_1);
    this.oct_1.c3();
    // Inline function 'androidx.compose.ui.util.fastForEach' call
    var this_0 = this.pct_1;
    var inductionVariable = 0;
    var last = this_0.n1() - 1 | 0;
    if (inductionVariable <= last)
      do {
        var index = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var item = this_0.l1(index);
        item();
      }
       while (inductionVariable <= last);
    this.pct_1.c3();
  };
  function traverseDescendantsInDrawOrder(_this__u8e3s4, block) {
    // Inline function 'androidx.compose.ui.node.Nodes.Traversable' call
    // Inline function 'androidx.compose.ui.node.visitSubtreeIf' call
    var type = _NodeKind___init__impl__ojsprp(262144);
    // Inline function 'androidx.compose.ui.node.visitSubtreeIf' call
    var mask = _NodeKind___get_mask__impl__1uopb6(type);
    // Inline function 'androidx.compose.ui.internal.checkPrecondition' call
    if (!_this__u8e3s4.f4n().z8v_1) {
      var tmp$ret$4 = 'visitSubtreeIf called on an unattached node';
      throwIllegalStateException(tmp$ret$4);
    }
    // Inline function 'androidx.compose.runtime.collection.mutableVectorOf' call
    // Inline function 'androidx.compose.runtime.collection.MutableVector' call
    // Inline function 'kotlin.arrayOfNulls' call
    var tmp$ret$7 = Array(16);
    var branches = new MutableVector(tmp$ret$7, 0);
    var child = _this__u8e3s4.f4n().r8v_1;
    if (child == null) {
      access$addLayoutNodeChildren$tDelegatableNodeKt(branches, _this__u8e3s4.f4n(), true);
    } else
      branches.zz(child);
    outer: while (true) {
      // Inline function 'androidx.compose.runtime.collection.MutableVector.isNotEmpty' call
      if (!!(branches.d3e_1 === 0)) {
        break outer;
      }
      var branch = branches.h3(branches.d3e_1 - 1 | 0);
      if (!((branch.p8v_1 & mask) === 0)) {
        var node = branch;
        while (!(node == null) && node.z8v_1) {
          if (!((node.o8v_1 & mask) === 0)) {
            var tmp0 = node;
            var tmp$ret$9;
            $l$block: {
              // Inline function 'androidx.compose.ui.node.dispatchForKind' call
              // Inline function 'androidx.compose.ui.node.dispatchForKind' call
              var stack = null;
              var node_0 = tmp0;
              $l$loop: while (!(node_0 == null)) {
                var tmp;
                if (isInterface(node_0, TraversableNode)) {
                  var it = node_0;
                  if (equals(_this__u8e3s4.t91(), it.t91()) && areObjectsOfSameType(_this__u8e3s4, it)) {
                    if (!block(isInterface(it, TraversableNode) ? it : THROW_CCE()))
                      return Unit_instance;
                  }
                  if (!true) {
                    tmp$ret$9 = false;
                    break $l$block;
                  }
                  tmp = false;
                } else {
                  tmp = true;
                }
                var dispatchAgain = tmp;
                var tmp_0;
                var tmp_1;
                if (dispatchAgain || false) {
                  // Inline function 'androidx.compose.ui.Node.isKind' call
                  tmp_1 = !((node_0.o8v_1 & _NodeKind___get_mask__impl__1uopb6(type)) === 0);
                } else {
                  tmp_1 = false;
                }
                if (tmp_1) {
                  tmp_0 = node_0 instanceof DelegatingNode;
                } else {
                  tmp_0 = false;
                }
                if (tmp_0) {
                  var count = 0;
                  // Inline function 'androidx.compose.ui.node.DelegatingNode.forEachImmediateDelegate' call
                  var node_1 = node_0.e9a_1;
                  while (!(node_1 == null)) {
                    var next = node_1;
                    // Inline function 'androidx.compose.ui.Node.isKind' call
                    if (!((next.o8v_1 & _NodeKind___get_mask__impl__1uopb6(type)) === 0)) {
                      count = count + 1 | 0;
                      if (count === 1) {
                        node_0 = next;
                      } else {
                        var tmp0_elvis_lhs = stack;
                        var tmp_2;
                        if (tmp0_elvis_lhs == null) {
                          // Inline function 'androidx.compose.runtime.collection.mutableVectorOf' call
                          // Inline function 'androidx.compose.runtime.collection.MutableVector' call
                          // Inline function 'kotlin.arrayOfNulls' call
                          var tmp$ret$20 = Array(16);
                          tmp_2 = new MutableVector(tmp$ret$20, 0);
                        } else {
                          tmp_2 = tmp0_elvis_lhs;
                        }
                        stack = tmp_2;
                        var theNode = node_0;
                        if (!(theNode == null)) {
                          var tmp1_safe_receiver = stack;
                          if (tmp1_safe_receiver == null)
                            null;
                          else
                            tmp1_safe_receiver.zz(theNode);
                          node_0 = null;
                        }
                        var tmp2_safe_receiver = stack;
                        if (tmp2_safe_receiver == null)
                          null;
                        else
                          tmp2_safe_receiver.zz(next);
                      }
                    }
                    node_1 = node_1.r8v_1;
                  }
                  if (count === 1) {
                    continue $l$loop;
                  }
                }
                node_0 = access$pop$tDelegatableNodeKt(stack);
              }
              tmp$ret$9 = true;
            }
            var diveDeeper = tmp$ret$9;
            if (!diveDeeper)
              continue outer;
          }
          node = node.r8v_1;
        }
      }
      access$addLayoutNodeChildren$tDelegatableNodeKt(branches, branch, true);
    }
  }
  function get_LocalPlatformScreenReader() {
    _init_properties_CompositionLocals_skiko_kt__kd7t15();
    return LocalPlatformScreenReader;
  }
  var LocalPlatformScreenReader;
  function get_LocalPlatformWindowInsets() {
    _init_properties_CompositionLocals_skiko_kt__kd7t15();
    return LocalPlatformWindowInsets;
  }
  var LocalPlatformWindowInsets;
  function ProvidePlatformCompositionLocals(values, platformContext, content, $composer, $changed) {
    _init_properties_CompositionLocals_skiko_kt__kd7t15();
    var $composer_0 = $composer;
    $composer_0 = $composer_0.s30(684213531);
    var $dirty = $changed;
    if (($changed & 48) === 0)
      $dirty = $dirty | ((($changed & 64) === 0 ? $composer_0.k31(platformContext) : $composer_0.q31(platformContext)) ? 32 : 16);
    if (($changed & 384) === 0)
      $dirty = $dirty | ($composer_0.q31(content) ? 256 : 128);
    $composer_0.o30(399208378, values.length);
    $dirty = $dirty | ($composer_0.m31(values.length) ? 4 : 0);
    var inductionVariable = 0;
    var last = values.length;
    while (inductionVariable < last) {
      var value = values[inductionVariable];
      inductionVariable = inductionVariable + 1 | 0;
      $dirty = $dirty | ((($changed & 8) === 0 ? $composer_0.k31(value) : $composer_0.q31(value)) ? 4 : 0);
    }
    $composer_0.p30();
    if (($dirty & 14) === 0)
      $dirty = $dirty | 2;
    if ($composer_0.r31(!(($dirty & 147) === 146), $dirty & 1)) {
      var tmp0 = $composer_0;
      // Inline function 'androidx.compose.runtime.cache' call
      var invalid = ($dirty & 112) === 32 || (!(($dirty & 64) === 0) && $composer_0.k31(platformContext));
      // Inline function 'kotlin.let' call
      var it = tmp0.i31();
      var tmp;
      if (invalid || it === Companion_getInstance_9().f30_1) {
        var value_0 = DisposableSaveableStateRegistry_0('ComposeContainer', platformContext.wct().xct());
        tmp0.j31(value_0);
        tmp = value_0;
      } else {
        tmp = it;
      }
      var saveableStateRegistry = tmp;
      var tmp0_0 = $composer_0;
      // Inline function 'androidx.compose.runtime.cache' call
      var invalid_0 = $composer_0.q31(saveableStateRegistry);
      // Inline function 'kotlin.let' call
      var it_0 = tmp0_0.i31();
      var tmp_0;
      if (invalid_0 || it_0 === Companion_getInstance_9().f30_1) {
        var value_1 = ProvidePlatformCompositionLocals$lambda(saveableStateRegistry);
        tmp0_0.j31(value_1);
        tmp_0 = value_1;
      } else {
        tmp_0 = it_0;
      }
      var tmp$ret$4 = tmp_0;
      DisposableEffect(platformContext, tmp$ret$4, $composer_0, 14 & $dirty >> 3);
      var tmp0_1 = $composer_0;
      // Inline function 'androidx.compose.runtime.cache' call
      var invalid_1 = ($dirty & 112) === 32 || (!(($dirty & 64) === 0) && $composer_0.k31(platformContext));
      // Inline function 'kotlin.let' call
      var it_1 = tmp0_1.i31();
      var tmp_1;
      if (invalid_1 || it_1 === Companion_getInstance_9().f30_1) {
        var value_2 = new ProvidePlatformCompositionLocals$hostDefaultProvider$1(platformContext);
        tmp0_1.j31(value_2);
        tmp_1 = value_2;
      } else {
        tmp_1 = it_1;
      }
      var hostDefaultProvider = tmp_1;
      CompositionLocalProvider(arrayConcat([values, [get_LocalPlatformScreenReader().h3c(platformContext.yct()), get_LocalPlatformWindowInsets().h3c(platformContext.ycp())], get_values(platformContext.wct()), [get_LocalSaveableStateRegistry().h3c(saveableStateRegistry), get_LocalHostDefaultProvider().h3c(hostDefaultProvider)]]), content, $composer_0, androidx_compose_runtime_ProvidedValue$stableprop_getter() | 112 & $dirty >> 3);
    } else {
      $composer_0.z30();
    }
    var tmp0_safe_receiver = $composer_0.t30();
    if (tmp0_safe_receiver == null)
      null;
    else {
      tmp0_safe_receiver.p3c(ProvidePlatformCompositionLocals$lambda_0(values, platformContext, content, $changed));
    }
  }
  function get_values(_this__u8e3s4) {
    _init_properties_CompositionLocals_skiko_kt__kd7t15();
    var providedValues = mutableListOf([get_LocalLifecycleOwner().h3c(_this__u8e3s4.zct()), get_LocalInternalNavigationEventDispatcherOwner().h3c(_this__u8e3s4.acu()), get_LocalCompatNavigationEventDispatcherOwner().h3c(_this__u8e3s4.acu()), get_LocalSavedStateRegistryOwner().h3c(_this__u8e3s4.xct())]);
    var tmp0_safe_receiver = _this__u8e3s4.bcu();
    if (tmp0_safe_receiver == null)
      null;
    else {
      // Inline function 'kotlin.let' call
      providedValues.j1(get_LocalInternalViewModelStoreOwner().h3c(tmp0_safe_receiver));
    }
    // Inline function 'kotlin.collections.toTypedArray' call
    return copyToArray(providedValues);
  }
  function LocalPlatformScreenReader$lambda() {
    _init_properties_CompositionLocals_skiko_kt__kd7t15();
    // Inline function 'kotlin.error' call
    var message = 'CompositionLocal LocalPlatformScreenReader not present';
    throw IllegalStateException_init_$Create$(toString(message));
  }
  function LocalPlatformWindowInsets$lambda() {
    _init_properties_CompositionLocals_skiko_kt__kd7t15();
    // Inline function 'kotlin.error' call
    var message = 'CompositionLocal LocalPlatformWindowInsets not present';
    throw IllegalStateException_init_$Create$(toString(message));
  }
  function ProvidePlatformCompositionLocals$$inlined$cache$1$1($registry) {
    this.ccu_1 = $registry;
  }
  protoOf(ProvidePlatformCompositionLocals$$inlined$cache$1$1).s1d = function () {
    this.ccu_1.s1d();
  };
  function ProvidePlatformCompositionLocals$lambda($saveableStateRegistry) {
    return function ($this$DisposableEffect) {
      var registry = $saveableStateRegistry;
      // Inline function 'androidx.compose.runtime.DisposableEffectScope.onDispose' call
      return new ProvidePlatformCompositionLocals$$inlined$cache$1$1(registry);
    };
  }
  function ProvidePlatformCompositionLocals$hostDefaultProvider$1($platformContext) {
    this.fcu_1 = $platformContext;
  }
  function ProvidePlatformCompositionLocals$lambda_0($values, $platformContext, $content, $$changed) {
    return function ($composer, $force) {
      ProvidePlatformCompositionLocals($values, $platformContext, $content, $composer, updateChangedFlags($$changed | 1));
      return Unit_instance;
    };
  }
  var properties_initialized_CompositionLocals_skiko_kt_5tqmlz;
  function _init_properties_CompositionLocals_skiko_kt__kd7t15() {
    if (!properties_initialized_CompositionLocals_skiko_kt_5tqmlz) {
      properties_initialized_CompositionLocals_skiko_kt_5tqmlz = true;
      LocalPlatformScreenReader = staticCompositionLocalOf(LocalPlatformScreenReader$lambda);
      LocalPlatformWindowInsets = staticCompositionLocalOf(LocalPlatformWindowInsets$lambda);
    }
  }
  var androidx_compose_ui_platform_DefaultAccessibilityManager$stable;
  function DefaultAccessibilityManager() {
  }
  protoOf(DefaultAccessibilityManager).gcu = function (originalTimeoutMillis, containsIcons, containsText, containsControls) {
    return originalTimeoutMillis;
  };
  var androidx_compose_ui_platform_DefaultHapticFeedback$stable;
  function DefaultHapticFeedback() {
  }
  protoOf(DefaultHapticFeedback).hcu = function (hapticFeedbackType) {
  };
  function get_LocalInternalNavigationEventDispatcherOwner() {
    _init_properties_DefaultNavigationEventDispatcherOwner_skiko_kt__pr5lvg();
    return LocalInternalNavigationEventDispatcherOwner;
  }
  var LocalInternalNavigationEventDispatcherOwner;
  function findDefaultNavigationEventDispatcherOwner($composer, $changed) {
    _init_properties_DefaultNavigationEventDispatcherOwner_skiko_kt__pr5lvg();
    var $composer_0 = $composer;
    // Inline function 'androidx.compose.runtime.CompositionLocal.current' call
    var this_0 = get_LocalInternalNavigationEventDispatcherOwner();
    var $composer_1 = $composer_0;
    var tmp0_elvis_lhs = $composer_1.u31(this_0);
    var tmp;
    if (tmp0_elvis_lhs == null) {
      $composer_0.m30(-263928761);
      // Inline function 'androidx.compose.runtime.CompositionLocal.current' call
      var this_1 = get_LocalCompatNavigationEventDispatcherOwner();
      var $composer_2 = $composer_0;
      var tmp1_group = $composer_2.u31(this_1);
      $composer_0.n30();
      tmp = tmp1_group;
    } else {
      $composer_0.m30(-263932016);
      $composer_0.n30();
      tmp = tmp0_elvis_lhs;
    }
    return tmp;
  }
  function LocalInternalNavigationEventDispatcherOwner$lambda() {
    _init_properties_DefaultNavigationEventDispatcherOwner_skiko_kt__pr5lvg();
    return null;
  }
  var properties_initialized_DefaultNavigationEventDispatcherOwner_skiko_kt_dr1hem;
  function _init_properties_DefaultNavigationEventDispatcherOwner_skiko_kt__pr5lvg() {
    if (!properties_initialized_DefaultNavigationEventDispatcherOwner_skiko_kt_dr1hem) {
      properties_initialized_DefaultNavigationEventDispatcherOwner_skiko_kt_dr1hem = true;
      LocalInternalNavigationEventDispatcherOwner = staticCompositionLocalOf(LocalInternalNavigationEventDispatcherOwner$lambda);
    }
  }
  var androidx_compose_ui_platform_DefaultTextToolbar$stable;
  function DefaultUiApplier(root) {
    AbstractApplier.call(this, root);
  }
  protoOf(DefaultUiApplier).lcu = function (index, instance) {
  };
  protoOf(DefaultUiApplier).j2y = function (index, instance) {
    return this.lcu(index, instance instanceof LayoutNode ? instance : THROW_CCE());
  };
  protoOf(DefaultUiApplier).mcu = function (index, instance) {
    this.e2y().xav(index, instance);
  };
  protoOf(DefaultUiApplier).k2y = function (index, instance) {
    return this.mcu(index, instance instanceof LayoutNode ? instance : THROW_CCE());
  };
  protoOf(DefaultUiApplier).l2y = function (index, count) {
    this.e2y().waw(index, count);
  };
  protoOf(DefaultUiApplier).m2y = function (from, to, count) {
    this.e2y().yav(from, to, count);
  };
  protoOf(DefaultUiApplier).v2y = function () {
    this.q2y_1.yas();
  };
  protoOf(DefaultUiApplier).g2y = function () {
    protoOf(AbstractApplier).g2y.call(this);
    var tmp0_safe_receiver = this.q2y_1.l90_1;
    if (tmp0_safe_receiver == null)
      null;
    else {
      tmp0_safe_receiver.nbm();
    }
  };
  var androidx_compose_ui_platform_DefaultViewConfiguration$stable;
  function get_LocalInternalViewModelStoreOwner() {
    _init_properties_DefaultViewModelOwnerStore_skiko_kt__ntcfgo();
    return LocalInternalViewModelStoreOwner;
  }
  var LocalInternalViewModelStoreOwner;
  function findComposeDefaultViewModelStoreOwner($composer, $changed) {
    _init_properties_DefaultViewModelOwnerStore_skiko_kt__ntcfgo();
    var $composer_0 = $composer;
    // Inline function 'androidx.compose.runtime.CompositionLocal.current' call
    var this_0 = get_LocalInternalViewModelStoreOwner();
    var $composer_1 = $composer_0;
    return $composer_1.u31(this_0);
  }
  function LocalInternalViewModelStoreOwner$lambda() {
    _init_properties_DefaultViewModelOwnerStore_skiko_kt__ntcfgo();
    return null;
  }
  var properties_initialized_DefaultViewModelOwnerStore_skiko_kt_v71e06;
  function _init_properties_DefaultViewModelOwnerStore_skiko_kt__ntcfgo() {
    if (!properties_initialized_DefaultViewModelOwnerStore_skiko_kt_v71e06) {
      properties_initialized_DefaultViewModelOwnerStore_skiko_kt_v71e06 = true;
      LocalInternalViewModelStoreOwner = staticCompositionLocalOf(LocalInternalViewModelStoreOwner$lambda);
    }
  }
  var androidx_compose_ui_platform_DisposableSaveableStateRegistry$stable;
  function DisposableSaveableStateRegistry(saveableStateRegistry, onDispose) {
    this.dcu_1 = saveableStateRegistry;
    this.ecu_1 = onDispose;
  }
  protoOf(DisposableSaveableStateRegistry).s1d = function () {
    this.ecu_1();
  };
  protoOf(DisposableSaveableStateRegistry).a7o = function (key) {
    return this.dcu_1.a7o(key);
  };
  protoOf(DisposableSaveableStateRegistry).k7o = function (key, valueProvider) {
    return this.dcu_1.k7o(key, valueProvider);
  };
  protoOf(DisposableSaveableStateRegistry).z7n = function (value) {
    return this.dcu_1.z7n(value);
  };
  protoOf(DisposableSaveableStateRegistry).t7o = function () {
    return this.dcu_1.t7o();
  };
  function DisposableSaveableStateRegistry_0(id, savedStateRegistryOwner) {
    var key = '' + getKClass(SaveableStateRegistry).o() + ':' + id;
    var androidxRegistry = savedStateRegistryOwner.i7p();
    var savedState = androidxRegistry.r7m(key);
    var restored = savedState == null ? null : toMap(savedState);
    var saveableStateRegistry = SaveableStateRegistry_0(restored, DisposableSaveableStateRegistry$lambda);
    var tmp;
    try {
      var tmp_0 = DisposableSaveableStateRegistry$lambda_0(saveableStateRegistry);
      androidxRegistry.s7m(key, new sam$androidx_savedstate_SavedStateRegistry_SavedStateProvider$0(tmp_0));
      tmp = true;
    } catch ($p) {
      var tmp_1;
      if ($p instanceof IllegalArgumentException) {
        var ignore = $p;
        tmp_1 = false;
      } else {
        throw $p;
      }
      tmp = tmp_1;
    }
    var registered = tmp;
    return new DisposableSaveableStateRegistry(saveableStateRegistry, DisposableSaveableStateRegistry$lambda_1(registered, androidxRegistry, key));
  }
  function toMap(_this__u8e3s4) {
    // Inline function 'androidx.savedstate.read' call
    var $this$read = _SavedStateReader___init__impl__k2stzo(_this__u8e3s4);
    var tmp = SavedStateReader__toMap_impl_49zebr($this$read);
    return isInterface(tmp, KtMap) ? tmp : THROW_CCE();
  }
  function toSavedState(_this__u8e3s4) {
    // Inline function 'androidx.savedstate.savedState' call
    var copiedState = toMutableMap(_this__u8e3s4);
    // Inline function 'kotlin.apply' call
    var this_0 = new SavedState(copiedState);
    // Inline function 'androidx.savedstate.write' call
    _SavedStateWriter___init__impl__99cr38(this_0);
    return this_0;
  }
  function sam$androidx_savedstate_SavedStateRegistry_SavedStateProvider$0(function_0) {
    this.ncu_1 = function_0;
  }
  protoOf(sam$androidx_savedstate_SavedStateRegistry_SavedStateProvider$0).z7m = function () {
    return this.ncu_1();
  };
  protoOf(sam$androidx_savedstate_SavedStateRegistry_SavedStateProvider$0).q3 = function () {
    return this.ncu_1;
  };
  protoOf(sam$androidx_savedstate_SavedStateRegistry_SavedStateProvider$0).equals = function (other) {
    var tmp;
    if (!(other == null) ? isInterface(other, SavedStateProvider) : false) {
      var tmp_0;
      if (!(other == null) ? isInterface(other, FunctionAdapter) : false) {
        tmp_0 = equals(this.q3(), other.q3());
      } else {
        tmp_0 = false;
      }
      tmp = tmp_0;
    } else {
      tmp = false;
    }
    return tmp;
  };
  protoOf(sam$androidx_savedstate_SavedStateRegistry_SavedStateProvider$0).hashCode = function () {
    return hashCode(this.q3());
  };
  function DisposableSaveableStateRegistry$lambda(it) {
    return true;
  }
  function DisposableSaveableStateRegistry$lambda_0($saveableStateRegistry) {
    return function () {
      return toSavedState($saveableStateRegistry.t7o());
    };
  }
  function DisposableSaveableStateRegistry$lambda_1($registered, $androidxRegistry, $key) {
    return function () {
      var tmp;
      if ($registered) {
        $androidxRegistry.u7m($key);
        tmp = Unit_instance;
      }
      return Unit_instance;
    };
  }
  var androidx_compose_ui_platform_FlushCoroutineDispatcher$stable;
  function FlushCoroutineDispatcher$dispatch$slambda$lambda(this$0, $block) {
    return function () {
      // Inline function 'androidx.compose.ui.platform.synchronized' call
      // Inline function 'kotlinx.atomicfu.locks.synchronized' call
      this$0.scu_1;
      var isTaskAlive = this$0.qcu_1.d3($block);
      var tmp;
      if (isTaskAlive) {
        $block.o1f();
        tmp = Unit_instance;
      }
      return Unit_instance;
    };
  }
  function FlushCoroutineDispatcher$scheduleResumeAfterDelay$slambda$lambda(this$0, $block) {
    return function () {
      // Inline function 'androidx.compose.ui.platform.synchronized' call
      // Inline function 'kotlinx.atomicfu.locks.synchronized' call
      this$0.tcu_1;
      var isTaskAlive = this$0.rcu_1.d3($block);
      var tmp;
      if (isTaskAlive) {
        $block.o1f();
        tmp = Unit_instance;
      }
      return Unit_instance;
    };
  }
  function performRun($this, body) {
    // Inline function 'androidx.compose.ui.platform.synchronized' call
    // Inline function 'kotlinx.atomicfu.locks.synchronized' call
    $this.wcu_1;
    try {
      $this.vcu_1 = true;
      body();
    }finally {
      $this.vcu_1 = false;
    }
    return Unit_instance;
  }
  function FlushCoroutineDispatcher$dispatch$slambda(this$0, $block, resultContinuation) {
    this.fcv_1 = this$0;
    this.gcv_1 = $block;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(FlushCoroutineDispatcher$dispatch$slambda).p24 = function ($this$launch, $completion) {
    var tmp = this.q24($this$launch, $completion);
    tmp.p9_1 = Unit_instance;
    tmp.q9_1 = null;
    return tmp.v9();
  };
  protoOf(FlushCoroutineDispatcher$dispatch$slambda).ja = function (p1, $completion) {
    return this.p24((!(p1 == null) ? isInterface(p1, CoroutineScope_0) : false) ? p1 : THROW_CCE(), $completion);
  };
  protoOf(FlushCoroutineDispatcher$dispatch$slambda).v9 = function () {
    var suspendResult = this.p9_1;
    $sm: do
      try {
        var tmp = this.n9_1;
        if (tmp === 0) {
          this.o9_1 = 1;
          performRun(this.fcv_1, FlushCoroutineDispatcher$dispatch$slambda$lambda(this.fcv_1, this.gcv_1));
          return Unit_instance;
        } else if (tmp === 1) {
          throw this.q9_1;
        }
      } catch ($p) {
        var e = $p;
        throw e;
      }
     while (true);
  };
  protoOf(FlushCoroutineDispatcher$dispatch$slambda).q24 = function ($this$launch, completion) {
    var i = new FlushCoroutineDispatcher$dispatch$slambda(this.fcv_1, this.gcv_1, completion);
    i.hcv_1 = $this$launch;
    return i;
  };
  function FlushCoroutineDispatcher$dispatch$slambda_0(this$0, $block, resultContinuation) {
    var i = new FlushCoroutineDispatcher$dispatch$slambda(this$0, $block, resultContinuation);
    return constructCallableReference(function ($this$launch, $completion) {
      return i.p24($this$launch, $completion);
    }, 1);
  }
  function FlushCoroutineDispatcher$flush$lambda(this$0) {
    return function () {
      while (true) {
        // Inline function 'androidx.compose.ui.platform.synchronized' call
        // Inline function 'kotlinx.atomicfu.locks.synchronized' call
        this$0.scu_1;
        if (this$0.qcu_1.r())
          return Unit_instance;
        var tmp = this$0.ucu_1;
        this$0.ucu_1 = this$0.qcu_1;
        this$0.qcu_1 = tmp;
        // Inline function 'kotlin.collections.forEach' call
        var _iterator__ex2g4s = this$0.ucu_1.t();
        while (_iterator__ex2g4s.u()) {
          var element = _iterator__ex2g4s.v();
          element.o1f();
        }
        this$0.ucu_1.c3();
      }
      return Unit_instance;
    };
  }
  function FlushCoroutineDispatcher$scheduleResumeAfterDelay$$inlined$Runnable$1($continuation) {
    this.icv_1 = $continuation;
  }
  protoOf(FlushCoroutineDispatcher$scheduleResumeAfterDelay$$inlined$Runnable$1).o1f = function () {
    this.icv_1.h1d(Unit_instance, null);
  };
  function FlushCoroutineDispatcher$scheduleResumeAfterDelay$slambda($timeMillis, this$0, $block, resultContinuation) {
    this.rcv_1 = $timeMillis;
    this.scv_1 = this$0;
    this.tcv_1 = $block;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(FlushCoroutineDispatcher$scheduleResumeAfterDelay$slambda).p24 = function ($this$launch, $completion) {
    var tmp = this.q24($this$launch, $completion);
    tmp.p9_1 = Unit_instance;
    tmp.q9_1 = null;
    return tmp.v9();
  };
  protoOf(FlushCoroutineDispatcher$scheduleResumeAfterDelay$slambda).ja = function (p1, $completion) {
    return this.p24((!(p1 == null) ? isInterface(p1, CoroutineScope_0) : false) ? p1 : THROW_CCE(), $completion);
  };
  protoOf(FlushCoroutineDispatcher$scheduleResumeAfterDelay$slambda).v9 = function () {
    var suspendResult = this.p9_1;
    $sm: do
      try {
        var tmp = this.n9_1;
        switch (tmp) {
          case 0:
            this.o9_1 = 2;
            this.n9_1 = 1;
            suspendResult = delay(this.rcv_1, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            performRun(this.scv_1, FlushCoroutineDispatcher$scheduleResumeAfterDelay$slambda$lambda(this.scv_1, this.tcv_1));
            return Unit_instance;
          case 2:
            throw this.q9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.o9_1 === 2) {
          throw e;
        } else {
          this.n9_1 = this.o9_1;
          this.q9_1 = e;
        }
      }
     while (true);
  };
  protoOf(FlushCoroutineDispatcher$scheduleResumeAfterDelay$slambda).q24 = function ($this$launch, completion) {
    var i = new FlushCoroutineDispatcher$scheduleResumeAfterDelay$slambda(this.rcv_1, this.scv_1, this.tcv_1, completion);
    i.ucv_1 = $this$launch;
    return i;
  };
  function FlushCoroutineDispatcher$scheduleResumeAfterDelay$slambda_0($timeMillis, this$0, $block, resultContinuation) {
    var i = new FlushCoroutineDispatcher$scheduleResumeAfterDelay$slambda($timeMillis, this$0, $block, resultContinuation);
    return constructCallableReference(function ($this$launch, $completion) {
      return i.p24($this$launch, $completion);
    }, 1);
  }
  function FlushCoroutineDispatcher$scheduleResumeAfterDelay$lambda($job, this$0, $block) {
    return function (it) {
      $job.b1b();
      // Inline function 'androidx.compose.ui.platform.synchronized' call
      // Inline function 'kotlinx.atomicfu.locks.synchronized' call
      this$0.tcu_1;
      this$0.rcu_1.d3($block);
      return Unit_instance;
    };
  }
  function FlushCoroutineDispatcher(scope) {
    CoroutineDispatcher.call(this);
    this.pcu_1 = CoroutineScope(scope.q19().vj(Key_instance));
    this.qcu_1 = ArrayDeque_init_$Create$();
    this.rcu_1 = ArrayDeque_init_$Create$();
    var tmp = this;
    // Inline function 'androidx.compose.ui.platform.makeSynchronizedObject' call
    tmp.scu_1 = new SynchronizedObject();
    var tmp_0 = this;
    // Inline function 'androidx.compose.ui.platform.makeSynchronizedObject' call
    tmp_0.tcu_1 = new SynchronizedObject();
    this.ucu_1 = ArrayDeque_init_$Create$();
    this.vcu_1 = false;
    var tmp_1 = this;
    // Inline function 'androidx.compose.ui.platform.makeSynchronizedObject' call
    tmp_1.wcu_1 = new SynchronizedObject();
  }
  protoOf(FlushCoroutineDispatcher).b1h = function (context, block) {
    // Inline function 'androidx.compose.ui.platform.synchronized' call
    // Inline function 'kotlinx.atomicfu.locks.synchronized' call
    this.scu_1;
    this.qcu_1.j1(block);
    launch(this.pcu_1, VOID, VOID, FlushCoroutineDispatcher$dispatch$slambda_0(this, block, null));
  };
  protoOf(FlushCoroutineDispatcher).k9 = function () {
    return performRun(this, FlushCoroutineDispatcher$flush$lambda(this));
  };
  protoOf(FlushCoroutineDispatcher).o1h = function (timeMillis, continuation) {
    // Inline function 'kotlinx.coroutines.Runnable' call
    var block = new FlushCoroutineDispatcher$scheduleResumeAfterDelay$$inlined$Runnable$1(continuation);
    // Inline function 'androidx.compose.ui.platform.synchronized' call
    // Inline function 'kotlinx.atomicfu.locks.synchronized' call
    this.tcu_1;
    this.rcu_1.j1(block);
    var job = launch(this.pcu_1, VOID, VOID, FlushCoroutineDispatcher$scheduleResumeAfterDelay$slambda_0(timeMillis, this, block, null));
    continuation.f1d(FlushCoroutineDispatcher$scheduleResumeAfterDelay$lambda(job, this, block));
  };
  var androidx_compose_ui_platform_GlobalSnapshotManager$stable;
  function GlobalSnapshotManager$ensureStarted$slambda($channel, resultContinuation) {
    this.dcw_1 = $channel;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(GlobalSnapshotManager$ensureStarted$slambda).p24 = function ($this$launch, $completion) {
    var tmp = this.q24($this$launch, $completion);
    tmp.p9_1 = Unit_instance;
    tmp.q9_1 = null;
    return tmp.v9();
  };
  protoOf(GlobalSnapshotManager$ensureStarted$slambda).ja = function (p1, $completion) {
    return this.p24((!(p1 == null) ? isInterface(p1, CoroutineScope_0) : false) ? p1 : THROW_CCE(), $completion);
  };
  protoOf(GlobalSnapshotManager$ensureStarted$slambda).v9 = function () {
    var suspendResult = this.p9_1;
    $sm: do
      try {
        var tmp = this.n9_1;
        switch (tmp) {
          case 0:
            this.o9_1 = 10;
            this.icw_1 = this.dcw_1;
            this.n9_1 = 1;
            continue $sm;
          case 1:
            this.gcw_1 = this.icw_1;
            this.fcw_1 = null;
            this.n9_1 = 2;
            continue $sm;
          case 2:
            this.n9_1 = 3;
            continue $sm;
          case 3:
            this.o9_1 = 9;
            this.o9_1 = 8;
            this.hcw_1 = this.gcw_1.t();
            this.n9_1 = 4;
            continue $sm;
          case 4:
            this.n9_1 = 5;
            suspendResult = this.hcw_1.d1q(this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 5:
            if (!suspendResult) {
              this.n9_1 = 6;
              continue $sm;
            }

            var e = this.hcw_1.v();
            GlobalSnapshotManager_getInstance().kcw_1.atomicfu$compareAndSet(1, 0);
            Companion_instance.w41();
            this.n9_1 = 4;
            continue $sm;
          case 6:
            this.o9_1 = 10;
            this.n9_1 = 7;
            var tmp_0 = this;
            continue $sm;
          case 7:
            this.o9_1 = 10;
            cancelConsumed(this.gcw_1, this.fcw_1);
            this.n9_1 = 12;
            continue $sm;
          case 8:
            this.o9_1 = 9;
            var tmp_1 = this.q9_1;
            if (tmp_1 instanceof Error) {
              var e_0 = this.q9_1;
              var tmp_2 = this;
              this.fcw_1 = e_0;
              throw e_0;
            } else {
              throw this.q9_1;
            }

          case 9:
            this.o9_1 = 10;
            var t = this.q9_1;
            cancelConsumed(this.gcw_1, this.fcw_1);
            throw t;
          case 10:
            throw this.q9_1;
          case 11:
            this.o9_1 = 10;
            cancelConsumed(this.gcw_1, this.fcw_1);
            if (false) {
              this.n9_1 = 1;
              continue $sm;
            }

            this.n9_1 = 12;
            continue $sm;
          case 12:
            return Unit_instance;
        }
      } catch ($p) {
        var e_1 = $p;
        if (this.o9_1 === 10) {
          throw e_1;
        } else {
          this.n9_1 = this.o9_1;
          this.q9_1 = e_1;
        }
      }
     while (true);
  };
  protoOf(GlobalSnapshotManager$ensureStarted$slambda).q24 = function ($this$launch, completion) {
    var i = new GlobalSnapshotManager$ensureStarted$slambda(this.dcw_1, completion);
    i.ecw_1 = $this$launch;
    return i;
  };
  function GlobalSnapshotManager$ensureStarted$slambda_0($channel, resultContinuation) {
    var i = new GlobalSnapshotManager$ensureStarted$slambda($channel, resultContinuation);
    return constructCallableReference(function ($this$launch, $completion) {
      return i.p24($this$launch, $completion);
    }, 1);
  }
  function GlobalSnapshotManager$ensureStarted$lambda($channel) {
    return function (it) {
      var tmp;
      if (GlobalSnapshotManager_getInstance().kcw_1.atomicfu$compareAndSet(0, 1)) {
        $channel.s1s(Unit_instance);
        tmp = Unit_instance;
      }
      return Unit_instance;
    };
  }
  function GlobalSnapshotManager() {
    GlobalSnapshotManager_instance = this;
    this.jcw_1 = atomic$int$1(0);
    this.kcw_1 = atomic$int$1(0);
  }
  protoOf(GlobalSnapshotManager).lcw = function () {
    if (this.jcw_1.atomicfu$compareAndSet(0, 1)) {
      var channel = Channel(1);
      var tmp = CoroutineScope(get_GlobalSnapshotManagerDispatcher());
      launch(tmp, VOID, VOID, GlobalSnapshotManager$ensureStarted$slambda_0(channel, null));
      var tmp_0 = Companion_instance;
      tmp_0.d53(GlobalSnapshotManager$ensureStarted$lambda(channel));
    }
  };
  var GlobalSnapshotManager_instance;
  function GlobalSnapshotManager_getInstance() {
    if (GlobalSnapshotManager_instance == null)
      new GlobalSnapshotManager();
    return GlobalSnapshotManager_instance;
  }
  function get_LIGHT_Y() {
    _init_properties_GraphicsLayerOwnerLayer_skiko_kt__18k61z();
    return LIGHT_Y;
  }
  var LIGHT_Y;
  function get_LIGHT_Z() {
    _init_properties_GraphicsLayerOwnerLayer_skiko_kt__18k61z();
    return LIGHT_Z;
  }
  var LIGHT_Z;
  function get_LIGHT_RADIUS() {
    _init_properties_GraphicsLayerOwnerLayer_skiko_kt__18k61z();
    return LIGHT_RADIUS;
  }
  var LIGHT_RADIUS;
  var androidx_compose_ui_platform_GraphicsLayerOwnerLayer$stable;
  function setLightingInfo(_this__u8e3s4, canvasOffset, density, containerSize) {
    _init_properties_GraphicsLayerOwnerLayer_skiko_kt__18k61z();
    // Inline function 'kotlin.with' call
    // Inline function 'androidx.compose.ui.unit.IntSize.width' call
    // Inline function 'androidx.compose.ui.util.unpackInt1' call
    var value = _IntSize___get_packedValue__impl__uho7jf(containerSize);
    var tmp = convertToInt(shiftRight(value, 32)) / 2.0;
    // Inline function 'androidx.compose.ui.geometry.Offset.x' call
    // Inline function 'androidx.compose.ui.util.unpackFloat1' call
    var value_0 = _Offset___get_packedValue__impl__xh2k8q(canvasOffset);
    // Inline function 'androidx.compose.ui.util.floatFromBits' call
    // Inline function 'kotlin.fromBits' call
    var bits = convertToInt(shiftRight(value_0, 32));
    var lightX = tmp - floatFromBits(bits);
    var tmp_0 = density.v5e(get_LIGHT_Y());
    // Inline function 'androidx.compose.ui.geometry.Offset.y' call
    // Inline function 'androidx.compose.ui.util.unpackFloat2' call
    var value_1 = _Offset___get_packedValue__impl__xh2k8q(canvasOffset);
    // Inline function 'androidx.compose.ui.util.floatFromBits' call
    // Inline function 'kotlin.fromBits' call
    var bits_0 = convertToInt(bitwiseAnd(value_1, new Long(-1, 0)));
    var lightY = tmp_0 - floatFromBits(bits_0);
    // Inline function 'androidx.compose.ui.unit.IntSize.width' call
    // Inline function 'androidx.compose.ui.util.unpackInt1' call
    var value_2 = _IntSize___get_packedValue__impl__uho7jf(containerSize);
    var tmp0 = convertToInt(shiftRight(value_2, 32));
    // Inline function 'androidx.compose.ui.unit.IntSize.height' call
    // Inline function 'androidx.compose.ui.util.unpackInt2' call
    var value_3 = _IntSize___get_packedValue__impl__uho7jf(containerSize);
    // Inline function 'kotlin.math.min' call
    var b = convertToInt(bitwiseAnd(value_3, new Long(-1, 0)));
    var tmp_1 = Math.min(tmp0, b);
    // Inline function 'androidx.compose.ui.unit.dp' call
    var tmp$ret$17 = _Dp___init__impl__ms3zkb(450);
    var zRatio = tmp_1 / density.v5e(tmp$ret$17);
    var zWeightedAdjustment = (zRatio + 2) / 3.0;
    var lightZ = density.v5e(get_LIGHT_Z()) * zWeightedAdjustment;
    _this__u8e3s4.t67(lightX, lightY, lightZ, density.v5e(get_LIGHT_RADIUS()), 0.039, 0.19);
    return Unit_instance;
  }
  function _set_isDirty__l4l9oj($this, value) {
    if (!(value === $this.bcx_1)) {
      $this.bcx_1 = value;
      $this.ncw_1.ycq($this, value);
    }
  }
  function triggerRepaint($this) {
    $this.ncw_1.m40();
  }
  function updateOutline($this) {
    var tmp0_elvis_lhs = $this.xcw_1;
    var tmp;
    if (tmp0_elvis_lhs == null) {
      return Unit_instance;
    } else {
      tmp = tmp0_elvis_lhs;
    }
    var outline = tmp;
    setOutline($this.ocw_1, outline);
  }
  function getMatrix($this) {
    updateMatrix_0($this);
    return $this.ycw_1;
  }
  function getInverseMatrix($this) {
    var matrix = getMatrix($this);
    if ($this.ecx_1) {
      return matrix;
    }
    var tmp0_elvis_lhs = $this.zcw_1;
    var tmp;
    var tmp_0 = tmp0_elvis_lhs;
    if ((tmp_0 == null ? null : new Matrix(tmp_0)) == null) {
      // Inline function 'kotlin.also' call
      var this_0 = new Matrix(_Matrix___init__impl__q3kp4w());
      $this.zcw_1 = this_0.e6h_1;
      tmp = this_0.e6h_1;
    } else {
      tmp = tmp0_elvis_lhs;
    }
    var inverseMatrix = tmp;
    if (!$this.dcx_1) {
      var tmp_1;
      // Inline function 'androidx.compose.ui.graphics.Matrix.get' call
      var tmp$ret$2 = _Matrix___get_values__impl__fblr7b(inverseMatrix)[imul(0, 4) + 0 | 0];
      if (isNaN_0(tmp$ret$2)) {
        tmp_1 = null;
      } else {
        tmp_1 = inverseMatrix;
      }
      return tmp_1;
    }
    $this.dcx_1 = false;
    var tmp_2;
    if (invertTo(matrix, inverseMatrix)) {
      tmp_2 = inverseMatrix;
    } else {
      // Inline function 'androidx.compose.ui.graphics.Matrix.set' call
      _Matrix___get_values__impl__fblr7b(inverseMatrix)[imul(0, 4) + 0 | 0] = NaN;
      tmp_2 = null;
    }
    return tmp_2;
  }
  function updateMatrix_0($this) {
    if (!$this.ccx_1)
      return Unit_instance;
    // Inline function 'kotlin.with' call
    var $this$with = $this.ocw_1;
    var pivotX;
    var pivotY;
    // Inline function 'androidx.compose.ui.geometry.isUnspecified' call
    var this_0 = $this$with.m6r_1;
    if (equalsLong(bitwiseAnd(_Offset___get_packedValue__impl__xh2k8q(this_0), new Long(2147483647, 2147483647)), new Long(2143289344, 2143289344))) {
      // Inline function 'androidx.compose.ui.unit.IntSize.width' call
      var this_1 = $this.rcw_1;
      // Inline function 'androidx.compose.ui.util.unpackInt1' call
      var value = _IntSize___get_packedValue__impl__uho7jf(this_1);
      pivotX = convertToInt(shiftRight(value, 32)) / 2.0;
      // Inline function 'androidx.compose.ui.unit.IntSize.height' call
      var this_2 = $this.rcw_1;
      // Inline function 'androidx.compose.ui.util.unpackInt2' call
      var value_0 = _IntSize___get_packedValue__impl__uho7jf(this_2);
      pivotY = convertToInt(bitwiseAnd(value_0, new Long(-1, 0))) / 2.0;
    } else {
      // Inline function 'androidx.compose.ui.geometry.Offset.x' call
      var this_3 = $this$with.m6r_1;
      // Inline function 'androidx.compose.ui.util.unpackFloat1' call
      var value_1 = _Offset___get_packedValue__impl__xh2k8q(this_3);
      // Inline function 'androidx.compose.ui.util.floatFromBits' call
      // Inline function 'kotlin.fromBits' call
      var bits = convertToInt(shiftRight(value_1, 32));
      pivotX = floatFromBits(bits);
      // Inline function 'androidx.compose.ui.geometry.Offset.y' call
      var this_4 = $this$with.m6r_1;
      // Inline function 'androidx.compose.ui.util.unpackFloat2' call
      var value_2 = _Offset___get_packedValue__impl__xh2k8q(this_4);
      // Inline function 'androidx.compose.ui.util.floatFromBits' call
      // Inline function 'kotlin.fromBits' call
      var bits_0 = convertToInt(bitwiseAnd(value_2, new Long(-1, 0)));
      pivotY = floatFromBits(bits_0);
    }
    prepareTransformationMatrix($this.ycw_1, pivotX, pivotY, $this$with.q6r_1, $this$with.r6r_1, $this$with.x6r_1, $this$with.y6r_1, $this$with.z6r_1, $this$with.o6r_1, $this$with.p6r_1, $this$with.a6s_1);
    $this.ccx_1 = false;
    $this.ecx_1 = isIdentity($this.ycw_1);
  }
  function GraphicsLayerOwnerLayer$recordLambda$lambda(this$0) {
    return function (_this__u8e3s4) {
      // Inline function 'androidx.compose.ui.graphics.drawscope.drawIntoCanvas' call
      var canvas = _this__u8e3s4.v6p().x5u();
      var tmp0_safe_receiver = this$0.pcw_1;
      if (tmp0_safe_receiver == null)
        null;
      else {
        // Inline function 'kotlin.let' call
        tmp0_safe_receiver(canvas, _this__u8e3s4.v6p().u6p());
      }
      return Unit_instance;
    };
  }
  function GraphicsLayerOwnerLayer(graphicsLayer, context, layerManager, drawBlock, invalidateParentLayer) {
    this.mcw_1 = context;
    this.ncw_1 = layerManager;
    this.ocw_1 = graphicsLayer;
    this.pcw_1 = drawBlock;
    this.qcw_1 = invalidateParentLayer;
    var tmp = this;
    var tmp0 = 2147483647;
    // Inline function 'androidx.compose.ui.unit.IntSize' call
    // Inline function 'androidx.compose.ui.util.packInts' call
    var val2 = 2147483647;
    var tmp$ret$1 = bitwiseOr(shiftLeft(fromInt(tmp0), 32), bitwiseAnd(fromInt(val2), new Long(-1, 0)));
    tmp.rcw_1 = _IntSize___init__impl__emcjft(tmp$ret$1);
    this.scw_1 = Density_0(1.0);
    this.tcw_1 = LayoutDirection_Ltr_getInstance();
    this.ucw_1 = new CanvasDrawScope();
    this.vcw_1 = 0;
    this.wcw_1 = Companion_getInstance_35().f9i_1;
    this.xcw_1 = null;
    this.ycw_1 = _Matrix___init__impl__q3kp4w();
    this.zcw_1 = null;
    this.acx_1 = false;
    this.bcx_1 = true;
    this.ccx_1 = false;
    this.dcx_1 = false;
    this.ecx_1 = true;
    this.fcx_1 = 0.0;
    this.gcx_1 = false;
    var tmp_0 = this;
    tmp_0.hcx_1 = GraphicsLayerOwnerLayer$recordLambda$lambda(this);
  }
  protoOf(GraphicsLayerOwnerLayer).ebl = function (scope) {
    var maybeChangedFields = scope.m9i_1 | this.vcw_1;
    this.tcw_1 = scope.f9j_1;
    this.scw_1 = scope.e9j_1;
    if (!((maybeChangedFields & 4096) === 0)) {
      this.wcw_1 = scope.z9i_1;
    }
    if (!((maybeChangedFields & 1) === 0)) {
      this.ocw_1.w66(scope.n9i_1);
    }
    if (!((maybeChangedFields & 2) === 0)) {
      this.ocw_1.x66(scope.o9i_1);
    }
    if (!((maybeChangedFields & 4) === 0)) {
      this.ocw_1.v66(scope.p9i_1);
    }
    if (!((maybeChangedFields & 8) === 0)) {
      this.ocw_1.y66(scope.q9i_1);
    }
    if (!((maybeChangedFields & 16) === 0)) {
      this.ocw_1.z66(scope.r9i_1);
    }
    if (!((maybeChangedFields & 32) === 0)) {
      this.ocw_1.a67(scope.s9i_1);
    }
    if (!((maybeChangedFields & 64) === 0)) {
      this.ocw_1.y6z(scope.t9i_1);
    }
    if (!((maybeChangedFields & 128) === 0)) {
      this.ocw_1.z6z(scope.u9i_1);
    }
    if (!((maybeChangedFields & 1024) === 0)) {
      this.ocw_1.f67(scope.x9i_1);
    }
    if (!((maybeChangedFields & 256) === 0)) {
      this.ocw_1.d67(scope.v9i_1);
    }
    if (!((maybeChangedFields & 512) === 0)) {
      this.ocw_1.e67(scope.w9i_1);
    }
    if (!((maybeChangedFields & 2048) === 0)) {
      this.ocw_1.g67(scope.y9i_1);
    }
    if (!((maybeChangedFields & 4096) === 0)) {
      if (equals(this.wcw_1, Companion_getInstance_35().f9i_1)) {
        this.ocw_1.x6z(Companion_getInstance().i5d_1);
      } else {
        var tmp = this.ocw_1;
        var tmp_0 = _TransformOrigin___get_pivotFractionX__impl__a9pmci(this.wcw_1);
        // Inline function 'androidx.compose.ui.unit.IntSize.width' call
        var this_0 = this.rcw_1;
        // Inline function 'androidx.compose.ui.util.unpackInt1' call
        var value = _IntSize___get_packedValue__impl__uho7jf(this_0);
        var tmp0 = tmp_0 * convertToInt(shiftRight(value, 32));
        var tmp_1 = _TransformOrigin___get_pivotFractionY__impl__ijwupp(this.wcw_1);
        // Inline function 'androidx.compose.ui.unit.IntSize.height' call
        var this_1 = this.rcw_1;
        // Inline function 'androidx.compose.ui.util.unpackInt2' call
        var value_0 = _IntSize___get_packedValue__impl__uho7jf(this_1);
        // Inline function 'androidx.compose.ui.geometry.Offset' call
        // Inline function 'androidx.compose.ui.util.packFloats' call
        var val2 = tmp_1 * convertToInt(bitwiseAnd(value_0, new Long(-1, 0)));
        var v1 = fromInt(toRawBits(tmp0));
        var v2 = fromInt(toRawBits(val2));
        var tmp$ret$5 = bitwiseOr(shiftLeft(v1, 32), bitwiseAnd(v2, new Long(-1, 0)));
        var tmp$ret$4 = _Offset___init__impl__c168vi(tmp$ret$5);
        tmp.x6z(tmp$ret$4);
      }
    }
    if (!((maybeChangedFields & 16384) === 0)) {
      this.ocw_1.n67(scope.b9j_1);
    }
    if (!((maybeChangedFields & 131072) === 0)) {
      this.ocw_1.a70(scope.g9j_1);
    }
    if (!((maybeChangedFields & 262144) === 0)) {
      this.ocw_1.z6o(scope.h9j_1);
    }
    if (!((maybeChangedFields & 524288) === 0)) {
      this.ocw_1.b6p(scope.i9j_1);
    }
    if (!((maybeChangedFields & 32768) === 0)) {
      var tmp_2 = this.ocw_1;
      var tmp0_subject = scope.c9j_1;
      var tmp_3;
      if (tmp0_subject === Companion_getInstance_34().g9i_1) {
        tmp_3 = Companion_getInstance_17().l6s_1;
      } else if (tmp0_subject === Companion_getInstance_34().h9i_1) {
        tmp_3 = Companion_getInstance_17().m6s_1;
      } else if (tmp0_subject === Companion_getInstance_34().i9i_1) {
        tmp_3 = Companion_getInstance_17().n6s_1;
      } else {
        throw IllegalStateException_init_$Create$('Not supported composition strategy');
      }
      tmp_2.v6z(tmp_3);
    }
    if (!((maybeChangedFields & 7963) === 0)) {
      this.ccx_1 = true;
      this.dcx_1 = true;
    }
    var outlineChanged = false;
    if (!equals(this.xcw_1, scope.j9j_1)) {
      outlineChanged = true;
      this.xcw_1 = scope.j9j_1;
      updateOutline(this);
    }
    this.vcw_1 = scope.m9i_1;
    if (!(maybeChangedFields === 0) || outlineChanged) {
      triggerRepaint(this);
      this.ncw_1.rbk(this.fcx_1);
    }
  };
  protoOf(GraphicsLayerOwnerLayer).qbl = function (position) {
    // Inline function 'androidx.compose.ui.geometry.Offset.x' call
    // Inline function 'androidx.compose.ui.util.unpackFloat1' call
    var value = _Offset___get_packedValue__impl__xh2k8q(position);
    // Inline function 'androidx.compose.ui.util.floatFromBits' call
    // Inline function 'kotlin.fromBits' call
    var bits = convertToInt(shiftRight(value, 32));
    var x = floatFromBits(bits);
    // Inline function 'androidx.compose.ui.geometry.Offset.y' call
    // Inline function 'androidx.compose.ui.util.unpackFloat2' call
    var value_0 = _Offset___get_packedValue__impl__xh2k8q(position);
    // Inline function 'androidx.compose.ui.util.floatFromBits' call
    // Inline function 'kotlin.fromBits' call
    var bits_0 = convertToInt(bitwiseAnd(value_0, new Long(-1, 0)));
    var y = floatFromBits(bits_0);
    if (this.ocw_1.b6s_1) {
      return isInOutline(this.ocw_1.u6z(), x, y);
    }
    return true;
  };
  protoOf(GraphicsLayerOwnerLayer).qbk = function (position) {
    this.ncw_1.rbk(_FrameRateCategory___get_value__impl__e037z6(Companion_getInstance_26().l8v_1));
    this.ocw_1.w6z(position);
    triggerRepaint(this);
  };
  protoOf(GraphicsLayerOwnerLayer).pbk = function (size) {
    if (!equals(size, this.rcw_1)) {
      this.ncw_1.rbk(_FrameRateCategory___get_value__impl__e037z6(Companion_getInstance_26().l8v_1));
      this.rcw_1 = size;
      this.m40();
    }
  };
  protoOf(GraphicsLayerOwnerLayer).ibl = function (canvas, parentLayer) {
    this.acr();
    // Inline function 'kotlin.also' call
    var this_0 = this.ucw_1.i6o_1;
    this_0.n6p(canvas);
    this_0.t6p(parentLayer);
    drawLayer(this.ucw_1, this.ocw_1);
  };
  protoOf(GraphicsLayerOwnerLayer).acr = function () {
    this.ncw_1.rbk(this.fcx_1);
    if (this.bcx_1) {
      if (!equals(this.wcw_1, Companion_getInstance_35().f9i_1) && !equals(this.ocw_1.l6r_1, this.rcw_1)) {
        var tmp = this.ocw_1;
        var tmp_0 = _TransformOrigin___get_pivotFractionX__impl__a9pmci(this.wcw_1);
        // Inline function 'androidx.compose.ui.unit.IntSize.width' call
        var this_0 = this.rcw_1;
        // Inline function 'androidx.compose.ui.util.unpackInt1' call
        var value = _IntSize___get_packedValue__impl__uho7jf(this_0);
        var tmp0 = tmp_0 * convertToInt(shiftRight(value, 32));
        var tmp_1 = _TransformOrigin___get_pivotFractionY__impl__ijwupp(this.wcw_1);
        // Inline function 'androidx.compose.ui.unit.IntSize.height' call
        var this_1 = this.rcw_1;
        // Inline function 'androidx.compose.ui.util.unpackInt2' call
        var value_0 = _IntSize___get_packedValue__impl__uho7jf(this_1);
        // Inline function 'androidx.compose.ui.geometry.Offset' call
        // Inline function 'androidx.compose.ui.util.packFloats' call
        var val2 = tmp_1 * convertToInt(bitwiseAnd(value_0, new Long(-1, 0)));
        var v1 = fromInt(toRawBits(tmp0));
        var v2 = fromInt(toRawBits(val2));
        var tmp$ret$5 = bitwiseOr(shiftLeft(v1, 32), bitwiseAnd(v2, new Long(-1, 0)));
        var tmp$ret$4 = _Offset___init__impl__c168vi(tmp$ret$5);
        tmp.x6z(tmp$ret$4);
      }
      this.ocw_1.e6s(this.scw_1, this.tcw_1, this.rcw_1, this.hcx_1);
      _set_isDirty__l4l9oj(this, false);
    }
  };
  protoOf(GraphicsLayerOwnerLayer).m40 = function () {
    if (this.acx_1)
      return Unit_instance;
    _set_isDirty__l4l9oj(this, true);
    this.ncw_1.m40();
  };
  protoOf(GraphicsLayerOwnerLayer).kbl = function () {
    this.fcx_1 = 0.0;
    this.gcx_1 = false;
    this.pcw_1 = null;
    this.qcw_1 = null;
    this.acx_1 = true;
    _set_isDirty__l4l9oj(this, false);
    if (!(this.mcw_1 == null)) {
      this.mcw_1.n6z(this.ocw_1);
      this.ncw_1.xcq(this);
    }
  };
  protoOf(GraphicsLayerOwnerLayer).pbl = function (point, inverse) {
    var tmp;
    if (inverse) {
      var tmp0_elvis_lhs = getInverseMatrix(this);
      var tmp_0;
      var tmp_1 = tmp0_elvis_lhs;
      if ((tmp_1 == null ? null : new Matrix(tmp_1)) == null) {
        return Companion_getInstance().h5d_1;
      } else {
        tmp_0 = tmp0_elvis_lhs;
      }
      tmp = tmp_0;
    } else {
      tmp = getMatrix(this);
    }
    var matrix = tmp;
    var tmp_2;
    if (this.ecx_1) {
      tmp_2 = point;
    } else {
      tmp_2 = Matrix__map_impl_7meu7m_0(matrix, point);
    }
    return tmp_2;
  };
  protoOf(GraphicsLayerOwnerLayer).hbl = function (rect, inverse) {
    var matrix = inverse ? getInverseMatrix(this) : getMatrix(this);
    if (!this.ecx_1) {
      var tmp = matrix;
      if ((tmp == null ? null : new Matrix(tmp)) == null) {
        rect.d5d(0.0, 0.0, 0.0, 0.0);
      } else {
        Matrix__map_impl_7meu7m(matrix, rect);
      }
    }
  };
  protoOf(GraphicsLayerOwnerLayer).z6i = function (matrix) {
    Matrix__timesAssign_impl_oas521(matrix, getMatrix(this));
  };
  protoOf(GraphicsLayerOwnerLayer).jbl = function () {
    return getMatrix(this);
  };
  protoOf(GraphicsLayerOwnerLayer).gbl = function (matrix) {
    var inverse = getInverseMatrix(this);
    var tmp = inverse;
    if (!((tmp == null ? null : new Matrix(tmp)) == null)) {
      Matrix__timesAssign_impl_oas521(matrix, inverse);
    }
  };
  var properties_initialized_GraphicsLayerOwnerLayer_skiko_kt_jol1np;
  function _init_properties_GraphicsLayerOwnerLayer_skiko_kt__18k61z() {
    if (!properties_initialized_GraphicsLayerOwnerLayer_skiko_kt_jol1np) {
      properties_initialized_GraphicsLayerOwnerLayer_skiko_kt_jol1np = true;
      // Inline function 'androidx.compose.ui.unit.dp' call
      LIGHT_Y = _Dp___init__impl__ms3zkb(0);
      // Inline function 'androidx.compose.ui.unit.dp' call
      LIGHT_Z = _Dp___init__impl__ms3zkb(500);
      // Inline function 'androidx.compose.ui.unit.dp' call
      LIGHT_RADIUS = _Dp___init__impl__ms3zkb(800);
      androidx_compose_ui_platform_GraphicsLayerOwnerLayer$stable = 8;
    }
  }
  var androidx_compose_ui_platform_LegacyRenderNodeLayer$stable;
  function _get_inverseMatrix__z2089s($this) {
    // Inline function 'kotlin.apply' call
    var this_0 = new Matrix(_Matrix___init__impl__q3kp4w());
    var $this$apply = this_0.e6h_1;
    invertTo($this.qcx_1, $this$apply);
    return this_0.e6h_1;
  }
  function updateMatrix_1($this) {
    var tmp = _TransformOrigin___get_pivotFractionX__impl__a9pmci($this.ycx_1);
    // Inline function 'androidx.compose.ui.unit.IntSize.width' call
    var this_0 = $this.ncx_1;
    // Inline function 'androidx.compose.ui.util.unpackInt1' call
    var value = _IntSize___get_packedValue__impl__uho7jf(this_0);
    var pivotX = tmp * convertToInt(shiftRight(value, 32));
    var tmp_0 = _TransformOrigin___get_pivotFractionY__impl__ijwupp($this.ycx_1);
    // Inline function 'androidx.compose.ui.unit.IntSize.height' call
    var this_1 = $this.ncx_1;
    // Inline function 'androidx.compose.ui.util.unpackInt2' call
    var value_0 = _IntSize___get_packedValue__impl__uho7jf(this_1);
    var pivotY = tmp_0 * convertToInt(bitwiseAnd(value_0, new Long(-1, 0)));
    prepareTransformationMatrix($this.qcx_1, pivotX, pivotY, $this.zcx_1, $this.acy_1, $this.bcy_1, $this.ccy_1, $this.dcy_1, $this.fcy_1, $this.gcy_1, $this.ecy_1);
  }
  function performDrawLayer($this, canvas, bounds) {
    if ($this.hcy_1 > 0) {
      if ($this.kcy_1 > 0) {
        $this.pcy(canvas);
      }
      var outline = $this.pcx_1;
      var tmp;
      if ($this.icy_1 && !(outline == null)) {
        canvas.t6d();
        if (outline instanceof Rectangle) {
          canvas.e6e(outline.s6h_1.k5d_1, outline.s6h_1.l5d_1, outline.s6h_1.m5d_1, outline.s6h_1.n5d_1);
        } else {
          if (outline instanceof Rounded) {
            var antiAlias = true;
            var tmp_0 = get_skiaCanvas(canvas);
            // Inline function 'androidx.compose.ui.geometry.CornerRadius.x' call
            var this_0 = outline.t6h_1.b5e_1;
            // Inline function 'androidx.compose.ui.util.unpackFloat1' call
            var value = _CornerRadius___get_packedValue__impl__okv4jq(this_0);
            // Inline function 'androidx.compose.ui.util.floatFromBits' call
            // Inline function 'kotlin.fromBits' call
            var bits = convertToInt(shiftRight(value, 32));
            var tmp_1 = floatFromBits(bits);
            // Inline function 'androidx.compose.ui.geometry.CornerRadius.y' call
            var this_1 = outline.t6h_1.b5e_1;
            // Inline function 'androidx.compose.ui.util.unpackFloat2' call
            var value_0 = _CornerRadius___get_packedValue__impl__okv4jq(this_1);
            // Inline function 'androidx.compose.ui.util.floatFromBits' call
            // Inline function 'kotlin.fromBits' call
            var bits_0 = convertToInt(bitwiseAnd(value_0, new Long(-1, 0)));
            var tmp_2 = floatFromBits(bits_0);
            // Inline function 'androidx.compose.ui.geometry.CornerRadius.x' call
            var this_2 = outline.t6h_1.c5e_1;
            // Inline function 'androidx.compose.ui.util.unpackFloat1' call
            var value_1 = _CornerRadius___get_packedValue__impl__okv4jq(this_2);
            // Inline function 'androidx.compose.ui.util.floatFromBits' call
            // Inline function 'kotlin.fromBits' call
            var bits_1 = convertToInt(shiftRight(value_1, 32));
            var tmp_3 = floatFromBits(bits_1);
            // Inline function 'androidx.compose.ui.geometry.CornerRadius.y' call
            var this_3 = outline.t6h_1.c5e_1;
            // Inline function 'androidx.compose.ui.util.unpackFloat2' call
            var value_2 = _CornerRadius___get_packedValue__impl__okv4jq(this_3);
            // Inline function 'androidx.compose.ui.util.floatFromBits' call
            // Inline function 'kotlin.fromBits' call
            var bits_2 = convertToInt(bitwiseAnd(value_2, new Long(-1, 0)));
            var tmp_4 = floatFromBits(bits_2);
            // Inline function 'androidx.compose.ui.geometry.CornerRadius.x' call
            var this_4 = outline.t6h_1.d5e_1;
            // Inline function 'androidx.compose.ui.util.unpackFloat1' call
            var value_3 = _CornerRadius___get_packedValue__impl__okv4jq(this_4);
            // Inline function 'androidx.compose.ui.util.floatFromBits' call
            // Inline function 'kotlin.fromBits' call
            var bits_3 = convertToInt(shiftRight(value_3, 32));
            var tmp_5 = floatFromBits(bits_3);
            // Inline function 'androidx.compose.ui.geometry.CornerRadius.y' call
            var this_5 = outline.t6h_1.d5e_1;
            // Inline function 'androidx.compose.ui.util.unpackFloat2' call
            var value_4 = _CornerRadius___get_packedValue__impl__okv4jq(this_5);
            // Inline function 'androidx.compose.ui.util.floatFromBits' call
            // Inline function 'kotlin.fromBits' call
            var bits_4 = convertToInt(bitwiseAnd(value_4, new Long(-1, 0)));
            var tmp_6 = floatFromBits(bits_4);
            // Inline function 'androidx.compose.ui.geometry.CornerRadius.x' call
            var this_6 = outline.t6h_1.e5e_1;
            // Inline function 'androidx.compose.ui.util.unpackFloat1' call
            var value_5 = _CornerRadius___get_packedValue__impl__okv4jq(this_6);
            // Inline function 'androidx.compose.ui.util.floatFromBits' call
            // Inline function 'kotlin.fromBits' call
            var bits_5 = convertToInt(shiftRight(value_5, 32));
            var tmp_7 = floatFromBits(bits_5);
            // Inline function 'androidx.compose.ui.geometry.CornerRadius.y' call
            var this_7 = outline.t6h_1.e5e_1;
            // Inline function 'androidx.compose.ui.util.unpackFloat2' call
            var value_6 = _CornerRadius___get_packedValue__impl__okv4jq(this_7);
            // Inline function 'androidx.compose.ui.util.floatFromBits' call
            // Inline function 'kotlin.fromBits' call
            var bits_6 = convertToInt(bitwiseAnd(value_6, new Long(-1, 0)));
            var tmp$ret$28 = floatFromBits(bits_6);
            // Inline function 'kotlin.floatArrayOf' call
            var tmp$ret$32 = new Float32Array([tmp_1, tmp_2, tmp_3, tmp_4, tmp_5, tmp_6, tmp_7, tmp$ret$28]);
            tmp_0.a5l(outline.t6h_1.x5d_1, outline.t6h_1.y5d_1, outline.t6h_1.z5d_1, outline.t6h_1.a5e_1, tmp$ret$32, ClipMode_INTERSECT_getInstance(), antiAlias);
          } else {
            if (outline instanceof Generic) {
              canvas.g6e(outline.w6h_1);
            } else {
              noWhenBranchMatchedException();
            }
          }
        }
        tmp = true;
      } else {
        tmp = false;
      }
      var isClipping = tmp;
      var currentRenderEffect = $this.jcy_1;
      var requiresLayer = $this.hcy_1 < 1 && !($this.ncy_1 === Companion_getInstance_34().i9i_1) || !(currentRenderEffect == null) || $this.ncy_1 === Companion_getInstance_34().h9i_1;
      if (requiresLayer) {
        // Inline function 'kotlin.apply' call
        var this_8 = Paint();
        this_8.v66($this.hcy_1);
        var tmp_8 = get_skiaPaint(this_8);
        tmp_8.q5r(currentRenderEffect == null ? null : get_skiaImageFilter(currentRenderEffect));
        canvas.v6d(bounds, this_8);
      } else {
        canvas.t6d();
      }
      var tmp_9;
      if ($this.ncy_1 === Companion_getInstance_34().i9i_1) {
        tmp_9 = $this.hcy_1;
      } else {
        tmp_9 = 1.0;
      }
      set_alphaMultiplier(canvas, tmp_9);
      $this.mcx_1(canvas, null);
      canvas.u6d();
      if (isClipping) {
        canvas.u6d();
      }
    }
  }
  function LegacyRenderNodeLayer$drawState$1() {
  }
  protoOf(LegacyRenderNodeLayer$drawState$1).qcy = function (a, b) {
    return false;
  };
  protoOf(LegacyRenderNodeLayer$drawState$1).w3e = function (a, b) {
    var tmp = a instanceof Unit ? a : THROW_CCE();
    return this.qcy(tmp, b instanceof Unit ? b : THROW_CCE());
  };
  protoOf(LegacyRenderNodeLayer$drawState$1).rcy = function (previous, current, applied) {
    return current;
  };
  protoOf(LegacyRenderNodeLayer$drawState$1).p49 = function (previous, current, applied) {
    var tmp = previous instanceof Unit ? previous : THROW_CCE();
    var tmp_0 = current instanceof Unit ? current : THROW_CCE();
    this.rcy(tmp, tmp_0, applied instanceof Unit ? applied : THROW_CCE());
    return Unit_instance;
  };
  function LegacyRenderNodeLayer(density, measureDrawBounds, layerManager, requiresStateWorkaround, invalidateParentLayer, drawBlock) {
    this.icx_1 = density;
    this.jcx_1 = layerManager;
    this.kcx_1 = requiresStateWorkaround;
    this.lcx_1 = invalidateParentLayer;
    this.mcx_1 = drawBlock;
    this.ncx_1 = Companion_getInstance_0().n5g_1;
    this.ocx_1 = Companion_getInstance_11().c5g_1;
    this.pcx_1 = null;
    this.qcx_1 = _Matrix___init__impl__q3kp4w();
    this.rcx_1 = PictureRecorder_init_$Create$();
    this.scx_1 = measureDrawBounds ? RTreeFactory_init_$Create$() : null;
    this.tcx_1 = null;
    this.ucx_1 = false;
    this.vcx_1 = 0.0;
    this.wcx_1 = false;
    var tmp = this;
    tmp.xcx_1 = mutableStateOf(Unit_instance, new LegacyRenderNodeLayer$drawState$1());
    this.ycx_1 = Companion_getInstance_35().f9i_1;
    this.zcx_1 = 0.0;
    this.acy_1 = 0.0;
    this.bcy_1 = 0.0;
    this.ccy_1 = 0.0;
    this.dcy_1 = 0.0;
    this.ecy_1 = 8.0;
    this.fcy_1 = 1.0;
    this.gcy_1 = 1.0;
    this.hcy_1 = 1.0;
    this.icy_1 = false;
    this.jcy_1 = null;
    this.kcy_1 = 0.0;
    this.lcy_1 = get_DefaultShadowColor();
    this.mcy_1 = get_DefaultShadowColor();
    this.ncy_1 = Companion_getInstance_34().g9i_1;
    this.ocy_1 = 0;
  }
  protoOf(LegacyRenderNodeLayer).kbl = function () {
    var tmp0_safe_receiver = this.tcx_1;
    if (tmp0_safe_receiver == null)
      null;
    else {
      tmp0_safe_receiver.j4();
    }
    this.rcx_1.j4();
    this.ucx_1 = true;
    this.jcx_1.xcq(this);
  };
  protoOf(LegacyRenderNodeLayer).pbk = function (size) {
    if (!equals(size, this.ncx_1)) {
      this.jcx_1.rbk(_FrameRateCategory___get_value__impl__e037z6(Companion_getInstance_26().l8v_1));
      this.ncx_1 = size;
      updateMatrix_1(this);
      this.m40();
    }
  };
  protoOf(LegacyRenderNodeLayer).qbk = function (position) {
    this.jcx_1.rbk(_FrameRateCategory___get_value__impl__e037z6(Companion_getInstance_26().l8v_1));
    if (!equals(position, this.ocx_1)) {
      this.ocx_1 = position;
      this.lcx_1();
      this.jcx_1.m40();
    }
  };
  protoOf(LegacyRenderNodeLayer).pbl = function (point, inverse) {
    var tmp;
    if (inverse) {
      tmp = _get_inverseMatrix__z2089s(this);
    } else {
      tmp = this.qcx_1;
    }
    return Matrix__map_impl_7meu7m_0(tmp, point);
  };
  protoOf(LegacyRenderNodeLayer).hbl = function (rect, inverse) {
    var tmp;
    if (inverse) {
      tmp = _get_inverseMatrix__z2089s(this);
    } else {
      tmp = this.qcx_1;
    }
    Matrix__map_impl_7meu7m(tmp, rect);
  };
  protoOf(LegacyRenderNodeLayer).qbl = function (position) {
    if (!this.icy_1) {
      return true;
    }
    // Inline function 'androidx.compose.ui.geometry.Offset.x' call
    // Inline function 'androidx.compose.ui.util.unpackFloat1' call
    var value = _Offset___get_packedValue__impl__xh2k8q(position);
    // Inline function 'androidx.compose.ui.util.floatFromBits' call
    // Inline function 'kotlin.fromBits' call
    var bits = convertToInt(shiftRight(value, 32));
    var x = floatFromBits(bits);
    // Inline function 'androidx.compose.ui.geometry.Offset.y' call
    // Inline function 'androidx.compose.ui.util.unpackFloat2' call
    var value_0 = _Offset___get_packedValue__impl__xh2k8q(position);
    // Inline function 'androidx.compose.ui.util.floatFromBits' call
    // Inline function 'kotlin.fromBits' call
    var bits_0 = convertToInt(bitwiseAnd(value_0, new Long(-1, 0)));
    var y = floatFromBits(bits_0);
    var tmp0_elvis_lhs = this.pcx_1;
    var tmp;
    if (tmp0_elvis_lhs == null) {
      return true;
    } else {
      tmp = tmp0_elvis_lhs;
    }
    var outline = tmp;
    return isInOutline(outline, x, y);
  };
  protoOf(LegacyRenderNodeLayer).ebl = function (scope) {
    var maybeChangedFields = scope.m9i_1 | this.ocy_1;
    this.ycx_1 = scope.z9i_1;
    this.zcx_1 = scope.q9i_1;
    this.acy_1 = scope.r9i_1;
    this.bcy_1 = scope.v9i_1;
    this.ccy_1 = scope.w9i_1;
    this.dcy_1 = scope.x9i_1;
    var tmp = this;
    // Inline function 'kotlin.math.max' call
    var a = scope.y9i_1;
    tmp.ecy_1 = Math.max(a, 0.001);
    this.fcy_1 = scope.n9i_1;
    this.gcy_1 = scope.o9i_1;
    this.hcy_1 = scope.p9i_1;
    this.icy_1 = scope.b9j_1;
    this.kcy_1 = scope.s9i_1;
    this.icx_1 = scope.e9j_1;
    this.jcy_1 = scope.g9j_1;
    this.lcy_1 = scope.t9i_1;
    this.mcy_1 = scope.u9i_1;
    this.ncy_1 = scope.c9j_1;
    this.pcx_1 = scope.j9j_1;
    if (!((maybeChangedFields & 7963) === 0)) {
      updateMatrix_1(this);
    }
    this.ocy_1 = scope.m9i_1;
    this.m40();
    this.jcx_1.rbk(this.vcx_1);
  };
  protoOf(LegacyRenderNodeLayer).m40 = function () {
    if (!this.ucx_1 && !(this.tcx_1 == null)) {
      var tmp0_safe_receiver = this.tcx_1;
      if (tmp0_safe_receiver == null)
        null;
      else {
        tmp0_safe_receiver.j4();
      }
      this.tcx_1 = null;
    }
    if (this.kcx_1()) {
      this.xcx_1.s21(Unit_instance);
    }
    this.lcx_1();
    this.jcx_1.m40();
  };
  protoOf(LegacyRenderNodeLayer).ibl = function (canvas, parentLayer) {
    if (this.kcx_1() && !(parentLayer == null)) {
      this.xcx_1.u1();
    }
    this.jcx_1.rbk(this.vcx_1);
    if (this.tcx_1 == null) {
      var measureDrawBounds = !this.icy_1 || this.kcy_1 > 0;
      // Inline function 'androidx.compose.ui.unit.toRect' call
      var this_0 = this.ncx_1;
      // Inline function 'androidx.compose.ui.unit.IntSize.width' call
      // Inline function 'androidx.compose.ui.util.unpackInt1' call
      var value = _IntSize___get_packedValue__impl__uho7jf(this_0);
      var tmp = convertToInt(shiftRight(value, 32));
      // Inline function 'androidx.compose.ui.unit.IntSize.height' call
      // Inline function 'androidx.compose.ui.util.unpackInt2' call
      var value_0 = _IntSize___get_packedValue__impl__uho7jf(this_0);
      var tmp$ret$3 = convertToInt(bitwiseAnd(value_0, new Long(-1, 0)));
      var bounds = new Rect(0.0, 0.0, tmp, tmp$ret$3);
      var pictureCanvas = this.rcx_1.t5t(measureDrawBounds ? -1.0737418E9 : bounds.k5d_1, measureDrawBounds ? -1.0737418E9 : bounds.l5d_1, measureDrawBounds ? 1.0737418E9 : bounds.m5d_1, measureDrawBounds ? 1.0737418E9 : bounds.n5d_1, measureDrawBounds ? this.scx_1 : null);
      performDrawLayer(this, asComposeCanvas(pictureCanvas), bounds);
      this.tcx_1 = this.rcx_1.u5t();
    }
    canvas.t6d();
    canvas.y6d(this.qcx_1);
    canvas.b5d(_IntOffset___get_x__impl__qiqr5o(this.ocx_1), _IntOffset___get_y__impl__2avpwj(this.ocx_1));
    get_skiaCanvas(canvas).w5k(ensureNotNull(this.tcx_1), null, null);
    canvas.u6d();
  };
  protoOf(LegacyRenderNodeLayer).z6i = function (matrix) {
    Matrix__timesAssign_impl_oas521(matrix, this.qcx_1);
  };
  protoOf(LegacyRenderNodeLayer).jbl = function () {
    return this.qcx_1;
  };
  protoOf(LegacyRenderNodeLayer).gbl = function (matrix) {
    Matrix__timesAssign_impl_oas521(matrix, _get_inverseMatrix__z2089s(this));
  };
  protoOf(LegacyRenderNodeLayer).acr = function () {
    return Unit_instance;
  };
  protoOf(LegacyRenderNodeLayer).pcy = function (canvas) {
    // Inline function 'kotlin.with' call
    var $this$with = this.icx_1;
    var outline = this.pcx_1;
    var tmp;
    if (outline instanceof Rectangle) {
      // Inline function 'kotlin.apply' call
      var this_0 = Path();
      this_0.d6i(outline.s6h_1);
      tmp = this_0;
    } else {
      if (outline instanceof Rounded) {
        // Inline function 'kotlin.apply' call
        var this_1 = Path();
        this_1.v6h(outline.t6h_1);
        tmp = this_1;
      } else {
        if (outline instanceof Generic) {
          tmp = outline.w6h_1;
        } else {
          return Unit_instance;
        }
      }
    }
    var path = tmp;
    var zParams = new Point3(0.0, 0.0, this.kcy_1);
    // Inline function 'androidx.compose.ui.unit.dp' call
    var tmp$ret$6 = _Dp___init__impl__ms3zkb(300);
    var tmp_0 = -$this$with.v5e(tmp$ret$6);
    // Inline function 'androidx.compose.ui.unit.dp' call
    var tmp$ret$7 = _Dp___init__impl__ms3zkb(600);
    var lightPos = new Point3(0.0, tmp_0, $this$with.v5e(tmp$ret$7));
    // Inline function 'androidx.compose.ui.unit.dp' call
    var tmp$ret$8 = _Dp___init__impl__ms3zkb(800);
    var lightRad = $this$with.v5e(tmp$ret$8);
    var ambientAlpha = 0.039 * this.hcy_1;
    var spotAlpha = 0.19 * this.hcy_1;
    var ambientColor = Color__copy$default_impl_ectz3s(this.lcy_1, ambientAlpha);
    var spotColor = Color__copy$default_impl_ectz3s(this.mcy_1, spotAlpha);
    ShadowUtils_getInstance().m5u(get_skiaCanvas(canvas), materializeSkiaPath(path), zParams, lightPos, lightRad, toArgb(ambientColor), toArgb(spotColor), this.hcy_1 < 1.0, false);
    return Unit_instance;
  };
  function OwnedLayerManager() {
  }
  var androidx_compose_ui_platform_ClipMetadata$stable;
  function get_EmptyArchitectureComponentsOwner() {
    _init_properties_PlatformContext_skiko_kt__bv8xht();
    return EmptyArchitectureComponentsOwner;
  }
  var EmptyArchitectureComponentsOwner;
  var androidx_compose_ui_platform_PlatformContext_Empty$stable;
  var androidx_compose_ui_platform_PlatformContext_DefaultViewConfiguration$stable;
  var androidx_compose_ui_platform_PlatformContext_EmptyFocusManager$stable;
  var androidx_compose_ui_platform_DefaultInputModeManager$stable;
  var androidx_compose_ui_platform_DelegateRootForTestListener$stable;
  function Empty() {
    var tmp = this;
    // Inline function 'kotlin.apply' call
    var this_0 = new WindowInfoImpl();
    this_0.gbr(true);
    tmp.scy_1 = this_0;
    this.tcy_1 = new DefaultInputModeManager();
  }
  protoOf(Empty).hbm = function () {
    return this.scy_1;
  };
  protoOf(Empty).xbl = function () {
    return this.tcy_1;
  };
  function DefaultViewConfiguration() {
    DefaultViewConfiguration_instance = this;
    this.wcy_1 = new Long(500, 0);
    this.xcy_1 = new Long(300, 0);
    this.ycy_1 = new Long(40, 0);
    this.zcy_1 = 18.0;
  }
  protoOf(DefaultViewConfiguration).rb9 = function () {
    return this.wcy_1;
  };
  protoOf(DefaultViewConfiguration).sb9 = function () {
    return this.xcy_1;
  };
  protoOf(DefaultViewConfiguration).tb9 = function () {
    return this.ycy_1;
  };
  protoOf(DefaultViewConfiguration).ub9 = function () {
    return this.zcy_1;
  };
  var DefaultViewConfiguration_instance;
  function DefaultViewConfiguration_getInstance() {
    if (DefaultViewConfiguration_instance == null)
      new DefaultViewConfiguration();
    return DefaultViewConfiguration_instance;
  }
  function EmptyFocusManager() {
  }
  protoOf(EmptyFocusManager).d9d = function (force) {
    return Unit_instance;
  };
  protoOf(EmptyFocusManager).f9d = function (focusDirection) {
    return false;
  };
  var EmptyFocusManager_instance;
  function EmptyFocusManager_getInstance() {
    return EmptyFocusManager_instance;
  }
  function $startInputMethodCOROUTINE$_1(_this__u8e3s4, request, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.icz_1 = _this__u8e3s4;
    this.jcz_1 = request;
  }
  protoOf($startInputMethodCOROUTINE$_1).v9 = function () {
    var suspendResult = this.p9_1;
    $sm: do
      try {
        var tmp = this.n9_1;
        switch (tmp) {
          case 0:
            this.o9_1 = 2;
            this.n9_1 = 1;
            suspendResult = awaitCancellation(this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            throwKotlinNothingValueException();
            break;
          case 2:
            throw this.q9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.o9_1 === 2) {
          throw e;
        } else {
          this.n9_1 = this.o9_1;
          this.q9_1 = e;
        }
      }
     while (true);
  };
  function PlatformContext() {
  }
  function EmptyPlatformScreenReader() {
    this.kcz_1 = false;
  }
  var EmptyPlatformScreenReader_instance;
  function EmptyPlatformScreenReader_getInstance() {
    return EmptyPlatformScreenReader_instance;
  }
  function EmptyPlatformTextInputService() {
  }
  protoOf(EmptyPlatformTextInputService).a8d = function (value, imeOptions, onEditCommand, onImeActionPerformed) {
    return Unit_instance;
  };
  protoOf(EmptyPlatformTextInputService).d8d = function () {
    return Unit_instance;
  };
  protoOf(EmptyPlatformTextInputService).e8d = function () {
    return Unit_instance;
  };
  protoOf(EmptyPlatformTextInputService).f8d = function () {
    return Unit_instance;
  };
  protoOf(EmptyPlatformTextInputService).l8d = function (oldValue, newValue) {
    return Unit_instance;
  };
  var EmptyPlatformTextInputService_instance;
  function EmptyPlatformTextInputService_getInstance() {
    return EmptyPlatformTextInputService_instance;
  }
  function EmptyTextToolbar() {
    EmptyTextToolbar_instance = this;
    this.lcz_1 = TextToolbarStatus_Hidden_getInstance();
  }
  protoOf(EmptyTextToolbar).wbq = function () {
    return Unit_instance;
  };
  protoOf(EmptyTextToolbar).zbq = function () {
    return this.lcz_1;
  };
  protoOf(EmptyTextToolbar).ybq = function (rect, onCopyRequested, onPasteRequested, onCutRequested, onSelectAllRequested) {
    return Unit_instance;
  };
  var EmptyTextToolbar_instance;
  function EmptyTextToolbar_getInstance() {
    if (EmptyTextToolbar_instance == null)
      new EmptyTextToolbar();
    return EmptyTextToolbar_instance;
  }
  function EmptyDragAndDropManager() {
  }
  var EmptyDragAndDropManager_instance;
  function EmptyDragAndDropManager_getInstance() {
    return EmptyDragAndDropManager_instance;
  }
  function DefaultInputModeManager$_get_inputMode_$ref_s796mo() {
    return constructCallableReference(function (p0) {
      return new InputMode(p0.ncz());
    }, 1, 0, 147);
  }
  function DefaultInputModeManager$_set_inputMode_$ref_rm3cu4() {
    return constructCallableReference(function (p0, p1) {
      p0.ocz(p1.c9u_1);
      return Unit_instance;
    }, 2, 0, 148);
  }
  function DefaultInputModeManager(initialInputMode) {
    initialInputMode = initialInputMode === VOID ? Companion_getInstance_38().b9u_1 : initialInputMode;
    this.mcz_1 = mutableStateOf(new InputMode(initialInputMode));
  }
  protoOf(DefaultInputModeManager).ocz = function (_set____db54di) {
    var tmp0 = this.mcz_1;
    var tmp = KMutableProperty1;
    var tmp_0 = DefaultInputModeManager$_get_inputMode_$ref_s796mo();
    getPropertyCallableRef('inputMode', 1, tmp, tmp_0, DefaultInputModeManager$_set_inputMode_$ref_rm3cu4());
    // Inline function 'androidx.compose.runtime.setValue' call
    var value = new InputMode(_set____db54di);
    tmp0.s21(value);
    return Unit_instance;
  };
  protoOf(DefaultInputModeManager).ncz = function () {
    var tmp0 = this.mcz_1;
    var tmp = KMutableProperty1;
    var tmp_0 = DefaultInputModeManager$_get_inputMode_$ref_s796mo();
    // Inline function 'androidx.compose.runtime.getValue' call
    getPropertyCallableRef('inputMode', 1, tmp, tmp_0, DefaultInputModeManager$_set_inputMode_$ref_rm3cu4());
    return tmp0.u1().c9u_1;
  };
  protoOf(DefaultInputModeManager).xcp = function (inputMode) {
    var tmp;
    if (inputMode === Companion_getInstance_38().a9u_1 || inputMode === Companion_getInstance_38().b9u_1) {
      this.ocz(inputMode);
      tmp = true;
    } else {
      tmp = false;
    }
    return tmp;
  };
  var properties_initialized_PlatformContext_skiko_kt_vs4nzh;
  function _init_properties_PlatformContext_skiko_kt__bv8xht() {
    if (!properties_initialized_PlatformContext_skiko_kt_vs4nzh) {
      properties_initialized_PlatformContext_skiko_kt_vs4nzh = true;
      // Inline function 'kotlin.apply' call
      var this_0 = new DefaultArchitectureComponentsOwner(VOID, false);
      enableSavedStateHandles(this_0);
      this_0.vcz(State_RESUMED_getInstance());
      EmptyArchitectureComponentsOwner = this_0;
      androidx_compose_ui_platform_PlatformContext_Empty$stable = 8;
      androidx_compose_ui_platform_PlatformContext_DefaultViewConfiguration$stable = 0;
      androidx_compose_ui_platform_PlatformContext_EmptyFocusManager$stable = 0;
      androidx_compose_ui_platform_DefaultInputModeManager$stable = 0;
      androidx_compose_ui_platform_DelegateRootForTestListener$stable = 8;
    }
  }
  var androidx_compose_ui_platform_DefaultArchitectureComponentsOwner$stable;
  function DefaultArchitectureComponentsOwner(savedState, enforceMainThread) {
    savedState = savedState === VOID ? null : savedState;
    enforceMainThread = enforceMainThread === VOID ? true : enforceMainThread;
    var tmp = this;
    var tmp_0;
    if (enforceMainThread) {
      tmp_0 = LifecycleRegistry_init_$Create$(this);
    } else {
      tmp_0 = Companion_instance_2.w7n(this);
    }
    tmp.pcz_1 = tmp_0;
    this.qcz_1 = new ViewModelStore();
    this.rcz_1 = NavigationEventDispatcher_init_$Create$();
    this.scz_1 = Companion_instance_3.c7n(this);
    this.tcz_1 = new SavedStateViewModelFactory();
    this.ucz_1 = defaultViewModelCreationExtras(this, this);
    this.scz_1.v7m();
    this.scz_1.f7n(savedState);
  }
  protoOf(DefaultArchitectureComponentsOwner).zct = function () {
    return this;
  };
  protoOf(DefaultArchitectureComponentsOwner).acu = function () {
    return this;
  };
  protoOf(DefaultArchitectureComponentsOwner).bcu = function () {
    return this;
  };
  protoOf(DefaultArchitectureComponentsOwner).xct = function () {
    return this;
  };
  protoOf(DefaultArchitectureComponentsOwner).w7m = function () {
    return this.pcz_1;
  };
  protoOf(DefaultArchitectureComponentsOwner).g8r = function () {
    return this.qcz_1;
  };
  protoOf(DefaultArchitectureComponentsOwner).p8s = function () {
    return this.rcz_1;
  };
  protoOf(DefaultArchitectureComponentsOwner).i7p = function () {
    return this.scz_1.e7n_1;
  };
  protoOf(DefaultArchitectureComponentsOwner).x8p = function () {
    return this.tcz_1;
  };
  protoOf(DefaultArchitectureComponentsOwner).y8p = function () {
    return this.ucz_1;
  };
  protoOf(DefaultArchitectureComponentsOwner).vcz = function (state) {
    this.pcz_1.x7n(state);
    if (state.equals(State_DESTROYED_getInstance())) {
      this.qcz_1.c3();
    }
  };
  function defaultViewModelCreationExtras(savedStateRegistryOwner, viewModelStoreOwner) {
    // Inline function 'kotlin.also' call
    var this_0 = MutableCreationExtras_init_$Create$();
    this_0.j8q(get_SAVED_STATE_REGISTRY_OWNER_KEY(), savedStateRegistryOwner);
    this_0.j8q(get_VIEW_MODEL_STORE_OWNER_KEY(), viewModelStoreOwner);
    return this_0;
  }
  function PlatformTextInputSession() {
  }
  var androidx_compose_ui_platform_EmptyPlatformWindowInsets$stable;
  function Companion_47() {
    Companion_instance_52 = this;
    this.wcz_1 = new ValuePlatformInsets(_ValuePlatformInsets___init__impl__cc9ra7(new Long(0, 0)));
  }
  var Companion_instance_52;
  function Companion_getInstance_73() {
    if (Companion_instance_52 == null)
      new Companion_47();
    return Companion_instance_52;
  }
  function get_safeDrawing(_this__u8e3s4) {
    return new safeDrawing$1(_this__u8e3s4);
  }
  function PlatformWindowInsets() {
  }
  function get_safeGestures(_this__u8e3s4) {
    return new safeGestures$1(_this__u8e3s4);
  }
  function get_safeContent(_this__u8e3s4) {
    return new safeContent$1(_this__u8e3s4);
  }
  function _ValuePlatformInsets___init__impl__cc9ra7(packedValue) {
    return packedValue;
  }
  function _ValuePlatformInsets___get_packedValue__impl__f4stcb($this) {
    return $this;
  }
  function _ValuePlatformInsets___get_left__impl__730gcz($this) {
    return convertToInt(bitwiseAnd(shiftRightUnsigned(_ValuePlatformInsets___get_packedValue__impl__f4stcb($this), 48), new Long(65535, 0)));
  }
  function _ValuePlatformInsets___get_top__impl__w7zssv($this) {
    return convertToInt(bitwiseAnd(shiftRightUnsigned(_ValuePlatformInsets___get_packedValue__impl__f4stcb($this), 32), new Long(65535, 0)));
  }
  function _ValuePlatformInsets___get_right__impl__qioq54($this) {
    return convertToInt(bitwiseAnd(shiftRightUnsigned(_ValuePlatformInsets___get_packedValue__impl__f4stcb($this), 16), new Long(65535, 0)));
  }
  function _ValuePlatformInsets___get_bottom__impl__1kxht($this) {
    return convertToInt(bitwiseAnd(_ValuePlatformInsets___get_packedValue__impl__f4stcb($this), new Long(65535, 0)));
  }
  function ValuePlatformInsets__toString_impl_ozll1j($this) {
    return 'ValueInsets(' + _ValuePlatformInsets___get_left__impl__730gcz($this) + ', ' + _ValuePlatformInsets___get_top__impl__w7zssv($this) + ', ' + _ValuePlatformInsets___get_right__impl__qioq54($this) + ', ' + _ValuePlatformInsets___get_bottom__impl__1kxht($this) + ')';
  }
  function Companion_48() {
  }
  var Companion_instance_53;
  function Companion_getInstance_74() {
    return Companion_instance_53;
  }
  function ValuePlatformInsets__hashCode_impl_38fo8o($this) {
    return $this.hashCode();
  }
  function ValuePlatformInsets__equals_impl_r6ilgs($this, other) {
    if (!(other instanceof ValuePlatformInsets))
      return false;
    var tmp0_other_with_cast = other.zcz_1;
    if (!equalsLong($this, tmp0_other_with_cast))
      return false;
    return true;
  }
  function ValuePlatformInsets(packedValue) {
    this.zcz_1 = packedValue;
  }
  protoOf(ValuePlatformInsets).e9f = function () {
    return _ValuePlatformInsets___get_left__impl__730gcz(this.zcz_1);
  };
  protoOf(ValuePlatformInsets).map = function () {
    return _ValuePlatformInsets___get_top__impl__w7zssv(this.zcz_1);
  };
  protoOf(ValuePlatformInsets).x61 = function () {
    return _ValuePlatformInsets___get_right__impl__qioq54(this.zcz_1);
  };
  protoOf(ValuePlatformInsets).nap = function () {
    return _ValuePlatformInsets___get_bottom__impl__1kxht(this.zcz_1);
  };
  protoOf(ValuePlatformInsets).toString = function () {
    return ValuePlatformInsets__toString_impl_ozll1j(this.zcz_1);
  };
  protoOf(ValuePlatformInsets).hashCode = function () {
    return ValuePlatformInsets__hashCode_impl_38fo8o(this.zcz_1);
  };
  protoOf(ValuePlatformInsets).equals = function (other) {
    return ValuePlatformInsets__equals_impl_r6ilgs(this.zcz_1, other);
  };
  function EmptyPlatformWindowInsets() {
  }
  var EmptyPlatformWindowInsets_instance;
  function EmptyPlatformWindowInsets_getInstance() {
    return EmptyPlatformWindowInsets_instance;
  }
  function exclude(_this__u8e3s4, safeInsets, ime, content, $composer, $changed) {
    var $composer_0 = $composer;
    $composer_0 = $composer_0.s30(1248449560);
    var $dirty = $changed;
    if (($changed & 6) === 0)
      $dirty = $dirty | ((($changed & 8) === 0 ? $composer_0.k31(_this__u8e3s4) : $composer_0.q31(_this__u8e3s4)) ? 4 : 2);
    if (($changed & 48) === 0)
      $dirty = $dirty | ($composer_0.l31(safeInsets) ? 32 : 16);
    if (($changed & 384) === 0)
      $dirty = $dirty | ($composer_0.l31(ime) ? 256 : 128);
    if (($changed & 3072) === 0)
      $dirty = $dirty | ($composer_0.q31(content) ? 2048 : 1024);
    if ($composer_0.r31(!(($dirty & 1171) === 1170), $dirty & 1)) {
      CompositionLocalProvider_0(get_LocalPlatformWindowInsets().h3c(_this__u8e3s4.ycz(safeInsets, ime)), content, $composer_0, androidx_compose_runtime_ProvidedValue$stableprop_getter() | 112 & $dirty >> 6);
    } else {
      $composer_0.z30();
    }
    var tmp0_safe_receiver = $composer_0.t30();
    if (tmp0_safe_receiver == null)
      null;
    else {
      tmp0_safe_receiver.p3c(exclude$lambda(_this__u8e3s4, safeInsets, ime, content, $changed));
    }
  }
  function union(_this__u8e3s4, insets) {
    var tmp = union$lambda(_this__u8e3s4, insets);
    var tmp_0 = union$lambda_0(_this__u8e3s4, insets);
    var tmp_1 = union$lambda_1(_this__u8e3s4, insets);
    return PlatformInsets(tmp, tmp_0, tmp_1, union$lambda_2(_this__u8e3s4, insets));
  }
  function PlatformInsets(getLeft, getTop, getRight, getBottom) {
    var tmp;
    if (getLeft === VOID) {
      tmp = PlatformInsets$lambda;
    } else {
      tmp = getLeft;
    }
    getLeft = tmp;
    var tmp_0;
    if (getTop === VOID) {
      tmp_0 = PlatformInsets$lambda_0;
    } else {
      tmp_0 = getTop;
    }
    getTop = tmp_0;
    var tmp_1;
    if (getRight === VOID) {
      tmp_1 = PlatformInsets$lambda_1;
    } else {
      tmp_1 = getRight;
    }
    getRight = tmp_1;
    var tmp_2;
    if (getBottom === VOID) {
      tmp_2 = PlatformInsets$lambda_2;
    } else {
      tmp_2 = getBottom;
    }
    getBottom = tmp_2;
    return new DynamicPlatformInsets(getLeft, getTop, getRight, getBottom);
  }
  function DynamicPlatformInsets$_init_$lambda_uydlwj() {
    return 0;
  }
  function DynamicPlatformInsets$_init_$lambda_uydlwj_0() {
    return 0;
  }
  function DynamicPlatformInsets$_init_$lambda_uydlwj_1() {
    return 0;
  }
  function DynamicPlatformInsets$_init_$lambda_uydlwj_2() {
    return 0;
  }
  function DynamicPlatformInsets(getLeft, getTop, getRight, getBottom) {
    var tmp;
    if (getLeft === VOID) {
      tmp = DynamicPlatformInsets$_init_$lambda_uydlwj;
    } else {
      tmp = getLeft;
    }
    getLeft = tmp;
    var tmp_0;
    if (getTop === VOID) {
      tmp_0 = DynamicPlatformInsets$_init_$lambda_uydlwj_0;
    } else {
      tmp_0 = getTop;
    }
    getTop = tmp_0;
    var tmp_1;
    if (getRight === VOID) {
      tmp_1 = DynamicPlatformInsets$_init_$lambda_uydlwj_1;
    } else {
      tmp_1 = getRight;
    }
    getRight = tmp_1;
    var tmp_2;
    if (getBottom === VOID) {
      tmp_2 = DynamicPlatformInsets$_init_$lambda_uydlwj_2;
    } else {
      tmp_2 = getBottom;
    }
    getBottom = tmp_2;
    this.ad0_1 = getLeft;
    this.bd0_1 = getTop;
    this.cd0_1 = getRight;
    this.dd0_1 = getBottom;
  }
  protoOf(DynamicPlatformInsets).e9f = function () {
    return this.ad0_1();
  };
  protoOf(DynamicPlatformInsets).map = function () {
    return this.bd0_1();
  };
  protoOf(DynamicPlatformInsets).x61 = function () {
    return this.cd0_1();
  };
  protoOf(DynamicPlatformInsets).nap = function () {
    return this.dd0_1();
  };
  function safeDrawing$1($this_safeDrawing) {
    this.ed0_1 = $this_safeDrawing;
  }
  protoOf(safeDrawing$1).e9f = function () {
    var tmp0 = this.ed0_1.mc8().e9f();
    var tmp2 = this.ed0_1.nc8().e9f();
    // Inline function 'kotlin.comparisons.maxOf' call
    var c = this.ed0_1.xcz().e9f();
    return Math.max(tmp0, tmp2, c);
  };
  protoOf(safeDrawing$1).map = function () {
    var tmp0 = this.ed0_1.mc8().map();
    var tmp2 = this.ed0_1.nc8().map();
    // Inline function 'kotlin.comparisons.maxOf' call
    var c = this.ed0_1.xcz().map();
    return Math.max(tmp0, tmp2, c);
  };
  protoOf(safeDrawing$1).x61 = function () {
    var tmp0 = this.ed0_1.mc8().x61();
    var tmp2 = this.ed0_1.nc8().x61();
    // Inline function 'kotlin.comparisons.maxOf' call
    var c = this.ed0_1.xcz().x61();
    return Math.max(tmp0, tmp2, c);
  };
  protoOf(safeDrawing$1).nap = function () {
    var tmp0 = this.ed0_1.mc8().nap();
    var tmp2 = this.ed0_1.nc8().nap();
    // Inline function 'kotlin.comparisons.maxOf' call
    var c = this.ed0_1.xcz().nap();
    return Math.max(tmp0, tmp2, c);
  };
  function safeGestures$1($this_safeGestures) {
    this.fd0_1 = $this_safeGestures;
  }
  protoOf(safeGestures$1).e9f = function () {
    return maxOf(this.fd0_1.oc8().e9f(), new Int32Array([this.fd0_1.rc8().e9f(), this.fd0_1.sc8().e9f(), this.fd0_1.tc8().e9f()]));
  };
  protoOf(safeGestures$1).map = function () {
    return maxOf(this.fd0_1.oc8().map(), new Int32Array([this.fd0_1.rc8().map(), this.fd0_1.sc8().map(), this.fd0_1.tc8().map()]));
  };
  protoOf(safeGestures$1).x61 = function () {
    return maxOf(this.fd0_1.oc8().x61(), new Int32Array([this.fd0_1.rc8().x61(), this.fd0_1.sc8().x61(), this.fd0_1.tc8().x61()]));
  };
  protoOf(safeGestures$1).nap = function () {
    return maxOf(this.fd0_1.oc8().nap(), new Int32Array([this.fd0_1.rc8().nap(), this.fd0_1.sc8().nap(), this.fd0_1.tc8().nap()]));
  };
  function safeContent$1($this_safeContent) {
    this.gd0_1 = $this_safeContent;
  }
  protoOf(safeContent$1).e9f = function () {
    var tmp0 = get_safeDrawing(this.gd0_1).e9f();
    // Inline function 'kotlin.comparisons.maxOf' call
    var b = get_safeGestures(this.gd0_1).e9f();
    return Math.max(tmp0, b);
  };
  protoOf(safeContent$1).map = function () {
    var tmp0 = get_safeDrawing(this.gd0_1).map();
    // Inline function 'kotlin.comparisons.maxOf' call
    var b = get_safeGestures(this.gd0_1).map();
    return Math.max(tmp0, b);
  };
  protoOf(safeContent$1).x61 = function () {
    var tmp0 = get_safeDrawing(this.gd0_1).x61();
    // Inline function 'kotlin.comparisons.maxOf' call
    var b = get_safeGestures(this.gd0_1).x61();
    return Math.max(tmp0, b);
  };
  protoOf(safeContent$1).nap = function () {
    var tmp0 = get_safeDrawing(this.gd0_1).nap();
    // Inline function 'kotlin.comparisons.maxOf' call
    var b = get_safeGestures(this.gd0_1).nap();
    return Math.max(tmp0, b);
  };
  function exclude$lambda($this_exclude, $safeInsets, $ime, $content, $$changed) {
    return function ($composer, $force) {
      exclude($this_exclude, $safeInsets, $ime, $content, $composer, updateChangedFlags($$changed | 1));
      return Unit_instance;
    };
  }
  function union$lambda($this_union, $insets) {
    return function () {
      var tmp0 = $this_union.e9f();
      // Inline function 'kotlin.comparisons.maxOf' call
      var b = $insets.e9f();
      return Math.max(tmp0, b);
    };
  }
  function union$lambda_0($this_union, $insets) {
    return function () {
      var tmp0 = $this_union.map();
      // Inline function 'kotlin.comparisons.maxOf' call
      var b = $insets.map();
      return Math.max(tmp0, b);
    };
  }
  function union$lambda_1($this_union, $insets) {
    return function () {
      var tmp0 = $this_union.x61();
      // Inline function 'kotlin.comparisons.maxOf' call
      var b = $insets.x61();
      return Math.max(tmp0, b);
    };
  }
  function union$lambda_2($this_union, $insets) {
    return function () {
      var tmp0 = $this_union.nap();
      // Inline function 'kotlin.comparisons.maxOf' call
      var b = $insets.nap();
      return Math.max(tmp0, b);
    };
  }
  function PlatformInsets$lambda() {
    return 0;
  }
  function PlatformInsets$lambda_0() {
    return 0;
  }
  function PlatformInsets$lambda_1() {
    return 0;
  }
  function PlatformInsets$lambda_2() {
    return 0;
  }
  var androidx_compose_ui_platform_PlatformWindowInsetsProviderNode$stable;
  function setAncestorWindowInsets($this, windowInsets) {
    if (equals($this.kct_1, windowInsets))
      return Unit_instance;
    $this.kct_1 = windowInsets;
    $this.lct();
  }
  function invalidateChildWindowInsets($this) {
    var tmp = $this.t91();
    traverseDescendants($this, tmp, PlatformWindowInsetsProviderNode$invalidateChildWindowInsets$lambda($this));
  }
  function PlatformWindowInsetsProviderNode$onAttach$lambda(this$0) {
    return function (parent) {
      var tmp = this$0;
      tmp.kct_1 = (parent instanceof PlatformWindowInsetsProviderNode ? parent : THROW_CCE()).jct_1;
      return false;
    };
  }
  function PlatformWindowInsetsProviderNode$invalidateChildWindowInsets$lambda(this$0) {
    return function (it) {
      setAncestorWindowInsets(it instanceof PlatformWindowInsetsProviderNode ? it : THROW_CCE(), this$0.jct_1);
      return TraverseDescendantsAction_SkipSubtreeAndContinueTraversal_getInstance();
    };
  }
  function PlatformWindowInsetsProviderNode(windowInsets) {
    windowInsets = windowInsets === VOID ? EmptyPlatformWindowInsets_instance : windowInsets;
    DelegatingNode.call(this);
    this.jct_1 = windowInsets;
    this.kct_1 = EmptyPlatformWindowInsets_instance;
  }
  protoOf(PlatformWindowInsetsProviderNode).t91 = function () {
    return 'androidx.compose.ui.platform.PlatformWindowInsetsProviderNode';
  };
  protoOf(PlatformWindowInsetsProviderNode).f8w = function () {
    var tmp = this.t91();
    traverseAncestors(this, tmp, PlatformWindowInsetsProviderNode$onAttach$lambda(this));
    this.lct();
    protoOf(DelegatingNode).f8w.call(this);
  };
  protoOf(PlatformWindowInsetsProviderNode).lct = function () {
    this.jct_1 = this.scs(this.kct_1);
    invalidateChildWindowInsets(this);
  };
  function excludeWindowInsets(_this__u8e3s4, safeInsets, ime) {
    return _this__u8e3s4.d8v(new ExcludedWindowInsetsProviderModifierElement(safeInsets, ime));
  }
  function ExcludedWindowInsetsProviderModifierElement(safeInsets, ime) {
    ModifierNodeElement.call(this);
    this.id0_1 = safeInsets;
    this.jd0_1 = ime;
  }
  protoOf(ExcludedWindowInsetsProviderModifierElement).r3d = function () {
    return new ExcludedWindowInsetsProviderNode(this.id0_1, this.jd0_1);
  };
  protoOf(ExcludedWindowInsetsProviderModifierElement).kd0 = function (node) {
    return node.fd1(this.id0_1, this.jd0_1);
  };
  protoOf(ExcludedWindowInsetsProviderModifierElement).d8y = function (node) {
    return this.kd0(node instanceof ExcludedWindowInsetsProviderNode ? node : THROW_CCE());
  };
  protoOf(ExcludedWindowInsetsProviderModifierElement).toString = function () {
    return 'ExcludedWindowInsetsProviderModifierElement(safeInsets=' + this.id0_1 + ', ime=' + this.jd0_1 + ')';
  };
  protoOf(ExcludedWindowInsetsProviderModifierElement).hashCode = function () {
    var result = getBooleanHashCode(this.id0_1);
    result = imul(result, 31) + getBooleanHashCode(this.jd0_1) | 0;
    return result;
  };
  protoOf(ExcludedWindowInsetsProviderModifierElement).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof ExcludedWindowInsetsProviderModifierElement))
      return false;
    if (!(this.id0_1 === other.id0_1))
      return false;
    if (!(this.jd0_1 === other.jd0_1))
      return false;
    return true;
  };
  function ExcludedWindowInsetsProviderNode(safeInsets, ime) {
    PlatformWindowInsetsProviderNode.call(this);
    this.dd1_1 = safeInsets;
    this.ed1_1 = ime;
  }
  protoOf(ExcludedWindowInsetsProviderNode).scs = function (ancestorWindowInsets) {
    return ancestorWindowInsets.ycz(this.dd1_1, this.ed1_1);
  };
  protoOf(ExcludedWindowInsetsProviderNode).fd1 = function (safeInsets, ime) {
    if (!(this.dd1_1 === safeInsets) || !(this.ed1_1 === ime)) {
      this.dd1_1 = safeInsets;
      this.ed1_1 = ime;
      this.lct();
    }
  };
  function createApplier(container) {
    return new DefaultUiApplier(container);
  }
  var androidx_compose_ui_platform_SynchronizedObject$stable;
  function SynchronizedObject() {
  }
  var androidx_compose_ui_platform_TranslationsCache$stable;
  function setContent(_this__u8e3s4, parent, getCompositionLocalContext, content) {
    var tmp;
    if (getCompositionLocalContext === VOID) {
      tmp = setContent$lambda;
    } else {
      tmp = getCompositionLocalContext;
    }
    getCompositionLocalContext = tmp;
    var composition = Composition(new DefaultUiApplier(_this__u8e3s4.qcp().n65()), parent);
    composition.k39(ComposableLambda$invoke$ref(composableLambdaInstance(1921797090, true, setContent$lambda_0(getCompositionLocalContext, _this__u8e3s4, content))));
    return composition;
  }
  function provide(_this__u8e3s4, content, $composer, $changed) {
    var $composer_0 = $composer;
    $composer_0 = $composer_0.s30(1703369316);
    var $dirty = $changed;
    if (($changed & 6) === 0)
      $dirty = $dirty | ($composer_0.k31(_this__u8e3s4) ? 4 : 2);
    if (($changed & 48) === 0)
      $dirty = $dirty | ($composer_0.q31(content) ? 32 : 16);
    if ($composer_0.r31(!(($dirty & 19) === 18), $dirty & 1)) {
      if (!(_this__u8e3s4 == null)) {
        $composer_0.m30(36785981);
        CompositionLocalProvider_1(_this__u8e3s4, content, $composer_0, 14 & $dirty | 112 & $dirty);
        $composer_0.n30();
      } else {
        $composer_0.m30(36855173);
        content($composer_0, 14 & $dirty >> 3);
        $composer_0.n30();
      }
    } else {
      $composer_0.z30();
    }
    var tmp0_safe_receiver = $composer_0.t30();
    if (tmp0_safe_receiver == null)
      null;
    else {
      tmp0_safe_receiver.p3c(provide$lambda(_this__u8e3s4, content, $changed));
    }
  }
  function setContent$lambda() {
    return null;
  }
  function setContent$lambda$lambda($this_setContent, $content) {
    return function ($composer, $changed) {
      var $composer_0 = $composer;
      var tmp;
      if ($composer_0.r31(!(($changed & 3) === 2), $changed & 1)) {
        var tmp_0 = $this_setContent.qcp();
        // Inline function 'androidx.compose.runtime.cache' call
        // Inline function 'kotlin.let' call
        var it = $composer_0.i31();
        var tmp_1;
        if (false || it === Companion_getInstance_9().f30_1) {
          var value = createPlatformUriHandler();
          $composer_0.j31(value);
          tmp_1 = value;
        } else {
          tmp_1 = it;
        }
        var tmp$ret$0 = tmp_1;
        ProvideCommonCompositionLocals(tmp_0, tmp$ret$0, $content, $composer_0, 0);
        tmp = Unit_instance;
      } else {
        $composer_0.z30();
        tmp = Unit_instance;
      }
      return Unit_instance;
    };
  }
  function setContent$lambda_0($getCompositionLocalContext, $this_setContent, $content) {
    return function ($composer, $changed) {
      var $composer_0 = $composer;
      var tmp;
      if ($composer_0.r31(!(($changed & 3) === 2), $changed & 1)) {
        var tmp_0 = $getCompositionLocalContext();
        // Inline function 'kotlin.run' call
        var dispatchReceiver = rememberComposableLambda(416243724, true, setContent$lambda$lambda($this_setContent, $content), $composer_0, 54);
        // Inline function 'androidx.compose.runtime.remember' call
        var $composer_1 = $composer_0;
        // Inline function 'androidx.compose.runtime.cache' call
        var invalid = $composer_1.k31(dispatchReceiver);
        // Inline function 'kotlin.let' call
        var it = $composer_1.i31();
        var tmp_1;
        if (invalid || it === Companion_getInstance_9().f30_1) {
          var value = ComposableLambda$invoke$ref(dispatchReceiver);
          $composer_1.j31(value);
          tmp_1 = value;
        } else {
          tmp_1 = it;
        }
        var tmp$ret$0 = tmp_1;
        provide(tmp_0, tmp$ret$0, $composer_0, 48);
        tmp = Unit_instance;
      } else {
        $composer_0.z30();
        tmp = Unit_instance;
      }
      return Unit_instance;
    };
  }
  function provide$lambda($this_provide, $content, $$changed) {
    return function ($composer, $force) {
      provide($this_provide, $content, $composer, updateChangedFlags($$changed | 1));
      return Unit_instance;
    };
  }
  var androidx_compose_ui_scene_BaseComposeScene$stable;
  function onPointerInputEvent($this, event) {
    // Inline function 'kotlin.also' call
    var this_0 = new PointerEventResult($this.rd1(event));
    this_0.dc7_1;
    if ($this.wd1().xd1().vcy()) {
      var isDown = event.ca7_1 === Companion_getInstance_41().la1_1;
      var pointer = singleOrNull(event.ea7_1);
      var tmp = pointer == null ? null : pointer.ea2_1;
      var isFromMouse = equals(tmp == null ? null : new PointerType(tmp), new PointerType(Companion_getInstance_42().na2_1));
      if (isDown && isFromMouse) {
        $this.sd1().vd1(pointer.ba2_1);
      }
    }
    return this_0.dc7_1;
  }
  function BaseComposeScene$updateInvalidations$ref(p0) {
    return constructCallableReference(function () {
      p0.yd1();
      return Unit_instance;
    }, 0, 0, 149, 'updateInvalidations', [p0]);
  }
  function BaseComposeScene$doMeasureAndLayout$ref(p0) {
    return constructCallableReference(function () {
      p0.zd1();
      return Unit_instance;
    }, 0, 0, 150, 'doMeasureAndLayout', [p0]);
  }
  function BaseComposeScene$onPointerInputEvent$ref(p0) {
    return constructCallableReference(function (p0_0) {
      var tmp0 = p0;
      return new PointerEventResult(onPointerInputEvent(tmp0, p0_0));
    }, 1, 0, 151, 'onPointerInputEvent', [p0]);
  }
  function BaseComposeScene$processCancelPointerInput$ref(p0) {
    return constructCallableReference(function () {
      p0.ad2();
      return Unit_instance;
    }, 0, 0, 152, 'processCancelPointerInput', [p0]);
  }
  function BaseComposeScene$processKeyEvent$ref(p0) {
    return constructCallableReference(function (p0_0) {
      return p0.bd2(p0_0.e9u_1);
    }, 1, 0, 153, 'processKeyEvent', [p0]);
  }
  function BaseComposeScene$_get_compositionLocalContext_$ref_u1tjpj() {
    return constructCallableReference(function (p0) {
      return p0.cd2();
    }, 1, 0, 154);
  }
  function BaseComposeScene$_set_compositionLocalContext_$ref_2sb8gj() {
    return constructCallableReference(function (p0, p1) {
      p0.dd2(p1);
      return Unit_instance;
    }, 2, 0, 155);
  }
  function BaseComposeScene$setContent$lambda(this$0, $content) {
    return function ($composer, $changed) {
      var $composer_0 = $composer;
      var tmp;
      if ($composer_0.r31(!(($changed & 3) === 2), $changed & 1)) {
        ProvidePlatformCompositionLocals([get_LocalComposeScene().h3c(this$0), get_LocalComposeSceneContext().h3c(this$0.wd1())], this$0.wd1().xd1(), $content, $composer_0, androidx_compose_runtime_ProvidedValue$stableprop_getter());
        tmp = Unit_instance;
      } else {
        $composer_0.z30();
        tmp = Unit_instance;
      }
      return Unit_instance;
    };
  }
  function BaseComposeScene$render$lambda(this$0) {
    return function () {
      this$0.id1_1.fc7();
      return Unit_instance;
    };
  }
  function BaseComposeScene(coroutineContext, invalidate) {
    this.gd1_1 = invalidate;
    var tmp = this;
    tmp.hd1_1 = new SnapshotInvalidationTracker(BaseComposeScene$updateInvalidations$ref(this));
    var tmp_0 = this;
    var tmp_1 = BaseComposeScene$doMeasureAndLayout$ref(this);
    var tmp_2 = BaseComposeScene$onPointerInputEvent$ref(this);
    var tmp_3 = BaseComposeScene$processCancelPointerInput$ref(this);
    tmp_0.id1_1 = new ComposeSceneInputHandler(tmp_1, tmp_2, tmp_3, BaseComposeScene$processKeyEvent$ref(this));
    var tmp_4 = this;
    tmp_4.jd1_1 = new BroadcastFrameClock(BaseComposeScene$updateInvalidations$ref(this));
    this.kd1_1 = new ComposeSceneRecomposer(coroutineContext, [this.jd1_1]);
    this.ld1_1 = null;
    this.md1_1 = false;
    this.nd1_1 = false;
    this.od1_1 = true;
    this.pd1_1 = mutableStateOf(null);
    var tmp_5 = this;
    var tmp_6 = KProperty0;
    tmp_5.qd1_1 = getPropertyCallableRef('lastKnownPointerPosition', 0, tmp_6, ComposeSceneInputHandler$_get_lastKnownPointerPosition_$ref_oik3lh(this.id1_1), null);
    GlobalSnapshotManager_getInstance().lcw();
  }
  protoOf(BaseComposeScene).ed2 = function () {
    return this.kd1_1.ed2();
  };
  protoOf(BaseComposeScene).yd1 = function () {
    this.od1_1 = this.jd1_1.j2z() || this.hd1_1.v39();
    if (this.od1_1 && !this.nd1_1 && !this.md1_1 && !(this.ld1_1 == null)) {
      this.gd1_1();
    }
  };
  protoOf(BaseComposeScene).dd2 = function (_set____db54di) {
    var tmp0 = this.pd1_1;
    var tmp = KMutableProperty1;
    var tmp_0 = BaseComposeScene$_get_compositionLocalContext_$ref_u1tjpj();
    // Inline function 'androidx.compose.runtime.setValue' call
    getPropertyCallableRef('compositionLocalContext', 1, tmp, tmp_0, BaseComposeScene$_set_compositionLocalContext_$ref_2sb8gj());
    tmp0.s21(_set____db54di);
    return Unit_instance;
  };
  protoOf(BaseComposeScene).cd2 = function () {
    var tmp0 = this.pd1_1;
    var tmp = KMutableProperty1;
    var tmp_0 = BaseComposeScene$_get_compositionLocalContext_$ref_u1tjpj();
    // Inline function 'androidx.compose.runtime.getValue' call
    getPropertyCallableRef('compositionLocalContext', 1, tmp, tmp_0, BaseComposeScene$_set_compositionLocalContext_$ref_2sb8gj());
    return tmp0.u1();
  };
  protoOf(BaseComposeScene).j4 = function () {
    // Inline function 'kotlin.check' call
    if (!!this.md1_1) {
      var message = 'ComposeScene is already closed';
      throw IllegalStateException_init_$Create$(toString(message));
    }
    this.md1_1 = true;
    var tmp0_safe_receiver = this.ld1_1;
    if (tmp0_safe_receiver == null)
      null;
    else {
      tmp0_safe_receiver.s1d();
    }
    this.kd1_1.e2z();
  };
  protoOf(BaseComposeScene).k39 = function (content) {
    $l$block: {
      // Inline function 'androidx.compose.ui.scene.BaseComposeScene.postponeInvalidation' call
      // Inline function 'androidx.compose.ui.util.trace' call
      // Inline function 'kotlin.check' call
      if (!!this.md1_1) {
        var message = 'postponeInvalidation called after ComposeScene is closed';
        throw IllegalStateException_init_$Create$(toString(message));
      }
      this.nd1_1 = true;
      var tmp;
      try {
        this.hd1_1.uct();
        // Inline function 'androidx.compose.ui.node.SnapshotInvalidationTracker.performSnapshotChangesSynchronously' call
        var this_0 = this.hd1_1;
        var tmp_0;
        try {
          access$_set_renderingThreadId__hexfbg(this_0, getCurrentThreadId());
          // Inline function 'kotlin.check' call
          if (!!this.md1_1) {
            var message_0 = 'setContent called after ComposeScene is closed';
            throw IllegalStateException_init_$Create$(toString(message_0));
          }
          this.id1_1.kd2();
          this.kd1_1.ld2();
          var tmp0_safe_receiver = this.ld1_1;
          if (tmp0_safe_receiver == null)
            null;
          else {
            tmp0_safe_receiver.s1d();
          }
          var tmp_1 = this;
          tmp_1.ld1_1 = this.md2(ComposableLambda$invoke$ref(composableLambdaInstance(669410678, true, BaseComposeScene$setContent$lambda(this, content))));
          this.kd1_1.ld2();
          tmp_0 = Unit_instance;
        }finally {
          access$_set_renderingThreadId__hexfbg(this_0, null);
        }
        tmp = tmp_0;
      }finally {
        this.hd1_1.uct();
        this.nd1_1 = false;
      }
      // Inline function 'kotlin.also' call
      this.yd1();
      break $l$block;
    }
    return Unit_instance;
  };
  protoOf(BaseComposeScene).nd2 = function (canvas, nanoTime) {
    if (this.md1_1)
      return Unit_instance;
    $l$block: {
      // Inline function 'androidx.compose.ui.scene.BaseComposeScene.postponeInvalidation' call
      // Inline function 'androidx.compose.ui.util.trace' call
      // Inline function 'kotlin.check' call
      if (!!this.md1_1) {
        var message = 'postponeInvalidation called after ComposeScene is closed';
        throw IllegalStateException_init_$Create$(toString(message));
      }
      this.nd1_1 = true;
      var tmp;
      try {
        this.hd1_1.uct();
        // Inline function 'androidx.compose.ui.node.SnapshotInvalidationTracker.performSnapshotChangesSynchronously' call
        var this_0 = this.hd1_1;
        var tmp_0;
        try {
          access$_set_renderingThreadId__hexfbg(this_0, getCurrentThreadId());
          this.kd1_1.od2();
          this.kd1_1.ld2();
          this.jd1_1.p2z(nanoTime);
          this.zd1();
          if (this.id1_1.qd2()) {
            this.kd1_1.pd2(BaseComposeScene$render$lambda(this));
          }
          Companion_instance.w41();
          this.zd1();
          Companion_instance.w41();
          this.hd1_1.tct();
          this.zcq(canvas);
          tmp_0 = Unit_instance;
        }finally {
          access$_set_renderingThreadId__hexfbg(this_0, null);
        }
        tmp = tmp_0;
      }finally {
        this.hd1_1.uct();
        this.nd1_1 = false;
      }
      // Inline function 'kotlin.also' call
      this.yd1();
      break $l$block;
    }
  };
  protoOf(BaseComposeScene).rd2 = function (eventType, position, scrollDelta, timeMillis, type, buttons, keyboardModifiers, nativeEvent, button, scaleGestureFactor, panGestureOffset) {
    var tmp$ret$0;
    $l$block: {
      // Inline function 'androidx.compose.ui.scene.BaseComposeScene.postponeInvalidation' call
      // Inline function 'androidx.compose.ui.util.trace' call
      // Inline function 'kotlin.check' call
      if (!!this.md1_1) {
        var message = 'postponeInvalidation called after ComposeScene is closed';
        throw IllegalStateException_init_$Create$(toString(message));
      }
      this.nd1_1 = true;
      var tmp;
      try {
        this.hd1_1.uct();
        // Inline function 'androidx.compose.ui.node.SnapshotInvalidationTracker.performSnapshotChangesSynchronously' call
        var this_0 = this.hd1_1;
        var tmp_0;
        try {
          access$_set_renderingThreadId__hexfbg(this_0, getCurrentThreadId());
          // Inline function 'kotlin.also' call
          var this_1 = new PointerEventResult(this.id1_1.sd2(eventType, position, scrollDelta, timeMillis, type, buttons, keyboardModifiers, nativeEvent, button, scaleGestureFactor, panGestureOffset));
          this_1.dc7_1;
          this.kd1_1.od2();
          var tmp$ret$7 = this_1.dc7_1;
          tmp_0 = new PointerEventResult(tmp$ret$7);
        }finally {
          access$_set_renderingThreadId__hexfbg(this_0, null);
        }
        tmp = tmp_0;
      }finally {
        this.hd1_1.uct();
        this.nd1_1 = false;
      }
      // Inline function 'kotlin.also' call
      this.yd1();
      tmp$ret$0 = tmp.dc7_1;
      break $l$block;
    }
    return tmp$ret$0;
  };
  protoOf(BaseComposeScene).ud2 = function (eventType, pointers, buttons, keyboardModifiers, scrollDelta, timeMillis, nativeEvent, button, scaleGestureFactor, panGestureOffset) {
    var tmp$ret$0;
    $l$block: {
      // Inline function 'androidx.compose.ui.scene.BaseComposeScene.postponeInvalidation' call
      // Inline function 'androidx.compose.ui.util.trace' call
      // Inline function 'kotlin.check' call
      if (!!this.md1_1) {
        var message = 'postponeInvalidation called after ComposeScene is closed';
        throw IllegalStateException_init_$Create$(toString(message));
      }
      this.nd1_1 = true;
      var tmp;
      try {
        this.hd1_1.uct();
        // Inline function 'androidx.compose.ui.node.SnapshotInvalidationTracker.performSnapshotChangesSynchronously' call
        var this_0 = this.hd1_1;
        var tmp_0;
        try {
          access$_set_renderingThreadId__hexfbg(this_0, getCurrentThreadId());
          // Inline function 'kotlin.also' call
          var this_1 = new PointerEventResult(this.id1_1.vd2(eventType, pointers, buttons, keyboardModifiers, scrollDelta, timeMillis, nativeEvent, button, scaleGestureFactor, panGestureOffset));
          this_1.dc7_1;
          this.kd1_1.od2();
          var tmp$ret$7 = this_1.dc7_1;
          tmp_0 = new PointerEventResult(tmp$ret$7);
        }finally {
          access$_set_renderingThreadId__hexfbg(this_0, null);
        }
        tmp = tmp_0;
      }finally {
        this.hd1_1.uct();
        this.nd1_1 = false;
      }
      // Inline function 'kotlin.also' call
      this.yd1();
      tmp$ret$0 = tmp.dc7_1;
      break $l$block;
    }
    return tmp$ret$0;
  };
  protoOf(BaseComposeScene).xd2 = function (keyEvent) {
    $l$block: {
      // Inline function 'androidx.compose.ui.scene.BaseComposeScene.postponeInvalidation' call
      // Inline function 'androidx.compose.ui.util.trace' call
      // Inline function 'kotlin.check' call
      if (!!this.md1_1) {
        var message = 'postponeInvalidation called after ComposeScene is closed';
        throw IllegalStateException_init_$Create$(toString(message));
      }
      this.nd1_1 = true;
      var tmp;
      try {
        this.hd1_1.uct();
        // Inline function 'androidx.compose.ui.node.SnapshotInvalidationTracker.performSnapshotChangesSynchronously' call
        var this_0 = this.hd1_1;
        var tmp_0;
        try {
          access$_set_renderingThreadId__hexfbg(this_0, getCurrentThreadId());
          // Inline function 'kotlin.also' call
          var this_1 = this.id1_1.w9e(keyEvent);
          this.kd1_1.od2();
          tmp_0 = this_1;
        }finally {
          access$_set_renderingThreadId__hexfbg(this_0, null);
        }
        tmp = tmp_0;
      }finally {
        this.hd1_1.uct();
        this.nd1_1 = false;
      }
      // Inline function 'kotlin.also' call
      this.yd1();
      break $l$block;
    }
    return tmp;
  };
  protoOf(BaseComposeScene).zd1 = function () {
    this.hd1_1.sct();
    this.scr();
  };
  function get_semanticsOwnerListener_0(_this__u8e3s4) {
    return _this__u8e3s4.wd1().xd1().ncq();
  }
  var androidx_compose_ui_scene_CopiedList$stable;
  function CanvasLayersComposeScene(density, layoutDirection, size, coroutineContext, platformContext, invalidate) {
    density = density === VOID ? Density_0(1.0) : density;
    layoutDirection = layoutDirection === VOID ? LayoutDirection_Ltr_getInstance() : layoutDirection;
    size = size === VOID ? null : size;
    coroutineContext = coroutineContext === VOID ? Dispatchers_getInstance().j1h_1 : coroutineContext;
    platformContext = platformContext === VOID ? new Empty() : platformContext;
    var tmp;
    if (invalidate === VOID) {
      tmp = CanvasLayersComposeScene$lambda;
    } else {
      tmp = invalidate;
    }
    invalidate = tmp;
    return new CanvasLayersComposeSceneImpl(density, layoutDirection, size, coroutineContext, platformContext, invalidate);
  }
  function $startInputMethodCOROUTINE$_2(_this__u8e3s4, request, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.hd3_1 = _this__u8e3s4;
    this.id3_1 = request;
  }
  protoOf($startInputMethodCOROUTINE$_2).v9 = function () {
    var suspendResult = this.p9_1;
    $sm: do
      try {
        var tmp = this.n9_1;
        switch (tmp) {
          case 0:
            this.o9_1 = 2;
            this.n9_1 = 1;
            suspendResult = this.hd3_1.jd3_1.hbp(this.id3_1, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            throwKotlinNothingValueException();
            break;
          case 2:
            throw this.q9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.o9_1 === 2) {
          throw e;
        } else {
          this.n9_1 = this.o9_1;
          this.q9_1 = e;
        }
      }
     while (true);
  };
  function _get_background__3vp7tv($this) {
    var tmp0_safe_receiver = $this.yd3();
    var tmp;
    var tmp_0 = tmp0_safe_receiver;
    if ((tmp_0 == null ? null : new Color(tmp_0)) == null) {
      tmp = null;
    } else {
      var tmp_1 = tmp0_safe_receiver;
      // Inline function 'kotlin.let' call
      var it = (tmp_1 == null ? null : new Color(tmp_1)).c6d_1;
      var tmp_2 = Companion_instance_6;
      tmp = drawBehind(tmp_2, CanvasLayersComposeSceneImpl$AttachedComposeSceneLayer$_get_background_$lambda_pab5jn(it, $this.xd3_1));
    }
    var tmp1_elvis_lhs = tmp;
    return tmp1_elvis_lhs == null ? Companion_instance_6 : tmp1_elvis_lhs;
  }
  function CanvasLayersComposeSceneImpl$AttachedComposeSceneLayer$owner$1(this$0) {
    this.jd3_1 = this$0.wd1().xd1();
  }
  protoOf(CanvasLayersComposeSceneImpl$AttachedComposeSceneLayer$owner$1).qco = function () {
    return EmptyFocusManager_instance;
  };
  protoOf(CanvasLayersComposeSceneImpl$AttachedComposeSceneLayer$owner$1).hbm = function () {
    return this.jd3_1.hbm();
  };
  protoOf(CanvasLayersComposeSceneImpl$AttachedComposeSceneLayer$owner$1).yct = function () {
    return this.jd3_1.yct();
  };
  protoOf(CanvasLayersComposeSceneImpl$AttachedComposeSceneLayer$owner$1).wct = function () {
    return this.jd3_1.wct();
  };
  protoOf(CanvasLayersComposeSceneImpl$AttachedComposeSceneLayer$owner$1).ucy = function () {
    return this.jd3_1.ucy();
  };
  protoOf(CanvasLayersComposeSceneImpl$AttachedComposeSceneLayer$owner$1).ocp = function () {
    return this.jd3_1.ocp();
  };
  protoOf(CanvasLayersComposeSceneImpl$AttachedComposeSceneLayer$owner$1).pcp = function (localPosition) {
    return this.jd3_1.pcp(localPosition);
  };
  protoOf(CanvasLayersComposeSceneImpl$AttachedComposeSceneLayer$owner$1).qcq = function (positionInWindow) {
    return this.jd3_1.qcq(positionInWindow);
  };
  protoOf(CanvasLayersComposeSceneImpl$AttachedComposeSceneLayer$owner$1).ncp = function (localPosition) {
    return this.jd3_1.ncp(localPosition);
  };
  protoOf(CanvasLayersComposeSceneImpl$AttachedComposeSceneLayer$owner$1).rcq = function (positionOnScreen) {
    return this.jd3_1.rcq(positionOnScreen);
  };
  protoOf(CanvasLayersComposeSceneImpl$AttachedComposeSceneLayer$owner$1).wcq = function () {
    return this.jd3_1.wcq();
  };
  protoOf(CanvasLayersComposeSceneImpl$AttachedComposeSceneLayer$owner$1).n82 = function () {
    return this.jd3_1.n82();
  };
  protoOf(CanvasLayersComposeSceneImpl$AttachedComposeSceneLayer$owner$1).la7 = function () {
    return this.jd3_1.la7();
  };
  protoOf(CanvasLayersComposeSceneImpl$AttachedComposeSceneLayer$owner$1).xbl = function () {
    return this.jd3_1.xbl();
  };
  protoOf(CanvasLayersComposeSceneImpl$AttachedComposeSceneLayer$owner$1).fbm = function () {
    return this.jd3_1.fbm();
  };
  protoOf(CanvasLayersComposeSceneImpl$AttachedComposeSceneLayer$owner$1).hbp = function (request, $completion) {
    var tmp = new $startInputMethodCOROUTINE$_2(this, request, $completion);
    tmp.p9_1 = Unit_instance;
    tmp.q9_1 = null;
    return tmp.v9();
  };
  protoOf(CanvasLayersComposeSceneImpl$AttachedComposeSceneLayer$owner$1).bbm = function () {
    return this.jd3_1.bbm();
  };
  protoOf(CanvasLayersComposeSceneImpl$AttachedComposeSceneLayer$owner$1).vcq = function (pointerIcon) {
    this.jd3_1.vcq(pointerIcon);
  };
  protoOf(CanvasLayersComposeSceneImpl$AttachedComposeSceneLayer$owner$1).pco = function () {
    return this.jd3_1.pco();
  };
  protoOf(CanvasLayersComposeSceneImpl$AttachedComposeSceneLayer$owner$1).b8z = function () {
    return this.jd3_1.b8z();
  };
  protoOf(CanvasLayersComposeSceneImpl$AttachedComposeSceneLayer$owner$1).ycp = function () {
    return this.jd3_1.ycp();
  };
  protoOf(CanvasLayersComposeSceneImpl$AttachedComposeSceneLayer$owner$1).bcr = function (frameRate, frameRateCategory) {
    this.jd3_1.bcr(frameRate, frameRateCategory);
  };
  protoOf(CanvasLayersComposeSceneImpl$AttachedComposeSceneLayer$owner$1).ocr = function () {
    return this.jd3_1.ocr();
  };
  protoOf(CanvasLayersComposeSceneImpl$AttachedComposeSceneLayer$owner$1).ncq = function () {
    return this.jd3_1.ncq();
  };
  protoOf(CanvasLayersComposeSceneImpl$AttachedComposeSceneLayer$owner$1).vcy = function () {
    return this.jd3_1.vcy();
  };
  function CanvasLayersComposeSceneImpl$AttachedComposeSceneLayer$_get_density_$ref_21o8uv() {
    return constructCallableReference(function (p0) {
      return p0.u5e();
    }, 1, 0, 156);
  }
  function CanvasLayersComposeSceneImpl$AttachedComposeSceneLayer$_set_density_$ref_s8pxh1() {
    return constructCallableReference(function (p0, p1) {
      p0.s6p(p1);
      return Unit_instance;
    }, 2, 0, 157);
  }
  function CanvasLayersComposeSceneImpl$AttachedComposeSceneLayer$_get_layoutDirection_$ref_22srca() {
    return constructCallableReference(function (p0) {
      return p0.r6p();
    }, 1, 0, 158);
  }
  function CanvasLayersComposeSceneImpl$AttachedComposeSceneLayer$_set_layoutDirection_$ref_b7xhk2() {
    return constructCallableReference(function (p0, p1) {
      p0.q6p(p1);
      return Unit_instance;
    }, 2, 0, 159);
  }
  function CanvasLayersComposeSceneImpl$AttachedComposeSceneLayer$_get_boundsInWindow_$ref_bnt3dd() {
    return constructCallableReference(function (p0) {
      return p0.yd4();
    }, 1, 0, 160);
  }
  function CanvasLayersComposeSceneImpl$AttachedComposeSceneLayer$_set_boundsInWindow_$ref_pffnhf() {
    return constructCallableReference(function (p0, p1) {
      p0.zd4(p1);
      return Unit_instance;
    }, 2, 0, 161);
  }
  function CanvasLayersComposeSceneImpl$AttachedComposeSceneLayer$_get_scrimColor_$ref_cabrcu() {
    return constructCallableReference(function (p0) {
      var tmp = p0.yd3();
      return tmp == null ? null : new Color(tmp);
    }, 1, 0, 162);
  }
  function CanvasLayersComposeSceneImpl$AttachedComposeSceneLayer$_set_scrimColor_$ref_d8room() {
    return constructCallableReference(function (p0, p1) {
      var tmp = p1;
      p0.ad5(tmp == null ? null : tmp.c6d_1);
      return Unit_instance;
    }, 2, 0, 163);
  }
  function CanvasLayersComposeSceneImpl$AttachedComposeSceneLayer$_get_background_$lambda_pab5jn($it, this$0) {
    return function ($this$drawBehind) {
      $this$drawBehind.b6q($it, VOID, VOID, VOID, VOID, VOID, getDialogScrimBlendMode(this$0.wd1().xd1().ucy()));
      return Unit_instance;
    };
  }
  function CanvasLayersComposeSceneImpl$AttachedComposeSceneLayer$setContent$lambda() {
    return null;
  }
  function CanvasLayersComposeSceneImpl$AttachedComposeSceneLayer$setContent$lambda_0(this$0, $content) {
    return function ($composer, $changed) {
      var $composer_0 = $composer;
      var tmp;
      if ($composer_0.r31(!(($changed & 3) === 2), $changed & 1)) {
        this$0.ld3_1.tcr(_get_background__3vp7tv(this$0));
        tmp = $content($composer_0, 0);
      } else {
        $composer_0.z30();
        tmp = Unit_instance;
      }
      return Unit_instance;
    };
  }
  function _get_focusedOwner__o339sf($this) {
    var tmp0_safe_receiver = $this.ud4_1;
    var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.ld3_1;
    return tmp1_elvis_lhs == null ? $this.ld4_1 : tmp1_elvis_lhs;
  }
  function hoveredOwner($this, event) {
    var position = first_0(event.ea7_1).ba2_1;
    var tmp0 = $this.rd4_1;
    var tmp$ret$0;
    $l$block: {
      // Inline function 'androidx.compose.ui.util.fastLastOrNull' call
      var inductionVariable = tmp0.n1() - 1 | 0;
      if (0 <= inductionVariable)
        do {
          var index = inductionVariable;
          inductionVariable = inductionVariable + -1 | 0;
          var item = tmp0.l1(index);
          if (contains_1(item, position)) {
            tmp$ret$0 = item;
            break $l$block;
          }
        }
         while (0 <= inductionVariable);
      tmp$ret$0 = null;
    }
    var tmp0_safe_receiver = tmp$ret$0;
    var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.ld3_1;
    return tmp1_elvis_lhs == null ? $this.ld4_1 : tmp1_elvis_lhs;
  }
  function isInteractive($this, owner) {
    if (owner == null || $this.ud4_1 == null) {
      return true;
    }
    if (equals(owner, $this.ld4_1)) {
      return false;
    }
    // Inline function 'androidx.compose.ui.util.fastForEach' call
    var this_0 = $this.rd4_1;
    var inductionVariable = 0;
    var last = this_0.n1() - 1 | 0;
    if (inductionVariable <= last)
      do {
        var index = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var item = this_0.l1(index);
        if (equals(item, $this.ud4_1)) {
          return true;
        }
        if (equals(item.ld3_1, owner)) {
          return false;
        }
      }
       while (inductionVariable <= last);
    return true;
  }
  function processPress($this, event) {
    var currentGestureOwner = $this.vd4_1;
    if (!(currentGestureOwner == null)) {
      return currentGestureOwner.ucr(event);
    }
    var position = first_0(event.ea7_1).ba2_1;
    // Inline function 'androidx.compose.ui.scene.CanvasLayersComposeSceneImpl.forEachLayerReversed' call
    // Inline function 'androidx.compose.ui.scene.CopiedList.withCopy' call
    var this_0 = $this.sd4_1;
    var tmp;
    if (this_0.r()) {
      tmp = this_0;
    } else {
      // Inline function 'kotlin.collections.mutableListOf' call
      tmp = ArrayList_init_$Create$();
    }
    var copy = tmp;
    access$_get_populate__bcra8v(this_0)(copy);
    try {
      // Inline function 'androidx.compose.ui.util.fastForEachReversed' call
      var inductionVariable = copy.n1() - 1 | 0;
      if (0 <= inductionVariable)
        do {
          var index = inductionVariable;
          inductionVariable = inductionVariable + -1 | 0;
          var item = copy.l1(index);
          if (contains_1(item, position)) {
            var result = item.ld3_1.ucr(event);
            $this.vd4_1 = item.ld3_1;
            return result;
          }
          item.dd5(event);
          if (equals(item, $this.ud4_1)) {
            return _PointerEventResult___init__impl__b3e4iv_0(false);
          }
        }
         while (0 <= inductionVariable);
    }finally {
      copy.c3();
    }
    var result_0 = $this.ld4_1.ucr(event);
    $this.vd4_1 = $this.ld4_1;
    return result_0;
  }
  function processRelease($this, event) {
    var tmp0_safe_receiver = $this.vd4_1;
    var result = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.ucr(event);
    if (!get_isGestureInProgress(event)) {
      var owner = hoveredOwner($this, event);
      if (isInteractive($this, owner)) {
        var tmp1_safe_receiver = processHover($this, event, owner);
        var tmp = tmp1_safe_receiver;
        if ((tmp == null ? null : new PointerEventResult(tmp)) == null)
          null;
        else {
          var tmp_0 = tmp1_safe_receiver;
          // Inline function 'kotlin.let' call
          return (tmp_0 == null ? null : new PointerEventResult(tmp_0)).dc7_1;
        }
      } else if ($this.vd4_1 == null) {
        var tmp2_safe_receiver = $this.ud4_1;
        if (tmp2_safe_receiver == null)
          null;
        else {
          tmp2_safe_receiver.dd5(event);
        }
      }
    }
    var tmp_1;
    var tmp_2 = result;
    if ((tmp_2 == null ? null : new PointerEventResult(tmp_2)) == null) {
      tmp_1 = _PointerEventResult___init__impl__b3e4iv_0(false);
    } else {
      tmp_1 = result;
    }
    return tmp_1;
  }
  function processMove($this, event) {
    var owner = get_isGestureInProgress(event) ? $this.vd4_1 : event.ca7_1 === Companion_getInstance_41().pa1_1 ? null : hoveredOwner($this, event);
    if (!isInteractive($this, owner)) {
      owner = null;
    }
    var tmp0_safe_receiver = processHover($this, event, owner);
    var tmp = tmp0_safe_receiver;
    if ((tmp == null ? null : new PointerEventResult(tmp)) == null)
      null;
    else {
      var tmp_0 = tmp0_safe_receiver;
      // Inline function 'kotlin.let' call
      return (tmp_0 == null ? null : new PointerEventResult(tmp_0)).dc7_1;
    }
    var tmp1_safe_receiver = owner;
    var tmp2_elvis_lhs = tmp1_safe_receiver == null ? null : tmp1_safe_receiver.ucr(event.xc4(Companion_getInstance_41().na1_1));
    var tmp_1;
    var tmp_2 = tmp2_elvis_lhs;
    if ((tmp_2 == null ? null : new PointerEventResult(tmp_2)) == null) {
      tmp_1 = _PointerEventResult___init__impl__b3e4iv_0(false);
    } else {
      tmp_1 = tmp2_elvis_lhs;
    }
    return tmp_1;
  }
  function processHover($this, event, owner) {
    var tmp0 = event.ea7_1;
    var tmp$ret$0;
    $l$block: {
      // Inline function 'androidx.compose.ui.util.fastAny' call
      // Inline function 'androidx.compose.ui.util.fastForEach' call
      var inductionVariable = 0;
      var last = tmp0.n1() - 1 | 0;
      if (inductionVariable <= last)
        do {
          var index = inductionVariable;
          inductionVariable = inductionVariable + 1 | 0;
          var item = tmp0.l1(index);
          if (!(item.ea2_1 === Companion_getInstance_42().na2_1)) {
            tmp$ret$0 = true;
            break $l$block;
          }
        }
         while (inductionVariable <= last);
      tmp$ret$0 = false;
    }
    if (tmp$ret$0) {
      return null;
    }
    if (equals(owner, $this.wd4_1)) {
      return null;
    }
    var tmp0_safe_receiver = $this.wd4_1;
    var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.ucr(event.xc4(Companion_getInstance_41().pa1_1));
    var tmp;
    var tmp_0 = tmp1_elvis_lhs;
    if ((tmp_0 == null ? null : new PointerEventResult(tmp_0)) == null) {
      tmp = _PointerEventResult___init__impl__b3e4iv_0(false);
    } else {
      tmp = tmp1_elvis_lhs;
    }
    var lastHoverOwnerResult = tmp;
    var tmp3_elvis_lhs = owner == null ? null : owner.ucr(event.xc4(Companion_getInstance_41().oa1_1));
    var tmp_1;
    var tmp_2 = tmp3_elvis_lhs;
    if ((tmp_2 == null ? null : new PointerEventResult(tmp_2)) == null) {
      tmp_1 = _PointerEventResult___init__impl__b3e4iv_0(false);
    } else {
      tmp_1 = tmp3_elvis_lhs;
    }
    var ownerResult = tmp_1;
    $this.wd4_1 = owner;
    return merging(lastHoverOwnerResult, ownerResult);
  }
  function processHoveredEvent($this, event) {
    var owner = hoveredOwner($this, event);
    var tmp;
    if (isInteractive($this, owner)) {
      tmp = owner.ucr(event);
    } else {
      tmp = _PointerEventResult___init__impl__b3e4iv_0(false);
    }
    return tmp;
  }
  function processUnknownEvent($this, event) {
    var gestureOwner = $this.vd4_1;
    var tmp;
    if (!(gestureOwner == null)) {
      tmp = gestureOwner.ucr(event);
    } else {
      tmp = processHoveredEvent($this, event);
    }
    return tmp;
  }
  function onOwnerAppended($this, owner) {
    var tmp0_safe_receiver = get_semanticsOwnerListener_0($this);
    if (tmp0_safe_receiver == null)
      null;
    else {
      tmp0_safe_receiver.ed5(owner.lbb());
    }
  }
  function onOwnerRemoved($this, owner) {
    if (equals(owner, $this.wd4_1)) {
      $this.wd4_1 = null;
    }
    if (equals(owner, $this.vd4_1)) {
      $this.vd4_1 = null;
    }
    var tmp0_safe_receiver = get_semanticsOwnerListener_0($this);
    if (tmp0_safe_receiver == null)
      null;
    else {
      tmp0_safe_receiver.fd5(owner.lbb());
    }
  }
  function attachLayer($this, layer) {
    // Inline function 'kotlin.check' call
    if (!!$this.md1_1) {
      var message = 'attachLayer called after ComposeScene is closed';
      throw IllegalStateException_init_$Create$(toString(message));
    }
    $this.rd4_1.j1(layer);
    if (layer.ud3_1) {
      requestFocus_2($this, layer);
    }
    onOwnerAppended($this, layer.ld3_1);
    $this.id1_1.gcq();
    $this.yd1();
  }
  function detachLayer($this, layer) {
    // Inline function 'kotlin.check' call
    if (!!$this.md1_1) {
      var message = 'detachLayer called after ComposeScene is closed';
      throw IllegalStateException_init_$Create$(toString(message));
    }
    $this.rd4_1.d3(layer);
    releaseFocus($this, layer);
    onOwnerRemoved($this, layer.ld3_1);
    $this.id1_1.gcq();
    $this.yd1();
  }
  function requestFocus_2($this, layer) {
    if (isInteractive($this, layer.ld3_1)) {
      $this.ud4_1 = layer;
    }
  }
  function releaseFocus($this, layer) {
    if (equals(layer, $this.ud4_1)) {
      var tmp = $this;
      var tmp0 = $this.rd4_1;
      var tmp$ret$0;
      $l$block: {
        // Inline function 'androidx.compose.ui.util.fastLastOrNull' call
        var inductionVariable = tmp0.n1() - 1 | 0;
        if (0 <= inductionVariable)
          do {
            var index = inductionVariable;
            inductionVariable = inductionVariable + -1 | 0;
            var item = tmp0.l1(index);
            if (item.ud3_1) {
              tmp$ret$0 = item;
              break $l$block;
            }
          }
           while (0 <= inductionVariable);
        tmp$ret$0 = null;
      }
      tmp.ud4_1 = tmp$ret$0;
    }
  }
  function AttachedComposeSceneLayer($outer, density, layoutDirection, focusable, compositionContext) {
    this.xd3_1 = $outer;
    this.kd3_1 = compositionContext;
    var tmp = this;
    var tmp0_coroutineContext = this.kd3_1.r3b();
    var tmp1_size = this.xd3_1.od4_1;
    var tmp2_platformContext = new CanvasLayersComposeSceneImpl$AttachedComposeSceneLayer$owner$1(this.xd3_1);
    var tmp3_snapshotInvalidationTracker = this.xd3_1.hd1_1;
    var tmp4_inputHandler = this.xd3_1.id1_1;
    tmp.ld3_1 = new RootNodeOwner(density, layoutDirection, tmp1_size, tmp0_coroutineContext, tmp2_platformContext, tmp3_snapshotInvalidationTracker, tmp4_inputHandler);
    this.md3_1 = null;
    this.nd3_1 = null;
    this.od3_1 = false;
    var tmp_0 = this;
    var tmp0 = this.ld3_1;
    var tmp_1 = KMutableProperty0;
    var tmp_2 = RootNodeOwner$_get_density_$ref_6pt2al_0(tmp0);
    tmp_0.pd3_1 = getPropertyCallableRef('density', 0, tmp_1, tmp_2, RootNodeOwner$_set_density_$ref_y0wtcn_0(tmp0));
    var tmp_3 = this;
    var tmp0_0 = this.ld3_1;
    var tmp_4 = KMutableProperty0;
    var tmp_5 = RootNodeOwner$_get_layoutDirection_$ref_68hoi2(tmp0_0);
    tmp_3.qd3_1 = getPropertyCallableRef('layoutDirection', 0, tmp_4, tmp_5, RootNodeOwner$_set_layoutDirection_$ref_jj7xee(tmp0_0));
    this.rd3_1 = mutableStateOf(Companion_getInstance_19().e5g_1);
    this.sd3_1 = null;
    this.td3_1 = mutableStateOf(null);
    this.ud3_1 = focusable;
    this.vd3_1 = null;
    this.wd3_1 = null;
    this.ld3_1.qcp().lbm(this.xd3_1.xd4_1);
    attachLayer(this.xd3_1, this);
  }
  protoOf(AttachedComposeSceneLayer).s6p = function (_set____db54di) {
    var tmp0 = this.pd3_1;
    var tmp = KMutableProperty1;
    var tmp_0 = CanvasLayersComposeSceneImpl$AttachedComposeSceneLayer$_get_density_$ref_21o8uv();
    // Inline function 'kotlin.setValue' call
    getPropertyCallableRef('density', 1, tmp, tmp_0, CanvasLayersComposeSceneImpl$AttachedComposeSceneLayer$_set_density_$ref_s8pxh1());
    tmp0.set(_set____db54di);
    return Unit_instance;
  };
  protoOf(AttachedComposeSceneLayer).u5e = function () {
    var tmp0 = this.pd3_1;
    var tmp = KMutableProperty1;
    var tmp_0 = CanvasLayersComposeSceneImpl$AttachedComposeSceneLayer$_get_density_$ref_21o8uv();
    // Inline function 'kotlin.getValue' call
    getPropertyCallableRef('density', 1, tmp, tmp_0, CanvasLayersComposeSceneImpl$AttachedComposeSceneLayer$_set_density_$ref_s8pxh1());
    return tmp0.get();
  };
  protoOf(AttachedComposeSceneLayer).q6p = function (_set____db54di) {
    var tmp0 = this.qd3_1;
    var tmp = KMutableProperty1;
    var tmp_0 = CanvasLayersComposeSceneImpl$AttachedComposeSceneLayer$_get_layoutDirection_$ref_22srca();
    // Inline function 'kotlin.setValue' call
    getPropertyCallableRef('layoutDirection', 1, tmp, tmp_0, CanvasLayersComposeSceneImpl$AttachedComposeSceneLayer$_set_layoutDirection_$ref_b7xhk2());
    tmp0.set(_set____db54di);
    return Unit_instance;
  };
  protoOf(AttachedComposeSceneLayer).r6p = function () {
    var tmp0 = this.qd3_1;
    var tmp = KMutableProperty1;
    var tmp_0 = CanvasLayersComposeSceneImpl$AttachedComposeSceneLayer$_get_layoutDirection_$ref_22srca();
    // Inline function 'kotlin.getValue' call
    getPropertyCallableRef('layoutDirection', 1, tmp, tmp_0, CanvasLayersComposeSceneImpl$AttachedComposeSceneLayer$_set_layoutDirection_$ref_b7xhk2());
    return tmp0.get();
  };
  protoOf(AttachedComposeSceneLayer).zd4 = function (_set____db54di) {
    var tmp0 = this.rd3_1;
    var tmp = KMutableProperty1;
    var tmp_0 = CanvasLayersComposeSceneImpl$AttachedComposeSceneLayer$_get_boundsInWindow_$ref_bnt3dd();
    // Inline function 'androidx.compose.runtime.setValue' call
    getPropertyCallableRef('boundsInWindow', 1, tmp, tmp_0, CanvasLayersComposeSceneImpl$AttachedComposeSceneLayer$_set_boundsInWindow_$ref_pffnhf());
    tmp0.s21(_set____db54di);
    return Unit_instance;
  };
  protoOf(AttachedComposeSceneLayer).yd4 = function () {
    var tmp0 = this.rd3_1;
    var tmp = KMutableProperty1;
    var tmp_0 = CanvasLayersComposeSceneImpl$AttachedComposeSceneLayer$_get_boundsInWindow_$ref_bnt3dd();
    // Inline function 'androidx.compose.runtime.getValue' call
    getPropertyCallableRef('boundsInWindow', 1, tmp, tmp_0, CanvasLayersComposeSceneImpl$AttachedComposeSceneLayer$_set_boundsInWindow_$ref_pffnhf());
    return tmp0.u1();
  };
  protoOf(AttachedComposeSceneLayer).dd2 = function (_set____db54di) {
    this.sd3_1 = _set____db54di;
  };
  protoOf(AttachedComposeSceneLayer).ad5 = function (_set____db54di) {
    var tmp0 = this.td3_1;
    var tmp = KMutableProperty1;
    var tmp_0 = CanvasLayersComposeSceneImpl$AttachedComposeSceneLayer$_get_scrimColor_$ref_cabrcu();
    getPropertyCallableRef('scrimColor', 1, tmp, tmp_0, CanvasLayersComposeSceneImpl$AttachedComposeSceneLayer$_set_scrimColor_$ref_d8room());
    var tmp_1 = _set____db54di;
    // Inline function 'androidx.compose.runtime.setValue' call
    var value = tmp_1 == null ? null : new Color(tmp_1);
    tmp0.s21(value);
    return Unit_instance;
  };
  protoOf(AttachedComposeSceneLayer).yd3 = function () {
    var tmp0 = this.td3_1;
    var tmp = KMutableProperty1;
    var tmp_0 = CanvasLayersComposeSceneImpl$AttachedComposeSceneLayer$_get_scrimColor_$ref_cabrcu();
    // Inline function 'androidx.compose.runtime.getValue' call
    getPropertyCallableRef('scrimColor', 1, tmp, tmp_0, CanvasLayersComposeSceneImpl$AttachedComposeSceneLayer$_set_scrimColor_$ref_d8room());
    var tmp_1 = tmp0.u1();
    return tmp_1 == null ? null : tmp_1.c6d_1;
  };
  protoOf(AttachedComposeSceneLayer).gd5 = function (value) {
    this.ud3_1 = value;
    if (value) {
      requestFocus_2(this.xd3_1, this);
    } else {
      releaseFocus(this.xd3_1, this);
    }
    this.xd3_1.id1_1.gcq();
    this.xd3_1.yd1();
  };
  protoOf(AttachedComposeSceneLayer).j4 = function () {
    if (this.od3_1)
      return Unit_instance;
    detachLayer(this.xd3_1, this);
    var tmp0_safe_receiver = this.md3_1;
    if (tmp0_safe_receiver == null)
      null;
    else {
      tmp0_safe_receiver.s1d();
    }
    this.md3_1 = null;
    this.ld3_1.s1d();
    this.od3_1 = true;
  };
  protoOf(AttachedComposeSceneLayer).hd5 = function (onPreviewKeyEvent, onKeyEvent) {
    this.vd3_1 = onPreviewKeyEvent;
    this.wd3_1 = onKeyEvent;
  };
  protoOf(AttachedComposeSceneLayer).w9e = function (keyEvent) {
    var tmp;
    var tmp_0;
    var tmp0_safe_receiver = this.vd3_1;
    if ((tmp0_safe_receiver == null ? null : tmp0_safe_receiver(new KeyEvent(keyEvent))) === true) {
      tmp_0 = true;
    } else {
      tmp_0 = this.ld3_1.w9e(keyEvent);
    }
    if (tmp_0) {
      tmp = true;
    } else {
      var tmp1_safe_receiver = this.wd3_1;
      tmp = (tmp1_safe_receiver == null ? null : tmp1_safe_receiver(new KeyEvent(keyEvent))) === true;
    }
    return tmp;
  };
  protoOf(AttachedComposeSceneLayer).id5 = function (onOutsidePointerEvent) {
    this.nd3_1 = onOutsidePointerEvent;
  };
  protoOf(AttachedComposeSceneLayer).k39 = function (content) {
    // Inline function 'kotlin.check' call
    if (!!this.od3_1) {
      var message = 'AttachedComposeSceneLayer is closed';
      throw IllegalStateException_init_$Create$(toString(message));
    }
    var tmp0_safe_receiver = this.md3_1;
    if (tmp0_safe_receiver == null)
      null;
    else {
      tmp0_safe_receiver.s1d();
    }
    var tmp = this;
    var tmp_0 = CanvasLayersComposeSceneImpl$AttachedComposeSceneLayer$setContent$lambda;
    tmp.md3_1 = setContent(this.ld3_1, this.kd3_1, tmp_0, ComposableLambda$invoke$ref(composableLambdaInstance(456152430, true, CanvasLayersComposeSceneImpl$AttachedComposeSceneLayer$setContent$lambda_0(this, content))));
  };
  protoOf(AttachedComposeSceneLayer).jd5 = function (positionInWindow) {
    return positionInWindow;
  };
  protoOf(AttachedComposeSceneLayer).dd5 = function (event) {
    if (!isMouseOrSingleTouch(event)) {
      return Unit_instance;
    }
    var tmp0_safe_receiver = this.nd3_1;
    if (tmp0_safe_receiver == null)
      null;
    else {
      var tmp = event.ia7_1;
      tmp0_safe_receiver(new PointerEventType(event.ca7_1), tmp == null ? null : new PointerButton(tmp));
    }
  };
  function CanvasLayersComposeSceneImpl$_init_$lambda_s8no5z() {
    return Unit_instance;
  }
  function CanvasLayersComposeSceneImpl$focusManager$lambda(this$0) {
    return function () {
      return _get_focusedOwner__o339sf(this$0).o9c();
    };
  }
  function CanvasLayersComposeSceneImpl$doMeasureAndLayout$ref(p0) {
    return constructCallableReference(function () {
      p0.zd1();
      return Unit_instance;
    }, 0, 0, 164, 'doMeasureAndLayout', [p0]);
  }
  function CanvasLayersComposeSceneImpl$rootDragAndDropNode$lambda(this$0) {
    return function () {
      return _get_focusedOwner__o339sf(this$0).vcm_1;
    };
  }
  function CanvasLayersComposeSceneImpl$_layersCopyCache$lambda(this$0) {
    return function (it) {
      it.o1(this$0.rd4_1);
      return Unit_instance;
    };
  }
  function CanvasLayersComposeSceneImpl$_ownersCopyCache$lambda(this$0) {
    return function (it) {
      it.j1(this$0.ld4_1);
      // Inline function 'androidx.compose.ui.util.fastForEach' call
      var this_0 = this$0.rd4_1;
      var inductionVariable = 0;
      var last = this_0.n1() - 1 | 0;
      if (inductionVariable <= last)
        do {
          var index = inductionVariable;
          inductionVariable = inductionVariable + 1 | 0;
          var item = this_0.l1(index);
          it.j1(item.ld3_1);
        }
         while (inductionVariable <= last);
      return Unit_instance;
    };
  }
  function CanvasLayersComposeSceneImpl$createComposition$lambda(this$0) {
    return function () {
      return this$0.cd2();
    };
  }
  function CanvasLayersComposeSceneImpl(density, layoutDirection, size, coroutineContext, platformContext, invalidate) {
    var tmp;
    if (invalidate === VOID) {
      tmp = CanvasLayersComposeSceneImpl$_init_$lambda_s8no5z;
    } else {
      tmp = invalidate;
    }
    invalidate = tmp;
    BaseComposeScene.call(this, coroutineContext, invalidate);
    this.kd4_1 = platformContext;
    this.ld4_1 = new RootNodeOwner(density, layoutDirection, size, this.ed2().r3b(), this.wd1().xd1(), this.hd1_1, this.id1_1);
    this.md4_1 = density;
    this.nd4_1 = layoutDirection;
    this.od4_1 = size;
    var tmp_0 = this;
    var tmp_1 = CanvasLayersComposeSceneImpl$focusManager$lambda(this);
    tmp_0.pd4_1 = new ComposeSceneFocusManager(tmp_1, CanvasLayersComposeSceneImpl$doMeasureAndLayout$ref(this));
    var tmp_2 = this;
    tmp_2.qd4_1 = new ComposeSceneDragAndDropNode(CanvasLayersComposeSceneImpl$rootDragAndDropNode$lambda(this));
    var tmp_3 = this;
    // Inline function 'kotlin.collections.mutableListOf' call
    tmp_3.rd4_1 = ArrayList_init_$Create$();
    var tmp_4 = this;
    tmp_4.sd4_1 = new CopiedList(CanvasLayersComposeSceneImpl$_layersCopyCache$lambda(this));
    var tmp_5 = this;
    tmp_5.td4_1 = new CopiedList(CanvasLayersComposeSceneImpl$_ownersCopyCache$lambda(this));
    this.ud4_1 = null;
    this.vd4_1 = null;
    this.wd4_1 = null;
    onOwnerAppended(this, this.ld4_1);
    this.xd4_1 = false;
  }
  protoOf(CanvasLayersComposeSceneImpl).xd1 = function () {
    return this.kd4_1;
  };
  protoOf(CanvasLayersComposeSceneImpl).wd1 = function () {
    return this;
  };
  protoOf(CanvasLayersComposeSceneImpl).s6p = function (value) {
    // Inline function 'kotlin.check' call
    if (!!this.md1_1) {
      var message = 'density set after ComposeScene is closed';
      throw IllegalStateException_init_$Create$(toString(message));
    }
    this.md4_1 = value;
    this.ld4_1.s6p(value);
  };
  protoOf(CanvasLayersComposeSceneImpl).qcr = function (value) {
    // Inline function 'kotlin.check' call
    if (!!this.md1_1) {
      var message = 'size set after ComposeScene is closed';
      throw IllegalStateException_init_$Create$(toString(message));
    }
    var tmp;
    var tmp_0 = value;
    if ((tmp_0 == null ? null : new IntSize(tmp_0)) == null) {
      tmp = true;
    } else {
      var tmp_1;
      // Inline function 'androidx.compose.ui.unit.IntSize.width' call
      // Inline function 'androidx.compose.ui.util.unpackInt1' call
      var value_0 = _IntSize___get_packedValue__impl__uho7jf(value);
      if (convertToInt(shiftRight(value_0, 32)) >= 0.0) {
        // Inline function 'androidx.compose.ui.unit.IntSize.height' call
        // Inline function 'androidx.compose.ui.util.unpackInt2' call
        var value_1 = _IntSize___get_packedValue__impl__uho7jf(value);
        tmp_1 = convertToInt(bitwiseAnd(value_1, new Long(-1, 0))) >= 0;
      } else {
        tmp_1 = false;
      }
      tmp = tmp_1;
    }
    // Inline function 'kotlin.check' call
    if (!tmp) {
      var message_0 = 'Size of ComposeScene cannot be negative';
      throw IllegalStateException_init_$Create$(toString(message_0));
    }
    this.od4_1 = value;
    this.ld4_1.qcr(value);
    // Inline function 'androidx.compose.ui.scene.CanvasLayersComposeSceneImpl.forEachLayer' call
    // Inline function 'androidx.compose.ui.scene.CopiedList.withCopy' call
    var this_0 = this.sd4_1;
    var tmp_2;
    if (this_0.r()) {
      tmp_2 = this_0;
    } else {
      // Inline function 'kotlin.collections.mutableListOf' call
      tmp_2 = ArrayList_init_$Create$();
    }
    var copy = tmp_2;
    access$_get_populate__bcra8v(this_0)(copy);
    try {
      // Inline function 'androidx.compose.ui.util.fastForEach' call
      var inductionVariable = 0;
      var last = copy.n1() - 1 | 0;
      if (inductionVariable <= last)
        do {
          var index = inductionVariable;
          inductionVariable = inductionVariable + 1 | 0;
          var item = copy.l1(index);
          item.ld3_1.qcr(value);
        }
         while (inductionVariable <= last);
    }finally {
      copy.c3();
    }
  };
  protoOf(CanvasLayersComposeSceneImpl).sd1 = function () {
    return this.pd4_1;
  };
  protoOf(CanvasLayersComposeSceneImpl).yd2 = function () {
    return this.qd4_1;
  };
  protoOf(CanvasLayersComposeSceneImpl).j4 = function () {
    // Inline function 'kotlin.check' call
    if (!!this.md1_1) {
      var message = 'ComposeScene is already closed';
      throw IllegalStateException_init_$Create$(toString(message));
    }
    onOwnerRemoved(this, this.ld4_1);
    this.ld4_1.s1d();
    // Inline function 'androidx.compose.ui.scene.CanvasLayersComposeSceneImpl.forEachLayer' call
    // Inline function 'androidx.compose.ui.scene.CopiedList.withCopy' call
    var this_0 = this.sd4_1;
    var tmp;
    if (this_0.r()) {
      tmp = this_0;
    } else {
      // Inline function 'kotlin.collections.mutableListOf' call
      tmp = ArrayList_init_$Create$();
    }
    var copy = tmp;
    access$_get_populate__bcra8v(this_0)(copy);
    try {
      // Inline function 'androidx.compose.ui.util.fastForEach' call
      var inductionVariable = 0;
      var last = copy.n1() - 1 | 0;
      if (inductionVariable <= last)
        do {
          var index = inductionVariable;
          inductionVariable = inductionVariable + 1 | 0;
          var item = copy.l1(index);
          item.j4();
        }
         while (inductionVariable <= last);
    }finally {
      copy.c3();
    }
    protoOf(BaseComposeScene).j4.call(this);
  };
  protoOf(CanvasLayersComposeSceneImpl).md2 = function (content) {
    var tmp = this.ed2();
    return setContent(this.ld4_1, tmp, CanvasLayersComposeSceneImpl$createComposition$lambda(this), content);
  };
  protoOf(CanvasLayersComposeSceneImpl).rd1 = function (event) {
    var tmp0_subject = event.ca7_1;
    var tmp;
    if (tmp0_subject === Companion_getInstance_41().la1_1) {
      tmp = processPress(this, event);
    } else if (tmp0_subject === Companion_getInstance_41().ma1_1) {
      tmp = processRelease(this, event);
    } else if (tmp0_subject === Companion_getInstance_41().na1_1) {
      tmp = processMove(this, event);
    } else if (tmp0_subject === Companion_getInstance_41().oa1_1) {
      tmp = processMove(this, event);
    } else if (tmp0_subject === Companion_getInstance_41().pa1_1) {
      tmp = processMove(this, event);
    } else if (tmp0_subject === Companion_getInstance_41().qa1_1) {
      tmp = processHoveredEvent(this, event);
    } else if (tmp0_subject === Companion_getInstance_41().ua1_1 || (tmp0_subject === Companion_getInstance_41().va1_1 || tmp0_subject === Companion_getInstance_41().wa1_1)) {
      tmp = processHoveredEvent(this, event);
    } else if (tmp0_subject === Companion_getInstance_41().ra1_1 || (tmp0_subject === Companion_getInstance_41().sa1_1 || tmp0_subject === Companion_getInstance_41().ta1_1)) {
      tmp = processHoveredEvent(this, event);
    } else if (tmp0_subject === Companion_getInstance_41().ka1_1) {
      return processUnknownEvent(this, event);
    } else {
      tmp = _PointerEventResult___init__impl__b3e4iv_0(false);
    }
    var result = tmp;
    if (!get_isGestureInProgress(event)) {
      this.vd4_1 = null;
    }
    return result;
  };
  protoOf(CanvasLayersComposeSceneImpl).ad2 = function () {
    // Inline function 'androidx.compose.ui.scene.CanvasLayersComposeSceneImpl.forEachOwner' call
    // Inline function 'androidx.compose.ui.scene.CopiedList.withCopy' call
    var this_0 = this.td4_1;
    var tmp;
    if (this_0.r()) {
      tmp = this_0;
    } else {
      // Inline function 'kotlin.collections.mutableListOf' call
      tmp = ArrayList_init_$Create$();
    }
    var copy = tmp;
    access$_get_populate__bcra8v(this_0)(copy);
    try {
      // Inline function 'androidx.compose.ui.util.fastForEach' call
      var inductionVariable = 0;
      var last = copy.n1() - 1 | 0;
      if (inductionVariable <= last)
        do {
          var index = inductionVariable;
          inductionVariable = inductionVariable + 1 | 0;
          var item = copy.l1(index);
          item.xa1();
        }
         while (inductionVariable <= last);
    }finally {
      copy.c3();
    }
    this.vd4_1 = null;
  };
  protoOf(CanvasLayersComposeSceneImpl).bd2 = function (keyEvent) {
    var tmp0_safe_receiver = this.ud4_1;
    var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.w9e(keyEvent);
    return tmp1_elvis_lhs == null ? this.ld4_1.w9e(keyEvent) : tmp1_elvis_lhs;
  };
  protoOf(CanvasLayersComposeSceneImpl).scr = function () {
    // Inline function 'androidx.compose.ui.scene.CanvasLayersComposeSceneImpl.forEachOwner' call
    // Inline function 'androidx.compose.ui.scene.CopiedList.withCopy' call
    var this_0 = this.td4_1;
    var tmp;
    if (this_0.r()) {
      tmp = this_0;
    } else {
      // Inline function 'kotlin.collections.mutableListOf' call
      tmp = ArrayList_init_$Create$();
    }
    var copy = tmp;
    access$_get_populate__bcra8v(this_0)(copy);
    try {
      // Inline function 'androidx.compose.ui.util.fastForEach' call
      var inductionVariable = 0;
      var last = copy.n1() - 1 | 0;
      if (inductionVariable <= last)
        do {
          var index = inductionVariable;
          inductionVariable = inductionVariable + 1 | 0;
          var item = copy.l1(index);
          item.scr();
        }
         while (inductionVariable <= last);
    }finally {
      copy.c3();
    }
  };
  protoOf(CanvasLayersComposeSceneImpl).zcq = function (canvas) {
    // Inline function 'androidx.compose.ui.scene.CanvasLayersComposeSceneImpl.forEachOwner' call
    // Inline function 'androidx.compose.ui.scene.CopiedList.withCopy' call
    var this_0 = this.td4_1;
    var tmp;
    if (this_0.r()) {
      tmp = this_0;
    } else {
      // Inline function 'kotlin.collections.mutableListOf' call
      tmp = ArrayList_init_$Create$();
    }
    var copy = tmp;
    access$_get_populate__bcra8v(this_0)(copy);
    try {
      // Inline function 'androidx.compose.ui.util.fastForEach' call
      var inductionVariable = 0;
      var last = copy.n1() - 1 | 0;
      if (inductionVariable <= last)
        do {
          var index = inductionVariable;
          inductionVariable = inductionVariable + 1 | 0;
          var item = copy.l1(index);
          item.zcq(canvas);
        }
         while (inductionVariable <= last);
    }finally {
      copy.c3();
    }
  };
  protoOf(CanvasLayersComposeSceneImpl).kd5 = function (density, layoutDirection, focusable, compositionContext) {
    return new AttachedComposeSceneLayer(this, density, layoutDirection, focusable, compositionContext);
  };
  function access$_get_populate__bcra8v($this) {
    return $this.cd5_1;
  }
  function CopiedList(populate) {
    var tmp = this;
    // Inline function 'kotlin.collections.mutableListOf' call
    tmp.bd5_1 = ArrayList_init_$Create$();
    this.cd5_1 = populate;
  }
  protoOf(CopiedList).zz = function (element) {
    return this.bd5_1.j1(element);
  };
  protoOf(CopiedList).j1 = function (element) {
    return this.zz(element);
  };
  protoOf(CopiedList).ni = function (index, element) {
    this.bd5_1.g3(index, element);
  };
  protoOf(CopiedList).g3 = function (index, element) {
    return this.ni(index, element);
  };
  protoOf(CopiedList).g10 = function (element) {
    return this.bd5_1.d3(element);
  };
  protoOf(CopiedList).d3 = function (element) {
    if (!true)
      return false;
    return this.g10(element);
  };
  protoOf(CopiedList).e10 = function (elements) {
    return this.bd5_1.o1(elements);
  };
  protoOf(CopiedList).o1 = function (elements) {
    return this.e10(elements);
  };
  protoOf(CopiedList).d10 = function (index, elements) {
    return this.bd5_1.e3(index, elements);
  };
  protoOf(CopiedList).e3 = function (index, elements) {
    return this.d10(index, elements);
  };
  protoOf(CopiedList).c3 = function () {
    this.bd5_1.c3();
  };
  protoOf(CopiedList).mi = function (index, element) {
    return this.bd5_1.f3(index, element);
  };
  protoOf(CopiedList).f3 = function (index, element) {
    return this.mi(index, element);
  };
  protoOf(CopiedList).h3 = function (index) {
    return this.bd5_1.h3(index);
  };
  protoOf(CopiedList).p1 = function (index) {
    return this.bd5_1.p1(index);
  };
  protoOf(CopiedList).t2 = function (fromIndex, toIndex) {
    return this.bd5_1.t2(fromIndex, toIndex);
  };
  protoOf(CopiedList).r = function () {
    return this.bd5_1.r();
  };
  protoOf(CopiedList).lh = function (element) {
    return this.bd5_1.m1(element);
  };
  protoOf(CopiedList).m1 = function (element) {
    if (!true)
      return false;
    return this.lh(element);
  };
  protoOf(CopiedList).t = function () {
    return this.bd5_1.t();
  };
  protoOf(CopiedList).mh = function (elements) {
    return this.bd5_1.r2(elements);
  };
  protoOf(CopiedList).r2 = function (elements) {
    return this.mh(elements);
  };
  protoOf(CopiedList).l1 = function (index) {
    return this.bd5_1.l1(index);
  };
  protoOf(CopiedList).yz = function (element) {
    return this.bd5_1.q1(element);
  };
  protoOf(CopiedList).q1 = function (element) {
    if (!true)
      return -1;
    return this.yz(element);
  };
  protoOf(CopiedList).n1 = function () {
    return this.bd5_1.n1();
  };
  function get_isGestureInProgress(_this__u8e3s4) {
    var tmp0 = _this__u8e3s4.ea7_1;
    var tmp$ret$0;
    $l$block: {
      // Inline function 'androidx.compose.ui.util.fastAny' call
      // Inline function 'androidx.compose.ui.util.fastForEach' call
      var inductionVariable = 0;
      var last = tmp0.n1() - 1 | 0;
      if (inductionVariable <= last)
        do {
          var index = inductionVariable;
          inductionVariable = inductionVariable + 1 | 0;
          var item = tmp0.l1(index);
          if (item.ca2_1) {
            tmp$ret$0 = true;
            break $l$block;
          }
        }
         while (inductionVariable <= last);
      tmp$ret$0 = false;
    }
    return tmp$ret$0;
  }
  function isMouseOrSingleTouch(_this__u8e3s4) {
    var tmp;
    var tmp_0 = _this__u8e3s4.ia7_1;
    if (!((tmp_0 == null ? null : new PointerButton(tmp_0)) == null)) {
      tmp = true;
    } else {
      tmp = _this__u8e3s4.ea7_1.n1() === 1;
    }
    return tmp;
  }
  function CanvasLayersComposeScene$lambda() {
    return Unit_instance;
  }
  function get_LocalComposeScene() {
    _init_properties_ComposeScene_skiko_kt__5e2gu9();
    return LocalComposeScene;
  }
  var LocalComposeScene;
  function ComposeScene() {
  }
  function LocalComposeScene$lambda() {
    _init_properties_ComposeScene_skiko_kt__5e2gu9();
    return null;
  }
  var properties_initialized_ComposeScene_skiko_kt_ips5q5;
  function _init_properties_ComposeScene_skiko_kt__5e2gu9() {
    if (!properties_initialized_ComposeScene_skiko_kt_ips5q5) {
      properties_initialized_ComposeScene_skiko_kt_ips5q5 = true;
      LocalComposeScene = staticCompositionLocalOf(LocalComposeScene$lambda);
    }
  }
  function get_LocalComposeSceneContext() {
    _init_properties_ComposeSceneContext_skiko_kt__pf3nau();
    return LocalComposeSceneContext;
  }
  var LocalComposeSceneContext;
  var androidx_compose_ui_scene_ComposeSceneContext_Empty$stable;
  function ComposeSceneContext() {
  }
  function requireCurrent(_this__u8e3s4, $composer, $changed) {
    _init_properties_ComposeSceneContext_skiko_kt__pf3nau();
    var $composer_0 = $composer;
    // Inline function 'androidx.compose.runtime.CompositionLocal.current' call
    var $composer_1 = $composer_0;
    var tmp0_elvis_lhs = $composer_1.u31(_this__u8e3s4);
    var tmp;
    if (tmp0_elvis_lhs == null) {
      // Inline function 'kotlin.error' call
      var message = 'CompositionLocal LocalComposeSceneContext not provided';
      throw IllegalStateException_init_$Create$(toString(message));
    } else {
      tmp = tmp0_elvis_lhs;
    }
    return tmp;
  }
  function LocalComposeSceneContext$lambda() {
    _init_properties_ComposeSceneContext_skiko_kt__pf3nau();
    return null;
  }
  var properties_initialized_ComposeSceneContext_skiko_kt_asxsb8;
  function _init_properties_ComposeSceneContext_skiko_kt__pf3nau() {
    if (!properties_initialized_ComposeSceneContext_skiko_kt_asxsb8) {
      properties_initialized_ComposeSceneContext_skiko_kt_asxsb8 = true;
      LocalComposeSceneContext = staticCompositionLocalOf(LocalComposeSceneContext$lambda);
      androidx_compose_ui_scene_ComposeSceneContext_Empty$stable = 8;
    }
  }
  var androidx_compose_ui_scene_ComposeSceneDragAndDropNode$stable;
  function _get_currentRootNode__sgrtnw($this) {
    return $this.ld5_1().mck_1;
  }
  function ensureStartedOwner($this, event) {
    var currentOwner = $this.ld5_1();
    if (!equals($this.md5_1, currentOwner)) {
      var tmp0_safe_receiver = $this.md5_1;
      if (tmp0_safe_receiver == null)
        null;
      else {
        tmp0_safe_receiver.a8z(event);
      }
      $this.md5_1 = currentOwner;
      var tmp1_safe_receiver = $this.md5_1;
      if (tmp1_safe_receiver == null)
        null;
      else {
        tmp1_safe_receiver.w8y(event);
      }
    }
    return currentOwner;
  }
  function ComposeSceneDragAndDropNode(dragAndDropOwner) {
    this.ld5_1 = dragAndDropOwner;
    this.md5_1 = null;
  }
  protoOf(ComposeSceneDragAndDropNode).w91 = function (startEvent) {
    var tmp0_safe_receiver = this.md5_1;
    if (tmp0_safe_receiver == null)
      null;
    else {
      tmp0_safe_receiver.a8z(startEvent);
    }
    this.md5_1 = null;
    return _get_currentRootNode__sgrtnw(this).w91(startEvent);
  };
  protoOf(ComposeSceneDragAndDropNode).nd5 = function (_this__u8e3s4, offset, isTransferStarted) {
    // Inline function 'kotlin.with' call
    _get_currentRootNode__sgrtnw(this).v91(asDragAndDropStartTransferScope(_this__u8e3s4), offset, isTransferStarted);
    return Unit_instance;
  };
  protoOf(ComposeSceneDragAndDropNode).v8y = function (event) {
    return ensureStartedOwner(this, event).v8y(event);
  };
  protoOf(ComposeSceneDragAndDropNode).w8y = function (event) {
    ensureStartedOwner(this, event);
  };
  protoOf(ComposeSceneDragAndDropNode).x8y = function (event) {
    return ensureStartedOwner(this, event).x8y(event);
  };
  protoOf(ComposeSceneDragAndDropNode).y8y = function (event) {
    return ensureStartedOwner(this, event).y8y(event);
  };
  protoOf(ComposeSceneDragAndDropNode).z8y = function (event) {
    return ensureStartedOwner(this, event).z8y(event);
  };
  protoOf(ComposeSceneDragAndDropNode).a8z = function (event) {
    var tmp0_safe_receiver = this.md5_1;
    if (tmp0_safe_receiver == null)
      null;
    else {
      tmp0_safe_receiver.a8z(event);
    }
    this.md5_1 = null;
  };
  function asDragAndDropStartTransferScope(_this__u8e3s4) {
    return new asDragAndDropStartTransferScope$1(_this__u8e3s4);
  }
  function asDragAndDropStartTransferScope$1($this_asDragAndDropStartTransferScope) {
    this.od5_1 = $this_asDragAndDropStartTransferScope;
  }
  var androidx_compose_ui_scene_ComposeSceneFocusManager$stable;
  function ComposeSceneFocusManager(focusOwner, measureAndLayout) {
    this.td1_1 = focusOwner;
    this.ud1_1 = measureAndLayout;
  }
  protoOf(ComposeSceneFocusManager).vd1 = function (position) {
    // Inline function 'androidx.compose.ui.scene.ComposeSceneFocusManager.measureAndLayoutThen' call
    this.ud1_1();
    var focusOwner = this.td1_1();
    var activeFocusTargetNode = focusOwner.v9c();
    if (!(activeFocusTargetNode == null)) {
      var focusedNodeBounds = boundsInRoot(requireLayoutCoordinates(activeFocusTargetNode));
      if (!focusedNodeBounds.u5d(position)) {
        focusOwner.e9d();
      }
    }
    return Unit_instance;
  };
  var androidx_compose_ui_scene_ComposeSceneInputHandler$stable;
  function updatePointerPositions($this, event) {
    // Inline function 'androidx.compose.ui.util.fastForEach' call
    var this_0 = event.ea7_1;
    var inductionVariable = 0;
    var last = this_0.n1() - 1 | 0;
    if (inductionVariable <= last)
      do {
        var index = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var item = this_0.l1(index);
        if (item.ea2_1 === Companion_getInstance_42().na2_1 && !(event.ca7_1 === Companion_getInstance_41().pa1_1) || item.ca2_1) {
          var tmp0 = $this.ecq_1;
          var tmp2 = new PointerId(item.ya1_1);
          // Inline function 'kotlin.collections.set' call
          var value = new Offset(item.ba2_1);
          tmp0.z2(tmp2, value);
        }
      }
       while (inductionVariable <= last);
    // Inline function 'kotlin.collections.iterator' call
    var iterator = $this.ecq_1.s1().t();
    $l$loop: while (iterator.u()) {
      var pointerId = iterator.v().t1().wa2_1;
      var tmp0_0 = event.ea7_1;
      var tmp$ret$4;
      $l$block: {
        // Inline function 'androidx.compose.ui.util.fastFirstOrNull' call
        // Inline function 'androidx.compose.ui.util.fastForEach' call
        var inductionVariable_0 = 0;
        var last_0 = tmp0_0.n1() - 1 | 0;
        if (inductionVariable_0 <= last_0)
          do {
            var index_0 = inductionVariable_0;
            inductionVariable_0 = inductionVariable_0 + 1 | 0;
            var item_0 = tmp0_0.l1(index_0);
            if (equals(item_0.ya1_1, pointerId)) {
              tmp$ret$4 = item_0;
              break $l$block;
            }
          }
           while (inductionVariable_0 <= last_0);
        tmp$ret$4 = null;
      }
      var tmp0_elvis_lhs = tmp$ret$4;
      var tmp;
      if (tmp0_elvis_lhs == null) {
        continue $l$loop;
      } else {
        tmp = tmp0_elvis_lhs;
      }
      var pointer = tmp;
      if (!(pointer.ea2_1 === Companion_getInstance_42().na2_1) && !pointer.ca2_1 || (pointer.ea2_1 === Companion_getInstance_42().na2_1 && event.ca7_1 === Companion_getInstance_41().pa1_1)) {
        iterator.l4();
      }
    }
  }
  function withTrackedModifiers($this, $receiver) {
    var tmp;
    if (get_internal($receiver).pc4_1 == null && _PointerKeyboardModifiers___get_packedValue__impl__7vcep7(get_internal($receiver).oc4_1) === 0) {
      tmp = copy($receiver, VOID, VOID, VOID, $this.dcq_1.qd5_1);
    } else {
      tmp = $receiver;
    }
    return tmp;
  }
  function ComposeSceneInputHandler(prepareForPointerInputEvent, processPointerInputEvent, cancelPointerInput, processKeyEvent) {
    this.acq_1 = prepareForPointerInputEvent;
    this.bcq_1 = cancelPointerInput;
    this.ccq_1 = processKeyEvent;
    this.dcq_1 = new DefaultPointerStateTracker();
    this.ecq_1 = mutableStateMapOf();
    this.fcq_1 = new SyntheticEventSender(processPointerInputEvent);
  }
  protoOf(ComposeSceneInputHandler).rd5 = function () {
    var tmp = firstOrNull_0(this.ecq_1.i58_1);
    return tmp == null ? null : tmp.e5d_1;
  };
  protoOf(ComposeSceneInputHandler).qd2 = function () {
    return this.fcq_1.cc7_1;
  };
  protoOf(ComposeSceneInputHandler).sd2 = function (eventType, position, scrollDelta, timeMillis, type, buttons, keyboardModifiers, nativeEvent, button, scaleGestureFactor, panGestureOffset) {
    this.dcq_1.sd5(button, eventType);
    var tmp;
    var tmp_0 = buttons;
    if ((tmp_0 == null ? null : new PointerButtons(tmp_0)) == null) {
      tmp = this.dcq_1.pd5_1;
    } else {
      tmp = buttons;
    }
    var actualButtons = tmp;
    var tmp_1;
    var tmp_2 = keyboardModifiers;
    if ((tmp_2 == null ? null : new PointerKeyboardModifiers(tmp_2)) == null) {
      tmp_1 = this.dcq_1.qd5_1;
    } else {
      tmp_1 = keyboardModifiers;
    }
    var actualKeyboardModifiers = tmp_1;
    return this.vd2(eventType, listOf(new ComposeScenePointer(_PointerId___init__impl__w2urwh(new Long(0, 0)), position, get_areAnyPressed(actualButtons), type)), actualButtons, actualKeyboardModifiers, scrollDelta, timeMillis, nativeEvent, button, scaleGestureFactor, panGestureOffset);
  };
  protoOf(ComposeSceneInputHandler).vd2 = function (eventType, pointers, buttons, keyboardModifiers, scrollDelta, timeMillis, nativeEvent, button, scaleGestureFactor, panGestureOffset) {
    var event = PointerInputEvent_0(eventType, pointers, timeMillis, nativeEvent, scrollDelta, buttons, keyboardModifiers, button, scaleGestureFactor, panGestureOffset);
    this.acq_1();
    var updatePointerPositionResult = this.fc7();
    var eventResult = this.fcq_1.ec7(event);
    updatePointerPositions(this, event);
    return merging(updatePointerPositionResult, eventResult);
  };
  protoOf(ComposeSceneInputHandler).w9e = function (keyEvent) {
    this.dcq_1.td5(keyEvent);
    return this.ccq_1(new KeyEvent(withTrackedModifiers(this, keyEvent)));
  };
  protoOf(ComposeSceneInputHandler).fc7 = function () {
    // Inline function 'androidx.compose.ui.util.trace' call
    return this.fcq_1.fc7();
  };
  protoOf(ComposeSceneInputHandler).kd2 = function () {
    this.fcq_1.u4c();
  };
  protoOf(ComposeSceneInputHandler).gcq = function () {
    this.fcq_1.cc7_1 = true;
  };
  function DefaultPointerStateTracker() {
    this.pd5_1 = PointerButtons_0();
    this.qd5_1 = PointerKeyboardModifiers_0();
  }
  protoOf(DefaultPointerStateTracker).sd5 = function (button, eventType) {
    var tmp = this;
    var tmp_0 = this.pd5_1;
    var tmp_1;
    var tmp_2 = button;
    if ((tmp_2 == null ? null : new PointerButton(tmp_2)) == null) {
      tmp_1 = Companion_getInstance_71().qc4_1;
    } else {
      tmp_1 = button;
    }
    tmp.pd5_1 = update(tmp_0, tmp_1, eventType);
  };
  protoOf(DefaultPointerStateTracker).td5 = function (keyEvent) {
    this.qd5_1 = update_0(this.qd5_1, get_key_0(keyEvent), get_type(keyEvent));
  };
  function update(_this__u8e3s4, button, eventType) {
    var tmp;
    if (eventType === Companion_getInstance_41().la1_1) {
      tmp = true;
    } else if (eventType === Companion_getInstance_41().ma1_1) {
      tmp = false;
    } else {
      return _this__u8e3s4;
    }
    var pressed = tmp;
    return button === Companion_getInstance_71().qc4_1 ? copy_0(_this__u8e3s4, pressed) : button === Companion_getInstance_71().rc4_1 ? copy_0(_this__u8e3s4, VOID, pressed) : button === Companion_getInstance_71().sc4_1 ? copy_0(_this__u8e3s4, VOID, VOID, pressed) : button === Companion_getInstance_71().uc4_1 ? copy_0(_this__u8e3s4, VOID, VOID, VOID, VOID, pressed) : button === Companion_getInstance_71().tc4_1 ? copy_0(_this__u8e3s4, VOID, VOID, VOID, pressed) : _this__u8e3s4;
  }
  function update_0(_this__u8e3s4, key, eventType) {
    var tmp;
    if (eventType === Companion_getInstance_39().e9e_1) {
      tmp = true;
    } else if (eventType === Companion_getInstance_39().d9e_1) {
      tmp = false;
    } else {
      return _this__u8e3s4;
    }
    var pressed = tmp;
    return equals(key, Companion_getInstance_75().ecb_1) || equals(key, Companion_getInstance_75().fcb_1) ? copy_1(_this__u8e3s4, pressed) : equals(key, Companion_getInstance_75().icb_1) || equals(key, Companion_getInstance_75().jcb_1) ? copy_1(_this__u8e3s4, VOID, pressed) : equals(key, Companion_getInstance_75().uca_1) || equals(key, Companion_getInstance_75().vca_1) ? copy_1(_this__u8e3s4, VOID, VOID, pressed) : equals(key, Companion_getInstance_75().wca_1) || equals(key, Companion_getInstance_75().xca_1) ? copy_1(_this__u8e3s4, VOID, VOID, VOID, pressed) : equals(key, Companion_getInstance_75().wcd_1) ? copy_1(_this__u8e3s4, VOID, VOID, VOID, VOID, VOID, pressed) : equals(key, Companion_getInstance_75().zcd_1) ? copy_1(_this__u8e3s4, VOID, VOID, VOID, VOID, VOID, VOID, pressed) : equals(key, Companion_getInstance_75().gcb_1) ? copy_1(_this__u8e3s4, VOID, VOID, VOID, VOID, VOID, VOID, VOID, pressed) : equals(key, Companion_getInstance_75().hcb_1) ? copy_1(_this__u8e3s4, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, pressed) : equals(key, Companion_getInstance_75().gcc_1) ? copy_1(_this__u8e3s4, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, pressed) : _this__u8e3s4;
  }
  function ComposeSceneInputHandler$onPointerUpdate$ref(p0) {
    return constructCallableReference(function () {
      p0.gcq();
      return Unit_instance;
    }, 0, 0, 165, 'onPointerUpdate', [p0]);
  }
  function ComposeSceneInputHandler$_get_lastKnownPointerPosition_$ref_oik3lh(p0) {
    return constructCallableReference(function () {
      var tmp = p0.rd5();
      return tmp == null ? null : new Offset(tmp);
    }, 0, 0, 166, VOID, [p0]);
  }
  function rememberComposeSceneLayer(focusable, $composer, $changed, $default) {
    var focusable_0 = focusable;
    var $composer_0 = $composer;
    if (!(($default & 1) === 0))
      focusable_0 = false;
    var sceneContext = requireCurrent(get_LocalComposeSceneContext(), $composer_0, 6);
    // Inline function 'androidx.compose.runtime.CompositionLocal.current' call
    var this_0 = get_LocalDensity();
    var $composer_1 = $composer_0;
    var density = $composer_1.u31(this_0);
    // Inline function 'androidx.compose.runtime.CompositionLocal.current' call
    var this_1 = get_LocalLayoutDirection();
    var $composer_2 = $composer_0;
    var layoutDirection = $composer_2.u31(this_1);
    var parentComposition = rememberCompositionContext($composer_0, 0);
    var compositionLocalContext = get_currentCompositionLocalContext($composer_0, 0);
    // Inline function 'androidx.compose.runtime.cache' call
    // Inline function 'kotlin.let' call
    var it = $composer_0.i31();
    var tmp;
    if (false || it === Companion_getInstance_9().f30_1) {
      var value = sceneContext.kd5(density, layoutDirection, focusable_0, parentComposition);
      $composer_0.j31(value);
      tmp = value;
    } else {
      tmp = it;
    }
    var layer = tmp;
    layer.gd5(focusable_0);
    layer.dd2(compositionLocalContext);
    layer.s6p(density);
    layer.q6p(layoutDirection);
    return layer;
  }
  function Content(_this__u8e3s4, content, $composer, $changed) {
    var $composer_0 = $composer;
    $composer_0 = $composer_0.s30(-1084618316);
    var $dirty = $changed;
    if (($changed & 6) === 0)
      $dirty = $dirty | ((($changed & 8) === 0 ? $composer_0.k31(_this__u8e3s4) : $composer_0.q31(_this__u8e3s4)) ? 4 : 2);
    if (($changed & 48) === 0)
      $dirty = $dirty | ($composer_0.q31(content) ? 32 : 16);
    if ($composer_0.r31(!(($dirty & 19) === 18), $dirty & 1)) {
      var tmp0 = $composer_0;
      // Inline function 'androidx.compose.runtime.cache' call
      var invalid = !!((($dirty & 14) === 4 || (!(($dirty & 8) === 0) && $composer_0.q31(_this__u8e3s4))) | ($dirty & 112) === 32);
      // Inline function 'kotlin.let' call
      var it = tmp0.i31();
      var tmp;
      if (invalid || it === Companion_getInstance_9().f30_1) {
        var value = Content$lambda(_this__u8e3s4, content);
        tmp0.j31(value);
        tmp = value;
      } else {
        tmp = it;
      }
      var tmp$ret$0 = tmp;
      DisposableEffect_0(_this__u8e3s4, content, tmp$ret$0, $composer_0, 14 & $dirty | 112 & $dirty);
    } else {
      $composer_0.z30();
    }
    var tmp0_safe_receiver = $composer_0.t30();
    if (tmp0_safe_receiver == null)
      null;
    else {
      tmp0_safe_receiver.p3c(Content$lambda_0(_this__u8e3s4, content, $changed));
    }
  }
  function contains_1(_this__u8e3s4, point) {
    return _this__u8e3s4.yd4().m5g(round(point));
  }
  function Content$$inlined$cache$1$1() {
  }
  protoOf(Content$$inlined$cache$1$1).s1d = function () {
  };
  function Content$lambda($this_Content, $content) {
    return function ($this$DisposableEffect) {
      $this_Content.k39($content);
      // Inline function 'androidx.compose.runtime.DisposableEffectScope.onDispose' call
      return new Content$$inlined$cache$1$1();
    };
  }
  function Content$lambda_0($this_Content, $content, $$changed) {
    return function ($composer, $force) {
      Content($this_Content, $content, $composer, updateChangedFlags($$changed | 1));
      return Unit_instance;
    };
  }
  var androidx_compose_ui_scene_ComposeScenePointer$stable;
  function _PointerEventResult___init__impl__b3e4iv(value) {
    return value;
  }
  function _PointerEventResult___get_value__impl__1zjqdh($this) {
    return $this;
  }
  function _PointerEventResult___init__impl__b3e4iv_0(anyMovementConsumed, anyChangeConsumed, dispatchedToAPointerInputModifier) {
    anyMovementConsumed = anyMovementConsumed === VOID ? false : anyMovementConsumed;
    anyChangeConsumed = anyChangeConsumed === VOID ? false : anyChangeConsumed;
    dispatchedToAPointerInputModifier = dispatchedToAPointerInputModifier === VOID ? false : dispatchedToAPointerInputModifier;
    // Inline function 'androidx.compose.ui.scene.toInt' call
    var tmp = dispatchedToAPointerInputModifier ? 1 : 0;
    // Inline function 'androidx.compose.ui.scene.toInt' call
    var tmp_0 = tmp | (anyMovementConsumed ? 1 : 0) << 1;
    // Inline function 'androidx.compose.ui.scene.toInt' call
    var tmp$ret$2 = anyChangeConsumed ? 1 : 0;
    return _PointerEventResult___init__impl__b3e4iv(tmp_0 | tmp$ret$2 << 2);
  }
  function PointerEventResult__toString_impl_n42xq1($this) {
    return 'PointerEventResult(value=' + $this + ')';
  }
  function PointerEventResult__hashCode_impl_q5v7g8($this) {
    return $this;
  }
  function PointerEventResult__equals_impl_w3xqgc($this, other) {
    if (!(other instanceof PointerEventResult))
      return false;
    if (!($this === other.dc7_1))
      return false;
    return true;
  }
  function PointerEventResult(value) {
    this.dc7_1 = value;
  }
  protoOf(PointerEventResult).toString = function () {
    return PointerEventResult__toString_impl_n42xq1(this.dc7_1);
  };
  protoOf(PointerEventResult).hashCode = function () {
    return PointerEventResult__hashCode_impl_q5v7g8(this.dc7_1);
  };
  protoOf(PointerEventResult).equals = function (other) {
    return PointerEventResult__equals_impl_w3xqgc(this.dc7_1, other);
  };
  function ComposeScenePointer(id, position, pressed, type, pressure, historical) {
    type = type === VOID ? Companion_getInstance_42().na2_1 : type;
    pressure = pressure === VOID ? 1.0 : pressure;
    historical = historical === VOID ? emptyList() : historical;
    this.ud5_1 = id;
    this.vd5_1 = position;
    this.wd5_1 = pressed;
    this.xd5_1 = type;
    this.yd5_1 = pressure;
    this.zd5_1 = historical;
  }
  protoOf(ComposeScenePointer).equals = function (other) {
    if (this === other)
      return true;
    if (other == null || !getKClassFromExpression(this).equals(getKClassFromExpression(other)))
      return false;
    if (!(other instanceof ComposeScenePointer))
      THROW_CCE();
    if (!equals(this.vd5_1, other.vd5_1))
      return false;
    if (!(this.wd5_1 === other.wd5_1))
      return false;
    if (!(this.xd5_1 === other.xd5_1))
      return false;
    if (!equals(this.ud5_1, other.ud5_1))
      return false;
    if (!(this.yd5_1 === other.yd5_1))
      return false;
    return true;
  };
  protoOf(ComposeScenePointer).hashCode = function () {
    var result = Offset__hashCode_impl_hbql41(this.vd5_1);
    result = imul(31, result) + getBooleanHashCode(this.wd5_1) | 0;
    result = imul(31, result) + PointerType__hashCode_impl_d0afh7(this.xd5_1) | 0;
    result = imul(31, result) + PointerId__hashCode_impl_vobdra(this.ud5_1) | 0;
    result = imul(31, result) + getNumberHashCode(this.yd5_1) | 0;
    return result;
  };
  protoOf(ComposeScenePointer).toString = function () {
    return 'Pointer(position=' + Offset__toString_impl_4ffbou(this.vd5_1) + ', pressed=' + this.wd5_1 + ', type=' + PointerType__toString_impl_yrgca2(this.xd5_1) + ', id=' + PointerId__toString_impl_9x5gyf(this.ud5_1) + ', pressure=' + this.yd5_1 + ')';
  };
  function merging(_this__u8e3s4, result1, result2, result3, result4, result5, result6, result7) {
    result2 = result2 === VOID ? null : result2;
    result3 = result3 === VOID ? null : result3;
    result4 = result4 === VOID ? null : result4;
    result5 = result5 === VOID ? null : result5;
    result6 = result6 === VOID ? null : result6;
    result7 = result7 === VOID ? null : result7;
    var tmp = _PointerEventResult___get_value__impl__1zjqdh(_this__u8e3s4) | _PointerEventResult___get_value__impl__1zjqdh(result1);
    var tmp_0;
    var tmp_1 = result2;
    if ((tmp_1 == null ? null : new PointerEventResult(tmp_1)) == null) {
      tmp_0 = null;
    } else {
      tmp_0 = _PointerEventResult___get_value__impl__1zjqdh(result2);
    }
    var tmp1_elvis_lhs = tmp_0;
    var tmp_2 = tmp | (tmp1_elvis_lhs == null ? 0 : tmp1_elvis_lhs);
    var tmp_3;
    var tmp_4 = result3;
    if ((tmp_4 == null ? null : new PointerEventResult(tmp_4)) == null) {
      tmp_3 = null;
    } else {
      tmp_3 = _PointerEventResult___get_value__impl__1zjqdh(result3);
    }
    var tmp3_elvis_lhs = tmp_3;
    var tmp_5 = tmp_2 | (tmp3_elvis_lhs == null ? 0 : tmp3_elvis_lhs);
    var tmp_6;
    var tmp_7 = result4;
    if ((tmp_7 == null ? null : new PointerEventResult(tmp_7)) == null) {
      tmp_6 = null;
    } else {
      tmp_6 = _PointerEventResult___get_value__impl__1zjqdh(result4);
    }
    var tmp5_elvis_lhs = tmp_6;
    var tmp_8 = tmp_5 | (tmp5_elvis_lhs == null ? 0 : tmp5_elvis_lhs);
    var tmp_9;
    var tmp_10 = result5;
    if ((tmp_10 == null ? null : new PointerEventResult(tmp_10)) == null) {
      tmp_9 = null;
    } else {
      tmp_9 = _PointerEventResult___get_value__impl__1zjqdh(result5);
    }
    var tmp7_elvis_lhs = tmp_9;
    var tmp_11 = tmp_8 | (tmp7_elvis_lhs == null ? 0 : tmp7_elvis_lhs);
    var tmp_12;
    var tmp_13 = result6;
    if ((tmp_13 == null ? null : new PointerEventResult(tmp_13)) == null) {
      tmp_12 = null;
    } else {
      tmp_12 = _PointerEventResult___get_value__impl__1zjqdh(result6);
    }
    var tmp9_elvis_lhs = tmp_12;
    var tmp_14 = tmp_11 | (tmp9_elvis_lhs == null ? 0 : tmp9_elvis_lhs);
    var tmp_15;
    var tmp_16 = result7;
    if ((tmp_16 == null ? null : new PointerEventResult(tmp_16)) == null) {
      tmp_15 = null;
    } else {
      tmp_15 = _PointerEventResult___get_value__impl__1zjqdh(result7);
    }
    var tmp11_elvis_lhs = tmp_15;
    return _PointerEventResult___init__impl__b3e4iv(tmp_14 | (tmp11_elvis_lhs == null ? 0 : tmp11_elvis_lhs));
  }
  function PointerInputEvent_0(eventType, pointers, timeMillis, nativeEvent, scrollDelta, buttons, keyboardModifiers, changedButton, scaleGestureFactor, panGestureOffset) {
    // Inline function 'androidx.compose.ui.util.fastMap' call
    var target = ArrayList_init_$Create$_0(pointers.n1());
    // Inline function 'androidx.compose.ui.util.fastForEach' call
    var inductionVariable = 0;
    var last = pointers.n1() - 1 | 0;
    if (inductionVariable <= last)
      do {
        var index = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var item = pointers.l1(index);
        var tmp0_id = item.ud5_1;
        var tmp1_positionOnScreen = item.vd5_1;
        var tmp2_position = item.vd5_1;
        var tmp3_down = item.wd5_1;
        var tmp4_pressure = item.yd5_1;
        var tmp5_type = item.xd5_1;
        var tmp6_activeHover = item.xd5_1 === Companion_getInstance_42().na2_1;
        var tmp7_historical = item.zd5_1;
        var tmp8_originalEventPosition = item.vd5_1;
        // Inline function 'kotlin.collections.plusAssign' call
        var element = new PointerInputEventData(tmp0_id, timeMillis, tmp1_positionOnScreen, tmp2_position, tmp3_down, tmp4_pressure, tmp5_type, tmp6_activeHover, tmp7_historical, scrollDelta, scaleGestureFactor, panGestureOffset, tmp8_originalEventPosition);
        target.j1(element);
      }
       while (inductionVariable <= last);
    return new PointerInputEvent(eventType, timeMillis, target, buttons, keyboardModifiers, nativeEvent, changedButton);
  }
  var androidx_compose_ui_scene_ComposeSceneRecomposer$stable;
  function ComposeSceneRecomposer$slambda(this$0, resultContinuation) {
    this.id6_1 = this$0;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(ComposeSceneRecomposer$slambda).p24 = function ($this$launch, $completion) {
    var tmp = this.q24($this$launch, $completion);
    tmp.p9_1 = Unit_instance;
    tmp.q9_1 = null;
    return tmp.v9();
  };
  protoOf(ComposeSceneRecomposer$slambda).ja = function (p1, $completion) {
    return this.p24((!(p1 == null) ? isInterface(p1, CoroutineScope_0) : false) ? p1 : THROW_CCE(), $completion);
  };
  protoOf(ComposeSceneRecomposer$slambda).v9 = function () {
    var suspendResult = this.p9_1;
    $sm: do
      try {
        var tmp = this.n9_1;
        switch (tmp) {
          case 0:
            this.o9_1 = 2;
            this.n9_1 = 1;
            suspendResult = this.id6_1.jd2_1.g45(this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            return Unit_instance;
          case 2:
            throw this.q9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.o9_1 === 2) {
          throw e;
        } else {
          this.n9_1 = this.o9_1;
          this.q9_1 = e;
        }
      }
     while (true);
  };
  protoOf(ComposeSceneRecomposer$slambda).q24 = function ($this$launch, completion) {
    var i = new ComposeSceneRecomposer$slambda(this.id6_1, completion);
    i.jd6_1 = $this$launch;
    return i;
  };
  function ComposeSceneRecomposer$slambda_0(this$0, resultContinuation) {
    var i = new ComposeSceneRecomposer$slambda(this$0, resultContinuation);
    return constructCallableReference(function ($this$launch, $completion) {
      return i.p24($this$launch, $completion);
    }, 1);
  }
  function ComposeSceneRecomposer$scheduleAsEffect$$inlined$Runnable$1($block) {
    this.kd6_1 = $block;
  }
  protoOf(ComposeSceneRecomposer$scheduleAsEffect$$inlined$Runnable$1).o1f = function () {
    this.kd6_1();
  };
  function ComposeSceneRecomposer(coroutineContext, elements) {
    this.fd2_1 = Job();
    this.gd2_1 = CoroutineScope(coroutineContext.xj(this.fd2_1));
    this.hd2_1 = new FlushCoroutineDispatcher(this.gd2_1);
    this.id2_1 = new FlushCoroutineDispatcher(this.gd2_1);
    this.jd2_1 = new Recomposer(coroutineContext.xj(this.fd2_1).xj(this.hd2_1));
    var context = this.id2_1;
    var inductionVariable = 0;
    var last = elements.length;
    while (inductionVariable < last) {
      var element = elements[inductionVariable];
      inductionVariable = inductionVariable + 1 | 0;
      context = context.xj(element);
    }
    var tmp = context;
    var tmp_0 = CoroutineStart_UNDISPATCHED_getInstance();
    launch(this.gd2_1, tmp, tmp_0, ComposeSceneRecomposer$slambda_0(this, null));
  }
  protoOf(ComposeSceneRecomposer).ed2 = function () {
    return this.jd2_1;
  };
  protoOf(ComposeSceneRecomposer).ld2 = function () {
    // Inline function 'androidx.compose.ui.util.trace' call
    this.id2_1.k9();
    return Unit_instance;
  };
  protoOf(ComposeSceneRecomposer).od2 = function () {
    // Inline function 'androidx.compose.ui.util.trace' call
    this.hd2_1.k9();
    return Unit_instance;
  };
  protoOf(ComposeSceneRecomposer).pd2 = function (block) {
    // Inline function 'kotlinx.coroutines.Runnable' call
    var tmp$ret$0 = new ComposeSceneRecomposer$scheduleAsEffect$$inlined$Runnable$1(block);
    this.hd2_1.b1h(this.fd2_1, tmp$ret$0);
  };
  protoOf(ComposeSceneRecomposer).e2z = function () {
    this.jd2_1.e2z();
    this.fd2_1.b1b();
  };
  var androidx_compose_ui_skiko_OverlayRenderDecorator$stable;
  var androidx_compose_ui_skiko_RecordDrawRectRenderDecorator$stable;
  function toDpOffset(_this__u8e3s4, density) {
    // Inline function 'kotlin.with' call
    var tmp;
    // Inline function 'androidx.compose.ui.geometry.isSpecified' call
    if (!equalsLong(bitwiseAnd(_Offset___get_packedValue__impl__xh2k8q(_this__u8e3s4), new Long(2147483647, 2147483647)), new Long(2143289344, 2143289344))) {
      // Inline function 'androidx.compose.ui.geometry.Offset.x' call
      // Inline function 'androidx.compose.ui.util.unpackFloat1' call
      var value = _Offset___get_packedValue__impl__xh2k8q(_this__u8e3s4);
      // Inline function 'androidx.compose.ui.util.floatFromBits' call
      // Inline function 'kotlin.fromBits' call
      var bits = convertToInt(shiftRight(value, 32));
      var tmp$ret$3 = floatFromBits(bits);
      var tmp0 = density.e5f(tmp$ret$3);
      // Inline function 'androidx.compose.ui.geometry.Offset.y' call
      // Inline function 'androidx.compose.ui.util.unpackFloat2' call
      var value_0 = _Offset___get_packedValue__impl__xh2k8q(_this__u8e3s4);
      // Inline function 'androidx.compose.ui.util.floatFromBits' call
      // Inline function 'kotlin.fromBits' call
      var bits_0 = convertToInt(bitwiseAnd(value_0, new Long(-1, 0)));
      var tmp$ret$7 = floatFromBits(bits_0);
      // Inline function 'androidx.compose.ui.unit.DpOffset' call
      var y = density.e5f(tmp$ret$7);
      var tmp0_0 = _Dp___get_value__impl__geb1vb(tmp0);
      // Inline function 'androidx.compose.ui.util.packFloats' call
      var val2 = _Dp___get_value__impl__geb1vb(y);
      var v1 = fromInt(toRawBits(tmp0_0));
      var v2 = fromInt(toRawBits(val2));
      var tmp$ret$12 = bitwiseOr(shiftLeft(v1, 32), bitwiseAnd(v2, new Long(-1, 0)));
      tmp = _DpOffset___init__impl__yq36wy(tmp$ret$12);
    } else {
      tmp = Companion_getInstance_20().u5f_1;
    }
    return tmp;
  }
  function get_LocalInteropContainer() {
    _init_properties_InteropContainer_skiko_kt__av6fbp();
    return LocalInteropContainer;
  }
  var LocalInteropContainer;
  var androidx_compose_ui_viewinterop_TrackInteropPlacementModifierNode$stable;
  function TrackInteropPlacementModifierNode(interopViewHolder) {
    Node.call(this);
    this.zd6_1 = interopViewHolder;
    this.ad7_1 = false;
    this.bd7_1 = 'androidx.compose.ui.node.TRACK_INTEROP_TRAVERSAL_NODE_KEY';
  }
  protoOf(TrackInteropPlacementModifierNode).t91 = function () {
    return this.bd7_1;
  };
  protoOf(TrackInteropPlacementModifierNode).x91 = function (coordinates) {
    var tmp0_safe_receiver = this.zd6_1;
    if (tmp0_safe_receiver == null)
      null;
    else {
      tmp0_safe_receiver.rd7();
    }
    this.ad7_1 = true;
  };
  protoOf(TrackInteropPlacementModifierNode).cb7 = function () {
    var tmp0_safe_receiver = this.zd6_1;
    if (tmp0_safe_receiver == null)
      null;
    else {
      tmp0_safe_receiver.sd7();
    }
    this.ad7_1 = false;
  };
  protoOf(TrackInteropPlacementModifierNode).eam = function (coordinates) {
    if (!this.ad7_1) {
      this.x91(coordinates);
    }
  };
  protoOf(TrackInteropPlacementModifierNode).h8w = function () {
    if (this.ad7_1) {
      this.cb7();
    }
    protoOf(Node).h8w.call(this);
  };
  function TrackInteropPlacementContainer(_this__u8e3s4, content, $composer, $changed) {
    _init_properties_InteropContainer_skiko_kt__av6fbp();
    var $composer_0 = $composer;
    $composer_0 = $composer_0.s30(-158119589);
    var $dirty = $changed;
    if (($changed & 6) === 0)
      $dirty = $dirty | ((($changed & 8) === 0 ? $composer_0.k31(_this__u8e3s4) : $composer_0.q31(_this__u8e3s4)) ? 4 : 2);
    if (($changed & 48) === 0)
      $dirty = $dirty | ($composer_0.q31(content) ? 32 : 16);
    if ($composer_0.r31(!(($dirty & 19) === 18), $dirty & 1)) {
      var tmp0 = $composer_0;
      // Inline function 'androidx.compose.runtime.cache' call
      var invalid = ($dirty & 14) === 4 || (!(($dirty & 8) === 0) && $composer_0.q31(_this__u8e3s4));
      // Inline function 'kotlin.let' call
      var it = tmp0.i31();
      var tmp;
      if (invalid || it === Companion_getInstance_9().f30_1) {
        var value = TrackInteropPlacementContainer$lambda(_this__u8e3s4);
        tmp0.j31(value);
        tmp = value;
      } else {
        tmp = it;
      }
      var tmp$ret$0 = tmp;
      OverlayLayout(new RootTrackInteropPlacementModifierElement(tmp$ret$0), content, $composer_0, 112 & $dirty);
    } else {
      $composer_0.z30();
    }
    var tmp0_safe_receiver = $composer_0.t30();
    if (tmp0_safe_receiver == null)
      null;
    else {
      tmp0_safe_receiver.p3c(TrackInteropPlacementContainer$lambda_0(_this__u8e3s4, content, $changed));
    }
  }
  function countInteropComponentsBelow(_this__u8e3s4, holder, predicate) {
    var tmp;
    if (predicate === VOID) {
      tmp = countInteropComponentsBelow$lambda;
    } else {
      tmp = predicate;
    }
    predicate = tmp;
    _init_properties_InteropContainer_skiko_kt__av6fbp();
    var componentsBefore = {_v: 0};
    var tmp0_safe_receiver = _this__u8e3s4.td7();
    if (tmp0_safe_receiver == null)
      null;
    else {
      traverseDescendantsInDrawOrder(tmp0_safe_receiver, countInteropComponentsBelow$lambda_0(holder, predicate, _this__u8e3s4, componentsBefore));
    }
    return componentsBefore._v;
  }
  function RootTrackInteropPlacementModifierElement(onModifierNodeCreated) {
    ModifierNodeElement.call(this);
    this.vd7_1 = onModifierNodeCreated;
  }
  protoOf(RootTrackInteropPlacementModifierElement).r3d = function () {
    // Inline function 'kotlin.also' call
    var this_0 = new TrackInteropPlacementModifierNode(null);
    this.vd7_1(this_0);
    return this_0;
  };
  protoOf(RootTrackInteropPlacementModifierElement).wd7 = function (node) {
  };
  protoOf(RootTrackInteropPlacementModifierElement).d8y = function (node) {
    return this.wd7(node instanceof TrackInteropPlacementModifierNode ? node : THROW_CCE());
  };
  protoOf(RootTrackInteropPlacementModifierElement).toString = function () {
    return 'RootTrackInteropPlacementModifierElement(onModifierNodeCreated=' + toString(this.vd7_1) + ')';
  };
  protoOf(RootTrackInteropPlacementModifierElement).hashCode = function () {
    return hashCode(this.vd7_1);
  };
  protoOf(RootTrackInteropPlacementModifierElement).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof RootTrackInteropPlacementModifierElement))
      return false;
    if (!equals(this.vd7_1, other.vd7_1))
      return false;
    return true;
  };
  function LocalInteropContainer$lambda() {
    _init_properties_InteropContainer_skiko_kt__av6fbp();
    // Inline function 'kotlin.error' call
    var message = 'LocalInteropContainer not provided';
    throw IllegalStateException_init_$Create$(toString(message));
  }
  function TrackInteropPlacementContainer$lambda($this_TrackInteropPlacementContainer) {
    return function (it) {
      $this_TrackInteropPlacementContainer.xd7(it);
      return Unit_instance;
    };
  }
  function TrackInteropPlacementContainer$lambda_0($this_TrackInteropPlacementContainer, $content, $$changed) {
    return function ($composer, $force) {
      TrackInteropPlacementContainer($this_TrackInteropPlacementContainer, $content, $composer, updateChangedFlags($$changed | 1));
      return Unit_instance;
    };
  }
  function countInteropComponentsBelow$lambda(_this__u8e3s4, it) {
    _init_properties_InteropContainer_skiko_kt__av6fbp();
    return _this__u8e3s4.yd7(it);
  }
  function countInteropComponentsBelow$lambda_0($holder, $predicate, $this_countInteropComponentsBelow, $componentsBefore) {
    return function (it) {
      var currentHolder = it.zd6_1;
      var tmp;
      if (!(currentHolder == null) && !equals(currentHolder, $holder)) {
        if ($predicate($this_countInteropComponentsBelow, currentHolder)) {
          var _unary__edvuaz = $componentsBefore._v;
          $componentsBefore._v = _unary__edvuaz + 1 | 0;
        }
        tmp = true;
      } else {
        tmp = false;
      }
      return tmp;
    };
  }
  var properties_initialized_InteropContainer_skiko_kt_cxvxqr;
  function _init_properties_InteropContainer_skiko_kt__av6fbp() {
    if (!properties_initialized_InteropContainer_skiko_kt_cxvxqr) {
      properties_initialized_InteropContainer_skiko_kt_cxvxqr = true;
      LocalInteropContainer = staticCompositionLocalOf(LocalInteropContainer$lambda);
      androidx_compose_ui_viewinterop_TrackInteropPlacementModifierNode$stable = 8;
    }
  }
  var androidx_compose_ui_viewinterop_InteropPointerInputModifier$stable;
  var androidx_compose_ui_viewinterop_InteropViewFactoryHolder$stable;
  function abstractInvocationError(name) {
    throw new NotImplementedError('Abstract `' + name + '` must be implemented by platform-specific subclass of `InteropViewHolder`');
  }
  var androidx_compose_ui_viewinterop_InteropViewHolder$stable;
  function _set_isAttachedToWindow__wyc4m6($this, value) {
    if (!(value === $this.od7_1)) {
      $this.od7_1 = value;
      if (value) {
        $this.pd7_1();
      } else {
        _get_snapshotObserver__i94x1t_0($this).a5b($this);
      }
    }
  }
  function _get_snapshotObserver__i94x1t_0($this) {
    return $this.cd7_1.fb0();
  }
  function get_DefaultScrimColor() {
    _init_properties_Dialog_skiko_kt__7m405t();
    return DefaultScrimColor;
  }
  var DefaultScrimColor;
  var androidx_compose_ui_window_DialogProperties$stable;
  function Dialog(onDismissRequest, properties, content, $composer, $changed, $default) {
    _init_properties_Dialog_skiko_kt__7m405t();
    var properties_0 = {_v: properties};
    var $composer_0 = $composer;
    $composer_0 = $composer_0.s30(912469306);
    var $dirty = $changed;
    if (($changed & 6) === 0)
      $dirty = $dirty | ($composer_0.q31(onDismissRequest) ? 4 : 2);
    if (!(($default & 2) === 0))
      $dirty = $dirty | 48;
    else if (($changed & 48) === 0)
      $dirty = $dirty | ($composer_0.k31(properties_0._v) ? 32 : 16);
    if (($changed & 384) === 0)
      $dirty = $dirty | ($composer_0.q31(content) ? 256 : 128);
    if ($composer_0.r31(!(($dirty & 147) === 146), $dirty & 1)) {
      if (!(($default & 2) === 0)) {
        properties_0._v = DialogProperties_init_$Create$();
      }
      var currentOnDismissRequest$delegate = rememberUpdatedState(onDismissRequest, $composer_0, 14 & $dirty);
      var compositeKey = get_currentCompositeKeyHashCode($composer_0, 0);
      var tmp0 = $composer_0;
      // Inline function 'androidx.compose.runtime.cache' call
      var invalid = $composer_0.o31(compositeKey);
      // Inline function 'kotlin.let' call
      var it = tmp0.i31();
      var tmp;
      if (invalid || it === Companion_getInstance_9().f30_1) {
        var value = new OnBackClickEventHandler(compositeKey, Dialog$lambda_0(currentOnDismissRequest$delegate));
        tmp0.j31(value);
        tmp = value;
      } else {
        tmp = it;
      }
      var onBackHandler = tmp;
      var tmp_0 = properties_0._v.zd7_1;
      var tmp0_0 = $composer_0;
      // Inline function 'androidx.compose.runtime.cache' call
      var invalid_0 = !!($composer_0.q31(onBackHandler) | ($dirty & 112) === 32);
      // Inline function 'kotlin.let' call
      var it_0 = tmp0_0.i31();
      var tmp_1;
      if (invalid_0 || it_0 === Companion_getInstance_9().f30_1) {
        var value_0 = Dialog$slambda_0(onBackHandler, properties_0, null);
        tmp0_0.j31(value_0);
        tmp_1 = value_0;
      } else {
        tmp_1 = it_0;
      }
      var tmp$ret$4 = tmp_1;
      LaunchedEffect(onBackHandler, tmp_0, tmp$ret$4, $composer_0, 0);
      var tmp0_1 = findDefaultNavigationEventDispatcherOwner($composer_0, 0);
      var tmp$ret$8;
      $l$block: {
        // Inline function 'kotlin.requireNotNull' call
        if (tmp0_1 == null) {
          // Inline function 'kotlin.error' call
          var message = 'NavigationEventDispatcherOwner not found';
          throw IllegalStateException_init_$Create$(toString(message));
        } else {
          tmp$ret$8 = tmp0_1;
          break $l$block;
        }
      }
      var navigationEventDispatcher = tmp$ret$8.p8s();
      var tmp0_2 = $composer_0;
      // Inline function 'androidx.compose.runtime.cache' call
      var invalid_1 = !!($composer_0.q31(navigationEventDispatcher) | $composer_0.q31(onBackHandler));
      // Inline function 'kotlin.let' call
      var it_1 = tmp0_2.i31();
      var tmp_2;
      if (invalid_1 || it_1 === Companion_getInstance_9().f30_1) {
        var value_1 = Dialog$lambda_1(navigationEventDispatcher, onBackHandler);
        tmp0_2.j31(value_1);
        tmp_2 = value_1;
      } else {
        tmp_2 = it_1;
      }
      var tmp$ret$11 = tmp_2;
      DisposableEffect_0(navigationEventDispatcher, onBackHandler, tmp$ret$11, $composer_0, 0);
      var tmp_3;
      if (properties_0._v.ad8_1) {
        $composer_0.m30(526057923);
        var tmp0_3 = $composer_0;
        // Inline function 'androidx.compose.runtime.cache' call
        var invalid_2 = $composer_0.k31(currentOnDismissRequest$delegate);
        // Inline function 'kotlin.let' call
        var it_2 = tmp0_3.i31();
        var tmp_4;
        if (invalid_2 || it_2 === Companion_getInstance_9().f30_1) {
          var value_2 = Dialog$lambda_2(currentOnDismissRequest$delegate);
          tmp0_3.j31(value_2);
          tmp_4 = value_2;
        } else {
          tmp_4 = it_2;
        }
        var tmp0_group = tmp_4;
        $composer_0.n30();
        tmp_3 = tmp0_group;
      } else {
        $composer_0.m30(526530580);
        $composer_0.n30();
        tmp_3 = null;
      }
      var onOutsidePointerEvent = tmp_3;
      var tmp_5 = Companion_instance_6;
      // Inline function 'androidx.compose.runtime.cache' call
      var this_0 = $composer_0;
      // Inline function 'kotlin.let' call
      var it_3 = this_0.i31();
      var tmp_6;
      if (false || it_3 === Companion_getInstance_9().f30_1) {
        var value_3 = Dialog$lambda_3;
        this_0.j31(value_3);
        tmp_6 = value_3;
      } else {
        tmp_6 = it_3;
      }
      var tmp$ret$19 = tmp_6;
      var tmp0_modifier = semantics(tmp_5, VOID, tmp$ret$19);
      DialogLayout(properties_0._v, tmp0_modifier, onOutsidePointerEvent, content, $composer_0, 14 & $dirty >> 3 | 7168 & $dirty << 3, 0);
    } else {
      $composer_0.z30();
    }
    var tmp1_safe_receiver = $composer_0.t30();
    if (tmp1_safe_receiver == null)
      null;
    else {
      tmp1_safe_receiver.p3c(Dialog$lambda_4(onDismissRequest, properties_0, content, $changed, $default));
    }
  }
  function DialogProperties_init_$Init$(dismissOnBackPress, dismissOnClickOutside, usePlatformDefaultWidth, $this) {
    dismissOnBackPress = dismissOnBackPress === VOID ? true : dismissOnBackPress;
    dismissOnClickOutside = dismissOnClickOutside === VOID ? true : dismissOnClickOutside;
    usePlatformDefaultWidth = usePlatformDefaultWidth === VOID ? true : usePlatformDefaultWidth;
    DialogProperties_init_$Init$_0(dismissOnBackPress, dismissOnClickOutside, usePlatformDefaultWidth, true, true, get_DefaultScrimColor(), $this);
    return $this;
  }
  function DialogProperties_init_$Create$(dismissOnBackPress, dismissOnClickOutside, usePlatformDefaultWidth) {
    return DialogProperties_init_$Init$(dismissOnBackPress, dismissOnClickOutside, usePlatformDefaultWidth, objectCreate(protoOf(DialogProperties)));
  }
  function DialogProperties_init_$Init$_0(dismissOnBackPress, dismissOnClickOutside, usePlatformDefaultWidth, usePlatformInsets, useSoftwareKeyboardInset, scrimColor, $this) {
    dismissOnBackPress = dismissOnBackPress === VOID ? true : dismissOnBackPress;
    dismissOnClickOutside = dismissOnClickOutside === VOID ? true : dismissOnClickOutside;
    usePlatformDefaultWidth = usePlatformDefaultWidth === VOID ? true : usePlatformDefaultWidth;
    usePlatformInsets = usePlatformInsets === VOID ? true : usePlatformInsets;
    useSoftwareKeyboardInset = useSoftwareKeyboardInset === VOID ? true : useSoftwareKeyboardInset;
    scrimColor = scrimColor === VOID ? get_DefaultScrimColor() : scrimColor;
    DialogProperties.call($this, dismissOnBackPress, dismissOnClickOutside, usePlatformDefaultWidth, usePlatformInsets, useSoftwareKeyboardInset, scrimColor, get_isDialogAnimationEnabled(ComposeUiFlags_instance));
    return $this;
  }
  function DialogProperties_init_$Create$_0(dismissOnBackPress, dismissOnClickOutside, usePlatformDefaultWidth, usePlatformInsets, useSoftwareKeyboardInset, scrimColor) {
    return DialogProperties_init_$Init$_0(dismissOnBackPress, dismissOnClickOutside, usePlatformDefaultWidth, usePlatformInsets, useSoftwareKeyboardInset, scrimColor, objectCreate(protoOf(DialogProperties)));
  }
  function DialogProperties(dismissOnBackPress, dismissOnClickOutside, usePlatformDefaultWidth, usePlatformInsets, useSoftwareKeyboardInset, scrimColor, animateTransition) {
    dismissOnBackPress = dismissOnBackPress === VOID ? true : dismissOnBackPress;
    dismissOnClickOutside = dismissOnClickOutside === VOID ? true : dismissOnClickOutside;
    usePlatformDefaultWidth = usePlatformDefaultWidth === VOID ? true : usePlatformDefaultWidth;
    usePlatformInsets = usePlatformInsets === VOID ? true : usePlatformInsets;
    useSoftwareKeyboardInset = useSoftwareKeyboardInset === VOID ? true : useSoftwareKeyboardInset;
    scrimColor = scrimColor === VOID ? get_DefaultScrimColor() : scrimColor;
    animateTransition = animateTransition === VOID ? get_isDialogAnimationEnabled(ComposeUiFlags_instance) : animateTransition;
    this.zd7_1 = dismissOnBackPress;
    this.ad8_1 = dismissOnClickOutside;
    this.bd8_1 = usePlatformDefaultWidth;
    this.cd8_1 = usePlatformInsets;
    this.dd8_1 = useSoftwareKeyboardInset;
    this.ed8_1 = scrimColor;
    this.fd8_1 = animateTransition;
  }
  protoOf(DialogProperties).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof DialogProperties))
      return false;
    if (!(this.zd7_1 === other.zd7_1))
      return false;
    if (!(this.ad8_1 === other.ad8_1))
      return false;
    if (!(this.bd8_1 === other.bd8_1))
      return false;
    if (!(this.cd8_1 === other.cd8_1))
      return false;
    if (!(this.dd8_1 === other.dd8_1))
      return false;
    if (!equals(this.ed8_1, other.ed8_1))
      return false;
    if (!(this.fd8_1 === other.fd8_1))
      return false;
    return true;
  };
  protoOf(DialogProperties).hashCode = function () {
    var result = getBooleanHashCode(this.zd7_1);
    result = imul(31, result) + getBooleanHashCode(this.ad8_1) | 0;
    result = imul(31, result) + getBooleanHashCode(this.bd8_1) | 0;
    result = imul(31, result) + getBooleanHashCode(this.cd8_1) | 0;
    result = imul(31, result) + getBooleanHashCode(this.dd8_1) | 0;
    result = imul(31, result) + Color__hashCode_impl_vjyivj(this.ed8_1) | 0;
    result = imul(31, result) + getBooleanHashCode(this.fd8_1) | 0;
    return result;
  };
  function DialogLayout(properties, modifier, onOutsidePointerEvent, content, $composer, $changed, $default) {
    _init_properties_Dialog_skiko_kt__7m405t();
    var modifier_0 = {_v: modifier};
    var onOutsidePointerEvent_0 = {_v: onOutsidePointerEvent};
    var $composer_0 = $composer;
    $composer_0 = $composer_0.s30(-1897196659);
    var $dirty = $changed;
    if (($changed & 6) === 0)
      $dirty = $dirty | ($composer_0.k31(properties) ? 4 : 2);
    if (!(($default & 2) === 0))
      $dirty = $dirty | 48;
    else if (($changed & 48) === 0)
      $dirty = $dirty | ($composer_0.k31(modifier_0._v) ? 32 : 16);
    if (!(($default & 4) === 0))
      $dirty = $dirty | 384;
    else if (($changed & 384) === 0)
      $dirty = $dirty | ($composer_0.q31(onOutsidePointerEvent_0._v) ? 256 : 128);
    if (($changed & 3072) === 0)
      $dirty = $dirty | ($composer_0.q31(content) ? 2048 : 1024);
    if ($composer_0.r31(!(($dirty & 1171) === 1170), $dirty & 1)) {
      if (!(($default & 2) === 0)) {
        modifier_0._v = Companion_instance_6;
      }
      if (!(($default & 4) === 0)) {
        onOutsidePointerEvent_0._v = null;
      }
      var layer = rememberComposeSceneLayer(true, $composer_0, 6, 0);
      layer.id5(onOutsidePointerEvent_0._v);
      var currentContent$delegate = rememberUpdatedState(content, $composer_0, 14 & $dirty >> 9);
      var tmp0 = get_LocalGraphicsContext();
      // Inline function 'androidx.compose.runtime.CompositionLocal.current' call
      var $composer_1 = $composer_0;
      var graphicsContext = $composer_1.u31(tmp0);
      // Inline function 'androidx.compose.runtime.cache' call
      var this_0 = $composer_0;
      // Inline function 'kotlin.let' call
      var it = this_0.i31();
      var tmp;
      if (false || it === Companion_getInstance_9().f30_1) {
        var value = new DialogAppearanceController(layer, graphicsContext, properties);
        this_0.j31(value);
        tmp = value;
      } else {
        tmp = it;
      }
      var animator = tmp;
      animator.md8(properties);
      var layerScope = {_v: null};
      // Inline function 'kotlin.run' call
      var dispatchReceiver = rememberComposableLambda(1475979611, true, DialogLayout$lambda_0(layerScope, animator, layer, properties, modifier_0, currentContent$delegate), $composer_0, 54);
      // Inline function 'androidx.compose.runtime.remember' call
      var $composer_2 = $composer_0;
      // Inline function 'androidx.compose.runtime.cache' call
      var invalid = $composer_2.k31(dispatchReceiver);
      // Inline function 'kotlin.let' call
      var it_0 = $composer_2.i31();
      var tmp_0;
      if (invalid || it_0 === Companion_getInstance_9().f30_1) {
        var value_0 = ComposableLambda$invoke$ref(dispatchReceiver);
        $composer_2.j31(value_0);
        tmp_0 = value_0;
      } else {
        tmp_0 = it_0;
      }
      var tmp$ret$5 = tmp_0;
      Content(layer, tmp$ret$5, $composer_0, 48);
      DisposableEffect(Unit_instance, DialogLayout$lambda_1(layerScope, animator), $composer_0, 6);
    } else {
      $composer_0.z30();
    }
    var tmp0_safe_receiver = $composer_0.t30();
    if (tmp0_safe_receiver == null)
      null;
    else {
      tmp0_safe_receiver.p3c(DialogLayout$lambda_2(properties, modifier_0, onOutsidePointerEvent_0, content, $changed, $default));
    }
  }
  function DialogAppearanceController$hideDialogWithAnimation$lambda$slambda$lambda($initialProgress, this$0) {
    return function (progress) {
      var reversedProgress = (1.0 - progress) * $initialProgress;
      _set_appearanceProgress__rmofei(this$0, reversedProgress);
      updateScrimLayerColor(this$0, reversedProgress);
      return Unit_instance;
    };
  }
  function _set_appearanceProgress__rmofei($this, _set____db54di) {
    var tmp0 = $this.id8_1;
    var tmp = KMutableProperty1;
    var tmp_0 = DialogAppearanceController$_get_appearanceProgress_$ref_u40gwr();
    // Inline function 'androidx.compose.runtime.setValue' call
    getPropertyCallableRef('appearanceProgress', 1, tmp, tmp_0, DialogAppearanceController$_set_appearanceProgress_$ref_io04mp());
    tmp0.i45(_set____db54di);
    return Unit_instance;
  }
  function _get_appearanceProgress__9gkbga($this) {
    var tmp0 = $this.id8_1;
    var tmp = KMutableProperty1;
    var tmp_0 = DialogAppearanceController$_get_appearanceProgress_$ref_u40gwr();
    // Inline function 'androidx.compose.runtime.getValue' call
    getPropertyCallableRef('appearanceProgress', 1, tmp, tmp_0, DialogAppearanceController$_set_appearanceProgress_$ref_io04mp());
    return tmp0.j45();
  }
  function updateScrimLayerColor($this, progress) {
    $this.gd8_1.ad5(Color__copy$default_impl_ectz3s($this.kd8_1.ed8_1, _Color___get_alpha__impl__wcfyv1($this.kd8_1.ed8_1) * contentAlpha($this, progress)));
  }
  function contentAlpha($this, progress) {
    return 0.2 + (1.0 - 0.2) * progress;
  }
  function applyAnimationProgress($this, $receiver, progress, density) {
    $receiver.v66(contentAlpha($this, progress));
    var reversedProgress = 1.0 - progress;
    var scale = 1.0 - reversedProgress * 0.05;
    $receiver.w66(scale);
    $receiver.x66(scale);
    $receiver.z66(10.0 * reversedProgress * density);
  }
  function drawWithGraphicsLayer($this, $receiver, getProgress) {
    return drawWithContent($receiver, DialogAppearanceController$drawWithGraphicsLayer$lambda($this, getProgress));
  }
  function DialogAppearanceController$_get_appearanceProgress_$ref_u40gwr() {
    return constructCallableReference(function (p0) {
      return _get_appearanceProgress__9gkbga(p0);
    }, 1, 0, 167);
  }
  function DialogAppearanceController$_set_appearanceProgress_$ref_io04mp() {
    return constructCallableReference(function (p0, p1) {
      _set_appearanceProgress__rmofei(p0, p1);
      return Unit_instance;
    }, 2, 0, 168);
  }
  function DialogAppearanceController$modifier$lambda(this$0) {
    return function () {
      return _get_appearanceProgress__9gkbga(this$0);
    };
  }
  function DialogAppearanceController$onDialogShown$lambda(this$0) {
    return function (progress) {
      _set_appearanceProgress__rmofei(this$0, progress);
      updateScrimLayerColor(this$0, progress);
      return Unit_instance;
    };
  }
  function DialogAppearanceController$hideDialogWithAnimation$lambda$lambda(this$0) {
    return function ($this$drawBehind) {
      applyAnimationProgress(this$0, this$0.jd8_1, _get_appearanceProgress__9gkbga(this$0), $this$drawBehind.u5e());
      drawLayer($this$drawBehind, this$0.jd8_1);
      return Unit_instance;
    };
  }
  function DialogAppearanceController$hideDialogWithAnimation$lambda$slambda(this$0, resultContinuation) {
    this.vd8_1 = this$0;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(DialogAppearanceController$hideDialogWithAnimation$lambda$slambda).p24 = function ($this$LaunchedEffect, $completion) {
    var tmp = this.q24($this$LaunchedEffect, $completion);
    tmp.p9_1 = Unit_instance;
    tmp.q9_1 = null;
    return tmp.v9();
  };
  protoOf(DialogAppearanceController$hideDialogWithAnimation$lambda$slambda).ja = function (p1, $completion) {
    return this.p24((!(p1 == null) ? isInterface(p1, CoroutineScope_0) : false) ? p1 : THROW_CCE(), $completion);
  };
  protoOf(DialogAppearanceController$hideDialogWithAnimation$lambda$slambda).v9 = function () {
    var suspendResult = this.p9_1;
    $sm: do
      try {
        var tmp = this.n9_1;
        switch (tmp) {
          case 0:
            this.o9_1 = 2;
            var durationScale_0 = durationScale(this.t9());
            var initialProgress = _get_appearanceProgress__9gkbga(this.vd8_1);
            var duration = durationScale_0 * initialProgress * 0.1;
            this.n9_1 = 1;
            Companion_getInstance_16();
            var tmp_0 = toDuration_0(duration, DurationUnit_SECONDS_getInstance());
            var tmp_1 = easeOutTimingFunction$ref();
            suspendResult = withAnimationProgress(tmp_0, tmp_1, DialogAppearanceController$hideDialogWithAnimation$lambda$slambda$lambda(initialProgress, this.vd8_1), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            this.vd8_1.hd8_1.n6z(this.vd8_1.jd8_1);
            this.vd8_1.gd8_1.j4();
            return Unit_instance;
          case 2:
            throw this.q9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.o9_1 === 2) {
          throw e;
        } else {
          this.n9_1 = this.o9_1;
          this.q9_1 = e;
        }
      }
     while (true);
  };
  protoOf(DialogAppearanceController$hideDialogWithAnimation$lambda$slambda).q24 = function ($this$LaunchedEffect, completion) {
    var i = new DialogAppearanceController$hideDialogWithAnimation$lambda$slambda(this.vd8_1, completion);
    i.wd8_1 = $this$LaunchedEffect;
    return i;
  };
  function DialogAppearanceController$hideDialogWithAnimation$lambda$slambda_0(this$0, resultContinuation) {
    var i = new DialogAppearanceController$hideDialogWithAnimation$lambda$slambda(this$0, resultContinuation);
    return constructCallableReference(function ($this$LaunchedEffect, $completion) {
      return i.p24($this$LaunchedEffect, $completion);
    }, 1);
  }
  function DialogAppearanceController$hideDialogWithAnimation$lambda(this$0) {
    return function ($composer, $changed) {
      var $composer_0 = $composer;
      var tmp;
      if ($composer_0.r31(!(($changed & 3) === 2), $changed & 1)) {
        // Inline function 'androidx.compose.runtime.CompositionLocal.current' call
        var this_0 = get_LocalWindowInfo();
        var $composer_1 = $composer_0;
        var containerSize = $composer_1.u31(this_0).bbr();
        var measurePolicy = rememberDialogMeasurePolicy(this$0.gd8_1, this$0.kd8_1, containerSize, $composer_0, 0);
        var tmp_0 = Companion_instance_6;
        // Inline function 'androidx.compose.runtime.cache' call
        var invalid = $composer_0.q31(this$0);
        // Inline function 'kotlin.let' call
        var it = $composer_0.i31();
        var tmp_1;
        if (invalid || it === Companion_getInstance_9().f30_1) {
          var value = DialogAppearanceController$hideDialogWithAnimation$lambda$lambda(this$0);
          $composer_0.j31(value);
          tmp_1 = value;
        } else {
          tmp_1 = it;
        }
        var tmp$ret$1 = tmp_1;
        // Inline function 'androidx.compose.ui.layout.Layout' call
        var modifier = drawBehind(tmp_0, tmp$ret$1);
        var $composer_2 = $composer_0;
        if (!((0 & 1) === 0))
          modifier = Companion_instance_6;
        var compositeKeyHash = get_currentCompositeKeyHashCode($composer_2, 0).hashCode();
        var materialized = materialize($composer_2, modifier);
        var localMap = $composer_2.t31();
        // Inline function 'androidx.compose.runtime.ReusableComposeNode' call
        var factory = Companion_getInstance_53().oah_1;
        var $composer_3 = $composer_2;
        var tmp_2 = $composer_3.g30();
        if (!isInterface(tmp_2, Applier)) {
          invalidApplier();
        }
        $composer_3.b31();
        if ($composer_3.h30()) {
          $composer_3.c31(factory);
        } else {
          $composer_3.d31();
        }
        var $this$ReusableComposeNode = _Updater___init__impl__rbfxm8($composer_3);
        Updater__set_impl_v7kwss($this$ReusableComposeNode, measurePolicy, Companion_getInstance_53().tah_1);
        Updater__set_impl_v7kwss($this$ReusableComposeNode, localMap, Companion_getInstance_53().sah_1);
        Updater__reconcile_impl_1mfi6g($this$ReusableComposeNode, Companion_getInstance_53().xah_1);
        Updater__set_impl_v7kwss($this$ReusableComposeNode, materialized, Companion_getInstance_53().qah_1);
        Updater__set_impl_v7kwss($this$ReusableComposeNode, compositeKeyHash, Companion_getInstance_53().wah_1);
        $composer_3.e31();
        // Inline function 'androidx.compose.runtime.cache' call
        var invalid_0 = $composer_0.q31(this$0);
        // Inline function 'kotlin.let' call
        var it_0 = $composer_0.i31();
        var tmp_3;
        if (invalid_0 || it_0 === Companion_getInstance_9().f30_1) {
          var value_0 = DialogAppearanceController$hideDialogWithAnimation$lambda$slambda_0(this$0, null);
          $composer_0.j31(value_0);
          tmp_3 = value_0;
        } else {
          tmp_3 = it_0;
        }
        var tmp$ret$8 = tmp_3;
        LaunchedEffect_0(Unit_instance, tmp$ret$8, $composer_0, 6);
        tmp = Unit_instance;
      } else {
        $composer_0.z30();
        tmp = Unit_instance;
      }
      return Unit_instance;
    };
  }
  function DialogAppearanceController$drawWithGraphicsLayer$lambda$lambda($this_drawWithContent) {
    return function ($this$record) {
      $this_drawWithContent.z91();
      return Unit_instance;
    };
  }
  function DialogAppearanceController$drawWithGraphicsLayer$lambda(this$0, $getProgress) {
    return function ($this$drawWithContent) {
      $this$drawWithContent.o6q(this$0.jd8_1, VOID, DialogAppearanceController$drawWithGraphicsLayer$lambda$lambda($this$drawWithContent));
      applyAnimationProgress(this$0, this$0.jd8_1, $getProgress(), $this$drawWithContent.u5e());
      drawLayer($this$drawWithContent, this$0.jd8_1);
      return Unit_instance;
    };
  }
  function $onDialogShownCOROUTINE$(_this__u8e3s4, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.fd9_1 = _this__u8e3s4;
  }
  protoOf($onDialogShownCOROUTINE$).v9 = function () {
    var suspendResult = this.p9_1;
    $sm: do
      try {
        var tmp = this.n9_1;
        switch (tmp) {
          case 0:
            this.o9_1 = 3;
            if (this.fd9_1.kd8_1.fd8_1) {
              var durationScale_0 = durationScale(this.t9());
              this.n9_1 = 1;
              Companion_getInstance_16();
              var this_0 = durationScale_0 * 0.2;
              var tmp_0 = toDuration_0(this_0, DurationUnit_SECONDS_getInstance());
              var tmp_1 = easeOutTimingFunction$ref();
              suspendResult = withAnimationProgress(tmp_0, tmp_1, DialogAppearanceController$onDialogShown$lambda(this.fd9_1), this);
              if (suspendResult === get_COROUTINE_SUSPENDED()) {
                return suspendResult;
              }
              continue $sm;
            } else {
              this.n9_1 = 2;
              continue $sm;
            }

          case 1:
            this.n9_1 = 2;
            continue $sm;
          case 2:
            _set_appearanceProgress__rmofei(this.fd9_1, 1.0);
            this.fd9_1.gd8_1.ad5(this.fd9_1.kd8_1.ed8_1);
            return Unit_instance;
          case 3:
            throw this.q9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.o9_1 === 3) {
          throw e;
        } else {
          this.n9_1 = this.o9_1;
          this.q9_1 = e;
        }
      }
     while (true);
  };
  function DialogAppearanceController(layer, graphicsContext, properties) {
    this.gd8_1 = layer;
    this.hd8_1 = graphicsContext;
    this.id8_1 = mutableFloatStateOf(0.0);
    this.jd8_1 = this.hd8_1.m6z();
    this.kd8_1 = properties;
    var tmp = this;
    var tmp_0 = Companion_instance_6;
    tmp.ld8_1 = drawWithGraphicsLayer(this, tmp_0, DialogAppearanceController$modifier$lambda(this));
  }
  protoOf(DialogAppearanceController).md8 = function (value) {
    this.kd8_1 = value;
    var tmp$ret$0;
    $l$block: {
      // Inline function 'androidx.compose.runtime.snapshots.Companion.withoutReadObservation' call
      var previousSnapshot = Companion_instance.p52();
      var observer = previousSnapshot == null ? null : previousSnapshot.t3e();
      var newSnapshot = Companion_instance.q52(previousSnapshot);
      try {
        tmp$ret$0 = _get_appearanceProgress__9gkbga(this);
        break $l$block;
      }finally {
        Companion_instance.c53(previousSnapshot, newSnapshot, observer);
      }
    }
    updateScrimLayerColor(this, tmp$ret$0);
  };
  protoOf(DialogAppearanceController).gd9 = function ($completion) {
    var tmp = new $onDialogShownCOROUTINE$(this, $completion);
    tmp.p9_1 = Unit_instance;
    tmp.q9_1 = null;
    return tmp.v9();
  };
  protoOf(DialogAppearanceController).hd9 = function () {
    if (this.kd8_1.fd8_1) {
      this.id9();
    } else {
      this.gd8_1.j4();
    }
  };
  protoOf(DialogAppearanceController).id9 = function () {
    this.gd8_1.k39(ComposableLambda$invoke$ref(composableLambdaInstance(-316777110, true, DialogAppearanceController$hideDialogWithAnimation$lambda(this))));
  };
  function rememberDialogMeasurePolicy(layer, properties, containerSize, $composer, $changed) {
    _init_properties_Dialog_skiko_kt__7m405t();
    var $composer_0 = $composer;
    var platformInsets = get_platformInsets(properties, $composer_0, 14 & $changed >> 3);
    // Inline function 'androidx.compose.runtime.cache' call
    var invalid = !!(!!(!!((($changed & 14 ^ 6) > 4 && $composer_0.k31(layer) || ($changed & 6) === 4) | (($changed & 112 ^ 48) > 32 && $composer_0.k31(properties) || ($changed & 48) === 32)) | (($changed & 896 ^ 384) > 256 && $composer_0.o31(_IntSize___get_packedValue__impl__uho7jf(containerSize)) || ($changed & 384) === 256)) | $composer_0.k31(platformInsets));
    // Inline function 'kotlin.let' call
    var it = $composer_0.i31();
    var tmp;
    if (invalid || it === Companion_getInstance_9().f30_1) {
      var value = RootMeasurePolicy_0(platformInsets, properties.bd8_1, rememberDialogMeasurePolicy$lambda(platformInsets, containerSize, layer));
      $composer_0.j31(value);
      tmp = value;
    } else {
      tmp = it;
    }
    return tmp;
  }
  function durationScale(_this__u8e3s4) {
    _init_properties_Dialog_skiko_kt__7m405t();
    var tmp0_safe_receiver = _this__u8e3s4.aa(Key_instance_0);
    var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.r8w();
    return tmp1_elvis_lhs == null ? 1.0 : tmp1_elvis_lhs;
  }
  function get_platformInsets(_this__u8e3s4, $composer, $changed) {
    _init_properties_Dialog_skiko_kt__7m405t();
    var $composer_0 = $composer;
    var tmp;
    if (_this__u8e3s4.cd8_1) {
      $composer_0.m30(-639512445);
      // Inline function 'androidx.compose.runtime.CompositionLocal.current' call
      var this_0 = get_LocalPlatformWindowInsets();
      var $composer_1 = $composer_0;
      var tmp1_group = $composer_1.u31(this_0).xcz();
      $composer_0.n30();
      tmp = tmp1_group;
    } else {
      $composer_0.m30(-639439812);
      $composer_0.n30();
      tmp = Companion_getInstance_73().wcz_1;
    }
    var safeInsets = tmp;
    var tmp_0;
    if (_this__u8e3s4.dd8_1) {
      $composer_0.m30(-639346998);
      // Inline function 'androidx.compose.runtime.CompositionLocal.current' call
      var this_1 = get_LocalPlatformWindowInsets();
      var $composer_2 = $composer_0;
      var tmp2_group = $composer_2.u31(this_1).nc8();
      $composer_0.n30();
      tmp_0 = tmp2_group;
    } else {
      $composer_0.m30(-639281092);
      $composer_0.n30();
      tmp_0 = Companion_getInstance_73().wcz_1;
    }
    var ime = tmp_0;
    return union(safeInsets, ime);
  }
  function getDialogScrimBlendMode(isWindowTransparent) {
    _init_properties_Dialog_skiko_kt__7m405t();
    var tmp;
    if (isWindowTransparent) {
      tmp = Companion_getInstance_3().h6a_1;
    } else {
      tmp = Companion_getInstance_3().b6a_1;
    }
    return tmp;
  }
  function Dialog$lambda($currentOnDismissRequest$delegate) {
    _init_properties_Dialog_skiko_kt__7m405t();
    // Inline function 'androidx.compose.runtime.getValue' call
    getLocalDelegateReference('currentOnDismissRequest', KProperty0, false);
    return $currentOnDismissRequest$delegate.u1();
  }
  function Dialog$lambda_0($currentOnDismissRequest$delegate) {
    return function () {
      Dialog$lambda($currentOnDismissRequest$delegate)();
      return Unit_instance;
    };
  }
  function Dialog$slambda($onBackHandler, $properties, resultContinuation) {
    this.rd9_1 = $onBackHandler;
    this.sd9_1 = $properties;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(Dialog$slambda).p24 = function ($this$LaunchedEffect, $completion) {
    var tmp = this.q24($this$LaunchedEffect, $completion);
    tmp.p9_1 = Unit_instance;
    tmp.q9_1 = null;
    return tmp.v9();
  };
  protoOf(Dialog$slambda).ja = function (p1, $completion) {
    return this.p24((!(p1 == null) ? isInterface(p1, CoroutineScope_0) : false) ? p1 : THROW_CCE(), $completion);
  };
  protoOf(Dialog$slambda).v9 = function () {
    var suspendResult = this.p9_1;
    $sm: do
      try {
        var tmp = this.n9_1;
        if (tmp === 0) {
          this.o9_1 = 1;
          this.rd9_1.dda_1 = this.sd9_1._v.zd7_1;
          return Unit_instance;
        } else if (tmp === 1) {
          throw this.q9_1;
        }
      } catch ($p) {
        var e = $p;
        throw e;
      }
     while (true);
  };
  protoOf(Dialog$slambda).q24 = function ($this$LaunchedEffect, completion) {
    var i = new Dialog$slambda(this.rd9_1, this.sd9_1, completion);
    i.td9_1 = $this$LaunchedEffect;
    return i;
  };
  function Dialog$slambda_0($onBackHandler, $properties, resultContinuation) {
    var i = new Dialog$slambda($onBackHandler, $properties, resultContinuation);
    return constructCallableReference(function ($this$LaunchedEffect, $completion) {
      return i.p24($this$LaunchedEffect, $completion);
    }, 1);
  }
  function Dialog$$inlined$cache$3$1($onBackHandler) {
    this.eda_1 = $onBackHandler;
  }
  protoOf(Dialog$$inlined$cache$3$1).s1d = function () {
    this.eda_1.l4();
  };
  function Dialog$lambda_1($navigationEventDispatcher, $onBackHandler) {
    return function ($this$DisposableEffect) {
      $navigationEventDispatcher.w8n($onBackHandler);
      // Inline function 'androidx.compose.runtime.DisposableEffectScope.onDispose' call
      return new Dialog$$inlined$cache$3$1($onBackHandler);
    };
  }
  function Dialog$lambda_2($currentOnDismissRequest$delegate) {
    return function (eventType, button) {
      var tmp;
      if (equals(eventType, new PointerEventType(Companion_getInstance_41().ma1_1)) && (button == null || equals(button, new PointerButton(Companion_getInstance_71().qc4_1)))) {
        tmp = Dialog$lambda($currentOnDismissRequest$delegate)();
      }
      return Unit_instance;
    };
  }
  function Dialog$lambda_3($this$semantics) {
    _init_properties_Dialog_skiko_kt__7m405t();
    dialog($this$semantics);
    return Unit_instance;
  }
  function Dialog$lambda_4($onDismissRequest, $properties, $content, $$changed, $$default) {
    return function ($composer, $force) {
      Dialog($onDismissRequest, $properties._v, $content, $composer, updateChangedFlags($$changed | 1), $$default);
      return Unit_instance;
    };
  }
  function DialogLayout$lambda($currentContent$delegate) {
    _init_properties_Dialog_skiko_kt__7m405t();
    // Inline function 'androidx.compose.runtime.getValue' call
    getLocalDelegateReference('currentContent', KProperty0, false);
    return $currentContent$delegate.u1();
  }
  function DialogLayout$lambda$lambda() {
    _init_properties_Dialog_skiko_kt__7m405t();
    return EmptyCoroutineContext_getInstance();
  }
  function DialogLayout$lambda$slambda($animator, resultContinuation) {
    this.nda_1 = $animator;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(DialogLayout$lambda$slambda).p24 = function ($this$LaunchedEffect, $completion) {
    var tmp = this.q24($this$LaunchedEffect, $completion);
    tmp.p9_1 = Unit_instance;
    tmp.q9_1 = null;
    return tmp.v9();
  };
  protoOf(DialogLayout$lambda$slambda).ja = function (p1, $completion) {
    return this.p24((!(p1 == null) ? isInterface(p1, CoroutineScope_0) : false) ? p1 : THROW_CCE(), $completion);
  };
  protoOf(DialogLayout$lambda$slambda).v9 = function () {
    var suspendResult = this.p9_1;
    $sm: do
      try {
        var tmp = this.n9_1;
        switch (tmp) {
          case 0:
            this.o9_1 = 2;
            this.n9_1 = 1;
            suspendResult = this.nda_1.gd9(this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            return Unit_instance;
          case 2:
            throw this.q9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.o9_1 === 2) {
          throw e;
        } else {
          this.n9_1 = this.o9_1;
          this.q9_1 = e;
        }
      }
     while (true);
  };
  protoOf(DialogLayout$lambda$slambda).q24 = function ($this$LaunchedEffect, completion) {
    var i = new DialogLayout$lambda$slambda(this.nda_1, completion);
    i.oda_1 = $this$LaunchedEffect;
    return i;
  };
  function DialogLayout$lambda$slambda_0($animator, resultContinuation) {
    var i = new DialogLayout$lambda$slambda($animator, resultContinuation);
    return constructCallableReference(function ($this$LaunchedEffect, $completion) {
      return i.p24($this$LaunchedEffect, $completion);
    }, 1);
  }
  function DialogLayout$lambda$lambda_0($animator, $modifier, $properties, $measurePolicy, $currentContent$delegate) {
    return function ($composer, $changed) {
      var $composer_0 = $composer;
      var tmp;
      if ($composer_0.r31(!(($changed & 3) === 2), $changed & 1)) {
        var tmp0 = DialogLayout$lambda($currentContent$delegate);
        var tmp2 = excludeWindowInsets($animator.ld8_1.d8v($modifier._v), $properties.cd8_1, $properties.dd8_1);
        // Inline function 'androidx.compose.ui.layout.Layout' call
        var measurePolicy = $measurePolicy;
        var modifier = tmp2;
        var $composer_1 = $composer_0;
        if (!((0 & 2) === 0))
          modifier = Companion_instance_6;
        var compositeKeyHash = get_currentCompositeKeyHashCode($composer_1, 0).hashCode();
        var localMap = $composer_1.t31();
        var materialized = materialize($composer_1, modifier);
        var tmp0_0 = Companion_getInstance_53().oah_1;
        // Inline function 'androidx.compose.runtime.ReusableComposeNode' call
        var $changed_0 = 6 | 896 & 0 << 6;
        var $composer_2 = $composer_1;
        var tmp_0 = $composer_2.g30();
        if (!isInterface(tmp_0, Applier)) {
          invalidApplier();
        }
        $composer_2.b31();
        if ($composer_2.h30()) {
          $composer_2.c31(tmp0_0);
        } else {
          $composer_2.d31();
        }
        var $this$ReusableComposeNode = _Updater___init__impl__rbfxm8($composer_2);
        Updater__set_impl_v7kwss($this$ReusableComposeNode, measurePolicy, Companion_getInstance_53().tah_1);
        Updater__set_impl_v7kwss($this$ReusableComposeNode, localMap, Companion_getInstance_53().sah_1);
        Updater__set_impl_v7kwss($this$ReusableComposeNode, compositeKeyHash, Companion_getInstance_53().wah_1);
        Updater__reconcile_impl_1mfi6g($this$ReusableComposeNode, Companion_getInstance_53().xah_1);
        Updater__set_impl_v7kwss($this$ReusableComposeNode, materialized, Companion_getInstance_53().qah_1);
        tmp0($composer_2, 14 & $changed_0 >> 6);
        $composer_2.e31();
        tmp = Unit_instance;
      } else {
        $composer_0.z30();
        tmp = Unit_instance;
      }
      return Unit_instance;
    };
  }
  function DialogLayout$lambda_0($layerScope, $animator, $layer, $properties, $modifier, $currentContent$delegate) {
    return function ($composer, $changed) {
      var $composer_0 = $composer;
      var tmp;
      if ($composer_0.r31(!(($changed & 3) === 2), $changed & 1)) {
        // Inline function 'androidx.compose.runtime.rememberCoroutineScope' call
        var getContext = null;
        var $composer_1 = $composer_0;
        if (!((1 & 1) === 0)) {
          getContext = DialogLayout$lambda$lambda;
        }
        var composer = $composer_1;
        // Inline function 'androidx.compose.runtime.cache' call
        // Inline function 'kotlin.let' call
        var it = $composer_1.i31();
        var tmp_0;
        if (false || it === Companion_getInstance_9().f30_1) {
          var value = createCompositionCoroutineScope(getContext(), composer);
          $composer_1.j31(value);
          tmp_0 = value;
        } else {
          tmp_0 = it;
        }
        var tmp$ret$0 = tmp_0;
        $layerScope._v = tmp$ret$0;
        // Inline function 'androidx.compose.runtime.cache' call
        var invalid = $composer_0.q31($animator);
        // Inline function 'kotlin.let' call
        var it_0 = $composer_0.i31();
        var tmp_1;
        if (invalid || it_0 === Companion_getInstance_9().f30_1) {
          var value_0 = DialogLayout$lambda$slambda_0($animator, null);
          $composer_0.j31(value_0);
          tmp_1 = value_0;
        } else {
          tmp_1 = it_0;
        }
        var tmp$ret$5 = tmp_1;
        LaunchedEffect_0(Unit_instance, tmp$ret$5, $composer_0, 6);
        // Inline function 'androidx.compose.runtime.CompositionLocal.current' call
        var this_0 = get_LocalWindowInfo();
        var $composer_2 = $composer_0;
        var containerSize = $composer_2.u31(this_0).bbr();
        var measurePolicy = rememberDialogMeasurePolicy($layer, $properties, containerSize, $composer_0, 0);
        // Inline function 'androidx.compose.runtime.CompositionLocal.current' call
        var this_1 = get_LocalPlatformWindowInsets();
        var $composer_3 = $composer_0;
        var tmp_2 = $composer_3.u31(this_1);
        // Inline function 'kotlin.run' call
        var dispatchReceiver = rememberComposableLambda(-979378898, true, DialogLayout$lambda$lambda_0($animator, $modifier, $properties, measurePolicy, $currentContent$delegate), $composer_0, 54);
        // Inline function 'androidx.compose.runtime.remember' call
        var $composer_4 = $composer_0;
        // Inline function 'androidx.compose.runtime.cache' call
        var invalid_0 = $composer_4.k31(dispatchReceiver);
        // Inline function 'kotlin.let' call
        var it_1 = $composer_4.i31();
        var tmp_3;
        if (invalid_0 || it_1 === Companion_getInstance_9().f30_1) {
          var value_1 = ComposableLambda$invoke$ref(dispatchReceiver);
          $composer_4.j31(value_1);
          tmp_3 = value_1;
        } else {
          tmp_3 = it_1;
        }
        var tmp$ret$11 = tmp_3;
        exclude(tmp_2, $properties.cd8_1, $properties.dd8_1, tmp$ret$11, $composer_0, 3072);
        tmp = Unit_instance;
      } else {
        $composer_0.z30();
        tmp = Unit_instance;
      }
      return Unit_instance;
    };
  }
  function DialogLayout$1$$inlined$onDispose$1($layerScope, $animator) {
    this.pda_1 = $layerScope;
    this.qda_1 = $animator;
  }
  protoOf(DialogLayout$1$$inlined$onDispose$1).s1d = function () {
    var tmp0_safe_receiver = this.pda_1._v;
    if ((tmp0_safe_receiver == null ? null : get_isActive(tmp0_safe_receiver)) === true) {
      this.qda_1.hd9();
    }
  };
  function DialogLayout$lambda_1($layerScope, $animator) {
    return function ($this$DisposableEffect) {
      // Inline function 'androidx.compose.runtime.DisposableEffectScope.onDispose' call
      return new DialogLayout$1$$inlined$onDispose$1($layerScope, $animator);
    };
  }
  function DialogLayout$lambda_2($properties, $modifier, $onOutsidePointerEvent, $content, $$changed, $$default) {
    return function ($composer, $force) {
      DialogLayout($properties, $modifier._v, $onOutsidePointerEvent._v, $content, $composer, updateChangedFlags($$changed | 1), $$default);
      return Unit_instance;
    };
  }
  function rememberDialogMeasurePolicy$lambda$lambda($contentSize) {
    return function (sizeWithoutInsets) {
      return new IntOffset(IntOffset__minus_impl_4m69hb(get_center(sizeWithoutInsets.o5g_1), get_center($contentSize)));
    };
  }
  function rememberDialogMeasurePolicy$lambda($platformInsets, $containerSize, $layer) {
    return function ($this$RootMeasurePolicy, contentSize) {
      var positionWithInsets_0 = positionWithInsets($this$RootMeasurePolicy, $platformInsets, $containerSize, rememberDialogMeasurePolicy$lambda$lambda(contentSize.o5g_1));
      $layer.zd4(IntRect(positionWithInsets_0, contentSize.o5g_1));
      return new IntOffset($layer.jd5(positionWithInsets_0));
    };
  }
  var properties_initialized_Dialog_skiko_kt_5sooc1;
  function _init_properties_Dialog_skiko_kt__7m405t() {
    if (!properties_initialized_Dialog_skiko_kt_5sooc1) {
      properties_initialized_Dialog_skiko_kt_5sooc1 = true;
      DefaultScrimColor = Color__copy$default_impl_ectz3s(Companion_getInstance_4().i6b_1, 0.6);
      androidx_compose_ui_window_DialogProperties$stable = 0;
    }
  }
  var androidx_compose_ui_window_OnBackClickEventHandler$stable;
  function OnBackClickEventHandler(compositeKey, onBack) {
    NavigationEventHandler_init_$Init$(new BackClickHandlerInfo(compositeKey), true, this);
    this.bda_1 = onBack;
    this.cda_1 = false;
    this.dda_1 = true;
  }
  protoOf(OnBackClickEventHandler).w8o = function () {
    if (!this.cda_1 && this.dda_1) {
      this.bda_1();
    }
    this.cda_1 = false;
  };
  protoOf(OnBackClickEventHandler).y8o = function () {
    this.cda_1 = false;
  };
  function BackClickHandlerInfo(compositeKey) {
    NavigationEventInfo.call(this);
    this.rda_1 = compositeKey;
  }
  protoOf(BackClickHandlerInfo).toString = function () {
    return 'BackClickHandlerInfo(compositeKey=' + this.rda_1.toString() + ')';
  };
  protoOf(BackClickHandlerInfo).hashCode = function () {
    return this.rda_1.hashCode();
  };
  protoOf(BackClickHandlerInfo).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof BackClickHandlerInfo))
      return false;
    if (!equalsLong(this.rda_1, other.rda_1))
      return false;
    return true;
  };
  var androidx_compose_ui_window_PopupProperties$stable;
  function PopupProperties_init_$Init$(focusable, dismissOnBackPress, dismissOnClickOutside, clippingEnabled, usePlatformDefaultWidth, $this) {
    focusable = focusable === VOID ? false : focusable;
    dismissOnBackPress = dismissOnBackPress === VOID ? true : dismissOnBackPress;
    dismissOnClickOutside = dismissOnClickOutside === VOID ? true : dismissOnClickOutside;
    clippingEnabled = clippingEnabled === VOID ? true : clippingEnabled;
    usePlatformDefaultWidth = usePlatformDefaultWidth === VOID ? false : usePlatformDefaultWidth;
    PopupProperties.call($this, focusable, dismissOnBackPress, dismissOnClickOutside, clippingEnabled, usePlatformDefaultWidth, true);
    return $this;
  }
  function PopupProperties_init_$Create$(focusable, dismissOnBackPress, dismissOnClickOutside, clippingEnabled, usePlatformDefaultWidth) {
    return PopupProperties_init_$Init$(focusable, dismissOnBackPress, dismissOnClickOutside, clippingEnabled, usePlatformDefaultWidth, objectCreate(protoOf(PopupProperties)));
  }
  function PopupProperties_init_$Init$_0(focusable, dismissOnBackPress, dismissOnClickOutside, clippingEnabled, $this) {
    focusable = focusable === VOID ? false : focusable;
    dismissOnBackPress = dismissOnBackPress === VOID ? true : dismissOnBackPress;
    dismissOnClickOutside = dismissOnClickOutside === VOID ? true : dismissOnClickOutside;
    clippingEnabled = clippingEnabled === VOID ? true : clippingEnabled;
    PopupProperties.call($this, focusable, dismissOnBackPress, dismissOnClickOutside, clippingEnabled, false, true);
    return $this;
  }
  function PopupProperties_init_$Create$_0(focusable, dismissOnBackPress, dismissOnClickOutside, clippingEnabled) {
    return PopupProperties_init_$Init$_0(focusable, dismissOnBackPress, dismissOnClickOutside, clippingEnabled, objectCreate(protoOf(PopupProperties)));
  }
  function PopupProperties(focusable, dismissOnBackPress, dismissOnClickOutside, clippingEnabled, usePlatformDefaultWidth, usePlatformInsets) {
    focusable = focusable === VOID ? false : focusable;
    dismissOnBackPress = dismissOnBackPress === VOID ? true : dismissOnBackPress;
    dismissOnClickOutside = dismissOnClickOutside === VOID ? true : dismissOnClickOutside;
    clippingEnabled = clippingEnabled === VOID ? true : clippingEnabled;
    usePlatformDefaultWidth = usePlatformDefaultWidth === VOID ? false : usePlatformDefaultWidth;
    usePlatformInsets = usePlatformInsets === VOID ? true : usePlatformInsets;
    this.sda_1 = focusable;
    this.tda_1 = dismissOnBackPress;
    this.uda_1 = dismissOnClickOutside;
    this.vda_1 = clippingEnabled;
    this.wda_1 = usePlatformDefaultWidth;
    this.xda_1 = usePlatformInsets;
  }
  protoOf(PopupProperties).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof PopupProperties))
      return false;
    if (!(this.sda_1 === other.sda_1))
      return false;
    if (!(this.tda_1 === other.tda_1))
      return false;
    if (!(this.uda_1 === other.uda_1))
      return false;
    if (!(this.vda_1 === other.vda_1))
      return false;
    if (!(this.wda_1 === other.wda_1))
      return false;
    if (!(this.xda_1 === other.xda_1))
      return false;
    return true;
  };
  protoOf(PopupProperties).hashCode = function () {
    var result = getBooleanHashCode(this.sda_1);
    result = imul(31, result) + getBooleanHashCode(this.tda_1) | 0;
    result = imul(31, result) + getBooleanHashCode(this.uda_1) | 0;
    result = imul(31, result) + getBooleanHashCode(this.vda_1) | 0;
    result = imul(31, result) + getBooleanHashCode(this.wda_1) | 0;
    result = imul(31, result) + getBooleanHashCode(this.xda_1) | 0;
    return result;
  };
  function Popup(popupPositionProvider, onDismissRequest, properties, content, $composer, $changed, $default) {
    var onDismissRequest_0 = {_v: onDismissRequest};
    var properties_0 = {_v: properties};
    var $composer_0 = $composer;
    $composer_0 = $composer_0.s30(-698215156);
    var $dirty = $changed;
    if (($changed & 6) === 0)
      $dirty = $dirty | ($composer_0.k31(popupPositionProvider) ? 4 : 2);
    if (!(($default & 2) === 0))
      $dirty = $dirty | 48;
    else if (($changed & 48) === 0)
      $dirty = $dirty | ($composer_0.q31(onDismissRequest_0._v) ? 32 : 16);
    if (!(($default & 4) === 0))
      $dirty = $dirty | 384;
    else if (($changed & 384) === 0)
      $dirty = $dirty | ($composer_0.k31(properties_0._v) ? 256 : 128);
    if (($changed & 3072) === 0)
      $dirty = $dirty | ($composer_0.q31(content) ? 2048 : 1024);
    if ($composer_0.r31(!(($dirty & 1171) === 1170), $dirty & 1)) {
      if (!(($default & 2) === 0)) {
        onDismissRequest_0._v = null;
      }
      if (!(($default & 4) === 0)) {
        properties_0._v = PopupProperties_init_$Create$();
      }
      Popup_0(popupPositionProvider, onDismissRequest_0._v, properties_0._v, null, null, content, $composer_0, 27648 | 14 & $dirty | 112 & $dirty | 896 & $dirty | 458752 & $dirty << 6, 0);
    } else {
      $composer_0.z30();
    }
    var tmp0_safe_receiver = $composer_0.t30();
    if (tmp0_safe_receiver == null)
      null;
    else {
      tmp0_safe_receiver.p3c(Popup$lambda(popupPositionProvider, onDismissRequest_0, properties_0, content, $changed, $default));
    }
  }
  function Popup_0(popupPositionProvider, onDismissRequest, properties, onPreviewKeyEvent, onKeyEvent, content, $composer, $changed, $default) {
    var onDismissRequest_0 = {_v: onDismissRequest};
    var properties_0 = {_v: properties};
    var onPreviewKeyEvent_0 = {_v: onPreviewKeyEvent};
    var onKeyEvent_0 = {_v: onKeyEvent};
    var $composer_0 = $composer;
    $composer_0 = $composer_0.s30(-719911066);
    var $dirty = $changed;
    if (($changed & 6) === 0)
      $dirty = $dirty | ($composer_0.k31(popupPositionProvider) ? 4 : 2);
    if (!(($default & 2) === 0))
      $dirty = $dirty | 48;
    else if (($changed & 48) === 0)
      $dirty = $dirty | ($composer_0.q31(onDismissRequest_0._v) ? 32 : 16);
    if (!(($default & 4) === 0))
      $dirty = $dirty | 384;
    else if (($changed & 384) === 0)
      $dirty = $dirty | ($composer_0.k31(properties_0._v) ? 256 : 128);
    if (!(($default & 8) === 0))
      $dirty = $dirty | 3072;
    else if (($changed & 3072) === 0)
      $dirty = $dirty | ($composer_0.q31(onPreviewKeyEvent_0._v) ? 2048 : 1024);
    if (!(($default & 16) === 0))
      $dirty = $dirty | 24576;
    else if (($changed & 24576) === 0)
      $dirty = $dirty | ($composer_0.q31(onKeyEvent_0._v) ? 16384 : 8192);
    if (($changed & 196608) === 0)
      $dirty = $dirty | ($composer_0.q31(content) ? 131072 : 65536);
    if ($composer_0.r31(!(($dirty & 74899) === 74898), $dirty & 1)) {
      if (!(($default & 2) === 0)) {
        onDismissRequest_0._v = null;
      }
      if (!(($default & 4) === 0)) {
        properties_0._v = PopupProperties_init_$Create$();
      }
      if (!(($default & 8) === 0)) {
        onPreviewKeyEvent_0._v = null;
      }
      if (!(($default & 16) === 0)) {
        onKeyEvent_0._v = null;
      }
      var currentOnDismissRequest$delegate = rememberUpdatedState(onDismissRequest_0._v, $composer_0, 14 & $dirty >> 3);
      var currentOnKeyEvent$delegate = rememberUpdatedState(onKeyEvent_0._v, $composer_0, 14 & $dirty >> 12);
      if (properties_0._v.sda_1) {
        $composer_0.m30(-2098310227);
        var compositeKey = get_currentCompositeKeyHashCode($composer_0, 0);
        var tmp0 = $composer_0;
        // Inline function 'androidx.compose.runtime.cache' call
        var invalid = $composer_0.o31(compositeKey);
        // Inline function 'kotlin.let' call
        var it = tmp0.i31();
        var tmp;
        if (invalid || it === Companion_getInstance_9().f30_1) {
          var value = new OnBackClickEventHandler(compositeKey, Popup$lambda_2(currentOnDismissRequest$delegate));
          tmp0.j31(value);
          tmp = value;
        } else {
          tmp = it;
        }
        var onBackHandler = tmp;
        var tmp_0 = properties_0._v.tda_1;
        var tmp0_0 = $composer_0;
        // Inline function 'androidx.compose.runtime.cache' call
        var invalid_0 = !!($composer_0.q31(onBackHandler) | ($dirty & 896) === 256);
        // Inline function 'kotlin.let' call
        var it_0 = tmp0_0.i31();
        var tmp_1;
        if (invalid_0 || it_0 === Companion_getInstance_9().f30_1) {
          var value_0 = Popup$slambda_0(onBackHandler, properties_0, null);
          tmp0_0.j31(value_0);
          tmp_1 = value_0;
        } else {
          tmp_1 = it_0;
        }
        var tmp$ret$4 = tmp_1;
        LaunchedEffect(onBackHandler, tmp_0, tmp$ret$4, $composer_0, 0);
        var tmp0_1 = findDefaultNavigationEventDispatcherOwner($composer_0, 0);
        var tmp$ret$8;
        $l$block: {
          // Inline function 'kotlin.requireNotNull' call
          if (tmp0_1 == null) {
            // Inline function 'kotlin.error' call
            var message = 'NavigationEventDispatcherOwner not found';
            throw IllegalStateException_init_$Create$(toString(message));
          } else {
            tmp$ret$8 = tmp0_1;
            break $l$block;
          }
        }
        var navigationEventDispatcher = tmp$ret$8.p8s();
        var tmp0_2 = $composer_0;
        // Inline function 'androidx.compose.runtime.cache' call
        var invalid_1 = !!($composer_0.q31(navigationEventDispatcher) | $composer_0.q31(onBackHandler));
        // Inline function 'kotlin.let' call
        var it_1 = tmp0_2.i31();
        var tmp_2;
        if (invalid_1 || it_1 === Companion_getInstance_9().f30_1) {
          var value_1 = Popup$lambda_3(navigationEventDispatcher, onBackHandler);
          tmp0_2.j31(value_1);
          tmp_2 = value_1;
        } else {
          tmp_2 = it_1;
        }
        var tmp$ret$11 = tmp_2;
        DisposableEffect_0(navigationEventDispatcher, onBackHandler, tmp$ret$11, $composer_0, 0);
        $composer_0.n30();
      } else {
        $composer_0.m30(-2097557764);
        $composer_0.n30();
      }
      var tmp_3;
      if (properties_0._v.uda_1 && !(onDismissRequest_0._v == null)) {
        $composer_0.m30(-2097442847);
        var tmp0_3 = $composer_0;
        // Inline function 'androidx.compose.runtime.cache' call
        var invalid_2 = $composer_0.k31(currentOnDismissRequest$delegate);
        // Inline function 'kotlin.let' call
        var it_2 = tmp0_3.i31();
        var tmp_4;
        if (invalid_2 || it_2 === Companion_getInstance_9().f30_1) {
          var value_2 = Popup$lambda_4(currentOnDismissRequest$delegate);
          tmp0_3.j31(value_2);
          tmp_4 = value_2;
        } else {
          tmp_4 = it_2;
        }
        var tmp0_group = tmp_4;
        $composer_0.n30();
        tmp_3 = tmp0_group;
      } else {
        $composer_0.m30(-2096918296);
        $composer_0.n30();
        tmp_3 = null;
      }
      var onOutsidePointerEvent = tmp_3;
      var tmp_5 = properties_0._v;
      var tmp_6 = Companion_instance_6;
      // Inline function 'androidx.compose.runtime.cache' call
      var this_0 = $composer_0;
      // Inline function 'kotlin.let' call
      var it_3 = this_0.i31();
      var tmp_7;
      if (false || it_3 === Companion_getInstance_9().f30_1) {
        var value_3 = Popup$lambda_5;
        this_0.j31(value_3);
        tmp_7 = value_3;
      } else {
        tmp_7 = it_3;
      }
      var tmp$ret$19 = tmp_7;
      PopupLayout(popupPositionProvider, tmp_5, semantics(tmp_6, VOID, tmp$ret$19), onPreviewKeyEvent_0._v, Popup$lambda_1(currentOnKeyEvent$delegate), onOutsidePointerEvent, content, $composer_0, 14 & $dirty | 112 & $dirty >> 3 | 7168 & $dirty | 3670016 & $dirty << 3, 0);
    } else {
      $composer_0.z30();
    }
    var tmp1_safe_receiver = $composer_0.t30();
    if (tmp1_safe_receiver == null)
      null;
    else {
      tmp1_safe_receiver.p3c(Popup$lambda_6(popupPositionProvider, onDismissRequest_0, properties_0, onPreviewKeyEvent_0, onKeyEvent_0, content, $changed, $default));
    }
  }
  function PopupLayout(popupPositionProvider, properties, modifier, onPreviewKeyEvent, onKeyEvent, onOutsidePointerEvent, content, $composer, $changed, $default) {
    var onPreviewKeyEvent_0 = {_v: onPreviewKeyEvent};
    var onKeyEvent_0 = {_v: onKeyEvent};
    var onOutsidePointerEvent_0 = {_v: onOutsidePointerEvent};
    var $composer_0 = $composer;
    $composer_0 = $composer_0.s30(-495490045);
    var $dirty = $changed;
    if (($changed & 6) === 0)
      $dirty = $dirty | ($composer_0.k31(popupPositionProvider) ? 4 : 2);
    if (($changed & 48) === 0)
      $dirty = $dirty | ($composer_0.k31(properties) ? 32 : 16);
    if (($changed & 384) === 0)
      $dirty = $dirty | ($composer_0.k31(modifier) ? 256 : 128);
    if (!(($default & 8) === 0))
      $dirty = $dirty | 3072;
    else if (($changed & 3072) === 0)
      $dirty = $dirty | ($composer_0.q31(onPreviewKeyEvent_0._v) ? 2048 : 1024);
    if (!(($default & 16) === 0))
      $dirty = $dirty | 24576;
    else if (($changed & 24576) === 0)
      $dirty = $dirty | ($composer_0.q31(onKeyEvent_0._v) ? 16384 : 8192);
    if (!(($default & 32) === 0))
      $dirty = $dirty | 196608;
    else if (($changed & 196608) === 0)
      $dirty = $dirty | ($composer_0.q31(onOutsidePointerEvent_0._v) ? 131072 : 65536);
    if (($changed & 1572864) === 0)
      $dirty = $dirty | ($composer_0.q31(content) ? 1048576 : 524288);
    if ($composer_0.r31(!(($dirty & 599187) === 599186), $dirty & 1)) {
      if (!(($default & 8) === 0)) {
        onPreviewKeyEvent_0._v = null;
      }
      if (!(($default & 16) === 0)) {
        onKeyEvent_0._v = null;
      }
      if (!(($default & 32) === 0)) {
        onOutsidePointerEvent_0._v = null;
      }
      // Inline function 'androidx.compose.runtime.cache' call
      var this_0 = $composer_0;
      // Inline function 'kotlin.let' call
      var it = this_0.i31();
      var tmp;
      if (false || it === Companion_getInstance_9().f30_1) {
        var value = mutableStateOf(Companion_getInstance_19().e5g_1);
        this_0.j31(value);
        tmp = value;
      } else {
        tmp = it;
      }
      var parentBoundsInWindow = tmp;
      var tmp_0 = Companion_instance_6;
      // Inline function 'androidx.compose.runtime.cache' call
      var this_1 = $composer_0;
      // Inline function 'kotlin.let' call
      var it_0 = this_1.i31();
      var tmp_1;
      if (false || it_0 === Companion_getInstance_9().f30_1) {
        var value_0 = PopupLayout$lambda(parentBoundsInWindow);
        this_1.j31(value_0);
        tmp_1 = value_0;
      } else {
        tmp_1 = it_0;
      }
      var tmp$ret$4 = tmp_1;
      EmptyLayout(onPlaced_0(tmp_0, tmp$ret$4), $composer_0, 6);
      var currentContent$delegate = rememberUpdatedState(content, $composer_0, 14 & $dirty >> 18);
      var layer = rememberComposeSceneLayer(properties.sda_1, $composer_0, 0, 0);
      layer.hd5(onPreviewKeyEvent_0._v, onKeyEvent_0._v);
      layer.id5(onOutsidePointerEvent_0._v);
      // Inline function 'kotlin.run' call
      var dispatchReceiver = rememberComposableLambda(-1393358219, true, PopupLayout$lambda_1(properties, layer, popupPositionProvider, parentBoundsInWindow, modifier, currentContent$delegate), $composer_0, 54);
      // Inline function 'androidx.compose.runtime.remember' call
      var $composer_1 = $composer_0;
      // Inline function 'androidx.compose.runtime.cache' call
      var invalid = $composer_1.k31(dispatchReceiver);
      // Inline function 'kotlin.let' call
      var it_1 = $composer_1.i31();
      var tmp_2;
      if (invalid || it_1 === Companion_getInstance_9().f30_1) {
        var value_1 = ComposableLambda$invoke$ref(dispatchReceiver);
        $composer_1.j31(value_1);
        tmp_2 = value_1;
      } else {
        tmp_2 = it_1;
      }
      var tmp$ret$8 = tmp_2;
      Content(layer, tmp$ret$8, $composer_0, 48);
      var tmp0 = $composer_0;
      // Inline function 'androidx.compose.runtime.cache' call
      var invalid_0 = $composer_0.q31(layer);
      // Inline function 'kotlin.let' call
      var it_2 = tmp0.i31();
      var tmp_3;
      if (invalid_0 || it_2 === Companion_getInstance_9().f30_1) {
        var value_2 = PopupLayout$lambda_2(layer);
        tmp0.j31(value_2);
        tmp_3 = value_2;
      } else {
        tmp_3 = it_2;
      }
      var tmp$ret$15 = tmp_3;
      DisposableEffect(Unit_instance, tmp$ret$15, $composer_0, 6);
    } else {
      $composer_0.z30();
    }
    var tmp0_safe_receiver = $composer_0.t30();
    if (tmp0_safe_receiver == null)
      null;
    else {
      tmp0_safe_receiver.p3c(PopupLayout$lambda_3(popupPositionProvider, properties, modifier, onPreviewKeyEvent_0, onKeyEvent_0, onOutsidePointerEvent_0, content, $changed, $default));
    }
  }
  function get_platformInsets_0(_this__u8e3s4, $composer, $changed) {
    var $composer_0 = $composer;
    var tmp;
    if (_this__u8e3s4.xda_1) {
      $composer_0.m30(-1386059787);
      // Inline function 'androidx.compose.runtime.CompositionLocal.current' call
      var this_0 = get_LocalPlatformWindowInsets();
      var $composer_1 = $composer_0;
      var tmp1_group = $composer_1.u31(this_0).xcz();
      $composer_0.n30();
      tmp = tmp1_group;
    } else {
      $composer_0.m30(-1385987154);
      $composer_0.n30();
      tmp = Companion_getInstance_73().wcz_1;
    }
    return tmp;
  }
  function rememberPopupMeasurePolicy(layer, popupPositionProvider, properties, containerSize, platformInsets, layoutDirection, parentBoundsInWindow, $composer, $changed) {
    var $composer_0 = $composer;
    // Inline function 'androidx.compose.runtime.cache' call
    var invalid = !!(!!(!!(!!(!!(!!((($changed & 14 ^ 6) > 4 && $composer_0.k31(layer) || ($changed & 6) === 4) | (($changed & 112 ^ 48) > 32 && $composer_0.k31(popupPositionProvider) || ($changed & 48) === 32)) | (($changed & 896 ^ 384) > 256 && $composer_0.k31(properties) || ($changed & 384) === 256)) | (($changed & 7168 ^ 3072) > 2048 && $composer_0.o31(_IntSize___get_packedValue__impl__uho7jf(containerSize)) || ($changed & 3072) === 2048)) | (($changed & 57344 ^ 24576) > 16384 && $composer_0.k31(platformInsets) || ($changed & 24576) === 16384)) | (($changed & 458752 ^ 196608) > 131072 && $composer_0.m31(layoutDirection.a1_1) || ($changed & 196608) === 131072)) | (($changed & 3670016 ^ 1572864) > 1048576 && $composer_0.k31(parentBoundsInWindow) || ($changed & 1572864) === 1048576));
    // Inline function 'kotlin.let' call
    var it = $composer_0.i31();
    var tmp;
    if (invalid || it === Companion_getInstance_9().f30_1) {
      var value = RootMeasurePolicy_0(platformInsets, properties.wda_1, rememberPopupMeasurePolicy$lambda(parentBoundsInWindow, platformInsets, containerSize, layer, popupPositionProvider, layoutDirection, properties));
      $composer_0.j31(value);
      tmp = value;
    } else {
      tmp = it;
    }
    return tmp;
  }
  function clipPosition(position, contentSize, containerSize) {
    var tmp;
    // Inline function 'androidx.compose.ui.unit.IntSize.width' call
    // Inline function 'androidx.compose.ui.util.unpackInt1' call
    var value = _IntSize___get_packedValue__impl__uho7jf(contentSize);
    var tmp_0 = convertToInt(shiftRight(value, 32));
    // Inline function 'androidx.compose.ui.unit.IntSize.width' call
    // Inline function 'androidx.compose.ui.util.unpackInt1' call
    var value_0 = _IntSize___get_packedValue__impl__uho7jf(containerSize);
    if (tmp_0 < convertToInt(shiftRight(value_0, 32))) {
      var tmp_1 = _IntOffset___get_x__impl__qiqr5o(position);
      // Inline function 'androidx.compose.ui.unit.IntSize.width' call
      // Inline function 'androidx.compose.ui.util.unpackInt1' call
      var value_1 = _IntSize___get_packedValue__impl__uho7jf(containerSize);
      var tmp_2 = convertToInt(shiftRight(value_1, 32));
      // Inline function 'androidx.compose.ui.unit.IntSize.width' call
      // Inline function 'androidx.compose.ui.util.unpackInt1' call
      var value_2 = _IntSize___get_packedValue__impl__uho7jf(contentSize);
      var tmp$ret$6 = convertToInt(shiftRight(value_2, 32));
      tmp = coerceIn(tmp_1, 0, tmp_2 - tmp$ret$6 | 0);
    } else {
      tmp = 0;
    }
    var tmp0 = tmp;
    var tmp_3;
    // Inline function 'androidx.compose.ui.unit.IntSize.height' call
    // Inline function 'androidx.compose.ui.util.unpackInt2' call
    var value_3 = _IntSize___get_packedValue__impl__uho7jf(contentSize);
    var tmp_4 = convertToInt(bitwiseAnd(value_3, new Long(-1, 0)));
    // Inline function 'androidx.compose.ui.unit.IntSize.height' call
    // Inline function 'androidx.compose.ui.util.unpackInt2' call
    var value_4 = _IntSize___get_packedValue__impl__uho7jf(containerSize);
    if (tmp_4 < convertToInt(bitwiseAnd(value_4, new Long(-1, 0)))) {
      var tmp_5 = _IntOffset___get_y__impl__2avpwj(position);
      // Inline function 'androidx.compose.ui.unit.IntSize.height' call
      // Inline function 'androidx.compose.ui.util.unpackInt2' call
      var value_5 = _IntSize___get_packedValue__impl__uho7jf(containerSize);
      var tmp_6 = convertToInt(bitwiseAnd(value_5, new Long(-1, 0)));
      // Inline function 'androidx.compose.ui.unit.IntSize.height' call
      // Inline function 'androidx.compose.ui.util.unpackInt2' call
      var value_6 = _IntSize___get_packedValue__impl__uho7jf(contentSize);
      var tmp$ret$14 = convertToInt(bitwiseAnd(value_6, new Long(-1, 0)));
      tmp_3 = coerceIn(tmp_5, 0, tmp_6 - tmp$ret$14 | 0);
    } else {
      tmp_3 = 0;
    }
    // Inline function 'androidx.compose.ui.unit.IntOffset' call
    // Inline function 'androidx.compose.ui.util.packInts' call
    var val2 = tmp_3;
    var tmp$ret$17 = bitwiseOr(shiftLeft(fromInt(tmp0), 32), bitwiseAnd(fromInt(val2), new Long(-1, 0)));
    return _IntOffset___init__impl__rq8h7b(tmp$ret$17);
  }
  function Popup$lambda($popupPositionProvider, $onDismissRequest, $properties, $content, $$changed, $$default) {
    return function ($composer, $force) {
      Popup($popupPositionProvider, $onDismissRequest._v, $properties._v, $content, $composer, updateChangedFlags($$changed | 1), $$default);
      return Unit_instance;
    };
  }
  function Popup$lambda_0($currentOnDismissRequest$delegate) {
    // Inline function 'androidx.compose.runtime.getValue' call
    getLocalDelegateReference('currentOnDismissRequest', KProperty0, false);
    return $currentOnDismissRequest$delegate.u1();
  }
  function Popup$lambda_1($currentOnKeyEvent$delegate) {
    // Inline function 'androidx.compose.runtime.getValue' call
    getLocalDelegateReference('currentOnKeyEvent', KProperty0, false);
    return $currentOnKeyEvent$delegate.u1();
  }
  function Popup$lambda_2($currentOnDismissRequest$delegate) {
    return function () {
      var tmp0_safe_receiver = Popup$lambda_0($currentOnDismissRequest$delegate);
      if (tmp0_safe_receiver == null)
        null;
      else
        tmp0_safe_receiver();
      return Unit_instance;
    };
  }
  function Popup$slambda($onBackHandler, $properties, resultContinuation) {
    this.gdb_1 = $onBackHandler;
    this.hdb_1 = $properties;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(Popup$slambda).p24 = function ($this$LaunchedEffect, $completion) {
    var tmp = this.q24($this$LaunchedEffect, $completion);
    tmp.p9_1 = Unit_instance;
    tmp.q9_1 = null;
    return tmp.v9();
  };
  protoOf(Popup$slambda).ja = function (p1, $completion) {
    return this.p24((!(p1 == null) ? isInterface(p1, CoroutineScope_0) : false) ? p1 : THROW_CCE(), $completion);
  };
  protoOf(Popup$slambda).v9 = function () {
    var suspendResult = this.p9_1;
    $sm: do
      try {
        var tmp = this.n9_1;
        if (tmp === 0) {
          this.o9_1 = 1;
          this.gdb_1.dda_1 = this.hdb_1._v.tda_1;
          return Unit_instance;
        } else if (tmp === 1) {
          throw this.q9_1;
        }
      } catch ($p) {
        var e = $p;
        throw e;
      }
     while (true);
  };
  protoOf(Popup$slambda).q24 = function ($this$LaunchedEffect, completion) {
    var i = new Popup$slambda(this.gdb_1, this.hdb_1, completion);
    i.idb_1 = $this$LaunchedEffect;
    return i;
  };
  function Popup$slambda_0($onBackHandler, $properties, resultContinuation) {
    var i = new Popup$slambda($onBackHandler, $properties, resultContinuation);
    return constructCallableReference(function ($this$LaunchedEffect, $completion) {
      return i.p24($this$LaunchedEffect, $completion);
    }, 1);
  }
  function Popup$$inlined$cache$3$1($onBackHandler) {
    this.jdb_1 = $onBackHandler;
  }
  protoOf(Popup$$inlined$cache$3$1).s1d = function () {
    this.jdb_1.l4();
  };
  function Popup$lambda_3($navigationEventDispatcher, $onBackHandler) {
    return function ($this$DisposableEffect) {
      $navigationEventDispatcher.w8n($onBackHandler);
      // Inline function 'androidx.compose.runtime.DisposableEffectScope.onDispose' call
      return new Popup$$inlined$cache$3$1($onBackHandler);
    };
  }
  function Popup$lambda_4($currentOnDismissRequest$delegate) {
    return function (eventType, _unused_var__etf5q3) {
      var tmp;
      if (equals(eventType, new PointerEventType(Companion_getInstance_41().la1_1))) {
        var tmp0_safe_receiver = Popup$lambda_0($currentOnDismissRequest$delegate);
        if (tmp0_safe_receiver == null)
          null;
        else
          tmp0_safe_receiver();
        tmp = Unit_instance;
      }
      return Unit_instance;
    };
  }
  function Popup$lambda_5($this$semantics) {
    popup($this$semantics);
    return Unit_instance;
  }
  function Popup$lambda_6($popupPositionProvider, $onDismissRequest, $properties, $onPreviewKeyEvent, $onKeyEvent, $content, $$changed, $$default) {
    return function ($composer, $force) {
      Popup_0($popupPositionProvider, $onDismissRequest._v, $properties._v, $onPreviewKeyEvent._v, $onKeyEvent._v, $content, $composer, updateChangedFlags($$changed | 1), $$default);
      return Unit_instance;
    };
  }
  function PopupLayout$lambda($parentBoundsInWindow) {
    return function (childCoordinates) {
      var tmp0_safe_receiver = childCoordinates.zah();
      if (tmp0_safe_receiver == null)
        null;
      else {
        // Inline function 'kotlin.let' call
        var layoutPosition = round(positionInWindow(tmp0_safe_receiver));
        var layoutSize = tmp0_safe_receiver.q95();
        $parentBoundsInWindow.s21(IntRect(layoutPosition, layoutSize));
      }
      return Unit_instance;
    };
  }
  function PopupLayout$lambda_0($currentContent$delegate) {
    // Inline function 'androidx.compose.runtime.getValue' call
    getLocalDelegateReference('currentContent', KProperty0, false);
    return $currentContent$delegate.u1();
  }
  function PopupLayout$lambda$lambda($modifier, $properties, $measurePolicy, $currentContent$delegate) {
    return function ($composer, $changed) {
      var $composer_0 = $composer;
      var tmp;
      if ($composer_0.r31(!(($changed & 3) === 2), $changed & 1)) {
        var tmp0 = PopupLayout$lambda_0($currentContent$delegate);
        var tmp2 = excludeWindowInsets($modifier, $properties.xda_1, false);
        // Inline function 'androidx.compose.ui.layout.Layout' call
        var measurePolicy = $measurePolicy;
        var modifier = tmp2;
        var $composer_1 = $composer_0;
        if (!((0 & 2) === 0))
          modifier = Companion_instance_6;
        var compositeKeyHash = get_currentCompositeKeyHashCode($composer_1, 0).hashCode();
        var localMap = $composer_1.t31();
        var materialized = materialize($composer_1, modifier);
        var tmp0_0 = Companion_getInstance_53().oah_1;
        // Inline function 'androidx.compose.runtime.ReusableComposeNode' call
        var $changed_0 = 6 | 896 & 0 << 6;
        var $composer_2 = $composer_1;
        var tmp_0 = $composer_2.g30();
        if (!isInterface(tmp_0, Applier)) {
          invalidApplier();
        }
        $composer_2.b31();
        if ($composer_2.h30()) {
          $composer_2.c31(tmp0_0);
        } else {
          $composer_2.d31();
        }
        var $this$ReusableComposeNode = _Updater___init__impl__rbfxm8($composer_2);
        Updater__set_impl_v7kwss($this$ReusableComposeNode, measurePolicy, Companion_getInstance_53().tah_1);
        Updater__set_impl_v7kwss($this$ReusableComposeNode, localMap, Companion_getInstance_53().sah_1);
        Updater__set_impl_v7kwss($this$ReusableComposeNode, compositeKeyHash, Companion_getInstance_53().wah_1);
        Updater__reconcile_impl_1mfi6g($this$ReusableComposeNode, Companion_getInstance_53().xah_1);
        Updater__set_impl_v7kwss($this$ReusableComposeNode, materialized, Companion_getInstance_53().qah_1);
        tmp0($composer_2, 14 & $changed_0 >> 6);
        $composer_2.e31();
        tmp = Unit_instance;
      } else {
        $composer_0.z30();
        tmp = Unit_instance;
      }
      return Unit_instance;
    };
  }
  function PopupLayout$lambda_1($properties, $layer, $popupPositionProvider, $parentBoundsInWindow, $modifier, $currentContent$delegate) {
    return function ($composer, $changed) {
      var $composer_0 = $composer;
      var tmp;
      if ($composer_0.r31(!(($changed & 3) === 2), $changed & 1)) {
        var platformInsets = get_platformInsets_0($properties, $composer_0, 0);
        // Inline function 'androidx.compose.runtime.CompositionLocal.current' call
        var this_0 = get_LocalWindowInfo();
        var $composer_1 = $composer_0;
        var containerSize = $composer_1.u31(this_0).bbr();
        // Inline function 'androidx.compose.runtime.CompositionLocal.current' call
        var this_1 = get_LocalLayoutDirection();
        var $composer_2 = $composer_0;
        var layoutDirection = $composer_2.u31(this_1);
        var measurePolicy = rememberPopupMeasurePolicy($layer, $popupPositionProvider, $properties, containerSize, platformInsets, layoutDirection, $parentBoundsInWindow, $composer_0, 1572864);
        // Inline function 'androidx.compose.runtime.CompositionLocal.current' call
        var this_2 = get_LocalPlatformWindowInsets();
        var $composer_3 = $composer_0;
        var tmp_0 = $composer_3.u31(this_2);
        // Inline function 'kotlin.run' call
        var dispatchReceiver = rememberComposableLambda(-1791557822, true, PopupLayout$lambda$lambda($modifier, $properties, measurePolicy, $currentContent$delegate), $composer_0, 54);
        // Inline function 'androidx.compose.runtime.remember' call
        var $composer_4 = $composer_0;
        // Inline function 'androidx.compose.runtime.cache' call
        var invalid = $composer_4.k31(dispatchReceiver);
        // Inline function 'kotlin.let' call
        var it = $composer_4.i31();
        var tmp_1;
        if (invalid || it === Companion_getInstance_9().f30_1) {
          var value = ComposableLambda$invoke$ref(dispatchReceiver);
          $composer_4.j31(value);
          tmp_1 = value;
        } else {
          tmp_1 = it;
        }
        var tmp$ret$3 = tmp_1;
        exclude(tmp_0, $properties.xda_1, false, tmp$ret$3, $composer_0, 3456);
        tmp = Unit_instance;
      } else {
        $composer_0.z30();
        tmp = Unit_instance;
      }
      return Unit_instance;
    };
  }
  function PopupLayout$$inlined$cache$2$1($layer) {
    this.kdb_1 = $layer;
  }
  protoOf(PopupLayout$$inlined$cache$2$1).s1d = function () {
    this.kdb_1.j4();
  };
  function PopupLayout$lambda_2($layer) {
    return function ($this$DisposableEffect) {
      // Inline function 'androidx.compose.runtime.DisposableEffectScope.onDispose' call
      return new PopupLayout$$inlined$cache$2$1($layer);
    };
  }
  function PopupLayout$lambda_3($popupPositionProvider, $properties, $modifier, $onPreviewKeyEvent, $onKeyEvent, $onOutsidePointerEvent, $content, $$changed, $$default) {
    return function ($composer, $force) {
      PopupLayout($popupPositionProvider, $properties, $modifier, $onPreviewKeyEvent._v, $onKeyEvent._v, $onOutsidePointerEvent._v, $content, $composer, updateChangedFlags($$changed | 1), $$default);
      return Unit_instance;
    };
  }
  function rememberPopupMeasurePolicy$lambda$lambda($parentRectInWindow, $platformInsets, $popupPositionProvider, $layoutDirection, $contentSize, $properties) {
    return function (sizeWithoutInsets) {
      var boundsWithoutInsets = $parentRectInWindow.j5g(-$platformInsets.e9f() | 0, -$platformInsets.map() | 0);
      var positionInWindow = $popupPositionProvider.ldb(boundsWithoutInsets, sizeWithoutInsets.o5g_1, $layoutDirection, $contentSize);
      var tmp;
      if ($properties.vda_1) {
        tmp = clipPosition(positionInWindow, $contentSize, sizeWithoutInsets.o5g_1);
      } else {
        tmp = positionInWindow;
      }
      return new IntOffset(tmp);
    };
  }
  function rememberPopupMeasurePolicy$lambda($parentBoundsInWindow, $platformInsets, $containerSize, $layer, $popupPositionProvider, $layoutDirection, $properties) {
    return function ($this$RootMeasurePolicy, contentSize) {
      var parentRectInWindow = $parentBoundsInWindow.u1();
      var positionWithInsets_0 = positionWithInsets($this$RootMeasurePolicy, $platformInsets, $containerSize, rememberPopupMeasurePolicy$lambda$lambda(parentRectInWindow, $platformInsets, $popupPositionProvider, $layoutDirection, contentSize.o5g_1, $properties));
      $layer.zd4(IntRect(positionWithInsets_0, contentSize.o5g_1));
      return new IntOffset($layer.jd5(positionWithInsets_0));
    };
  }
  function RootMeasurePolicy_0(platformInsets, usePlatformDefaultWidth, calculatePosition) {
    var tmp = RootMeasurePolicy$lambda(platformInsets, usePlatformDefaultWidth, calculatePosition);
    return new sam$androidx_compose_ui_layout_MeasurePolicy$0_1(tmp);
  }
  function positionWithInsets(_this__u8e3s4, insets, size, calculatePosition) {
    var horizontal = insets.e9f() + insets.x61() | 0;
    var vertical = insets.map() + insets.nap() | 0;
    // Inline function 'androidx.compose.ui.unit.IntSize.width' call
    // Inline function 'androidx.compose.ui.util.unpackInt1' call
    var value = _IntSize___get_packedValue__impl__uho7jf(size);
    var tmp0 = convertToInt(shiftRight(value, 32)) - horizontal | 0;
    // Inline function 'androidx.compose.ui.unit.IntSize.height' call
    // Inline function 'androidx.compose.ui.util.unpackInt2' call
    var value_0 = _IntSize___get_packedValue__impl__uho7jf(size);
    // Inline function 'androidx.compose.ui.unit.IntSize' call
    // Inline function 'androidx.compose.ui.util.packInts' call
    var val2 = convertToInt(bitwiseAnd(value_0, new Long(-1, 0))) - vertical | 0;
    var tmp$ret$5 = bitwiseOr(shiftLeft(fromInt(tmp0), 32), bitwiseAnd(fromInt(val2), new Long(-1, 0)));
    var sizeWithoutInsets = _IntSize___init__impl__emcjft(tmp$ret$5);
    var position = calculatePosition(new IntSize(sizeWithoutInsets)).a5g_1;
    var tmp0_0 = insets.e9f();
    // Inline function 'androidx.compose.ui.unit.IntOffset' call
    // Inline function 'androidx.compose.ui.util.packInts' call
    var val2_0 = insets.map();
    var tmp$ret$7 = bitwiseOr(shiftLeft(fromInt(tmp0_0), 32), bitwiseAnd(fromInt(val2_0), new Long(-1, 0)));
    var offset = _IntOffset___init__impl__rq8h7b(tmp$ret$7);
    return IntOffset__plus_impl_nqoa9b(position, offset);
  }
  function applyPlatformConstrains(_this__u8e3s4, constraints, platformInsets, usePlatformDefaultWidth) {
    var horizontal = platformInsets.e9f() + platformInsets.x61() | 0;
    var vertical = platformInsets.map() + platformInsets.nap() | 0;
    var platformConstraints = offset(constraints, -horizontal | 0, -vertical | 0);
    var tmp;
    if (usePlatformDefaultWidth) {
      tmp = constrain(platformConstraints, platformDefaultConstrains(_this__u8e3s4, constraints));
    } else {
      tmp = platformConstraints;
    }
    return tmp;
  }
  function platformDefaultConstrains(_this__u8e3s4, constraints) {
    var tmp0 = preferredDialogWidth(_this__u8e3s4, constraints);
    // Inline function 'kotlin.math.min' call
    var b = _Constraints___get_maxWidth__impl__uuyqc(constraints);
    var tmp$ret$0 = Math.min(tmp0, b);
    return Constraints__copy$default_impl_f452rp(constraints, VOID, tmp$ret$0);
  }
  function preferredDialogWidth(_this__u8e3s4, constraints) {
    var tmp0 = _Constraints___get_maxWidth__impl__uuyqc(constraints);
    // Inline function 'kotlin.math.min' call
    var b = _Constraints___get_maxHeight__impl__dt3e8z(constraints);
    var tmp$ret$0 = Math.min(tmp0, b);
    var smallestWidth = _this__u8e3s4.d5f(tmp$ret$0);
    var tmp;
    // Inline function 'androidx.compose.ui.unit.dp' call
    var tmp$ret$1 = _Dp___init__impl__ms3zkb(600);
    if (Dp__compareTo_impl_tlg3dl(smallestWidth, tmp$ret$1) >= 0) {
      // Inline function 'androidx.compose.ui.unit.dp' call
      tmp = _Dp___init__impl__ms3zkb(580);
    } else {
      // Inline function 'androidx.compose.ui.unit.dp' call
      var tmp$ret$3 = _Dp___init__impl__ms3zkb(480);
      if (Dp__compareTo_impl_tlg3dl(smallestWidth, tmp$ret$3) >= 0) {
        // Inline function 'androidx.compose.ui.unit.dp' call
        tmp = _Dp___init__impl__ms3zkb(440);
      } else {
        // Inline function 'androidx.compose.ui.unit.dp' call
        tmp = _Dp___init__impl__ms3zkb(320);
      }
    }
    return _this__u8e3s4.w5e(tmp);
  }
  function sam$androidx_compose_ui_layout_MeasurePolicy$0_1(function_0) {
    this.mdb_1 = function_0;
  }
  protoOf(sam$androidx_compose_ui_layout_MeasurePolicy$0_1).mak = function (_this__u8e3s4, measurables, constraints) {
    return this.mdb_1(_this__u8e3s4, measurables, new Constraints_0(constraints));
  };
  protoOf(sam$androidx_compose_ui_layout_MeasurePolicy$0_1).q3 = function () {
    return this.mdb_1;
  };
  protoOf(sam$androidx_compose_ui_layout_MeasurePolicy$0_1).equals = function (other) {
    var tmp;
    if (!(other == null) ? isInterface(other, MeasurePolicy) : false) {
      var tmp_0;
      if (!(other == null) ? isInterface(other, FunctionAdapter) : false) {
        tmp_0 = equals(this.q3(), other.q3());
      } else {
        tmp_0 = false;
      }
      tmp = tmp_0;
    } else {
      tmp = false;
    }
    return tmp;
  };
  protoOf(sam$androidx_compose_ui_layout_MeasurePolicy$0_1).hashCode = function () {
    return hashCode(this.q3());
  };
  function RootMeasurePolicy$lambda$lambda($placeables, $constraints, $calculatePosition, $this_MeasurePolicy) {
    return function ($this$layout) {
      var tmp0 = $placeables;
      var tmp$ret$0;
      $l$block: {
        // Inline function 'androidx.compose.ui.util.fastMaxBy' call
        if (tmp0.r()) {
          tmp$ret$0 = null;
          break $l$block;
        }
        var maxElem = tmp0.l1(0);
        var maxValue = maxElem.i8y_1;
        var inductionVariable = 1;
        var last = get_lastIndex(tmp0);
        if (inductionVariable <= last)
          do {
            var i = inductionVariable;
            inductionVariable = inductionVariable + 1 | 0;
            var e = tmp0.l1(i);
            var v = e.i8y_1;
            if (compareTo(maxValue, v) < 0) {
              maxElem = e;
              maxValue = v;
            }
          }
           while (!(i === last));
        tmp$ret$0 = maxElem;
      }
      var tmp0_safe_receiver = tmp$ret$0;
      var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.i8y_1;
      var tmp0_0 = tmp1_elvis_lhs == null ? _Constraints___get_minWidth__impl__hi9lfi($constraints) : tmp1_elvis_lhs;
      var tmp0_1 = $placeables;
      var tmp$ret$3;
      $l$block_0: {
        // Inline function 'androidx.compose.ui.util.fastMaxBy' call
        if (tmp0_1.r()) {
          tmp$ret$3 = null;
          break $l$block_0;
        }
        var maxElem_0 = tmp0_1.l1(0);
        var maxValue_0 = maxElem_0.j8y_1;
        var inductionVariable_0 = 1;
        var last_0 = get_lastIndex(tmp0_1);
        if (inductionVariable_0 <= last_0)
          do {
            var i_0 = inductionVariable_0;
            inductionVariable_0 = inductionVariable_0 + 1 | 0;
            var e_0 = tmp0_1.l1(i_0);
            var v_0 = e_0.j8y_1;
            if (compareTo(maxValue_0, v_0) < 0) {
              maxElem_0 = e_0;
              maxValue_0 = v_0;
            }
          }
           while (!(i_0 === last_0));
        tmp$ret$3 = maxElem_0;
      }
      var tmp2_safe_receiver = tmp$ret$3;
      var tmp3_elvis_lhs = tmp2_safe_receiver == null ? null : tmp2_safe_receiver.j8y_1;
      // Inline function 'androidx.compose.ui.unit.IntSize' call
      // Inline function 'androidx.compose.ui.util.packInts' call
      var val2 = tmp3_elvis_lhs == null ? _Constraints___get_minHeight__impl__ev4bgx($constraints) : tmp3_elvis_lhs;
      var tmp$ret$7 = bitwiseOr(shiftLeft(fromInt(tmp0_0), 32), bitwiseAnd(fromInt(val2), new Long(-1, 0)));
      var contentSize = _IntSize___init__impl__emcjft(tmp$ret$7);
      var position = $calculatePosition($this_MeasurePolicy, new IntSize(contentSize)).a5g_1;
      // Inline function 'androidx.compose.ui.util.fastForEach' call
      var this_0 = $placeables;
      var inductionVariable_1 = 0;
      var last_1 = this_0.n1() - 1 | 0;
      if (inductionVariable_1 <= last_1)
        do {
          var index = inductionVariable_1;
          inductionVariable_1 = inductionVariable_1 + 1 | 0;
          var item = this_0.l1(index);
          $this$layout.jal(item, _IntOffset___get_x__impl__qiqr5o(position), _IntOffset___get_y__impl__2avpwj(position));
        }
         while (inductionVariable_1 <= last_1);
      return Unit_instance;
    };
  }
  function RootMeasurePolicy$lambda($platformInsets, $usePlatformDefaultWidth, $calculatePosition) {
    return function ($this$MeasurePolicy, measurables, constraints) {
      var platformConstraints = applyPlatformConstrains($this$MeasurePolicy, constraints.m5e_1, $platformInsets, $usePlatformDefaultWidth);
      // Inline function 'androidx.compose.ui.util.fastMap' call
      var target = ArrayList_init_$Create$_0(measurables.n1());
      // Inline function 'androidx.compose.ui.util.fastForEach' call
      var inductionVariable = 0;
      var last = measurables.n1() - 1 | 0;
      if (inductionVariable <= last)
        do {
          var index = inductionVariable;
          inductionVariable = inductionVariable + 1 | 0;
          var item = measurables.l1(index);
          // Inline function 'kotlin.collections.plusAssign' call
          var element = item.h8y(platformConstraints);
          target.j1(element);
        }
         while (inductionVariable <= last);
      var placeables = target;
      var tmp = _Constraints___get_maxWidth__impl__uuyqc(constraints.m5e_1);
      var tmp_0 = _Constraints___get_maxHeight__impl__dt3e8z(constraints.m5e_1);
      return $this$MeasurePolicy.n8y(tmp, tmp_0, VOID, RootMeasurePolicy$lambda$lambda(placeables, constraints.m5e_1, $calculatePosition, $this$MeasurePolicy));
    };
  }
  function get_domEventOrNull(_this__u8e3s4) {
    var tmp = get_internal(_this__u8e3s4).pc4_1;
    return (tmp == null ? true : tmp instanceof KeyboardEvent) ? tmp : null;
  }
  var androidx_compose_ui_draganddrop_DragAndDropEvent$stable;
  function DragAndDropEvent(offset, transferData) {
    this.ndb_1 = offset;
    this.odb_1 = transferData;
  }
  function get_positionInRoot(_this__u8e3s4) {
    return _this__u8e3s4.ndb_1;
  }
  var androidx_compose_ui_draganddrop_DragAndDropTransferData$stable;
  function DragAndDropTransferData(nativeTransferData) {
    nativeTransferData = nativeTransferData === VOID ? null : nativeTransferData;
    this.pdb_1 = nativeTransferData;
  }
  var androidx_compose_ui_draganddrop_WebDragAndDropManager$stable;
  function setAsDragImage($this, $receiver, ghostImage) {
    // Inline function 'kotlin.with' call
    var $this$with = ghostImage.style;
    $this$with.position = 'absolute';
    $this$with.top = '0';
    $this$with.left = '0';
    $this$with.setProperty('pointer-events', 'none');
    $this$with.setProperty('z-index', '-1');
    $this.qdb_1.appendChild(ghostImage);
    var tmp0_safe_receiver = $receiver.dataTransfer;
    if (tmp0_safe_receiver == null)
      null;
    else {
      tmp0_safe_receiver.setDragImage(ghostImage, 0, 0);
    }
    var tmp = window;
    tmp.requestAnimationFrame(WebDragAndDropManager$setAsDragImage$lambda(ghostImage));
  }
  function startTransfer($this, $receiver, dragEvent) {
    // Inline function 'kotlin.with' call
    var $this$with = $this.yd2();
    var tmp = _get_offset__c6qzmg($this, dragEvent);
    $this$with.nd5($receiver, tmp, WebDragAndDropManager$startTransfer$lambda($receiver));
    if ($receiver.wdb()) {
      return acceptTransfer($this, dragEvent);
    }
    dragEvent.preventDefault();
    return false;
  }
  function acceptTransfer($this, dragEvent) {
    var acceptedTransfer = false;
    // Inline function 'kotlin.with' call
    var $this$with = $this.yd2();
    var evt = new DragAndDropEvent(_get_offset__c6qzmg($this, dragEvent), new DragAndDropTransferData(dragEvent.dataTransfer));
    acceptedTransfer = $this$with.w91(evt);
    if (acceptedTransfer) {
      $this$with.w8y(evt);
      $this$with.x8y(evt);
    }
    return acceptedTransfer;
  }
  function initEvents($this, eventListener, globalEventsListener) {
    var previousDragEventIsStart = {_v: false};
    eventListener.zdb('dragstart', WebDragAndDropManager$initEvents$lambda(previousDragEventIsStart, $this));
    eventListener.zdb('dragenter', WebDragAndDropManager$initEvents$lambda_0(previousDragEventIsStart, $this));
    eventListener.zdb('dragover', WebDragAndDropManager$initEvents$lambda_1($this));
    eventListener.zdb('drop', WebDragAndDropManager$initEvents$lambda_2($this));
    globalEventsListener.zdb('dragover', WebDragAndDropManager$initEvents$lambda_3);
  }
  function _get_offset__c6qzmg($this, $receiver) {
    var tmp0 = $receiver.offsetX;
    // Inline function 'androidx.compose.ui.geometry.Offset' call
    // Inline function 'androidx.compose.ui.util.packFloats' call
    var val2 = $receiver.offsetY;
    var v1 = fromInt(toRawBits(tmp0));
    var v2 = fromInt(toRawBits(val2));
    var tmp$ret$1 = bitwiseOr(shiftLeft(v1, 32), bitwiseAnd(v2, new Long(-1, 0)));
    var tmp$ret$0 = _Offset___init__impl__c168vi(tmp$ret$1);
    return Offset__times_impl_jz1mli(tmp$ret$0, $this.rdb_1.u5e());
  }
  function WebDragAndDropManager$setAsDragImage$lambda($ghostImage) {
    return function (it) {
      $ghostImage.remove();
      return Unit_instance;
    };
  }
  function WebDragAndDropManager$startTransfer$lambda($this_startTransfer) {
    return function () {
      return $this_startTransfer.wdb();
    };
  }
  function WebDragAndDropManager$initEvents$lambda($previousDragEventIsStart, this$0) {
    return function (event) {
      $previousDragEventIsStart._v = true;
      if (!(event instanceof DragEvent))
        THROW_CCE();
      var scope = new InternalStartTransferScope(this$0.rdb_1);
      var tmp;
      if (startTransfer(this$0, scope, event)) {
        var tmp0_safe_receiver = event.dataTransfer;
        if (tmp0_safe_receiver == null)
          null;
        else {
          tmp0_safe_receiver.setData('text/plain', '');
        }
        var tmp1_safe_receiver = scope.udb_1;
        if (tmp1_safe_receiver == null)
          null;
        else {
          // Inline function 'kotlin.let' call
          setAsDragImage(this$0, event, tmp1_safe_receiver);
        }
        this$0.sdb_1 = scope;
        tmp = Unit_instance;
      }
      return Unit_instance;
    };
  }
  function WebDragAndDropManager$initEvents$lambda_0($previousDragEventIsStart, this$0) {
    return function (event) {
      var tmp;
      if (!$previousDragEventIsStart._v) {
        if (!(event instanceof DragEvent))
          THROW_CCE();
        acceptTransfer(this$0, event);
        tmp = Unit_instance;
      }
      $previousDragEventIsStart._v = false;
      return Unit_instance;
    };
  }
  function WebDragAndDropManager$initEvents$lambda_1(this$0) {
    return function (event) {
      event.preventDefault();
      if (!(event instanceof DragEvent))
        THROW_CCE();
      this$0.yd2().y8y(new DragAndDropEvent(_get_offset__c6qzmg(this$0, event), null));
      return Unit_instance;
    };
  }
  function WebDragAndDropManager$initEvents$lambda_2(this$0) {
    return function (event) {
      event.preventDefault();
      if (!(event instanceof DragEvent))
        THROW_CCE();
      var tmp = _get_offset__c6qzmg(this$0, event);
      var tmp0_safe_receiver = this$0.sdb_1;
      var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.vdb_1;
      var dragAndDropEvent = new DragAndDropEvent(tmp, tmp1_elvis_lhs == null ? new DragAndDropTransferData(event.dataTransfer) : tmp1_elvis_lhs);
      this$0.yd2().v8y(dragAndDropEvent);
      this$0.yd2().a8z(dragAndDropEvent);
      this$0.sdb_1 = null;
      return Unit_instance;
    };
  }
  function WebDragAndDropManager$initEvents$lambda_3(event) {
    if (!(event instanceof DragEvent))
      THROW_CCE();
    event.preventDefault();
    var tmp0_safe_receiver = event.dataTransfer;
    if (tmp0_safe_receiver == null)
      null;
    else {
      tmp0_safe_receiver.dropEffect = 'move';
    }
    return Unit_instance;
  }
  function WebDragAndDropManager(rootNode, eventListener, globalEventsListener, density) {
    this.qdb_1 = rootNode;
    this.rdb_1 = density;
    this.sdb_1 = null;
    initEvents(this, eventListener, globalEventsListener);
  }
  function InternalStartTransferScope(density) {
    this.tdb_1 = density;
    this.udb_1 = null;
    this.vdb_1 = null;
  }
  protoOf(InternalStartTransferScope).wdb = function () {
    return !(this.vdb_1 == null);
  };
  var androidx_compose_ui_events_EventTargetListener$stable;
  function EventTargetListener(eventTarget) {
    this.xdb_1 = eventTarget;
    this.ydb_1 = new AbortController();
  }
  protoOf(EventTargetListener).zdb = function (eventName, handler) {
    this.xdb_1.addEventListener(eventName, handler, withSignal(this.ydb_1.signal));
  };
  protoOf(EventTargetListener).adc = function (eventName, passive, handler) {
    this.xdb_1.addEventListener(eventName, handler, withSignalAndPassive(this.ydb_1.signal, passive));
  };
  function withSignal(signal) {
    return {signal: signal};
  }
  function withSignalAndPassive(signal, passive) {
    return {signal: signal, passive: passive};
  }
  function systemDefinedCanFocus(node) {
    return true;
  }
  function _Key___init__impl__p6mluu(keyCode) {
    return keyCode;
  }
  function _Key___get_keyCode__impl__ymzu5v($this) {
    return $this;
  }
  function Companion_49() {
    Companion_instance_54 = this;
    this.zc8_1 = _Key___init__impl__p6mluu(new Long(-1, -1));
    this.ac9_1 = _Key___init__impl__p6mluu(new Long(36, 0));
    this.bc9_1 = _Key___init__impl__p6mluu(new Long(-1000000207, -1));
    this.cc9_1 = _Key___init__impl__p6mluu(new Long(38, 0));
    this.dc9_1 = _Key___init__impl__p6mluu(new Long(40, 0));
    this.ec9_1 = _Key___init__impl__p6mluu(new Long(37, 0));
    this.fc9_1 = _Key___init__impl__p6mluu(new Long(39, 0));
    this.gc9_1 = _Key___init__impl__p6mluu(new Long(48, 0));
    this.hc9_1 = _Key___init__impl__p6mluu(new Long(49, 0));
    this.ic9_1 = _Key___init__impl__p6mluu(new Long(50, 0));
    this.jc9_1 = _Key___init__impl__p6mluu(new Long(51, 0));
    this.kc9_1 = _Key___init__impl__p6mluu(new Long(52, 0));
    this.lc9_1 = _Key___init__impl__p6mluu(new Long(53, 0));
    this.mc9_1 = _Key___init__impl__p6mluu(new Long(54, 0));
    this.nc9_1 = _Key___init__impl__p6mluu(new Long(55, 0));
    this.oc9_1 = _Key___init__impl__p6mluu(new Long(56, 0));
    this.pc9_1 = _Key___init__impl__p6mluu(new Long(57, 0));
    this.qc9_1 = _Key___init__impl__p6mluu(new Long(173, 0));
    this.rc9_1 = _Key___init__impl__p6mluu(new Long(61, 0));
    this.sc9_1 = _Key___init__impl__p6mluu(new Long(65, 0));
    this.tc9_1 = _Key___init__impl__p6mluu(new Long(66, 0));
    this.uc9_1 = _Key___init__impl__p6mluu(new Long(67, 0));
    this.vc9_1 = _Key___init__impl__p6mluu(new Long(68, 0));
    this.wc9_1 = _Key___init__impl__p6mluu(new Long(69, 0));
    this.xc9_1 = _Key___init__impl__p6mluu(new Long(70, 0));
    this.yc9_1 = _Key___init__impl__p6mluu(new Long(71, 0));
    this.zc9_1 = _Key___init__impl__p6mluu(new Long(72, 0));
    this.aca_1 = _Key___init__impl__p6mluu(new Long(73, 0));
    this.bca_1 = _Key___init__impl__p6mluu(new Long(74, 0));
    this.cca_1 = _Key___init__impl__p6mluu(new Long(75, 0));
    this.dca_1 = _Key___init__impl__p6mluu(new Long(76, 0));
    this.eca_1 = _Key___init__impl__p6mluu(new Long(77, 0));
    this.fca_1 = _Key___init__impl__p6mluu(new Long(78, 0));
    this.gca_1 = _Key___init__impl__p6mluu(new Long(79, 0));
    this.hca_1 = _Key___init__impl__p6mluu(new Long(80, 0));
    this.ica_1 = _Key___init__impl__p6mluu(new Long(81, 0));
    this.jca_1 = _Key___init__impl__p6mluu(new Long(82, 0));
    this.kca_1 = _Key___init__impl__p6mluu(new Long(83, 0));
    this.lca_1 = _Key___init__impl__p6mluu(new Long(84, 0));
    this.mca_1 = _Key___init__impl__p6mluu(new Long(85, 0));
    this.nca_1 = _Key___init__impl__p6mluu(new Long(86, 0));
    this.oca_1 = _Key___init__impl__p6mluu(new Long(87, 0));
    this.pca_1 = _Key___init__impl__p6mluu(new Long(88, 0));
    this.qca_1 = _Key___init__impl__p6mluu(new Long(89, 0));
    this.rca_1 = _Key___init__impl__p6mluu(new Long(90, 0));
    this.sca_1 = _Key___init__impl__p6mluu(new Long(188, 0));
    this.tca_1 = _Key___init__impl__p6mluu(new Long(190, 0));
    this.uca_1 = _Key___init__impl__p6mluu(new Long(18, 0));
    this.vca_1 = _Key___init__impl__p6mluu(new Long(225, 0));
    this.wca_1 = _Key___init__impl__p6mluu(new Long(16, 0));
    this.xca_1 = _Key___init__impl__p6mluu(new Long(-2147483632, -1));
    this.yca_1 = _Key___init__impl__p6mluu(new Long(9, 0));
    this.zca_1 = _Key___init__impl__p6mluu(new Long(32, 0));
    this.acb_1 = _Key___init__impl__p6mluu(new Long(13, 0));
    this.bcb_1 = _Key___init__impl__p6mluu(new Long(8, 0));
    this.ccb_1 = _Key___init__impl__p6mluu(new Long(46, 0));
    this.dcb_1 = _Key___init__impl__p6mluu(new Long(27, 0));
    this.ecb_1 = _Key___init__impl__p6mluu(new Long(17, 0));
    this.fcb_1 = _Key___init__impl__p6mluu(new Long(-2147483631, -1));
    this.gcb_1 = _Key___init__impl__p6mluu(new Long(20, 0));
    this.hcb_1 = _Key___init__impl__p6mluu(new Long(145, 0));
    this.icb_1 = _Key___init__impl__p6mluu(new Long(224, 0));
    this.jcb_1 = _Key___init__impl__p6mluu(new Long(-2147483424, -1));
    this.kcb_1 = _Key___init__impl__p6mluu(new Long(44, 0));
    this.lcb_1 = _Key___init__impl__p6mluu(new Long(45, 0));
    this.mcb_1 = _Key___init__impl__p6mluu(new Long(192, 0));
    this.ncb_1 = _Key___init__impl__p6mluu(new Long(219, 0));
    this.ocb_1 = _Key___init__impl__p6mluu(new Long(221, 0));
    this.pcb_1 = _Key___init__impl__p6mluu(new Long(191, 0));
    this.qcb_1 = _Key___init__impl__p6mluu(new Long(220, 0));
    this.rcb_1 = _Key___init__impl__p6mluu(new Long(59, 0));
    this.scb_1 = _Key___init__impl__p6mluu(new Long(33, 0));
    this.tcb_1 = _Key___init__impl__p6mluu(new Long(34, 0));
    this.ucb_1 = _Key___init__impl__p6mluu(new Long(112, 0));
    this.vcb_1 = _Key___init__impl__p6mluu(new Long(113, 0));
    this.wcb_1 = _Key___init__impl__p6mluu(new Long(114, 0));
    this.xcb_1 = _Key___init__impl__p6mluu(new Long(115, 0));
    this.ycb_1 = _Key___init__impl__p6mluu(new Long(116, 0));
    this.zcb_1 = _Key___init__impl__p6mluu(new Long(117, 0));
    this.acc_1 = _Key___init__impl__p6mluu(new Long(118, 0));
    this.bcc_1 = _Key___init__impl__p6mluu(new Long(119, 0));
    this.ccc_1 = _Key___init__impl__p6mluu(new Long(120, 0));
    this.dcc_1 = _Key___init__impl__p6mluu(new Long(121, 0));
    this.ecc_1 = _Key___init__impl__p6mluu(new Long(122, 0));
    this.fcc_1 = _Key___init__impl__p6mluu(new Long(123, 0));
    this.gcc_1 = _Key___init__impl__p6mluu(new Long(144, 0));
    this.hcc_1 = _Key___init__impl__p6mluu(new Long(96, 0));
    this.icc_1 = _Key___init__impl__p6mluu(new Long(97, 0));
    this.jcc_1 = _Key___init__impl__p6mluu(new Long(98, 0));
    this.kcc_1 = _Key___init__impl__p6mluu(new Long(99, 0));
    this.lcc_1 = _Key___init__impl__p6mluu(new Long(100, 0));
    this.mcc_1 = _Key___init__impl__p6mluu(new Long(101, 0));
    this.ncc_1 = _Key___init__impl__p6mluu(new Long(102, 0));
    this.occ_1 = _Key___init__impl__p6mluu(new Long(103, 0));
    this.pcc_1 = _Key___init__impl__p6mluu(new Long(104, 0));
    this.qcc_1 = _Key___init__impl__p6mluu(new Long(105, 0));
    this.rcc_1 = _Key___init__impl__p6mluu(new Long(111, 0));
    this.scc_1 = _Key___init__impl__p6mluu(new Long(106, 0));
    this.tcc_1 = _Key___init__impl__p6mluu(new Long(109, 0));
    this.ucc_1 = _Key___init__impl__p6mluu(new Long(107, 0));
    this.vcc_1 = _Key___init__impl__p6mluu(new Long(14, 0));
    this.wcc_1 = _Key___init__impl__p6mluu(new Long(36, 0));
    this.xcc_1 = _Key___init__impl__p6mluu(new Long(35, 0));
    this.ycc_1 = _Key___init__impl__p6mluu(new Long(222, 0));
    this.zcc_1 = _Key___init__impl__p6mluu(new Long(-1000000001, -1));
    this.acd_1 = _Key___init__impl__p6mluu(new Long(-1000000002, -1));
    this.bcd_1 = _Key___init__impl__p6mluu(new Long(-1000000003, -1));
    this.ccd_1 = _Key___init__impl__p6mluu(new Long(-1000000004, -1));
    this.dcd_1 = _Key___init__impl__p6mluu(new Long(-1000000005, -1));
    this.ecd_1 = _Key___init__impl__p6mluu(new Long(-1000000006, -1));
    this.fcd_1 = _Key___init__impl__p6mluu(new Long(-1000000007, -1));
    this.gcd_1 = _Key___init__impl__p6mluu(new Long(-1000000008, -1));
    this.hcd_1 = _Key___init__impl__p6mluu(new Long(-1000000009, -1));
    this.icd_1 = _Key___init__impl__p6mluu(new Long(-1000000010, -1));
    this.jcd_1 = _Key___init__impl__p6mluu(new Long(-1000000011, -1));
    this.kcd_1 = _Key___init__impl__p6mluu(new Long(-1000000012, -1));
    this.lcd_1 = _Key___init__impl__p6mluu(new Long(-1000000013, -1));
    this.mcd_1 = _Key___init__impl__p6mluu(new Long(-1000000014, -1));
    this.ncd_1 = _Key___init__impl__p6mluu(new Long(-1000000015, -1));
    this.ocd_1 = _Key___init__impl__p6mluu(new Long(-1000000016, -1));
    this.pcd_1 = _Key___init__impl__p6mluu(new Long(-1000000017, -1));
    this.qcd_1 = _Key___init__impl__p6mluu(new Long(-1000000018, -1));
    this.rcd_1 = _Key___init__impl__p6mluu(new Long(-1000000019, -1));
    this.scd_1 = _Key___init__impl__p6mluu(new Long(-1000000020, -1));
    this.tcd_1 = _Key___init__impl__p6mluu(new Long(-1000000021, -1));
    this.ucd_1 = _Key___init__impl__p6mluu(new Long(-1000000022, -1));
    this.vcd_1 = _Key___init__impl__p6mluu(new Long(-1000000023, -1));
    this.wcd_1 = _Key___init__impl__p6mluu(new Long(-1000000024, -1));
    this.xcd_1 = _Key___init__impl__p6mluu(new Long(-1000000025, -1));
    this.ycd_1 = _Key___init__impl__p6mluu(new Long(-1000000026, -1));
    this.zcd_1 = _Key___init__impl__p6mluu(new Long(-1000000027, -1));
    this.ace_1 = _Key___init__impl__p6mluu(new Long(-1000000028, -1));
    this.bce_1 = _Key___init__impl__p6mluu(new Long(-1000000031, -1));
    this.cce_1 = _Key___init__impl__p6mluu(new Long(-1000000032, -1));
    this.dce_1 = _Key___init__impl__p6mluu(new Long(-1000000033, -1));
    this.ece_1 = _Key___init__impl__p6mluu(new Long(-1000000034, -1));
    this.fce_1 = _Key___init__impl__p6mluu(new Long(-1000000035, -1));
    this.gce_1 = _Key___init__impl__p6mluu(new Long(-1000000036, -1));
    this.hce_1 = _Key___init__impl__p6mluu(new Long(-1000000037, -1));
    this.ice_1 = _Key___init__impl__p6mluu(new Long(-1000000038, -1));
    this.jce_1 = _Key___init__impl__p6mluu(new Long(-1000000039, -1));
    this.kce_1 = _Key___init__impl__p6mluu(new Long(-1000000040, -1));
    this.lce_1 = _Key___init__impl__p6mluu(new Long(-1000000041, -1));
    this.mce_1 = _Key___init__impl__p6mluu(new Long(-1000000042, -1));
    this.nce_1 = _Key___init__impl__p6mluu(new Long(-1000000043, -1));
    this.oce_1 = _Key___init__impl__p6mluu(new Long(-1000000044, -1));
    this.pce_1 = _Key___init__impl__p6mluu(new Long(-1000000045, -1));
    this.qce_1 = _Key___init__impl__p6mluu(new Long(-1000000046, -1));
    this.rce_1 = _Key___init__impl__p6mluu(new Long(-1000000047, -1));
    this.sce_1 = _Key___init__impl__p6mluu(new Long(-1000000048, -1));
    this.tce_1 = _Key___init__impl__p6mluu(new Long(-1000000049, -1));
    this.uce_1 = _Key___init__impl__p6mluu(new Long(-1000000050, -1));
    this.vce_1 = _Key___init__impl__p6mluu(new Long(-1000000051, -1));
    this.wce_1 = _Key___init__impl__p6mluu(new Long(-1000000052, -1));
    this.xce_1 = _Key___init__impl__p6mluu(new Long(-1000000053, -1));
    this.yce_1 = _Key___init__impl__p6mluu(new Long(-1000000054, -1));
    this.zce_1 = _Key___init__impl__p6mluu(new Long(-1000000055, -1));
    this.acf_1 = _Key___init__impl__p6mluu(new Long(-1000000056, -1));
    this.bcf_1 = _Key___init__impl__p6mluu(new Long(-1000000057, -1));
    this.ccf_1 = _Key___init__impl__p6mluu(new Long(-1000000058, -1));
    this.dcf_1 = _Key___init__impl__p6mluu(new Long(-1000000059, -1));
    this.ecf_1 = _Key___init__impl__p6mluu(new Long(-1000000060, -1));
    this.fcf_1 = _Key___init__impl__p6mluu(new Long(-1000000061, -1));
    this.gcf_1 = _Key___init__impl__p6mluu(new Long(-1000000062, -1));
    this.hcf_1 = _Key___init__impl__p6mluu(new Long(-1000000063, -1));
    this.icf_1 = _Key___init__impl__p6mluu(new Long(-1000000064, -1));
    this.jcf_1 = _Key___init__impl__p6mluu(new Long(-1000000065, -1));
    this.kcf_1 = _Key___init__impl__p6mluu(new Long(-1000000066, -1));
    this.lcf_1 = _Key___init__impl__p6mluu(new Long(-1000000067, -1));
    this.mcf_1 = _Key___init__impl__p6mluu(new Long(-1000000068, -1));
    this.ncf_1 = _Key___init__impl__p6mluu(new Long(-1000000069, -1));
    this.ocf_1 = _Key___init__impl__p6mluu(new Long(-1000000070, -1));
    this.pcf_1 = _Key___init__impl__p6mluu(new Long(-1000000071, -1));
    this.qcf_1 = _Key___init__impl__p6mluu(new Long(-1000000072, -1));
    this.rcf_1 = _Key___init__impl__p6mluu(new Long(-1000000073, -1));
    this.scf_1 = _Key___init__impl__p6mluu(new Long(-1000000074, -1));
    this.tcf_1 = _Key___init__impl__p6mluu(new Long(-1000000075, -1));
    this.ucf_1 = _Key___init__impl__p6mluu(new Long(-1000000076, -1));
    this.vcf_1 = _Key___init__impl__p6mluu(new Long(-1000000077, -1));
    this.wcf_1 = _Key___init__impl__p6mluu(new Long(-1000000078, -1));
    this.xcf_1 = _Key___init__impl__p6mluu(new Long(-1000000079, -1));
    this.ycf_1 = _Key___init__impl__p6mluu(new Long(-1000000080, -1));
    this.zcf_1 = _Key___init__impl__p6mluu(new Long(-1000000081, -1));
    this.acg_1 = _Key___init__impl__p6mluu(new Long(-1000000082, -1));
    this.bcg_1 = _Key___init__impl__p6mluu(new Long(-1000000083, -1));
    this.ccg_1 = _Key___init__impl__p6mluu(new Long(-1000000084, -1));
    this.dcg_1 = _Key___init__impl__p6mluu(new Long(-1000000085, -1));
    this.ecg_1 = _Key___init__impl__p6mluu(new Long(-1000000086, -1));
    this.fcg_1 = _Key___init__impl__p6mluu(new Long(-1000000087, -1));
    this.gcg_1 = _Key___init__impl__p6mluu(new Long(-1000000088, -1));
    this.hcg_1 = _Key___init__impl__p6mluu(new Long(-1000000089, -1));
    this.icg_1 = _Key___init__impl__p6mluu(new Long(-1000000090, -1));
    this.jcg_1 = _Key___init__impl__p6mluu(new Long(-1000000091, -1));
    this.kcg_1 = _Key___init__impl__p6mluu(new Long(-1000000092, -1));
    this.lcg_1 = _Key___init__impl__p6mluu(new Long(-1000000093, -1));
    this.mcg_1 = _Key___init__impl__p6mluu(new Long(-1000000094, -1));
    this.ncg_1 = _Key___init__impl__p6mluu(new Long(-1000000095, -1));
    this.ocg_1 = _Key___init__impl__p6mluu(new Long(-1000000096, -1));
    this.pcg_1 = _Key___init__impl__p6mluu(new Long(-1000000097, -1));
    this.qcg_1 = _Key___init__impl__p6mluu(new Long(-1000000098, -1));
    this.rcg_1 = _Key___init__impl__p6mluu(new Long(-1000000099, -1));
    this.scg_1 = _Key___init__impl__p6mluu(new Long(-1000000100, -1));
    this.tcg_1 = _Key___init__impl__p6mluu(new Long(-1000000101, -1));
    this.ucg_1 = _Key___init__impl__p6mluu(new Long(-1000000102, -1));
    this.vcg_1 = _Key___init__impl__p6mluu(new Long(-1000000103, -1));
    this.wcg_1 = _Key___init__impl__p6mluu(new Long(-1000000104, -1));
    this.xcg_1 = _Key___init__impl__p6mluu(new Long(-1000000105, -1));
    this.ycg_1 = _Key___init__impl__p6mluu(new Long(-1000000106, -1));
    this.zcg_1 = _Key___init__impl__p6mluu(new Long(-1000000107, -1));
    this.ach_1 = _Key___init__impl__p6mluu(new Long(-1000000108, -1));
    this.bch_1 = _Key___init__impl__p6mluu(new Long(-1000000109, -1));
    this.cch_1 = _Key___init__impl__p6mluu(new Long(-1000000110, -1));
    this.dch_1 = _Key___init__impl__p6mluu(new Long(-1000000111, -1));
    this.ech_1 = _Key___init__impl__p6mluu(new Long(-1000000112, -1));
    this.fch_1 = _Key___init__impl__p6mluu(new Long(-1000000113, -1));
    this.gch_1 = _Key___init__impl__p6mluu(new Long(-1000000114, -1));
    this.hch_1 = _Key___init__impl__p6mluu(new Long(-1000000125, -1));
    this.ich_1 = _Key___init__impl__p6mluu(new Long(-1000000126, -1));
    this.jch_1 = _Key___init__impl__p6mluu(new Long(-1000000127, -1));
    this.kch_1 = _Key___init__impl__p6mluu(new Long(-1000000128, -1));
    this.lch_1 = _Key___init__impl__p6mluu(new Long(-1000000129, -1));
    this.mch_1 = _Key___init__impl__p6mluu(new Long(-1000000130, -1));
    this.nch_1 = _Key___init__impl__p6mluu(new Long(-1000000131, -1));
    this.och_1 = _Key___init__impl__p6mluu(new Long(-1000000132, -1));
    this.pch_1 = _Key___init__impl__p6mluu(new Long(-1000000133, -1));
    this.qch_1 = _Key___init__impl__p6mluu(new Long(-1000000134, -1));
    this.rch_1 = _Key___init__impl__p6mluu(new Long(-1000000135, -1));
    this.sch_1 = _Key___init__impl__p6mluu(new Long(-1000000136, -1));
    this.tch_1 = _Key___init__impl__p6mluu(new Long(-1000000137, -1));
    this.uch_1 = _Key___init__impl__p6mluu(new Long(-1000000138, -1));
    this.vch_1 = _Key___init__impl__p6mluu(new Long(-1000000139, -1));
    this.wch_1 = _Key___init__impl__p6mluu(new Long(-1000000140, -1));
    this.xch_1 = _Key___init__impl__p6mluu(new Long(-1000000141, -1));
    this.ych_1 = _Key___init__impl__p6mluu(new Long(-1000000142, -1));
    this.zch_1 = _Key___init__impl__p6mluu(new Long(-1000000143, -1));
    this.aci_1 = _Key___init__impl__p6mluu(new Long(-1000000144, -1));
    this.bci_1 = _Key___init__impl__p6mluu(new Long(-1000000145, -1));
    this.cci_1 = _Key___init__impl__p6mluu(new Long(-1000000146, -1));
    this.dci_1 = _Key___init__impl__p6mluu(new Long(-1000000147, -1));
    this.eci_1 = _Key___init__impl__p6mluu(new Long(-1000000148, -1));
    this.fci_1 = _Key___init__impl__p6mluu(new Long(-1000000149, -1));
    this.gci_1 = _Key___init__impl__p6mluu(new Long(-1000000150, -1));
    this.hci_1 = _Key___init__impl__p6mluu(new Long(-1000000151, -1));
    this.ici_1 = _Key___init__impl__p6mluu(new Long(-1000000152, -1));
    this.jci_1 = _Key___init__impl__p6mluu(new Long(-1000000153, -1));
    this.kci_1 = _Key___init__impl__p6mluu(new Long(-1000000154, -1));
    this.lci_1 = _Key___init__impl__p6mluu(new Long(-1000000155, -1));
    this.mci_1 = _Key___init__impl__p6mluu(new Long(-1000000156, -1));
    this.nci_1 = _Key___init__impl__p6mluu(new Long(-1000000157, -1));
    this.oci_1 = _Key___init__impl__p6mluu(new Long(-1000000158, -1));
    this.pci_1 = _Key___init__impl__p6mluu(new Long(-1000000159, -1));
    this.qci_1 = _Key___init__impl__p6mluu(new Long(-1000000160, -1));
    this.rci_1 = _Key___init__impl__p6mluu(new Long(-1000000161, -1));
    this.sci_1 = _Key___init__impl__p6mluu(new Long(-1000000162, -1));
    this.tci_1 = _Key___init__impl__p6mluu(new Long(-1000000163, -1));
    this.uci_1 = _Key___init__impl__p6mluu(new Long(-1000000164, -1));
    this.vci_1 = _Key___init__impl__p6mluu(new Long(-1000000165, -1));
    this.wci_1 = _Key___init__impl__p6mluu(new Long(-1000000166, -1));
    this.xci_1 = _Key___init__impl__p6mluu(new Long(-1000000167, -1));
    this.yci_1 = _Key___init__impl__p6mluu(new Long(-1000000168, -1));
    this.zci_1 = _Key___init__impl__p6mluu(new Long(-1000000169, -1));
    this.acj_1 = _Key___init__impl__p6mluu(new Long(-1000000170, -1));
    this.bcj_1 = _Key___init__impl__p6mluu(new Long(-1000000171, -1));
    this.ccj_1 = _Key___init__impl__p6mluu(new Long(-1000000172, -1));
    this.dcj_1 = _Key___init__impl__p6mluu(new Long(-1000000173, -1));
    this.ecj_1 = _Key___init__impl__p6mluu(new Long(-1000000174, -1));
    this.fcj_1 = _Key___init__impl__p6mluu(new Long(-1000000175, -1));
    this.gcj_1 = _Key___init__impl__p6mluu(new Long(-1000000176, -1));
    this.hcj_1 = _Key___init__impl__p6mluu(new Long(-1000000177, -1));
    this.icj_1 = _Key___init__impl__p6mluu(new Long(-1000000178, -1));
    this.jcj_1 = _Key___init__impl__p6mluu(new Long(-1000000179, -1));
    this.kcj_1 = _Key___init__impl__p6mluu(new Long(-1000000180, -1));
    this.lcj_1 = _Key___init__impl__p6mluu(new Long(-1000000181, -1));
    this.mcj_1 = _Key___init__impl__p6mluu(new Long(-1000000182, -1));
    this.ncj_1 = _Key___init__impl__p6mluu(new Long(-1000000183, -1));
    this.ocj_1 = _Key___init__impl__p6mluu(new Long(-1000000184, -1));
    this.pcj_1 = _Key___init__impl__p6mluu(new Long(-1000000185, -1));
    this.qcj_1 = _Key___init__impl__p6mluu(new Long(-1000000186, -1));
    this.rcj_1 = _Key___init__impl__p6mluu(new Long(-1000000187, -1));
    this.scj_1 = _Key___init__impl__p6mluu(new Long(-1000000188, -1));
    this.tcj_1 = _Key___init__impl__p6mluu(new Long(-1000000189, -1));
    this.ucj_1 = _Key___init__impl__p6mluu(new Long(-1000000190, -1));
    this.vcj_1 = _Key___init__impl__p6mluu(new Long(-1410067310, -3));
    this.wcj_1 = _Key___init__impl__p6mluu(new Long(-1000000193, -1));
    this.xcj_1 = _Key___init__impl__p6mluu(new Long(-1000000194, -1));
    this.ycj_1 = _Key___init__impl__p6mluu(new Long(-1000000195, -1));
    this.zcj_1 = _Key___init__impl__p6mluu(new Long(-1000000196, -1));
    this.ack_1 = _Key___init__impl__p6mluu(new Long(-1000000197, -1));
    this.bck_1 = _Key___init__impl__p6mluu(new Long(-1000000198, -1));
    this.cck_1 = _Key___init__impl__p6mluu(new Long(-1000000199, -1));
    this.dck_1 = _Key___init__impl__p6mluu(new Long(-1000000200, -1));
    this.eck_1 = _Key___init__impl__p6mluu(new Long(-1000000201, -1));
    this.fck_1 = _Key___init__impl__p6mluu(new Long(-1000000202, -1));
    this.gck_1 = _Key___init__impl__p6mluu(new Long(-1000000203, -1));
    this.hck_1 = _Key___init__impl__p6mluu(new Long(-1000000204, -1));
    this.ick_1 = _Key___init__impl__p6mluu(new Long(-1000000205, -1));
    this.jck_1 = _Key___init__impl__p6mluu(new Long(-1000000206, -1));
    this.kck_1 = _Key___init__impl__p6mluu(new Long(-1000000208, -1));
  }
  var Companion_instance_54;
  function Companion_getInstance_75() {
    if (Companion_instance_54 == null)
      new Companion_49();
    return Companion_instance_54;
  }
  function Key__toString_impl_q8hli6($this) {
    return 'Key keyCode: ' + _Key___get_keyCode__impl__ymzu5v($this).toString();
  }
  function Key__hashCode_impl_n1gjo3($this) {
    return $this.hashCode();
  }
  function Key__equals_impl_vw9vhr($this, other) {
    if (!(other instanceof Key_1))
      return false;
    var tmp0_other_with_cast = other.bdc_1;
    if (!equalsLong($this, tmp0_other_with_cast))
      return false;
    return true;
  }
  function Key_1(keyCode) {
    Companion_getInstance_75();
    this.bdc_1 = keyCode;
  }
  protoOf(Key_1).toString = function () {
    return Key__toString_impl_q8hli6(this.bdc_1);
  };
  protoOf(Key_1).hashCode = function () {
    return Key__hashCode_impl_n1gjo3(this.bdc_1);
  };
  protoOf(Key_1).equals = function (other) {
    return Key__equals_impl_vw9vhr(this.bdc_1, other);
  };
  function get_codeMap() {
    _init_properties_KeyEvent_web_kt__kpgh35();
    return codeMap;
  }
  var codeMap;
  function toComposeEvent(_this__u8e3s4) {
    _init_properties_KeyEvent_web_kt__kpgh35();
    var composeKey = toKey(_this__u8e3s4);
    var tmp;
    switch (_this__u8e3s4.type) {
      case 'keydown':
        tmp = Companion_getInstance_39().e9e_1;
        break;
      case 'keyup':
        tmp = Companion_getInstance_39().d9e_1;
        break;
      default:
        tmp = Companion_getInstance_39().c9e_1;
        break;
    }
    var tmp_0;
    var tmp1_safe_receiver = firstOrNull_1(_this__u8e3s4.key);
    var tmp_1;
    var tmp_2 = tmp1_safe_receiver;
    if ((tmp_2 == null ? null : new Char(tmp_2)) == null) {
      tmp_1 = null;
    } else {
      tmp_1 = toString_1(tmp1_safe_receiver);
    }
    if (tmp_1 === _this__u8e3s4.key) {
      tmp_0 = codePointAt(_this__u8e3s4.key, 0);
    } else {
      tmp_0 = convertToInt(_Key___get_keyCode__impl__ymzu5v(composeKey));
    }
    return _KeyEvent___init__impl__411tom(new InternalKeyEvent(composeKey, tmp, tmp_0, toInputModifiers(_this__u8e3s4), _this__u8e3s4));
  }
  function toKey(_this__u8e3s4) {
    _init_properties_KeyEvent_web_kt__kpgh35();
    var tmp;
    // Inline function 'kotlin.text.isEmpty' call
    var this_0 = _this__u8e3s4.code;
    if (charSequenceLength(this_0) === 0) {
      var tmp_0 = get_codeMap().w2(_this__u8e3s4.key);
      tmp = tmp_0 == null ? null : tmp_0.bdc_1;
    } else {
      var tmp_1 = get_codeMap().w2(_this__u8e3s4.code);
      tmp = tmp_1 == null ? null : tmp_1.bdc_1;
    }
    var keyResolved = tmp;
    var tmp_2;
    var tmp_3 = keyResolved;
    if ((tmp_3 == null ? null : new Key_1(tmp_3)) == null) {
      tmp_2 = Companion_getInstance_75().zc8_1;
    } else {
      tmp_2 = keyResolved;
    }
    return tmp_2;
  }
  function codePointAt(_this__u8e3s4, index) {
    _init_properties_KeyEvent_web_kt__kpgh35();
    var high = charCodeAt(_this__u8e3s4, index);
    if (isHighSurrogate(high) && (index + 1 | 0) < _this__u8e3s4.length) {
      var low = charCodeAt(_this__u8e3s4, index + 1 | 0);
      if (isLowSurrogate(low)) {
        return toCodePoint(Companion_getInstance_21(), high, low);
      }
    }
    // Inline function 'kotlin.code' call
    return Char__toInt_impl_vasixd(high);
  }
  function toInputModifiers(_this__u8e3s4) {
    _init_properties_KeyEvent_web_kt__kpgh35();
    var tmp0_isAltPressed = _this__u8e3s4.altKey;
    var tmp1_isShiftPressed = _this__u8e3s4.shiftKey;
    var tmp2_isCtrlPressed = _this__u8e3s4.ctrlKey;
    var tmp3_isMetaPressed = _this__u8e3s4.metaKey;
    return PointerKeyboardModifiers_0(tmp2_isCtrlPressed, tmp3_isMetaPressed, tmp0_isAltPressed, tmp1_isShiftPressed);
  }
  function toCodePoint(_this__u8e3s4, high, low) {
    _init_properties_KeyEvent_web_kt__kpgh35();
    return (Char__minus_impl_a2frrh(high, _Char___init__impl__6a9atx(55296)) << 10 | Char__minus_impl_a2frrh(low, _Char___init__impl__6a9atx(56320))) + 65536 | 0;
  }
  var properties_initialized_KeyEvent_web_kt_b5m6v1;
  function _init_properties_KeyEvent_web_kt__kpgh35() {
    if (!properties_initialized_KeyEvent_web_kt_b5m6v1) {
      properties_initialized_KeyEvent_web_kt_b5m6v1 = true;
      codeMap = mapOf([to('KeyA', new Key_1(Companion_getInstance_75().sc9_1)), to('KeyB', new Key_1(Companion_getInstance_75().tc9_1)), to('KeyC', new Key_1(Companion_getInstance_75().uc9_1)), to('KeyD', new Key_1(Companion_getInstance_75().vc9_1)), to('KeyE', new Key_1(Companion_getInstance_75().wc9_1)), to('KeyF', new Key_1(Companion_getInstance_75().xc9_1)), to('KeyG', new Key_1(Companion_getInstance_75().yc9_1)), to('KeyH', new Key_1(Companion_getInstance_75().zc9_1)), to('KeyI', new Key_1(Companion_getInstance_75().aca_1)), to('KeyJ', new Key_1(Companion_getInstance_75().bca_1)), to('KeyK', new Key_1(Companion_getInstance_75().cca_1)), to('KeyL', new Key_1(Companion_getInstance_75().dca_1)), to('KeyM', new Key_1(Companion_getInstance_75().eca_1)), to('KeyN', new Key_1(Companion_getInstance_75().fca_1)), to('KeyO', new Key_1(Companion_getInstance_75().gca_1)), to('KeyP', new Key_1(Companion_getInstance_75().hca_1)), to('KeyQ', new Key_1(Companion_getInstance_75().ica_1)), to('KeyR', new Key_1(Companion_getInstance_75().jca_1)), to('KeyS', new Key_1(Companion_getInstance_75().kca_1)), to('KeyT', new Key_1(Companion_getInstance_75().lca_1)), to('KeyU', new Key_1(Companion_getInstance_75().mca_1)), to('KeyV', new Key_1(Companion_getInstance_75().nca_1)), to('KeyW', new Key_1(Companion_getInstance_75().oca_1)), to('KeyX', new Key_1(Companion_getInstance_75().pca_1)), to('KeyY', new Key_1(Companion_getInstance_75().qca_1)), to('KeyZ', new Key_1(Companion_getInstance_75().rca_1)), to('Digit0', new Key_1(Companion_getInstance_75().gc9_1)), to('Digit1', new Key_1(Companion_getInstance_75().hc9_1)), to('Digit2', new Key_1(Companion_getInstance_75().ic9_1)), to('Digit3', new Key_1(Companion_getInstance_75().jc9_1)), to('Digit4', new Key_1(Companion_getInstance_75().kc9_1)), to('Digit5', new Key_1(Companion_getInstance_75().lc9_1)), to('Digit6', new Key_1(Companion_getInstance_75().mc9_1)), to('Digit7', new Key_1(Companion_getInstance_75().nc9_1)), to('Digit8', new Key_1(Companion_getInstance_75().oc9_1)), to('Digit9', new Key_1(Companion_getInstance_75().pc9_1)), to('Numpad0', new Key_1(Companion_getInstance_75().hcc_1)), to('Numpad1', new Key_1(Companion_getInstance_75().icc_1)), to('Numpad2', new Key_1(Companion_getInstance_75().jcc_1)), to('Numpad3', new Key_1(Companion_getInstance_75().kcc_1)), to('Numpad4', new Key_1(Companion_getInstance_75().lcc_1)), to('Numpad5', new Key_1(Companion_getInstance_75().mcc_1)), to('Numpad6', new Key_1(Companion_getInstance_75().ncc_1)), to('Numpad7', new Key_1(Companion_getInstance_75().occ_1)), to('Numpad8', new Key_1(Companion_getInstance_75().pcc_1)), to('Numpad9', new Key_1(Companion_getInstance_75().qcc_1)), to('NumpadDivide', new Key_1(Companion_getInstance_75().rcc_1)), to('NumpadMultiply', new Key_1(Companion_getInstance_75().scc_1)), to('NumpadSubtract', new Key_1(Companion_getInstance_75().tcc_1)), to('NumpadAdd', new Key_1(Companion_getInstance_75().ucc_1)), to('NumpadEnter', new Key_1(Companion_getInstance_75().vcc_1)), to('NumpadEqual', new Key_1(Companion_getInstance_75().ycj_1)), to('NumpadDecimal', new Key_1(Companion_getInstance_75().wcj_1)), to('NumLock', new Key_1(Companion_getInstance_75().gcc_1)), to('Minus', new Key_1(Companion_getInstance_75().qc9_1)), to('Equal', new Key_1(Companion_getInstance_75().rc9_1)), to('Backspace', new Key_1(Companion_getInstance_75().bcb_1)), to('BracketLeft', new Key_1(Companion_getInstance_75().ncb_1)), to('BracketRight', new Key_1(Companion_getInstance_75().ocb_1)), to('Backslash', new Key_1(Companion_getInstance_75().qcb_1)), to('Semicolon', new Key_1(Companion_getInstance_75().rcb_1)), to('Enter', new Key_1(Companion_getInstance_75().acb_1)), to('Comma', new Key_1(Companion_getInstance_75().sca_1)), to('Period', new Key_1(Companion_getInstance_75().tca_1)), to('Slash', new Key_1(Companion_getInstance_75().pcb_1)), to('ArrowLeft', new Key_1(Companion_getInstance_75().ec9_1)), to('ArrowUp', new Key_1(Companion_getInstance_75().cc9_1)), to('ArrowRight', new Key_1(Companion_getInstance_75().fc9_1)), to('ArrowDown', new Key_1(Companion_getInstance_75().dc9_1)), to('Home', new Key_1(Companion_getInstance_75().wcc_1)), to('PageUp', new Key_1(Companion_getInstance_75().scb_1)), to('PageDown', new Key_1(Companion_getInstance_75().tcb_1)), to('Delete', new Key_1(Companion_getInstance_75().ccb_1)), to('End', new Key_1(Companion_getInstance_75().xcc_1)), to('Backquote', new Key_1(Companion_getInstance_75().mcb_1)), to('Tab', new Key_1(Companion_getInstance_75().yca_1)), to('CapsLock', new Key_1(Companion_getInstance_75().gcb_1)), to('ShiftLeft', new Key_1(Companion_getInstance_75().wca_1)), to('ControlLeft', new Key_1(Companion_getInstance_75().ecb_1)), to('AltLeft', new Key_1(Companion_getInstance_75().uca_1)), to('MetaLeft', new Key_1(Companion_getInstance_75().icb_1)), to('ShiftRight', new Key_1(Companion_getInstance_75().xca_1)), to('ControlRight', new Key_1(Companion_getInstance_75().fcb_1)), to('AltRight', new Key_1(Companion_getInstance_75().vca_1)), to('MetaRight', new Key_1(Companion_getInstance_75().jcb_1)), to('Insert', new Key_1(Companion_getInstance_75().lcb_1)), to('Escape', new Key_1(Companion_getInstance_75().dcb_1)), to('F1', new Key_1(Companion_getInstance_75().ucb_1)), to('F2', new Key_1(Companion_getInstance_75().vcb_1)), to('F3', new Key_1(Companion_getInstance_75().wcb_1)), to('F4', new Key_1(Companion_getInstance_75().xcb_1)), to('F5', new Key_1(Companion_getInstance_75().ycb_1)), to('F6', new Key_1(Companion_getInstance_75().zcb_1)), to('F7', new Key_1(Companion_getInstance_75().acc_1)), to('F8', new Key_1(Companion_getInstance_75().bcc_1)), to('F9', new Key_1(Companion_getInstance_75().ccc_1)), to('F10', new Key_1(Companion_getInstance_75().dcc_1)), to('F11', new Key_1(Companion_getInstance_75().ecc_1)), to('F12', new Key_1(Companion_getInstance_75().fcc_1)), to('Space', new Key_1(Companion_getInstance_75().zca_1)), to('Quote', new Key_1(Companion_getInstance_75().ycc_1))]);
    }
  }
  function get_composeButtons(_this__u8e3s4) {
    return _PointerButtons___init__impl__wq04zh(_this__u8e3s4.buttons);
  }
  function get_composeButton(_this__u8e3s4) {
    switch (_this__u8e3s4.type) {
      case 'pointerdown':
      case 'pointerup':
        break;
      default:
        return null;
    }
    var buttonIndex = _this__u8e3s4.button;
    switch (buttonIndex) {
      case 0:
        return Companion_getInstance_71().qc4_1;
      case 1:
        return Companion_getInstance_71().sc4_1;
      case 2:
        return Companion_getInstance_71().rc4_1;
      case 3:
        return Companion_getInstance_71().tc4_1;
      case 4:
        return Companion_getInstance_71().uc4_1;
      default:
        return _PointerButton___init__impl__7ge8a2(buttonIndex);
    }
  }
  function get_pointerIconDefault() {
    _init_properties_PointerIcon_web_kt__qoqsfq();
    return pointerIconDefault;
  }
  var pointerIconDefault;
  function get_pointerIconCrosshair() {
    _init_properties_PointerIcon_web_kt__qoqsfq();
    return pointerIconCrosshair;
  }
  var pointerIconCrosshair;
  function get_pointerIconText() {
    _init_properties_PointerIcon_web_kt__qoqsfq();
    return pointerIconText;
  }
  var pointerIconText;
  function get_pointerIconHand() {
    _init_properties_PointerIcon_web_kt__qoqsfq();
    return pointerIconHand;
  }
  var pointerIconHand;
  var androidx_compose_ui_input_pointer_DummyPointerIcon$stable;
  var androidx_compose_ui_input_pointer_BrowserCursor$stable;
  function BrowserCursor(id) {
    this.cdc_1 = id;
  }
  protoOf(BrowserCursor).toString = function () {
    return 'BrowserCursor(id=' + this.cdc_1 + ')';
  };
  protoOf(BrowserCursor).hashCode = function () {
    return getStringHashCode(this.cdc_1);
  };
  protoOf(BrowserCursor).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof BrowserCursor))
      return false;
    if (!(this.cdc_1 === other.cdc_1))
      return false;
    return true;
  };
  var properties_initialized_PointerIcon_web_kt_7hxbxo;
  function _init_properties_PointerIcon_web_kt__qoqsfq() {
    if (!properties_initialized_PointerIcon_web_kt_7hxbxo) {
      properties_initialized_PointerIcon_web_kt_7hxbxo = true;
      pointerIconDefault = new BrowserCursor('default');
      pointerIconCrosshair = new BrowserCursor('crosshair');
      pointerIconText = new BrowserCursor('text');
      pointerIconHand = new BrowserCursor('pointer');
      androidx_compose_ui_input_pointer_DummyPointerIcon$stable = 0;
      androidx_compose_ui_input_pointer_BrowserCursor$stable = 0;
    }
  }
  function PlatformVelocityTracker() {
    return new WebVelocityTracker();
  }
  var androidx_compose_ui_input_pointer_util_WebVelocityTracker$stable;
  function addPointerInputChangeLegacy($this, event, offset) {
    if (changedToDownIgnoreConsumed(event)) {
      $this.fdc_1 = event.ka0_1;
      $this.jab();
    }
    var previousPointerPosition = event.oa0_1;
    // Inline function 'androidx.compose.ui.util.fastForEach' call
    var this_0 = event.ba1();
    var inductionVariable = 0;
    var last = this_0.n1() - 1 | 0;
    if (inductionVariable <= last)
      do {
        var index = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var item = this_0.l1(index);
        var historicalDelta = Offset__minus_impl_hoj2c0(item.da1_1, previousPointerPosition);
        previousPointerPosition = item.da1_1;
        $this.fdc_1 = Offset__plus_impl_c78cg0($this.fdc_1, historicalDelta);
        $this.hdc(item.ca1_1, Offset__plus_impl_c78cg0($this.fdc_1, offset));
      }
       while (inductionVariable <= last);
    var delta = Offset__minus_impl_hoj2c0(event.ka0_1, previousPointerPosition);
    $this.fdc_1 = Offset__plus_impl_c78cg0($this.fdc_1, delta);
    $this.hdc(event.ja0_1, Offset__plus_impl_c78cg0($this.fdc_1, offset));
  }
  function addPointerInputChangeWithFix($this, event, offset) {
    if (changedToDownIgnoreConsumed(event)) {
      $this.jab();
    }
    if (!changedToUpIgnoreConsumed(event)) {
      // Inline function 'androidx.compose.ui.util.fastForEach' call
      var this_0 = event.ba1();
      var inductionVariable = 0;
      var last = this_0.n1() - 1 | 0;
      if (inductionVariable <= last)
        do {
          var index = inductionVariable;
          inductionVariable = inductionVariable + 1 | 0;
          var item = this_0.l1(index);
          $this.hdc(item.ca1_1, Offset__plus_impl_c78cg0(item.ga1_1, offset));
        }
         while (inductionVariable <= last);
      $this.hdc(event.ja0_1, Offset__plus_impl_c78cg0(event.va0_1, offset));
    }
    if (changedToUpIgnoreConsumed(event) && compare(subtract(event.ja0_1, $this.gdc_1), new Long(40, 0)) > 0) {
      $this.jab();
    }
    $this.gdc_1 = event.ja0_1;
  }
  function WebVelocityTracker() {
    this.ddc_1 = new PointerVelocityTracker1D();
    this.edc_1 = new PointerVelocityTracker1D();
    this.fdc_1 = Companion_getInstance().g5d_1;
    this.gdc_1 = new Long(0, 0);
  }
  protoOf(WebVelocityTracker).hdc = function (timeMillis, position) {
    // Inline function 'androidx.compose.ui.geometry.Offset.x' call
    // Inline function 'androidx.compose.ui.util.unpackFloat1' call
    var value = _Offset___get_packedValue__impl__xh2k8q(position);
    // Inline function 'androidx.compose.ui.util.floatFromBits' call
    // Inline function 'kotlin.fromBits' call
    var bits = convertToInt(shiftRight(value, 32));
    var tmp$ret$0 = floatFromBits(bits);
    this.ddc_1.tab(timeMillis, tmp$ret$0);
    // Inline function 'androidx.compose.ui.geometry.Offset.y' call
    // Inline function 'androidx.compose.ui.util.unpackFloat2' call
    var value_0 = _Offset___get_packedValue__impl__xh2k8q(position);
    // Inline function 'androidx.compose.ui.util.floatFromBits' call
    // Inline function 'kotlin.fromBits' call
    var bits_0 = convertToInt(bitwiseAnd(value_0, new Long(-1, 0)));
    var tmp$ret$4 = floatFromBits(bits_0);
    this.edc_1.tab(timeMillis, tmp$ret$4);
  };
  protoOf(WebVelocityTracker).iab = function (maximumVelocity) {
    // Inline function 'androidx.compose.ui.internal.checkPrecondition' call
    if (!(_Velocity___get_x__impl__qqcikv(maximumVelocity) > 0.0 && _Velocity___get_y__impl__239yhc(maximumVelocity) > 0)) {
      var tmp$ret$1 = 'maximumVelocity should be a positive value. You specified=' + Velocity__toString_impl_n5zo2k(maximumVelocity);
      throwIllegalStateException(tmp$ret$1);
    }
    var velocityX = this.ddc_1.xab(_Velocity___get_x__impl__qqcikv(maximumVelocity));
    var velocityY = this.edc_1.xab(_Velocity___get_y__impl__239yhc(maximumVelocity));
    return Velocity_0(velocityX, velocityY);
  };
  protoOf(WebVelocityTracker).kab = function (event, offset) {
    if (get_VelocityTrackerAddPointsFix()) {
      addPointerInputChangeWithFix(this, event, offset);
    } else {
      addPointerInputChangeLegacy(this, event, offset);
    }
  };
  protoOf(WebVelocityTracker).jab = function () {
    this.ddc_1.jab();
    this.edc_1.jab();
    this.gdc_1 = new Long(0, 0);
  };
  function getCurrentThreadId() {
    return new Long(0, 0);
  }
  function focusExt(element, _preventScroll) {
    element.focus({preventScroll: _preventScroll});
    return Unit_instance;
  }
  var androidx_compose_ui_node_WeakReference$stable;
  function WeakReference(referent) {
    var tmp = this;
    // Inline function 'kotlin.js.toJsReference' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    tmp.ibh_1 = new WeakRef(referent);
  }
  protoOf(WeakReference).f1i = function () {
    var tmp0_safe_receiver = this.ibh_1;
    var tmp1_safe_receiver = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.deref();
    var tmp;
    if (tmp1_safe_receiver == null) {
      tmp = null;
    } else {
      // Inline function 'kotlin.js.unsafeCast' call
      // Inline function 'kotlin.js.asDynamic' call
      tmp = tmp1_safe_receiver;
    }
    var tmp2_safe_receiver = tmp;
    var tmp_0;
    if (tmp2_safe_receiver == null) {
      tmp_0 = null;
    } else {
      // Inline function 'kotlin.js.get' call
      // Inline function 'kotlin.js.unsafeCast' call
      // Inline function 'kotlin.js.asDynamic' call
      tmp_0 = tmp2_safe_receiver;
    }
    return tmp_0;
  };
  var androidx_compose_ui_platform_BackingDomInput$stable;
  function BackingDomInput$focus$lambda(this$0) {
    return function (it) {
      this$0.kdc_1.focus();
      return Unit_instance;
    };
  }
  function BackingDomInput(inputContainer, imeOptions, composeCommunicator) {
    this.idc_1 = inputContainer;
    this.jdc_1 = new DomInputStrategy(imeOptions, composeCommunicator);
    this.kdc_1 = this.jdc_1.mdc_1;
  }
  protoOf(BackingDomInput).sdc = function () {
    setBackingInputBox(this.idc_1, 0.0, 0.0, 0.0, 0.0);
    this.idc_1.appendChild(this.kdc_1);
  };
  protoOf(BackingDomInput).tdc = function () {
    this.kdc_1.focus();
    var tmp = window;
    tmp.requestAnimationFrame(BackingDomInput$focus$lambda(this));
  };
  protoOf(BackingDomInput).udc = function () {
    this.kdc_1.blur();
  };
  protoOf(BackingDomInput).vdc = function (left, top, width, height) {
    setBackingInputBox(this.idc_1, left, top, coerceAtLeast(width, 1.0), height);
  };
  protoOf(BackingDomInput).wdc = function (textFieldValue) {
    this.jdc_1.wdc(textFieldValue);
    this.tdc();
  };
  protoOf(BackingDomInput).s1d = function () {
    this.jdc_1.s1d();
    this.kdc_1.remove();
  };
  function ComposeCommandCommunicator() {
  }
  function setBackingInputBox(container, left, top, width, height) {
    container.style.setProperty('--compose-internal-web-backing-input-left', left);
    container.style.setProperty('--compose-internal-web-backing-input-top', top);
    container.style.setProperty('--compose-internal-web-backing-input-width', width);
    container.style.setProperty('--compose-internal-web-backing-input-height', height);
  }
  function simpleIdentityToString(obj, name) {
    var className = name == null ? '<object>' : name;
    return className + '@' + hashCode(obj);
  }
  var androidx_compose_ui_platform_DomInputStrategy$stable;
  var androidx_compose_ui_platform_InputEventExt$stable;
  function DomInputStrategy$nativeInputEventsProcessor$o$scheduleCheckpoint$lambda(this$0, this$1) {
    return function (it) {
      this$0.gdd(this$1.ndc_1);
      return Unit_instance;
    };
  }
  function initEvents_0($this) {
    $this.mdc_1.addEventListener('keydown', DomInputStrategy$initEvents$lambda($this));
    $this.mdc_1.addEventListener('keyup', DomInputStrategy$initEvents$lambda_0($this));
    $this.mdc_1.addEventListener('beforeinput', DomInputStrategy$initEvents$lambda_1($this));
    $this.mdc_1.addEventListener('compositionstart', DomInputStrategy$initEvents$lambda_2($this));
    $this.mdc_1.addEventListener('compositionend', DomInputStrategy$initEvents$lambda_3($this));
    var tmp = $this;
    tmp.pdc_1 = DomInputStrategy$initEvents$lambda_4($this);
    document.addEventListener('selectionchange', $this.pdc_1);
  }
  function isInputActive($this) {
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var root = $this.mdc_1.getRootNode();
    var rootActive = root == null ? null : root.activeElement;
    return equals(rootActive, $this.mdc_1);
  }
  function DomInputStrategy$nativeInputEventsProcessor$1(this$0) {
    this.mdd_1 = this$0;
    NativeInputEventsProcessor.call(this, this$0.ldc_1);
  }
  protoOf(DomInputStrategy$nativeInputEventsProcessor$1).ndd = function () {
    var tmp = window;
    tmp.requestAnimationFrame(DomInputStrategy$nativeInputEventsProcessor$o$scheduleCheckpoint$lambda(this, this.mdd_1));
  };
  function DomInputStrategy$initEvents$lambda(this$0) {
    return function (evt) {
      this$0.qdc_1.odd(evt instanceof KeyboardEvent ? evt : THROW_CCE());
      var tmp;
      if (evt.keyCode === this$0.rdc_1) {
        evt.preventDefault();
        tmp = Unit_instance;
      }
      this$0.odc_1 = true;
      return Unit_instance;
    };
  }
  function DomInputStrategy$initEvents$lambda_0(this$0) {
    return function (evt) {
      this$0.qdc_1.odd(evt instanceof KeyboardEvent ? evt : THROW_CCE());
      return Unit_instance;
    };
  }
  function DomInputStrategy$initEvents$lambda_1(this$0) {
    return function (evt) {
      var tmp;
      if (evt instanceof InputEvent) {
        var tmp_0 = this$0.mdc_1;
        if (tmp_0 == null)
          THROW_CCE();
        // Inline function 'androidx.compose.ui.platform.asInputEventExt' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        var inputExt = evt;
        inputExt.textRangeStart = this$0.mdc_1.selectionStart;
        inputExt.textRangeEnd = this$0.mdc_1.selectionEnd;
        this$0.qdc_1.odd(evt);
        tmp = Unit_instance;
      }
      return Unit_instance;
    };
  }
  function DomInputStrategy$initEvents$lambda_2(this$0) {
    return function (evt) {
      this$0.qdc_1.odd(evt instanceof CompositionEvent ? evt : THROW_CCE());
      return Unit_instance;
    };
  }
  function DomInputStrategy$initEvents$lambda_3(this$0) {
    return function (evt) {
      this$0.qdc_1.odd(evt instanceof CompositionEvent ? evt : THROW_CCE());
      return Unit_instance;
    };
  }
  function DomInputStrategy$initEvents$lambda_4(this$0) {
    return function (_unused_var__etf5q3) {
      var tmp;
      if (this$0.odc_1 || !isInputActive(this$0)) {
        return Unit_instance;
      }
      var tmp_0 = this$0.mdc_1;
      if (tmp_0 == null)
        THROW_CCE();
      var start = this$0.mdc_1.selectionStart;
      var end = this$0.mdc_1.selectionEnd;
      var selection = this$0.ndc_1.g8a_1;
      var tmp_1;
      if (!(start === _TextRange___get_min__impl__uu95c4(selection)) || !(end === _TextRange___get_max__impl__owm8m(selection))) {
        // Inline function 'kotlin.comparisons.minOf' call
        var normalizedStart = Math.min(start, end);
        // Inline function 'kotlin.comparisons.maxOf' call
        var normalizedEnd = Math.max(start, end);
        this$0.ldc_1.ydc(new SetSelectionCommand(normalizedStart, normalizedEnd));
        tmp_1 = Unit_instance;
      }
      return Unit_instance;
    };
  }
  function DomInputStrategy(imeOptions, composeSender) {
    this.ldc_1 = composeSender;
    this.mdc_1 = createDomElement(imeOptions);
    this.ndc_1 = TextFieldValue_init_$Create$('');
    this.odc_1 = false;
    this.pdc_1 = null;
    initEvents_0(this);
    var tmp = this;
    tmp.qdc_1 = new DomInputStrategy$nativeInputEventsProcessor$1(this);
    this.rdc_1 = convertToInt(_Key___get_keyCode__impl__ymzu5v(Companion_getInstance_75().yca_1));
  }
  protoOf(DomInputStrategy).wdc = function (textFieldValue) {
    var tmp = this.mdc_1;
    if (tmp == null)
      THROW_CCE();
    var needsTextUpdate = !(this.ndc_1.h89() === textFieldValue.h89());
    var needsSelectionUpdate = !equals(this.ndc_1.g8a_1, textFieldValue.g8a_1);
    this.ndc_1 = textFieldValue;
    if (needsTextUpdate) {
      this.mdc_1.value = textFieldValue.h89();
    }
    if (needsSelectionUpdate) {
      this.odc_1 = true;
      this.mdc_1.setSelectionRange(_TextRange___get_min__impl__uu95c4(textFieldValue.g8a_1), _TextRange___get_max__impl__owm8m(textFieldValue.g8a_1));
      this.odc_1 = false;
    }
  };
  protoOf(DomInputStrategy).s1d = function () {
    document.removeEventListener('selectionchange', this.pdc_1);
    this.pdc_1 = null;
  };
  function createDomElement(_this__u8e3s4) {
    var tmp = document.createElement(_this__u8e3s4.f8c_1 ? 'input' : 'textarea');
    var htmlElement = tmp instanceof HTMLElement ? tmp : THROW_CCE();
    htmlElement.setAttribute('autocorrect', 'on');
    htmlElement.setAttribute('autocomplete', 'off');
    htmlElement.setAttribute('autocapitalize', 'off');
    htmlElement.setAttribute('spellcheck', 'false');
    var tmp0_subject = _this__u8e3s4.i8c_1;
    var inputMode = tmp0_subject === Companion_getInstance_22().w8b_1 ? 'text' : tmp0_subject === Companion_getInstance_22().x8b_1 ? 'text' : tmp0_subject === Companion_getInstance_22().y8b_1 ? 'number' : tmp0_subject === Companion_getInstance_22().z8b_1 ? 'tel' : tmp0_subject === Companion_getInstance_22().a8c_1 ? 'url' : tmp0_subject === Companion_getInstance_22().b8c_1 ? 'email' : tmp0_subject === Companion_getInstance_22().c8c_1 ? 'password' : tmp0_subject === Companion_getInstance_22().d8c_1 ? 'number' : tmp0_subject === Companion_getInstance_22().e8c_1 ? 'decimal' : 'text';
    var tmp1_subject = _this__u8e3s4.j8c_1;
    var enterKeyHint = tmp1_subject === Companion_getInstance_23().g8b_1 ? 'enter' : tmp1_subject === Companion_getInstance_23().h8b_1 ? 'enter' : tmp1_subject === Companion_getInstance_23().n8b_1 ? 'done' : tmp1_subject === Companion_getInstance_23().i8b_1 ? 'go' : tmp1_subject === Companion_getInstance_23().m8b_1 ? 'next' : tmp1_subject === Companion_getInstance_23().l8b_1 ? 'previous' : tmp1_subject === Companion_getInstance_23().j8b_1 ? 'search' : tmp1_subject === Companion_getInstance_23().k8b_1 ? 'send' : 'enter';
    htmlElement.setAttribute('inputmode', inputMode);
    htmlElement.setAttribute('enterkeyhint', enterKeyHint);
    // Inline function 'kotlin.apply' call
    var this_0 = htmlElement.style;
    this_0.setProperty('position', 'absolute');
    this_0.setProperty('user-select', 'none');
    this_0.setProperty('forced-color-adjust', 'none');
    this_0.setProperty('white-space', 'pre');
    this_0.setProperty('align-content', 'center');
    this_0.setProperty('top', 'calc(min(var(--compose-internal-web-backing-input-top) * 1px, 100vh - var(--compose-internal-web-backing-input-height) * 1px))');
    this_0.setProperty('left', 'calc(min(var(--compose-internal-web-backing-input-left) * 1px, 100vw - var(--compose-internal-web-backing-input-width) * 1px))');
    this_0.setProperty('width', 'calc(var(--compose-internal-web-backing-input-width) * 1px');
    this_0.setProperty('height', 'calc(var(--compose-internal-web-backing-input-height) * 1px');
    this_0.setProperty('padding', '0');
    this_0.setProperty('color', 'transparent');
    this_0.setProperty('background', 'transparent');
    this_0.setProperty('caret-color', 'transparent');
    this_0.setProperty('outline', 'none');
    this_0.setProperty('border', 'none');
    this_0.setProperty('resize', 'none');
    this_0.setProperty('text-shadow', 'none');
    this_0.setProperty('z-index', '-1');
    this_0.setProperty('font-size', '20px');
    return htmlElement;
  }
  function isTypedEvent(evt) {
    return !evt.metaKey && !evt.ctrlKey && evt.key.charAt(0) === evt.key;
  }
  function get_textRangeSize(_this__u8e3s4) {
    // Inline function 'androidx.compose.ui.platform.asInputEventExt' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    // Inline function 'kotlin.let' call
    return _this__u8e3s4.textRangeEnd - _this__u8e3s4.textRangeStart | 0;
  }
  function get_GlobalSnapshotManagerDispatcher() {
    _init_properties_GlobalSnapshotManager_web_kt__7ctjl2();
    return GlobalSnapshotManagerDispatcher;
  }
  var GlobalSnapshotManagerDispatcher;
  var properties_initialized_GlobalSnapshotManager_web_kt_27yr0k;
  function _init_properties_GlobalSnapshotManager_web_kt__7ctjl2() {
    if (!properties_initialized_GlobalSnapshotManager_web_kt_27yr0k) {
      properties_initialized_GlobalSnapshotManager_web_kt_27yr0k = true;
      GlobalSnapshotManagerDispatcher = Dispatchers_getInstance().m1h();
    }
  }
  var androidx_compose_ui_platform_NativeInputEventsProcessor$stable;
  function getPrevWordOffset($this, $receiver, currentOffset, offsetMapping) {
    offsetMapping = offsetMapping === VOID ? Companion_getInstance_24().q8c_1 : offsetMapping;
    var $this_0 = $this;
    var $this_1 = $receiver;
    var currentOffset_0 = currentOffset;
    var offsetMapping_0 = offsetMapping;
    $l$1: do {
      $l$0: do {
        if (currentOffset_0 <= 0) {
          return 0;
        }
        var text = $this_1.e80_1.q80_1;
        var offset = coerceAtMost_0(currentOffset_0, text.a() - 1 | 0);
        if (offset <= 0) {
          return 0;
        }
        var currentWord = $this_1.z7t(offset);
        var tmp;
        if (_TextRange___get_start__impl__ww4t90(currentWord) >= currentOffset_0) {
          var tmp0 = $this_0;
          var tmp1 = $this_1;
          var tmp2 = currentOffset_0 - 1 | 0;
          var tmp4 = Companion_getInstance_24().q8c_1;
          $this_0 = tmp0;
          $this_1 = tmp1;
          currentOffset_0 = tmp2;
          offsetMapping_0 = tmp4;
          continue $l$0;
        } else {
          tmp = offsetMapping_0.p8c(_TextRange___get_start__impl__ww4t90(currentWord));
        }
        return tmp;
      }
       while (false);
    }
     while (true);
  }
  function internalScheduleCheckpoint($this) {
    if (!$this.ddd_1) {
      $this.ndd();
      $this.ddd_1 = true;
    }
  }
  function process($this, $receiver, currentTextFieldValue) {
    var tmp;
    switch ($receiver.inputType) {
      case 'deleteContentBackward':
        // Inline function 'kotlin.collections.buildList' call

        // Inline function 'kotlin.collections.buildListInternal' call

        // Inline function 'kotlin.apply' call

        var this_0 = ArrayList_init_$Create$();
        if (!_TextRange___get_collapsed__impl__cilesp(currentTextFieldValue.g8a_1)) {
          var tmp0_safe_receiver = $this.fdd_1;
          if (!((tmp0_safe_receiver == null ? null : isBackspace(tmp0_safe_receiver)) === true)) {
            this_0.j1(new BackspaceCommand());
          }
        } else {
          if (get_textRangeSize($receiver) > 0) {
            this_0.j1(new SetSelectionCommand($receiver.textRangeStart, $receiver.textRangeEnd));
            this_0.j1(new BackspaceCommand());
          } else {
            var tmp_0;
            if (get_textRangeSize($receiver) === 0) {
              var tmp1_safe_receiver = $this.fdd_1;
              tmp_0 = !((tmp1_safe_receiver == null ? null : isBackspace(tmp1_safe_receiver)) === true);
            } else {
              tmp_0 = false;
            }
            if (tmp_0) {
              this_0.j1(new BackspaceCommand());
            }
          }
        }

        tmp = this_0.t5();
        break;
      case 'deleteWordBackward':
        // Inline function 'kotlin.collections.buildList' call

        // Inline function 'kotlin.collections.buildListInternal' call

        // Inline function 'kotlin.apply' call

        var this_1 = ArrayList_init_$Create$();
        $l$block_0: {
          var tmp0_safe_receiver_0 = $this.fdd_1;
          if (!((tmp0_safe_receiver_0 == null ? null : isBackspace(tmp0_safe_receiver_0)) === true)) {
            break $l$block_0;
          }
          var tmp2_safe_receiver = $this.fdd_1;
          if ((tmp2_safe_receiver == null ? null : tmp2_safe_receiver.repeat) === true) {
            var tmp1_elvis_lhs = $this.bdd_1.add();
            var tmp_1;
            if (tmp1_elvis_lhs == null) {
              break $l$block_0;
            } else {
              tmp_1 = tmp1_elvis_lhs;
            }
            var layoutResult = tmp_1;
            var offset = getPrevWordOffset($this, layoutResult, $receiver.textRangeEnd);
            var deleteCommand = new DeleteSurroundingTextCommand(coerceAtLeast_0($receiver.textRangeEnd - offset | 0, 0), 0);
            this_1.j1(deleteCommand);
          }
        }

        tmp = this_1.t5();
        break;
      case 'insertReplacementText':
        // Inline function 'kotlin.collections.buildList' call

        // Inline function 'kotlin.collections.buildListInternal' call

        // Inline function 'kotlin.apply' call

        var this_2 = ArrayList_init_$Create$();
        $l$block_1: {
          if ($receiver.data == null) {
            break $l$block_1;
          }
          if (get_textRangeSize($receiver) > 0) {
            this_2.j1(new SetSelectionCommand($receiver.textRangeStart, $receiver.textRangeEnd));
          }
          this_2.j1(CommitTextCommand_init_$Create$($receiver.data, 1));
        }

        tmp = this_2.t5();
        break;
      case 'insertText':
        // Inline function 'kotlin.collections.buildList' call

        // Inline function 'kotlin.collections.buildListInternal' call

        // Inline function 'kotlin.apply' call

        var this_3 = ArrayList_init_$Create$();
        $l$block_2: {
          if ($receiver.data == null) {
            break $l$block_2;
          }
          if (get_textRangeSize($receiver) > 0 && _TextRange___get_collapsed__impl__cilesp(currentTextFieldValue.g8a_1)) {
            this_3.j1(new SetSelectionCommand($receiver.textRangeStart, $receiver.textRangeEnd));
          }
          this_3.j1(CommitTextCommand_init_$Create$($receiver.data, 1));
        }

        tmp = this_3.t5();
        break;
      case 'insertCompositionText':
        // Inline function 'kotlin.collections.buildList' call

        // Inline function 'kotlin.collections.buildListInternal' call

        // Inline function 'kotlin.apply' call

        var this_4 = ArrayList_init_$Create$();
        $l$block_3: {
          if ($receiver.data == null) {
            break $l$block_3;
          }
          if (get_textRangeSize($receiver) > 0) {
            this_4.j1(new SetSelectionCommand($receiver.textRangeStart, $receiver.textRangeEnd));
          }
          this_4.j1(SetComposingTextCommand_init_$Create$($receiver.data, 1));
        }

        tmp = this_4.t5();
        break;
      default:
        tmp = emptyList();
        break;
    }
    var editCommands = tmp;
    // Inline function 'kotlin.collections.isNotEmpty' call
    if (!editCommands.r()) {
      $this.bdd_1.xdc(editCommands);
    }
  }
  function sam$kotlin_Comparator$0_0(function_0) {
    this.pdd_1 = function_0;
  }
  protoOf(sam$kotlin_Comparator$0_0).ze = function (a, b) {
    return this.pdd_1(a, b);
  };
  protoOf(sam$kotlin_Comparator$0_0).compare = function (a, b) {
    return this.ze(a, b);
  };
  protoOf(sam$kotlin_Comparator$0_0).q3 = function () {
    return this.pdd_1;
  };
  protoOf(sam$kotlin_Comparator$0_0).equals = function (other) {
    var tmp;
    if (!(other == null) ? isInterface(other, Comparator) : false) {
      var tmp_0;
      if (!(other == null) ? isInterface(other, FunctionAdapter) : false) {
        tmp_0 = equals(this.q3(), other.q3());
      } else {
        tmp_0 = false;
      }
      tmp = tmp_0;
    } else {
      tmp = false;
    }
    return tmp;
  };
  protoOf(sam$kotlin_Comparator$0_0).hashCode = function () {
    return hashCode(this.q3());
  };
  function NativeInputEventsProcessor$runCheckpoint$lambda(a, b) {
    // Inline function 'kotlin.comparisons.compareValuesBy' call
    var tmp = numberToInt(a.timeStamp);
    var tmp$ret$2 = numberToInt(b.timeStamp);
    return compareValues(tmp, tmp$ret$2);
  }
  function NativeInputEventsProcessor(composeSender) {
    this.bdd_1 = composeSender;
    var tmp = this;
    // Inline function 'kotlin.collections.mutableListOf' call
    tmp.cdd_1 = ArrayList_init_$Create$();
    this.ddd_1 = false;
    this.edd_1 = 0.0;
    this.fdd_1 = null;
  }
  protoOf(NativeInputEventsProcessor).gdd = function (currentTextFieldValue) {
    this.ddd_1 = false;
    // Inline function 'kotlin.collections.sortBy' call
    var this_0 = this.cdd_1;
    if (this_0.n1() > 1) {
      // Inline function 'kotlin.comparisons.compareBy' call
      var tmp = NativeInputEventsProcessor$runCheckpoint$lambda;
      var tmp$ret$1 = new sam$kotlin_Comparator$0_0(tmp);
      sortWith(this_0, tmp$ret$1);
    }
    var tmp0 = this.cdd_1;
    var tmp$ret$2;
    $l$block: {
      // Inline function 'androidx.compose.ui.util.fastAny' call
      // Inline function 'androidx.compose.ui.util.fastForEach' call
      var inductionVariable = 0;
      var last = tmp0.n1() - 1 | 0;
      if (inductionVariable <= last)
        do {
          var index = inductionVariable;
          inductionVariable = inductionVariable + 1 | 0;
          var item = tmp0.l1(index);
          var tmp_0;
          var tmp_1;
          if (item.type === 'compositionstart' || item.type === 'compositionupdate' || item.type === 'compositionend') {
            tmp_1 = true;
          } else {
            var tmp_2;
            if (item.type === 'keydown') {
              tmp_2 = (item instanceof KeyboardEvent ? item : THROW_CCE()).isComposing;
            } else {
              tmp_2 = false;
            }
            tmp_1 = tmp_2;
          }
          if (tmp_1) {
            tmp_0 = true;
          } else {
            var tmp_3;
            if (item.type === 'beforeinput') {
              tmp_3 = (item instanceof InputEvent ? item : THROW_CCE()).isComposing;
            } else {
              tmp_3 = false;
            }
            tmp_0 = tmp_3;
          }
          if (tmp_0) {
            tmp$ret$2 = true;
            break $l$block;
          }
        }
         while (inductionVariable <= last);
      tmp$ret$2 = false;
    }
    var isInIMEComposition = tmp$ret$2;
    // Inline function 'androidx.compose.ui.util.fastForEach' call
    var this_1 = this.cdd_1;
    var inductionVariable_0 = 0;
    var last_0 = this_1.n1() - 1 | 0;
    if (inductionVariable_0 <= last_0)
      do {
        var index_0 = inductionVariable_0;
        inductionVariable_0 = inductionVariable_0 + 1 | 0;
        var item_0 = this_1.l1(index_0);
        $l$block_1: {
          var timestamp = numberToDouble(item_0.timeStamp);
          switch (item_0.type) {
            case 'keydown':
              if (isInIMEComposition) {
                break $l$block_1;
              }

              if (!(item_0 instanceof KeyboardEvent))
                THROW_CCE();
              if (isTypedEvent(item_0)) {
                this.fdd_1 = null;
                break $l$block_1;
              }

              var isFromLastComposition = timestamp < this.edd_1;
              var shouldBeProcessed = timestamp === 0.0 || !isFromLastComposition;
              if (shouldBeProcessed) {
                var isProcessed = this.bdd_1.zdc(toComposeEvent(item_0));
                if (isProcessed) {
                  this.fdd_1 = item_0;
                }
              }

              break;
            case 'compositionend':
              this.edd_1 = timestamp;
              this.bdd_1.ydc(CommitTextCommand_init_$Create$((item_0 instanceof CompositionEvent ? item_0 : THROW_CCE()).data, 1));
              break;
            case 'beforeinput':
              // Inline function 'androidx.compose.ui.platform.asInputEventExt' call

              // Inline function 'kotlin.js.unsafeCast' call

              // Inline function 'kotlin.js.asDynamic' call

              process(this, item_0, currentTextFieldValue);
              break;
          }
        }
      }
       while (inductionVariable_0 <= last_0);
    this.cdd_1.c3();
  };
  protoOf(NativeInputEventsProcessor).odd = function (event) {
    this.cdd_1.j1(event);
    internalScheduleCheckpoint(this);
  };
  function isBackspace(_this__u8e3s4) {
    return _this__u8e3s4.key === 'Backspace';
  }
  var androidx_compose_ui_platform_W3CTemporaryClipboard$stable;
  function getW3CClipboard() {
    return window.navigator.clipboard;
  }
  function isSecureContext() {
    return window.isSecureContext === true;
  }
  function isFullClipboardApiSupported() {
    return Boolean(window.navigator.clipboard && window.navigator.clipboard.write && window.navigator.clipboard.read && typeof ClipboardItem !== 'undefined');
  }
  function isFallbackWriteTextApiAvailable() {
    return Boolean(window.navigator.clipboard && window.navigator.clipboard.writeText);
  }
  function createPlatformUriHandler() {
    return new WebUriHandler();
  }
  function WebUriHandler() {
  }
  protoOf(WebUriHandler).qdd = function (uri) {
    window.open(uri, '_blank');
  };
  var androidx_compose_ui_platform_WebTextInputService$stable;
  function _set_backingDomInput__kd7j3y($this, value) {
    var tmp0_safe_receiver = $this.rdd_1;
    if (tmp0_safe_receiver == null)
      null;
    else {
      tmp0_safe_receiver.s1d();
    }
    $this.rdd_1 = value;
  }
  function WebTextInputService$startInput$1(this$0, $onEditCommand, $request) {
    this.tdd_1 = this$0;
    this.udd_1 = $onEditCommand;
    this.vdd_1 = $request;
  }
  protoOf(WebTextInputService$startInput$1).zdc = function (keyboardEvent) {
    return this.tdd_1.wdd(keyboardEvent);
  };
  protoOf(WebTextInputService$startInput$1).xdc = function (commands) {
    this.udd_1(commands);
  };
  protoOf(WebTextInputService$startInput$1).add = function () {
    return this.vdd_1.xdd()();
  };
  function WebTextInputService() {
    this.rdd_1 = null;
    this.sdd_1 = null;
  }
  protoOf(WebTextInputService).ydd = function () {
    return this.sdd_1;
  };
  protoOf(WebTextInputService).ade = function (request, onEditCommand) {
    var tmp0_imeOptions = request.bde();
    var tmp1_composeCommunicator = new WebTextInputService$startInput$1(this, onEditCommand, request);
    var tmp2_inputContainer = this.zdd();
    _set_backingDomInput__kd7j3y(this, new BackingDomInput(tmp2_inputContainer, tmp0_imeOptions, tmp1_composeCommunicator));
    var tmp3_safe_receiver = this.rdd_1;
    if (tmp3_safe_receiver == null)
      null;
    else {
      tmp3_safe_receiver.sdc();
    }
    var tmp = this.ydd();
    if (!((tmp == null ? null : new Offset(tmp)) == null)) {
      var tmp_0 = this.ydd();
      var tmp_1 = ensureNotNull(tmp_0 == null ? null : new Offset(tmp_0));
      // Inline function 'androidx.compose.ui.geometry.Size' call
      // Inline function 'androidx.compose.ui.util.packFloats' call
      var v1 = fromInt(toRawBits(1.0));
      var v2 = fromInt(toRawBits(1.0));
      var tmp$ret$1 = bitwiseOr(shiftLeft(v1, 32), bitwiseAnd(v2, new Long(-1, 0)));
      var tmp$ret$0 = _Size___init__impl__aywn0g(tmp$ret$1);
      this.i8d(Rect_0(tmp_1.e5d_1, tmp$ret$0));
    }
    this.e8d();
  };
  protoOf(WebTextInputService).a8d = function (value, imeOptions, onEditCommand, onImeActionPerformed) {
  };
  protoOf(WebTextInputService).cde = function () {
    var tmp0_safe_receiver = this.rdd_1;
    var tmp1_safe_receiver = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.kdc_1;
    var tmp;
    if (tmp1_safe_receiver == null) {
      tmp = null;
    } else {
      // Inline function 'kotlin.takeIf' call
      var tmp_0;
      if (tmp1_safe_receiver.isConnected) {
        tmp_0 = tmp1_safe_receiver;
      } else {
        tmp_0 = null;
      }
      tmp = tmp_0;
    }
    return tmp;
  };
  protoOf(WebTextInputService).d8d = function () {
    var tmp0_safe_receiver = this.rdd_1;
    if (tmp0_safe_receiver == null)
      null;
    else {
      tmp0_safe_receiver.s1d();
    }
    _set_backingDomInput__kd7j3y(this, null);
  };
  protoOf(WebTextInputService).e8d = function () {
    var tmp0_safe_receiver = this.rdd_1;
    if (tmp0_safe_receiver == null)
      null;
    else {
      tmp0_safe_receiver.tdc();
    }
  };
  protoOf(WebTextInputService).f8d = function () {
    var tmp0_safe_receiver = this.rdd_1;
    if (tmp0_safe_receiver == null)
      null;
    else {
      tmp0_safe_receiver.udc();
    }
  };
  protoOf(WebTextInputService).l8d = function (oldValue, newValue) {
    var tmp0_safe_receiver = this.rdd_1;
    if (tmp0_safe_receiver == null)
      null;
    else {
      tmp0_safe_receiver.wdc(newValue);
    }
  };
  protoOf(WebTextInputService).i8d = function (rect) {
    var newRect = this.dde(rect);
    var tmp0_safe_receiver = this.rdd_1;
    if (tmp0_safe_receiver == null)
      null;
    else {
      var tmp = _Dp___get_value__impl__geb1vb(newRect.w5f_1);
      var tmp_0 = _Dp___get_value__impl__geb1vb(newRect.x5f_1);
      // Inline function 'androidx.compose.ui.unit.width' call
      var tmp0 = newRect.y5f_1;
      // Inline function 'androidx.compose.ui.unit.Dp.minus' call
      var other = newRect.w5f_1;
      var tmp$ret$0 = _Dp___init__impl__ms3zkb(_Dp___get_value__impl__geb1vb(tmp0) - _Dp___get_value__impl__geb1vb(other));
      var tmp_1 = _Dp___get_value__impl__geb1vb(tmp$ret$0);
      // Inline function 'androidx.compose.ui.unit.height' call
      var tmp0_0 = newRect.z5f_1;
      // Inline function 'androidx.compose.ui.unit.Dp.minus' call
      var other_0 = newRect.x5f_1;
      var tmp$ret$2 = _Dp___init__impl__ms3zkb(_Dp___get_value__impl__geb1vb(tmp0_0) - _Dp___get_value__impl__geb1vb(other_0));
      tmp0_safe_receiver.vdc(tmp, tmp_0, tmp_1, _Dp___get_value__impl__geb1vb(tmp$ret$2));
    }
  };
  var androidx_compose_ui_platform_WebTextToolbar_TextToolbarMenu$stable;
  var androidx_compose_ui_platform_WebTextToolbar$stable;
  function TextToolbarMenu(rect, onCopyRequested, onPasteRequested, onCutRequested, onSelectAllRequested) {
    this.ede_1 = rect;
    this.fde_1 = onCopyRequested;
    this.gde_1 = onPasteRequested;
    this.hde_1 = onCutRequested;
    this.ide_1 = onSelectAllRequested;
  }
  protoOf(TextToolbarMenu).toString = function () {
    return 'TextToolbarMenu(rect=' + this.ede_1.toString() + ', onCopyRequested=' + toString_0(this.fde_1) + ', onPasteRequested=' + toString_0(this.gde_1) + ', onCutRequested=' + toString_0(this.hde_1) + ', onSelectAllRequested=' + toString_0(this.ide_1) + ')';
  };
  protoOf(TextToolbarMenu).hashCode = function () {
    var result = this.ede_1.hashCode();
    result = imul(result, 31) + (this.fde_1 == null ? 0 : hashCode(this.fde_1)) | 0;
    result = imul(result, 31) + (this.gde_1 == null ? 0 : hashCode(this.gde_1)) | 0;
    result = imul(result, 31) + (this.hde_1 == null ? 0 : hashCode(this.hde_1)) | 0;
    result = imul(result, 31) + (this.ide_1 == null ? 0 : hashCode(this.ide_1)) | 0;
    return result;
  };
  protoOf(TextToolbarMenu).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof TextToolbarMenu))
      return false;
    if (!this.ede_1.equals(other.ede_1))
      return false;
    if (!equals(this.fde_1, other.fde_1))
      return false;
    if (!equals(this.gde_1, other.gde_1))
      return false;
    if (!equals(this.hde_1, other.hde_1))
      return false;
    if (!equals(this.ide_1, other.ide_1))
      return false;
    return true;
  };
  function _set_menu__9qixnc($this, _set____db54di) {
    var tmp0 = $this.jde_1;
    var tmp = KMutableProperty1;
    var tmp_0 = WebTextToolbar$_get_menu_$ref_cq3izp();
    // Inline function 'androidx.compose.runtime.setValue' call
    getPropertyCallableRef('menu', 1, tmp, tmp_0, WebTextToolbar$_set_menu_$ref_pizugh());
    tmp0.s21(_set____db54di);
    return Unit_instance;
  }
  function WebTextToolbar$_get_menu_$ref_cq3izp() {
    return constructCallableReference(function (p0) {
      return p0.lde();
    }, 1, 0, 169);
  }
  function WebTextToolbar$_set_menu_$ref_pizugh() {
    return constructCallableReference(function (p0, p1) {
      _set_menu__9qixnc(p0, p1);
      return Unit_instance;
    }, 2, 0, 170);
  }
  function WebTextToolbar() {
    this.jde_1 = mutableStateOf(null);
    this.kde_1 = TextToolbarStatus_Hidden_getInstance();
  }
  protoOf(WebTextToolbar).lde = function () {
    var tmp0 = this.jde_1;
    var tmp = KMutableProperty1;
    var tmp_0 = WebTextToolbar$_get_menu_$ref_cq3izp();
    // Inline function 'androidx.compose.runtime.getValue' call
    getPropertyCallableRef('menu', 1, tmp, tmp_0, WebTextToolbar$_set_menu_$ref_pizugh());
    return tmp0.u1();
  };
  protoOf(WebTextToolbar).zbq = function () {
    return this.kde_1;
  };
  protoOf(WebTextToolbar).wbq = function () {
    _set_menu__9qixnc(this, null);
    this.kde_1 = TextToolbarStatus_Hidden_getInstance();
  };
  protoOf(WebTextToolbar).ybq = function (rect, onCopyRequested, onPasteRequested, onCutRequested, onSelectAllRequested) {
    _set_menu__9qixnc(this, new TextToolbarMenu(rect, onCopyRequested, onPasteRequested, onCutRequested, onSelectAllRequested));
    this.kde_1 = TextToolbarStatus_Shown_getInstance();
  };
  var androidx_compose_ui_platform_accessibility_ComposeWebSemanticsListener$stable;
  var androidx_compose_ui_platform_accessibility_AriaRoleId$stable;
  function ComposeWebSemanticsListener$slambda$slambda$slambda($lastDebouncedTime, $timeSpentDebouncing, $lastSyncTime, this$0, resultContinuation) {
    this.ude_1 = $lastDebouncedTime;
    this.vde_1 = $timeSpentDebouncing;
    this.wde_1 = $lastSyncTime;
    this.xde_1 = this$0;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(ComposeWebSemanticsListener$slambda$slambda$slambda).zde = function (it, $completion) {
    var tmp = this.sbo(it, $completion);
    tmp.p9_1 = Unit_instance;
    tmp.q9_1 = null;
    return tmp.v9();
  };
  protoOf(ComposeWebSemanticsListener$slambda$slambda$slambda).ja = function (p1, $completion) {
    return this.zde(p1 instanceof Unit ? p1 : THROW_CCE(), $completion);
  };
  protoOf(ComposeWebSemanticsListener$slambda$slambda$slambda).v9 = function () {
    var suspendResult = this.p9_1;
    $sm: do
      try {
        var tmp = this.n9_1;
        if (tmp === 0) {
          this.o9_1 = 1;
          var currentTime = currentTimeMillis();
          if (equalsLong(this.ude_1._v, new Long(0, 0))) {
            this.ude_1._v = currentTime;
            this.vde_1._v = new Long(0, 0);
          } else {
            var delta = subtract(currentTime, this.ude_1._v);
            this.vde_1._v = add(this.vde_1._v, delta);
            this.ude_1._v = currentTime;
          }
          if (compare(this.vde_1._v, new Long(1000, 0)) >= 0) {
            this.ude_1._v = new Long(0, 0);
            this.wde_1._v = currentTime;
            syncSemanticsWithWebA11Y(this.xde_1);
          } else {
            new ChannelResult(this.xde_1.ddf_1.s1s(currentTime));
          }
          return Unit_instance;
        } else if (tmp === 1) {
          throw this.q9_1;
        }
      } catch ($p) {
        var e = $p;
        throw e;
      }
     while (true);
  };
  protoOf(ComposeWebSemanticsListener$slambda$slambda$slambda).sbo = function (it, completion) {
    var i = new ComposeWebSemanticsListener$slambda$slambda$slambda(this.ude_1, this.vde_1, this.wde_1, this.xde_1, completion);
    i.yde_1 = it;
    return i;
  };
  function ComposeWebSemanticsListener$slambda$slambda$slambda_0($lastDebouncedTime, $timeSpentDebouncing, $lastSyncTime, this$0, resultContinuation) {
    var i = new ComposeWebSemanticsListener$slambda$slambda$slambda($lastDebouncedTime, $timeSpentDebouncing, $lastSyncTime, this$0, resultContinuation);
    return constructCallableReference(function (it, $completion) {
      return i.zde(it, $completion);
    }, 1);
  }
  function ComposeWebSemanticsListener$slambda$slambda$slambda_1($lastSyncTime, $lastDebouncedTime, this$0, resultContinuation) {
    this.rdf_1 = $lastSyncTime;
    this.sdf_1 = $lastDebouncedTime;
    this.tdf_1 = this$0;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(ComposeWebSemanticsListener$slambda$slambda$slambda_1).vdf = function (it, $completion) {
    var tmp = this.wdf(it, $completion);
    tmp.p9_1 = Unit_instance;
    tmp.q9_1 = null;
    return tmp.v9();
  };
  protoOf(ComposeWebSemanticsListener$slambda$slambda$slambda_1).ja = function (p1, $completion) {
    return this.vdf(p1 instanceof Long ? p1 : THROW_CCE(), $completion);
  };
  protoOf(ComposeWebSemanticsListener$slambda$slambda$slambda_1).v9 = function () {
    var suspendResult = this.p9_1;
    $sm: do
      try {
        var tmp = this.n9_1;
        if (tmp === 0) {
          this.o9_1 = 1;
          var currentTime = currentTimeMillis();
          if (compare(subtract(currentTime, this.rdf_1._v), new Long(100, 0)) >= 0) {
            this.sdf_1._v = new Long(0, 0);
            this.rdf_1._v = currentTime;
            syncSemanticsWithWebA11Y(this.tdf_1);
          }
          return Unit_instance;
        } else if (tmp === 1) {
          throw this.q9_1;
        }
      } catch ($p) {
        var e = $p;
        throw e;
      }
     while (true);
  };
  protoOf(ComposeWebSemanticsListener$slambda$slambda$slambda_1).wdf = function (it, completion) {
    var i = new ComposeWebSemanticsListener$slambda$slambda$slambda_1(this.rdf_1, this.sdf_1, this.tdf_1, completion);
    i.udf_1 = it;
    return i;
  };
  function ComposeWebSemanticsListener$slambda$slambda$slambda_2($lastSyncTime, $lastDebouncedTime, this$0, resultContinuation) {
    var i = new ComposeWebSemanticsListener$slambda$slambda$slambda_1($lastSyncTime, $lastDebouncedTime, this$0, resultContinuation);
    return constructCallableReference(function (it, $completion) {
      return i.vdf(it, $completion);
    }, 1);
  }
  function ComposeWebSemanticsListener$slambda$slambda(this$0, $lastDebouncedTime, $timeSpentDebouncing, $lastSyncTime, resultContinuation) {
    this.fdg_1 = this$0;
    this.gdg_1 = $lastDebouncedTime;
    this.hdg_1 = $timeSpentDebouncing;
    this.idg_1 = $lastSyncTime;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(ComposeWebSemanticsListener$slambda$slambda).p24 = function ($this$launch, $completion) {
    var tmp = this.q24($this$launch, $completion);
    tmp.p9_1 = Unit_instance;
    tmp.q9_1 = null;
    return tmp.v9();
  };
  protoOf(ComposeWebSemanticsListener$slambda$slambda).ja = function (p1, $completion) {
    return this.p24((!(p1 == null) ? isInterface(p1, CoroutineScope_0) : false) ? p1 : THROW_CCE(), $completion);
  };
  protoOf(ComposeWebSemanticsListener$slambda$slambda).v9 = function () {
    var suspendResult = this.p9_1;
    $sm: do
      try {
        var tmp = this.n9_1;
        switch (tmp) {
          case 0:
            this.o9_1 = 2;
            this.n9_1 = 1;
            var tmp_0 = receiveAsFlow(this.fdg_1.cdf_1);
            var tmp_1 = ComposeWebSemanticsListener$slambda$slambda$slambda_0(this.gdg_1, this.hdg_1, this.idg_1, this.fdg_1, null);
            suspendResult = tmp_0.l1u(new sam$kotlinx_coroutines_flow_FlowCollector$0_0(tmp_1), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            return Unit_instance;
          case 2:
            throw this.q9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.o9_1 === 2) {
          throw e;
        } else {
          this.n9_1 = this.o9_1;
          this.q9_1 = e;
        }
      }
     while (true);
  };
  protoOf(ComposeWebSemanticsListener$slambda$slambda).q24 = function ($this$launch, completion) {
    var i = new ComposeWebSemanticsListener$slambda$slambda(this.fdg_1, this.gdg_1, this.hdg_1, this.idg_1, completion);
    i.jdg_1 = $this$launch;
    return i;
  };
  function ComposeWebSemanticsListener$slambda$slambda_0(this$0, $lastDebouncedTime, $timeSpentDebouncing, $lastSyncTime, resultContinuation) {
    var i = new ComposeWebSemanticsListener$slambda$slambda(this$0, $lastDebouncedTime, $timeSpentDebouncing, $lastSyncTime, resultContinuation);
    return constructCallableReference(function ($this$launch, $completion) {
      return i.p24($this$launch, $completion);
    }, 1);
  }
  function ComposeWebSemanticsListener$slambda$slambda_1(this$0, $lastSyncTime, $lastDebouncedTime, resultContinuation) {
    this.sdg_1 = this$0;
    this.tdg_1 = $lastSyncTime;
    this.udg_1 = $lastDebouncedTime;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(ComposeWebSemanticsListener$slambda$slambda_1).p24 = function ($this$launch, $completion) {
    var tmp = this.q24($this$launch, $completion);
    tmp.p9_1 = Unit_instance;
    tmp.q9_1 = null;
    return tmp.v9();
  };
  protoOf(ComposeWebSemanticsListener$slambda$slambda_1).ja = function (p1, $completion) {
    return this.p24((!(p1 == null) ? isInterface(p1, CoroutineScope_0) : false) ? p1 : THROW_CCE(), $completion);
  };
  protoOf(ComposeWebSemanticsListener$slambda$slambda_1).v9 = function () {
    var suspendResult = this.p9_1;
    $sm: do
      try {
        var tmp = this.n9_1;
        switch (tmp) {
          case 0:
            this.o9_1 = 2;
            this.n9_1 = 1;
            var tmp_0 = receiveAsFlow(this.sdg_1.ddf_1);
            Companion_getInstance_16();
            var this_0 = new Long(100, 0);
            var tmp_1 = debounce(tmp_0, toDuration(this_0, DurationUnit_MILLISECONDS_getInstance()));
            var tmp_2 = ComposeWebSemanticsListener$slambda$slambda$slambda_2(this.tdg_1, this.udg_1, this.sdg_1, null);
            suspendResult = tmp_1.l1u(new sam$kotlinx_coroutines_flow_FlowCollector$0_0(tmp_2), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            return Unit_instance;
          case 2:
            throw this.q9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.o9_1 === 2) {
          throw e;
        } else {
          this.n9_1 = this.o9_1;
          this.q9_1 = e;
        }
      }
     while (true);
  };
  protoOf(ComposeWebSemanticsListener$slambda$slambda_1).q24 = function ($this$launch, completion) {
    var i = new ComposeWebSemanticsListener$slambda$slambda_1(this.sdg_1, this.tdg_1, this.udg_1, completion);
    i.vdg_1 = $this$launch;
    return i;
  };
  function ComposeWebSemanticsListener$slambda$slambda_2(this$0, $lastSyncTime, $lastDebouncedTime, resultContinuation) {
    var i = new ComposeWebSemanticsListener$slambda$slambda_1(this$0, $lastSyncTime, $lastDebouncedTime, resultContinuation);
    return constructCallableReference(function ($this$launch, $completion) {
      return i.p24($this$launch, $completion);
    }, 1);
  }
  function Companion_50() {
    Companion_instance_55 = this;
    this.wdg_1 = new Long(1000, 0);
    this.xdg_1 = new Long(100, 0);
  }
  var Companion_instance_55;
  function Companion_getInstance_76() {
    if (Companion_instance_55 == null)
      new Companion_50();
    return Companion_instance_55;
  }
  function syncSemanticsWithWebA11Y($this) {
    var tmp0_safe_receiver = $this.edf_1;
    var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.kbw();
    var tmp;
    if (tmp1_elvis_lhs == null) {
      return Unit_instance;
    } else {
      tmp = tmp1_elvis_lhs;
    }
    var root = tmp;
    if (syncSemanticsWithWebA11Y$isValid(root)) {
      $this.fdf_1.ah(root);
    }
    // Inline function 'kotlin.collections.mutableSetOf' call
    var allIds = LinkedHashSet_init_$Create$();
    // Inline function 'kotlin.let' call
    var it = $this.bdf_1.getBoundingClientRect();
    var tmp0 = it.left;
    // Inline function 'androidx.compose.ui.geometry.Offset' call
    // Inline function 'androidx.compose.ui.util.packFloats' call
    var val2 = it.top;
    var v1 = fromInt(toRawBits(tmp0));
    var v2 = fromInt(toRawBits(val2));
    var tmp$ret$4 = bitwiseOr(shiftLeft(v1, 32), bitwiseAnd(v2, new Long(-1, 0)));
    var rootPosition = _Offset___init__impl__c168vi(tmp$ret$4);
    while (!$this.fdf_1.r()) {
      var node = $this.fdf_1.dh();
      var currentId = node.qbt_1;
      allIds.j1(currentId);
      var children = asReversed(node.gbw());
      $this.fdf_1.o1(children);
      // Inline function 'androidx.compose.ui.util.fastForEach' call
      var inductionVariable = 0;
      var last = children.n1() - 1 | 0;
      if (inductionVariable <= last)
        do {
          var index = inductionVariable;
          inductionVariable = inductionVariable + 1 | 0;
          var item = children.l1(index);
          $this.hdf_1.h13(item.qbt_1, currentId);
        }
         while (inductionVariable <= last);
      var tmp_0;
      if (!($this.gdf_1.w2(currentId) == null)) {
        $this.gdf_1.h13(currentId, node);
        var tmp2_elvis_lhs = $this.idf_1.w2(currentId);
        var tmp_1;
        if (tmp2_elvis_lhs == null) {
          // Inline function 'kotlin.error' call
          var message = 'Node ' + currentId + ' not found';
          throw IllegalStateException_init_$Create$(toString(message));
        } else {
          tmp_1 = tmp2_elvis_lhs;
        }
        var htmlNode = tmp_1;
        // Inline function 'kotlin.collections.isNotEmpty' call
        if (!children.r()) {
          removeAllChildrenOf(htmlNode);
        }
        syncNode($this, node, htmlNode, rootPosition);
        tmp_0 = htmlNode;
      } else {
        $this.gdf_1.h13(currentId, node);
        var tmp_2 = document.createElement('div');
        var htmlNode_0 = tmp_2 instanceof HTMLElement ? tmp_2 : THROW_CCE();
        // Inline function 'kotlin.apply' call
        var this_0 = htmlNode_0.style;
        this_0.position = 'fixed';
        this_0.whiteSpace = 'pre';
        $this.idf_1.h13(currentId, htmlNode_0);
        syncNode($this, node, htmlNode_0, rootPosition, true);
        tmp_0 = htmlNode_0;
      }
      var htmlNode_1 = tmp_0;
      var parentId = $this.hdf_1.w2(currentId);
      var tmp_3;
      if (parentId == null) {
        tmp_3 = null;
      } else {
        // Inline function 'kotlin.let' call
        tmp_3 = $this.idf_1.w2(parentId);
      }
      var tmp4_elvis_lhs = tmp_3;
      var htmlParent = tmp4_elvis_lhs == null ? $this.bdf_1 : tmp4_elvis_lhs;
      htmlParent.appendChild(htmlNode_1);
    }
    // Inline function 'kotlin.collections.mutableSetOf' call
    var removedIds = LinkedHashSet_init_$Create$();
    // Inline function 'androidx.collection.ScatterMap.forEachKey' call
    var this_1 = $this.idf_1;
    var k = this_1.x12_1;
    $l$block: {
      // Inline function 'androidx.collection.ScatterMap.forEachIndexed' call
      var m = this_1.w12_1;
      var lastIndex = m.length - 2 | 0;
      var inductionVariable_0 = 0;
      if (inductionVariable_0 <= lastIndex)
        do {
          var i = inductionVariable_0;
          inductionVariable_0 = inductionVariable_0 + 1 | 0;
          var slot = m[i];
          // Inline function 'androidx.collection.maskEmptyOrDeleted' call
          var this_2 = slot;
          var tmp$ret$16 = bitwiseAnd(bitwiseAnd(this_2, shiftLeft(invert(this_2), 7)), new Long(-2139062144, -2139062144));
          if (!equalsLong(tmp$ret$16, new Long(-2139062144, -2139062144))) {
            var bitCount = 8 - (~(i - lastIndex | 0) >>> 31 | 0) | 0;
            var inductionVariable_1 = 0;
            if (inductionVariable_1 < bitCount)
              do {
                var j = inductionVariable_1;
                inductionVariable_1 = inductionVariable_1 + 1 | 0;
                // Inline function 'androidx.collection.isFull' call
                var value = bitwiseAnd(slot, new Long(255, 0));
                if (compare(value, new Long(128, 0)) < 0) {
                  var index_0 = (i << 3) + j | 0;
                  var it_0 = k[index_0];
                  if (!allIds.m1(it_0)) {
                    var tmp0_safe_receiver_0 = $this.idf_1.w2(it_0);
                    if (tmp0_safe_receiver_0 == null)
                      null;
                    else {
                      tmp0_safe_receiver_0.remove();
                    }
                    removedIds.j1(it_0);
                  }
                }
                slot = shiftRight(slot, 8);
              }
               while (inductionVariable_1 < bitCount);
            if (!(bitCount === 8)) {
              break $l$block;
            }
          }
        }
         while (!(i === lastIndex));
    }
    // Inline function 'kotlin.collections.forEach' call
    var _iterator__ex2g4s = removedIds.t();
    while (_iterator__ex2g4s.u()) {
      var element = _iterator__ex2g4s.v();
      $this.idf_1.a3(element);
      $this.gdf_1.a3(element);
      $this.hdf_1.a3(element);
    }
  }
  function syncNode($this, sn, htmlNode, rootOffset, justCreated) {
    justCreated = justCreated === VOID ? false : justCreated;
    var config = sn.ebw();
    if (config.nbr(SemanticsProperties_getInstance().ubu_1)) {
      var text = config.kbr(SemanticsProperties_getInstance().ubu_1);
      htmlNode.innerText = fastJoinToString(text, '\n', VOID, VOID, VOID, VOID, ComposeWebSemanticsListener$syncNode$lambda);
    }
    if (config.nbr(SemanticsProperties_getInstance().sbt_1)) {
      var contentDescription = config.kbr(SemanticsProperties_getInstance().sbt_1);
      htmlNode.setAttribute('aria-label', fastJoinToString(contentDescription, ', '));
    }
    if (config.nbr(SemanticsActions_getInstance().qbw_1) && justCreated) {
      var listener = ensureNotNull(config.kbr(SemanticsActions_getInstance().qbw_1).pbr_1);
      htmlNode.addEventListener('click', ComposeWebSemanticsListener$syncNode$lambda_0(listener));
    }
    if (config.nbr(SemanticsProperties_getInstance().sbu_1)) {
      var testTag = config.kbr(SemanticsProperties_getInstance().sbu_1);
      htmlNode.id = testTag;
    }
    if (config.nbr(SemanticsProperties_getInstance().ybu_1)) {
      var text_0 = config.kbr(SemanticsProperties_getInstance().ybu_1).h7q_1;
      htmlNode.innerText = text_0;
      if (justCreated) {
        htmlNode.setAttribute('contenteditable', 'true');
        htmlNode.addEventListener('focus', ComposeWebSemanticsListener$syncNode$lambda_1(htmlNode));
      }
    }
    setA11YAriaRole(htmlNode, getRoleId(config));
    var density = sn.nbt_1.w90_1;
    // Inline function 'kotlin.let' call
    var rect = sn.bbw();
    var newPosition = Offset__plus_impl_c78cg0(rootOffset, Offset__div_impl_eaxtg1(rect.s5d(), density.u5e()));
    // Inline function 'androidx.compose.ui.geometry.Rect.width' call
    var width = (rect.m5d_1 - rect.k5d_1) / density.u5e();
    // Inline function 'androidx.compose.ui.geometry.Rect.height' call
    var height = (rect.n5d_1 - rect.l5d_1) / density.u5e();
    // Inline function 'androidx.compose.ui.geometry.Offset.x' call
    // Inline function 'androidx.compose.ui.util.unpackFloat1' call
    var value = _Offset___get_packedValue__impl__xh2k8q(newPosition);
    // Inline function 'androidx.compose.ui.util.floatFromBits' call
    // Inline function 'kotlin.fromBits' call
    var bits = convertToInt(shiftRight(value, 32));
    var tmp = floatFromBits(bits);
    // Inline function 'androidx.compose.ui.geometry.Offset.y' call
    // Inline function 'androidx.compose.ui.util.unpackFloat2' call
    var value_0 = _Offset___get_packedValue__impl__xh2k8q(newPosition);
    // Inline function 'androidx.compose.ui.util.floatFromBits' call
    // Inline function 'kotlin.fromBits' call
    var bits_0 = convertToInt(bitwiseAnd(value_0, new Long(-1, 0)));
    var tmp$ret$8 = floatFromBits(bits_0);
    setSizeAndPosition(htmlNode, tmp, tmp$ret$8, width, height);
  }
  function sam$kotlinx_coroutines_flow_FlowCollector$0_0(function_0) {
    this.ydg_1 = function_0;
  }
  protoOf(sam$kotlinx_coroutines_flow_FlowCollector$0_0).a1v = function (value, $completion) {
    return this.ydg_1(value, $completion);
  };
  protoOf(sam$kotlinx_coroutines_flow_FlowCollector$0_0).q3 = function () {
    return this.ydg_1;
  };
  protoOf(sam$kotlinx_coroutines_flow_FlowCollector$0_0).equals = function (other) {
    var tmp;
    if (!(other == null) ? isInterface(other, FlowCollector) : false) {
      var tmp_0;
      if (!(other == null) ? isInterface(other, FunctionAdapter) : false) {
        tmp_0 = equals(this.q3(), other.q3());
      } else {
        tmp_0 = false;
      }
      tmp = tmp_0;
    } else {
      tmp = false;
    }
    return tmp;
  };
  protoOf(sam$kotlinx_coroutines_flow_FlowCollector$0_0).hashCode = function () {
    return hashCode(this.q3());
  };
  function ComposeWebSemanticsListener$slambda(this$0, resultContinuation) {
    this.hdh_1 = this$0;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(ComposeWebSemanticsListener$slambda).p24 = function ($this$launch, $completion) {
    var tmp = this.q24($this$launch, $completion);
    tmp.p9_1 = Unit_instance;
    tmp.q9_1 = null;
    return tmp.v9();
  };
  protoOf(ComposeWebSemanticsListener$slambda).ja = function (p1, $completion) {
    return this.p24((!(p1 == null) ? isInterface(p1, CoroutineScope_0) : false) ? p1 : THROW_CCE(), $completion);
  };
  protoOf(ComposeWebSemanticsListener$slambda).v9 = function () {
    var suspendResult = this.p9_1;
    $sm: do
      try {
        var tmp = this.n9_1;
        if (tmp === 0) {
          this.o9_1 = 1;
          var timeSpentDebouncing = {_v: new Long(0, 0)};
          var lastDebouncedTime = {_v: new Long(0, 0)};
          var lastSyncTime = {_v: currentTimeMillis()};
          launch(this.idh_1, VOID, VOID, ComposeWebSemanticsListener$slambda$slambda_0(this.hdh_1, lastDebouncedTime, timeSpentDebouncing, lastSyncTime, null));
          launch(this.idh_1, VOID, VOID, ComposeWebSemanticsListener$slambda$slambda_2(this.hdh_1, lastSyncTime, lastDebouncedTime, null));
          return Unit_instance;
        } else if (tmp === 1) {
          throw this.q9_1;
        }
      } catch ($p) {
        var e = $p;
        throw e;
      }
     while (true);
  };
  protoOf(ComposeWebSemanticsListener$slambda).q24 = function ($this$launch, completion) {
    var i = new ComposeWebSemanticsListener$slambda(this.hdh_1, completion);
    i.idh_1 = $this$launch;
    return i;
  };
  function ComposeWebSemanticsListener$slambda_0(this$0, resultContinuation) {
    var i = new ComposeWebSemanticsListener$slambda(this$0, resultContinuation);
    return constructCallableReference(function ($this$launch, $completion) {
      return i.p24($this$launch, $completion);
    }, 1);
  }
  function syncSemanticsWithWebA11Y$isValid(_this__u8e3s4) {
    // Inline function 'kotlin.let' call
    var it = _this__u8e3s4.nbt_1;
    return it.b9i() && it.y91();
  }
  function ComposeWebSemanticsListener$syncNode$lambda(it) {
    return it.h7q_1;
  }
  function ComposeWebSemanticsListener$syncNode$lambda_0($listener) {
    return function (it) {
      $listener();
      return Unit_instance;
    };
  }
  function ComposeWebSemanticsListener$syncNode$lambda_1($htmlNode) {
    return function (it) {
      $htmlNode.click();
      return Unit_instance;
    };
  }
  function ComposeWebSemanticsListener(coroutineScope, webSemanticsRoot) {
    Companion_getInstance_76();
    this.adf_1 = coroutineScope;
    this.bdf_1 = webSemanticsRoot;
    this.cdf_1 = Channel(1, BufferOverflow_DROP_LATEST_getInstance());
    this.ddf_1 = Channel(1, BufferOverflow_DROP_LATEST_getInstance());
    launch(this.adf_1, VOID, VOID, ComposeWebSemanticsListener$slambda_0(this, null));
    this.edf_1 = null;
    this.fdf_1 = ArrayDeque_init_$Create$();
    this.gdf_1 = new MutableScatterMap();
    this.hdf_1 = new MutableScatterMap();
    this.idf_1 = new MutableScatterMap();
  }
  protoOf(ComposeWebSemanticsListener).ed5 = function (semanticsOwner) {
    this.edf_1 = semanticsOwner;
  };
  protoOf(ComposeWebSemanticsListener).fd5 = function (semanticsOwner) {
    if (equals(semanticsOwner, this.edf_1)) {
      this.edf_1 = null;
    }
  };
  protoOf(ComposeWebSemanticsListener).ocq = function (semanticsOwner) {
    this.cdf_1.s1s(Unit_instance);
  };
  protoOf(ComposeWebSemanticsListener).pcq = function (semanticsOwner, semanticsNodeId) {
    this.cdf_1.s1s(Unit_instance);
  };
  function removeAllChildrenOf(element) {
    element.replaceChildren();
  }
  function setA11YAriaRole(element, ariaRoleId) {
    var roleValue = '';
    switch (ariaRoleId) {
      case 0:
        // Role.Button
        roleValue = 'button';
        break;
      case 1:
        // Role.Checkbox
        roleValue = 'checkbox';
        break;
      case 2:
        // Role.Switch
        roleValue = 'switch';
        break;
      case 3:
        // Role.RadioButton
        roleValue = 'radio';
        break;
      case 4:
        // Role.Tab
        roleValue = 'tab';
        break;
      case 5:
        // Role.Image
        roleValue = 'img';
        break;
      case 6:
        // Role.DropdownList
        roleValue = 'menu';
        break;
      case 7:
        // heading https://developer.mozilla.org/en-US/docs/Web/Accessibility/ARIA/Reference/Roles/heading_role
        roleValue = 'heading';
        break;
      case 8:
        // https://developer.mozilla.org/en-US/docs/Web/Accessibility/ARIA/Reference/Roles/textbox_role
        roleValue = 'textbox';
        break;
      case 9:
        // https://developer.mozilla.org/en-US/docs/Web/Accessibility/ARIA/Reference/Roles/list_role
        roleValue = 'list';
        break;
      case 10:
        // https://developer.mozilla.org/en-US/docs/Web/Accessibility/ARIA/Reference/Roles/grid_role
        roleValue = 'grid';
        break;
      default:
        break;
    }
    if (roleValue.length > 0) {
      element.setAttribute('role', roleValue);
    } else {
      element.removeAttribute('role');
    }
  }
  function getRoleId(_this__u8e3s4) {
    var roleId = -1;
    if (_this__u8e3s4.nbr(SemanticsProperties_getInstance().rbu_1)) {
      roleId = getRoleId$toIntId(_this__u8e3s4.kbr(SemanticsProperties_getInstance().rbu_1).jbw_1);
    }
    if (_this__u8e3s4.nbr(SemanticsActions_getInstance().qbw_1)) {
      roleId = getRoleId$toIntId(Companion_getInstance_65().tbx_1);
    }
    if (_this__u8e3s4.nbr(SemanticsProperties_getInstance().zbt_1)) {
      roleId = 7;
    }
    if (_this__u8e3s4.nbr(SemanticsProperties_getInstance().ybu_1)) {
      roleId = 8;
    }
    if (_this__u8e3s4.nbr(SemanticsProperties_getInstance().xbt_1)) {
      var info = _this__u8e3s4.kbr(SemanticsProperties_getInstance().xbt_1);
      var tmp;
      if (info.mby_1 > 1 && info.lby_1 > 1) {
        tmp = 10;
      } else {
        tmp = 9;
      }
      roleId = tmp;
    }
    return roleId;
  }
  function setSizeAndPosition(element, left, top, width, height) {
    element.style.left = '' + left + 'px';
    element.style.top = '' + top + 'px';
    element.style.width = '' + width + 'px';
    element.style.height = '' + height + 'px';
  }
  function getRoleId$toIntId(_this__u8e3s4) {
    return _this__u8e3s4 === Companion_getInstance_65().tbx_1 ? 0 : _this__u8e3s4 === Companion_getInstance_65().ubx_1 ? 1 : _this__u8e3s4 === Companion_getInstance_65().vbx_1 ? 2 : _this__u8e3s4 === Companion_getInstance_65().wbx_1 ? 3 : _this__u8e3s4 === Companion_getInstance_65().xbx_1 ? 4 : _this__u8e3s4 === Companion_getInstance_65().ybx_1 ? 5 : _this__u8e3s4 === Companion_getInstance_65().zbx_1 ? 6 : _this__u8e3s4 === Companion_getInstance_65().aby_1 ? -1 : _this__u8e3s4 === Companion_getInstance_65().bby_1 ? -1 : -1;
  }
  var androidx_compose_ui_viewinterop_InteropViewGroup$stable;
  function InteropViewGroup(htmlElement) {
    this.jdh_1 = htmlElement;
  }
  var androidx_compose_ui_viewinterop_WebInteropContainer$stable;
  function WebInteropContainer$snapshotObserver$lambda(command) {
    command();
    return Unit_instance;
  }
  function WebInteropContainer(root) {
    var tmp;
    if (root === VOID) {
      var tmp_0 = document.body;
      tmp = new InteropViewGroup(tmp_0 instanceof HTMLElement ? tmp_0 : THROW_CCE());
    } else {
      tmp = root;
    }
    root = tmp;
    this.kdh_1 = root;
    this.ldh_1 = null;
    var tmp_1 = this;
    // Inline function 'kotlin.collections.mutableMapOf' call
    tmp_1.mdh_1 = LinkedHashMap_init_$Create$();
    var tmp_2 = this;
    tmp_2.ndh_1 = new SnapshotStateObserver(WebInteropContainer$snapshotObserver$lambda);
  }
  protoOf(WebInteropContainer).xd7 = function (_set____db54di) {
    this.ldh_1 = _set____db54di;
  };
  protoOf(WebInteropContainer).td7 = function () {
    return this.ldh_1;
  };
  protoOf(WebInteropContainer).fb0 = function () {
    return this.ndh_1;
  };
  protoOf(WebInteropContainer).yd7 = function (holder) {
    var tmp0 = this.mdh_1;
    // Inline function 'kotlin.collections.contains' call
    // Inline function 'kotlin.collections.containsKey' call
    var key = holder.odh();
    return (isInterface(tmp0, KtMap) ? tmp0 : THROW_CCE()).u2(key);
  };
  protoOf(WebInteropContainer).pdh = function (holder) {
    // Inline function 'kotlin.checkNotNull' call
    var tmp0 = holder.odh();
    var tmp$ret$1;
    $l$block: {
      // Inline function 'kotlin.checkNotNull' call
      if (tmp0 == null) {
        var message = 'Required value was null.';
        throw IllegalStateException_init_$Create$(toString(message));
      } else {
        tmp$ret$1 = tmp0;
        break $l$block;
      }
    }
    var interopView = tmp$ret$1;
    if (this.mdh_1.r()) {
      this.ndh_1.c5b();
    }
    var isAdded = this.mdh_1.z2(interopView, holder) == null;
    var countBelow = countInteropComponentsBelow(this, holder);
    if (isAdded) {
      holder.rdh(this.kdh_1, countBelow);
    } else {
      holder.qdh(this.kdh_1, countBelow);
    }
  };
  protoOf(WebInteropContainer).sdh = function (holder) {
    // Inline function 'kotlin.requireNotNull' call
    var tmp0 = holder.odh();
    var tmp$ret$1;
    $l$block: {
      // Inline function 'kotlin.requireNotNull' call
      if (tmp0 == null) {
        var message = 'Required value was null.';
        throw IllegalArgumentException_init_$Create$(toString(message));
      } else {
        tmp$ret$1 = tmp0;
        break $l$block;
      }
    }
    var interopView = tmp$ret$1;
    this.mdh_1.a3(interopView);
    if (this.mdh_1.r()) {
      this.ndh_1.d5b();
    }
    holder.tdh(this.kdh_1);
  };
  var androidx_compose_ui_viewinterop_WebInteropElementHolder$stable;
  var androidx_compose_ui_viewinterop_WebInteropViewHolder$stable;
  var androidx_compose_ui_window_ComposeViewportConfiguration$stable;
  function ComposeViewportConfiguration() {
    this.udh_1 = true;
    this.vdh_1 = get_isClearFocusOnMouseDownEnabled_0(ComposeUiFlags_instance);
  }
  function ComposeViewport(viewportContainerId, configure, content) {
    viewportContainerId = viewportContainerId === VOID ? null : viewportContainerId;
    var tmp;
    if (configure === VOID) {
      tmp = ComposeViewport$lambda;
    } else {
      tmp = configure;
    }
    configure = tmp;
    content = content === VOID ? ComposableSingletons$ComposeWindow_webKt_getInstance().wdh_1 : content;
    onDomReady(ComposeViewport$lambda_0(viewportContainerId, configure, content));
  }
  function ComposableSingletons$ComposeWindow_webKt$lambda$_1543850037$lambda_jf4m2s($composer, $changed) {
    var $composer_0 = $composer;
    if (!$composer_0.r31(!(($changed & 3) === 2), $changed & 1)) {
      $composer_0.z30();
    }
    return Unit_instance;
  }
  function ComposableSingletons$ComposeWindow_webKt$lambda$_75259340$lambda_gsengv($composer, $changed) {
    var $composer_0 = $composer;
    if (!$composer_0.r31(!(($changed & 3) === 2), $changed & 1)) {
      $composer_0.z30();
    }
    return Unit_instance;
  }
  function ComposableSingletons$ComposeWindow_webKt() {
    ComposableSingletons$ComposeWindow_webKt_instance = this;
    var tmp = this;
    tmp.wdh_1 = ComposableLambda$invoke$ref(composableLambdaInstance(-1543850037, false, ComposableSingletons$ComposeWindow_webKt$lambda$_1543850037$lambda_jf4m2s));
    var tmp_0 = this;
    tmp_0.xdh_1 = ComposableLambda$invoke$ref(composableLambdaInstance(-75259340, false, ComposableSingletons$ComposeWindow_webKt$lambda$_75259340$lambda_gsengv));
  }
  var ComposableSingletons$ComposeWindow_webKt_instance;
  function ComposableSingletons$ComposeWindow_webKt_getInstance() {
    if (ComposableSingletons$ComposeWindow_webKt_instance == null)
      new ComposableSingletons$ComposeWindow_webKt();
    return ComposableSingletons$ComposeWindow_webKt_instance;
  }
  function ComposeViewport_0(viewportContainer, configure, content) {
    var tmp;
    if (configure === VOID) {
      tmp = ComposeViewport$lambda_1;
    } else {
      tmp = configure;
    }
    configure = tmp;
    content = content === VOID ? ComposableSingletons$ComposeWindow_webKt_getInstance().xdh_1 : content;
    return onSkikoReady(ComposeViewport$lambda_2(viewportContainer, configure, content));
  }
  function ComposeViewport$lambda(_this__u8e3s4) {
    return Unit_instance;
  }
  function ComposeViewport$lambda_0($viewportContainerId, $configure, $content) {
    return function () {
      var tmp;
      if (!($viewportContainerId == null)) {
        var tmp0_elvis_lhs = document.getElementById($viewportContainerId);
        var tmp_0;
        if (tmp0_elvis_lhs == null) {
          // Inline function 'kotlin.error' call
          var message = "failed to find element by viewportContainerId: '" + $viewportContainerId + "'";
          throw IllegalStateException_init_$Create$(toString(message));
        } else {
          tmp_0 = tmp0_elvis_lhs;
        }
        tmp = tmp_0;
      } else {
        var tmp1_elvis_lhs = document.body;
        var tmp_1;
        if (tmp1_elvis_lhs == null) {
          // Inline function 'kotlin.error' call
          var message_0 = 'failed to find <body> element';
          throw IllegalStateException_init_$Create$(toString(message_0));
        } else {
          tmp_1 = tmp1_elvis_lhs;
        }
        tmp = tmp_1;
      }
      var providedContainer = tmp;
      ComposeViewport_0(providedContainer, $configure, $content);
      return Unit_instance;
    };
  }
  function ComposeViewport$lambda_1(_this__u8e3s4) {
    return Unit_instance;
  }
  function ComposeViewport$lambda_2($viewportContainer, $configure, $content) {
    return function () {
      clear($viewportContainer);
      var tmp = document.createElement('div');
      var positioningContainer = tmp instanceof HTMLDivElement ? tmp : THROW_CCE();
      // Inline function 'kotlin.apply' call
      positioningContainer.style.position = 'relative';
      $viewportContainer.appendChild(positioningContainer);
      var tmp_0 = document.createElement('div');
      var shadowContainer = tmp_0 instanceof HTMLDivElement ? tmp_0 : THROW_CCE();
      // Inline function 'kotlin.apply' call
      shadowContainer.style.position = 'relative';
      positioningContainer.appendChild(shadowContainer);
      // Inline function 'org.w3c.dom.OPEN' call
      // Inline function 'kotlin.js.asDynamic' call
      // Inline function 'kotlin.js.unsafeCast' call
      // Inline function 'org.w3c.dom.ShadowRootInit' call
      var o = {};
      o['mode'] = 'open';
      var tmp$ret$7 = (!(o == null) ? !(o == null) : false) ? o : THROW_CCE();
      var shadowRoot = shadowContainer.attachShadow(tmp$ret$7);
      var shadowRootStyle = document.createElement('style');
      shadowRootStyle.textContent = ':host {\n    -webkit-touch-callout: none; \n    -webkit-user-select: none; \n    user-select: none;\n    \n    position: relative;\n}';
      shadowRoot.appendChild(shadowRootStyle);
      var tmp_1 = document.createElement('div');
      var appContainer = tmp_1 instanceof HTMLElement ? tmp_1 : THROW_CCE();
      // Inline function 'kotlin.apply' call
      appContainer.style.position = 'relative';
      shadowRoot.appendChild(appContainer);
      var tmp_2 = document.createElement('canvas');
      var canvas = tmp_2 instanceof HTMLCanvasElement ? tmp_2 : THROW_CCE();
      canvas.setAttribute('tabindex', '0');
      canvas.setAttribute('role', 'generic');
      canvas.style.outline = 'none';
      canvas.style.setProperty('touch-action', 'none');
      appContainer.appendChild(canvas);
      var tmp0 = new ComposeViewportConfiguration();
      // Inline function 'kotlin.apply' call
      $configure(tmp0);
      var configuration = tmp0;
      var tmp_3;
      if (configuration.udh_1) {
        var tmp_4 = document.createElement('div');
        // Inline function 'kotlin.also' call
        var this_0 = tmp_4 instanceof HTMLDivElement ? tmp_4 : THROW_CCE();
        // Inline function 'kotlin.apply' call
        var this_1 = this_0.style;
        this_1.position = 'absolute';
        this_1.top = '0';
        this_1.left = '0';
        appContainer.appendChild(this_0);
        tmp_3 = this_0;
      } else {
        tmp_3 = null;
      }
      var a11yContainerElement = tmp_3;
      var tmp_5 = document.createElement('div');
      var interopContainerElement = tmp_5 instanceof HTMLDivElement ? tmp_5 : THROW_CCE();
      // Inline function 'kotlin.apply' call
      var this_2 = interopContainerElement.style;
      this_2.position = 'absolute';
      this_2.top = '0';
      this_2.left = '0';
      positioningContainer.appendChild(interopContainerElement);
      var tmp0_state = new DefaultWindowState($viewportContainer);
      new ComposeWindow(canvas, shadowRoot, appContainer, interopContainerElement, a11yContainerElement, configuration, $content, tmp0_state);
      return Unit_instance;
    };
  }
  var androidx_compose_ui_window_KeyboardModeState_Virtual$stable;
  var androidx_compose_ui_window_KeyboardModeState_Hardware$stable;
  var androidx_compose_ui_window_DefaultWindowState$stable;
  var androidx_compose_ui_window_ComposeWindow$stable;
  function onDomReady(block) {
    var tmp = document.readyState;
    // Inline function 'org.w3c.dom.LOADING' call
    // Inline function 'kotlin.js.asDynamic' call
    // Inline function 'kotlin.js.unsafeCast' call
    if (equals(tmp, 'loading')) {
      var tmp_0 = document;
      tmp_0.addEventListener('DOMContentLoaded', onDomReady$lambda(block));
    } else {
      block();
    }
  }
  function onSkikoReady(block) {
    onWasmReady(onSkikoReady$lambda(block));
  }
  function ComposeWindow$platformContext$1$dragAndDropManager$1(this$0) {
    this.bdi_1 = this$0;
    WebDragAndDropManager.call(this, this$0.ddi_1, this$0.pdi_1, this$0.idi_1.bdj(), this$0.ldi_1);
  }
  protoOf(ComposeWindow$platformContext$1$dragAndDropManager$1).yd2 = function () {
    return this.bdi_1.vdi_1.yd2();
  };
  function ComposeWindow$platformContext$1$textInputService$1(this$0) {
    this.edj_1 = this$0;
    WebTextInputService.call(this);
  }
  protoOf(ComposeWindow$platformContext$1$textInputService$1).ydd = function () {
    return this.edj_1.rdi_1;
  };
  protoOf(ComposeWindow$platformContext$1$textInputService$1).zdd = function () {
    return this.edj_1.edi_1;
  };
  protoOf(ComposeWindow$platformContext$1$textInputService$1).dde = function (rect) {
    // Inline function 'androidx.compose.ui.unit.toDpRect' call
    var density = this.edj_1.ldi_1;
    // Inline function 'kotlin.with' call
    var dpRect = DpRect_init_$Create$(toDpOffset(rect.s5d(), density), density.g5f(rect.o5d()));
    var left = _Dp___get_value__impl__geb1vb(dpRect.w5f_1);
    var top = _Dp___get_value__impl__geb1vb(dpRect.x5f_1);
    // Inline function 'androidx.compose.ui.unit.dp' call
    var tmp0 = _Dp___init__impl__ms3zkb(left);
    // Inline function 'androidx.compose.ui.unit.dp' call
    // Inline function 'androidx.compose.ui.unit.DpOffset' call
    var y = _Dp___init__impl__ms3zkb(top);
    var tmp0_0 = _Dp___get_value__impl__geb1vb(tmp0);
    // Inline function 'androidx.compose.ui.util.packFloats' call
    var val2 = _Dp___get_value__impl__geb1vb(y);
    var v1 = fromInt(toRawBits(tmp0_0));
    var v2 = fromInt(toRawBits(val2));
    var tmp$ret$6 = bitwiseOr(shiftLeft(v1, 32), bitwiseAnd(v2, new Long(-1, 0)));
    var tmp = _DpOffset___init__impl__yq36wy(tmp$ret$6);
    // Inline function 'androidx.compose.ui.unit.size' call
    // Inline function 'androidx.compose.ui.unit.width' call
    var tmp0_1 = dpRect.y5f_1;
    // Inline function 'androidx.compose.ui.unit.Dp.minus' call
    var other = dpRect.w5f_1;
    var tmp_0 = _Dp___init__impl__ms3zkb(_Dp___get_value__impl__geb1vb(tmp0_1) - _Dp___get_value__impl__geb1vb(other));
    // Inline function 'androidx.compose.ui.unit.height' call
    var tmp0_2 = dpRect.z5f_1;
    // Inline function 'androidx.compose.ui.unit.Dp.minus' call
    var other_0 = dpRect.x5f_1;
    var tmp$ret$10 = _Dp___init__impl__ms3zkb(_Dp___get_value__impl__geb1vb(tmp0_2) - _Dp___get_value__impl__geb1vb(other_0));
    var tmp$ret$7 = DpSize(tmp_0, tmp$ret$10);
    return DpRect_init_$Create$(tmp, tmp$ret$7);
  };
  protoOf(ComposeWindow$platformContext$1$textInputService$1).wdd = function (keyEvent) {
    return this.edj_1.vdi_1.xd2(keyEvent);
  };
  function ComposeWindow$platformContext$1$viewConfiguration$1(this$0) {
    this.gdj_1 = this$0;
    this.fdj_1 = DefaultViewConfiguration_getInstance();
  }
  protoOf(ComposeWindow$platformContext$1$viewConfiguration$1).ub9 = function () {
    // Inline function 'kotlin.with' call
    var $this$with = this.gdj_1.ldi_1;
    // Inline function 'androidx.compose.ui.unit.dp' call
    var tmp$ret$2 = _Dp___init__impl__ms3zkb(18);
    return $this$with.v5e(tmp$ret$2);
  };
  protoOf(ComposeWindow$platformContext$1$viewConfiguration$1).wb9 = function () {
    // Inline function 'kotlin.with' call
    var $this$with = this.gdj_1.ldi_1;
    // Inline function 'androidx.compose.ui.unit.dp' call
    var tmp$ret$2 = _Dp___init__impl__ms3zkb(8000);
    return $this$with.v5e(tmp$ret$2);
  };
  protoOf(ComposeWindow$platformContext$1$viewConfiguration$1).rb9 = function () {
    return this.fdj_1.wcy_1;
  };
  protoOf(ComposeWindow$platformContext$1$viewConfiguration$1).sb9 = function () {
    return this.fdj_1.xcy_1;
  };
  protoOf(ComposeWindow$platformContext$1$viewConfiguration$1).tb9 = function () {
    return this.fdj_1.ycy_1;
  };
  protoOf(ComposeWindow$platformContext$1$viewConfiguration$1).vb9 = function () {
    return this.fdj_1.vb9();
  };
  protoOf(ComposeWindow$platformContext$1$viewConfiguration$1).eab = function () {
    return this.fdj_1.eab();
  };
  function ComposeWindow$platformContext$o$startInputMethod$slambda(this$0, $request, resultContinuation) {
    this.pdj_1 = this$0;
    this.qdj_1 = $request;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(ComposeWindow$platformContext$o$startInputMethod$slambda).rcm = function ($this$coroutineScope, $completion) {
    var tmp = this.q24($this$coroutineScope, $completion);
    tmp.p9_1 = Unit_instance;
    tmp.q9_1 = null;
    return tmp.v9();
  };
  protoOf(ComposeWindow$platformContext$o$startInputMethod$slambda).ja = function (p1, $completion) {
    return this.rcm((!(p1 == null) ? isInterface(p1, CoroutineScope_0) : false) ? p1 : THROW_CCE(), $completion);
  };
  protoOf(ComposeWindow$platformContext$o$startInputMethod$slambda).v9 = function () {
    var suspendResult = this.p9_1;
    $sm: do
      try {
        var tmp = this.n9_1;
        switch (tmp) {
          case 0:
            this.o9_1 = 2;
            this.n9_1 = 1;
            suspendResult = (new WebTextInputSession(this.rdj_1, this.pdj_1.xdj_1)).hbp(this.qdj_1, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            throwKotlinNothingValueException();
            break;
          case 2:
            throw this.q9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.o9_1 === 2) {
          throw e;
        } else {
          this.n9_1 = this.o9_1;
          this.q9_1 = e;
        }
      }
     while (true);
  };
  protoOf(ComposeWindow$platformContext$o$startInputMethod$slambda).q24 = function ($this$coroutineScope, completion) {
    var i = new ComposeWindow$platformContext$o$startInputMethod$slambda(this.pdj_1, this.qdj_1, completion);
    i.rdj_1 = $this$coroutineScope;
    return i;
  };
  function ComposeWindow$platformContext$o$startInputMethod$slambda_0(this$0, $request, resultContinuation) {
    var i = new ComposeWindow$platformContext$o$startInputMethod$slambda(this$0, $request, resultContinuation);
    return constructCallableReference(function ($this$coroutineScope, $completion) {
      return i.rcm($this$coroutineScope, $completion);
    }, 1);
  }
  function $startInputMethodCOROUTINE$_3(_this__u8e3s4, request, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.kdk_1 = _this__u8e3s4;
    this.ldk_1 = request;
  }
  protoOf($startInputMethodCOROUTINE$_3).v9 = function () {
    var suspendResult = this.p9_1;
    $sm: do
      try {
        var tmp = this.n9_1;
        switch (tmp) {
          case 0:
            this.o9_1 = 2;
            this.n9_1 = 1;
            suspendResult = coroutineScope(ComposeWindow$platformContext$o$startInputMethod$slambda_0(this.kdk_1, this.ldk_1, null), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            throwKotlinNothingValueException();
            break;
          case 2:
            throw this.q9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.o9_1 === 2) {
          throw e;
        } else {
          this.n9_1 = this.o9_1;
          this.q9_1 = e;
        }
      }
     while (true);
  };
  function ComposeWindow$lambda$lambda$slambda$slambda(this$0, resultContinuation) {
    this.udk_1 = this$0;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(ComposeWindow$lambda$lambda$slambda$slambda).lcp = function (size, $completion) {
    var tmp = this.mcp(size, $completion);
    tmp.p9_1 = Unit_instance;
    tmp.q9_1 = null;
    return tmp.v9();
  };
  protoOf(ComposeWindow$lambda$lambda$slambda$slambda).ja = function (p1, $completion) {
    return this.lcp(p1 instanceof IntSize ? p1.o5g_1 : THROW_CCE(), $completion);
  };
  protoOf(ComposeWindow$lambda$lambda$slambda$slambda).v9 = function () {
    var suspendResult = this.p9_1;
    $sm: do
      try {
        var tmp = this.n9_1;
        if (tmp === 0) {
          this.o9_1 = 1;
          var this_0 = this.vdk_1;
          var value = _IntSize___get_packedValue__impl__uho7jf(this_0);
          var this_1 = convertToInt(shiftRight(value, 32));
          var tmp_0 = _Dp___init__impl__ms3zkb(this_1);
          var this_2 = this.vdk_1;
          var value_0 = _IntSize___get_packedValue__impl__uho7jf(this_2);
          var this_3 = convertToInt(bitwiseAnd(value_0, new Long(-1, 0)));
          var boxSize = DpSize(tmp_0, _Dp___init__impl__ms3zkb(this_3));
          resize(this.udk_1, boxSize);
          return Unit_instance;
        } else if (tmp === 1) {
          throw this.q9_1;
        }
      } catch ($p) {
        var e = $p;
        throw e;
      }
     while (true);
  };
  protoOf(ComposeWindow$lambda$lambda$slambda$slambda).mcp = function (size, completion) {
    var i = new ComposeWindow$lambda$lambda$slambda$slambda(this.udk_1, completion);
    i.vdk_1 = size;
    return i;
  };
  function ComposeWindow$lambda$lambda$slambda$slambda_0(this$0, resultContinuation) {
    var i = new ComposeWindow$lambda$lambda$slambda$slambda(this$0, resultContinuation);
    return constructCallableReference(function (size, $completion) {
      return i.lcp(size.o5g_1, $completion);
    }, 1);
  }
  function addTypedEvent($this, type, handler) {
    $this.pdi_1.zdb(type, ComposeWindow$addTypedEvent$lambda(handler));
  }
  function addTypedEvent_0($this, type, passive, handler) {
    $this.pdi_1.adc(type, passive, ComposeWindow$addTypedEvent$lambda_0(handler));
  }
  function processKeyboardEvent($this, keyboardEvent) {
    var keyEvent = toComposeEvent(keyboardEvent);
    var processed = $this.vdi_1.xd2(keyEvent) || $this.odi_1.w9e(keyEvent);
    if (processed) {
      keyboardEvent.preventDefault();
    } else if (get_type(keyEvent) === Companion_getInstance_39().e9e_1) {
      processClipKeyDown($this, keyEvent);
    }
  }
  function processClipKeyDown($this, keyEvent) {
    var mod = $this.xdi_1 ? get_isMetaPressed(keyEvent) : get_isCtrlPressed(keyEvent);
    if (!mod)
      return Unit_instance;
    if (equals(get_key_0(keyEvent), Companion_getInstance_75().uc9_1) || equals(get_key_0(keyEvent), Companion_getInstance_75().nca_1) || equals(get_key_0(keyEvent), Companion_getInstance_75().pca_1)) {
      $this.edi_1.appendChild($this.sdi_1);
      focusExt($this.sdi_1, true);
    }
  }
  function initEvents_1($this, canvas) {
    // Inline function 'kotlin.collections.forEach' call
    var _iterator__ex2g4s = listOf_0(['pointerenter', 'pointerdown', 'pointermove', 'pointerup', 'pointerleave', 'pointercancel']).t();
    while (_iterator__ex2g4s.u()) {
      var element = _iterator__ex2g4s.v();
      addTypedEvent_0($this, element, false, ComposeWindow$initEvents$lambda($this));
    }
    var tmp = $this.idi_1.bdj();
    tmp.zdb('dragend', ComposeWindow$initEvents$lambda_0($this));
    addTypedEvent($this, 'touchstart', ComposeWindow$initEvents$lambda_1($this));
    addTypedEvent_0($this, 'wheel', false, ComposeWindow$initEvents$lambda_2($this));
    canvas.addEventListener('contextmenu', ComposeWindow$initEvents$lambda_3);
    addTypedEvent($this, 'keydown', ComposeWindow$initEvents$lambda_4($this));
    addTypedEvent($this, 'keyup', ComposeWindow$initEvents$lambda_5($this));
    addTypedEvent($this, 'focus', ComposeWindow$initEvents$lambda_6($this));
    addTypedEvent($this, 'blur', ComposeWindow$initEvents$lambda_7($this));
    var tmp_0 = $this.idi_1.bdj();
    tmp_0.zdb('focus', ComposeWindow$initEvents$lambda_8($this));
    var tmp_1 = $this.idi_1.bdj();
    tmp_1.zdb('blur', ComposeWindow$initEvents$lambda_9($this));
    var tmp_2 = $this.idi_1.bdj();
    tmp_2.zdb('visibilitychange', ComposeWindow$initEvents$lambda_10($this));
  }
  function resize($this, boxSize) {
    // Inline function 'androidx.compose.ui.unit.toSize' call
    // Inline function 'kotlin.with' call
    var tmp$ret$0 = $this.ldi_1.f5f(boxSize);
    var sizeInPx = toIntSize(tmp$ret$0);
    // Inline function 'androidx.compose.ui.unit.IntSize.width' call
    // Inline function 'androidx.compose.ui.util.unpackInt1' call
    var value = _IntSize___get_packedValue__impl__uho7jf(sizeInPx);
    var tmp$ret$3 = convertToInt(shiftRight(value, 32));
    $this.cdi_1.width = tmp$ret$3;
    // Inline function 'androidx.compose.ui.unit.IntSize.height' call
    // Inline function 'androidx.compose.ui.util.unpackInt2' call
    var value_0 = _IntSize___get_packedValue__impl__uho7jf(sizeInPx);
    var tmp$ret$5 = convertToInt(bitwiseAnd(value_0, new Long(-1, 0)));
    $this.cdi_1.height = tmp$ret$5;
    $this.cdi_1.style.width = '' + _Dp___get_value__impl__geb1vb(_DpSize___get_width__impl__o3d5gt(boxSize)) + 'px';
    $this.cdi_1.style.height = '' + _Dp___get_value__impl__geb1vb(_DpSize___get_height__impl__5xueo2(boxSize)) + 'px';
    $this.mdi_1.hbr(sizeInPx);
    $this.mdi_1.ibr(boxSize);
    $this.udi_1.x69($this.cdi_1);
    $this.vdi_1.qcr(sizeInPx);
    $this.udi_1.w69();
  }
  function TouchEventWithContainerOffset($outer, event, containerOffset) {
    this.zdk_1 = $outer;
    this.wdk_1 = event;
    this.xdk_1 = containerOffset;
    this.ydk_1 = toScenePointerEvent(this.wdk_1, this.xdk_1, this.zdk_1.ldi_1);
  }
  protoOf(TouchEventWithContainerOffset).equals = function (other) {
    if (this === other)
      return true;
    if (other == null || !getKClassFromExpression(this).equals(getKClassFromExpression(other)))
      return false;
    if (!(other instanceof TouchEventWithContainerOffset))
      THROW_CCE();
    if (!equals(this.wdk_1, other.wdk_1))
      return false;
    if (!equals(this.xdk_1, other.xdk_1))
      return false;
    return true;
  };
  protoOf(TouchEventWithContainerOffset).hashCode = function () {
    var result = hashCode(this.wdk_1);
    result = imul(31, result) + Offset__hashCode_impl_hbql41(this.xdk_1) | 0;
    return result;
  };
  function getActivePointers($this) {
    $this.adj_1.c3();
    // Inline function 'androidx.collection.IntObjectMap.forEachValue' call
    var this_0 = $this.zdi_1;
    var v = this_0.vv_1;
    $l$block: {
      // Inline function 'androidx.collection.IntObjectMap.forEachIndexed' call
      var m = this_0.tv_1;
      var lastIndex = m.length - 2 | 0;
      var inductionVariable = 0;
      if (inductionVariable <= lastIndex)
        do {
          var i = inductionVariable;
          inductionVariable = inductionVariable + 1 | 0;
          var slot = m[i];
          // Inline function 'androidx.collection.maskEmptyOrDeleted' call
          var this_1 = slot;
          var tmp$ret$2 = bitwiseAnd(bitwiseAnd(this_1, shiftLeft(invert(this_1), 7)), new Long(-2139062144, -2139062144));
          if (!equalsLong(tmp$ret$2, new Long(-2139062144, -2139062144))) {
            var bitCount = 8 - (~(i - lastIndex | 0) >>> 31 | 0) | 0;
            var inductionVariable_0 = 0;
            if (inductionVariable_0 < bitCount)
              do {
                var j = inductionVariable_0;
                inductionVariable_0 = inductionVariable_0 + 1 | 0;
                // Inline function 'androidx.collection.isFull' call
                var value = bitwiseAnd(slot, new Long(255, 0));
                if (compare(value, new Long(128, 0)) < 0) {
                  var index = (i << 3) + j | 0;
                  var it = v[index];
                  $this.adj_1.j1(it.ydk_1);
                }
                slot = shiftRight(slot, 8);
              }
               while (inductionVariable_0 < bitCount);
            if (!(bitCount === 8)) {
              break $l$block;
            }
          }
        }
         while (!(i === lastIndex));
    }
    return $this.adj_1;
  }
  function onPointerEvent_0($this, event) {
    var eventType = getPointerEventType(event);
    var result = null;
    if (isMouseEvent(event)) {
      $this.qdi_1 = Hardware_instance;
      var isValidEvent = true;
      if (eventType === Companion_getInstance_41().la1_1) {
        $this.kdi_1 = get_composeButtons(event);
      } else if (eventType === Companion_getInstance_41().ma1_1) {
        $this.kdi_1 = null;
      } else if (eventType === Companion_getInstance_41().na1_1) {
        var tmp;
        var tmp_0 = $this.kdi_1;
        if ((tmp_0 == null ? null : new PointerButtons(tmp_0)) == null) {
          tmp = true;
        } else {
          var tmp_1 = $this.kdi_1;
          tmp = equals(tmp_1 == null ? null : new PointerButtons(tmp_1), new PointerButtons(get_composeButtons(event)));
        }
        isValidEvent = tmp;
      }
      if (!isValidEvent)
        return Unit_instance;
      new PointerEventResult($this.vdi_1.td2(eventType, _get_offset__c6qzmg_0($this, event), VOID, fromInt(numberToInt(event.timeStamp)), VOID, get_composeButtons(event), PointerKeyboardModifiers_0(event.ctrlKey, event.metaKey, event.altKey, event.shiftKey), event, get_composeButton(event)));
    } else {
      if (eventType === Companion_getInstance_41().oa1_1 || eventType === Companion_getInstance_41().pa1_1) {
        return Unit_instance;
      }
      $this.ndi_1.pcz_1.x7n(State_RESUMED_getInstance());
      var inputModeManager = $this.tdi_1.xbl();
      if (!(inputModeManager.ncz() === Companion_getInstance_38().a9u_1)) {
        inputModeManager.xcp(Companion_getInstance_38().a9u_1);
      }
      $this.qdi_1 = Virtual_instance;
      var current;
      var active = $this.zdi_1.l1(event.pointerId);
      if (active == null) {
        var tmp1_safe_receiver = event.target;
        if (tmp1_safe_receiver == null)
          null;
        else {
          // Inline function 'kotlin.let' call
          setPointerCapture(tmp1_safe_receiver, event.pointerId);
        }
        // Inline function 'kotlin.let' call
        var it = $this.cdi_1.getBoundingClientRect();
        var tmp0 = it.left;
        // Inline function 'androidx.compose.ui.geometry.Offset' call
        // Inline function 'androidx.compose.ui.util.packFloats' call
        var val2 = it.top;
        var v1 = fromInt(toRawBits(tmp0));
        var v2 = fromInt(toRawBits(val2));
        var tmp$ret$5 = bitwiseOr(shiftLeft(v1, 32), bitwiseAnd(v2, new Long(-1, 0)));
        var containerOffset = _Offset___init__impl__c168vi(tmp$ret$5);
        current = new TouchEventWithContainerOffset($this, event, containerOffset);
      } else {
        current = new TouchEventWithContainerOffset($this, event, active.xdk_1);
      }
      $this.zdi_1.ew(event.pointerId, current);
      $this.rdi_1 = current.ydk_1.vd5_1;
      var pointers = getActivePointers($this);
      var buttons = PointerButtons_0();
      var keyboardModifiers = PointerKeyboardModifiers_0();
      var coalescedEvents = null;
      if (eventType === Companion_getInstance_41().na1_1) {
        coalescedEvents = toList_0(getCoalescedEvents(event));
      }
      if (!(coalescedEvents == null) && coalescedEvents.n1() > 1) {
        var indexOfCurrentPointer = -1;
        var inductionVariable = 0;
        var last = pointers.n1() - 1 | 0;
        if (inductionVariable <= last)
          $l$loop: do {
            var index = inductionVariable;
            inductionVariable = inductionVariable + 1 | 0;
            if (pointers.l1(index).equals(current.ydk_1)) {
              indexOfCurrentPointer = index;
              break $l$loop;
            }
          }
           while (inductionVariable <= last);
        // Inline function 'androidx.compose.ui.util.fastForEach' call
        var this_0 = coalescedEvents;
        var inductionVariable_0 = 0;
        var last_0 = this_0.n1() - 1 | 0;
        if (inductionVariable_0 <= last_0)
          do {
            var index_0 = inductionVariable_0;
            inductionVariable_0 = inductionVariable_0 + 1 | 0;
            var item = this_0.l1(index_0);
            var coalescedEventType = getPointerEventType(item);
            var sceneEvent = toScenePointerEvent(item, current.xdk_1, $this.ldi_1);
            pointers.f3(indexOfCurrentPointer, sceneEvent);
            result = $this.vdi_1.wd2(coalescedEventType, pointers, buttons, keyboardModifiers, Companion_getInstance().g5d_1, fromInt(numberToInt(item.timeStamp)), item, null);
          }
           while (inductionVariable_0 <= last_0);
      } else {
        result = $this.vdi_1.wd2(eventType, pointers, buttons, keyboardModifiers, Companion_getInstance().g5d_1, fromInt(numberToInt(event.timeStamp)), event, null);
      }
      $this.rdi_1 = null;
      if (eventType === Companion_getInstance_41().ma1_1) {
        $this.zdi_1.gw(event.pointerId);
      }
      var tmp_2;
      var tmp_3;
      var tmp_4 = result;
      if (!((tmp_4 == null ? null : new PointerEventResult(tmp_4)) == null)) {
        // Inline function 'androidx.compose.ui.scene.PointerEventResult.anyChangeConsumed' call
        var this_1 = result;
        tmp_3 = !((_PointerEventResult___get_value__impl__1zjqdh(this_1) & 4) === 0);
      } else {
        tmp_3 = false;
      }
      if (tmp_3) {
        tmp_2 = event.cancelable;
      } else {
        tmp_2 = false;
      }
      if (tmp_2) {
        event.preventDefault();
      }
    }
  }
  function onWheelEvent($this, event) {
    $this.qdi_1 = Hardware_instance;
    var tmp;
    // Inline function 'kotlin.math.absoluteValue' call
    var this_0 = event.deltaX;
    var tmp_0 = Math.abs(this_0);
    // Inline function 'kotlin.math.absoluteValue' call
    var this_1 = event.deltaY;
    if (tmp_0 >= Math.abs(this_1)) {
      tmp = event.deltaX;
    } else {
      if (event.shiftKey) {
        tmp = event.deltaY;
      } else {
        tmp = 0.0;
      }
    }
    var horizontalScroll = tmp;
    var verticalScroll = equals(horizontalScroll, 0.0) ? event.deltaY : 0.0;
    var tmp0_elvis_lhs = $this.kdi_1;
    var tmp_1;
    var tmp_2 = tmp0_elvis_lhs;
    if ((tmp_2 == null ? null : new PointerButtons(tmp_2)) == null) {
      tmp_1 = get_composeButtons(event);
    } else {
      tmp_1 = tmp0_elvis_lhs;
    }
    var buttons = tmp_1;
    var tmp_3 = Companion_getInstance_41().qa1_1;
    var tmp_4 = _get_offset__c6qzmg_0($this, event);
    var tmp0 = numberToDouble(horizontalScroll);
    // Inline function 'androidx.compose.ui.geometry.Offset' call
    // Inline function 'androidx.compose.ui.util.packFloats' call
    var val2 = numberToDouble(verticalScroll);
    var v1 = fromInt(toRawBits(tmp0));
    var v2 = fromInt(toRawBits(val2));
    var tmp$ret$3 = bitwiseOr(shiftLeft(v1, 32), bitwiseAnd(v2, new Long(-1, 0)));
    var tmp$ret$2 = _Offset___init__impl__c168vi(tmp$ret$3);
    var result = $this.vdi_1.td2(tmp_3, tmp_4, tmp$ret$2, VOID, VOID, buttons, PointerKeyboardModifiers_0(event.ctrlKey, event.metaKey, event.altKey, event.shiftKey), event, get_composeButton(event));
    var tmp_5;
    // Inline function 'androidx.compose.ui.scene.PointerEventResult.anyChangeConsumed' call
    if (!((_PointerEventResult___get_value__impl__1zjqdh(result) & 4) === 0)) {
      tmp_5 = event.cancelable;
    } else {
      tmp_5 = false;
    }
    if (tmp_5) {
      event.preventDefault();
    }
  }
  function _get_offset__c6qzmg_0($this, $receiver) {
    var tmp0 = $receiver.offsetX * $this.ldi_1.u5e();
    // Inline function 'androidx.compose.ui.geometry.Offset' call
    // Inline function 'androidx.compose.ui.util.packFloats' call
    var val2 = $receiver.offsetY * $this.ldi_1.u5e();
    var v1 = fromInt(toRawBits(tmp0));
    var v2 = fromInt(toRawBits(val2));
    var tmp$ret$1 = bitwiseOr(shiftLeft(v1, 32), bitwiseAnd(v2, new Long(-1, 0)));
    return _Offset___init__impl__c168vi(tmp$ret$1);
  }
  function sam$org_jetbrains_skiko_SkikoRenderDelegate$0(function_0) {
    this.adl_1 = function_0;
  }
  protoOf(sam$org_jetbrains_skiko_SkikoRenderDelegate$0).p66 = function (canvas, width, height, nanoTime) {
    return this.adl_1(canvas, width, height, nanoTime);
  };
  protoOf(sam$org_jetbrains_skiko_SkikoRenderDelegate$0).q3 = function () {
    return this.adl_1;
  };
  protoOf(sam$org_jetbrains_skiko_SkikoRenderDelegate$0).equals = function (other) {
    var tmp;
    if (!(other == null) ? isInterface(other, SkikoRenderDelegate) : false) {
      var tmp_0;
      if (!(other == null) ? isInterface(other, FunctionAdapter) : false) {
        tmp_0 = equals(this.q3(), other.q3());
      } else {
        tmp_0 = false;
      }
      tmp = tmp_0;
    } else {
      tmp = false;
    }
    return tmp;
  };
  protoOf(sam$org_jetbrains_skiko_SkikoRenderDelegate$0).hashCode = function () {
    return hashCode(this.q3());
  };
  function sam$kotlinx_coroutines_flow_FlowCollector$0_1(function_0) {
    this.bdl_1 = function_0;
  }
  protoOf(sam$kotlinx_coroutines_flow_FlowCollector$0_1).a1v = function (value, $completion) {
    return this.bdl_1(value, $completion);
  };
  protoOf(sam$kotlinx_coroutines_flow_FlowCollector$0_1).q3 = function () {
    return this.bdl_1;
  };
  protoOf(sam$kotlinx_coroutines_flow_FlowCollector$0_1).equals = function (other) {
    var tmp;
    if (!(other == null) ? isInterface(other, FlowCollector) : false) {
      var tmp_0;
      if (!(other == null) ? isInterface(other, FunctionAdapter) : false) {
        tmp_0 = equals(this.q3(), other.q3());
      } else {
        tmp_0 = false;
      }
      tmp = tmp_0;
    } else {
      tmp = false;
    }
    return tmp;
  };
  protoOf(sam$kotlinx_coroutines_flow_FlowCollector$0_1).hashCode = function () {
    return hashCode(this.q3());
  };
  function ComposeWindow$platformContext$1(this$0) {
    this.zdj_1 = this$0;
    this.sdj_1 = new Empty();
    this.tdj_1 = new DefaultInputModeManager();
    var tmp = this;
    tmp.udj_1 = new ComposeWindow$platformContext$1$dragAndDropManager$1(this$0);
    this.vdj_1 = new WebTextToolbar();
    var tmp_0 = this;
    var tmp_1;
    if (this$0.hdi_1.udh_1) {
      var tmp_2 = MainScope();
      var tmp0_safe_receiver = this$0.gdi_1;
      var tmp_3;
      if (tmp0_safe_receiver == null) {
        tmp_3 = null;
      } else {
        // Inline function 'kotlin.apply' call
        tmp0_safe_receiver.setAttribute('aria-label', '');
        tmp0_safe_receiver.setAttribute('role', 'presentation');
        tmp0_safe_receiver.setAttribute('aria-live', 'polite');
        tmp0_safe_receiver.id = 'cmp_a11y_root';
        tmp0_safe_receiver.style.opacity = '0';
        tmp0_safe_receiver.style.setProperty('pointer-events', 'none');
        tmp_3 = tmp0_safe_receiver;
      }
      var tmp1_elvis_lhs = tmp_3;
      var tmp_4;
      if (tmp1_elvis_lhs == null) {
        // Inline function 'kotlin.error' call
        var message = 'a11yContainerElement must be provided';
        throw IllegalStateException_init_$Create$(toString(message));
      } else {
        tmp_4 = tmp1_elvis_lhs;
      }
      tmp_1 = new ComposeWebSemanticsListener(tmp_2, tmp_4);
    } else {
      tmp_1 = null;
    }
    tmp_0.wdj_1 = tmp_1;
    var tmp_5 = this;
    tmp_5.xdj_1 = new ComposeWindow$platformContext$1$textInputService$1(this$0);
    var tmp_6 = this;
    tmp_6.ydj_1 = new ComposeWindow$platformContext$1$viewConfiguration$1(this$0);
  }
  protoOf(ComposeWindow$platformContext$1).hbm = function () {
    return this.zdj_1.mdi_1;
  };
  protoOf(ComposeWindow$platformContext$1).wct = function () {
    return this.zdj_1.ndi_1;
  };
  protoOf(ComposeWindow$platformContext$1).xbl = function () {
    return this.tdj_1;
  };
  protoOf(ComposeWindow$platformContext$1).b8z = function () {
    return this.udj_1;
  };
  protoOf(ComposeWindow$platformContext$1).pcp = function (localPosition) {
    return convertLocalToWindowPosition.call(this, localPosition);
  };
  protoOf(ComposeWindow$platformContext$1).qcq = function (positionInWindow) {
    return convertWindowToLocalPosition.call(this, positionInWindow);
  };
  protoOf(ComposeWindow$platformContext$1).bbm = function () {
    return this.vdj_1;
  };
  protoOf(ComposeWindow$platformContext$1).ncq = function () {
    return this.wdj_1;
  };
  protoOf(ComposeWindow$platformContext$1).fbm = function () {
    return this.xdj_1;
  };
  protoOf(ComposeWindow$platformContext$1).la7 = function () {
    return this.ydj_1;
  };
  protoOf(ComposeWindow$platformContext$1).vcq = function (pointerIcon) {
    if (pointerIcon instanceof BrowserCursor) {
      this.zdj_1.cdi_1.style.cursor = pointerIcon.cdc_1;
    }
  };
  protoOf(ComposeWindow$platformContext$1).hbp = function (request, $completion) {
    var tmp = new $startInputMethodCOROUTINE$_3(this, request, $completion);
    tmp.p9_1 = Unit_instance;
    tmp.q9_1 = null;
    return tmp.v9();
  };
  protoOf(ComposeWindow$platformContext$1).vcy = function () {
    return this.zdj_1.hdi_1.vdh_1;
  };
  protoOf(ComposeWindow$platformContext$1).yct = function () {
    return this.sdj_1.yct();
  };
  protoOf(ComposeWindow$platformContext$1).ucy = function () {
    return this.sdj_1.ucy();
  };
  protoOf(ComposeWindow$platformContext$1).ocp = function () {
    return this.sdj_1.ocp();
  };
  protoOf(ComposeWindow$platformContext$1).ncp = function (localPosition) {
    return this.sdj_1.ncp(localPosition);
  };
  protoOf(ComposeWindow$platformContext$1).rcq = function (positionOnScreen) {
    return this.sdj_1.rcq(positionOnScreen);
  };
  protoOf(ComposeWindow$platformContext$1).wcq = function () {
    return this.sdj_1.wcq();
  };
  protoOf(ComposeWindow$platformContext$1).n82 = function () {
    return this.sdj_1.n82();
  };
  protoOf(ComposeWindow$platformContext$1).qco = function () {
    return this.sdj_1.qco();
  };
  protoOf(ComposeWindow$platformContext$1).pco = function () {
    return this.sdj_1.pco();
  };
  protoOf(ComposeWindow$platformContext$1).ycp = function () {
    return this.sdj_1.ycp();
  };
  protoOf(ComposeWindow$platformContext$1).bcr = function (frameRate, frameRateCategory) {
    this.sdj_1.bcr(frameRate, frameRateCategory);
  };
  protoOf(ComposeWindow$platformContext$1).ocr = function () {
    return this.sdj_1.ocr();
  };
  function ComposeWindow$skiaLayer$lambda(this$0) {
    return function (canvas, _unused_var__etf5q3, _unused_var__etf5q3_0, nanoTime) {
      this$0.vdi_1.nd2(asComposeCanvas(canvas), nanoTime);
      return Unit_instance;
    };
  }
  function SkiaLayer$needRender$ref(p0) {
    return constructCallableReference(function () {
      p0.w69();
      return Unit_instance;
    }, 0, 0, 171, VOID, [p0]);
  }
  function ComposeWindow$addTypedEvent$lambda($handler) {
    return function (event) {
      $handler(event instanceof Event ? event : THROW_CCE());
      return Unit_instance;
    };
  }
  function ComposeWindow$addTypedEvent$lambda_0($handler) {
    return function (event) {
      $handler(event instanceof Event ? event : THROW_CCE());
      return Unit_instance;
    };
  }
  function ComposeWindow$initEvents$lambda(this$0) {
    return function (it) {
      onPointerEvent_0(this$0, it);
      return Unit_instance;
    };
  }
  function ComposeWindow$initEvents$lambda_0(this$0) {
    return function (it) {
      this$0.kdi_1 = null;
      return Unit_instance;
    };
  }
  function ComposeWindow$initEvents$lambda_1(this$0) {
    return function (evt) {
      var tmp = this$0.tdi_1.fbm();
      var backingInput = (tmp instanceof WebTextInputService ? tmp : THROW_CCE()).cde();
      var tmp_0;
      if ((backingInput == null ? null : isFocused(backingInput)) === true) {
        evt.preventDefault();
        tmp_0 = Unit_instance;
      }
      return Unit_instance;
    };
  }
  function ComposeWindow$initEvents$lambda_2(this$0) {
    return function (event) {
      onWheelEvent(this$0, event);
      return Unit_instance;
    };
  }
  function ComposeWindow$initEvents$lambda_3(event) {
    event.preventDefault();
    return Unit_instance;
  }
  function ComposeWindow$initEvents$lambda_4(this$0) {
    return function (event) {
      processKeyboardEvent(this$0, event);
      return Unit_instance;
    };
  }
  function ComposeWindow$initEvents$lambda_5(this$0) {
    return function (event) {
      processKeyboardEvent(this$0, event);
      return Unit_instance;
    };
  }
  function ComposeWindow$initEvents$lambda_6(this$0) {
    return function (event) {
      this$0.ydi_1 = true;
      return Unit_instance;
    };
  }
  function ComposeWindow$initEvents$lambda_7(this$0) {
    return function (event) {
      this$0.ydi_1 = false;
      return Unit_instance;
    };
  }
  function ComposeWindow$initEvents$lambda_8(this$0) {
    return function (it) {
      this$0.ndi_1.pcz_1.y7n(Event_ON_RESUME_getInstance());
      return Unit_instance;
    };
  }
  function ComposeWindow$initEvents$lambda_9(this$0) {
    return function (it) {
      this$0.ndi_1.pcz_1.y7n(Event_ON_PAUSE_getInstance());
      return Unit_instance;
    };
  }
  function ComposeWindow$initEvents$lambda_10(this$0) {
    return function (event) {
      this$0.ndi_1.pcz_1.y7n(documentIsVisible() ? Event_ON_START_getInstance() : Event_ON_STOP_getInstance());
      return Unit_instance;
    };
  }
  function ComposeWindow$lambda(this$0) {
    return function () {
      var tmp = this$0.tdi_1.fbm();
      var tmp0_elvis_lhs = (tmp instanceof WebTextInputService ? tmp : THROW_CCE()).cde();
      return tmp0_elvis_lhs == null ? this$0.sdi_1 : tmp0_elvis_lhs;
    };
  }
  function ComposeWindow$lambda$lambda$lambda($content) {
    return function ($composer, $changed) {
      var $composer_0 = $composer;
      var tmp;
      if ($composer_0.r31(!(($changed & 3) === 2), $changed & 1)) {
        tmp = $content($composer_0, 0);
      } else {
        $composer_0.z30();
        tmp = Unit_instance;
      }
      return Unit_instance;
    };
  }
  function ComposeWindow$lambda$lambda$slambda(this$0, resultContinuation) {
    this.kdl_1 = this$0;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(ComposeWindow$lambda$lambda$slambda).p24 = function ($this$LaunchedEffect, $completion) {
    var tmp = this.q24($this$LaunchedEffect, $completion);
    tmp.p9_1 = Unit_instance;
    tmp.q9_1 = null;
    return tmp.v9();
  };
  protoOf(ComposeWindow$lambda$lambda$slambda).ja = function (p1, $completion) {
    return this.p24((!(p1 == null) ? isInterface(p1, CoroutineScope_0) : false) ? p1 : THROW_CCE(), $completion);
  };
  protoOf(ComposeWindow$lambda$lambda$slambda).v9 = function () {
    var suspendResult = this.p9_1;
    $sm: do
      try {
        var tmp = this.n9_1;
        switch (tmp) {
          case 0:
            this.o9_1 = 2;
            this.n9_1 = 1;
            var tmp_0 = this.kdl_1.idi_1.mdl();
            var tmp_1 = ComposeWindow$lambda$lambda$slambda$slambda_0(this.kdl_1, null);
            suspendResult = tmp_0.l1u(new sam$kotlinx_coroutines_flow_FlowCollector$0_1(tmp_1), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            return Unit_instance;
          case 2:
            throw this.q9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.o9_1 === 2) {
          throw e;
        } else {
          this.n9_1 = this.o9_1;
          this.q9_1 = e;
        }
      }
     while (true);
  };
  protoOf(ComposeWindow$lambda$lambda$slambda).q24 = function ($this$LaunchedEffect, completion) {
    var i = new ComposeWindow$lambda$lambda$slambda(this.kdl_1, completion);
    i.ldl_1 = $this$LaunchedEffect;
    return i;
  };
  function ComposeWindow$lambda$lambda$slambda_0(this$0, resultContinuation) {
    var i = new ComposeWindow$lambda$lambda$slambda(this$0, resultContinuation);
    return constructCallableReference(function ($this$LaunchedEffect, $completion) {
      return i.p24($this$LaunchedEffect, $completion);
    }, 1);
  }
  function ComposeWindow$lambda$lambda($interopContainer, this$0, $content) {
    return function ($composer, $changed) {
      var $composer_0 = $composer;
      var tmp;
      if ($composer_0.r31(!(($changed & 3) === 2), $changed & 1)) {
        // Inline function 'kotlin.run' call
        var dispatchReceiver = rememberComposableLambda(-1237755903, true, ComposeWindow$lambda$lambda$lambda($content), $composer_0, 54);
        // Inline function 'androidx.compose.runtime.remember' call
        var $composer_1 = $composer_0;
        // Inline function 'androidx.compose.runtime.cache' call
        var invalid = $composer_1.k31(dispatchReceiver);
        // Inline function 'kotlin.let' call
        var it = $composer_1.i31();
        var tmp_0;
        if (invalid || it === Companion_getInstance_9().f30_1) {
          var value = ComposableLambda$invoke$ref(dispatchReceiver);
          $composer_1.j31(value);
          tmp_0 = value;
        } else {
          tmp_0 = it;
        }
        var tmp$ret$0 = tmp_0;
        TrackInteropPlacementContainer($interopContainer, tmp$ret$0, $composer_0, 48);
        // Inline function 'androidx.compose.runtime.cache' call
        var invalid_0 = $composer_0.q31(this$0);
        // Inline function 'kotlin.let' call
        var it_0 = $composer_0.i31();
        var tmp_1;
        if (invalid_0 || it_0 === Companion_getInstance_9().f30_1) {
          var value_0 = ComposeWindow$lambda$lambda$slambda_0(this$0, null);
          $composer_0.j31(value_0);
          tmp_1 = value_0;
        } else {
          tmp_1 = it_0;
        }
        var tmp$ret$7 = tmp_1;
        LaunchedEffect_0(Unit_instance, tmp$ret$7, $composer_0, 6);
        tmp = Unit_instance;
      } else {
        $composer_0.z30();
        tmp = Unit_instance;
      }
      return Unit_instance;
    };
  }
  function ComposeWindow$lambda_0(this$0, $interopContainer, $clipEventsTargetProvider, $content) {
    return function ($composer, $changed) {
      var $composer_0 = $composer;
      var tmp;
      if ($composer_0.r31(!(($changed & 3) === 2), $changed & 1)) {
        var tmp_0 = [get_LocalSystemTheme().h3c(this$0.wdi_1.ndl().u1()), get_LocalInteropContainer().h3c($interopContainer), get_LocalActiveClipEventsTarget().h3c($clipEventsTargetProvider)];
        // Inline function 'kotlin.run' call
        var dispatchReceiver = rememberComposableLambda(525143580, true, ComposeWindow$lambda$lambda($interopContainer, this$0, $content), $composer_0, 54);
        // Inline function 'androidx.compose.runtime.remember' call
        var $composer_1 = $composer_0;
        // Inline function 'androidx.compose.runtime.cache' call
        var invalid = $composer_1.k31(dispatchReceiver);
        // Inline function 'kotlin.let' call
        var it = $composer_1.i31();
        var tmp_1;
        if (invalid || it === Companion_getInstance_9().f30_1) {
          var value = ComposableLambda$invoke$ref(dispatchReceiver);
          $composer_1.j31(value);
          tmp_1 = value;
        } else {
          tmp_1 = it;
        }
        var tmp$ret$0 = tmp_1;
        CompositionLocalProvider(tmp_0, tmp$ret$0, $composer_0, 48 | androidx_compose_runtime_ProvidedValue$stableprop_getter());
        tmp = Unit_instance;
      } else {
        $composer_0.z30();
        tmp = Unit_instance;
      }
      return Unit_instance;
    };
  }
  function ComposeWindow(canvas, rootNode, layerRoot, interopContainerElement, a11yContainerElement, configuration, content, state) {
    this.cdi_1 = canvas;
    this.ddi_1 = rootNode;
    this.edi_1 = layerRoot;
    this.fdi_1 = interopContainerElement;
    this.gdi_1 = a11yContainerElement;
    this.hdi_1 = configuration;
    this.idi_1 = state;
    this.jdi_1 = false;
    this.kdi_1 = null;
    this.ldi_1 = Density_0(get_actualDensity(), 1.0);
    var tmp = this;
    // Inline function 'kotlin.apply' call
    var this_0 = new WindowInfoImpl();
    this_0.gbr(true);
    tmp.mdi_1 = this_0;
    this.ndi_1 = new DefaultArchitectureComponentsOwner();
    this.odi_1 = new BackNavigationEventInput();
    this.pdi_1 = new EventTargetListener(this.cdi_1);
    this.qdi_1 = Hardware_instance;
    this.rdi_1 = null;
    this.sdi_1 = clipTargetElement(this.cdi_1);
    var tmp_0 = this;
    tmp_0.tdi_1 = new ComposeWindow$platformContext$1(this);
    var tmp_1 = this;
    // Inline function 'kotlin.apply' call
    var this_1 = new SkiaLayer();
    var tmp_2 = this_1;
    var tmp_3 = ComposeWindow$skiaLayer$lambda(this);
    tmp_2.k69_1 = new sam$org_jetbrains_skiko_SkikoRenderDelegate$0(tmp_3);
    tmp_1.udi_1 = this_1;
    var tmp_4 = this;
    var tmp0_coroutineContext = Dispatchers_getInstance().m1h();
    var tmp1_platformContext = this.tdi_1;
    var tmp2_density = this.ldi_1;
    var tmp3_invalidate = SkiaLayer$needRender$ref(this.udi_1);
    tmp_4.vdi_1 = CanvasLayersComposeScene(tmp2_density, VOID, VOID, tmp0_coroutineContext, tmp1_platformContext, tmp3_invalidate);
    this.wdi_1 = getSystemThemeObserver();
    this.xdi_1 = get_hostOs().l66();
    this.ydi_1 = false;
    initEvents_1(this, this.cdi_1);
    this.idi_1.odl();
    this.cdi_1.setAttribute('tabindex', '0');
    this.cdi_1.setAttribute('draggable', 'true');
    this.vdi_1.s6p(this.ldi_1);
    enableSavedStateHandles(this.ndi_1);
    var interopContainer = new WebInteropContainer(new InteropViewGroup(this.fdi_1));
    var clipEventsTargetProvider = ComposeWindow$lambda(this);
    this.vdi_1.k39(ComposableLambda$invoke$ref(composableLambdaInstance(-355018020, true, ComposeWindow$lambda_0(this, interopContainer, clipEventsTargetProvider, content))));
    this.ndi_1.pcz_1.y7n(document.hasFocus() ? Event_ON_RESUME_getInstance() : Event_ON_START_getInstance());
    this.ndi_1.acu().rcz_1.z8n(this.odi_1);
    this.zdi_1 = mutableIntObjectMapOf();
    var tmp_5 = this;
    // Inline function 'kotlin.collections.mutableListOf' call
    tmp_5.adj_1 = ArrayList_init_$Create$();
  }
  function getParentContainerBox($this) {
    var tmp0 = $this.pdl_1.clientWidth;
    // Inline function 'androidx.compose.ui.unit.IntSize' call
    // Inline function 'androidx.compose.ui.util.packInts' call
    var val2 = $this.pdl_1.clientHeight;
    var tmp$ret$1 = bitwiseOr(shiftLeft(fromInt(tmp0), 32), bitwiseAnd(fromInt(val2), new Long(-1, 0)));
    return _IntSize___init__impl__emcjft(tmp$ret$1);
  }
  function initMediaEventListener($this, handler) {
    var contentScale = get_actualDensity();
    var tmp = window.matchMedia('(resolution: ' + contentScale + 'dppx)');
    var tmp_0 = DefaultWindowState$initMediaEventListener$lambda(handler, contentScale, $this);
    // Inline function 'org.w3c.dom.AddEventListenerOptions' call
    var o = {};
    o['passive'] = false;
    o['once'] = true;
    o['capture'] = true;
    var tmp$ret$0 = (!(o == null) ? !(o == null) : false) ? o : THROW_CCE();
    tmp.addEventListener('change', tmp_0, tmp$ret$0);
  }
  function DefaultWindowState$init$lambda(this$0) {
    return function (it) {
      this$0.qdl_1.s1s(new IntSize(getParentContainerBox(this$0)));
      return Unit_instance;
    };
  }
  function DefaultWindowState$init$lambda_0(this$0) {
    return function (it) {
      this$0.qdl_1.s1s(new IntSize(getParentContainerBox(this$0)));
      return Unit_instance;
    };
  }
  function DefaultWindowState$initMediaEventListener$lambda($handler, $contentScale, this$0) {
    return function (evt) {
      if (!(evt instanceof MediaQueryListEvent))
        THROW_CCE();
      var tmp;
      if (!evt.matches) {
        tmp = $handler($contentScale);
      }
      initMediaEventListener(this$0, $handler);
      return Unit_instance;
    };
  }
  function DefaultWindowState(viewportContainer) {
    this.pdl_1 = viewportContainer;
    this.qdl_1 = Channel(-1);
    this.rdl_1 = new EventTargetListener(window);
  }
  protoOf(DefaultWindowState).bdj = function () {
    return this.rdl_1;
  };
  protoOf(DefaultWindowState).odl = function () {
    this.rdl_1.zdb('resize', DefaultWindowState$init$lambda(this));
    initMediaEventListener(this, DefaultWindowState$init$lambda_0(this));
    this.qdl_1.s1s(new IntSize(getParentContainerBox(this)));
  };
  protoOf(DefaultWindowState).mdl = function () {
    return receiveAsFlow(this.qdl_1);
  };
  function ComposeWindowState() {
  }
  function get_actualDensity() {
    return window.devicePixelRatio;
  }
  function Virtual() {
  }
  var Virtual_instance;
  function Virtual_getInstance() {
    return Virtual_instance;
  }
  function Hardware() {
  }
  var Hardware_instance;
  function Hardware_getInstance() {
    return Hardware_instance;
  }
  function clipTargetElement(canvas) {
    var tmp = document.createElement('textarea');
    // Inline function 'kotlin.apply' call
    var this_0 = tmp instanceof HTMLTextAreaElement ? tmp : THROW_CCE();
    this_0.tabIndex = -1;
    this_0.setAttribute('aria-hidden', 'true');
    this_0.style.position = 'fixed';
    this_0.style.left = '-1000px';
    this_0.style.top = '0';
    this_0.style.opacity = '0';
    this_0.style.width = '1px';
    this_0.style.height = '1px';
    var clipTarget = this_0;
    var clipEventListener = clipTargetElement$lambda(canvas, clipTarget);
    clipTarget.addEventListener('copy', clipEventListener);
    clipTarget.addEventListener('cut', clipEventListener);
    clipTarget.addEventListener('paste', clipEventListener);
    return clipTarget;
  }
  function isFocused(_this__u8e3s4) {
    var tmp;
    var tmp2_safe_receiver = document.activeElement;
    if (!((tmp2_safe_receiver == null ? null : tmp2_safe_receiver.shadowRoot) == null)) {
      var tmp0_safe_receiver = document.activeElement;
      var tmp_0 = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.shadowRoot;
      var tmp1_safe_receiver = (!(tmp_0 == null) ? !(tmp_0 == null) : false) ? tmp_0 : null;
      tmp = tmp1_safe_receiver == null ? null : tmp1_safe_receiver.activeElement;
    } else {
      tmp = document.activeElement;
    }
    var activeElement = tmp;
    if (activeElement == null) {
      return false;
    }
    return equals(activeElement, _this__u8e3s4);
  }
  function documentIsVisible() {
    return document.visibilityState === 'visible';
  }
  function toScenePointerEvent(_this__u8e3s4, containerOffset, density, pointerType) {
    pointerType = pointerType === VOID ? Companion_getInstance_42().ma2_1 : pointerType;
    var event = _this__u8e3s4;
    var type = getPointerEventType(event);
    var tmp = event.clientX;
    // Inline function 'androidx.compose.ui.geometry.Offset.x' call
    // Inline function 'androidx.compose.ui.util.unpackFloat1' call
    var value = _Offset___get_packedValue__impl__xh2k8q(containerOffset);
    // Inline function 'androidx.compose.ui.util.floatFromBits' call
    // Inline function 'kotlin.fromBits' call
    var bits = convertToInt(shiftRight(value, 32));
    var tmp0 = (tmp - floatFromBits(bits)) * density.u5e();
    var tmp_0 = event.clientY;
    // Inline function 'androidx.compose.ui.geometry.Offset.y' call
    // Inline function 'androidx.compose.ui.util.unpackFloat2' call
    var value_0 = _Offset___get_packedValue__impl__xh2k8q(containerOffset);
    // Inline function 'androidx.compose.ui.util.floatFromBits' call
    // Inline function 'kotlin.fromBits' call
    var bits_0 = convertToInt(bitwiseAnd(value_0, new Long(-1, 0)));
    // Inline function 'androidx.compose.ui.geometry.Offset' call
    // Inline function 'androidx.compose.ui.util.packFloats' call
    var val2 = (tmp_0 - floatFromBits(bits_0)) * density.u5e();
    var v1 = fromInt(toRawBits(tmp0));
    var v2 = fromInt(toRawBits(val2));
    var tmp$ret$9 = bitwiseOr(shiftLeft(v1, 32), bitwiseAnd(v2, new Long(-1, 0)));
    var position = _Offset___init__impl__c168vi(tmp$ret$9);
    return new ComposeScenePointer(_PointerId___init__impl__w2urwh(fromInt(event.pointerId)), position, type === Companion_getInstance_41().la1_1 || type === Companion_getInstance_41().na1_1, pointerType, event.pressure);
  }
  function getPointerEventType(_this__u8e3s4) {
    var tmp0_subject = getPointerEventCode(_this__u8e3s4);
    return tmp0_subject === _PointerEventType___get_value__impl__teq1fm(Companion_getInstance_41().la1_1) ? Companion_getInstance_41().la1_1 : tmp0_subject === _PointerEventType___get_value__impl__teq1fm(Companion_getInstance_41().ma1_1) ? Companion_getInstance_41().ma1_1 : tmp0_subject === _PointerEventType___get_value__impl__teq1fm(Companion_getInstance_41().na1_1) ? Companion_getInstance_41().na1_1 : tmp0_subject === _PointerEventType___get_value__impl__teq1fm(Companion_getInstance_41().oa1_1) ? Companion_getInstance_41().oa1_1 : tmp0_subject === _PointerEventType___get_value__impl__teq1fm(Companion_getInstance_41().pa1_1) ? Companion_getInstance_41().pa1_1 : Companion_getInstance_41().ka1_1;
  }
  function isMouseEvent(event) {
    return event.pointerType === 'mouse';
  }
  function setPointerCapture(target, pointerId) {
    try {
      target.setPointerCapture(pointerId);
    } catch (e) {
    }
  }
  function getCoalescedEvents(pointerEvent) {
    return pointerEvent.getCoalescedEvents ? pointerEvent.getCoalescedEvents() : [];
  }
  function getPointerEventCode(event) {
    return function () {
      switch (event.type) {
        case 'pointerdown':
          return 1; // PointerEventType.Press

        case 'pointerup':
        case 'pointercancel':
          return 2; // PointerEventType.Release

        case 'pointermove':
          return 3; // PointerEventType.Move

        case 'pointerenter':
          return 4; //PointerEventType.Enter

        case 'pointerleave':
          return 5; //PointerEventType.Exit

        default:
          return 0; // PointerEventType.Unknown

      }
      return void 3;
    }();
  }
  function onDomReady$lambda($block) {
    return function (it) {
      $block();
      return Unit_instance;
    };
  }
  function onSkikoReady$lambda($block) {
    return function () {
      $block();
      return Unit_instance;
    };
  }
  function clipTargetElement$lambda$lambda($canvas, $clipTarget) {
    return function (it) {
      focusExt($canvas, true);
      $clipTarget.remove();
      return Unit_instance;
    };
  }
  function clipTargetElement$lambda($canvas, $clipTarget) {
    return function (_unused_var__etf5q3) {
      var tmp = window;
      tmp.requestAnimationFrame(clipTargetElement$lambda$lambda($canvas, $clipTarget));
      return Unit_instance;
    };
  }
  var androidx_compose_ui_window_SystemThemeObserverImpl$stable;
  function getSystemThemeObserver() {
    return new SystemThemeObserverImpl(window);
  }
  function _get_media__ebgb6b($this) {
    var tmp0 = $this.sdl_1;
    var tmp = KProperty1;
    // Inline function 'kotlin.getValue' call
    getPropertyCallableRef('media', 1, tmp, SystemThemeObserverImpl$_get_media_$ref_tr43bs(), null);
    return tmp0.u1();
  }
  function SystemThemeObserverImpl$media$delegate$lambda($window) {
    return function () {
      return $window.matchMedia('(prefers-color-scheme: dark)');
    };
  }
  function SystemThemeObserverImpl$_get_media_$ref_tr43bs() {
    return constructCallableReference(function (p0) {
      return _get_media__ebgb6b(p0);
    }, 1, 0, 172);
  }
  function SystemThemeObserverImpl$listener$lambda(this$0) {
    return function (event) {
      var tmp;
      if ((event instanceof MediaQueryListEvent ? event : THROW_CCE()).matches) {
        tmp = SystemTheme_Dark_getInstance();
      } else {
        tmp = SystemTheme_Light_getInstance();
      }
      this$0.tdl_1.s21(tmp);
      return Unit_instance;
    };
  }
  function SystemThemeObserverImpl(window_0) {
    var tmp = this;
    tmp.sdl_1 = lazy_0(SystemThemeObserverImpl$media$delegate$lambda(window_0));
    this.tdl_1 = mutableStateOf(!isMatchMediaSupported() ? SystemTheme_Unknown_getInstance() : _get_media__ebgb6b(this).matches ? SystemTheme_Dark_getInstance() : SystemTheme_Light_getInstance());
    var tmp_0 = this;
    tmp_0.udl_1 = SystemThemeObserverImpl$listener$lambda(this);
    if (isMatchMediaSupported()) {
      try {
        _get_media__ebgb6b(this).addEventListener('change', this.udl_1);
      } catch ($p) {
        if ($p instanceof Error) {
          var t = $p;
          _get_media__ebgb6b(this).addListener(this.udl_1);
        } else {
          throw $p;
        }
      }
    }
  }
  protoOf(SystemThemeObserverImpl).ndl = function () {
    return this.tdl_1;
  };
  function isMatchMediaSupported() {
    return window.matchMedia != undefined;
  }
  function get_LocalActiveClipEventsTarget() {
    _init_properties_WebCompositionLocals_kt__62xwv6();
    return LocalActiveClipEventsTarget;
  }
  var LocalActiveClipEventsTarget;
  function LocalActiveClipEventsTarget$lambda() {
    _init_properties_WebCompositionLocals_kt__62xwv6();
    return LocalActiveClipEventsTarget$lambda$lambda;
  }
  function LocalActiveClipEventsTarget$lambda$lambda() {
    _init_properties_WebCompositionLocals_kt__62xwv6();
    return null;
  }
  var properties_initialized_WebCompositionLocals_kt_nkoxmo;
  function _init_properties_WebCompositionLocals_kt__62xwv6() {
    if (!properties_initialized_WebCompositionLocals_kt_nkoxmo) {
      properties_initialized_WebCompositionLocals_kt_nkoxmo = true;
      LocalActiveClipEventsTarget = staticCompositionLocalOf(LocalActiveClipEventsTarget$lambda);
    }
  }
  var androidx_compose_ui_window_WebTextInputSession$stable;
  function WebTextInputSession$startInputMethod$slambda$slambda$lambda($request) {
    return function () {
      return $request.u1()();
    };
  }
  function WebTextInputSession$startInputMethod$slambda$slambda$slambda(this$0, resultContinuation) {
    this.ddm_1 = this$0;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(WebTextInputSession$startInputMethod$slambda$slambda$slambda).fdm = function (it, $completion) {
    var tmp = this.gdm(it, $completion);
    tmp.p9_1 = Unit_instance;
    tmp.q9_1 = null;
    return tmp.v9();
  };
  protoOf(WebTextInputSession$startInputMethod$slambda$slambda$slambda).ja = function (p1, $completion) {
    return this.fdm(p1 instanceof TextFieldValue ? p1 : THROW_CCE(), $completion);
  };
  protoOf(WebTextInputSession$startInputMethod$slambda$slambda$slambda).v9 = function () {
    var suspendResult = this.p9_1;
    $sm: do
      try {
        var tmp = this.n9_1;
        if (tmp === 0) {
          this.o9_1 = 1;
          this.ddm_1.bdk_1.l8d(null, this.edm_1);
          return Unit_instance;
        } else if (tmp === 1) {
          throw this.q9_1;
        }
      } catch ($p) {
        var e = $p;
        throw e;
      }
     while (true);
  };
  protoOf(WebTextInputSession$startInputMethod$slambda$slambda$slambda).gdm = function (it, completion) {
    var i = new WebTextInputSession$startInputMethod$slambda$slambda$slambda(this.ddm_1, completion);
    i.edm_1 = it;
    return i;
  };
  function WebTextInputSession$startInputMethod$slambda$slambda$slambda_0(this$0, resultContinuation) {
    var i = new WebTextInputSession$startInputMethod$slambda$slambda$slambda(this$0, resultContinuation);
    return constructCallableReference(function (it, $completion) {
      return i.fdm(it, $completion);
    }, 1);
  }
  function WebTextInputSession$startInputMethod$slambda$slambda$lambda_0($request) {
    return function () {
      return $request.hdm()();
    };
  }
  function WebTextInputSession$startInputMethod$slambda$slambda$slambda_1(this$0, resultContinuation) {
    this.qdm_1 = this$0;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(WebTextInputSession$startInputMethod$slambda$slambda$slambda_1).sdm = function (it, $completion) {
    var tmp = this.tdm(it, $completion);
    tmp.p9_1 = Unit_instance;
    tmp.q9_1 = null;
    return tmp.v9();
  };
  protoOf(WebTextInputSession$startInputMethod$slambda$slambda$slambda_1).ja = function (p1, $completion) {
    return this.sdm(p1 instanceof Rect ? p1 : THROW_CCE(), $completion);
  };
  protoOf(WebTextInputSession$startInputMethod$slambda$slambda$slambda_1).v9 = function () {
    var suspendResult = this.p9_1;
    $sm: do
      try {
        var tmp = this.n9_1;
        if (tmp === 0) {
          this.o9_1 = 1;
          if (!this.rdm_1.equals(Companion_getInstance_2().j5d_1)) {
            this.qdm_1.bdk_1.i8d(this.rdm_1);
          }
          return Unit_instance;
        } else if (tmp === 1) {
          throw this.q9_1;
        }
      } catch ($p) {
        var e = $p;
        throw e;
      }
     while (true);
  };
  protoOf(WebTextInputSession$startInputMethod$slambda$slambda$slambda_1).tdm = function (it, completion) {
    var i = new WebTextInputSession$startInputMethod$slambda$slambda$slambda_1(this.qdm_1, completion);
    i.rdm_1 = it;
    return i;
  };
  function WebTextInputSession$startInputMethod$slambda$slambda$slambda_2(this$0, resultContinuation) {
    var i = new WebTextInputSession$startInputMethod$slambda$slambda$slambda_1(this$0, resultContinuation);
    return constructCallableReference(function (it, $completion) {
      return i.sdm(it, $completion);
    }, 1);
  }
  function WebTextInputSession$startInputMethod$slambda$slambda($request, this$0, resultContinuation) {
    this.cdn_1 = $request;
    this.ddn_1 = this$0;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(WebTextInputSession$startInputMethod$slambda$slambda).p24 = function ($this$launch, $completion) {
    var tmp = this.q24($this$launch, $completion);
    tmp.p9_1 = Unit_instance;
    tmp.q9_1 = null;
    return tmp.v9();
  };
  protoOf(WebTextInputSession$startInputMethod$slambda$slambda).ja = function (p1, $completion) {
    return this.p24((!(p1 == null) ? isInterface(p1, CoroutineScope_0) : false) ? p1 : THROW_CCE(), $completion);
  };
  protoOf(WebTextInputSession$startInputMethod$slambda$slambda).v9 = function () {
    var suspendResult = this.p9_1;
    $sm: do
      try {
        var tmp = this.n9_1;
        switch (tmp) {
          case 0:
            this.o9_1 = 2;
            this.n9_1 = 1;
            var tmp_0 = snapshotFlow(WebTextInputSession$startInputMethod$slambda$slambda$lambda(this.cdn_1));
            var tmp_1 = WebTextInputSession$startInputMethod$slambda$slambda$slambda_0(this.ddn_1, null);
            suspendResult = tmp_0.l1u(new sam$kotlinx_coroutines_flow_FlowCollector$0_2(tmp_1), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            return Unit_instance;
          case 2:
            throw this.q9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.o9_1 === 2) {
          throw e;
        } else {
          this.n9_1 = this.o9_1;
          this.q9_1 = e;
        }
      }
     while (true);
  };
  protoOf(WebTextInputSession$startInputMethod$slambda$slambda).q24 = function ($this$launch, completion) {
    var i = new WebTextInputSession$startInputMethod$slambda$slambda(this.cdn_1, this.ddn_1, completion);
    i.edn_1 = $this$launch;
    return i;
  };
  function WebTextInputSession$startInputMethod$slambda$slambda_0($request, this$0, resultContinuation) {
    var i = new WebTextInputSession$startInputMethod$slambda$slambda($request, this$0, resultContinuation);
    return constructCallableReference(function ($this$launch, $completion) {
      return i.p24($this$launch, $completion);
    }, 1);
  }
  function WebTextInputSession$startInputMethod$slambda$slambda_1($request, this$0, resultContinuation) {
    this.ndn_1 = $request;
    this.odn_1 = this$0;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(WebTextInputSession$startInputMethod$slambda$slambda_1).p24 = function ($this$launch, $completion) {
    var tmp = this.q24($this$launch, $completion);
    tmp.p9_1 = Unit_instance;
    tmp.q9_1 = null;
    return tmp.v9();
  };
  protoOf(WebTextInputSession$startInputMethod$slambda$slambda_1).ja = function (p1, $completion) {
    return this.p24((!(p1 == null) ? isInterface(p1, CoroutineScope_0) : false) ? p1 : THROW_CCE(), $completion);
  };
  protoOf(WebTextInputSession$startInputMethod$slambda$slambda_1).v9 = function () {
    var suspendResult = this.p9_1;
    $sm: do
      try {
        var tmp = this.n9_1;
        switch (tmp) {
          case 0:
            this.o9_1 = 2;
            this.n9_1 = 1;
            var tmp_0 = filterNotNull(snapshotFlow(WebTextInputSession$startInputMethod$slambda$slambda$lambda_0(this.ndn_1)));
            var tmp_1 = WebTextInputSession$startInputMethod$slambda$slambda$slambda_2(this.odn_1, null);
            suspendResult = tmp_0.l1u(new sam$kotlinx_coroutines_flow_FlowCollector$0_2(tmp_1), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            return Unit_instance;
          case 2:
            throw this.q9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.o9_1 === 2) {
          throw e;
        } else {
          this.n9_1 = this.o9_1;
          this.q9_1 = e;
        }
      }
     while (true);
  };
  protoOf(WebTextInputSession$startInputMethod$slambda$slambda_1).q24 = function ($this$launch, completion) {
    var i = new WebTextInputSession$startInputMethod$slambda$slambda_1(this.ndn_1, this.odn_1, completion);
    i.pdn_1 = $this$launch;
    return i;
  };
  function WebTextInputSession$startInputMethod$slambda$slambda_2($request, this$0, resultContinuation) {
    var i = new WebTextInputSession$startInputMethod$slambda$slambda_1($request, this$0, resultContinuation);
    return constructCallableReference(function ($this$launch, $completion) {
      return i.p24($this$launch, $completion);
    }, 1);
  }
  function WebTextInputSession$startInputMethod$slambda$lambda(this$0) {
    return function (it) {
      this$0.bdk_1.d8d();
      return Unit_instance;
    };
  }
  function sam$kotlinx_coroutines_flow_FlowCollector$0_2(function_0) {
    this.qdn_1 = function_0;
  }
  protoOf(sam$kotlinx_coroutines_flow_FlowCollector$0_2).a1v = function (value, $completion) {
    return this.qdn_1(value, $completion);
  };
  protoOf(sam$kotlinx_coroutines_flow_FlowCollector$0_2).q3 = function () {
    return this.qdn_1;
  };
  protoOf(sam$kotlinx_coroutines_flow_FlowCollector$0_2).equals = function (other) {
    var tmp;
    if (!(other == null) ? isInterface(other, FlowCollector) : false) {
      var tmp_0;
      if (!(other == null) ? isInterface(other, FunctionAdapter) : false) {
        tmp_0 = equals(this.q3(), other.q3());
      } else {
        tmp_0 = false;
      }
      tmp = tmp_0;
    } else {
      tmp = false;
    }
    return tmp;
  };
  protoOf(sam$kotlinx_coroutines_flow_FlowCollector$0_2).hashCode = function () {
    return hashCode(this.q3());
  };
  function WebTextInputSession$startInputMethod$slambda(this$0, $request, resultContinuation) {
    this.zdn_1 = this$0;
    this.ado_1 = $request;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(WebTextInputSession$startInputMethod$slambda).rcm = function ($this$coroutineScope, $completion) {
    var tmp = this.q24($this$coroutineScope, $completion);
    tmp.p9_1 = Unit_instance;
    tmp.q9_1 = null;
    return tmp.v9();
  };
  protoOf(WebTextInputSession$startInputMethod$slambda).ja = function (p1, $completion) {
    return this.rcm((!(p1 == null) ? isInterface(p1, CoroutineScope_0) : false) ? p1 : THROW_CCE(), $completion);
  };
  protoOf(WebTextInputSession$startInputMethod$slambda).v9 = function () {
    var suspendResult = this.p9_1;
    $sm: do
      try {
        var tmp = this.n9_1;
        switch (tmp) {
          case 0:
            this.o9_1 = 2;
            launch(this.bdo_1, VOID, VOID, WebTextInputSession$startInputMethod$slambda$slambda_0(this.ado_1, this.zdn_1, null));
            launch(this.bdo_1, VOID, VOID, WebTextInputSession$startInputMethod$slambda$slambda_2(this.ado_1, this.zdn_1, null));
            this.n9_1 = 1;
            var cancellable = new CancellableContinuationImpl(intercepted(this), 1);
            cancellable.v1e();
            this.zdn_1.bdk_1.ade(this.ado_1, this.ado_1.cdo());
            cancellable.f1d(WebTextInputSession$startInputMethod$slambda$lambda(this.zdn_1));
            suspendResult = returnIfSuspended(cancellable.x1b(), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            return Unit_instance;
          case 2:
            throw this.q9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.o9_1 === 2) {
          throw e;
        } else {
          this.n9_1 = this.o9_1;
          this.q9_1 = e;
        }
      }
     while (true);
  };
  protoOf(WebTextInputSession$startInputMethod$slambda).q24 = function ($this$coroutineScope, completion) {
    var i = new WebTextInputSession$startInputMethod$slambda(this.zdn_1, this.ado_1, completion);
    i.bdo_1 = $this$coroutineScope;
    return i;
  };
  function WebTextInputSession$startInputMethod$slambda_0(this$0, $request, resultContinuation) {
    var i = new WebTextInputSession$startInputMethod$slambda(this$0, $request, resultContinuation);
    return constructCallableReference(function ($this$coroutineScope, $completion) {
      return i.rcm($this$coroutineScope, $completion);
    }, 1);
  }
  function $startInputMethodCOROUTINE$_4(_this__u8e3s4, request, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.ldo_1 = _this__u8e3s4;
    this.mdo_1 = request;
  }
  protoOf($startInputMethodCOROUTINE$_4).v9 = function () {
    var suspendResult = this.p9_1;
    $sm: do
      try {
        var tmp = this.n9_1;
        switch (tmp) {
          case 0:
            this.o9_1 = 2;
            this.n9_1 = 1;
            suspendResult = coroutineScope(WebTextInputSession$startInputMethod$slambda_0(this.ldo_1, this.mdo_1, null), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            return throwKotlinNothingValueException();
          case 2:
            throw this.q9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.o9_1 === 2) {
          throw e;
        } else {
          this.n9_1 = this.o9_1;
          this.q9_1 = e;
        }
      }
     while (true);
  };
  function WebTextInputSession(coroutineScope, webTextInputService) {
    this.adk_1 = coroutineScope;
    this.bdk_1 = webTextInputService;
  }
  protoOf(WebTextInputSession).hbp = function (request, $completion) {
    var tmp = new $startInputMethodCOROUTINE$_4(this, request, $completion);
    tmp.p9_1 = Unit_instance;
    tmp.q9_1 = null;
    return tmp.v9();
  };
  protoOf(WebTextInputSession).q19 = function () {
    return this.adk_1.q19();
  };
  //region block: post-declaration
  protoOf(ComposedModifier).h8v = foldIn;
  protoOf(ComposedModifier).i8v = all;
  protoOf(ComposedModifier).d8v = then;
  protoOf(Node).n8w = onDensityChange;
  protoOf(Node).o8w = onLayoutDirectionChange;
  protoOf(CombinedModifier).d8v = then;
  protoOf(ModifierNodeElement).h8v = foldIn;
  protoOf(ModifierNodeElement).i8v = all;
  protoOf(ModifierNodeElement).d8v = then;
  protoOf(ZIndexNode).o8y = minIntrinsicWidth;
  protoOf(ZIndexNode).p8y = minIntrinsicHeight;
  protoOf(ZIndexNode).q8y = maxIntrinsicWidth;
  protoOf(ZIndexNode).r8y = maxIntrinsicHeight;
  protoOf(DragAndDropNode).x91 = onPlaced;
  protoOf(CacheDrawScope).v5e = toPx;
  protoOf(CacheDrawScope).x5e = toPx_0;
  protoOf(CacheDrawScope).w5e = roundToPx;
  protoOf(CacheDrawScope).c5f = roundToPx_0;
  protoOf(CacheDrawScope).d5f = toDp;
  protoOf(CacheDrawScope).e5f = toDp_0;
  protoOf(CacheDrawScope).b5f = toDp_1;
  protoOf(CacheDrawScope).f5f = toSize_0;
  protoOf(CacheDrawScope).g5f = toDpSize;
  protoOf(DrawBackgroundModifier).v95 = onMeasureResultChanged;
  protoOf(DrawWithContentModifier).v95 = onMeasureResultChanged;
  protoOf(PainterNode).v95 = onMeasureResultChanged;
  protoOf(FocusOwnerImpl).e9d = clearFocus$default;
  protoOf(FocusOwnerImpl).n9d = dispatchKeyEvent$default;
  protoOf(FocusTargetNode).o9h = requestFocus$default;
  protoOf(FocusTargetNode).u91 = onRemeasured;
  protoOf(FocusTargetNode).y9h = get_providedValues;
  protoOf(BlockGraphicsLayerModifier).o8y = minIntrinsicWidth;
  protoOf(BlockGraphicsLayerModifier).p8y = minIntrinsicHeight;
  protoOf(BlockGraphicsLayerModifier).q8y = maxIntrinsicWidth;
  protoOf(BlockGraphicsLayerModifier).r8y = maxIntrinsicHeight;
  protoOf(BlockGraphicsLayerModifier).k9j = get_shouldClearDescendantSemantics;
  protoOf(BlockGraphicsLayerModifier).l9j = get_shouldMergeDescendantSemantics;
  protoOf(SimpleGraphicsLayerModifier).o8y = minIntrinsicWidth;
  protoOf(SimpleGraphicsLayerModifier).p8y = minIntrinsicHeight;
  protoOf(SimpleGraphicsLayerModifier).q8y = maxIntrinsicWidth;
  protoOf(SimpleGraphicsLayerModifier).r8y = maxIntrinsicHeight;
  protoOf(SimpleGraphicsLayerModifier).k9j = get_shouldClearDescendantSemantics;
  protoOf(SimpleGraphicsLayerModifier).l9j = get_shouldMergeDescendantSemantics;
  protoOf(ReusableGraphicsLayerScope).v5e = toPx;
  protoOf(ReusableGraphicsLayerScope).x5e = toPx_0;
  protoOf(ReusableGraphicsLayerScope).w5e = roundToPx;
  protoOf(ReusableGraphicsLayerScope).c5f = roundToPx_0;
  protoOf(ReusableGraphicsLayerScope).d5f = toDp;
  protoOf(ReusableGraphicsLayerScope).e5f = toDp_0;
  protoOf(ReusableGraphicsLayerScope).b5f = toDp_1;
  protoOf(ReusableGraphicsLayerScope).f5f = toSize_0;
  protoOf(ReusableGraphicsLayerScope).g5f = toDpSize;
  protoOf(HoverIconModifierNode).n8w = onDensityChange_0;
  protoOf(HoverIconModifierNode).fa5 = interceptOutOfBoundsChildEvents;
  protoOf(HoverIconModifierNode).ga5 = sharePointerInputWithSiblings;
  protoOf(HoverIconModifierNode).ha5 = onViewConfigurationChange;
  protoOf(PointerEventHandlerCoroutine).qa7 = awaitPointerEvent$default;
  protoOf(SuspendingPointerInputModifierNodeImpl).fa5 = interceptOutOfBoundsChildEvents;
  protoOf(SuspendingPointerInputModifierNodeImpl).ga5 = sharePointerInputWithSiblings;
  protoOf(SuspendingPointerInputModifierNodeImpl).ea5 = get_touchBoundsExpansion;
  protoOf(SuspendingPointerInputModifierNodeImpl).v5e = toPx;
  protoOf(SuspendingPointerInputModifierNodeImpl).x5e = toPx_0;
  protoOf(SuspendingPointerInputModifierNodeImpl).w5e = roundToPx;
  protoOf(SuspendingPointerInputModifierNodeImpl).c5f = roundToPx_0;
  protoOf(SuspendingPointerInputModifierNodeImpl).d5f = toDp;
  protoOf(SuspendingPointerInputModifierNodeImpl).e5f = toDp_0;
  protoOf(SuspendingPointerInputModifierNodeImpl).b5f = toDp_1;
  protoOf(SuspendingPointerInputModifierNodeImpl).f5f = toSize_0;
  protoOf(SuspendingPointerInputModifierNodeImpl).g5f = toDpSize;
  protoOf(ApproachMeasureScopeImpl).iag = layout$default_0;
  protoOf(ApproachMeasureScopeImpl).n8y = layout$default;
  protoOf(IntrinsicsMeasureScope).iag = layout$default_0;
  protoOf(IntrinsicsMeasureScope).kag = layout;
  protoOf(IntrinsicsMeasureScope).n8y = layout$default;
  protoOf(ApproachIntrinsicsMeasureScope).iag = layout$default_0;
  protoOf(ApproachIntrinsicsMeasureScope).kag = layout;
  protoOf(ApproachIntrinsicsMeasureScope).n8y = layout$default;
  protoOf(Placeable).xag = get_parentData;
  protoOf(LayoutModifierImpl).o8y = minIntrinsicWidth;
  protoOf(LayoutModifierImpl).p8y = minIntrinsicHeight;
  protoOf(LayoutModifierImpl).q8y = maxIntrinsicWidth;
  protoOf(LayoutModifierImpl).r8y = maxIntrinsicHeight;
  protoOf(LookaheadLayoutCoordinates).w9h = localPositionOf$default;
  protoOf(LookaheadLayoutCoordinates).fai = localBoundingBoxOf$default;
  protoOf(PlacementScope).v5e = toPx;
  protoOf(PlacementScope).x5e = toPx_0;
  protoOf(PlacementScope).w5e = roundToPx;
  protoOf(PlacementScope).c5f = roundToPx_0;
  protoOf(PlacementScope).d5f = toDp;
  protoOf(PlacementScope).e5f = toDp_0;
  protoOf(PlacementScope).b5f = toDp_1;
  protoOf(PlacementScope).f5f = toSize_0;
  protoOf(PlacementScope).g5f = toDpSize;
  protoOf(OnPlacedNode).u91 = onRemeasured;
  protoOf(Scope).iag = layout$default_0;
  protoOf(Scope).kag = layout;
  protoOf(Scope).n8y = layout$default;
  protoOf(Scope).v5e = toPx;
  protoOf(Scope).x5e = toPx_0;
  protoOf(Scope).w5e = roundToPx;
  protoOf(Scope).c5f = roundToPx_0;
  protoOf(Scope).d5f = toDp;
  protoOf(Scope).e5f = toDp_0;
  protoOf(Scope).b5f = toDp_1;
  protoOf(Scope).f5f = toSize_0;
  protoOf(Scope).g5f = toDpSize;
  protoOf(ApproachMeasureScopeImpl_0).n8y = layout$default;
  protoOf(ApproachMeasureScopeImpl_0).iag = layout$default_0;
  protoOf(LayoutNodeSubcompositionsState$createPrecomposedSlotHandle$1).law = get_placeablesCount;
  protoOf(LayoutNodeSubcompositionsState$createPrecomposedSlotHandle$1).maw = getSize;
  defineProp(protoOf(SubcomposeLayoutPausableCompositionException), 'message', function () {
    return this.e();
  });
  protoOf(BackwardsCompatNode).k9j = get_shouldClearDescendantSemantics;
  protoOf(BackwardsCompatNode).l9j = get_shouldMergeDescendantSemantics;
  protoOf(BackwardsCompatNode).k9i = get_isImportantForBounds;
  protoOf(BackwardsCompatNode).ha5 = onViewConfigurationChange;
  protoOf(BackwardsCompatNode).ea5 = get_touchBoundsExpansion;
  protoOf(LookaheadCapablePlaceable).iag = layout$default_0;
  protoOf(LookaheadCapablePlaceable).kag = layout;
  protoOf(LookaheadCapablePlaceable).n8y = layout$default;
  protoOf(LookaheadCapablePlaceable).v5e = toPx;
  protoOf(LookaheadCapablePlaceable).x5e = toPx_0;
  protoOf(LookaheadCapablePlaceable).w5e = roundToPx;
  protoOf(LookaheadCapablePlaceable).c5f = roundToPx_0;
  protoOf(LookaheadCapablePlaceable).d5f = toDp;
  protoOf(LookaheadCapablePlaceable).e5f = toDp_0;
  protoOf(LookaheadCapablePlaceable).b5f = toDp_1;
  protoOf(LookaheadCapablePlaceable).f5f = toSize_0;
  protoOf(LookaheadCapablePlaceable).g5f = toDpSize;
  protoOf(NodeCoordinator).w9h = localPositionOf$default;
  protoOf(NodeCoordinator).fai = localBoundingBoxOf$default;
  protoOf(LayoutNode$Companion$DummyViewConfiguration$1).vb9 = get_handwritingSlop;
  protoOf(LayoutNode$Companion$DummyViewConfiguration$1).wb9 = get_maximumFlingVelocity;
  protoOf(LayoutNodeDrawScope).o6q = record$default;
  protoOf(LayoutNodeDrawScope).x6p = drawLine$default;
  protoOf(LayoutNodeDrawScope).z6p = drawLine$default_0;
  protoOf(LayoutNodeDrawScope).a6q = drawRect$default;
  protoOf(LayoutNodeDrawScope).b6q = drawRect$default_0;
  protoOf(LayoutNodeDrawScope).d6q = drawImage$default;
  protoOf(LayoutNodeDrawScope).e6q = drawRoundRect$default;
  protoOf(LayoutNodeDrawScope).f6q = drawRoundRect$default_0;
  protoOf(LayoutNodeDrawScope).h6q = drawCircle$default;
  protoOf(LayoutNodeDrawScope).j6q = drawArc$default;
  protoOf(LayoutNodeDrawScope).k6q = drawPath$default;
  protoOf(LayoutNodeDrawScope).l6q = drawPath$default_0;
  protoOf(ResettableRulerScope).v5e = toPx;
  protoOf(ResettableRulerScope).x5e = toPx_0;
  protoOf(ResettableRulerScope).w5e = roundToPx;
  protoOf(ResettableRulerScope).c5f = roundToPx_0;
  protoOf(ResettableRulerScope).d5f = toDp;
  protoOf(ResettableRulerScope).e5f = toDp_0;
  protoOf(ResettableRulerScope).b5f = toDp_1;
  protoOf(ResettableRulerScope).f5f = toSize_0;
  protoOf(ResettableRulerScope).g5f = toDpSize;
  protoOf(NodeCoordinator$Companion$PointerInputSource$1).mbk = shouldHitTest;
  protoOf(CanFocusChecker).c1o = get_next;
  protoOf(CanFocusChecker).b9f = get_previous;
  protoOf(CanFocusChecker).c9f = get_up;
  protoOf(CanFocusChecker).d9f = get_down;
  protoOf(CanFocusChecker).e9f = get_left;
  protoOf(CanFocusChecker).x61 = get_right;
  protoOf(CanFocusChecker).e1 = get_start;
  protoOf(CanFocusChecker).f9f = get_end;
  protoOf(CanFocusChecker).g9f = get_onEnter;
  protoOf(CanFocusChecker).h9f = set_onExit;
  protoOf(CanFocusChecker).i9f = get_onExit;
  protoOf(CanFocusChecker).j9f = get_focusRect;
  protoOf(CoreSemanticsModifierNode).k9i = get_isImportantForBounds;
  protoOf(EmptySemanticsModifier).k9j = get_shouldClearDescendantSemantics;
  protoOf(EmptySemanticsModifier).l9j = get_shouldMergeDescendantSemantics;
  protoOf(EmptySemanticsModifier).k9i = get_isImportantForBounds;
  protoOf(SemanticsNode$fakeSemanticsNode$fakeNode$1).k9j = get_shouldClearDescendantSemantics;
  protoOf(SemanticsNode$fakeSemanticsNode$fakeNode$1).l9j = get_shouldMergeDescendantSemantics;
  protoOf(SemanticsNode$fakeSemanticsNode$fakeNode$1).k9i = get_isImportantForBounds;
  protoOf(sam$androidx_compose_ui_layout_MeasurePolicy$0).nak = minIntrinsicWidth_1;
  protoOf(sam$androidx_compose_ui_layout_MeasurePolicy$0).oak = minIntrinsicHeight_1;
  protoOf(sam$androidx_compose_ui_layout_MeasurePolicy$0).pak = maxIntrinsicWidth_1;
  protoOf(sam$androidx_compose_ui_layout_MeasurePolicy$0).qak = maxIntrinsicHeight_1;
  protoOf(sam$androidx_compose_ui_layout_MeasurePolicy$0_0).nak = minIntrinsicWidth_1;
  protoOf(sam$androidx_compose_ui_layout_MeasurePolicy$0_0).oak = minIntrinsicHeight_1;
  protoOf(sam$androidx_compose_ui_layout_MeasurePolicy$0_0).pak = maxIntrinsicWidth_1;
  protoOf(sam$androidx_compose_ui_layout_MeasurePolicy$0_0).qak = maxIntrinsicHeight_1;
  protoOf(RulerProviderModifierNode).o8y = minIntrinsicWidth;
  protoOf(RulerProviderModifierNode).p8y = minIntrinsicHeight;
  protoOf(RulerProviderModifierNode).q8y = maxIntrinsicWidth;
  protoOf(RulerProviderModifierNode).r8y = maxIntrinsicHeight;
  protoOf(RootNodeOwner$OwnerImpl$platformFocusOwner$1).o9d = focusTargetAvailable;
  protoOf(OwnerImpl).vbe = measureAndLayout$default;
  protoOf(OwnerImpl).obj = forceMeasureTheSubtree$default;
  protoOf(OwnerImpl).wbd = onRequestMeasure$default;
  protoOf(OwnerImpl).fbe = onRequestRelayout$default;
  protoOf(OwnerImpl).lbl = createLayer$default;
  protoOf(OwnerImpl).zbe = onPostLayoutNodeReused;
  protoOf(OwnerImpl).cbd = get_placementScope;
  protoOf(OwnerImpl).aas = get_outOfFrameExecutor;
  protoOf(OwnerImpl).pb1 = dispatchOnScrollChanged;
  protoOf(FlushCoroutineDispatcher).p1h = invokeOnTimeout;
  protoOf(Empty).yct = get_screenReader;
  protoOf(Empty).wct = get_architectureComponentsOwner;
  protoOf(Empty).ucy = get_isWindowTransparent;
  protoOf(Empty).ocp = get_hasNonTranslationComponents;
  protoOf(Empty).pcp = convertLocalToWindowPosition;
  protoOf(Empty).qcq = convertWindowToLocalPosition;
  protoOf(Empty).ncp = convertLocalToScreenPosition;
  protoOf(Empty).rcq = convertScreenToLocalPosition;
  protoOf(Empty).wcq = get_measureDrawLayerBounds;
  protoOf(Empty).n82 = get_localeList;
  protoOf(Empty).la7 = get_viewConfiguration;
  protoOf(Empty).fbm = get_textInputService;
  protoOf(Empty).hbp = startInputMethod;
  protoOf(Empty).bbm = get_textToolbar;
  protoOf(Empty).vcq = setPointerIcon;
  protoOf(Empty).qco = get_parentFocusManager;
  protoOf(Empty).pco = requestFocus;
  protoOf(Empty).b8z = get_dragAndDropManager;
  protoOf(Empty).ycp = get_windowInsets;
  protoOf(Empty).bcr = voteFrameRate_1;
  protoOf(Empty).ocr = get_rootForTestListener;
  protoOf(Empty).ncq = get_semanticsOwnerListener;
  protoOf(Empty).vcy = get_isClearFocusOnMouseDownEnabled;
  protoOf(DefaultViewConfiguration).vb9 = get_handwritingSlop;
  protoOf(DefaultViewConfiguration).eab = get_minimumTouchTargetSize;
  protoOf(DefaultViewConfiguration).wb9 = get_maximumFlingVelocity;
  protoOf(EmptyFocusManager).e9d = clearFocus$default;
  protoOf(EmptyPlatformTextInputService).b8d = startInput;
  protoOf(EmptyPlatformTextInputService).i8d = notifyFocusedRect;
  protoOf(EmptyPlatformTextInputService).k8d = updateTextLayoutResult;
  protoOf(EmptyTextToolbar).xbq = showMenu;
  protoOf(EmptyPlatformWindowInsets).uc8 = get_displayCutouts;
  protoOf(EmptyPlatformWindowInsets).lc8 = get_captionBar;
  protoOf(EmptyPlatformWindowInsets).mc8 = get_displayCutout;
  protoOf(EmptyPlatformWindowInsets).nc8 = get_ime;
  protoOf(EmptyPlatformWindowInsets).oc8 = get_mandatorySystemGestures;
  protoOf(EmptyPlatformWindowInsets).pc8 = get_navigationBars;
  protoOf(EmptyPlatformWindowInsets).qc8 = get_statusBars;
  protoOf(EmptyPlatformWindowInsets).xcz = get_systemBars;
  protoOf(EmptyPlatformWindowInsets).rc8 = get_systemGestures;
  protoOf(EmptyPlatformWindowInsets).sc8 = get_tappableElement;
  protoOf(EmptyPlatformWindowInsets).tc8 = get_waterfall;
  protoOf(EmptyPlatformWindowInsets).ycz = excluding;
  protoOf(BaseComposeScene).td2 = sendPointerEvent$default;
  protoOf(BaseComposeScene).wd2 = sendPointerEvent$default_0;
  protoOf(TrackInteropPlacementModifierNode).u91 = onRemeasured;
  protoOf(sam$androidx_compose_ui_layout_MeasurePolicy$0_1).nak = minIntrinsicWidth_1;
  protoOf(sam$androidx_compose_ui_layout_MeasurePolicy$0_1).oak = minIntrinsicHeight_1;
  protoOf(sam$androidx_compose_ui_layout_MeasurePolicy$0_1).pak = maxIntrinsicWidth_1;
  protoOf(sam$androidx_compose_ui_layout_MeasurePolicy$0_1).qak = maxIntrinsicHeight_1;
  protoOf(WebTextInputService$startInput$1).ydc = sendEditCommand;
  protoOf(WebTextInputService).b8d = startInput;
  protoOf(WebTextInputService).k8d = updateTextLayoutResult;
  protoOf(WebTextToolbar).xbq = showMenu;
  //endregion
  //region block: init
  androidx_compose_ui_AbsoluteAlignment$stable = 0;
  androidx_compose_ui_BiasAlignment_Horizontal$stable = 0;
  androidx_compose_ui_BiasAlignment_Vertical$stable = 0;
  androidx_compose_ui_BiasAlignment$stable = 0;
  androidx_compose_ui_BiasAbsoluteAlignment_Horizontal$stable = 0;
  androidx_compose_ui_BiasAbsoluteAlignment$stable = 0;
  androidx_compose_ui_ComposeUiFlags$stable = 8;
  ComposeUiFlags_instance = new ComposeUiFlags();
  androidx_compose_ui_CompositionLocalMapInjectionNode$stable = 8;
  androidx_compose_ui_CompositionLocalMapInjectionElement$stable = 0;
  androidx_compose_ui_FrameRateModifierNode$stable = 8;
  androidx_compose_ui_ModifierNodeDetachedCancellationException$stable = 8;
  androidx_compose_ui_Modifier_Node$stable = 8;
  androidx_compose_ui_CombinedModifier$stable = 0;
  Companion_instance_6 = new Companion_1();
  Key_instance_0 = new Key();
  androidx_compose_ui_ZIndexElement$stable = 0;
  androidx_compose_ui_ZIndexNode$stable = 8;
  androidx_compose_ui_autofill_AutofillNode$stable = 8;
  androidx_compose_ui_autofill_AutofillManager$stable = 0;
  androidx_compose_ui_autofill_AutofillTree$stable = 8;
  Companion_instance_7 = new Companion_2();
  androidx_compose_ui_draganddrop_DragAndDropNode$stable = 8;
  DragAndDropTraversableKey_instance = new DragAndDropTraversableKey();
  Companion_instance_8 = new Companion_3();
  androidx_compose_ui_draw_DrawBackgroundModifier$stable = 8;
  androidx_compose_ui_draw_CacheDrawScope$stable = 0;
  androidx_compose_ui_draw_DrawResult$stable = 8;
  androidx_compose_ui_draw_BlockDropShadowElement$stable = 0;
  androidx_compose_ui_draw_SimpleDropShadowElement$stable = 0;
  androidx_compose_ui_draw_SimpleDropShadowNode$stable = 8;
  androidx_compose_ui_draw_SimpleInnerShadowElement$stable = 0;
  androidx_compose_ui_draw_SimpleInnerShadowNode$stable = 8;
  androidx_compose_ui_draw_BlockInnerShadowElement$stable = 0;
  androidx_compose_ui_draw_BlockInnerShadowNode$stable = 0;
  androidx_compose_ui_draw_BlockDropShadowNode$stable = 0;
  androidx_compose_ui_draw_ShadowGraphicsLayerElement$stable = 0;
  androidx_compose_ui_focus_FocusInvalidationManager$stable = 8;
  androidx_compose_ui_focus_FocusOrder$stable = 8;
  androidx_compose_ui_focus_FocusOrderToProperties$stable = 0;
  androidx_compose_ui_focus_FocusOwnerImpl$stable = 8;
  androidx_compose_ui_focus_CancelIndicatingFocusBoundaryScope$stable = 8;
  androidx_compose_ui_focus_FocusPropertiesImpl$stable = 8;
  androidx_compose_ui_focus_FocusRequester_Companion_FocusRequesterFactory$stable = 0;
  androidx_compose_ui_focus_FocusRequester$stable = 0;
  androidx_compose_ui_focus_FocusRestorerNode$stable = 8;
  androidx_compose_ui_focus_FocusTargetNode_FocusTargetElement$stable = 0;
  androidx_compose_ui_focus_FocusTargetNode$stable = 8;
  FocusableChildrenComparator_instance = new FocusableChildrenComparator();
  reusableGraphicsLayerScope = null;
  androidx_compose_ui_graphics_BlockGraphicsLayerModifier$stable = 8;
  androidx_compose_ui_graphics_vector_DrawCache$stable = 8;
  androidx_compose_ui_graphics_vector_ImageVector_Builder$stable = 8;
  androidx_compose_ui_graphics_vector_ImageVector$stable = 0;
  androidx_compose_ui_graphics_vector_VectorNode$stable = 0;
  androidx_compose_ui_graphics_vector_VectorGroup$stable = 0;
  androidx_compose_ui_graphics_vector_VectorPath$stable = 0;
  androidx_compose_ui_graphics_vector_VectorPainter$stable = 8;
  androidx_compose_ui_graphics_vector_VectorProperty_Rotation$stable = 0;
  androidx_compose_ui_graphics_vector_VectorProperty_PivotX$stable = 0;
  androidx_compose_ui_graphics_vector_VectorProperty_PivotY$stable = 0;
  androidx_compose_ui_graphics_vector_VectorProperty_ScaleX$stable = 0;
  androidx_compose_ui_graphics_vector_VectorProperty_ScaleY$stable = 0;
  androidx_compose_ui_graphics_vector_VectorProperty_TranslateX$stable = 0;
  androidx_compose_ui_graphics_vector_VectorProperty_TranslateY$stable = 0;
  androidx_compose_ui_graphics_vector_VectorProperty_PathData$stable = 0;
  androidx_compose_ui_graphics_vector_VectorProperty_Fill$stable = 0;
  androidx_compose_ui_graphics_vector_VectorProperty_FillAlpha$stable = 0;
  androidx_compose_ui_graphics_vector_VectorProperty_Stroke$stable = 0;
  androidx_compose_ui_graphics_vector_VectorProperty_StrokeLineWidth$stable = 0;
  androidx_compose_ui_graphics_vector_VectorProperty_StrokeAlpha$stable = 0;
  androidx_compose_ui_graphics_vector_VectorProperty_TrimPathStart$stable = 0;
  androidx_compose_ui_graphics_vector_VectorProperty_TrimPathEnd$stable = 0;
  androidx_compose_ui_graphics_vector_VectorProperty_TrimPathOffset$stable = 0;
  androidx_compose_ui_graphics_vector_VectorProperty$stable = 0;
  Companion_instance_16 = new Companion_11();
  androidx_compose_ui_input_InputModeManagerImpl$stable = 8;
  androidx_compose_ui_input_indirect_IndirectPointerInputChange$stable = 8;
  androidx_compose_ui_input_nestedscroll_NestedScrollDispatcher$stable = 8;
  androidx_compose_ui_input_nestedscroll_NestedScrollNode$stable = 8;
  androidx_compose_ui_input_pointer_HitPathTracker$stable = 8;
  androidx_compose_ui_input_pointer_NodeParent$stable = 8;
  androidx_compose_ui_input_pointer_Node$stable = 8;
  androidx_compose_ui_input_pointer_PointerInputEventData$stable = 8;
  androidx_compose_ui_input_pointer_PointerInputFilter$stable = 8;
  androidx_compose_ui_input_pointer_PointerInputChange$stable = 0;
  androidx_compose_ui_input_pointer_HistoricalChange$stable = 0;
  androidx_compose_ui_input_pointer_ConsumedData$stable = 8;
  androidx_compose_ui_input_pointer_PointerHoverIconModifierElement$stable = 0;
  androidx_compose_ui_input_pointer_PointerHoverIconModifierNode$stable = 8;
  androidx_compose_ui_input_pointer_StylusHoverIconModifierElement$stable = 0;
  androidx_compose_ui_input_pointer_StylusHoverIconModifierNode$stable = 8;
  androidx_compose_ui_input_pointer_HoverIconModifierNode$stable = 8;
  androidx_compose_ui_input_pointer_PointerInputEventProcessor$stable = 8;
  androidx_compose_ui_input_pointer_util_DefaultVelocityTracker$stable = 8;
  androidx_compose_ui_input_pointer_util_PointerIdArray$stable = 8;
  VelocityTrackerAddPointsFix = true;
  androidx_compose_ui_input_pointer_util_VelocityTracker$stable = 8;
  androidx_compose_ui_input_pointer_util_VelocityTracker1D$stable = 8;
  androidx_compose_ui_input_pointer_util_DataPointAtTime$stable = 8;
  Companion_instance_23 = new Companion_18();
  androidx_compose_ui_layout_ApproachMeasureScopeImpl$stable = 0;
  androidx_compose_ui_layout_FixedScale$stable = 0;
  androidx_compose_ui_layout_DefaultIntrinsicMeasurable$stable = 8;
  androidx_compose_ui_layout_IntrinsicsMeasureScope$stable = 0;
  androidx_compose_ui_layout_ApproachIntrinsicsMeasureScope$stable = 0;
  androidx_compose_ui_layout_LayoutBoundsHolder$stable = 0;
  androidx_compose_ui_layout_LayoutBoundsElement$stable = 0;
  androidx_compose_ui_layout_LayoutBoundsNode$stable = 8;
  androidx_compose_ui_layout_LayoutIdModifier$stable = 8;
  androidx_compose_ui_layout_ModifierInfo$stable = 8;
  androidx_compose_ui_layout_LayoutModifierImpl$stable = 8;
  MeasuringIntrinsics_instance = new MeasuringIntrinsics();
  androidx_compose_ui_layout_LookaheadLayoutCoordinates$stable = 0;
  androidx_compose_ui_layout_MultiContentMeasurePolicyImpl$stable = 0;
  androidx_compose_ui_layout_OnPlacedNode$stable = 8;
  androidx_compose_ui_layout_OnSizeChangedNode$stable = 8;
  androidx_compose_ui_layout_OnVisibilityChangedNode$stable = 8;
  Companion_instance_26 = new Companion_21();
  androidx_compose_ui_layout_RootMeasurePolicy$stable = 0;
  androidx_compose_ui_layout_Ruler$stable = 0;
  androidx_compose_ui_layout_VerticalRuler$stable = 0;
  androidx_compose_ui_layout_HorizontalRuler$stable = 0;
  Companion_instance_27 = new Companion_22();
  Companion_instance_28 = new Companion_23();
  NoOpSubcomposeSlotReusePolicy_instance = new NoOpSubcomposeSlotReusePolicy();
  androidx_compose_ui_layout_TestModifierUpdater$stable = 8;
  androidx_compose_ui_modifier_ModifierLocal$stable = 0;
  androidx_compose_ui_modifier_ProvidableModifierLocal$stable = 0;
  androidx_compose_ui_modifier_ModifierLocalManager$stable = 8;
  androidx_compose_ui_modifier_ModifierLocalMap$stable = 0;
  androidx_compose_ui_modifier_SingleLocalMap$stable = 0;
  androidx_compose_ui_modifier_BackwardsCompatLocalMap$stable = 8;
  androidx_compose_ui_modifier_MultiLocalMap$stable = 0;
  androidx_compose_ui_modifier_EmptyMap$stable = 0;
  androidx_compose_ui_node_DelegatingNode$stable = 8;
  androidx_compose_ui_node_HitTestResult$stable = 8;
  androidx_compose_ui_node_TailModifierNode$stable = 8;
  androidx_compose_ui_node_InnerNodeCoordinator$stable = 0;
  androidx_compose_ui_node_IntrinsicsPolicy$stable = 8;
  androidx_compose_ui_node_NodeMeasuringIntrinsics$stable = 0;
  NodeMeasuringIntrinsics_instance = new NodeMeasuringIntrinsics();
  androidx_compose_ui_node_LayoutModifierNodeCoordinator$stable = 0;
  androidx_compose_ui_node_AlignmentLines$stable = 8;
  androidx_compose_ui_node_LayoutNodeAlignmentLines$stable = 8;
  androidx_compose_ui_node_LookaheadAlignmentLines$stable = 8;
  androidx_compose_ui_node_LayoutNodeDrawScope$stable = 0;
  androidx_compose_ui_node_LayoutNodeLayoutDelegate$stable = 8;
  androidx_compose_ui_node_LayoutTreeConsistencyChecker$stable = 8;
  androidx_compose_ui_node_LookaheadCapablePlaceable$stable = 0;
  androidx_compose_ui_node_LookaheadDelegate$stable = 0;
  androidx_compose_ui_node_LookaheadPassDelegate$stable = 8;
  androidx_compose_ui_node_MeasureAndLayoutDelegate_PostponedRequest$stable = 8;
  androidx_compose_ui_node_MeasureAndLayoutDelegate$stable = 8;
  androidx_compose_ui_node_MeasurePassDelegate$stable = 8;
  androidx_compose_ui_node_ModifierNodeElement$stable = 0;
  androidx_compose_ui_node_NodeChain$stable = 8;
  androidx_compose_ui_node_NodeCoordinator$stable = 0;
  Nodes_instance = new Nodes();
  CanFocusChecker_instance = new CanFocusChecker();
  androidx_compose_ui_node_ObserverNodeOwnerScope$stable = 8;
  androidx_compose_ui_node_OnPositionedDispatcher$stable = 8;
  DepthComparator_instance = new DepthComparator_0();
  Companion_instance_39 = new Companion_34();
  Companion_instance_40 = new Companion_35();
  androidx_compose_ui_node_Ref$stable = 8;
  androidx_compose_ui_node_DpTouchBoundsExpansion$stable = 0;
  Companion_instance_41 = new Companion_36();
  Key_instance_1 = new Key_0();
  androidx_compose_ui_platform_DelegatingSoftwareKeyboardController$stable = 0;
  androidx_compose_ui_platform_WindowInfoImpl$stable = 0;
  androidx_compose_ui_semantics_SemanticsConfiguration$stable = 8;
  androidx_compose_ui_semantics_SemanticsNode$stable = 8;
  androidx_compose_ui_spatial_RectManager$stable = 8;
  ExecuteDelayUsingPostAndRemove_instance = new ExecuteDelayUsingPostAndRemove();
  androidx_compose_ui_spatial_RelativeLayoutBounds$stable = 8;
  androidx_compose_ui_spatial_ThrottledCallbacks$stable = 8;
  DefaultCacheSize = 8;
  androidx_compose_ui_window_AlignmentOffsetPositionProvider$stable = 0;
  Companion_instance_47 = new Companion_42();
  androidx_compose_ui_AtomicReference$stable = 8;
  androidx_compose_ui_input_pointer_PointerEventTimeoutCancellationException$stable = 8;
  androidx_compose_ui_internal_PlatformOptimizedCancellationException$stable = 8;
  androidx_compose_ui_node_SortedSet$stable = 8;
  androidx_compose_ui_platform_AtomicInt$stable = 8;
  SkikoComposeUiFlags_instance = new SkikoComposeUiFlags();
  androidx_compose_ui_ImageComposeScene$stable = 8;
  androidx_compose_ui_hapticfeedback_PlatformHapticFeedbackType$stable = 0;
  androidx_compose_ui_input_key_InternalKeyEvent$stable = 8;
  androidx_compose_ui_input_pointer_InternalPointerEvent$stable = 8;
  androidx_compose_ui_input_pointer_PointerEvent$stable = 8;
  Companion_instance_51 = new Companion_46();
  androidx_compose_ui_input_pointer_PointerInputEvent$stable = 8;
  androidx_compose_ui_input_pointer_TestPointerInputEventData$stable = 0;
  androidx_compose_ui_input_pointer_util_PointerVelocityTracker1D$stable = 8;
  androidx_compose_ui_input_rotary_RotaryScrollEvent$stable = 0;
  androidx_compose_ui_layout_RulerProviderModifierElement$stable = 0;
  androidx_compose_ui_layout_RulerProviderModifierNode$stable = 8;
  androidx_compose_ui_navigationevent_BackNavigationEventInput$stable = 8;
  androidx_compose_ui_node_DragAndDropOwner$stable = 8;
  androidx_compose_ui_node_EmptySemanticsElement$stable = 0;
  androidx_compose_ui_node_RootNodeOwner$stable = 8;
  IdentityPositionCalculator_instance = new IdentityPositionCalculator();
  androidx_compose_ui_node_SnapshotInvalidationTracker$stable = 8;
  androidx_compose_ui_platform_DefaultAccessibilityManager$stable = 0;
  androidx_compose_ui_platform_DefaultHapticFeedback$stable = 0;
  androidx_compose_ui_platform_DefaultTextToolbar$stable = 0;
  androidx_compose_ui_platform_DefaultViewConfiguration$stable = 0;
  androidx_compose_ui_platform_DisposableSaveableStateRegistry$stable = 8;
  androidx_compose_ui_platform_FlushCoroutineDispatcher$stable = 8;
  androidx_compose_ui_platform_GlobalSnapshotManager$stable = 8;
  androidx_compose_ui_platform_LegacyRenderNodeLayer$stable = 8;
  androidx_compose_ui_platform_ClipMetadata$stable = 0;
  EmptyFocusManager_instance = new EmptyFocusManager();
  EmptyPlatformScreenReader_instance = new EmptyPlatformScreenReader();
  EmptyPlatformTextInputService_instance = new EmptyPlatformTextInputService();
  EmptyDragAndDropManager_instance = new EmptyDragAndDropManager();
  androidx_compose_ui_platform_DefaultArchitectureComponentsOwner$stable = 8;
  androidx_compose_ui_platform_EmptyPlatformWindowInsets$stable = 0;
  Companion_instance_53 = new Companion_48();
  EmptyPlatformWindowInsets_instance = new EmptyPlatformWindowInsets();
  androidx_compose_ui_platform_PlatformWindowInsetsProviderNode$stable = 8;
  androidx_compose_ui_platform_SynchronizedObject$stable = 0;
  androidx_compose_ui_platform_TranslationsCache$stable = 8;
  androidx_compose_ui_scene_BaseComposeScene$stable = 8;
  androidx_compose_ui_scene_CopiedList$stable = 8;
  androidx_compose_ui_scene_ComposeSceneDragAndDropNode$stable = 8;
  androidx_compose_ui_scene_ComposeSceneFocusManager$stable = 0;
  androidx_compose_ui_scene_ComposeSceneInputHandler$stable = 8;
  androidx_compose_ui_scene_ComposeScenePointer$stable = 8;
  androidx_compose_ui_scene_ComposeSceneRecomposer$stable = 8;
  androidx_compose_ui_skiko_OverlayRenderDecorator$stable = 8;
  androidx_compose_ui_skiko_RecordDrawRectRenderDecorator$stable = 8;
  androidx_compose_ui_viewinterop_InteropPointerInputModifier$stable = 0;
  androidx_compose_ui_viewinterop_InteropViewFactoryHolder$stable = 0;
  androidx_compose_ui_viewinterop_InteropViewHolder$stable = 8;
  androidx_compose_ui_window_OnBackClickEventHandler$stable = 8;
  androidx_compose_ui_window_PopupProperties$stable = 0;
  androidx_compose_ui_draganddrop_DragAndDropEvent$stable = 8;
  androidx_compose_ui_draganddrop_DragAndDropTransferData$stable = 8;
  androidx_compose_ui_draganddrop_WebDragAndDropManager$stable = 8;
  androidx_compose_ui_events_EventTargetListener$stable = 8;
  androidx_compose_ui_input_pointer_util_WebVelocityTracker$stable = 8;
  androidx_compose_ui_node_WeakReference$stable = 8;
  androidx_compose_ui_platform_BackingDomInput$stable = 8;
  androidx_compose_ui_platform_DomInputStrategy$stable = 8;
  androidx_compose_ui_platform_InputEventExt$stable = 8;
  androidx_compose_ui_platform_NativeInputEventsProcessor$stable = 8;
  androidx_compose_ui_platform_W3CTemporaryClipboard$stable = 0;
  androidx_compose_ui_platform_WebTextInputService$stable = 8;
  androidx_compose_ui_platform_WebTextToolbar_TextToolbarMenu$stable = 0;
  androidx_compose_ui_platform_WebTextToolbar$stable = 8;
  androidx_compose_ui_platform_accessibility_ComposeWebSemanticsListener$stable = 8;
  androidx_compose_ui_platform_accessibility_AriaRoleId$stable = 0;
  androidx_compose_ui_viewinterop_InteropViewGroup$stable = 8;
  androidx_compose_ui_viewinterop_WebInteropContainer$stable = 8;
  androidx_compose_ui_viewinterop_WebInteropElementHolder$stable = 8;
  androidx_compose_ui_viewinterop_WebInteropViewHolder$stable = 8;
  androidx_compose_ui_window_ComposeViewportConfiguration$stable = 8;
  androidx_compose_ui_window_KeyboardModeState_Virtual$stable = 0;
  androidx_compose_ui_window_KeyboardModeState_Hardware$stable = 0;
  androidx_compose_ui_window_DefaultWindowState$stable = 8;
  androidx_compose_ui_window_ComposeWindow$stable = 8;
  Virtual_instance = new Virtual();
  Hardware_instance = new Hardware();
  androidx_compose_ui_window_SystemThemeObserverImpl$stable = 8;
  androidx_compose_ui_window_WebTextInputSession$stable = 8;
  //endregion
  //region block: exports
  _.$_$ = _.$_$ || {};
  _.$_$.a = createFromBoolean;
  _.$_$.b = createFromText;
  _.$_$.c = get_domEventOrNull;
  _.$_$.d = CacheDrawModifierNode;
  _.$_$.e = DrawModifier;
  _.$_$.f = alpha;
  _.$_$.g = clipToBounds;
  _.$_$.h = clip;
  _.$_$.i = drawBehind;
  _.$_$.j = drawWithCache;
  _.$_$.k = drawWithContent;
  _.$_$.l = paint;
  _.$_$.m = rotate;
  _.$_$.n = scale;
  _.$_$.o = shadow;
  _.$_$.p = FocusEventModifierNode;
  _.$_$.q = FocusRequester;
  _.$_$.r = funFocusTargetModifierNode2;
  _.$_$.s = focusRequester;
  _.$_$.t = getFocusedRect;
  _.$_$.u = onFocusChanged;
  _.$_$.v = requestFocus_0;
  _.$_$.w = get_DefaultFillType;
  _.$_$.x = get_DefaultStrokeLineCap;
  _.$_$.y = get_DefaultStrokeLineJoin;
  _.$_$.z = DrawCache;
  _.$_$.a1 = get_EmptyPath;
  _.$_$.b1 = Builder;
  _.$_$.c1 = addPathNodes;
  _.$_$.d1 = androidx_compose_ui_graphics_vector_VectorPainter$stableprop_getter;
  _.$_$.e1 = rememberVectorPainter;
  _.$_$.f1 = TransformOrigin_0;
  _.$_$.g1 = TransformOrigin;
  _.$_$.h1 = graphicsLayer;
  _.$_$.i1 = graphicsLayer_0;
  _.$_$.j1 = toolingGraphicsLayer;
  _.$_$.k1 = HapticFeedbackType;
  _.$_$.l1 = IndirectPointerInputModifierNode;
  _.$_$.m1 = KeyInputModifierNode;
  _.$_$.n1 = get_isAltPressed;
  _.$_$.o1 = get_isCtrlPressed;
  _.$_$.p1 = get_isMetaPressed;
  _.$_$.q1 = get_isShiftPressed;
  _.$_$.r1 = get_key_0;
  _.$_$.s1 = onKeyEvent;
  _.$_$.t1 = onPreviewKeyEvent;
  _.$_$.u1 = get_type;
  _.$_$.v1 = get_utf16CodePoint;
  _.$_$.w1 = onPreScroll;
  _.$_$.x1 = NestedScrollConnection;
  _.$_$.y1 = NestedScrollDispatcher;
  _.$_$.z1 = nestedScrollModifierNode;
  _.$_$.a2 = nestedScroll;
  _.$_$.b2 = VelocityTracker;
  _.$_$.c2 = addPointerInputChange;
  _.$_$.d2 = addPointerInputChange_0;
  _.$_$.e2 = AwaitPointerEventScope;
  _.$_$.f2 = PointerEventTimeoutCancellationException;
  _.$_$.g2 = PointerInputEventHandler;
  _.$_$.h2 = PointerInputScope;
  _.$_$.i2 = PointerType;
  _.$_$.j2 = SuspendingPointerInputModifierNode;
  _.$_$.k2 = changedToDownIgnoreConsumed;
  _.$_$.l2 = changedToDown;
  _.$_$.m2 = changedToUpIgnoreConsumed;
  _.$_$.n2 = changedToUp;
  _.$_$.o2 = isOutOfBounds;
  _.$_$.p2 = get_isPrimaryPressed;
  _.$_$.q2 = get_isSecondaryPressed;
  _.$_$.r2 = get_isShiftPressed_0;
  _.$_$.s2 = onPointerEvent;
  _.$_$.t2 = pointerHoverIcon;
  _.$_$.u2 = pointerInput;
  _.$_$.v2 = pointerInput_0;
  _.$_$.w2 = positionChangeIgnoreConsumed;
  _.$_$.x2 = positionChangedIgnoreConsumed;
  _.$_$.y2 = positionChanged;
  _.$_$.z2 = positionChange;
  _.$_$.a3 = stylusHoverIcon;
  _.$_$.b3 = InputMode;
  _.$_$.c3 = BeyondBoundsLayoutProviderModifierNode;
  _.$_$.d3 = get_FirstBaseline;
  _.$_$.e3 = HorizontalAlignmentLine;
  _.$_$.f3 = get_LastBaseline;
  _.$_$.g3 = LayoutIdParentData;
  _.$_$.h3 = maxIntrinsicHeight_0;
  _.$_$.i3 = maxIntrinsicWidth_0;
  _.$_$.j3 = minIntrinsicHeight_0;
  _.$_$.k3 = minIntrinsicWidth_0;
  _.$_$.l3 = LayoutModifier;
  _.$_$.m3 = get_LocalPinnableContainer;
  _.$_$.n3 = maxIntrinsicHeight_1;
  _.$_$.o3 = maxIntrinsicWidth_1;
  _.$_$.p3 = minIntrinsicHeight_1;
  _.$_$.q3 = minIntrinsicWidth_1;
  _.$_$.r3 = MeasurePolicy;
  _.$_$.s3 = get_rulers;
  _.$_$.t3 = MeasureResult;
  _.$_$.u3 = MeasureScope;
  _.$_$.v3 = maxIntrinsicHeight_2;
  _.$_$.w3 = maxIntrinsicWidth_2;
  _.$_$.x3 = minIntrinsicHeight_2;
  _.$_$.y3 = minIntrinsicWidth_2;
  _.$_$.z3 = MultiContentMeasurePolicy;
  _.$_$.a4 = ParentDataModifier;
  _.$_$.b4 = Placeable;
  _.$_$.c4 = RemeasurementModifier;
  _.$_$.d4 = SubcomposeLayoutState;
  _.$_$.e4 = SubcomposeLayout;
  _.$_$.f4 = SubcomposeLayout_0;
  _.$_$.g4 = VerticalAlignmentLine;
  _.$_$.h4 = androidx_compose_ui_layout_SubcomposeLayoutState$stableprop_getter;
  _.$_$.i4 = boundsInWindow;
  _.$_$.j4 = boundsInWindow_0;
  _.$_$.k4 = combineAsVirtualLayouts;
  _.$_$.l4 = createMeasurePolicy;
  _.$_$.m4 = findRootCoordinates;
  _.$_$.n4 = get_layoutId;
  _.$_$.o4 = layoutId;
  _.$_$.p4 = layout_1;
  _.$_$.q4 = onGloballyPositioned;
  _.$_$.r4 = onSizeChanged;
  _.$_$.s4 = positionInParent;
  _.$_$.t4 = positionInWindow;
  _.$_$.u4 = positionOnScreen;
  _.$_$.v4 = registerOnLayoutRectChanged;
  _.$_$.w4 = CompositionLocalConsumerModifierNode;
  _.$_$.x4 = DelegatableNode;
  _.$_$.y4 = DelegatingNode;
  _.$_$.z4 = DpTouchBoundsExpansion_0;
  _.$_$.a5 = onMeasureResultChanged;
  _.$_$.b5 = DrawModifierNode;
  _.$_$.c5 = GlobalPositionAwareModifierNode;
  _.$_$.d5 = onPlaced;
  _.$_$.e5 = onRemeasured;
  _.$_$.f5 = LayoutAwareModifierNode;
  _.$_$.g5 = maxIntrinsicHeight;
  _.$_$.h5 = maxIntrinsicWidth;
  _.$_$.i5 = minIntrinsicHeight;
  _.$_$.j5 = minIntrinsicWidth;
  _.$_$.k5 = LayoutModifierNode;
  _.$_$.l5 = MeasuredSizeAwareModifierNode;
  _.$_$.m5 = ModifierNodeElement;
  _.$_$.n5 = ParentDataModifierNode;
  _.$_$.o5 = interceptOutOfBoundsChildEvents;
  _.$_$.p5 = onDensityChange_0;
  _.$_$.q5 = onViewConfigurationChange;
  _.$_$.r5 = sharePointerInputWithSiblings;
  _.$_$.s5 = get_touchBoundsExpansion;
  _.$_$.t5 = PointerInputModifierNode;
  _.$_$.u5 = get_isImportantForBounds;
  _.$_$.v5 = get_shouldClearDescendantSemantics;
  _.$_$.w5 = get_shouldMergeDescendantSemantics;
  _.$_$.x5 = SemanticsModifierNode;
  _.$_$.y5 = TraversableNode;
  _.$_$.z5 = currentValueOf;
  _.$_$.a6 = dispatchOnScrollChanged_0;
  _.$_$.b6 = findNearestAncestor;
  _.$_$.c6 = findNearestAncestor_0;
  _.$_$.d6 = invalidateDraw;
  _.$_$.e6 = invalidateLayer;
  _.$_$.f6 = invalidateMeasurement;
  _.$_$.g6 = invalidatePlacement;
  _.$_$.h6 = invalidateSemantics;
  _.$_$.i6 = observeReads;
  _.$_$.j6 = remeasureSync;
  _.$_$.k6 = requestAutofill;
  _.$_$.l6 = requireDensity;
  _.$_$.m6 = requireLayoutCoordinates;
  _.$_$.n6 = requireLayoutDirection;
  _.$_$.o6 = traverseAncestors;
  _.$_$.p6 = traverseDescendants;
  _.$_$.q6 = get_LocalAccessibilityManager;
  _.$_$.r6 = get_LocalClipboard;
  _.$_$.s6 = get_LocalCursorBlinkEnabled;
  _.$_$.t6 = get_LocalDensity;
  _.$_$.u6 = get_LocalFocusManager;
  _.$_$.v6 = get_LocalFontFamilyResolver;
  _.$_$.w6 = get_LocalGraphicsContext;
  _.$_$.x6 = get_LocalHapticFeedback;
  _.$_$.y6 = get_LocalInputModeManager;
  _.$_$.z6 = get_LocalInspectionMode;
  _.$_$.a7 = get_LocalLayoutDirection;
  _.$_$.b7 = get_LocalPlatformWindowInsets;
  _.$_$.c7 = get_LocalScrollCaptureInProgress;
  _.$_$.d7 = get_LocalSoftwareKeyboardController;
  _.$_$.e7 = get_LocalTextToolbar;
  _.$_$.f7 = get_LocalUriHandler;
  _.$_$.g7 = get_LocalViewConfiguration;
  _.$_$.h7 = get_LocalWindowInfo;
  _.$_$.i7 = get_NoInspectorInfo;
  _.$_$.j7 = PlatformTextInputSession;
  _.$_$.k7 = PlatformWindowInsetsProviderNode;
  _.$_$.l7 = WebTextToolbar;
  _.$_$.m7 = findComposeDefaultViewModelStoreOwner;
  _.$_$.n7 = findDefaultNavigationEventDispatcherOwner;
  _.$_$.o7 = get_isDebugInspectorInfoEnabled;
  _.$_$.p7 = get_safeContent;
  _.$_$.q7 = get_safeDrawing;
  _.$_$.r7 = get_safeGestures;
  _.$_$.s7 = BringIntoViewModifierNode;
  _.$_$.t7 = CollectionInfo;
  _.$_$.u7 = ProgressBarRangeInfo;
  _.$_$.v7 = Role;
  _.$_$.w7 = ScrollAxisRange;
  _.$_$.x7 = SemanticsPropertyKey;
  _.$_$.y7 = clearAndSetSemantics;
  _.$_$.z7 = clearTextSubstitution;
  _.$_$.a8 = collapse;
  _.$_$.b8 = set_collectionInfo;
  _.$_$.c8 = set_contentDataType;
  _.$_$.d8 = set_contentDescription;
  _.$_$.e8 = set_contentType;
  _.$_$.f8 = copyText;
  _.$_$.g8 = cutText;
  _.$_$.h8 = disabled;
  _.$_$.i8 = dismiss;
  _.$_$.j8 = set_editableText;
  _.$_$.k8 = error;
  _.$_$.l8 = expand;
  _.$_$.m8 = set_fillableData;
  _.$_$.n8 = set_focused;
  _.$_$.o8 = getScrollViewportLength;
  _.$_$.p8 = getTextLayoutResult;
  _.$_$.q8 = set_horizontalScrollAxisRange;
  _.$_$.r8 = indexForKey;
  _.$_$.s8 = set_inputText;
  _.$_$.t8 = insertTextAtCursor;
  _.$_$.u8 = set_isContainer;
  _.$_$.v8 = set_isEditable;
  _.$_$.w8 = set_isShowingTextSubstitution;
  _.$_$.x8 = set_isTraversalGroup;
  _.$_$.y8 = set_liveRegion;
  _.$_$.z8 = onClick;
  _.$_$.a9 = onFillData;
  _.$_$.b9 = onImeAction;
  _.$_$.c9 = onLongClick;
  _.$_$.d9 = pageDown;
  _.$_$.e9 = pageLeft;
  _.$_$.f9 = pageRight;
  _.$_$.g9 = pageUp;
  _.$_$.h9 = set_paneTitle;
  _.$_$.i9 = password;
  _.$_$.j9 = pasteText;
  _.$_$.k9 = set_progressBarRangeInfo;
  _.$_$.l9 = requestFocus_1;
  _.$_$.m9 = set_role;
  _.$_$.n9 = scrollByOffset;
  _.$_$.o9 = scrollBy;
  _.$_$.p9 = scrollToIndex;
  _.$_$.q9 = selectableGroup;
  _.$_$.r9 = set_selected;
  _.$_$.s9 = semantics;
  _.$_$.t9 = setProgress;
  _.$_$.u9 = setSelection;
  _.$_$.v9 = setTextSubstitution;
  _.$_$.w9 = setText;
  _.$_$.x9 = set_shape;
  _.$_$.y9 = showTextSubstitution;
  _.$_$.z9 = set_stateDescription;
  _.$_$.aa = set_text;
  _.$_$.ba = set_textSelectionRange;
  _.$_$.ca = set_textSubstitution;
  _.$_$.da = set_toggleableState;
  _.$_$.ea = set_traversalIndex;
  _.$_$.fa = set_verticalScrollAxisRange;
  _.$_$.ga = ToggleableState_0;
  _.$_$.ha = rememberTextMeasurer;
  _.$_$.ia = ComposeViewport;
  _.$_$.ja = Dialog;
  _.$_$.ka = get_LocalActiveClipEventsTarget;
  _.$_$.la = Popup_0;
  _.$_$.ma = Popup;
  _.$_$.na = get_LocalSystemTheme;
  _.$_$.oa = all;
  _.$_$.pa = foldIn;
  _.$_$.qa = Node;
  _.$_$.ra = then;
  _.$_$.sa = get_key;
  _.$_$.ta = MotionDurationScale;
  _.$_$.ua = androidx_compose_ui_Modifier_Node$stableprop_getter;
  _.$_$.va = composed;
  _.$_$.wa = materialize;
  _.$_$.xa = zIndex;
  _.$_$.ya = TransformOrigin__hashCode_impl_pmqpcw;
  _.$_$.za = _TransformOrigin___get_pivotFractionX__impl__a9pmci;
  _.$_$.ab = _TransformOrigin___get_pivotFractionY__impl__ijwupp;
  _.$_$.bb = TransformOrigin__toString_impl_nn7ftd;
  _.$_$.cb = _Key___get_keyCode__impl__ymzu5v;
  _.$_$.db = _PointerId___init__impl__w2urwh;
  _.$_$.eb = Role__hashCode_impl_ucjza4;
  _.$_$.fb = Companion_getInstance_69;
  _.$_$.gb = Companion_getInstance_70;
  _.$_$.hb = Companion_instance_7;
  _.$_$.ib = Companion_getInstance_30;
  _.$_$.jb = Companion_getInstance_33;
  _.$_$.kb = Companion_getInstance_35;
  _.$_$.lb = Companion_instance_16;
  _.$_$.mb = Companion_getInstance_75;
  _.$_$.nb = Companion_getInstance_39;
  _.$_$.ob = Companion_getInstance_40;
  _.$_$.pb = Companion_getInstance_41;
  _.$_$.qb = Companion_getInstance_43;
  _.$_$.rb = Companion_getInstance_42;
  _.$_$.sb = Companion_getInstance_38;
  _.$_$.tb = Companion_getInstance_45;
  _.$_$.ub = Companion_getInstance_46;
  _.$_$.vb = Companion_getInstance_53;
  _.$_$.wb = Companion_instance_47;
  _.$_$.xb = Key_instance_1;
  _.$_$.yb = Companion_getInstance_67;
  _.$_$.zb = Companion_getInstance_66;
  _.$_$.ac = Companion_getInstance_65;
  _.$_$.bc = SemanticsProperties_getInstance;
  _.$_$.cc = AbsoluteAlignment_getInstance;
  _.$_$.dc = Companion_getInstance_25;
  _.$_$.ec = Companion_instance_6;
  _.$_$.fc = Key_instance_0;
  _.$_$.gc = PointerEventPass_Final_getInstance;
  _.$_$.hc = PointerEventPass_Initial_getInstance;
  _.$_$.ic = PointerEventPass_Main_getInstance;
  _.$_$.jc = TraverseDescendantsAction_SkipSubtreeAndContinueTraversal_getInstance;
  _.$_$.kc = TextToolbarStatus_Shown_getInstance;
  _.$_$.lc = ToggleableState_Indeterminate_getInstance;
  _.$_$.mc = ToggleableState_Off_getInstance;
  _.$_$.nc = SystemTheme_Dark_getInstance;
  _.$_$.oc = onPreFling;
  _.$_$.pc = establishTextInputSession;
  _.$_$.qc = bringIntoView;
  _.$_$.rc = layout$default;
  _.$_$.sc = layout$default_0;
  _.$_$.tc = VelocityTracker1D_init_$Create$;
  _.$_$.uc = HorizontalRuler_init_$Create$;
  _.$_$.vc = VerticalRuler_init_$Create$;
  _.$_$.wc = DialogProperties_init_$Create$;
  _.$_$.xc = DialogProperties_init_$Create$_0;
  _.$_$.yc = PopupProperties_init_$Create$_0;
  _.$_$.zc = PopupProperties_init_$Create$;
  //endregion
  return _;
}));

//# sourceMappingURL=compose-multiplatform-core-compose-ui-ui.js.map
